// Auto-generated file from TASE (Maya) + Yahoo Finance data
// Generated on: 2026-01-20 13:06:00
// Run 'python generate_data.py' to regenerate

export const Information = [
  {
    "Id": "TASE:5135587",
    "MayaId": "5135587",
    "Name": "$ Ayalim Floaters Bonds",
    "ShortName": "$ Ayalim Floaters Bonds",
    "Symbol": "TASE:5135587",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalim (0D) Floaters Bonds Liquidity Dollar- in dollar",
    "EnglishLongName": "Ayalim (0D) Floaters Bonds Liquidity Dollar- in dollar",
    "HebrewName": "אילים אג\"ח FLOATERS $",
    "HebrewLongName": "אילים (0D) אג\"ח Floaters לנזילות דולרית - נקובה $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.23,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALIM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Bonds",
    "AssetValue": 28.5,
    "MonthYield": -0.88,
    "YearYield": -0.88,
    "Last12MonthYield": -8.9,
    "ISIN": "IL0051355878"
  },
  {
    "Id": "TASE:5105614",
    "MayaId": "5105614",
    "Name": "$ AYALON 90/10 GLO BO DEN",
    "ShortName": "$ AYALON 90/10 GLO BO DEN",
    "Symbol": "TASE:5105614",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALON (1D) 90/10 Global Bond - Denominated in Dollar",
    "EnglishLongName": "AYALON (1D) 90/10 Global Bond - Denominated in Dollar",
    "HebrewName": "איילון 10/90 תק אג חו נ$",
    "HebrewLongName": "איילון (1D)י 10/90 תיק אג\"ח חול - נקובה $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.88,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.09,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Bonds",
    "AssetValue": 95.2,
    "MonthYield": -0.85,
    "YearYield": -0.85,
    "Last12MonthYield": -7.54,
    "ISIN": "IL0051056146"
  },
  {
    "Id": "TASE:5127824",
    "MayaId": "5127824",
    "Name": "$ AYALON GLO BO 2Y SE DEN",
    "ShortName": "$ AYALON GLO BO 2Y SE DEN",
    "Symbol": "TASE:5127824",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALON (0D) Global Bond - 2 Years Savings Denominated in Dollar",
    "EnglishLongName": "AYALON (0D) Global Bond - 2 Years Savings Denominated in Dollar",
    "HebrewName": "איילון אגח חול חס עד 2.$",
    "HebrewLongName": "איילון (0D) תיק אג\"ח חול - חסכון עד שנתיים נקוב $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Bonds",
    "AssetValue": 3.0,
    "MonthYield": -0.89,
    "YearYield": -0.89,
    "Last12MonthYield": -9.87,
    "ISIN": "IL0051278245"
  },
  {
    "Id": "TASE:5113568",
    "MayaId": "5113568",
    "Name": "$ Harel Foreign Bond In",
    "ShortName": "$ Harel Foreign Bond -In",
    "Symbol": "TASE:5113568",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "$ Harel (0D) Foreign Bond - Denominated In",
    "EnglishLongName": "$ Harel (0D) Foreign Bond - Denominated In",
    "HebrewName": "הראל בונד חו\"ל - נקובה $",
    "HebrewLongName": "הראל (0D) בונד חו\"ל - נקובה $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.15,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Bonds",
    "AssetValue": 181.7,
    "MonthYield": -0.79,
    "YearYield": -0.79,
    "Last12MonthYield": -7.2,
    "ISIN": "IL0051135684"
  },
  {
    "Id": "TASE:5110655",
    "MayaId": "5110655",
    "Name": "$ Harel Frgn Rate Bond in",
    "ShortName": "$ Harel Frgn Rate Bond in",
    "Symbol": "TASE:5110655",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "$ Harel (2D) Foreign Rated Bond Denominated in",
    "EnglishLongName": "$ Harel (2D) Foreign Rated Bond Denominated in",
    "HebrewName": "הראל בונד חול מדורג נקו $",
    "HebrewLongName": "הראל (2D) בונד חו\"ל מדורג נקובה $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.97,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.05,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Bonds",
    "AssetValue": 29.2,
    "MonthYield": -0.54,
    "YearYield": -0.54,
    "Last12MonthYield": -5.75,
    "ISIN": "IL0051106552"
  },
  {
    "Id": "TASE:5138326",
    "MayaId": "5138326",
    "Name": "$ Meitav $ MonMarFundD in",
    "ShortName": "$ Meitav $ MonMarFundD in",
    "Symbol": "TASE:5138326",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Meitav (0D) Dollar Money Market Fund- $ Denominated",
    "EnglishLongName": "Meitav (0D) Dollar Money Market Fund- $ Denominated",
    "HebrewName": "מיטב כספית דולרית נקובה $",
    "HebrewLongName": "מיטב (0D) כספית דולרית - נקובה $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.14,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.18,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "FX Money Market with Corporate",
    "AssetValue": 2224.1,
    "MonthYield": -0.92,
    "YearYield": -0.92,
    "Last12MonthYield": -9.34,
    "ISIN": "IL0051383268"
  },
  {
    "Id": "TASE:5140587",
    "MayaId": "5140587",
    "Name": "$AYALON ZVULUN GLO STOC",
    "ShortName": "$AYALON ZVULUN GLO STOC",
    "Symbol": "TASE:5140587",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALON ZVULUN (4D) Global stocks - Denominated in Dollar",
    "EnglishLongName": "AYALON ZVULUN (4D) Global stocks - Denominated in Dollar",
    "HebrewName": "איילון זבולון מני חול נ$",
    "HebrewLongName": "איילון זבולון (4D) מניות חו\"ל - נקובת דולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.75,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 4.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 18.0,
    "MonthYield": -1.7,
    "YearYield": -1.7,
    "Last12MonthYield": null,
    "ISIN": "IL0051405871"
  },
  {
    "Id": "TASE:5140942",
    "MayaId": "5140942",
    "Name": "$Dolphin Isra glo bo d in",
    "ShortName": "$Dolphin Isra glo bo d in",
    "Symbol": "TASE:5140942",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "$ Dolphin (0D)(!) Israeli global bond Denominated in",
    "EnglishLongName": "$ Dolphin (0D)(!) Israeli global bond Denominated in",
    "HebrewName": "דולפין $Isra glo bon d in",
    "HebrewLongName": "דולפין (0D)(!)י Israeli global bond נקובה $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Bonds",
    "AssetValue": 186.2,
    "MonthYield": -0.71,
    "YearYield": -0.71,
    "Last12MonthYield": null,
    "ISIN": "IL0051409428"
  },
  {
    "Id": "TASE:5127774",
    "MayaId": "5127774",
    "Name": "$Harel Frgn Bond Portf In",
    "ShortName": "$Harel Frgn Bond Portf In",
    "Symbol": "TASE:5127774",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "$ Harel (2D) Foreign Bond Portfolio - Denominated In",
    "EnglishLongName": "$ Harel (2D) Foreign Bond Portfolio - Denominated In",
    "HebrewName": "הראל תיק אג\"ח חו\"ל נקובה$",
    "HebrewLongName": "הראל (2D) תיק אג\"ח חו\"ל - נקובה $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.3,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.14,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Bonds",
    "AssetValue": 27.7,
    "MonthYield": -0.66,
    "YearYield": -0.66,
    "Last12MonthYield": -5.73,
    "ISIN": "IL0051277742"
  },
  {
    "Id": "TASE:5103247",
    "MayaId": "5103247",
    "Name": "$Harel Gov Bond Overse in",
    "ShortName": "$Harel Gov Bond Overse-in",
    "Symbol": "TASE:5103247",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "$ Harel (0D) Governments Bonds Overseas - Denominated in",
    "EnglishLongName": "$ Harel (0D) Governments Bonds Overseas - Denominated in",
    "HebrewName": "הראל אגח מדינות בחול-נ.$",
    "HebrewLongName": "הראל (0D) אג\"ח מדינות בחו\"ל - נקובה $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.99,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Bonds",
    "AssetValue": 64.5,
    "MonthYield": -0.76,
    "YearYield": -0.76,
    "Last12MonthYield": -8.45,
    "ISIN": "IL0051032477"
  },
  {
    "Id": "TASE:5129523",
    "MayaId": "5129523",
    "Name": "$HarelDollarLinkMonMarDnm",
    "ShortName": "$HarelDollarLinkMonMarDnm",
    "Symbol": "TASE:5129523",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "$ Harel (0D) Dollar Linked Money Market - Denominated in",
    "EnglishLongName": "$ Harel (0D) Dollar Linked Money Market - Denominated in",
    "HebrewName": "הראל כספית דולרית נקובה $",
    "HebrewLongName": "הראל (0D) כספית דולרית - נקובה $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.23,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "FX Money Market with Corporate",
    "AssetValue": 6543.0,
    "MonthYield": -0.93,
    "YearYield": -0.93,
    "Last12MonthYield": -9.3,
    "ISIN": "IL0051295231"
  },
  {
    "Id": "TASE:5139563",
    "MayaId": "5139563",
    "Name": "$IBI MEHAKA IsGov B 1 5 D",
    "ShortName": "$IBI MEHAKA IsGov B 1-5 D",
    "Symbol": "TASE:5139563",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (0D) Israeli Gov USD Bonds 1-5 iNDEX Denominated in dollar",
    "EnglishLongName": "I.B.I. MEHAKA (0D) Israeli Gov USD Bonds 1-5 iNDEX Denominated in dollar",
    "HebrewName": "איביאי מחקה מ ישראל 1-5נ$",
    "HebrewLongName": "אי.בי.אי. מחקה (0D) אינדקס מדינת ישראל דולר 1-5 נקובה $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.16,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Government - Medium",
    "AssetValue": 172.6,
    "MonthYield": -0.84,
    "YearYield": -0.84,
    "Last12MonthYield": -6.55,
    "ISIN": "IL0051395635"
  },
  {
    "Id": "TASE:5137179",
    "MayaId": "5137179",
    "Name": "$IBI MEHAKA ShillerC US D",
    "ShortName": "$IBI MEHAKA ShillerC US D",
    "Symbol": "TASE:5137179",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "$I.B.I. MEHAKA(4D)Shiller Barclays CAPE®US Core Mid-Month Sector–Denominated in",
    "EnglishLongName": "$I.B.I. MEHAKA(4D)Shiller Barclays CAPE®US Core Mid-Month Sector–Denominated in",
    "HebrewName": "איביאי מחקה ShillerC USנ$",
    "HebrewLongName": "אי.בי.אי. מחקה (4D)י Shiller Barclays CAPE® US Core Mid-Month Sector-נקובה $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.66,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 156.0,
    "MonthYield": 1.49,
    "YearYield": 1.49,
    "Last12MonthYield": -1.94,
    "ISIN": "IL0051371792"
  },
  {
    "Id": "TASE:5134671",
    "MayaId": "5134671",
    "Name": "$IBI MEHAKA TA125Denomina",
    "ShortName": "$IBI MEHAKA TA125Denomina",
    "Symbol": "TASE:5134671",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "$ I.B.I. MEHAKA (4D) TA 125 IL-Denominated in",
    "EnglishLongName": "$ I.B.I. MEHAKA (4D) TA 125 IL-Denominated in",
    "HebrewName": "איביאי מחקה תא 125-נ $",
    "HebrewLongName": "אי.בי.אי. מחקה (4D) ת\"א 125–נקובה $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.54,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 278.4,
    "MonthYield": 7.82,
    "YearYield": 7.82,
    "Last12MonthYield": 44.48,
    "ISIN": "IL0051346711"
  },
  {
    "Id": "TASE:5140777",
    "MayaId": "5140777",
    "Name": "$KSM KTF GL$Bul 30 D",
    "ShortName": "$KSM KTF GL$Bul 30 D",
    "Symbol": "TASE:5140777",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (0D) Global $ Bullet 2030 iNDEX $Denominated",
    "EnglishLongName": "KSM KTF (0D) Global $ Bullet 2030 iNDEX $Denominated",
    "HebrewName": "קסם Bu KTF דו 2030 גל נ $",
    "HebrewLongName": "קסם KTF י(0D) אינדקס Bullet דולר 2030 - גלובלי נקובה $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Hedged Corporate and Convertibles",
    "AssetValue": 6.6,
    "MonthYield": -1.05,
    "YearYield": -1.05,
    "Last12MonthYield": null,
    "ISIN": "IL0051407778"
  },
  {
    "Id": "TASE:5136890",
    "MayaId": "5136890",
    "Name": "$Migdal $MnMrk Deno",
    "ShortName": "$Migdal $MnMrk Deno",
    "Symbol": "TASE:5136890",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (0D) Dollar Money Market Fund-Denominated in $",
    "EnglishLongName": "Migdal (0D) Dollar Money Market Fund-Denominated in $",
    "HebrewName": "מגדל כספית דולרית נקובה $",
    "HebrewLongName": "מגדל (0D) כספית דולרית - נקובה $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.21,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.11,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "FX Money Market with Corporate",
    "AssetValue": 1112.7,
    "MonthYield": -0.93,
    "YearYield": -0.93,
    "Last12MonthYield": -9.42,
    "ISIN": "IL0051368905"
  },
  {
    "Id": "TASE:5135017",
    "MayaId": "5135017",
    "Name": "$MORE ! COR B IS Related",
    "ShortName": "$MORE ! COR B IS Related",
    "Symbol": "TASE:5135017",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE (1D)(!) CORPORATE BONDS ISRAEL Related in $ IL",
    "EnglishLongName": "MORE (1D)(!) CORPORATE BONDS ISRAEL Related in $ IL",
    "HebrewName": "מור ! אגח חברות זיקה יש $",
    "HebrewLongName": "מור (1D)(!) אג\"ח חברות זיקה לישראל- נקוב $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.46,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles with Equity",
    "AssetValue": 46.2,
    "MonthYield": 1.18,
    "YearYield": 1.18,
    "Last12MonthYield": 4.62,
    "ISIN": "IL0051350176"
  },
  {
    "Id": "TASE:5141007",
    "MayaId": "5141007",
    "Name": "$MTF TR USANRN DENOM",
    "ShortName": "$MTF TR USANRN DENOM",
    "Symbol": "TASE:5141007",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4D) Bloomberg US Analyst Recommendations Denominated in Dollar",
    "EnglishLongName": "MTF TR (4D) Bloomberg US Analyst Recommendations Denominated in Dollar",
    "HebrewName": "MTF מחBLBRG US AN RCנקוב$",
    "HebrewLongName": "MTF מחקה (4D)י Bloomberg US Analyst Recommendations נקובה $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 4.0,
    "MonthYield": 0.69,
    "YearYield": 0.69,
    "Last12MonthYield": null,
    "ISIN": "IL0051410079"
  },
  {
    "Id": "TASE:5137823",
    "MayaId": "5137823",
    "Name": "$Sela Eq Foreign Fund – D",
    "ShortName": "$Sela Eq Foreign Fund – D",
    "Symbol": "TASE:5137823",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Sela (4D) Equity Foreign Fund of Funds – Denominated in $",
    "EnglishLongName": "Sela (4D) Equity Foreign Fund of Funds – Denominated in $",
    "HebrewName": "סלע אגד חוץ מנייתי-נקוב $",
    "HebrewLongName": "סלע (4D) אגד חוץ מנייתי - נקוב $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.35,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.99,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Fund of Funds",
    "SecondaryClassification": "Foreign Fund of Funds",
    "AssetValue": 21.4,
    "MonthYield": 1.06,
    "YearYield": 1.06,
    "Last12MonthYield": 3.7,
    "ISIN": "IL0051378235"
  },
  {
    "Id": "TASE:5140678",
    "MayaId": "5140678",
    "Name": "$Y.L.TF S&P 500 MrkLead D",
    "ShortName": "$Y.L.TF S&P500 MrkLead D",
    "Symbol": "TASE:5140678",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (4D) S&P 500 Market Leaders USD Denominated",
    "EnglishLongName": "YLTF (4D) S&P 500 Market Leaders USD Denominated",
    "HebrewName": "י.ל מחקה S&P500 MrkLeadנ$",
    "HebrewLongName": "ילין לפידות מחקה (4D)י S&P 500 Market Leaders נקובה $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 9.2,
    "MonthYield": 0.8,
    "YearYield": 0.8,
    "Last12MonthYield": null,
    "ISIN": "IL0051406788"
  },
  {
    "Id": "KSM-F208.TA",
    "MayaId": "1186634",
    "Name": "(2649.49) KSM ETF (60) Short TA RealEstate IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F208.TA",
    "TaseSymbol": "KSM.F208",
    "YahooId": "KSM-F208.TA",
    "EnglishName": "KSM.SHTAREALIL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.חסתא נדלן",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 1.0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5358.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Leveraged",
    "SecondaryClassification": "Stocks in Israel",
    "AssetValue": null,
    "MonthYield": -25.9,
    "YearYield": -25.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011866345"
  },
  {
    "Id": "KSM-F169.TA",
    "MayaId": "1147347",
    "Name": "(KSM ETF (6A) Short TA SME60 IL (1913.2",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F169.TA",
    "TaseSymbol": "KSM.F169",
    "YahooId": "KSM-F169.TA",
    "EnglishName": "KSM.SHTASME60IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.חסתא SME60",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 2.35,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2400.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "UBANK",
    "MainClassification": "Leveraged",
    "SecondaryClassification": "Stocks in Israel",
    "AssetValue": null,
    "MonthYield": -7.0,
    "YearYield": -7.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011473472"
  },
  {
    "Id": "TASE:5115464",
    "MayaId": "5115464",
    "Name": "+ Ayalon lqd benleumi IL",
    "ShortName": "+ Ayalon lqd benleumi IL",
    "Symbol": "TASE:5115464",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalon (0A) Following Liquidity Component Plus portfolio– Benleumi Bank IL",
    "EnglishLongName": "Ayalon (0A) Following Liquidity Component Plus portfolio– Benleumi Bank IL",
    "HebrewName": "איילון נזילות בינלאומי +",
    "HebrewLongName": "איילון (0A) עוקבת תיק מרכיב הנזילות פלוס - הבנק הבינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.52,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.1,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 14.8,
    "MonthYield": 0.38,
    "YearYield": 0.38,
    "Last12MonthYield": 5.24,
    "ISIN": "IL0051154644"
  },
  {
    "Id": "TASE:5111620",
    "MayaId": "5111620",
    "Name": "+ I.B.I. Gov Shkl Short",
    "ShortName": "+ I.B.I. Gov Shkl Short",
    "Symbol": "TASE:5111620",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (00) Government Shekel Short Term Plus IL",
    "EnglishLongName": "I.B.I. (00) Government Shekel Short Term Plus IL",
    "HebrewName": "איביאי ממשל שקלי קצר פלוס",
    "HebrewLongName": "אי.בי.אי. (00) ממשלתי שקלי קצר פלוס",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.35,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.03,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Shekel Bonds - No Equity",
    "AssetValue": 27.3,
    "MonthYield": 0.38,
    "YearYield": 0.38,
    "Last12MonthYield": 5.33,
    "ISIN": "IL0051116205"
  },
  {
    "Id": "TASE:5114640",
    "MayaId": "5114640",
    "Name": "+ MEITAV ! CORP BND",
    "ShortName": "+ MEITAV ! CORP BND",
    "Symbol": "TASE:5114640",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Meitav (1A)(!) Konzerni plus IL",
    "EnglishLongName": "Meitav (1A)(!) Konzerni plus IL",
    "HebrewName": "מיטב (!) קונצרני פלוס",
    "HebrewLongName": "מיטב (1A)(!) קונצרני פלוס",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.29,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles with Equity",
    "AssetValue": 109.6,
    "MonthYield": 1.04,
    "YearYield": 1.04,
    "Last12MonthYield": 10.4,
    "ISIN": "IL0051146400"
  },
  {
    "Id": "TASE:5119367",
    "MayaId": "5119367",
    "Name": "+ MEITAV BONDS",
    "ShortName": "+ MEITAV BONDS",
    "Symbol": "TASE:5119367",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (1B) Bonds Plus IL",
    "EnglishLongName": "MEITAV (1B) Bonds Plus IL",
    "HebrewName": "מיטב אג\"ח פלוס",
    "HebrewLongName": "מיטב (1B) אג\"ח פלוס",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 73.5,
    "MonthYield": 1.22,
    "YearYield": 1.22,
    "Last12MonthYield": 10.47,
    "ISIN": "IL0051193675"
  },
  {
    "Id": "TASE:5123146",
    "MayaId": "5123146",
    "Name": "+ MEITAV NIS CRP BND",
    "ShortName": "+ MEITAV NIS CRP BND",
    "Symbol": "TASE:5123146",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (1A) NIS CORPORATE PLUS IL",
    "EnglishLongName": "MEITAV (1A) NIS CORPORATE PLUS IL",
    "HebrewName": "מיטב קונצרני שקלי פלוס",
    "HebrewLongName": "מיטב (1A) קונצרני שקלי פלוס",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.38,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Shekel Corporate and Convertibles with Equity",
    "AssetValue": 121.9,
    "MonthYield": 1.58,
    "YearYield": 1.58,
    "Last12MonthYield": 12.87,
    "ISIN": "IL0051231467"
  },
  {
    "Id": "TASE:5116967",
    "MayaId": "5116967",
    "Name": "+MORE T Tel Shekel 5",
    "ShortName": "+MORE T Tel Shekel 5",
    "Symbol": "TASE:5116967",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE Tracking (00) Tel Gov- Shekel 5+ IL",
    "EnglishLongName": "MORE Tracking (00) Tel Gov- Shekel 5+ IL",
    "HebrewName": "מור מחקה שחר 5+",
    "HebrewLongName": "מור מחקה (00) תל גוב- שקלי 5+",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.74,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Non-Linked Government Bonds",
    "AssetValue": 31.2,
    "MonthYield": 1.25,
    "YearYield": 1.25,
    "Last12MonthYield": 11.04,
    "ISIN": "IL0051169675"
  },
  {
    "Id": "TASE:5138417",
    "MayaId": "5138417",
    "Name": "+Tachlit TTF AA AAA 5",
    "ShortName": "+Tachlit TTF AA-AAA 5",
    "Symbol": "TASE:5138417",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (00) Index AA-AAA 5+ Low Financial leveraged Factor IL",
    "EnglishLongName": "Tachlit TTF (00) Index AA-AAA 5+ Low Financial leveraged Factor IL",
    "HebrewName": "תכלית AA-AAA TTF י5+",
    "HebrewLongName": "תכלית TTF י(00) אינדקס AA-AAA י5+ פקטור מינוף פיננסי נמוך",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.65,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 11.1,
    "MonthYield": 0.84,
    "YearYield": 0.84,
    "Last12MonthYield": 10.07,
    "ISIN": "IL0051384175"
  },
  {
    "Id": "TASE:5133871",
    "MayaId": "5133871",
    "Name": "30 +FALCON Portfolio",
    "ShortName": "30 +FALCON Portfolio",
    "Symbol": "TASE:5133871",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "FALCON (2B) PORTFOLIO +30% IL",
    "EnglishLongName": "FALCON (2B) PORTFOLIO +30% IL",
    "HebrewName": "פלקון תיק השקעות+30",
    "HebrewLongName": "פלקון (2B) תיק השקעות + 30%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.78,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 29.3,
    "MonthYield": 2.22,
    "YearYield": 2.22,
    "Last12MonthYield": 19.33,
    "ISIN": "IL0051338718"
  },
  {
    "Id": "TASE:5139662",
    "MayaId": "5139662",
    "Name": "A.S (4D) Electrification",
    "ShortName": "A.S (4D) Electrification",
    "Symbol": "TASE:5139662",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham (4D) Electrification",
    "EnglishLongName": "Altshuler Shaham (4D) Electrification",
    "HebrewName": "א.ש (4D)י Electrification",
    "HebrewLongName": "אלטשולר שחם (4D)י Electrification",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.5,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.66,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks by Sectors - Foreign",
    "AssetValue": 252.2,
    "MonthYield": 4.47,
    "YearYield": 4.47,
    "Last12MonthYield": 33.34,
    "ISIN": "IL0051396625"
  },
  {
    "Id": "TASE:5140546",
    "MayaId": "5140546",
    "Name": "A.S Tracking (4A) S&P CH",
    "ShortName": "A.S Tracking (4A) S&P CH",
    "Symbol": "TASE:5140546",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham Tracking (4A) S&P 500 Currency-Hedged",
    "EnglishLongName": "Altshuler Shaham Tracking (4A) S&P 500 Currency-Hedged",
    "HebrewName": "א.ש מחקה (4A)י S&P 500 ממ",
    "HebrewLongName": "אלטשולר שחם מחקה (4A)י S&P 500 מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.61,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 24.2,
    "MonthYield": 1.46,
    "YearYield": 1.46,
    "Last12MonthYield": null,
    "ISIN": "IL0051405467"
  },
  {
    "Id": "TASE:5138029",
    "MayaId": "5138029",
    "Name": "A.S Tracking A.B SB US MF",
    "ShortName": "A.S Tracking A.B SB US MF",
    "Symbol": "TASE:5138029",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham Tracking (4D) A.B Smartbeta USA MultiFactor",
    "EnglishLongName": "Altshuler Shaham Tracking (4D) A.B Smartbeta USA MultiFactor",
    "HebrewName": "א.ש מחקה A.B SB US MF",
    "HebrewLongName": "אלטשולר שחם מחקה (4D)י A.B SmartBeta USA MultiFactor",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.84,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 1.2,
    "MonthYield": 3.79,
    "YearYield": 3.79,
    "Last12MonthYield": -4.47,
    "ISIN": "IL0051380298"
  },
  {
    "Id": "TASE:5139100",
    "MayaId": "5139100",
    "Name": "A.S Tracking S&P 500",
    "ShortName": "A.S Tracking S&P 500",
    "Symbol": "TASE:5139100",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham Tracking (4D) S&P 500",
    "EnglishLongName": "Altshuler Shaham Tracking (4D) S&P 500",
    "HebrewName": "א.ש מחקה S&P 500",
    "HebrewLongName": "אלטשולר שחם מחקה (4D)י S&P 500",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.4,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 35.7,
    "MonthYield": 0.09,
    "YearYield": 0.09,
    "Last12MonthYield": 3.02,
    "ISIN": "IL0051391006"
  },
  {
    "Id": "ABOU-M.TA",
    "MayaId": "1175819",
    "Name": "ABOU RESIDENC M",
    "ShortName": "ABOU FAMILY RESIDENCE LTD",
    "Symbol": "ABOU-M.TA",
    "TaseSymbol": "ABOU-M",
    "YahooId": "ABOU-M.TA",
    "EnglishName": "ABOU RESIDENC-M",
    "EnglishLongName": "ABOU FAMILY RESIDENCE LTD",
    "HebrewName": "אבו מגורים-ש",
    "HebrewLongName": "אבו פמילי מגורים בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 649.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -7.5,
    "YearYield": -7.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011758195"
  },
  {
    "Id": "ABRA.TA",
    "MayaId": "1101666",
    "Name": "ABRA",
    "ShortName": "ABRA INFORMATION TECHNOLOGIES LTD.",
    "Symbol": "ABRA.TA",
    "TaseSymbol": "ABRA",
    "YahooId": "ABRA.TA",
    "EnglishName": "ABRA",
    "EnglishLongName": "ABRA INFORMATION TECHNOLOGIES LTD.",
    "HebrewName": "אברא",
    "HebrewLongName": "אברא טכנולוגיות מידע בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 541.2,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 18.2,
    "YearYield": 18.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011016669"
  },
  {
    "Id": "ACCL.TA",
    "MayaId": "770016",
    "Name": "ACCEL",
    "ShortName": "ACCEL SOLUTIONS GROUP LTD",
    "Symbol": "ACCL.TA",
    "TaseSymbol": "ACCL",
    "YahooId": "ACCL.TA",
    "EnglishName": "ACCEL",
    "EnglishLongName": "ACCEL SOLUTIONS GROUP LTD",
    "HebrewName": "אקסל",
    "HebrewLongName": "אקסל סולושנס גרופ בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 190.9,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 5.8,
    "YearYield": 5.8,
    "Last12MonthYield": null,
    "ISIN": "IL0007700169"
  },
  {
    "Id": "TASE:5138821",
    "MayaId": "5138821",
    "Name": "Achord (!) Bonds Plus IL",
    "ShortName": "Achord (!) Bonds Plus IL",
    "Symbol": "TASE:5138821",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Achord (1B)(!) Bonds Plus IL",
    "EnglishLongName": "Achord (1B)(!) Bonds Plus IL",
    "HebrewName": "אקורד (!) אג\"ח פלוס",
    "HebrewLongName": "אקורד (1B)(!) אג\"ח פלוס",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 35.6,
    "MonthYield": 1.62,
    "YearYield": 1.62,
    "Last12MonthYield": 9.62,
    "ISIN": "IL0051388218"
  },
  {
    "Id": "TASE:5131545",
    "MayaId": "5131545",
    "Name": "Achord (1A) 90/10 IL",
    "ShortName": "Achord (1A) 90/10 IL",
    "Symbol": "TASE:5131545",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Achord (1A) 90/10 IL",
    "EnglishLongName": "Achord (1A) 90/10 IL",
    "HebrewName": "אקורד (1A)י 10/90",
    "HebrewLongName": "אקורד (1A)י 10/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.45,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 336.4,
    "MonthYield": 0.77,
    "YearYield": 0.77,
    "Last12MonthYield": 9.09,
    "ISIN": "IL0051315450"
  },
  {
    "Id": "TASE:5132873",
    "MayaId": "5132873",
    "Name": "ACHORD (2B) 70/30 IL",
    "ShortName": "ACHORD (2B) 70/30 IL",
    "Symbol": "TASE:5132873",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ACHORD (2B) 70/30 IL",
    "EnglishLongName": "ACHORD (2B) 70/30 IL",
    "HebrewName": "אקורד (2B)י 30/70",
    "HebrewLongName": "אקורד (2B)י 30/70",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.88,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.73,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 232.1,
    "MonthYield": 2.0,
    "YearYield": 2.0,
    "Last12MonthYield": 14.47,
    "ISIN": "IL0051328735"
  },
  {
    "Id": "TASE:5131560",
    "MayaId": "5131560",
    "Name": "Achord (2B) 80/20 IL",
    "ShortName": "Achord (2B) 80/20 IL",
    "Symbol": "TASE:5131560",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Achord (2B) 80/20 IL",
    "EnglishLongName": "Achord (2B) 80/20 IL",
    "HebrewName": "אקורד (2B)י 20/80",
    "HebrewLongName": "אקורד (2B)י 20/80",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.6,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 469.6,
    "MonthYield": 1.95,
    "YearYield": 1.95,
    "Last12MonthYield": 11.99,
    "ISIN": "IL0051315609"
  },
  {
    "Id": "TASE:5140033",
    "MayaId": "5140033",
    "Name": "Achord (4B) Stocks IL",
    "ShortName": "Achord (4B) Stocks IL",
    "Symbol": "TASE:5140033",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Achord (4B) Stocks IL",
    "EnglishLongName": "Achord (4B) Stocks IL",
    "HebrewName": "אקורד (4B) מניות",
    "HebrewLongName": "אקורד (4B) מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.45,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.31,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 12.0,
    "MonthYield": 7.1,
    "YearYield": 7.1,
    "Last12MonthYield": null,
    "ISIN": "IL0051400336"
  },
  {
    "Id": "TASE:5140470",
    "MayaId": "5140470",
    "Name": "Achord Bonds No Stocks IL",
    "ShortName": "Achord Bonds No Stocks IL",
    "Symbol": "TASE:5140470",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Achord (0B) Bonds Without Stocks IL",
    "EnglishLongName": "Achord (0B) Bonds Without Stocks IL",
    "HebrewName": "אקורד אג\"ח ללא מניות",
    "HebrewLongName": "אקורד (0B) אג\"ח ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.42,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 5.6,
    "MonthYield": 0.96,
    "YearYield": 0.96,
    "Last12MonthYield": null,
    "ISIN": "IL0051404700"
  },
  {
    "Id": "TASE:5131552",
    "MayaId": "5131552",
    "Name": "Achord Inv Grade Bnds IL",
    "ShortName": "Achord Inv Grade Bnds IL",
    "Symbol": "TASE:5131552",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Achord (00) Investment Grade Bonds IL",
    "EnglishLongName": "Achord (00) Investment Grade Bonds IL",
    "HebrewName": "אקורד אג\"ח מדורגות",
    "HebrewLongName": "אקורד (00) אג\"ח מדורגות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.77,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.36,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 274.7,
    "MonthYield": 0.69,
    "YearYield": 0.69,
    "Last12MonthYield": 6.58,
    "ISIN": "IL0051315526"
  },
  {
    "Id": "ACKR.TA",
    "MayaId": "1176205",
    "Name": "ACKERSTEIN GRP.",
    "ShortName": "ACKERSTEIN GROUP LTD",
    "Symbol": "ACKR.TA",
    "TaseSymbol": "ACKR",
    "YahooId": "ACKR.TA",
    "EnglishName": "ACKERSTEIN GRP.",
    "EnglishLongName": "ACKERSTEIN GROUP LTD",
    "HebrewName": "קבוצת אקרשטיין",
    "HebrewLongName": "קבוצת אקרשטיין בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 750.2,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -13.8,
    "YearYield": -13.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011762056"
  },
  {
    "Id": "ACRO.TA",
    "MayaId": "1184902",
    "Name": "ACRO KVUT",
    "ShortName": "KVUTZAT ACRO LTD",
    "Symbol": "ACRO.TA",
    "TaseSymbol": "ACRO",
    "YahooId": "ACRO.TA",
    "EnglishName": "ACRO KVUT",
    "EnglishLongName": "KVUTZAT ACRO LTD",
    "HebrewName": "אקרו",
    "HebrewLongName": "קבוצת אקרו בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5033.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 11.4,
    "YearYield": 11.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011849028"
  },
  {
    "Id": "ADGR.TA",
    "MayaId": "1820083",
    "Name": "ADGAR INV.",
    "ShortName": "ADGAR INVESTMENT & DEVELOPMENT LTD",
    "Symbol": "ADGR.TA",
    "TaseSymbol": "ADGR",
    "YahooId": "ADGR.TA",
    "EnglishName": "ADGAR INV.",
    "EnglishLongName": "ADGAR INVESTMENT & DEVELOPMENT LTD",
    "HebrewName": "אדגר",
    "HebrewLongName": "אדגר השקעות ופיתוח בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 463.5,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.1,
    "YearYield": 0.1,
    "Last12MonthYield": null,
    "ISIN": "IL0018200837"
  },
  {
    "Id": "ARDM.TA",
    "MayaId": "363010",
    "Name": "AERODROME GROUP",
    "ShortName": "AERODROME GROUP LTD",
    "Symbol": "ARDM.TA",
    "TaseSymbol": "ARDM",
    "YahooId": "ARDM.TA",
    "EnglishName": "AERODROME GROUP",
    "EnglishLongName": "AERODROME GROUP LTD",
    "HebrewName": "אירודרום קבוצה",
    "HebrewLongName": "קבוצת אירודרום בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 86.7,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 230.3,
    "YearYield": 230.3,
    "Last12MonthYield": null,
    "ISIN": "IL0003630105"
  },
  {
    "Id": "AFHL.TA",
    "MayaId": "578013",
    "Name": "AFCON HOLD",
    "ShortName": "AFCON HOLDINGS LTD.",
    "Symbol": "AFHL.TA",
    "TaseSymbol": "AFHL",
    "YahooId": "AFHL.TA",
    "EnglishName": "AFCON HOLD",
    "EnglishLongName": "AFCON HOLDINGS LTD.",
    "HebrewName": "אפקון החזקות",
    "HebrewLongName": "אפקון החזקות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 33720.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Investment & Holdings",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -5.5,
    "YearYield": -5.5,
    "Last12MonthYield": null,
    "ISIN": "IL0005780130"
  },
  {
    "Id": "AFPR.TA",
    "MayaId": "1091354",
    "Name": "AFI PROPERTIES",
    "ShortName": "AFI PROPERTIES LTD",
    "Symbol": "AFPR.TA",
    "TaseSymbol": "AFPR",
    "YahooId": "AFPR.TA",
    "EnglishName": "AFI PROPERTIES",
    "EnglishLongName": "AFI PROPERTIES LTD",
    "HebrewName": "אפי נכסים",
    "HebrewLongName": "אפי נכסים בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 24190.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 5.3,
    "YearYield": 5.3,
    "Last12MonthYield": null,
    "ISIN": "IL0010913544"
  },
  {
    "Id": "TASE:5120514",
    "MayaId": "5120514",
    "Name": "AFK CHUL",
    "ShortName": "AFK CHUL",
    "Symbol": "TASE:5120514",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal Afikim (4D) Global",
    "EnglishLongName": "Migdal Afikim (4D) Global",
    "HebrewName": "אפיקים 4D חו\"ל",
    "HebrewLongName": "מגדל אפיקים (4D) חו\"ל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.97,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.03,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 63.4,
    "MonthYield": 0.89,
    "YearYield": 0.89,
    "Last12MonthYield": 3.6,
    "ISIN": "IL0051205149"
  },
  {
    "Id": "AFRE.TA",
    "MayaId": "1097948",
    "Name": "AFRICA RESIDENC",
    "ShortName": "AFRICA ISRAEL RESIDENCES LTD.",
    "Symbol": "AFRE.TA",
    "TaseSymbol": "AFRE",
    "YahooId": "AFRE.TA",
    "EnglishName": "AFRICA RESIDENC",
    "EnglishLongName": "AFRICA ISRAEL RESIDENCES LTD.",
    "HebrewName": "אפריקה מגורים",
    "HebrewLongName": "אפריקה ישראל מגורים בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 29580.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 11.4,
    "YearYield": 11.4,
    "Last12MonthYield": null,
    "ISIN": "IL0010979487"
  },
  {
    "Id": "ARPT.TA",
    "MayaId": "1095835",
    "Name": "AIRPORT CITY",
    "ShortName": "AIRPORT CITY LTD",
    "Symbol": "ARPT.TA",
    "TaseSymbol": "ARPT",
    "YahooId": "ARPT.TA",
    "EnglishName": "AIRPORT CITY",
    "EnglishLongName": "AIRPORT CITY LTD",
    "HebrewName": "ארפורט סיטי",
    "HebrewLongName": "איירפורט סיטי בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 6046.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -1.8,
    "YearYield": -1.8,
    "Last12MonthYield": null,
    "ISIN": "IL0010958358"
  },
  {
    "Id": "ARTS.TA",
    "MayaId": "1173376",
    "Name": "AIRTOUCH",
    "ShortName": "AIRTOUCH SOLAR LTD",
    "Symbol": "ARTS.TA",
    "TaseSymbol": "ARTS",
    "YahooId": "ARTS.TA",
    "EnglishName": "AIRTOUCH",
    "EnglishLongName": "AIRTOUCH SOLAR LTD",
    "HebrewName": "איירטאצ",
    "HebrewLongName": "איירטאצ' סולאר בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 43.9,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -2.2,
    "YearYield": -2.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011733768"
  },
  {
    "Id": "ALAR.TA",
    "MayaId": "1083856",
    "Name": "ALARUM",
    "ShortName": "ALARUM TECHNOLOGIES LTD",
    "Symbol": "ALAR.TA",
    "TaseSymbol": "ALAR",
    "YahooId": "ALAR.TA",
    "EnglishName": "ALARUM",
    "EnglishLongName": "ALARUM TECHNOLOGIES LTD",
    "HebrewName": "אלארום",
    "HebrewLongName": "אלארום טכנולוגיות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 276.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -1.8,
    "YearYield": -1.8,
    "Last12MonthYield": null,
    "ISIN": "IL0010838568"
  },
  {
    "Id": "ALBA.TA",
    "MayaId": "625012",
    "Name": "ALBAAD",
    "ShortName": "ALBAAD MASSUOT YITZHAK LTD.",
    "Symbol": "ALBA.TA",
    "TaseSymbol": "ALBA",
    "YahooId": "ALBA.TA",
    "EnglishName": "ALBAAD",
    "EnglishLongName": "ALBAAD MASSUOT YITZHAK LTD.",
    "HebrewName": "עלבד",
    "HebrewLongName": "עלבד משואות יצחק בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3200.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -8.0,
    "YearYield": -8.0,
    "Last12MonthYield": null,
    "ISIN": "IL0006250125"
  },
  {
    "Id": "TASE:5129473",
    "MayaId": "5129473",
    "Name": "Alfa Tech ESG Foreign Equ",
    "ShortName": "Alfa Tech ESG Foreign Equ",
    "Symbol": "TASE:5129473",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Alfa Tech (4D) ESG Foreign Equity",
    "EnglishLongName": "Alfa Tech (4D) ESG Foreign Equity",
    "HebrewName": "אלפא טק מניות חו\"ל ESG",
    "HebrewLongName": "אלפא טק (4D) מניות חו\"ל ESG",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.9,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.75,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 31.3,
    "MonthYield": 3.23,
    "YearYield": 3.23,
    "Last12MonthYield": 14.55,
    "ISIN": "IL0051294739"
  },
  {
    "Id": "TASE:5122536",
    "MayaId": "5122536",
    "Name": "Alfa Tech Europe E.S.G",
    "ShortName": "Alfa Tech Europe E.S.G",
    "Symbol": "TASE:5122536",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Alfa Tech (4D) Europe E.S.G",
    "EnglishLongName": "Alfa Tech (4D) Europe E.S.G",
    "HebrewName": "אלפא טק אירופה E.S.G",
    "HebrewLongName": "אלפא טק (4D) אירופה E.S.G",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.98,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.67,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Geographical stocks",
    "AssetValue": 9.5,
    "MonthYield": 3.93,
    "YearYield": 3.93,
    "Last12MonthYield": 28.61,
    "ISIN": "IL0051225360"
  },
  {
    "Id": "TASE:5125836",
    "MayaId": "5125836",
    "Name": "Alfa Tech IsraelESG Eq IL",
    "ShortName": "Alfa Tech IsraelESG Eq IL",
    "Symbol": "TASE:5125836",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Alfa Tech (4A) Israel ESG Equity IL",
    "EnglishLongName": "Alfa Tech (4A) Israel ESG Equity IL",
    "HebrewName": "אלפא טק מניות ESG ישראל",
    "HebrewLongName": "אלפא טק (4A) מניות ESG ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.25,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.89,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 42.0,
    "MonthYield": 6.56,
    "YearYield": 6.56,
    "Last12MonthYield": 63.88,
    "ISIN": "IL0051258361"
  },
  {
    "Id": "TASE:5125828",
    "MayaId": "5125828",
    "Name": "Alfi Bene All Bon Comp IL",
    "ShortName": "Alfi Bene All Bon Comp IL",
    "Symbol": "TASE:5125828",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Alfi Benedek (0A)(!) All Bond Composite IL",
    "EnglishLongName": "Alfi Benedek (0A)(!) All Bond Composite IL",
    "HebrewName": "אלפי בנדק All Bond כללי",
    "HebrewLongName": "אלפי בנדק (0A)(!)י All Bond כללי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.41,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 106.9,
    "MonthYield": 0.58,
    "YearYield": 0.58,
    "Last12MonthYield": 6.47,
    "ISIN": "IL0051258288"
  },
  {
    "Id": "TASE:5125208",
    "MayaId": "5125208",
    "Name": "Alfi Benedek 70/30IsPorIL",
    "ShortName": "Alfi Benedek 70/30IsPorIL",
    "Symbol": "TASE:5125208",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Alfi Benedek (2B) 70/30 Israel Portfolio IL",
    "EnglishLongName": "Alfi Benedek (2B) 70/30 Israel Portfolio IL",
    "HebrewName": "אלפי בנדק 30/70 תיק ישראל",
    "HebrewLongName": "אלפי בנדק (2B)י 30/70 תיק ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.055,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.83,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 139.7,
    "MonthYield": 2.1,
    "YearYield": 2.1,
    "Last12MonthYield": 19.7,
    "ISIN": "IL0051252083"
  },
  {
    "Id": "TASE:5121363",
    "MayaId": "5121363",
    "Name": "Alfi Benedek 80/20 IL",
    "ShortName": "Alfi Benedek 80/20 IL",
    "Symbol": "TASE:5121363",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Alfi Benedek (2C) 80/20 IL",
    "EnglishLongName": "Alfi Benedek (2C) 80/20 IL",
    "HebrewName": "אלפי בנדק 20/80",
    "HebrewLongName": "אלפי בנדק (2C)י 20/80",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.06,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.56,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 40.3,
    "MonthYield": 2.35,
    "YearYield": 2.35,
    "Last12MonthYield": 14.5,
    "ISIN": "IL0051213630"
  },
  {
    "Id": "TASE:5125216",
    "MayaId": "5125216",
    "Name": "Alfi Benedek 90/10 IL",
    "ShortName": "Alfi Benedek 90/10 IL",
    "Symbol": "TASE:5125216",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Alfi Benedek (1A) 90/10 IL",
    "EnglishLongName": "Alfi Benedek (1A) 90/10 IL",
    "HebrewName": "אלפי בנדק 10/90",
    "HebrewLongName": "אלפי בנדק (1A)י 10/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.76,
    "TrusteeFee": 0.055,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.5,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 39.1,
    "MonthYield": 1.49,
    "YearYield": 1.49,
    "Last12MonthYield": 9.71,
    "ISIN": "IL0051252166"
  },
  {
    "Id": "TASE:5127188",
    "MayaId": "5127188",
    "Name": "Alfi Benedek Equities IL",
    "ShortName": "Alfi Benedek Equities IL",
    "Symbol": "TASE:5127188",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Alfi Benedek (4B) Israel Equities IL",
    "EnglishLongName": "Alfi Benedek (4B) Israel Equities IL",
    "HebrewName": "אלפי בנדק מניות ישראל",
    "HebrewLongName": "אלפי בנדק (4B) מניות ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.69,
    "TrusteeFee": 0.06,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.1,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 113.1,
    "MonthYield": 9.4,
    "YearYield": 9.4,
    "Last12MonthYield": 65.92,
    "ISIN": "IL0051271885"
  },
  {
    "Id": "TASE:5135322",
    "MayaId": "5135322",
    "Name": "Alfi Benedek Flexible",
    "ShortName": "Alfi Benedek Flexible",
    "Symbol": "TASE:5135322",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Alfi Benedek (4D) Flexible",
    "EnglishLongName": "Alfi Benedek (4D) Flexible",
    "HebrewName": "אלפי בנדק גמישה",
    "HebrewLongName": "אלפי בנדק (4D) גמישה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.5,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 7.1,
    "MonthYield": -1.39,
    "YearYield": -1.39,
    "Last12MonthYield": -0.94,
    "ISIN": "IL0051353220"
  },
  {
    "Id": "TASE:5132436",
    "MayaId": "5132436",
    "Name": "Alfi Benedek Global Equi",
    "ShortName": "Alfi Benedek Global Equi",
    "Symbol": "TASE:5132436",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Alfi Benedek (4D) Global Equity",
    "EnglishLongName": "Alfi Benedek (4D) Global Equity",
    "HebrewName": "אלפי בנדק מניות חול",
    "HebrewLongName": "אלפי בנדק (4D) מניות חו\"ל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.69,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.59,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 57.7,
    "MonthYield": 6.67,
    "YearYield": 6.67,
    "Last12MonthYield": 22.02,
    "ISIN": "IL0051324361"
  },
  {
    "Id": "TASE:5141932",
    "MayaId": "5141932",
    "Name": "Alfi Benedek Port upto50%",
    "ShortName": "Alfi Benedek Port upto50%",
    "Symbol": "TASE:5141932",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Alfi Benedek (3C) Portfoio up to 50%",
    "EnglishLongName": "Alfi Benedek (3C) Portfoio up to 50%",
    "HebrewName": "אלפי בנדק תיק השקעות 50%",
    "HebrewLongName": "אלפי בנדק (3C) תיק השקעות עד 50%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.85,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - Max. Exposure over 30% Equity",
    "AssetValue": 0.0,
    "MonthYield": 1.31,
    "YearYield": 1.31,
    "Last12MonthYield": null,
    "ISIN": "IL0051419328"
  },
  {
    "Id": "TASE:5132428",
    "MayaId": "5132428",
    "Name": "AlfiBenedek FlwBonFib3 IL",
    "ShortName": "AlfiBenedek FlwBonFib3 IL",
    "Symbol": "TASE:5132428",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Alfi Benedek (2B) Tracking Portfolio 3 International Bank IL",
    "EnglishLongName": "Alfi Benedek (2B) Tracking Portfolio 3 International Bank IL",
    "HebrewName": "אלפי בנדק עוקבת תיק3 בינ",
    "HebrewLongName": "אלפי בנדק (2B) עוקבת תיק 3 הבנק הבינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.47,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 81.6,
    "MonthYield": 1.75,
    "YearYield": 1.75,
    "Last12MonthYield": 10.43,
    "ISIN": "IL0051324288"
  },
  {
    "Id": "TASE:601",
    "MayaId": "601",
    "Name": "All Bond",
    "ShortName": "All-Bond",
    "Symbol": "TASE:601",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "All Bond",
    "EnglishLongName": "All-Bond",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:604",
    "MayaId": "604",
    "Name": "All Bond CPI Linked",
    "ShortName": "All-Bond CPI-Linked",
    "Symbol": "TASE:604",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "All Bond CPI Linked",
    "EnglishLongName": "All-Bond CPI-Linked",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:739",
    "MayaId": "739",
    "Name": "All Bond Dollar & Top 5 Tel Bond 20 CPI",
    "ShortName": "All-Bond Dollar & Top 5 Tel Bond 20 CPI",
    "Symbol": "TASE:739",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "All Bond Dollar & Top 5 Tel Bond 20 CPI",
    "EnglishLongName": "All-Bond Dollar & Top 5 Tel Bond 20 CPI",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:716",
    "MayaId": "716",
    "Name": "All Bond Floating Shekel",
    "ShortName": "All-Bond Floating Shekel",
    "Symbol": "TASE:716",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "All Bond Floating Shekel",
    "EnglishLongName": "All-Bond Floating Shekel",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:740",
    "MayaId": "740",
    "Name": "All Bond Shekel",
    "ShortName": "All-Bond Shekel",
    "Symbol": "TASE:740",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "All Bond Shekel",
    "EnglishLongName": "All-Bond Shekel",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:603",
    "MayaId": "603",
    "Name": "All Corporate Bonds",
    "ShortName": "All Corporate Bonds",
    "Symbol": "TASE:603",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "All Corporate Bonds",
    "EnglishLongName": "All Corporate Bonds",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "ALMD.TA",
    "MayaId": "1101450",
    "Name": "ALLMED SOLUTION",
    "ShortName": "ALLMED SOLUTIONS LTD",
    "Symbol": "ALMD.TA",
    "TaseSymbol": "ALMD",
    "YahooId": "ALMD.TA",
    "EnglishName": "ALLMED SOLUTION",
    "EnglishLongName": "ALLMED SOLUTIONS LTD",
    "HebrewName": "אולמד סולושנס",
    "HebrewLongName": "אולמד סולושנס בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 33.9,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 5.6,
    "YearYield": 5.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011014508"
  },
  {
    "Id": "ALLT.TA",
    "MayaId": "1099654",
    "Name": "ALLOT",
    "ShortName": "ALLOT LTD",
    "Symbol": "ALLT.TA",
    "TaseSymbol": "ALLT",
    "YahooId": "ALLT.TA",
    "EnglishName": "ALLOT",
    "EnglishLongName": "ALLOT LTD",
    "HebrewName": "אלוט",
    "HebrewLongName": "אלוט בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3236.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 5.3,
    "YearYield": 5.3,
    "Last12MonthYield": null,
    "ISIN": "IL0010996549"
  },
  {
    "Id": "ALMY.TA",
    "MayaId": "1173145",
    "Name": "ALMA YESODOT",
    "ShortName": "ALMA YESODOT LTD",
    "Symbol": "ALMY.TA",
    "TaseSymbol": "ALMY",
    "YahooId": "ALMY.TA",
    "EnglishName": "ALMA YESODOT",
    "EnglishLongName": "ALMA YESODOT LTD",
    "HebrewName": "עלמא יסודות",
    "HebrewLongName": "עלמא יסודות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1467.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Investment & Holdings",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.7,
    "YearYield": 1.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011731457"
  },
  {
    "Id": "ALMA.TA",
    "MayaId": "1136829",
    "Name": "ALMOGIM",
    "ShortName": "ALMOGIM HOLDINGS LTD",
    "Symbol": "ALMA.TA",
    "TaseSymbol": "ALMA",
    "YahooId": "ALMA.TA",
    "EnglishName": "ALMOGIM",
    "EnglishLongName": "ALMOGIM HOLDINGS LTD",
    "HebrewName": "אלמוגים",
    "HebrewLongName": "אלמוגים החזקות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1100.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 14.6,
    "YearYield": 14.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011368292"
  },
  {
    "Id": "TASE:5117809",
    "MayaId": "5117809",
    "Name": "ALN $ PI 3",
    "ShortName": "ALN $ PI 3",
    "Symbol": "TASE:5117809",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALON (0F) EXTREME TRIPLE TIMES DOLLAR",
    "EnglishLongName": "AYALON (0F) EXTREME TRIPLE TIMES DOLLAR",
    "HebrewName": "איילון 0F אקסטרים דולר פ3",
    "HebrewLongName": "איילון (0F) אקסטרים דולר פי 3",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": true,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.75,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Leveraged and Strategic",
    "SecondaryClassification": "Leveraged, High-Risk",
    "AssetValue": 10.6,
    "MonthYield": -2.65,
    "YearYield": -2.65,
    "Last12MonthYield": -34.56,
    "ISIN": "IL0051178098"
  },
  {
    "Id": "TASE:5117759",
    "MayaId": "5117759",
    "Name": "ALN 500 S&P PI3",
    "ShortName": "ALN 500 S&P PI3",
    "Symbol": "TASE:5117759",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALON (6D) EXTREME TRIPLE TIMES S&P 500",
    "EnglishLongName": "AYALON (6D) EXTREME TRIPLE TIMES S&P 500",
    "HebrewName": "איילון 6D S&P 500 פי 3",
    "HebrewLongName": "איילון (6D) אקסטרים 500 S&P פי 3",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.85,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": true,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 4.27,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Leveraged and Strategic",
    "SecondaryClassification": "Leveraged, High-Risk",
    "AssetValue": 157.1,
    "MonthYield": 2.7,
    "YearYield": 2.7,
    "Last12MonthYield": 18.33,
    "ISIN": "IL0051177595"
  },
  {
    "Id": "TASE:5128947",
    "MayaId": "5128947",
    "Name": "ALN EXT NSDQ P3",
    "ShortName": "ALN EXT NSDQ P3",
    "Symbol": "TASE:5128947",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALON (6D) EXTREME TRIPLE TIMES NASDAQ 100",
    "EnglishLongName": "AYALON (6D) EXTREME TRIPLE TIMES NASDAQ 100",
    "HebrewName": "איילון אקסטרים נאסד\"ק 3X",
    "HebrewLongName": "איילון (6D) אקסטרים נאסד\"ק 100 פי 3",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.85,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": true,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 5.8,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Leveraged and Strategic",
    "SecondaryClassification": "Leveraged, High-Risk",
    "AssetValue": 134.1,
    "MonthYield": 1.73,
    "YearYield": 1.73,
    "Last12MonthYield": 19.6,
    "ISIN": "IL0051289473"
  },
  {
    "Id": "TASE:5128855",
    "MayaId": "5128855",
    "Name": "ALN MNY GLOBALY",
    "ShortName": "ALN MNY GLOBALY",
    "Symbol": "TASE:5128855",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALON (4D) GLOBAL STOCKS",
    "EnglishLongName": "AYALON (4D) GLOBAL STOCKS",
    "HebrewName": "איילון (4D) מניות גלובאלי",
    "HebrewLongName": "איילון (4D) מניות גלובאלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.5,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.77,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 187.3,
    "MonthYield": 2.34,
    "YearYield": 2.34,
    "Last12MonthYield": -1.61,
    "ISIN": "IL0051288558"
  },
  {
    "Id": "ALHE.TA",
    "MayaId": "390013",
    "Name": "ALONY HETZ",
    "ShortName": "ALONY HETZ PROPERTIES & INVESTMENTS LTD.",
    "Symbol": "ALHE.TA",
    "TaseSymbol": "ALHE",
    "YahooId": "ALHE.TA",
    "EnglishName": "ALONY HETZ",
    "EnglishLongName": "ALONY HETZ PROPERTIES & INVESTMENTS LTD.",
    "HebrewName": "אלוני חץ",
    "HebrewLongName": "אלוני-חץ נכסים והשקעות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4023.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 5.4,
    "YearYield": 5.4,
    "Last12MonthYield": null,
    "ISIN": "IL0003900136"
  },
  {
    "Id": "ALRPR.TA",
    "MayaId": "387019",
    "Name": "ALROV PROPERT",
    "ShortName": "ALROV PROPERTIES & LODGINGS LTD.",
    "Symbol": "ALRPR.TA",
    "TaseSymbol": "ALRPR",
    "YahooId": "ALRPR.TA",
    "EnglishName": "ALROV PROPERT",
    "EnglishLongName": "ALROV PROPERTIES & LODGINGS LTD.",
    "HebrewName": "אלרוב נדלן",
    "HebrewLongName": "אלרוב נדל\"ן ומלונאות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 25610.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 2.3,
    "YearYield": 2.3,
    "Last12MonthYield": null,
    "ISIN": "IL0003870198"
  },
  {
    "Id": "TASE:5107784",
    "MayaId": "5107784",
    "Name": "ALT CHUL MUGENT",
    "ShortName": "ALT CHUL MUGENT",
    "Symbol": "TASE:5107784",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ALTSHULER SHAHAM (0A)(!) GLOBAL BONDS UP TO 10% FOREIGN CURRENCY",
    "EnglishLongName": "ALTSHULER SHAHAM (0A)(!) GLOBAL BONDS UP TO 10% FOREIGN CURRENCY",
    "HebrewName": "אש אגח חול עד 10 מטח",
    "HebrewLongName": "אלטשולר שחם (0A)(!) אג\"ח חו\"ל עד 10% מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.24,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX-Protected Bonds",
    "AssetValue": 593.9,
    "MonthYield": 0.2,
    "YearYield": 0.2,
    "Last12MonthYield": 6.81,
    "ISIN": "IL0051077845"
  },
  {
    "Id": "TASE:5124201",
    "MayaId": "5124201",
    "Name": "ALT GMISHA",
    "ShortName": "ALT GMISHA",
    "Symbol": "TASE:5124201",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ALTSHULER SHAHAM (4D) FLEXIBLE",
    "EnglishLongName": "ALTSHULER SHAHAM (4D) FLEXIBLE",
    "HebrewName": "אלטשולר 4D גמישה",
    "HebrewLongName": "אלטשולר שחם (4D) גמישה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.5,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.23,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 89.4,
    "MonthYield": 1.48,
    "YearYield": 1.48,
    "Last12MonthYield": -4.73,
    "ISIN": "IL0051242019"
  },
  {
    "Id": "TASE:5105895",
    "MayaId": "5105895",
    "Name": "ALT MEMUNEFET",
    "ShortName": "ALT MEMUNEFET",
    "Symbol": "TASE:5105895",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ALTSHULER SHAHAM (6F) – OPTIONS FUND",
    "EnglishLongName": "ALTSHULER SHAHAM (6F) – OPTIONS FUND",
    "HebrewName": "אלטשולר 6F קרן ממונפת",
    "HebrewLongName": "אלטשולר שחם (6F) – קרן ממונפת",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.2,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": true,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.13,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Leveraged and Strategic",
    "SecondaryClassification": "Leveraged, High-Risk",
    "AssetValue": 63.7,
    "MonthYield": 0.22,
    "YearYield": 0.22,
    "Last12MonthYield": -9.71,
    "ISIN": "IL0051058951"
  },
  {
    "Id": "TASE:5108329",
    "MayaId": "5108329",
    "Name": "ALT MNY MUGENET",
    "ShortName": "ALT MNY MUGENET",
    "Symbol": "TASE:5108329",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ALTSHULER SHAHAM (4B) GLOBAL EQUITY UP TO 30% FOREIGN CURRENCY",
    "EnglishLongName": "ALTSHULER SHAHAM (4B) GLOBAL EQUITY UP TO 30% FOREIGN CURRENCY",
    "HebrewName": "אש מניות גלובלי עד 30 מטח",
    "HebrewLongName": "אלטשולר שחם (4B) מניות גלובלי עד 30% מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.78,
    "TrusteeFee": 0.035,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.49,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 228.5,
    "MonthYield": 2.69,
    "YearYield": 2.69,
    "Last12MonthYield": 14.34,
    "ISIN": "IL0051083298"
  },
  {
    "Id": "TASE:5128004",
    "MayaId": "5128004",
    "Name": "ALT MSL US AD2$",
    "ShortName": "ALT MSL US AD2$",
    "Symbol": "TASE:5128004",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ALTSHULER SHAHAM (0D) USA GOVERNMENT UP TO 2 YEARS DOLLAR",
    "EnglishLongName": "ALTSHULER SHAHAM (0D) USA GOVERNMENT UP TO 2 YEARS DOLLAR",
    "HebrewName": "אלטשולר 0D ממשלארהב עד2 ד",
    "HebrewLongName": "אלטשולר שחם (0D) ממשלת ארה\"ב עד שנתיים דולרית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.1,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "Dollar Bond",
    "AssetValue": 9.1,
    "MonthYield": -1.28,
    "YearYield": -1.28,
    "Last12MonthYield": -9.79,
    "ISIN": "IL0051280043"
  },
  {
    "Id": "TASE:5115407",
    "MayaId": "5115407",
    "Name": "ALT OKV HUL2 BL",
    "ShortName": "ALT OKV HUL2 BL",
    "Symbol": "TASE:5115407",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ALTSHULER SHAHAM (2D) FOLLOWING GLOBAL PORTFOLIO 2 FIBI BANK",
    "EnglishLongName": "ALTSHULER SHAHAM (2D) FOLLOWING GLOBAL PORTFOLIO 2 FIBI BANK",
    "HebrewName": "אלטשולר עק חול 2 בנק בינל",
    "HebrewLongName": "אלטשולר שחם (2D) עוקבת תיק חו\"ל 2 הבנק הבינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.92,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.07,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Bond",
    "AssetValue": 118.8,
    "MonthYield": -1.1,
    "YearYield": -1.1,
    "Last12MonthYield": -5.7,
    "ISIN": "IL0051154073"
  },
  {
    "Id": "TASE:5118609",
    "MayaId": "5118609",
    "Name": "ALT SHVAKIM MFT",
    "ShortName": "ALT SHVAKIM MFT",
    "Symbol": "TASE:5118609",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ALTSHULER SHAHAM (4B) DEVELOPED MARKETS UP TO 30% FOREIGN CURRENCY",
    "EnglishLongName": "ALTSHULER SHAHAM (4B) DEVELOPED MARKETS UP TO 30% FOREIGN CURRENCY",
    "HebrewName": "אש שווקים מפתח עד 30 מטח",
    "HebrewLongName": "אלטשולר שחם (4B) שווקים מפותחים עד 30% מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.5,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.64,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Geographical stocks",
    "AssetValue": 947.8,
    "MonthYield": 2.42,
    "YearYield": 2.42,
    "Last12MonthYield": 21.65,
    "ISIN": "IL0051186091"
  },
  {
    "Id": "ALTF.TA",
    "MayaId": "1184936",
    "Name": "ALTSHULER FIN",
    "ShortName": "ALTSHULER SHAHAM FINANCE LTD",
    "Symbol": "ALTF.TA",
    "TaseSymbol": "ALTF",
    "YahooId": "ALTF.TA",
    "EnglishName": "ALTSHULER FIN",
    "EnglishLongName": "ALTSHULER SHAHAM FINANCE LTD",
    "HebrewName": "אלטשולר שחם פנ",
    "HebrewLongName": "אלטשולר שחם פיננסים בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 678.1,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Financial Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -6.2,
    "YearYield": -6.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011849366"
  },
  {
    "Id": "TASE:5108402",
    "MayaId": "5108402",
    "Name": "ALTSHULER FL 2 FIB BNK IL",
    "ShortName": "ALTSHULER FL 2 FIB BNK IL",
    "Symbol": "TASE:5108402",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ALTSHULER SHAHAM (2B) FOLLOWING PORTFOLIO 2 FIBI BANK IL",
    "EnglishLongName": "ALTSHULER SHAHAM (2B) FOLLOWING PORTFOLIO 2 FIBI BANK IL",
    "HebrewName": "אלטשולר עק 2 בנק בינל",
    "HebrewLongName": "אלטשולר שחם (2B) עוקבת תיק 2 הבנק הבינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.26,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 15% Equity",
    "AssetValue": 55.9,
    "MonthYield": 0.43,
    "YearYield": 0.43,
    "Last12MonthYield": 8.37,
    "ISIN": "IL0051084023"
  },
  {
    "Id": "TASE:5105531",
    "MayaId": "5105531",
    "Name": "Altshuler Shaham S&P 500",
    "ShortName": "Altshuler Shaham S&P 500",
    "Symbol": "TASE:5105531",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ALTSHULER SHAHAM (4D) S&P 500",
    "EnglishLongName": "ALTSHULER SHAHAM (4D) S&P 500",
    "HebrewName": "אלטשולר שחם S&P 500",
    "HebrewLongName": "אלטשולר שחם (4D)י S&P 500",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.6,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.4,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Geographical stocks",
    "AssetValue": 669.9,
    "MonthYield": -0.14,
    "YearYield": -0.14,
    "Last12MonthYield": 5.72,
    "ISIN": "IL0051055312"
  },
  {
    "Id": "ALUMA.TA",
    "MayaId": "1181643",
    "Name": "ALUMA INFRASTR'",
    "ShortName": "ALUMA INFRASTRUCTURE FUND (2020) LTD",
    "Symbol": "ALUMA.TA",
    "TaseSymbol": "ALUMA",
    "YahooId": "ALUMA.TA",
    "EnglishName": "ALUMA INFRASTR'",
    "EnglishLongName": "ALUMA INFRASTRUCTURE FUND (2020) LTD",
    "HebrewName": "אלומה תשתיות",
    "HebrewLongName": "אלומה קרן תשתיות (2020) בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 96.9,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Investment & Holdings",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 15.3,
    "YearYield": 15.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011816431"
  },
  {
    "Id": "AMAL.TA",
    "MayaId": "1232008",
    "Name": "AMAL HOLDINGS",
    "ShortName": "AMAL HOLDINGS A.D LTD",
    "Symbol": "AMAL.TA",
    "TaseSymbol": "AMAL",
    "YahooId": "AMAL.TA",
    "EnglishName": "AMAL HOLDINGS",
    "EnglishLongName": "AMAL HOLDINGS A.D LTD",
    "HebrewName": "עמל הולדינגס",
    "HebrewLongName": "עמל הולדינגס א.ד בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1984.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.1,
    "YearYield": 1.1,
    "Last12MonthYield": null,
    "ISIN": "IL0012320086"
  },
  {
    "Id": "AMAN.TA",
    "MayaId": "654012",
    "Name": "AMANET",
    "ShortName": "AMANET MANAGEMENT & SYSTEMS LTD.",
    "Symbol": "AMAN.TA",
    "TaseSymbol": "AMAN",
    "YahooId": "AMAN.TA",
    "EnglishName": "AMANET",
    "EnglishLongName": "AMANET MANAGEMENT & SYSTEMS LTD.",
    "HebrewName": "אמנת",
    "HebrewLongName": "אמנת ניהול ומערכות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2503.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -3.8,
    "YearYield": -3.8,
    "Last12MonthYield": null,
    "ISIN": "IL0006540129"
  },
  {
    "Id": "AMD.TA",
    "MayaId": "1094390",
    "Name": "AMIAD",
    "ShortName": "AMIAD WATER SYSTEMS LTD",
    "Symbol": "AMD.TA",
    "TaseSymbol": "AMD",
    "YahooId": "AMD.TA",
    "EnglishName": "AMIAD",
    "EnglishLongName": "AMIAD WATER SYSTEMS LTD",
    "HebrewName": "עמיעד",
    "HebrewLongName": "עמיעד מערכות מים בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 852.8,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 30.3,
    "YearYield": 30.3,
    "Last12MonthYield": null,
    "ISIN": "IL0010943905"
  },
  {
    "Id": "AMRK.TA",
    "MayaId": "1092204",
    "Name": "AMIR MARK.",
    "ShortName": "AMIR MARKETING AND INVESTMTS IN AGRICULTURE LTD.",
    "Symbol": "AMRK.TA",
    "TaseSymbol": "AMRK",
    "YahooId": "AMRK.TA",
    "EnglishName": "AMIR MARK.",
    "EnglishLongName": "AMIR MARKETING AND INVESTMTS IN AGRICULTURE LTD.",
    "HebrewName": "עמיר שיווק",
    "HebrewLongName": "עמיר שיווק והשקעות בחקלאות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3350.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -3.2,
    "YearYield": -3.2,
    "Last12MonthYield": null,
    "ISIN": "IL0010922040"
  },
  {
    "Id": "AMOT.TA",
    "MayaId": "1097278",
    "Name": "AMOT",
    "ShortName": "AMOT INVESTMENTS LTD.",
    "Symbol": "AMOT.TA",
    "TaseSymbol": "AMOT",
    "YahooId": "AMOT.TA",
    "EnglishName": "AMOT",
    "EnglishLongName": "AMOT INVESTMENTS LTD.",
    "HebrewName": "אמות",
    "HebrewLongName": "אמות השקעות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2605.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 6.6,
    "YearYield": 6.6,
    "Last12MonthYield": null,
    "ISIN": "IL0010972789"
  },
  {
    "Id": "AMPA.TA",
    "MayaId": "1225200",
    "Name": "AMPA",
    "ShortName": "AMPA LTD",
    "Symbol": "AMPA.TA",
    "TaseSymbol": "AMPA",
    "YahooId": "AMPA.TA",
    "EnglishName": "AMPA",
    "EnglishLongName": "AMPA LTD",
    "HebrewName": "אמפא",
    "HebrewLongName": "אמפא בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1701.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 7.1,
    "YearYield": 7.1,
    "Last12MonthYield": null,
    "ISIN": "IL0012252008"
  },
  {
    "Id": "AMRM.TA",
    "MayaId": "1188200",
    "Name": "AMRM",
    "ShortName": "AMRAM AVRAHAM CONSTRUCTION COMPANY LTD",
    "Symbol": "AMRM.TA",
    "TaseSymbol": "AMRM",
    "YahooId": "AMRM.TA",
    "EnglishName": "AMRM",
    "EnglishLongName": "AMRAM AVRAHAM CONSTRUCTION COMPANY LTD",
    "HebrewName": "עמרם",
    "HebrewLongName": "עמרם אברהם חברה לבנין בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5386.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 37.0,
    "YearYield": 37.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011882003"
  },
  {
    "Id": "TASE:5118963",
    "MayaId": "5118963",
    "Name": "ANALIST DIVERIFIED 90/10",
    "ShortName": "ANALIST DIVERIFIED 90/10",
    "Symbol": "TASE:5118963",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ANALIST (1A) DIVERIFIED PROTFOLIO 90/10 IL",
    "EnglishLongName": "ANALIST (1A) DIVERIFIED PROTFOLIO 90/10 IL",
    "HebrewName": "אנליסט פיזור רחב 10/90",
    "HebrewLongName": "אנליסט (1A) פיזור רחב 10/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.76,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.42,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 293.0,
    "MonthYield": 1.26,
    "YearYield": 1.26,
    "Last12MonthYield": 10.08,
    "ISIN": "IL0051189632"
  },
  {
    "Id": "ANLT.TA",
    "MayaId": "1080613",
    "Name": "ANALYST",
    "ShortName": "ANALYST I.M.S. INVESTMENT MANAGEMENT SERVICES LTD.",
    "Symbol": "ANLT.TA",
    "TaseSymbol": "ANLT",
    "YahooId": "ANLT.TA",
    "EnglishName": "ANALYST",
    "EnglishLongName": "ANALYST I.M.S. INVESTMENT MANAGEMENT SERVICES LTD.",
    "HebrewName": "אנליסט",
    "HebrewLongName": "אנליסט אי.אמ.אס.-שרותי ניהול השקעות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 16670.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Financial Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -5.3,
    "YearYield": -5.3,
    "Last12MonthYield": null,
    "ISIN": "IL0010806136"
  },
  {
    "Id": "TASE:5110523",
    "MayaId": "5110523",
    "Name": "Analyst (!) Bonds IL",
    "ShortName": "Analyst (!) Bonds IL",
    "Symbol": "TASE:5110523",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Analyst (0B)(!) Bonds IL",
    "EnglishLongName": "Analyst (0B)(!) Bonds IL",
    "HebrewName": "אנליסט (!) אג\"ח",
    "HebrewLongName": "אנליסט (0B)(!) אג\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.29,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 286.8,
    "MonthYield": 0.62,
    "YearYield": 0.62,
    "Last12MonthYield": 6.35,
    "ISIN": "IL0051105232"
  },
  {
    "Id": "TASE:5121140",
    "MayaId": "5121140",
    "Name": "ANALYST (00) MONEY MARKET",
    "ShortName": "ANALYST (00) MONEY MARKET",
    "Symbol": "TASE:5121140",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ANALYST (00) MONEY MARKET FUND IL",
    "EnglishLongName": "ANALYST (00) MONEY MARKET FUND IL",
    "HebrewName": "אנליסט (00) כספית",
    "HebrewLongName": "אנליסט (00) כספית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.215,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 5916.3,
    "MonthYield": 0.22,
    "YearYield": 0.22,
    "Last12MonthYield": 4.67,
    "ISIN": "IL0051211402"
  },
  {
    "Id": "TASE:5137070",
    "MayaId": "5137070",
    "Name": "ANALYST (0A) SOLID IL",
    "ShortName": "ANALYST (0A) SOLID IL",
    "Symbol": "TASE:5137070",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ANALYST (0A) SOLID IL",
    "EnglishLongName": "ANALYST (0A) SOLID IL",
    "HebrewName": "אנליסט (0A) סולידית",
    "HebrewLongName": "אנליסט (0A) סולידית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.48,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.1,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 3.2,
    "MonthYield": 0.64,
    "YearYield": 0.64,
    "Last12MonthYield": 5.81,
    "ISIN": "IL0051370703"
  },
  {
    "Id": "TASE:5130950",
    "MayaId": "5130950",
    "Name": "ANALYST (0B) Solid LV",
    "ShortName": "ANALYST (0B) Solid LV",
    "Symbol": "TASE:5130950",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ANALYST (0B) SOLID LV IL",
    "EnglishLongName": "ANALYST (0B) SOLID LV IL",
    "HebrewName": "אנליסט סולידית",
    "HebrewLongName": "אנליסט (0B) סולידית LV",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.2,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 32.9,
    "MonthYield": 0.43,
    "YearYield": 0.43,
    "Last12MonthYield": 6.06,
    "ISIN": "IL0051309503"
  },
  {
    "Id": "TASE:5131263",
    "MayaId": "5131263",
    "Name": "Analyst (2A) 15/85",
    "ShortName": "Analyst (2A) 15/85",
    "Symbol": "TASE:5131263",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ANALYST (2A) 15/85 IL",
    "EnglishLongName": "ANALYST (2A) 15/85 IL",
    "HebrewName": "אנליסט (2A)י 15/85",
    "HebrewLongName": "אנליסט (2A)י 15/85",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.45,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.54,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 15% Equity",
    "AssetValue": 10.4,
    "MonthYield": 1.46,
    "YearYield": 1.46,
    "Last12MonthYield": 12.03,
    "ISIN": "IL0051312630"
  },
  {
    "Id": "TASE:5113709",
    "MayaId": "5113709",
    "Name": "ANALYST (2B) TRACKING FIB",
    "ShortName": "ANALYST (2B) TRACKING FIB",
    "Symbol": "TASE:5113709",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ANALYST (2B) TRACKING FIBI PORTFOLIO NO. 2 IL",
    "EnglishLongName": "ANALYST (2B) TRACKING FIBI PORTFOLIO NO. 2 IL",
    "HebrewName": "אנליסט תיק 2 הבינלאומי",
    "HebrewLongName": "אנליסט (2B) עוקבת תיק 2 הבנק הבינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 15% Equity",
    "AssetValue": 38.0,
    "MonthYield": 0.88,
    "YearYield": 0.88,
    "Last12MonthYield": 8.91,
    "ISIN": "IL0051137094"
  },
  {
    "Id": "TASE:5101258",
    "MayaId": "5101258",
    "Name": "ANALYST (4B) Israel Equit",
    "ShortName": "ANALYST (4B) Israel Equit",
    "Symbol": "TASE:5101258",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ANALYST (4B) ISRAEL EQUITY LARGE & MID CAP IL",
    "EnglishLongName": "ANALYST (4B) ISRAEL EQUITY LARGE & MID CAP IL",
    "HebrewName": "אנליסט מניות ישראל",
    "HebrewLongName": "אנליסט (4B) מניות ישראל Large & mid cap",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.69,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.15,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 452.5,
    "MonthYield": 7.23,
    "YearYield": 7.23,
    "Last12MonthYield": 59.44,
    "ISIN": "IL0051012586"
  },
  {
    "Id": "TASE:5114350",
    "MayaId": "5114350",
    "Name": "ANALYST (A1) 90/10",
    "ShortName": "ANALYST (A1) 90/10",
    "Symbol": "TASE:5114350",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ANALYST 90/10 (1A) IL",
    "EnglishLongName": "ANALYST 90/10 (1A) IL",
    "HebrewName": "אנליסט (1A) 10/90",
    "HebrewLongName": "אנליסט 10/90 (1A)",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.74,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.43,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 65.9,
    "MonthYield": 1.4,
    "YearYield": 1.4,
    "Last12MonthYield": 10.64,
    "ISIN": "IL0051143506"
  },
  {
    "Id": "TASE:5139712",
    "MayaId": "5139712",
    "Name": "Analyst 30/70 IL",
    "ShortName": "Analyst 30/70 IL",
    "Symbol": "TASE:5139712",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Analyst (2B) 30/70 IL",
    "EnglishLongName": "Analyst (2B) 30/70 IL",
    "HebrewName": "אנליסט 30/70",
    "HebrewLongName": "אנליסט (2B)י 30/70",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.58,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.77,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 159.6,
    "MonthYield": 2.27,
    "YearYield": 2.27,
    "Last12MonthYield": 21.48,
    "ISIN": "IL0051397128"
  },
  {
    "Id": "TASE:5116033",
    "MayaId": "5116033",
    "Name": "Analyst 80/20 IL",
    "ShortName": "Analyst 80/20 IL",
    "Symbol": "TASE:5116033",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Analyst (2B) 80/20 IL",
    "EnglishLongName": "Analyst (2B) 80/20 IL",
    "HebrewName": "אנליסט 20/80",
    "HebrewLongName": "אנליסט (2B)י 20/80",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.84,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.45,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 1689.8,
    "MonthYield": 1.64,
    "YearYield": 1.64,
    "Last12MonthYield": 15.39,
    "ISIN": "IL0051160336"
  },
  {
    "Id": "TASE:5119672",
    "MayaId": "5119672",
    "Name": "ANALYST BONDS DIVERSIFIED",
    "ShortName": "ANALYST BONDS DIVERSIFIED",
    "Symbol": "TASE:5119672",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ANALYST (0A)(!) DIVERSIFIED BONDS PROTFOLIO WITH NO EQUITY IL",
    "EnglishLongName": "ANALYST (0A)(!) DIVERSIFIED BONDS PROTFOLIO WITH NO EQUITY IL",
    "HebrewName": "אנליסט אג\"ח פיזור רחב ללא",
    "HebrewLongName": "אנליסט (0A)(!) אג\"ח פיזור רחב ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.31,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 73.1,
    "MonthYield": 0.8,
    "YearYield": 0.8,
    "Last12MonthYield": 7.29,
    "ISIN": "IL0051196728"
  },
  {
    "Id": "TASE:5139688",
    "MayaId": "5139688",
    "Name": "Analyst Bonds no Equty IL",
    "ShortName": "Analyst Bonds no Equty IL",
    "Symbol": "TASE:5139688",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Analyst (0B) Bonds without Equities IL",
    "EnglishLongName": "Analyst (0B) Bonds without Equities IL",
    "HebrewName": "אנליסט אגח ללא מניות",
    "HebrewLongName": "אנליסט (0B) אג\"ח ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.48,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 20.3,
    "MonthYield": 0.69,
    "YearYield": 0.69,
    "Last12MonthYield": 5.85,
    "ISIN": "IL0051396880"
  },
  {
    "Id": "TASE:5120894",
    "MayaId": "5120894",
    "Name": "Analyst Corp Bonds+30% IL",
    "ShortName": "Analyst Corp Bonds+30% IL",
    "Symbol": "TASE:5120894",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Analyst (2C) Corporate Bonds + 30% IL",
    "EnglishLongName": "Analyst (2C) Corporate Bonds + 30% IL",
    "HebrewName": "אנליסט אג\"ח חברות + 30%",
    "HebrewLongName": "אנליסט (2C) אג\"ח חברות + 30%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.9,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.49,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles with Equity",
    "AssetValue": 28.1,
    "MonthYield": 2.07,
    "YearYield": 2.07,
    "Last12MonthYield": 14.62,
    "ISIN": "IL0051208945"
  },
  {
    "Id": "TASE:5139449",
    "MayaId": "5139449",
    "Name": "Analyst Corporate Port IL",
    "ShortName": "Analyst Corporate Port IL",
    "Symbol": "TASE:5139449",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Analyst (0B)(!) Corporate Portfolio IL",
    "EnglishLongName": "Analyst (0B)(!) Corporate Portfolio IL",
    "HebrewName": "אנליסט תיק קונצרני",
    "HebrewLongName": "אנליסט (0B)(!) תיק קונצרני",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.54,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 28.5,
    "MonthYield": 0.8,
    "YearYield": 0.8,
    "Last12MonthYield": 7.01,
    "ISIN": "IL0051394497"
  },
  {
    "Id": "TASE:5125109",
    "MayaId": "5125109",
    "Name": "ANALYST DIVERSIFIED 80/20",
    "ShortName": "ANALYST DIVERSIFIED 80/20",
    "Symbol": "TASE:5125109",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ANALYST (2B) DIVERSIFIED PORTFOLIO 80/20 IL",
    "EnglishLongName": "ANALYST (2B) DIVERSIFIED PORTFOLIO 80/20 IL",
    "HebrewName": "אנליסט פיזור רחב 20/80",
    "HebrewLongName": "אנליסט (2B) פיזור רחב 20/80",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.74,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.53,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 52.7,
    "MonthYield": 2.15,
    "YearYield": 2.15,
    "Last12MonthYield": 15.91,
    "ISIN": "IL0051251093"
  },
  {
    "Id": "TASE:5138839",
    "MayaId": "5138839",
    "Name": "Analyst DLR Money Market$",
    "ShortName": "Analyst DLR Money Market$",
    "Symbol": "TASE:5138839",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Analyst (0D) Dollar Money Market – Denominated in $",
    "EnglishLongName": "Analyst (0D) Dollar Money Market – Denominated in $",
    "HebrewName": "אנליסט כספית דולר נקובה $",
    "HebrewLongName": "אנליסט (0D) כספית דולרית - נקובה $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.13,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.2,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "FX Money Market with Corporate",
    "AssetValue": 1961.4,
    "MonthYield": -0.94,
    "YearYield": -0.94,
    "Last12MonthYield": -9.64,
    "ISIN": "IL0051388390"
  },
  {
    "Id": "TASE:5120811",
    "MayaId": "5120811",
    "Name": "Analyst Equities IL",
    "ShortName": "Analyst Equities IL",
    "Symbol": "TASE:5120811",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Analyst (4B) Equities IL",
    "EnglishLongName": "Analyst (4B) Equities IL",
    "HebrewName": "אנליסט מניות",
    "HebrewLongName": "אנליסט (4B) מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.05,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.21,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 378.3,
    "MonthYield": 5.88,
    "YearYield": 5.88,
    "Last12MonthYield": 54.2,
    "ISIN": "IL0051208119"
  },
  {
    "Id": "TASE:5140686",
    "MayaId": "5140686",
    "Name": "Analyst Equity Leveraged",
    "ShortName": "Analyst Equity Leveraged",
    "Symbol": "TASE:5140686",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Analyst (6F) Equity Leveraged",
    "EnglishLongName": "Analyst (6F) Equity Leveraged",
    "HebrewName": "אנליסט מניות ממונפת",
    "HebrewLongName": "אנליסט (6F) מניות ממונפת",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 3.75,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": true,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.16,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Leveraged and Strategic",
    "SecondaryClassification": "Leveraged, High-Risk",
    "AssetValue": 0.9,
    "MonthYield": 8.85,
    "YearYield": 8.85,
    "Last12MonthYield": null,
    "ISIN": "IL0051406861"
  },
  {
    "Id": "TASE:5129655",
    "MayaId": "5129655",
    "Name": "ANALYST FIBI NO. 3",
    "ShortName": "ANALYST FIBI NO. 3",
    "Symbol": "TASE:5129655",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ANALYST (2B) TRACKING FIBI PORTFOLIO NO. 3 IL",
    "EnglishLongName": "ANALYST (2B) TRACKING FIBI PORTFOLIO NO. 3 IL",
    "HebrewName": "אנליסט עוקבת 3 הבנק הבינל",
    "HebrewLongName": "אנליסט (2B) עוקבת תיק 3 הבנק הבינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.44,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 79.6,
    "MonthYield": 1.11,
    "YearYield": 1.11,
    "Last12MonthYield": 10.68,
    "ISIN": "IL0051296551"
  },
  {
    "Id": "TASE:5120795",
    "MayaId": "5120795",
    "Name": "Analyst Flexible IL",
    "ShortName": "Analyst Flexible IL",
    "Symbol": "TASE:5120795",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Analyst (4D) Flexible IL",
    "EnglishLongName": "Analyst (4D) Flexible IL",
    "HebrewName": "אנליסט גמישה",
    "HebrewLongName": "אנליסט (4D) גמישה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.93,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.99,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 369.5,
    "MonthYield": 4.98,
    "YearYield": 4.98,
    "Last12MonthYield": 47.74,
    "ISIN": "IL0051207954"
  },
  {
    "Id": "TASE:5101092",
    "MayaId": "5101092",
    "Name": "ANALYST GLOBAL TECHNOLOGI",
    "ShortName": "ANALYST GLOBAL TECHNOLOGI",
    "Symbol": "TASE:5101092",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ANALYST (4D) GLOBAL TECHNOLOGIES",
    "EnglishLongName": "ANALYST (4D) GLOBAL TECHNOLOGIES",
    "HebrewName": "אנליסט טכנולוגיות חו\"ל",
    "HebrewLongName": "אנליסט (4D) טכנולוגיות חו\"ל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.95,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.17,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks by Sectors - Foreign",
    "AssetValue": 461.6,
    "MonthYield": 0.18,
    "YearYield": 0.18,
    "Last12MonthYield": 4.21,
    "ISIN": "IL0051010929"
  },
  {
    "Id": "TASE:5119607",
    "MayaId": "5119607",
    "Name": "ANALYST GOV BOND 0 EQUITY",
    "ShortName": "ANALYST GOV BOND 0 EQUITY",
    "Symbol": "TASE:5119607",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ANALYST (00) GOVERNMENT BONDS DURATION UP TO 5 YEARS WITH NO EQUITY IL",
    "EnglishLongName": "ANALYST (00) GOVERNMENT BONDS DURATION UP TO 5 YEARS WITH NO EQUITY IL",
    "HebrewName": "אנליסט מדינה ללא מניות",
    "HebrewLongName": "אנליסט (00) אג\"ח מדינה עד 5 שנים ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.62,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - No Equity",
    "AssetValue": 192.1,
    "MonthYield": 0.53,
    "YearYield": 0.53,
    "Last12MonthYield": 6.19,
    "ISIN": "IL0051196074"
  },
  {
    "Id": "TASE:5120910",
    "MayaId": "5120910",
    "Name": "Analyst Gov Bonds +10% IL",
    "ShortName": "Analyst Gov Bonds +10% IL",
    "Symbol": "TASE:5120910",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Analyst (1C) Government Bonds +10% IL",
    "EnglishLongName": "Analyst (1C) Government Bonds +10% IL",
    "HebrewName": "אנליסט אג\"ח מדינה + 10%",
    "HebrewLongName": "אנליסט (1C) אג\"ח מדינה + 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - up to 10% Equity",
    "AssetValue": 30.9,
    "MonthYield": 0.91,
    "YearYield": 0.91,
    "Last12MonthYield": 9.04,
    "ISIN": "IL0051209109"
  },
  {
    "Id": "TASE:5141254",
    "MayaId": "5141254",
    "Name": "Analyst Gov CPI Link + IL",
    "ShortName": "Analyst Gov CPI-Link + IL",
    "Symbol": "TASE:5141254",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Analyst (1A) Government CPI-Linked Plus IL",
    "EnglishLongName": "Analyst (1A) Government CPI-Linked Plus IL",
    "HebrewName": "אנליסט מדינה צמודה פלוס",
    "HebrewLongName": "אנליסט (1A) מדינה צמודה פלוס",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.58,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked Government Bonds - Up to 10% Equity",
    "AssetValue": 1.4,
    "MonthYield": 0.79,
    "YearYield": 0.79,
    "Last12MonthYield": null,
    "ISIN": "IL0051412547"
  },
  {
    "Id": "TASE:5115803",
    "MayaId": "5115803",
    "Name": "ANALYST GOV SOLID UP TO 2",
    "ShortName": "ANALYST GOV SOLID UP TO 2",
    "Symbol": "TASE:5115803",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ANALYST (1A) GOVERNMENT SOLID PORTFOLIO DURATION UP TO TWO YEARS IL",
    "EnglishLongName": "ANALYST (1A) GOVERNMENT SOLID PORTFOLIO DURATION UP TO TWO YEARS IL",
    "HebrewName": "אנליסט ממשלתית סולידי עד2",
    "HebrewLongName": "אנליסט (1A) ממשלתית תיק סולידי עד שנתיים",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.58,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.06,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - up to 10% Equity",
    "AssetValue": 125.5,
    "MonthYield": 0.43,
    "YearYield": 0.43,
    "Last12MonthYield": 4.93,
    "ISIN": "IL0051158033"
  },
  {
    "Id": "TASE:5120837",
    "MayaId": "5120837",
    "Name": "Analyst Industries IL",
    "ShortName": "Analyst Industries IL",
    "Symbol": "TASE:5120837",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Analyst (4B) Industries IL",
    "EnglishLongName": "Analyst (4B) Industries IL",
    "HebrewName": "אנליסט תעשיות",
    "HebrewLongName": "אנליסט (4B) תעשיות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.05,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.06,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sectors",
    "AssetValue": 111.6,
    "MonthYield": 9.95,
    "YearYield": 9.95,
    "Last12MonthYield": 59.96,
    "ISIN": "IL0051208374"
  },
  {
    "Id": "TASE:5101639",
    "MayaId": "5101639",
    "Name": "Analyst Investments",
    "ShortName": "Analyst Investments",
    "Symbol": "TASE:5101639",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Analyst (4D) Investments",
    "EnglishLongName": "Analyst (4D) Investments",
    "HebrewName": "אנליסט השקעות",
    "HebrewLongName": "אנליסט (4D) השקעות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.94,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.97,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 438.0,
    "MonthYield": 4.1,
    "YearYield": 4.1,
    "Last12MonthYield": 41.1,
    "ISIN": "IL0051016397"
  },
  {
    "Id": "TASE:5141767",
    "MayaId": "5141767",
    "Name": "Analyst Invst Port 50% IL",
    "ShortName": "Analyst Invst Port 50% IL",
    "Symbol": "TASE:5141767",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Analyst (3C) Investments Portfolio up to 50% IL",
    "EnglishLongName": "Analyst (3C) Investments Portfolio up to 50% IL",
    "HebrewName": "אנליסט תיק השקעות עד 50%",
    "HebrewLongName": "אנליסט (3C) תיק השקעות עד 50%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.68,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - Max. Exposure over 30% Equity",
    "AssetValue": 3.4,
    "MonthYield": 2.68,
    "YearYield": 2.68,
    "Last12MonthYield": null,
    "ISIN": "IL0051417678"
  },
  {
    "Id": "TASE:5141247",
    "MayaId": "5141247",
    "Name": "Analyst Mid Cap Equity IL",
    "ShortName": "Analyst Mid Cap Equity IL",
    "Symbol": "TASE:5141247",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Analyst (4B) Israel Mid Cap Equities IL",
    "EnglishLongName": "Analyst (4B) Israel Mid Cap Equities IL",
    "HebrewName": "אנליסט מניות MidCap ישראל",
    "HebrewLongName": "אנליסט (4B) מניות Mid Cap ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.95,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 2.6,
    "MonthYield": 6.62,
    "YearYield": 6.62,
    "Last12MonthYield": null,
    "ISIN": "IL0051412471"
  },
  {
    "Id": "TASE:5116934",
    "MayaId": "5116934",
    "Name": "ANALYST PROPRIETARY",
    "ShortName": "ANALYST PROPRIETARY",
    "Symbol": "TASE:5116934",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ANALYST (0B) PROPRIETARY RATING MODEL IL",
    "EnglishLongName": "ANALYST (0B) PROPRIETARY RATING MODEL IL",
    "HebrewName": "אנליסט דירוג פנימי",
    "HebrewLongName": "אנליסט (0B) מודל דירוג פנימי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 226.1,
    "MonthYield": 0.58,
    "YearYield": 0.58,
    "Last12MonthYield": 6.86,
    "ISIN": "IL0051169345"
  },
  {
    "Id": "TASE:5101266",
    "MayaId": "5101266",
    "Name": "Analyst Real Estate IL",
    "ShortName": "Analyst Real Estate IL",
    "Symbol": "TASE:5101266",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Analyst (4B) Real Estate IL",
    "EnglishLongName": "Analyst (4B) Real Estate IL",
    "HebrewName": "אנליסט נדל\"ן",
    "HebrewLongName": "אנליסט (4B) נדל\"ן",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.85,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.93,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sectors",
    "AssetValue": 43.2,
    "MonthYield": 8.07,
    "YearYield": 8.07,
    "Last12MonthYield": 27.36,
    "ISIN": "IL0051012669"
  },
  {
    "Id": "TASE:5140413",
    "MayaId": "5140413",
    "Name": "Analyst Saving Money M IL",
    "ShortName": "Analyst Saving Money M IL",
    "Symbol": "TASE:5140413",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Analyst (00) Savings Money Market IL",
    "EnglishLongName": "Analyst (00) Savings Money Market IL",
    "HebrewName": "אנליסט כספית חיסכון",
    "HebrewLongName": "אנליסט (00) כספית חיסכון",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.12,
    "TrusteeFee": 0.005,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 1402.6,
    "MonthYield": 0.23,
    "YearYield": 0.23,
    "Last12MonthYield": null,
    "ISIN": "IL0051404130"
  },
  {
    "Id": "TASE:5115225",
    "MayaId": "5115225",
    "Name": "ANALYST SHEKEL CORPRATE",
    "ShortName": "ANALYST SHEKEL CORPRATE",
    "Symbol": "TASE:5115225",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ANALYST (00) NIS CORPORATE WITH NO EQUITY IL",
    "EnglishLongName": "ANALYST (00) NIS CORPORATE WITH NO EQUITY IL",
    "HebrewName": "אנליסט שקלית קונצרנית ללא",
    "HebrewLongName": "אנליסט (00) שקלית קונצרנית ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.54,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Shekel Corporate and Convertibles - No Equity",
    "AssetValue": 12.4,
    "MonthYield": 0.87,
    "YearYield": 0.87,
    "Last12MonthYield": 5.99,
    "ISIN": "IL0051152259"
  },
  {
    "Id": "TASE:5126685",
    "MayaId": "5126685",
    "Name": "ANALYST SMALL CAP Equity",
    "ShortName": "ANALYST SMALL CAP Equity",
    "Symbol": "TASE:5126685",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ANALYST (4B) SMALL CAP EQUITY IL",
    "EnglishLongName": "ANALYST (4B) SMALL CAP EQUITY IL",
    "HebrewName": "אנליסט מניות SMALL CAP יש",
    "HebrewLongName": "אנליסט (4B) מניות SMALL CAP ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.21,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.02,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 267.4,
    "MonthYield": 5.24,
    "YearYield": 5.24,
    "Last12MonthYield": 32.44,
    "ISIN": "IL0051266851"
  },
  {
    "Id": "TASE:5104328",
    "MayaId": "5104328",
    "Name": "ANALYST STRATEGIES",
    "ShortName": "ANALYST STRATEGIES",
    "Symbol": "TASE:5104328",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ANALYST (5C) STRATEGIC INVESTMENTS IL",
    "EnglishLongName": "ANALYST (5C) STRATEGIC INVESTMENTS IL",
    "HebrewName": "אנליסט אסטרטגיות",
    "HebrewLongName": "אנליסט (5C) אסטרטגיות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 3.52,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.17,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Leveraged and Strategic",
    "SecondaryClassification": "Strategic (not leveraged)",
    "AssetValue": 12.2,
    "MonthYield": 5.36,
    "YearYield": 5.36,
    "Last12MonthYield": 58.74,
    "ISIN": "IL0051043284"
  },
  {
    "Id": "TASE:5105929",
    "MayaId": "5105929",
    "Name": "Analyst U.S. Equities",
    "ShortName": "Analyst U.S. Equities",
    "Symbol": "TASE:5105929",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Analyst (4D) U.S. Equities",
    "EnglishLongName": "Analyst (4D) U.S. Equities",
    "HebrewName": "אנליסט מניות ארה\"ב",
    "HebrewLongName": "אנליסט (4D) מניות ארה\"ב",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.4,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.47,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Geographical stocks",
    "AssetValue": 92.4,
    "MonthYield": -0.25,
    "YearYield": -0.25,
    "Last12MonthYield": 0.24,
    "ISIN": "IL0051059298"
  },
  {
    "Id": "TASE:5139670",
    "MayaId": "5139670",
    "Name": "Analyst Value Equities IL",
    "ShortName": "Analyst Value Equities IL",
    "Symbol": "TASE:5139670",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Analyst (4B) Value Equities IL",
    "EnglishLongName": "Analyst (4B) Value Equities IL",
    "HebrewName": "אנליסט מניות ערך",
    "HebrewLongName": "אנליסט (4B) מניות ערך",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.29,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.13,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 39.6,
    "MonthYield": 3.92,
    "YearYield": 3.92,
    "Last12MonthYield": 51.12,
    "ISIN": "IL0051396708"
  },
  {
    "Id": "TASE:5120852",
    "MayaId": "5120852",
    "Name": "Analyst(00)NISMoneyMarket",
    "ShortName": "Analyst(00)NISMoneyMarket",
    "Symbol": "TASE:5120852",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ANALYST (00) NIS MONEY MARKET FUND IL",
    "EnglishLongName": "ANALYST (00) NIS MONEY MARKET FUND IL",
    "HebrewName": "אנליסט (00) כספית שקלית",
    "HebrewLongName": "אנליסט (00) כספית שקלית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.169,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 5451.2,
    "MonthYield": 0.23,
    "YearYield": 0.23,
    "Last12MonthYield": 4.77,
    "ISIN": "IL0051208523"
  },
  {
    "Id": "TASE:5118328",
    "MayaId": "5118328",
    "Name": "ANALYST0A A ORHIGHER",
    "ShortName": "ANALYST0A-A ORHIGHER",
    "Symbol": "TASE:5118328",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ANALYST (0A) BONDS RATED A AND ABOVE DURATION 1-4 YEARS IL",
    "EnglishLongName": "ANALYST (0A) BONDS RATED A AND ABOVE DURATION 1-4 YEARS IL",
    "HebrewName": "אנליסט0Aאג\"ח A מחמ1-4",
    "HebrewLongName": "אנליסט (0A) אג\"ח מדורג A ומעלה מח\"מ 1-4 שנים",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.68,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.25,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 390.4,
    "MonthYield": 0.52,
    "YearYield": 0.52,
    "Last12MonthYield": 6.04,
    "ISIN": "IL0051183288"
  },
  {
    "Id": "TASE:5121777",
    "MayaId": "5121777",
    "Name": "ANALYST0A!GLOBBONHEDG",
    "ShortName": "ANALYST0A!GLOBBONHEDG",
    "Symbol": "TASE:5121777",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ANALYST (0A)(!) GLOBAL BONDS WITH NO EQUITY FOREGIN CURRENCY HEDGED",
    "EnglishLongName": "ANALYST (0A)(!) GLOBAL BONDS WITH NO EQUITY FOREGIN CURRENCY HEDGED",
    "HebrewName": "אנליסט0A!אג\"חחוללאמנוטרלת",
    "HebrewLongName": "אנליסט (0A)(!) אג\"ח חו\"ל ללא מניות מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX-Protected Bonds",
    "AssetValue": 53.9,
    "MonthYield": -0.3,
    "YearYield": -0.3,
    "Last12MonthYield": 4.22,
    "ISIN": "IL0051217771"
  },
  {
    "Id": "TASE:5115027",
    "MayaId": "5115027",
    "Name": "AnalystTel Aviv momentum",
    "ShortName": "AnalystTel Aviv momentum",
    "Symbol": "TASE:5115027",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ANALYST (4B) TEL AVIV 125 MOMENTUM FACTOR IL",
    "EnglishLongName": "ANALYST (4B) TEL AVIV 125 MOMENTUM FACTOR IL",
    "HebrewName": "אנליסט (4B) מניות ת\"א 125",
    "HebrewLongName": "אנליסט (4B) מניות ת\"א 125 במומנטום",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.05,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.22,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 95.0,
    "MonthYield": 6.81,
    "YearYield": 6.81,
    "Last12MonthYield": 63.68,
    "ISIN": "IL0051150279"
  },
  {
    "Id": "ANGL.TA",
    "MayaId": "180018",
    "Name": "ANGEL SALOMON",
    "ShortName": "SALOMON A.ANGEL LTD.",
    "Symbol": "ANGL.TA",
    "TaseSymbol": "ANGL",
    "YahooId": "ANGL.TA",
    "EnglishName": "ANGEL SALOMON",
    "EnglishLongName": "SALOMON A.ANGEL LTD.",
    "HebrewName": "אנגל שלמה",
    "HebrewLongName": "שלמה א. אנג'ל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3110.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 21.3,
    "YearYield": 21.3,
    "Last12MonthYield": null,
    "ISIN": "IL0001800189"
  },
  {
    "Id": "TASE:5104237",
    "MayaId": "5104237",
    "Name": "ANL AG CHUL LLO",
    "ShortName": "ANL AG CHUL LLO",
    "Symbol": "TASE:5104237",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ANALYST (0D)(!) GLOBAL BONDS WITH NO EQUITY",
    "EnglishLongName": "ANALYST (0D)(!) GLOBAL BONDS WITH NO EQUITY",
    "HebrewName": "אנליסט 0D ! אג\"ח חו\"ל ללא",
    "HebrewLongName": "אנליסט (0D)(!) אג\"ח חו\"ל ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.09,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Bond",
    "AssetValue": 78.1,
    "MonthYield": -1.21,
    "YearYield": -1.21,
    "Last12MonthYield": -6.99,
    "ISIN": "IL0051042377"
  },
  {
    "Id": "TASE:5119144",
    "MayaId": "5119144",
    "Name": "ANL MNAYOT CHUL",
    "ShortName": "ANL MNAYOT CHUL",
    "Symbol": "TASE:5119144",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ANALYST (4D) GLOBAL EQUITY",
    "EnglishLongName": "ANALYST (4D) GLOBAL EQUITY",
    "HebrewName": "אנליסט 4D מניות חו\"ל",
    "HebrewLongName": "אנליסט (4D) מניות חו\"ל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.4,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 35.2,
    "MonthYield": 1.2,
    "YearYield": 1.2,
    "Last12MonthYield": 6.05,
    "ISIN": "IL0051191448"
  },
  {
    "Id": "APLP.TA",
    "MayaId": "1082114",
    "Name": "APOLLO POWER",
    "ShortName": "APOLLO POWER LTD",
    "Symbol": "APLP.TA",
    "TaseSymbol": "APLP",
    "YahooId": "APLP.TA",
    "EnglishName": "APOLLO POWER",
    "EnglishLongName": "APOLLO POWER LTD",
    "HebrewName": "אפולו פאוור",
    "HebrewLongName": "אפולו פאוור בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 468.4,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 15.0,
    "YearYield": 15.0,
    "Last12MonthYield": null,
    "ISIN": "IL0010821143"
  },
  {
    "Id": "AQUA.TA",
    "MayaId": "1170240",
    "Name": "AQUARIUS EN",
    "ShortName": "AQUARIUS ENGINES (A.M) LTD",
    "Symbol": "AQUA.TA",
    "TaseSymbol": "AQUA",
    "YahooId": "AQUA.TA",
    "EnglishName": "AQUARIUS EN",
    "EnglishLongName": "AQUARIUS ENGINES (A.M) LTD",
    "HebrewName": "אקוואריוס מנוע",
    "HebrewLongName": "אקוואריוס מנועים (א.מ) בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 169.9,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 53.7,
    "YearYield": 53.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011702409"
  },
  {
    "Id": "ARD.TA",
    "MayaId": "1091651",
    "Name": "ARAD",
    "ShortName": "ARAD LTD.",
    "Symbol": "ARD.TA",
    "TaseSymbol": "ARD",
    "YahooId": "ARD.TA",
    "EnglishName": "ARAD",
    "EnglishLongName": "ARAD LTD.",
    "HebrewName": "ארד",
    "HebrewLongName": "ארד בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5054.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -0.9,
    "YearYield": -0.9,
    "Last12MonthYield": null,
    "ISIN": "IL0010916513"
  },
  {
    "Id": "ARAN.TA",
    "MayaId": "1085265",
    "Name": "ARAN",
    "ShortName": "ARAN RESEARCH & DEVELOPMENT (1982) LTD.",
    "Symbol": "ARAN.TA",
    "TaseSymbol": "ARAN",
    "YahooId": "ARAN.TA",
    "EnglishName": "ARAN",
    "EnglishLongName": "ARAN RESEARCH & DEVELOPMENT (1982) LTD.",
    "HebrewName": "ארן",
    "HebrewLongName": "ארן מחקר ופיתוח (1982) בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3800.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 3.6,
    "YearYield": 3.6,
    "Last12MonthYield": null,
    "ISIN": "IL0010852650"
  },
  {
    "Id": "ARBE.TA",
    "MayaId": "1179662",
    "Name": "ARBE ROBOTICS",
    "ShortName": "ARBE ROBOTICS LTD",
    "Symbol": "ARBE.TA",
    "TaseSymbol": "ARBE",
    "YahooId": "ARBE.TA",
    "EnglishName": "ARBE ROBOTICS",
    "EnglishLongName": "ARBE ROBOTICS LTD",
    "HebrewName": "ארבה רובוטיקס",
    "HebrewLongName": "ארבה רובוטיקס בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 356.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 2.4,
    "YearYield": 2.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011796625"
  },
  {
    "Id": "ARGO.TA",
    "MayaId": "1175371",
    "Name": "ARGO PROP.",
    "ShortName": "ARGO PROPERTIES N.V.",
    "Symbol": "ARGO.TA",
    "TaseSymbol": "ARGO",
    "YahooId": "ARGO.TA",
    "EnglishName": "ARGO PROP.",
    "EnglishLongName": "ARGO PROPERTIES N.V.",
    "HebrewName": "ארגו פרופרטיז",
    "HebrewLongName": "ארגו פרופרטיז אן.וי.",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 13670.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 7.4,
    "YearYield": 7.4,
    "Last12MonthYield": null,
    "ISIN": "NL0015000D84"
  },
  {
    "Id": "ARIN.TA",
    "MayaId": "366013",
    "Name": "ARI RAEL ESTATE",
    "ShortName": "ARI REAL ESTATE (ARENA) INVESTMENT LTD",
    "Symbol": "ARIN.TA",
    "TaseSymbol": "ARIN",
    "YahooId": "ARIN.TA",
    "EnglishName": "ARI RAEL ESTATE",
    "EnglishLongName": "ARI REAL ESTATE (ARENA) INVESTMENT LTD",
    "HebrewName": "ארי נדלן",
    "HebrewLongName": "ארי נדל\"ן (ארנה) השקעות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 426.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 11.5,
    "YearYield": 11.5,
    "Last12MonthYield": null,
    "ISIN": "IL0003660136"
  },
  {
    "Id": "ARYT.TA",
    "MayaId": "587014",
    "Name": "ARYT",
    "ShortName": "ARYT INDUSTRIES LTD.",
    "Symbol": "ARYT.TA",
    "TaseSymbol": "ARYT",
    "YahooId": "ARYT.TA",
    "EnglishName": "ARYT",
    "EnglishLongName": "ARYT INDUSTRIES LTD.",
    "HebrewName": "ארית תעשיות",
    "HebrewLongName": "ארית תעשיות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 6096.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 38.0,
    "YearYield": 38.0,
    "Last12MonthYield": null,
    "ISIN": "IL0005870147"
  },
  {
    "Id": "TASE:5136742",
    "MayaId": "5136742",
    "Name": "AS $ Denmted Money Market",
    "ShortName": "AS $ Denmted Money Market",
    "Symbol": "TASE:5136742",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Althshuler Shaham (0D) $ Denominated Money Market",
    "EnglishLongName": "Althshuler Shaham (0D) $ Denominated Money Market",
    "HebrewName": "אש כספית נקובת דולר",
    "HebrewLongName": "אלטשולר שחם (OD) כספית נקובת דולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.13,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.07,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "FX Money Market with Corporate",
    "AssetValue": 307.6,
    "MonthYield": -0.98,
    "YearYield": -0.98,
    "Last12MonthYield": -9.49,
    "ISIN": "IL0051367428"
  },
  {
    "Id": "TASE:5116017",
    "MayaId": "5116017",
    "Name": "AS (0D) GLOBAL BND USD",
    "ShortName": "AS (0D) GLOBAL BND USD",
    "Symbol": "TASE:5116017",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham (0D) Global Bonds Stated in USD",
    "EnglishLongName": "Altshuler Shaham (0D) Global Bonds Stated in USD",
    "HebrewName": "אש 0D אגח גלובלי נקובה ב$",
    "HebrewLongName": "אלטשולר שחם (0D) אג\"ח גלובלי נקובה בדולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.2,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Bonds",
    "AssetValue": 356.7,
    "MonthYield": -0.93,
    "YearYield": -0.93,
    "Last12MonthYield": -6.51,
    "ISIN": "IL0051160179"
  },
  {
    "Id": "TASE:5115167",
    "MayaId": "5115167",
    "Name": "AS (1B) 90 10 IL",
    "ShortName": "AS (1B) 90-10 IL",
    "Symbol": "TASE:5115167",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham (1B) 90-10 IL",
    "EnglishLongName": "Altshuler Shaham (1B) 90-10 IL",
    "HebrewName": "אש (1B)י 10-90",
    "HebrewLongName": "אלטשולר שחם (1B)י 10-90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.035,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.37,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 486.1,
    "MonthYield": 0.95,
    "YearYield": 0.95,
    "Last12MonthYield": 10.41,
    "ISIN": "IL0051151673"
  },
  {
    "Id": "TASE:5114236",
    "MayaId": "5114236",
    "Name": "AS (2B) 80 20 IL",
    "ShortName": "AS (2B) 80-20 IL",
    "Symbol": "TASE:5114236",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham (2B) 80-20 IL",
    "EnglishLongName": "Altshuler Shaham (2B) 80-20 IL",
    "HebrewName": "אש (2B)י 20-80",
    "HebrewLongName": "אלטשולר שחם (2B)י 20-80",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.36,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 149.7,
    "MonthYield": 0.9,
    "YearYield": 0.9,
    "Last12MonthYield": 11.77,
    "ISIN": "IL0051142367"
  },
  {
    "Id": "TASE:5126164",
    "MayaId": "5126164",
    "Name": "AS (2B) 85 15 IL",
    "ShortName": "AS (2B) 85-15 IL",
    "Symbol": "TASE:5126164",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ALTSHULER SHAHAM (2B) 85-15 IL",
    "EnglishLongName": "ALTSHULER SHAHAM (2B) 85-15 IL",
    "HebrewName": "אש (2B)י 15-85",
    "HebrewLongName": "אלטשולר שחם (2B)י 15-85",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.44,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 15% Equity",
    "AssetValue": 54.6,
    "MonthYield": 1.24,
    "YearYield": 1.24,
    "Last12MonthYield": 13.09,
    "ISIN": "IL0051261647"
  },
  {
    "Id": "TASE:5105705",
    "MayaId": "5105705",
    "Name": "AS (2C) 25 75 IL",
    "ShortName": "AS (2C) 25-75 IL",
    "Symbol": "TASE:5105705",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham (2C) 75-25 IL",
    "EnglishLongName": "Altshuler Shaham (2C) 75-25 IL",
    "HebrewName": "אש (2C)י 25-75",
    "HebrewLongName": "אלטשולר שחם (2C)י 25-75",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.92,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 25% Equity",
    "AssetValue": 140.2,
    "MonthYield": 1.59,
    "YearYield": 1.59,
    "Last12MonthYield": 13.63,
    "ISIN": "IL0051057052"
  },
  {
    "Id": "TASE:5124615",
    "MayaId": "5124615",
    "Name": "AS (3C) 50 50 IL",
    "ShortName": "AS (3C) 50-50 IL",
    "Symbol": "TASE:5124615",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ALTSHULER SHAHAM (3C) 50-50 IL",
    "EnglishLongName": "ALTSHULER SHAHAM (3C) 50-50 IL",
    "HebrewName": "אש (3C)י 50-50",
    "HebrewLongName": "אלטשולר שחם (3C)י 50-50",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.9,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.63,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - Max. Exposure over 30% Equity",
    "AssetValue": 58.0,
    "MonthYield": 2.95,
    "YearYield": 2.95,
    "Last12MonthYield": 18.93,
    "ISIN": "IL0051246150"
  },
  {
    "Id": "TASE:5126180",
    "MayaId": "5126180",
    "Name": "AS (3C) 65 35 IL",
    "ShortName": "AS (3C) 65-35 IL",
    "Symbol": "TASE:5126180",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ALTSHULER SHAHAM (3C) 35-65 IL",
    "EnglishLongName": "ALTSHULER SHAHAM (3C) 35-65 IL",
    "HebrewName": "אש (3C)י 35-65",
    "HebrewLongName": "אלטשולר שחם (3C)י 35-65",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.85,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.68,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - Max. Exposure over 30% Equity",
    "AssetValue": 17.3,
    "MonthYield": 1.81,
    "YearYield": 1.81,
    "Last12MonthYield": 14.63,
    "ISIN": "IL0051261803"
  },
  {
    "Id": "TASE:5105903",
    "MayaId": "5105903",
    "Name": "AS (40) YETER IL",
    "ShortName": "AS (40) YETER IL",
    "Symbol": "TASE:5105903",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ALTSHULER SHAHAM (40) YETER IL",
    "EnglishLongName": "ALTSHULER SHAHAM (40) YETER IL",
    "HebrewName": "אש (40) יתר",
    "HebrewLongName": "אלטשולר שחם (40) יתר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.5,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.93,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 158.1,
    "MonthYield": 3.62,
    "YearYield": 3.62,
    "Last12MonthYield": 39.57,
    "ISIN": "IL0051059033"
  },
  {
    "Id": "TASE:5103700",
    "MayaId": "5103700",
    "Name": "AS (4B) REAL ESTATE IL",
    "ShortName": "AS (4B) REAL ESTATE IL",
    "Symbol": "TASE:5103700",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ALTSHULER SHAHAM (4B) REAL ESTATE IL",
    "EnglishLongName": "ALTSHULER SHAHAM (4B) REAL ESTATE IL",
    "HebrewName": "אש (4B) נדל\"ן",
    "HebrewLongName": "אלטשולר שחם (4B) נדל\"ן",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.24,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.62,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sectors",
    "AssetValue": 153.5,
    "MonthYield": 5.96,
    "YearYield": 5.96,
    "Last12MonthYield": 32.52,
    "ISIN": "IL0051037005"
  },
  {
    "Id": "TASE:5126701",
    "MayaId": "5126701",
    "Name": "AS (4B) SUFA EQUITY IL",
    "ShortName": "AS (4B) SUFA EQUITY IL",
    "Symbol": "TASE:5126701",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham (4B) Sufa Equity IL",
    "EnglishLongName": "Altshuler Shaham (4B) Sufa Equity IL",
    "HebrewName": "אש (4B) סופה מניות",
    "HebrewLongName": "אלטשולר שחם (4B) סופה מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.2,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.9,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 755.9,
    "MonthYield": 4.85,
    "YearYield": 4.85,
    "Last12MonthYield": 44.52,
    "ISIN": "IL0051267016"
  },
  {
    "Id": "TASE:5105218",
    "MayaId": "5105218",
    "Name": "AS (4D) GLOBAL GREEN",
    "ShortName": "AS (4D) GLOBAL GREEN",
    "Symbol": "TASE:5105218",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham (4D) Global Green",
    "EnglishLongName": "Altshuler Shaham (4D) Global Green",
    "HebrewName": "אש (4D) ירוקה גלובלי",
    "HebrewLongName": "אלטשולר שחם (4D) ירוקה גלובלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.25,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.97,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks by Sectors - Foreign",
    "AssetValue": 31.5,
    "MonthYield": 2.76,
    "YearYield": 2.76,
    "Last12MonthYield": 17.25,
    "ISIN": "IL0051052186"
  },
  {
    "Id": "TASE:5136734",
    "MayaId": "5136734",
    "Name": "AS (4D) MSCI World",
    "ShortName": "AS (4D) MSCI World",
    "Symbol": "TASE:5136734",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham (4D) MSCI World",
    "EnglishLongName": "Altshuler Shaham (4D) MSCI World",
    "HebrewName": "אש (4D)י MSCI World",
    "HebrewLongName": "אלטשולר שחם (4D)י MSCI World",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.5,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Geographical stocks",
    "AssetValue": 331.2,
    "MonthYield": 0.99,
    "YearYield": 0.99,
    "Last12MonthYield": 11.55,
    "ISIN": "IL0051367345"
  },
  {
    "Id": "TASE:5111000",
    "MayaId": "5111000",
    "Name": "AS 00 GOV MED CPI LINK IL",
    "ShortName": "AS 00 GOV MED CPI LINK IL",
    "Symbol": "TASE:5111000",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham (00) Government Medium CPI Linked IL",
    "EnglishLongName": "Altshuler Shaham (00) Government Medium CPI Linked IL",
    "HebrewName": "אש (00) מדינה צמוד בינוני",
    "HebrewLongName": "אלטשולר שחם (00) מדינה צמוד בינוני",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.2,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked Government Bonds - No Equity",
    "AssetValue": 75.5,
    "MonthYield": 0.06,
    "YearYield": 0.06,
    "Last12MonthYield": 4.6,
    "ISIN": "IL0051110000"
  },
  {
    "Id": "TASE:5110085",
    "MayaId": "5110085",
    "Name": "AS 00 TEL BOND Bonds IL",
    "ShortName": "AS 00 TEL BOND Bonds IL",
    "Symbol": "TASE:5110085",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham (00) TEL BOND Bonds IL",
    "EnglishLongName": "Altshuler Shaham (00) TEL BOND Bonds IL",
    "HebrewName": "אש 00 אגח תל בונד",
    "HebrewLongName": "אלטשולר שחם (00) אג\"ח תל בונד",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.36,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 295.0,
    "MonthYield": 0.71,
    "YearYield": 0.71,
    "Last12MonthYield": 7.36,
    "ISIN": "IL0051100852"
  },
  {
    "Id": "TASE:5116983",
    "MayaId": "5116983",
    "Name": "AS 0A GOV BND 0EQ IL",
    "ShortName": "AS 0A GOV BND 0EQ IL",
    "Symbol": "TASE:5116983",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham (0A) Government Bonds Stocks Free IL",
    "EnglishLongName": "Altshuler Shaham (0A) Government Bonds Stocks Free IL",
    "HebrewName": "אש (0A) אגח מדינה ללא מנ'",
    "HebrewLongName": "אלטשולר שחם (0A) אג\"ח מדינה ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.63,
    "TrusteeFee": 0.035,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - No Equity",
    "AssetValue": 254.1,
    "MonthYield": 0.49,
    "YearYield": 0.49,
    "Last12MonthYield": 6.27,
    "ISIN": "IL0051169832"
  },
  {
    "Id": "TASE:5126727",
    "MayaId": "5126727",
    "Name": "AS 0B(!) BND 0EQ PORT IL",
    "ShortName": "AS 0B(!) BND 0EQ PORT IL",
    "Symbol": "TASE:5126727",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham (0B)(!) Bonds, Stocks Free Portfolio IL",
    "EnglishLongName": "Altshuler Shaham (0B)(!) Bonds, Stocks Free Portfolio IL",
    "HebrewName": "אש 0B(!) תיק אגח ללא מנ'",
    "HebrewLongName": "אלטשולר שחם (0B)(!) תיק אג\"ח ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.31,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 135.8,
    "MonthYield": 0.8,
    "YearYield": 0.8,
    "Last12MonthYield": 6.53,
    "ISIN": "IL0051267271"
  },
  {
    "Id": "TASE:5105697",
    "MayaId": "5105697",
    "Name": "AS 0B(!) CORP BND 0EQ IL",
    "ShortName": "AS 0B(!) CORP BND 0EQ IL",
    "Symbol": "TASE:5105697",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham (0B)(!) Corporate Bonds Stocks Free IL",
    "EnglishLongName": "Altshuler Shaham (0B)(!) Corporate Bonds Stocks Free IL",
    "HebrewName": "אש 0B(!) אג חברות ללא מנ'",
    "HebrewLongName": "אלטשולר שחם (0B)(!) אג\"ח חברות ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.24,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.37,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 302.7,
    "MonthYield": 1.05,
    "YearYield": 1.05,
    "Last12MonthYield": 6.97,
    "ISIN": "IL0051056971"
  },
  {
    "Id": "TASE:5105911",
    "MayaId": "5105911",
    "Name": "AS 0D(!) GOLBAL BND 0EQ",
    "ShortName": "AS 0D(!) GOLBAL BND 0EQ",
    "Symbol": "TASE:5105911",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham (0D)(!) Global Bonds Stocks Free",
    "EnglishLongName": "Altshuler Shaham (0D)(!) Global Bonds Stocks Free",
    "HebrewName": "אש 0D(!) אג גלובל ללא מנ'",
    "HebrewLongName": "אלטשולר שחם (0D)(!) אג\"ח גלובלי ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.95,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.15,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Bond",
    "AssetValue": 186.1,
    "MonthYield": -1.18,
    "YearYield": -1.18,
    "Last12MonthYield": -6.68,
    "ISIN": "IL0051059116"
  },
  {
    "Id": "TASE:5122825",
    "MayaId": "5122825",
    "Name": "AS 2B 70 30 IL",
    "ShortName": "AS 2B 70-30 IL",
    "Symbol": "TASE:5122825",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ALTSHULER SHAHAM (2B) 70-30 IL",
    "EnglishLongName": "ALTSHULER SHAHAM (2B) 70-30 IL",
    "HebrewName": "אש 2Bי 30-70",
    "HebrewLongName": "אלטשולר שחם (2B)י 30-70",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.63,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 97.9,
    "MonthYield": 2.15,
    "YearYield": 2.15,
    "Last12MonthYield": 19.03,
    "ISIN": "IL0051228257"
  },
  {
    "Id": "TASE:5118476",
    "MayaId": "5118476",
    "Name": "AS 2B GOV BND +20% IL",
    "ShortName": "AS 2B GOV BND +20% IL",
    "Symbol": "TASE:5118476",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham (2B) Government Bonds + 20% IL",
    "EnglishLongName": "Altshuler Shaham (2B) Government Bonds + 20% IL",
    "HebrewName": "אש 2B אג מד +20%",
    "HebrewLongName": "אלטשולר שחם (2B) אג\"ח מדינה + 20%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bonds - General - Up to 20% Equity",
    "AssetValue": 58.0,
    "MonthYield": 0.7,
    "YearYield": 0.7,
    "Last12MonthYield": 10.31,
    "ISIN": "IL0051184765"
  },
  {
    "Id": "TASE:5136700",
    "MayaId": "5136700",
    "Name": "AS 70/30 TA Equity IL",
    "ShortName": "AS 70/30 TA Equity IL",
    "Symbol": "TASE:5136700",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham (2A) 70/30 TA Equity IL",
    "EnglishLongName": "Altshuler Shaham (2A) 70/30 TA Equity IL",
    "HebrewName": "אש 30/70 מניות ת\"א",
    "HebrewLongName": "אלטשולר שחם (2A)י 30/70 מניות ת\"א",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.49,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.77,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 11.8,
    "MonthYield": 0.26,
    "YearYield": 0.26,
    "Last12MonthYield": 16.85,
    "ISIN": "IL0051367006"
  },
  {
    "Id": "TASE:5136718",
    "MayaId": "5136718",
    "Name": "AS 80/20 TA Equity IL",
    "ShortName": "AS 80/20 TA Equity IL",
    "Symbol": "TASE:5136718",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham (2A) 80/20 TA Equity IL",
    "EnglishLongName": "Altshuler Shaham (2A) 80/20 TA Equity IL",
    "HebrewName": "אש 20/80 מניות ת\"א",
    "HebrewLongName": "אלטשולר שחם (2A)י 20/80 מניות ת\"א",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.49,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.54,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 156.7,
    "MonthYield": 1.83,
    "YearYield": 1.83,
    "Last12MonthYield": 17.5,
    "ISIN": "IL0051367188"
  },
  {
    "Id": "TASE:5100235",
    "MayaId": "5100235",
    "Name": "AS 90/10 Global Porfolio",
    "ShortName": "AS 90/10 Global Porfolio",
    "Symbol": "TASE:5100235",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ALTSHULER SHAHAM (1D) 90/10 Global Portfolio",
    "EnglishLongName": "ALTSHULER SHAHAM (1D) 90/10 Global Portfolio",
    "HebrewName": "אלטשולר שחם 10/90 תיק חול",
    "HebrewLongName": "אלטשולר שחם (1D)י 10/90 תיק חו\"ל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.78,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.1,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "Dollar Bond",
    "AssetValue": 100.1,
    "MonthYield": -1.12,
    "YearYield": -1.12,
    "Last12MonthYield": -6.01,
    "ISIN": "IL0051002355"
  },
  {
    "Id": "TASE:5136726",
    "MayaId": "5136726",
    "Name": "AS 90/10 TA Equity IL",
    "ShortName": "AS 90/10 TA Equity IL",
    "Symbol": "TASE:5136726",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham (1A) 90/10 TA Equity IL",
    "EnglishLongName": "Altshuler Shaham (1A) 90/10 TA Equity IL",
    "HebrewName": "אש 10/90 מניות ת\"א",
    "HebrewLongName": "אלטשולר שחם (1A)י 10/90 מניות ת\"א",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.49,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.47,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 5.2,
    "MonthYield": 0.81,
    "YearYield": 0.81,
    "Last12MonthYield": 8.72,
    "ISIN": "IL0051367261"
  },
  {
    "Id": "TASE:5116975",
    "MayaId": "5116975",
    "Name": "AS A&Hi Corp Bonds IL",
    "ShortName": "AS A&Hi Corp Bonds IL",
    "Symbol": "TASE:5116975",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham (0A) A And Higher Rated Corporate Bonds IL",
    "EnglishLongName": "Altshuler Shaham (0A) A And Higher Rated Corporate Bonds IL",
    "HebrewName": "אש אגח קונצרני A ומעלה",
    "HebrewLongName": "אלטשולר שחם (0A) אג\"ח קונצרני A ומעלה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.035,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.29,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 252.4,
    "MonthYield": 0.55,
    "YearYield": 0.55,
    "Last12MonthYield": 6.74,
    "ISIN": "IL0051169758"
  },
  {
    "Id": "TASE:5135496",
    "MayaId": "5135496",
    "Name": "AS AB SB IL Real Estate",
    "ShortName": "AS AB SB IL Real Estate",
    "Symbol": "TASE:5135496",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham Tracking (4A) A.B SmartBeta IL Real Estate",
    "EnglishLongName": "Altshuler Shaham Tracking (4A) A.B SmartBeta IL Real Estate",
    "HebrewName": "אש נדלן ישראל AB SB",
    "HebrewLongName": "אלטשולר שחם מחקה (4A) נדל\"ן ישראל A.B SmartBeta",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.9,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.08,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 8.7,
    "MonthYield": 8.32,
    "YearYield": 8.32,
    "Last12MonthYield": 37.46,
    "ISIN": "IL0051354962"
  },
  {
    "Id": "TASE:5135504",
    "MayaId": "5135504",
    "Name": "AS AB SB IL Technology",
    "ShortName": "AS AB SB IL Technology",
    "Symbol": "TASE:5135504",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham Tracking (4A) A.B SmartBeta IL Technology",
    "EnglishLongName": "Altshuler Shaham Tracking (4A) A.B SmartBeta IL Technology",
    "HebrewName": "אש טכנולוגיה ישראל AB SB",
    "HebrewLongName": "אלטשולר שחם מחקה (4A)י טכנולוגיה ישראל A.B SmartBeta",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.9,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.49,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 45.0,
    "MonthYield": 12.97,
    "YearYield": 12.97,
    "Last12MonthYield": 90.76,
    "ISIN": "IL0051355043"
  },
  {
    "Id": "TASE:5134150",
    "MayaId": "5134150",
    "Name": "AS AB SB MSCapMF T30TA IL",
    "ShortName": "AS AB SB MSCapMF T30TA IL",
    "Symbol": "TASE:5134150",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham Tracking (4A) A.B SmartBeta MidSmall Cap Multifactor Top30TA IL",
    "EnglishLongName": "Altshuler Shaham Tracking (4A) A.B SmartBeta MidSmall Cap Multifactor Top30TA IL",
    "HebrewName": "אש AB SB MS Cap MF T30TA",
    "HebrewLongName": "אלטשולר שחם מחקה (4A)י A.B SmartBeta Mid – Small Cap MultiFactor Top 30 TA",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.77,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 11.6,
    "MonthYield": 7.63,
    "YearYield": 7.63,
    "Last12MonthYield": 76.23,
    "ISIN": "IL0051341506"
  },
  {
    "Id": "TASE:5133269",
    "MayaId": "5133269",
    "Name": "AS AB SB USAPureValue FCH",
    "ShortName": "AS AB SB USAPureValue FCH",
    "Symbol": "TASE:5133269",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham Tracking (4A) A.B SmartBeta USA Pure Value FCH",
    "EnglishLongName": "Altshuler Shaham Tracking (4A) A.B SmartBeta USA Pure Value FCH",
    "HebrewName": "אש AB SBי USAPureValue ממ",
    "HebrewLongName": "אלטשולר שחם מחקה (4A)י A.B SmartBeta USA Pure Value מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.9,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.37,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 3.1,
    "MonthYield": 4.34,
    "YearYield": 4.34,
    "Last12MonthYield": 20.3,
    "ISIN": "IL0051332695"
  },
  {
    "Id": "TASE:5140959",
    "MayaId": "5140959",
    "Name": "AS AB Trcking TLVNY IL 25",
    "ShortName": "AS AB Trcking TLVNY IL 25",
    "Symbol": "TASE:5140959",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham Tracking (4C) A.B TLV-NY Israel Top 25",
    "EnglishLongName": "Altshuler Shaham Tracking (4C) A.B TLV-NY Israel Top 25",
    "HebrewName": "אש מחקה אב TLVNY IL 25",
    "HebrewLongName": "אלטשולר שחם מחקה (4C)י A.B TLV-NY Israel Top 25",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 0.2,
    "MonthYield": 6.63,
    "YearYield": 6.63,
    "Last12MonthYield": null,
    "ISIN": "IL0051409592"
  },
  {
    "Id": "TASE:5108667",
    "MayaId": "5108667",
    "Name": "AS CPI LINKD GV BD 0EQ IL",
    "ShortName": "AS CPI LINKD GV BD 0EQ IL",
    "Symbol": "TASE:5108667",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham (00) Index Linked Government Bonds Stocks Free IL",
    "EnglishLongName": "Altshuler Shaham (00) Index Linked Government Bonds Stocks Free IL",
    "HebrewName": "אש אג מד צמוד-מדד ללא מנ'",
    "HebrewLongName": "אלטשולר שחם (00) אג\"ח מדינה צמודי מדד ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.78,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.27,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked Government Bonds - No Equity",
    "AssetValue": 567.6,
    "MonthYield": -0.12,
    "YearYield": -0.12,
    "Last12MonthYield": 4.12,
    "ISIN": "IL0051086671"
  },
  {
    "Id": "TASE:5118591",
    "MayaId": "5118591",
    "Name": "AS GL CR/US BND UP 10 FC",
    "ShortName": "AS GL CR/US BND UP 10 FC",
    "Symbol": "TASE:5118591",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ALTSHULER SHAHAM (0A)(!) GLOBAL CORPORATE/USA BONDS UP TO 10% FOREIGN CURRENCY",
    "EnglishLongName": "ALTSHULER SHAHAM (0A)(!) GLOBAL CORPORATE/USA BONDS UP TO 10% FOREIGN CURRENCY",
    "HebrewName": "אש אג ארב/חל קצ עד 10 מטח",
    "HebrewLongName": "אלטשולר שחם (0A)(!) אג\"ח ארה\"ב/חו\"ל קונצרני עד 10% מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.95,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.24,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX-Protected Bonds",
    "AssetValue": 371.6,
    "MonthYield": 0.16,
    "YearYield": 0.16,
    "Last12MonthYield": 6.77,
    "ISIN": "IL0051185911"
  },
  {
    "Id": "TASE:5122122",
    "MayaId": "5122122",
    "Name": "AS Gov AB SB IL",
    "ShortName": "AS Gov AB SB IL",
    "Symbol": "TASE:5122122",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham Tracking (00) Government A.B SmartBeta IL",
    "EnglishLongName": "Altshuler Shaham Tracking (00) Government A.B SmartBeta IL",
    "HebrewName": "אש ממשלתי AB SB",
    "HebrewLongName": "אלטשולר שחם מחקה (00) ממשלתי A.B SmartBeta",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.45,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.27,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bonds - Other",
    "AssetValue": 4.2,
    "MonthYield": 0.34,
    "YearYield": 0.34,
    "Last12MonthYield": 1.38,
    "ISIN": "IL0051221229"
  },
  {
    "Id": "TASE:5107800",
    "MayaId": "5107800",
    "Name": "AS GOV BONDS + 10% IL",
    "ShortName": "AS GOV BONDS + 10% IL",
    "Symbol": "TASE:5107800",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ALTSHULER SHAHAM (1A) GOVERNMENT BONDS + 10% IL",
    "EnglishLongName": "ALTSHULER SHAHAM (1A) GOVERNMENT BONDS + 10% IL",
    "HebrewName": "אש אג\"ח מדינה + 10%",
    "HebrewLongName": "אלטשולר שחם (1A) אג\"ח מדינה + 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.36,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - up to 10% Equity",
    "AssetValue": 75.5,
    "MonthYield": 0.92,
    "YearYield": 0.92,
    "Last12MonthYield": 9.56,
    "ISIN": "IL0051078009"
  },
  {
    "Id": "TASE:5135744",
    "MayaId": "5135744",
    "Name": "AS IL FndFnd up to 15% St",
    "ShortName": "AS IL FndFnd up to 15% St",
    "Symbol": "TASE:5135744",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ALTSHULER SHAHAM (2B) IL Fund of Funds Up to 15% Stocks",
    "EnglishLongName": "ALTSHULER SHAHAM (2B) IL Fund of Funds Up to 15% Stocks",
    "HebrewName": "אש אגד ישראלי עד 15% מנ",
    "HebrewLongName": "אלטשולר שחם (2B) אגד ישראלי עד 15% מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Fund of Funds",
    "SecondaryClassification": "Israeli Fund of Funds",
    "AssetValue": 23.6,
    "MonthYield": 0.83,
    "YearYield": 0.83,
    "Last12MonthYield": 8.12,
    "ISIN": "IL0051357445"
  },
  {
    "Id": "TASE:5135751",
    "MayaId": "5135751",
    "Name": "AS IL FndFnd up to 30% St",
    "ShortName": "AS IL FndFnd up to 30% St",
    "Symbol": "TASE:5135751",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ALTSHULER SHAHAM (2B) IL Fund of Funds Up to 30% Stocks",
    "EnglishLongName": "ALTSHULER SHAHAM (2B) IL Fund of Funds Up to 30% Stocks",
    "HebrewName": "אש אגד ישראלי עד 30% מנ",
    "HebrewLongName": "אלטשולר שחם (2B) אגד ישראלי עד 30% מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.44,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Fund of Funds",
    "SecondaryClassification": "Israeli Fund of Funds",
    "AssetValue": 23.2,
    "MonthYield": 1.19,
    "YearYield": 1.19,
    "Last12MonthYield": 10.5,
    "ISIN": "IL0051357510"
  },
  {
    "Id": "TASE:5124144",
    "MayaId": "5124144",
    "Name": "AS Isr Equity IL SB",
    "ShortName": "AS Isr Equity IL SB",
    "Symbol": "TASE:5124144",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham (4A) Israel Equity SmartBeta IL",
    "EnglishLongName": "Altshuler Shaham (4A) Israel Equity SmartBeta IL",
    "HebrewName": "אש מניות ישראל SB",
    "HebrewLongName": "אלטשולר שחם (4A) מניות ישראל SmartBeta",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.95,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.04,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 44.2,
    "MonthYield": 11.07,
    "YearYield": 11.07,
    "Last12MonthYield": 65.43,
    "ISIN": "IL0051241441"
  },
  {
    "Id": "TASE:5105820",
    "MayaId": "5105820",
    "Name": "AS Kaspit No Corporate IL",
    "ShortName": "AS Kaspit No Corporate IL",
    "Symbol": "TASE:5105820",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Saham(00) Kaspit Without Corporate IL",
    "EnglishLongName": "Altshuler Saham(00) Kaspit Without Corporate IL",
    "HebrewName": "אש כספית ללא קונצרני",
    "HebrewLongName": "אלטשולר שחם (00) כספית ללא קונצרני",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.21,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 1322.7,
    "MonthYield": 0.21,
    "YearYield": 0.21,
    "Last12MonthYield": 4.38,
    "ISIN": "IL0051058209"
  },
  {
    "Id": "TASE:5140918",
    "MayaId": "5140918",
    "Name": "AS Liquid Manage MM IL",
    "ShortName": "AS Liquid Manage MM IL",
    "Symbol": "TASE:5140918",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham (00) Liquidity Management Money Market IL",
    "EnglishLongName": "Altshuler Shaham (00) Liquidity Management Money Market IL",
    "HebrewName": "אש כספית ניהול נזילות",
    "HebrewLongName": "אלטשולר שחם (00) כספית ניהול נזילות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.06,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 2983.9,
    "MonthYield": 0.24,
    "YearYield": 0.24,
    "Last12MonthYield": null,
    "ISIN": "IL0051409188"
  },
  {
    "Id": "TASE:5138763",
    "MayaId": "5138763",
    "Name": "AS Money Market Fund IL",
    "ShortName": "AS Money Market Fund IL",
    "Symbol": "TASE:5138763",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham(00) Money Market Fund IL",
    "EnglishLongName": "Altshuler Shaham(00) Money Market Fund IL",
    "HebrewName": "אלטשולר שחם כספית",
    "HebrewLongName": "אלטשולר שחם (00) כספית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.234,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 3129.4,
    "MonthYield": 0.2,
    "YearYield": 0.2,
    "Last12MonthYield": 4.6,
    "ISIN": "IL0051387632"
  },
  {
    "Id": "TASE:5108642",
    "MayaId": "5108642",
    "Name": "AS OPPORTUNITY BONDS IL",
    "ShortName": "AS OPPORTUNITY BONDS IL",
    "Symbol": "TASE:5108642",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ALTSHULER SHACHAM (1B)(!) OPPORTUNITY BONDS IL",
    "EnglishLongName": "ALTSHULER SHACHAM (1B)(!) OPPORTUNITY BONDS IL",
    "HebrewName": "אש אג\"ח הזדמנויות",
    "HebrewLongName": "אלטשולר שחם (1B)(!) אג\"ח הזדמנויות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.49,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.65,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles with Equity",
    "AssetValue": 179.3,
    "MonthYield": 1.04,
    "YearYield": 1.04,
    "Last12MonthYield": 8.6,
    "ISIN": "IL0051086424"
  },
  {
    "Id": "TASE:5129598",
    "MayaId": "5129598",
    "Name": "AS Port 3 FIBI IL",
    "ShortName": "AS Port 3 FIBI IL",
    "Symbol": "TASE:5129598",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ALTSHULER SHAHAM (2B) FOLLOWING PORTFOLIO 3 FIBI BANK IL",
    "EnglishLongName": "ALTSHULER SHAHAM (2B) FOLLOWING PORTFOLIO 3 FIBI BANK IL",
    "HebrewName": "אש עוקבת תיק 3 הבינלאומי",
    "HebrewLongName": "אלטשולר שחם (2B) עוקבת תיק 3 הבנק הבינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 12.1,
    "MonthYield": 1.27,
    "YearYield": 1.27,
    "Last12MonthYield": 13.46,
    "ISIN": "IL0051295983"
  },
  {
    "Id": "TASE:1223866",
    "MayaId": "1223866",
    "Name": "AS R MM Month 16022026 IL",
    "ShortName": "AS R MM Month 16022026 IL",
    "Symbol": "TASE:1223866",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham (00) Renewing Money Market Monthly Maturity Up To 16/02/2026 IL",
    "EnglishLongName": "Altshuler Shaham (00) Renewing Money Market Monthly Maturity Up To 16/02/2026 IL",
    "HebrewName": "אש מ כספ חודשי 16022026",
    "HebrewLongName": "אלטשולר שחם (00) כספית מתחדשת חודשי לפדיון 16/02/2026",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.19,
    "TrusteeFee": 0.007,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 6.1,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": "IL0012238668"
  },
  {
    "Id": "TASE:5136759",
    "MayaId": "5136759",
    "Name": "AS Rated Corp Bonds IL",
    "ShortName": "AS Rated Corp Bonds IL",
    "Symbol": "TASE:5136759",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham (0B) Rated Corporate Bonds IL",
    "EnglishLongName": "Altshuler Shaham (0B) Rated Corporate Bonds IL",
    "HebrewName": "אש אג\"ח קונצרני מדורג",
    "HebrewLongName": "אלטשולר שחם (0B) אג\"ח קונצרני מדורג",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 230.4,
    "MonthYield": 0.58,
    "YearYield": 0.58,
    "Last12MonthYield": 7.63,
    "ISIN": "IL0051367592"
  },
  {
    "Id": "TASE:5138037",
    "MayaId": "5138037",
    "Name": "AS S&P 500 FCH",
    "ShortName": "AS S&P 500 FCH",
    "Symbol": "TASE:5138037",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham (4A) S&P 500 - Foreign Currency Hedged",
    "EnglishLongName": "Altshuler Shaham (4A) S&P 500 - Foreign Currency Hedged",
    "HebrewName": "אש S&P 500 מנוטרלת מט\"ח",
    "HebrewLongName": "אלטשולר שחם (4A)י S&P 500 – מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.45,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.89,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Geographical stocks",
    "AssetValue": 41.3,
    "MonthYield": 1.2,
    "YearYield": 1.2,
    "Last12MonthYield": 22.4,
    "ISIN": "IL0051380371"
  },
  {
    "Id": "TASE:5124003",
    "MayaId": "5124003",
    "Name": "AS SB AB EUR ILS",
    "ShortName": "AS SB AB EUR ILS",
    "Symbol": "TASE:5124003",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham Tracking (4A) A.B SmartBeta Europe Foreign Currency Hedged",
    "EnglishLongName": "Altshuler Shaham Tracking (4A) A.B SmartBeta Europe Foreign Currency Hedged",
    "HebrewName": "אש SB אירופה AB ממ",
    "HebrewLongName": "אלטשולר שחם מחקה (4A) אירופה A.B SmartBeta מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.9,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 32.5,
    "MonthYield": 8.51,
    "YearYield": 8.51,
    "Last12MonthYield": 62.38,
    "ISIN": "IL0051240039"
  },
  {
    "Id": "TASE:5119201",
    "MayaId": "5119201",
    "Name": "AS SB AB TA 125 LV",
    "ShortName": "AS SB AB TA 125 LV",
    "Symbol": "TASE:5119201",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham Tracking (4A) A.B SmartBeta TA 125 Low Volatility IL",
    "EnglishLongName": "Altshuler Shaham Tracking (4A) A.B SmartBeta TA 125 Low Volatility IL",
    "HebrewName": "אש LV SB תא 125 AB",
    "HebrewLongName": "אלטשולר שחם מחקה (4A)י Low Volatility ת\"א 125 A.B SmartBeta",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.48,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 229.7,
    "MonthYield": 10.11,
    "YearYield": 10.11,
    "Last12MonthYield": 84.97,
    "ISIN": "IL0051192016"
  },
  {
    "Id": "TASE:5119219",
    "MayaId": "5119219",
    "Name": "AS SB AB TA125 MF",
    "ShortName": "AS SB AB TA125 MF",
    "Symbol": "TASE:5119219",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham Tracking (4A) A.B SmartBeta TA 125 Multi Factor IL",
    "EnglishLongName": "Altshuler Shaham Tracking (4A) A.B SmartBeta TA 125 Multi Factor IL",
    "HebrewName": "אש SB מפ תא125 AB",
    "HebrewLongName": "אלטשולר שחם מחקה (4A) מולטי פקטור ת\"א 125 A.B SmartBeta",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.89,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 517.2,
    "MonthYield": 8.03,
    "YearYield": 8.03,
    "Last12MonthYield": 80.76,
    "ISIN": "IL0051192198"
  },
  {
    "Id": "TASE:5121306",
    "MayaId": "5121306",
    "Name": "AS SB Com TA Large Cap IL",
    "ShortName": "AS SB Com TA Large Cap IL",
    "Symbol": "TASE:5121306",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham Tracking (4A) SmartBeta Composite Large Cap TA Monthly IL",
    "EnglishLongName": "Altshuler Shaham Tracking (4A) SmartBeta Composite Large Cap TA Monthly IL",
    "HebrewName": "אש SB מש תא Large Cap",
    "HebrewLongName": "אלטשולר שחם מחקה (4A)י SmartBeta משולבת ת\"א Large Cap חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.89,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks in Israel, Composite",
    "AssetValue": 61.5,
    "MonthYield": 11.24,
    "YearYield": 11.24,
    "Last12MonthYield": 80.94,
    "ISIN": "IL0051213069"
  },
  {
    "Id": "TASE:5119227",
    "MayaId": "5119227",
    "Name": "AS SB COMP BND EQU 10 IL",
    "ShortName": "AS SB COMP BND EQU 10 IL",
    "Symbol": "TASE:5119227",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham Tracking (2A) SmartBeta Comp Bond(90%) & Equity(10%) Monthly IL",
    "EnglishLongName": "Altshuler Shaham Tracking (2A) SmartBeta Comp Bond(90%) & Equity(10%) Monthly IL",
    "HebrewName": "אש SB מש אגח מניות 10",
    "HebrewLongName": "אלטשולר שחם מחקה (2A)י SmartBeta משולבת אג\"ח (90%) ומניות (10%) חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.55,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.43,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Composite Bonds",
    "SecondaryClassification": "up to 10% Equity",
    "AssetValue": 15.7,
    "MonthYield": 1.34,
    "YearYield": 1.34,
    "Last12MonthYield": 9.59,
    "ISIN": "IL0051192271"
  },
  {
    "Id": "TASE:5119235",
    "MayaId": "5119235",
    "Name": "AS SB Corp Mom A AB",
    "ShortName": "AS SB Corp Mom A- AB",
    "Symbol": "TASE:5119235",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham Tracking (00) Corporate Momentum (A-) UP A.B SmartBeta IL",
    "EnglishLongName": "Altshuler Shaham Tracking (00) Corporate Momentum (A-) UP A.B SmartBeta IL",
    "HebrewName": "אש SB מומ קונצרני -AB A",
    "HebrewLongName": "אלטשולר שחם מחקה (00) מומנטום קונצרני (-A) ומעלה A.B SmartBeta",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.21,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 12.9,
    "MonthYield": 0.4,
    "YearYield": 0.4,
    "Last12MonthYield": 6.17,
    "ISIN": "IL0051192354"
  },
  {
    "Id": "TASE:5133954",
    "MayaId": "5133954",
    "Name": "AS SHEKEL GOV BONDS IL",
    "ShortName": "AS SHEKEL GOV BONDS IL",
    "Symbol": "TASE:5133954",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ALTSHULER SHAHAM (0A) SHEKEL GOVERNMENT BONDS IL",
    "EnglishLongName": "ALTSHULER SHAHAM (0A) SHEKEL GOVERNMENT BONDS IL",
    "HebrewName": "אש אג\"ח מדינה שקליות",
    "HebrewLongName": "אלטשולר שחם (0A) אג\"ח מדינה שקליות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.035,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.36,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Shekel Bonds - No Equity",
    "AssetValue": 55.0,
    "MonthYield": 0.69,
    "YearYield": 0.69,
    "Last12MonthYield": 6.94,
    "ISIN": "IL0051339542"
  },
  {
    "Id": "TASE:5100813",
    "MayaId": "5100813",
    "Name": "AS SKL PROTFOLIO BOND IL",
    "ShortName": "AS SKL PROTFOLIO BOND IL",
    "Symbol": "TASE:5100813",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ALTSHULER SHAHAM (0A) SHIKLI PROTFOLIO BOND IL",
    "EnglishLongName": "ALTSHULER SHAHAM (0A) SHIKLI PROTFOLIO BOND IL",
    "HebrewName": "אש תיק אג\"ח שקלי",
    "HebrewLongName": "אלטשולר שחם (0A) תיק אג\"ח שקלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.78,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 482.3,
    "MonthYield": 0.84,
    "YearYield": 0.84,
    "Last12MonthYield": 6.98,
    "ISIN": "IL0051008139"
  },
  {
    "Id": "TASE:5110564",
    "MayaId": "5110564",
    "Name": "AS STOCKS FREE PORT IL",
    "ShortName": "AS STOCKS FREE PORT IL",
    "Symbol": "TASE:5110564",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ALTSHULER SHAHAM (0B) STOCKS FREE PORTFOLIO IL",
    "EnglishLongName": "ALTSHULER SHAHAM (0B) STOCKS FREE PORTFOLIO IL",
    "HebrewName": "אש תיק השקעות ללא מניות",
    "HebrewLongName": "אלטשולר שחם (0B) תיק השקעות ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.92,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 95.4,
    "MonthYield": 0.63,
    "YearYield": 0.63,
    "Last12MonthYield": 6.76,
    "ISIN": "IL0051105646"
  },
  {
    "Id": "TASE:5141288",
    "MayaId": "5141288",
    "Name": "AS T INDXX US BigData",
    "ShortName": "AS T INDXX US BigData",
    "Symbol": "TASE:5141288",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham Tracking (4D) INDXX US Big Data",
    "EnglishLongName": "Altshuler Shaham Tracking (4D) INDXX US Big Data",
    "HebrewName": "אש מחקה INDXX US BigData",
    "HebrewLongName": "אלטשולר שחם מחקה (4D)י INDXX US Big Data",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 0.3,
    "MonthYield": -3.55,
    "YearYield": -3.55,
    "Last12MonthYield": null,
    "ISIN": "IL0051412885"
  },
  {
    "Id": "TASE:5122080",
    "MayaId": "5122080",
    "Name": "AS TA 125 IL",
    "ShortName": "AS TA 125 IL",
    "Symbol": "TASE:5122080",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham (4A) TA 125 IL",
    "EnglishLongName": "Altshuler Shaham (4A) TA 125 IL",
    "HebrewName": "אש ת\"א 125",
    "HebrewLongName": "אלטשולר שחם (4A) ת\"א 125",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.5,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.04,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 170.5,
    "MonthYield": 7.67,
    "YearYield": 7.67,
    "Last12MonthYield": 59.2,
    "ISIN": "IL0051220809"
  },
  {
    "Id": "TASE:5102298",
    "MayaId": "5102298",
    "Name": "AS TA MidCap Stk Pick IL",
    "ShortName": "AS TA MidCap Stk Pick IL",
    "Symbol": "TASE:5102298",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ALTSHULER SHAHAM (4B) TA MID CAP STOCK PICKING IL",
    "EnglishLongName": "ALTSHULER SHAHAM (4B) TA MID CAP STOCK PICKING IL",
    "HebrewName": "אש ת\"א MidCap Stk Pick",
    "HebrewLongName": "אלטשולר שחם (4B) ת\"א MID CAP STOCK PICKING",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.5,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.29,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 302.8,
    "MonthYield": 3.73,
    "YearYield": 3.73,
    "Last12MonthYield": 50.47,
    "ISIN": "IL0051022981"
  },
  {
    "Id": "TASE:5141205",
    "MayaId": "5141205",
    "Name": "AS Tracking (4A) TA 125IL",
    "ShortName": "AS Tracking (4A) TA 125IL",
    "Symbol": "TASE:5141205",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham Tracking (4A) TA 125 IL",
    "EnglishLongName": "Altshuler Shaham Tracking (4A) TA 125 IL",
    "HebrewName": "אש מחקה (4A) ת\"א 125",
    "HebrewLongName": "אלטשולר שחם מחקה (4A) ת\"א 125",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 13.1,
    "MonthYield": 8.85,
    "YearYield": 8.85,
    "Last12MonthYield": null,
    "ISIN": "IL0051412059"
  },
  {
    "Id": "TASE:5141056",
    "MayaId": "5141056",
    "Name": "AS Tracking (4A) TA 90 IL",
    "ShortName": "AS Tracking (4A) TA 90 IL",
    "Symbol": "TASE:5141056",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham Tracking (4A) TA 90 IL",
    "EnglishLongName": "Altshuler Shaham Tracking (4A) TA 90 IL",
    "HebrewName": "אש מחקה (4A) ת\"א 90",
    "HebrewLongName": "אלטשולר שחם מחקה (4A) ת\"א 90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 1.6,
    "MonthYield": 7.35,
    "YearYield": 7.35,
    "Last12MonthYield": null,
    "ISIN": "IL0051410566"
  },
  {
    "Id": "TASE:5140645",
    "MayaId": "5140645",
    "Name": "AS Tracking AB US TET30",
    "ShortName": "AS Tracking AB US TET30",
    "Symbol": "TASE:5140645",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham Tracking (4D) A.B US Tech Ex Top 30",
    "EnglishLongName": "Altshuler Shaham Tracking (4D) A.B US Tech Ex Top 30",
    "HebrewName": "אש מחקה AB US TET30",
    "HebrewLongName": "אלטשולר שחם מחקה (4D)י A.B US Tech Ex Top 30",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 0.1,
    "MonthYield": -1.1,
    "YearYield": -1.1,
    "Last12MonthYield": null,
    "ISIN": "IL0051406457"
  },
  {
    "Id": "TASE:5140223",
    "MayaId": "5140223",
    "Name": "AS Tracking AB US TTET5",
    "ShortName": "AS Tracking AB US TTET5",
    "Symbol": "TASE:5140223",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham Tracking (4D) A.B US Top Tech Ex Top 5",
    "EnglishLongName": "Altshuler Shaham Tracking (4D) A.B US Top Tech Ex Top 5",
    "HebrewName": "אש מחקה AB US TTET5",
    "HebrewLongName": "אלטשולר שחם מחקה (4D)י A.B US Top Tech Ex Top 5",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.46,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 1.1,
    "MonthYield": 2.19,
    "YearYield": 2.19,
    "Last12MonthYield": null,
    "ISIN": "IL0051402233"
  },
  {
    "Id": "TASE:5138946",
    "MayaId": "5138946",
    "Name": "AS Tracking IdBTR DUT3 IL",
    "ShortName": "AS Tracking IdBTR DUT3 IL",
    "Symbol": "TASE:5138946",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham Tracking (00) Index Banks to Redempion - Duration up to 3 years",
    "EnglishLongName": "Altshuler Shaham Tracking (00) Index Banks to Redempion - Duration up to 3 years",
    "HebrewName": "אש מחקה אינ בנק ל.מחמ עד3",
    "HebrewLongName": "אלטשולר שחם מחקה (00) אינדקס בנקים לפדיון - מח\"מ עד 3 שנים",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.17,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 5.9,
    "MonthYield": 0.16,
    "YearYield": 0.16,
    "Last12MonthYield": 5.37,
    "ISIN": "IL0051389463"
  },
  {
    "Id": "TASE:5140652",
    "MayaId": "5140652",
    "Name": "AS Tracking IL AAA CPLink",
    "ShortName": "AS Tracking IL AAA CPLink",
    "Symbol": "TASE:5140652",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham Tracking (00) Index AAA CPI-Linked IL",
    "EnglishLongName": "Altshuler Shaham Tracking (00) Index AAA CPI-Linked IL",
    "HebrewName": "אש מחקה אינדקס AAA שקלי",
    "HebrewLongName": "אלטשולר שחם מחקה (00) אינדקס AAA שקלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "",
    "AssetValue": 2.3,
    "MonthYield": 0.62,
    "YearYield": 0.62,
    "Last12MonthYield": null,
    "ISIN": "IL0051406523"
  },
  {
    "Id": "TASE:5141239",
    "MayaId": "5141239",
    "Name": "AS Tracking IL Banks A.B",
    "ShortName": "AS Tracking IL Banks A.B",
    "Symbol": "TASE:5141239",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham Tracking (4A) A.B Banks In Israel",
    "EnglishLongName": "Altshuler Shaham Tracking (4A) A.B Banks In Israel",
    "HebrewName": "אש מחקה בנקים בישראל A.B",
    "HebrewLongName": "אלטשולר שחם מחקה (4A) בנקים בישראל A.B",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 0.6,
    "MonthYield": 9.34,
    "YearYield": 9.34,
    "Last12MonthYield": null,
    "ISIN": "IL0051412398"
  },
  {
    "Id": "TASE:5140660",
    "MayaId": "5140660",
    "Name": "AS Tracking IL Inv&Trd Ma",
    "ShortName": "AS Tracking IL Inv&Trd Ma",
    "Symbol": "TASE:5140660",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham Tracking (4A) Investment Management & Trading Company Index IL",
    "EnglishLongName": "Altshuler Shaham Tracking (4A) Investment Management & Trading Company Index IL",
    "HebrewName": "אש מחקה אינדקס חב הש מס י",
    "HebrewLongName": "אלטשולר שחם מחקה (4A) אינדקס חברות ניהול השקעות ומסחר בישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 20.3,
    "MonthYield": 4.59,
    "YearYield": 4.59,
    "Last12MonthYield": null,
    "ISIN": "IL0051406606"
  },
  {
    "Id": "TASE:5138953",
    "MayaId": "5138953",
    "Name": "AS Tracking IndAAA CPI IL",
    "ShortName": "AS Tracking IndAAA CPI IL",
    "Symbol": "TASE:5138953",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham Tracking (00) Index AAA CPI IL",
    "EnglishLongName": "Altshuler Shaham Tracking (00) Index AAA CPI IL",
    "HebrewName": "אש מחקה אינדקס AAA צמוד",
    "HebrewLongName": "אלטשולר שחם מחקה (00) אינדקס AAA צמוד",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.27,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 67.7,
    "MonthYield": 0.17,
    "YearYield": 0.17,
    "Last12MonthYield": 6.09,
    "ISIN": "IL0051389539"
  },
  {
    "Id": "TASE:5139811",
    "MayaId": "5139811",
    "Name": "AS Tracking Nasdaq 100",
    "ShortName": "AS Tracking Nasdaq 100",
    "Symbol": "TASE:5139811",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham Tracking (4D) Nasdaq 100",
    "EnglishLongName": "Altshuler Shaham Tracking (4D) Nasdaq 100",
    "HebrewName": "אש מחקה Nasdaq 100",
    "HebrewLongName": "אלטשולר שחם מחקה (4D)י Nasdaq 100",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.87,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 37.3,
    "MonthYield": -0.2,
    "YearYield": -0.2,
    "Last12MonthYield": 5.53,
    "ISIN": "IL0051398118"
  },
  {
    "Id": "TASE:5141569",
    "MayaId": "5141569",
    "Name": "AS Tracking Nasdaq 100 CH",
    "ShortName": "AS Tracking Nasdaq 100 CH",
    "Symbol": "TASE:5141569",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham Tracking (4A) Nasdaq 100 Currency Hedged",
    "EnglishLongName": "Altshuler Shaham Tracking (4A) Nasdaq 100 Currency Hedged",
    "HebrewName": "אש מחקה Nasdaq 100 ממ",
    "HebrewLongName": "אלטשולר שחם מחקה (4A)י Nasdaq 100 מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.015,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 1.9,
    "MonthYield": 1.17,
    "YearYield": 1.17,
    "Last12MonthYield": null,
    "ISIN": "IL0051415698"
  },
  {
    "Id": "TASE:5141635",
    "MayaId": "5141635",
    "Name": "AS Tracking TBSkl 5 15 IL",
    "ShortName": "AS Tracking TBSkl 5-15 IL",
    "Symbol": "TASE:5141635",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham Tracking (00) Tel Bond-Shekel 5-15 IL",
    "EnglishLongName": "Altshuler Shaham Tracking (00) Tel Bond-Shekel 5-15 IL",
    "HebrewName": "אש מחקה תל בונד-שקלי 5-15",
    "HebrewLongName": "אלטשולר שחם מחקה (00) תל בונד-שקלי 5-15",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.015,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 0.2,
    "MonthYield": 1.23,
    "YearYield": 1.23,
    "Last12MonthYield": null,
    "ISIN": "IL0051416357"
  },
  {
    "Id": "TASE:5139126",
    "MayaId": "5139126",
    "Name": "AS Trck ! Ind UT A Bnd WS",
    "ShortName": "AS Trck ! Ind UT A Bnd WS",
    "Symbol": "TASE:5139126",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham Tracking (00)(!) Index Up To A BondS Wide Spread",
    "EnglishLongName": "Altshuler Shaham Tracking (00)(!) Index Up To A BondS Wide Spread",
    "HebrewName": "אש מחקה! אנ אגח עדA פ.רחב",
    "HebrewLongName": "אלטשולר שחם מחקה (00)(!) אינדקס אג\"ח עד A פיזור רחב",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.25,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Hi-risk Corporate & Convertibles",
    "AssetValue": 8.0,
    "MonthYield": 0.68,
    "YearYield": 0.68,
    "Last12MonthYield": 7.4,
    "ISIN": "IL0051391261"
  },
  {
    "Id": "TASE:5139118",
    "MayaId": "5139118",
    "Name": "AS Trcking NonLink Ind WS",
    "ShortName": "AS Trcking NonLink Ind WS",
    "Symbol": "TASE:5139118",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham Tracking (00) Non-Linked Index AAA-A Wide Spread",
    "EnglishLongName": "Altshuler Shaham Tracking (00) Non-Linked Index AAA-A Wide Spread",
    "HebrewName": "אש מחקה אינ שקל פיזור רחב",
    "HebrewLongName": "אלטשולר שחם מחקה (00) אינדקס שקלי A-AAA פיזור רחב",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.25,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 4.7,
    "MonthYield": 0.92,
    "YearYield": 0.92,
    "Last12MonthYield": 8.4,
    "ISIN": "IL0051391188"
  },
  {
    "Id": "TASE:5139134",
    "MayaId": "5139134",
    "Name": "AS Trk CPILinkIndAAA A WS",
    "ShortName": "AS Trk CPILinkIndAAA-A WS",
    "Symbol": "TASE:5139134",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham Tracking (00) CPI-Linked index AAA-A Wide spread",
    "EnglishLongName": "Altshuler Shaham Tracking (00) CPI-Linked index AAA-A Wide spread",
    "HebrewName": "אש מחקה אדק צמודA-AAA פ.ר",
    "HebrewLongName": "אלטשולר שחם מחקה (00) אינדקס צמוד A-AAA פיזור רחב",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.27,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 20.5,
    "MonthYield": 0.26,
    "YearYield": 0.26,
    "Last12MonthYield": 6.61,
    "ISIN": "IL0051391345"
  },
  {
    "Id": "TASE:5141064",
    "MayaId": "5141064",
    "Name": "AS Trk TelBdCPILi 1 3 IL",
    "ShortName": "AS Trk TelBdCPILi 1-3 IL",
    "Symbol": "TASE:5141064",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Altshuler Shaham Tracking (00) Tel Bond-CPI Linked 1-3 IL",
    "EnglishLongName": "Altshuler Shaham Tracking (00) Tel Bond-CPI Linked 1-3 IL",
    "HebrewName": "אש מחקה תלבונד-צמודות 1-3",
    "HebrewLongName": "אלטשולר שחם מחקה (00) תל בונד-צמודות 1-3",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ALTSHULER - SHAHAM MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 10.7,
    "MonthYield": 0.18,
    "YearYield": 0.18,
    "Last12MonthYield": null,
    "ISIN": "IL0051410640"
  },
  {
    "Id": "ARF.TA",
    "MayaId": "1198910",
    "Name": "ASHDOD REFINERY",
    "ShortName": "ASHDOD REFINERY LTD",
    "Symbol": "ARF.TA",
    "TaseSymbol": "ARF",
    "YahooId": "ARF.TA",
    "EnglishName": "ASHDOD REFINERY",
    "EnglishLongName": "ASHDOD REFINERY LTD",
    "HebrewName": "בזא",
    "HebrewLongName": "בית זיקוק אשדוד בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5839.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Energy And Oil & Gas Exploration",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.3,
    "YearYield": 1.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011989105"
  },
  {
    "Id": "ASHO.TA",
    "MayaId": "312017",
    "Name": "ASHOT",
    "ShortName": "ASHOT - ASHKELON INDUSTRIES LTD.",
    "Symbol": "ASHO.TA",
    "TaseSymbol": "ASHO",
    "YahooId": "ASHO.TA",
    "EnglishName": "ASHOT",
    "EnglishLongName": "ASHOT - ASHKELON INDUSTRIES LTD.",
    "HebrewName": "עשות",
    "HebrewLongName": "עשות - אשקלון תעשיות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 11720.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 44.1,
    "YearYield": 44.1,
    "Last12MonthYield": null,
    "ISIN": "IL0003120172"
  },
  {
    "Id": "ASHG.TA",
    "MayaId": "1132315",
    "Name": "ASHTROM GROUP",
    "ShortName": "ASHTROM GROUP LTD",
    "Symbol": "ASHG.TA",
    "TaseSymbol": "ASHG",
    "YahooId": "ASHG.TA",
    "EnglishName": "ASHTROM GROUP",
    "EnglishLongName": "ASHTROM GROUP LTD",
    "HebrewName": "אשטרום קבוצה",
    "HebrewLongName": "קבוצת אשטרום בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 7608.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 11.2,
    "YearYield": 11.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011323156"
  },
  {
    "Id": "ASGR.TA",
    "MayaId": "313015",
    "Name": "ASPEN GROUP",
    "ShortName": "ASPEN GROUP LTD.",
    "Symbol": "ASGR.TA",
    "TaseSymbol": "ASGR",
    "YahooId": "ASGR.TA",
    "EnglishName": "ASPEN GROUP",
    "EnglishLongName": "ASPEN GROUP LTD.",
    "HebrewName": "אספן גרופ",
    "HebrewLongName": "אספן גרופ בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 804.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 6.9,
    "YearYield": 6.9,
    "Last12MonthYield": null,
    "ISIN": "IL0003130155"
  },
  {
    "Id": "TASE:5128293",
    "MayaId": "5128293",
    "Name": "ATC FLEXIBLE",
    "ShortName": "ATC FLEXIBLE",
    "Symbol": "TASE:5128293",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Alfa Tech (4D) Flexible",
    "EnglishLongName": "Alfa Tech (4D) Flexible",
    "HebrewName": "אלפא טק גמישה",
    "HebrewLongName": "אלפא טק (4D) גמישה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.95,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.1,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 28.3,
    "MonthYield": -0.45,
    "YearYield": -0.45,
    "Last12MonthYield": -11.81,
    "ISIN": "IL0051282932"
  },
  {
    "Id": "TASE:5135975",
    "MayaId": "5135975",
    "Name": "ATF Banks & Gove Bonds IL",
    "ShortName": "ATF Banks & Gove Bonds IL",
    "Symbol": "TASE:5135975",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ATF (00) iNDEX Banks & Government Companies Bonds IL",
    "EnglishLongName": "ATF (00) iNDEX Banks & Government Companies Bonds IL",
    "HebrewName": "ATF מחקה אגח בנקיםוממשלתי",
    "HebrewLongName": "ATF מחקה (00) אינדקס אג\"ח בנקים וחב' ממשלתיות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 151.7,
    "MonthYield": 0.23,
    "YearYield": 0.23,
    "Last12MonthYield": 5.99,
    "ISIN": "IL0051359755"
  },
  {
    "Id": "TASE:5136676",
    "MayaId": "5136676",
    "Name": "ATF Composite 75/25 M IL",
    "ShortName": "ATF Composite 75/25 M IL",
    "Symbol": "TASE:5136676",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ATF (2B) Composite iNDEX Bonds (75%) Equity (25%) Monthly IL",
    "EnglishLongName": "ATF (2B) Composite iNDEX Bonds (75%) Equity (25%) Monthly IL",
    "HebrewName": "ATF מחקה משולבת 25/75חודש",
    "HebrewLongName": "ATF מחקה (2B) משולבת אינדקס מנגנון אג\"ח (75%) מניות (25%) חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.29,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.46,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Composite Bonds",
    "SecondaryClassification": "up to 30% Equity",
    "AssetValue": 11.3,
    "MonthYield": 1.75,
    "YearYield": 1.75,
    "Last12MonthYield": 13.22,
    "ISIN": "IL0051366768"
  },
  {
    "Id": "TASE:5133905",
    "MayaId": "5133905",
    "Name": "ATF Corp Bonds EW T100 IL",
    "ShortName": "ATF Corp Bonds EW T100 IL",
    "Symbol": "TASE:5133905",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ATF (00) iNDEX Israeli Corp Bonds TOP100 – EW IL",
    "EnglishLongName": "ATF (00) iNDEX Israeli Corp Bonds TOP100 – EW IL",
    "HebrewName": "ATF מחקה אג\"ח TOP 100 EW",
    "HebrewLongName": "ATF מחקה (00) אינדקס אג\"ח חברות ישראל EW TOP 100",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.31,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 126.8,
    "MonthYield": 0.4,
    "YearYield": 0.4,
    "Last12MonthYield": 7.05,
    "ISIN": "IL0051339054"
  },
  {
    "Id": "ANLT-F2.TA",
    "MayaId": "1218924",
    "Name": "ATF ETF (4A) S&P 500 Currency Hedged",
    "ShortName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT 1986 LTD",
    "Symbol": "ANLT-F2.TA",
    "TaseSymbol": "ANLT.F2",
    "YahooId": "ANLT-F2.TA",
    "EnglishName": "ATF ETF SP500CH",
    "EnglishLongName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT 1986 LTD",
    "HebrewName": "ATF סל SP500 מנ",
    "HebrewLongName": "אנליסט אי.אמ.אס ניהול קרנות בנאמנות (1986) בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.008,
    "VariableFee": 0.2,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 6823.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "ANALYST",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": -0.3,
    "YearYield": -0.3,
    "Last12MonthYield": null,
    "ISIN": "IL0012189242"
  },
  {
    "Id": "ANLT-F1.TA",
    "MayaId": "1218916",
    "Name": "ATF ETF (4D) S&P 500",
    "ShortName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT 1986 LTD",
    "Symbol": "ANLT-F1.TA",
    "TaseSymbol": "ANLT.F1",
    "YahooId": "ANLT-F1.TA",
    "EnglishName": "ATF ETF S&P 500",
    "EnglishLongName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT 1986 LTD",
    "HebrewName": "ATF סל P 500&S",
    "HebrewLongName": "אנליסט אי.אמ.אס ניהול קרנות בנאמנות (1986) בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.008,
    "VariableFee": 0.2,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5800.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "ANALYST",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": -0.9,
    "YearYield": -0.9,
    "Last12MonthYield": null,
    "ISIN": "IL0012189168"
  },
  {
    "Id": "TASE:5133236",
    "MayaId": "5133236",
    "Name": "ATF Isr Bank & Insuran IL",
    "ShortName": "ATF Isr Bank & Insuran IL",
    "Symbol": "TASE:5133236",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ATF (40) iNDEX Israel Banks & Insurance Index IL",
    "EnglishLongName": "ATF (40) iNDEX Israel Banks & Insurance Index IL",
    "HebrewName": "ATF מחקה בנקים וביטוח יש",
    "HebrewLongName": "ATF מחקה (40) אינדקס בנקים וביטוח ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.67,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 618.3,
    "MonthYield": 8.33,
    "YearYield": 8.33,
    "Last12MonthYield": 107.19,
    "ISIN": "IL0051332364"
  },
  {
    "Id": "TASE:5139175",
    "MayaId": "5139175",
    "Name": "ATF Israel Banks iNDEX IL",
    "ShortName": "ATF Israel Banks iNDEX IL",
    "Symbol": "TASE:5139175",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ATF (4A) iNDEX Israeli Banks IL",
    "EnglishLongName": "ATF (4A) iNDEX Israeli Banks IL",
    "HebrewName": "ATF מח אינדקס בנקים ישראל",
    "HebrewLongName": "ATF מחקה (4A) אינדקס בנקים ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.45,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.98,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 265.1,
    "MonthYield": 9.42,
    "YearYield": 9.42,
    "Last12MonthYield": 71.09,
    "ISIN": "IL0051391758"
  },
  {
    "Id": "TASE:5137997",
    "MayaId": "5137997",
    "Name": "ATF Non Link Long Bond IL",
    "ShortName": "ATF Non-Link Long Bond IL",
    "Symbol": "TASE:5137997",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ATF (00) iNDEX Israeli Non-Linked Long Bonds up to 20% gov IL",
    "EnglishLongName": "ATF (00) iNDEX Israeli Non-Linked Long Bonds up to 20% gov IL",
    "HebrewName": "ATF מחקה שקלים ארוכיםעד20",
    "HebrewLongName": "ATF מחקה (00) אינדקס שקלים ארוכים עד 20% מדינה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.66,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 272.8,
    "MonthYield": 1.38,
    "YearYield": 1.38,
    "Last12MonthYield": 11.88,
    "ISIN": "IL0051379977"
  },
  {
    "Id": "TASE:5138359",
    "MayaId": "5138359",
    "Name": "ATF Spread EWTop100 Du IL",
    "ShortName": "ATF Spread EWTop100 Du IL",
    "Symbol": "TASE:5138359",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ATF (00) iNDEX Israeli Bonds Dur Above Average Spread Adjusted Top100 EW IL",
    "EnglishLongName": "ATF (00) iNDEX Israeli Bonds Dur Above Average Spread Adjusted Top100 EW IL",
    "HebrewName": "ATF מחקה מרווח מעל הממוצע",
    "HebrewLongName": "ATF מחקה (00) אינדקס EW TOP100 מרווח מעל הממוצע מותאם מח\"מ",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 68.2,
    "MonthYield": 0.69,
    "YearYield": 0.69,
    "Last12MonthYield": 8.1,
    "ISIN": "IL0051383599"
  },
  {
    "Id": "TASE:5135165",
    "MayaId": "5135165",
    "Name": "ATF TA 125 SecMomentum IL",
    "ShortName": "ATF TA-125 SecMomentum IL",
    "Symbol": "TASE:5135165",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ATF (4A) iNDEX TA-125 Sector Momentum IL",
    "EnglishLongName": "ATF (4A) iNDEX TA-125 Sector Momentum IL",
    "HebrewName": "ATF מחקה ת\"א-125 מומנטוםע",
    "HebrewLongName": "ATF מחקה (4A) אינדקס ת\"א-125 מומנטום ענפי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.21,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 78.8,
    "MonthYield": 8.71,
    "YearYield": 8.71,
    "Last12MonthYield": 65.41,
    "ISIN": "IL0051351653"
  },
  {
    "Id": "TASE:5139936",
    "MayaId": "5139936",
    "Name": "ATF TA 20 IL",
    "ShortName": "ATF TA-20 IL",
    "Symbol": "TASE:5139936",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ATF (4A) TA-20 IL",
    "EnglishLongName": "ATF (4A) TA-20 IL",
    "HebrewName": "ATF מחקה ת\"א-20",
    "HebrewLongName": "ATF מחקה (4A) ת\"א-20",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.015,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.96,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 5.2,
    "MonthYield": 9.35,
    "YearYield": 9.35,
    "Last12MonthYield": null,
    "ISIN": "IL0051399363"
  },
  {
    "Id": "TASE:5139951",
    "MayaId": "5139951",
    "Name": "ATF TA 200 IL",
    "ShortName": "ATF TA-200 IL",
    "Symbol": "TASE:5139951",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ATF (4A) TA-200 IL",
    "EnglishLongName": "ATF (4A) TA-200 IL",
    "HebrewName": "ATF מחקה ת\"א-200",
    "HebrewLongName": "ATF מחקה (4A) ת\"א-200",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.015,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.59,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 46.1,
    "MonthYield": 7.54,
    "YearYield": 7.54,
    "Last12MonthYield": null,
    "ISIN": "IL0051399512"
  },
  {
    "Id": "TASE:5139944",
    "MayaId": "5139944",
    "Name": "ATF TA 50 Real IL",
    "ShortName": "ATF TA-50 Real IL",
    "Symbol": "TASE:5139944",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ATF (4A) TA-50 Real IL",
    "EnglishLongName": "ATF (4A) TA-50 Real IL",
    "HebrewName": "ATF מחקה ת\"א-50 ריאלי",
    "HebrewLongName": "ATF מחקה (4A) ת\"א-50 ריאלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.015,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.08,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 5.4,
    "MonthYield": 7.86,
    "YearYield": 7.86,
    "Last12MonthYield": null,
    "ISIN": "IL0051399447"
  },
  {
    "Id": "TASE:5140124",
    "MayaId": "5140124",
    "Name": "ATF Tel Bond Yield CPI IL",
    "ShortName": "ATF Tel Bond Yield CPI IL",
    "Symbol": "TASE:5140124",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ATF (00)(!) Tel Bond Yields CPI Linked IL",
    "EnglishLongName": "ATF (00)(!) Tel Bond Yields CPI Linked IL",
    "HebrewName": "ATF תל בונדתשואות צמודות",
    "HebrewLongName": "ATF מחקה (00)(!) תל בונד-תשואות צמודות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 90.6,
    "MonthYield": 0.17,
    "YearYield": 0.17,
    "Last12MonthYield": null,
    "ISIN": "IL0051401243"
  },
  {
    "Id": "TASE:5140116",
    "MayaId": "5140116",
    "Name": "ATF Tel BondCPI Link A IL",
    "ShortName": "ATF Tel BondCPI Link A IL",
    "Symbol": "TASE:5140116",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ATF (00) Tel Bond-CPI Linked A IL",
    "EnglishLongName": "ATF (00) Tel Bond-CPI Linked A IL",
    "HebrewName": "ATF תל בונד-צמודות A",
    "HebrewLongName": "ATF מחקה (00) תל בונד-צמודות A",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 1.7,
    "MonthYield": 0.21,
    "YearYield": 0.21,
    "Last12MonthYield": null,
    "ISIN": "IL0051401169"
  },
  {
    "Id": "TASE:5141817",
    "MayaId": "5141817",
    "Name": "ATF US Bond–Dynmic Dur CH",
    "ShortName": "ATF US Bond–Dynmic Dur CH",
    "Symbol": "TASE:5141817",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ATF (0A) Index US Treasury Bonds – Dynamic Duration Currency Hedged",
    "EnglishLongName": "ATF (0A) Index US Treasury Bonds – Dynamic Duration Currency Hedged",
    "HebrewName": "ATF ממשל ארהב-מחמ דינמי מ",
    "HebrewLongName": "ATF מחקה (0A) אינדקס אג\"ח ממשלת ארה\"ב - מח\"מ דינמי מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Hedged Government - Long",
    "AssetValue": 0.7,
    "MonthYield": 0.87,
    "YearYield": 0.87,
    "Last12MonthYield": null,
    "ISIN": "IL0051418171"
  },
  {
    "Id": "TASE:5136775",
    "MayaId": "5136775",
    "Name": "ATF US MomentumLC Hedged",
    "ShortName": "ATF US MomentumLC Hedged",
    "Symbol": "TASE:5136775",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ATF (4A) iNDEX US Large Cap Sector Momentum Currency Hedged",
    "EnglishLongName": "ATF (4A) iNDEX US Large Cap Sector Momentum Currency Hedged",
    "HebrewName": "ATF מניות מומנטוםUSמנוטרל",
    "HebrewLongName": "ATF מחקה (4A) אינדקס מניות ארה\"ב Large Cap מומנטום ענפי מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.69,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 146.7,
    "MonthYield": -0.18,
    "YearYield": -0.18,
    "Last12MonthYield": 9.65,
    "ISIN": "IL0051367758"
  },
  {
    "Id": "TASE:5137336",
    "MayaId": "5137336",
    "Name": "ATF USLarge Momentum USD",
    "ShortName": "ATF USLarge Momentum USD",
    "Symbol": "TASE:5137336",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ATF (4D) iNDEX US Large Cap Sector Momentum",
    "EnglishLongName": "ATF (4D) iNDEX US Large Cap Sector Momentum",
    "HebrewName": "ATF מחקה מניות ארה\"ב חשוף",
    "HebrewLongName": "ATF מחקה (4D) אינדקס מניות ארה\"ב Large Cap מומנטום ענפי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.64,
    "Sector": "",
    "Industry": "",
    "ManagerName": "ANALYST I.M.S MUTUAL FUNDS MANAGEMENT (1986) LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 72.7,
    "MonthYield": -1.54,
    "YearYield": -1.54,
    "Last12MonthYield": -3.89,
    "ISIN": "IL0051373368"
  },
  {
    "Id": "ATRY.TA",
    "MayaId": "1096106",
    "Name": "ATREYU CAP",
    "ShortName": "ATREYU CAPITAL MARKETS LTD",
    "Symbol": "ATRY.TA",
    "TaseSymbol": "ATRY",
    "YahooId": "ATRY.TA",
    "EnglishName": "ATREYU CAP",
    "EnglishLongName": "ATREYU CAPITAL MARKETS LTD",
    "HebrewName": "אטראו שוקי הון",
    "HebrewLongName": "אטראו שוקי הון בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 8282.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Financial Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -2.9,
    "YearYield": -2.9,
    "Last12MonthYield": null,
    "ISIN": "IL0010961063"
  },
  {
    "Id": "AUDC.TA",
    "MayaId": "1082965",
    "Name": "AUDIOCODES",
    "ShortName": "AUDIOCODES LTD.",
    "Symbol": "AUDC.TA",
    "TaseSymbol": "AUDC",
    "YahooId": "AUDC.TA",
    "EnglishName": "AUDIOCODES",
    "EnglishLongName": "AUDIOCODES LTD.",
    "HebrewName": "אודיוקודס",
    "HebrewLongName": "אודיוקודס בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2590.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -6.1,
    "YearYield": -6.1,
    "Last12MonthYield": null,
    "ISIN": "IL0010829658"
  },
  {
    "Id": "AUGN.TA",
    "MayaId": "1105907",
    "Name": "AUGWIND",
    "ShortName": "AUGWIND ENERGY TECH STORAGE LTD",
    "Symbol": "AUGN.TA",
    "TaseSymbol": "AUGN",
    "YahooId": "AUGN.TA",
    "EnglishName": "AUGWIND",
    "EnglishLongName": "AUGWIND ENERGY TECH STORAGE LTD",
    "HebrewName": "אוגווינד",
    "HebrewLongName": "אוגווינד אנרגיה טק אחסון בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 379.8,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -5.8,
    "YearYield": -5.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011059073"
  },
  {
    "Id": "AURA.TA",
    "MayaId": "373019",
    "Name": "AURA",
    "ShortName": "AURA INVESTMENTS LTD.",
    "Symbol": "AURA.TA",
    "TaseSymbol": "AURA",
    "YahooId": "AURA.TA",
    "EnglishName": "AURA",
    "EnglishLongName": "AURA INVESTMENTS LTD.",
    "HebrewName": "אאורה",
    "HebrewLongName": "אאורה השקעות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2391.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 21.3,
    "YearYield": 21.3,
    "Last12MonthYield": null,
    "ISIN": "IL0003730194"
  },
  {
    "Id": "AUSA-M.TA",
    "MayaId": "1176619",
    "Name": "AURA SMART M",
    "ShortName": "AURA SMART AIR LTD",
    "Symbol": "AUSA-M.TA",
    "TaseSymbol": "AUSA-M",
    "YahooId": "AUSA-M.TA",
    "EnglishName": "AURA SMART-M",
    "EnglishLongName": "AURA SMART AIR LTD",
    "HebrewName": "אורה סמארט-ש",
    "HebrewLongName": "אורה סמארט אייר בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 67.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -41.1,
    "YearYield": -41.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011766198"
  },
  {
    "Id": "AUIS.TA",
    "MayaId": "1080522",
    "Name": "AUSTRALIA ISR",
    "ShortName": "E.S. AUSTRALIA ISRAEL HOLDINGS LTD",
    "Symbol": "AUIS.TA",
    "TaseSymbol": "AUIS",
    "YahooId": "AUIS.TA",
    "EnglishName": "AUSTRALIA ISR",
    "EnglishLongName": "E.S. AUSTRALIA ISRAEL HOLDINGS LTD",
    "HebrewName": "אוסטרליה ישראל",
    "HebrewLongName": "א.ש. אוסטרליה ישראל החזקות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1570.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -1.9,
    "YearYield": -1.9,
    "Last12MonthYield": null,
    "ISIN": "IL0010805229"
  },
  {
    "Id": "SHVA.TA",
    "MayaId": "1158161",
    "Name": "AUTO BANK SERV",
    "ShortName": "AUTOMATIC BANK SERVICES LIMITED",
    "Symbol": "SHVA.TA",
    "TaseSymbol": "SHVA",
    "YahooId": "SHVA.TA",
    "EnglishName": "AUTO BANK SERV",
    "EnglishLongName": "AUTOMATIC BANK SERVICES LIMITED",
    "HebrewName": "שירותי בנק אוטו",
    "HebrewLongName": "שירותי בנק אוטומטיים בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2305.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Financial Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 14.1,
    "YearYield": 14.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011581613"
  },
  {
    "Id": "AMX.TA",
    "MayaId": "1131697",
    "Name": "AUTOMAX",
    "ShortName": "AUTOMAX MOTORS LTD",
    "Symbol": "AMX.TA",
    "TaseSymbol": "AMX",
    "YahooId": "AMX.TA",
    "EnglishName": "AUTOMAX",
    "EnglishLongName": "AUTOMAX MOTORS LTD",
    "HebrewName": "אוטומקס",
    "HebrewLongName": "אוטומקס מוטורס בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 10.8,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.0,
    "YearYield": 0.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011316978"
  },
  {
    "Id": "AGRD.TA",
    "MayaId": "1083419",
    "Name": "AUTONOMOUS",
    "ShortName": "AUTONOMOUS GUARD LTD",
    "Symbol": "AGRD.TA",
    "TaseSymbol": "AGRD",
    "YahooId": "AGRD.TA",
    "EnglishName": "AUTONOMOUS",
    "EnglishLongName": "AUTONOMOUS GUARD LTD",
    "HebrewName": "אוטונומוס",
    "HebrewLongName": "אוטונומוס גארד בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1321.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 8.8,
    "YearYield": 8.8,
    "Last12MonthYield": null,
    "ISIN": "IL0010834195"
  },
  {
    "Id": "AVER.TA",
    "MayaId": "675017",
    "Name": "AVERBUCH",
    "ShortName": "AVERBUCH FORMICA CENTER LTD.",
    "Symbol": "AVER.TA",
    "TaseSymbol": "AVER",
    "YahooId": "AVER.TA",
    "EnglishName": "AVERBUCH",
    "EnglishLongName": "AVERBUCH FORMICA CENTER LTD.",
    "HebrewName": "אברבוך",
    "HebrewLongName": "מרכז הפורמיקה אברבוך בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1435.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 9.4,
    "YearYield": 9.4,
    "Last12MonthYield": null,
    "ISIN": "IL0006750173"
  },
  {
    "Id": "AVGD.TA",
    "MayaId": "1171818",
    "Name": "AVGAD",
    "ShortName": "AV-GAD HOLDINGS LTD",
    "Symbol": "AVGD.TA",
    "TaseSymbol": "AVGD",
    "YahooId": "AVGD.TA",
    "EnglishName": "AVGAD",
    "EnglishLongName": "AV-GAD HOLDINGS LTD",
    "HebrewName": "אב-גד",
    "HebrewLongName": "אב-גד החזקות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1770.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 9.9,
    "YearYield": 9.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011718181"
  },
  {
    "Id": "AVGL.TA",
    "MayaId": "1100957",
    "Name": "AVGOL",
    "ShortName": "AVGOL INDUSTRIES 1953 LTD.",
    "Symbol": "AVGL.TA",
    "TaseSymbol": "AVGL",
    "YahooId": "AVGL.TA",
    "EnglishName": "AVGOL",
    "EnglishLongName": "AVGOL INDUSTRIES 1953 LTD.",
    "HebrewName": "אבגול",
    "HebrewLongName": "אבגול תעשיות 1953 בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 130.1,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -0.1,
    "YearYield": -0.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011009573"
  },
  {
    "Id": "AVIA.TA",
    "MayaId": "413013",
    "Name": "AVIATION LINKS",
    "ShortName": "AVIATION LINKS LTD.",
    "Symbol": "AVIA.TA",
    "TaseSymbol": "AVIA",
    "YahooId": "AVIA.TA",
    "EnglishName": "AVIATION LINKS",
    "EnglishLongName": "AVIATION LINKS LTD.",
    "HebrewName": "קשרי תעופה",
    "HebrewLongName": "קשרי תעופה בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1970.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 11.3,
    "YearYield": 11.3,
    "Last12MonthYield": null,
    "ISIN": "IL0004130139"
  },
  {
    "Id": "AVIV.TA",
    "MayaId": "444018",
    "Name": "AVIV",
    "ShortName": "MORDECHAI AVIV TAASIOT BENIYAH (1973) LTD.",
    "Symbol": "AVIV.TA",
    "TaseSymbol": "AVIV",
    "YahooId": "AVIV.TA",
    "EnglishName": "AVIV",
    "EnglishLongName": "MORDECHAI AVIV TAASIOT BENIYAH (1973) LTD.",
    "HebrewName": "אביב בניה",
    "HebrewLongName": "מרדכי אביב תעשיות בניה (1973) בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2193.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 5.2,
    "YearYield": 5.2,
    "Last12MonthYield": null,
    "ISIN": "IL0004440181"
  },
  {
    "Id": "TASE:5140371",
    "MayaId": "5140371",
    "Name": "Aviv 90/10 ESG M Pt Kr IL",
    "ShortName": "Aviv 90/10 ESG M Pt Kr IL",
    "Symbol": "TASE:5140371",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Aviv (1B) 90/10 ESG Model Portfolio Kosher IL",
    "EnglishLongName": "Aviv (1B) 90/10 ESG Model Portfolio Kosher IL",
    "HebrewName": "אביב 10/90 תיק מ ESG כשרה",
    "HebrewLongName": "אביב (1B)י 10/90 תיק מודל ESG כשרה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.87,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 21.9,
    "MonthYield": 1.06,
    "YearYield": 1.06,
    "Last12MonthYield": null,
    "ISIN": "IL0051403710"
  },
  {
    "Id": "TASE:5135553",
    "MayaId": "5135553",
    "Name": "Aviv ESG C Bond Kosher IL",
    "ShortName": "Aviv ESG C Bond Kosher IL",
    "Symbol": "TASE:5135553",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Aviv (0A) ESG Corporate Bonds Kosher IL",
    "EnglishLongName": "Aviv (0A) ESG Corporate Bonds Kosher IL",
    "HebrewName": "אביב אג\"ח חברות ESG כשרה",
    "HebrewLongName": "אביב (0A) אג\"ח חברות ESG כשרה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.045,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.27,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 55.2,
    "MonthYield": 0.47,
    "YearYield": 0.47,
    "Last12MonthYield": 6.26,
    "ISIN": "IL0051355530"
  },
  {
    "Id": "TASE:5135546",
    "MayaId": "5135546",
    "Name": "Aviv ESG Equity IL",
    "ShortName": "Aviv ESG Equity IL",
    "Symbol": "TASE:5135546",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Aviv (4B) ESG Equity IL",
    "EnglishLongName": "Aviv (4B) ESG Equity IL",
    "HebrewName": "אביב ESG מניות ישראל",
    "HebrewLongName": "אביב (4B)י ESG מניות ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.95,
    "TrusteeFee": 0.045,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.92,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 31.4,
    "MonthYield": 9.21,
    "YearYield": 9.21,
    "Last12MonthYield": 46.98,
    "ISIN": "IL0051355464"
  },
  {
    "Id": "TASE:5135520",
    "MayaId": "5135520",
    "Name": "Aviv ESG Equity Kosher IL",
    "ShortName": "Aviv ESG Equity Kosher IL",
    "Symbol": "TASE:5135520",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Aviv (4B) ESG Equity Kosher IL",
    "EnglishLongName": "Aviv (4B) ESG Equity Kosher IL",
    "HebrewName": "אביב מניות ישראל ESG כשרה",
    "HebrewLongName": "אביב (4B) מניות ישראל ESG כשרה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.95,
    "TrusteeFee": 0.045,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.92,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 73.3,
    "MonthYield": 8.72,
    "YearYield": 8.72,
    "Last12MonthYield": 43.65,
    "ISIN": "IL0051355209"
  },
  {
    "Id": "TASE:5135512",
    "MayaId": "5135512",
    "Name": "Aviv Global Equity Kosher",
    "ShortName": "Aviv Global Equity Kosher",
    "Symbol": "TASE:5135512",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Aviv (4D) Global Equity Kosher",
    "EnglishLongName": "Aviv (4D) Global Equity Kosher",
    "HebrewName": "אביב מניות גלובלי כשרה",
    "HebrewLongName": "אביב (4D) מניות גלובלי כשרה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.95,
    "TrusteeFee": 0.045,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.55,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 31.9,
    "MonthYield": 0.66,
    "YearYield": 0.66,
    "Last12MonthYield": 5.62,
    "ISIN": "IL0051355126"
  },
  {
    "Id": "TASE:5133186",
    "MayaId": "5133186",
    "Name": "Aviv Segev (4D) Flexible",
    "ShortName": "Aviv-Segev (4D) Flexible",
    "Symbol": "TASE:5133186",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Aviv - Segev (4D) Flexible",
    "EnglishLongName": "Aviv - Segev (4D) Flexible",
    "HebrewName": "אביב-שגב (4D) גמישה",
    "HebrewLongName": "אביב - שגב (4D) גמישה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.85,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.64,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 17.5,
    "MonthYield": 5.35,
    "YearYield": 5.35,
    "Last12MonthYield": 29.97,
    "ISIN": "IL0051331861"
  },
  {
    "Id": "TASE:5138920",
    "MayaId": "5138920",
    "Name": "Aviv Sgv In Prt M 80/20IL",
    "ShortName": "Aviv Sgv In Prt M 80/20IL",
    "Symbol": "TASE:5138920",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Aviv Segev (2A) Investment Portfolio Management 80/20 IL",
    "EnglishLongName": "Aviv Segev (2A) Investment Portfolio Management 80/20 IL",
    "HebrewName": "אביב שגב נ.תיק השקע 20/80",
    "HebrewLongName": "אביב שגב (2A) ניהול תיק השקעות 20/80",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.53,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.53,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 8.1,
    "MonthYield": 1.92,
    "YearYield": 1.92,
    "Last12MonthYield": 13.6,
    "ISIN": "IL0051389208"
  },
  {
    "Id": "TASE:5135538",
    "MayaId": "5135538",
    "Name": "Aviv80/20 ESG P Kosher IL",
    "ShortName": "Aviv80/20 ESG P Kosher IL",
    "Symbol": "TASE:5135538",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Aviv (2B) 80/20 ESG Portfolio Kosher IL",
    "EnglishLongName": "Aviv (2B) 80/20 ESG Portfolio Kosher IL",
    "HebrewName": "אביב 20/80 תיק ESG כשרה",
    "HebrewLongName": "אביב (2B)י 20/80 תיק ESG כשרה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.93,
    "TrusteeFee": 0.045,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.52,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 19.3,
    "MonthYield": 1.93,
    "YearYield": 1.93,
    "Last12MonthYield": 12.7,
    "ISIN": "IL0051355381"
  },
  {
    "Id": "AVRT.TA",
    "MayaId": "297010",
    "Name": "AVROT",
    "ShortName": "AVROT INDUSTRIES LTD.",
    "Symbol": "AVRT.TA",
    "TaseSymbol": "AVRT",
    "YahooId": "AVRT.TA",
    "EnglishName": "AVROT",
    "EnglishLongName": "AVROT INDUSTRIES LTD.",
    "HebrewName": "אברות",
    "HebrewLongName": "אברות תעשיות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 50.7,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -1.7,
    "YearYield": -1.7,
    "Last12MonthYield": null,
    "ISIN": "IL0002970106"
  },
  {
    "Id": "AILN.TA",
    "MayaId": "383018",
    "Name": "AXILION",
    "ShortName": "AXILION SMART MOBILITY LTD",
    "Symbol": "AILN.TA",
    "TaseSymbol": "AILN",
    "YahooId": "AILN.TA",
    "EnglishName": "AXILION",
    "EnglishLongName": "AXILION SMART MOBILITY LTD",
    "HebrewName": "אקסיליון",
    "HebrewLongName": "אקסיליון תחבורה חכמה בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 24.5,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.4,
    "YearYield": 0.4,
    "Last12MonthYield": null,
    "ISIN": "IL0003830184"
  },
  {
    "Id": "TASE:5107883",
    "MayaId": "5107883",
    "Name": "Axioma (2B)' 70/30",
    "ShortName": "Axioma (2B)' 70/30",
    "Symbol": "TASE:5107883",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Axioma (2B)' 70/30 IL",
    "EnglishLongName": "Axioma (2B)' 70/30 IL",
    "HebrewName": "אקסיומה 30/70",
    "HebrewLongName": "אקסיומה (2B)י 30/70",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.5,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 121.2,
    "MonthYield": 1.79,
    "YearYield": 1.79,
    "Last12MonthYield": 15.81,
    "ISIN": "IL0051078835"
  },
  {
    "Id": "TASE:5108774",
    "MayaId": "5108774",
    "Name": "Axioma Rated BondsWithout",
    "ShortName": "Axioma Rated BondsWithout",
    "Symbol": "TASE:5108774",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Axioma (0B) Rated Bonds Without Stocks IL",
    "EnglishLongName": "Axioma (0B) Rated Bonds Without Stocks IL",
    "HebrewName": "אקסיומה אגח מדורג ללא מנ",
    "HebrewLongName": "אקסיומה (0B) אג\"ח מדורג ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.24,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 697.4,
    "MonthYield": 0.51,
    "YearYield": 0.51,
    "Last12MonthYield": 6.76,
    "ISIN": "IL0051087745"
  },
  {
    "Id": "TASE:5108865",
    "MayaId": "5108865",
    "Name": "Axioma Stocks Select 125",
    "ShortName": "Axioma Stocks Select 125",
    "Symbol": "TASE:5108865",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Axioma (4B) Stocks Selected TA 125 IL",
    "EnglishLongName": "Axioma (4B) Stocks Selected TA 125 IL",
    "HebrewName": "אקסיומה נבחרת מניות 125",
    "HebrewLongName": "אקסיומה (4B) נבחרת מניות ת\"א 125",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.38,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.31,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 21.7,
    "MonthYield": 9.12,
    "YearYield": 9.12,
    "Last12MonthYield": 70.41,
    "ISIN": "IL0051088651"
  },
  {
    "Id": "AXN.TA",
    "MayaId": "1227552",
    "Name": "AXON VISION",
    "ShortName": "AXON VISION LTD",
    "Symbol": "AXN.TA",
    "TaseSymbol": "AXN",
    "YahooId": "AXN.TA",
    "EnglishName": "AXON VISION",
    "EnglishLongName": "AXON VISION LTD",
    "HebrewName": "אקסון ויז'ן",
    "HebrewLongName": "אקסון ויז'ן בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1202.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 69.8,
    "YearYield": 69.8,
    "Last12MonthYield": null,
    "ISIN": "IL0012275520"
  },
  {
    "Id": "TASE:5123286",
    "MayaId": "5123286",
    "Name": "AYALIM 10/90 IL",
    "ShortName": "AYALIM 10/90 IL",
    "Symbol": "TASE:5123286",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALIM (1B) 10/90 IL",
    "EnglishLongName": "AYALIM (1B) 10/90 IL",
    "HebrewName": "אילים 10/90",
    "HebrewLongName": "אילים (1B)י 10/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.74,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.43,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALIM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 770.5,
    "MonthYield": 1.11,
    "YearYield": 1.11,
    "Last12MonthYield": 10.91,
    "ISIN": "IL0051232861"
  },
  {
    "Id": "TASE:5125794",
    "MayaId": "5125794",
    "Name": "AYALIM 20/80 IL",
    "ShortName": "AYALIM 20/80 IL",
    "Symbol": "TASE:5125794",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALIM (2A) 80/20 IL",
    "EnglishLongName": "AYALIM (2A) 80/20 IL",
    "HebrewName": "אילים 20/80",
    "HebrewLongName": "אילים (2A)י 20/80",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.55,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALIM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 2995.9,
    "MonthYield": 1.62,
    "YearYield": 1.62,
    "Last12MonthYield": 14.43,
    "ISIN": "IL0051257942"
  },
  {
    "Id": "TASE:5125729",
    "MayaId": "5125729",
    "Name": "AYALIM 30/70 IL",
    "ShortName": "AYALIM 30/70 IL",
    "Symbol": "TASE:5125729",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALIM (2C) 70/30 IL",
    "EnglishLongName": "AYALIM (2C) 70/30 IL",
    "HebrewName": "אילים 30/70",
    "HebrewLongName": "אילים (2C)י 30/70",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.8,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALIM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 530.7,
    "MonthYield": 2.12,
    "YearYield": 2.12,
    "Last12MonthYield": 17.54,
    "ISIN": "IL0051257298"
  },
  {
    "Id": "TASE:5125778",
    "MayaId": "5125778",
    "Name": "AYALIM 50/50 IL",
    "ShortName": "AYALIM 50/50 IL",
    "Symbol": "TASE:5125778",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALIM (3A) 50/50 IL",
    "EnglishLongName": "AYALIM (3A) 50/50 IL",
    "HebrewName": "אילים 50/50",
    "HebrewLongName": "אילים (3A)י 50/50",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.08,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALIM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - Max. Exposure over 30% Equity",
    "AssetValue": 106.4,
    "MonthYield": 2.88,
    "YearYield": 2.88,
    "Last12MonthYield": 25.02,
    "ISIN": "IL0051257785"
  },
  {
    "Id": "TASE:5138714",
    "MayaId": "5138714",
    "Name": "Ayalim 90\\10 global bonds",
    "ShortName": "Ayalim 90\\10 global bonds",
    "Symbol": "TASE:5138714",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalim (1D) 90\\10 portfolio global bonds & stocks",
    "EnglishLongName": "Ayalim (1D) 90\\10 portfolio global bonds & stocks",
    "HebrewName": "אילים 90\\10 תיק אג\"ח חו\"ל",
    "HebrewLongName": "אילים (1D)י 10/90 תיק אג\"ח חו\"ל ומניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.82,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALIM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Bond",
    "AssetValue": 26.0,
    "MonthYield": -0.67,
    "YearYield": -0.67,
    "Last12MonthYield": -2.78,
    "ISIN": "IL0051387145"
  },
  {
    "Id": "TASE:5137534",
    "MayaId": "5137534",
    "Name": "AYALIM AI EQUITY",
    "ShortName": "AYALIM AI EQUITY",
    "Symbol": "TASE:5137534",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALIM (4D) GLOBAL AI EQUITY",
    "EnglishLongName": "AYALIM (4D) GLOBAL AI EQUITY",
    "HebrewName": "אילים מניות AI",
    "HebrewLongName": "אילים (4D) מניות AI בינה מלאכותית חו\"ל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.52,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALIM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks by Sectors - Foreign",
    "AssetValue": 419.9,
    "MonthYield": 1.87,
    "YearYield": 1.87,
    "Last12MonthYield": 22.96,
    "ISIN": "IL0051375348"
  },
  {
    "Id": "TASE:5132303",
    "MayaId": "5132303",
    "Name": "Ayalim Bank Stocks IL",
    "ShortName": "Ayalim Bank Stocks IL",
    "Symbol": "TASE:5132303",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALIM (4B) BANK STOCKS IL",
    "EnglishLongName": "AYALIM (4B) BANK STOCKS IL",
    "HebrewName": "אילים מניות בנקים",
    "HebrewLongName": "אילים (4B) מניות בנקים",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.9,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALIM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sectors",
    "AssetValue": 436.3,
    "MonthYield": 8.85,
    "YearYield": 8.85,
    "Last12MonthYield": 67.91,
    "ISIN": "IL0051323033"
  },
  {
    "Id": "TASE:5114178",
    "MayaId": "5114178",
    "Name": "AYALIM BOND + SECURED",
    "ShortName": "AYALIM BOND + SECURED",
    "Symbol": "TASE:5114178",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALIM (0A) BOND + SECURED IL",
    "EnglishLongName": "AYALIM (0A) BOND + SECURED IL",
    "HebrewName": "אילים אגח+מגובה בביטחונות",
    "HebrewLongName": "אילים (0A) אג\"ח + מגובה בביטחונות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALIM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 137.1,
    "MonthYield": 0.65,
    "YearYield": 0.65,
    "Last12MonthYield": 7.2,
    "ISIN": "IL0051141781"
  },
  {
    "Id": "TASE:5126271",
    "MayaId": "5126271",
    "Name": "AYALIM Bonds +20% IL",
    "ShortName": "AYALIM Bonds +20% IL",
    "Symbol": "TASE:5126271",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalim (2B) Bonds Portfolio + 20% IL",
    "EnglishLongName": "Ayalim (2B) Bonds Portfolio + 20% IL",
    "HebrewName": "אילים אג\"ח +20%",
    "HebrewLongName": "אילים (2B) תיק אג\"ח + 20%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.72,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALIM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 71.0,
    "MonthYield": 2.01,
    "YearYield": 2.01,
    "Last12MonthYield": 15.5,
    "ISIN": "IL0051262710"
  },
  {
    "Id": "TASE:5100193",
    "MayaId": "5100193",
    "Name": "AYALIM BONDS +30% IL",
    "ShortName": "AYALIM BONDS +30% IL",
    "Symbol": "TASE:5100193",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALIM (2B) BONDS PORTFOLIO + 30% IL",
    "EnglishLongName": "AYALIM (2B) BONDS PORTFOLIO + 30% IL",
    "HebrewName": "אילים אג\"ח + 30%",
    "HebrewLongName": "אילים (2B) תיק אג\"ח + 30%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.83,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALIM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 176.8,
    "MonthYield": 2.39,
    "YearYield": 2.39,
    "Last12MonthYield": 22.2,
    "ISIN": "IL0051001936"
  },
  {
    "Id": "TASE:5109384",
    "MayaId": "5109384",
    "Name": "AYALIM BONDS NO STOCKS IL",
    "ShortName": "AYALIM BONDS NO STOCKS IL",
    "Symbol": "TASE:5109384",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALIM (0A)(!) Bonds Portfolio STOCKS FREE IL",
    "EnglishLongName": "AYALIM (0A)(!) Bonds Portfolio STOCKS FREE IL",
    "HebrewName": "אילים אג\"ח ללא מניות",
    "HebrewLongName": "אילים (0A)(!) תיק אג\"ח ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALIM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 424.4,
    "MonthYield": 0.96,
    "YearYield": 0.96,
    "Last12MonthYield": 7.79,
    "ISIN": "IL0051093842"
  },
  {
    "Id": "TASE:5134804",
    "MayaId": "5134804",
    "Name": "AYALIM CORPORATE BONDS IL",
    "ShortName": "AYALIM CORPORATE BONDS IL",
    "Symbol": "TASE:5134804",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALIM (0A)(!) CORPORATE BONDS IL",
    "EnglishLongName": "AYALIM (0A)(!) CORPORATE BONDS IL",
    "HebrewName": "אילים אג\"ח קונצרני",
    "HebrewLongName": "אילים (0A)(!) אג\"ח קונצרני",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALIM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 588.3,
    "MonthYield": 1.02,
    "YearYield": 1.02,
    "Last12MonthYield": 8.38,
    "ISIN": "IL0051348048"
  },
  {
    "Id": "TASE:5135595",
    "MayaId": "5135595",
    "Name": "Ayalim Floaters Bonds",
    "ShortName": "Ayalim Floaters Bonds",
    "Symbol": "TASE:5135595",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalim (0D) Floaters Bonds Liquidity Dollar",
    "EnglishLongName": "Ayalim (0D) Floaters Bonds Liquidity Dollar",
    "HebrewName": "אילים אג\"ח FLOATERS",
    "HebrewLongName": "אילים (0D) אג\"ח Floaters לנזילות דולרית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.14,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALIM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "Dollar Bond",
    "AssetValue": 12.9,
    "MonthYield": -1.14,
    "YearYield": -1.14,
    "Last12MonthYield": -9.19,
    "ISIN": "IL0051355951"
  },
  {
    "Id": "TASE:5125737",
    "MayaId": "5125737",
    "Name": "AYALIM FOLLOW TIK 2 IL",
    "ShortName": "AYALIM FOLLOW TIK 2 IL",
    "Symbol": "TASE:5125737",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALIM (2B) FOLLOWING PORTFOLIO NUMBER 2 – FIRST INTERNATIONAL BANK IL",
    "EnglishLongName": "AYALIM (2B) FOLLOWING PORTFOLIO NUMBER 2 – FIRST INTERNATIONAL BANK IL",
    "HebrewName": "אילים עוקבת תיק 2",
    "HebrewLongName": "אילים (2B) עוקבת תיק 2 הבנק הבינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.78,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALIM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 15% Equity",
    "AssetValue": 172.7,
    "MonthYield": 0.96,
    "YearYield": 0.96,
    "Last12MonthYield": 9.57,
    "ISIN": "IL0051257371"
  },
  {
    "Id": "TASE:5125745",
    "MayaId": "5125745",
    "Name": "AYALIM FOLLOW TIK 3 IL",
    "ShortName": "AYALIM FOLLOW TIK 3 IL",
    "Symbol": "TASE:5125745",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALIM (2C) FOLLOWING PORTFOLIO NUMBER 3 –FIRST INTERNATIONAL BANK IL",
    "EnglishLongName": "AYALIM (2C) FOLLOWING PORTFOLIO NUMBER 3 –FIRST INTERNATIONAL BANK IL",
    "HebrewName": "אילים עוקבת תיק 3",
    "HebrewLongName": "אילים (2C) עוקבת תיק 3 הבנק הבינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.78,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.52,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALIM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 74.8,
    "MonthYield": 1.33,
    "YearYield": 1.33,
    "Last12MonthYield": 10.85,
    "ISIN": "IL0051257454"
  },
  {
    "Id": "TASE:5136437",
    "MayaId": "5136437",
    "Name": "AYALIM fundoffunds 15% IL",
    "ShortName": "AYALIM fundoffunds 15% IL",
    "Symbol": "TASE:5136437",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALIM (2B) Israeli Fund Of Funds 15% Equities IL",
    "EnglishLongName": "AYALIM (2B) Israeli Fund Of Funds 15% Equities IL",
    "HebrewName": "אילים אגד ישראל 15% מניות",
    "HebrewLongName": "אילים (2B) אגד ישראלי עד 15% מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.42,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALIM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Fund of Funds",
    "SecondaryClassification": "Israeli Fund of Funds",
    "AssetValue": 220.3,
    "MonthYield": 1.52,
    "YearYield": 1.52,
    "Last12MonthYield": 12.54,
    "ISIN": "IL0051364375"
  },
  {
    "Id": "TASE:5136445",
    "MayaId": "5136445",
    "Name": "AYALIM fundoffunds 30% IL",
    "ShortName": "AYALIM fundoffunds 30% IL",
    "Symbol": "TASE:5136445",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALIM (2C) Israeli Fund Of Funds 30% Equities IL",
    "EnglishLongName": "AYALIM (2C) Israeli Fund Of Funds 30% Equities IL",
    "HebrewName": "אילים אגד ישראל 30% מניות",
    "HebrewLongName": "אילים (2C) אגד ישראלי עד 30% מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.69,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALIM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Fund of Funds",
    "SecondaryClassification": "Israeli Fund of Funds",
    "AssetValue": 262.7,
    "MonthYield": 2.21,
    "YearYield": 2.21,
    "Last12MonthYield": 17.96,
    "ISIN": "IL0051364458"
  },
  {
    "Id": "TASE:5141577",
    "MayaId": "5141577",
    "Name": "Ayalim Gov CPI Link + IL",
    "ShortName": "Ayalim Gov CPI-Link + IL",
    "Symbol": "TASE:5141577",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalim (1B) Government CPI-Linked Plus IL",
    "EnglishLongName": "Ayalim (1B) Government CPI-Linked Plus IL",
    "HebrewName": "אילים מדינה צמודה פלוס",
    "HebrewLongName": "אילים (1B) מדינה צמודה פלוס",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALIM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked Government Bonds - Up to 10% Equity",
    "AssetValue": 4.1,
    "MonthYield": 0.8,
    "YearYield": 0.8,
    "Last12MonthYield": null,
    "ISIN": "IL0051415771"
  },
  {
    "Id": "TASE:5105382",
    "MayaId": "5105382",
    "Name": "AYALIM GOVERNMENT+10% IL",
    "ShortName": "AYALIM GOVERNMENT+10% IL",
    "Symbol": "TASE:5105382",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALIM (1B) GOVERNMENT BOND + 10% IL",
    "EnglishLongName": "AYALIM (1B) GOVERNMENT BOND + 10% IL",
    "HebrewName": "אילים אג\"ח מדינה +10%",
    "HebrewLongName": "אילים (1B) אג\"ח מדינה + 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.43,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALIM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - up to 10% Equity",
    "AssetValue": 415.7,
    "MonthYield": 1.11,
    "YearYield": 1.11,
    "Last12MonthYield": 10.31,
    "ISIN": "IL0051053820"
  },
  {
    "Id": "TASE:5134176",
    "MayaId": "5134176",
    "Name": "Ayalim infrastructure IL",
    "ShortName": "Ayalim infrastructure IL",
    "Symbol": "TASE:5134176",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalim (4B) stocks infrastructure IL",
    "EnglishLongName": "Ayalim (4B) stocks infrastructure IL",
    "HebrewName": "אילים מניות תשתיות",
    "HebrewLongName": "אילים (4B) מניות תשתיות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.38,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALIM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sectors",
    "AssetValue": 218.9,
    "MonthYield": 4.35,
    "YearYield": 4.35,
    "Last12MonthYield": 56.79,
    "ISIN": "IL0051341761"
  },
  {
    "Id": "TASE:5140835",
    "MayaId": "5140835",
    "Name": "AYALIM Inves Grade Bonds",
    "ShortName": "AYALIM Inves Grade Bonds",
    "Symbol": "TASE:5140835",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALIM (0B) Investment Grade Bonds IL",
    "EnglishLongName": "AYALIM (0B) Investment Grade Bonds IL",
    "HebrewName": "אילים אג\"ח מדורגות",
    "HebrewLongName": "אילים (0B) אג\"ח מדורגות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALIM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 0.9,
    "MonthYield": 1.11,
    "YearYield": 1.11,
    "Last12MonthYield": null,
    "ISIN": "IL0051408354"
  },
  {
    "Id": "TASE:5138672",
    "MayaId": "5138672",
    "Name": "Ayalim Israel Stocks IL",
    "ShortName": "Ayalim Israel Stocks IL",
    "Symbol": "TASE:5138672",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalim (4B) Israel Stocks IL",
    "EnglishLongName": "Ayalim (4B) Israel Stocks IL",
    "HebrewName": "אילים מניות ישראל",
    "HebrewLongName": "אילים (4B) מניות ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.41,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALIM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 23.7,
    "MonthYield": 10.72,
    "YearYield": 10.72,
    "Last12MonthYield": 34.65,
    "ISIN": "IL0051386725"
  },
  {
    "Id": "TASE:5106810",
    "MayaId": "5106810",
    "Name": "AYALIM LARGE MID ISRAEL",
    "ShortName": "AYALIM LARGE MID ISRAEL",
    "Symbol": "TASE:5106810",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALIM (4B) SELECTED STOCKS LARGE & MID CAP ISRAEL",
    "EnglishLongName": "AYALIM (4B) SELECTED STOCKS LARGE & MID CAP ISRAEL",
    "HebrewName": "אילים LARGE MID CAP ישראל",
    "HebrewLongName": "אילים (4B) נבחרת מניות LARGE & MID CAP ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.05,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.21,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALIM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 2017.0,
    "MonthYield": 5.86,
    "YearYield": 5.86,
    "Last12MonthYield": 58.66,
    "ISIN": "IL0051068109"
  },
  {
    "Id": "TASE:5138680",
    "MayaId": "5138680",
    "Name": "Ayalim Portfolio+10% IL",
    "ShortName": "Ayalim Portfolio+10% IL",
    "Symbol": "TASE:5138680",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalim (1A) Bonds Portfolio+10% IL",
    "EnglishLongName": "Ayalim (1A) Bonds Portfolio+10% IL",
    "HebrewName": "אילים תיק אג\"ח +10%",
    "HebrewLongName": "אילים (1A) תיק אג\"ח +10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.57,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALIM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 69.1,
    "MonthYield": 1.17,
    "YearYield": 1.17,
    "Last12MonthYield": 12.42,
    "ISIN": "IL0051386808"
  },
  {
    "Id": "TASE:5126941",
    "MayaId": "5126941",
    "Name": "AYALIM SHIKLIT GOV PLUS",
    "ShortName": "AYALIM SHIKLIT GOV PLUS",
    "Symbol": "TASE:5126941",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALIM (1A) SHIKLIT GOVERNMENT PLUS IL",
    "EnglishLongName": "AYALIM (1A) SHIKLIT GOVERNMENT PLUS IL",
    "HebrewName": "אילים מדינה שקלית פלוס",
    "HebrewLongName": "אילים (1A) מדינה שקלית פלוס",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.53,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALIM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Shekel Bonds - Up to 10% Equity",
    "AssetValue": 146.6,
    "MonthYield": 1.23,
    "YearYield": 1.23,
    "Last12MonthYield": 11.56,
    "ISIN": "IL0051269418"
  },
  {
    "Id": "TASE:5136924",
    "MayaId": "5136924",
    "Name": "Ayalon $ Money Market",
    "ShortName": "Ayalon $ Money Market",
    "Symbol": "TASE:5136924",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalon (0D) Dollar Money Market",
    "EnglishLongName": "Ayalon (0D) Dollar Money Market",
    "HebrewName": "איילון כספית דולרית",
    "HebrewLongName": "איילון (0D) כספית דולרית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.005,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.17,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "FX Money Market with Corporate",
    "AssetValue": 38.1,
    "MonthYield": -1.24,
    "YearYield": -1.24,
    "Last12MonthYield": -9.98,
    "ISIN": "IL0051369242"
  },
  {
    "Id": "TASE:5117700",
    "MayaId": "5117700",
    "Name": "AYALON (00) MM FUND IL",
    "ShortName": "AYALON (00) MM FUND IL",
    "Symbol": "TASE:5117700",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALON (00) MONEY MARKET FUND IL",
    "EnglishLongName": "AYALON (00) MONEY MARKET FUND IL",
    "HebrewName": "איילון (00) כספית",
    "HebrewLongName": "איילון (00) כספית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.18,
    "TrusteeFee": 0.005,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 7580.1,
    "MonthYield": 0.2,
    "YearYield": 0.2,
    "Last12MonthYield": 4.73,
    "ISIN": "IL0051177009"
  },
  {
    "Id": "TASE:5112925",
    "MayaId": "5112925",
    "Name": "AYALON (2B) 20/80 IL",
    "ShortName": "AYALON (2B) 20/80 IL",
    "Symbol": "TASE:5112925",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALON (2B) 20/80 IL",
    "EnglishLongName": "AYALON (2B) 20/80 IL",
    "HebrewName": "איילון (2B)י 20/80",
    "HebrewLongName": "איילון (2B)י 20/80",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.57,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 55.2,
    "MonthYield": 2.45,
    "YearYield": 2.45,
    "Last12MonthYield": 13.6,
    "ISIN": "IL0051129257"
  },
  {
    "Id": "TASE:5103809",
    "MayaId": "5103809",
    "Name": "Ayalon (2B) 85/15 IL",
    "ShortName": "Ayalon (2B) 85/15 IL",
    "Symbol": "TASE:5103809",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalon (2B) 85/15 IL",
    "EnglishLongName": "Ayalon (2B) 85/15 IL",
    "HebrewName": "איילון (2B)י 15/85",
    "HebrewLongName": "איילון (2B)י 15/85",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.4,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 15% Equity",
    "AssetValue": 24.1,
    "MonthYield": 1.65,
    "YearYield": 1.65,
    "Last12MonthYield": 10.91,
    "ISIN": "IL0051038094"
  },
  {
    "Id": "TASE:5134523",
    "MayaId": "5134523",
    "Name": "Ayalon (2C) 70/30 IL",
    "ShortName": "Ayalon (2C) 70/30 IL",
    "Symbol": "TASE:5134523",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalon (2C) 70/30 IL",
    "EnglishLongName": "Ayalon (2C) 70/30 IL",
    "HebrewName": "איילון (2C)י 30/70",
    "HebrewLongName": "איילון (2C)י 30/70",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.73,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 6.9,
    "MonthYield": 2.83,
    "YearYield": 2.83,
    "Last12MonthYield": 17.39,
    "ISIN": "IL0051345234"
  },
  {
    "Id": "TASE:5133731",
    "MayaId": "5133731",
    "Name": "AYALON (4D) INVESTMENTS",
    "ShortName": "AYALON (4D) INVESTMENTS",
    "Symbol": "TASE:5133731",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALON (4D) INVESTMENTS",
    "EnglishLongName": "AYALON (4D) INVESTMENTS",
    "HebrewName": "איילון (4D) השקעות",
    "HebrewLongName": "איילון (4D) השקעות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.54,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.59,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 10.8,
    "MonthYield": 11.77,
    "YearYield": 11.77,
    "Last12MonthYield": 27.93,
    "ISIN": "IL0051337314"
  },
  {
    "Id": "TASE:5130307",
    "MayaId": "5130307",
    "Name": "Ayalon 10/90 IL",
    "ShortName": "Ayalon 10/90 IL",
    "Symbol": "TASE:5130307",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalon (1B) 10/90 IL",
    "EnglishLongName": "Ayalon (1B) 10/90 IL",
    "HebrewName": "איילון 10/90",
    "HebrewLongName": "איילון (1B)י 10/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.58,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 162.8,
    "MonthYield": 1.14,
    "YearYield": 1.14,
    "Last12MonthYield": 15.85,
    "ISIN": "IL0051303076"
  },
  {
    "Id": "TASE:5117650",
    "MayaId": "5117650",
    "Name": "Ayalon 75\\25 Kosher IL",
    "ShortName": "Ayalon 75\\25 Kosher IL",
    "Symbol": "TASE:5117650",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalon (2C) 75\\25 Kosher IL",
    "EnglishLongName": "Ayalon (2C) 75\\25 Kosher IL",
    "HebrewName": "איילון 75/25 כשרה",
    "HebrewLongName": "איילון (2C)י 25/75 כשרה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.64,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 25% Equity",
    "AssetValue": 122.6,
    "MonthYield": 2.21,
    "YearYield": 2.21,
    "Last12MonthYield": 14.53,
    "ISIN": "IL0051176506"
  },
  {
    "Id": "TASE:5132113",
    "MayaId": "5132113",
    "Name": "Ayalon A AA Bonds IL",
    "ShortName": "Ayalon A-AA Bonds IL",
    "Symbol": "TASE:5132113",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalon (1A) A-AA Bonds IL",
    "EnglishLongName": "Ayalon (1A) A-AA Bonds IL",
    "HebrewName": "איילון בונד A-AA",
    "HebrewLongName": "איילון (1A) בונד A-AA",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.37,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles with Equity",
    "AssetValue": 5.6,
    "MonthYield": 1.24,
    "YearYield": 1.24,
    "Last12MonthYield": 10.34,
    "ISIN": "IL0051321136"
  },
  {
    "Id": "TASE:5104922",
    "MayaId": "5104922",
    "Name": "Ayalon Bank Stocks IL",
    "ShortName": "Ayalon Bank Stocks IL",
    "Symbol": "TASE:5104922",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalon (4A) Bank Stocks IL",
    "EnglishLongName": "Ayalon (4A) Bank Stocks IL",
    "HebrewName": "איילון מניות בנקים",
    "HebrewLongName": "איילון (4A) מניות בנקים",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.15,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.9,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sectors",
    "AssetValue": 1191.1,
    "MonthYield": 8.76,
    "YearYield": 8.76,
    "Last12MonthYield": 65.66,
    "ISIN": "IL0051049224"
  },
  {
    "Id": "TASE:5129317",
    "MayaId": "5129317",
    "Name": "Ayalon Benleumi 4 IL",
    "ShortName": "Ayalon Benleumi 4 IL",
    "Symbol": "TASE:5129317",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalon (3D) Following portfolio 4 Benleumi Bank IL",
    "EnglishLongName": "Ayalon (3D) Following portfolio 4 Benleumi Bank IL",
    "HebrewName": "איילון בינלאומי 4",
    "HebrewLongName": "איילון (3D) עוקבת תיק 4 הבנק הבינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.65,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - Max. Exposure over 30% Equity",
    "AssetValue": 58.7,
    "MonthYield": 2.83,
    "YearYield": 2.83,
    "Last12MonthYield": 14.88,
    "ISIN": "IL0051293178"
  },
  {
    "Id": "TASE:5134077",
    "MayaId": "5134077",
    "Name": "Ayalon Blkchin&Mining Stk",
    "ShortName": "Ayalon Blkchin&Mining Stk",
    "Symbol": "TASE:5134077",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalon (4D) BlockChain & Mining Stocks",
    "EnglishLongName": "Ayalon (4D) BlockChain & Mining Stocks",
    "HebrewName": "איילון מנ בלוקציין וכרייה",
    "HebrewLongName": "איילון (4D) מניות בלוקצ'יין וכרייה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.85,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 8.52,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks by Sectors - Foreign",
    "AssetValue": 19.6,
    "MonthYield": 16.95,
    "YearYield": 16.95,
    "Last12MonthYield": 29.9,
    "ISIN": "IL0051340771"
  },
  {
    "Id": "TASE:5109673",
    "MayaId": "5109673",
    "Name": "Ayalon Bnd&Iss No Shr IL",
    "ShortName": "Ayalon Bnd&Iss No Shr IL",
    "Symbol": "TASE:5109673",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalon (0B)(!) Bonds And Issues Without Shares IL",
    "EnglishLongName": "Ayalon (0B)(!) Bonds And Issues Without Shares IL",
    "HebrewName": "איילון אג\"ח והנפקות ללא מ",
    "HebrewLongName": "איילון (0B)(!) אג\"ח והנפקות ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.24,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 366.1,
    "MonthYield": 0.92,
    "YearYield": 0.92,
    "Last12MonthYield": 5.52,
    "ISIN": "IL0051096738"
  },
  {
    "Id": "TASE:5137344",
    "MayaId": "5137344",
    "Name": "Ayalon Bnk&Insrnce Bnd IL",
    "ShortName": "Ayalon Bnk&Insrnce Bnd IL",
    "Symbol": "TASE:5137344",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalon (00) Banks & Insurance Bonds IL",
    "EnglishLongName": "Ayalon (00) Banks & Insurance Bonds IL",
    "HebrewName": "איילון אגח בנקים וביטוח",
    "HebrewLongName": "איילון (00) אג\"ח בנקים וביטוח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.27,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 162.3,
    "MonthYield": 0.51,
    "YearYield": 0.51,
    "Last12MonthYield": 6.48,
    "ISIN": "IL0051373442"
  },
  {
    "Id": "TASE:5106745",
    "MayaId": "5106745",
    "Name": "AYALON BOND + 10%",
    "ShortName": "AYALON BOND + 10%",
    "Symbol": "TASE:5106745",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALON (1A) BOND + 10% IL",
    "EnglishLongName": "AYALON (1A) BOND + 10% IL",
    "HebrewName": "איילון אג\"ח + 10%",
    "HebrewLongName": "איילון (1A) אג\"ח + 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.73,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.38,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 143.1,
    "MonthYield": 1.36,
    "YearYield": 1.36,
    "Last12MonthYield": 10.24,
    "ISIN": "IL0051067457"
  },
  {
    "Id": "TASE:5106729",
    "MayaId": "5106729",
    "Name": "AYALON BOND RAT A & ABO",
    "ShortName": "AYALON BOND RAT A & ABO",
    "Symbol": "TASE:5106729",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALON (0A) BONDS RATED A AND ABOVE IL",
    "EnglishLongName": "AYALON (0A) BONDS RATED A AND ABOVE IL",
    "HebrewName": "איילון אג\"ח מדורג A ומעלה",
    "HebrewLongName": "איילון (0A) אג\"ח מדורג A ומעלה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.25,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 5.7,
    "MonthYield": 0.45,
    "YearYield": 0.45,
    "Last12MonthYield": 6.32,
    "ISIN": "IL0051067291"
  },
  {
    "Id": "TASE:5130315",
    "MayaId": "5130315",
    "Name": "Ayalon Bonds Stok Free IL",
    "ShortName": "Ayalon Bonds Stok Free IL",
    "Symbol": "TASE:5130315",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalon (OB) Bonds Without Stocks IL",
    "EnglishLongName": "Ayalon (OB) Bonds Without Stocks IL",
    "HebrewName": "איילון אגח ללא מניות",
    "HebrewLongName": "איילון (0B) אג\"ח ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.43,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 584.7,
    "MonthYield": 0.59,
    "YearYield": 0.59,
    "Last12MonthYield": 10.65,
    "ISIN": "IL0051303159"
  },
  {
    "Id": "TASE:5120381",
    "MayaId": "5120381",
    "Name": "AYALON BONDS WITHOUT EQU",
    "ShortName": "AYALON BONDS WITHOUT EQU",
    "Symbol": "TASE:5120381",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALON (0B)(!) BONDS WITHOUT EQUITY IL",
    "EnglishLongName": "AYALON (0B)(!) BONDS WITHOUT EQUITY IL",
    "HebrewName": "איילון אג\"ח ללא מניות",
    "HebrewLongName": "איילון (0B)(!) אג\"ח ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.68,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 39.0,
    "MonthYield": 0.96,
    "YearYield": 0.96,
    "Last12MonthYield": 6.58,
    "ISIN": "IL0051203813"
  },
  {
    "Id": "TASE:5109608",
    "MayaId": "5109608",
    "Name": "Ayalon Bonds+10% IL",
    "ShortName": "Ayalon Bonds+10% IL",
    "Symbol": "TASE:5109608",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalon (1B)(!) Bonds + 10% IL",
    "EnglishLongName": "Ayalon (1B)(!) Bonds + 10% IL",
    "HebrewName": "איילון אג\"ח+10%",
    "HebrewLongName": "איילון (1B)(!) אג\"ח + 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.62,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 15.5,
    "MonthYield": 1.16,
    "YearYield": 1.16,
    "Last12MonthYield": 11.47,
    "ISIN": "IL0051096084"
  },
  {
    "Id": "TASE:5137286",
    "MayaId": "5137286",
    "Name": "Ayalon CLKD UPTO 12\\28 IL",
    "ShortName": "Ayalon CLKD UPTO 12\\28 IL",
    "Symbol": "TASE:5137286",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalon (00) CPI Linked Bonds UP TO 12/2028 IL",
    "EnglishLongName": "Ayalon (00) CPI Linked Bonds UP TO 12/2028 IL",
    "HebrewName": "איילון אגח צמוד 12/28",
    "HebrewLongName": "איילון (00) אג\"ח צמוד לפדיון עד 12/2028",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.16,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 315.1,
    "MonthYield": 0.11,
    "YearYield": 0.11,
    "Last12MonthYield": 4.57,
    "ISIN": "IL0051372865"
  },
  {
    "Id": "TASE:5106158",
    "MayaId": "5106158",
    "Name": "AYALON CORP EQUITY FR IL",
    "ShortName": "AYALON CORP EQUITY FR IL",
    "Symbol": "TASE:5106158",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALON (0B) CORPORATE BONDS EQUITY FREE IL",
    "EnglishLongName": "AYALON (0B) CORPORATE BONDS EQUITY FREE IL",
    "HebrewName": "איילון חברות ללא מניות",
    "HebrewLongName": "איילון (0B) אג\"ח חברות ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.78,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 31.9,
    "MonthYield": 0.64,
    "YearYield": 0.64,
    "Last12MonthYield": 6.18,
    "ISIN": "IL0051061583"
  },
  {
    "Id": "TASE:5137831",
    "MayaId": "5137831",
    "Name": "Ayalon Crp Bnd A&Above IL",
    "ShortName": "Ayalon Crp Bnd A&Above IL",
    "Symbol": "TASE:5137831",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalon (00) Corporate Bonds Rated A & Above IL",
    "EnglishLongName": "Ayalon (00) Corporate Bonds Rated A & Above IL",
    "HebrewName": "איילון אגח קונצרני A ומעל",
    "HebrewLongName": "איילון (00) אג\"ח קונצרני מדורג A ומעלה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.29,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 172.1,
    "MonthYield": 0.62,
    "YearYield": 0.62,
    "Last12MonthYield": 7.27,
    "ISIN": "IL0051378318"
  },
  {
    "Id": "TASE:5141445",
    "MayaId": "5141445",
    "Name": "Ayalon Defense Equity IL",
    "ShortName": "Ayalon Defense Equity IL",
    "Symbol": "TASE:5141445",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalon (4B) Defense Equity IL",
    "EnglishLongName": "Ayalon (4B) Defense Equity IL",
    "HebrewName": "איילון מניות ביטחוניות",
    "HebrewLongName": "איילון (4B) מניות ביטחוניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sectors",
    "AssetValue": 3.2,
    "MonthYield": 22.76,
    "YearYield": 22.76,
    "Last12MonthYield": null,
    "ISIN": "IL0051414451"
  },
  {
    "Id": "TASE:5117742",
    "MayaId": "5117742",
    "Name": "AYALON EQL WGHT TLV 35 IL",
    "ShortName": "AYALON EQL WGHT TLV 35 IL",
    "Symbol": "TASE:5117742",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALON (4B) EQUAL WEIGHT TLV 35 IL",
    "EnglishLongName": "AYALON (4B) EQUAL WEIGHT TLV 35 IL",
    "HebrewName": "איילון משקל שווה ת\"א 35",
    "HebrewLongName": "איילון (4B) משקל שווה ת\"א 35",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.15,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.1,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 17.4,
    "MonthYield": 7.74,
    "YearYield": 7.74,
    "Last12MonthYield": 64.06,
    "ISIN": "IL0051177421"
  },
  {
    "Id": "TASE:5139845",
    "MayaId": "5139845",
    "Name": "Ayalon Exposur to bitcoin",
    "ShortName": "Ayalon Exposur to bitcoin",
    "Symbol": "TASE:5139845",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalon (4D) Exposure To bitcoin",
    "EnglishLongName": "Ayalon (4D) Exposure To bitcoin",
    "HebrewName": "איילון חשיפה לביטקוין",
    "HebrewLongName": "איילון (4D) חשיפה לביטקוין",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 4.5,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Digital Assets",
    "SecondaryClassification": "Bitcoin",
    "AssetValue": 17.9,
    "MonthYield": 7.3,
    "YearYield": 7.3,
    "Last12MonthYield": -13.41,
    "ISIN": "IL0051398456"
  },
  {
    "Id": "TASE:5139357",
    "MayaId": "5139357",
    "Name": "AYALON EXTREM X3 TA90 IL",
    "ShortName": "AYALON EXTREM X3 TA90 IL",
    "Symbol": "TASE:5139357",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALON (6A) EXTREME TRIPLE TIMES TLV 90 IL",
    "EnglishLongName": "AYALON (6A) EXTREME TRIPLE TIMES TLV 90 IL",
    "HebrewName": "איילון אקסטרים תא 90 פי 3",
    "HebrewLongName": "איילון (6A) אקסטרים ת\"א 90 פי 3",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.85,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": true,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 8.9,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Leveraged and Strategic",
    "SecondaryClassification": "Leveraged, High-Risk",
    "AssetValue": 21.1,
    "MonthYield": 22.0,
    "YearYield": 22.0,
    "Last12MonthYield": 183.91,
    "ISIN": "IL0051393572"
  },
  {
    "Id": "TASE:5139340",
    "MayaId": "5139340",
    "Name": "AYALON EXTREME X3 BANK IL",
    "ShortName": "AYALON EXTREME X3 BANK IL",
    "Symbol": "TASE:5139340",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALON (6A) EXTREME TRIPLE TIMES BANK IL",
    "EnglishLongName": "AYALON (6A) EXTREME TRIPLE TIMES BANK IL",
    "HebrewName": "איילון אקסטרים בנקים פי 3",
    "HebrewLongName": "איילון (6A) אקסטרים בנקים פי 3",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.85,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": true,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 8.87,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Leveraged and Strategic",
    "SecondaryClassification": "Leveraged, High-Risk",
    "AssetValue": 49.5,
    "MonthYield": 30.6,
    "YearYield": 30.6,
    "Last12MonthYield": 287.2,
    "ISIN": "IL0051393408"
  },
  {
    "Id": "TASE:5117684",
    "MayaId": "5117684",
    "Name": "AYALON EXTRME 3X 125TL IL",
    "ShortName": "AYALON EXTRME 3X 125TL IL",
    "Symbol": "TASE:5117684",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALON (6A) EXTREME TRIPLE TIMES TLV 125 IL",
    "EnglishLongName": "AYALON (6A) EXTREME TRIPLE TIMES TLV 125 IL",
    "HebrewName": "איילון אקסטרים ת\"א 125",
    "HebrewLongName": "איילון (6A) אקסטרים ת\"א 125 פי 3",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.85,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": true,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 6.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Leveraged and Strategic",
    "SecondaryClassification": "Leveraged, High-Risk",
    "AssetValue": 156.0,
    "MonthYield": 28.42,
    "YearYield": 28.42,
    "Last12MonthYield": 261.49,
    "ISIN": "IL0051176845"
  },
  {
    "Id": "TASE:5117692",
    "MayaId": "5117692",
    "Name": "AYALON EXTRME 3X 35TLV IL",
    "ShortName": "AYALON EXTRME 3X 35TLV IL",
    "Symbol": "TASE:5117692",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALON (60) EXTREME TRIPLE TIMES TLV 35 IL",
    "EnglishLongName": "AYALON (60) EXTREME TRIPLE TIMES TLV 35 IL",
    "HebrewName": "איילון אקסטרים ת\"א 35",
    "HebrewLongName": "איילון (60) אקסטרים ת\"א 35 פי 3",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.85,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": true,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 5.98,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Leveraged and Strategic",
    "SecondaryClassification": "Leveraged, High-Risk",
    "AssetValue": 106.7,
    "MonthYield": 30.4,
    "YearYield": 30.4,
    "Last12MonthYield": 272.73,
    "ISIN": "IL0051176928"
  },
  {
    "Id": "TASE:5122791",
    "MayaId": "5122791",
    "Name": "AYALON FOL POR 2 FIBI BA",
    "ShortName": "AYALON FOL POR 2 FIBI BA",
    "Symbol": "TASE:5122791",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALON (2B) FOLOWING PORTFOLIO NO' 2 FIBI BANK IL",
    "EnglishLongName": "AYALON (2B) FOLOWING PORTFOLIO NO' 2 FIBI BANK IL",
    "HebrewName": "איילון עוקב תיק מס 2 בינל",
    "HebrewLongName": "איילון (2B) עוקבת תיק מס' 2 הבנק הבינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 15% Equity",
    "AssetValue": 59.4,
    "MonthYield": 0.75,
    "YearYield": 0.75,
    "Last12MonthYield": 8.19,
    "ISIN": "IL0051227911"
  },
  {
    "Id": "TASE:5127568",
    "MayaId": "5127568",
    "Name": "Ayalon Global Cannabis",
    "ShortName": "Ayalon Global Cannabis",
    "Symbol": "TASE:5127568",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalon (4D) Global Cannabis",
    "EnglishLongName": "Ayalon (4D) Global Cannabis",
    "HebrewName": "איילון קנאביס חו\"ל",
    "HebrewLongName": "איילון (4D) קנאביס חו\"ל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.6,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 8.92,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks by Sectors - Foreign",
    "AssetValue": 2.9,
    "MonthYield": 2.53,
    "YearYield": 2.53,
    "Last12MonthYield": 0.56,
    "ISIN": "IL0051275688"
  },
  {
    "Id": "TASE:5111448",
    "MayaId": "5111448",
    "Name": "Ayalon Gov CPI No Stks IL",
    "ShortName": "Ayalon Gov CPI No Stks IL",
    "Symbol": "TASE:5111448",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalon (0A) Government CPI Linked Without Stocks IL",
    "EnglishLongName": "Ayalon (0A) Government CPI Linked Without Stocks IL",
    "HebrewName": "איילון מדדית מדינה ללא מנ",
    "HebrewLongName": "איילון (0A) מדדית מדינה ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.68,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.17,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked Government Bonds - No Equity",
    "AssetValue": 8.4,
    "MonthYield": 0.11,
    "YearYield": 0.11,
    "Last12MonthYield": 4.11,
    "ISIN": "IL0051114481"
  },
  {
    "Id": "TASE:5112933",
    "MayaId": "5112933",
    "Name": "Ayalon Gov S&R Bonds IL",
    "ShortName": "Ayalon Gov S&R Bonds IL",
    "Symbol": "TASE:5112933",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalon (0B) Government Shekel and Ranked Bonds IL",
    "EnglishLongName": "Ayalon (0B) Government Shekel and Ranked Bonds IL",
    "HebrewName": "איילון שקלי מ ואג\"ח מדורג",
    "HebrewLongName": "איילון (0B) שקלי ממשלתי ואג\"ח מדורגות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.61,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.46,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Shekel Bonds - No Equity",
    "AssetValue": 20.4,
    "MonthYield": 1.0,
    "YearYield": 1.0,
    "Last12MonthYield": 8.06,
    "ISIN": "IL0051129331"
  },
  {
    "Id": "TASE:5112941",
    "MayaId": "5112941",
    "Name": "AYALON GOV+20% IL",
    "ShortName": "AYALON GOV+20% IL",
    "Symbol": "TASE:5112941",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALON (2B) GOVERNMENT + 20% IL",
    "EnglishLongName": "AYALON (2B) GOVERNMENT + 20% IL",
    "HebrewName": "איילון מדינה+20%",
    "HebrewLongName": "איילון (2B) מדינה + 20%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.4,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bonds - General - Up to 20% Equity",
    "AssetValue": 22.5,
    "MonthYield": 2.02,
    "YearYield": 2.02,
    "Last12MonthYield": 12.02,
    "ISIN": "IL0051129414"
  },
  {
    "Id": "TASE:5106778",
    "MayaId": "5106778",
    "Name": "AYALON GOVERNMENT +10% IL",
    "ShortName": "AYALON GOVERNMENT +10% IL",
    "Symbol": "TASE:5106778",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALON (1B) GOVERNMENT +10% IL",
    "EnglishLongName": "AYALON (1B) GOVERNMENT +10% IL",
    "HebrewName": "איילון מדינה + 10%",
    "HebrewLongName": "איילון (1B) מדינה + 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.57,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.38,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - up to 10% Equity",
    "AssetValue": 25.9,
    "MonthYield": 1.4,
    "YearYield": 1.4,
    "Last12MonthYield": 9.54,
    "ISIN": "IL0051067788"
  },
  {
    "Id": "TASE:5132014",
    "MayaId": "5132014",
    "Name": "Ayalon Green Energy IL&US",
    "ShortName": "Ayalon Green Energy IL&US",
    "Symbol": "TASE:5132014",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalon (4B) Green Energy Israel & US IL",
    "EnglishLongName": "Ayalon (4B) Green Energy Israel & US IL",
    "HebrewName": "איילון אנרגיה ירוקה יש-אר",
    "HebrewLongName": "איילון (4B) אנרגיה ירוקה ישראל וארה\"ב",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.25,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.39,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sectors",
    "AssetValue": 7.6,
    "MonthYield": 8.22,
    "YearYield": 8.22,
    "Last12MonthYield": 68.82,
    "ISIN": "IL0051320146"
  },
  {
    "Id": "AYAL.TA",
    "MayaId": "209015",
    "Name": "AYALON HOLD.",
    "ShortName": "AYALON INSURANCE COMPANY LTD",
    "Symbol": "AYAL.TA",
    "TaseSymbol": "AYAL",
    "YahooId": "AYAL.TA",
    "EnglishName": "AYALON  HOLD.",
    "EnglishLongName": "AYALON INSURANCE COMPANY LTD",
    "HebrewName": "איילון",
    "HebrewLongName": "איילון חברה לביטוח בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 9411.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Insurance",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 8.7,
    "YearYield": 8.7,
    "Last12MonthYield": null,
    "ISIN": "IL0002090152"
  },
  {
    "Id": "TASE:5140983",
    "MayaId": "5140983",
    "Name": "Ayalon InsuranceEquity IL",
    "ShortName": "Ayalon InsuranceEquity IL",
    "Symbol": "TASE:5140983",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalon (4A) Insurance Equity IL",
    "EnglishLongName": "Ayalon (4A) Insurance Equity IL",
    "HebrewName": "איילון מניות ביטוח",
    "HebrewLongName": "איילון (4A) מניות ביטוח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sectors",
    "AssetValue": 8.6,
    "MonthYield": 5.65,
    "YearYield": 5.65,
    "Last12MonthYield": null,
    "ISIN": "IL0051409832"
  },
  {
    "Id": "TASE:5137377",
    "MayaId": "5137377",
    "Name": "Ayalon IS GR EQ USA",
    "ShortName": "Ayalon IS GR EQ USA",
    "Symbol": "TASE:5137377",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalon (4D) Israeli Growth Equity in USA",
    "EnglishLongName": "Ayalon (4D) Israeli Growth Equity in USA",
    "HebrewName": "איילון מניות צמ ישרא ארהב",
    "HebrewLongName": "איילון (4D) מניות צמיחה ישראליות בארה\"ב",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.6,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.89,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Geographical stocks",
    "AssetValue": 1.9,
    "MonthYield": 5.67,
    "YearYield": 5.67,
    "Last12MonthYield": 5.07,
    "ISIN": "IL0051373772"
  },
  {
    "Id": "TASE:5130042",
    "MayaId": "5130042",
    "Name": "Ayalon Kosher Eqt Port IL",
    "ShortName": "Ayalon Kosher Eqt Port IL",
    "Symbol": "TASE:5130042",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalon (4B) Kosher Equity Portfolio IL",
    "EnglishLongName": "Ayalon (4B) Kosher Equity Portfolio IL",
    "HebrewName": "איילון תיק מניות כשרה",
    "HebrewLongName": "איילון (4B) תיק מניות כשרה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.36,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 95.6,
    "MonthYield": 8.33,
    "YearYield": 8.33,
    "Last12MonthYield": 58.21,
    "ISIN": "IL0051300429"
  },
  {
    "Id": "TASE:5114624",
    "MayaId": "5114624",
    "Name": "Ayalon Kosher Gov Prim IL",
    "ShortName": "Ayalon Kosher Gov Prim IL",
    "Symbol": "TASE:5114624",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalon (0A) Kosher Government Premium IL",
    "EnglishLongName": "Ayalon (0A) Kosher Government Premium IL",
    "HebrewName": "איילון מדינה פרימיום כשרה",
    "HebrewLongName": "איילון (0A) מדינה פרימיום כשרה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.64,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.21,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - No Equity",
    "AssetValue": 34.2,
    "MonthYield": 0.54,
    "YearYield": 0.54,
    "Last12MonthYield": 5.75,
    "ISIN": "IL0051146244"
  },
  {
    "Id": "TASE:5131990",
    "MayaId": "5131990",
    "Name": "Ayalon Local Auth Port IL",
    "ShortName": "Ayalon Local Auth Port IL",
    "Symbol": "TASE:5131990",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalon (10) Local Authorities Portfolio IL",
    "EnglishLongName": "Ayalon (10) Local Authorities Portfolio IL",
    "HebrewName": "איילון תיק רשויות מקומיות",
    "HebrewLongName": "איילון (10) תיק לרשויות מקומיות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.54,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 5% Equity",
    "AssetValue": 11.5,
    "MonthYield": 0.96,
    "YearYield": 0.96,
    "Last12MonthYield": 8.54,
    "ISIN": "IL0051319908"
  },
  {
    "Id": "TASE:5136866",
    "MayaId": "5136866",
    "Name": "Ayalon Lq Man Mny Mrkt IL",
    "ShortName": "Ayalon Lq Man Mny Mrkt IL",
    "Symbol": "TASE:5136866",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalon (00) Liquidity Management Money Market IL",
    "EnglishLongName": "Ayalon (00) Liquidity Management Money Market IL",
    "HebrewName": "איילון כספית ניהול נזילות",
    "HebrewLongName": "איילון (00) כספית ניהול הנזילות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.18,
    "TrusteeFee": 0.005,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 4735.7,
    "MonthYield": 0.22,
    "YearYield": 0.22,
    "Last12MonthYield": 4.7,
    "ISIN": "IL0051368665"
  },
  {
    "Id": "TASE:5101811",
    "MayaId": "5101811",
    "Name": "Ayalon Mdna Shklt+10% IL",
    "ShortName": "Ayalon Mdna Shklt+10% IL",
    "Symbol": "TASE:5101811",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalon (1A) Medina Shiklit + 10% IL",
    "EnglishLongName": "Ayalon (1A) Medina Shiklit + 10% IL",
    "HebrewName": "איילון מדינה שקלית+10%",
    "HebrewLongName": "איילון (1A) מדינה שקלית פלוס 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.64,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.46,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Shekel Bonds - Up to 10% Equity",
    "AssetValue": 9.7,
    "MonthYield": 1.55,
    "YearYield": 1.55,
    "Last12MonthYield": 10.55,
    "ISIN": "IL0051018112"
  },
  {
    "Id": "TASE:5130323",
    "MayaId": "5130323",
    "Name": "AYALON NO BANK FIN&CR IL",
    "ShortName": "AYALON NO-BANK FIN&CR IL",
    "Symbol": "TASE:5130323",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALON (4B) NON-BANKING FINANCING AND CREDIT IL",
    "EnglishLongName": "AYALON (4B) NON-BANKING FINANCING AND CREDIT IL",
    "HebrewName": "איילון מימון ואש חוץ בנק",
    "HebrewLongName": "איילון (4B) מימון ואשראי חוץ בנקאי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.5,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.75,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sectors",
    "AssetValue": 18.9,
    "MonthYield": 2.75,
    "YearYield": 2.75,
    "Last12MonthYield": 42.76,
    "ISIN": "IL0051303233"
  },
  {
    "Id": "TASE:5106737",
    "MayaId": "5106737",
    "Name": "AYALON NON CPI GOV NO EQ",
    "ShortName": "AYALON NON-CPI GOV NO EQ",
    "Symbol": "TASE:5106737",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALON (0A) NON-CPI Government Bond Without Equity IL",
    "EnglishLongName": "AYALON (0A) NON-CPI Government Bond Without Equity IL",
    "HebrewName": "איילון שקלית מדינה ללא מנ",
    "HebrewLongName": "איילון (0A) שקלית מדינה ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.45,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.03,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Shekel Bonds - No Equity",
    "AssetValue": 10.6,
    "MonthYield": 0.3,
    "YearYield": 0.3,
    "Last12MonthYield": 4.38,
    "ISIN": "IL0051067374"
  },
  {
    "Id": "TASE:5102157",
    "MayaId": "5102157",
    "Name": "AYALON PI 70/30",
    "ShortName": "AYALON PI 70/30",
    "Symbol": "TASE:5102157",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALON PI (2B) 70/30 IL",
    "EnglishLongName": "AYALON PI (2B) 70/30 IL",
    "HebrewName": "איילון פאי 30/70",
    "HebrewLongName": "איילון פאי (2B)י 30/70",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.85,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.71,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 45.3,
    "MonthYield": 2.33,
    "YearYield": 2.33,
    "Last12MonthYield": 18.11,
    "ISIN": "IL0051021579"
  },
  {
    "Id": "TASE:5117668",
    "MayaId": "5117668",
    "Name": "AYALON PORT EQ FR IL",
    "ShortName": "AYALON PORT EQ FR IL",
    "Symbol": "TASE:5117668",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALON (0B) PORTFOLIO EQUITY FREE IL",
    "EnglishLongName": "AYALON (0B) PORTFOLIO EQUITY FREE IL",
    "HebrewName": "איילון תיק השקעות ללא מנ",
    "HebrewLongName": "איילון (0B) תיק השקעות ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.61,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 35.6,
    "MonthYield": 0.74,
    "YearYield": 0.74,
    "Last12MonthYield": 6.71,
    "ISIN": "IL0051176688"
  },
  {
    "Id": "TASE:5124763",
    "MayaId": "5124763",
    "Name": "AYALON Portfolio 80/20",
    "ShortName": "AYALON Portfolio 80/20",
    "Symbol": "TASE:5124763",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALON (2B) Portfolio 80/20 IL",
    "EnglishLongName": "AYALON (2B) Portfolio 80/20 IL",
    "HebrewName": "איילון תיק 20/80",
    "HebrewLongName": "איילון (2B) תיק 20/80",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.39,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 22.6,
    "MonthYield": 1.7,
    "YearYield": 1.7,
    "Last12MonthYield": 12.54,
    "ISIN": "IL0051247638"
  },
  {
    "Id": "TASE:5126289",
    "MayaId": "5126289",
    "Name": "AYALON Portfolio 85/15",
    "ShortName": "AYALON Portfolio 85/15",
    "Symbol": "TASE:5126289",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALON (2B) Portfolio 85/15IL",
    "EnglishLongName": "AYALON (2B) Portfolio 85/15IL",
    "HebrewName": "איילון תיק 15/85",
    "HebrewLongName": "איילון (2B) תיק 15/85",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.39,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 15% Equity",
    "AssetValue": 25.6,
    "MonthYield": 1.61,
    "YearYield": 1.61,
    "Last12MonthYield": 11.26,
    "ISIN": "IL0051262892"
  },
  {
    "Id": "TASE:5118625",
    "MayaId": "5118625",
    "Name": "AYALON PRT 3 FIBI IL",
    "ShortName": "AYALON PRT 3 FIBI IL",
    "Symbol": "TASE:5118625",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALON (2C) FOLLOWING PORTFOLIO 3 FIBI BANK IL",
    "EnglishLongName": "AYALON (2C) FOLLOWING PORTFOLIO 3 FIBI BANK IL",
    "HebrewName": "איילון תיק 3 הבינלאומי",
    "HebrewLongName": "איילון (2C) עוקבת תיק 3 הבנק הבינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.42,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 267.8,
    "MonthYield": 1.48,
    "YearYield": 1.48,
    "Last12MonthYield": 10.66,
    "ISIN": "IL0051186257"
  },
  {
    "Id": "TASE:5136296",
    "MayaId": "5136296",
    "Name": "Ayalon S Bd UpTo 06/26 IL",
    "ShortName": "Ayalon S Bd UpTo 06/26 IL",
    "Symbol": "TASE:5136296",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalon (00) Shekel Bonds to Maturity Up To 06/2026 IL",
    "EnglishLongName": "Ayalon (00) Shekel Bonds to Maturity Up To 06/2026 IL",
    "HebrewName": "איילון אגח ש לפדיון 06/26",
    "HebrewLongName": "איילון (00) אג\"ח שקלי לפדיון עד 06/2026",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.03,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 26.6,
    "MonthYield": 0.27,
    "YearYield": 0.27,
    "Last12MonthYield": 4.28,
    "ISIN": "IL0051362965"
  },
  {
    "Id": "TASE:5136791",
    "MayaId": "5136791",
    "Name": "Ayalon Sh Bd UpTo 6/28 IL",
    "ShortName": "Ayalon Sh Bd UpTo 6/28 IL",
    "Symbol": "TASE:5136791",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalon (00) Shekel Bonds to Maturity Up To 06/2028 IL",
    "EnglishLongName": "Ayalon (00) Shekel Bonds to Maturity Up To 06/2028 IL",
    "HebrewName": "איילון אגח ש לפדיון 6/28",
    "HebrewLongName": "איילון (00) אג\"ח שקלי לפדיון עד 06/2028",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.13,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 40.9,
    "MonthYield": 0.38,
    "YearYield": 0.38,
    "Last12MonthYield": 5.08,
    "ISIN": "IL0051367915"
  },
  {
    "Id": "TASE:5101795",
    "MayaId": "5101795",
    "Name": "AYALON SOLID+10% IL",
    "ShortName": "AYALON SOLID+10% IL",
    "Symbol": "TASE:5101795",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALON (1B) SOLID +10% IL",
    "EnglishLongName": "AYALON (1B) SOLID +10% IL",
    "HebrewName": "איילון סולידית +10%",
    "HebrewLongName": "איילון (1B) סולידית + 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 21.3,
    "MonthYield": 1.34,
    "YearYield": 1.34,
    "Last12MonthYield": 9.69,
    "ISIN": "IL0051017957"
  },
  {
    "Id": "TASE:5101381",
    "MayaId": "5101381",
    "Name": "Ayalon StkS MutualFund IL",
    "ShortName": "Ayalon StkS MutualFund IL",
    "Symbol": "TASE:5101381",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalon (4B) Stocks - Mutual Fund IL",
    "EnglishLongName": "Ayalon (4B) Stocks - Mutual Fund IL",
    "HebrewName": "איילון מניות קרן נאמנות",
    "HebrewLongName": "איילון (4B) מניות – קרן נאמנות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.49,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.24,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 20.6,
    "MonthYield": 9.44,
    "YearYield": 9.44,
    "Last12MonthYield": 59.63,
    "ISIN": "IL0051013816"
  },
  {
    "Id": "TASE:5131362",
    "MayaId": "5131362",
    "Name": "Ayalon Tech Israel IL",
    "ShortName": "Ayalon Tech Israel IL",
    "Symbol": "TASE:5131362",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalon (4B) Israel Technology IL",
    "EnglishLongName": "Ayalon (4B) Israel Technology IL",
    "HebrewName": "איילון טכנולוגיה ישראל",
    "HebrewLongName": "איילון (4B) טכנולוגיה ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.25,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.2,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sectors",
    "AssetValue": 14.7,
    "MonthYield": 13.08,
    "YearYield": 13.08,
    "Last12MonthYield": 79.93,
    "ISIN": "IL0051313620"
  },
  {
    "Id": "TASE:5101118",
    "MayaId": "5101118",
    "Name": "AYALON U.S.A TAXABLE",
    "ShortName": "AYALON U.S.A TAXABLE",
    "Symbol": "TASE:5101118",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALON (4D) U.S.A TAXABLE",
    "EnglishLongName": "AYALON (4D) U.S.A TAXABLE",
    "HebrewName": "איילון ארה\"ב חייבת",
    "HebrewLongName": "איילון (4D) ארה\"ב חייבת",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.95,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.13,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Geographical stocks",
    "AssetValue": 96.4,
    "MonthYield": 1.04,
    "YearYield": 1.04,
    "Last12MonthYield": 3.32,
    "ISIN": "IL0051011182"
  },
  {
    "Id": "TASE:5139076",
    "MayaId": "5139076",
    "Name": "Ayalon US $Denominated MM",
    "ShortName": "Ayalon US $Denominated MM",
    "Symbol": "TASE:5139076",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalon (0D) US Dollar Denominated Money Market",
    "EnglishLongName": "Ayalon (0D) US Dollar Denominated Money Market",
    "HebrewName": "איילון כספית דולרית נקוב$",
    "HebrewLongName": "איילון (0D) כספית דולרית – נקובה דולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.12,
    "TrusteeFee": 0.005,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.26,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "FX Money Market with Corporate",
    "AssetValue": 56.2,
    "MonthYield": -0.94,
    "YearYield": -0.94,
    "Last12MonthYield": -9.75,
    "ISIN": "IL0051390768"
  },
  {
    "Id": "TASE:5101159",
    "MayaId": "5101159",
    "Name": "AYALON US Equities",
    "ShortName": "AYALON US Equities",
    "Symbol": "TASE:5101159",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALON (4D) US Equities",
    "EnglishLongName": "AYALON (4D) US Equities",
    "HebrewName": "איילון מניות US",
    "HebrewLongName": "איילון (4D) מניות US",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.95,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.71,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Geographical stocks",
    "AssetValue": 40.0,
    "MonthYield": 1.05,
    "YearYield": 1.05,
    "Last12MonthYield": 1.56,
    "ISIN": "IL0051011596"
  },
  {
    "Id": "TASE:5137633",
    "MayaId": "5137633",
    "Name": "AYALON ZVULUN ! BOND HY",
    "ShortName": "AYALON ZVULUN ! BOND HY",
    "Symbol": "TASE:5137633",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALON ZVULUN (0D)(!) Global Bonds HY",
    "EnglishLongName": "AYALON ZVULUN (0D)(!) Global Bonds HY",
    "HebrewName": "איילון זבולון ! אג\"ח HY",
    "HebrewLongName": "איילון זבולון (0D)(!) אג\"ח חו\"ל HY",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Bond",
    "AssetValue": 307.9,
    "MonthYield": 1.03,
    "YearYield": 1.03,
    "Last12MonthYield": 17.88,
    "ISIN": "IL0051376338"
  },
  {
    "Id": "TASE:5137625",
    "MayaId": "5137625",
    "Name": "AYALON ZVULUN GLOB STOCKS",
    "ShortName": "AYALON ZVULUN GLOB STOCKS",
    "Symbol": "TASE:5137625",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALON ZVULUN (4D) Global Stocks",
    "EnglishLongName": "AYALON ZVULUN (4D) Global Stocks",
    "HebrewName": "איילון זבולון מניות חו\"ל",
    "HebrewLongName": "איילון זבולון (4D) מניות חו\"ל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.75,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 5.18,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 178.5,
    "MonthYield": -2.61,
    "YearYield": -2.61,
    "Last12MonthYield": 27.81,
    "ISIN": "IL0051376254"
  },
  {
    "Id": "TASE:5132287",
    "MayaId": "5132287",
    "Name": "AyalonValue S ESG Upto30C",
    "ShortName": "AyalonValue S ESG Upto30C",
    "Symbol": "TASE:5132287",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ayalon Value 2 (4B) ESG Foreign Equity Up To 30% Currency",
    "EnglishLongName": "Ayalon Value 2 (4B) ESG Foreign Equity Up To 30% Currency",
    "HebrewName": "איילון ואליו מ ESGעד30מטח",
    "HebrewLongName": "איילון ואליו 2 (4B) מניות חו''ל ESG עד 30% מט''ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.48,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.57,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 4.4,
    "MonthYield": 3.0,
    "YearYield": 3.0,
    "Last12MonthYield": 17.4,
    "ISIN": "IL0051322878"
  },
  {
    "Id": "TASE:5134978",
    "MayaId": "5134978",
    "Name": "AYL 15% STK PT IL FND FND",
    "ShortName": "AYL 15% STK PT IL FND FND",
    "Symbol": "TASE:5134978",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALON (2B) UP TO 15% STOCKS PORTFOLIO - IL FUND OF FUNDS",
    "EnglishLongName": "AYALON (2B) UP TO 15% STOCKS PORTFOLIO - IL FUND OF FUNDS",
    "HebrewName": "איילון עד 15% מניות אגד",
    "HebrewLongName": "איילון (2B) תיק עד 15% מניות – אגד ישראלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Fund of Funds",
    "SecondaryClassification": "Israeli Fund of Funds",
    "AssetValue": 55.6,
    "MonthYield": 1.55,
    "YearYield": 1.55,
    "Last12MonthYield": 11.17,
    "ISIN": "IL0051349780"
  },
  {
    "Id": "TASE:5134960",
    "MayaId": "5134960",
    "Name": "AYL 30% STK PT IL FND FND",
    "ShortName": "AYL 30% STK PT IL FND FND",
    "Symbol": "TASE:5134960",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALON (2B) UP TO 30% STOCKS PORTFOLIO - IL FUND OF FUNDS",
    "EnglishLongName": "AYALON (2B) UP TO 30% STOCKS PORTFOLIO - IL FUND OF FUNDS",
    "HebrewName": "איילון עד 30% מניות אגד",
    "HebrewLongName": "איילון (2B) תיק עד 30% מניות – אגד ישראלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.58,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Fund of Funds",
    "SecondaryClassification": "Israeli Fund of Funds",
    "AssetValue": 67.7,
    "MonthYield": 1.93,
    "YearYield": 1.93,
    "Last12MonthYield": 15.66,
    "ISIN": "IL0051349608"
  },
  {
    "Id": "TASE:5126099",
    "MayaId": "5126099",
    "Name": "AYL MNAYOT CHUL",
    "ShortName": "AYL MNAYOT CHUL",
    "Symbol": "TASE:5126099",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AYALIM (4D) GLOBAL STOCKS",
    "EnglishLongName": "AYALIM (4D) GLOBAL STOCKS",
    "HebrewName": "אילים 4D מניות חו\"ל",
    "HebrewLongName": "אילים (4D) מניות חו\"ל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.05,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALIM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 41.9,
    "MonthYield": 1.07,
    "YearYield": 1.07,
    "Last12MonthYield": 9.03,
    "ISIN": "IL0051260995"
  },
  {
    "Id": "TASE:5108279",
    "MayaId": "5108279",
    "Name": "AZIMUTH (1A) 95/5 IL",
    "ShortName": "AZIMUTH (1A) 95/5 IL",
    "Symbol": "TASE:5108279",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AZIMUTH (1A) 95/5 IL",
    "EnglishLongName": "AZIMUTH (1A) 95/5 IL",
    "HebrewName": "אזימוט (1A)י 5/95",
    "HebrewLongName": "אזימוט (1A)י 5/95",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.25,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 5% Equity",
    "AssetValue": 205.8,
    "MonthYield": 0.4,
    "YearYield": 0.4,
    "Last12MonthYield": 6.51,
    "ISIN": "IL0051082795"
  },
  {
    "Id": "TASE:5120951",
    "MayaId": "5120951",
    "Name": "AZIMUTH (2B) 75/25 IL",
    "ShortName": "AZIMUTH (2B) 75/25 IL",
    "Symbol": "TASE:5120951",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AZIMUTH (2B) 75/25 IL",
    "EnglishLongName": "AZIMUTH (2B) 75/25 IL",
    "HebrewName": "אזימוט (2B)י 25/75",
    "HebrewLongName": "אזימוט (2B)י 25/75",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.71,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 25% Equity",
    "AssetValue": 15.6,
    "MonthYield": 1.87,
    "YearYield": 1.87,
    "Last12MonthYield": 13.26,
    "ISIN": "IL0051209513"
  },
  {
    "Id": "TASE:5122593",
    "MayaId": "5122593",
    "Name": "AZIMUTH 82/18 Hay Div IL",
    "ShortName": "AZIMUTH 82/18 Hay Div IL",
    "Symbol": "TASE:5122593",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AZIMUTH (2A) 82/18 Hay Dividend IL",
    "EnglishLongName": "AZIMUTH (2A) 82/18 Hay Dividend IL",
    "HebrewName": "אזימוט 18/82 חי דיבדינד",
    "HebrewLongName": "אזימוט (2A)י 18/82 חי דיבידנד",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.95,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.73,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 34.7,
    "MonthYield": 0.92,
    "YearYield": 0.92,
    "Last12MonthYield": 14.04,
    "ISIN": "IL0051225931"
  },
  {
    "Id": "TASE:5114160",
    "MayaId": "5114160",
    "Name": "AZIMUTH 90/10 DIVIDEND IL",
    "ShortName": "AZIMUTH 90/10 DIVIDEND IL",
    "Symbol": "TASE:5114160",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AZIMUTH 90/10 DIVIDEND (1B) IL",
    "EnglishLongName": "AZIMUTH 90/10 DIVIDEND (1B) IL",
    "HebrewName": "אזימוט 10/90 דיבידנד",
    "HebrewLongName": "אזימוט 10/90 דיבידנד (1B)",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.48,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 110.4,
    "MonthYield": 0.85,
    "YearYield": 0.85,
    "Last12MonthYield": 10.68,
    "ISIN": "IL0051141609"
  },
  {
    "Id": "TASE:5116082",
    "MayaId": "5116082",
    "Name": "AZIMUTH AGAH LELO MEN IL",
    "ShortName": "AZIMUTH AGAH LELO MEN IL",
    "Symbol": "TASE:5116082",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AZIMUTH (0B) AGAH LELO MENAYOT IL",
    "EnglishLongName": "AZIMUTH (0B) AGAH LELO MENAYOT IL",
    "HebrewName": "אזימוט אג\"ח ללא מניות",
    "HebrewLongName": "אזימוט (0B) אג\"ח ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 93.2,
    "MonthYield": 0.55,
    "YearYield": 0.55,
    "Last12MonthYield": 6.83,
    "ISIN": "IL0051160823"
  },
  {
    "Id": "TASE:5127006",
    "MayaId": "5127006",
    "Name": "AZIMUTH Equities IL",
    "ShortName": "AZIMUTH Equities IL",
    "Symbol": "TASE:5127006",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AZIMUTH (4B) Equities IL",
    "EnglishLongName": "AZIMUTH (4B) Equities IL",
    "HebrewName": "אזימוט מניות",
    "HebrewLongName": "אזימוט (4B) מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.18,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.55,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 39.4,
    "MonthYield": 3.44,
    "YearYield": 3.44,
    "Last12MonthYield": 46.06,
    "ISIN": "IL0051270069"
  },
  {
    "Id": "TASE:5136601",
    "MayaId": "5136601",
    "Name": "AZIMUTH FOREIGN EQUITY",
    "ShortName": "AZIMUTH FOREIGN EQUITY",
    "Symbol": "TASE:5136601",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AZIMUTH (4D) FOREIGN EQUITY",
    "EnglishLongName": "AZIMUTH (4D) FOREIGN EQUITY",
    "HebrewName": "אזימוט מניות חו\"ל",
    "HebrewLongName": "אזימוט (4D) מניות חו\"ל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.15,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 19.0,
    "MonthYield": 1.48,
    "YearYield": 1.48,
    "Last12MonthYield": 4.17,
    "ISIN": "IL0051366016"
  },
  {
    "Id": "TASE:5114285",
    "MayaId": "5114285",
    "Name": "AZIMUTH HASHKAOT (4D) IL",
    "ShortName": "AZIMUTH HASHKAOT (4D) IL",
    "Symbol": "TASE:5114285",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "AZIMUTH HASHKAOT (4D) IL",
    "EnglishLongName": "AZIMUTH HASHKAOT (4D) IL",
    "HebrewName": "אזימוט השקעות (4D)",
    "HebrewLongName": "אזימוט השקעות (4D)",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.94,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.41,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 45.2,
    "MonthYield": 4.47,
    "YearYield": 4.47,
    "Last12MonthYield": 33.87,
    "ISIN": "IL0051142854"
  },
  {
    "Id": "TASE:5138706",
    "MayaId": "5138706",
    "Name": "Azimuth MM Fund IL",
    "ShortName": "Azimuth MM Fund IL",
    "Symbol": "TASE:5138706",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Azimuth (00) Money Market Fund IL",
    "EnglishLongName": "Azimuth (00) Money Market Fund IL",
    "HebrewName": "אזימוט כספית",
    "HebrewLongName": "אזימוט (00) כספית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.14,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 144.9,
    "MonthYield": 0.2,
    "YearYield": 0.2,
    "Last12MonthYield": 4.64,
    "ISIN": "IL0051387061"
  },
  {
    "Id": "AZRM.TA",
    "MayaId": "715011",
    "Name": "AZORIM",
    "ShortName": "AZORIM-INVESTMENT, DEVELOPMENT & CONSTRUCTION CO. LTD.",
    "Symbol": "AZRM.TA",
    "TaseSymbol": "AZRM",
    "YahooId": "AZRM.TA",
    "EnglishName": "AZORIM",
    "EnglishLongName": "AZORIM-INVESTMENT, DEVELOPMENT & CONSTRUCTION CO. LTD.",
    "HebrewName": "אזורים",
    "HebrewLongName": "אזורים-חברה להשקעות בפתוח ובבנין בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1986.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 11.4,
    "YearYield": 11.4,
    "Last12MonthYield": null,
    "ISIN": "IL0007150118"
  },
  {
    "Id": "AZRG.TA",
    "MayaId": "1119478",
    "Name": "AZRIELI GROUP",
    "ShortName": "AZRIELI GROUP LTD",
    "Symbol": "AZRG.TA",
    "TaseSymbol": "AZRG",
    "YahooId": "AZRG.TA",
    "EnglishName": "AZRIELI GROUP",
    "EnglishLongName": "AZRIELI GROUP LTD",
    "HebrewName": "עזריאלי קבוצה",
    "HebrewLongName": "קבוצת עזריאלי בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 42300.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 18.2,
    "YearYield": 18.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011194789"
  },
  {
    "Id": "TASE:5141502",
    "MayaId": "5141502",
    "Name": "B. Alternative 70/30 IL",
    "ShortName": "B. Alternative 70/30 IL",
    "Symbol": "TASE:5141502",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "B. Alternative (2B) 70/30 IL",
    "EnglishLongName": "B. Alternative (2B) 70/30 IL",
    "HebrewName": "ב. אלטרנטיב 30/70",
    "HebrewLongName": "ב. אלטרנטיב (2B)י 30/70",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.78,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 1.0,
    "MonthYield": 3.04,
    "YearYield": 3.04,
    "Last12MonthYield": null,
    "ISIN": "IL0051415029"
  },
  {
    "Id": "TASE:5135769",
    "MayaId": "5135769",
    "Name": "B. Alternative 80/20 IL",
    "ShortName": "B. Alternative 80/20 IL",
    "Symbol": "TASE:5135769",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "B. Alternative (2B) 80/20 IL",
    "EnglishLongName": "B. Alternative (2B) 80/20 IL",
    "HebrewName": "ב. אלטרנטיב 20/80",
    "HebrewLongName": "ב. אלטרנטיב (2B)י 20/80",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.045,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.57,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 300.6,
    "MonthYield": 2.21,
    "YearYield": 2.21,
    "Last12MonthYield": 16.47,
    "ISIN": "IL0051357692"
  },
  {
    "Id": "TASE:5132055",
    "MayaId": "5132055",
    "Name": "B. Alternative 90/10 IL",
    "ShortName": "B. Alternative 90/10 IL",
    "Symbol": "TASE:5132055",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "B. Alternative (1B) 90/10 IL",
    "EnglishLongName": "B. Alternative (1B) 90/10 IL",
    "HebrewName": "ב. אלטרנטיב 10/90",
    "HebrewLongName": "ב. אלטרנטיב (1B)י 10/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.44,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 101.0,
    "MonthYield": 1.44,
    "YearYield": 1.44,
    "Last12MonthYield": 12.22,
    "ISIN": "IL0051320559"
  },
  {
    "Id": "TASE:5128848",
    "MayaId": "5128848",
    "Name": "B. Alternative Crp Bnd IL",
    "ShortName": "B. Alternative Crp Bnd IL",
    "Symbol": "TASE:5128848",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "B. Alternative (0C)(!) Corporate Bonds IL",
    "EnglishLongName": "B. Alternative (0C)(!) Corporate Bonds IL",
    "HebrewName": "ב. אלטרנטיב אגח קונצרני",
    "HebrewLongName": "ב. אלטרנטיב (0C)(!) אג\"ח קונצרני",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 334.5,
    "MonthYield": 0.77,
    "YearYield": 0.77,
    "Last12MonthYield": 8.69,
    "ISIN": "IL0051288483"
  },
  {
    "Id": "TASE:5136122",
    "MayaId": "5136122",
    "Name": "B. Alternative Flexible",
    "ShortName": "B. Alternative Flexible",
    "Symbol": "TASE:5136122",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "B. Alternative (4D) Flexible",
    "EnglishLongName": "B. Alternative (4D) Flexible",
    "HebrewName": "ב. אלטרנטיב גמישה",
    "HebrewLongName": "ב. אלטרנטיב (4D) גמישה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.68,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.6,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 43.7,
    "MonthYield": 7.68,
    "YearYield": 7.68,
    "Last12MonthYield": 55.01,
    "ISIN": "IL0051361223"
  },
  {
    "Id": "TASE:5136809",
    "MayaId": "5136809",
    "Name": "B. Alternative Global Eqt",
    "ShortName": "B. Alternative Global Eqt",
    "Symbol": "TASE:5136809",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "B. Alternative (4D) Global Equity",
    "EnglishLongName": "B. Alternative (4D) Global Equity",
    "HebrewName": "ב. אלטרנטיב מניות חו\"ל",
    "HebrewLongName": "ב. אלטרנטיב (4D) מניות חו\"ל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.85,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.59,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 1.5,
    "MonthYield": 2.6,
    "YearYield": 2.6,
    "Last12MonthYield": -7.7,
    "ISIN": "IL0051368095"
  },
  {
    "Id": "TASE:5130349",
    "MayaId": "5130349",
    "Name": "B.Alternati IL Equity",
    "ShortName": "B.Alternati IL Equity",
    "Symbol": "TASE:5130349",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "B. Alternative (4B) IL Equities",
    "EnglishLongName": "B. Alternative (4B) IL Equities",
    "HebrewName": "ב. אלטרנטיב מניות ישראל",
    "HebrewLongName": "ב. אלטרנטיב (4B) מניות ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.8,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.99,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 398.0,
    "MonthYield": 8.48,
    "YearYield": 8.48,
    "Last12MonthYield": 65.51,
    "ISIN": "IL0051303498"
  },
  {
    "Id": "BKFR.TA",
    "MayaId": "1183656",
    "Name": "BAIT BAKFAR",
    "ShortName": "BAIT BAKFAR LTD",
    "Symbol": "BKFR.TA",
    "TaseSymbol": "BKFR",
    "YahooId": "BKFR.TA",
    "EnglishName": "BAIT BAKFAR",
    "EnglishLongName": "BAIT BAKFAR LTD",
    "HebrewName": "בית בכפר",
    "HebrewLongName": "בית בכפר בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1517.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 6.2,
    "YearYield": 6.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011836561"
  },
  {
    "Id": "BVGG.TA",
    "MayaId": "1185362",
    "Name": "BAIT VEGAG GL",
    "ShortName": "BAIT VEGAG REAL ESTATE DEVELOPMENT LTD",
    "Symbol": "BVGG.TA",
    "TaseSymbol": "BVGG",
    "YahooId": "BVGG.TA",
    "EnglishName": "BAIT VEGAG GL",
    "EnglishLongName": "BAIT VEGAG REAL ESTATE DEVELOPMENT LTD",
    "HebrewName": "בית וגג",
    "HebrewLongName": "בית וגג יזמות ונדל\"ן בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 751.1,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 20.9,
    "YearYield": 20.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011853624"
  },
  {
    "Id": "BLDI.TA",
    "MayaId": "1212539",
    "Name": "BALADI",
    "ShortName": "BALADI LTD",
    "Symbol": "BLDI.TA",
    "TaseSymbol": "BLDI",
    "YahooId": "BLDI.TA",
    "EnglishName": "BALADI",
    "EnglishLongName": "BALADI LTD",
    "HebrewName": "בלדי",
    "HebrewLongName": "בלדי בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4833.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 14.8,
    "YearYield": 14.8,
    "Last12MonthYield": null,
    "ISIN": "IL0012125394"
  },
  {
    "Id": "TASE:13",
    "MayaId": "13",
    "Name": "Banks Shares and Convertibles",
    "ShortName": "Banks Shares and Convertibles",
    "Symbol": "TASE:13",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Banks Shares and Convertibles",
    "EnglishLongName": "Banks Shares and Convertibles",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:5139209",
    "MayaId": "5139209",
    "Name": "BARAK (4B) ISRAEL EQUITY",
    "ShortName": "BARAK (4B) ISRAEL EQUITY",
    "Symbol": "TASE:5139209",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "BARAK (4B) ISRAEL EQUITY",
    "EnglishLongName": "BARAK (4B) ISRAEL EQUITY",
    "HebrewName": "ברק (4B) מניות ישראל",
    "HebrewLongName": "ברק (4B) מניות ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.8,
    "TrusteeFee": 0.1,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.4,
    "Sector": "",
    "Industry": "",
    "ManagerName": "BARAK MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 2.5,
    "MonthYield": 9.47,
    "YearYield": 9.47,
    "Last12MonthYield": 65.09,
    "ISIN": "IL0051392095"
  },
  {
    "Id": "TASE:5139217",
    "MayaId": "5139217",
    "Name": "BARAK (4D) FOREIGN EQUITY",
    "ShortName": "BARAK (4D) FOREIGN EQUITY",
    "Symbol": "TASE:5139217",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "BARAK (4D) FOREIGN EQUITY",
    "EnglishLongName": "BARAK (4D) FOREIGN EQUITY",
    "HebrewName": "ברק (4D) מניות חו\"ל",
    "HebrewLongName": "ברק (4D) מניות חו\"ל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.8,
    "TrusteeFee": 0.1,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.66,
    "Sector": "",
    "Industry": "",
    "ManagerName": "BARAK MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 1.5,
    "MonthYield": 1.74,
    "YearYield": 1.74,
    "Last12MonthYield": 3.75,
    "ISIN": "IL0051392178"
  },
  {
    "Id": "TASE:5140819",
    "MayaId": "5140819",
    "Name": "Barak Bonds Stock Free IL",
    "ShortName": "Barak Bonds Stock Free IL",
    "Symbol": "TASE:5140819",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Barak (0C) Bonds Without Stocks IL",
    "EnglishLongName": "Barak (0C) Bonds Without Stocks IL",
    "HebrewName": "ברק אג\"ח ללא מניות",
    "HebrewLongName": "ברק (0C) אג\"ח ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.1,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "BARAK MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 0.9,
    "MonthYield": 0.62,
    "YearYield": 0.62,
    "Last12MonthYield": null,
    "ISIN": "IL0051408198"
  },
  {
    "Id": "BARI.TA",
    "MayaId": "1104363",
    "Name": "BARAK INVEST",
    "ShortName": "BARAK INVESTMENT HOUSE LTD",
    "Symbol": "BARI.TA",
    "TaseSymbol": "BARI",
    "YahooId": "BARI.TA",
    "EnglishName": "BARAK INVEST",
    "EnglishLongName": "BARAK INVESTMENT HOUSE LTD",
    "HebrewName": "ברק בית השקעות",
    "HebrewLongName": "ברק בית השקעות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4715.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Financial Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 5.3,
    "YearYield": 5.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011043630"
  },
  {
    "Id": "TASE:5141692",
    "MayaId": "5141692",
    "Name": "BARAK MONEY MARKET",
    "ShortName": "BARAK MONEY MARKET",
    "Symbol": "TASE:5141692",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "BARAK (00) MONEY MARKET IL",
    "EnglishLongName": "BARAK (00) MONEY MARKET IL",
    "HebrewName": "ברק כספית",
    "HebrewLongName": "ברק (00) כספית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "BARAK MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 5.3,
    "MonthYield": 0.25,
    "YearYield": 0.25,
    "Last12MonthYield": null,
    "ISIN": "IL0051416928"
  },
  {
    "Id": "TASE:5137914",
    "MayaId": "5137914",
    "Name": "BARAK Tik 80/20 IL",
    "ShortName": "BARAK Tik 80/20 IL",
    "Symbol": "TASE:5137914",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "BARAK (2B) Portfolio 80/20 IL",
    "EnglishLongName": "BARAK (2B) Portfolio 80/20 IL",
    "HebrewName": "ברק תיק 20/80",
    "HebrewLongName": "ברק (2B) תיק 20/80",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.1,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.45,
    "Sector": "",
    "Industry": "",
    "ManagerName": "BARAK MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 7.5,
    "MonthYield": 2.09,
    "YearYield": 2.09,
    "Last12MonthYield": 11.08,
    "ISIN": "IL0051379142"
  },
  {
    "Id": "TASE:5137922",
    "MayaId": "5137922",
    "Name": "BARAK Tik 90/10 IL",
    "ShortName": "BARAK Tik 90/10 IL",
    "Symbol": "TASE:5137922",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "BARAK (1B) Portfolio 90/10 IL",
    "EnglishLongName": "BARAK (1B) Portfolio 90/10 IL",
    "HebrewName": "ברק תיק 10/90",
    "HebrewLongName": "ברק (1B) תיק 10/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.1,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "BARAK MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 8.1,
    "MonthYield": 1.17,
    "YearYield": 1.17,
    "Last12MonthYield": 8.06,
    "ISIN": "IL0051379225"
  },
  {
    "Id": "TASE:5139829",
    "MayaId": "5139829",
    "Name": "BARAK ULTRA TRIPLE 90",
    "ShortName": "BARAK ULTRA TRIPLE 90",
    "Symbol": "TASE:5139829",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "BARAK (6A) ULTRA TRIPLE TIMES TLV 90 IL",
    "EnglishLongName": "BARAK (6A) ULTRA TRIPLE TIMES TLV 90 IL",
    "HebrewName": "ברק אולטרה ת\"א 90 פי 3",
    "HebrewLongName": "ברק (6A) אולטרה ת\"א 90 פי 3",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.8,
    "TrusteeFee": 0.1,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": true,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 9.02,
    "Sector": "",
    "Industry": "",
    "ManagerName": "BARAK MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Leveraged and Strategic",
    "SecondaryClassification": "Leveraged, High-Risk",
    "AssetValue": 31.0,
    "MonthYield": 22.41,
    "YearYield": 22.41,
    "Last12MonthYield": 188.25,
    "ISIN": "IL0051398290"
  },
  {
    "Id": "TASE:5135652",
    "MayaId": "5135652",
    "Name": "BARAK ULTRA TRIPLE BANK",
    "ShortName": "BARAK ULTRA TRIPLE BANK",
    "Symbol": "TASE:5135652",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "BARAK (6A) ULTRA TRIPLE TIMES BANK IL",
    "EnglishLongName": "BARAK (6A) ULTRA TRIPLE TIMES BANK IL",
    "HebrewName": "ברק אולטרה בנקים פי 3",
    "HebrewLongName": "ברק (6A) אולטרה בנקים פי 3",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 3.6,
    "TrusteeFee": 0.1,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": true,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 8.94,
    "Sector": "",
    "Industry": "",
    "ManagerName": "BARAK MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Leveraged and Strategic",
    "SecondaryClassification": "Leveraged, High-Risk",
    "AssetValue": 175.6,
    "MonthYield": 30.86,
    "YearYield": 30.86,
    "Last12MonthYield": 287.8,
    "ISIN": "IL0051356520"
  },
  {
    "Id": "TASE:5135199",
    "MayaId": "5135199",
    "Name": "BARAK ULTRA TRIPLE DAX",
    "ShortName": "BARAK ULTRA TRIPLE DAX",
    "Symbol": "TASE:5135199",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "BARAK (6D) ULTRA TRIPLE TIMES DAX",
    "EnglishLongName": "BARAK (6D) ULTRA TRIPLE TIMES DAX",
    "HebrewName": "ברק אולטרה דאקס פי 3",
    "HebrewLongName": "ברק (6D) אולטרה דאקס פי 3",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 3.6,
    "TrusteeFee": 0.1,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": true,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 4.06,
    "Sector": "",
    "Industry": "",
    "ManagerName": "BARAK MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Leveraged and Strategic",
    "SecondaryClassification": "Leveraged, High-Risk",
    "AssetValue": 13.5,
    "MonthYield": 8.73,
    "YearYield": 8.73,
    "Last12MonthYield": 67.12,
    "ISIN": "IL0051351992"
  },
  {
    "Id": "TASE:5140801",
    "MayaId": "5140801",
    "Name": "BARAK ULTRA TRIPLE GOLD",
    "ShortName": "BARAK ULTRA TRIPLE GOLD",
    "Symbol": "TASE:5140801",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "BARAK (6D) ULTRA TRIPLE TIMES GOLD",
    "EnglishLongName": "BARAK (6D) ULTRA TRIPLE TIMES GOLD",
    "HebrewName": "ברק אולטרה זהב פי 3",
    "HebrewLongName": "ברק (6D) אולטרה זהב פי 3",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.8,
    "TrusteeFee": 0.1,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": true,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "BARAK MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Leveraged and Strategic",
    "SecondaryClassification": "Leveraged, High-Risk",
    "AssetValue": 13.8,
    "MonthYield": 20.12,
    "YearYield": 20.12,
    "Last12MonthYield": null,
    "ISIN": "IL0051408016"
  },
  {
    "Id": "TASE:5135207",
    "MayaId": "5135207",
    "Name": "BARAK ULTRA TRIPLE NAS100",
    "ShortName": "BARAK ULTRA TRIPLE NAS100",
    "Symbol": "TASE:5135207",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "BARAK (6D) ULTRA TRIPLE TIMES NASDAQ 100",
    "EnglishLongName": "BARAK (6D) ULTRA TRIPLE TIMES NASDAQ 100",
    "HebrewName": "ברק אולטרה נאסד\"ק 100 פי3",
    "HebrewLongName": "ברק (6D) אולטרה נאסד\"ק 100 פי 3",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.8,
    "TrusteeFee": 0.1,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": true,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 6.16,
    "Sector": "",
    "Industry": "",
    "ManagerName": "BARAK MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Leveraged and Strategic",
    "SecondaryClassification": "Leveraged, High-Risk",
    "AssetValue": 31.8,
    "MonthYield": 1.89,
    "YearYield": 1.89,
    "Last12MonthYield": 21.28,
    "ISIN": "IL0051352073"
  },
  {
    "Id": "TASE:5135181",
    "MayaId": "5135181",
    "Name": "BARAK ULTRA TRIPLE S&P 500",
    "ShortName": "BARAK ULTRA TRIPLE S&P500",
    "Symbol": "TASE:5135181",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "BARAK (6D) ULTRA TRIPLE TIMES S&P 500",
    "EnglishLongName": "BARAK (6D) ULTRA TRIPLE TIMES S&P 500",
    "HebrewName": "ברק אולטרה S&P 500 פי 3",
    "HebrewLongName": "ברק (6D) אולטרה S&P 500 פי 3",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.8,
    "TrusteeFee": 0.1,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": true,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 4.64,
    "Sector": "",
    "Industry": "",
    "ManagerName": "BARAK MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Leveraged and Strategic",
    "SecondaryClassification": "Leveraged, High-Risk",
    "AssetValue": 14.2,
    "MonthYield": 3.01,
    "YearYield": 3.01,
    "Last12MonthYield": 21.72,
    "ISIN": "IL0051351810"
  },
  {
    "Id": "TASE:5135215",
    "MayaId": "5135215",
    "Name": "BARAK ULTRA TRIPLE TLV125",
    "ShortName": "BARAK ULTRA TRIPLE TLV125",
    "Symbol": "TASE:5135215",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "BARAK (6A) ULTRA TRIPLE TIMES TLV 125 IL",
    "EnglishLongName": "BARAK (6A) ULTRA TRIPLE TIMES TLV 125 IL",
    "HebrewName": "ברק אולטרה ת\"א 125 פי 3",
    "HebrewLongName": "ברק (6A) אולטרה ת\"א 125 פי 3",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.8,
    "TrusteeFee": 0.1,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": true,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 6.4,
    "Sector": "",
    "Industry": "",
    "ManagerName": "BARAK MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Leveraged and Strategic",
    "SecondaryClassification": "Leveraged, High-Risk",
    "AssetValue": 43.9,
    "MonthYield": 28.09,
    "YearYield": 28.09,
    "Last12MonthYield": 249.42,
    "ISIN": "IL0051352156"
  },
  {
    "Id": "TASE:5135173",
    "MayaId": "5135173",
    "Name": "BARAK ULTRA TRIPLE TLV35",
    "ShortName": "BARAK ULTRA TRIPLE TLV35",
    "Symbol": "TASE:5135173",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "BARAK (60) ULTRA TRIPLE TIMES TLV 35 IL",
    "EnglishLongName": "BARAK (60) ULTRA TRIPLE TIMES TLV 35 IL",
    "HebrewName": "ברק אולטרה ת\"א 35 פי 3",
    "HebrewLongName": "ברק (60) אולטרה ת\"א 35 פי 3",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.8,
    "TrusteeFee": 0.1,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": true,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 6.11,
    "Sector": "",
    "Industry": "",
    "ManagerName": "BARAK MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Leveraged and Strategic",
    "SecondaryClassification": "Leveraged, High-Risk",
    "AssetValue": 31.7,
    "MonthYield": 30.18,
    "YearYield": 30.18,
    "Last12MonthYield": 266.97,
    "ISIN": "IL0051351737"
  },
  {
    "Id": "TASE:5141841",
    "MayaId": "5141841",
    "Name": "Barak ULTRA X3 WTI Oil",
    "ShortName": "Barak ULTRA X3 WTI Oil",
    "Symbol": "TASE:5141841",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "BARAK (6D) ULTRA TRIPLE TIME WTI OIL",
    "EnglishLongName": "BARAK (6D) ULTRA TRIPLE TIME WTI OIL",
    "HebrewName": "ברק אולטרה נפט WTI פי 3",
    "HebrewLongName": "ברק (6D) אולטרה נפט WTI פי 3",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.8,
    "TrusteeFee": 0.1,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": true,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "BARAK MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Leveraged and Strategic",
    "SecondaryClassification": "Leveraged, High-Risk",
    "AssetValue": 0.2,
    "MonthYield": 14.51,
    "YearYield": 14.51,
    "Last12MonthYield": null,
    "ISIN": "IL0051418411"
  },
  {
    "Id": "BRAN.TA",
    "MayaId": "286013",
    "Name": "BARAN",
    "ShortName": "BARAN GROUP LTD.",
    "Symbol": "BRAN.TA",
    "TaseSymbol": "BRAN",
    "YahooId": "BRAN.TA",
    "EnglishName": "BARAN",
    "EnglishLongName": "BARAN GROUP LTD.",
    "HebrewName": "ברן",
    "HebrewLongName": "קבוצת ברן בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2799.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 10.2,
    "YearYield": 10.2,
    "Last12MonthYield": null,
    "ISIN": "IL0002860133"
  },
  {
    "Id": "BRKT.TA",
    "MayaId": "1178276",
    "Name": "BAREKET",
    "ShortName": "BAREKET CAPITAL LTD.",
    "Symbol": "BRKT.TA",
    "TaseSymbol": "BRKT",
    "YahooId": "BRKT.TA",
    "EnglishName": "BAREKET",
    "EnglishLongName": "BAREKET CAPITAL LTD.",
    "HebrewName": "ברקת",
    "HebrewLongName": "ברקת קפיטל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 297.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Financial Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -1.5,
    "YearYield": -1.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011782765"
  },
  {
    "Id": "TASE:5129200",
    "MayaId": "5129200",
    "Name": "BAROMETER (!) CORP IL",
    "ShortName": "BAROMETER (!) CORP IL",
    "Symbol": "TASE:5129200",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "BAROMETER (0B)(!) CORPORATE BONDS EQUITY FREE IL",
    "EnglishLongName": "BAROMETER (0B)(!) CORPORATE BONDS EQUITY FREE IL",
    "HebrewName": "ברומטר (!) אג\"ח חברות",
    "HebrewLongName": "ברומטר (0B)(!) אג\"ח חברות ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.24,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 107.8,
    "MonthYield": 0.36,
    "YearYield": 0.36,
    "Last12MonthYield": 6.2,
    "ISIN": "IL0051292006"
  },
  {
    "Id": "TASE:5105267",
    "MayaId": "5105267",
    "Name": "Barometer (2B) 85/15 IL",
    "ShortName": "Barometer (2B) 85/15 IL",
    "Symbol": "TASE:5105267",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Barometer (2B) 85/15 IL",
    "EnglishLongName": "Barometer (2B) 85/15 IL",
    "HebrewName": "ברומטר (2B)י 15/85",
    "HebrewLongName": "ברומטר (2B)י 15/85",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.93,
    "TrusteeFee": 0.035,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.39,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 15% Equity",
    "AssetValue": 745.4,
    "MonthYield": 0.92,
    "YearYield": 0.92,
    "Last12MonthYield": 10.83,
    "ISIN": "IL0051052673"
  },
  {
    "Id": "TASE:5124979",
    "MayaId": "5124979",
    "Name": "Barometer (4B) Equity IL",
    "ShortName": "Barometer (4B) Equity IL",
    "Symbol": "TASE:5124979",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Barometer (4B) Equity IL",
    "EnglishLongName": "Barometer (4B) Equity IL",
    "HebrewName": "ברומטר (4B) מניות",
    "HebrewLongName": "ברומטר (4B) מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.48,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.77,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 204.1,
    "MonthYield": 6.21,
    "YearYield": 6.21,
    "Last12MonthYield": 53.4,
    "ISIN": "IL0051249790"
  },
  {
    "Id": "TASE:5136817",
    "MayaId": "5136817",
    "Name": "Barometer Flexible",
    "ShortName": "Barometer Flexible",
    "Symbol": "TASE:5136817",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Barometer (4D) Flexible",
    "EnglishLongName": "Barometer (4D) Flexible",
    "HebrewName": "ברומטר גמישה",
    "HebrewLongName": "ברומטר (4D) גמישה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.48,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.48,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 25.0,
    "MonthYield": 0.96,
    "YearYield": 0.96,
    "Last12MonthYield": 11.54,
    "ISIN": "IL0051368178"
  },
  {
    "Id": "BVC.TA",
    "MayaId": "1158823",
    "Name": "BATM",
    "ShortName": "BATM ADVANCED COMMUNICATIONS LTD",
    "Symbol": "BVC.TA",
    "TaseSymbol": "BVC",
    "YahooId": "BVC.TA",
    "EnglishName": "BATM",
    "EnglishLongName": "BATM ADVANCED COMMUNICATIONS LTD",
    "HebrewName": "באטמ",
    "HebrewLongName": "באטמ תקשורת מתקדמת בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 66.1,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -1.4,
    "YearYield": -1.4,
    "Last12MonthYield": null,
    "ISIN": "IL0010849045"
  },
  {
    "Id": "ORL.TA",
    "MayaId": "2590248",
    "Name": "BAZAN",
    "ShortName": "OIL REFINERIES LTD.",
    "Symbol": "ORL.TA",
    "TaseSymbol": "ORL",
    "YahooId": "ORL.TA",
    "EnglishName": "BAZAN",
    "EnglishLongName": "OIL REFINERIES LTD.",
    "HebrewName": "בזן",
    "HebrewLongName": "בתי זקוק לנפט בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 103.9,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Energy And Oil & Gas Exploration",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 6.6,
    "YearYield": 6.6,
    "Last12MonthYield": null,
    "ISIN": "IL0025902482"
  },
  {
    "Id": "BHNY.TA",
    "MayaId": "1082346",
    "Name": "BEEIO HONEY",
    "ShortName": "BEEIO HONEY LTD",
    "Symbol": "BHNY.TA",
    "TaseSymbol": "BHNY",
    "YahooId": "BHNY.TA",
    "EnglishName": "BEEIO HONEY",
    "EnglishLongName": "BEEIO HONEY LTD",
    "HebrewName": "ביו דבש",
    "HebrewLongName": "ביו דבש בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 120.2,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 7.0,
    "YearYield": 7.0,
    "Last12MonthYield": null,
    "ISIN": "IL0010823461"
  },
  {
    "Id": "BSEN.TA",
    "MayaId": "1081561",
    "Name": "BET SHEMESH",
    "ShortName": "BET SHEMESH ENGINES HOLDINGS (1997) LTD.",
    "Symbol": "BSEN.TA",
    "TaseSymbol": "BSEN",
    "YahooId": "BSEN.TA",
    "EnglishName": "BET SHEMESH",
    "EnglishLongName": "BET SHEMESH ENGINES HOLDINGS (1997) LTD.",
    "HebrewName": "בית שמש",
    "HebrewLongName": "מנועי בית שמש אחזקות (1997) בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 80760.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 10.4,
    "YearYield": 10.4,
    "Last12MonthYield": null,
    "ISIN": "IL0010815616"
  },
  {
    "Id": "BYON.TA",
    "MayaId": "1175561",
    "Name": "BEYON 3D",
    "ShortName": "BEYON3D LTD",
    "Symbol": "BYON.TA",
    "TaseSymbol": "BYON",
    "YahooId": "BYON.TA",
    "EnglishName": "BEYON 3D",
    "EnglishLongName": "BEYON3D LTD",
    "HebrewName": "ביונ תלת מימד",
    "HebrewLongName": "ביונ תלת מימד בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 101.4,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -26.5,
    "YearYield": -26.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011755613"
  },
  {
    "Id": "BEZQ.TA",
    "MayaId": "230011",
    "Name": "BEZEQ",
    "ShortName": "BEZEQ THE ISRAELI TELECOMMUNICATION CORP. LTD.",
    "Symbol": "BEZQ.TA",
    "TaseSymbol": "BEZQ",
    "YahooId": "BEZQ.TA",
    "EnglishName": "BEZEQ",
    "EnglishLongName": "BEZEQ THE ISRAELI TELECOMMUNICATION CORP. LTD.",
    "HebrewName": "בזק",
    "HebrewLongName": "בזק החברה הישראלית לתקשורת בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 747.9,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 6.4,
    "YearYield": 6.4,
    "Last12MonthYield": null,
    "ISIN": "IL0002300114"
  },
  {
    "Id": "BIG.TA",
    "MayaId": "1097260",
    "Name": "BIG",
    "ShortName": "BIG SHOPPING CENTERS LTD",
    "Symbol": "BIG.TA",
    "TaseSymbol": "BIG",
    "YahooId": "BIG.TA",
    "EnglishName": "BIG",
    "EnglishLongName": "BIG SHOPPING CENTERS LTD",
    "HebrewName": "ביג",
    "HebrewLongName": "ביג מרכזי קניות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 76590.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.8,
    "YearYield": 0.8,
    "Last12MonthYield": null,
    "ISIN": "IL0010972607"
  },
  {
    "Id": "BKRY.TA",
    "MayaId": "1172618",
    "Name": "BIKUREY HASHDE",
    "ShortName": "BIKUREY HASADE GROUP LTD",
    "Symbol": "BKRY.TA",
    "TaseSymbol": "BKRY",
    "YahooId": "BKRY.TA",
    "EnglishName": "BIKUREY HASHDE",
    "EnglishLongName": "BIKUREY HASADE GROUP LTD",
    "HebrewName": "בכורי שדה",
    "HebrewLongName": "קבוצת ביכורי השדה בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 423.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -9.5,
    "YearYield": -9.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011726184"
  },
  {
    "Id": "BIOV.TA",
    "MayaId": "1096049",
    "Name": "BIO VIEW",
    "ShortName": "BIO VIEW LTD",
    "Symbol": "BIOV.TA",
    "TaseSymbol": "BIOV",
    "YahooId": "BIOV.TA",
    "EnglishName": "BIO VIEW",
    "EnglishLongName": "BIO VIEW LTD",
    "HebrewName": "ביו ויו",
    "HebrewLongName": "ביו ויו בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 18.2,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 4.8,
    "YearYield": 4.8,
    "Last12MonthYield": null,
    "ISIN": "IL0010960495"
  },
  {
    "Id": "BOLT.TA",
    "MayaId": "1095223",
    "Name": "BIOLIGHT",
    "ShortName": "BIOLIGHT LIFE SCIENCES LTD",
    "Symbol": "BOLT.TA",
    "TaseSymbol": "BOLT",
    "YahooId": "BOLT.TA",
    "EnglishName": "BIOLIGHT",
    "EnglishLongName": "BIOLIGHT LIFE SCIENCES LTD",
    "HebrewName": "ביולייט",
    "HebrewLongName": "ביולייט מדעי החיים בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 368.1,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 2.3,
    "YearYield": 2.3,
    "Last12MonthYield": null,
    "ISIN": "IL0010952237"
  },
  {
    "Id": "BLRX.TA",
    "MayaId": "1101518",
    "Name": "BIOLINE RX",
    "ShortName": "BIOLINE RX LTD.",
    "Symbol": "BLRX.TA",
    "TaseSymbol": "BLRX",
    "YahooId": "BLRX.TA",
    "EnglishName": "BIOLINE RX",
    "EnglishLongName": "BIOLINE RX LTD.",
    "HebrewName": "ביוליין",
    "HebrewLongName": "ביוליין אר אקס בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1.5,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -6.3,
    "YearYield": -6.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011015182"
  },
  {
    "Id": "BIRM.TA",
    "MayaId": "530014",
    "Name": "BIRMAN",
    "ShortName": "BIRMAN WOOD AND HARDWARE LTD.",
    "Symbol": "BIRM.TA",
    "TaseSymbol": "BIRM",
    "YahooId": "BIRM.TA",
    "EnglishName": "BIRMAN",
    "EnglishLongName": "BIRMAN WOOD AND HARDWARE LTD.",
    "HebrewName": "בירמן",
    "HebrewLongName": "בירמן עצים ופרזול בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1000.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -9.6,
    "YearYield": -9.6,
    "Last12MonthYield": null,
    "ISIN": "IL0005300145"
  },
  {
    "Id": "BLEG.TA",
    "MayaId": "1172337",
    "Name": "BLACKEDGE",
    "ShortName": "BLACKEDGE LTD",
    "Symbol": "BLEG.TA",
    "TaseSymbol": "BLEG",
    "YahooId": "BLEG.TA",
    "EnglishName": "BLACKEDGE",
    "EnglishLongName": "BLACKEDGE LTD",
    "HebrewName": "בלאקאדג'",
    "HebrewLongName": "בלאקאדג' בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 36000.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Financial Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 4.0,
    "YearYield": 4.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011723371"
  },
  {
    "Id": "BLRN.TA",
    "MayaId": "1170513",
    "Name": "BLADE RANGER",
    "ShortName": "BLADERANGER LTD",
    "Symbol": "BLRN.TA",
    "TaseSymbol": "BLRN",
    "YahooId": "BLRN.TA",
    "EnglishName": "BLADE RANGER",
    "EnglishLongName": "BLADERANGER LTD",
    "HebrewName": "בלייד ריינג'ר",
    "HebrewLongName": "בלייד ריינג'ר בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 61.5,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 17.5,
    "YearYield": 17.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011705139"
  },
  {
    "Id": "BLND.TA",
    "MayaId": "1172097",
    "Name": "BLENDER",
    "ShortName": "BLENDER FINANCIAL TECHLOGIES LTD",
    "Symbol": "BLND.TA",
    "TaseSymbol": "BLND",
    "YahooId": "BLND.TA",
    "EnglishName": "BLENDER",
    "EnglishLongName": "BLENDER FINANCIAL TECHLOGIES LTD",
    "HebrewName": "בלנדר",
    "HebrewLongName": "בלנדר טכנולוגיות פיננסיות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 541.4,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 4.4,
    "YearYield": 4.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011720971"
  },
  {
    "Id": "BLITZ-M.TA",
    "MayaId": "424010",
    "Name": "BLITZ M",
    "ShortName": "BLITZ TECHNOLOGIES LTD",
    "Symbol": "BLITZ-M.TA",
    "TaseSymbol": "BLITZ-M",
    "YahooId": "BLITZ-M.TA",
    "EnglishName": "BLITZ-M",
    "EnglishLongName": "BLITZ TECHNOLOGIES LTD",
    "HebrewName": "בליץ-ש",
    "HebrewLongName": "בליץ טכנולוגיות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 562.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 8.6,
    "YearYield": 8.6,
    "Last12MonthYield": null,
    "ISIN": "IL0004240102"
  },
  {
    "Id": "BLSR.TA",
    "MayaId": "1098565",
    "Name": "BLUE SQ REAL ES",
    "ShortName": "BLUE SQUARE REAL ESTATE LTD",
    "Symbol": "BLSR.TA",
    "TaseSymbol": "BLSR",
    "YahooId": "BLSR.TA",
    "EnglishName": "BLUE SQ REAL ES",
    "EnglishLongName": "BLUE SQUARE REAL ESTATE LTD",
    "HebrewName": "רבוע נדלן",
    "HebrewLongName": "רבוע כחול נדל\"ן בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 45030.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 17.2,
    "YearYield": 17.2,
    "Last12MonthYield": null,
    "ISIN": "IL0010985658"
  },
  {
    "Id": "BLWV-M.TA",
    "MayaId": "1096890",
    "Name": "BLUE WAVE M",
    "ShortName": "BLUE WAVE WATER CAPITAL LTD",
    "Symbol": "BLWV-M.TA",
    "TaseSymbol": "BLWV-M",
    "YahooId": "BLWV-M.TA",
    "EnglishName": "BLUE WAVE-M",
    "EnglishLongName": "BLUE WAVE WATER CAPITAL LTD",
    "HebrewName": "בלו וייב-ש",
    "HebrewLongName": "בלו וייב וואטר קפיטל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 250.9,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 25.6,
    "YearYield": 25.6,
    "Last12MonthYield": null,
    "ISIN": "IL0010968902"
  },
  {
    "Id": "TASE:5138912",
    "MayaId": "5138912",
    "Name": "bmeniv flex",
    "ShortName": "bmeniv flex",
    "Symbol": "TASE:5138912",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "bmeniv (4D) flex trust fund",
    "EnglishLongName": "bmeniv (4D) flex trust fund",
    "HebrewName": "bmeniv גמישה",
    "HebrewLongName": "bmeniv י(4D) גמישה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.3,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.03,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 19.2,
    "MonthYield": 4.28,
    "YearYield": 4.28,
    "Last12MonthYield": 22.55,
    "ISIN": "IL0051389125"
  },
  {
    "Id": "TASE:751",
    "MayaId": "751",
    "Name": "Bond Max one year maturity",
    "ShortName": "Bond Max one year maturity",
    "Symbol": "TASE:751",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Bond Max one year maturity",
    "EnglishLongName": "Bond Max one year maturity",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "BOTI.TA",
    "MayaId": "531012",
    "Name": "BONEI TICHON",
    "ShortName": "BONEI HATICHON CIVIL ENGINEERING & INFRASTRUCTURES LTD.",
    "Symbol": "BOTI.TA",
    "TaseSymbol": "BOTI",
    "YahooId": "BOTI.TA",
    "EnglishName": "BONEI TICHON",
    "EnglishLongName": "BONEI HATICHON CIVIL ENGINEERING & INFRASTRUCTURES LTD.",
    "HebrewName": "בוני תיכון",
    "HebrewLongName": "בוני התיכון הנדסה אזרחית ותשתיות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3409.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 3.5,
    "YearYield": 3.5,
    "Last12MonthYield": null,
    "ISIN": "IL0005310128"
  },
  {
    "Id": "BONS.TA",
    "MayaId": "485011",
    "Name": "BONUS BIOGROUP",
    "ShortName": "BONUS BIOGROUP LTD.",
    "Symbol": "BONS.TA",
    "TaseSymbol": "BONS",
    "YahooId": "BONS.TA",
    "EnglishName": "BONUS BIOGROUP",
    "EnglishLongName": "BONUS BIOGROUP LTD.",
    "HebrewName": "בונוס ביוגרופ",
    "HebrewLongName": "בונוס ביוגרופ בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 49.4,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 103.2,
    "YearYield": 103.2,
    "Last12MonthYield": null,
    "ISIN": "IL0004850116"
  },
  {
    "Id": "BWAY.TA",
    "MayaId": "1100718",
    "Name": "BRAINSWAY",
    "ShortName": "BRAINSWAY LTD.",
    "Symbol": "BWAY.TA",
    "TaseSymbol": "BWAY",
    "YahooId": "BWAY.TA",
    "EnglishName": "BRAINSWAY",
    "EnglishLongName": "BRAINSWAY LTD.",
    "HebrewName": "בריינסוויי",
    "HebrewLongName": "בריינסוויי בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3453.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 13.6,
    "YearYield": 13.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011007189"
  },
  {
    "Id": "BRAM.TA",
    "MayaId": "1094515",
    "Name": "BRAM INDUS",
    "ShortName": "BRAM INDUSTRIES LTD",
    "Symbol": "BRAM.TA",
    "TaseSymbol": "BRAM",
    "YahooId": "BRAM.TA",
    "EnglishName": "BRAM INDUS",
    "EnglishLongName": "BRAM INDUSTRIES LTD",
    "HebrewName": "ברם תעשיות",
    "HebrewLongName": "ברם תעשיות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 131.5,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 22.8,
    "YearYield": 22.8,
    "Last12MonthYield": null,
    "ISIN": "IL0010945157"
  },
  {
    "Id": "BRND.TA",
    "MayaId": "536011",
    "Name": "BRAND",
    "ShortName": "BRAND GROUP(M.G) LTD",
    "Symbol": "BRND.TA",
    "TaseSymbol": "BRND",
    "YahooId": "BRND.TA",
    "EnglishName": "BRAND",
    "EnglishLongName": "BRAND GROUP(M.G) LTD",
    "HebrewName": "ברנד",
    "HebrewLongName": "קבוצת ברנד (מ.ג) בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 277.5,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 12.5,
    "YearYield": 12.5,
    "Last12MonthYield": null,
    "ISIN": "IL0005360115"
  },
  {
    "Id": "BRIL.TA",
    "MayaId": "399014",
    "Name": "BRILL",
    "ShortName": "BRILL SHOE INDUSTRIES LTD.",
    "Symbol": "BRIL.TA",
    "TaseSymbol": "BRIL",
    "YahooId": "BRIL.TA",
    "EnglishName": "BRILL",
    "EnglishLongName": "BRILL SHOE INDUSTRIES LTD.",
    "HebrewName": "בריל",
    "HebrewLongName": "בריל תעשיות נעליים  בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1594.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 35.6,
    "YearYield": 35.6,
    "Last12MonthYield": null,
    "ISIN": "IL0003990145"
  },
  {
    "Id": "BRMG.TA",
    "MayaId": "1094283",
    "Name": "BRIMAG",
    "ShortName": "BRIMAG DIGITAL AGE LTD",
    "Symbol": "BRMG.TA",
    "TaseSymbol": "BRMG",
    "YahooId": "BRMG.TA",
    "EnglishName": "BRIMAG",
    "EnglishLongName": "BRIMAG DIGITAL AGE LTD",
    "HebrewName": "ברימאג",
    "HebrewLongName": "ברימאג דיגיטל אייג' בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2355.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 3.7,
    "YearYield": 3.7,
    "Last12MonthYield": null,
    "ISIN": "IL0010942832"
  },
  {
    "Id": "TASE:5122676",
    "MayaId": "5122676",
    "Name": "BRK ASTRATGYOT",
    "ShortName": "BRK ASTRATGYOT",
    "Symbol": "TASE:5122676",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "BARAK (6F) STRATEGIES - LEVERAGED FUND",
    "EnglishLongName": "BARAK (6F) STRATEGIES - LEVERAGED FUND",
    "HebrewName": "ברק 6F אסטרטגיות",
    "HebrewLongName": "ברק (6F) אסטרטגיות – קרן ממונפת",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 3.8,
    "TrusteeFee": 0.1,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": true,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 5.42,
    "Sector": "",
    "Industry": "",
    "ManagerName": "BARAK MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Leveraged and Strategic",
    "SecondaryClassification": "Leveraged, High-Risk",
    "AssetValue": 28.3,
    "MonthYield": 22.47,
    "YearYield": 22.47,
    "Last12MonthYield": 77.65,
    "ISIN": "IL0051226764"
  },
  {
    "Id": "TASE:5130240",
    "MayaId": "5130240",
    "Name": "BRK FLEXIBLE",
    "ShortName": "BRK FLEXIBLE",
    "Symbol": "TASE:5130240",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "BARAK (4D) FLEXIBLE",
    "EnglishLongName": "BARAK (4D) FLEXIBLE",
    "HebrewName": "ברק גמישה",
    "HebrewLongName": "ברק (4D) גמישה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.8,
    "TrusteeFee": 0.1,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.06,
    "Sector": "",
    "Industry": "",
    "ManagerName": "BARAK MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 4.1,
    "MonthYield": 9.34,
    "YearYield": 9.34,
    "Last12MonthYield": 22.21,
    "ISIN": "IL0051302409"
  },
  {
    "Id": "TASE:5123302",
    "MayaId": "5123302",
    "Name": "BRM MNYT GLOBAL",
    "ShortName": "BRM MNYT GLOBAL",
    "Symbol": "TASE:5123302",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "BAROMETER (4D) GLOBAL STOCKS",
    "EnglishLongName": "BAROMETER (4D) GLOBAL STOCKS",
    "HebrewName": "ברומטר 4D מניות גלובלי",
    "HebrewLongName": "ברומטר (4D) מניות גלובאלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.48,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.88,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 171.0,
    "MonthYield": 0.86,
    "YearYield": 0.86,
    "Last12MonthYield": 5.75,
    "ISIN": "IL0051233026"
  },
  {
    "Id": "BBLS.TA",
    "MayaId": "1105139",
    "Name": "BUBBLES",
    "ShortName": "BUBBLES INTERGROUP LTD",
    "Symbol": "BBLS.TA",
    "TaseSymbol": "BBLS",
    "YahooId": "BBLS.TA",
    "EnglishName": "BUBBLES",
    "EnglishLongName": "BUBBLES INTERGROUP LTD",
    "HebrewName": "באבלס",
    "HebrewLongName": "באבלס אינטרגרופ בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 29.3,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 21.1,
    "YearYield": 21.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011051393"
  },
  {
    "Id": "BUFT.TA",
    "MayaId": "1179043",
    "Name": "BUFF TECH'",
    "ShortName": "BUFF TECHNOLOGIES",
    "Symbol": "BUFT.TA",
    "TaseSymbol": "BUFT",
    "YahooId": "BUFT.TA",
    "EnglishName": "BUFF TECH'",
    "EnglishLongName": "BUFF TECHNOLOGIES",
    "HebrewName": "באפ טכנו'",
    "HebrewLongName": "באפ טכנולוגיות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1009.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 2.8,
    "YearYield": 2.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011790438"
  },
  {
    "Id": "BLGO.TA",
    "MayaId": "1180595",
    "Name": "BULIGO",
    "ShortName": "BULIGO CAPITAL LTD",
    "Symbol": "BLGO.TA",
    "TaseSymbol": "BLGO",
    "YahooId": "BLGO.TA",
    "EnglishName": "BULIGO",
    "EnglishLongName": "BULIGO CAPITAL LTD",
    "HebrewName": "בוליגו",
    "HebrewLongName": "בוליגו קפיטל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1066.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 5.1,
    "YearYield": 5.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011805954"
  },
  {
    "Id": "TASE:5136254",
    "MayaId": "5136254",
    "Name": "Bull Market Investment",
    "ShortName": "Bull Market Investment",
    "Symbol": "TASE:5136254",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Bull Market (4D) Investment",
    "EnglishLongName": "Bull Market (4D) Investment",
    "HebrewName": "בול מרקט השקעות",
    "HebrewLongName": "בול מרקט (4D) השקעות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.5,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 16.5,
    "MonthYield": 5.45,
    "YearYield": 5.45,
    "Last12MonthYield": 33.63,
    "ISIN": "IL0051362544"
  },
  {
    "Id": "BULL-M.TA",
    "MayaId": "1176635",
    "Name": "BULL TRADING M",
    "ShortName": "BULL TRADING AND INVESTMENT LTD.",
    "Symbol": "BULL-M.TA",
    "TaseSymbol": "BULL-M",
    "YahooId": "BULL-M.TA",
    "EnglishName": "BULL TRADING-M",
    "EnglishLongName": "BULL TRADING AND INVESTMENT LTD.",
    "HebrewName": "בול מסחר-ש",
    "HebrewLongName": "בול מסחר והשקעות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4.7,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Financial Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -20.3,
    "YearYield": -20.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011766354"
  },
  {
    "Id": "CISY.TA",
    "MayaId": "442012",
    "Name": "C I SYSTEMS",
    "ShortName": "CI SYSTEMS (ISRAEL) LTD.",
    "Symbol": "CISY.TA",
    "TaseSymbol": "CISY",
    "YahooId": "CISY.TA",
    "EnglishName": "C I SYSTEMS",
    "EnglishLongName": "CI SYSTEMS (ISRAEL) LTD.",
    "HebrewName": "סיאי",
    "HebrewLongName": "סי אי סיסטמס (ישראל) בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4680.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.8,
    "YearYield": 1.8,
    "Last12MonthYield": null,
    "ISIN": "IL0004420126"
  },
  {
    "Id": "CLAB.TA",
    "MayaId": "1140300",
    "Name": "C LAB",
    "ShortName": "C-LAB LTD",
    "Symbol": "CLAB.TA",
    "TaseSymbol": "CLAB",
    "YahooId": "CLAB.TA",
    "EnglishName": "C-LAB",
    "EnglishLongName": "C-LAB LTD",
    "HebrewName": "סי-לאב",
    "HebrewLongName": "סי-לאב בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1169.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 24.2,
    "YearYield": 24.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011403008"
  },
  {
    "Id": "CAMT.TA",
    "MayaId": "1095264",
    "Name": "CAMTEK",
    "ShortName": "CAMTEK LTD.",
    "Symbol": "CAMT.TA",
    "TaseSymbol": "CAMT",
    "YahooId": "CAMT.TA",
    "EnglishName": "CAMTEK",
    "EnglishLongName": "CAMTEK LTD.",
    "HebrewName": "קמטק",
    "HebrewLongName": "קמטק בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 44310.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 32.8,
    "YearYield": 32.8,
    "Last12MonthYield": null,
    "ISIN": "IL0010952641"
  },
  {
    "Id": "CANF.TA",
    "MayaId": "1094473",
    "Name": "CAN FITE BIO",
    "ShortName": "CAN FITE BIOPHARMA LTD",
    "Symbol": "CANF.TA",
    "TaseSymbol": "CANF",
    "YahooId": "CANF.TA",
    "EnglishName": "CAN FITE BIO",
    "EnglishLongName": "CAN FITE BIOPHARMA LTD",
    "HebrewName": "כן פייט ביופרמה",
    "HebrewLongName": "כן פייט ביופרמה בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 650.1,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -77.3,
    "YearYield": -77.3,
    "Last12MonthYield": null,
    "ISIN": "IL0010944739"
  },
  {
    "Id": "CNGL.TA",
    "MayaId": "106013",
    "Name": "CANADA GLOBAL",
    "ShortName": "CANADA GLOBAL (T.R) LTD",
    "Symbol": "CNGL.TA",
    "TaseSymbol": "CNGL",
    "YahooId": "CNGL.TA",
    "EnglishName": "CANADA GLOBAL",
    "EnglishLongName": "CANADA GLOBAL (T.R) LTD",
    "HebrewName": "קנדה גלובל",
    "HebrewLongName": "קנדה גלובל (ט.ר) בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1075.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -1.5,
    "YearYield": -1.5,
    "Last12MonthYield": null,
    "ISIN": "IL0001060131"
  },
  {
    "Id": "CNZN-M.TA",
    "MayaId": "1096007",
    "Name": "CANZON M",
    "ShortName": "CANZON ISRAEL LTD",
    "Symbol": "CNZN-M.TA",
    "TaseSymbol": "CNZN-M",
    "YahooId": "CNZN-M.TA",
    "EnglishName": "CANZON-M",
    "EnglishLongName": "CANZON ISRAEL LTD",
    "HebrewName": "קנזון-ש",
    "HebrewLongName": "קנזון ישראל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 145.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Investment & Holdings",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 25.3,
    "YearYield": 25.3,
    "Last12MonthYield": null,
    "ISIN": "IL0010960073"
  },
  {
    "Id": "CPTP.TA",
    "MayaId": "1097146",
    "Name": "CAPITAL POINT",
    "ShortName": "CAPITAL POINT LTD",
    "Symbol": "CPTP.TA",
    "TaseSymbol": "CPTP",
    "YahooId": "CPTP.TA",
    "EnglishName": "CAPITAL POINT",
    "EnglishLongName": "CAPITAL POINT LTD",
    "HebrewName": "קפיטל פוינט",
    "HebrewLongName": "קפיטל פוינט בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 52.4,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 3.4,
    "YearYield": 3.4,
    "Last12MonthYield": null,
    "ISIN": "IL0010971468"
  },
  {
    "Id": "CRSM.TA",
    "MayaId": "1123850",
    "Name": "CARASSO MOTORS",
    "ShortName": "CARASSO MOTORS LTD",
    "Symbol": "CRSM.TA",
    "TaseSymbol": "CRSM",
    "YahooId": "CRSM.TA",
    "EnglishName": "CARASSO MOTORS",
    "EnglishLongName": "CARASSO MOTORS LTD",
    "HebrewName": "קרסו מוטורס",
    "HebrewLongName": "קרסו מוטורס בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3577.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 3.0,
    "YearYield": 3.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011238503"
  },
  {
    "Id": "CRSR.TA",
    "MayaId": "1187962",
    "Name": "CARASSO REAL ES",
    "ShortName": "CARASSO REAL ESTATE LTD",
    "Symbol": "CRSR.TA",
    "TaseSymbol": "CRSR",
    "YahooId": "CRSR.TA",
    "EnglishName": "CARASSO REAL ES",
    "EnglishLongName": "CARASSO REAL ESTATE LTD",
    "HebrewName": "קרסו נדלן",
    "HebrewLongName": "קרסו נדל\"ן בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3803.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 5.2,
    "YearYield": 5.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011879629"
  },
  {
    "Id": "CRML.TA",
    "MayaId": "1147685",
    "Name": "CARMEL CORP",
    "ShortName": "CARMEL CORP LTD",
    "Symbol": "CRML.TA",
    "TaseSymbol": "CRML",
    "YahooId": "CRML.TA",
    "EnglishName": "CARMEL CORP",
    "EnglishLongName": "CARMEL CORP LTD",
    "HebrewName": "כרמל קורפ",
    "HebrewLongName": "כרמל קורפ בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1838.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 8.1,
    "YearYield": 8.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011476855"
  },
  {
    "Id": "CRMT.TA",
    "MayaId": "440016",
    "Name": "CARMIT",
    "ShortName": "CARMIT CANDY INDUSTRIES LTD",
    "Symbol": "CRMT.TA",
    "TaseSymbol": "CRMT",
    "YahooId": "CRMT.TA",
    "EnglishName": "CARMIT",
    "EnglishLongName": "CARMIT CANDY INDUSTRIES LTD",
    "HebrewName": "כרמית",
    "HebrewLongName": "כרמית תעשיות ממתקים בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1173.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -1.4,
    "YearYield": -1.4,
    "Last12MonthYield": null,
    "ISIN": "IL0004400169"
  },
  {
    "Id": "CAST.TA",
    "MayaId": "280016",
    "Name": "CASTRO",
    "ShortName": "CASTRO MODEL LTD.",
    "Symbol": "CAST.TA",
    "TaseSymbol": "CAST",
    "YahooId": "CAST.TA",
    "EnglishName": "CASTRO",
    "EnglishLongName": "CASTRO MODEL LTD.",
    "HebrewName": "קסטרו",
    "HebrewLongName": "קסטרו מודל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 14350.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.7,
    "YearYield": 1.7,
    "Last12MonthYield": null,
    "ISIN": "IL0002800162"
  },
  {
    "Id": "TASE:5115050",
    "MayaId": "5115050",
    "Name": "CBN HASKAHOT",
    "ShortName": "CBN HASKAHOT",
    "Symbol": "TASE:5115050",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KABIN (6F) INVESTMENTS - LEVERAGED FUND",
    "EnglishLongName": "KABIN (6F) INVESTMENTS - LEVERAGED FUND",
    "HebrewName": "קבין 6F השקעות- ממונפת",
    "HebrewLongName": "קבין (6F) השקעות - קרן ממונפת",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.8,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": true,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.54,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Leveraged and Strategic",
    "SecondaryClassification": "Leveraged, High-Risk",
    "AssetValue": 27.8,
    "MonthYield": 8.1,
    "YearYield": 8.1,
    "Last12MonthYield": 27.35,
    "ISIN": "IL0051150501"
  },
  {
    "Id": "CEL.TA",
    "MayaId": "1101534",
    "Name": "CELLCOM",
    "ShortName": "CELLCOM ISRAEL LTD.",
    "Symbol": "CEL.TA",
    "TaseSymbol": "CEL",
    "YahooId": "CEL.TA",
    "EnglishName": "CELLCOM",
    "EnglishLongName": "CELLCOM ISRAEL LTD.",
    "HebrewName": "סלקום",
    "HebrewLongName": "סלקום ישראל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3563.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -1.1,
    "YearYield": -1.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011015349"
  },
  {
    "Id": "TASE:97",
    "MayaId": "97",
    "Name": "Chemical, Rubber & Plastic Shares and Convertibles",
    "ShortName": "Chemical, Rubber & Plastic Shares and Convertibles",
    "Symbol": "TASE:97",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Chemical, Rubber & Plastic Shares and Convertibles",
    "EnglishLongName": "Chemical, Rubber & Plastic Shares and Convertibles",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "CILO.TA",
    "MayaId": "1102532",
    "Name": "CIELO BLU",
    "ShortName": "CIELO-BLU GROUP LTD",
    "Symbol": "CILO.TA",
    "TaseSymbol": "CILO",
    "YahooId": "CILO.TA",
    "EnglishName": "CIELO-BLU",
    "EnglishLongName": "CIELO-BLU GROUP LTD",
    "HebrewName": "צילו-בלו",
    "HebrewLongName": "קבוצת צילו-בלו בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 328.8,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 13.6,
    "YearYield": 13.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011025322"
  },
  {
    "Id": "CION.TA",
    "MayaId": "1194000",
    "Name": "CION",
    "ShortName": "CION INVESTMENT CORPORATION",
    "Symbol": "CION.TA",
    "TaseSymbol": "CION",
    "YahooId": "CION.TA",
    "EnglishName": "CION",
    "EnglishLongName": "CION INVESTMENT CORPORATION",
    "HebrewName": "סיאון",
    "HebrewLongName": "סיאון אינווסטמנט קורפוריישן",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2857.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Financial Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.0,
    "YearYield": 0.0,
    "Last12MonthYield": null,
    "ISIN": "US17259U2042"
  },
  {
    "Id": "CPIA.TA",
    "MayaId": "1181932",
    "Name": "CIPIA VISION",
    "ShortName": "CIPIA VISION LTD",
    "Symbol": "CPIA.TA",
    "TaseSymbol": "CPIA",
    "YahooId": "CPIA.TA",
    "EnglishName": "CIPIA VISION",
    "EnglishLongName": "CIPIA VISION LTD",
    "HebrewName": "סיפיה וויז'ן",
    "HebrewLongName": "סיפיה וויז'ן בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 7.9,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 8.2,
    "YearYield": 8.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011819328"
  },
  {
    "Id": "CTPL5.TA",
    "MayaId": "716035",
    "Name": "CITRUS PLANT 5",
    "ShortName": "I.C.P. ISRAEL CITRUS PLANTATIONS LTD.",
    "Symbol": "CTPL5.TA",
    "TaseSymbol": "CTPL5",
    "YahooId": "CTPL5.TA",
    "EnglishName": "CITRUS PLANT 5",
    "EnglishLongName": "I.C.P. ISRAEL CITRUS PLANTATIONS LTD.",
    "HebrewName": "מטעי הדר 5",
    "HebrewLongName": "י.ס.פ. מטעי הדר ישראל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 115500.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.0,
    "YearYield": 0.0,
    "Last12MonthYield": null,
    "ISIN": "IL0007160356"
  },
  {
    "Id": "CTPL1.TA",
    "MayaId": "716019",
    "Name": "CITRUS PLANT1",
    "ShortName": "I.C.P. ISRAEL CITRUS PLANTATIONS LTD.",
    "Symbol": "CTPL1.TA",
    "TaseSymbol": "CTPL1",
    "YahooId": "CTPL1.TA",
    "EnglishName": "CITRUS PLANT1",
    "EnglishLongName": "I.C.P. ISRAEL CITRUS PLANTATIONS LTD.",
    "HebrewName": "מטעי הדר 1",
    "HebrewLongName": "י.ס.פ. מטעי הדר ישראל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 23160.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.0,
    "YearYield": 0.0,
    "Last12MonthYield": null,
    "ISIN": "IL0007160190"
  },
  {
    "Id": "CPPL.TA",
    "MayaId": "1198266",
    "Name": "CITY PEOPLE",
    "ShortName": "CITY PEOPLE OF ROTSHTEIN GROUP LTD",
    "Symbol": "CPPL.TA",
    "TaseSymbol": "CPPL",
    "YahooId": "CPPL.TA",
    "EnglishName": "CITY PEOPLE",
    "EnglishLongName": "CITY PEOPLE OF ROTSHTEIN GROUP LTD",
    "HebrewName": "אנשי העיר",
    "HebrewLongName": "אנשי העיר מקבוצת רוטשטיין בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 348.8,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 30.4,
    "YearYield": 30.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011982662"
  },
  {
    "Id": "CBI.TA",
    "MayaId": "1104280",
    "Name": "CLAL BIOTECH",
    "ShortName": "CLAL BIOTECHNOLOGY INDUSTRIES LTD",
    "Symbol": "CBI.TA",
    "TaseSymbol": "CBI",
    "YahooId": "CBI.TA",
    "EnglishName": "CLAL BIOTECH",
    "EnglishLongName": "CLAL BIOTECHNOLOGY INDUSTRIES LTD",
    "HebrewName": "כלל ביוטכנו",
    "HebrewLongName": "כלל תעשיות ביוטכנולוגיה בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 33.8,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 11.2,
    "YearYield": 11.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011042806"
  },
  {
    "Id": "CLIS.TA",
    "MayaId": "224014",
    "Name": "CLAL INSURANCE",
    "ShortName": "CLAL INSURANCE ENTERPRISES HOLDINGS LTD.",
    "Symbol": "CLIS.TA",
    "TaseSymbol": "CLIS",
    "YahooId": "CLIS.TA",
    "EnglishName": "CLAL INSURANCE",
    "EnglishLongName": "CLAL INSURANCE ENTERPRISES HOLDINGS LTD.",
    "HebrewName": "כלל עסקי ביטוח",
    "HebrewLongName": "כלל החזקות עסקי ביטוח בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 21620.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Insurance",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 7.0,
    "YearYield": 7.0,
    "Last12MonthYield": null,
    "ISIN": "IL0002240146"
  },
  {
    "Id": "CDEV.TA",
    "MayaId": "810010",
    "Name": "COHEN DEV",
    "ShortName": "COHEN DEVELOPMENT GAS & OIL LTD.",
    "Symbol": "CDEV.TA",
    "TaseSymbol": "CDEV",
    "YahooId": "CDEV.TA",
    "EnglishName": "COHEN DEV",
    "EnglishLongName": "COHEN DEVELOPMENT GAS & OIL LTD.",
    "HebrewName": "כהן פיתוח",
    "HebrewLongName": "כהן פיתוח גז ונפט בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 19350.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Energy And Oil & Gas Exploration",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 4.5,
    "YearYield": 4.5,
    "Last12MonthYield": null,
    "ISIN": "IL0008100104"
  },
  {
    "Id": "TASE:41",
    "MayaId": "41",
    "Name": "Commerce & Services Shares and Convertibles",
    "ShortName": "Commerce & Services Shares and Convertibles",
    "Symbol": "TASE:41",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Commerce & Services Shares and Convertibles",
    "EnglishLongName": "Commerce & Services Shares and Convertibles",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "CGEN.TA",
    "MayaId": "1085208",
    "Name": "COMPUGEN",
    "ShortName": "COMPUGEN LTD.",
    "Symbol": "CGEN.TA",
    "TaseSymbol": "CGEN",
    "YahooId": "CGEN.TA",
    "EnglishName": "COMPUGEN",
    "EnglishLongName": "COMPUGEN LTD.",
    "HebrewName": "קומפיוגן",
    "HebrewLongName": "קומפיוגן בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 715.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 60.7,
    "YearYield": 60.7,
    "Last12MonthYield": null,
    "ISIN": "IL0010852080"
  },
  {
    "Id": "CMDR.TA",
    "MayaId": "507012",
    "Name": "COMPUTER DIRECT",
    "ShortName": "COMPUTER DIRECT GROUP LTD.",
    "Symbol": "CMDR.TA",
    "TaseSymbol": "CMDR",
    "YahooId": "CMDR.TA",
    "EnglishName": "COMPUTER DIRECT",
    "EnglishLongName": "COMPUTER DIRECT GROUP LTD.",
    "HebrewName": "מיחשוב ישר קב",
    "HebrewLongName": "קבוצת מיחשוב ישיר בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 49490.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -2.3,
    "YearYield": -2.3,
    "Last12MonthYield": null,
    "ISIN": "IL0005070128"
  },
  {
    "Id": "CNTL-M.TA",
    "MayaId": "1182260",
    "Name": "CONTINUAL M",
    "ShortName": "CONTINUAL LTD.",
    "Symbol": "CNTL-M.TA",
    "TaseSymbol": "CNTL-M",
    "YahooId": "CNTL-M.TA",
    "EnglishName": "CONTINUAL-M",
    "EnglishLongName": "CONTINUAL LTD.",
    "HebrewName": "קונטיניואל-ש",
    "HebrewLongName": "קונטיניואל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 75.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Investment & Holdings",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -12.1,
    "YearYield": -12.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011822603"
  },
  {
    "Id": "TASE:4",
    "MayaId": "4",
    "Name": "Convertible Bonds",
    "ShortName": "Convertible Bonds",
    "Symbol": "TASE:4",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Convertible Bonds",
    "EnglishLongName": "Convertible Bonds",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:606",
    "MayaId": "606",
    "Name": "CPI Linked Corporate Bonds",
    "ShortName": "CPI-Linked Corporate Bonds",
    "Symbol": "TASE:606",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "CPI Linked Corporate Bonds",
    "EnglishLongName": "CPI-Linked Corporate Bonds",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:5108147",
    "MayaId": "5108147",
    "Name": "Cramim (2A) 85/15 IL",
    "ShortName": "Cramim (2A) 85/15 IL",
    "Symbol": "TASE:5108147",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Cramim (2A) 85/15 IL",
    "EnglishLongName": "Cramim (2A) 85/15 IL",
    "HebrewName": "כרמים (2A)י 15/85",
    "HebrewLongName": "כרמים (2A)י 15/85",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.42,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 15% Equity",
    "AssetValue": 71.3,
    "MonthYield": 1.66,
    "YearYield": 1.66,
    "Last12MonthYield": 14.6,
    "ISIN": "IL0051081474"
  },
  {
    "Id": "TASE:5141536",
    "MayaId": "5141536",
    "Name": "Cramim (2B) 70/30 IL",
    "ShortName": "Cramim (2B) 70/30 IL",
    "Symbol": "TASE:5141536",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Cramim (2B) 70/30 IL",
    "EnglishLongName": "Cramim (2B) 70/30 IL",
    "HebrewName": "כרמים (2B)י 30/70",
    "HebrewLongName": "כרמים (2B)י 30/70",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.85,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 6.9,
    "MonthYield": 2.88,
    "YearYield": 2.88,
    "Last12MonthYield": null,
    "ISIN": "IL0051415367"
  },
  {
    "Id": "TASE:5108162",
    "MayaId": "5108162",
    "Name": "Cramim Corporate Bonds IL",
    "ShortName": "Cramim Corporate Bonds IL",
    "Symbol": "TASE:5108162",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "CRAMIM (1A) (!) CORPORATE BONDS IL",
    "EnglishLongName": "CRAMIM (1A) (!) CORPORATE BONDS IL",
    "HebrewName": "כרמים אג\"ח חברות",
    "HebrewLongName": "כרמים (1A) (!) אג\"ח חברות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.45,
    "TrusteeFee": 0.045,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.38,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles with Equity",
    "AssetValue": 94.2,
    "MonthYield": 1.51,
    "YearYield": 1.51,
    "Last12MonthYield": 11.54,
    "ISIN": "IL0051081623"
  },
  {
    "Id": "TASE:5109079",
    "MayaId": "5109079",
    "Name": "Cramim Mdna Shiklit+10 IL",
    "ShortName": "Cramim Mdna Shiklit+10 IL",
    "Symbol": "TASE:5109079",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Cramim (1A) Medina Shiklit + 10% IL",
    "EnglishLongName": "Cramim (1A) Medina Shiklit + 10% IL",
    "HebrewName": "כרמים מדינה שקלית +10",
    "HebrewLongName": "כרמים (1A) מדינה שקלית + 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.045,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.8,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Shekel Bonds - Up to 10% Equity",
    "AssetValue": 71.6,
    "MonthYield": 1.7,
    "YearYield": 1.7,
    "Last12MonthYield": 14.2,
    "ISIN": "IL0051090798"
  },
  {
    "Id": "TASE:5115381",
    "MayaId": "5115381",
    "Name": "CRAMIM MED GOV CPILINK IL",
    "ShortName": "CRAMIM MED GOV CPILINK IL",
    "Symbol": "TASE:5115381",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "CRAMIM (00) MEDIUM GOVERNMENT CPI LINKED IL",
    "EnglishLongName": "CRAMIM (00) MEDIUM GOVERNMENT CPI LINKED IL",
    "HebrewName": "כרמים צמוד ממשלתי בינוני",
    "HebrewLongName": "כרמים (00) צמוד ממשלתי בינוני",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.1,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.13,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked Government Bonds - No Equity",
    "AssetValue": 0.6,
    "MonthYield": 0.08,
    "YearYield": 0.08,
    "Last12MonthYield": 3.22,
    "ISIN": "IL0051153810"
  },
  {
    "Id": "TASE:5108188",
    "MayaId": "5108188",
    "Name": "CRAMIM RTD LINK INDEX IL",
    "ShortName": "CRAMIM RTD LINK INDEX IL",
    "Symbol": "TASE:5108188",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "CRAMIM RATED LINKED INDEX (00) IL",
    "EnglishLongName": "CRAMIM RATED LINKED INDEX (00) IL",
    "HebrewName": "כרמים צמוד מדד מדורג",
    "HebrewLongName": "כרמים (00) צמוד מדד מדורג",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.35,
    "TrusteeFee": 0.045,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.27,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 43.2,
    "MonthYield": 0.25,
    "YearYield": 0.25,
    "Last12MonthYield": 5.91,
    "ISIN": "IL0051081888"
  },
  {
    "Id": "DANH.TA",
    "MayaId": "822015",
    "Name": "DAN HOTELS",
    "ShortName": "DAN HOTELS  LTD.",
    "Symbol": "DANH.TA",
    "TaseSymbol": "DANH",
    "YahooId": "DANH.TA",
    "EnglishName": "DAN   HOTELS",
    "EnglishLongName": "DAN HOTELS  LTD.",
    "HebrewName": "דן מלונות",
    "HebrewLongName": "מלונות דן בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3667.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 8.6,
    "YearYield": 8.6,
    "Last12MonthYield": null,
    "ISIN": "IL0008220159"
  },
  {
    "Id": "DANE.TA",
    "MayaId": "314013",
    "Name": "DANEL",
    "ShortName": "DANEL (ADIR YEOSHUA) LTD.",
    "Symbol": "DANE.TA",
    "TaseSymbol": "DANE",
    "YahooId": "DANE.TA",
    "EnglishName": "DANEL",
    "EnglishLongName": "DANEL (ADIR YEOSHUA) LTD.",
    "HebrewName": "דנאל",
    "HebrewLongName": "דנאל (אדיר יהושע) בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 44970.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -2.7,
    "YearYield": -2.7,
    "Last12MonthYield": null,
    "ISIN": "IL0003140139"
  },
  {
    "Id": "DNYA.TA",
    "MayaId": "1173137",
    "Name": "DANYA CEBUS",
    "ShortName": "DANYA CEBUS LTD.",
    "Symbol": "DNYA.TA",
    "TaseSymbol": "DNYA",
    "YahooId": "DNYA.TA",
    "EnglishName": "DANYA CEBUS",
    "EnglishLongName": "DANYA CEBUS LTD.",
    "HebrewName": "דניה סיבוס",
    "HebrewLongName": "דניה סיבוס בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 15150.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 9.8,
    "YearYield": 9.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011731374"
  },
  {
    "Id": "TASE:5139969",
    "MayaId": "5139969",
    "Name": "DCMS Glb Port UpTo30%Eqt",
    "ShortName": "DCMS Glb Port UpTo30%Eqt",
    "Symbol": "TASE:5139969",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "DCMS (2D) Global Portfolio Up To 30% Equity",
    "EnglishLongName": "DCMS (2D) Global Portfolio Up To 30% Equity",
    "HebrewName": "DCMSי תיק השק גלב עד30%מנ",
    "HebrewLongName": "DCMSי (2D) תיק השקעות גלובלי עד 30% מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.9,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.93,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Bond",
    "AssetValue": 14.2,
    "MonthYield": -0.46,
    "YearYield": -0.46,
    "Last12MonthYield": null,
    "ISIN": "IL0051399694"
  },
  {
    "Id": "DLEA.TA",
    "MayaId": "829010",
    "Name": "DELEK AUTOMOTIV",
    "ShortName": "DELEK AUTOMOTIVE SYSTEMS LTD.",
    "Symbol": "DLEA.TA",
    "TaseSymbol": "DLEA",
    "YahooId": "DLEA.TA",
    "EnglishName": "DELEK AUTOMOTIV",
    "EnglishLongName": "DELEK AUTOMOTIVE SYSTEMS LTD.",
    "HebrewName": "דלק רכב",
    "HebrewLongName": "דלק מערכות רכב בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2506.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 4.9,
    "YearYield": 4.9,
    "Last12MonthYield": null,
    "ISIN": "IL0008290103"
  },
  {
    "Id": "DLEKG.TA",
    "MayaId": "1084128",
    "Name": "DELEK GROUP",
    "ShortName": "DELEK GROUP LTD.",
    "Symbol": "DLEKG.TA",
    "TaseSymbol": "DLEKG",
    "YahooId": "DLEKG.TA",
    "EnglishName": "DELEK GROUP",
    "EnglishLongName": "DELEK GROUP LTD.",
    "HebrewName": "דלק קבוצה",
    "HebrewLongName": "קבוצת דלק בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 80600.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Energy And Oil & Gas Exploration",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -3.5,
    "YearYield": -3.5,
    "Last12MonthYield": null,
    "ISIN": "IL0010841281"
  },
  {
    "Id": "DLPR.TA",
    "MayaId": "1196211",
    "Name": "DELEK PROP",
    "ShortName": "DELEK ISRAEL PROPERTIES (D.P.) LTD",
    "Symbol": "DLPR.TA",
    "TaseSymbol": "DLPR",
    "YahooId": "DLPR.TA",
    "EnglishName": "DELEK PROP",
    "EnglishLongName": "DELEK ISRAEL PROPERTIES (D.P.) LTD",
    "HebrewName": "דלק נכסים",
    "HebrewLongName": "דלק ישראל נכסים (ד.פ.)בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5761.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -6.3,
    "YearYield": -6.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011962110"
  },
  {
    "Id": "DLTI.TA",
    "MayaId": "1173699",
    "Name": "DELTA BRANDS",
    "ShortName": "DELTA ISRAEL BRANDS LTD",
    "Symbol": "DLTI.TA",
    "TaseSymbol": "DLTI",
    "YahooId": "DLTI.TA",
    "EnglishName": "DELTA BRANDS",
    "EnglishLongName": "DELTA ISRAEL BRANDS LTD",
    "HebrewName": "דלתא מותגים",
    "HebrewLongName": "דלתא ישראל מותגים בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 13490.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 15.4,
    "YearYield": 15.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011736993"
  },
  {
    "Id": "DELG.TA",
    "MayaId": "627034",
    "Name": "DELTA GALIL",
    "ShortName": "DELTA-GALIL INDUSTRIES LTD.",
    "Symbol": "DELG.TA",
    "TaseSymbol": "DELG",
    "YahooId": "DELG.TA",
    "EnglishName": "DELTA GALIL",
    "EnglishLongName": "DELTA-GALIL INDUSTRIES LTD.",
    "HebrewName": "דלתא גליל",
    "HebrewLongName": "דלתא-גליל תעשיות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 16540.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -3.5,
    "YearYield": -3.5,
    "Last12MonthYield": null,
    "ISIN": "IL0006270347"
  },
  {
    "Id": "TASE:764",
    "MayaId": "764",
    "Name": "Deposit Backed Bonds",
    "ShortName": "Deposit Backed Bonds",
    "Symbol": "TASE:764",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Deposit Backed Bonds",
    "EnglishLongName": "Deposit Backed Bonds",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:5138771",
    "MayaId": "5138771",
    "Name": "DERECH BOND NO EQUITY",
    "ShortName": "DERECH BOND NO EQUITY",
    "Symbol": "TASE:5138771",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "DERECH (0A) BOND NO EQUITY KOSHER IL",
    "EnglishLongName": "DERECH (0A) BOND NO EQUITY KOSHER IL",
    "HebrewName": "דרך אג\"ח ללא מניות",
    "HebrewLongName": "דרך (0A) אג\"ח ללא מניות כשרה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.19,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 29.6,
    "MonthYield": 0.48,
    "YearYield": 0.48,
    "Last12MonthYield": 5.73,
    "ISIN": "IL0051387715"
  },
  {
    "Id": "TASE:5131461",
    "MayaId": "5131461",
    "Name": "DERECH VALUE STOCKS KOSH",
    "ShortName": "DERECH VALUE STOCKS KOSH",
    "Symbol": "TASE:5131461",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "DERECH (4D) VALUE STOCKS KOSHER",
    "EnglishLongName": "DERECH (4D) VALUE STOCKS KOSHER",
    "HebrewName": "דרך מניות ערך כשר",
    "HebrewLongName": "דרך (4D) מניות ערך כשר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.85,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.42,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 20.1,
    "MonthYield": -0.7,
    "YearYield": -0.7,
    "Last12MonthYield": 0.96,
    "ISIN": "IL0051314610"
  },
  {
    "Id": "TASE:5134291",
    "MayaId": "5134291",
    "Name": "Diamond (1B) 90/10 IL",
    "ShortName": "Diamond (1B) 90/10 IL",
    "Symbol": "TASE:5134291",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Diamond (1B) 90/10 IL",
    "EnglishLongName": "Diamond (1B) 90/10 IL",
    "HebrewName": "דיאמונד (1B)י 10/90",
    "HebrewLongName": "דיאמונד (1B)י 10/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.7,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 23.0,
    "MonthYield": 1.61,
    "YearYield": 1.61,
    "Last12MonthYield": 12.85,
    "ISIN": "IL0051342918"
  },
  {
    "Id": "TASE:5131958",
    "MayaId": "5131958",
    "Name": "Diamond (2B) 30/70 IL",
    "ShortName": "Diamond (2B) 30/70 IL",
    "Symbol": "TASE:5131958",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Diamond (2B) 30/70 IL",
    "EnglishLongName": "Diamond (2B) 30/70 IL",
    "HebrewName": "דיאמונד (2B)י 30/70",
    "HebrewLongName": "דיאמונד (2B)י 30/70",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.99,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 75.9,
    "MonthYield": 2.67,
    "YearYield": 2.67,
    "Last12MonthYield": 22.93,
    "ISIN": "IL0051319585"
  },
  {
    "Id": "TASE:5118435",
    "MayaId": "5118435",
    "Name": "Diamond 80/20 Kosher IL",
    "ShortName": "Diamond 80/20 Kosher IL",
    "Symbol": "TASE:5118435",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Diamond (2B) 80/20 Kosher IL",
    "EnglishLongName": "Diamond (2B) 80/20 Kosher IL",
    "HebrewName": "דיאמונד 20/80 כשרה",
    "HebrewLongName": "דיאמונד (2B)י 20/80 כשרה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.39,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.52,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 50.6,
    "MonthYield": 1.96,
    "YearYield": 1.96,
    "Last12MonthYield": 12.07,
    "ISIN": "IL0051184351"
  },
  {
    "Id": "TASE:5119862",
    "MayaId": "5119862",
    "Name": "Diamond Bnd Or Hahaim IL",
    "ShortName": "Diamond Bnd Or Hahaim IL",
    "Symbol": "TASE:5119862",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Diamond (0A) Bonds Without Stocks Or Hachaim IL",
    "EnglishLongName": "Diamond (0A) Bonds Without Stocks Or Hachaim IL",
    "HebrewName": "דיאמונד אג\"ח אור החיים",
    "HebrewLongName": "דיאמונד (0A) אג\"ח ללא מניות אור החיים",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.41,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 478.0,
    "MonthYield": 0.76,
    "YearYield": 0.76,
    "Last12MonthYield": 9.06,
    "ISIN": "IL0051198625"
  },
  {
    "Id": "TASE:5139035",
    "MayaId": "5139035",
    "Name": "Diamond FGE Prt FIBI Bank",
    "ShortName": "Diamond FGE Prt FIBI Bank",
    "Symbol": "TASE:5139035",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Diamond (4D) Following Global Equity Portfolio- FIBI Bank",
    "EnglishLongName": "Diamond (4D) Following Global Equity Portfolio- FIBI Bank",
    "HebrewName": "דיאמונד עוקב ת מנ חול ביל",
    "HebrewLongName": "דיאמונד (4D) עוקבת תיק מניות חו\"ל – הבנק הבינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.25,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.51,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 2.7,
    "MonthYield": 1.4,
    "YearYield": 1.4,
    "Last12MonthYield": 5.6,
    "ISIN": "IL0051390354"
  },
  {
    "Id": "TASE:5136684",
    "MayaId": "5136684",
    "Name": "Diamond Shk Bd 06/27 IL",
    "ShortName": "Diamond Shk Bd 06/27 IL",
    "Symbol": "TASE:5136684",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Diamond (00) Shekel Bonds to Maturity Up To 06/2027 IL",
    "EnglishLongName": "Diamond (00) Shekel Bonds to Maturity Up To 06/2027 IL",
    "HebrewName": "דיאמונד אג שק פדיון 06/27",
    "HebrewLongName": "דיאמונד (00) אג\"ח שקלי לפדיון עד 06/2027",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.12,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 89.8,
    "MonthYield": 0.38,
    "YearYield": 0.38,
    "Last12MonthYield": 5.15,
    "ISIN": "IL0051366842"
  },
  {
    "Id": "TASE:5136304",
    "MayaId": "5136304",
    "Name": "Diamond Strtgy Kosher Inv",
    "ShortName": "Diamond Strtgy Kosher Inv",
    "Symbol": "TASE:5136304",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Diamond (5E) Kosher Strategy Investments",
    "EnglishLongName": "Diamond (5E) Kosher Strategy Investments",
    "HebrewName": "דיאמונד אסטרטג השקעות כשר",
    "HebrewLongName": "דיאמונד (5E) אסטרטגיות השקעות כשרות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.8,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.26,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Leveraged and Strategic",
    "SecondaryClassification": "Strategic (not leveraged)",
    "AssetValue": 14.5,
    "MonthYield": 8.0,
    "YearYield": 8.0,
    "Last12MonthYield": 29.28,
    "ISIN": "IL0051363047"
  },
  {
    "Id": "TASE:5116736",
    "MayaId": "5116736",
    "Name": "Diamond TA 125 Equity IL",
    "ShortName": "Diamond TA 125 Equity IL",
    "Symbol": "TASE:5116736",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Diamond (4A) TA 125 Equity IL",
    "EnglishLongName": "Diamond (4A) TA 125 Equity IL",
    "HebrewName": "דיאמונד מניות ת\"א 125",
    "HebrewLongName": "דיאמונד (4A) מניות ת\"א 125",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.3,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 31.7,
    "MonthYield": 9.79,
    "YearYield": 9.79,
    "Last12MonthYield": 59.54,
    "ISIN": "IL0051167364"
  },
  {
    "Id": "DIMRI.TA",
    "MayaId": "1090315",
    "Name": "DIMRI",
    "ShortName": "Y.H.DIMRI CONTRUCTION & DEVELOPMENT LTD",
    "Symbol": "DIMRI.TA",
    "TaseSymbol": "DIMRI",
    "YahooId": "DIMRI.TA",
    "EnglishName": "DIMRI",
    "EnglishLongName": "Y.H.DIMRI CONTRUCTION & DEVELOPMENT LTD",
    "HebrewName": "דמרי",
    "HebrewLongName": "י.ח.דמרי בניה ופיתוח בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 41980.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 13.9,
    "YearYield": 13.9,
    "Last12MonthYield": null,
    "ISIN": "IL0010903156"
  },
  {
    "Id": "DIPL.TA",
    "MayaId": "1173491",
    "Name": "DIPLOMAT HOLDI.",
    "ShortName": "DIPLOMAT HOLDINGS LTD",
    "Symbol": "DIPL.TA",
    "TaseSymbol": "DIPL",
    "YahooId": "DIPL.TA",
    "EnglishName": "DIPLOMAT HOLDI.",
    "EnglishLongName": "DIPLOMAT HOLDINGS LTD",
    "HebrewName": "דיפלומט אחזקות",
    "HebrewLongName": "דיפלומט אחזקות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5091.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 4.8,
    "YearYield": 4.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011734915"
  },
  {
    "Id": "DIFI.TA",
    "MayaId": "1168186",
    "Name": "DIRECT FINANCE",
    "ShortName": "DIRECT FINANCE OF DIRECT GROUP (2006) LTD",
    "Symbol": "DIFI.TA",
    "TaseSymbol": "DIFI",
    "YahooId": "DIFI.TA",
    "EnglishName": "DIRECT FINANCE",
    "EnglishLongName": "DIRECT FINANCE OF DIRECT GROUP (2006) LTD",
    "HebrewName": "מימון ישיר",
    "HebrewLongName": "מימון ישיר מקבוצת ישיר (2006) בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 50550.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Financial Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -7.5,
    "YearYield": -7.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011681868"
  },
  {
    "Id": "DSCT.TA",
    "MayaId": "691212",
    "Name": "DISCOUNT",
    "ShortName": "ISRAEL DISCOUNT BANK LTD.",
    "Symbol": "DSCT.TA",
    "TaseSymbol": "DSCT",
    "YahooId": "DSCT.TA",
    "EnglishName": "DISCOUNT",
    "EnglishLongName": "ISRAEL DISCOUNT BANK LTD.",
    "HebrewName": "דיסקונט       א",
    "HebrewLongName": "בנק דיסקונט לישראל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3622.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Banks",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 9.2,
    "YearYield": 9.2,
    "Last12MonthYield": null,
    "ISIN": "IL0006912120"
  },
  {
    "Id": "DISI.TA",
    "MayaId": "639013",
    "Name": "DISCOUNT INV",
    "ShortName": "DISCOUNT INVESTMENT CORP. LTD.",
    "Symbol": "DISI.TA",
    "TaseSymbol": "DISI",
    "YahooId": "DISI.TA",
    "EnglishName": "DISCOUNT INV",
    "EnglishLongName": "DISCOUNT INVESTMENT CORP. LTD.",
    "HebrewName": "דיסקונט השקעות",
    "HebrewLongName": "חברת השקעות דיסקונט בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 939.4,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.5,
    "YearYield": 1.5,
    "Last12MonthYield": null,
    "ISIN": "IL0006390137"
  },
  {
    "Id": "TASE:5127279",
    "MayaId": "5127279",
    "Name": "DLF GMISHA",
    "ShortName": "DLF GMISHA",
    "Symbol": "TASE:5127279",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Dolphin (4D) Flexible",
    "EnglishLongName": "Dolphin (4D) Flexible",
    "HebrewName": "דולפין 4D גמישה",
    "HebrewLongName": "דולפין (4D) גמישה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.9,
    "TrusteeFee": 0.045,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.19,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 77.4,
    "MonthYield": 4.03,
    "YearYield": 4.03,
    "Last12MonthYield": 17.59,
    "ISIN": "IL0051272792"
  },
  {
    "Id": "TASE:5123609",
    "MayaId": "5123609",
    "Name": "DMN GMISA",
    "ShortName": "DMN GMISA",
    "Symbol": "TASE:5123609",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "DIAMOND (4D) FLEXIBLE",
    "EnglishLongName": "DIAMOND (4D) FLEXIBLE",
    "HebrewName": "דיאמונד 4D גמישה",
    "HebrewLongName": "דיאמונד (4D) גמישה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.64,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.96,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 272.9,
    "MonthYield": 5.78,
    "YearYield": 5.78,
    "Last12MonthYield": 37.07,
    "ISIN": "IL0051236094"
  },
  {
    "Id": "TASE:5128509",
    "MayaId": "5128509",
    "Name": "DMN MNY GLOBALI",
    "ShortName": "DMN MNY GLOBALI",
    "Symbol": "TASE:5128509",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "DIAMOND (4D) GLOBAL STOCKS",
    "EnglishLongName": "DIAMOND (4D) GLOBAL STOCKS",
    "HebrewName": "דיאמונד מניות גלובאלי",
    "HebrewLongName": "דיאמונד (4D) מניות גלובאלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.44,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.94,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 14.7,
    "MonthYield": 1.52,
    "YearYield": 1.52,
    "Last12MonthYield": 7.57,
    "ISIN": "IL0051285091"
  },
  {
    "Id": "TASE:5139456",
    "MayaId": "5139456",
    "Name": "Dolphin (!) Corp Bonds IL",
    "ShortName": "Dolphin (!) Corp Bonds IL",
    "Symbol": "TASE:5139456",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Dolphin (0B)(!) Corporate Bonds IL",
    "EnglishLongName": "Dolphin (0B)(!) Corporate Bonds IL",
    "HebrewName": "דולפין (!) אג\"ח חברות",
    "HebrewLongName": "דולפין (0B)(!) אג\"ח חברות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.52,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 16.3,
    "MonthYield": 0.8,
    "YearYield": 0.8,
    "Last12MonthYield": 2.25,
    "ISIN": "IL0051394562"
  },
  {
    "Id": "TASE:5139472",
    "MayaId": "5139472",
    "Name": "Dolphin (2B) 70/30 IL",
    "ShortName": "Dolphin (2B) 70/30 IL",
    "Symbol": "TASE:5139472",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Dolphin (2B) 70/30 IL",
    "EnglishLongName": "Dolphin (2B) 70/30 IL",
    "HebrewName": "דולפין (2B)י 30/70",
    "HebrewLongName": "דולפין (2B)י 30/70",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.76,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 13.1,
    "MonthYield": 2.57,
    "YearYield": 2.57,
    "Last12MonthYield": 14.29,
    "ISIN": "IL0051394729"
  },
  {
    "Id": "TASE:5133707",
    "MayaId": "5133707",
    "Name": "Dolphin 75/25 IL",
    "ShortName": "Dolphin 75/25 IL",
    "Symbol": "TASE:5133707",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Dolphin (2B) 75/25 IL",
    "EnglishLongName": "Dolphin (2B) 75/25 IL",
    "HebrewName": "דולפין 25/75",
    "HebrewLongName": "דולפין (2B)י 25/75",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.57,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 25% Equity",
    "AssetValue": 336.7,
    "MonthYield": 1.88,
    "YearYield": 1.88,
    "Last12MonthYield": 14.2,
    "ISIN": "IL0051337074"
  },
  {
    "Id": "TASE:5136429",
    "MayaId": "5136429",
    "Name": "Dolphin 80/20 IL",
    "ShortName": "Dolphin 80/20 IL",
    "Symbol": "TASE:5136429",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Dolphin (2B) 80/20 IL",
    "EnglishLongName": "Dolphin (2B) 80/20 IL",
    "HebrewName": "דולפין 20/80",
    "HebrewLongName": "דולפין (2B)י 20/80",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.49,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 277.9,
    "MonthYield": 1.58,
    "YearYield": 1.58,
    "Last12MonthYield": 12.72,
    "ISIN": "IL0051364292"
  },
  {
    "Id": "TASE:5123328",
    "MayaId": "5123328",
    "Name": "Dolphin 90/10 IL",
    "ShortName": "Dolphin 90/10 IL",
    "Symbol": "TASE:5123328",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Dolphin (1B) 90/10 IL",
    "EnglishLongName": "Dolphin (1B) 90/10 IL",
    "HebrewName": "דולפין 10/90",
    "HebrewLongName": "דולפין (1B)י 10/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.4,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 2527.0,
    "MonthYield": 1.15,
    "YearYield": 1.15,
    "Last12MonthYield": 9.3,
    "ISIN": "IL0051233281"
  },
  {
    "Id": "TASE:5137708",
    "MayaId": "5137708",
    "Name": "Dolphin Bond no Equity IL",
    "ShortName": "Dolphin Bond no Equity IL",
    "Symbol": "TASE:5137708",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Dolphin (0B) Bonds without Equity IL",
    "EnglishLongName": "Dolphin (0B) Bonds without Equity IL",
    "HebrewName": "דולפין אג\"ח ללא מניות",
    "HebrewLongName": "דולפין (0B) אג\"ח ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.72,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 11.7,
    "MonthYield": 0.63,
    "YearYield": 0.63,
    "Last12MonthYield": 5.48,
    "ISIN": "IL0051377088"
  },
  {
    "Id": "TASE:5140496",
    "MayaId": "5140496",
    "Name": "Dolphin Flex Portfolio",
    "ShortName": "Dolphin Flex Portfolio",
    "Symbol": "TASE:5140496",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Dolphin (4D) Flexible Portfolio",
    "EnglishLongName": "Dolphin (4D) Flexible Portfolio",
    "HebrewName": "דולפין תיק השקעות גמיש",
    "HebrewLongName": "דולפין (4D) תיק השקעות גמיש",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.2,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.13,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 12.9,
    "MonthYield": 3.66,
    "YearYield": 3.66,
    "Last12MonthYield": null,
    "ISIN": "IL0051404965"
  },
  {
    "Id": "TASE:5138615",
    "MayaId": "5138615",
    "Name": "Dolphin Global Equity",
    "ShortName": "Dolphin Global Equity",
    "Symbol": "TASE:5138615",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Dolphin (4D) Global Equity",
    "EnglishLongName": "Dolphin (4D) Global Equity",
    "HebrewName": "דולפין מניות חו\"ל",
    "HebrewLongName": "דולפין (4D) מניות חו\"ל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.45,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 16.6,
    "MonthYield": 2.66,
    "YearYield": 2.66,
    "Last12MonthYield": 21.62,
    "ISIN": "IL0051386154"
  },
  {
    "Id": "TASE:5141809",
    "MayaId": "5141809",
    "Name": "Dolphin L&M Cap Equity IL",
    "ShortName": "Dolphin L&M Cap Equity IL",
    "Symbol": "TASE:5141809",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Dolphin (4B) Large & Mid Cap Equity IL",
    "EnglishLongName": "Dolphin (4B) Large & Mid Cap Equity IL",
    "HebrewName": "דולפין מנ L&M Cap ישראל",
    "HebrewLongName": "דולפין (4B) מניות Large & Mid Cap ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.59,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 0.4,
    "MonthYield": 0.45,
    "YearYield": 0.45,
    "Last12MonthYield": null,
    "ISIN": "IL0051418098"
  },
  {
    "Id": "TASE:5138698",
    "MayaId": "5138698",
    "Name": "Dolphin MM Fund IL",
    "ShortName": "Dolphin MM Fund IL",
    "Symbol": "TASE:5138698",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Dolphin (00) Money Market Fund IL",
    "EnglishLongName": "Dolphin (00) Money Market Fund IL",
    "HebrewName": "דולפין כספית",
    "HebrewLongName": "דולפין (00) כספית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.149,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 5938.0,
    "MonthYield": 0.22,
    "YearYield": 0.22,
    "Last12MonthYield": 4.72,
    "ISIN": "IL0051386980"
  },
  {
    "Id": "TASE:5141098",
    "MayaId": "5141098",
    "Name": "Dolphin Shkl MoneyMrkt IL",
    "ShortName": "Dolphin Shkl MoneyMrkt IL",
    "Symbol": "TASE:5141098",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Dolphin (00) Shekel Money Market IL",
    "EnglishLongName": "Dolphin (00) Shekel Money Market IL",
    "HebrewName": "דולפין כספית שקלית",
    "HebrewLongName": "דולפין (00) כספית שקלית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.09,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 8.6,
    "MonthYield": 0.22,
    "YearYield": 0.22,
    "Last12MonthYield": null,
    "ISIN": "IL0051410988"
  },
  {
    "Id": "TASE:5128418",
    "MayaId": "5128418",
    "Name": "Dolphin Solid Bonds IL",
    "ShortName": "Dolphin Solid Bonds IL",
    "Symbol": "TASE:5128418",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Dolphin (0B) Solid Bonds IL",
    "EnglishLongName": "Dolphin (0B) Solid Bonds IL",
    "HebrewName": "דולפין אגח סולידית",
    "HebrewLongName": "דולפין (0B) אג\"ח סולידית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.045,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.26,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 79.7,
    "MonthYield": 0.39,
    "YearYield": 0.39,
    "Last12MonthYield": 6.51,
    "ISIN": "IL0051284185"
  },
  {
    "Id": "TASE:5123336",
    "MayaId": "5123336",
    "Name": "Dolphin Stocks IL",
    "ShortName": "Dolphin Stocks IL",
    "Symbol": "TASE:5123336",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Dolphin (4B) Stocks IL",
    "EnglishLongName": "Dolphin (4B) Stocks IL",
    "HebrewName": "דולפין מניות",
    "HebrewLongName": "דולפין (4B) מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.78,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.91,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 385.1,
    "MonthYield": 5.98,
    "YearYield": 5.98,
    "Last12MonthYield": 41.63,
    "ISIN": "IL0051233364"
  },
  {
    "Id": "TASE:5123716",
    "MayaId": "5123716",
    "Name": "Dolphin Yeter Shares IL",
    "ShortName": "Dolphin Yeter Shares IL",
    "Symbol": "TASE:5123716",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Dolphin (4B) Yeter - Rest of Shares IL",
    "EnglishLongName": "Dolphin (4B) Yeter - Rest of Shares IL",
    "HebrewName": "דולפין יתר",
    "HebrewLongName": "דולפין (4B) יתר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.85,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.83,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 174.9,
    "MonthYield": 4.18,
    "YearYield": 4.18,
    "Last12MonthYield": 20.03,
    "ISIN": "IL0051237167"
  },
  {
    "Id": "DRAL.TA",
    "MayaId": "1093202",
    "Name": "DOR ALON",
    "ShortName": "DOR ALON ENERGY IN ISRAEL (1988) LTD",
    "Symbol": "DRAL.TA",
    "TaseSymbol": "DRAL",
    "YahooId": "DRAL.TA",
    "EnglishName": "DOR ALON",
    "EnglishLongName": "DOR ALON ENERGY IN ISRAEL (1988) LTD",
    "HebrewName": "דור אלון",
    "HebrewLongName": "דור אלון אנרגיה בישראל (1988) בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 15450.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Energy And Oil & Gas Exploration",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -3.2,
    "YearYield": -3.2,
    "Last12MonthYield": null,
    "ISIN": "IL0010932023"
  },
  {
    "Id": "DORL.TA",
    "MayaId": "1166768",
    "Name": "DORAL ENERGY",
    "ShortName": "DORAL GROUP RENEWABLE ENERGY RESOURCES LTD",
    "Symbol": "DORL.TA",
    "TaseSymbol": "DORL",
    "YahooId": "DORL.TA",
    "EnglishName": "DORAL ENERGY",
    "EnglishLongName": "DORAL GROUP RENEWABLE ENERGY RESOURCES LTD",
    "HebrewName": "דוראל אנרגיה",
    "HebrewLongName": "קבוצת דוראל משאבי אנרגיה מתחדשת בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3693.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.1,
    "YearYield": 0.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011667685"
  },
  {
    "Id": "DRSH.TA",
    "MayaId": "1190628",
    "Name": "DORSEL HOLD",
    "ShortName": "DORSEL HOLDINGS LTD",
    "Symbol": "DRSH.TA",
    "TaseSymbol": "DRSH",
    "YahooId": "DRSH.TA",
    "EnglishName": "DORSEL HOLD",
    "EnglishLongName": "DORSEL HOLDINGS LTD",
    "HebrewName": "דורסל החז",
    "HebrewLongName": "דורסל החזקות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2339.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 3.4,
    "YearYield": 3.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011906281"
  },
  {
    "Id": "DUNI.TA",
    "MayaId": "400010",
    "Name": "DUNIEC",
    "ShortName": "DUNIEC BROS. LTD.",
    "Symbol": "DUNI.TA",
    "TaseSymbol": "DUNI",
    "YahooId": "DUNI.TA",
    "EnglishName": "DUNIEC",
    "EnglishLongName": "DUNIEC BROS. LTD.",
    "HebrewName": "דוניץ",
    "HebrewLongName": "אחים דוניץ בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 26940.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 2.7,
    "YearYield": 2.7,
    "Last12MonthYield": null,
    "ISIN": "IL0004000100"
  },
  {
    "Id": "EMCO.TA",
    "MayaId": "382010",
    "Name": "E&M",
    "ShortName": "E & M COMPUTING LTD.",
    "Symbol": "EMCO.TA",
    "TaseSymbol": "EMCO",
    "YahooId": "EMCO.TA",
    "EnglishName": "E&M",
    "EnglishLongName": "E & M COMPUTING LTD.",
    "HebrewName": "אמת",
    "HebrewLongName": "א.מ.ת. מיחשוב בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 910.3,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -3.9,
    "YearYield": -3.9,
    "Last12MonthYield": null,
    "ISIN": "IL0003820102"
  },
  {
    "Id": "EEAM-M.TA",
    "MayaId": "1169895",
    "Name": "E.E.A.M.I M",
    "ShortName": "E.E.A.M.I LTD",
    "Symbol": "EEAM-M.TA",
    "TaseSymbol": "EEAM-M",
    "YahooId": "EEAM-M.TA",
    "EnglishName": "E.E.A.M.I-M",
    "EnglishLongName": "E.E.A.M.I LTD",
    "HebrewName": "א.א.א.מ.א-ש",
    "HebrewLongName": "א.א.א.מ.א בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 239.8,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Investment & Holdings",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 20.1,
    "YearYield": 20.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011698953"
  },
  {
    "Id": "TASE:5141510",
    "MayaId": "5141510",
    "Name": "Eckhaus Foreign Equity",
    "ShortName": "Eckhaus Foreign Equity",
    "Symbol": "TASE:5141510",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Eckhaus (4D) Foreign Equity",
    "EnglishLongName": "Eckhaus (4D) Foreign Equity",
    "HebrewName": "אקהאוס מניות חו\"ל",
    "HebrewLongName": "אקהאוס (4D) מניות חו\"ל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.75,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 1.5,
    "MonthYield": 0.95,
    "YearYield": 0.95,
    "Last12MonthYield": null,
    "ISIN": "IL0051415102"
  },
  {
    "Id": "TASE:5140579",
    "MayaId": "5140579",
    "Name": "Eckhaus Israel Equity",
    "ShortName": "Eckhaus Israel Equity",
    "Symbol": "TASE:5140579",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Eckhaus (4B) Israel Equity",
    "EnglishLongName": "Eckhaus (4B) Israel Equity",
    "HebrewName": "אקהאוס מניות ישראל",
    "HebrewLongName": "אקהאוס (4B) מניות ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.7,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 19.9,
    "MonthYield": 10.01,
    "YearYield": 10.01,
    "Last12MonthYield": null,
    "ISIN": "IL0051405798"
  },
  {
    "Id": "ECNR.TA",
    "MayaId": "1178334",
    "Name": "ECONERGY",
    "ShortName": "ECONERGY RENEWABLE ENERGY LTD.",
    "Symbol": "ECNR.TA",
    "TaseSymbol": "ECNR",
    "YahooId": "ECNR.TA",
    "EnglishName": "ECONERGY",
    "EnglishLongName": "ECONERGY RENEWABLE ENERGY LTD.",
    "HebrewName": "אקונרג'י",
    "HebrewLongName": "אקונרג'י אנרגיה מתחדשת בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4896.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 8.3,
    "YearYield": 8.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011783342"
  },
  {
    "Id": "EFCP.TA",
    "MayaId": "1181437",
    "Name": "EFFI CAP",
    "ShortName": "EFFI CAPITAL NADLAN LTD",
    "Symbol": "EFCP.TA",
    "TaseSymbol": "EFCP",
    "YahooId": "EFCP.TA",
    "EnglishName": "EFFI CAP",
    "EnglishLongName": "EFFI CAPITAL NADLAN LTD",
    "HebrewName": "אפי קפיטל",
    "HebrewLongName": "אפי קפיטל נדל\"ן בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1643.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 5.3,
    "YearYield": 5.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011814378"
  },
  {
    "Id": "ELAL.TA",
    "MayaId": "1087824",
    "Name": "EL AL",
    "ShortName": "EL AL ISRAEL AIRLINES LTD.",
    "Symbol": "ELAL.TA",
    "TaseSymbol": "ELAL",
    "YahooId": "ELAL.TA",
    "EnglishName": "EL AL",
    "EnglishLongName": "EL AL ISRAEL AIRLINES LTD.",
    "HebrewName": "אל על",
    "HebrewLongName": "אל על  נתיבי אויר לישראל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1696.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 9.6,
    "YearYield": 9.6,
    "Last12MonthYield": null,
    "ISIN": "IL0010878242"
  },
  {
    "Id": "ELAD.TA",
    "MayaId": "1217702",
    "Name": "ELAD SOFTWARE",
    "ShortName": "ELAD SOFTWARE SYSTEMS LTD",
    "Symbol": "ELAD.TA",
    "TaseSymbol": "ELAD",
    "YahooId": "ELAD.TA",
    "EnglishName": "ELAD SOFTWARE",
    "EnglishLongName": "ELAD SOFTWARE SYSTEMS LTD",
    "HebrewName": "אלעד תוכנה",
    "HebrewLongName": "אלעד מערכות תוכנה בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1311.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -4.0,
    "YearYield": -4.0,
    "Last12MonthYield": null,
    "ISIN": "IL0012177023"
  },
  {
    "Id": "EMITF.TA",
    "MayaId": "1081116",
    "Name": "ELBIT IMAGING",
    "ShortName": "ELBIT IMAGING LTD.",
    "Symbol": "EMITF.TA",
    "TaseSymbol": "EMITF",
    "YahooId": "EMITF.TA",
    "EnglishName": "ELBIT IMAGING",
    "EnglishLongName": "ELBIT IMAGING LTD.",
    "HebrewName": "אלביט הדמיה",
    "HebrewLongName": "אלביט הדמיה בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 494.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.7,
    "YearYield": 1.7,
    "Last12MonthYield": null,
    "ISIN": "IL0010811169"
  },
  {
    "Id": "EMTC-M.TA",
    "MayaId": "474015",
    "Name": "ELBIT MEDITEC M",
    "ShortName": "ELBIT MEDICAL TECHNOLOGIES LTD",
    "Symbol": "EMTC-M.TA",
    "TaseSymbol": "EMTC-M",
    "YahooId": "EMTC-M.TA",
    "EnglishName": "ELBIT MEDITEC-M",
    "EnglishLongName": "ELBIT MEDICAL TECHNOLOGIES LTD",
    "HebrewName": "אלביט מדקל טכ-ש",
    "HebrewLongName": "אלביט מדיקל טכנולוג'יס בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 28.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Investment & Holdings",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 24.4,
    "YearYield": 24.4,
    "Last12MonthYield": null,
    "ISIN": "IL0004740150"
  },
  {
    "Id": "ESLT.TA",
    "MayaId": "1081124",
    "Name": "ELBIT SYSTEMS",
    "ShortName": "ELBIT SYSTEMS LTD.",
    "Symbol": "ESLT.TA",
    "TaseSymbol": "ESLT",
    "YahooId": "ESLT.TA",
    "EnglishName": "ELBIT SYSTEMS",
    "EnglishLongName": "ELBIT SYSTEMS LTD.",
    "HebrewName": "אלביט מערכות",
    "HebrewLongName": "אלביט מערכות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 227990.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 23.5,
    "YearYield": 23.5,
    "Last12MonthYield": null,
    "ISIN": "IL0010811243"
  },
  {
    "Id": "ELCO.TA",
    "MayaId": "694034",
    "Name": "ELCO",
    "ShortName": "ELCO LTD",
    "Symbol": "ELCO.TA",
    "TaseSymbol": "ELCO",
    "YahooId": "ELCO.TA",
    "EnglishName": "ELCO",
    "EnglishLongName": "ELCO LTD",
    "HebrewName": "אלקו",
    "HebrewLongName": "אלקו בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 17260.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Investment & Holdings",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -2.8,
    "YearYield": -2.8,
    "Last12MonthYield": null,
    "ISIN": "IL0006940345"
  },
  {
    "Id": "ELDT.TA",
    "MayaId": "1134881",
    "Name": "ELDAN TRANS",
    "ShortName": "ELDAN TRANSPORTATION LTD",
    "Symbol": "ELDT.TA",
    "TaseSymbol": "ELDT",
    "YahooId": "ELDT.TA",
    "EnglishName": "ELDAN TRANS",
    "EnglishLongName": "ELDAN TRANSPORTATION LTD",
    "HebrewName": "אלדן תחבורה",
    "HebrewLongName": "אלדן תחבורה בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 834.7,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 2.6,
    "YearYield": 2.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011348815"
  },
  {
    "Id": "ELTR.TA",
    "MayaId": "739037",
    "Name": "ELECTRA",
    "ShortName": "ELECTRA LTD.",
    "Symbol": "ELTR.TA",
    "TaseSymbol": "ELTR",
    "YahooId": "ELTR.TA",
    "EnglishName": "ELECTRA",
    "EnglishLongName": "ELECTRA LTD.",
    "HebrewName": "אלקטרה",
    "HebrewLongName": "אלקטרה בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 11540.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Investment & Holdings",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 8.4,
    "YearYield": 8.4,
    "Last12MonthYield": null,
    "ISIN": "IL0007390375"
  },
  {
    "Id": "ECP.TA",
    "MayaId": "5010129",
    "Name": "ELECTRA CO PR",
    "ShortName": "ELECTRA CONSUMER PRODUCTS (1970) LTD",
    "Symbol": "ECP.TA",
    "TaseSymbol": "ECP",
    "YahooId": "ECP.TA",
    "EnglishName": "ELECTRA CO  PR",
    "EnglishLongName": "ELECTRA CONSUMER PRODUCTS (1970) LTD",
    "HebrewName": "אלקטרה צריכה",
    "HebrewLongName": "אלקטרה מוצרי צריכה (1970) בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 9698.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -10.2,
    "YearYield": -10.2,
    "Last12MonthYield": null,
    "ISIN": "IL0050101299"
  },
  {
    "Id": "ELCRE.TA",
    "MayaId": "1094044",
    "Name": "ELECTRA REAL E.",
    "ShortName": "ELECTRA REAL ESTATE LTD",
    "Symbol": "ELCRE.TA",
    "TaseSymbol": "ELCRE",
    "YahooId": "ELCRE.TA",
    "EnglishName": "ELECTRA REAL E.",
    "EnglishLongName": "ELECTRA REAL ESTATE LTD",
    "HebrewName": "אלקטרה נדלן",
    "HebrewLongName": "אלקטרה נדל\"ן בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5694.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 23.8,
    "YearYield": 23.8,
    "Last12MonthYield": null,
    "ISIN": "IL0010940448"
  },
  {
    "Id": "ELWS.TA",
    "MayaId": "368019",
    "Name": "ELECTREON",
    "ShortName": "ELECTREON WIRELESS LTD",
    "Symbol": "ELWS.TA",
    "TaseSymbol": "ELWS",
    "YahooId": "ELWS.TA",
    "EnglishName": "ELECTREON",
    "EnglishLongName": "ELECTREON WIRELESS LTD",
    "HebrewName": "אלקטריאון",
    "HebrewLongName": "אלקטריאון וירלס בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5921.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 31.5,
    "YearYield": 31.5,
    "Last12MonthYield": null,
    "ISIN": "IL0003680191"
  },
  {
    "Id": "ELLO.TA",
    "MayaId": "1082635",
    "Name": "ELLOMAY",
    "ShortName": "ELLOMAY CAPITAL LTD",
    "Symbol": "ELLO.TA",
    "TaseSymbol": "ELLO",
    "YahooId": "ELLO.TA",
    "EnglishName": "ELLOMAY",
    "EnglishLongName": "ELLOMAY CAPITAL LTD",
    "HebrewName": "אלומיי",
    "HebrewLongName": "אלומיי קפיטל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 8273.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 2.6,
    "YearYield": 2.6,
    "Last12MonthYield": null,
    "ISIN": "IL0010826357"
  },
  {
    "Id": "ELMR.TA",
    "MayaId": "1142454",
    "Name": "ELMOR",
    "ShortName": "ELMOR ELECTRIC INSTALLATIONS & SERVICES (1986) LTD",
    "Symbol": "ELMR.TA",
    "TaseSymbol": "ELMR",
    "YahooId": "ELMR.TA",
    "EnglishName": "ELMOR",
    "EnglishLongName": "ELMOR ELECTRIC INSTALLATIONS & SERVICES (1986) LTD",
    "HebrewName": "אלמור חשמל",
    "HebrewLongName": "אלמור חשמל התקנות ושירותים (1986) בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2015.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -1.0,
    "YearYield": -1.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011424541"
  },
  {
    "Id": "ELRN.TA",
    "MayaId": "749077",
    "Name": "ELRON",
    "ShortName": "ELRON VENTURES LTD",
    "Symbol": "ELRN.TA",
    "TaseSymbol": "ELRN",
    "YahooId": "ELRN.TA",
    "EnglishName": "ELRON",
    "EnglishLongName": "ELRON VENTURES LTD",
    "HebrewName": "אלרון",
    "HebrewLongName": "אלרון ונצ'רס בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 554.9,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -2.5,
    "YearYield": -2.5,
    "Last12MonthYield": null,
    "ISIN": "IL0007490779"
  },
  {
    "Id": "ELSPC.TA",
    "MayaId": "1090364",
    "Name": "ELSPEC",
    "ShortName": "ELSPEC ENGINEERING LTD.",
    "Symbol": "ELSPC.TA",
    "TaseSymbol": "ELSPC",
    "YahooId": "ELSPC.TA",
    "EnglishName": "ELSPEC",
    "EnglishLongName": "ELSPEC ENGINEERING LTD.",
    "HebrewName": "אלספק",
    "HebrewLongName": "אלספק הנדסה בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 420.4,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -4.1,
    "YearYield": -4.1,
    "Last12MonthYield": null,
    "ISIN": "IL0010903644"
  },
  {
    "Id": "EMDV.TA",
    "MayaId": "589010",
    "Name": "EMILIA DEVEL",
    "ShortName": "EMILIA DEVELOPMENT (O.F.G) LTD.",
    "Symbol": "EMDV.TA",
    "TaseSymbol": "EMDV",
    "YahooId": "EMDV.TA",
    "EnglishName": "EMILIA DEVEL",
    "EnglishLongName": "EMILIA DEVELOPMENT (O.F.G) LTD.",
    "HebrewName": "אמיליה פיתוח",
    "HebrewLongName": "אמיליה פיתוח (מ.עו.פ) בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2876.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Investment & Holdings",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 2.2,
    "YearYield": 2.2,
    "Last12MonthYield": null,
    "ISIN": "IL0005890103"
  },
  {
    "Id": "ENOG.TA",
    "MayaId": "1155290",
    "Name": "ENERGEAN",
    "ShortName": "ENERGEAN PLC",
    "Symbol": "ENOG.TA",
    "TaseSymbol": "ENOG",
    "YahooId": "ENOG.TA",
    "EnglishName": "ENERGEAN",
    "EnglishLongName": "ENERGEAN PLC",
    "HebrewName": "אנרג'יאן",
    "HebrewLongName": "אנרג'יאן פי אל סי",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3954.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Energy And Oil & Gas Exploration",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -0.2,
    "YearYield": -0.2,
    "Last12MonthYield": null,
    "ISIN": "GB00BG12Y042"
  },
  {
    "Id": "ENRG.TA",
    "MayaId": "1123355",
    "Name": "ENERGIX",
    "ShortName": "ENERGIX-RENEWABLE ENERGIES LTD",
    "Symbol": "ENRG.TA",
    "TaseSymbol": "ENRG",
    "YahooId": "ENRG.TA",
    "EnglishName": "ENERGIX",
    "EnglishLongName": "ENERGIX-RENEWABLE ENERGIES LTD",
    "HebrewName": "אנרג'יקס",
    "HebrewLongName": "אנרג'יקס-אנרגיות מתחדשות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1731.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 8.3,
    "YearYield": 8.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011233553"
  },
  {
    "Id": "ENLT.TA",
    "MayaId": "720011",
    "Name": "ENLIGHT ENERGY",
    "ShortName": "ENLIGHT RENEWABLE ENERGY LTD.",
    "Symbol": "ENLT.TA",
    "TaseSymbol": "ENLT",
    "YahooId": "ENLT.TA",
    "EnglishName": "ENLIGHT ENERGY",
    "EnglishLongName": "ENLIGHT RENEWABLE ENERGY LTD.",
    "HebrewName": "אנלייט אנרגיה",
    "HebrewLongName": "אנלייט אנרגיה מתחדשת בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 17150.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 19.9,
    "YearYield": 19.9,
    "Last12MonthYield": null,
    "ISIN": "IL0007200111"
  },
  {
    "Id": "ENLV.TA",
    "MayaId": "1158997",
    "Name": "ENLIVEX",
    "ShortName": "ENLIVEX THERAPEUTICS LTD",
    "Symbol": "ENLV.TA",
    "TaseSymbol": "ENLV",
    "YahooId": "ENLV.TA",
    "EnglishName": "ENLIVEX",
    "EnglishLongName": "ENLIVEX THERAPEUTICS LTD",
    "HebrewName": "אנלייבקס",
    "HebrewLongName": "אנלייבקס תרפיוטיקס בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 302.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 38.0,
    "YearYield": 38.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011319527"
  },
  {
    "Id": "EPIT.TA",
    "MayaId": "1182591",
    "Name": "EPITOMEE MED",
    "ShortName": "EPITOMEE MEDICAL LTD",
    "Symbol": "EPIT.TA",
    "TaseSymbol": "EPIT",
    "YahooId": "EPIT.TA",
    "EnglishName": "EPITOMEE MED",
    "EnglishLongName": "EPITOMEE MEDICAL LTD",
    "HebrewName": "אפיטומי מדיקל",
    "HebrewLongName": "אפיטומי מדיקל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 950.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 34.7,
    "YearYield": 34.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011825911"
  },
  {
    "Id": "EQTL.TA",
    "MayaId": "755017",
    "Name": "EQUITAL",
    "ShortName": "EQUITAL LTD.",
    "Symbol": "EQTL.TA",
    "TaseSymbol": "EQTL",
    "YahooId": "EQTL.TA",
    "EnglishName": "EQUITAL",
    "EnglishLongName": "EQUITAL LTD.",
    "HebrewName": "אקויטל",
    "HebrewLongName": "אקויטל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 15130.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Investment & Holdings",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -5.1,
    "YearYield": -5.1,
    "Last12MonthYield": null,
    "ISIN": "IL0007550176"
  },
  {
    "Id": "EFNC-M.TA",
    "MayaId": "1120161",
    "Name": "ERECH FINANCEM",
    "ShortName": "ERECH FINANCE CAHALACHA LTD",
    "Symbol": "EFNC-M.TA",
    "TaseSymbol": "EFNC-M",
    "YahooId": "EFNC-M.TA",
    "EnglishName": "ERECH FINANCEM",
    "EnglishLongName": "ERECH FINANCE CAHALACHA LTD",
    "HebrewName": "ערך פיננסים-ש",
    "HebrewLongName": "ערך פיננסים כהלכה בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 146.9,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Investment & Holdings",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 13.3,
    "YearYield": 13.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011201618"
  },
  {
    "Id": "ERKA.TA",
    "MayaId": "1178912",
    "Name": "ERIKA CARMEL",
    "ShortName": "ERIKA CARMEL-TECH LTD",
    "Symbol": "ERKA.TA",
    "TaseSymbol": "ERKA",
    "YahooId": "ERKA.TA",
    "EnglishName": "ERIKA CARMEL",
    "EnglishLongName": "ERIKA CARMEL-TECH LTD",
    "HebrewName": "אריקה כרמל",
    "HebrewLongName": "אריקה כרמל-טק בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 24.4,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 21.1,
    "YearYield": 21.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011789125"
  },
  {
    "Id": "ETGA.TA",
    "MayaId": "1176114",
    "Name": "ETGA GROUP",
    "ShortName": "ETGA GROUP LTD",
    "Symbol": "ETGA.TA",
    "TaseSymbol": "ETGA",
    "YahooId": "ETGA.TA",
    "EnglishName": "ETGA GROUP",
    "EnglishLongName": "ETGA GROUP LTD",
    "HebrewName": "אי.טי.ג'י.איי",
    "HebrewLongName": "אי.טי.ג'י.איי גרופ בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2734.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -1.8,
    "YearYield": -1.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011761140"
  },
  {
    "Id": "TASE:5136767",
    "MayaId": "5136767",
    "Name": "Etzioni Flexible",
    "ShortName": "Etzioni Flexible",
    "Symbol": "TASE:5136767",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Etzioni (4D) Flexible",
    "EnglishLongName": "Etzioni (4D) Flexible",
    "HebrewName": "עציוני גמישה",
    "HebrewLongName": "עציוני (4D) גמישה - קרן נאמנות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.5,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.01,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 127.8,
    "MonthYield": 3.91,
    "YearYield": 3.91,
    "Last12MonthYield": 28.16,
    "ISIN": "IL0051367675"
  },
  {
    "Id": "TASE:5137757",
    "MayaId": "5137757",
    "Name": "Etzioni Israel Equity",
    "ShortName": "Etzioni Israel Equity",
    "Symbol": "TASE:5137757",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Etzioni (4B) Israel Equity IL",
    "EnglishLongName": "Etzioni (4B) Israel Equity IL",
    "HebrewName": "עציוני מניות ישראל",
    "HebrewLongName": "עציוני (4B) מניות ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.5,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.72,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 309.1,
    "MonthYield": 4.7,
    "YearYield": 4.7,
    "Last12MonthYield": 43.58,
    "ISIN": "IL0051377575"
  },
  {
    "Id": "EVGN.TA",
    "MayaId": "1105055",
    "Name": "EVOGENE",
    "ShortName": "EVOGENE LTD",
    "Symbol": "EVGN.TA",
    "TaseSymbol": "EVGN",
    "YahooId": "EVGN.TA",
    "EnglishName": "EVOGENE",
    "EnglishLongName": "EVOGENE LTD",
    "HebrewName": "אבוג'ן",
    "HebrewLongName": "אבוג'ן בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 323.7,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 9.7,
    "YearYield": 9.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011050551"
  },
  {
    "Id": "EXPO.TA",
    "MayaId": "704015",
    "Name": "EXPORT INV",
    "ShortName": "EXPORT INVESTMENT CO. LTD.",
    "Symbol": "EXPO.TA",
    "TaseSymbol": "EXPO",
    "YahooId": "EXPO.TA",
    "EnglishName": "EXPORT INV",
    "EnglishLongName": "EXPORT INVESTMENT CO. LTD.",
    "HebrewName": "יצוא",
    "HebrewLongName": "יצוא-חברה להשקעות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 8439.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Banks",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 5.4,
    "YearYield": 5.4,
    "Last12MonthYield": null,
    "ISIN": "IL0007040152"
  },
  {
    "Id": "TASE:5132410",
    "MayaId": "5132410",
    "Name": "FALCON (2B) 80/20",
    "ShortName": "FALCON (2B) 80/20",
    "Symbol": "TASE:5132410",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "FALCON (2B) 80/20 IL",
    "EnglishLongName": "FALCON (2B) 80/20 IL",
    "HebrewName": "פלקון 20/80",
    "HebrewLongName": "פלקון (2B)י 20/80",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.57,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 38.9,
    "MonthYield": 1.55,
    "YearYield": 1.55,
    "Last12MonthYield": 14.38,
    "ISIN": "IL0051324106"
  },
  {
    "Id": "TASE:5141890",
    "MayaId": "5141890",
    "Name": "Falcon (4D) Flexible",
    "ShortName": "Falcon (4D) Flexible",
    "Symbol": "TASE:5141890",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Falcon (4D) Flexible Investment Portfolio",
    "EnglishLongName": "Falcon (4D) Flexible Investment Portfolio",
    "HebrewName": "פלקון (4D) תיק גמיש",
    "HebrewLongName": "פלקון (4D) תיק השקעות גמיש",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.95,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 12.6,
    "MonthYield": 3.74,
    "YearYield": 3.74,
    "Last12MonthYield": null,
    "ISIN": "IL0051418908"
  },
  {
    "Id": "TASE:5136619",
    "MayaId": "5136619",
    "Name": "FALCON bonds Portfolio",
    "ShortName": "FALCON bonds Portfolio",
    "Symbol": "TASE:5136619",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "FALCON (0A) Bonds, Stocks Free Portfolio IL",
    "EnglishLongName": "FALCON (0A) Bonds, Stocks Free Portfolio IL",
    "HebrewName": "פלקון תיק אג\"ח ללא מניות",
    "HebrewLongName": "פלקון (0A) תיק אג\"ח ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 28.4,
    "MonthYield": 0.56,
    "YearYield": 0.56,
    "Last12MonthYield": 7.22,
    "ISIN": "IL0051366198"
  },
  {
    "Id": "FTAL.TA",
    "MayaId": "1143429",
    "Name": "FATTAL HOLD",
    "ShortName": "FATTAL HOLDINGS (1998) LTD",
    "Symbol": "FTAL.TA",
    "TaseSymbol": "FTAL",
    "YahooId": "FTAL.TA",
    "EnglishName": "FATTAL HOLD",
    "EnglishLongName": "FATTAL HOLDINGS (1998) LTD",
    "HebrewName": "פתאל החזקות",
    "HebrewLongName": "פתאל החזקות (1998) בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 65490.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 2.2,
    "YearYield": 2.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011434292"
  },
  {
    "Id": "FIBI.TA",
    "MayaId": "593038",
    "Name": "FIBI BANK",
    "ShortName": "FIRST INTERNATIONAL BANK OF ISRAEL LTD.",
    "Symbol": "FIBI.TA",
    "TaseSymbol": "FIBI",
    "YahooId": "FIBI.TA",
    "EnglishName": "FIBI BANK",
    "EnglishLongName": "FIRST INTERNATIONAL BANK OF ISRAEL LTD.",
    "HebrewName": "בינלאומי",
    "HebrewLongName": "הבנק הבינלאומי הראשון לישראל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 26090.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Banks",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 5.8,
    "YearYield": 5.8,
    "Last12MonthYield": null,
    "ISIN": "IL0005930388"
  },
  {
    "Id": "FIBIH.TA",
    "MayaId": "763011",
    "Name": "FIBI HOLDINGS",
    "ShortName": "F.I.B.I. HOLDINGS LTD.",
    "Symbol": "FIBIH.TA",
    "TaseSymbol": "FIBIH",
    "YahooId": "FIBIH.TA",
    "EnglishName": "FIBI HOLDINGS",
    "EnglishLongName": "F.I.B.I. HOLDINGS LTD.",
    "HebrewName": "פיבי",
    "HebrewLongName": "פ.י.ב.י. אחזקות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 27100.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Banks",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 3.6,
    "YearYield": 3.6,
    "Last12MonthYield": null,
    "ISIN": "IL0007630119"
  },
  {
    "Id": "TASE:5139423",
    "MayaId": "5139423",
    "Name": "Finessa 70/30",
    "ShortName": "Finessa 70/30",
    "Symbol": "TASE:5139423",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Finessa (2C) 70/30 IL",
    "EnglishLongName": "Finessa (2C) 70/30 IL",
    "HebrewName": "פינסה 30/70",
    "HebrewLongName": "פינסה (2C)י 30/70",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.51,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 23.1,
    "MonthYield": 0.98,
    "YearYield": 0.98,
    "Last12MonthYield": 9.39,
    "ISIN": "IL0051394232"
  },
  {
    "Id": "TASE:5134333",
    "MayaId": "5134333",
    "Name": "Finessa 80/20",
    "ShortName": "Finessa 80/20",
    "Symbol": "TASE:5134333",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Finessa (2B) 80/20 IL",
    "EnglishLongName": "Finessa (2B) 80/20 IL",
    "HebrewName": "פינסה 20/80",
    "HebrewLongName": "פינסה (2B)י 20/80",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.4,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 460.0,
    "MonthYield": 1.81,
    "YearYield": 1.81,
    "Last12MonthYield": 11.92,
    "ISIN": "IL0051343338"
  },
  {
    "Id": "TASE:5134341",
    "MayaId": "5134341",
    "Name": "Finessa 90/10",
    "ShortName": "Finessa 90/10",
    "Symbol": "TASE:5134341",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Finessa (1B) 90/10 IL",
    "EnglishLongName": "Finessa (1B) 90/10 IL",
    "HebrewName": "פינסה 10/90",
    "HebrewLongName": "פינסה (1B)י 10/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 98.7,
    "MonthYield": 1.14,
    "YearYield": 1.14,
    "Last12MonthYield": 11.52,
    "ISIN": "IL0051343411"
  },
  {
    "Id": "TASE:5141270",
    "MayaId": "5141270",
    "Name": "Finessa Bond Portfolio",
    "ShortName": "Finessa Bond Portfolio",
    "Symbol": "TASE:5141270",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Finesse (0B)(!) bond portfolio IL",
    "EnglishLongName": "Finesse (0B)(!) bond portfolio IL",
    "HebrewName": "פינסה תיק אג\"ח",
    "HebrewLongName": "פינסה (0B)(!) תיק אג\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 78.0,
    "MonthYield": 0.78,
    "YearYield": 0.78,
    "Last12MonthYield": null,
    "ISIN": "IL0051412703"
  },
  {
    "Id": "TASE:5134366",
    "MayaId": "5134366",
    "Name": "Finessa Bonds Without Equ",
    "ShortName": "Finessa Bonds Without Equ",
    "Symbol": "TASE:5134366",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Finessa (0B) Bonds Without Equity IL",
    "EnglishLongName": "Finessa (0B) Bonds Without Equity IL",
    "HebrewName": "פינסה אג\"ח ללא מניות",
    "HebrewLongName": "פינסה (0B) אג\"ח ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 1000.7,
    "MonthYield": 0.46,
    "YearYield": 0.46,
    "Last12MonthYield": 6.89,
    "ISIN": "IL0051343668"
  },
  {
    "Id": "TASE:5137450",
    "MayaId": "5137450",
    "Name": "Finessa Corporate Bonds",
    "ShortName": "Finessa Corporate Bonds",
    "Symbol": "TASE:5137450",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Finessa (0B)(!) Corporate Bonds IL",
    "EnglishLongName": "Finessa (0B)(!) Corporate Bonds IL",
    "HebrewName": "פינסה אג\"ח חברות",
    "HebrewLongName": "פינסה (0B)(!) אג\"ח חברות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.85,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 462.9,
    "MonthYield": 0.64,
    "YearYield": 0.64,
    "Last12MonthYield": 7.86,
    "ISIN": "IL0051374507"
  },
  {
    "Id": "TASE:5134358",
    "MayaId": "5134358",
    "Name": "Finessa Equity",
    "ShortName": "Finessa Equity",
    "Symbol": "TASE:5134358",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Finessa (4B) Equity IL",
    "EnglishLongName": "Finessa (4B) Equity IL",
    "HebrewName": "פינסה מניות",
    "HebrewLongName": "פינסה (4B) מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.8,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.95,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 145.4,
    "MonthYield": 7.71,
    "YearYield": 7.71,
    "Last12MonthYield": 58.05,
    "ISIN": "IL0051343585"
  },
  {
    "Id": "TASE:5134374",
    "MayaId": "5134374",
    "Name": "Finessa Flexible",
    "ShortName": "Finessa Flexible",
    "Symbol": "TASE:5134374",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Finessa (4D) Flexible",
    "EnglishLongName": "Finessa (4D) Flexible",
    "HebrewName": "פינסה גמישה",
    "HebrewLongName": "פינסה (4D) גמישה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.7,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.66,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 51.5,
    "MonthYield": 5.64,
    "YearYield": 5.64,
    "Last12MonthYield": 31.18,
    "ISIN": "IL0051343742"
  },
  {
    "Id": "TASE:5137468",
    "MayaId": "5137468",
    "Name": "Finessa Global Equity",
    "ShortName": "Finessa Global Equity",
    "Symbol": "TASE:5137468",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Finessa (4D) Global Equity",
    "EnglishLongName": "Finessa (4D) Global Equity",
    "HebrewName": "פינסה Global Equity",
    "HebrewLongName": "פינסה (4D)י Global Equity",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.4,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.55,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 41.4,
    "MonthYield": 2.06,
    "YearYield": 2.06,
    "Last12MonthYield": 6.55,
    "ISIN": "IL0051374689"
  },
  {
    "Id": "FGAS.TA",
    "MayaId": "1165307",
    "Name": "FIRE AND GAS",
    "ShortName": "FIRE & GAS DETECTION TECHNOLOGIES LTD.",
    "Symbol": "FGAS.TA",
    "TaseSymbol": "FGAS",
    "YahooId": "FGAS.TA",
    "EnglishName": "FIRE AND GAS",
    "EnglishLongName": "FIRE & GAS DETECTION TECHNOLOGIES LTD.",
    "HebrewName": "טכנ גילוי אש גז",
    "HebrewLongName": "טכנולוגיות גילוי אש וגזים בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1020.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -6.7,
    "YearYield": -6.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011653073"
  },
  {
    "Id": "FLYS.TA",
    "MayaId": "1173582",
    "Name": "FLYING SPARK",
    "ShortName": "FLYING SPARK LTD",
    "Symbol": "FLYS.TA",
    "TaseSymbol": "FLYS",
    "YahooId": "FLYS.TA",
    "EnglishName": "FLYING SPARK",
    "EnglishLongName": "FLYING SPARK LTD",
    "HebrewName": "פליינג ספארק",
    "HebrewLongName": "פליינג ספארק בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 35.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -4.9,
    "YearYield": -4.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011735821"
  },
  {
    "Id": "FBRT.TA",
    "MayaId": "315010",
    "Name": "FMS",
    "ShortName": "FMS ENTERPRISES MIGUN LTD",
    "Symbol": "FBRT.TA",
    "TaseSymbol": "FBRT",
    "YahooId": "FBRT.TA",
    "EnglishName": "FMS",
    "EnglishLongName": "FMS ENTERPRISES MIGUN LTD",
    "HebrewName": "פמס",
    "HebrewLongName": "מפעלי פ.מ.ס. מיגון בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 25350.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 9.0,
    "YearYield": 9.0,
    "Last12MonthYield": null,
    "ISIN": "IL0003150104"
  },
  {
    "Id": "TASE:5130539",
    "MayaId": "5130539",
    "Name": "FNX KSM BOND WTHOU EQU IL",
    "ShortName": "FNX KSM BOND WTHOU EQU IL",
    "Symbol": "TASE:5130539",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "FNX KSM (!)(0A) BONDS WITHOUT EQUITY IL",
    "EnglishLongName": "FNX KSM (!)(0A) BONDS WITHOUT EQUITY IL",
    "HebrewName": "הפניקס קסם אגח ללא מניות",
    "HebrewLongName": "הפניקס קסם (0A)(!) אג\"ח ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.84,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 647.8,
    "MonthYield": 0.6,
    "YearYield": 0.6,
    "Last12MonthYield": 5.85,
    "ISIN": "IL0051305394"
  },
  {
    "Id": "TASE:5130554",
    "MayaId": "5130554",
    "Name": "FNX KSM FOREIGN EQUITY",
    "ShortName": "FNX KSM FOREIGN EQUITY",
    "Symbol": "TASE:5130554",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "FNX KSM (4D) FOREIGN EQUITY",
    "EnglishLongName": "FNX KSM (4D) FOREIGN EQUITY",
    "HebrewName": "הפניקס קסם מניות חו\"ל",
    "HebrewLongName": "הפניקס קסם (4D) מניות חו\"ל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.79,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.42,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 387.9,
    "MonthYield": 1.67,
    "YearYield": 1.67,
    "Last12MonthYield": 7.64,
    "ISIN": "IL0051305543"
  },
  {
    "Id": "TASE:5110739",
    "MayaId": "5110739",
    "Name": "FNX KSM Global Bonds",
    "ShortName": "FNX KSM Global Bonds",
    "Symbol": "TASE:5110739",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "FNX KSM (0D)(!) Global Bonds",
    "EnglishLongName": "FNX KSM (0D)(!) Global Bonds",
    "HebrewName": "הפניקס קסם אג\"ח גלובלי",
    "HebrewLongName": "הפניקס קסם (0D)(!) אג\"ח גלובלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.85,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.9,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Bond",
    "AssetValue": 73.3,
    "MonthYield": -0.88,
    "YearYield": -0.88,
    "Last12MonthYield": -4.88,
    "ISIN": "IL0051107394"
  },
  {
    "Id": "TASE:5105176",
    "MayaId": "5105176",
    "Name": "FNX KSM NO CPI LIN GOV IL",
    "ShortName": "FNX KSM NO-CPI LIN GOV IL",
    "Symbol": "TASE:5105176",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "FNX KSM (0A) NON-CPI LINKED GOVERNMENT IL",
    "EnglishLongName": "FNX KSM (0A) NON-CPI LINKED GOVERNMENT IL",
    "HebrewName": "הפניקס קסם ממשלתי שקלי",
    "HebrewLongName": "הפניקס קסם (0A) ממשלתי שקלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.85,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.37,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Shekel Bonds - No Equity",
    "AssetValue": 284.9,
    "MonthYield": 0.69,
    "YearYield": 0.69,
    "Last12MonthYield": 6.75,
    "ISIN": "IL0051051766"
  },
  {
    "Id": "TASE:5104732",
    "MayaId": "5104732",
    "Name": "FNX KSM RATED COR PORT IL",
    "ShortName": "FNX KSM RATED COR PORT IL",
    "Symbol": "TASE:5104732",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "FNX KSM (0B) RATED CORPORATE PORTFOLIO IL",
    "EnglishLongName": "FNX KSM (0B) RATED CORPORATE PORTFOLIO IL",
    "HebrewName": "הפניקסקסם תיק קונצרנימדור",
    "HebrewLongName": "הפניקס קסם (0B) תיק קונצרני מדורג",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 487.4,
    "MonthYield": 0.62,
    "YearYield": 0.62,
    "Last12MonthYield": 6.82,
    "ISIN": "IL0051047327"
  },
  {
    "Id": "TASE:5110788",
    "MayaId": "5110788",
    "Name": "FNX KSM TA 125 IL",
    "ShortName": "FNX KSM TA 125 IL",
    "Symbol": "TASE:5110788",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "FNX KSM (4A) TA 125 IL",
    "EnglishLongName": "FNX KSM (4A) TA 125 IL",
    "HebrewName": "הפניקס קסם ת\"א 125",
    "HebrewLongName": "הפניקס קסם (4A) ת\"א 125",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.84,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.22,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 948.2,
    "MonthYield": 10.2,
    "YearYield": 10.2,
    "Last12MonthYield": 69.55,
    "ISIN": "IL0051107881"
  },
  {
    "Id": "TASE:5129564",
    "MayaId": "5129564",
    "Name": "FNXKSMGen Bond Aand Up IL",
    "ShortName": "FNXKSMGen Bond Aand Up IL",
    "Symbol": "TASE:5129564",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "FNX KSM(00) General Bonds A and Up IL",
    "EnglishLongName": "FNX KSM(00) General Bonds A and Up IL",
    "HebrewName": "הפניקסקסם אגח כללי Aומעלה",
    "HebrewLongName": "הפניקס קסם (00) אג\"ח כללי A ומעלה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.37,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.31,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 234.5,
    "MonthYield": 0.65,
    "YearYield": 0.65,
    "Last12MonthYield": 8.16,
    "ISIN": "IL0051295645"
  },
  {
    "Id": "TASE:5106653",
    "MayaId": "5106653",
    "Name": "FNXKSMGlo EqPort Denomin$",
    "ShortName": "FNXKSMGlo EqPort-Denomin$",
    "Symbol": "TASE:5106653",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "FNX KSM (4D) Global Equity Portfolio - Denominated in $",
    "EnglishLongName": "FNX KSM (4D) Global Equity Portfolio - Denominated in $",
    "HebrewName": "פניקסם תיק מניות עולמי-נ$",
    "HebrewLongName": "הפניקס קסם (4D) תיק מניות עולמי - נקובה $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.74,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.49,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 46.7,
    "MonthYield": 1.84,
    "YearYield": 1.84,
    "Last12MonthYield": 6.56,
    "ISIN": "IL0051066533"
  },
  {
    "Id": "TASE:5115647",
    "MayaId": "5115647",
    "Name": "FNXKSMGlo RatBon Denomin$",
    "ShortName": "FNXKSMGlo RatBon-Denomin$",
    "Symbol": "TASE:5115647",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "FNX KSM (0D) Global Rated Bonds - Denominated in $",
    "EnglishLongName": "FNX KSM (0D) Global Rated Bonds - Denominated in $",
    "HebrewName": "הפניקסקסם אגח חולמדורג-נ$",
    "HebrewLongName": "הפניקס קסם (0D) אג\"ח חו\"ל מדורג - נקובה $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.98,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Bonds",
    "AssetValue": 91.6,
    "MonthYield": -0.91,
    "YearYield": -0.91,
    "Last12MonthYield": -6.84,
    "ISIN": "IL0051156474"
  },
  {
    "Id": "TASE:5129333",
    "MayaId": "5129333",
    "Name": "Focus (0A) Bond IL",
    "ShortName": "Focus (0A) Bond IL",
    "Symbol": "TASE:5129333",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Focus (0A) Bond IL",
    "EnglishLongName": "Focus (0A) Bond IL",
    "HebrewName": "פוקוס (0A) אג\"ח",
    "HebrewLongName": "פוקוס (0A) אג\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.37,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 276.1,
    "MonthYield": 0.63,
    "YearYield": 0.63,
    "Last12MonthYield": 6.39,
    "ISIN": "IL0051293335"
  },
  {
    "Id": "TASE:5134069",
    "MayaId": "5134069",
    "Name": "Focus (2B) 70/30 IL",
    "ShortName": "Focus (2B) 70/30 IL",
    "Symbol": "TASE:5134069",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Focus (2B) 70/30 IL",
    "EnglishLongName": "Focus (2B) 70/30 IL",
    "HebrewName": "פוקוס (2B)י 30/70",
    "HebrewLongName": "פוקוס (2B)י 30/70",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.68,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 458.9,
    "MonthYield": 2.36,
    "YearYield": 2.36,
    "Last12MonthYield": 21.73,
    "ISIN": "IL0051340698"
  },
  {
    "Id": "TASE:5141528",
    "MayaId": "5141528",
    "Name": "Focus (3C) 50/50",
    "ShortName": "Focus (3C) 50/50",
    "Symbol": "TASE:5141528",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Focus (3C) 50/50",
    "EnglishLongName": "Focus (3C) 50/50",
    "HebrewName": "פוקוס (3C)י 50/50",
    "HebrewLongName": "פוקוס (3C)י 50/50",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - Max. Exposure over 30% Equity",
    "AssetValue": 10.8,
    "MonthYield": 3.84,
    "YearYield": 3.84,
    "Last12MonthYield": null,
    "ISIN": "IL0051415284"
  },
  {
    "Id": "TASE:5133525",
    "MayaId": "5133525",
    "Name": "Focus (4B) Stocks IL",
    "ShortName": "Focus (4B) Stocks IL",
    "Symbol": "TASE:5133525",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Focus (4B) Stocks IL",
    "EnglishLongName": "Focus (4B) Stocks IL",
    "HebrewName": "פוקוס (4B) מניות",
    "HebrewLongName": "פוקוס (4B) מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.69,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.07,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 55.6,
    "MonthYield": 9.38,
    "YearYield": 9.38,
    "Last12MonthYield": 74.22,
    "ISIN": "IL0051335250"
  },
  {
    "Id": "TASE:5126123",
    "MayaId": "5126123",
    "Name": "Focus 80/20 IL",
    "ShortName": "Focus 80/20 IL",
    "Symbol": "TASE:5126123",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Focus (2B) 80/20 IL",
    "EnglishLongName": "Focus (2B) 80/20 IL",
    "HebrewName": "פוקוס 20/80",
    "HebrewLongName": "פוקוס (2B)י 20/80",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.85,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.46,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 392.7,
    "MonthYield": 2.01,
    "YearYield": 2.01,
    "Last12MonthYield": 13.58,
    "ISIN": "IL0051261233"
  },
  {
    "Id": "TASE:5126107",
    "MayaId": "5126107",
    "Name": "Focus 90/10 IL",
    "ShortName": "Focus 90/10 IL",
    "Symbol": "TASE:5126107",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Focus (1A) 90/10 IL",
    "EnglishLongName": "Focus (1A) 90/10 IL",
    "HebrewName": "פוקוס 10/90",
    "HebrewLongName": "פוקוס (1A)י 10/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.39,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 282.7,
    "MonthYield": 1.3,
    "YearYield": 1.3,
    "Last12MonthYield": 10.18,
    "ISIN": "IL0051261076"
  },
  {
    "Id": "TASE:5136361",
    "MayaId": "5136361",
    "Name": "Focus Bond IL 0B(!)",
    "ShortName": "Focus Bond IL 0B(!)",
    "Symbol": "TASE:5136361",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Focus Bond IL 0B(!)",
    "EnglishLongName": "Focus Bond IL 0B(!)",
    "HebrewName": "פוקוס אג\"ח (0B)(!)",
    "HebrewLongName": "פוקוס אג\"ח (0B)(!)",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.27,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 79.4,
    "MonthYield": 0.74,
    "YearYield": 0.74,
    "Last12MonthYield": 6.0,
    "ISIN": "IL0051363617"
  },
  {
    "Id": "TASE:5132386",
    "MayaId": "5132386",
    "Name": "FOCUS CORPORATE BONDS IL",
    "ShortName": "FOCUS CORPORATE BONDS IL",
    "Symbol": "TASE:5132386",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "FOCUS (0A)(!) CORPORATE BONDS IL",
    "EnglishLongName": "FOCUS (0A)(!) CORPORATE BONDS IL",
    "HebrewName": "פוקוס אג\"ח חברות",
    "HebrewLongName": "פוקוס (0A)(!) אג\"ח חברות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 120.2,
    "MonthYield": 0.75,
    "YearYield": 0.75,
    "Last12MonthYield": 6.13,
    "ISIN": "IL0051323868"
  },
  {
    "Id": "TASE:5126081",
    "MayaId": "5126081",
    "Name": "Focus flexible",
    "ShortName": "Focus flexible",
    "Symbol": "TASE:5126081",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Focus (4D) flexible",
    "EnglishLongName": "Focus (4D) flexible",
    "HebrewName": "פוקוס גמישה",
    "HebrewLongName": "פוקוס (4D) גמישה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.6,
    "TrusteeFee": 0.045,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 125.7,
    "MonthYield": 6.79,
    "YearYield": 6.79,
    "Last12MonthYield": 51.06,
    "ISIN": "IL0051260813"
  },
  {
    "Id": "FRSX.TA",
    "MayaId": "199018",
    "Name": "FORESIGHT",
    "ShortName": "FORESIGHT AUTONOMOUS HOLDINGS LTD",
    "Symbol": "FRSX.TA",
    "TaseSymbol": "FRSX",
    "YahooId": "FRSX.TA",
    "EnglishName": "FORESIGHT",
    "EnglishLongName": "FORESIGHT AUTONOMOUS HOLDINGS LTD",
    "HebrewName": "פורסייט",
    "HebrewLongName": "פורסייט אוטונומס הולדינגס בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 15.8,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 2.6,
    "YearYield": 2.6,
    "Last12MonthYield": null,
    "ISIN": "IL0001990188"
  },
  {
    "Id": "TASE:5136288",
    "MayaId": "5136288",
    "Name": "FOREST 70/30",
    "ShortName": "FOREST 70/30",
    "Symbol": "TASE:5136288",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "FOREST (2B) 70/30 IL",
    "EnglishLongName": "FOREST (2B) 70/30 IL",
    "HebrewName": "FORESTי 30/70",
    "HebrewLongName": "FOREST י(2B)י 30/70",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.95,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.57,
    "Sector": "",
    "Industry": "",
    "ManagerName": "FOREST MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 137.6,
    "MonthYield": 1.33,
    "YearYield": 1.33,
    "Last12MonthYield": 15.54,
    "ISIN": "IL0051362882"
  },
  {
    "Id": "TASE:5118674",
    "MayaId": "5118674",
    "Name": "FOREST 80/20",
    "ShortName": "FOREST 80/20",
    "Symbol": "TASE:5118674",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "FOREST (2B) 80/20 IL",
    "EnglishLongName": "FOREST (2B) 80/20 IL",
    "HebrewName": "20/80FOREST",
    "HebrewLongName": "FOREST י(2B)י 20/80",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.95,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.49,
    "Sector": "",
    "Industry": "",
    "ManagerName": "FOREST MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 1291.1,
    "MonthYield": 1.22,
    "YearYield": 1.22,
    "Last12MonthYield": 12.55,
    "ISIN": "IL0051186745"
  },
  {
    "Id": "TASE:5125265",
    "MayaId": "5125265",
    "Name": "FOREST 90/10",
    "ShortName": "FOREST 90/10",
    "Symbol": "TASE:5125265",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "FOREST (1B) 90/10 IL",
    "EnglishLongName": "FOREST (1B) 90/10 IL",
    "HebrewName": "FORESTי 10/90",
    "HebrewLongName": "FOREST י(1B)י 10/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "FOREST MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 1663.6,
    "MonthYield": 0.83,
    "YearYield": 0.83,
    "Last12MonthYield": 9.4,
    "ISIN": "IL0051252653"
  },
  {
    "Id": "TASE:5106562",
    "MayaId": "5106562",
    "Name": "FOREST AGAM GOV BONDS",
    "ShortName": "FOREST AGAM-GOV BONDS",
    "Symbol": "TASE:5106562",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "FOREST (0A) AGAM- GOVERNMENT BONDS IL",
    "EnglishLongName": "FOREST (0A) AGAM- GOVERNMENT BONDS IL",
    "HebrewName": "FOREST אגם - אג\"ח מדינה",
    "HebrewLongName": "0A) FOREST) אגם - אג\"ח מדינה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.14,
    "Sector": "",
    "Industry": "",
    "ManagerName": "FOREST MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - No Equity",
    "AssetValue": 1056.0,
    "MonthYield": 0.24,
    "YearYield": 0.24,
    "Last12MonthYield": 4.81,
    "ISIN": "IL0051065626"
  },
  {
    "Id": "TASE:5138938",
    "MayaId": "5138938",
    "Name": "FOREST BOND Portfolio",
    "ShortName": "FOREST BOND Portfolio",
    "Symbol": "TASE:5138938",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "FOREST (0B) BOND Portfolio IL",
    "EnglishLongName": "FOREST (0B) BOND Portfolio IL",
    "HebrewName": "FOREST תיק אג\"ח ללא מניות",
    "HebrewLongName": "FOREST י(0B) תיק אג\"ח ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.19,
    "Sector": "",
    "Industry": "",
    "ManagerName": "FOREST MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 106.1,
    "MonthYield": 0.4,
    "YearYield": 0.4,
    "Last12MonthYield": 6.54,
    "ISIN": "IL0051389380"
  },
  {
    "Id": "TASE:5108519",
    "MayaId": "5108519",
    "Name": "FOREST BONDS",
    "ShortName": "FOREST BONDS",
    "Symbol": "TASE:5108519",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "FOREST (1B)(!) BONDS IL",
    "EnglishLongName": "FOREST (1B)(!) BONDS IL",
    "HebrewName": "FOREST אג\"ח",
    "HebrewLongName": "FORESTי (1B)(!) אג\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.88,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "FOREST MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 1246.1,
    "MonthYield": 0.89,
    "YearYield": 0.89,
    "Last12MonthYield": 9.43,
    "ISIN": "IL0051085194"
  },
  {
    "Id": "TASE:5129978",
    "MayaId": "5129978",
    "Name": "FOREST BONDS ONLY",
    "ShortName": "FOREST BONDS ONLY",
    "Symbol": "TASE:5129978",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "FOREST (0B)(!) BONDS ONLY IL",
    "EnglishLongName": "FOREST (0B)(!) BONDS ONLY IL",
    "HebrewName": "FOREST אג\"ח ללא מניות",
    "HebrewLongName": "FOREST (י0B)(!) אג\"ח ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.21,
    "Sector": "",
    "Industry": "",
    "ManagerName": "FOREST MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 687.4,
    "MonthYield": 0.51,
    "YearYield": 0.51,
    "Last12MonthYield": 6.36,
    "ISIN": "IL0051299787"
  },
  {
    "Id": "TASE:5128616",
    "MayaId": "5128616",
    "Name": "FOREST EQUITY",
    "ShortName": "FOREST EQUITY",
    "Symbol": "TASE:5128616",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "FOREST (4B) EQUITY IL",
    "EnglishLongName": "FOREST (4B) EQUITY IL",
    "HebrewName": "FOREST מניות",
    "HebrewLongName": "FOREST י(4B) מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.2,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.61,
    "Sector": "",
    "Industry": "",
    "ManagerName": "FOREST MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 266.1,
    "MonthYield": 3.22,
    "YearYield": 3.22,
    "Last12MonthYield": 34.77,
    "ISIN": "IL0051286164"
  },
  {
    "Id": "TASE:5116629",
    "MayaId": "5116629",
    "Name": "FOREST INV. GRADE BONDS",
    "ShortName": "FOREST INV. GRADE BONDS",
    "Symbol": "TASE:5116629",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "FOREST (0A)(!) INVESTMENT GRADE BONDS IL",
    "EnglishLongName": "FOREST (0A)(!) INVESTMENT GRADE BONDS IL",
    "HebrewName": "FOREST אג\"ח מדורג",
    "HebrewLongName": "FOREST (י0A)(!) אג\"ח מדורג",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.86,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.21,
    "Sector": "",
    "Industry": "",
    "ManagerName": "FOREST MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 578.0,
    "MonthYield": 0.51,
    "YearYield": 0.51,
    "Last12MonthYield": 6.19,
    "ISIN": "IL0051166291"
  },
  {
    "Id": "TASE:5141353",
    "MayaId": "5141353",
    "Name": "FOREST MONEY MARKET FUND",
    "ShortName": "FOREST MONEY MARKET FUND",
    "Symbol": "TASE:5141353",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "FOREST(00) MONEY MARKET FUND IL",
    "EnglishLongName": "FOREST(00) MONEY MARKET FUND IL",
    "HebrewName": "FOREST כספית",
    "HebrewLongName": "FOREST י(00) כספית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.07,
    "TrusteeFee": 0.005,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "FOREST MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 195.7,
    "MonthYield": 0.25,
    "YearYield": 0.25,
    "Last12MonthYield": null,
    "ISIN": "IL0051413537"
  },
  {
    "Id": "TASE:5108501",
    "MayaId": "5108501",
    "Name": "FOREST SEA EAGLE",
    "ShortName": "FOREST SEA EAGLE",
    "Symbol": "TASE:5108501",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "FOREST (3B) SEA EAGLE IL",
    "EnglishLongName": "FOREST (3B) SEA EAGLE IL",
    "HebrewName": "FOREST עיטם",
    "HebrewLongName": "3B) FOREST) עיטם",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.17,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.77,
    "Sector": "",
    "Industry": "",
    "ManagerName": "FOREST MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - Max. Exposure over 30% Equity",
    "AssetValue": 938.1,
    "MonthYield": 1.97,
    "YearYield": 1.97,
    "Last12MonthYield": 18.29,
    "ISIN": "IL0051085012"
  },
  {
    "Id": "TASE:5123542",
    "MayaId": "5123542",
    "Name": "FOREST SELECT 75/25",
    "ShortName": "FOREST SELECT 75/25",
    "Symbol": "TASE:5123542",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "FOREST (2B) SELECT 75\\25 IL",
    "EnglishLongName": "FOREST (2B) SELECT 75\\25 IL",
    "HebrewName": "FOREST סלקט 25/75",
    "HebrewLongName": "FOREST י(2B) סלקט 25/75",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.46,
    "Sector": "",
    "Industry": "",
    "ManagerName": "FOREST MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 25% Equity",
    "AssetValue": 207.3,
    "MonthYield": 1.23,
    "YearYield": 1.23,
    "Last12MonthYield": 12.8,
    "ISIN": "IL0051235427"
  },
  {
    "Id": "TASE:5115258",
    "MayaId": "5115258",
    "Name": "FOREST SELECT 85/15",
    "ShortName": "FOREST SELECT 85/15",
    "Symbol": "TASE:5115258",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "FOREST (2A) SELECT 85\\15 IL",
    "EnglishLongName": "FOREST (2A) SELECT 85\\15 IL",
    "HebrewName": "FOREST סלקט 15/85",
    "HebrewLongName": "FOREST י(2A) סלקט 15/85",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.87,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.31,
    "Sector": "",
    "Industry": "",
    "ManagerName": "FOREST MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 15% Equity",
    "AssetValue": 308.8,
    "MonthYield": 0.9,
    "YearYield": 0.9,
    "Last12MonthYield": 9.88,
    "ISIN": "IL0051152580"
  },
  {
    "Id": "FORTY.TA",
    "MayaId": "256016",
    "Name": "FORMULA",
    "ShortName": "FORMULA SYSTEMS (1985) LTD.",
    "Symbol": "FORTY.TA",
    "TaseSymbol": "FORTY",
    "YahooId": "FORTY.TA",
    "EnglishName": "FORMULA",
    "EnglishLongName": "FORMULA SYSTEMS (1985) LTD.",
    "HebrewName": "פורמולה מערכות",
    "HebrewLongName": "פורמולה מערכות (1985)בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 51700.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -1.5,
    "YearYield": -1.5,
    "Last12MonthYield": null,
    "ISIN": "IL0002560162"
  },
  {
    "Id": "TASE:5128541",
    "MayaId": "5128541",
    "Name": "FORT BOND LELO MEN IL",
    "ShortName": "FORT BOND LELO MEN IL",
    "Symbol": "TASE:5128541",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "FORTE (0B) BONDS WITHOUT STOCKS IL",
    "EnglishLongName": "FORTE (0B) BONDS WITHOUT STOCKS IL",
    "HebrewName": "פורטה אגח ללא מנ",
    "HebrewLongName": "פורטה (0B) אג\"ח ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 542.4,
    "MonthYield": 0.64,
    "YearYield": 0.64,
    "Last12MonthYield": 6.59,
    "ISIN": "IL0051285414"
  },
  {
    "Id": "TASE:5128475",
    "MayaId": "5128475",
    "Name": "Forte (1B) 90/10 IL",
    "ShortName": "Forte (1B) 90/10 IL",
    "Symbol": "TASE:5128475",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Forte (1B) 90/10 IL",
    "EnglishLongName": "Forte (1B) 90/10 IL",
    "HebrewName": "פורטה (1B)י 10/90",
    "HebrewLongName": "פורטה (1B)י 10/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.62,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.39,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 422.4,
    "MonthYield": 1.3,
    "YearYield": 1.3,
    "Last12MonthYield": 10.86,
    "ISIN": "IL0051284755"
  },
  {
    "Id": "TASE:5125000",
    "MayaId": "5125000",
    "Name": "Forte (2B) 80/20 IL",
    "ShortName": "Forte (2B) 80/20 IL",
    "Symbol": "TASE:5125000",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Forte (2B) 80/20 IL",
    "EnglishLongName": "Forte (2B) 80/20 IL",
    "HebrewName": "פורטה (2B)י 20/80",
    "HebrewLongName": "פורטה (2B)י 20/80",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.85,
    "TrusteeFee": 0.055,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.49,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 217.8,
    "MonthYield": 1.78,
    "YearYield": 1.78,
    "Last12MonthYield": 14.75,
    "ISIN": "IL0051250004"
  },
  {
    "Id": "TASE:5125018",
    "MayaId": "5125018",
    "Name": "Forte (4B) IL Equity",
    "ShortName": "Forte (4B) IL Equity",
    "Symbol": "TASE:5125018",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Forte (4B) Israel Equity IL",
    "EnglishLongName": "Forte (4B) Israel Equity IL",
    "HebrewName": "פורטה (4B) מניות ישראל",
    "HebrewLongName": "פורטה (4B) מניות ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.8,
    "TrusteeFee": 0.06,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.02,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 491.0,
    "MonthYield": 7.66,
    "YearYield": 7.66,
    "Last12MonthYield": 63.27,
    "ISIN": "IL0051250186"
  },
  {
    "Id": "TASE:5124995",
    "MayaId": "5124995",
    "Name": "Forte 4D Investment IL",
    "ShortName": "Forte 4D Investment IL",
    "Symbol": "TASE:5124995",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Forte (4D) Investment IL",
    "EnglishLongName": "Forte (4D) Investment IL",
    "HebrewName": "פורטה 4D השקעות",
    "HebrewLongName": "פורטה (4D) השקעות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.5,
    "TrusteeFee": 0.06,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.96,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 231.3,
    "MonthYield": 4.15,
    "YearYield": 4.15,
    "Last12MonthYield": 28.4,
    "ISIN": "IL0051249956"
  },
  {
    "Id": "TASE:5134432",
    "MayaId": "5134432",
    "Name": "Forte 70/30 IL",
    "ShortName": "Forte 70/30 IL",
    "Symbol": "TASE:5134432",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Forte (2B) 70/30 IL",
    "EnglishLongName": "Forte (2B) 70/30 IL",
    "HebrewName": "פורטה 30/70",
    "HebrewLongName": "פורטה (2B)י 30/70",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.63,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 491.3,
    "MonthYield": 2.3,
    "YearYield": 2.3,
    "Last12MonthYield": 19.56,
    "ISIN": "IL0051344328"
  },
  {
    "Id": "TASE:5128525",
    "MayaId": "5128525",
    "Name": "FORTE Equity IL",
    "ShortName": "FORTE Equity IL",
    "Symbol": "TASE:5128525",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "FORTE (4D) Equity IL",
    "EnglishLongName": "FORTE (4D) Equity IL",
    "HebrewName": "פורטה מניות",
    "HebrewLongName": "פורטה (4D) מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.85,
    "TrusteeFee": 0.06,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.05,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 271.3,
    "MonthYield": 8.16,
    "YearYield": 8.16,
    "Last12MonthYield": 68.31,
    "ISIN": "IL0051285257"
  },
  {
    "Id": "TASE:5137146",
    "MayaId": "5137146",
    "Name": "FORTE FOREIGN EQUITY",
    "ShortName": "FORTE FOREIGN EQUITY",
    "Symbol": "TASE:5137146",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "FORTE (4D) FOREIGN EQUITY",
    "EnglishLongName": "FORTE (4D) FOREIGN EQUITY",
    "HebrewName": "פורטה מניות חו\"ל",
    "HebrewLongName": "פורטה (4D) מניות חו\"ל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.7,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.27,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 114.7,
    "MonthYield": 2.0,
    "YearYield": 2.0,
    "Last12MonthYield": 6.35,
    "ISIN": "IL0051371461"
  },
  {
    "Id": "TASE:5128483",
    "MayaId": "5128483",
    "Name": "Forte General Bonds IL",
    "ShortName": "Forte General Bonds IL",
    "Symbol": "TASE:5128483",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Forte (oB)(!) General Bonds IL",
    "EnglishLongName": "Forte (oB)(!) General Bonds IL",
    "HebrewName": "פורטה אג\"ח כללי",
    "HebrewLongName": "פורטה (0B)(!) אג\"ח כללי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.27,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 80.4,
    "MonthYield": 0.85,
    "YearYield": 0.85,
    "Last12MonthYield": 6.98,
    "ISIN": "IL0051284839"
  },
  {
    "Id": "TASE:5136593",
    "MayaId": "5136593",
    "Name": "FORTE GOV BOND IL",
    "ShortName": "FORTE GOV BOND IL",
    "Symbol": "TASE:5136593",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "FORTE (1A) GOVERNMENT BOND IL",
    "EnglishLongName": "FORTE (1A) GOVERNMENT BOND IL",
    "HebrewName": "פורטה אג\"ח מדינה + 10%",
    "HebrewLongName": "פורטה (1A) אג\"ח מדינה + 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.38,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - up to 10% Equity",
    "AssetValue": 117.7,
    "MonthYield": 1.1,
    "YearYield": 1.1,
    "Last12MonthYield": 9.79,
    "ISIN": "IL0051365935"
  },
  {
    "Id": "TASE:5125562",
    "MayaId": "5125562",
    "Name": "Forte Port BON up 10% IL",
    "ShortName": "Forte Port BON up 10% IL",
    "Symbol": "TASE:5125562",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Forte (1B) Portfolio BONDS up to 10% IL",
    "EnglishLongName": "Forte (1B) Portfolio BONDS up to 10% IL",
    "HebrewName": "פורטה תיק אג\"ח עד 10%",
    "HebrewLongName": "פורטה (1B) תיק אג\"ח עד 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.055,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 266.4,
    "MonthYield": 1.0,
    "YearYield": 1.0,
    "Last12MonthYield": 9.48,
    "ISIN": "IL0051255623"
  },
  {
    "Id": "TASE:5136569",
    "MayaId": "5136569",
    "Name": "FORTE Port up to 50% IL",
    "ShortName": "FORTE Port up to 50% IL",
    "Symbol": "TASE:5136569",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "FORTE (3C) Portfolio up to 50% IL",
    "EnglishLongName": "FORTE (3C) Portfolio up to 50% IL",
    "HebrewName": "פורטה תיק השקעות עד 50%",
    "HebrewLongName": "פורטה (3C) תיק השקעות עד 50%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.95,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.91,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - Max. Exposure over 30% Equity",
    "AssetValue": 162.1,
    "MonthYield": 3.63,
    "YearYield": 3.63,
    "Last12MonthYield": 28.27,
    "ISIN": "IL0051365695"
  },
  {
    "Id": "TASE:5141395",
    "MayaId": "5141395",
    "Name": "FORTE Quality Equity USA",
    "ShortName": "FORTE Quality Equity USA",
    "Symbol": "TASE:5141395",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "FORTE (4D) Quality Equity USA",
    "EnglishLongName": "FORTE (4D) Quality Equity USA",
    "HebrewName": "פורטה Quality Equity USA",
    "HebrewLongName": "פורטה (4D)י Quality Equity USA",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.2,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Geographical stocks",
    "AssetValue": 156.9,
    "MonthYield": 3.82,
    "YearYield": 3.82,
    "Last12MonthYield": null,
    "ISIN": "IL0051413958"
  },
  {
    "Id": "TASE:5125570",
    "MayaId": "5125570",
    "Name": "Forte(!) CORP Bonds IL",
    "ShortName": "Forte(!) CORP Bonds IL",
    "Symbol": "TASE:5125570",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Forte (1B)(!) CORPORATE Bonds IL",
    "EnglishLongName": "Forte (1B)(!) CORPORATE Bonds IL",
    "HebrewName": "פורטה (!) אג\"ח חברות",
    "HebrewLongName": "פורטה (1B)(!) אג\"ח חברות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.0,
    "TrusteeFee": 0.055,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles with Equity",
    "AssetValue": 480.2,
    "MonthYield": 1.16,
    "YearYield": 1.16,
    "Last12MonthYield": 9.7,
    "ISIN": "IL0051255706"
  },
  {
    "Id": "TASE:5138425",
    "MayaId": "5138425",
    "Name": "Fortune (!) Gl Bnd D $",
    "ShortName": "Fortune (!) Gl Bnd D $",
    "Symbol": "TASE:5138425",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Fortune (0D)(!) Global Bond - Denominated in Dollar",
    "EnglishLongName": "Fortune (0D)(!) Global Bond - Denominated in Dollar",
    "HebrewName": "פורצן (!) אגח נקובה $",
    "HebrewLongName": "פורצ'ן (0D)(!) אג\"ח גלובלי – נקובה $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.9,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.09,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Bonds",
    "AssetValue": 279.3,
    "MonthYield": -0.44,
    "YearYield": -0.44,
    "Last12MonthYield": -3.8,
    "ISIN": "IL0051384258"
  },
  {
    "Id": "TASE:5141940",
    "MayaId": "5141940",
    "Name": "Fortune (2B) 70/30 IL",
    "ShortName": "Fortune (2B) 70/30 IL",
    "Symbol": "TASE:5141940",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Fortune (2B) 70/30 IL",
    "EnglishLongName": "Fortune (2B) 70/30 IL",
    "HebrewName": "פורצ'ן (2B)י 30/70",
    "HebrewLongName": "פורצ'ן (2B)י 30/70",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:5133459",
    "MayaId": "5133459",
    "Name": "Fortune (2B) 80/20 IL",
    "ShortName": "Fortune (2B) 80/20 IL",
    "Symbol": "TASE:5133459",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Fortune (2B) 80/20 IL",
    "EnglishLongName": "Fortune (2B) 80/20 IL",
    "HebrewName": "פורצ'ן (2B)י 20/80",
    "HebrewLongName": "פורצ'ן (2B)י 20/80",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.45,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 68.5,
    "MonthYield": 1.8,
    "YearYield": 1.8,
    "Last12MonthYield": 13.29,
    "ISIN": "IL0051334592"
  },
  {
    "Id": "TASE:5129119",
    "MayaId": "5129119",
    "Name": "FORTUNE 10/90 IL",
    "ShortName": "FORTUNE 10/90 IL",
    "Symbol": "TASE:5129119",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "FORTUNE (1B) 10/90 IL",
    "EnglishLongName": "FORTUNE (1B) 10/90 IL",
    "HebrewName": "פורצ'ן 10/90",
    "HebrewLongName": "פורצ'ן (1B)י 10/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.44,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 368.1,
    "MonthYield": 1.23,
    "YearYield": 1.23,
    "Last12MonthYield": 9.64,
    "ISIN": "IL0051291198"
  },
  {
    "Id": "TASE:5130802",
    "MayaId": "5130802",
    "Name": "FORTUNE BND NO STOCK IL",
    "ShortName": "FORTUNE BND NO STOCK IL",
    "Symbol": "TASE:5130802",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "FORTUNE (0B)(!) BONDS WITHOUT STOCKS IL",
    "EnglishLongName": "FORTUNE (0B)(!) BONDS WITHOUT STOCKS IL",
    "HebrewName": "פורצ'ן אג\"ח ללא מניות",
    "HebrewLongName": "פורצ'ן (0B)(!) אג\"ח ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 156.2,
    "MonthYield": 0.73,
    "YearYield": 0.73,
    "Last12MonthYield": 7.19,
    "ISIN": "IL0051308026"
  },
  {
    "Id": "TASE:5137211",
    "MayaId": "5137211",
    "Name": "Fortune Bonds Port IL",
    "ShortName": "Fortune Bonds Port IL",
    "Symbol": "TASE:5137211",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Fortune (0B) Bonds Portfolio IL",
    "EnglishLongName": "Fortune (0B) Bonds Portfolio IL",
    "HebrewName": "פורצ'ן תיק אג\"ח",
    "HebrewLongName": "פורצ'ן (0B) תיק אג\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.38,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 52.0,
    "MonthYield": 0.71,
    "YearYield": 0.71,
    "Last12MonthYield": 7.75,
    "ISIN": "IL0051372113"
  },
  {
    "Id": "TASE:5139753",
    "MayaId": "5139753",
    "Name": "Fortune Gl Bnd Prt 20% FC",
    "ShortName": "Fortune Gl Bnd Prt 20% FC",
    "Symbol": "TASE:5139753",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Fortune (1B) Global Bond Portfolio up to 20% Foreign Currency",
    "EnglishLongName": "Fortune (1B) Global Bond Portfolio up to 20% Foreign Currency",
    "HebrewName": "פורצ'ן אגח בינל עד 20 מטח",
    "HebrewLongName": "פורצ'ן (1B) תיק אג\"ח בינלאומי עד 20% מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.9,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.23,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX-Protected Bonds",
    "AssetValue": 176.8,
    "MonthYield": 0.5,
    "YearYield": 0.5,
    "Last12MonthYield": 8.56,
    "ISIN": "IL0051397532"
  },
  {
    "Id": "TASE:5134283",
    "MayaId": "5134283",
    "Name": "Fortune Global Equity",
    "ShortName": "Fortune Global Equity",
    "Symbol": "TASE:5134283",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Fortune (4D) Global Equity",
    "EnglishLongName": "Fortune (4D) Global Equity",
    "HebrewName": "פורצ'ן מניות חו\"ל",
    "HebrewLongName": "פורצ'ן (4D) מניות חו\"ל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.8,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 26.7,
    "MonthYield": 3.31,
    "YearYield": 3.31,
    "Last12MonthYield": 17.39,
    "ISIN": "IL0051342835"
  },
  {
    "Id": "FOX.TA",
    "MayaId": "1087022",
    "Name": "FOX",
    "ShortName": "FOX-WIZEL LTD.",
    "Symbol": "FOX.TA",
    "TaseSymbol": "FOX",
    "YahooId": "FOX.TA",
    "EnglishName": "FOX",
    "EnglishLongName": "FOX-WIZEL LTD.",
    "HebrewName": "פוקס",
    "HebrewLongName": "פוקס-ויזל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 32430.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 5.8,
    "YearYield": 5.8,
    "Last12MonthYield": null,
    "ISIN": "IL0010870223"
  },
  {
    "Id": "FRDN.TA",
    "MayaId": "1102219",
    "Name": "FRIDENSON",
    "ShortName": "FRIDENSON LOGISTIC SERVICES LTD",
    "Symbol": "FRDN.TA",
    "TaseSymbol": "FRDN",
    "YahooId": "FRDN.TA",
    "EnglishName": "FRIDENSON",
    "EnglishLongName": "FRIDENSON LOGISTIC SERVICES LTD",
    "HebrewName": "פרידנזון",
    "HebrewLongName": "פרידנזון שירותים לוגיסטיים בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 7560.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 2.1,
    "YearYield": 2.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011022196"
  },
  {
    "Id": "TASE:5129093",
    "MayaId": "5129093",
    "Name": "FRN FLEXIBLE",
    "ShortName": "FRN FLEXIBLE",
    "Symbol": "TASE:5129093",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "FORTUNE (4D) FLEXIBLE",
    "EnglishLongName": "FORTUNE (4D) FLEXIBLE",
    "HebrewName": "פורצ'ן גמישה",
    "HebrewLongName": "פורצ'ן (4D) גמישה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.8,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.95,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 148.2,
    "MonthYield": 6.73,
    "YearYield": 6.73,
    "Last12MonthYield": 44.18,
    "ISIN": "IL0051290935"
  },
  {
    "Id": "TASE:5129101",
    "MayaId": "5129101",
    "Name": "FRN GLOBAL BND",
    "ShortName": "FRN GLOBAL BND",
    "Symbol": "TASE:5129101",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "FORTUNE (0D)(!) GLOBAL BOND",
    "EnglishLongName": "FORTUNE (0D)(!) GLOBAL BOND",
    "HebrewName": "פורצ'ן אג\"ח בינלאומי",
    "HebrewLongName": "פורצ'ן (0D)(!) אג\"ח בינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.9,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.91,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Bond",
    "AssetValue": 728.9,
    "MonthYield": -0.61,
    "YearYield": -0.61,
    "Last12MonthYield": -3.4,
    "ISIN": "IL0051291016"
  },
  {
    "Id": "GOSS.TA",
    "MayaId": "1156280",
    "Name": "G 1 SECU",
    "ShortName": "G 1 SECURE SOLUTIONS LTD.",
    "Symbol": "GOSS.TA",
    "TaseSymbol": "GOSS",
    "YahooId": "GOSS.TA",
    "EnglishName": "G 1 SECU",
    "EnglishLongName": "G 1 SECURE SOLUTIONS LTD.",
    "HebrewName": "ג'י וואן",
    "HebrewLongName": "ג'י וואן פתרונות אבטחה בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 990.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 7.3,
    "YearYield": 7.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011562803"
  },
  {
    "Id": "GCT.TA",
    "MayaId": "126011",
    "Name": "G CITY",
    "ShortName": "G CITY LTD",
    "Symbol": "GCT.TA",
    "TaseSymbol": "GCT",
    "YahooId": "GCT.TA",
    "EnglishName": "G CITY",
    "EnglishLongName": "G CITY LTD",
    "HebrewName": "ג'י סיטי",
    "HebrewLongName": "ג'י סיטי בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 914.3,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 16.1,
    "YearYield": 16.1,
    "Last12MonthYield": null,
    "ISIN": "IL0001260111"
  },
  {
    "Id": "GFC-M.TA",
    "MayaId": "1122688",
    "Name": "G.F.C M",
    "ShortName": "G.F.C GREEN FIELDS CAPITAL LTD",
    "Symbol": "GFC-M.TA",
    "TaseSymbol": "GFC-M",
    "YahooId": "GFC-M.TA",
    "EnglishName": "G.F.C-M",
    "EnglishLongName": "G.F.C GREEN FIELDS CAPITAL LTD",
    "HebrewName": "ג'י.אף.סי-ש",
    "HebrewLongName": "ג'י.אף.סי גרין פילדס קפיטל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1376.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Investment & Holdings",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 8.0,
    "YearYield": 8.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011226888"
  },
  {
    "Id": "GPGB-M.TA",
    "MayaId": "1144781",
    "Name": "G.P GLOBAL M",
    "ShortName": "G.P. GLOBAL POWER LTD",
    "Symbol": "GPGB-M.TA",
    "TaseSymbol": "GPGB-M",
    "YahooId": "GPGB-M.TA",
    "EnglishName": "G.P GLOBAL-M",
    "EnglishLongName": "G.P. GLOBAL POWER LTD",
    "HebrewName": "ג'י.פי גלובל-ש",
    "HebrewLongName": "ג'י.פי. גלובל פאוור בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1300.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Energy And Oil & Gas Exploration",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 13.0,
    "YearYield": 13.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011447815"
  },
  {
    "Id": "GAD.TA",
    "MayaId": "1228808",
    "Name": "GAD DAIRIES",
    "ShortName": "GAD DAIRIES MARKETING 1992 LTD",
    "Symbol": "GAD.TA",
    "TaseSymbol": "GAD",
    "YahooId": "GAD.TA",
    "EnglishName": "GAD DAIRIES",
    "EnglishLongName": "GAD DAIRIES MARKETING 1992 LTD",
    "HebrewName": "מחלבות גד",
    "HebrewLongName": "מחלבות גד (שיווק-1992) בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1115.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -5.7,
    "YearYield": -5.7,
    "Last12MonthYield": null,
    "ISIN": "IL0012288085"
  },
  {
    "Id": "GSFI.TA",
    "MayaId": "532010",
    "Name": "GAN SHMUEL",
    "ShortName": "GAN SHMUEL FOODS LTD.",
    "Symbol": "GSFI.TA",
    "TaseSymbol": "GSFI",
    "YahooId": "GSFI.TA",
    "EnglishName": "GAN SHMUEL",
    "EnglishLongName": "GAN SHMUEL FOODS LTD.",
    "HebrewName": "גן שמואל",
    "HebrewLongName": "גן שמואל מזון בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3346.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 16.7,
    "YearYield": 16.7,
    "Last12MonthYield": null,
    "ISIN": "IL0005320101"
  },
  {
    "Id": "GAGR.TA",
    "MayaId": "454017",
    "Name": "GAON GROUP",
    "ShortName": "GAON GROUP LTD.",
    "Symbol": "GAGR.TA",
    "TaseSymbol": "GAGR",
    "YahooId": "GAGR.TA",
    "EnglishName": "GAON GROUP",
    "EnglishLongName": "GAON GROUP LTD.",
    "HebrewName": "גאון קבוצה",
    "HebrewLongName": "קבוצת גאון בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 821.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 8.5,
    "YearYield": 8.5,
    "Last12MonthYield": null,
    "ISIN": "IL0004540170"
  },
  {
    "Id": "GAON-M.TA",
    "MayaId": "1104744",
    "Name": "GAON M",
    "ShortName": "B.GAON HOLDINGS LTD.",
    "Symbol": "GAON-M.TA",
    "TaseSymbol": "GAON-M",
    "YahooId": "GAON-M.TA",
    "EnglishName": "GAON-M",
    "EnglishLongName": "B.GAON HOLDINGS LTD.",
    "HebrewName": "גאון אחזקות-ש",
    "HebrewLongName": "ב.גאון אחזקות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4375.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -2.7,
    "YearYield": -2.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011047441"
  },
  {
    "Id": "GVYM.TA",
    "MayaId": "759019",
    "Name": "GAV YAM",
    "ShortName": "GAV-YAM LANDS CORP.LTD",
    "Symbol": "GVYM.TA",
    "TaseSymbol": "GVYM",
    "YahooId": "GVYM.TA",
    "EnglishName": "GAV YAM",
    "EnglishLongName": "GAV-YAM LANDS CORP.LTD",
    "HebrewName": "גב ים",
    "HebrewLongName": "חברת גב ים לקרקעות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4111.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 8.5,
    "YearYield": 8.5,
    "Last12MonthYield": null,
    "ISIN": "IL0007590198"
  },
  {
    "Id": "TASE:5137443",
    "MayaId": "5137443",
    "Name": "Gavish 70/30 IL",
    "ShortName": "Gavish 70/30 IL",
    "Symbol": "TASE:5137443",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Gavish (2B) 70/30 IL",
    "EnglishLongName": "Gavish (2B) 70/30 IL",
    "HebrewName": "גביש 30/70",
    "HebrewLongName": "גביש (2B)י 30/70",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.63,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 26.8,
    "MonthYield": 2.99,
    "YearYield": 2.99,
    "Last12MonthYield": 15.78,
    "ISIN": "IL0051374432"
  },
  {
    "Id": "TASE:5122247",
    "MayaId": "5122247",
    "Name": "Gavish 80/20 IL",
    "ShortName": "Gavish 80/20 IL",
    "Symbol": "TASE:5122247",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Gavish (2B) 80/20 IL",
    "EnglishLongName": "Gavish (2B) 80/20 IL",
    "HebrewName": "גביש 20/80",
    "HebrewLongName": "גביש (2B)י 20/80",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.06,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.46,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 75.8,
    "MonthYield": 1.88,
    "YearYield": 1.88,
    "Last12MonthYield": 11.4,
    "ISIN": "IL0051222474"
  },
  {
    "Id": "TASE:5128566",
    "MayaId": "5128566",
    "Name": "Gavish Corp Bond no Eq IL",
    "ShortName": "Gavish Corp Bond no Eq IL",
    "Symbol": "TASE:5128566",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Gavish (0B)(!) Corporate Bonds without Equity IL",
    "EnglishLongName": "Gavish (0B)(!) Corporate Bonds without Equity IL",
    "HebrewName": "גביש אג\"ח חברות ללא מניות",
    "HebrewLongName": "גביש (0B)(!) אג\"ח חברות ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.29,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 42.3,
    "MonthYield": 0.59,
    "YearYield": 0.59,
    "Last12MonthYield": 3.88,
    "ISIN": "IL0051285661"
  },
  {
    "Id": "TASE:5135629",
    "MayaId": "5135629",
    "Name": "Gavish Flexible",
    "ShortName": "Gavish Flexible",
    "Symbol": "TASE:5135629",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Gavish (4D) Flexible",
    "EnglishLongName": "Gavish (4D) Flexible",
    "HebrewName": "גביש גמישה",
    "HebrewLongName": "גביש (4D) גמישה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.85,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.42,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 24.8,
    "MonthYield": 1.59,
    "YearYield": 1.59,
    "Last12MonthYield": 14.25,
    "ISIN": "IL0051356298"
  },
  {
    "Id": "TASE:5141551",
    "MayaId": "5141551",
    "Name": "Gavish IL Stocks",
    "ShortName": "Gavish IL Stocks",
    "Symbol": "TASE:5141551",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Gavish (4B) Israeli Stocks IL",
    "EnglishLongName": "Gavish (4B) Israeli Stocks IL",
    "HebrewName": "גביש מניות ישראל",
    "HebrewLongName": "גביש (4B) מניות ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.85,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 1.9,
    "MonthYield": 9.76,
    "YearYield": 9.76,
    "Last12MonthYield": null,
    "ISIN": "IL0051415516"
  },
  {
    "Id": "GEFR.TA",
    "MayaId": "1118116",
    "Name": "GEFFEN R&R",
    "ShortName": "GEFFEN RESIDENCE & RENEWAL LTD",
    "Symbol": "GEFR.TA",
    "TaseSymbol": "GEFR",
    "YahooId": "GEFR.TA",
    "EnglishName": "GEFFEN R&R",
    "EnglishLongName": "GEFFEN RESIDENCE & RENEWAL LTD",
    "HebrewName": "גפן מגורים",
    "HebrewLongName": "גפן מגורים והתחדשות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 82.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 2.1,
    "YearYield": 2.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011181166"
  },
  {
    "Id": "GNCL.TA",
    "MayaId": "1169689",
    "Name": "GENCELL",
    "ShortName": "GENCELL LTD",
    "Symbol": "GNCL.TA",
    "TaseSymbol": "GNCL",
    "YahooId": "GNCL.TA",
    "EnglishName": "GENCELL",
    "EnglishLongName": "GENCELL LTD",
    "HebrewName": "ג'נסל",
    "HebrewLongName": "ג'נסל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 128.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 50.5,
    "YearYield": 50.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011696890"
  },
  {
    "Id": "TASE:1",
    "MayaId": "1",
    "Name": "General Shares and Convertibles",
    "ShortName": "General Shares and Convertibles",
    "Symbol": "TASE:1",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "General Shares and Convertibles",
    "EnglishLongName": "General Shares and Convertibles",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "GNRS.TA",
    "MayaId": "1156926",
    "Name": "GENERATION CAP",
    "ShortName": "GENERATION CAPITAL LTD",
    "Symbol": "GNRS.TA",
    "TaseSymbol": "GNRS",
    "YahooId": "GNRS.TA",
    "EnglishName": "GENERATION CAP",
    "EnglishLongName": "GENERATION CAPITAL LTD",
    "HebrewName": "ג'נריישן קפיטל",
    "HebrewLongName": "ג'נריישן קפיטל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 144.2,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Investment & Holdings",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 7.4,
    "YearYield": 7.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011569261"
  },
  {
    "Id": "GIBUI.TA",
    "MayaId": "448019",
    "Name": "GIBUI HOLDING",
    "ShortName": "GIBUI HOLDINGS LTD.",
    "Symbol": "GIBUI.TA",
    "TaseSymbol": "GIBUI",
    "YahooId": "GIBUI.TA",
    "EnglishName": "GIBUI HOLDING",
    "EnglishLongName": "GIBUI HOLDINGS LTD.",
    "HebrewName": "גיבוי אחזקות",
    "HebrewLongName": "גיבוי אחזקות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 76.3,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Financial Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.0,
    "YearYield": 0.0,
    "Last12MonthYield": null,
    "ISIN": "IL0004480195"
  },
  {
    "Id": "GILT.TA",
    "MayaId": "1082510",
    "Name": "GILAT",
    "ShortName": "GILAT SATELLITE NETWORKS LTD.",
    "Symbol": "GILT.TA",
    "TaseSymbol": "GILT",
    "YahooId": "GILT.TA",
    "EnglishName": "GILAT",
    "EnglishLongName": "GILAT SATELLITE NETWORKS LTD.",
    "HebrewName": "גילת",
    "HebrewLongName": "גילת רשתות לווין בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5487.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 34.4,
    "YearYield": 34.4,
    "Last12MonthYield": null,
    "ISIN": "IL0010825102"
  },
  {
    "Id": "GLTL.TA",
    "MayaId": "1080597",
    "Name": "GILAT TELECOM",
    "ShortName": "GILAT TELECOM GLOBAL LTD",
    "Symbol": "GLTL.TA",
    "TaseSymbol": "GLTL",
    "YahooId": "GLTL.TA",
    "EnglishName": "GILAT TELECOM",
    "EnglishLongName": "GILAT TELECOM GLOBAL LTD",
    "HebrewName": "גילת טלקום",
    "HebrewLongName": "גילת טלקום גלובל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 134.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 13.1,
    "YearYield": 13.1,
    "Last12MonthYield": null,
    "ISIN": "IL0010805971"
  },
  {
    "Id": "GNGR.TA",
    "MayaId": "1095892",
    "Name": "GINEGAR",
    "ShortName": "GINEGAR PLASTIC PRODUCTS LTD.",
    "Symbol": "GNGR.TA",
    "TaseSymbol": "GNGR",
    "YahooId": "GNGR.TA",
    "EnglishName": "GINEGAR",
    "EnglishLongName": "GINEGAR PLASTIC PRODUCTS LTD.",
    "HebrewName": "גניגר",
    "HebrewLongName": "גניגר מפעלי פלסטיק בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 885.9,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 7.2,
    "YearYield": 7.2,
    "Last12MonthYield": null,
    "ISIN": "IL0010958929"
  },
  {
    "Id": "GIX.TA",
    "MayaId": "744011",
    "Name": "GIX",
    "ShortName": "GIX INTERNET LTD",
    "Symbol": "GIX.TA",
    "TaseSymbol": "GIX",
    "YahooId": "GIX.TA",
    "EnglishName": "GIX",
    "EnglishLongName": "GIX INTERNET LTD",
    "HebrewName": "גיקס",
    "HebrewLongName": "גיקס אינטרנט בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2291.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 42.4,
    "YearYield": 42.4,
    "Last12MonthYield": null,
    "ISIN": "IL0007440113"
  },
  {
    "Id": "GKL.TA",
    "MayaId": "1141316",
    "Name": "GLOBAL KNAFAIM",
    "ShortName": "GLOBAL KNAFAIM LEASING LTD",
    "Symbol": "GKL.TA",
    "TaseSymbol": "GKL",
    "YahooId": "GKL.TA",
    "EnglishName": "GLOBAL KNAFAIM",
    "EnglishLongName": "GLOBAL KNAFAIM LEASING LTD",
    "HebrewName": "גלובל כנפיים",
    "HebrewLongName": "גלובל כנפיים ליסינג בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 77.5,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.7,
    "YearYield": 1.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011413163"
  },
  {
    "Id": "GPAY-M.TA",
    "MayaId": "1081983",
    "Name": "GLOBAL PAY M",
    "ShortName": "GLOBAL PAY (P.C.S) LTD",
    "Symbol": "GPAY-M.TA",
    "TaseSymbol": "GPAY-M",
    "YahooId": "GPAY-M.TA",
    "EnglishName": "GLOBAL PAY-M",
    "EnglishLongName": "GLOBAL PAY (P.C.S) LTD",
    "HebrewName": "גלובל פיי-ש",
    "HebrewLongName": "גלובל פיי (פי.סי.אס) בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 140.1,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Financial Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 16.7,
    "YearYield": 16.7,
    "Last12MonthYield": null,
    "ISIN": "IL0010819832"
  },
  {
    "Id": "GLRS.TA",
    "MayaId": "1147487",
    "Name": "GLOBRANDS",
    "ShortName": "GLOBRANDS GROUP LTD",
    "Symbol": "GLRS.TA",
    "TaseSymbol": "GLRS",
    "YahooId": "GLRS.TA",
    "EnglishName": "GLOBRANDS",
    "EnglishLongName": "GLOBRANDS GROUP LTD",
    "HebrewName": "גלוברנדס",
    "HebrewLongName": "גלוברנדס גרופ בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 49030.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 9.6,
    "YearYield": 9.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011474876"
  },
  {
    "Id": "GRIN.TA",
    "MayaId": "1091933",
    "Name": "GOLAN INDUS",
    "ShortName": "GOLAN RENEWABLE INDUSTRIES LTD.",
    "Symbol": "GRIN.TA",
    "TaseSymbol": "GRIN",
    "YahooId": "GRIN.TA",
    "EnglishName": "GOLAN INDUS",
    "EnglishLongName": "GOLAN RENEWABLE INDUSTRIES LTD.",
    "HebrewName": "גולן תעשיות",
    "HebrewLongName": "גולן תעשיות מתחדשות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 918.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -4.2,
    "YearYield": -4.2,
    "Last12MonthYield": null,
    "ISIN": "IL0010919335"
  },
  {
    "Id": "GOLD.TA",
    "MayaId": "149013",
    "Name": "GOLD",
    "ShortName": "THE GOLD BOND GROUP LTD.",
    "Symbol": "GOLD.TA",
    "TaseSymbol": "GOLD",
    "YahooId": "GOLD.TA",
    "EnglishName": "GOLD",
    "EnglishLongName": "THE GOLD BOND GROUP LTD.",
    "HebrewName": "גולד",
    "HebrewLongName": "קבוצת גולד בונד בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 25560.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 13.9,
    "YearYield": 13.9,
    "Last12MonthYield": null,
    "ISIN": "IL0001490130"
  },
  {
    "Id": "GLDE.TA",
    "MayaId": "1083443",
    "Name": "GOLDEN ENERGY",
    "ShortName": "GOLDEN ENERGY POWER LTD",
    "Symbol": "GLDE.TA",
    "TaseSymbol": "GLDE",
    "YahooId": "GLDE.TA",
    "EnglishName": "GOLDEN ENERGY",
    "EnglishLongName": "GOLDEN ENERGY POWER LTD",
    "HebrewName": "גולדן אנרג'י",
    "HebrewLongName": "גולדן אנרג'י פאואר בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 337.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 67.0,
    "YearYield": 67.0,
    "Last12MonthYield": null,
    "ISIN": "IL0010834435"
  },
  {
    "Id": "GOHO.TA",
    "MayaId": "235010",
    "Name": "GOLDEN HOUSE",
    "ShortName": "GOLDEN HOUSE LTD.",
    "Symbol": "GOHO.TA",
    "TaseSymbol": "GOHO",
    "YahooId": "GOHO.TA",
    "EnglishName": "GOLDEN HOUSE",
    "EnglishLongName": "GOLDEN HOUSE LTD.",
    "HebrewName": "בית הזהב",
    "HebrewLongName": "בית-הזהב בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1130.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 9.6,
    "YearYield": 9.6,
    "Last12MonthYield": null,
    "ISIN": "IL0002350101"
  },
  {
    "Id": "GOLF.TA",
    "MayaId": "1096148",
    "Name": "GOLF",
    "ShortName": "GOLF & CO GROUP LTD",
    "Symbol": "GOLF.TA",
    "TaseSymbol": "GOLF",
    "YahooId": "GOLF.TA",
    "EnglishName": "GOLF",
    "EnglishLongName": "GOLF & CO GROUP LTD",
    "HebrewName": "גולף",
    "HebrewLongName": "קבוצת גולף א. ק. בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 712.3,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.8,
    "YearYield": 1.8,
    "Last12MonthYield": null,
    "ISIN": "IL0010961485"
  },
  {
    "Id": "GOTO.TA",
    "MayaId": "1176726",
    "Name": "GOTO",
    "ShortName": "GOTO LTD",
    "Symbol": "GOTO.TA",
    "TaseSymbol": "GOTO",
    "YahooId": "GOTO.TA",
    "EnglishName": "GOTO",
    "EnglishLongName": "GOTO LTD",
    "HebrewName": "גוטו",
    "HebrewLongName": "גוטו בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 370.6,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -3.0,
    "YearYield": -3.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011767261"
  },
  {
    "Id": "GRAC.TA",
    "MayaId": "1184365",
    "Name": "GRACE BREEDING",
    "ShortName": "GRACE BREEDING LTD",
    "Symbol": "GRAC.TA",
    "TaseSymbol": "GRAC",
    "YahooId": "GRAC.TA",
    "EnglishName": "GRACE BREEDING",
    "EnglishLongName": "GRACE BREEDING LTD",
    "HebrewName": "גרייס ברידינג",
    "HebrewLongName": "גרייס ברידינג בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1687.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -5.9,
    "YearYield": -5.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011843658"
  },
  {
    "Id": "G107.TA",
    "MayaId": "1180181",
    "Name": "GROUP 107",
    "ShortName": "GROUP 107 LTD",
    "Symbol": "G107.TA",
    "TaseSymbol": "G107",
    "YahooId": "G107.TA",
    "EnglishName": "GROUP 107",
    "EnglishLongName": "GROUP 107 LTD",
    "HebrewName": "גרופ 107",
    "HebrewLongName": "גרופ 107 בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 95.9,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -15.9,
    "YearYield": -15.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011801813"
  },
  {
    "Id": "TASE:5135058",
    "MayaId": "5135058",
    "Name": "Gse Spot (4B) Equity IL",
    "ShortName": "Gse Spot (4B) Equity IL",
    "Symbol": "TASE:5135058",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Gse Spot (4B) Equity IL",
    "EnglishLongName": "Gse Spot (4B) Equity IL",
    "HebrewName": "Gse Spotי (4B) מניות",
    "HebrewLongName": "Gse Spotי (4B) מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.85,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 7.4,
    "MonthYield": 7.5,
    "YearYield": 7.5,
    "Last12MonthYield": 66.14,
    "ISIN": "IL0051350580"
  },
  {
    "Id": "TASE:5117445",
    "MayaId": "5117445",
    "Name": "Gse Spot Analys IL",
    "ShortName": "Gse Spot Analys IL",
    "Symbol": "TASE:5117445",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Gse Spot (0A) Corporate Bond Analysis IL",
    "EnglishLongName": "Gse Spot (0A) Corporate Bond Analysis IL",
    "HebrewName": "Gse Spot מחקר",
    "HebrewLongName": "Gse Spotי (0A) מחקר קונצרני",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.9,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.27,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 38.8,
    "MonthYield": 0.58,
    "YearYield": 0.58,
    "Last12MonthYield": 5.23,
    "ISIN": "IL0051174451"
  },
  {
    "Id": "HDST-M.TA",
    "MayaId": "1095405",
    "Name": "HADASIT BIO M",
    "ShortName": "HBL - HADASIT BIO HOLDINGS LTD",
    "Symbol": "HDST-M.TA",
    "TaseSymbol": "HDST-M",
    "YahooId": "HDST-M.TA",
    "EnglishName": "HADASIT BIO-M",
    "EnglishLongName": "HBL - HADASIT BIO HOLDINGS LTD",
    "HebrewName": "הדסית ביו-ש",
    "HebrewLongName": "אייץ' בי אל - הדסית ביו החזקות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 33.2,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Investment & Holdings",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 7.1,
    "YearYield": 7.1,
    "Last12MonthYield": null,
    "ISIN": "IL0010954050"
  },
  {
    "Id": "HGG.TA",
    "MayaId": "823013",
    "Name": "HAGAG",
    "ShortName": "HAGAG GROUP REAL ESTATE ENTREPRENEURSHIP LTD",
    "Symbol": "HGG.TA",
    "TaseSymbol": "HGG",
    "YahooId": "HGG.TA",
    "EnglishName": "HAGAG",
    "EnglishLongName": "HAGAG GROUP REAL ESTATE ENTREPRENEURSHIP LTD",
    "HebrewName": "חג'ג'",
    "HebrewLongName": "קבוצת חג'ג' ייזום נדל\"ן בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2345.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 9.2,
    "YearYield": 9.2,
    "Last12MonthYield": null,
    "ISIN": "IL0008230133"
  },
  {
    "Id": "HGGE.TA",
    "MayaId": "1143635",
    "Name": "HAGAG EURO",
    "ShortName": "HAGAG EUROPE DEVELOPMENT Z.F.LTD",
    "Symbol": "HGGE.TA",
    "TaseSymbol": "HGGE",
    "YahooId": "HGGE.TA",
    "EnglishName": "HAGAG EURO",
    "EnglishLongName": "HAGAG EUROPE DEVELOPMENT Z.F.LTD",
    "HebrewName": "חג'ג' אירופה",
    "HebrewLongName": "חג'ג' אירופה דיוולופמנט צ.ש. בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1061.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 3.0,
    "YearYield": 3.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011436354"
  },
  {
    "Id": "HMAM.TA",
    "MayaId": "1104785",
    "Name": "HAMAMA",
    "ShortName": "HAMAMA MEIR TRADING (1996) LTD.",
    "Symbol": "HMAM.TA",
    "TaseSymbol": "HMAM",
    "YahooId": "HMAM.TA",
    "EnglishName": "HAMAMA",
    "EnglishLongName": "HAMAMA MEIR TRADING (1996) LTD.",
    "HebrewName": "חממה סחר",
    "HebrewLongName": "חממה מאיר סחר (1996) בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 601.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 5.3,
    "YearYield": 5.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011047854"
  },
  {
    "Id": "MSBI.TA",
    "MayaId": "1104959",
    "Name": "HAMASHBIR 365",
    "ShortName": "HAMASHBIR 365 LTD",
    "Symbol": "MSBI.TA",
    "TaseSymbol": "MSBI",
    "YahooId": "MSBI.TA",
    "EnglishName": "HAMASHBIR 365",
    "EnglishLongName": "HAMASHBIR 365 LTD",
    "HebrewName": "המשביר 365",
    "HebrewLongName": "המשביר 365 בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 107.5,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -3.7,
    "YearYield": -3.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011049595"
  },
  {
    "Id": "HAMAT.TA",
    "MayaId": "384016",
    "Name": "HAMAT",
    "ShortName": "HAMAT GROUP LTD.",
    "Symbol": "HAMAT.TA",
    "TaseSymbol": "HAMAT",
    "YahooId": "HAMAT.TA",
    "EnglishName": "HAMAT",
    "EnglishLongName": "HAMAT GROUP LTD.",
    "HebrewName": "חמת",
    "HebrewLongName": "קבוצת חמת בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1686.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -0.5,
    "YearYield": -0.5,
    "Last12MonthYield": null,
    "ISIN": "IL0003840167"
  },
  {
    "Id": "HARL.TA",
    "MayaId": "585018",
    "Name": "HAREL",
    "ShortName": "HAREL INSURANCE INVESTMENTS & FINANCIAL SERVICES LTD.",
    "Symbol": "HARL.TA",
    "TaseSymbol": "HARL",
    "YahooId": "HARL.TA",
    "EnglishName": "HAREL",
    "EnglishLongName": "HAREL INSURANCE INVESTMENTS & FINANCIAL SERVICES LTD.",
    "HebrewName": "הראל השקעות",
    "HebrewLongName": "הראל השקעות בביטוח ושרותים פיננסים בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 13390.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Insurance",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 10.1,
    "YearYield": 10.1,
    "Last12MonthYield": null,
    "ISIN": "IL0005850180"
  },
  {
    "Id": "TASE:5112768",
    "MayaId": "5112768",
    "Name": "Harel 70/30 IL",
    "ShortName": "Harel 70/30 IL",
    "Symbol": "TASE:5112768",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "HAREL (2B) 70/30 IL",
    "EnglishLongName": "HAREL (2B) 70/30 IL",
    "HebrewName": "הראל 30/70",
    "HebrewLongName": "הראל (2B)י 30/70",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.44,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 342.9,
    "MonthYield": 2.19,
    "YearYield": 2.19,
    "Last12MonthYield": 17.56,
    "ISIN": "IL0051127681"
  },
  {
    "Id": "TASE:5115555",
    "MayaId": "5115555",
    "Name": "Harel 70\\30 Plus IL",
    "ShortName": "Harel 70\\30 Plus IL",
    "Symbol": "TASE:5115555",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (2B) 70\\30 Plus IL",
    "EnglishLongName": "Harel (2B) 70\\30 Plus IL",
    "HebrewName": "הראל 30/70 פלוס",
    "HebrewLongName": "הראל (2B)י 30/70 פלוס",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.64,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 8.7,
    "MonthYield": 2.04,
    "YearYield": 2.04,
    "Last12MonthYield": 9.85,
    "ISIN": "IL0051155559"
  },
  {
    "Id": "TASE:5125943",
    "MayaId": "5125943",
    "Name": "Harel 75/25 IL",
    "ShortName": "Harel 75/25 IL",
    "Symbol": "TASE:5125943",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (2B) 75/25 IL",
    "EnglishLongName": "Harel (2B) 75/25 IL",
    "HebrewName": "הראל 25/75",
    "HebrewLongName": "הראל (2B)י 25/75",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.49,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.56,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 25% Equity",
    "AssetValue": 4.9,
    "MonthYield": 2.61,
    "YearYield": 2.61,
    "Last12MonthYield": 14.91,
    "ISIN": "IL0051259435"
  },
  {
    "Id": "TASE:5125950",
    "MayaId": "5125950",
    "Name": "Harel 80/20 IL",
    "ShortName": "Harel 80/20 IL",
    "Symbol": "TASE:5125950",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (2B) 80/20 IL",
    "EnglishLongName": "Harel (2B) 80/20 IL",
    "HebrewName": "הראל 20/80",
    "HebrewLongName": "הראל (2B)י 20/80",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.84,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 451.8,
    "MonthYield": 1.14,
    "YearYield": 1.14,
    "Last12MonthYield": 12.8,
    "ISIN": "IL0051259500"
  },
  {
    "Id": "TASE:5132998",
    "MayaId": "5132998",
    "Name": "Harel 85/15 Denomd in$ IL",
    "ShortName": "Harel 85/15 Denomd in$ IL",
    "Symbol": "TASE:5132998",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (2D) 85/15 - Denominated in - $ IL",
    "EnglishLongName": "Harel (2D) 85/15 - Denominated in - $ IL",
    "HebrewName": "הראל 15/85 - נקובה $",
    "HebrewLongName": "הראל (2D)י 15/85 - נקובה $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.96,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 15% Equity",
    "AssetValue": 207.1,
    "MonthYield": 0.36,
    "YearYield": 0.36,
    "Last12MonthYield": -1.98,
    "ISIN": "IL0051329980"
  },
  {
    "Id": "TASE:5125935",
    "MayaId": "5125935",
    "Name": "Harel 85/15 IL",
    "ShortName": "Harel 85/15 IL",
    "Symbol": "TASE:5125935",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (2B) 85/15 IL",
    "EnglishLongName": "Harel (2B) 85/15 IL",
    "HebrewName": "הראל 15/85",
    "HebrewLongName": "הראל (2B)י 15/85",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.58,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.38,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 15% Equity",
    "AssetValue": 158.5,
    "MonthYield": 1.4,
    "YearYield": 1.4,
    "Last12MonthYield": 12.46,
    "ISIN": "IL0051259351"
  },
  {
    "Id": "TASE:5115290",
    "MayaId": "5115290",
    "Name": "Harel 90/10 + Payout IL",
    "ShortName": "Harel 90/10 + Payout IL",
    "Symbol": "TASE:5115290",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (1A) 90/10 + Payout IL",
    "EnglishLongName": "Harel (1A) 90/10 + Payout IL",
    "HebrewName": "הראל 10/90 מחלקת",
    "HebrewLongName": "הראל 10/90 (1A) מחלקת",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.77,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.27,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 25.4,
    "MonthYield": 0.67,
    "YearYield": 0.67,
    "Last12MonthYield": 6.87,
    "ISIN": "IL0051152903"
  },
  {
    "Id": "TASE:5104476",
    "MayaId": "5104476",
    "Name": "HAREL 90/10 Kosher IL",
    "ShortName": "HAREL 90/10 - Kosher IL",
    "Symbol": "TASE:5104476",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "HAREL (1B) 90/10- Kosher IL",
    "EnglishLongName": "HAREL (1B) 90/10- Kosher IL",
    "HebrewName": "הראל 10/90 - כשרה",
    "HebrewLongName": "הראל (1B)י10/90 - כשרה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.23,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 58.0,
    "MonthYield": 1.1,
    "YearYield": 1.1,
    "Last12MonthYield": 8.22,
    "ISIN": "IL0051044761"
  },
  {
    "Id": "TASE:5115365",
    "MayaId": "5115365",
    "Name": "Harel 90/10 Platinum IL",
    "ShortName": "Harel 90/10 Platinum IL",
    "Symbol": "TASE:5115365",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (1B)(!) 90/10 Platinum IL",
    "EnglishLongName": "Harel (1B)(!) 90/10 Platinum IL",
    "HebrewName": "הראל 10/90 פלטינום",
    "HebrewLongName": "הראל (1B)(!)י 10/90 פלטינום",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.27,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 177.0,
    "MonthYield": 0.79,
    "YearYield": 0.79,
    "Last12MonthYield": 7.1,
    "ISIN": "IL0051153653"
  },
  {
    "Id": "TASE:5115548",
    "MayaId": "5115548",
    "Name": "Harel 90\\10 Plus IL",
    "ShortName": "Harel 90\\10 Plus IL",
    "Symbol": "TASE:5115548",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (1B) 90\\10 Plus IL",
    "EnglishLongName": "Harel (1B) 90\\10 Plus IL",
    "HebrewName": "הראל 10/90 פלוס",
    "HebrewLongName": "הראל (1B)י 10/90 פלוס",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.689,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.26,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 97.7,
    "MonthYield": 1.16,
    "YearYield": 1.16,
    "Last12MonthYield": 9.04,
    "ISIN": "IL0051155484"
  },
  {
    "Id": "TASE:5129143",
    "MayaId": "5129143",
    "Name": "Harel Amalfi IL",
    "ShortName": "Harel Amalfi IL",
    "Symbol": "TASE:5129143",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (2B) Amalfi IL",
    "EnglishLongName": "Harel (2B) Amalfi IL",
    "HebrewName": "הראל אמלפי",
    "HebrewLongName": "הראל (2B) אמלפי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.43,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.59,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 61.6,
    "MonthYield": 2.69,
    "YearYield": 2.69,
    "Last12MonthYield": 21.61,
    "ISIN": "IL0051291438"
  },
  {
    "Id": "TASE:5132634",
    "MayaId": "5132634",
    "Name": "Harel Bond Denomnd in$ IL",
    "ShortName": "Harel Bond Denomnd in$ IL",
    "Symbol": "TASE:5132634",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (0D) Israel Bond - Denominated in - $ IL",
    "EnglishLongName": "Harel (0D) Israel Bond - Denominated in - $ IL",
    "HebrewName": "הראל אג\"ח ישראל - נקובה $",
    "HebrewLongName": "הראל (0D) אג\"ח ישראל - נקובה $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.49,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.15,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 29.8,
    "MonthYield": -0.43,
    "YearYield": -0.43,
    "Last12MonthYield": -7.02,
    "ISIN": "IL0051326341"
  },
  {
    "Id": "TASE:5110929",
    "MayaId": "5110929",
    "Name": "Harel Bond Por Plus10% IL",
    "ShortName": "Harel Bond Por Plus10% IL",
    "Symbol": "TASE:5110929",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (1B)(!) Bonds Portfolio Plus 10% IL",
    "EnglishLongName": "Harel (1B)(!) Bonds Portfolio Plus 10% IL",
    "HebrewName": "הראל תיק אג\"ח פלוס 10%",
    "HebrewLongName": "הראל (1B)(!) תיק אג\"ח פלוס 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.26,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 19.9,
    "MonthYield": 1.13,
    "YearYield": 1.13,
    "Last12MonthYield": 9.5,
    "ISIN": "IL0051109291"
  },
  {
    "Id": "TASE:5115936",
    "MayaId": "5115936",
    "Name": "Harel Bond Total Retrn IL",
    "ShortName": "Harel Bond Total Retrn IL",
    "Symbol": "TASE:5115936",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (0B) Bond Total Return IL",
    "EnglishLongName": "Harel (0B) Bond Total Return IL",
    "HebrewName": "הראל אג\"ח Total Return",
    "HebrewLongName": "הראל (0B) אג\"ח Total Return",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.49,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.25,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 51.8,
    "MonthYield": 0.67,
    "YearYield": 0.67,
    "Last12MonthYield": 5.4,
    "ISIN": "IL0051159361"
  },
  {
    "Id": "TASE:5117460",
    "MayaId": "5117460",
    "Name": "Harel Bonds Portfo+15% IL",
    "ShortName": "Harel Bonds Portfo+15% IL",
    "Symbol": "TASE:5117460",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (2B) Bonds Portfolio + 15% IL",
    "EnglishLongName": "Harel (2B) Bonds Portfolio + 15% IL",
    "HebrewName": "הראל תיק אג\"ח + 15%",
    "HebrewLongName": "הראל (2B) תיק אג\"ח + 15%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.74,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.24,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 15% Equity",
    "AssetValue": 222.3,
    "MonthYield": 1.87,
    "YearYield": 1.87,
    "Last12MonthYield": 9.8,
    "ISIN": "IL0051174600"
  },
  {
    "Id": "TASE:5111216",
    "MayaId": "5111216",
    "Name": "Harel Bonds Portfo+20% IL",
    "ShortName": "Harel Bonds Portfo+20% IL",
    "Symbol": "TASE:5111216",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (2B) Bonds Portfolio + 20% IL",
    "EnglishLongName": "Harel (2B) Bonds Portfolio + 20% IL",
    "HebrewName": "הראל תיק אג\"ח + 20%",
    "HebrewLongName": "הראל (2B) תיק אג\"ח + 20%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.69,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.43,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 93.7,
    "MonthYield": 1.24,
    "YearYield": 1.24,
    "Last12MonthYield": 7.61,
    "ISIN": "IL0051112162"
  },
  {
    "Id": "TASE:5111836",
    "MayaId": "5111836",
    "Name": "Harel Bonds Track IL",
    "ShortName": "Harel Bonds Track IL",
    "Symbol": "TASE:5111836",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (0A) Bonds Track IL",
    "EnglishLongName": "Harel (0A) Bonds Track IL",
    "HebrewName": "הראל מסלול אג\"ח",
    "HebrewLongName": "הראל (0A) מסלול אג\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.934,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.27,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 167.8,
    "MonthYield": 0.53,
    "YearYield": 0.53,
    "Last12MonthYield": 6.04,
    "ISIN": "IL0051118367"
  },
  {
    "Id": "TASE:5113105",
    "MayaId": "5113105",
    "Name": "Harel Conserv Gov +10% IL",
    "ShortName": "Harel Conserv Gov +10% IL",
    "Symbol": "TASE:5113105",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (1A) Conservative Government + 10% IL",
    "EnglishLongName": "Harel (1A) Conservative Government + 10% IL",
    "HebrewName": "הראל מדינה שמרני + 10%",
    "HebrewLongName": "הראל (1A) מדינה שמרני + 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.64,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.22,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - up to 10% Equity",
    "AssetValue": 821.7,
    "MonthYield": 1.12,
    "YearYield": 1.12,
    "Last12MonthYield": 8.95,
    "ISIN": "IL0051131055"
  },
  {
    "Id": "TASE:5119441",
    "MayaId": "5119441",
    "Name": "Harel Corp Bo Ptf IL–Kosh",
    "ShortName": "Harel Corp Bo Ptf IL–Kosh",
    "Symbol": "TASE:5119441",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (0B) Corporate Bonds Portfolio IL - Kosher",
    "EnglishLongName": "Harel (0B) Corporate Bonds Portfolio IL - Kosher",
    "HebrewName": "הראל תיק אגח קונצרני-כשרה",
    "HebrewLongName": "הראל (0B) תיק אג\"ח קונצרני - כשרה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.1,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.23,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 391.8,
    "MonthYield": 0.45,
    "YearYield": 0.45,
    "Last12MonthYield": 5.09,
    "ISIN": "IL0051194418"
  },
  {
    "Id": "TASE:5115993",
    "MayaId": "5115993",
    "Name": "Harel Corp Bond + 10% IL",
    "ShortName": "Harel Corp Bond + 10% IL",
    "Symbol": "TASE:5115993",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (1A) Corporate Bonds + 10% IL",
    "EnglishLongName": "Harel (1A) Corporate Bonds + 10% IL",
    "HebrewName": "הראל אג\"ח קונצרני + 10%",
    "HebrewLongName": "הראל (1A) אג\"ח קונצרני + 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.49,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles with Equity",
    "AssetValue": 141.9,
    "MonthYield": 1.2,
    "YearYield": 1.2,
    "Last12MonthYield": 10.32,
    "ISIN": "IL0051159932"
  },
  {
    "Id": "TASE:5115928",
    "MayaId": "5115928",
    "Name": "Harel Corp Bond Team IL",
    "ShortName": "Harel Corp Bond Team IL",
    "Symbol": "TASE:5115928",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (0A)(!) Corporate Bond Team IL",
    "EnglishLongName": "Harel (0A)(!) Corporate Bond Team IL",
    "HebrewName": "הראל נבחרת קונצרני",
    "HebrewLongName": "הראל (0A)(!) נבחרת קונצרני",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.13,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 49.1,
    "MonthYield": 0.53,
    "YearYield": 0.53,
    "Last12MonthYield": 5.54,
    "ISIN": "IL0051159288"
  },
  {
    "Id": "TASE:5111059",
    "MayaId": "5111059",
    "Name": "Harel Corp Bonds no Eq IL",
    "ShortName": "Harel Corp Bonds no Eq IL",
    "Symbol": "TASE:5111059",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (0B) Corporate Bonds without Equity IL",
    "EnglishLongName": "Harel (0B) Corporate Bonds without Equity IL",
    "HebrewName": "הראל אג\"ח קונצרני ללא מני",
    "HebrewLongName": "הראל (0B) אג\"ח קונצרני ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.27,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 47.2,
    "MonthYield": 0.7,
    "YearYield": 0.7,
    "Last12MonthYield": 5.82,
    "ISIN": "IL0051110596"
  },
  {
    "Id": "TASE:5124706",
    "MayaId": "5124706",
    "Name": "Harel Corp Dolar no Eq IL",
    "ShortName": "Harel Corp Dolar no Eq IL",
    "Symbol": "TASE:5124706",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (0D)(!) Corporate Dollar Without Equity IL",
    "EnglishLongName": "Harel (0D)(!) Corporate Dollar Without Equity IL",
    "HebrewName": "הראל קונצרני דולרי ללא מנ",
    "HebrewLongName": "הראל (0D)(!) קונצרני דולרי ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.72,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.09,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 18.3,
    "MonthYield": -0.7,
    "YearYield": -0.7,
    "Last12MonthYield": -8.75,
    "ISIN": "IL0051247067"
  },
  {
    "Id": "TASE:5231030",
    "MayaId": "5231030",
    "Name": "Harel Corp Shekel Plus IL",
    "ShortName": "Harel Corp Shekel Plus IL",
    "Symbol": "TASE:5231030",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (2B) Corporate Shekel Plus IL",
    "EnglishLongName": "Harel (2B) Corporate Shekel Plus IL",
    "HebrewName": "הראל שקלית קונצרני פלוס",
    "HebrewLongName": "הראל (2B) שקלית קונצרני פלוס",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.55,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.62,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Shekel Corporate and Convertibles with Equity",
    "AssetValue": 36.1,
    "MonthYield": 2.44,
    "YearYield": 2.44,
    "Last12MonthYield": 17.35,
    "ISIN": "IL0052310302"
  },
  {
    "Id": "TASE:5113188",
    "MayaId": "5113188",
    "Name": "Harel Corpora AA AndUp IL",
    "ShortName": "Harel Corpora AA AndUp IL",
    "Symbol": "TASE:5113188",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (0A) Corporate AA And Up IL",
    "EnglishLongName": "Harel (0A) Corporate AA And Up IL",
    "HebrewName": "הראל קונצרני AA ומעלה",
    "HebrewLongName": "הראל (0A) קונצרני AA ומעלה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.2,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 34.0,
    "MonthYield": 0.4,
    "YearYield": 0.4,
    "Last12MonthYield": 6.4,
    "ISIN": "IL0051131881"
  },
  {
    "Id": "TASE:5107156",
    "MayaId": "5107156",
    "Name": "Harel Corporate AandUp IL",
    "ShortName": "Harel Corporate AandUp IL",
    "Symbol": "TASE:5107156",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (0C) Corporate A and Up IL",
    "EnglishLongName": "Harel (0C) Corporate A and Up IL",
    "HebrewName": "הראל קונצרני A ומעלה",
    "HebrewLongName": "הראל (0C) קונצרני A ומעלה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.23,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 84.2,
    "MonthYield": 0.56,
    "YearYield": 0.56,
    "Last12MonthYield": 6.45,
    "ISIN": "IL0051071566"
  },
  {
    "Id": "TASE:5101670",
    "MayaId": "5101670",
    "Name": "Harel Corporate Bond IL",
    "ShortName": "Harel Corporate Bond IL",
    "Symbol": "TASE:5101670",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (1B)(!) Corporate Bond IL",
    "EnglishLongName": "Harel (1B)(!) Corporate Bond IL",
    "HebrewName": "הראל אג\"ח תאגידים",
    "HebrewLongName": "הראל (1B)(!) אג\"ח תאגידים",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.26,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles with Equity",
    "AssetValue": 37.7,
    "MonthYield": 0.56,
    "YearYield": 0.56,
    "Last12MonthYield": 4.91,
    "ISIN": "IL0051016702"
  },
  {
    "Id": "TASE:5110150",
    "MayaId": "5110150",
    "Name": "Harel Corporate Dollar IL",
    "ShortName": "Harel Corporate Dollar IL",
    "Symbol": "TASE:5110150",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (1D) Corporate Dollar IL",
    "EnglishLongName": "Harel (1D) Corporate Dollar IL",
    "HebrewName": "הראל קונצרני דולרי",
    "HebrewLongName": "הראל (1D) קונצרני דולרי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.32,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles with Equity",
    "AssetValue": 17.8,
    "MonthYield": -0.57,
    "YearYield": -0.57,
    "Last12MonthYield": -8.44,
    "ISIN": "IL0051101504"
  },
  {
    "Id": "TASE:5101704",
    "MayaId": "5101704",
    "Name": "Harel Corporate Plus IL",
    "ShortName": "Harel Corporate Plus IL",
    "Symbol": "TASE:5101704",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (1B)(!) Corporate Plus IL",
    "EnglishLongName": "Harel (1B)(!) Corporate Plus IL",
    "HebrewName": "הראל קונצרני פלוס",
    "HebrewLongName": "הראל (1B)(!) קונצרני פלוס",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles with Equity",
    "AssetValue": 6.2,
    "MonthYield": 1.25,
    "YearYield": 1.25,
    "Last12MonthYield": 9.52,
    "ISIN": "IL0051017049"
  },
  {
    "Id": "TASE:5102850",
    "MayaId": "5102850",
    "Name": "Harel Divid Solid BondsIL",
    "ShortName": "Harel Divid Solid BondsIL",
    "Symbol": "TASE:5102850",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (0B) Dividend Solid Bonds IL",
    "EnglishLongName": "Harel (0B) Dividend Solid Bonds IL",
    "HebrewName": "הראל אג\"ח סולידית מחלקת",
    "HebrewLongName": "הראל (0B) אג\"ח סולידית מחלקת",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.17,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.16,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 22.3,
    "MonthYield": 0.4,
    "YearYield": 0.4,
    "Last12MonthYield": 4.87,
    "ISIN": "IL0051028509"
  },
  {
    "Id": "TASE:5110374",
    "MayaId": "5110374",
    "Name": "Harel Dividend Equitie IL",
    "ShortName": "Harel Dividend Equitie IL",
    "Symbol": "TASE:5110374",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (4B) Dividend Equities IL",
    "EnglishLongName": "Harel (4B) Dividend Equities IL",
    "HebrewName": "הראל מניות דיבידנד",
    "HebrewLongName": "הראל (4B) מניות דיבידנד",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.47,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.2,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 55.1,
    "MonthYield": 5.72,
    "YearYield": 5.72,
    "Last12MonthYield": 56.33,
    "ISIN": "IL0051103740"
  },
  {
    "Id": "TASE:5108006",
    "MayaId": "5108006",
    "Name": "Harel Dvlp Mrkt Up30Crncy",
    "ShortName": "Harel Dvlp Mrkt Up30Crncy",
    "Symbol": "TASE:5108006",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (4B) Developed Markets Up to 30% Currency",
    "EnglishLongName": "Harel (4B) Developed Markets Up to 30% Currency",
    "HebrewName": "הראל שווקים מפותח עד30מטח",
    "HebrewLongName": "הראל (4B) שווקים מפותחים עד 30% מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.39,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.85,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Geographical stocks",
    "AssetValue": 88.1,
    "MonthYield": -0.85,
    "YearYield": -0.85,
    "Last12MonthYield": -3.89,
    "ISIN": "IL0051080062"
  },
  {
    "Id": "TASE:5130505",
    "MayaId": "5130505",
    "Name": "Harel Eitan",
    "ShortName": "Harel Eitan",
    "Symbol": "TASE:5130505",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (4D) Eitan",
    "EnglishLongName": "Harel (4D) Eitan",
    "HebrewName": "הראל איתן",
    "HebrewLongName": "הראל (4D) איתן",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.13,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 375.4,
    "MonthYield": 7.41,
    "YearYield": 7.41,
    "Last12MonthYield": 82.37,
    "ISIN": "IL0051305055"
  },
  {
    "Id": "TASE:5131107",
    "MayaId": "5131107",
    "Name": "Harel Eitan Bonds IL",
    "ShortName": "Harel Eitan Bonds IL",
    "Symbol": "TASE:5131107",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (0C)(!) Eitan Bonds IL",
    "EnglishLongName": "Harel (0C)(!) Eitan Bonds IL",
    "HebrewName": "הראל איתן אג\"ח",
    "HebrewLongName": "הראל (0C)(!) איתן אג\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 170.5,
    "MonthYield": 0.52,
    "YearYield": 0.52,
    "Last12MonthYield": 5.88,
    "ISIN": "IL0051311079"
  },
  {
    "Id": "TASE:5135041",
    "MayaId": "5135041",
    "Name": "Harel Eitan Strategies",
    "ShortName": "Harel Eitan Strategies",
    "Symbol": "TASE:5135041",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (5D) Eitan Strategies",
    "EnglishLongName": "Harel (5D) Eitan Strategies",
    "HebrewName": "הראל איתן אסטרטגיות",
    "HebrewLongName": "הראל (5D) איתן אסטרטגיות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.03,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Leveraged and Strategic",
    "SecondaryClassification": "Strategic (not leveraged)",
    "AssetValue": 15.4,
    "MonthYield": -2.5,
    "YearYield": -2.5,
    "Last12MonthYield": -14.7,
    "ISIN": "IL0051350416"
  },
  {
    "Id": "TASE:5137310",
    "MayaId": "5137310",
    "Name": "Harel Euro Lnk Money Mrkt",
    "ShortName": "Harel Euro Lnk Money Mrkt",
    "Symbol": "TASE:5137310",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (0D) Euro Linked Money Market",
    "EnglishLongName": "Harel (0D) Euro Linked Money Market",
    "HebrewName": "הראל כספית יורו",
    "HebrewLongName": "הראל (0D) כספית יורו",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.14,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.22,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "FX Money Market with Corporate",
    "AssetValue": 71.2,
    "MonthYield": -2.61,
    "YearYield": -2.61,
    "Last12MonthYield": -1.53,
    "ISIN": "IL0051373103"
  },
  {
    "Id": "TASE:5125646",
    "MayaId": "5125646",
    "Name": "Harel Eyal IL",
    "ShortName": "Harel Eyal IL",
    "Symbol": "TASE:5125646",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (2B) Eyal IL",
    "EnglishLongName": "Harel (2B) Eyal IL",
    "HebrewName": "הראל אייל",
    "HebrewLongName": "הראל (2B) אייל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.58,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.53,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 173.8,
    "MonthYield": 2.01,
    "YearYield": 2.01,
    "Last12MonthYield": 17.68,
    "ISIN": "IL0051256464"
  },
  {
    "Id": "TASE:5130273",
    "MayaId": "5130273",
    "Name": "Harel Finance Equity IL",
    "ShortName": "Harel Finance Equity IL",
    "Symbol": "TASE:5130273",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (4A) Finance Equity IL",
    "EnglishLongName": "Harel (4A) Finance Equity IL",
    "HebrewName": "הראל מניות פיננסים",
    "HebrewLongName": "הראל (4A) מניות פיננסים",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.5,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.97,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sectors",
    "AssetValue": 133.9,
    "MonthYield": 7.23,
    "YearYield": 7.23,
    "Last12MonthYield": 74.12,
    "ISIN": "IL0051302730"
  },
  {
    "Id": "TASE:5128871",
    "MayaId": "5128871",
    "Name": "Harel Flw BenLeumi 3 IL",
    "ShortName": "Harel Flw BenLeumi 3 IL",
    "Symbol": "TASE:5128871",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (2B) Tracking Portfolio No. 3 - International Bank IL",
    "EnglishLongName": "Harel (2B) Tracking Portfolio No. 3 - International Bank IL",
    "HebrewName": "הראל עוקבת תיק3 הבינלאומי",
    "HebrewLongName": "הראל (2B) עוקבת תיק מס` 3 - הבנק הבינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.55,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.37,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 136.3,
    "MonthYield": 1.15,
    "YearYield": 1.15,
    "Last12MonthYield": 10.0,
    "ISIN": "IL0051288715"
  },
  {
    "Id": "TASE:5117841",
    "MayaId": "5117841",
    "Name": "Harel Follow BenLeumi 2IL",
    "ShortName": "Harel Follow BenLeumi 2IL",
    "Symbol": "TASE:5117841",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (2B) Tracking Portfolio No. 2‎ - International Bank IL",
    "EnglishLongName": "Harel (2B) Tracking Portfolio No. 2‎ - International Bank IL",
    "HebrewName": "הראל עוקבת תיק2 הבינלאומי",
    "HebrewLongName": "הראל (2B) עוקבת תיק מס` 2 - הבנק הבינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.76,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.21,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 15% Equity",
    "AssetValue": 205.7,
    "MonthYield": 0.82,
    "YearYield": 0.82,
    "Last12MonthYield": 7.11,
    "ISIN": "IL0051178411"
  },
  {
    "Id": "TASE:5110333",
    "MayaId": "5110333",
    "Name": "Harel Foreign Dollar Bond",
    "ShortName": "Harel Foreign Dollar Bond",
    "Symbol": "TASE:5110333",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (0D) Foreign Dollar Bonds",
    "EnglishLongName": "Harel (0D) Foreign Dollar Bonds",
    "HebrewName": "הראל אג\"ח חו\"ל דולר",
    "HebrewLongName": "הראל (0D) אג\"ח חו\"ל דולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.02,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "Dollar Bond",
    "AssetValue": 148.3,
    "MonthYield": -1.01,
    "YearYield": -1.01,
    "Last12MonthYield": -6.91,
    "ISIN": "IL0051103336"
  },
  {
    "Id": "TASE:5101712",
    "MayaId": "5101712",
    "Name": "Harel Foreign Euro Bond",
    "ShortName": "Harel Foreign Euro Bond",
    "Symbol": "TASE:5101712",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (0D) Foreign Euro Bonds",
    "EnglishLongName": "Harel (0D) Foreign Euro Bonds",
    "HebrewName": "הראל אג\"ח חו\"ל יורו",
    "HebrewLongName": "הראל (0D) אג\"ח חו\"ל יורו",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.17,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.13,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Bond",
    "AssetValue": 16.1,
    "MonthYield": -2.35,
    "YearYield": -2.35,
    "Last12MonthYield": 0.1,
    "ISIN": "IL0051017122"
  },
  {
    "Id": "TASE:5111190",
    "MayaId": "5111190",
    "Name": "Harel Foreign Growth Sect",
    "ShortName": "Harel Foreign Growth Sect",
    "Symbol": "TASE:5111190",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (4D) Foreign Growth Sectors",
    "EnglishLongName": "Harel (4D) Foreign Growth Sectors",
    "HebrewName": "הראל חו\"ל סקטורים בצמיחה",
    "HebrewLongName": "הראל (4D) חו\"ל סקטורים בצמיחה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.95,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 101.5,
    "MonthYield": -2.72,
    "YearYield": -2.72,
    "Last12MonthYield": 0.52,
    "ISIN": "IL0051111909"
  },
  {
    "Id": "TASE:5128590",
    "MayaId": "5128590",
    "Name": "Harel Gav Bo Por no Eq IL",
    "ShortName": "Harel Gav Bo Por no Eq IL",
    "Symbol": "TASE:5128590",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Gavish (0B) Bonds Portfolio without Equity IL",
    "EnglishLongName": "Harel Gavish (0B) Bonds Portfolio without Equity IL",
    "HebrewName": "הראל גביש תיק אגח ללא מני",
    "HebrewLongName": "הראל גביש (0B) תיק אג\"ח ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.73,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 1189.3,
    "MonthYield": 0.68,
    "YearYield": 0.68,
    "Last12MonthYield": 5.48,
    "ISIN": "IL0051285901"
  },
  {
    "Id": "TASE:5105390",
    "MayaId": "5105390",
    "Name": "Harel Global Bond Portfol",
    "ShortName": "Harel Global Bond Portfol",
    "Symbol": "TASE:5105390",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (0D)(!) Global Bond",
    "EnglishLongName": "Harel (0D)(!) Global Bond",
    "HebrewName": "הראל אג\"ח עולמי",
    "HebrewLongName": "הראל (0D)(!) אג\"ח עולמי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.78,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.97,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Bond",
    "AssetValue": 60.8,
    "MonthYield": -0.87,
    "YearYield": -0.87,
    "Last12MonthYield": -5.31,
    "ISIN": "IL0051053903"
  },
  {
    "Id": "TASE:5111117",
    "MayaId": "5111117",
    "Name": "Harel GlobBon&Equ 20%Curr",
    "ShortName": "Harel GlobBon&Equ 20%Curr",
    "Symbol": "TASE:5111117",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (2B) Global Bonds & Equities Up to 20% Currency",
    "EnglishLongName": "Harel (2B) Global Bonds & Equities Up to 20% Currency",
    "HebrewName": "הראל אג חול מניות 20% מטח",
    "HebrewLongName": "הראל (2B) אג\"ח חו\"ל ומניות עד 20% מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.74,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX-Protected Bonds",
    "AssetValue": 557.1,
    "MonthYield": 0.36,
    "YearYield": 0.36,
    "Last12MonthYield": 7.28,
    "ISIN": "IL0051111172"
  },
  {
    "Id": "TASE:5119458",
    "MayaId": "5119458",
    "Name": "Harel Gnrl Bnd Po IL–Kosh",
    "ShortName": "Harel Gnrl Bnd Po IL–Kosh",
    "Symbol": "TASE:5119458",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (0B)(!) General Bonds Portfolio IL - Kosher",
    "EnglishLongName": "Harel (0B)(!) General Bonds Portfolio IL - Kosher",
    "HebrewName": "הראל תיק אג\"ח כללי - כשרה",
    "HebrewLongName": "הראל (0B)(!) תיק אג\"ח כללי - כשרה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.14,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.25,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 483.4,
    "MonthYield": 0.43,
    "YearYield": 0.43,
    "Last12MonthYield": 5.22,
    "ISIN": "IL0051194582"
  },
  {
    "Id": "TASE:5112560",
    "MayaId": "5112560",
    "Name": "Harel Gov Bond Portfol IL",
    "ShortName": "Harel Gov Bond Portfol IL",
    "Symbol": "TASE:5112560",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (0B) Government Bond Portfolio IL",
    "EnglishLongName": "Harel (0B) Government Bond Portfolio IL",
    "HebrewName": "הראל תיק מדינה",
    "HebrewLongName": "הראל (0B) תיק מדינה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.49,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.2,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - No Equity",
    "AssetValue": 83.7,
    "MonthYield": 0.47,
    "YearYield": 0.47,
    "Last12MonthYield": 6.12,
    "ISIN": "IL0051125602"
  },
  {
    "Id": "TASE:5115068",
    "MayaId": "5115068",
    "Name": "Harel Gov Cpi li no Eq IL",
    "ShortName": "Harel Gov Cpi-li no Eq IL",
    "Symbol": "TASE:5115068",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (0A) Government Cpi-linked without Equity IL",
    "EnglishLongName": "Harel (0A) Government Cpi-linked without Equity IL",
    "HebrewName": "הראל צמודים ממשלת ללא מני",
    "HebrewLongName": "הראל (0A) צמודים ממשלתי ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.09,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked Government Bonds - No Equity",
    "AssetValue": 74.5,
    "MonthYield": 0.16,
    "YearYield": 0.16,
    "Last12MonthYield": 3.87,
    "ISIN": "IL0051150683"
  },
  {
    "Id": "TASE:5111331",
    "MayaId": "5111331",
    "Name": "Harel Gov Cpi linke+10 IL",
    "ShortName": "Harel Gov Cpi-linke+10 IL",
    "Symbol": "TASE:5111331",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (1A) Government Cpi-linked + 10% IL",
    "EnglishLongName": "Harel (1A) Government Cpi-linked + 10% IL",
    "HebrewName": "הראל מדינה צמוד + 10%",
    "HebrewLongName": "הראל (1A) מדינה צמוד + 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.15,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked Government Bonds - Up to 10% Equity",
    "AssetValue": 542.8,
    "MonthYield": 0.88,
    "YearYield": 0.88,
    "Last12MonthYield": 8.62,
    "ISIN": "IL0051113319"
  },
  {
    "Id": "TASE:5115985",
    "MayaId": "5115985",
    "Name": "Harel Gov CPI Linked IL",
    "ShortName": "Harel Gov CPI Linked IL",
    "Symbol": "TASE:5115985",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (00) Government CPI Linked IL",
    "EnglishLongName": "Harel (00) Government CPI Linked IL",
    "HebrewName": "הראל צמודים ממשלתיים",
    "HebrewLongName": "הראל (00) צמודים ממשלתיים",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.16,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked Government Bonds - No Equity",
    "AssetValue": 49.3,
    "MonthYield": 0.08,
    "YearYield": 0.08,
    "Last12MonthYield": 4.59,
    "ISIN": "IL0051159858"
  },
  {
    "Id": "TASE:5110192",
    "MayaId": "5110192",
    "Name": "Harel Gov Interm Cpi L IL",
    "ShortName": "Harel Gov Interm Cpi-L IL",
    "Symbol": "TASE:5110192",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (1B) Government Intermediate Cpi-linked IL",
    "EnglishLongName": "Harel (1B) Government Intermediate Cpi-linked IL",
    "HebrewName": "הראל מדד בינוני ממשלתי",
    "HebrewLongName": "הראל (1B) מדד בינוני ממשלתי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.27,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.25,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked Government Bonds - Up to 10% Equity",
    "AssetValue": 50.9,
    "MonthYield": 0.59,
    "YearYield": 0.59,
    "Last12MonthYield": 5.55,
    "ISIN": "IL0051101926"
  },
  {
    "Id": "TASE:5100565",
    "MayaId": "5100565",
    "Name": "Harel Gov Long Te Shkl IL",
    "ShortName": "Harel Gov Long-Te Shkl IL",
    "Symbol": "TASE:5100565",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (00) Government Long-Term Shekel IL",
    "EnglishLongName": "Harel (00) Government Long-Term Shekel IL",
    "HebrewName": "הראל מדינה שקלית ארוכה",
    "HebrewLongName": "הראל (00) מדינה שקלית ארוכה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.69,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Shekel Bonds - No Equity",
    "AssetValue": 105.8,
    "MonthYield": 1.19,
    "YearYield": 1.19,
    "Last12MonthYield": 9.21,
    "ISIN": "IL0051005655"
  },
  {
    "Id": "TASE:5102470",
    "MayaId": "5102470",
    "Name": "Harel Gov Shikli0 3+10 IL",
    "ShortName": "Harel Gov Shikli0-3+10 IL",
    "Symbol": "TASE:5102470",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (1A) Government Shikli 0-3 YEARS + 10% IL",
    "EnglishLongName": "Harel (1A) Government Shikli 0-3 YEARS + 10% IL",
    "HebrewName": "הראל מדינה שקלי 0-3 + 10%",
    "HebrewLongName": "הראל (1A) מדינה שקלי 0-3 שנים + 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.35,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.21,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Shekel Bonds - Up to 10% Equity",
    "AssetValue": 41.4,
    "MonthYield": 0.63,
    "YearYield": 0.63,
    "Last12MonthYield": 7.2,
    "ISIN": "IL0051024706"
  },
  {
    "Id": "TASE:5115076",
    "MayaId": "5115076",
    "Name": "Harel Gover Cpi linked IL",
    "ShortName": "Harel Gover Cpi-linked IL",
    "Symbol": "TASE:5115076",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (0B) Government Cpi-linked IL",
    "EnglishLongName": "Harel (0B) Government Cpi-linked IL",
    "HebrewName": "הראל מדינה צמודה",
    "HebrewLongName": "הראל (0B) מדינה צמודה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.1,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked Government Bonds - No Equity",
    "AssetValue": 549.6,
    "MonthYield": 0.08,
    "YearYield": 0.08,
    "Last12MonthYield": 3.77,
    "ISIN": "IL0051150766"
  },
  {
    "Id": "TASE:5111869",
    "MayaId": "5111869",
    "Name": "Harel Governmen Shekel IL",
    "ShortName": "Harel Governmen Shekel IL",
    "Symbol": "TASE:5111869",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (0B) Government Shekel IL",
    "EnglishLongName": "Harel (0B) Government Shekel IL",
    "HebrewName": "הראל מדינה שקלית",
    "HebrewLongName": "הראל (0B) מדינה שקלית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.37,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.44,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Shekel Bonds - No Equity",
    "AssetValue": 119.8,
    "MonthYield": 0.72,
    "YearYield": 0.72,
    "Last12MonthYield": 7.85,
    "ISIN": "IL0051118698"
  },
  {
    "Id": "TASE:5127782",
    "MayaId": "5127782",
    "Name": "Harel Government + 10% IL",
    "ShortName": "Harel Government + 10% IL",
    "Symbol": "TASE:5127782",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (1B) Government + 10% IL",
    "EnglishLongName": "Harel (1B) Government + 10% IL",
    "HebrewName": "הראל מדינה + 10%",
    "HebrewLongName": "הראל (1B) מדינה + 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.43,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.4,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - up to 10% Equity",
    "AssetValue": 14.1,
    "MonthYield": 0.87,
    "YearYield": 0.87,
    "Last12MonthYield": 10.11,
    "ISIN": "IL0051277825"
  },
  {
    "Id": "TASE:5122932",
    "MayaId": "5122932",
    "Name": "Harel Government Bonds IL",
    "ShortName": "Harel Government Bonds IL",
    "Symbol": "TASE:5122932",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (0A) Government Bonds IL",
    "EnglishLongName": "Harel (0A) Government Bonds IL",
    "HebrewName": "הראל אג\"ח ממשלתיות",
    "HebrewLongName": "הראל (0A) אג\"ח ממשלתיות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.43,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.26,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - No Equity",
    "AssetValue": 26.6,
    "MonthYield": 0.36,
    "YearYield": 0.36,
    "Last12MonthYield": 5.64,
    "ISIN": "IL0051229321"
  },
  {
    "Id": "TASE:5111885",
    "MayaId": "5111885",
    "Name": "Harel Government IL",
    "ShortName": "Harel Government IL",
    "Symbol": "TASE:5111885",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (0A) Government IL",
    "EnglishLongName": "Harel (0A) Government IL",
    "HebrewName": "הראל מדינה",
    "HebrewLongName": "הראל (0A) מדינה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.72,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.16,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - No Equity",
    "AssetValue": 152.6,
    "MonthYield": 0.46,
    "YearYield": 0.46,
    "Last12MonthYield": 5.18,
    "ISIN": "IL0051118854"
  },
  {
    "Id": "TASE:5115977",
    "MayaId": "5115977",
    "Name": "Harel Government Plus IL",
    "ShortName": "Harel Government Plus IL",
    "Symbol": "TASE:5115977",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (2B) Government Plus IL",
    "EnglishLongName": "Harel (2B) Government Plus IL",
    "HebrewName": "הראל מדינה פלוס",
    "HebrewLongName": "הראל (2B) מדינה פלוס",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.49,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.41,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bonds - General - Up to 20% Equity",
    "AssetValue": 36.2,
    "MonthYield": 2.03,
    "YearYield": 2.03,
    "Last12MonthYield": 13.27,
    "ISIN": "IL0051159775"
  },
  {
    "Id": "TASE:5111455",
    "MayaId": "5111455",
    "Name": "Harel Growth Equity IL",
    "ShortName": "Harel Growth Equity IL",
    "Symbol": "TASE:5111455",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (4A) Growth Equity IL",
    "EnglishLongName": "Harel (4A) Growth Equity IL",
    "HebrewName": "הראל מניות צמיחה",
    "HebrewLongName": "הראל (‏‎4A‎‏) מניות צמיחה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.25,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.03,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 40.0,
    "MonthYield": 10.0,
    "YearYield": 10.0,
    "Last12MonthYield": 73.03,
    "ISIN": "IL0051114556"
  },
  {
    "Id": "TASE:5107453",
    "MayaId": "5107453",
    "Name": "Harel Hi Risk Corp Opp IL",
    "ShortName": "Harel Hi Risk Corp Opp IL",
    "Symbol": "TASE:5107453",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (0A)(!) High Risk Corporate Opportunities IL",
    "EnglishLongName": "Harel (0A)(!) High Risk Corporate Opportunities IL",
    "HebrewName": "הראל הזדמנ קונצ בסיכוןגבו",
    "HebrewLongName": "הראל (0A)(!) הזדמנויות קונצרני בסיכון גבוה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.56,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.13,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Hi-risk Corporate & Convertibles",
    "AssetValue": 22.4,
    "MonthYield": 0.69,
    "YearYield": 0.69,
    "Last12MonthYield": 5.23,
    "ISIN": "IL0051074537"
  },
  {
    "Id": "TASE:5125281",
    "MayaId": "5125281",
    "Name": "Harel Hoshen IL",
    "ShortName": "Harel Hoshen IL",
    "Symbol": "TASE:5125281",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (3C) Hoshen IL",
    "EnglishLongName": "Harel (3C) Hoshen IL",
    "HebrewName": "הראל חושן",
    "HebrewLongName": "הראל (3C) חושן",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.35,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.63,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - Max. Exposure over 30% Equity",
    "AssetValue": 52.1,
    "MonthYield": 2.53,
    "YearYield": 2.53,
    "Last12MonthYield": 19.52,
    "ISIN": "IL0051252810"
  },
  {
    "Id": "TASE:5122551",
    "MayaId": "5122551",
    "Name": "Harel Htf Albnd FloSKL IL",
    "ShortName": "Harel Htf Albnd-FloSKL IL",
    "Symbol": "TASE:5122551",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (00) All-Bond-Floating Shekel IL",
    "EnglishLongName": "Harel Htf (00) All-Bond-Floating Shekel IL",
    "HebrewName": "הראל מחקה Albnd רב מש שקל",
    "HebrewLongName": "הראל מחקה (00) All-Bond-ריבית משתנה שקלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.05,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 19.0,
    "MonthYield": 0.17,
    "YearYield": 0.17,
    "Last12MonthYield": 5.08,
    "ISIN": "IL0051225519"
  },
  {
    "Id": "TASE:5133756",
    "MayaId": "5133756",
    "Name": "Harel Htf All Bon Comp IL",
    "ShortName": "Harel Htf All Bon Comp IL",
    "Symbol": "TASE:5133756",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (0A) All Bond Composite IL",
    "EnglishLongName": "Harel Htf (0A) All Bond Composite IL",
    "HebrewName": "הראל All Bond מחקה כללי",
    "HebrewLongName": "הראל מחקה (0A)י All Bond כללי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.26,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "",
    "AssetValue": 24.6,
    "MonthYield": 0.45,
    "YearYield": 0.45,
    "Last12MonthYield": 6.57,
    "ISIN": "IL0051337561"
  },
  {
    "Id": "TASE:5127501",
    "MayaId": "5127501",
    "Name": "Harel Htf DAX MM",
    "ShortName": "Harel Htf DAX MM",
    "Symbol": "TASE:5127501",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4A) Dax Currency-Hedged",
    "EnglishLongName": "Harel Htf (4A) Dax Currency-Hedged",
    "HebrewName": "הראל מחקה DAX ממ",
    "HebrewLongName": "הראל מחקה (4A)י Dax - מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.38,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 181.6,
    "MonthYield": 3.46,
    "YearYield": 3.46,
    "Last12MonthYield": 27.34,
    "ISIN": "IL0051275019"
  },
  {
    "Id": "TASE:5129721",
    "MayaId": "5129721",
    "Name": "Harel Htf DJ US DIV",
    "ShortName": "Harel Htf DJ US DIV",
    "Symbol": "TASE:5129721",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4D) DJ US Dividend",
    "EnglishLongName": "Harel Htf (4D) DJ US Dividend",
    "HebrewName": "הראל מחקה DJ US DIV",
    "HebrewLongName": "הראל מחקה (4D) ‏DJ US Dividend",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.38,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 21.8,
    "MonthYield": 3.37,
    "YearYield": 3.37,
    "Last12MonthYield": -0.43,
    "ISIN": "IL0051297211"
  },
  {
    "Id": "TASE:5130026",
    "MayaId": "5130026",
    "Name": "Harel Htf DJ US Medic Eq",
    "ShortName": "Harel Htf DJ US Medic Eq",
    "Symbol": "TASE:5130026",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4D) Dow Jones U.S. Select Medical Equipment",
    "EnglishLongName": "Harel Htf (4D) Dow Jones U.S. Select Medical Equipment",
    "HebrewName": "הראל מחקהDJ US Medic Eq",
    "HebrewLongName": "הראל מחקה (4D)י Dow Jones U.S. Select Medical Equipment",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.12,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 105.0,
    "MonthYield": -1.02,
    "YearYield": -1.02,
    "Last12MonthYield": -8.18,
    "ISIN": "IL0051300262"
  },
  {
    "Id": "TASE:5137088",
    "MayaId": "5137088",
    "Name": "Harel Htf Hang Seng",
    "ShortName": "Harel Htf Hang Seng",
    "Symbol": "TASE:5137088",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4D) Hang Seng",
    "EnglishLongName": "Harel Htf (4D) Hang Seng",
    "HebrewName": "הראל מחקה Hang Seng",
    "HebrewLongName": "הראל מחקה (4D)י Hang Seng",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 7.0,
    "MonthYield": 3.01,
    "YearYield": 3.01,
    "Last12MonthYield": 16.6,
    "ISIN": "IL0051370885"
  },
  {
    "Id": "TASE:5139993",
    "MayaId": "5139993",
    "Name": "Harel Htf Hotels, R&Cr MM",
    "ShortName": "Harel Htf Hotels, R&Cr MM",
    "Symbol": "TASE:5139993",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4A) S&P Hotels, Resorts & Cruise lines 15% FMC Capped Currency - Hedg",
    "EnglishLongName": "Harel Htf (4A) S&P Hotels, Resorts & Cruise lines 15% FMC Capped Currency - Hedg",
    "HebrewName": "הראל מחקה Hotels, R&Cr ממ",
    "HebrewLongName": "הראל מחקה (4A)י S&P Hotels, Resorts & Cruise lines 15% FMC Capped מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.76,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 0.8,
    "MonthYield": 1.21,
    "YearYield": 1.21,
    "Last12MonthYield": null,
    "ISIN": "IL0051399934"
  },
  {
    "Id": "TASE:5137021",
    "MayaId": "5137021",
    "Name": "Harel Htf iBox $ 3 7",
    "ShortName": "Harel Htf iBox $ 3-7",
    "Symbol": "TASE:5137021",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (0D) iBoxx $ Corps Liquid 3-7 Years",
    "EnglishLongName": "Harel Htf (0D) iBoxx $ Corps Liquid 3-7 Years",
    "HebrewName": "הראל מחקה iBox $ 3-7",
    "HebrewLongName": "הראל מחקה (0D)י iBoxx $ Corps Liquid 3-7 Years",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.2,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Corporate and Convertibles - Medium",
    "AssetValue": 130.5,
    "MonthYield": -1.34,
    "YearYield": -1.34,
    "Last12MonthYield": -6.74,
    "ISIN": "IL0051370216"
  },
  {
    "Id": "TASE:5129770",
    "MayaId": "5129770",
    "Name": "Harel Htf iBox $ 3 7 MM",
    "ShortName": "Harel Htf iBox $ 3-7 MM",
    "Symbol": "TASE:5129770",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (0A) iBoxx $ Corps Liquid 3-7 Years Currency-Hedged",
    "EnglishLongName": "Harel Htf (0A) iBoxx $ Corps Liquid 3-7 Years Currency-Hedged",
    "HebrewName": "הראל מחקה iBox $ 3-7 ממ",
    "HebrewLongName": "הראל מחקה (0A)יiBoxx $ Corps Liquid 3-7 Years מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.22,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Hedged Corporate and Convertibles - Medium",
    "AssetValue": 464.8,
    "MonthYield": 0.04,
    "YearYield": 0.04,
    "Last12MonthYield": 7.57,
    "ISIN": "IL0051297708"
  },
  {
    "Id": "TASE:5138722",
    "MayaId": "5138722",
    "Name": "Harel Htf iBox US5 9 T50",
    "ShortName": "Harel Htf iBox US5-9 T50",
    "Symbol": "TASE:5138722",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (0D) iBoxx USD Liquid 5-9 Top 50",
    "EnglishLongName": "Harel Htf (0D) iBoxx USD Liquid 5-9 Top 50",
    "HebrewName": "הראל מחקה iBox US5-9 T50",
    "HebrewLongName": "הראל מחקה (0D)י iBoxx USD Liquid 5-9 Top 50",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.24,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Corporate and Convertibles - Long",
    "AssetValue": 99.5,
    "MonthYield": -1.23,
    "YearYield": -1.23,
    "Last12MonthYield": -6.52,
    "ISIN": "IL0051387228"
  },
  {
    "Id": "TASE:5132030",
    "MayaId": "5132030",
    "Name": "Harel Htf In ASh Isrsu IL",
    "ShortName": "Harel Htf In ASh Isrsu IL",
    "Symbol": "TASE:5132030",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (00) Index A Non-Linked Israel Issuers IL",
    "EnglishLongName": "Harel Htf (00) Index A Non-Linked Israel Issuers IL",
    "HebrewName": "הראל מחקהאנד Aשק מנפ ישר",
    "HebrewLongName": "הראל מחקה (00) אינדקס A שקלי מנפיקים ישראלים",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.3,
    "TrusteeFee": 0.02,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.26,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 75.9,
    "MonthYield": 0.94,
    "YearYield": 0.94,
    "Last12MonthYield": 7.86,
    "ISIN": "IL0051320302"
  },
  {
    "Id": "TASE:5140629",
    "MayaId": "5140629",
    "Name": "Harel Htf In In Co US ISR",
    "ShortName": "Harel Htf In In Co US ISR",
    "Symbol": "TASE:5140629",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4D) Index Infrastructures and Construction U.S. and Israel",
    "EnglishLongName": "Harel Htf (4D) Index Infrastructures and Construction U.S. and Israel",
    "HebrewName": "הראל מחקה אי תש ובי אר וי",
    "HebrewLongName": "הראל מחקה (4D) אינדקס תשתיות ובינוי ארה\"ב וישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 8.4,
    "MonthYield": 3.07,
    "YearYield": 3.07,
    "Last12MonthYield": null,
    "ISIN": "IL0051406291"
  },
  {
    "Id": "TASE:5134101",
    "MayaId": "5134101",
    "Name": "Harel Htf In Is Val Eq IL",
    "ShortName": "Harel Htf In Is Val Eq IL",
    "Symbol": "TASE:5134101",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4A) Index Israel Value Equity IL",
    "EnglishLongName": "Harel Htf (4A) Index Israel Value Equity IL",
    "HebrewName": "הראל מחקה אינ מני ערך ישר",
    "HebrewLongName": "הראל מחקה (4A) אינדקס מניות ערך ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.02,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.68,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 417.5,
    "MonthYield": 5.3,
    "YearYield": 5.3,
    "Last12MonthYield": 55.86,
    "ISIN": "IL0051341019"
  },
  {
    "Id": "TASE:5137948",
    "MayaId": "5137948",
    "Name": "Harel Htf In Isr Energ IL",
    "ShortName": "Harel Htf In Isr Energ IL",
    "Symbol": "TASE:5137948",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4A) Index Israel Energy IL",
    "EnglishLongName": "Harel Htf (4A) Index Israel Energy IL",
    "HebrewName": "הראל מחקה אינ אנרגיה ישרא",
    "HebrewLongName": "הראל מחקה (4A) אינדקס אנרגיה ישראלית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 70.6,
    "MonthYield": 4.77,
    "YearYield": 4.77,
    "Last12MonthYield": 75.35,
    "ISIN": "IL0051379480"
  },
  {
    "Id": "TASE:5140561",
    "MayaId": "5140561",
    "Name": "Harel Htf In Se In USI MM",
    "ShortName": "Harel Htf In Se In USI MM",
    "Symbol": "TASE:5140561",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4A) Index Security Industries U.S. and Israel Currency - Hedged",
    "EnglishLongName": "Harel Htf (4A) Index Security Industries U.S. and Israel Currency - Hedged",
    "HebrewName": "הראל מחקה אי תע ביט אי ממ",
    "HebrewLongName": "הראל מחקה (4A) אינדקס תעשיות ביטחוניות ארה\"ב וישראל מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.02,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 61.6,
    "MonthYield": 16.63,
    "YearYield": 16.63,
    "Last12MonthYield": null,
    "ISIN": "IL0051405616"
  },
  {
    "Id": "TASE:5138409",
    "MayaId": "5138409",
    "Name": "Harel Htf In Secur Indust",
    "ShortName": "Harel Htf In Secur Indust",
    "Symbol": "TASE:5138409",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4D) Index Security Industries U.S. and Israel",
    "EnglishLongName": "Harel Htf (4D) Index Security Industries U.S. and Israel",
    "HebrewName": "הראל מחקה אינ תעש ביטחונ",
    "HebrewLongName": "הראל מחקה (4D) אינדקס תעשיות ביטחוניות ארה''ב וישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.66,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 525.6,
    "MonthYield": 15.23,
    "YearYield": 15.23,
    "Last12MonthYield": 62.33,
    "ISIN": "IL0051384092"
  },
  {
    "Id": "TASE:5132592",
    "MayaId": "5132592",
    "Name": "Harel Htf InA AAA TAS $IL",
    "ShortName": "Harel Htf InA-AAA TAS $IL",
    "Symbol": "TASE:5132592",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (0D) Index A-AAA Shekel TA-Denominated in $ IL",
    "EnglishLongName": "Harel Htf (0D) Index A-AAA Shekel TA-Denominated in $ IL",
    "HebrewName": "הראל מחקהאינ A-AAA תשק $",
    "HebrewLongName": "הראל מחקה (0D) אינדקס A-AAA ת\"א שקלי - נקובה $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.35,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.04,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 124.5,
    "MonthYield": 0.0,
    "YearYield": null,
    "Last12MonthYield": -5.81,
    "ISIN": "IL0051325921"
  },
  {
    "Id": "TASE:5133608",
    "MayaId": "5133608",
    "Name": "Harel Htf InAA AAAT0 2$IL",
    "ShortName": "Harel Htf InAA-AAAT0-2$IL",
    "Symbol": "TASE:5133608",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (0D) Index AA-AAA 0-2 TA - Denominated in $ IL",
    "EnglishLongName": "Harel Htf (0D) Index AA-AAA 0-2 TA - Denominated in $ IL",
    "HebrewName": "הראל מחקהאנד AA-AAAת0-2 $",
    "HebrewLongName": "הראל מחקה (0D) אינדקס AA-AAA ת\"א 0-2 - נקובה $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.11,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 39.2,
    "MonthYield": -0.82,
    "YearYield": -0.82,
    "Last12MonthYield": -8.51,
    "ISIN": "IL0051336084"
  },
  {
    "Id": "TASE:5131180",
    "MayaId": "5131180",
    "Name": "Harel Htf Ind boAA AAA IL",
    "ShortName": "Harel Htf Ind boAA-AAA IL",
    "Symbol": "TASE:5131180",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (00) Index Israeli Non-Financial Bonds AA-AAA CPI Linked IL",
    "EnglishLongName": "Harel Htf (00) Index Israeli Non-Financial Bonds AA-AAA CPI Linked IL",
    "HebrewName": "הראל מחקה אינ אג AA-AAA צ",
    "HebrewLongName": "הראל מחקה (00) אינדקס AA-AAA ריאליות צמוד",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.29,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 78.1,
    "MonthYield": 0.28,
    "YearYield": 0.28,
    "Last12MonthYield": 6.8,
    "ISIN": "IL0051311806"
  },
  {
    "Id": "TASE:5140926",
    "MayaId": "5140926",
    "Name": "Harel Htf Ind Eu Defe T10",
    "ShortName": "Harel Htf Ind Eu Defe T10",
    "Symbol": "TASE:5140926",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4D) Index Europe Defense Top10",
    "EnglishLongName": "Harel Htf (4D) Index Europe Defense Top10",
    "HebrewName": "הראל מחקה אנ תע ב איר T10",
    "HebrewLongName": "הראל מחקה (4D) אינדקס תעשיות ביטחוניות אירופה Top10",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 4.2,
    "MonthYield": 12.96,
    "YearYield": 12.96,
    "Last12MonthYield": null,
    "ISIN": "IL0051409261"
  },
  {
    "Id": "TASE:5133152",
    "MayaId": "5133152",
    "Name": "Harel Htf Ind EWIs Iss IL",
    "ShortName": "Harel Htf Ind EWIs Iss IL",
    "Symbol": "TASE:5133152",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (0A) Index Equal Weight Israel Issuers Bonds IL",
    "EnglishLongName": "Harel Htf (0A) Index Equal Weight Israel Issuers Bonds IL",
    "HebrewName": "הראל מחקהאנד מנפיש מש ש",
    "HebrewLongName": "הראל מחקה (0A) אינדקס אג\"ח מנפיקים ישראלים במשקל שווה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.24,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 16.2,
    "MonthYield": 0.61,
    "YearYield": 0.61,
    "Last12MonthYield": 7.01,
    "ISIN": "IL0051331523"
  },
  {
    "Id": "TASE:5132295",
    "MayaId": "5132295",
    "Name": "Harel Htf Ind Is RetnCoIL",
    "ShortName": "Harel Htf Ind Is RetnCoIL",
    "Symbol": "TASE:5132295",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4A) Index Israel Retail and Commerce IL",
    "EnglishLongName": "Harel Htf (4A) Index Israel Retail and Commerce IL",
    "HebrewName": "הראל מחקהאנד קמעו מסח יש",
    "HebrewLongName": "הראל מחקה (4A) אינדקס קמעונאות ומסחר ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.35,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.55,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 25.8,
    "MonthYield": 6.65,
    "YearYield": 6.65,
    "Last12MonthYield": 35.54,
    "ISIN": "IL0051322951"
  },
  {
    "Id": "TASE:5133616",
    "MayaId": "5133616",
    "Name": "Harel Htf Ind isrl BankIL",
    "ShortName": "Harel Htf Ind isrl BankIL",
    "Symbol": "TASE:5133616",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4A) Index Israel Banks IL",
    "EnglishLongName": "Harel Htf (4A) Index Israel Banks IL",
    "HebrewName": "הראל מחקה אנד בנקים ישראל",
    "HebrewLongName": "הראל מחקה (4A)י אינדקס בנקים ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.97,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 247.8,
    "MonthYield": 9.42,
    "YearYield": 9.42,
    "Last12MonthYield": 70.6,
    "ISIN": "IL0051336167"
  },
  {
    "Id": "TASE:5137435",
    "MayaId": "5137435",
    "Name": "Harel Htf Ind Top10Tec",
    "ShortName": "Harel Htf Ind Top10Tec",
    "Symbol": "TASE:5137435",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4D) Index Top10 Tech",
    "EnglishLongName": "Harel Htf (4D) Index Top10 Tech",
    "HebrewName": "הראל מחקה אנד Top10Tec",
    "HebrewLongName": "הראל מחקה (4D) אינדקס Top10 Tech",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.52,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 51.4,
    "MonthYield": -2.99,
    "YearYield": -2.99,
    "Last12MonthYield": 5.9,
    "ISIN": "IL0051374358"
  },
  {
    "Id": "TASE:5133145",
    "MayaId": "5133145",
    "Name": "Harel Htf IndA AAASpr FIL",
    "ShortName": "Harel Htf IndA-AAASpr FIL",
    "Symbol": "TASE:5133145",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (00) Index A-AAA Non-Financial Spread Factor From Gov Bonds IL",
    "EnglishLongName": "Harel Htf (00) Index A-AAA Non-Financial Spread Factor From Gov Bonds IL",
    "HebrewName": "הראל מחקהאנדA-AAAריא פקט",
    "HebrewLongName": "הראל מחקה (00) אינדקס A-AAA ריאליות פקטור מרווח מאג''ח ממשלתי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.3,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.27,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 47.2,
    "MonthYield": 0.6,
    "YearYield": 0.6,
    "Last12MonthYield": 7.0,
    "ISIN": "IL0051331457"
  },
  {
    "Id": "TASE:5132865",
    "MayaId": "5132865",
    "Name": "Harel Htf IndA AALin0 2IL",
    "ShortName": "Harel Htf IndA-AALin0-2IL",
    "Symbol": "TASE:5132865",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (00) Index A-AA CPI-Linked 0-2 IL",
    "EnglishLongName": "Harel Htf (00) Index A-AA CPI-Linked 0-2 IL",
    "HebrewName": "הראל מחקהאנד A-AA צמו0-2",
    "HebrewLongName": "הראל מחקה (00) אינדקס A-AA צמוד 0-2",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.17,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 129.9,
    "MonthYield": 0.07,
    "YearYield": 0.07,
    "Last12MonthYield": 4.88,
    "ISIN": "IL0051328651"
  },
  {
    "Id": "TASE:5130018",
    "MayaId": "5130018",
    "Name": "Harel Htf IndBnkCoCoBo IL",
    "ShortName": "Harel Htf IndBnkCoCoBo IL",
    "Symbol": "TASE:5130018",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (00) Index Banks CoCo Bonds IL",
    "EnglishLongName": "Harel Htf (00) Index Banks CoCo Bonds IL",
    "HebrewName": "הראל מחקה אנד אגח CoCo בנ",
    "HebrewLongName": "הראל מחקה (00) אינדקס אג\"ח CoCo בנקים",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.36,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 515.4,
    "MonthYield": 0.39,
    "YearYield": 0.39,
    "Last12MonthYield": 7.2,
    "ISIN": "IL0051300189"
  },
  {
    "Id": "TASE:5131164",
    "MayaId": "5131164",
    "Name": "Harel Htf Indbo AA AAASIL",
    "ShortName": "Harel Htf Indbo AA-AAASIL",
    "Symbol": "TASE:5131164",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (00) Index Israeli Non-Financial Bonds AA-AAA Non-Linked IL",
    "EnglishLongName": "Harel Htf (00) Index Israeli Non-Financial Bonds AA-AAA Non-Linked IL",
    "HebrewName": "הראל מחקה אנד אגAA-AAA ש",
    "HebrewLongName": "הראל מחקה (00) אינדקס AA-AAA ריאליות שקלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.29,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 29.5,
    "MonthYield": 0.8,
    "YearYield": 0.8,
    "Last12MonthYield": 7.58,
    "ISIN": "IL0051311640"
  },
  {
    "Id": "TASE:5134705",
    "MayaId": "5134705",
    "Name": "Harel Htf IndMat2026EW IL",
    "ShortName": "Harel Htf IndMat2026EW IL",
    "Symbol": "TASE:5134705",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (0A) Index to Maturity 2026 EW Issuers (Rolling Every 6 Years) IL",
    "EnglishLongName": "Harel Htf (0A) Index to Maturity 2026 EW Issuers (Rolling Every 6 Years) IL",
    "HebrewName": "הראל מחקה אינ פד 2026 משש",
    "HebrewLongName": "הראל מחקה (0A) אינדקס לפדיון 2026 מנפיקים במשקל שווה (מתגלגל כל 6 שנים)",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.19,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 43.2,
    "MonthYield": 0.33,
    "YearYield": 0.33,
    "Last12MonthYield": 3.52,
    "ISIN": "IL0051347057"
  },
  {
    "Id": "TASE:5129663",
    "MayaId": "5129663",
    "Name": "Harel Htf IndxCashBonA IL",
    "ShortName": "Harel Htf IndxCashBonA IL",
    "Symbol": "TASE:5129663",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (00) Index Cash Flow Bonds A and Up IL",
    "EnglishLongName": "Harel Htf (00) Index Cash Flow Bonds A and Up IL",
    "HebrewName": "הראל מחקה אנד אגח תזרA מע",
    "HebrewLongName": "הראל מחקה (00) אינדקס אג\"ח תזרימיות A ומעלה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.26,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 58.6,
    "MonthYield": 0.58,
    "YearYield": 0.58,
    "Last12MonthYield": 7.08,
    "ISIN": "IL0051296635"
  },
  {
    "Id": "TASE:5123112",
    "MayaId": "5123112",
    "Name": "Harel Htf IndxCorp ACP IL",
    "ShortName": "Harel Htf IndxCorp-ACP IL",
    "Symbol": "TASE:5123112",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (00) Index Corporate A CPI-Linked IL",
    "EnglishLongName": "Harel Htf (00) Index Corporate A CPI-Linked IL",
    "HebrewName": "הראל מחקה אינד חב צA",
    "HebrewLongName": "הראל מחקה (00) אינדקס קונצרני צמוד A",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.35,
    "TrusteeFee": 0.02,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.26,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 112.6,
    "MonthYield": 0.16,
    "YearYield": 0.16,
    "Last12MonthYield": 6.28,
    "ISIN": "IL0051231129"
  },
  {
    "Id": "TASE:5123559",
    "MayaId": "5123559",
    "Name": "Harel Htf IndxCorp ASh IL",
    "ShortName": "Harel Htf IndxCorp ASh IL",
    "Symbol": "TASE:5123559",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (00) Index Corporate A Shekel IL",
    "EnglishLongName": "Harel Htf (00) Index Corporate A Shekel IL",
    "HebrewName": "הראל מחקה אינד חב שA",
    "HebrewLongName": "הראל מחקה (00) אינדקס קונצרני שקלי A",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.02,
    "VariableFee": 0.02,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 49.7,
    "MonthYield": 0.96,
    "YearYield": 0.96,
    "Last12MonthYield": 7.24,
    "ISIN": "IL0051235591"
  },
  {
    "Id": "TASE:5123104",
    "MayaId": "5123104",
    "Name": "Harel Htf IndxCorpBL2 4IL",
    "ShortName": "Harel Htf IndxCorpBL2-4IL",
    "Symbol": "TASE:5123104",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (00) Index Corporate Balanced Duration 2-4 IL",
    "EnglishLongName": "Harel Htf (00) Index Corporate Balanced Duration 2-4 IL",
    "HebrewName": "הראל מחקה אינד חב2-4",
    "HebrewLongName": "הראל מחקה (00) אינדקס קונצרני מאוזן מח\"מ 2-4",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.21,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 39.7,
    "MonthYield": 0.53,
    "YearYield": 0.53,
    "Last12MonthYield": 6.55,
    "ISIN": "IL0051231046"
  },
  {
    "Id": "TASE:5124912",
    "MayaId": "5124912",
    "Name": "Harel Htf IndxMatu 2028IL",
    "ShortName": "Harel Htf IndxMatu 2028IL",
    "Symbol": "TASE:5124912",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (00) Index to Maturity 2028 (Rolling Every 6 Years) IL",
    "EnglishLongName": "Harel Htf (00) Index to Maturity 2028 (Rolling Every 6 Years) IL",
    "HebrewName": "הראל מחקה אינד פד' 2028",
    "HebrewLongName": "הראל מחקה (00) אינדקס לפדיון 2028 (מתגלגל כל 6 שנים)",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.24,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.2,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 167.5,
    "MonthYield": 0.42,
    "YearYield": 0.42,
    "Last12MonthYield": 5.82,
    "ISIN": "IL0051249121"
  },
  {
    "Id": "TASE:5140991",
    "MayaId": "5140991",
    "Name": "Harel Htf IndxMatu 2029IL",
    "ShortName": "Harel Htf IndxMatu 2029IL",
    "Symbol": "TASE:5140991",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (00) Index to Maturity 2029 (Rolling Every 4 Years) IL",
    "EnglishLongName": "Harel Htf (00) Index to Maturity 2029 (Rolling Every 4 Years) IL",
    "HebrewName": "הראל מחקה אינד פד' 2029",
    "HebrewLongName": "הראל מחקה (00) אינדקס לפדיון 2029 (מתגלגל כל 4 שנים)",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 24.5,
    "MonthYield": 0.47,
    "YearYield": 0.47,
    "Last12MonthYield": null,
    "ISIN": "IL0051409915"
  },
  {
    "Id": "TASE:5141460",
    "MayaId": "5141460",
    "Name": "Harel Htf IndxMatu 2031IL",
    "ShortName": "Harel Htf IndxMatu 2031IL",
    "Symbol": "TASE:5141460",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (00) Index to Maturity 2031 (Rolling Every 4 Years) IL",
    "EnglishLongName": "Harel Htf (00) Index to Maturity 2031 (Rolling Every 4 Years) IL",
    "HebrewName": "הראל מחקה אינד פד' 2031",
    "HebrewLongName": "הראל מחקה (00) אינדקס לפדיון 2031 (מתגלגל כל 4 שנים)",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 6.2,
    "MonthYield": 0.5,
    "YearYield": 0.5,
    "Last12MonthYield": null,
    "ISIN": "IL0051414600"
  },
  {
    "Id": "TASE:5129424",
    "MayaId": "5129424",
    "Name": "Harel Htf IndxMatur2030IL",
    "ShortName": "Harel Htf IndxMatur2030IL",
    "Symbol": "TASE:5129424",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (00) Index to Maturity 2030 (Rolling Every 6 Years) IL",
    "EnglishLongName": "Harel Htf (00) Index to Maturity 2030 (Rolling Every 6 Years) IL",
    "HebrewName": "הראל מחקה אינד פד' 2030",
    "HebrewLongName": "הראל מחקה (00) אינדקס לפדיון 2030 (מתגלגל כל 6 שנים)",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.27,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 90.0,
    "MonthYield": 0.62,
    "YearYield": 0.62,
    "Last12MonthYield": 6.84,
    "ISIN": "IL0051294242"
  },
  {
    "Id": "TASE:5128236",
    "MayaId": "5128236",
    "Name": "Harel Htf MS FoEquity",
    "ShortName": "Harel Htf MS FoEquity",
    "Symbol": "TASE:5128236",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4D) Composite Foreign Equity Monthly",
    "EnglishLongName": "Harel Htf (4D) Composite Foreign Equity Monthly",
    "HebrewName": "הראל מחקה מש מניות חול",
    "HebrewLongName": "הראל מחקה (4D) משולבת מניות חו\"ל חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.7,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks Abroad, Composite",
    "AssetValue": 87.5,
    "MonthYield": 1.88,
    "YearYield": 1.88,
    "Last12MonthYield": 3.61,
    "ISIN": "IL0051282361"
  },
  {
    "Id": "TASE:5128202",
    "MayaId": "5128202",
    "Name": "Harel Htf MS FrgEquity MM",
    "ShortName": "Harel Htf MS FrgEquity MM",
    "Symbol": "TASE:5128202",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4A) Composite Foreign Equity Monthly Currency-Hedged",
    "EnglishLongName": "Harel Htf (4A) Composite Foreign Equity Monthly Currency-Hedged",
    "HebrewName": "הראל מחקה מש מניות חול ממ",
    "HebrewLongName": "הראל מחקה (4A) משולבת מניות חו\"ל חודשי מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.77,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks Abroad, Composite",
    "AssetValue": 274.0,
    "MonthYield": 3.06,
    "YearYield": 3.06,
    "Last12MonthYield": 16.99,
    "ISIN": "IL0051282023"
  },
  {
    "Id": "TASE:5113121",
    "MayaId": "5113121",
    "Name": "Harel Htf MS Governmen IL",
    "ShortName": "Harel Htf MS Governmen IL",
    "Symbol": "TASE:5113121",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (00) Composite Government Bonds Monthly IL",
    "EnglishLongName": "Harel Htf (00) Composite Government Bonds Monthly IL",
    "HebrewName": "הראל מחקה מש מדינה",
    "HebrewLongName": "הראל מחקה (00) משולבת מדינה חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.3,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.36,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Composite Government Bond - No Equity",
    "AssetValue": 23.2,
    "MonthYield": 0.39,
    "YearYield": 0.39,
    "Last12MonthYield": 6.5,
    "ISIN": "IL0051131212"
  },
  {
    "Id": "TASE:5121819",
    "MayaId": "5121819",
    "Name": "Harel Htf MS Sovereign IL",
    "ShortName": "Harel Htf MS Sovereign IL",
    "Symbol": "TASE:5121819",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (00) Composite Sovereign Bonds Monthly IL",
    "EnglishLongName": "Harel Htf (00) Composite Sovereign Bonds Monthly IL",
    "HebrewName": "הראל מחקה מש ממשלתיות",
    "HebrewLongName": "הראל מחקה (00) משולבת ממשלתיות חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.29,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Composite Government Bond - No Equity",
    "AssetValue": 23.0,
    "MonthYield": 0.44,
    "YearYield": 0.44,
    "Last12MonthYield": 6.22,
    "ISIN": "IL0051218191"
  },
  {
    "Id": "TASE:5117007",
    "MayaId": "5117007",
    "Name": "Harel Htf MS UNLin Isr IL",
    "ShortName": "Harel Htf MS UNLin Isr IL",
    "Symbol": "TASE:5117007",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (00) Composite Non - Linked Israel Bonds Monthly IL",
    "EnglishLongName": "Harel Htf (00) Composite Non - Linked Israel Bonds Monthly IL",
    "HebrewName": "הראל מחקה מש אגח ישר שקל",
    "HebrewLongName": "הראל מחקה (00) משולבת אג\"ח ישראל שקלי חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Composite Bonds",
    "SecondaryClassification": "No Equity",
    "AssetValue": 22.7,
    "MonthYield": 0.88,
    "YearYield": 0.88,
    "Last12MonthYield": 8.19,
    "ISIN": "IL0051170079"
  },
  {
    "Id": "TASE:5128251",
    "MayaId": "5128251",
    "Name": "Harel Htf MS US SectEq MM",
    "ShortName": "Harel Htf MS US SectEq MM",
    "Symbol": "TASE:5128251",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4A) Composite USA sectors Equity Monthly Currency-Hedged",
    "EnglishLongName": "Harel Htf (4A) Composite USA sectors Equity Monthly Currency-Hedged",
    "HebrewName": "הראל מחקה מש מנסקטרארהבממ",
    "HebrewLongName": "הראל מחקה (4A) משולבת מניות סקטורים ארה\"ב חודשי מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.24,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks Abroad, Composite",
    "AssetValue": 33.1,
    "MonthYield": 1.91,
    "YearYield": 1.91,
    "Last12MonthYield": 13.97,
    "ISIN": "IL0051282510"
  },
  {
    "Id": "TASE:5128244",
    "MayaId": "5128244",
    "Name": "Harel Htf MS USSectEquity",
    "ShortName": "Harel Htf MS USSectEquity",
    "Symbol": "TASE:5128244",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4D) Composite USA sectors Equity Monthly",
    "EnglishLongName": "Harel Htf (4D) Composite USA sectors Equity Monthly",
    "HebrewName": "הראל מחקה מש מנ סקטורארהב",
    "HebrewLongName": "הראל מחקה (4D) משולבת מניות סקטורים ארה\"ב חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.24,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks Abroad, Composite",
    "AssetValue": 61.9,
    "MonthYield": 0.52,
    "YearYield": 0.52,
    "Last12MonthYield": -0.29,
    "ISIN": "IL0051282445"
  },
  {
    "Id": "TASE:5121801",
    "MayaId": "5121801",
    "Name": "Harel Htf MS75Bo25EqMM IL",
    "ShortName": "Harel Htf MS75Bo25EqMM IL",
    "Symbol": "TASE:5121801",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (2A) Composite Is.Bnd(75%)Is-Foreign Eq(25%)Monthly Currency-Hedged IL",
    "EnglishLongName": "Harel Htf (2A) Composite Is.Bnd(75%)Is-Foreign Eq(25%)Monthly Currency-Hedged IL",
    "HebrewName": "הראל מחקה מש 75אג 25מ ממ",
    "HebrewLongName": "הראל מחקה (2A) משולבת אג''ח ישראל (75%) מניות ישראל-חול (25%) חודשי מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.44,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Composite Bonds",
    "SecondaryClassification": "up to 30% Equity",
    "AssetValue": 68.9,
    "MonthYield": 1.94,
    "YearYield": 1.94,
    "Last12MonthYield": 14.61,
    "ISIN": "IL0051218019"
  },
  {
    "Id": "TASE:5115738",
    "MayaId": "5115738",
    "Name": "Harel Htf MS80Bond20Eq IL",
    "ShortName": "Harel Htf MS80Bond20Eq IL",
    "Symbol": "TASE:5115738",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (2B) Composite Is.Bonds (80%) Israel-Foreign Equity (20%) Monthly IL",
    "EnglishLongName": "Harel Htf (2B) Composite Is.Bonds (80%) Israel-Foreign Equity (20%) Monthly IL",
    "HebrewName": "הראל מחקה מש 80אגח 20מנ",
    "HebrewLongName": "הראל מחקה (2B) משולבת אג\"ח ישראל (80%) מניות ישראל-חול (20%) חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.41,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Composite Bonds",
    "SecondaryClassification": "up to 20% Equity",
    "AssetValue": 87.0,
    "MonthYield": 1.35,
    "YearYield": 1.35,
    "Last12MonthYield": 11.24,
    "ISIN": "IL0051157381"
  },
  {
    "Id": "TASE:5112586",
    "MayaId": "5112586",
    "Name": "Harel Htf MS90Bond10Eq IL",
    "ShortName": "Harel Htf MS90Bond10Eq IL",
    "Symbol": "TASE:5112586",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (2A) Composite Is.Bonds (90%) Israel-Foreign Equity (10%) Monthly IL",
    "EnglishLongName": "Harel Htf (2A) Composite Is.Bonds (90%) Israel-Foreign Equity (10%) Monthly IL",
    "HebrewName": "הראל מחקה מש 90אגח 10מנ",
    "HebrewLongName": "הראל מחקה (2A) משולבת אג\"ח ישראל (90%) מניות ישראל-חול (10%) חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Composite Bonds",
    "SecondaryClassification": "up to 10% Equity",
    "AssetValue": 60.9,
    "MonthYield": 0.71,
    "YearYield": 0.71,
    "Last12MonthYield": 8.66,
    "ISIN": "IL0051125867"
  },
  {
    "Id": "TASE:5119763",
    "MayaId": "5119763",
    "Name": "Harel Htf MS90Gov10Eq IL",
    "ShortName": "Harel Htf MS90Gov10Eq IL",
    "Symbol": "TASE:5119763",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (2A) Composite Government Bnds (90%)Is.-Foreign Equity (10%)Monthly IL",
    "EnglishLongName": "Harel Htf (2A) Composite Government Bnds (90%)Is.-Foreign Equity (10%)Monthly IL",
    "HebrewName": "הראל מחקה מש 90מדינ 10מנ",
    "HebrewLongName": "הראל מחקה (2A) משולבת מדינה (90%) מניות ישראל-חול (10%) חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.3,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Composite Government Bond - up to 10% Equity",
    "AssetValue": 23.4,
    "MonthYield": 0.78,
    "YearYield": 0.78,
    "Last12MonthYield": 8.38,
    "ISIN": "IL0051197635"
  },
  {
    "Id": "TASE:5137039",
    "MayaId": "5137039",
    "Name": "Harel Htf MSCI India",
    "ShortName": "Harel Htf MSCI India",
    "Symbol": "TASE:5137039",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4D) MSCI INDIA",
    "EnglishLongName": "Harel Htf (4D) MSCI INDIA",
    "HebrewName": "הראל מחקה MSCI India",
    "HebrewLongName": "הראל מחקה (4D)י MSCI INDIA",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.85,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.95,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 51.3,
    "MonthYield": -3.73,
    "YearYield": -3.73,
    "Last12MonthYield": -15.23,
    "ISIN": "IL0051370398"
  },
  {
    "Id": "TASE:5116793",
    "MayaId": "5116793",
    "Name": "Harel Htf MSCPI LinIsr IL",
    "ShortName": "Harel Htf MSCPI LinIsr IL",
    "Symbol": "TASE:5116793",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (00) Composite CPI-Linked Israel Bonds Monthly IL",
    "EnglishLongName": "Harel Htf (00) Composite CPI-Linked Israel Bonds Monthly IL",
    "HebrewName": "הראל מחקה מש אג ישר צמוד",
    "HebrewLongName": "הראל מחקה (00) משולבת אג\"ח ישראל צמוד חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.35,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Composite Bonds",
    "SecondaryClassification": "No Equity",
    "AssetValue": 26.0,
    "MonthYield": 0.03,
    "YearYield": 0.03,
    "Last12MonthYield": 5.34,
    "ISIN": "IL0051167935"
  },
  {
    "Id": "TASE:5129283",
    "MayaId": "5129283",
    "Name": "Harel Htf NDX 100",
    "ShortName": "Harel Htf NDX 100",
    "Symbol": "TASE:5129283",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4D) NASDAQ 100",
    "EnglishLongName": "Harel Htf (4D) NASDAQ 100",
    "HebrewName": "הראל מחקהNDX 100",
    "HebrewLongName": "הראל מחקה (4D)יNASDAQ 100",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.025,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.85,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 1467.9,
    "MonthYield": -0.2,
    "YearYield": -0.2,
    "Last12MonthYield": 5.46,
    "ISIN": "IL0051292832"
  },
  {
    "Id": "TASE:5133574",
    "MayaId": "5133574",
    "Name": "Harel Htf NDX 100 MM",
    "ShortName": "Harel Htf NDX 100 MM",
    "Symbol": "TASE:5133574",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4A) NASDAQ 100 Currency-Hedged",
    "EnglishLongName": "Harel Htf (4A) NASDAQ 100 Currency-Hedged",
    "HebrewName": "הראל מחקהNDX 100 ממ",
    "HebrewLongName": "הראל מחקה (4A)י NASDAQ 100 מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.01,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.07,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 762.5,
    "MonthYield": 1.15,
    "YearYield": 1.15,
    "Last12MonthYield": 19.88,
    "ISIN": "IL0051335748"
  },
  {
    "Id": "TASE:5129739",
    "MayaId": "5129739",
    "Name": "Harel Htf Russ2000 MM",
    "ShortName": "Harel Htf Russ2000 MM",
    "Symbol": "TASE:5129739",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4A) Russell 2000 Currency-Hedged",
    "EnglishLongName": "Harel Htf (4A) Russell 2000 Currency-Hedged",
    "HebrewName": "הראל מחקה Russell 2000 ממ",
    "HebrewLongName": "הראל מחקה (4A)יRussell 2000 מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.02,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.42,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 114.1,
    "MonthYield": 7.72,
    "YearYield": 7.72,
    "Last12MonthYield": 18.31,
    "ISIN": "IL0051297393"
  },
  {
    "Id": "TASE:5139837",
    "MayaId": "5139837",
    "Name": "Harel Htf Russell 2000",
    "ShortName": "Harel Htf Russell 2000",
    "Symbol": "TASE:5139837",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4D) Russell 2000",
    "EnglishLongName": "Harel Htf (4D) Russell 2000",
    "HebrewName": "הראל מחקה Russell 2000",
    "HebrewLongName": "הראל מחקה (4D)י Russell 2000",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.29,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 8.2,
    "MonthYield": 6.33,
    "YearYield": 6.33,
    "Last12MonthYield": 3.67,
    "ISIN": "IL0051398373"
  },
  {
    "Id": "TASE:5118419",
    "MayaId": "5118419",
    "Name": "Harel Htf S&P 500 Dollar",
    "ShortName": "Harel Htf S&P 500 Dollar",
    "Symbol": "TASE:5118419",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4D) S&P 500 Denominated in Dollar",
    "EnglishLongName": "Harel Htf (4D) S&P 500 Denominated in Dollar",
    "HebrewName": "הראל מחקה S&P 500 - $",
    "HebrewLongName": "הראל מחקה (4D)י S&P 500 נקובה ב-$",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.025,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.39,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 138.1,
    "MonthYield": 0.39,
    "YearYield": 0.39,
    "Last12MonthYield": 2.93,
    "ISIN": "IL0051184195"
  },
  {
    "Id": "TASE:5138300",
    "MayaId": "5138300",
    "Name": "Harel Htf SP HealthCareMM",
    "ShortName": "Harel Htf SP HealthCareMM",
    "Symbol": "TASE:5138300",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4A) S&P Health Care Currency-Hedged",
    "EnglishLongName": "Harel Htf (4A) S&P Health Care Currency-Hedged",
    "HebrewName": "הראל מחקה SP HealhCare ממ",
    "HebrewLongName": "הראל מחקה (4A)י S&P Health Care מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.98,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 81.1,
    "MonthYield": 1.42,
    "YearYield": 1.42,
    "Last12MonthYield": 14.07,
    "ISIN": "IL0051383003"
  },
  {
    "Id": "TASE:5129788",
    "MayaId": "5129788",
    "Name": "Harel Htf SP Tech MM",
    "ShortName": "Harel Htf SP Tech MM",
    "Symbol": "TASE:5129788",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4A) S&P Technology Currency-Hedged",
    "EnglishLongName": "Harel Htf (4A) S&P Technology Currency-Hedged",
    "HebrewName": "הראל מחקה SP Tech ממ",
    "HebrewLongName": "הראל מחקה (4A)יS&P Technology מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.66,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 243.2,
    "MonthYield": 0.98,
    "YearYield": 0.98,
    "Last12MonthYield": 22.07,
    "ISIN": "IL0051297880"
  },
  {
    "Id": "TASE:5129275",
    "MayaId": "5129275",
    "Name": "Harel Htf SP500",
    "ShortName": "Harel Htf SP500",
    "Symbol": "TASE:5129275",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4D) S&P 500",
    "EnglishLongName": "Harel Htf (4D) S&P 500",
    "HebrewName": "הראל מחקהSP500",
    "HebrewLongName": "הראל מחקה (4D)יS&P 500",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.025,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.39,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 3280.9,
    "MonthYield": 0.09,
    "YearYield": 0.09,
    "Last12MonthYield": 3.14,
    "ISIN": "IL0051292758"
  },
  {
    "Id": "TASE:5137807",
    "MayaId": "5137807",
    "Name": "Harel Htf SP500 EW",
    "ShortName": "Harel Htf SP500 EW",
    "Symbol": "TASE:5137807",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4D) S&P 500 Equal Weight",
    "EnglishLongName": "Harel Htf (4D) S&P 500 Equal Weight",
    "HebrewName": "הראל מחקה SP500 EW",
    "HebrewLongName": "הראל מחקה (4D)י S&P 500 Equal Weight",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.4,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 185.9,
    "MonthYield": 2.82,
    "YearYield": 2.82,
    "Last12MonthYield": -0.28,
    "ISIN": "IL0051378078"
  },
  {
    "Id": "TASE:5127527",
    "MayaId": "5127527",
    "Name": "Harel Htf SP500 MM",
    "ShortName": "Harel Htf SP500 MM",
    "Symbol": "TASE:5127527",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4A) S&P 500 Currency-Hedged",
    "EnglishLongName": "Harel Htf (4A) S&P 500 Currency-Hedged",
    "HebrewName": "הראל מחקה SP500 ממ",
    "HebrewLongName": "הראל מחקה (4A)י S&P 500 - מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.59,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 1101.4,
    "MonthYield": 1.46,
    "YearYield": 1.46,
    "Last12MonthYield": 16.99,
    "ISIN": "IL0051275274"
  },
  {
    "Id": "TASE:5140132",
    "MayaId": "5140132",
    "Name": "Harel Htf SP500 Momen MM",
    "ShortName": "Harel Htf SP500 Momen MM",
    "Symbol": "TASE:5140132",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4A) S&P 500 Momentum Currency - Hedged",
    "EnglishLongName": "Harel Htf (4A) S&P 500 Momentum Currency - Hedged",
    "HebrewName": "הראל מחקה SP500 Momen ממ",
    "HebrewLongName": "הראל מחקה (4A)י S&P 500 Momentum מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.03,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 129.2,
    "MonthYield": 0.31,
    "YearYield": 0.31,
    "Last12MonthYield": null,
    "ISIN": "IL0051401326"
  },
  {
    "Id": "TASE:5139571",
    "MayaId": "5139571",
    "Name": "Harel Htf SP500 Momentum",
    "ShortName": "Harel Htf SP500 Momentum",
    "Symbol": "TASE:5139571",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4D) S&P 500 Momentum",
    "EnglishLongName": "Harel Htf (4D) S&P 500 Momentum",
    "HebrewName": "הראל מחקה SP500 Momentum",
    "HebrewLongName": "הראל מחקה (4D)י S&P 500 Momentum",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.8,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 146.0,
    "MonthYield": -1.05,
    "YearYield": -1.05,
    "Last12MonthYield": 8.28,
    "ISIN": "IL0051395718"
  },
  {
    "Id": "TASE:5129713",
    "MayaId": "5129713",
    "Name": "Harel Htf SPConsumerDiscr",
    "ShortName": "Harel Htf SPConsumerDiscr",
    "Symbol": "TASE:5129713",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4D) S&P Consumer Discretionary",
    "EnglishLongName": "Harel Htf (4D) S&P Consumer Discretionary",
    "HebrewName": "הראל מחקה צריכה מחזור SP",
    "HebrewLongName": "הראל מחקה (4D) ‏S&P Consumer Discretionary",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.9,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 12.7,
    "MonthYield": 1.33,
    "YearYield": 1.33,
    "Last12MonthYield": -6.67,
    "ISIN": "IL0051297138"
  },
  {
    "Id": "TASE:5137203",
    "MayaId": "5137203",
    "Name": "Harel Htf STOXX600 ME",
    "ShortName": "Harel Htf STOXX600 ME",
    "Symbol": "TASE:5137203",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4A) STOXX Europe 600 Euro - Hedged",
    "EnglishLongName": "Harel Htf (4A) STOXX Europe 600 Euro - Hedged",
    "HebrewName": "הראל מחקה STOXX600 מא",
    "HebrewLongName": "הראל מחקה (4A)יSTOXX Europe 600 מנוטרלת אירו",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.01,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.17,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 258.5,
    "MonthYield": 3.75,
    "YearYield": 3.75,
    "Last12MonthYield": 26.32,
    "ISIN": "IL0051372030"
  },
  {
    "Id": "TASE:5122510",
    "MayaId": "5122510",
    "Name": "Harel Htf TA 125 IL",
    "ShortName": "Harel Htf TA-125 IL",
    "Symbol": "TASE:5122510",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4A) TA 125 IL",
    "EnglishLongName": "Harel Htf (4A) TA 125 IL",
    "HebrewName": "הראל מחקה תא 125",
    "HebrewLongName": "הראל מחקה (4A) ת\"א 125",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.018,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.12,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 906.4,
    "MonthYield": 8.85,
    "YearYield": 8.85,
    "Last12MonthYield": 64.12,
    "ISIN": "IL0051225105"
  },
  {
    "Id": "TASE:5130661",
    "MayaId": "5130661",
    "Name": "Harel Htf TA 35 IL",
    "ShortName": "Harel Htf TA 35 IL",
    "Symbol": "TASE:5130661",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4A) TA 35 IL",
    "EnglishLongName": "Harel Htf (4A) TA 35 IL",
    "HebrewName": "הראל מחקה ת\"א 35",
    "HebrewLongName": "הראל מחקה (4A) ת\"א 35",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.96,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 1057.2,
    "MonthYield": 9.28,
    "YearYield": 9.28,
    "Last12MonthYield": 65.75,
    "ISIN": "IL0051306616"
  },
  {
    "Id": "TASE:5135348",
    "MayaId": "5135348",
    "Name": "Harel Htf TA 90 Deno $ IL",
    "ShortName": "Harel Htf TA 90 Deno $ IL",
    "Symbol": "TASE:5135348",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4D) TA 90-Denominated in $ IL",
    "EnglishLongName": "Harel Htf (4D) TA 90-Denominated in $ IL",
    "HebrewName": "הראל מחקה ת\"א 90 נקובה $",
    "HebrewLongName": "הראל מחקה (4D) ת\"א 90 - נקובה $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.39,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 43.7,
    "MonthYield": 6.92,
    "YearYield": 6.92,
    "Last12MonthYield": 39.66,
    "ISIN": "IL0051353485"
  },
  {
    "Id": "TASE:5130638",
    "MayaId": "5130638",
    "Name": "Harel Htf TA 90 IL",
    "ShortName": "Harel Htf TA 90 IL",
    "Symbol": "TASE:5130638",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4A) TA 90 IL",
    "EnglishLongName": "Harel Htf (4A) TA 90 IL",
    "HebrewName": "הראל מחקה ת\"א 90",
    "HebrewLongName": "הראל מחקה (4A) ת\"א 90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.98,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 1311.7,
    "MonthYield": 7.35,
    "YearYield": 7.35,
    "Last12MonthYield": 57.29,
    "ISIN": "IL0051306384"
  },
  {
    "Id": "TASE:5140728",
    "MayaId": "5140728",
    "Name": "Harel Htf TA 90 PrM EW IL",
    "ShortName": "Harel Htf TA 90 PrM EW IL",
    "Symbol": "TASE:5140728",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4A) TA-90 Profitable Model EW IL",
    "EnglishLongName": "Harel Htf (4A) TA-90 Profitable Model EW IL",
    "HebrewName": "הראל מחקה תא 90 מו ר מש ש",
    "HebrewLongName": "הראל מחקה (4A) ת\"א-90 מודל רווחיות משקל שווה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 0.5,
    "MonthYield": 7.42,
    "YearYield": 7.42,
    "Last12MonthYield": null,
    "ISIN": "IL0051407281"
  },
  {
    "Id": "TASE:5139639",
    "MayaId": "5139639",
    "Name": "Harel Htf TA 90+Banks IL",
    "ShortName": "Harel Htf TA 90+Banks IL",
    "Symbol": "TASE:5139639",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4A) TA - 90 & Banks IL",
    "EnglishLongName": "Harel Htf (4A) TA - 90 & Banks IL",
    "HebrewName": "הראל מחקה תא 90 ובנקים",
    "HebrewLongName": "הראל מחקה (4A) ת\"א 90 ובנקים",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.67,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 354.2,
    "MonthYield": 8.08,
    "YearYield": 8.08,
    "Last12MonthYield": 62.38,
    "ISIN": "IL0051396393"
  },
  {
    "Id": "TASE:5133764",
    "MayaId": "5133764",
    "Name": "Harel Htf TA All Share IL",
    "ShortName": "Harel Htf TA All-Share IL",
    "Symbol": "TASE:5133764",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4A) TA All-Share IL",
    "EnglishLongName": "Harel Htf (4A) TA All-Share IL",
    "HebrewName": "הראל מחקה ת\"א All-Share",
    "HebrewLongName": "הראל מחקה (4A) ת\"א All-Share",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 27.2,
    "MonthYield": 7.29,
    "YearYield": 7.29,
    "Last12MonthYield": 52.19,
    "ISIN": "IL0051337645"
  },
  {
    "Id": "TASE:5131404",
    "MayaId": "5131404",
    "Name": "Harel Htf TA Construct IL",
    "ShortName": "Harel Htf TA-Construct IL",
    "Symbol": "TASE:5131404",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4A) TA - Construction IL",
    "EnglishLongName": "Harel Htf (4A) TA - Construction IL",
    "HebrewName": "הראל מחקה תא בנייה",
    "HebrewLongName": "הראל מחקה (4A) ת\"א בנייה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.02,
    "VariableFee": 0.2,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 4.55,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 87.2,
    "MonthYield": 12.05,
    "YearYield": 12.05,
    "Last12MonthYield": 23.26,
    "ISIN": "IL0051314040"
  },
  {
    "Id": "TASE:5141783",
    "MayaId": "5141783",
    "Name": "Harel Htf TA Infrastru IL",
    "ShortName": "Harel Htf TA Infrastru IL",
    "Symbol": "TASE:5141783",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4A) TA Infrastructure IL",
    "EnglishLongName": "Harel Htf (4A) TA Infrastructure IL",
    "HebrewName": "הראל מחקה ת\"א תשתיות",
    "HebrewLongName": "הראל מחקה (4A) ת\"א תשתיות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 6.1,
    "MonthYield": 5.25,
    "YearYield": 5.25,
    "Last12MonthYield": null,
    "ISIN": "IL0051417835"
  },
  {
    "Id": "TASE:5140009",
    "MayaId": "5140009",
    "Name": "Harel Htf TA Insurance",
    "ShortName": "Harel Htf TA - Insurance",
    "Symbol": "TASE:5140009",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4A) TA - Insurance IL",
    "EnglishLongName": "Harel Htf (4A) TA - Insurance IL",
    "HebrewName": "הראל מחקה ת\"א- ביטוח",
    "HebrewLongName": "הראל מחקה (4A) ת\"א- ביטוח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 5.43,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 114.0,
    "MonthYield": 7.09,
    "YearYield": 7.09,
    "Last12MonthYield": null,
    "ISIN": "IL0051400096"
  },
  {
    "Id": "TASE:5131420",
    "MayaId": "5131420",
    "Name": "Harel Htf TA Inv ProIs IL",
    "ShortName": "Harel Htf TA-Inv ProIs IL",
    "Symbol": "TASE:5131420",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4A) TA - Investment Properties in Israel IL",
    "EnglishLongName": "Harel Htf (4A) TA - Investment Properties in Israel IL",
    "HebrewName": "הראל מחקה ת\"א מניב ישראל",
    "HebrewLongName": "הראל מחקה (4A) ת\"א מניב ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.02,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 136.3,
    "MonthYield": 7.7,
    "YearYield": 7.7,
    "Last12MonthYield": 44.95,
    "ISIN": "IL0051314206"
  },
  {
    "Id": "TASE:5142021",
    "MayaId": "5142021",
    "Name": "Harel Htf TA RelEst 35 IL",
    "ShortName": "Harel Htf TA RelEst-35 IL",
    "Symbol": "TASE:5142021",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4A) TA Real Estate-35 IL",
    "EnglishLongName": "Harel Htf (4A) TA Real Estate-35 IL",
    "HebrewName": "הראל מחקה ת\"א נדל\"ן-35",
    "HebrewLongName": "הראל מחקה (4A) ת\"א נדל\"ן-35",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": null,
    "MonthYield": 0.0,
    "YearYield": null,
    "Last12MonthYield": 0.0,
    "ISIN": "IL0051420219"
  },
  {
    "Id": "TASE:5141775",
    "MayaId": "5141775",
    "Name": "Harel Htf TA Security IL",
    "ShortName": "Harel Htf TA Security IL",
    "Symbol": "TASE:5141775",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4A) TA Securities IL",
    "EnglishLongName": "Harel Htf (4A) TA Securities IL",
    "HebrewName": "הראל מחקה ת\"א בטחוניות",
    "HebrewLongName": "הראל מחקה (4A) ת\"א בטחוניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.35,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 19.8,
    "MonthYield": 23.04,
    "YearYield": 23.04,
    "Last12MonthYield": null,
    "ISIN": "IL0051417751"
  },
  {
    "Id": "TASE:5140710",
    "MayaId": "5140710",
    "Name": "Harel Htf TA SME60 PEW IL",
    "ShortName": "Harel Htf TA SME60 PEW IL",
    "Symbol": "TASE:5140710",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4A) TA SME60 Profitable Model EW IL",
    "EnglishLongName": "Harel Htf (4A) TA SME60 Profitable Model EW IL",
    "HebrewName": "הראל מחקה תא SME60 מור מש",
    "HebrewLongName": "הראל מחקה (4A) ת\"א SME60 מודל רווחיות משקל שווה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 5.1,
    "MonthYield": 6.02,
    "YearYield": 6.02,
    "Last12MonthYield": null,
    "ISIN": "IL0051407109"
  },
  {
    "Id": "TASE:5131081",
    "MayaId": "5131081",
    "Name": "Harel Htf TA Technolog IL",
    "ShortName": "Harel Htf TA-Technolog IL",
    "Symbol": "TASE:5131081",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4A) TA-Technology IL",
    "EnglishLongName": "Harel Htf (4A) TA-Technology IL",
    "HebrewName": "הראל מחקה ת\"א טכנולוגיה",
    "HebrewLongName": "הראל מחקה (4A) ת\"א טכנולוגיה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.02,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.27,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 152.7,
    "MonthYield": 14.93,
    "YearYield": 14.93,
    "Last12MonthYield": 80.46,
    "ISIN": "IL0051310816"
  },
  {
    "Id": "TASE:5128111",
    "MayaId": "5128111",
    "Name": "Harel Htf TANLCFXG IL",
    "ShortName": "Harel Htf TANLCFXG IL",
    "Symbol": "TASE:5128111",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (00) Tel Gov - Shekel IL",
    "EnglishLongName": "Harel Htf (00) Tel Gov - Shekel IL",
    "HebrewName": "הראל מחקה תל גוב-שקלי",
    "HebrewLongName": "הראל מחקה (00) תל גוב-שקלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.14,
    "TrusteeFee": 0.015,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.43,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Non-Linked Government Bonds",
    "AssetValue": 73.1,
    "MonthYield": 0.86,
    "YearYield": 0.86,
    "Last12MonthYield": 8.13,
    "ISIN": "IL0051281116"
  },
  {
    "Id": "TASE:5135835",
    "MayaId": "5135835",
    "Name": "Harel Htf TAR10FIG IL",
    "ShortName": "Harel Htf TAR10FIG IL",
    "Symbol": "TASE:5135835",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (00) Tel Gov - Shekel 10+ IL",
    "EnglishLongName": "Harel Htf (00) Tel Gov - Shekel 10+ IL",
    "HebrewName": "הראל מחקה תל גוב-שקלי 10+",
    "HebrewLongName": "הראל מחקה (00) תל גוב-שקלי 10+",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.93,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Non-Linked Government Bonds",
    "AssetValue": 64.1,
    "MonthYield": 1.56,
    "YearYield": 1.56,
    "Last12MonthYield": 12.47,
    "ISIN": "IL0051358351"
  },
  {
    "Id": "TASE:5135843",
    "MayaId": "5135843",
    "Name": "Harel Htf TAR10GV IL",
    "ShortName": "Harel Htf TAR10GV IL",
    "Symbol": "TASE:5135843",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (00) Tel Gov - CPI Linked 10+ IL",
    "EnglishLongName": "Harel Htf (00) Tel Gov - CPI Linked 10+ IL",
    "HebrewName": "הראל מחקה תל-גובצמוד 10+",
    "HebrewLongName": "הראל מחקה (00) תל גוב-צמודות 10+",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.09,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked",
    "AssetValue": 4.9,
    "MonthYield": 0.0,
    "YearYield": null,
    "Last12MonthYield": 4.61,
    "ISIN": "IL0051358435"
  },
  {
    "Id": "TASE:5117262",
    "MayaId": "5117262",
    "Name": "Harel Htf TAR25FIG IL",
    "ShortName": "Harel Htf TAR25FIG IL",
    "Symbol": "TASE:5117262",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (00) Tel Gov - Shekel 2-5 IL",
    "EnglishLongName": "Harel Htf (00) Tel Gov - Shekel 2-5 IL",
    "HebrewName": "הראל מחקה תל גוב-שקלי 2-5",
    "HebrewLongName": "הראל מחקה (00) תל גוב-שקלי 2-5",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.24,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Non-Linked Government Bonds",
    "AssetValue": 95.7,
    "MonthYield": 0.6,
    "YearYield": 0.6,
    "Last12MonthYield": 6.3,
    "ISIN": "IL0051172620"
  },
  {
    "Id": "TASE:5117247",
    "MayaId": "5117247",
    "Name": "Harel Htf TAR25GV IL",
    "ShortName": "Harel Htf TAR25GV IL",
    "Symbol": "TASE:5117247",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (00) Tel Gov - CPI Linked 2-5 IL",
    "EnglishLongName": "Harel Htf (00) Tel Gov - CPI Linked 2-5 IL",
    "HebrewName": "הראל מחקה תל-גוב צמוד2-5",
    "HebrewLongName": "הראל מחקה (00) תל גוב-צמודות 2-5",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.05,
    "TrusteeFee": 0.02,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.14,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked",
    "AssetValue": 171.5,
    "MonthYield": 0.15,
    "YearYield": 0.15,
    "Last12MonthYield": 4.52,
    "ISIN": "IL0051172471"
  },
  {
    "Id": "TASE:5116785",
    "MayaId": "5116785",
    "Name": "Harel Htf TAR510GV IL",
    "ShortName": "Harel Htf TAR510GV IL",
    "Symbol": "TASE:5116785",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (00) Tel Gov - CPI Linked 5-10 IL",
    "EnglishLongName": "Harel Htf (00) Tel Gov - CPI Linked 5-10 IL",
    "HebrewName": "הראל מחקה תל-גובצמוד5-10",
    "HebrewLongName": "הראל מחקה (00) תל גוב-צמודות 5-10",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.39,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked",
    "AssetValue": 84.8,
    "MonthYield": -0.1,
    "YearYield": -0.1,
    "Last12MonthYield": 5.29,
    "ISIN": "IL0051167851"
  },
  {
    "Id": "TASE:5128137",
    "MayaId": "5128137",
    "Name": "Harel Htf TAR5FIG IL",
    "ShortName": "Harel Htf TAR5FIG IL",
    "Symbol": "TASE:5128137",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (00) Tel Gov - Shekel 5+ IL",
    "EnglishLongName": "Harel Htf (00) Tel Gov - Shekel 5+ IL",
    "HebrewName": "הראל מחקה תל גוב-שקלי 5+",
    "HebrewLongName": "הראל מחקה (00) תל גוב-שקלי 5+",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.015,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.75,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Non-Linked Government Bonds",
    "AssetValue": 43.8,
    "MonthYield": 1.25,
    "YearYield": 1.25,
    "Last12MonthYield": 11.1,
    "ISIN": "IL0051281371"
  },
  {
    "Id": "TASE:5129689",
    "MayaId": "5129689",
    "Name": "Harel Htf TBBk out COC IL",
    "ShortName": "Harel Htf TBBk out COC IL",
    "Symbol": "TASE:5129689",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (00) Tel Bond CPI Linked - Bank Without COCO IL",
    "EnglishLongName": "Harel Htf (00) Tel Bond CPI Linked - Bank Without COCO IL",
    "HebrewName": "הראל מחקה תב צמ בנ לא קוק",
    "HebrewLongName": "הראל מחקה (00) תל בונד צמודות- בנקים ללא COCO",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.015,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.18,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 309.2,
    "MonthYield": 0.08,
    "YearYield": 0.08,
    "Last12MonthYield": 5.21,
    "ISIN": "IL0051296890"
  },
  {
    "Id": "TASE:5117270",
    "MayaId": "5117270",
    "Name": "Harel Htf TEL B20 CPI IL",
    "ShortName": "Harel Htf TEL-B20 CPI IL",
    "Symbol": "TASE:5117270",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (00) Tel Bond 20 CPI Linked IL",
    "EnglishLongName": "Harel Htf (00) Tel Bond 20 CPI Linked IL",
    "HebrewName": "הראל מחקה תלבונד 20 צמוד",
    "HebrewLongName": "הראל מחקה (00) תל בונד 20 צמודות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.43,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 532.9,
    "MonthYield": 0.22,
    "YearYield": 0.22,
    "Last12MonthYield": 7.31,
    "ISIN": "IL0051172703"
  },
  {
    "Id": "TASE:5137195",
    "MayaId": "5137195",
    "Name": "Harel Htf TEL B50 IL",
    "ShortName": "Harel Htf TEL-B50 IL",
    "Symbol": "TASE:5137195",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (00) Tel Bond Shekel-50 IL",
    "EnglishLongName": "Harel Htf (00) Tel Bond Shekel-50 IL",
    "HebrewName": "הראל מחקה תל בונד שקלי-50",
    "HebrewLongName": "הראל מחקה (00) תל בונד שקלי-50",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.07,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.37,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 526.8,
    "MonthYield": 0.92,
    "YearYield": 0.92,
    "Last12MonthYield": 8.43,
    "ISIN": "IL0051371958"
  },
  {
    "Id": "TASE:5121835",
    "MayaId": "5121835",
    "Name": "Harel Htf TEL B60 CPI IL",
    "ShortName": "Harel Htf TEL-B60 CPI IL",
    "Symbol": "TASE:5121835",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (00) Tel Bond 60 CPI Linked IL",
    "EnglishLongName": "Harel Htf (00) Tel Bond 60 CPI Linked IL",
    "HebrewName": "הראל מחקה תלבונד 60 צמוד",
    "HebrewLongName": "הראל מחקה (00) תל בונד 60 צמודות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.018,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 631.5,
    "MonthYield": 0.23,
    "YearYield": 0.23,
    "Last12MonthYield": 6.71,
    "ISIN": "IL0051218357"
  },
  {
    "Id": "TASE:5136379",
    "MayaId": "5136379",
    "Name": "Harel Htf Tel BCL 3 5 IL",
    "ShortName": "Harel Htf Tel-BCL 3-5 IL",
    "Symbol": "TASE:5136379",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (00) Tel Bond-CPI Linked 3-5 IL",
    "EnglishLongName": "Harel Htf (00) Tel Bond-CPI Linked 3-5 IL",
    "HebrewName": "הראל מחקה תלבונד-צמוד 3-5",
    "HebrewLongName": "הראל מחקה (00) תל בונד-צמודות 3-5",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.12,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.25,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 181.1,
    "MonthYield": 0.18,
    "YearYield": 0.18,
    "Last12MonthYield": 6.17,
    "ISIN": "IL0051363799"
  },
  {
    "Id": "TASE:5138854",
    "MayaId": "5138854",
    "Name": "Harel Htf Tel BCL 5 10 IL",
    "ShortName": "Harel Htf Tel-BCL 5-10 IL",
    "Symbol": "TASE:5138854",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (00) Tel Bond - CPI Linked 5-10 IL",
    "EnglishLongName": "Harel Htf (00) Tel Bond - CPI Linked 5-10 IL",
    "HebrewName": "הראל מחקה תלבונד צמוד5-10",
    "HebrewLongName": "הראל מחקה (00) תל בונד צמודות 5-10",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.42,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 26.4,
    "MonthYield": 0.33,
    "YearYield": 0.33,
    "Last12MonthYield": 8.3,
    "ISIN": "IL0051388549"
  },
  {
    "Id": "TASE:5138847",
    "MayaId": "5138847",
    "Name": "Harel Htf Tel BCLBGC IL",
    "ShortName": "Harel Htf Tel-BCLBGC IL",
    "Symbol": "TASE:5138847",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (00) Tel Bond CPI Linked - Bank & Government Companies IL",
    "EnglishLongName": "Harel Htf (00) Tel Bond CPI Linked - Bank & Government Companies IL",
    "HebrewName": "הראל מחקה תלבונד צ בנק ומ",
    "HebrewLongName": "הראל מחקה (00) תל בונד צמודות בנקים וחברות ממשלתיות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.015,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 49.1,
    "MonthYield": 0.22,
    "YearYield": 0.22,
    "Last12MonthYield": 6.48,
    "ISIN": "IL0051388473"
  },
  {
    "Id": "TASE:5114939",
    "MayaId": "5114939",
    "Name": "Harel Htf TEL BCLS IL",
    "ShortName": "Harel Htf TEL-BCLS IL",
    "Symbol": "TASE:5114939",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (00) Tel Bond-CPI Linked SmallCap IL",
    "EnglishLongName": "Harel Htf (00) Tel Bond-CPI Linked SmallCap IL",
    "HebrewName": "הראל מחקה תלבונד צ יתר",
    "HebrewLongName": "הראל מחקה (00) תל בונד צמודות-יתר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.02,
    "VariableFee": 0.02,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.27,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 49.3,
    "MonthYield": 0.28,
    "YearYield": 0.28,
    "Last12MonthYield": 6.61,
    "ISIN": "IL0051149396"
  },
  {
    "Id": "TASE:5138862",
    "MayaId": "5138862",
    "Name": "Harel Htf Tel BS 5 10 IL",
    "ShortName": "Harel Htf Tel-BS 5-10 IL",
    "Symbol": "TASE:5138862",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (00) Tel Bond - Shekel 5-10 IL",
    "EnglishLongName": "Harel Htf (00) Tel Bond - Shekel 5-10 IL",
    "HebrewName": "הראל מחקה תלבונד-שקל 5-10",
    "HebrewLongName": "הראל מחקה (00) תל בונד שקלי 5-10",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.57,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 147.3,
    "MonthYield": 1.23,
    "YearYield": 1.23,
    "Last12MonthYield": 10.82,
    "ISIN": "IL0051388622"
  },
  {
    "Id": "TASE:5136213",
    "MayaId": "5136213",
    "Name": "Harel Htf TEL BSH 1 3 IL",
    "ShortName": "Harel Htf TEL-BSH 1-3 IL",
    "Symbol": "TASE:5136213",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (00) Tel Bond-Shekel 1-3 IL",
    "EnglishLongName": "Harel Htf (00) Tel Bond-Shekel 1-3 IL",
    "HebrewName": "הראל מחקה תלבונד שקלי 1-3",
    "HebrewLongName": "הראל מחקה (00) תל בונד-שקלי 1-3",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.21,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 91.2,
    "MonthYield": 0.68,
    "YearYield": 0.68,
    "Last12MonthYield": 5.14,
    "ISIN": "IL0051362130"
  },
  {
    "Id": "TASE:5136221",
    "MayaId": "5136221",
    "Name": "Harel Htf Tel BSH 3 5 IL",
    "ShortName": "Harel Htf Tel-BSH 3-5 IL",
    "Symbol": "TASE:5136221",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (00) Tel Bond-Shekel 3-5 IL",
    "EnglishLongName": "Harel Htf (00) Tel Bond-Shekel 3-5 IL",
    "HebrewName": "הראל מחקה תלבונד-שקלי 3-5",
    "HebrewLongName": "הראל מחקה (00) תל בונד-שקלי 3-5",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.37,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 48.8,
    "MonthYield": 0.88,
    "YearYield": 0.88,
    "Last12MonthYield": 7.54,
    "ISIN": "IL0051362213"
  },
  {
    "Id": "TASE:5117288",
    "MayaId": "5117288",
    "Name": "Harel Htf TEL BSH IL",
    "ShortName": "Harel Htf TEL-BSH IL",
    "Symbol": "TASE:5117288",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (00) Tel Bond - Shekel IL",
    "EnglishLongName": "Harel Htf (00) Tel Bond - Shekel IL",
    "HebrewName": "הראל מחקה תלבונד שקלי",
    "HebrewLongName": "הראל מחקה (00) תל בונד שקלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.018,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 178.8,
    "MonthYield": 0.9,
    "YearYield": 0.9,
    "Last12MonthYield": 7.23,
    "ISIN": "IL0051172885"
  },
  {
    "Id": "TASE:5128095",
    "MayaId": "5128095",
    "Name": "Harel Htf TEL COMP IL",
    "ShortName": "Harel Htf TEL-COMP IL",
    "Symbol": "TASE:5128095",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (0A) Tel Bond Composite IL",
    "EnglishLongName": "Harel Htf (0A) Tel Bond Composite IL",
    "HebrewName": "הראל מחקה תלבונד מאגר",
    "HebrewLongName": "הראל מחקה (0A) תל בונד מאגר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.015,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 166.4,
    "MonthYield": 0.52,
    "YearYield": 0.52,
    "Last12MonthYield": 6.9,
    "ISIN": "IL0051280951"
  },
  {
    "Id": "TASE:5129697",
    "MayaId": "5129697",
    "Name": "Harel Htf TEL DIV IL",
    "ShortName": "Harel Htf TEL-DIV IL",
    "Symbol": "TASE:5129697",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4A) Tel - Div IL",
    "EnglishLongName": "Harel Htf (4A) Tel - Div IL",
    "HebrewName": "הראל מחקה תל דיב",
    "HebrewLongName": "הראל מחקה (4A) תל דיב",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.015,
    "VariableFee": 0.15,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.67,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 69.8,
    "MonthYield": 5.91,
    "YearYield": 5.91,
    "Last12MonthYield": 48.09,
    "ISIN": "IL0051296973"
  },
  {
    "Id": "TASE:5131792",
    "MayaId": "5131792",
    "Name": "Harel Htf Tel Gov IL",
    "ShortName": "Harel Htf Tel-Gov IL",
    "Symbol": "TASE:5131792",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (0A) Tel-Gov IL",
    "EnglishLongName": "Harel Htf (0A) Tel-Gov IL",
    "HebrewName": "הראל מחקה תל גוב-כללי",
    "HebrewLongName": "הראל מחקה (0A) תל גוב-כללי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.39,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bonds",
    "AssetValue": 165.8,
    "MonthYield": 0.48,
    "YearYield": 0.48,
    "Last12MonthYield": 6.49,
    "ISIN": "IL0051317928"
  },
  {
    "Id": "TASE:5129705",
    "MayaId": "5129705",
    "Name": "Harel Htf TEL SECT IL",
    "ShortName": "Harel Htf TEL-SECT IL",
    "Symbol": "TASE:5129705",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4A) TA Sector-Balance IL",
    "EnglishLongName": "Harel Htf (4A) TA Sector-Balance IL",
    "HebrewName": "הראל מחקה תא סקטור-באלאנס",
    "HebrewLongName": "הראל מחקה (4A) ת\"א סקטור-באלאנס",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.13,
    "TrusteeFee": 0.015,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 151.1,
    "MonthYield": 7.83,
    "YearYield": 7.83,
    "Last12MonthYield": 69.62,
    "ISIN": "IL0051297054"
  },
  {
    "Id": "TASE:5139985",
    "MayaId": "5139985",
    "Name": "Harel Htf TELB YLD cp lin",
    "ShortName": "Harel Htf TELB-YLD cp lin",
    "Symbol": "TASE:5139985",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (00)(!) Tel Bond - Yields CPI Linked IL",
    "EnglishLongName": "Harel Htf (00)(!) Tel Bond - Yields CPI Linked IL",
    "HebrewName": "הראל מחקה תלבונד תשוא צמו",
    "HebrewLongName": "הראל מחקה (00)(!) תל בונד- תשואות צמודות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.24,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 14.3,
    "MonthYield": 0.17,
    "YearYield": 0.17,
    "Last12MonthYield": null,
    "ISIN": "IL0051399850"
  },
  {
    "Id": "TASE:5128103",
    "MayaId": "5128103",
    "Name": "Harel Htf TELG FL SHKL IL",
    "ShortName": "Harel Htf TELG FL SHKL IL",
    "Symbol": "TASE:5128103",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (00) Tel Gov - Floating Shekel IL",
    "EnglishLongName": "Harel Htf (00) Tel Gov - Floating Shekel IL",
    "HebrewName": "הראל מחקה תל-גוב משתנ שקל",
    "HebrewLongName": "הראל מחקה (00) תל גוב-משתנה שקלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.015,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.03,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Non-Linked Government Bonds",
    "AssetValue": 23.2,
    "MonthYield": 0.16,
    "YearYield": 0.16,
    "Last12MonthYield": 5.21,
    "ISIN": "IL0051281033"
  },
  {
    "Id": "TASE:5135736",
    "MayaId": "5135736",
    "Name": "Harel Htf TelGovT Bi $ IL",
    "ShortName": "Harel Htf TelGovT-Bi $ IL",
    "Symbol": "TASE:5135736",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (0D) Tel Gov T-Bills (MAKAM) -Denominated in $ IL",
    "EnglishLongName": "Harel Htf (0D) Tel Gov T-Bills (MAKAM) -Denominated in $ IL",
    "HebrewName": "הראל מחקה תל גוב-מקמ נקו$",
    "HebrewLongName": "הראל מחקה (0D) תל גוב-מק\"מ - נקובה $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.07,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Non-Linked Government Bonds",
    "AssetValue": 10.1,
    "MonthYield": -0.82,
    "YearYield": -0.82,
    "Last12MonthYield": -9.1,
    "ISIN": "IL0051357361"
  },
  {
    "Id": "TASE:5119409",
    "MayaId": "5119409",
    "Name": "Harel ILS Money Market IL",
    "ShortName": "Harel ILS Money Market IL",
    "Symbol": "TASE:5119409",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (00) Shekels Money Market IL",
    "EnglishLongName": "Harel (00) Shekels Money Market IL",
    "HebrewName": "הראל כספית שקלית",
    "HebrewLongName": "הראל (00) כספית שקלית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.19,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 4357.5,
    "MonthYield": 0.22,
    "YearYield": 0.22,
    "Last12MonthYield": 4.63,
    "ISIN": "IL0051194095"
  },
  {
    "Id": "TASE:5102876",
    "MayaId": "5102876",
    "Name": "Harel Infrastructu Isr IL",
    "ShortName": "Harel Infrastructu Isr IL",
    "Symbol": "TASE:5102876",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (4A) Infrastructure Israel IL",
    "EnglishLongName": "Harel (4A) Infrastructure Israel IL",
    "HebrewName": "הראל תשתיות ישראל",
    "HebrewLongName": "הראל (4A) תשתיות ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.25,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.14,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sectors",
    "AssetValue": 85.3,
    "MonthYield": 2.25,
    "YearYield": 2.25,
    "Last12MonthYield": 51.26,
    "ISIN": "IL0051028764"
  },
  {
    "Id": "TASE:5120779",
    "MayaId": "5120779",
    "Name": "Harel Inv TA Lar&Micap IL",
    "ShortName": "Harel Inv TA Lar&Micap IL",
    "Symbol": "TASE:5120779",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (4B) Investments TA Large & Mid Cap IL",
    "EnglishLongName": "Harel (4B) Investments TA Large & Mid Cap IL",
    "HebrewName": "הראל השקע תא Large&MidCap",
    "HebrewLongName": "הראל (4B) השקעות ת\"א Large & Mid Cap",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.4,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.94,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 48.1,
    "MonthYield": 8.25,
    "YearYield": 8.25,
    "Last12MonthYield": 89.9,
    "ISIN": "IL0051207798"
  },
  {
    "Id": "TASE:5118849",
    "MayaId": "5118849",
    "Name": "Harel Isr Eq Lar&MdCap IL",
    "ShortName": "Harel Isr Eq Lar&MdCap IL",
    "Symbol": "TASE:5118849",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (4A) Israel Equities Large & Mid Cap IL",
    "EnglishLongName": "Harel (4A) Israel Equities Large & Mid Cap IL",
    "HebrewName": "הראל מניו ישרLarge&MidCap",
    "HebrewLongName": "הראל (4A) מניות ישראל Large & Mid Cap",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.95,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.48,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 215.7,
    "MonthYield": 8.19,
    "YearYield": 8.19,
    "Last12MonthYield": 71.95,
    "ISIN": "IL0051188493"
  },
  {
    "Id": "TASE:5134754",
    "MayaId": "5134754",
    "Name": "Harel Isr Fn of Fn 15%IL",
    "ShortName": "Harel Isr Fn of Fn 15%IL",
    "Symbol": "TASE:5134754",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (2C) Israeli Fund of Funds up to 15% Equity IL",
    "EnglishLongName": "Harel (2C) Israeli Fund of Funds up to 15% Equity IL",
    "HebrewName": "הראל אגד ישראלי עד 15%",
    "HebrewLongName": "הראל (2C) אגד ישראלי עד 15% מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.37,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Fund of Funds",
    "SecondaryClassification": "Israeli Fund of Funds",
    "AssetValue": 16.1,
    "MonthYield": 1.36,
    "YearYield": 1.36,
    "Last12MonthYield": 10.73,
    "ISIN": "IL0051347545"
  },
  {
    "Id": "TASE:5134762",
    "MayaId": "5134762",
    "Name": "Harel Isr Fn of Fn 30%IL",
    "ShortName": "Harel Isr Fn of Fn 30%IL",
    "Symbol": "TASE:5134762",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (2C) Israeli Fund of Funds up to 30% Equity IL",
    "EnglishLongName": "Harel (2C) Israeli Fund of Funds up to 30% Equity IL",
    "HebrewName": "הראל אגד ישראלי עד 30%",
    "HebrewLongName": "הראל (2C) אגד ישראלי עד 30% מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.51,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Fund of Funds",
    "SecondaryClassification": "Israeli Fund of Funds",
    "AssetValue": 19.1,
    "MonthYield": 2.08,
    "YearYield": 2.08,
    "Last12MonthYield": 15.05,
    "ISIN": "IL0051347628"
  },
  {
    "Id": "TASE:5111133",
    "MayaId": "5111133",
    "Name": "Harel Isr Val BySid Eq IL",
    "ShortName": "Harel Isr Val BySid Eq IL",
    "Symbol": "TASE:5111133",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (4B) Israel Value Buy Side Equity IL",
    "EnglishLongName": "Harel (4B) Israel Value Buy Side Equity IL",
    "HebrewName": "הראל מניות ערך BuySide",
    "HebrewLongName": "הראל (4B) מניות ערך Buy Side ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.59,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.27,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 698.5,
    "MonthYield": 7.44,
    "YearYield": 7.44,
    "Last12MonthYield": 71.63,
    "ISIN": "IL0051111339"
  },
  {
    "Id": "TASE:5102488",
    "MayaId": "5102488",
    "Name": "Harel Israel 75/25 IL",
    "ShortName": "Harel Israel 75/25 IL",
    "Symbol": "TASE:5102488",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (2B) Israel 75/25 IL",
    "EnglishLongName": "Harel (2B) Israel 75/25 IL",
    "HebrewName": "הראל ישראל 25/75",
    "HebrewLongName": "הראל (2B) ישראל 25/75",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.63,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.69,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 25% Equity",
    "AssetValue": 329.0,
    "MonthYield": 2.64,
    "YearYield": 2.64,
    "Last12MonthYield": 20.4,
    "ISIN": "IL0051024888"
  },
  {
    "Id": "TASE:5111695",
    "MayaId": "5111695",
    "Name": "Harel Israel LargCapEq IL",
    "ShortName": "Harel Israel LargCapEq IL",
    "Symbol": "TASE:5111695",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (4B) Israel Large Cap Equity IL",
    "EnglishLongName": "Harel (4B) Israel Large Cap Equity IL",
    "HebrewName": "הראל מניות LargCap ישראל",
    "HebrewLongName": "הראל (4B) מניות Large Cap ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.33,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.18,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 177.4,
    "MonthYield": 7.73,
    "YearYield": 7.73,
    "Last12MonthYield": 65.97,
    "ISIN": "IL0051116957"
  },
  {
    "Id": "TASE:5111299",
    "MayaId": "5111299",
    "Name": "Harel Israel MidCap Eq IL",
    "ShortName": "Harel Israel MidCap Eq IL",
    "Symbol": "TASE:5111299",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (4C) Israel Mid Cap Equity IL",
    "EnglishLongName": "Harel (4C) Israel Mid Cap Equity IL",
    "HebrewName": "הראל מניות Mid Cap ישראל",
    "HebrewLongName": "הראל (4C) מניות Mid Cap ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.34,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 54.4,
    "MonthYield": 8.96,
    "YearYield": 8.96,
    "Last12MonthYield": 64.67,
    "ISIN": "IL0051112998"
  },
  {
    "Id": "TASE:5103403",
    "MayaId": "5103403",
    "Name": "Harel Liq $ M.Mark Liable",
    "ShortName": "Harel Liq $ M.Mark Liable",
    "Symbol": "TASE:5103403",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (0D) Liquid Dollar Money Market Liable",
    "EnglishLongName": "Harel (0D) Liquid Dollar Money Market Liable",
    "HebrewName": "הראל כספית דולר נזיל חיבת",
    "HebrewLongName": "הראל (0D) כספית דולר נזיל חייבת",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.18,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "FX Money Market with Corporate",
    "AssetValue": 44.0,
    "MonthYield": -1.25,
    "YearYield": -1.25,
    "Last12MonthYield": -10.42,
    "ISIN": "IL0051034036"
  },
  {
    "Id": "TASE:5129408",
    "MayaId": "5129408",
    "Name": "Harel Liq Man Mny Mrkt IL",
    "ShortName": "Harel Liq Man Mny Mrkt IL",
    "Symbol": "TASE:5129408",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (00) Liquidity Management Money Market IL",
    "EnglishLongName": "Harel (00) Liquidity Management Money Market IL",
    "HebrewName": "הראל כספית ניהול נזילות",
    "HebrewLongName": "הראל (00) כספית ניהול נזילות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.17,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 5092.6,
    "MonthYield": 0.23,
    "YearYield": 0.23,
    "Last12MonthYield": 4.68,
    "ISIN": "IL0051294085"
  },
  {
    "Id": "TASE:5120340",
    "MayaId": "5120340",
    "Name": "Harel Liquid Comp Fibi IL",
    "ShortName": "Harel Liquid Comp Fibi IL",
    "Symbol": "TASE:5120340",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (0A) Tracking Liquidity Component - International Bank IL",
    "EnglishLongName": "Harel (0A) Tracking Liquidity Component - International Bank IL",
    "HebrewName": "הראל עוקבת מרכב נזל הבינל",
    "HebrewLongName": "הראל (0A) עוקבת מרכיב נזילות - הבנק הבינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.49,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.1,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 40.2,
    "MonthYield": 0.42,
    "YearYield": 0.42,
    "Last12MonthYield": 5.18,
    "ISIN": "IL0051203409"
  },
  {
    "Id": "TASE:5129168",
    "MayaId": "5129168",
    "Name": "Harel Low Vol EqTA LMC IL",
    "ShortName": "Harel Low Vol EqTA LMC IL",
    "Symbol": "TASE:5129168",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (4A) Low Volatility Equity TA Large & Mid Cap IL",
    "EnglishLongName": "Harel (4A) Low Volatility Equity TA Large & Mid Cap IL",
    "HebrewName": "הראל מנ תנודת נמוכה תאLMC",
    "HebrewLongName": "הראל (4A) מניות תנודתיות נמוכה ת\"א Large & Mid Cap",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.19,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.57,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 14.7,
    "MonthYield": 7.78,
    "YearYield": 7.78,
    "Last12MonthYield": 67.63,
    "ISIN": "IL0051291685"
  },
  {
    "Id": "TASE:5111570",
    "MayaId": "5111570",
    "Name": "Harel Maof Baribua IL",
    "ShortName": "Harel Maof Baribua IL",
    "Symbol": "TASE:5111570",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (6A) Maof Baribua IL",
    "EnglishLongName": "Harel (6A) Maof Baribua IL",
    "HebrewName": "הראל מעו\"ף בריבוע",
    "HebrewLongName": "הראל (6A) מעו\"ף בריבוע",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.83,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": true,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.86,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Leveraged and Strategic",
    "SecondaryClassification": "Leveraged, High-Risk",
    "AssetValue": 48.3,
    "MonthYield": 18.66,
    "YearYield": 18.66,
    "Last12MonthYield": 150.13,
    "ISIN": "IL0051115702"
  },
  {
    "Id": "TASE:5110176",
    "MayaId": "5110176",
    "Name": "Harel Mixed IL",
    "ShortName": "Harel Mixed IL",
    "Symbol": "TASE:5110176",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (3C) Mixed IL",
    "EnglishLongName": "Harel (3C) Mixed IL",
    "HebrewName": "הראל מעורבת",
    "HebrewLongName": "הראל (3C) מעורבת",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.249,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - Max. Exposure over 30% Equity",
    "AssetValue": 42.2,
    "MonthYield": 4.29,
    "YearYield": 4.29,
    "Last12MonthYield": 29.32,
    "ISIN": "IL0051101769"
  },
  {
    "Id": "TASE:5129465",
    "MayaId": "5129465",
    "Name": "Harel Moment Eq TA LMC IL",
    "ShortName": "Harel Moment Eq TA LMC IL",
    "Symbol": "TASE:5129465",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (4A) Momentum Equities TA Large & Mid Cap IL",
    "EnglishLongName": "Harel (4A) Momentum Equities TA Large & Mid Cap IL",
    "HebrewName": "הראל מנ במומנטום תאLMC",
    "HebrewLongName": "הראל (4A) מניות במומנטום ת\"א Large & Mid Cap",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.29,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.47,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 645.8,
    "MonthYield": 8.31,
    "YearYield": 8.31,
    "Last12MonthYield": 78.58,
    "ISIN": "IL0051294655"
  },
  {
    "Id": "TASE:5127790",
    "MayaId": "5127790",
    "Name": "Harel Money Mrkt Int TrIL",
    "ShortName": "Harel Money Mrkt Int TrIL",
    "Symbol": "TASE:5127790",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (00) Money Market Interest Trend IL",
    "EnglishLongName": "Harel (00) Money Market Interest Trend IL",
    "HebrewName": "הראל כספית מגמת ריבית",
    "HebrewLongName": "הראל (00) כספית מגמת ריבית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.18,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 10809.3,
    "MonthYield": 0.22,
    "YearYield": 0.22,
    "Last12MonthYield": 4.64,
    "ISIN": "IL0051277908"
  },
  {
    "Id": "TASE:5124672",
    "MayaId": "5124672",
    "Name": "Harel Portfoio UpTo 50%IL",
    "ShortName": "Harel Portfoio UpTo 50%IL",
    "Symbol": "TASE:5124672",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (3B) Portfoio up to 50% IL",
    "EnglishLongName": "Harel (3B) Portfoio up to 50% IL",
    "HebrewName": "הראל תיק השקעות עד 50%",
    "HebrewLongName": "הראל (3B) תיק השקעות עד 50%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.77,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.64,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - Max. Exposure over 30% Equity",
    "AssetValue": 88.7,
    "MonthYield": 0.64,
    "YearYield": 0.64,
    "Last12MonthYield": 5.47,
    "ISIN": "IL0051246721"
  },
  {
    "Id": "TASE:5106430",
    "MayaId": "5106430",
    "Name": "Harel Portfolio IL",
    "ShortName": "Harel Portfolio IL",
    "Symbol": "TASE:5106430",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (2B)(!) Portfolio IL",
    "EnglishLongName": "Harel (2B)(!) Portfolio IL",
    "HebrewName": "הראל תיק השקעות",
    "HebrewLongName": "הראל (2B)(!) תיק השקעות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.42,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Hi-risk Corporate & Convertibles",
    "AssetValue": 21.3,
    "MonthYield": 1.56,
    "YearYield": 1.56,
    "Last12MonthYield": 12.95,
    "ISIN": "IL0051064306"
  },
  {
    "Id": "TASE:5108253",
    "MayaId": "5108253",
    "Name": "Harel Premium Corp+25",
    "ShortName": "Harel Premium Corp+25",
    "Symbol": "TASE:5108253",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (2C) Premium Corporate + 25% IL",
    "EnglishLongName": "Harel (2C) Premium Corporate + 25% IL",
    "HebrewName": "הראל פרימיום קונצרני+25%",
    "HebrewLongName": "הראל (2C) פרימיום קונצרני + 25%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.49,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles with Equity",
    "AssetValue": 19.7,
    "MonthYield": 2.68,
    "YearYield": 2.68,
    "Last12MonthYield": 23.02,
    "ISIN": "IL0051082530"
  },
  {
    "Id": "TASE:5125992",
    "MayaId": "5125992",
    "Name": "Harel RatBond SecurCompIL",
    "ShortName": "Harel RatBond-SecurCompIL",
    "Symbol": "TASE:5125992",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (0A)(!) Rated Bonds - Security Component IL",
    "EnglishLongName": "Harel (0A)(!) Rated Bonds - Security Component IL",
    "HebrewName": "הראל אג\"ח מדורג רכב בטוחה",
    "HebrewLongName": "הראל (0A)(!) אג\"ח מדורג - רכיב בטוחה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.58,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.14,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 52.5,
    "MonthYield": 0.5,
    "YearYield": 0.5,
    "Last12MonthYield": 5.6,
    "ISIN": "IL0051259922"
  },
  {
    "Id": "TASE:5100110",
    "MayaId": "5100110",
    "Name": "Harel Rate Sh Bo no Eq IL",
    "ShortName": "Harel Rate Sh Bo no Eq IL",
    "Symbol": "TASE:5100110",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (00) Rated Shekel Bonds Without Equity IL",
    "EnglishLongName": "Harel (00) Rated Shekel Bonds Without Equity IL",
    "HebrewName": "הראל מדורג שקלי ללא מניות",
    "HebrewLongName": "הראל (00) מדורג שקלי ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.85,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Shekel Corporate and Convertibles - No Equity",
    "AssetValue": 76.4,
    "MonthYield": 0.77,
    "YearYield": 0.77,
    "Last12MonthYield": 6.83,
    "ISIN": "IL0051001100"
  },
  {
    "Id": "TASE:5107859",
    "MayaId": "5107859",
    "Name": "Harel Rated Bond & Equ IL",
    "ShortName": "Harel Rated Bond & Equ IL",
    "Symbol": "TASE:5107859",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (2B) Rated Bonds and Equity IL",
    "EnglishLongName": "Harel (2B) Rated Bonds and Equity IL",
    "HebrewName": "הראל אג\"ח מדורג ומניות",
    "HebrewLongName": "הראל (2B) אג\"ח מדורג ומניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.49,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.22,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles with Equity",
    "AssetValue": 8.1,
    "MonthYield": 1.01,
    "YearYield": 1.01,
    "Last12MonthYield": 7.91,
    "ISIN": "IL0051078595"
  },
  {
    "Id": "TASE:5127360",
    "MayaId": "5127360",
    "Name": "Harel Rated Corp Bonds IL",
    "ShortName": "Harel Rated Corp Bonds IL",
    "Symbol": "TASE:5127360",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (0A) Rated Corporate Bonds IL",
    "EnglishLongName": "Harel (0A) Rated Corporate Bonds IL",
    "HebrewName": "הראל אג\"ח קונצרני מדורג",
    "HebrewLongName": "הראל (0A) אג\"ח קונצרני מדורג",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.3,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.29,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 135.8,
    "MonthYield": 0.37,
    "YearYield": 0.37,
    "Last12MonthYield": 6.99,
    "ISIN": "IL0051273600"
  },
  {
    "Id": "HRL.FK41.TA",
    "MayaId": "1155092",
    "Name": "Harel Sal (00) Kosher Tel Bond 60 CPI Linked IL",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL.FK41.TA",
    "TaseSymbol": "HRL.FK41",
    "YahooId": "HRL.FK41.TA",
    "EnglishName": "HRL.KSTBCPI60IL",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.כשתלבנד60צמ",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.001,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 407.26,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "HAREL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.3,
    "YearYield": 0.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011550923"
  },
  {
    "Id": "HRL.FK42.TA",
    "MayaId": "1155191",
    "Name": "Harel Sal (00) Kosher Tel Bond Shekel IL",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL.FK42.TA",
    "TaseSymbol": "HRL.FK42",
    "YahooId": "HRL.FK42.TA",
    "EnglishName": "HRL.KS TABSH.IL",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.כשתלבונדשקל",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.001,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 431.76,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "HAREL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 1.0,
    "YearYield": 1.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011551913"
  },
  {
    "Id": "HRL-F3.TA",
    "MayaId": "1150440",
    "Name": "Harel Sal (00) Tel Bond 20 CPI Linked IL",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F3.TA",
    "TaseSymbol": "HRL.F3",
    "YahooId": "HRL-F3.TA",
    "EnglishName": "HRL.TB-20CPIIL",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.תלבד- 20 צמ",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.0085,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 408.81,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "HAREL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.3,
    "YearYield": 0.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011504409"
  },
  {
    "Id": "HRL-F13.TA",
    "MayaId": "1150499",
    "Name": "Harel Sal (00) Tel Bond 40 CPI Linked IL",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F13.TA",
    "TaseSymbol": "HRL.F13",
    "YahooId": "HRL-F13.TA",
    "EnglishName": "HRL.TB40CPI IL",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.תלבנד 40 צמ",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.01,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 385.12,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "HAREL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.4,
    "YearYield": 0.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011504995"
  },
  {
    "Id": "HRL-F4.TA",
    "MayaId": "1150473",
    "Name": "Harel Sal (00) Tel Bond 60 CPI Linked IL",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F4.TA",
    "TaseSymbol": "HRL.F4",
    "YahooId": "HRL-F4.TA",
    "EnglishName": "HRL.TB-60CPIIL",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.תלבד- 60 צמ",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.32,
    "TrusteeFee": 0.0085,
    "VariableFee": 0.02,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 395.7,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "HAREL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.3,
    "YearYield": 0.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011504730"
  },
  {
    "Id": "HRL-F227.TA",
    "MayaId": "1190776",
    "Name": "Harel Sal (00) Tel Bond CPI Linked Bank Without COCO IL",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F227.TA",
    "TaseSymbol": "HRL.F227",
    "YahooId": "HRL-F227.TA",
    "EnglishName": "HRL.TBBK OCO IL",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.תב צב לא קו",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 372.6,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "HAREL",
    "TrusteeName": "UBANK",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.1,
    "YearYield": 0.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011907768"
  },
  {
    "Id": "HRL-F61.TA",
    "MayaId": "1150606",
    "Name": "Harel Sal (00) Tel Bond CPI Linked IL",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F61.TA",
    "TaseSymbol": "HRL.F61",
    "YahooId": "HRL-F61.TA",
    "EnglishName": "HRL.TEL-BCL IL",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.תלבונד צמוד",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.008,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 412.36,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "HAREL",
    "TrusteeName": "UBANK",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.3,
    "YearYield": 0.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011506065"
  },
  {
    "Id": "HRL-F300.TA",
    "MayaId": "1150713",
    "Name": "Harel Sal (00) Tel Bond Shekel 50 IL",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F300.TA",
    "TaseSymbol": "HRL.F300",
    "YahooId": "HRL-F300.TA",
    "EnglishName": "HRL.TEL-B50 IL",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.תלבונד ש 50",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.008,
    "VariableFee": 0.02,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 436.3,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "HAREL",
    "TrusteeName": "UBANK",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 1.0,
    "YearYield": 1.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011507139"
  },
  {
    "Id": "HRL-F303.TA",
    "MayaId": "1150747",
    "Name": "Harel Sal (00) Tel Bond Shekel Bank & Insurance IL",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F303.TA",
    "TaseSymbol": "HRL.F303",
    "YahooId": "HRL-F303.TA",
    "EnglishName": "HRL.TEL-CPBI IL",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.תלבושקל-ביט",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.35,
    "TrusteeFee": 0.015,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 449.93,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "HAREL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.9,
    "YearYield": 0.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011507477"
  },
  {
    "Id": "HRL-F24.TA",
    "MayaId": "1150523",
    "Name": "Harel Sal (00) Tel Bond Shekel IL",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F24.TA",
    "TaseSymbol": "HRL.F24",
    "YahooId": "HRL-F24.TA",
    "EnglishName": "HRL.TEL-BSHIL",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.תלבונד שקלי",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.28,
    "TrusteeFee": 0.0085,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 431.6,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "HAREL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.9,
    "YearYield": 0.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011505232"
  },
  {
    "Id": "HRL-F237.TA",
    "MayaId": "1231919",
    "Name": "Harel Sal (00) Tel Gov Non Linked IL",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F237.TA",
    "TaseSymbol": "HRL.F237",
    "YahooId": "HRL-F237.TA",
    "EnglishName": "HRL.TIGV-NOL IL",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.תלגוב לא צמ",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.02,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 457.91,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "HAREL",
    "TrusteeName": "UBANK",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government shekels - other",
    "AssetValue": null,
    "MonthYield": 1.1,
    "YearYield": 1.1,
    "Last12MonthYield": null,
    "ISIN": "IL0012319195"
  },
  {
    "Id": "HRL-F301.TA",
    "MayaId": "1150739",
    "Name": "Harel Sal (00)(!) Tel Bond Global Shekel IL",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F301.TA",
    "TaseSymbol": "HRL.F301",
    "YahooId": "HRL-F301.TA",
    "EnglishName": "HRL.TBGLOSHKLIL",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.תלבנדגלבלצמ",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.015,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 471.95,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "HAREL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.8,
    "YearYield": 0.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011507394"
  },
  {
    "Id": "HRL-F69.TA",
    "MayaId": "1150622",
    "Name": "Harel Sal (00)(!) Tel Bond Yields CPI Linked IL",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F69.TA",
    "TaseSymbol": "HRL.F69",
    "YahooId": "HRL-F69.TA",
    "EnglishName": "HRL.TELYLDCL IL",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.תלבונד תשצמ",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.01,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 441.74,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "HAREL",
    "TrusteeName": "UBANK",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.1,
    "YearYield": 0.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011506222"
  },
  {
    "Id": "HRL-F109.TA",
    "MayaId": "1150671",
    "Name": "Harel Sal (00)(!) Tel Bond Yields Shekel IL",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F109.TA",
    "TaseSymbol": "HRL.F109",
    "YahooId": "HRL-F109.TA",
    "EnglishName": "HRL.TEL-NIS IL",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.תלבונדתשו ש",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.008,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 433.57,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "HAREL",
    "TrusteeName": "UBANK",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 1.1,
    "YearYield": 1.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011506719"
  },
  {
    "Id": "HRL-F221.TA",
    "MayaId": "1169622",
    "Name": "Harel Sal (0A) Tel Bond Composite IL",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F221.TA",
    "TaseSymbol": "HRL.F221",
    "YahooId": "HRL-F221.TA",
    "EnglishName": "HRL.TA-COMP IL",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.תלבונד מאגר",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.005,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 427.37,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "HAREL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate Bond - Shekel, Linked",
    "AssetValue": null,
    "MonthYield": 0.6,
    "YearYield": 0.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011696221"
  },
  {
    "Id": "HRL-F231.TA",
    "MayaId": "1210871",
    "Name": "Harel Sal (0D) S&P U.S. Treasury Bond 5 7 Year",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F231.TA",
    "TaseSymbol": "HRL.F231",
    "YahooId": "HRL-F231.TA",
    "EnglishName": "HRL.SPUS TB 5-7",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.SPUS TB 5-7",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4534.66,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "HAREL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -1.5,
    "YearYield": -1.5,
    "Last12MonthYield": null,
    "ISIN": "IL0012108713"
  },
  {
    "Id": "HRL-F53.TA",
    "MayaId": "1149160",
    "Name": "Harel Sal (4A) DAX Currency Hedged",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F53.TA",
    "TaseSymbol": "HRL.F53",
    "YahooId": "HRL-F53.TA",
    "EnglishName": "HRL.DAX MM",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.DAX ממ",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.015,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 21210.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Europe - developed markets",
    "AssetValue": null,
    "MonthYield": 2.7,
    "YearYield": 2.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011491607"
  },
  {
    "Id": "HRL-F226.TA",
    "MayaId": "1190685",
    "Name": "Harel Sal (4A) Index Israel 100 profitability Equal Weight IL",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F226.TA",
    "TaseSymbol": "HRL.F226",
    "YahooId": "HRL-F226.TA",
    "EnglishName": "HRL.LNL100PEWIL",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.א יש100רומש",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.02,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 332.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Large & Mid Cap",
    "AssetValue": null,
    "MonthYield": 8.6,
    "YearYield": 8.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011906851"
  },
  {
    "Id": "HRL-F12.TA",
    "MayaId": "1148949",
    "Name": "Harel Sal (4A) Index Israel Banks IL",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F12.TA",
    "TaseSymbol": "HRL.F12",
    "YahooId": "HRL-F12.TA",
    "EnglishName": "HRL.IN ISRBNKIL",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.אינ בנק ישר",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.008,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 7810.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "UBANK",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Banking and non-banking credit",
    "AssetValue": null,
    "MonthYield": 9.6,
    "YearYield": 9.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011489494"
  },
  {
    "Id": "HRL-F204.TA",
    "MayaId": "1150192",
    "Name": "Harel Sal (4A) ISE Cyber Security Dollar Hedged",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F204.TA",
    "TaseSymbol": "HRL.F204",
    "YahooId": "HRL-F204.TA",
    "EnglishName": "HRL.ISECYBER MM",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.ISECYBER ממ",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.015,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 560.4,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Cyber Security",
    "AssetValue": null,
    "MonthYield": -2.2,
    "YearYield": -2.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011501926"
  },
  {
    "Id": "HRL.FK43.TA",
    "MayaId": "1155340",
    "Name": "Harel Sal (4A) Kosher TA 125 IL",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL.FK43.TA",
    "TaseSymbol": "HRL.FK43",
    "YahooId": "HRL.FK43.TA",
    "EnglishName": "HRL. KSTA125 IL",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.כש תא 125",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.001,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3846.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Large & Mid Cap",
    "AssetValue": null,
    "MonthYield": 8.9,
    "YearYield": 8.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011553406"
  },
  {
    "Id": "HRL-F214.TA",
    "MayaId": "1166172",
    "Name": "Harel Sal (4A) Kosher TA 90 IL",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F214.TA",
    "TaseSymbol": "HRL.F214",
    "YahooId": "HRL-F214.TA",
    "EnglishName": "HRL.KS TA-90IL",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.כש תא 90",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.001,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3706.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Mid Cap",
    "AssetValue": null,
    "MonthYield": 7.6,
    "YearYield": 7.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011661720"
  },
  {
    "Id": "HRL-F205.TA",
    "MayaId": "1150200",
    "Name": "Harel Sal (4A) MSCI AC World Dollar Hedged",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F205.TA",
    "TaseSymbol": "HRL.F205",
    "YahooId": "HRL-F205.TA",
    "EnglishName": "HRL.MSCIACWORMM",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.MSCIACWORממ",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.02,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 962.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.0,
    "YearYield": 1.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011502007"
  },
  {
    "Id": "HRL-F49.TA",
    "MayaId": "1149103",
    "Name": "Harel Sal (4A) NASDAQ 100 Currency Hedged",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F49.TA",
    "TaseSymbol": "HRL.F49",
    "YahooId": "HRL-F49.TA",
    "EnglishName": "HRL.NDX 100 MM",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.NDX 100 ממ",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.015,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 21130.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": -1.2,
    "YearYield": -1.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011491037"
  },
  {
    "Id": "HRL-F67.TA",
    "MayaId": "1149251",
    "Name": "Harel Sal (4A) NIKKEI 225 Currency Hedged",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F67.TA",
    "TaseSymbol": "HRL.F67",
    "YahooId": "HRL-F67.TA",
    "EnglishName": "HRL.NIKKEI225MM",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.NIKKEI225ממ",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.78,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5520.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Asia and Pacific - developed markets",
    "AssetValue": null,
    "MonthYield": 6.5,
    "YearYield": 6.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011492514"
  },
  {
    "Id": "HRL-F50.TA",
    "MayaId": "1149137",
    "Name": "Harel Sal (4A) S&P 500 Currency Hedged",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F50.TA",
    "TaseSymbol": "HRL.F50",
    "YahooId": "HRL-F50.TA",
    "EnglishName": "HRL.SP500 MM",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.SP500 ממ",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.01,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 6530.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": -0.3,
    "YearYield": -0.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011491375"
  },
  {
    "Id": "HRL-F95.TA",
    "MayaId": "1149970",
    "Name": "Harel Sal (4A) S&P 500 Equal Weight Currency Hedged",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F95.TA",
    "TaseSymbol": "HRL.F95",
    "YahooId": "HRL-F95.TA",
    "EnglishName": "HRL.SP500 EW MM",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.SP500 EW ממ",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 8080.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": 3.1,
    "YearYield": 3.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011499709"
  },
  {
    "Id": "HRL-F82.TA",
    "MayaId": "1149905",
    "Name": "Harel Sal (4A) S&P 500 Low Volatility Currency Hedged",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F82.TA",
    "TaseSymbol": "HRL.F82",
    "YahooId": "HRL-F82.TA",
    "EnglishName": "HRL.SP500LV MM",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.SP500LV ממ",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1135.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": 1.7,
    "YearYield": 1.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011499055"
  },
  {
    "Id": "HRL-F81.TA",
    "MayaId": "1149897",
    "Name": "Harel Sal (4A) S&P Financial Currency Hedged",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F81.TA",
    "TaseSymbol": "HRL.F81",
    "YahooId": "HRL-F81.TA",
    "EnglishName": "HRL.SPFINANCEMM",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.SPFINANCEממ",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 613.7,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Financial",
    "AssetValue": null,
    "MonthYield": -2.9,
    "YearYield": -2.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011498974"
  },
  {
    "Id": "HRL-F224.TA",
    "MayaId": "1184092",
    "Name": "Harel Sal (4A) S&P North American Expanded Tech Software Currency Hedged",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F224.TA",
    "TaseSymbol": "HRL.F224",
    "YahooId": "HRL-F224.TA",
    "EnglishName": "HRL.SPEX TESFMM",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.SPEX TESFממ",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 6476.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Technology",
    "AssetValue": null,
    "MonthYield": -9.0,
    "YearYield": -9.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011840928"
  },
  {
    "Id": "HRL-F80.TA",
    "MayaId": "1149889",
    "Name": "Harel Sal (4A) STOXX Europe 600 Euro Hedged",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F80.TA",
    "TaseSymbol": "HRL.F80",
    "YahooId": "HRL-F80.TA",
    "EnglishName": "HRL.STOXX600 MM",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.STOXX600 ממ",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.02,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 779.5,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Europe - general",
    "AssetValue": null,
    "MonthYield": 2.1,
    "YearYield": 2.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011498891"
  },
  {
    "Id": "HRL-F2.TA",
    "MayaId": "1148899",
    "Name": "Harel Sal (4A) TA 125 IL",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F2.TA",
    "TaseSymbol": "HRL.F2",
    "YahooId": "HRL-F2.TA",
    "EnglishName": "HRL.TA-125 IL",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.תא 125",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.0085,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3849.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Large & Mid Cap",
    "AssetValue": null,
    "MonthYield": 8.6,
    "YearYield": 8.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011488991"
  },
  {
    "Id": "HRL-F7.TA",
    "MayaId": "1148907",
    "Name": "Harel Sal (4A) TA 35 IL",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F7.TA",
    "TaseSymbol": "HRL.F7",
    "YahooId": "HRL-F7.TA",
    "EnglishName": "HRL.TA-35 IL",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.תא 35",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.008,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3856.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "UBANK",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Large Cap",
    "AssetValue": null,
    "MonthYield": 9.0,
    "YearYield": 9.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011489072"
  },
  {
    "Id": "HRL-F233.TA",
    "MayaId": "1213594",
    "Name": "Harel Sal (4A) TA 90 & Banks IL",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F233.TA",
    "TaseSymbol": "HRL.F233",
    "YahooId": "HRL-F233.TA",
    "EnglishName": "HRL TA90BANK IL",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.תא 90 בנקים",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4130.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Large & Mid Cap",
    "AssetValue": null,
    "MonthYield": 8.0,
    "YearYield": 8.0,
    "Last12MonthYield": null,
    "ISIN": "IL0012135948"
  },
  {
    "Id": "HRL-F11.TA",
    "MayaId": "1148931",
    "Name": "Harel Sal (4A) TA 90 IL",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F11.TA",
    "TaseSymbol": "HRL.F11",
    "YahooId": "HRL-F11.TA",
    "EnglishName": "HRL.TA-90 IL",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.תא 90",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.0085,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3701.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Mid Cap",
    "AssetValue": null,
    "MonthYield": 6.8,
    "YearYield": 6.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011489312"
  },
  {
    "Id": "HRL-F16.TA",
    "MayaId": "1148980",
    "Name": "Harel Sal (4A) TA Finance IL",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F16.TA",
    "TaseSymbol": "HRL.F16",
    "YahooId": "HRL-F16.TA",
    "EnglishName": "HRL.TA-FIN IL",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.תא פיננסים",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.015,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 8830.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "UBANK",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Financial",
    "AssetValue": null,
    "MonthYield": 8.1,
    "YearYield": 8.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011489809"
  },
  {
    "Id": "HRL-F236.TA",
    "MayaId": "1226927",
    "Name": "Harel Sal (4A) TA Oil & Gas IL",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F236.TA",
    "TaseSymbol": "HRL.F236",
    "YahooId": "HRL-F236.TA",
    "EnglishName": "HRL.TA OILGA IL",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.תא נפט וגז",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3088.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "UBANK",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Oil, gas and energy",
    "AssetValue": null,
    "MonthYield": -1.9,
    "YearYield": -1.9,
    "Last12MonthYield": null,
    "ISIN": "IL0012269275"
  },
  {
    "Id": "HRL-F15.TA",
    "MayaId": "1148964",
    "Name": "Harel Sal (4A) TA RealEstate IL",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F15.TA",
    "TaseSymbol": "HRL.F15",
    "YahooId": "HRL-F15.TA",
    "EnglishName": "HRL.TA-REAL IL",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.תא נדלן",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.015,
    "VariableFee": 0.2,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1473.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "UBANK",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Real estate and construction",
    "AssetValue": null,
    "MonthYield": 9.5,
    "YearYield": 9.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011489643"
  },
  {
    "Id": "HRL-F238.TA",
    "MayaId": "1233170",
    "Name": "Harel Sal (4A) TA Securities IL",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F238.TA",
    "TaseSymbol": "HRL.F238",
    "YahooId": "HRL-F238.TA",
    "EnglishName": "HRL.TA SECUR IL",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.ת\"א בטחונית",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.35,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4799.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "UBANK",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "other market sector",
    "AssetValue": null,
    "MonthYield": 23.2,
    "YearYield": 23.2,
    "Last12MonthYield": null,
    "ISIN": "IL0012331703"
  },
  {
    "Id": "HRL-F14.TA",
    "MayaId": "1148956",
    "Name": "Harel Sal (4A) TA SME60 IL",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F14.TA",
    "TaseSymbol": "HRL.F14",
    "YahooId": "HRL-F14.TA",
    "EnglishName": "HRL.TA-SME60 IL",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.תא SME60",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.015,
    "VariableFee": 0.2,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1147.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "UBANK",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Mid & Small Cap",
    "AssetValue": null,
    "MonthYield": 5.3,
    "YearYield": 5.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011489569"
  },
  {
    "Id": "HRL-F220.TA",
    "MayaId": "1161827",
    "Name": "Harel Sal (4A) TA Technology IL",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F220.TA",
    "TaseSymbol": "HRL.F220",
    "YahooId": "HRL-F220.TA",
    "EnglishName": "HRL.TA-TECH IL",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.תא טכנולוגי",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.45,
    "TrusteeFee": 0.018,
    "VariableFee": 0.2,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 256.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "technology",
    "AssetValue": null,
    "MonthYield": 14.6,
    "YearYield": 14.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011618274"
  },
  {
    "Id": "HRL-F235.TA",
    "MayaId": "1220391",
    "Name": "Harel Sal (4D) CME CF Bitcoin Reference Rate (BRRNY)",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F235.TA",
    "TaseSymbol": "HRL.F235",
    "YahooId": "HRL-F235.TA",
    "EnglishName": "HRL.CME BITCOIN",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.CME BITCOIN",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 7567.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "HAREL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Digital Assets",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 4.9,
    "YearYield": 4.9,
    "Last12MonthYield": null,
    "ISIN": "IL0012203910"
  },
  {
    "Id": "HRL-F28.TA",
    "MayaId": "1149053",
    "Name": "Harel Sal (4D) DAX",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F28.TA",
    "TaseSymbol": "HRL.F28",
    "YahooId": "HRL-F28.TA",
    "EnglishName": "HRL.DAX",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.DAX",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.02,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 8306.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Europe - developed markets",
    "AssetValue": null,
    "MonthYield": 0.4,
    "YearYield": 0.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011490534"
  },
  {
    "Id": "HRL-F64.TA",
    "MayaId": "1149228",
    "Name": "Harel Sal (4D) DJ Industrial Average",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F64.TA",
    "TaseSymbol": "HRL.F64",
    "YahooId": "HRL-F64.TA",
    "EnglishName": "HRL.DJ30",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.DJ30",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.45,
    "TrusteeFee": 0.02,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 18940.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": 0.8,
    "YearYield": 0.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011492282"
  },
  {
    "Id": "HRL-F65.TA",
    "MayaId": "1149244",
    "Name": "Harel Sal (4D) EURO STOXX 50",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F65.TA",
    "TaseSymbol": "HRL.F65",
    "YahooId": "HRL-F65.TA",
    "EnglishName": "HRL.EU STOXX50",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.EU STOXX50",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.45,
    "TrusteeFee": 0.02,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2857.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Europe - general",
    "AssetValue": null,
    "MonthYield": 1.0,
    "YearYield": 1.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011492449"
  },
  {
    "Id": "HRL-F288.TA",
    "MayaId": "1190859",
    "Name": "Harel Sal (4D) Index U.S Momentum",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F288.TA",
    "TaseSymbol": "HRL.F288",
    "YahooId": "HRL-F288.TA",
    "EnglishName": "HRL.LN MOMNT US",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.אינ מומארהב",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.005,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3156.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": 3.8,
    "YearYield": 3.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011908592"
  },
  {
    "Id": "HRL-F207.TA",
    "MayaId": "1150374",
    "Name": "Harel Sal (4D) ISE Cyber Security",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F207.TA",
    "TaseSymbol": "HRL.F207",
    "YahooId": "HRL-F207.TA",
    "EnglishName": "HRL.ISECYBER",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.ISECYBER",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.015,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2274.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Cyber Security",
    "AssetValue": null,
    "MonthYield": -3.5,
    "YearYield": -3.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011503740"
  },
  {
    "Id": "HRL-F73.TA",
    "MayaId": "1149335",
    "Name": "Harel Sal (4D) MSCI AC World",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F73.TA",
    "TaseSymbol": "HRL.F73",
    "YahooId": "HRL-F73.TA",
    "EnglishName": "HRL.MSCIACWORLD",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.MSCIACWORLD",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.55,
    "TrusteeFee": 0.02,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3745.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -0.5,
    "YearYield": -0.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011493355"
  },
  {
    "Id": "HRL-F72.TA",
    "MayaId": "1149301",
    "Name": "Harel Sal (4D) MSCI Emerging Markets",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F72.TA",
    "TaseSymbol": "HRL.F72",
    "YahooId": "HRL-F72.TA",
    "EnglishName": "HRL.MSCI EM",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.MSCI EM",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.015,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5639.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Global - emerging markets",
    "AssetValue": null,
    "MonthYield": 5.6,
    "YearYield": 5.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011493017"
  },
  {
    "Id": "HRL-F26.TA",
    "MayaId": "1149038",
    "Name": "Harel Sal (4D) NASDAQ 100",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F26.TA",
    "TaseSymbol": "HRL.F26",
    "YahooId": "HRL-F26.TA",
    "EnglishName": "HRL.NDX 100",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.NDX 100",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.01,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 8435.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": -1.9,
    "YearYield": -1.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011490385"
  },
  {
    "Id": "HRL-F25.TA",
    "MayaId": "1149020",
    "Name": "Harel Sal (4D) S&P 500",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F25.TA",
    "TaseSymbol": "HRL.F25",
    "YahooId": "HRL-F25.TA",
    "EnglishName": "HRL.SP500",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.SP500",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.008,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2535.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": -1.1,
    "YearYield": -1.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011490203"
  },
  {
    "Id": "HRL-F76.TA",
    "MayaId": "1149863",
    "Name": "Harel Sal (4D) S&P Consumer Staples",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F76.TA",
    "TaseSymbol": "HRL.F76",
    "YahooId": "HRL-F76.TA",
    "EnglishName": "HRL.CONSUMSTASP",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.צריכהבסיסSP",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3117.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Consumer Staples",
    "AssetValue": null,
    "MonthYield": 4.2,
    "YearYield": 4.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011498636"
  },
  {
    "Id": "HRL-F96.TA",
    "MayaId": "1150036",
    "Name": "Harel Sal (4D) S&P Energy",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F96.TA",
    "TaseSymbol": "HRL.F96",
    "YahooId": "HRL-F96.TA",
    "EnglishName": "HRL.SPENERGY",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.SPENERGY",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.3,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5979.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Energy",
    "AssetValue": null,
    "MonthYield": 4.4,
    "YearYield": 4.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011500365"
  },
  {
    "Id": "HRL-F75.TA",
    "MayaId": "1149855",
    "Name": "Harel Sal (4D) S&P Financial",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F75.TA",
    "TaseSymbol": "HRL.F75",
    "YahooId": "HRL-F75.TA",
    "EnglishName": "HRL.SPFINANCE",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.SPFINANCE",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.45,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2374.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Financial",
    "AssetValue": null,
    "MonthYield": -3.3,
    "YearYield": -3.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011498552"
  },
  {
    "Id": "HRL-F74.TA",
    "MayaId": "1149848",
    "Name": "Harel Sal (4D) S&P Health Care",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F74.TA",
    "TaseSymbol": "HRL.F74",
    "YahooId": "HRL-F74.TA",
    "EnglishName": "HRL.SPHEALTHCAR",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.SPHEALTHCAR",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.01,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5559.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Health Care",
    "AssetValue": null,
    "MonthYield": -1.7,
    "YearYield": -1.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011498487"
  },
  {
    "Id": "HRL-F68.TA",
    "MayaId": "1149285",
    "Name": "Harel Sal (4D) S&P Industrial",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F68.TA",
    "TaseSymbol": "HRL.F68",
    "YahooId": "HRL-F68.TA",
    "EnglishName": "HRL.SPINDUST",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.SPINDUST",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.02,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5937.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Industrials",
    "AssetValue": null,
    "MonthYield": 3.8,
    "YearYield": 3.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011492852"
  },
  {
    "Id": "HRL-F87.TA",
    "MayaId": "1149939",
    "Name": "Harel Sal (4D) S&P Technology",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F87.TA",
    "TaseSymbol": "HRL.F87",
    "YahooId": "HRL-F87.TA",
    "EnglishName": "HRL.SPTECH",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.SPTECH",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.01,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 9566.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Technology",
    "AssetValue": null,
    "MonthYield": -2.3,
    "YearYield": -2.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011499394"
  },
  {
    "Id": "HRL-F77.TA",
    "MayaId": "1149871",
    "Name": "Harel Sal (4D) STOXX Europe 600",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F77.TA",
    "TaseSymbol": "HRL.F77",
    "YahooId": "HRL-F77.TA",
    "EnglishName": "HRL.STOXX600",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.STOXX600",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.02,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2981.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Europe - general",
    "AssetValue": null,
    "MonthYield": 1.2,
    "YearYield": 1.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011498719"
  },
  {
    "Id": "HRL-F217.TA",
    "MayaId": "1167568",
    "Name": "Harel Sal (6A) 3 Time Leverage Nasdaq 100 Monthly Currency Hedged",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F217.TA",
    "TaseSymbol": "HRL.F217",
    "YahooId": "HRL-F217.TA",
    "EnglishName": "HRL.NDX1003TMM",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.NDX100פי3ממ",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 2.5,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 13170.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Leveraged",
    "SecondaryClassification": "Stocks Abroad",
    "AssetValue": null,
    "MonthYield": -3.3,
    "YearYield": -3.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011675688"
  },
  {
    "Id": "HRL-F216.TA",
    "MayaId": "1167576",
    "Name": "Harel Sal (6D) 2 Time Short Leverage Nasdaq 100 Monthly",
    "ShortName": "HAREL MUTUAL FUNDS LTD",
    "Symbol": "HRL-F216.TA",
    "TaseSymbol": "HRL.F216",
    "YahooId": "HRL-F216.TA",
    "EnglishName": "HRL.NDX100 S 2T",
    "EnglishLongName": "HAREL MUTUAL FUNDS LTD",
    "HebrewName": "הרל.NDX100חספי2",
    "HebrewLongName": "הראל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 1.75,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 866.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "HAREL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Leveraged",
    "SecondaryClassification": "Stocks Abroad",
    "AssetValue": null,
    "MonthYield": 2.0,
    "YearYield": 2.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011675761"
  },
  {
    "Id": "TASE:5103999",
    "MayaId": "5103999",
    "Name": "Harel Sapir Equity IL",
    "ShortName": "Harel Sapir Equity IL",
    "Symbol": "TASE:5103999",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (4B) Sapir Equity IL",
    "EnglishLongName": "Harel (4B) Sapir Equity IL",
    "HebrewName": "הראל ספיר מניות",
    "HebrewLongName": "הראל (4B) ספיר מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.42,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 98.3,
    "MonthYield": 8.69,
    "YearYield": 8.69,
    "Last12MonthYield": 91.66,
    "ISIN": "IL0051039993"
  },
  {
    "Id": "TASE:5111273",
    "MayaId": "5111273",
    "Name": "Harel Selected Stocks IL",
    "ShortName": "Harel Selected Stocks IL",
    "Symbol": "TASE:5111273",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (4B) Selected Stocks IL",
    "EnglishLongName": "Harel (4B) Selected Stocks IL",
    "HebrewName": "הראל נבחרת מניות",
    "HebrewLongName": "הראל (4B) נבחרת מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.98,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 918.3,
    "MonthYield": 7.4,
    "YearYield": 7.4,
    "Last12MonthYield": 81.27,
    "ISIN": "IL0051112733"
  },
  {
    "Id": "TASE:5107503",
    "MayaId": "5107503",
    "Name": "Harel Shekel Corp +10 IL",
    "ShortName": "Harel Shekel Corp +10 IL",
    "Symbol": "TASE:5107503",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (1A) Shekel Corporate + 10% IL",
    "EnglishLongName": "Harel (1A) Shekel Corporate + 10% IL",
    "HebrewName": "הראל קונצרני שקלי + 10%",
    "HebrewLongName": "הראל (1A) קונצרני שקלי + 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Shekel Corporate and Convertibles with Equity",
    "AssetValue": 94.8,
    "MonthYield": 1.28,
    "YearYield": 1.28,
    "Last12MonthYield": 11.06,
    "ISIN": "IL0051075039"
  },
  {
    "Id": "TASE:5116009",
    "MayaId": "5116009",
    "Name": "Harel Shekel Governmen IL",
    "ShortName": "Harel Shekel Governmen IL",
    "Symbol": "TASE:5116009",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (00) Shekel Government IL",
    "EnglishLongName": "Harel (00) Shekel Government IL",
    "HebrewName": "הראל שקלית ממשלתית",
    "HebrewLongName": "הראל (00) שקלית ממשלתית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.36,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Shekel Bonds - No Equity",
    "AssetValue": 83.0,
    "MonthYield": 0.7,
    "YearYield": 0.7,
    "Last12MonthYield": 7.41,
    "ISIN": "IL0051160096"
  },
  {
    "Id": "TASE:5116660",
    "MayaId": "5116660",
    "Name": "Harel Shenhav Bonds IL",
    "ShortName": "Harel Shenhav Bonds IL",
    "Symbol": "TASE:5116660",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (2B) Shenhav Bonds IL",
    "EnglishLongName": "Harel (2B) Shenhav Bonds IL",
    "HebrewName": "הראל שנהב אג\"ח",
    "HebrewLongName": "הראל (2B) שנהב אג\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.28,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.12,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 15% Equity",
    "AssetValue": 59.2,
    "MonthYield": 0.54,
    "YearYield": 0.54,
    "Last12MonthYield": 5.55,
    "ISIN": "IL0051166606"
  },
  {
    "Id": "TASE:5111356",
    "MayaId": "5111356",
    "Name": "Harel Shk Rat Bo no Eq IL",
    "ShortName": "Harel Shk Rat Bo no Eq IL",
    "Symbol": "TASE:5111356",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (0A) Shekels Rated Bonds Without Equity IL",
    "EnglishLongName": "Harel (0A) Shekels Rated Bonds Without Equity IL",
    "HebrewName": "הראל שקלים מדורגות ללא מנ",
    "HebrewLongName": "הראל (0A) שקלים מדורגות ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.35,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.23,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Shekel Corporate and Convertibles - No Equity",
    "AssetValue": 37.3,
    "MonthYield": 0.66,
    "YearYield": 0.66,
    "Last12MonthYield": 4.85,
    "ISIN": "IL0051113566"
  },
  {
    "Id": "TASE:5137815",
    "MayaId": "5137815",
    "Name": "Harel Shkl Mny Mrkt IL Ks",
    "ShortName": "Harel Shkl Mny Mrkt IL-Ks",
    "Symbol": "TASE:5137815",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (00) Shekels Money Market IL - Kosher",
    "EnglishLongName": "Harel (00) Shekels Money Market IL - Kosher",
    "HebrewName": "הראל כספית שקלית כשרה",
    "HebrewLongName": "הראל (00) כספית שקלית כשרה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.14,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 2509.5,
    "MonthYield": 0.22,
    "YearYield": 0.22,
    "Last12MonthYield": 4.59,
    "ISIN": "IL0051378151"
  },
  {
    "Id": "TASE:5128897",
    "MayaId": "5128897",
    "Name": "Harel Shoh Sol Bo noEq IL",
    "ShortName": "Harel Shoh Sol Bo noEq IL",
    "Symbol": "TASE:5128897",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (00) Shoham Solid Bonds Without Equity IL",
    "EnglishLongName": "Harel (00) Shoham Solid Bonds Without Equity IL",
    "HebrewName": "הראל שהם אגח סוליד ללא מנ",
    "HebrewLongName": "הראל (00) שהם אג\"ח סולידי ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.2,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 65.4,
    "MonthYield": 0.45,
    "YearYield": 0.45,
    "Last12MonthYield": 6.32,
    "ISIN": "IL0051288970"
  },
  {
    "Id": "TASE:5111992",
    "MayaId": "5111992",
    "Name": "Harel Solid Assets IL",
    "ShortName": "Harel Solid Assets IL",
    "Symbol": "TASE:5111992",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (1A) Solid Assets IL",
    "EnglishLongName": "Harel (1A) Solid Assets IL",
    "HebrewName": "הראל נכסים סולידיים",
    "HebrewLongName": "הראל (1A) נכסים סולידיים",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.38,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.22,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 222.3,
    "MonthYield": 0.98,
    "YearYield": 0.98,
    "Last12MonthYield": 9.08,
    "ISIN": "IL0051119928"
  },
  {
    "Id": "TASE:5117239",
    "MayaId": "5117239",
    "Name": "Harel Solid Bon Po+10% IL",
    "ShortName": "Harel Solid Bon Po+10% IL",
    "Symbol": "TASE:5117239",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (1B) Solid Bonds Portfolio + 10% IL",
    "EnglishLongName": "Harel (1B) Solid Bonds Portfolio + 10% IL",
    "HebrewName": "הראל תיק אג\"ח סולידי+10%",
    "HebrewLongName": "הראל (1B) תיק אג\"ח סולידי + 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.55,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.38,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 27.8,
    "MonthYield": 1.27,
    "YearYield": 1.27,
    "Last12MonthYield": 10.62,
    "ISIN": "IL0051172398"
  },
  {
    "Id": "TASE:5115894",
    "MayaId": "5115894",
    "Name": "Harel Solid Prt No Stk IL",
    "ShortName": "Harel Solid Prt No Stk IL",
    "Symbol": "TASE:5115894",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (0B) Solid Portfolio Without Stocks IL",
    "EnglishLongName": "Harel (0B) Solid Portfolio Without Stocks IL",
    "HebrewName": "הראל תיק סולידי ללא מניות",
    "HebrewLongName": "הראל (0B) תיק סולידי ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.68,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.22,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 32.0,
    "MonthYield": 0.44,
    "YearYield": 0.44,
    "Last12MonthYield": 6.05,
    "ISIN": "IL0051158942"
  },
  {
    "Id": "TASE:5110051",
    "MayaId": "5110051",
    "Name": "Harel TA Midcap150 IL",
    "ShortName": "Harel TA-Midcap150 IL",
    "Symbol": "TASE:5110051",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (4B) TA-Midcap150 IL",
    "EnglishLongName": "Harel (4B) TA-Midcap150 IL",
    "HebrewName": "הראל ת\"א-Midcap150",
    "HebrewLongName": "הראל (4B) ת\"א-Midcap150",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.95,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.58,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 96.4,
    "MonthYield": 8.86,
    "YearYield": 8.86,
    "Last12MonthYield": 72.62,
    "ISIN": "IL0051100514"
  },
  {
    "Id": "TASE:5106422",
    "MayaId": "5106422",
    "Name": "Harel Team 80/20 IL",
    "ShortName": "Harel Team 80/20 IL",
    "Symbol": "TASE:5106422",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (2B) Team 80/20 IL",
    "EnglishLongName": "Harel (2B) Team 80/20 IL",
    "HebrewName": "הראל נבחרת 20/80",
    "HebrewLongName": "הראל (2B) נבחרת 20/80",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 71.8,
    "MonthYield": 1.58,
    "YearYield": 1.58,
    "Last12MonthYield": 11.28,
    "ISIN": "IL0051064223"
  },
  {
    "Id": "TASE:5104823",
    "MayaId": "5104823",
    "Name": "Harel Team 90/10 IL",
    "ShortName": "Harel Team 90/10 IL",
    "Symbol": "TASE:5104823",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (1B) Team 90/10 IL",
    "EnglishLongName": "Harel (1B) Team 90/10 IL",
    "HebrewName": "הראל נבחרת 10/90",
    "HebrewLongName": "הראל (1B) נבחרת 10/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 250.1,
    "MonthYield": 1.11,
    "YearYield": 1.11,
    "Last12MonthYield": 10.74,
    "ISIN": "IL0051048234"
  },
  {
    "Id": "TASE:5138888",
    "MayaId": "5138888",
    "Name": "Harel Track G.E up30 Inte",
    "ShortName": "Harel Track G.E up30 Inte",
    "Symbol": "TASE:5138888",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel(4B)Tracking Global Equity Portfolio- International Bank Up to 30% Currency",
    "EnglishLongName": "Harel(4B)Tracking Global Equity Portfolio- International Bank Up to 30% Currency",
    "HebrewName": "הראל עוק מנחו עד30 בינלאו",
    "HebrewLongName": "הראל (4B) עוקבת תיק מניות חו\"ל - הבנק הבינלאומי עד 30% מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.29,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 17.8,
    "MonthYield": 3.0,
    "YearYield": 3.0,
    "Last12MonthYield": 16.0,
    "ISIN": "IL0051388887"
  },
  {
    "Id": "TASE:5124698",
    "MayaId": "5124698",
    "Name": "Harel Up3Y Solid Bo Po IL",
    "ShortName": "Harel Up3Y Solid Bo Po IL",
    "Symbol": "TASE:5124698",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (0A) Up to 3 Years Solid Bonds Portfolio IL",
    "EnglishLongName": "Harel (0A) Up to 3 Years Solid Bonds Portfolio IL",
    "HebrewName": "הראל תיק אגח סולידי עד3שנ",
    "HebrewLongName": "הראל (0A) תיק אג\"ח סולידי עד שלוש שנים",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.49,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.14,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 176.7,
    "MonthYield": 0.34,
    "YearYield": 0.34,
    "Last12MonthYield": 5.44,
    "ISIN": "IL0051246986"
  },
  {
    "Id": "TASE:5231055",
    "MayaId": "5231055",
    "Name": "HarelBond Team IL",
    "ShortName": "HarelBond Team IL",
    "Symbol": "TASE:5231055",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (0B)(!) Bond Team IL",
    "EnglishLongName": "Harel (0B)(!) Bond Team IL",
    "HebrewName": "הראל נבחרת אג\"ח",
    "HebrewLongName": "הראל (0B)(!) נבחרת אג\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.58,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.21,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 101.2,
    "MonthYield": 0.65,
    "YearYield": 0.65,
    "Last12MonthYield": 6.37,
    "ISIN": "IL0052310559"
  },
  {
    "Id": "TASE:5128194",
    "MayaId": "5128194",
    "Name": "HarelHtf MS 90Bon 10Eq IL",
    "ShortName": "HarelHtf MS 90Bon 10Eq IL",
    "Symbol": "TASE:5128194",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (2A) Composite Israel Bonds (90%) and Equity (10%) Monthly IL",
    "EnglishLongName": "Harel Htf (2A) Composite Israel Bonds (90%) and Equity (10%) Monthly IL",
    "HebrewName": "הראל מחקה מש 90אגח 10מנ",
    "HebrewLongName": "הראל מחקה (2A) משולבת אג\"ח ישראל (90%) ומניות (10%) חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.36,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Composite Bonds",
    "SecondaryClassification": "up to 10% Equity",
    "AssetValue": 28.9,
    "MonthYield": 1.01,
    "YearYield": 1.01,
    "Last12MonthYield": 10.1,
    "ISIN": "IL0051281942"
  },
  {
    "Id": "TASE:5128210",
    "MayaId": "5128210",
    "Name": "HarelHtf MS85Bon15EqMM IL",
    "ShortName": "HarelHtf MS85Bon15EqMM IL",
    "Symbol": "TASE:5128210",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (2A) Composite Is.Bnd (85%) Gl.Equity (15%) Monthly Currency-Hedged IL",
    "EnglishLongName": "Harel Htf (2A) Composite Is.Bnd (85%) Gl.Equity (15%) Monthly Currency-Hedged IL",
    "HebrewName": "הראל מחקה מש 85אג 15מנ ממ",
    "HebrewLongName": "הראל מחקה (2A) משולבת אג\"ח ישראל (85%) מניות ישראל-חול (15%) חודשי מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.36,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Composite Bonds",
    "SecondaryClassification": "up to 20% Equity",
    "AssetValue": 49.0,
    "MonthYield": 1.19,
    "YearYield": 1.19,
    "Last12MonthYield": 10.61,
    "ISIN": "IL0051282106"
  },
  {
    "Id": "TASE:5129762",
    "MayaId": "5129762",
    "Name": "HarelHtf SPConsumerSta MM",
    "ShortName": "HarelHtf SPConsumerSta MM",
    "Symbol": "TASE:5129762",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel Htf (4A) S&P Consumer Staples Currency-Hedged",
    "EnglishLongName": "Harel Htf (4A) S&P Consumer Staples Currency-Hedged",
    "HebrewName": "הראל מחקה צריכה בסי SP ממ",
    "HebrewLongName": "הראל מחקה (4A)יS&P Consumer Staples מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.59,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 16.9,
    "MonthYield": 6.01,
    "YearYield": 6.01,
    "Last12MonthYield": 4.91,
    "ISIN": "IL0051297625"
  },
  {
    "Id": "HICN-M.TA",
    "MayaId": "1169945",
    "Name": "HIGHCON SYSTM M",
    "ShortName": "HIGHCON SYSTEMS LTD",
    "Symbol": "HICN-M.TA",
    "TaseSymbol": "HICN-M",
    "YahooId": "HICN-M.TA",
    "EnglishName": "HIGHCON SYSTM-M",
    "EnglishLongName": "HIGHCON SYSTEMS LTD",
    "HebrewName": "הייקון מערכות-ש",
    "HebrewLongName": "הייקון מערכות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4.5,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Investment & Holdings",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.0,
    "YearYield": 0.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011699456"
  },
  {
    "Id": "HLAN.TA",
    "MayaId": "1084698",
    "Name": "HILAN",
    "ShortName": "HILAN LTD.",
    "Symbol": "HLAN.TA",
    "TaseSymbol": "HLAN",
    "YahooId": "HLAN.TA",
    "EnglishName": "HILAN",
    "EnglishLongName": "HILAN LTD.",
    "HebrewName": "חילן",
    "HebrewLongName": "חילן בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 24890.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -2.5,
    "YearYield": -2.5,
    "Last12MonthYield": null,
    "ISIN": "IL0010846983"
  },
  {
    "Id": "HIPR.TA",
    "MayaId": "1184985",
    "Name": "HIPER GLOBAL",
    "ShortName": "HIPER GLOBAL LTD",
    "Symbol": "HIPR.TA",
    "TaseSymbol": "HIPR",
    "YahooId": "HIPR.TA",
    "EnglishName": "HIPER GLOBAL",
    "EnglishLongName": "HIPER GLOBAL LTD",
    "HebrewName": "הייפר גלובל",
    "HebrewLongName": "הייפר גלובל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2423.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 8.3,
    "YearYield": 8.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011849853"
  },
  {
    "Id": "HRON.TA",
    "MayaId": "150011",
    "Name": "HIRON",
    "ShortName": "HIRON-TRADE INVESTMENTS & INDUSTRIAL BUILDINGS LTD.",
    "Symbol": "HRON.TA",
    "TaseSymbol": "HRON",
    "YahooId": "HRON.TA",
    "EnglishName": "HIRON",
    "EnglishLongName": "HIRON-TRADE INVESTMENTS & INDUSTRIAL BUILDINGS LTD.",
    "HebrewName": "חירון",
    "HebrewLongName": "חירון-מסחר השקעות ומבנה תעשיה בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 263900.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.5,
    "YearYield": 0.5,
    "Last12MonthYield": null,
    "ISIN": "IL0001500110"
  },
  {
    "Id": "HOD.TA",
    "MayaId": "351015",
    "Name": "HOD",
    "ShortName": "HOD-ASSAF INDUSTRIES LTD.",
    "Symbol": "HOD.TA",
    "TaseSymbol": "HOD",
    "YahooId": "HOD.TA",
    "EnglishName": "HOD",
    "EnglishLongName": "HOD-ASSAF INDUSTRIES LTD.",
    "HebrewName": "חד",
    "HebrewLongName": "חד-אסף תעשיות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4530.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 5.1,
    "YearYield": 5.1,
    "Last12MonthYield": null,
    "ISIN": "IL0003510158"
  },
  {
    "Id": "HLMS.TA",
    "MayaId": "1142587",
    "Name": "HOLMES PLACE",
    "ShortName": "HOLMES PLACE INTERNATIONAL LTD",
    "Symbol": "HLMS.TA",
    "TaseSymbol": "HLMS",
    "YahooId": "HLMS.TA",
    "EnglishName": "HOLMES PLACE",
    "EnglishLongName": "HOLMES PLACE INTERNATIONAL LTD",
    "HebrewName": "הולמס פלייס",
    "HebrewLongName": "הולמס פלייס אינטרנשיונל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 755.6,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 11.7,
    "YearYield": 11.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011425878"
  },
  {
    "Id": "HMGS.TA",
    "MayaId": "1172204",
    "Name": "HOMEBIOGAS",
    "ShortName": "HOMEBIOGAS LTD",
    "Symbol": "HMGS.TA",
    "TaseSymbol": "HMGS",
    "YahooId": "HMGS.TA",
    "EnglishName": "HOMEBIOGAS",
    "EnglishLongName": "HOMEBIOGAS LTD",
    "HebrewName": "הום ביוגז",
    "HebrewLongName": "הום ביוגז בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 124.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -6.9,
    "YearYield": -6.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011722043"
  },
  {
    "Id": "TASE:5137252",
    "MayaId": "5137252",
    "Name": "Horizon (!) Glob $ Bonds",
    "ShortName": "Horizon (!) Glob $ Bonds",
    "Symbol": "TASE:5137252",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Horizon (oD)(!) Global Dolar Bonds",
    "EnglishLongName": "Horizon (oD)(!) Global Dolar Bonds",
    "HebrewName": "הורייזן (!) אגח $ בינלאומ",
    "HebrewLongName": "הורייזן (0D)(!) אג\"ח דולר בינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.98,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.1,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "Dollar Bond",
    "AssetValue": 55.5,
    "MonthYield": -0.55,
    "YearYield": -0.55,
    "Last12MonthYield": -6.52,
    "ISIN": "IL0051372527"
  },
  {
    "Id": "TASE:5139480",
    "MayaId": "5139480",
    "Name": "Horizon (1B) 90/10 IL",
    "ShortName": "Horizon (1B) 90/10 IL",
    "Symbol": "TASE:5139480",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Horizon (1B) 90/10 IL",
    "EnglishLongName": "Horizon (1B) 90/10 IL",
    "HebrewName": "הורייזן (1B)י 10/90",
    "HebrewLongName": "הורייזן (1B)י 10/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.9,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.52,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 14.6,
    "MonthYield": 1.03,
    "YearYield": 1.03,
    "Last12MonthYield": 4.33,
    "ISIN": "IL0051394802"
  },
  {
    "Id": "TASE:5118948",
    "MayaId": "5118948",
    "Name": "Horizon (2B) 30/70 IL",
    "ShortName": "Horizon (2B) 30/70 IL",
    "Symbol": "TASE:5118948",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Horizon (2B) 30/70 IL",
    "EnglishLongName": "Horizon (2B) 30/70 IL",
    "HebrewName": "הורייזן (2B)י 30/70",
    "HebrewLongName": "הורייזן (2B)י 30/70",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.9,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.68,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 389.6,
    "MonthYield": 2.05,
    "YearYield": 2.05,
    "Last12MonthYield": 9.71,
    "ISIN": "IL0051189483"
  },
  {
    "Id": "TASE:5118955",
    "MayaId": "5118955",
    "Name": "Horizon (2B) 80/20 IL",
    "ShortName": "Horizon (2B) 80/20 IL",
    "Symbol": "TASE:5118955",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Horizon (2B) 80/20 IL",
    "EnglishLongName": "Horizon (2B) 80/20 IL",
    "HebrewName": "הורייזן (2B)י 20/80",
    "HebrewLongName": "הורייזן (2B)י 20/80",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.9,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.58,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 401.3,
    "MonthYield": 1.74,
    "YearYield": 1.74,
    "Last12MonthYield": 6.81,
    "ISIN": "IL0051189558"
  },
  {
    "Id": "TASE:5138730",
    "MayaId": "5138730",
    "Name": "Horizon (4D) Strategies",
    "ShortName": "Horizon (4D) Strategies",
    "Symbol": "TASE:5138730",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Horizon (4D) Strategies",
    "EnglishLongName": "Horizon (4D) Strategies",
    "HebrewName": "הורייזן (4D) אסטרטגיות",
    "HebrewLongName": "הורייזן (4D) אסטרטגיות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.5,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.8,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Leveraged and Strategic",
    "SecondaryClassification": "Strategic (not leveraged)",
    "AssetValue": 46.9,
    "MonthYield": 1.88,
    "YearYield": 1.88,
    "Last12MonthYield": 9.03,
    "ISIN": "IL0051387301"
  },
  {
    "Id": "TASE:5139464",
    "MayaId": "5139464",
    "Name": "Horizon Bnds No Stocks IL",
    "ShortName": "Horizon Bnds No Stocks IL",
    "Symbol": "TASE:5139464",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Horizon (0B) Bonds Without Stocks IL",
    "EnglishLongName": "Horizon (0B) Bonds Without Stocks IL",
    "HebrewName": "הורייזן אג\"ח ללא מניות",
    "HebrewLongName": "הורייזן (0B) אג\"ח ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.9,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.51,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 23.2,
    "MonthYield": 0.81,
    "YearYield": 0.81,
    "Last12MonthYield": 3.73,
    "ISIN": "IL0051394646"
  },
  {
    "Id": "TASE:5139498",
    "MayaId": "5139498",
    "Name": "Horizon Cor Bnd No Stk IL",
    "ShortName": "Horizon Cor Bnd No Stk IL",
    "Symbol": "TASE:5139498",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Horizon (0B)(!) Corporate Bonds Without Stocks IL",
    "EnglishLongName": "Horizon (0B)(!) Corporate Bonds Without Stocks IL",
    "HebrewName": "הורייזן אגח חבר ללא מניות",
    "HebrewLongName": "הורייזן (0B)(!) אג\"ח חברות ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.9,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.46,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 26.2,
    "MonthYield": 0.6,
    "YearYield": 0.6,
    "Last12MonthYield": 2.07,
    "ISIN": "IL0051394984"
  },
  {
    "Id": "TASE:5137245",
    "MayaId": "5137245",
    "Name": "Horizon Glob RBonds D in$",
    "ShortName": "Horizon Glob RBonds-D in$",
    "Symbol": "TASE:5137245",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Horizon (oD) Global Rated Bonds - Denominated in Dolar",
    "EnglishLongName": "Horizon (oD) Global Rated Bonds - Denominated in Dolar",
    "HebrewName": "הורייזן אגח ח מדרג נקוב $",
    "HebrewLongName": "הורייזן (0D) אג\"ח חו\"ל מדורג - נקובת דולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.16,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Bonds",
    "AssetValue": 41.2,
    "MonthYield": -0.28,
    "YearYield": -0.28,
    "Last12MonthYield": -6.13,
    "ISIN": "IL0051372451"
  },
  {
    "Id": "TASE:5131974",
    "MayaId": "5131974",
    "Name": "Horizon Globa FutureTech",
    "ShortName": "Horizon Globa FutureTech",
    "Symbol": "TASE:5131974",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Horizon (4D) Global Future Tech",
    "EnglishLongName": "Horizon (4D) Global Future Tech",
    "HebrewName": "הורייזן פיוצ'ר טק גלובל",
    "HebrewLongName": "הורייזן (4D) פיוצ'ר טק גלובלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.6,
    "TrusteeFee": 0.045,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.08,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks by Sectors - Foreign",
    "AssetValue": 32.5,
    "MonthYield": -0.97,
    "YearYield": -0.97,
    "Last12MonthYield": 2.61,
    "ISIN": "IL0051319742"
  },
  {
    "Id": "TASE:5110341",
    "MayaId": "5110341",
    "Name": "HRL $ MONY MRKT",
    "ShortName": "HRL $ MONY MRKT",
    "Symbol": "TASE:5110341",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (0D) $ Money Market",
    "EnglishLongName": "Harel (0D) $ Money Market",
    "HebrewName": "הראל כספית נקובה ב-$",
    "HebrewLongName": "הראל (0D) כספית נקובה ב-$",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.19,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "FX Money Market with Corporate",
    "AssetValue": 4110.5,
    "MonthYield": -0.92,
    "YearYield": -0.92,
    "Last12MonthYield": -9.27,
    "ISIN": "IL0051103419"
  },
  {
    "Id": "TASE:5102371",
    "MayaId": "5102371",
    "Name": "HRL $BOND INTER",
    "ShortName": "HRL $BOND INTER",
    "Symbol": "TASE:5102371",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (0D) Dollar Bonds International",
    "EnglishLongName": "Harel (0D) Dollar Bonds International",
    "HebrewName": "הראל אג\"ח דולר בינלאומי",
    "HebrewLongName": "הראל (0D) אג\"ח דולר בינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.76,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.06,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "Dollar Bond",
    "AssetValue": 353.2,
    "MonthYield": -1.07,
    "YearYield": -1.07,
    "Last12MonthYield": -6.8,
    "ISIN": "IL0051023716"
  },
  {
    "Id": "TASE:5110531",
    "MayaId": "5110531",
    "Name": "HRL $GLOB EQUIT",
    "ShortName": "HRL $GLOB EQUIT",
    "Symbol": "TASE:5110531",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (4D) Global Equities - Denominated in Dollar",
    "EnglishLongName": "Harel (4D) Global Equities - Denominated in Dollar",
    "HebrewName": "הראל מניות חו\"ל-נקובה $",
    "HebrewLongName": "הראל (4D) מניות חו\"ל - נקובה $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.81,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.53,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 37.3,
    "MonthYield": -2.26,
    "YearYield": -2.26,
    "Last12MonthYield": 13.56,
    "ISIN": "IL0051105315"
  },
  {
    "Id": "TASE:5127808",
    "MayaId": "5127808",
    "Name": "HRL $MON INTRST",
    "ShortName": "HRL $MON INTRST",
    "Symbol": "TASE:5127808",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (0D) Dollar Linked Money Market Interest Trend",
    "EnglishLongName": "Harel (0D) Dollar Linked Money Market Interest Trend",
    "HebrewName": "הראל כספית דולר מגמת ריבי",
    "HebrewLongName": "הראל (0D) כספית דולרית מגמת ריבית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.17,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "FX Money Market with Corporate",
    "AssetValue": 598.7,
    "MonthYield": -1.23,
    "YearYield": -1.23,
    "Last12MonthYield": -9.67,
    "ISIN": "IL0051278088"
  },
  {
    "Id": "TASE:5113782",
    "MayaId": "5113782",
    "Name": "HRL BOND +10% $",
    "ShortName": "HRL BOND +10% $",
    "Symbol": "TASE:5113782",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "$ Harel (1D)(!) Bond + 10% - Foreign Fund of Funds Denominated in",
    "EnglishLongName": "$ Harel (1D)(!) Bond + 10% - Foreign Fund of Funds Denominated in",
    "HebrewName": "הראל 1D ! בונד +10% $",
    "HebrewLongName": "הראל (1D)(!) בונד + 10% - נקוב $ אגד חוץ",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.87,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.06,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Fund of Funds",
    "SecondaryClassification": "Foreign Fund of Funds",
    "AssetValue": 6.1,
    "MonthYield": -0.68,
    "YearYield": -0.68,
    "Last12MonthYield": -7.31,
    "ISIN": "IL0051137821"
  },
  {
    "Id": "TASE:5111414",
    "MayaId": "5111414",
    "Name": "HRL CHUL US",
    "ShortName": "HRL CHUL US",
    "Symbol": "TASE:5111414",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "HAREL (4D) CHUL US",
    "EnglishLongName": "HAREL (4D) CHUL US",
    "HebrewName": "הראל 4D חו\"ל US",
    "HebrewLongName": "הראל (4D) חו\"ל US",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.8,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.73,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Geographical stocks",
    "AssetValue": 14.1,
    "MonthYield": -1.74,
    "YearYield": -1.74,
    "Last12MonthYield": -13.47,
    "ISIN": "IL0051114143"
  },
  {
    "Id": "TASE:5102652",
    "MayaId": "5102652",
    "Name": "HRL ERO 30%CRNC",
    "ShortName": "HRL ERO 30%CRNC",
    "Symbol": "TASE:5102652",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (4B) Europe Up to 30% Currency",
    "EnglishLongName": "Harel (4B) Europe Up to 30% Currency",
    "HebrewName": "הראל אירופה עד 30 מטח",
    "HebrewLongName": "הראל (4B) אירופה עד 30% מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.15,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.97,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Geographical stocks",
    "AssetValue": 6.5,
    "MonthYield": 1.95,
    "YearYield": 1.95,
    "Last12MonthYield": 10.06,
    "ISIN": "IL0051026529"
  },
  {
    "Id": "TASE:5106885",
    "MayaId": "5106885",
    "Name": "HRL GLOBL EQUIT",
    "ShortName": "HRL GLOBL EQUIT",
    "Symbol": "TASE:5106885",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (4D) Global Equity",
    "EnglishLongName": "Harel (4D) Global Equity",
    "HebrewName": "הראל 4D מניות חו\"ל",
    "HebrewLongName": "הראל (4D) מניות חו\"ל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.95,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.42,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 100.5,
    "MonthYield": -1.68,
    "YearYield": -1.68,
    "Last12MonthYield": -11.74,
    "ISIN": "IL0051068851"
  },
  {
    "Id": "TASE:5117130",
    "MayaId": "5117130",
    "Name": "HRL INT BND 20%",
    "ShortName": "HRL INT BND 20%",
    "Symbol": "TASE:5117130",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (0B) International Bonds Up to 20% Currency",
    "EnglishLongName": "Harel (0B) International Bonds Up to 20% Currency",
    "HebrewName": "הראל אגח בינלאומי עד20מטח",
    "HebrewLongName": "הראל (0B) אג\"ח בינלאומי עד 20% מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.78,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.18,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX-Protected Bonds",
    "AssetValue": 90.7,
    "MonthYield": 0.17,
    "YearYield": 0.17,
    "Last12MonthYield": 5.71,
    "ISIN": "IL0051171309"
  },
  {
    "Id": "TASE:5231097",
    "MayaId": "5231097",
    "Name": "HRL KASPIT DOLR",
    "ShortName": "HRL KASPIT DOLR",
    "Symbol": "TASE:5231097",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "HAREL (0D) KASPIT DOLARIT",
    "EnglishLongName": "HAREL (0D) KASPIT DOLARIT",
    "HebrewName": "הראל 0D כספית דולרית",
    "HebrewLongName": "הראל (0D) כספית דולרית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.78,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.17,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "FX Money Market with Corporate",
    "AssetValue": 39.2,
    "MonthYield": -1.25,
    "YearYield": -1.25,
    "Last12MonthYield": -10.16,
    "ISIN": "IL0052310971"
  },
  {
    "Id": "TASE:5122114",
    "MayaId": "5122114",
    "Name": "HRL LESHEM",
    "ShortName": "HRL LESHEM",
    "Symbol": "TASE:5122114",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (4D) Leshem",
    "EnglishLongName": "Harel (4D) Leshem",
    "HebrewName": "הראל 4D לשם",
    "HebrewLongName": "הראל (4D) לשם",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.12,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 97.4,
    "MonthYield": 2.17,
    "YearYield": 2.17,
    "Last12MonthYield": 15.46,
    "ISIN": "IL0051221146"
  },
  {
    "Id": "TASE:5100169",
    "MayaId": "5100169",
    "Name": "HRL ODEM",
    "ShortName": "HRL ODEM",
    "Symbol": "TASE:5100169",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (4D) Odem",
    "EnglishLongName": "Harel (4D) Odem",
    "HebrewName": "הראל 4D אודם",
    "HebrewLongName": "הראל (4D) אודם",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.19,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.79,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 47.1,
    "MonthYield": 8.69,
    "YearYield": 8.69,
    "Last12MonthYield": 70.5,
    "ISIN": "IL0051001696"
  },
  {
    "Id": "TASE:5100771",
    "MayaId": "5100771",
    "Name": "HRL SCT 30% CRN",
    "ShortName": "HRL SCT 30% CRN",
    "Symbol": "TASE:5100771",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Harel (4B) Global Sectors Up to 30% Currency",
    "EnglishLongName": "Harel (4B) Global Sectors Up to 30% Currency",
    "HebrewName": "הראל סקטור עולמי עד30מטח",
    "HebrewLongName": "הראל (4B) סקטורים עולמי עד 30% מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.17,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.77,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 45.0,
    "MonthYield": -0.38,
    "YearYield": -0.38,
    "Last12MonthYield": -2.46,
    "ISIN": "IL0051007719"
  },
  {
    "Id": "TASE:5111398",
    "MayaId": "5111398",
    "Name": "HRL USA EQUITY",
    "ShortName": "HRL USA EQUITY",
    "Symbol": "TASE:5111398",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "HAREL (4D) US EQUITY – Mutual Fund For Foreign Residents",
    "EnglishLongName": "HAREL (4D) US EQUITY – Mutual Fund For Foreign Residents",
    "HebrewName": "הראל US EQUITY 4D ת.חוץ",
    "HebrewLongName": "HAREL (4D) US EQUITY - קרן נאמנות לתושבי חוץ",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.92,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.38,
    "Sector": "",
    "Industry": "",
    "ManagerName": "HAREL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "For Foreign Residents Only",
    "SecondaryClassification": "",
    "AssetValue": 7.6,
    "MonthYield": -0.79,
    "YearYield": -0.79,
    "Last12MonthYield": -5.05,
    "ISIN": "IL0051113988"
  },
  {
    "Id": "HUMX-M.TA",
    "MayaId": "1170000",
    "Name": "HUMAN XT M",
    "ShortName": "HUMAN XTENSIONS LTD",
    "Symbol": "HUMX-M.TA",
    "TaseSymbol": "HUMX-M",
    "YahooId": "HUMX-M.TA",
    "EnglishName": "HUMAN XT-M",
    "EnglishLongName": "HUMAN XTENSIONS LTD",
    "HebrewName": "יומן אקסטנשנס-ש",
    "HebrewLongName": "יומן אקסטנשנס בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 18.3,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Investment & Holdings",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 26.2,
    "YearYield": 26.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011700007"
  },
  {
    "Id": "TASE:5114632",
    "MayaId": "5114632",
    "Name": "I.B.I GOVERNMENT +10%",
    "ShortName": "I.B.I GOVERNMENT +10%",
    "Symbol": "TASE:5114632",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (1A) GOVERNMENT +10% IL",
    "EnglishLongName": "I.B.I. (1A) GOVERNMENT +10% IL",
    "HebrewName": "איביאי מדינה +10%",
    "HebrewLongName": "אי.בי.אי. (1A) מדינה +10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.58,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.38,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - up to 10% Equity",
    "AssetValue": 582.0,
    "MonthYield": 1.2,
    "YearYield": 1.2,
    "Last12MonthYield": 10.1,
    "ISIN": "IL0051146327"
  },
  {
    "Id": "TASE:5122502",
    "MayaId": "5122502",
    "Name": "I.B.I. 70/30",
    "ShortName": "I.B.I. 70/30",
    "Symbol": "TASE:5122502",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (2C) 70/30 IL",
    "EnglishLongName": "I.B.I. (2C) 70/30 IL",
    "HebrewName": "איביאי 30/70",
    "HebrewLongName": "אי.בי.אי. (2C)י 30/70",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.66,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 949.3,
    "MonthYield": 2.29,
    "YearYield": 2.29,
    "Last12MonthYield": 19.1,
    "ISIN": "IL0051225022"
  },
  {
    "Id": "TASE:5122494",
    "MayaId": "5122494",
    "Name": "I.B.I. 80/20",
    "ShortName": "I.B.I. 80/20",
    "Symbol": "TASE:5122494",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (2B) 80/20 IL",
    "EnglishLongName": "I.B.I. (2B) 80/20 IL",
    "HebrewName": "איביאי 20/80",
    "HebrewLongName": "אי.בי.אי. (2B)י 20/80",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.55,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 237.7,
    "MonthYield": 1.98,
    "YearYield": 1.98,
    "Last12MonthYield": 15.99,
    "ISIN": "IL0051224942"
  },
  {
    "Id": "TASE:5119417",
    "MayaId": "5119417",
    "Name": "I.B.I. 85/15",
    "ShortName": "I.B.I. 85/15",
    "Symbol": "TASE:5119417",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (2B) 85/15 IL",
    "EnglishLongName": "I.B.I. (2B) 85/15 IL",
    "HebrewName": "איביאי 15/85",
    "HebrewLongName": "אי.בי.אי. (2B) י 15/85",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.44,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 15% Equity",
    "AssetValue": 402.1,
    "MonthYield": 1.31,
    "YearYield": 1.31,
    "Last12MonthYield": 12.74,
    "ISIN": "IL0051194178"
  },
  {
    "Id": "TASE:5118310",
    "MayaId": "5118310",
    "Name": "I.B.I. 90/10",
    "ShortName": "I.B.I. 90/10",
    "Symbol": "TASE:5118310",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (1A) 90/10 IL",
    "EnglishLongName": "I.B.I. (1A) 90/10 IL",
    "HebrewName": "איביאי 10/90",
    "HebrewLongName": "אי.בי.אי. (1A)י 10/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.38,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 265.7,
    "MonthYield": 1.14,
    "YearYield": 1.14,
    "Last12MonthYield": 10.23,
    "ISIN": "IL0051183106"
  },
  {
    "Id": "TASE:5130265",
    "MayaId": "5130265",
    "Name": "I.B.I. 90/20",
    "ShortName": "I.B.I. 90/20",
    "Symbol": "TASE:5130265",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (2C) 90/20 IL",
    "EnglishLongName": "I.B.I. (2C) 90/20 IL",
    "HebrewName": "איביאי 20/90",
    "HebrewLongName": "אי.בי.אי. (2C)י 20/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.37,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Leveraged and Strategic",
    "SecondaryClassification": "Strategic (not leveraged)",
    "AssetValue": 268.9,
    "MonthYield": 0.65,
    "YearYield": 0.65,
    "Last12MonthYield": 12.03,
    "ISIN": "IL0051302656"
  },
  {
    "Id": "TASE:5117619",
    "MayaId": "5117619",
    "Name": "I.B.I. ALL – BONDS PORT",
    "ShortName": "I.B.I. ALL – BONDS PORT",
    "Symbol": "TASE:5117619",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (OB) ALL – BONDS PORTFOLIO IL",
    "EnglishLongName": "I.B.I. (OB) ALL – BONDS PORTFOLIO IL",
    "HebrewName": "איביאי תיק אג\"ח כללי",
    "HebrewLongName": "אי.בי.אי. (0B) תיק אג\"ח כללי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.44,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 50.2,
    "MonthYield": 0.55,
    "YearYield": 0.55,
    "Last12MonthYield": 6.46,
    "ISIN": "IL0051176191"
  },
  {
    "Id": "TASE:5126495",
    "MayaId": "5126495",
    "Name": "I.B.I. BOND PLUS 90/10",
    "ShortName": "I.B.I. BOND PLUS 90/10",
    "Symbol": "TASE:5126495",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (1A)(!) BOND PLUS 90/10 IL",
    "EnglishLongName": "I.B.I. (1A)(!) BOND PLUS 90/10 IL",
    "HebrewName": "איביאי אג\"ח פלוס 10/90",
    "HebrewLongName": "אי.בי.אי. (1A)(!) אג\"ח פלוס 10/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.55,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.38,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 77.4,
    "MonthYield": 1.19,
    "YearYield": 1.19,
    "Last12MonthYield": 11.87,
    "ISIN": "IL0051264955"
  },
  {
    "Id": "TASE:5127204",
    "MayaId": "5127204",
    "Name": "I.B.I. Bonds + 15%",
    "ShortName": "I.B.I. Bonds + 15%",
    "Symbol": "TASE:5127204",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (2B) Bonds + 15% IL",
    "EnglishLongName": "I.B.I. (2B) Bonds + 15% IL",
    "HebrewName": "איביאי אג\"ח+ 15%",
    "HebrewLongName": "אי.בי.אי. (2B) אג\"ח + 15%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.4,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 15% Equity",
    "AssetValue": 107.4,
    "MonthYield": 1.52,
    "YearYield": 1.52,
    "Last12MonthYield": 12.54,
    "ISIN": "IL0051272040"
  },
  {
    "Id": "TASE:5110580",
    "MayaId": "5110580",
    "Name": "I.B.I. BONDS NO EQUITY",
    "ShortName": "I.B.I. BONDS NO EQUITY",
    "Symbol": "TASE:5110580",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (0B)(!) BONDS WITHOUT EQUITY IL",
    "EnglishLongName": "I.B.I. (0B)(!) BONDS WITHOUT EQUITY IL",
    "HebrewName": "איביאי אג\"ח ללא מניות",
    "HebrewLongName": "אי.בי.אי. (0B)(!) אג\"ח ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.29,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 180.6,
    "MonthYield": 0.61,
    "YearYield": 0.61,
    "Last12MonthYield": 6.94,
    "ISIN": "IL0051105802"
  },
  {
    "Id": "TASE:5113048",
    "MayaId": "5113048",
    "Name": "I.B.I. Corp Floting Rate",
    "ShortName": "I.B.I. Corp Floting Rate",
    "Symbol": "TASE:5113048",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (00)(!) Corporate Floting Rate IL",
    "EnglishLongName": "I.B.I. (00)(!) Corporate Floting Rate IL",
    "HebrewName": "איביאי קונצרני משתנה",
    "HebrewLongName": "אי.בי.אי. (00)(!) קונצרני ריבית משתנה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.07,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Shekel Corporate and Convertibles - No Equity",
    "AssetValue": 24.7,
    "MonthYield": 0.4,
    "YearYield": 0.4,
    "Last12MonthYield": 5.12,
    "ISIN": "IL0051130487"
  },
  {
    "Id": "TASE:5128434",
    "MayaId": "5128434",
    "Name": "I.B.I. Corp Portfolio",
    "ShortName": "I.B.I. Corp Portfolio",
    "Symbol": "TASE:5128434",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (0B)(!) Corporate Portfolio IL",
    "EnglishLongName": "I.B.I. (0B)(!) Corporate Portfolio IL",
    "HebrewName": "איביאי תיק קונצרני",
    "HebrewLongName": "אי.בי.אי. (0B)(!) תיק קונצרני",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 1687.8,
    "MonthYield": 0.64,
    "YearYield": 0.64,
    "Last12MonthYield": 6.34,
    "ISIN": "IL0051284342"
  },
  {
    "Id": "TASE:5119425",
    "MayaId": "5119425",
    "Name": "I.B.I. CORPORATE BONDS",
    "ShortName": "I.B.I. CORPORATE BONDS",
    "Symbol": "TASE:5119425",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (0B)(!) CORPORATE BONDS IL",
    "EnglishLongName": "I.B.I. (0B)(!) CORPORATE BONDS IL",
    "HebrewName": "איביאי אג\"ח חברות",
    "HebrewLongName": "אי.בי.אי. (0B)(!) אג\"ח חברות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 534.0,
    "MonthYield": 0.77,
    "YearYield": 0.77,
    "Last12MonthYield": 6.68,
    "ISIN": "IL0051194251"
  },
  {
    "Id": "TASE:5131982",
    "MayaId": "5131982",
    "Name": "I.B.I. FLEXIBLE",
    "ShortName": "I.B.I. FLEXIBLE",
    "Symbol": "TASE:5131982",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (4D) FLEXIBLE",
    "EnglishLongName": "I.B.I. (4D) FLEXIBLE",
    "HebrewName": "איביאי גמישה",
    "HebrewLongName": "אי.בי.אי. (4D) גמישה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.9,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.51,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 17.2,
    "MonthYield": 6.82,
    "YearYield": 6.82,
    "Last12MonthYield": 32.63,
    "ISIN": "IL0051319825"
  },
  {
    "Id": "TASE:5101183",
    "MayaId": "5101183",
    "Name": "I.B.I. Global Biotech",
    "ShortName": "I.B.I. Global Biotech",
    "Symbol": "TASE:5101183",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I.(4D) Global Biotechnology",
    "EnglishLongName": "I.B.I.(4D) Global Biotechnology",
    "HebrewName": "איביאי ביוטכנולוגיה גלובל",
    "HebrewLongName": "אי.בי.אי. (4D) ביוטכנולוגיה גלובלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.1,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks by Sectors - Foreign",
    "AssetValue": 13.2,
    "MonthYield": -2.4,
    "YearYield": -2.4,
    "Last12MonthYield": -1.85,
    "ISIN": "IL0051011836"
  },
  {
    "Id": "TASE:5120647",
    "MayaId": "5120647",
    "Name": "I.B.I. GOV + A AND ABOVE",
    "ShortName": "I.B.I. GOV + A AND ABOVE",
    "Symbol": "TASE:5120647",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (0A) GOVERNMENT PLUS A AND ABOVE IL",
    "EnglishLongName": "I.B.I. (0A) GOVERNMENT PLUS A AND ABOVE IL",
    "HebrewName": "איביאי מדינה פלוס A ומעלה",
    "HebrewLongName": "אי.בי.אי. (0A) מדינה פלוס A ומעלה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.26,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - No Equity",
    "AssetValue": 899.6,
    "MonthYield": 0.47,
    "YearYield": 0.47,
    "Last12MonthYield": 5.76,
    "ISIN": "IL0051206477"
  },
  {
    "Id": "TASE:5126230",
    "MayaId": "5126230",
    "Name": "I.B.I. GUY 75/25",
    "ShortName": "I.B.I. GUY 75/25",
    "Symbol": "TASE:5126230",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (2B) GUY 75/25 IL",
    "EnglishLongName": "I.B.I. (2B) GUY 75/25 IL",
    "HebrewName": "איביאי גיא 25/75",
    "HebrewLongName": "אי.בי.אי. (2B) גיא 25/75",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.21,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.55,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 25% Equity",
    "AssetValue": 81.8,
    "MonthYield": 2.0,
    "YearYield": 2.0,
    "Last12MonthYield": 16.22,
    "ISIN": "IL0051262306"
  },
  {
    "Id": "TASE:5103494",
    "MayaId": "5103494",
    "Name": "I.B.I. IL Eq Large&MidCap",
    "ShortName": "I.B.I. IL Eq Large&MidCap",
    "Symbol": "TASE:5103494",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (4A) Israel Equities Large & Mid Cap IL",
    "EnglishLongName": "I.B.I. (4A) Israel Equities Large & Mid Cap IL",
    "HebrewName": "איביאי ILמנ Large&MidCap",
    "HebrewLongName": "אי.בי.אי. (4A) מניות ישראל Large & mid cap",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.55,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.08,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 80.7,
    "MonthYield": 9.46,
    "YearYield": 9.46,
    "Last12MonthYield": 76.59,
    "ISIN": "IL0051034945"
  },
  {
    "Id": "TASE:5134275",
    "MayaId": "5134275",
    "Name": "I.B.I. IL fundoffund 15%",
    "ShortName": "I.B.I. IL fundoffund 15%",
    "Symbol": "TASE:5134275",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (2B) Israeli Fund of Funds Up to 15% Equities IL",
    "EnglishLongName": "I.B.I. (2B) Israeli Fund of Funds Up to 15% Equities IL",
    "HebrewName": "איביאי אגד ישראלי עד 15%",
    "HebrewLongName": "אי.בי.אי. (2B) אגד ישראלי עד 15% מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.41,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Fund of Funds",
    "SecondaryClassification": "Israeli Fund of Funds",
    "AssetValue": 130.3,
    "MonthYield": 1.58,
    "YearYield": 1.58,
    "Last12MonthYield": 11.61,
    "ISIN": "IL0051342751"
  },
  {
    "Id": "TASE:5134267",
    "MayaId": "5134267",
    "Name": "I.B.I. IL fundoffund 30%",
    "ShortName": "I.B.I. IL fundoffund 30%",
    "Symbol": "TASE:5134267",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (2B) Israeli Fund of Funds Up to 30% Equities IL",
    "EnglishLongName": "I.B.I. (2B) Israeli Fund of Funds Up to 30% Equities IL",
    "HebrewName": "איביאי אגד ישראלי עד 30%",
    "HebrewLongName": "אי.בי.אי. (2B) אגד ישראלי עד 30% מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.57,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Fund of Funds",
    "SecondaryClassification": "Israeli Fund of Funds",
    "AssetValue": 107.8,
    "MonthYield": 2.45,
    "YearYield": 2.45,
    "Last12MonthYield": 16.91,
    "ISIN": "IL0051342678"
  },
  {
    "Id": "TASE:5103510",
    "MayaId": "5103510",
    "Name": "I.B.I. ILS Money Market",
    "ShortName": "I.B.I. ILS Money Market",
    "Symbol": "TASE:5103510",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (00) Shekels Money Market IL",
    "EnglishLongName": "I.B.I. (00) Shekels Money Market IL",
    "HebrewName": "איביאי כספית שקלית",
    "HebrewLongName": "אי.בי.אי. (00) כספית שקלית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 2403.3,
    "MonthYield": 0.23,
    "YearYield": 0.23,
    "Last12MonthYield": 4.68,
    "ISIN": "IL0051035108"
  },
  {
    "Id": "TASE:5139522",
    "MayaId": "5139522",
    "Name": "I.B.I. ILS Money Market K",
    "ShortName": "I.B.I. ILS Money Market K",
    "Symbol": "TASE:5139522",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (00)  Shekels Money Market Kosher IL",
    "EnglishLongName": "I.B.I. (00)  Shekels Money Market Kosher IL",
    "HebrewName": "איביאי כספית שקלית כשרה",
    "HebrewLongName": "אי.בי.אי. (00) כספית שקלית כשרה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.149,
    "TrusteeFee": 0.005,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 4686.7,
    "MonthYield": 0.22,
    "YearYield": 0.22,
    "Last12MonthYield": 4.75,
    "ISIN": "IL0051395221"
  },
  {
    "Id": "TASE:5117577",
    "MayaId": "5117577",
    "Name": "I.B.I. INVES GR CORP BOND",
    "ShortName": "I.B.I. INVES GR CORP BOND",
    "Symbol": "TASE:5117577",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (OB) INVESTMENT GRADE CORPORATE BOND IL",
    "EnglishLongName": "I.B.I. (OB) INVESTMENT GRADE CORPORATE BOND IL",
    "HebrewName": "איביאי אג\"ח חברות מדורג",
    "HebrewLongName": "אי.בי.אי. (0B) אג\"ח חברות מדורג",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.95,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 287.5,
    "MonthYield": 0.64,
    "YearYield": 0.64,
    "Last12MonthYield": 6.76,
    "ISIN": "IL0051175771"
  },
  {
    "Id": "TASE:5125190",
    "MayaId": "5125190",
    "Name": "I.B.I. Invest Port 50/50",
    "ShortName": "I.B.I. Invest Port 50/50",
    "Symbol": "TASE:5125190",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (3C) Investment Portfolio 50/50 IL",
    "EnglishLongName": "I.B.I. (3C) Investment Portfolio 50/50 IL",
    "HebrewName": "איביאי תיק השקעות 50/50",
    "HebrewLongName": "אי.בי.אי. (3C) תיק השקעות 50/50",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.85,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - Max. Exposure over 30% Equity",
    "AssetValue": 9.6,
    "MonthYield": 3.56,
    "YearYield": 3.56,
    "Last12MonthYield": 25.02,
    "ISIN": "IL0051251903"
  },
  {
    "Id": "TASE:5107305",
    "MayaId": "5107305",
    "Name": "I.B.I. MAKAM",
    "ShortName": "I.B.I. MAKAM",
    "Symbol": "TASE:5107305",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (00) MAKAM IL",
    "EnglishLongName": "I.B.I. (00) MAKAM IL",
    "HebrewName": "איביאי מק\"מ",
    "HebrewLongName": "אי.בי.אי. (00) מק\"מ",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.46,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Shekel Bonds - No Equity",
    "AssetValue": 30.2,
    "MonthYield": 0.22,
    "YearYield": 0.22,
    "Last12MonthYield": 4.28,
    "ISIN": "IL0051073059"
  },
  {
    "Id": "TASE:5107313",
    "MayaId": "5107313",
    "Name": "I.B.I. MAKAM PLUS",
    "ShortName": "I.B.I. MAKAM PLUS",
    "Symbol": "TASE:5107313",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (1A) MAKAM PLUS IL",
    "EnglishLongName": "I.B.I. (1A) MAKAM PLUS IL",
    "HebrewName": "איביאי מק\"מ פלוס",
    "HebrewLongName": "אי.בי.אי. (1A) מק\"מ פלוס",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.45,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.13,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Shekel Bonds - Up to 10% Equity",
    "AssetValue": 145.8,
    "MonthYield": 0.58,
    "YearYield": 0.58,
    "Last12MonthYield": 6.91,
    "ISIN": "IL0051073133"
  },
  {
    "Id": "TASE:5132493",
    "MayaId": "5132493",
    "Name": "I.B.I. MEHAKA BSTRGREENT",
    "ShortName": "I.B.I. MEHAKA BSTRGREENT",
    "Symbol": "TASE:5132493",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4D) BlueStar Global GreenTech",
    "EnglishLongName": "I.B.I. MEHAKA (4D) BlueStar Global GreenTech",
    "HebrewName": "איביאי מחקה BStarGreenTec",
    "HebrewLongName": "אי.בי.אי. מחקה (4D)י BlueStar Global GreenTech",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.63,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 10.7,
    "MonthYield": 0.84,
    "YearYield": 0.84,
    "Last12MonthYield": 14.6,
    "ISIN": "IL0051324932"
  },
  {
    "Id": "TASE:5132139",
    "MayaId": "5132139",
    "Name": "I.B.I. MEHAKA cmgltechmon",
    "ShortName": "I.B.I. MEHAKA cmgltechmon",
    "Symbol": "TASE:5132139",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4D) Composite Global Technology Monthly",
    "EnglishLongName": "I.B.I. MEHAKA (4D) Composite Global Technology Monthly",
    "HebrewName": "איביאי מחקה מש טכנל על חד",
    "HebrewLongName": "אי.בי.אי. מחקה (4D) משולבת טכנולוגיה עולמי חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.81,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks Abroad, Composite",
    "AssetValue": 22.2,
    "MonthYield": 7.15,
    "YearYield": 7.15,
    "Last12MonthYield": 31.61,
    "ISIN": "IL0051321391"
  },
  {
    "Id": "TASE:5134200",
    "MayaId": "5134200",
    "Name": "I.B.I. MEHAKA Co ILEQ MO",
    "ShortName": "I.B.I. MEHAKA Co ILEQ MO",
    "Symbol": "TASE:5134200",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A) Composite Israeli Equities Balance Monthly IL",
    "EnglishLongName": "I.B.I. MEHAKA (4A) Composite Israeli Equities Balance Monthly IL",
    "HebrewName": "איביאי מחקה מש מניותיש חד",
    "HebrewLongName": "אי.בי.אי. מחקה (4A) משולבת מניות ישראל חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.12,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks in Israel, Composite",
    "AssetValue": 78.0,
    "MonthYield": 7.52,
    "YearYield": 7.52,
    "Last12MonthYield": 56.49,
    "ISIN": "IL0051342009"
  },
  {
    "Id": "TASE:5132766",
    "MayaId": "5132766",
    "Name": "I.B.I. MEHAKA Idxchincon",
    "ShortName": "I.B.I. MEHAKA Idxchincon",
    "Symbol": "TASE:5132766",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4D) Index Chinese Consumer companies",
    "EnglishLongName": "I.B.I. MEHAKA (4D) Index Chinese Consumer companies",
    "HebrewName": "איביאי מחקה אנדקס חבצרכסן",
    "HebrewLongName": "אי.בי.אי. מחקה (4D) אינדקס חברות צריכה סיניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.58,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS MANAGEMENT (1978) LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 2.4,
    "MonthYield": 0.49,
    "YearYield": 3.22,
    "Last12MonthYield": -0.47,
    "ISIN": "IL0051327661"
  },
  {
    "Id": "TASE:5133533",
    "MayaId": "5133533",
    "Name": "I.B.I. MEHAKA IdxFinIL Ba",
    "ShortName": "I.B.I. MEHAKA IdxFinIL Ba",
    "Symbol": "TASE:5133533",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A) Index Israeli Finance Sector Balance IL",
    "EnglishLongName": "I.B.I. MEHAKA (4A) Index Israeli Finance Sector Balance IL",
    "HebrewName": "איביאי מחקה פננס יש אזןענ",
    "HebrewLongName": "אי.בי.אי. מחקה (4A) אינדקס פיננסים ישראל איזון ענפי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.44,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 278.2,
    "MonthYield": 7.17,
    "YearYield": 7.17,
    "Last12MonthYield": 114.81,
    "ISIN": "IL0051335334"
  },
  {
    "Id": "TASE:5135884",
    "MayaId": "5135884",
    "Name": "I.B.I. MEHAKA IdxNBCFSIL",
    "ShortName": "I.B.I. MEHAKA IdxNBCFSIL",
    "Symbol": "TASE:5135884",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A) Index Non-bank credit&others financial services in Israel IL",
    "EnglishLongName": "I.B.I. MEHAKA (4A) Index Non-bank credit&others financial services in Israel IL",
    "HebrewName": "איביאי מחקה אדקס אשחצ שפס",
    "HebrewLongName": "אי.בי.אי מחקה (4A) אינדקס אשראי חוץ בנקאי ושירותים פיננסיים אחרים בישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.03,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 59.7,
    "MonthYield": 2.88,
    "YearYield": 2.88,
    "Last12MonthYield": 74.59,
    "ISIN": "IL0051358849"
  },
  {
    "Id": "TASE:5132709",
    "MayaId": "5132709",
    "Name": "I.B.I. MEHAKA Ixglelcvhcl",
    "ShortName": "I.B.I. MEHAKA Ixglelcvhcl",
    "Symbol": "TASE:5132709",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4D) Index Global Electric Vehicle",
    "EnglishLongName": "I.B.I. MEHAKA (4D) Index Global Electric Vehicle",
    "HebrewName": "איביאי מחקה אנדק רכ חש גל",
    "HebrewLongName": "אי.בי.אי. מחקה (4D) אינדקס רכב חשמלי גלובלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.8,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 7.0,
    "MonthYield": -5.71,
    "YearYield": -5.71,
    "Last12MonthYield": -7.68,
    "ISIN": "IL0051327091"
  },
  {
    "Id": "TASE:5120282",
    "MayaId": "5120282",
    "Name": "I.B.I. MEHAKA SOBBREIL",
    "ShortName": "I.B.I. MEHAKA SOBBREIL",
    "Symbol": "TASE:5120282",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A) Solactive Israel Commercial Real Estate IL",
    "EnglishLongName": "I.B.I. MEHAKA (4A) Solactive Israel Commercial Real Estate IL",
    "HebrewName": "איביאי מחקה נדלן SOL IL",
    "HebrewLongName": "אי.בי.אי. מחקה (4A)י Solactive נדל\"ן מניב ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.49,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 125.7,
    "MonthYield": 8.42,
    "YearYield": 8.42,
    "Last12MonthYield": 44.64,
    "ISIN": "IL0051202823"
  },
  {
    "Id": "TASE:5124755",
    "MayaId": "5124755",
    "Name": "I.B.I. MEHAKA SOBBTAHD",
    "ShortName": "I.B.I. MEHAKA SOBBTAHD",
    "Symbol": "TASE:5124755",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A) Solactive TA 125 Low Volatility High Dividends IL",
    "EnglishLongName": "I.B.I. MEHAKA (4A) Solactive TA 125 Low Volatility High Dividends IL",
    "HebrewName": "איביאי מחקה תא125 SO LVHD",
    "HebrewLongName": "אי.בי.אי. מחקה (4A)י Solactive ת\"א 125 Low Volatility High Dividends",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.14,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 45.2,
    "MonthYield": 5.33,
    "YearYield": 5.33,
    "Last12MonthYield": 63.09,
    "ISIN": "IL0051247554"
  },
  {
    "Id": "TASE:5117023",
    "MayaId": "5117023",
    "Name": "I.B.I. MEHAKA TEL BCL",
    "ShortName": "I.B.I. MEHAKA TEL-BCL",
    "Symbol": "TASE:5117023",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00) TEL BOND CPI - LINKED IL",
    "EnglishLongName": "I.B.I. MEHAKA (00) TEL BOND CPI - LINKED IL",
    "HebrewName": "איביאי מחקה תלבונד צמוד",
    "HebrewLongName": "אי.בי.אי. מחקה (00) תל בונד צמודות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 57.0,
    "MonthYield": 0.24,
    "YearYield": 0.24,
    "Last12MonthYield": 6.56,
    "ISIN": "IL0051170236"
  },
  {
    "Id": "TASE:5102132",
    "MayaId": "5102132",
    "Name": "I.B.I. MENAYOT",
    "ShortName": "I.B.I. MENAYOT",
    "Symbol": "TASE:5102132",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (4A) MENAYOT IL",
    "EnglishLongName": "I.B.I. (4A) MENAYOT IL",
    "HebrewName": "איביאי מניות",
    "HebrewLongName": "אי.בי.אי. (4A) מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.29,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.05,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 300.1,
    "MonthYield": 8.38,
    "YearYield": 8.38,
    "Last12MonthYield": 63.22,
    "ISIN": "IL0051021322"
  },
  {
    "Id": "TASE:5126453",
    "MayaId": "5126453",
    "Name": "I.B.I. NETA GOV NO EQUITY",
    "ShortName": "I.B.I. NETA GOV NO EQUITY",
    "Symbol": "TASE:5126453",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (00) NETA GOVERMENT WITHOUT EQUITY IL",
    "EnglishLongName": "I.B.I. (00) NETA GOVERMENT WITHOUT EQUITY IL",
    "HebrewName": "איביאי נטע מדינה ללא מניו",
    "HebrewLongName": "אי.בי.אי. (00) נטע מדינה ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.48,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - No Equity",
    "AssetValue": 146.6,
    "MonthYield": 0.55,
    "YearYield": 0.55,
    "Last12MonthYield": 6.13,
    "ISIN": "IL0051264534"
  },
  {
    "Id": "TASE:5126479",
    "MayaId": "5126479",
    "Name": "I.B.I. NOGA 75/25",
    "ShortName": "I.B.I. NOGA 75/25",
    "Symbol": "TASE:5126479",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (2B)(!) NOGA 75/25 IL",
    "EnglishLongName": "I.B.I. (2B)(!) NOGA 75/25 IL",
    "HebrewName": "איביאי נוגה 25/75",
    "HebrewLongName": "אי.בי.אי. (2B)(!) נוגה 25/75",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.52,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 25% Equity",
    "AssetValue": 97.8,
    "MonthYield": 2.13,
    "YearYield": 2.13,
    "Last12MonthYield": 16.21,
    "ISIN": "IL0051264799"
  },
  {
    "Id": "TASE:5139621",
    "MayaId": "5139621",
    "Name": "I.B.I. Portfolio",
    "ShortName": "I.B.I. Portfolio",
    "Symbol": "TASE:5139621",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (3C) Portfolio IL",
    "EnglishLongName": "I.B.I. (3C) Portfolio IL",
    "HebrewName": "איביאי תיק השקעות",
    "HebrewLongName": "אי.בי.אי. (3C) תיק השקעות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.62,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - Max. Exposure over 30% Equity",
    "AssetValue": 92.7,
    "MonthYield": 1.21,
    "YearYield": 1.21,
    "Last12MonthYield": 17.73,
    "ISIN": "IL0051396211"
  },
  {
    "Id": "IBI-F13.TA",
    "MayaId": "1147974",
    "Name": "I.B.I. SAL (00) Tel Bond 40 CPI LINKED IL",
    "ShortName": "I.B.I MUTUAL FUNDS LTD",
    "Symbol": "IBI-F13.TA",
    "TaseSymbol": "IBI.F13",
    "YahooId": "IBI-F13.TA",
    "EnglishName": "IBI.TEL-B40CPI",
    "EnglishLongName": "I.B.I MUTUAL FUNDS LTD",
    "HebrewName": "IBI.תלבונד 40צד",
    "HebrewLongName": "אי.בי.אי קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.015,
    "VariableFee": 0.03,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 385.72,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "I.B.I",
    "TrusteeName": "UBANK",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.4,
    "YearYield": 0.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011479743"
  },
  {
    "Id": "IBI-F14.TA",
    "MayaId": "1148006",
    "Name": "I.B.I. SAL (00) Tel Bond 60 CPI LINKED IL",
    "ShortName": "I.B.I MUTUAL FUNDS LTD",
    "Symbol": "IBI-F14.TA",
    "TaseSymbol": "IBI.F14",
    "YahooId": "IBI-F14.TA",
    "EnglishName": "IBI.TEL-B60CPI",
    "EnglishLongName": "I.B.I MUTUAL FUNDS LTD",
    "HebrewName": "IBI.תלבונד 60צד",
    "HebrewLongName": "אי.בי.אי קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.008,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 397.49,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "I.B.I",
    "TrusteeName": "UBANK",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.3,
    "YearYield": 0.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011480063"
  },
  {
    "Id": "IBI-F22.TA",
    "MayaId": "1148477",
    "Name": "I.B.I. SAL (00) Tel Bond CPI Linked A IL",
    "ShortName": "I.B.I MUTUAL FUNDS LTD",
    "Symbol": "IBI-F22.TA",
    "TaseSymbol": "IBI.F22",
    "YahooId": "IBI-F22.TA",
    "EnglishName": "IBI.TEL-CPIA",
    "EnglishLongName": "I.B.I MUTUAL FUNDS LTD",
    "HebrewName": "IBI.תלבונד צ A",
    "HebrewLongName": "אי.בי.אי קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.0085,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4167.7,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "I.B.I",
    "TrusteeName": "UBANK",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.2,
    "YearYield": 0.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011484776"
  },
  {
    "Id": "IBI-F16.TA",
    "MayaId": "1148048",
    "Name": "I.B.I. SAL (00) Tel Bond CPI Linked IL",
    "ShortName": "I.B.I MUTUAL FUNDS LTD",
    "Symbol": "IBI-F16.TA",
    "TaseSymbol": "IBI.F16",
    "YahooId": "IBI-F16.TA",
    "EnglishName": "IBI.TEL-BCL",
    "EnglishLongName": "I.B.I MUTUAL FUNDS LTD",
    "HebrewName": "IBI.תלבונד צמוד",
    "HebrewLongName": "אי.בי.אי קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.015,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4110.87,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "I.B.I",
    "TrusteeName": "UBANK",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.3,
    "YearYield": 0.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011480485"
  },
  {
    "Id": "IBI-F62.TA",
    "MayaId": "1147966",
    "Name": "I.B.I. SAL (0D) iBoxx US Liquid Investment Grade Top 30",
    "ShortName": "I.B.I MUTUAL FUNDS LTD",
    "Symbol": "IBI-F62.TA",
    "TaseSymbol": "IBI.F62",
    "YahooId": "IBI-F62.TA",
    "EnglishName": "IBI.IBOX$IG30",
    "EnglishLongName": "I.B.I MUTUAL FUNDS LTD",
    "HebrewName": "IG30.IBI$ IBOX",
    "HebrewLongName": "אי.בי.אי קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 9505.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "I.B.I",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -2.0,
    "YearYield": -2.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011479669"
  },
  {
    "Id": "IBI-F112.TA",
    "MayaId": "1149830",
    "Name": "I.B.I. SAL (4A) DAX Currency Hedged",
    "ShortName": "I.B.I MUTUAL FUNDS LTD",
    "Symbol": "IBI-F112.TA",
    "TaseSymbol": "IBI.F112",
    "YahooId": "IBI-F112.TA",
    "EnglishName": "IBI.DAX H",
    "EnglishLongName": "I.B.I MUTUAL FUNDS LTD",
    "HebrewName": "DAX.IBI ממ",
    "HebrewLongName": "אי.בי.אי קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.02,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 21500.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "I.B.I",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Europe - developed markets",
    "AssetValue": null,
    "MonthYield": 2.3,
    "YearYield": 2.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011498305"
  },
  {
    "Id": "IBI-F35.TA",
    "MayaId": "1148774",
    "Name": "I.B.I. SAL (4A) Index Israel Banks IL",
    "ShortName": "I.B.I MUTUAL FUNDS LTD",
    "Symbol": "IBI-F35.TA",
    "TaseSymbol": "IBI.F35",
    "YahooId": "IBI-F35.TA",
    "EnglishName": "IBI.INDEX BANK",
    "EnglishLongName": "I.B.I MUTUAL FUNDS LTD",
    "HebrewName": "IBI.אינ בנק ישר",
    "HebrewLongName": "אי.בי.אי קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.008,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 7708.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "I.B.I",
    "TrusteeName": "UBANK",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Banking and non-banking credit",
    "AssetValue": null,
    "MonthYield": 9.8,
    "YearYield": 9.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011487746"
  },
  {
    "Id": "IBI-F184.TA",
    "MayaId": "1217843",
    "Name": "I.B.I. SAL (4A) Index Israeli Mid Cap & Banks IL",
    "ShortName": "I.B.I MUTUAL FUNDS LTD",
    "Symbol": "IBI-F184.TA",
    "TaseSymbol": "IBI.F184",
    "YahooId": "IBI-F184.TA",
    "EnglishName": "I.B.I.MIDCAP&BA",
    "EnglishLongName": "I.B.I MUTUAL FUNDS LTD",
    "HebrewName": "IBI.מידקאפובנקי",
    "HebrewLongName": "אי.בי.אי קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 7030.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "I.B.I",
    "TrusteeName": "UBANK",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Large & Mid Cap",
    "AssetValue": null,
    "MonthYield": 1.9,
    "YearYield": 1.9,
    "Last12MonthYield": null,
    "ISIN": "IL0012178435"
  },
  {
    "Id": "IBI-F176.TA",
    "MayaId": "1190347",
    "Name": "I.B.I. SAL (4A) Index US Momentum Currency Hedged",
    "ShortName": "I.B.I MUTUAL FUNDS LTD",
    "Symbol": "IBI-F176.TA",
    "TaseSymbol": "IBI.F176",
    "YahooId": "IBI-F176.TA",
    "EnglishName": "IBI.US MOMENT H",
    "EnglishLongName": "I.B.I MUTUAL FUNDS LTD",
    "HebrewName": "IBI.מומ ארהב ממ",
    "HebrewLongName": "אי.בי.אי קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3190.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "I.B.I",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": 6.3,
    "YearYield": 6.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011903478"
  },
  {
    "Id": "IBI.FK4.TA",
    "MayaId": "1155324",
    "Name": "I.B.I. SAL (4A) Kosher TA 125 IL",
    "ShortName": "I.B.I MUTUAL FUNDS LTD",
    "Symbol": "IBI.FK4.TA",
    "TaseSymbol": "IBI.FK4",
    "YahooId": "IBI.FK4.TA",
    "EnglishName": "IBI.KO TA125",
    "EnglishLongName": "I.B.I MUTUAL FUNDS LTD",
    "HebrewName": "IBI.כש תא 125",
    "HebrewLongName": "אי.בי.אי קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3835.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "I.B.I",
    "TrusteeName": "UBANK",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Large & Mid Cap",
    "AssetValue": null,
    "MonthYield": 8.9,
    "YearYield": 8.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011553240"
  },
  {
    "Id": "IBI-F180.TA",
    "MayaId": "1200443",
    "Name": "I.B.I. SAL (4A) Nasdaq 100 Currency Hedged",
    "ShortName": "I.B.I MUTUAL FUNDS LTD",
    "Symbol": "IBI-F180.TA",
    "TaseSymbol": "IBI.F180",
    "YahooId": "IBI-F180.TA",
    "EnglishName": "IBI.NASDAQ100CH",
    "EnglishLongName": "I.B.I MUTUAL FUNDS LTD",
    "HebrewName": "NDX100.IBIממ",
    "HebrewLongName": "אי.בי.אי קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.01,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 7177.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "I.B.I",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": -0.8,
    "YearYield": -0.8,
    "Last12MonthYield": null,
    "ISIN": "IL0012004433"
  },
  {
    "Id": "IBI-F179.TA",
    "MayaId": "1200435",
    "Name": "I.B.I. SAL (4A) S&P 500 Currency Hedged",
    "ShortName": "I.B.I MUTUAL FUNDS LTD",
    "Symbol": "IBI-F179.TA",
    "TaseSymbol": "IBI.F179",
    "YahooId": "IBI-F179.TA",
    "EnglishName": "IBI.S&P 500 CH",
    "EnglishLongName": "I.B.I MUTUAL FUNDS LTD",
    "HebrewName": "P 500.IBI&S ממ",
    "HebrewLongName": "אי.בי.אי קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.01,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 7010.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "I.B.I",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": -0.6,
    "YearYield": -0.6,
    "Last12MonthYield": null,
    "ISIN": "IL0012004359"
  },
  {
    "Id": "IBI-F126.TA",
    "MayaId": "1148212",
    "Name": "I.B.I. SAL (4A) S&P Health Care Currency Hedged",
    "ShortName": "I.B.I MUTUAL FUNDS LTD",
    "Symbol": "IBI-F126.TA",
    "TaseSymbol": "IBI.F126",
    "YahooId": "IBI-F126.TA",
    "EnglishName": "IBI.SPHEALTH H",
    "EnglishLongName": "I.B.I MUTUAL FUNDS LTD",
    "HebrewName": "SPHEALTH.IBIממ",
    "HebrewLongName": "אי.בי.אי קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.02,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4622.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "I.B.I",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Health Care",
    "AssetValue": null,
    "MonthYield": 0.6,
    "YearYield": 0.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011482127"
  },
  {
    "Id": "IBI-F42.TA",
    "MayaId": "1148808",
    "Name": "I.B.I. SAL (4A) TA 125 IL",
    "ShortName": "I.B.I MUTUAL FUNDS LTD",
    "Symbol": "IBI-F42.TA",
    "TaseSymbol": "IBI.F42",
    "YahooId": "IBI-F42.TA",
    "EnglishName": "IBI.TA-125",
    "EnglishLongName": "I.B.I MUTUAL FUNDS LTD",
    "HebrewName": "IBI.תא 125",
    "HebrewLongName": "אי.בי.אי קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.35,
    "TrusteeFee": 0.008,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3833.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "I.B.I",
    "TrusteeName": "UBANK",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Large & Mid Cap",
    "AssetValue": null,
    "MonthYield": 8.7,
    "YearYield": 8.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011488082"
  },
  {
    "Id": "IBI-F186.TA",
    "MayaId": "1225994",
    "Name": "I.B.I. SAL (4A) TA 35 IL",
    "ShortName": "I.B.I MUTUAL FUNDS LTD",
    "Symbol": "IBI-F186.TA",
    "TaseSymbol": "IBI.F186",
    "YahooId": "IBI-F186.TA",
    "EnglishName": "IBI.TA-35",
    "EnglishLongName": "I.B.I MUTUAL FUNDS LTD",
    "HebrewName": "IBI.ת\"א-35",
    "HebrewLongName": "אי.בי.אי קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.01,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 6373.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "I.B.I",
    "TrusteeName": "UBANK",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Large Cap",
    "AssetValue": null,
    "MonthYield": 8.4,
    "YearYield": 8.4,
    "Last12MonthYield": null,
    "ISIN": "IL0012259946"
  },
  {
    "Id": "IBI-F182.TA",
    "MayaId": "1209444",
    "Name": "I.B.I. SAL (4A) TA 90 IL",
    "ShortName": "I.B.I MUTUAL FUNDS LTD",
    "Symbol": "IBI-F182.TA",
    "TaseSymbol": "IBI.F182",
    "YahooId": "IBI-F182.TA",
    "EnglishName": "IBI SAL TA-90",
    "EnglishLongName": "I.B.I MUTUAL FUNDS LTD",
    "HebrewName": "IBI.ת\"א-90",
    "HebrewLongName": "אי.בי.אי קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.01,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 9670.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "I.B.I",
    "TrusteeName": "UBANK",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Mid Cap",
    "AssetValue": null,
    "MonthYield": 6.9,
    "YearYield": 6.9,
    "Last12MonthYield": null,
    "ISIN": "IL0012094442"
  },
  {
    "Id": "IBI-F183.TA",
    "MayaId": "1215771",
    "Name": "I.B.I. SAL (4A) TA Insurance IL",
    "ShortName": "I.B.I MUTUAL FUNDS LTD",
    "Symbol": "IBI-F183.TA",
    "TaseSymbol": "IBI.F183",
    "YahooId": "IBI-F183.TA",
    "EnglishName": "I.B.I.TA-INSURA",
    "EnglishLongName": "I.B.I MUTUAL FUNDS LTD",
    "HebrewName": "IBI.ת\"א-ביטוח",
    "HebrewLongName": "אי.בי.אי קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 12000.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "I.B.I",
    "TrusteeName": "UBANK",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Insurance",
    "AssetValue": null,
    "MonthYield": 7.2,
    "YearYield": 7.2,
    "Last12MonthYield": null,
    "ISIN": "IL0012157710"
  },
  {
    "Id": "IBI-F178.TA",
    "MayaId": "1190362",
    "Name": "I.B.I. SAL (4D) Index Global Growth",
    "ShortName": "I.B.I MUTUAL FUNDS LTD",
    "Symbol": "IBI-F178.TA",
    "TaseSymbol": "IBI.F178",
    "YahooId": "IBI-F178.TA",
    "EnglishName": "IBI.GLOB GROWTH",
    "EnglishLongName": "I.B.I MUTUAL FUNDS LTD",
    "HebrewName": "IBI.צמיחה עולמי",
    "HebrewLongName": "אי.בי.אי קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3016.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "I.B.I",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -0.6,
    "YearYield": -0.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011903627"
  },
  {
    "Id": "IBI-F177.TA",
    "MayaId": "1190354",
    "Name": "I.B.I. SAL (4D) Index Global Value",
    "ShortName": "I.B.I MUTUAL FUNDS LTD",
    "Symbol": "IBI-F177.TA",
    "TaseSymbol": "IBI.F177",
    "YahooId": "IBI-F177.TA",
    "EnglishName": "IBI.GLOB VALUE",
    "EnglishLongName": "I.B.I MUTUAL FUNDS LTD",
    "HebrewName": "IBI.ערך עולמי",
    "HebrewLongName": "אי.בי.אי קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2171.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "I.B.I",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.4,
    "YearYield": 1.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011903544"
  },
  {
    "Id": "IBI-F61.TA",
    "MayaId": "1147875",
    "Name": "I.B.I. SAL (4D) LBMA Gold Price AM",
    "ShortName": "I.B.I MUTUAL FUNDS LTD",
    "Symbol": "IBI-F61.TA",
    "TaseSymbol": "IBI.F61",
    "YahooId": "IBI-F61.TA",
    "EnglishName": "IBI.GOLDAM",
    "EnglishLongName": "I.B.I MUTUAL FUNDS LTD",
    "HebrewName": "GOLDAM.IBI",
    "HebrewLongName": "אי.בי.אי קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 1.5,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3208.5,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "I.B.I",
    "TrusteeName": "UBANK",
    "MainClassification": "Commodities",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 7.0,
    "YearYield": 7.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011478752"
  },
  {
    "Id": "IBI-F106.TA",
    "MayaId": "1149772",
    "Name": "I.B.I. SAL (4D) MSCI AC World",
    "ShortName": "I.B.I MUTUAL FUNDS LTD",
    "Symbol": "IBI-F106.TA",
    "TaseSymbol": "IBI.F106",
    "YahooId": "IBI-F106.TA",
    "EnglishName": "IBI.MSCI AC",
    "EnglishLongName": "I.B.I MUTUAL FUNDS LTD",
    "HebrewName": "MSCI AC.IBI",
    "HebrewLongName": "אי.בי.אי קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.02,
    "VariableFee": 0.15,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3771.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "I.B.I",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -0.4,
    "YearYield": -0.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011497729"
  },
  {
    "Id": "IBI-F181.TA",
    "MayaId": "1200450",
    "Name": "I.B.I. SAL (4D) Nasdaq 100",
    "ShortName": "I.B.I MUTUAL FUNDS LTD",
    "Symbol": "IBI-F181.TA",
    "TaseSymbol": "IBI.F181",
    "YahooId": "IBI-F181.TA",
    "EnglishName": "IBI.NASDAQ 100",
    "EnglishLongName": "I.B.I MUTUAL FUNDS LTD",
    "HebrewName": "NASDAQ 100.IBI",
    "HebrewLongName": "אי.בי.אי קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.01,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 6312.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "I.B.I",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": -1.9,
    "YearYield": -1.9,
    "Last12MonthYield": null,
    "ISIN": "IL0012004508"
  },
  {
    "Id": "IBI-F65.TA",
    "MayaId": "1148162",
    "Name": "I.B.I. SAL (4D) S&P 500",
    "ShortName": "I.B.I MUTUAL FUNDS LTD",
    "Symbol": "IBI-F65.TA",
    "TaseSymbol": "IBI.F65",
    "YahooId": "IBI-F65.TA",
    "EnglishName": "IBI.SP500",
    "EnglishLongName": "I.B.I MUTUAL FUNDS LTD",
    "HebrewName": "SP500.IBI",
    "HebrewLongName": "אי.בי.אי קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.0085,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 21450.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "I.B.I",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": -0.9,
    "YearYield": -0.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011481624"
  },
  {
    "Id": "IBI-F185.TA",
    "MayaId": "1222249",
    "Name": "I.B.I. SAL (4D) S&P Bitcoin",
    "ShortName": "I.B.I MUTUAL FUNDS LTD",
    "Symbol": "IBI-F185.TA",
    "TaseSymbol": "IBI.F185",
    "YahooId": "IBI-F185.TA",
    "EnglishName": "IBI.SP BITCOIN",
    "EnglishLongName": "I.B.I MUTUAL FUNDS LTD",
    "HebrewName": "SP BITCOIN.IBI",
    "HebrewLongName": "אי.בי.אי קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3649.3,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "I.B.I",
    "TrusteeName": "UBANK",
    "MainClassification": "Digital Assets",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 4.5,
    "YearYield": 4.5,
    "Last12MonthYield": null,
    "ISIN": "IL0012222498"
  },
  {
    "Id": "IBI-F161.TA",
    "MayaId": "1149236",
    "Name": "I.B.I. SAL (6A) Short TA 90 (6582.848) IL",
    "ShortName": "I.B.I MUTUAL FUNDS LTD",
    "Symbol": "IBI-F161.TA",
    "TaseSymbol": "IBI.F161",
    "YahooId": "IBI-F161.TA",
    "EnglishName": "IBI.STA-90",
    "EnglishLongName": "I.B.I MUTUAL FUNDS LTD",
    "HebrewName": "IBI.חס תא 90",
    "HebrewLongName": "אי.בי.אי קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.015,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 58.8,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "I.B.I",
    "TrusteeName": "UBANK",
    "MainClassification": "Leveraged",
    "SecondaryClassification": "Stocks in Israel",
    "AssetValue": null,
    "MonthYield": -22.9,
    "YearYield": -22.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011492365"
  },
  {
    "Id": "TASE:5111638",
    "MayaId": "5111638",
    "Name": "I.B.I. State CPI Bonds",
    "ShortName": "I.B.I. State CPI Bonds",
    "Symbol": "TASE:5111638",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (00)(!) State CPI- linked Bonds Without Equity IL",
    "EnglishLongName": "I.B.I. (00)(!) State CPI- linked Bonds Without Equity IL",
    "HebrewName": "איביאי מדינה צמוד ללא מנ",
    "HebrewLongName": "אי.בי.אי. (00)(!) מדינה צמוד ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.16,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked Government Bonds - No Equity",
    "AssetValue": 106.4,
    "MonthYield": 0.19,
    "YearYield": 0.19,
    "Last12MonthYield": 4.93,
    "ISIN": "IL0051116387"
  },
  {
    "Id": "TASE:5127949",
    "MayaId": "5127949",
    "Name": "I.B.I. UP TO 3 90/10",
    "ShortName": "I.B.I. UP TO 3 90/10",
    "Symbol": "TASE:5127949",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (1B) UP TO 3 YEARS 90/10 IL",
    "EnglishLongName": "I.B.I. (1B) UP TO 3 YEARS 90/10 IL",
    "HebrewName": "איביאי עד 3 שנים 10/90",
    "HebrewLongName": "אי.בי.אי. (1B) עד 3 שנים 10/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 1249.8,
    "MonthYield": 1.03,
    "YearYield": 1.03,
    "Last12MonthYield": 10.93,
    "ISIN": "IL0051279490"
  },
  {
    "Id": "TASE:5128665",
    "MayaId": "5128665",
    "Name": "I.B.I. Up To 3 YEAR 70/30",
    "ShortName": "I.B.I. Up To 3 YEAR 70/30",
    "Symbol": "TASE:5128665",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (2C) Up To 3 YEARS 70/30 IL",
    "EnglishLongName": "I.B.I. (2C) Up To 3 YEARS 70/30 IL",
    "HebrewName": "איביאי עד 3 שנים 30/70",
    "HebrewLongName": "אי.בי.אי. (2C) עד 3 שנים 30/70",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.5,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 202.2,
    "MonthYield": 2.04,
    "YearYield": 2.04,
    "Last12MonthYield": 16.5,
    "ISIN": "IL0051286651"
  },
  {
    "Id": "TASE:5107420",
    "MayaId": "5107420",
    "Name": "I.B.I. UpTo 3 YEAR 80/20",
    "ShortName": "I.B.I. UpTo 3 YEAR 80/20",
    "Symbol": "TASE:5107420",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (2B) Up To 3 YEARS 80/20 IL",
    "EnglishLongName": "I.B.I. (2B) Up To 3 YEARS 80/20 IL",
    "HebrewName": "איביאי עד 3 שנים 20/80",
    "HebrewLongName": "אי.בי.אי. (2B) עד 3 שנים 20/80",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.44,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 1080.7,
    "MonthYield": 1.61,
    "YearYield": 1.61,
    "Last12MonthYield": 13.16,
    "ISIN": "IL0051074206"
  },
  {
    "Id": "TASE:5100821",
    "MayaId": "5100821",
    "Name": "I.B.I. US Equities",
    "ShortName": "I.B.I. US Equities",
    "Symbol": "TASE:5100821",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (4D) US Equities",
    "EnglishLongName": "I.B.I. (4D) US Equities",
    "HebrewName": "איביאי מניות ארה\"ב",
    "HebrewLongName": "אי.בי.אי. (4D) מניות ארה\"ב",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.25,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Geographical stocks",
    "AssetValue": 93.7,
    "MonthYield": 0.69,
    "YearYield": 0.69,
    "Last12MonthYield": 4.34,
    "ISIN": "IL0051008212"
  },
  {
    "Id": "TASE:5127998",
    "MayaId": "5127998",
    "Name": "I.B.I. US$float rate plus",
    "ShortName": "I.B.I. US$float rate plus",
    "Symbol": "TASE:5127998",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (2D) US$ floating rate plus",
    "EnglishLongName": "I.B.I. (2D) US$ floating rate plus",
    "HebrewName": "איביאי אג\"ח $ ריבית משת +",
    "HebrewLongName": "אי.בי.אי. (2D) אג\"ח דולר ריבית משתנה פלוס",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.93,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "Dollar Bond",
    "AssetValue": 20.0,
    "MonthYield": -0.66,
    "YearYield": -0.66,
    "Last12MonthYield": -7.47,
    "ISIN": "IL0051279987"
  },
  {
    "Id": "TASE:5140751",
    "MayaId": "5140751",
    "Name": "I.B.I. Wein fundoffund IL",
    "ShortName": "I.B.I. Wein fundoffund IL",
    "Symbol": "TASE:5140751",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. Weinstein (3C) Israeli Fund of Funds IL",
    "EnglishLongName": "I.B.I. Weinstein (3C) Israeli Fund of Funds IL",
    "HebrewName": "איביאי וינשטיין אגדישראל",
    "HebrewLongName": "אי.בי.אי. ויינשטיין (3C) אגד ישראלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Fund of Funds",
    "SecondaryClassification": "Israeli Fund of Funds",
    "AssetValue": 11.6,
    "MonthYield": 0.7,
    "YearYield": 0.7,
    "Last12MonthYield": null,
    "ISIN": "IL0051407513"
  },
  {
    "Id": "TASE:5100144",
    "MayaId": "5100144",
    "Name": "I.B.I. YETER",
    "ShortName": "I.B.I. YETER",
    "Symbol": "TASE:5100144",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (4A) YETER IL",
    "EnglishLongName": "I.B.I. (4A) YETER IL",
    "HebrewName": "איביאי יתר",
    "HebrewLongName": "אי.בי.אי. (4A) יתר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.71,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.1,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 48.8,
    "MonthYield": 6.97,
    "YearYield": 6.97,
    "Last12MonthYield": 41.4,
    "ISIN": "IL0051001449"
  },
  {
    "Id": "TASE:5126214",
    "MayaId": "5126214",
    "Name": "I.B.I.Corp Portfolio+10%",
    "ShortName": "I.B.I.Corp Portfolio+10%",
    "Symbol": "TASE:5126214",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I.(1A) Corporate Portfolio +10% IL",
    "EnglishLongName": "I.B.I.(1A) Corporate Portfolio +10% IL",
    "HebrewName": "איביאי תיק קונצרני + 10%",
    "HebrewLongName": "אי.בי.אי. (1A) תיק קונצרני + 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.31,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles with Equity",
    "AssetValue": 47.9,
    "MonthYield": 0.97,
    "YearYield": 0.97,
    "Last12MonthYield": 9.45,
    "ISIN": "IL0051262140"
  },
  {
    "Id": "TASE:5120662",
    "MayaId": "5120662",
    "Name": "I.B.I.Fixed Incm Port+10%",
    "ShortName": "I.B.I.Fixed Incm Port+10%",
    "Symbol": "TASE:5120662",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (1B)(!) Fixed Income Portfolio+10% IL",
    "EnglishLongName": "I.B.I. (1B)(!) Fixed Income Portfolio+10% IL",
    "HebrewName": "איביאי תיק אג\"ח+10%",
    "HebrewLongName": "אי.בי.אי. (1B)(!) תיק אג\"ח + 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.38,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 776.2,
    "MonthYield": 1.3,
    "YearYield": 1.3,
    "Last12MonthYield": 11.7,
    "ISIN": "IL0051206626"
  },
  {
    "Id": "TASE:5139597",
    "MayaId": "5139597",
    "Name": "I.B.I.H Y Opportunities B",
    "ShortName": "I.B.I.H Y Opportunities B",
    "Symbol": "TASE:5139597",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (1B)(!) High Yield Opportunities Bonds IL",
    "EnglishLongName": "I.B.I. (1B)(!) High Yield Opportunities Bonds IL",
    "HebrewName": "איביאי הזדמנ אג\"ח תשואה ג",
    "HebrewLongName": "אי.בי.אי. (1B)(!) הזדמנויות אג\"ח תשואה גבוהה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.95,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.26,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Hi-risk Corporate & Convertibles",
    "AssetValue": 37.0,
    "MonthYield": 1.26,
    "YearYield": 1.26,
    "Last12MonthYield": 9.29,
    "ISIN": "IL0051395973"
  },
  {
    "Id": "TASE:5133137",
    "MayaId": "5133137",
    "Name": "I.B.I.Linked 90/20",
    "ShortName": "I.B.I.Linked 90/20",
    "Symbol": "TASE:5133137",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (2C) Linked 90/20 IL",
    "EnglishLongName": "I.B.I. (2C) Linked 90/20 IL",
    "HebrewName": "איביאיצמוד 20/90",
    "HebrewLongName": "אי.בי.אי. (2C) צמודה 20/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Leveraged and Strategic",
    "SecondaryClassification": "Strategic (not leveraged)",
    "AssetValue": 673.6,
    "MonthYield": 0.21,
    "YearYield": 0.21,
    "Last12MonthYield": 10.59,
    "ISIN": "IL0051331374"
  },
  {
    "Id": "TASE:5117627",
    "MayaId": "5117627",
    "Name": "I.B.I.MEHAKACOMBGOV",
    "ShortName": "I.B.I.MEHAKACOMBGOV",
    "Symbol": "TASE:5117627",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00) COMPOSITE GOVERNMENT MONTHLY IL",
    "EnglishLongName": "I.B.I. MEHAKA (00) COMPOSITE GOVERNMENT MONTHLY IL",
    "HebrewName": "איביאי מחקה מש ממשלתי",
    "HebrewLongName": "אי.בי.אי. מחקה (00) משולבת ממשלתי חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.36,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Composite Government Bond - No Equity",
    "AssetValue": 35.4,
    "MonthYield": 0.44,
    "YearYield": 0.44,
    "Last12MonthYield": 6.26,
    "ISIN": "IL0051176274"
  },
  {
    "Id": "TASE:5140462",
    "MayaId": "5140462",
    "Name": "I.B.I.Rated A and Above",
    "ShortName": "I.B.I.Rated A and Above",
    "Symbol": "TASE:5140462",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I.(0B) Rated A and Above IL",
    "EnglishLongName": "I.B.I.(0B) Rated A and Above IL",
    "HebrewName": "איביאי מדורגות A ומעלה",
    "HebrewLongName": "אי.בי.אי. (0B) מדורגות A ומעלה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 0.8,
    "MonthYield": 0.71,
    "YearYield": 0.71,
    "Last12MonthYield": null,
    "ISIN": "IL0051404627"
  },
  {
    "Id": "TASE:5140611",
    "MayaId": "5140611",
    "Name": "I.B.I.Rated Corporate",
    "ShortName": "I.B.I.Rated Corporate",
    "Symbol": "TASE:5140611",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I.(0A) Rated Corporate IL",
    "EnglishLongName": "I.B.I.(0A) Rated Corporate IL",
    "HebrewName": "איביאי קונצרני מדורג",
    "HebrewLongName": "אי.בי.אי. (0A) קונצרני מדורג",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 3.5,
    "MonthYield": 0.83,
    "YearYield": 0.83,
    "Last12MonthYield": null,
    "ISIN": "IL0051406119"
  },
  {
    "Id": "TASE:5126586",
    "MayaId": "5126586",
    "Name": "I.B.I.Shekel Corp Bond",
    "ShortName": "I.B.I.Shekel Corp Bond",
    "Symbol": "TASE:5126586",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (00) Shekel Corporate Bonds IL",
    "EnglishLongName": "I.B.I. (00) Shekel Corporate Bonds IL",
    "HebrewName": "איביאי אג\"ח חברות שקלי",
    "HebrewLongName": "אי.בי.אי. (00) אג\"ח חברות שקלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Shekel Corporate and Convertibles - No Equity",
    "AssetValue": 34.8,
    "MonthYield": 0.97,
    "YearYield": 0.97,
    "Last12MonthYield": 8.27,
    "ISIN": "IL0051265861"
  },
  {
    "Id": "TASE:5101902",
    "MayaId": "5101902",
    "Name": "IBI AG$HUL 3YR",
    "ShortName": "IBI AG$HUL 3YR",
    "Symbol": "TASE:5101902",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (0D) $ Denominated global Dollar Bonds Portfolio up to 3 Years",
    "EnglishLongName": "I.B.I. (0D) $ Denominated global Dollar Bonds Portfolio up to 3 Years",
    "HebrewName": "איביאי 0D אגחול$ נק$ 3שני",
    "HebrewLongName": "אי.בי.אי. (0D) אג\"ח $ חו\"ל נקובה $ - תיק עד 3 שנים",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.66,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.16,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Bonds",
    "AssetValue": 34.6,
    "MonthYield": -0.97,
    "YearYield": -0.97,
    "Last12MonthYield": -8.57,
    "ISIN": "IL0051019029"
  },
  {
    "Id": "TASE:5104393",
    "MayaId": "5104393",
    "Name": "IBI AGACH $ BNL",
    "ShortName": "IBI AGACH $ BNL",
    "Symbol": "TASE:5104393",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "IBI (0D)(!) INTERNATIONAL $ BONDS",
    "EnglishLongName": "IBI (0D)(!) INTERNATIONAL $ BONDS",
    "HebrewName": "איביאי 0D ! אג דולר בינ\"ל",
    "HebrewLongName": "אי.בי.אי. (0D)(!) אג\"ח דולר בינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.98,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.06,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "Dollar Bond",
    "AssetValue": 135.2,
    "MonthYield": -1.12,
    "YearYield": -1.12,
    "Last12MonthYield": -6.73,
    "ISIN": "IL0051043938"
  },
  {
    "Id": "TASE:5100615",
    "MayaId": "5100615",
    "Name": "IBI AGACH EURO",
    "ShortName": "IBI AGACH EURO",
    "Symbol": "TASE:5100615",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "IBI (0D)(!) INTERNATIONAL EURO BOND FUND",
    "EnglishLongName": "IBI (0D)(!) INTERNATIONAL EURO BOND FUND",
    "HebrewName": "איביאי 0D ! אג יורו בינ\"ל",
    "HebrewLongName": "אי.בי.אי. (0D)(!) אג\"ח יורו בינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.0,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.04,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Bond",
    "AssetValue": 2.7,
    "MonthYield": -2.24,
    "YearYield": -2.24,
    "Last12MonthYield": -0.53,
    "ISIN": "IL0051006158"
  },
  {
    "Id": "TASE:5107362",
    "MayaId": "5107362",
    "Name": "IBI AGCH GLOBAL",
    "ShortName": "IBI AGCH GLOBAL",
    "Symbol": "TASE:5107362",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (0D) GLOBAL BOND",
    "EnglishLongName": "I.B.I. (0D) GLOBAL BOND",
    "HebrewName": "איביאי 0D אג\"ח גלובלי",
    "HebrewLongName": "אי.בי.אי. (0D) אג\"ח גלובלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.97,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.05,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Bond",
    "AssetValue": 7.9,
    "MonthYield": -1.11,
    "YearYield": -1.11,
    "Last12MonthYield": -6.52,
    "ISIN": "IL0051073620"
  },
  {
    "Id": "TASE:5119839",
    "MayaId": "5119839",
    "Name": "IBI CHUL MNUTRL",
    "ShortName": "IBI CHUL MNUTRL",
    "Symbol": "TASE:5119839",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (0A)(!) FOREIGN CURRENCY HEDGED GLOBAL BOND",
    "EnglishLongName": "I.B.I. (0A)(!) FOREIGN CURRENCY HEDGED GLOBAL BOND",
    "HebrewName": "איביאי אגח חול מנוטרל מטח",
    "HebrewLongName": "אי. בי. אי. (0A)(!) אג\"ח חו\"ל מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.24,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX-Protected Bonds",
    "AssetValue": 21.6,
    "MonthYield": 0.16,
    "YearYield": 0.16,
    "Last12MonthYield": 5.53,
    "ISIN": "IL0051198393"
  },
  {
    "Id": "TASE:5127493",
    "MayaId": "5127493",
    "Name": "IBI D.A. MODEL",
    "ShortName": "IBI D.A. MODEL",
    "Symbol": "TASE:5127493",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (4D) D.A. MODEL",
    "EnglishLongName": "I.B.I. (4D) D.A. MODEL",
    "HebrewName": "איביאי D.A. MODEL 4D",
    "HebrewLongName": "אי.בי.אי. (D.A. MODEL (4D",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.35,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.84,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Geographical stocks",
    "AssetValue": 2.4,
    "MonthYield": 1.28,
    "YearYield": 1.28,
    "Last12MonthYield": -6.64,
    "ISIN": "IL0051274939"
  },
  {
    "Id": "TASE:5141189",
    "MayaId": "5141189",
    "Name": "IBI Defense Industr Is Eq",
    "ShortName": "IBI Defense Industr Is Eq",
    "Symbol": "TASE:5141189",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (4B) Defense Industries Israeli Equities IL",
    "EnglishLongName": "I.B.I. (4B) Defense Industries Israeli Equities IL",
    "HebrewName": "איביאי מניות תעש ביטח ישר",
    "HebrewLongName": "אי.בי.אי. (4B) מניות תעשיות ביטחוניות ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.95,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sectors",
    "AssetValue": 367.7,
    "MonthYield": 22.09,
    "YearYield": 22.09,
    "Last12MonthYield": null,
    "ISIN": "IL0051411895"
  },
  {
    "Id": "TASE:5141387",
    "MayaId": "5141387",
    "Name": "IBI Foreign Equity 30%",
    "ShortName": "IBI Foreign Equity 30%",
    "Symbol": "TASE:5141387",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (4B) Portfolio Foreign Equity UP TO 30% Foreign Currency",
    "EnglishLongName": "I.B.I. (4B) Portfolio Foreign Equity UP TO 30% Foreign Currency",
    "HebrewName": "איביאי מניות חו\"ל עד 30%",
    "HebrewLongName": "אי.בי.אי. (4B) תיק מניות חו\"ל עד 30% מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 0.1,
    "MonthYield": 8.19,
    "YearYield": 8.19,
    "Last12MonthYield": null,
    "ISIN": "IL0051413875"
  },
  {
    "Id": "TASE:5100482",
    "MayaId": "5100482",
    "Name": "IBI GLOBL ECUTY",
    "ShortName": "IBI GLOBL ECUTY",
    "Symbol": "TASE:5100482",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "IBI (4D) GLOBAL EQUITY",
    "EnglishLongName": "IBI (4D) GLOBAL EQUITY",
    "HebrewName": "איביאי 4D גלובל אקוויטי",
    "HebrewLongName": "אי.בי.אי. (4D) גלובל אקוויטי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.1,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.14,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 108.6,
    "MonthYield": 1.21,
    "YearYield": 1.21,
    "Last12MonthYield": 2.67,
    "ISIN": "IL0051004823"
  },
  {
    "Id": "TASE:5141106",
    "MayaId": "5141106",
    "Name": "IBI GOVERNMENT +20%",
    "ShortName": "IBI GOVERNMENT +20%",
    "Symbol": "TASE:5141106",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (2B) GOVERNMENT+20% IL",
    "EnglishLongName": "I.B.I. (2B) GOVERNMENT+20% IL",
    "HebrewName": "איביאי מדינה +20%",
    "HebrewLongName": "אי.בי.אי. (2B) מדינה + 20%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bonds - General - Up to 20% Equity",
    "AssetValue": 11.2,
    "MonthYield": 1.28,
    "YearYield": 1.28,
    "Last12MonthYield": null,
    "ISIN": "IL0051411069"
  },
  {
    "Id": "IBI.TA",
    "MayaId": "175018",
    "Name": "IBI INV HOUSE",
    "ShortName": "I.B.I INVESTMENT HOUSE LTD",
    "Symbol": "IBI.TA",
    "TaseSymbol": "IBI",
    "YahooId": "IBI.TA",
    "EnglishName": "IBI INV HOUSE",
    "EnglishLongName": "I.B.I INVESTMENT HOUSE LTD",
    "HebrewName": "איביאי בית השק",
    "HebrewLongName": "אי.בי.אי. בית השקעות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 33110.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Financial Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 14.0,
    "YearYield": 14.0,
    "Last12MonthYield": null,
    "ISIN": "IL0001750186"
  },
  {
    "Id": "TASE:5130067",
    "MayaId": "5130067",
    "Name": "IBI LVRG STRTGY",
    "ShortName": "IBI LVRG STRTGY",
    "Symbol": "TASE:5130067",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (6F) - Leveraged Strategy",
    "EnglishLongName": "I.B.I. (6F) - Leveraged Strategy",
    "HebrewName": "איביאי אסטרטגיות ממונפת",
    "HebrewLongName": "אי.בי.אי. (6F) אסטרטגיות - ממונפת",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.0,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": true,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.68,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Leveraged and Strategic",
    "SecondaryClassification": "Leveraged, High-Risk",
    "AssetValue": 389.3,
    "MonthYield": 0.87,
    "YearYield": 0.87,
    "Last12MonthYield": 18.22,
    "ISIN": "IL0051300676"
  },
  {
    "Id": "TASE:5133673",
    "MayaId": "5133673",
    "Name": "IBI MEHAKA A AA 0 2$",
    "ShortName": "IBI MEHAKA A-AA 0-2$",
    "Symbol": "TASE:5133673",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "$ I.B.I. MEHAKA (0D) Index 0-2 Non Linked A-AA IL-Denominated in",
    "EnglishLongName": "$ I.B.I. MEHAKA (0D) Index 0-2 Non Linked A-AA IL-Denominated in",
    "HebrewName": "איביאי מחקה אינA-AA 0-2 $",
    "HebrewLongName": "אי.בי.אי. מחקה (0D) אינדקס A-AA שקלי 0-2-נקובה $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.17,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 22.7,
    "MonthYield": -0.45,
    "YearYield": -0.45,
    "Last12MonthYield": -7.6,
    "ISIN": "IL0051336738"
  },
  {
    "Id": "TASE:5137989",
    "MayaId": "5137989",
    "Name": "IBI MEHAKA A AAA CPIL 1 4",
    "ShortName": "IBI MEHAKA A-AAA CPIL 1-4",
    "Symbol": "TASE:5137989",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00) Index A-AAA CPI Linked 1-4 IL",
    "EnglishLongName": "I.B.I. MEHAKA (00) Index A-AAA CPI Linked 1-4 IL",
    "HebrewName": "איביאי מחקה A-AAA צמד 1-4",
    "HebrewLongName": "אי.בי.אי. מחקה (00) אינדקס A-AAA צמוד 1-4",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.2,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 127.0,
    "MonthYield": 0.2,
    "YearYield": 0.2,
    "Last12MonthYield": 5.63,
    "ISIN": "IL0051379894"
  },
  {
    "Id": "TASE:5137542",
    "MayaId": "5137542",
    "Name": "IBI MEHAKA A AAA shkl 1 4",
    "ShortName": "IBI MEHAKA A-AAA shkl 1-4",
    "Symbol": "TASE:5137542",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00) Index A-AAA Shekel 1-4 IL",
    "EnglishLongName": "I.B.I. MEHAKA (00) Index A-AAA Shekel 1-4 IL",
    "HebrewName": "איביאי מחקה A-AAA שקל 1-4",
    "HebrewLongName": "אי.בי.אי. מחקה (00) אינדקס A-AAA שקלי 1-4",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 97.3,
    "MonthYield": 0.79,
    "YearYield": 0.79,
    "Last12MonthYield": 7.26,
    "ISIN": "IL0051375421"
  },
  {
    "Id": "TASE:5138169",
    "MayaId": "5138169",
    "Name": "IBI MEHAKA A AAA shkl 3 6",
    "ShortName": "IBI MEHAKA A-AAA shkl 3-6",
    "Symbol": "TASE:5138169",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00) Index A-AAA Shekel 3-6 IL",
    "EnglishLongName": "I.B.I. MEHAKA (00) Index A-AAA Shekel 3-6 IL",
    "HebrewName": "איביאי מחקה A-AAA שקל 3-6",
    "HebrewLongName": "אי.בי.אי. מחקה (00) אינדקס A-AAA שקלי 3-6",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.47,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 88.4,
    "MonthYield": 1.1,
    "YearYield": 1.1,
    "Last12MonthYield": 9.52,
    "ISIN": "IL0051381692"
  },
  {
    "Id": "TASE:5130703",
    "MayaId": "5130703",
    "Name": "IBI MEHAKA A AASpreadM",
    "ShortName": "IBI MEHAKA A-AASpreadM",
    "Symbol": "TASE:5130703",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00) Index A-AA Spread Mechanism IL",
    "EnglishLongName": "I.B.I. MEHAKA (00) Index A-AA Spread Mechanism IL",
    "HebrewName": "איביאי מחקה איA-AAמנ-מרוח",
    "HebrewLongName": "אי.בי.אי. מחקה‏ (00) אינדקס A-AA מנגנון מרווח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.3,
    "TrusteeFee": 0.02,
    "VariableFee": 0.03,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.31,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 539.3,
    "MonthYield": 0.53,
    "YearYield": 0.53,
    "Last12MonthYield": 7.31,
    "ISIN": "IL0051307036"
  },
  {
    "Id": "TASE:5122460",
    "MayaId": "5122460",
    "Name": "IBI MEHAKA A Balanced",
    "ShortName": "IBI MEHAKA A Balanced",
    "Symbol": "TASE:5122460",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00) Index A Balanced IL",
    "EnglishLongName": "I.B.I. MEHAKA (00) Index A Balanced IL",
    "HebrewName": "איביאי מחקה אינדקסA מאוזן",
    "HebrewLongName": "אי.בי.אי. מחקה‏ (00) אינדקס A מאוזן",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.3,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 217.5,
    "MonthYield": 0.57,
    "YearYield": 0.57,
    "Last12MonthYield": 6.75,
    "ISIN": "IL0051224603"
  },
  {
    "Id": "TASE:5131602",
    "MayaId": "5131602",
    "Name": "IBI MEHAKA A IssuerCap",
    "ShortName": "IBI MEHAKA A IssuerCap",
    "Symbol": "TASE:5131602",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00) Index A Issuer Capped IL",
    "EnglishLongName": "I.B.I. MEHAKA (00) Index A Issuer Capped IL",
    "HebrewName": "איביאי מחקה אינAתקרתמנפיק",
    "HebrewLongName": "אי.בי.אי. מחקה (00) אינדקס A תקרת מנפיק",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.3,
    "TrusteeFee": 0.02,
    "VariableFee": 0.03,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 487.0,
    "MonthYield": 0.69,
    "YearYield": 0.69,
    "Last12MonthYield": 6.89,
    "ISIN": "IL0051316029"
  },
  {
    "Id": "TASE:5122478",
    "MayaId": "5122478",
    "Name": "IBI MEHAKA AA Balanced",
    "ShortName": "IBI MEHAKA AA Balanced",
    "Symbol": "TASE:5122478",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00) Index AA & up Balanced IL",
    "EnglishLongName": "I.B.I. MEHAKA (00) Index AA & up Balanced IL",
    "HebrewName": "איביאי מחקה אינAA מע-מאזן",
    "HebrewLongName": "אי.בי.אי. מחקה‏ (00) אינדקס ‏‎ AAומעלה מאוזן",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.3,
    "TrusteeFee": 0.025,
    "VariableFee": 0.03,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 471.4,
    "MonthYield": 0.52,
    "YearYield": 0.52,
    "Last12MonthYield": 7.06,
    "ISIN": "IL0051224785"
  },
  {
    "Id": "TASE:5120563",
    "MayaId": "5120563",
    "Name": "IBI MEHAKA All Bond FloaS",
    "ShortName": "IBI MEHAKA All-Bond-FloaS",
    "Symbol": "TASE:5120563",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00) All-Bond-Floating Shekel IL",
    "EnglishLongName": "I.B.I. MEHAKA (00) All-Bond-Floating Shekel IL",
    "HebrewName": "איביאי מחקה All-Bondרמששק",
    "HebrewLongName": "אי.בי.אי. מחקה (00) All-Bond-ריבית משתנה שקלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.03,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 16.8,
    "MonthYield": 0.17,
    "YearYield": 0.17,
    "Last12MonthYield": 5.09,
    "ISIN": "IL0051205636"
  },
  {
    "Id": "TASE:5137963",
    "MayaId": "5137963",
    "Name": "IBI MEHAKA B HighS0 2",
    "ShortName": "IBI MEHAKA B-HighS0-2",
    "Symbol": "TASE:5137963",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00) Index Bonds High Spread-Duration 0-2 IL",
    "EnglishLongName": "I.B.I. MEHAKA (00) Index Bonds High Spread-Duration 0-2 IL",
    "HebrewName": "איביאי מחקה אינאגחמר-ג0-2",
    "HebrewLongName": "אי.בי.אי. מחקה (00) אינדקס אג\"ח במרווח גבוה-מח\"מ 0-2",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.35,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.21,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 274.1,
    "MonthYield": 0.58,
    "YearYield": 0.58,
    "Last12MonthYield": 5.51,
    "ISIN": "IL0051379639"
  },
  {
    "Id": "TASE:5130299",
    "MayaId": "5130299",
    "Name": "IBI MEHAKA BDef&Cy&Inte",
    "ShortName": "IBI MEHAKA BDef&Cy&Inte",
    "Symbol": "TASE:5130299",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4D) BlueStar Defense & Cyber & Intelligence",
    "EnglishLongName": "I.B.I. MEHAKA (4D) BlueStar Defense & Cyber & Intelligence",
    "HebrewName": "איביאי מחקה BDef&Cy&Intel",
    "HebrewLongName": "אי.בי.אי. מחקה (4D)י BlueStar Defense & Cyber & Intelligence",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.22,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 11.3,
    "MonthYield": 4.72,
    "YearYield": 4.72,
    "Last12MonthYield": 18.86,
    "ISIN": "IL0051302995"
  },
  {
    "Id": "TASE:5134812",
    "MayaId": "5134812",
    "Name": "IBI MEHAKA BloomUSCorp1 5",
    "ShortName": "IBI MEHAKA BloomUSCorp1-5",
    "Symbol": "TASE:5134812",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (0D) Bloomberg US Corporate 1-5 Years",
    "EnglishLongName": "I.B.I. MEHAKA (0D) Bloomberg US Corporate 1-5 Years",
    "HebrewName": "איביאי מחקה BloomUSCor1-5",
    "HebrewLongName": "אי.בי.אי. מחקה (0D)י Bloomberg US Corporate 1-5 Years",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.11,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Corporate and Convertibles - Medium",
    "AssetValue": 101.2,
    "MonthYield": -1.31,
    "YearYield": -1.31,
    "Last12MonthYield": -8.22,
    "ISIN": "IL0051348121"
  },
  {
    "Id": "TASE:5134838",
    "MayaId": "5134838",
    "Name": "IBI MEHAKA BlooUSCorp1 5H",
    "ShortName": "IBI MEHAKA BlooUSCorp1-5H",
    "Symbol": "TASE:5134838",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (0A) Bloomberg US Corporate 1-5 Years Currency-Hedged",
    "EnglishLongName": "I.B.I. MEHAKA (0A) Bloomberg US Corporate 1-5 Years Currency-Hedged",
    "HebrewName": "איביאי מחקהBlooUSCor1-5ממ",
    "HebrewLongName": "אי.בי.אי. מחקה (0A)י Bloomberg US Corporate 1-5 Years מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.2,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Hedged Corporate and Convertibles - Medium",
    "AssetValue": 210.1,
    "MonthYield": 0.05,
    "YearYield": 0.05,
    "Last12MonthYield": 5.73,
    "ISIN": "IL0051348386"
  },
  {
    "Id": "TASE:5134820",
    "MayaId": "5134820",
    "Name": "IBI MEHAKA BloUSInterCrdt",
    "ShortName": "IBI MEHAKA BloUSInterCrdt",
    "Symbol": "TASE:5134820",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (0D) Bloomberg US Intermediate Credit",
    "EnglishLongName": "I.B.I. MEHAKA (0D) Bloomberg US Intermediate Credit",
    "HebrewName": "איביאי מחקהBlooUSInterCrt",
    "HebrewLongName": "אי.בי.אי. מחקה (0D)י Bloomberg US Intermediate Credit",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.3,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.05,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "Foreign Bonds - Other",
    "AssetValue": 11.9,
    "MonthYield": -1.12,
    "YearYield": -1.12,
    "Last12MonthYield": -7.22,
    "ISIN": "IL0051348204"
  },
  {
    "Id": "TASE:5132626",
    "MayaId": "5132626",
    "Name": "IBI MEHAKA BndHighSprd",
    "ShortName": "IBI MEHAKA BndHighSprd",
    "Symbol": "TASE:5132626",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00) Index Bonds High Spread IL",
    "EnglishLongName": "I.B.I. MEHAKA (00) Index Bonds High Spread IL",
    "HebrewName": "איביאי מחקה אינאגח מ-גבוה",
    "HebrewLongName": "אי.בי.אי. מחקה (00) אינדקס אג\"ח במרווח גבוה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.3,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.31,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 330.1,
    "MonthYield": 0.67,
    "YearYield": 0.67,
    "Last12MonthYield": 7.38,
    "ISIN": "IL0051326267"
  },
  {
    "Id": "TASE:5133996",
    "MayaId": "5133996",
    "Name": "IBI MEHAKA Co RE EQ ILMO",
    "ShortName": "IBI MEHAKA Co RE EQ ILMO",
    "Symbol": "TASE:5133996",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A) Composite Israeli Real estate Equities Monthly IL",
    "EnglishLongName": "I.B.I. MEHAKA (4A) Composite Israeli Real estate Equities Monthly IL",
    "HebrewName": "איביאי מחקה מש מנ נדיש חד",
    "HebrewLongName": "אי.בי.אי. מחקה (4A) משולבת מניות נדל\"ן ישראליות חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.25,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks in Israel, Composite",
    "AssetValue": 14.6,
    "MonthYield": 8.86,
    "YearYield": 8.86,
    "Last12MonthYield": 21.64,
    "ISIN": "IL0051339963"
  },
  {
    "Id": "TASE:5123930",
    "MayaId": "5123930",
    "Name": "IBI MEHAKA Collateral",
    "ShortName": "IBI MEHAKA Collateral",
    "Symbol": "TASE:5123930",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00)(!) Index Bonds with Collateral Component IL",
    "EnglishLongName": "I.B.I. MEHAKA (00)(!) Index Bonds with Collateral Component IL",
    "HebrewName": "איביאי מחקה איאגח-ר-בטוחה",
    "HebrewLongName": "אי.בי.אי. מחקה (00)(!) אינדקס אג\"ח עם רכיב בטוחה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.2,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 149.4,
    "MonthYield": 0.49,
    "YearYield": 0.49,
    "Last12MonthYield": 6.1,
    "ISIN": "IL0051239304"
  },
  {
    "Id": "TASE:5119904",
    "MayaId": "5119904",
    "Name": "IBI MEHAKA ComIsrael B",
    "ShortName": "IBI MEHAKA ComIsrael-B",
    "Symbol": "TASE:5119904",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (0A) Composite Israel Bonds (100%) Monthly IL",
    "EnglishLongName": "I.B.I. MEHAKA (0A) Composite Israel Bonds (100%) Monthly IL",
    "HebrewName": "איביאי מחקה משולב אג\"ח יש",
    "HebrewLongName": "אי.בי.אי. מחקה (0A) משולבת אג\"ח ישראל (100%) חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Composite Bonds",
    "SecondaryClassification": "No Equity",
    "AssetValue": 52.7,
    "MonthYield": 0.45,
    "YearYield": 0.45,
    "Last12MonthYield": 6.1,
    "ISIN": "IL0051199045"
  },
  {
    "Id": "TASE:5132063",
    "MayaId": "5132063",
    "Name": "IBI MEHAKA CoSPUSSector H",
    "ShortName": "IBI MEHAKA CoSPUSSector H",
    "Symbol": "TASE:5132063",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A) Comp. S&P US Select Sector Monthly Currency-Hedged",
    "EnglishLongName": "I.B.I. MEHAKA (4A) Comp. S&P US Select Sector Monthly Currency-Hedged",
    "HebrewName": "איביאי מחקה משSPסקטורUSממ",
    "HebrewLongName": "אי.בי.אי. מחקה (4A) משולבת S&P סקטורים ארה\"ב חודשי מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.67,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks Abroad, Composite",
    "AssetValue": 22.0,
    "MonthYield": 0.52,
    "YearYield": 0.52,
    "Last12MonthYield": 16.46,
    "ISIN": "IL0051320633"
  },
  {
    "Id": "TASE:5121470",
    "MayaId": "5121470",
    "Name": "IBI MEHAKA DAX CURHED",
    "ShortName": "IBI MEHAKA DAX CURHED",
    "Symbol": "TASE:5121470",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A) DAX Currency Hedged",
    "EnglishLongName": "I.B.I. MEHAKA (4A) DAX Currency Hedged",
    "HebrewName": "איביאי מחקה DAX ממ",
    "HebrewLongName": "אי.בי.אי. מחקה (4A)י DAX מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.39,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 45.2,
    "MonthYield": 3.53,
    "YearYield": 3.53,
    "Last12MonthYield": 27.44,
    "ISIN": "IL0051214703"
  },
  {
    "Id": "TASE:5137237",
    "MayaId": "5137237",
    "Name": "IBI MEHAKA DivEquPayou",
    "ShortName": "IBI MEHAKA DivEquPayou",
    "Symbol": "TASE:5137237",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A) Index Israel Dividend Equities Payout IL",
    "EnglishLongName": "I.B.I. MEHAKA (4A) Index Israel Dividend Equities Payout IL",
    "HebrewName": "איביאי מחקה אינ דיב מחלק",
    "HebrewLongName": "אי.בי.אי. מחקה (4A) אינדקס מניות דיבידנד ישראל מחלקת",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.98,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 64.7,
    "MonthYield": 4.22,
    "YearYield": 4.22,
    "Last12MonthYield": 48.69,
    "ISIN": "IL0051372378"
  },
  {
    "Id": "TASE:5132329",
    "MayaId": "5132329",
    "Name": "IBI MEHAKA DJ Asia Div30",
    "ShortName": "IBI MEHAKA DJ Asia Div30",
    "Symbol": "TASE:5132329",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4D) DJ Asia Dividend 30",
    "EnglishLongName": "I.B.I. MEHAKA (4D) DJ Asia Dividend 30",
    "HebrewName": "איביאי מחקה DJ Asia Div30",
    "HebrewLongName": "אי.בי.אי. מחקה (4D)י DJ Asia Dividend 30",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.46,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 16.0,
    "MonthYield": 0.1,
    "YearYield": 0.1,
    "Last12MonthYield": 18.85,
    "ISIN": "IL0051323298"
  },
  {
    "Id": "TASE:5132071",
    "MayaId": "5132071",
    "Name": "IBI MEHAKA DJ Internet H",
    "ShortName": "IBI MEHAKA DJ Internet H",
    "Symbol": "TASE:5132071",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A) DJ Internet Composite Currency-Hedged",
    "EnglishLongName": "I.B.I. MEHAKA (4A) DJ Internet Composite Currency-Hedged",
    "HebrewName": "איביאי מחקה DJ Internetממ",
    "HebrewLongName": "אי.בי.אי. מחקה (4A)י DJ Internet Composite מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.8,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 33.4,
    "MonthYield": -2.03,
    "YearYield": -2.03,
    "Last12MonthYield": 5.4,
    "ISIN": "IL0051320716"
  },
  {
    "Id": "TASE:5131834",
    "MayaId": "5131834",
    "Name": "IBI MEHAKA DJ US RealEsta",
    "ShortName": "IBI MEHAKA DJ US RealEsta",
    "Symbol": "TASE:5131834",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4D) DJ US Real Estate",
    "EnglishLongName": "I.B.I. MEHAKA (4D) DJ US Real Estate",
    "HebrewName": "איביאי מחקה DJ US RealEst",
    "HebrewLongName": "אי.בי.אי. מחקה (4D)י DJ US Real Estate",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.02,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.75,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 137.9,
    "MonthYield": 1.89,
    "YearYield": 1.89,
    "Last12MonthYield": -9.14,
    "ISIN": "IL0051318348"
  },
  {
    "Id": "TASE:5135371",
    "MayaId": "5135371",
    "Name": "IBI MEHAKA Food Brands H",
    "ShortName": "IBI MEHAKA Food Brands H",
    "Symbol": "TASE:5135371",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4D) Index Food Brands Top 10 USD-Hedged",
    "EnglishLongName": "I.B.I. MEHAKA (4D) Index Food Brands Top 10 USD-Hedged",
    "HebrewName": "איביאי מחקה Food Brandsמד",
    "HebrewLongName": "אי.בי.אי. מחקה (4D)י אינדקס Food Brands Top 10 מנוטרלת דולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.023,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.9,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 3.1,
    "MonthYield": 0.59,
    "YearYield": 0.59,
    "Last12MonthYield": 5.11,
    "ISIN": "IL0051353717"
  },
  {
    "Id": "TASE:5135025",
    "MayaId": "5135025",
    "Name": "IBI MEHAKA GlCYBR EW US$H",
    "ShortName": "IBI MEHAKA GlCYBR EW US$H",
    "Symbol": "TASE:5135025",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4D) Index Global Cyber EW US$ - Hedged",
    "EnglishLongName": "I.B.I. MEHAKA (4D) Index Global Cyber EW US$ - Hedged",
    "HebrewName": "איביאי מחקה גל סיבר EW מד",
    "HebrewLongName": "אי.בי.אי. מחקה (4D) אינדקס סייבר גלובלי משקל שווה מנוטרלת דולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.23,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 5.6,
    "MonthYield": -0.32,
    "YearYield": -0.32,
    "Last12MonthYield": 1.62,
    "ISIN": "IL0051350259"
  },
  {
    "Id": "TASE:5134044",
    "MayaId": "5134044",
    "Name": "IBI MEHAKA GlFoodTec US$H",
    "ShortName": "IBI MEHAKA GlFoodTec US$H",
    "Symbol": "TASE:5134044",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4D) Index Global FoodTech US$ - Hedged",
    "EnglishLongName": "I.B.I. MEHAKA (4D) Index Global FoodTech US$ - Hedged",
    "HebrewName": "איביאי מחקה גלבל פודטק מד",
    "HebrewLongName": "אי.בי.אי. מחקה (4D) אינדקס פודטק גלובלי מנוטרלת דולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.55,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 1.8,
    "MonthYield": 5.26,
    "YearYield": 5.26,
    "Last12MonthYield": 5.23,
    "ISIN": "IL0051340441"
  },
  {
    "Id": "TASE:5137526",
    "MayaId": "5137526",
    "Name": "IBI MEHAKA Hcoup B Pay",
    "ShortName": "IBI MEHAKA Hcoup-B Pay",
    "Symbol": "TASE:5137526",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00) Index High Coupon Bonds Payout IL",
    "EnglishLongName": "I.B.I. MEHAKA (00) Index High Coupon Bonds Payout IL",
    "HebrewName": "איביאי מחקה אינ קו ג מחלק",
    "HebrewLongName": "אי.בי.אי. מחקה (00) אינדקס אג\"ח קופון גבוה מחלקת",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.24,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 14.7,
    "MonthYield": 0.82,
    "YearYield": 0.82,
    "Last12MonthYield": 6.53,
    "ISIN": "IL0051375264"
  },
  {
    "Id": "TASE:5134895",
    "MayaId": "5134895",
    "Name": "IBI MEHAKA iBoxx $ IG0 5H",
    "ShortName": "IBI MEHAKA iBoxx $ IG0-5H",
    "Symbol": "TASE:5134895",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (0A) iBoxx US Liquid Investment Grade 0-5 Years Currency-Hedged",
    "EnglishLongName": "I.B.I. MEHAKA (0A) iBoxx US Liquid Investment Grade 0-5 Years Currency-Hedged",
    "HebrewName": "איביאי מחקה iBox$ IG0-5ממ",
    "HebrewLongName": "אי.בי.אי. מחקה (0A)י iBoxx US Liquid Investment Grade 0-5 Years מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.3,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.12,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Hedged Corporate and Convertibles",
    "AssetValue": 74.1,
    "MonthYield": 0.09,
    "YearYield": 0.09,
    "Last12MonthYield": 5.23,
    "ISIN": "IL0051348956"
  },
  {
    "Id": "TASE:5135306",
    "MayaId": "5135306",
    "Name": "IBI MEHAKA iBoxx $ IG30 H",
    "ShortName": "IBI MEHAKA iBoxx $ IG30 H",
    "Symbol": "TASE:5135306",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (0A) iBoxx US Liquid Investment Grade Top 30 Currency-Hedged",
    "EnglishLongName": "I.B.I. MEHAKA (0A) iBoxx US Liquid Investment Grade Top 30 Currency-Hedged",
    "HebrewName": "איביאי מחקה iBox $ IG30ממ",
    "HebrewLongName": "אי.בי.אי. מחקה (0A)י iBoxx US Liquid Investment Grade Top 30 מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Hedged Corporate and Convertibles",
    "AssetValue": 12.1,
    "MonthYield": 0.08,
    "YearYield": 0.08,
    "Last12MonthYield": 7.11,
    "ISIN": "IL0051353063"
  },
  {
    "Id": "TASE:5133657",
    "MayaId": "5133657",
    "Name": "IBI MEHAKA IdxSemCEW US$H",
    "ShortName": "IBI MEHAKA IdxSemCEW US$H",
    "Symbol": "TASE:5133657",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4D) Index Global Semiconductor EW US$ - Hedged",
    "EnglishLongName": "I.B.I. MEHAKA (4D) Index Global Semiconductor EW US$ - Hedged",
    "HebrewName": "איביאי מחקה מוליכ גל EWמד",
    "HebrewLongName": "אי.בי.אי. מחקה (4D) אינדקס מוליכים למחצה גלובלי EW מנוטרלת דולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.98,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 41.2,
    "MonthYield": 15.04,
    "YearYield": 15.04,
    "Last12MonthYield": 56.99,
    "ISIN": "IL0051336571"
  },
  {
    "Id": "TASE:5139142",
    "MayaId": "5139142",
    "Name": "IBI MEHAKA IGov USD B 1 5",
    "ShortName": "IBI MEHAKA IGov USD B 1-5",
    "Symbol": "TASE:5139142",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (0D) Israeli Gov USD Bonds 1-5 iNDEX",
    "EnglishLongName": "I.B.I. MEHAKA (0D) Israeli Gov USD Bonds 1-5 iNDEX",
    "HebrewName": "איביאי מחקה מ ישראל ד 1-5",
    "HebrewLongName": "אי.בי.אי. מחקה (0D) אינדקס מדינת ישראל דולר 1-5",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.07,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Government - Medium",
    "AssetValue": 66.2,
    "MonthYield": -1.14,
    "YearYield": -1.14,
    "Last12MonthYield": -6.95,
    "ISIN": "IL0051391428"
  },
  {
    "Id": "TASE:5139159",
    "MayaId": "5139159",
    "Name": "IBI MEHAKA IGov USD B5 10",
    "ShortName": "IBI MEHAKA IGov USD B5-10",
    "Symbol": "TASE:5139159",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (0D) Israeli Gov USD Bonds 5-10 iNDEX",
    "EnglishLongName": "I.B.I. MEHAKA (0D) Israeli Gov USD Bonds 5-10 iNDEX",
    "HebrewName": "איביאי מחקה מ ישראל ד5-10",
    "HebrewLongName": "אי.בי.אי. מחקה (0D) אינדקס מדינת ישראל דולר 5-10",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.9,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Government - Long",
    "AssetValue": 75.2,
    "MonthYield": -1.18,
    "YearYield": -1.18,
    "Last12MonthYield": -3.83,
    "ISIN": "IL0051391592"
  },
  {
    "Id": "TASE:5135686",
    "MayaId": "5135686",
    "Name": "IBI MEHAKA IL womenleader",
    "ShortName": "IBI MEHAKA IL womenleader",
    "Symbol": "TASE:5135686",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A) Index Israel women leadership IL",
    "EnglishLongName": "I.B.I. MEHAKA (4A) Index Israel women leadership IL",
    "HebrewName": "איביאי מחקה ישר הנהגהנשית",
    "HebrewLongName": "אי.בי.אי. מחקה (4A) אינדקס ישראל הנהגה נשית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.7,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 2.3,
    "MonthYield": 7.92,
    "YearYield": 7.92,
    "Last12MonthYield": 58.83,
    "ISIN": "IL0051356868"
  },
  {
    "Id": "TASE:5132527",
    "MayaId": "5132527",
    "Name": "IBI MEHAKA ISECyberSecuri",
    "ShortName": "IBI MEHAKA ISECyberSecuri",
    "Symbol": "TASE:5132527",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4D) ISE Cyber Security",
    "EnglishLongName": "I.B.I. MEHAKA (4D) ISE Cyber Security",
    "HebrewName": "איביאי מחקה ISE CyberSecu",
    "HebrewLongName": "אי.בי.אי. מחקה (4D)י ISE Cyber Security",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.023,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.58,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 18.9,
    "MonthYield": -2.81,
    "YearYield": -2.81,
    "Last12MonthYield": -10.03,
    "ISIN": "IL0051325277"
  },
  {
    "Id": "TASE:5134168",
    "MayaId": "5134168",
    "Name": "IBI MEHAKA IsraelBanks",
    "ShortName": "IBI MEHAKA IsraelBanks",
    "Symbol": "TASE:5134168",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A) Index Israel Bank IL",
    "EnglishLongName": "I.B.I. MEHAKA (4A) Index Israel Bank IL",
    "HebrewName": "איביאי מחקה אינדק בנק-ישר",
    "HebrewLongName": "אי.בי.אי. מחקה (4A) אינדקס בנקים ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.98,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 641.0,
    "MonthYield": 9.41,
    "YearYield": 9.41,
    "Last12MonthYield": 70.48,
    "ISIN": "IL0051341688"
  },
  {
    "Id": "TASE:5121892",
    "MayaId": "5121892",
    "Name": "IBI MEHAKA IXMNTR CURHED",
    "ShortName": "IBI MEHAKA IXMNTR CURHED",
    "Symbol": "TASE:5121892",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A) S&P Financial Currency Hedged",
    "EnglishLongName": "I.B.I. MEHAKA (4A) S&P Financial Currency Hedged",
    "HebrewName": "איביאי מחקה SP Finance ממ",
    "HebrewLongName": "אי.בי.אי. מחקה (4A)י S&P Financial מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.74,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 31.7,
    "MonthYield": -0.76,
    "YearYield": -0.76,
    "Last12MonthYield": 10.87,
    "ISIN": "IL0051218928"
  },
  {
    "Id": "TASE:5132345",
    "MayaId": "5132345",
    "Name": "IBI MEHAKA Japan50Div CH",
    "ShortName": "IBI MEHAKA Japan50Div CH",
    "Symbol": "TASE:5132345",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A) Japan 50 Dividend iNDEX Currency-Hedged",
    "EnglishLongName": "I.B.I. MEHAKA (4A) Japan 50 Dividend iNDEX Currency-Hedged",
    "HebrewName": "איביאי מחקה Japan50Div ממ",
    "HebrewLongName": "אי.בי.אי. מחקה (4A)י Japan 50 Dividend iNDEX מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.63,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 35.8,
    "MonthYield": 8.11,
    "YearYield": 8.11,
    "Last12MonthYield": 32.22,
    "ISIN": "IL0051323454"
  },
  {
    "Id": "TASE:5140066",
    "MayaId": "5140066",
    "Name": "IBI MEHAKA ls Resident RE",
    "ShortName": "IBI MEHAKA ls Resident RE",
    "Symbol": "TASE:5140066",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A) Index Israeli Residential Real Estate IL",
    "EnglishLongName": "I.B.I. MEHAKA (4A) Index Israeli Residential Real Estate IL",
    "HebrewName": "איביאי מחקה נדלןלמגורישרא",
    "HebrewLongName": "אי.בי.אי. מחקה (4A) אינדקס נדל\"ן למגורים בישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 4.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 15.5,
    "MonthYield": 10.23,
    "YearYield": 10.23,
    "Last12MonthYield": null,
    "ISIN": "IL0051400666"
  },
  {
    "Id": "TASE:5139605",
    "MayaId": "5139605",
    "Name": "IBI MEHAKA MSCI ACWorld",
    "ShortName": "IBI MEHAKA MSCI ACWorld",
    "Symbol": "TASE:5139605",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4D) MSCI AC World",
    "EnglishLongName": "I.B.I. MEHAKA (4D) MSCI AC World",
    "HebrewName": "איביאי מחקה MSCI ACWorld",
    "HebrewLongName": "אי.בי.אי. מחקה (4D)י MSCI AC World",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.023,
    "VariableFee": 0.15,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.05,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Global Stocks",
    "AssetValue": 45.1,
    "MonthYield": 0.24,
    "YearYield": 0.24,
    "Last12MonthYield": 5.95,
    "ISIN": "IL0051396054"
  },
  {
    "Id": "TASE:5140843",
    "MayaId": "5140843",
    "Name": "IBI MEHAKA MV G Defense",
    "ShortName": "IBI MEHAKA MV G Defense",
    "Symbol": "TASE:5140843",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4D) MarketVector Global Defense",
    "EnglishLongName": "I.B.I. MEHAKA (4D) MarketVector Global Defense",
    "HebrewName": "איביאי מחקה MV G Defense",
    "HebrewLongName": "אי.בי.אי. מחקה (4D)י MarketVector Global Defense",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.023,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 20.2,
    "MonthYield": 17.28,
    "YearYield": 17.28,
    "Last12MonthYield": null,
    "ISIN": "IL0051408438"
  },
  {
    "Id": "TASE:5127766",
    "MayaId": "5127766",
    "Name": "IBI MEHAKA Nasdaq 100",
    "ShortName": "IBI MEHAKA Nasdaq 100",
    "Symbol": "TASE:5127766",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4D) Nasdaq 100",
    "EnglishLongName": "I.B.I. MEHAKA (4D) Nasdaq 100",
    "HebrewName": "איביאי מחקה Nasdaq 100",
    "HebrewLongName": "אי.בי.אי. מחקה (4D)י Nasdaq 100",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.3,
    "TrusteeFee": 0.025,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.86,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 803.9,
    "MonthYield": -0.21,
    "YearYield": -0.21,
    "Last12MonthYield": 5.28,
    "ISIN": "IL0051277668"
  },
  {
    "Id": "TASE:5131644",
    "MayaId": "5131644",
    "Name": "IBI MEHAKA Nasdaq100 H",
    "ShortName": "IBI MEHAKA Nasdaq100 H",
    "Symbol": "TASE:5131644",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A) NASDAQ 100 Currency-Hedged",
    "EnglishLongName": "I.B.I. MEHAKA (4A) NASDAQ 100 Currency-Hedged",
    "HebrewName": "איביאי מחקה Nasdaq100 ממ",
    "HebrewLongName": "אי.בי.אי. מחקה (4A)י NASDAQ 100 מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.3,
    "TrusteeFee": 0.015,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.07,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 917.2,
    "MonthYield": 1.15,
    "YearYield": 1.15,
    "Last12MonthYield": 19.62,
    "ISIN": "IL0051316441"
  },
  {
    "Id": "TASE:5140298",
    "MayaId": "5140298",
    "Name": "IBI MEHAKA NuclearEneUSDH",
    "ShortName": "IBI MEHAKA NuclearEneUSDH",
    "Symbol": "TASE:5140298",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4D) Indxx Nuclear Energy Industry USD-Hedged",
    "EnglishLongName": "I.B.I. MEHAKA (4D) Indxx Nuclear Energy Industry USD-Hedged",
    "HebrewName": "איביאי מחקהNuclearEnergמד",
    "HebrewLongName": "אי.בי.אי. מחקה (4D)י Indxx Nuclear Energy Industry מנוטרלת דולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.023,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 5.54,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 261.6,
    "MonthYield": 23.04,
    "YearYield": 23.04,
    "Last12MonthYield": null,
    "ISIN": "IL0051402985"
  },
  {
    "Id": "TASE:5127469",
    "MayaId": "5127469",
    "Name": "IBI MEHAKA S&P 500",
    "ShortName": "IBI MEHAKA S&P 500",
    "Symbol": "TASE:5127469",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4D) S&P 500",
    "EnglishLongName": "I.B.I. MEHAKA (4D) S&P 500",
    "HebrewName": "איביאי מחקה S&P 500",
    "HebrewLongName": "אי.בי.אי. מחקה (4D)י S&P 500",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.025,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.39,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 1438.0,
    "MonthYield": 0.08,
    "YearYield": 0.08,
    "Last12MonthYield": 2.73,
    "ISIN": "IL0051274699"
  },
  {
    "Id": "TASE:5131628",
    "MayaId": "5131628",
    "Name": "IBI MEHAKA S&P 500 H",
    "ShortName": "IBI MEHAKA S&P 500 H",
    "Symbol": "TASE:5131628",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A) S&P 500 Currency-Hedged",
    "EnglishLongName": "I.B.I. MEHAKA (4A) S&P 500 Currency-Hedged",
    "HebrewName": "איביאי מחקה S&P 500 ממ",
    "HebrewLongName": "אי.בי.אי. מחקה (4A)י S&P 500 מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.015,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.6,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 1178.4,
    "MonthYield": 1.45,
    "YearYield": 1.45,
    "Last12MonthYield": 16.96,
    "ISIN": "IL0051316284"
  },
  {
    "Id": "TASE:5139910",
    "MayaId": "5139910",
    "Name": "IBI MEHAKA S&P Bitcoin",
    "ShortName": "IBI MEHAKA S&P Bitcoin",
    "Symbol": "TASE:5139910",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4D) S&P Bitcoin",
    "EnglishLongName": "I.B.I. MEHAKA (4D) S&P Bitcoin",
    "HebrewName": "איביאי מחקה S&P Bitcoin",
    "HebrewLongName": "אי.בי.אי. מחקה (4D)י S&P Bitcoin",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.023,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 4.5,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Digital Assets",
    "SecondaryClassification": "Bitcoin",
    "AssetValue": 43.1,
    "MonthYield": 7.34,
    "YearYield": 7.34,
    "Last12MonthYield": -13.25,
    "ISIN": "IL0051399108"
  },
  {
    "Id": "TASE:5141866",
    "MayaId": "5141866",
    "Name": "IBI MEHAKA S&P Bitcoin CH",
    "ShortName": "IBI MEHAKA S&P Bitcoin CH",
    "Symbol": "TASE:5141866",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A) S&P Bitcoin Currency-Hedged",
    "EnglishLongName": "I.B.I. MEHAKA (4A) S&P Bitcoin Currency-Hedged",
    "HebrewName": "איביאי מחקה S&P Bitcoinממ",
    "HebrewLongName": "אי.בי.אי. מחקה (4A)י S&P Bitcoin מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.023,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Digital Assets",
    "SecondaryClassification": "Bitcoin",
    "AssetValue": 0.2,
    "MonthYield": 8.8,
    "YearYield": 8.8,
    "Last12MonthYield": null,
    "ISIN": "IL0051418668"
  },
  {
    "Id": "TASE:5141858",
    "MayaId": "5141858",
    "Name": "IBI MEHAKA S&PEthereum CH",
    "ShortName": "IBI MEHAKA S&PEthereum CH",
    "Symbol": "TASE:5141858",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A) S&P Ethereum Currency-Hedged",
    "EnglishLongName": "I.B.I. MEHAKA (4A) S&P Ethereum Currency-Hedged",
    "HebrewName": "איביאי מחקה S&PEthereumממ",
    "HebrewLongName": "אי.בי.אי. מחקה (4A)י S&P Ethereum מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.023,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Digital Assets",
    "SecondaryClassification": "Ethereum",
    "AssetValue": 0.2,
    "MonthYield": 10.62,
    "YearYield": 10.62,
    "Last12MonthYield": null,
    "ISIN": "IL0051418585"
  },
  {
    "Id": "TASE:5134689",
    "MayaId": "5134689",
    "Name": "IBI MEHAKA ShilerCAPE®USH",
    "ShortName": "IBI MEHAKA ShilerCAPE®USH",
    "Symbol": "TASE:5134689",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA(4A)Shiller Barclays CAPE® US Core Mid-Month Sector Currency-Hedged",
    "EnglishLongName": "I.B.I. MEHAKA(4A)Shiller Barclays CAPE® US Core Mid-Month Sector Currency-Hedged",
    "HebrewName": "איביאי מחקה Shiller US ממ",
    "HebrewLongName": "אי.בי.אי. מחקה (4A)י Shiller Barclays CAPE® US Core Mid-Month Sector מנוטרלת מטח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.44,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 658.1,
    "MonthYield": 2.61,
    "YearYield": 2.61,
    "Last12MonthYield": 11.67,
    "ISIN": "IL0051346893"
  },
  {
    "Id": "TASE:5130737",
    "MayaId": "5130737",
    "Name": "IBI MEHAKA ShillerCAPE®US",
    "ShortName": "IBI MEHAKA ShillerCAPE®US",
    "Symbol": "TASE:5130737",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4D) Shiller Barclays CAPE® US Core Mid-Month Sector",
    "EnglishLongName": "I.B.I. MEHAKA (4D) Shiller Barclays CAPE® US Core Mid-Month Sector",
    "HebrewName": "איביאי מחקה ShilerCAPE®US",
    "HebrewLongName": "אי.בי.אי. מחקה (4D)י Shiller Barclays CAPE® US Core Mid-Month Sector",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.55,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 651.5,
    "MonthYield": 1.24,
    "YearYield": 1.24,
    "Last12MonthYield": -2.04,
    "ISIN": "IL0051307374"
  },
  {
    "Id": "TASE:5134887",
    "MayaId": "5134887",
    "Name": "IBI MEHAKA SP 500 LVHD",
    "ShortName": "IBI MEHAKA SP 500 LVHD",
    "Symbol": "TASE:5134887",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4D) S&P 500 Low Volatility High Dividend",
    "EnglishLongName": "I.B.I. MEHAKA (4D) S&P 500 Low Volatility High Dividend",
    "HebrewName": "איביאי מחקה SP 500 LVHD",
    "HebrewLongName": "אי.בי.אי. מחקה (4D)י S&P 500 Low Volatility High Dividend",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.44,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 14.6,
    "MonthYield": 1.82,
    "YearYield": 1.82,
    "Last12MonthYield": -9.41,
    "ISIN": "IL0051348873"
  },
  {
    "Id": "TASE:5129226",
    "MayaId": "5129226",
    "Name": "IBI MEHAKA SP ConsStaples",
    "ShortName": "IBI MEHAKA SP ConsStaples",
    "Symbol": "TASE:5129226",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4D) S&P Consumer Staples",
    "EnglishLongName": "I.B.I. MEHAKA (4D) S&P Consumer Staples",
    "HebrewName": "איביאי מחקה SP ConsStaple",
    "HebrewLongName": "אי.בי.אי. מחקה (4D)י S&P Consumer Staples",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.3,
    "TrusteeFee": 0.023,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.83,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 33.7,
    "MonthYield": 4.52,
    "YearYield": 4.52,
    "Last12MonthYield": -8.11,
    "ISIN": "IL0051292261"
  },
  {
    "Id": "TASE:5129242",
    "MayaId": "5129242",
    "Name": "IBI MEHAKA SP Financial",
    "ShortName": "IBI MEHAKA SP Financial",
    "Symbol": "TASE:5129242",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4D) S&P Financial",
    "EnglishLongName": "I.B.I. MEHAKA (4D) S&P Financial",
    "HebrewName": "איביאי מחקה SP Financial",
    "HebrewLongName": "אי.בי.אי. מחקה (4D)י S&P Financial",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.023,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.52,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 148.6,
    "MonthYield": -2.13,
    "YearYield": -2.13,
    "Last12MonthYield": -2.37,
    "ISIN": "IL0051292428"
  },
  {
    "Id": "TASE:5129259",
    "MayaId": "5129259",
    "Name": "IBI MEHAKA SP HealthCare",
    "ShortName": "IBI MEHAKA SP HealthCare",
    "Symbol": "TASE:5129259",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4D) S&P Health Care",
    "EnglishLongName": "I.B.I. MEHAKA (4D) S&P Health Care",
    "HebrewName": "איביאי מחקה SP HealthCare",
    "HebrewLongName": "אי.בי.אי. מחקה (4D)י S&P Health Care",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.02,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.82,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 127.4,
    "MonthYield": -0.01,
    "YearYield": -0.01,
    "Last12MonthYield": -0.72,
    "ISIN": "IL0051292592"
  },
  {
    "Id": "TASE:5134879",
    "MayaId": "5134879",
    "Name": "IBI MEHAKA SP Industrial",
    "ShortName": "IBI MEHAKA SP Industrial",
    "Symbol": "TASE:5134879",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4D) S&P Industrial",
    "EnglishLongName": "I.B.I. MEHAKA (4D) S&P Industrial",
    "HebrewName": "איביאי מחקה SP Industrial",
    "HebrewLongName": "אי.בי.אי. מחקה (4D)י S&P Industrial",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.02,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.31,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 24.3,
    "MonthYield": 5.4,
    "YearYield": 5.4,
    "Last12MonthYield": 8.87,
    "ISIN": "IL0051348790"
  },
  {
    "Id": "TASE:5132337",
    "MayaId": "5132337",
    "Name": "IBI MEHAKA SP R Banks",
    "ShortName": "IBI MEHAKA SP R Banks",
    "Symbol": "TASE:5132337",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4D) S&P Regional Banks",
    "EnglishLongName": "I.B.I. MEHAKA (4D) S&P Regional Banks",
    "HebrewName": "איביאי מחקה SP R Banks",
    "HebrewLongName": "אי.בי.אי. מחקה (4D)י S&P Regional Banks",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 6.8,
    "MonthYield": 3.86,
    "YearYield": 3.86,
    "Last12MonthYield": -0.99,
    "ISIN": "IL0051323371"
  },
  {
    "Id": "TASE:5133293",
    "MayaId": "5133293",
    "Name": "IBI MEHAKA SP Semicondu H",
    "ShortName": "IBI MEHAKA SP Semicondu H",
    "Symbol": "TASE:5133293",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A) S&P Semiconductor Select Industry Currency-Hedged",
    "EnglishLongName": "I.B.I. MEHAKA (4A) S&P Semiconductor Select Industry Currency-Hedged",
    "HebrewName": "איביאי מחקה SP Semicon ממ",
    "HebrewLongName": "אי.בי.אי. מחקה (4A)י S&P Semiconductor Select Industry מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.023,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 4.49,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 34.2,
    "MonthYield": 9.32,
    "YearYield": 9.32,
    "Last12MonthYield": 36.63,
    "ISIN": "IL0051332935"
  },
  {
    "Id": "TASE:5132147",
    "MayaId": "5132147",
    "Name": "IBI MEHAKA SP Technology",
    "ShortName": "IBI MEHAKA SP Technology",
    "Symbol": "TASE:5132147",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4D) S&P Technology",
    "EnglishLongName": "I.B.I. MEHAKA (4D) S&P Technology",
    "HebrewName": "איביאי מחקה SP Technology",
    "HebrewLongName": "אי.בי.אי. מחקה (4D)י S&P Technology",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.023,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 116.6,
    "MonthYield": -0.4,
    "YearYield": -0.4,
    "Last12MonthYield": 7.56,
    "ISIN": "IL0051321474"
  },
  {
    "Id": "TASE:5132154",
    "MayaId": "5132154",
    "Name": "IBI MEHAKA SP TechnologyH",
    "ShortName": "IBI MEHAKA SP TechnologyH",
    "Symbol": "TASE:5132154",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A) S&P Technology Currency-Hedged",
    "EnglishLongName": "I.B.I. MEHAKA (4A) S&P Technology Currency-Hedged",
    "HebrewName": "איביאי מחקה SPTechnoממ",
    "HebrewLongName": "אי.בי.אי. מחקה (4A)י S&P Technology מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.023,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.91,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 136.9,
    "MonthYield": 0.97,
    "YearYield": 0.97,
    "Last12MonthYield": 22.02,
    "ISIN": "IL0051321540"
  },
  {
    "Id": "TASE:5140769",
    "MayaId": "5140769",
    "Name": "IBI MEHAKA SP500 EW",
    "ShortName": "IBI MEHAKA SP500 EW",
    "Symbol": "TASE:5140769",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4D) S&P 500 Equal Weight",
    "EnglishLongName": "I.B.I. MEHAKA (4D) S&P 500 Equal Weight",
    "HebrewName": "איביאי מחקה SP500 EW",
    "HebrewLongName": "אי.בי.אי. מחקה (4D)י S&P 500 Equal Weight",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.023,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 17.8,
    "MonthYield": 2.75,
    "YearYield": 2.75,
    "Last12MonthYield": null,
    "ISIN": "IL0051407695"
  },
  {
    "Id": "TASE:5136833",
    "MayaId": "5136833",
    "Name": "IBI MEHAKA SP500 EW CH",
    "ShortName": "IBI MEHAKA SP500 EW CH",
    "Symbol": "TASE:5136833",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A) S&P 500 Equal Weight Currency-Hedged",
    "EnglishLongName": "I.B.I. MEHAKA (4A) S&P 500 Equal Weight Currency-Hedged",
    "HebrewName": "איביאי מחקהSP500 EWממ",
    "HebrewLongName": "אי.בי.אי. מחקה (4A)י S&P 500 Equal Weight מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.023,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.56,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 109.7,
    "MonthYield": 4.17,
    "YearYield": 4.17,
    "Last12MonthYield": 13.28,
    "ISIN": "IL0051368335"
  },
  {
    "Id": "TASE:5132360",
    "MayaId": "5132360",
    "Name": "IBI MEHAKA SPCommunicatio",
    "ShortName": "IBI MEHAKA SPCommunicatio",
    "Symbol": "TASE:5132360",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4D) S&P Communication Services",
    "EnglishLongName": "I.B.I. MEHAKA (4D) S&P Communication Services",
    "HebrewName": "איביאי מחקה SPCommunicati",
    "HebrewLongName": "אי.בי.אי. מחקה (4D)י S&P Communication Services",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.023,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.91,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 49.1,
    "MonthYield": -2.68,
    "YearYield": -2.68,
    "Last12MonthYield": 3.65,
    "ISIN": "IL0051323603"
  },
  {
    "Id": "TASE:5130752",
    "MayaId": "5130752",
    "Name": "IBI MEHAKA STOXX 600",
    "ShortName": "IBI MEHAKA STOXX 600",
    "Symbol": "TASE:5130752",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4D) STOXX Europe 600",
    "EnglishLongName": "I.B.I. MEHAKA (4D) STOXX Europe 600",
    "HebrewName": "איביאי מחקה STOXX 600",
    "HebrewLongName": "אי.בי.אי. מחקה (4D)י STOXX Europe 600",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.025,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.48,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 161.2,
    "MonthYield": 0.91,
    "YearYield": 0.91,
    "Last12MonthYield": 19.26,
    "ISIN": "IL0051307523"
  },
  {
    "Id": "TASE:5129218",
    "MayaId": "5129218",
    "Name": "IBI MEHAKA STOXX 600 H",
    "ShortName": "IBI MEHAKA STOXX 600 H",
    "Symbol": "TASE:5129218",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A) STOXX Europe 600 EUR Hedged",
    "EnglishLongName": "I.B.I. MEHAKA (4A) STOXX Europe 600 EUR Hedged",
    "HebrewName": "איביאי מחקה STOXX 600 מא",
    "HebrewLongName": "אי.בי.אי. מחקה (4A)י STOXX Europe 600 מנוטרלת אירו",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.02,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.17,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 86.3,
    "MonthYield": 3.76,
    "YearYield": 3.76,
    "Last12MonthYield": 25.63,
    "ISIN": "IL0051292188"
  },
  {
    "Id": "TASE:5135280",
    "MayaId": "5135280",
    "Name": "IBI MEHAKA STOXX Div30 H",
    "ShortName": "IBI MEHAKA STOXX Div30 H",
    "Symbol": "TASE:5135280",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A) EURO STOXX Dividend 30 Currency-Hedged",
    "EnglishLongName": "I.B.I. MEHAKA (4A) EURO STOXX Dividend 30 Currency-Hedged",
    "HebrewName": "איביאי מחקהE-STOXXDiv30ממ",
    "HebrewLongName": "אי.בי.אי. מחקה (4A)י EURO STOXX Dividend 30 מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.4,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 76.4,
    "MonthYield": 1.28,
    "YearYield": 1.28,
    "Last12MonthYield": 45.37,
    "ISIN": "IL0051352800"
  },
  {
    "Id": "TASE:5131610",
    "MayaId": "5131610",
    "Name": "IBI MEHAKA T BCLB NOCC",
    "ShortName": "IBI MEHAKA T-BCLB NOCC",
    "Symbol": "TASE:5131610",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00) Tel Bond CPI Linked - Bank Without COCO IL",
    "EnglishLongName": "I.B.I. MEHAKA (00) Tel Bond CPI Linked - Bank Without COCO IL",
    "HebrewName": "איביאי מחקה תל-ב צבלאCOCO",
    "HebrewLongName": "אי.בי.אי. מחקה (00) תל בונד צמודות-בנקים ללא COCO",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.18,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.18,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 167.1,
    "MonthYield": 0.08,
    "YearYield": 0.08,
    "Last12MonthYield": 5.17,
    "ISIN": "IL0051316102"
  },
  {
    "Id": "TASE:5112628",
    "MayaId": "5112628",
    "Name": "IBI MEHAKA TA 125",
    "ShortName": "IBI MEHAKA TA-125",
    "Symbol": "TASE:5112628",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A) TA-125 IL",
    "EnglishLongName": "I.B.I. MEHAKA (4A) TA-125 IL",
    "HebrewName": "איביאי מחקה תא 125",
    "HebrewLongName": "אי.בי.אי. מחקה (4A) ת\"א 125",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.12,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 2011.4,
    "MonthYield": 8.85,
    "YearYield": 8.85,
    "Last12MonthYield": 64.27,
    "ISIN": "IL0051126287"
  },
  {
    "Id": "TASE:5130687",
    "MayaId": "5130687",
    "Name": "IBI MEHAKA TA 35",
    "ShortName": "IBI MEHAKA TA-35",
    "Symbol": "TASE:5130687",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A) TA-35 IL",
    "EnglishLongName": "I.B.I. MEHAKA (4A) TA-35 IL",
    "HebrewName": "איביאי מחקה תא 35",
    "HebrewLongName": "אי.בי.אי. מחקה (4A) ת\"א 35",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.02,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.96,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 344.6,
    "MonthYield": 9.27,
    "YearYield": 9.27,
    "Last12MonthYield": 65.33,
    "ISIN": "IL0051306871"
  },
  {
    "Id": "TASE:5130919",
    "MayaId": "5130919",
    "Name": "IBI MEHAKA TA 90",
    "ShortName": "IBI MEHAKA TA-90",
    "Symbol": "TASE:5130919",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A) TA-90 IL",
    "EnglishLongName": "I.B.I. MEHAKA (4A) TA-90 IL",
    "HebrewName": "איביאי מחקה תא 90",
    "HebrewLongName": "אי.בי.אי. מחקה (4A) ת\"א 90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.02,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.98,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 818.3,
    "MonthYield": 7.33,
    "YearYield": 7.33,
    "Last12MonthYield": 57.27,
    "ISIN": "IL0051309198"
  },
  {
    "Id": "TASE:5140306",
    "MayaId": "5140306",
    "Name": "IBI MEHAKA TA 90&S60 0.8C",
    "ShortName": "IBI MEHAKA TA-90&S60 0.8C",
    "Symbol": "TASE:5140306",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A) TA-90 and SME60 0.8% CAP IL",
    "EnglishLongName": "I.B.I. MEHAKA (4A) TA-90 and SME60 0.8% CAP IL",
    "HebrewName": "איביאי מחקה תא90 C0.8 S60",
    "HebrewLongName": "אי.בי.אי. מחקה (4A) ת\"א-90 ו- CAP 0.8% SME60",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.015,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.31,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 11.6,
    "MonthYield": 7.14,
    "YearYield": 7.14,
    "Last12MonthYield": null,
    "ISIN": "IL0051403066"
  },
  {
    "Id": "TASE:5135710",
    "MayaId": "5135710",
    "Name": "IBI MEHAKA TA Finance",
    "ShortName": "IBI MEHAKA TA-Finance",
    "Symbol": "TASE:5135710",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A) TA-Finance IL",
    "EnglishLongName": "I.B.I. MEHAKA (4A) TA-Finance IL",
    "HebrewName": "איביאי מחקה ת\"א-פיננסים",
    "HebrewLongName": "אי.בי.אי. מחקה (4A) ת\"א-פיננסים",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.02,
    "VariableFee": 0.03,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.52,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 278.7,
    "MonthYield": 8.44,
    "YearYield": 8.44,
    "Last12MonthYield": 107.02,
    "ISIN": "IL0051357106"
  },
  {
    "Id": "TASE:5136247",
    "MayaId": "5136247",
    "Name": "IBI MEHAKA TA Growth",
    "ShortName": "IBI MEHAKA TA-Growth",
    "Symbol": "TASE:5136247",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A) TA-Growth IL",
    "EnglishLongName": "I.B.I. MEHAKA (4A) TA-Growth IL",
    "HebrewName": "איביאי מחקה תא צמיחה",
    "HebrewLongName": "אי.בי.אי. מחקה (4A) ת\"א צמיחה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.015,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.99,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 8.1,
    "MonthYield": 7.37,
    "YearYield": 7.37,
    "Last12MonthYield": 32.5,
    "ISIN": "IL0051362478"
  },
  {
    "Id": "TASE:5125224",
    "MayaId": "5125224",
    "Name": "IBI MEHAKA TA MidCap Prof",
    "ShortName": "IBI MEHAKA TA MidCap Prof",
    "Symbol": "TASE:5125224",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A) Index TA Mid Cap Profitability IL",
    "EnglishLongName": "I.B.I. MEHAKA (4A) Index TA Mid Cap Profitability IL",
    "HebrewName": "איביאי מחקה אינתאMidCרווח",
    "HebrewLongName": "אי.בי.אי. מחקה (4A) אינדקס ת\"א Mid Cap רווחיות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.025,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.08,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 211.0,
    "MonthYield": 7.14,
    "YearYield": 7.14,
    "Last12MonthYield": 57.66,
    "ISIN": "IL0051252240"
  },
  {
    "Id": "TASE:5140827",
    "MayaId": "5140827",
    "Name": "IBI MEHAKA TA Oil&Gas",
    "ShortName": "IBI MEHAKA TA-Oil&Gas",
    "Symbol": "TASE:5140827",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A) TA-Oil&Gas IL",
    "EnglishLongName": "I.B.I. MEHAKA (4A) TA-Oil&Gas IL",
    "HebrewName": "איביאי מחקה ת\"א-נפט וגז",
    "HebrewLongName": "אי.בי.אי. מחקה (4A) ת\"א-נפט וגז",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 20.4,
    "MonthYield": -2.27,
    "YearYield": -2.27,
    "Last12MonthYield": null,
    "ISIN": "IL0051408271"
  },
  {
    "Id": "TASE:5135694",
    "MayaId": "5135694",
    "Name": "IBI MEHAKA TA RealEsta",
    "ShortName": "IBI MEHAKA TA-RealEsta",
    "Symbol": "TASE:5135694",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A) TA-Real Estate IL",
    "EnglishLongName": "I.B.I. MEHAKA (4A) TA-Real Estate IL",
    "HebrewName": "איביאי מחקה ת\"א-נדל\"ן",
    "HebrewLongName": "אי.בי.אי. מחקה (4A) ת\"א-נדל\"ן",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.02,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.7,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 124.7,
    "MonthYield": 9.75,
    "YearYield": 9.75,
    "Last12MonthYield": 36.53,
    "ISIN": "IL0051356942"
  },
  {
    "Id": "TASE:5141031",
    "MayaId": "5141031",
    "Name": "IBI MEHAKA TA SmallC 60 P",
    "ShortName": "IBI MEHAKA TA SmallC 60 P",
    "Symbol": "TASE:5141031",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A) Index TA Small Cap 60 Profitability IL",
    "EnglishLongName": "I.B.I. MEHAKA (4A) Index TA Small Cap 60 Profitability IL",
    "HebrewName": "איביאי מחקה אינתאSmalC60ר",
    "HebrewLongName": "אי.בי.אי. מחקה (4A) אינדקס ת\"א Small Cap 60 רווחיות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 10.8,
    "MonthYield": 6.34,
    "YearYield": 6.34,
    "Last12MonthYield": null,
    "ISIN": "IL0051410319"
  },
  {
    "Id": "TASE:5112271",
    "MayaId": "5112271",
    "Name": "IBI MEHAKA TAGBDGV",
    "ShortName": "IBI MEHAKA TAGBDGV",
    "Symbol": "TASE:5112271",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (0A) Tel-Gov IL",
    "EnglishLongName": "I.B.I. MEHAKA (0A) Tel-Gov IL",
    "HebrewName": "איביאי מחקה תל גוב-כללי",
    "HebrewLongName": "אי.בי.אי. מחקה (0A) תל גוב-כללי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.36,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bonds",
    "AssetValue": 54.5,
    "MonthYield": 0.47,
    "YearYield": 0.47,
    "Last12MonthYield": 6.37,
    "ISIN": "IL0051122716"
  },
  {
    "Id": "TASE:5134093",
    "MayaId": "5134093",
    "Name": "IBI MEHAKA TAInsurance",
    "ShortName": "IBI MEHAKA TAInsurance",
    "Symbol": "TASE:5134093",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A) TA-Insurance IL",
    "EnglishLongName": "I.B.I. MEHAKA (4A) TA-Insurance IL",
    "HebrewName": "איביאי מחקה ת\"א-ביטוח",
    "HebrewLongName": "אי.בי.אי. מחקה (4A) ת\"א-ביטוח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.02,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 5.43,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 424.2,
    "MonthYield": 7.06,
    "YearYield": 7.06,
    "Last12MonthYield": 168.74,
    "ISIN": "IL0051340938"
  },
  {
    "Id": "TASE:5131701",
    "MayaId": "5131701",
    "Name": "IBI MEHAKA TAR02GV",
    "ShortName": "IBI MEHAKA TAR02GV",
    "Symbol": "TASE:5131701",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00) Tel Gov-CPI Linked 0-2 IL",
    "EnglishLongName": "I.B.I. MEHAKA (00) Tel Gov-CPI Linked 0-2 IL",
    "HebrewName": "איביאי מחקה תלגוב-צמוד0-2",
    "HebrewLongName": "אי.בי.אי. מחקה (00) תל גוב-צמודות 0-2",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.015,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.09,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked",
    "AssetValue": 184.5,
    "MonthYield": 0.21,
    "YearYield": 0.21,
    "Last12MonthYield": 4.25,
    "ISIN": "IL0051317019"
  },
  {
    "Id": "TASE:5111422",
    "MayaId": "5111422",
    "Name": "IBI MEHAKA TAR25FIG",
    "ShortName": "IBI MEHAKA TAR25FIG",
    "Symbol": "TASE:5111422",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00) Tel Gov-Shekel 2-5 IL",
    "EnglishLongName": "I.B.I. MEHAKA (00) Tel Gov-Shekel 2-5 IL",
    "HebrewName": "איביאי מחקה תלגוב-שקלי2-5",
    "HebrewLongName": "אי.בי.אי. מחקה‏ (00) תל גוב-שקלי 2-5",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.025,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.24,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Non-Linked Government Bonds",
    "AssetValue": 112.2,
    "MonthYield": 0.59,
    "YearYield": 0.59,
    "Last12MonthYield": 6.29,
    "ISIN": "IL0051114226"
  },
  {
    "Id": "TASE:5111240",
    "MayaId": "5111240",
    "Name": "IBI MEHAKA TAR25GV",
    "ShortName": "IBI MEHAKA TAR25GV",
    "Symbol": "TASE:5111240",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00) Tel Gov-CPI Linked 2-5 IL",
    "EnglishLongName": "I.B.I. MEHAKA (00) Tel Gov-CPI Linked 2-5 IL",
    "HebrewName": "איביאי מחקה תלגוב-צמוד2-5",
    "HebrewLongName": "אי.בי.אי. מחקה‏ (00) תל גוב-צמודות 2-5",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.025,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.14,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked",
    "AssetValue": 113.0,
    "MonthYield": 0.14,
    "YearYield": 0.14,
    "Last12MonthYield": 4.4,
    "ISIN": "IL0051112402"
  },
  {
    "Id": "TASE:5117833",
    "MayaId": "5117833",
    "Name": "IBI MEHAKA TAR510GV",
    "ShortName": "IBI MEHAKA TAR510GV",
    "Symbol": "TASE:5117833",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00) Tel Gov-CPI Linked 5-10 IL",
    "EnglishLongName": "I.B.I. MEHAKA (00) Tel Gov-CPI Linked 5-10 IL",
    "HebrewName": "איביאי מחקה תלגו-צמוד5-10",
    "HebrewLongName": "אי.בי.אי. מחקה‏ (00) תל גוב-צמודות 5-10",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.025,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.31,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked",
    "AssetValue": 56.8,
    "MonthYield": -0.13,
    "YearYield": -0.13,
    "Last12MonthYield": 5.06,
    "ISIN": "IL0051178338"
  },
  {
    "Id": "TASE:5111489",
    "MayaId": "5111489",
    "Name": "IBI MEHAKA TAR5FIG",
    "ShortName": "IBI MEHAKA TAR5FIG",
    "Symbol": "TASE:5111489",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00) Tel Gov-Shekel 5+ IL",
    "EnglishLongName": "I.B.I. MEHAKA (00) Tel Gov-Shekel 5+ IL",
    "HebrewName": "איביאי מחקה תל גוב-שקלי5+",
    "HebrewLongName": "אי.בי.אי. מחקה‏ (00) תל גוב-שקלי 5+",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.025,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.79,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Non-Linked Government Bonds",
    "AssetValue": 132.2,
    "MonthYield": 1.26,
    "YearYield": 1.26,
    "Last12MonthYield": 11.23,
    "ISIN": "IL0051114895"
  },
  {
    "Id": "TASE:5136841",
    "MayaId": "5136841",
    "Name": "IBI MEHAKA TASec Balan",
    "ShortName": "IBI MEHAKA TASec-Balan",
    "Symbol": "TASE:5136841",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A) TA-Sector-Balance IL",
    "EnglishLongName": "I.B.I. MEHAKA (4A) TA-Sector-Balance IL",
    "HebrewName": "איביאי מחקה ת\"א סקט-בלנס",
    "HebrewLongName": "אי.בי.אי. מחקה (4A) ת\"א סקטור-באלאנס",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.02,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.5,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 71.9,
    "MonthYield": 7.81,
    "YearYield": 7.81,
    "Last12MonthYield": 69.6,
    "ISIN": "IL0051368418"
  },
  {
    "Id": "TASE:5111265",
    "MayaId": "5111265",
    "Name": "IBI MEHAKA TASHTTB",
    "ShortName": "IBI MEHAKA TASHTTB",
    "Symbol": "TASE:5111265",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00) Tel Gov T-Bills (MAKAM) IL",
    "EnglishLongName": "I.B.I. MEHAKA (00) Tel Gov T-Bills (MAKAM) IL",
    "HebrewName": "איביאי מחקה תל גוב-מק\"מ",
    "HebrewLongName": "אי.בי.אי. מחקה‏ (00) תל גוב-מק\"מ",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.09,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Non-Linked Government Bonds",
    "AssetValue": 55.7,
    "MonthYield": 0.27,
    "YearYield": 0.27,
    "Last12MonthYield": 4.44,
    "ISIN": "IL0051112659"
  },
  {
    "Id": "TASE:5113014",
    "MayaId": "5113014",
    "Name": "IBI MEHAKA TEL B 20 CPI L",
    "ShortName": "IBI MEHAKA TEL-B 20 CPI L",
    "Symbol": "TASE:5113014",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00) TEL BOND 20 CPI - LINKED IL",
    "EnglishLongName": "I.B.I. MEHAKA (00) TEL BOND 20 CPI - LINKED IL",
    "HebrewName": "איביאי מחקה תלבונד 20צמוד",
    "HebrewLongName": "אי.בי.אי. מחקה (00) תל בונד 20 צמודות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.37,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 36.1,
    "MonthYield": 0.21,
    "YearYield": 0.21,
    "Last12MonthYield": 7.01,
    "ISIN": "IL0051130149"
  },
  {
    "Id": "TASE:5114327",
    "MayaId": "5114327",
    "Name": "IBI MEHAKA TEL B 40 CPI L",
    "ShortName": "IBI MEHAKA TEL-B 40 CPI L",
    "Symbol": "TASE:5114327",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00) TEL BOND 40 CPI - LINKED IL",
    "EnglishLongName": "I.B.I. MEHAKA (00) TEL BOND 40 CPI - LINKED IL",
    "HebrewName": "איביאי מחקה תלבונד 40צמוד",
    "HebrewLongName": "אי.בי.אי. מחקה (00) תל בונד 40 צמודות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 10.0,
    "MonthYield": 0.24,
    "YearYield": 0.24,
    "Last12MonthYield": 6.22,
    "ISIN": "IL0051143274"
  },
  {
    "Id": "TASE:5115100",
    "MayaId": "5115100",
    "Name": "IBI MEHAKA TEL B 60 CPI L",
    "ShortName": "IBI MEHAKA TEL-B 60 CPI L",
    "Symbol": "TASE:5115100",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00) TEL BOND 60 CPI - LINKED IL",
    "EnglishLongName": "I.B.I. MEHAKA (00) TEL BOND 60 CPI - LINKED IL",
    "HebrewName": "איביאי מחקה תלבונד 60צמוד",
    "HebrewLongName": "אי.בי.אי. מחקה (00) תל בונד 60 צמודות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 57.8,
    "MonthYield": 0.23,
    "YearYield": 0.23,
    "Last12MonthYield": 6.58,
    "ISIN": "IL0051151004"
  },
  {
    "Id": "TASE:5136858",
    "MayaId": "5136858",
    "Name": "IBI MEHAKA Tel B CP1 3",
    "ShortName": "IBI MEHAKA Tel-B-CP1-3",
    "Symbol": "TASE:5136858",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00) Tel Bond-CPI Linked 1-3 IL",
    "EnglishLongName": "I.B.I. MEHAKA (00) Tel Bond-CPI Linked 1-3 IL",
    "HebrewName": "איביאי מחקה תלב-צמוד1-3",
    "HebrewLongName": "אי.בי.אי. מחקה (00) תל בונד-צמודות 1-3",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.18,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 479.1,
    "MonthYield": 0.16,
    "YearYield": 0.16,
    "Last12MonthYield": 4.96,
    "ISIN": "IL0051368582"
  },
  {
    "Id": "TASE:5125133",
    "MayaId": "5125133",
    "Name": "IBI MEHAKA TEL B GLO Shek",
    "ShortName": "IBI MEHAKA TEL-B GLO Shek",
    "Symbol": "TASE:5125133",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00)(!) TEL BOND GLOBAL Shekel IL",
    "EnglishLongName": "I.B.I. MEHAKA (00)(!) TEL BOND GLOBAL Shekel IL",
    "HebrewName": "איביאי מחקה תלבונד-גלובשק",
    "HebrewLongName": "אי.בי.אי. מחקה (00)(!) תל בונד גלובל שקלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.49,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 19.8,
    "MonthYield": 0.86,
    "YearYield": 0.86,
    "Last12MonthYield": 0.61,
    "ISIN": "IL0051251333"
  },
  {
    "Id": "TASE:5134911",
    "MayaId": "5134911",
    "Name": "IBI MEHAKA Tel B S A",
    "ShortName": "IBI MEHAKA Tel-B-S-A",
    "Symbol": "TASE:5134911",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00) Tel Bond Shekel-A IL",
    "EnglishLongName": "I.B.I. MEHAKA (00) Tel Bond Shekel-A IL",
    "HebrewName": "איביאי מחקה תל בונד-שקליA",
    "HebrewLongName": "אי.בי.אי. מחקה (00) תל בונד-שקלי A",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 139.1,
    "MonthYield": 0.97,
    "YearYield": 0.97,
    "Last12MonthYield": 6.68,
    "ISIN": "IL0051349111"
  },
  {
    "Id": "TASE:5117494",
    "MayaId": "5117494",
    "Name": "IBI MEHAKA TEL BCLS",
    "ShortName": "IBI MEHAKA TEL-BCLS",
    "Symbol": "TASE:5117494",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00) Tel Bond-CPI Linked SmallCap IL",
    "EnglishLongName": "I.B.I. MEHAKA (00) Tel Bond-CPI Linked SmallCap IL",
    "HebrewName": "איביאי מחקה תלבונד צמדיתר",
    "HebrewLongName": "אי.בי.אי. מחקה‏ (00) תל בונד צמודות-יתר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.26,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 92.2,
    "MonthYield": 0.28,
    "YearYield": 0.28,
    "Last12MonthYield": 6.54,
    "ISIN": "IL0051174949"
  },
  {
    "Id": "TASE:5113071",
    "MayaId": "5113071",
    "Name": "IBI MEHAKA TEL BSH",
    "ShortName": "IBI MEHAKA TEL-BSH",
    "Symbol": "TASE:5113071",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00) Tel Bond-Shekel IL",
    "EnglishLongName": "I.B.I. MEHAKA (00) Tel Bond-Shekel IL",
    "HebrewName": "איביאי מחקה תלבונד שקלי",
    "HebrewLongName": "אי.בי.אי. מחקה‏ (00) תל בונד שקלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 331.7,
    "MonthYield": 0.9,
    "YearYield": 0.9,
    "Last12MonthYield": 7.35,
    "ISIN": "IL0051130719"
  },
  {
    "Id": "TASE:5132519",
    "MayaId": "5132519",
    "Name": "IBI MEHAKA TEL BSH 50",
    "ShortName": "IBI MEHAKA TEL-BSH 50",
    "Symbol": "TASE:5132519",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00) Tel Bond Shekel-50 IL",
    "EnglishLongName": "I.B.I. MEHAKA (00) Tel Bond Shekel-50 IL",
    "HebrewName": "איביאי מחקה תלבונד שקלי50",
    "HebrewLongName": "אי.בי.אי. מחקה‏ (00) תל בונד שקלי 50",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.02,
    "VariableFee": 0.03,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.37,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 286.7,
    "MonthYield": 0.92,
    "YearYield": 0.92,
    "Last12MonthYield": 8.26,
    "ISIN": "IL0051325194"
  },
  {
    "Id": "TASE:5131636",
    "MayaId": "5131636",
    "Name": "IBI MEHAKA TEL COMP",
    "ShortName": "IBI MEHAKA TEL-COMP",
    "Symbol": "TASE:5131636",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (0A) Tel Bond-Composite IL",
    "EnglishLongName": "I.B.I. MEHAKA (0A) Tel Bond-Composite IL",
    "HebrewName": "איביאי מחקה תל בונד מאגר",
    "HebrewLongName": "אי.בי.אי. מחקה (0A) תל בונד מאגר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 65.4,
    "MonthYield": 0.51,
    "YearYield": 0.51,
    "Last12MonthYield": 6.71,
    "ISIN": "IL0051316367"
  },
  {
    "Id": "TASE:5130695",
    "MayaId": "5130695",
    "Name": "IBI MEHAKA TEL CP35",
    "ShortName": "IBI MEHAKA TEL-CP35",
    "Symbol": "TASE:5130695",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00) Tel Bond-CPI Linked 3-5 IL",
    "EnglishLongName": "I.B.I. MEHAKA (00) Tel Bond-CPI Linked 3-5 IL",
    "HebrewName": "איביאי מחקה תלב-צמוד3-5",
    "HebrewLongName": "אי.בי.אי. מחקה‏ (00) תל בונד צמודות 3-5",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.25,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 277.5,
    "MonthYield": 0.17,
    "YearYield": 0.17,
    "Last12MonthYield": 5.95,
    "ISIN": "IL0051306954"
  },
  {
    "Id": "TASE:5131008",
    "MayaId": "5131008",
    "Name": "IBI MEHAKA TEL CPAA",
    "ShortName": "IBI MEHAKA TEL-CPAA",
    "Symbol": "TASE:5131008",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00) Tel Bond-CPI Linked AA-AAA IL",
    "EnglishLongName": "I.B.I. MEHAKA (00) Tel Bond-CPI Linked AA-AAA IL",
    "HebrewName": "איביאי מחקה תלב-צמוAA-AAA",
    "HebrewLongName": "אי.בי.אי. מחקה (00) תל בונד צמודות AA-AAA",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 305.5,
    "MonthYield": 0.27,
    "YearYield": 0.27,
    "Last12MonthYield": 6.8,
    "ISIN": "IL0051310089"
  },
  {
    "Id": "TASE:5139431",
    "MayaId": "5139431",
    "Name": "IBI MEHAKA TEL CPILinkedA",
    "ShortName": "IBI MEHAKA TEL-CPILinkedA",
    "Symbol": "TASE:5139431",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00) Tel Bond-CPI Linked A IL",
    "EnglishLongName": "I.B.I. MEHAKA (00) Tel Bond-CPI Linked A IL",
    "HebrewName": "איביאי מחקה תלב-צמודותA",
    "HebrewLongName": "אי.בי.אי. מחקה (00) תל בונד-צמודות A",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 21.8,
    "MonthYield": 0.21,
    "YearYield": 0.21,
    "Last12MonthYield": 5.99,
    "ISIN": "IL0051394315"
  },
  {
    "Id": "TASE:5140322",
    "MayaId": "5140322",
    "Name": "IBI MEHAKA TEL GOV CPI L",
    "ShortName": "IBI MEHAKA TEL-GOV CPI L",
    "Symbol": "TASE:5140322",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00) Tel Gov-CPI Linked IL",
    "EnglishLongName": "I.B.I. MEHAKA (00) Tel Gov-CPI Linked IL",
    "HebrewName": "איביאי מחקה תל גוב-צמוד",
    "HebrewLongName": "אי.בי.אי. מחקה (00) תל גוב-צמודות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.015,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.46,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked",
    "AssetValue": 15.1,
    "MonthYield": 0.04,
    "YearYield": 0.04,
    "Last12MonthYield": null,
    "ISIN": "IL0051403223"
  },
  {
    "Id": "TASE:5134564",
    "MayaId": "5134564",
    "Name": "IBI MEHAKA Tel Gov FloaSH",
    "ShortName": "IBI MEHAKA Tel Gov-FloaSH",
    "Symbol": "TASE:5134564",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00) Tel Gov-Floating Shekel IL",
    "EnglishLongName": "I.B.I. MEHAKA (00) Tel Gov-Floating Shekel IL",
    "HebrewName": "איביאי מחקה תלגוב-משתנהשק",
    "HebrewLongName": "אי.בי.אי. מחקה (00) תל גוב-משתנה שקלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.015,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.06,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Non-Linked Government Bonds",
    "AssetValue": 4.8,
    "MonthYield": 0.15,
    "YearYield": 0.15,
    "Last12MonthYield": 5.16,
    "ISIN": "IL0051345648"
  },
  {
    "Id": "TASE:5140330",
    "MayaId": "5140330",
    "Name": "IBI MEHAKA TEL GOV NON L",
    "ShortName": "IBI MEHAKA TEL-GOV NON L",
    "Symbol": "TASE:5140330",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00) Tel Gov-Non Linked IL",
    "EnglishLongName": "I.B.I. MEHAKA (00) Tel Gov-Non Linked IL",
    "HebrewName": "איביאי מחקה תל גוב-לאצמוד",
    "HebrewLongName": "אי.בי.אי. מחקה (00) תל גוב-לא צמודות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.015,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Non-Linked Government Bonds",
    "AssetValue": 22.6,
    "MonthYield": 0.75,
    "YearYield": 0.75,
    "Last12MonthYield": null,
    "ISIN": "IL0051403306"
  },
  {
    "Id": "TASE:5140314",
    "MayaId": "5140314",
    "Name": "IBI MEHAKA TEL GOV SHEK",
    "ShortName": "IBI MEHAKA TEL-GOV SHEK",
    "Symbol": "TASE:5140314",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00) Tel Gov-Shekel IL",
    "EnglishLongName": "I.B.I. MEHAKA (00) Tel Gov-Shekel IL",
    "HebrewName": "איביאי מחקה תל גוב-שקלי",
    "HebrewLongName": "אי.בי.אי. מחקה (00) תל גוב-שקלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.015,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.42,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Non-Linked Government Bonds",
    "AssetValue": 2.6,
    "MonthYield": 0.86,
    "YearYield": 0.86,
    "Last12MonthYield": null,
    "ISIN": "IL0051403140"
  },
  {
    "Id": "TASE:5131909",
    "MayaId": "5131909",
    "Name": "IBI MEHAKA TEL NIS",
    "ShortName": "IBI MEHAKA TEL-NIS",
    "Symbol": "TASE:5131909",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00)(!) Tel Bond-Yields Shekel IL",
    "EnglishLongName": "I.B.I. MEHAKA (00)(!) Tel Bond-Yields Shekel IL",
    "HebrewName": "איביאי מחקה תלב-תשואות שק",
    "HebrewLongName": "אי.בי.אי. מחקה (00)(!) תל בונד תשואות שקל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 92.4,
    "MonthYield": 1.05,
    "YearYield": 1.05,
    "Last12MonthYield": 5.89,
    "ISIN": "IL0051319098"
  },
  {
    "Id": "TASE:5130380",
    "MayaId": "5130380",
    "Name": "IBI MEHAKA TEl S Bank&Ins",
    "ShortName": "IBI MEHAKA TEl-S Bank&Ins",
    "Symbol": "TASE:5130380",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00) Tel Bond-Shekel Bank & Insurance IL",
    "EnglishLongName": "I.B.I. MEHAKA (00) Tel Bond-Shekel Bank & Insurance IL",
    "HebrewName": "איביאי מחקה תלב-בנק ביטוח",
    "HebrewLongName": "אי.בי.אי. מחקה‏ (00) תל בונד שקלי בנקים וביטוח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.41,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 308.0,
    "MonthYield": 0.88,
    "YearYield": 0.88,
    "Last12MonthYield": 8.72,
    "ISIN": "IL0051303803"
  },
  {
    "Id": "TASE:5130992",
    "MayaId": "5130992",
    "Name": "IBI MEHAKA TEL SHAA",
    "ShortName": "IBI MEHAKA TEL-SHAA",
    "Symbol": "TASE:5130992",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00) Tel Bond-Shekel AA-AAA IL",
    "EnglishLongName": "I.B.I. MEHAKA (00) Tel Bond-Shekel AA-AAA IL",
    "HebrewName": "איביאי מחקה תלב-שקלAA-AAA",
    "HebrewLongName": "אי.בי.אי. מחקה (00) תל בונד שקלי AA-AAA",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.37,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 215.0,
    "MonthYield": 0.83,
    "YearYield": 0.83,
    "Last12MonthYield": 8.25,
    "ISIN": "IL0051309925"
  },
  {
    "Id": "TASE:5117957",
    "MayaId": "5117957",
    "Name": "IBI MEHAKA TelB YCPI L",
    "ShortName": "IBI MEHAKA TelB-YCPI L",
    "Symbol": "TASE:5117957",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (00)(!) Tel Bond-Yields CPI Linked IL",
    "EnglishLongName": "I.B.I. MEHAKA (00)(!) Tel Bond-Yields CPI Linked IL",
    "HebrewName": "איביאי מחקה תלב-תשואתצמוד",
    "HebrewLongName": "אי.בי.אי. מחקה (00)(!) תל בונד-תשואות צמודות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.025,
    "VariableFee": 0.02,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 267.3,
    "MonthYield": 0.16,
    "YearYield": 0.16,
    "Last12MonthYield": 5.8,
    "ISIN": "IL0051179575"
  },
  {
    "Id": "TASE:5134416",
    "MayaId": "5134416",
    "Name": "IBI MEHAKA USval Sec CURH",
    "ShortName": "IBI MEHAKA USval Sec CURH",
    "Symbol": "TASE:5134416",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A) Index US Value Equity Sectoral Distribution Currency Hedged",
    "EnglishLongName": "I.B.I. MEHAKA (4A) Index US Value Equity Sectoral Distribution Currency Hedged",
    "HebrewName": "איביאי מחקה ערךארהב סק ממ",
    "HebrewLongName": "אי.בי.אי. מחקה (4A) אינדקס מניות ערך ארה\"ב פיזור סקטוריאלי מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.03,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 16.9,
    "MonthYield": 3.11,
    "YearYield": 3.11,
    "Last12MonthYield": 13.17,
    "ISIN": "IL0051344161"
  },
  {
    "Id": "TASE:5137732",
    "MayaId": "5137732",
    "Name": "IBI MM Liquidity Manage",
    "ShortName": "IBI MM Liquidity Manage",
    "Symbol": "TASE:5137732",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (00) Money Market Liquidity Management IL",
    "EnglishLongName": "I.B.I. (00) Money Market Liquidity Management IL",
    "HebrewName": "איביאי כספית ניהול נזילות",
    "HebrewLongName": "אי.בי.אי. (00) כספית ניהול נזילות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.169,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 6032.7,
    "MonthYield": 0.22,
    "YearYield": 0.22,
    "Last12MonthYield": 4.69,
    "ISIN": "IL0051377328"
  },
  {
    "Id": "TASE:5129309",
    "MayaId": "5129309",
    "Name": "IBI MSHLV MN US",
    "ShortName": "IBI MSHLV MN US",
    "Symbol": "TASE:5129309",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4D) COMPOSITE US EQUITY MONTHLY",
    "EnglishLongName": "I.B.I. MEHAKA (4D) COMPOSITE US EQUITY MONTHLY",
    "HebrewName": "איביאי מחקה מש מנ ארהב",
    "HebrewLongName": "אי.בי.אי. מחקה (4D) משולבת מניות ארה\"ב חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.73,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks Abroad, Composite",
    "AssetValue": 235.6,
    "MonthYield": 2.03,
    "YearYield": 2.03,
    "Last12MonthYield": 3.72,
    "ISIN": "IL0051293095"
  },
  {
    "Id": "TASE:5141197",
    "MayaId": "5141197",
    "Name": "IBI Savings Money Market",
    "ShortName": "IBI Savings Money Market",
    "Symbol": "TASE:5141197",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (00) Savings Money Market IL",
    "EnglishLongName": "I.B.I. (00) Savings Money Market IL",
    "HebrewName": "איביאי כספית חיסכון",
    "HebrewLongName": "אי.בי.אי. (00) כספית חיסכון",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.07,
    "TrusteeFee": 0.005,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 26.6,
    "MonthYield": 0.22,
    "YearYield": 0.22,
    "Last12MonthYield": null,
    "ISIN": "IL0051411978"
  },
  {
    "Id": "TASE:5103593",
    "MayaId": "5103593",
    "Name": "IBI SIN",
    "ShortName": "IBI SIN",
    "Symbol": "TASE:5103593",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. CHINA (4D)",
    "EnglishLongName": "I.B.I. CHINA (4D)",
    "HebrewName": "איביאי 4D סין קרן נאמנות",
    "HebrewLongName": "אי.בי.אי. (4D) סין",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.95,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Geographical stocks",
    "AssetValue": 21.4,
    "MonthYield": 5.46,
    "YearYield": 5.46,
    "Last12MonthYield": 14.81,
    "ISIN": "IL0051035934"
  },
  {
    "Id": "TASE:5129507",
    "MayaId": "5129507",
    "Name": "IBI SOL ELC PAY",
    "ShortName": "IBI SOL ELC PAY",
    "Symbol": "TASE:5129507",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4D) Solactive Electronic Payment",
    "EnglishLongName": "I.B.I. MEHAKA (4D) Solactive Electronic Payment",
    "HebrewName": "איביאי מחקה Sol ElectrPay",
    "HebrewLongName": "אי.בי.אי. מחקה (4D)י Solactive Electronic Payment",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.75,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 2.6,
    "MonthYield": -4.77,
    "YearYield": -4.77,
    "Last12MonthYield": -25.68,
    "ISIN": "IL0051295074"
  },
  {
    "Id": "IBIU.TA",
    "MayaId": "1084482",
    "Name": "IBI UNDERWRIT",
    "ShortName": "I.B.I.-MANAGING & UNDERWRITING LTD",
    "Symbol": "IBIU.TA",
    "TaseSymbol": "IBIU",
    "YahooId": "IBIU.TA",
    "EnglishName": "IBI UNDERWRIT",
    "EnglishLongName": "I.B.I.-MANAGING & UNDERWRITING LTD",
    "HebrewName": "איביאי חיתום",
    "HebrewLongName": "אי.בי.אי. - ניהול וחיתום בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1233.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Financial Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 9.8,
    "YearYield": 9.8,
    "Last12MonthYield": null,
    "ISIN": "IL0010844822"
  },
  {
    "Id": "TASE:5117429",
    "MayaId": "5117429",
    "Name": "IBI US $ Denominated MM",
    "ShortName": "IBI US $ Denominated MM",
    "Symbol": "TASE:5117429",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (0D) US $ Denominated Money Market",
    "EnglishLongName": "I.B.I. (0D) US $ Denominated Money Market",
    "HebrewName": "איביאי כספית נקובה דולר $",
    "HebrewLongName": "אי.בי.אי. (0D) כספית נקובה דולר $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.14,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "FX Money Market with Corporate",
    "AssetValue": 1840.7,
    "MonthYield": -0.93,
    "YearYield": -0.93,
    "Last12MonthYield": -9.44,
    "ISIN": "IL0051174295"
  },
  {
    "Id": "TASE:5137906",
    "MayaId": "5137906",
    "Name": "IBI US$ Denominated MM",
    "ShortName": "IBI US$ Denominated MM",
    "Symbol": "TASE:5137906",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (0D) US Dollar Denominated Money Market",
    "EnglishLongName": "I.B.I. (0D) US Dollar Denominated Money Market",
    "HebrewName": "איביאי כספית דולרית נקוב$",
    "HebrewLongName": "אי.בי.אי. (0D) כספית דולרית – נקובה $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.16,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "FX Money Market with Corporate",
    "AssetValue": 1293.3,
    "MonthYield": -0.94,
    "YearYield": -0.94,
    "Last12MonthYield": -9.43,
    "ISIN": "IL0051379068"
  },
  {
    "Id": "TASE:5119318",
    "MayaId": "5119318",
    "Name": "IBI.M1EF",
    "ShortName": "IBI.M1EF",
    "Symbol": "TASE:5119318",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4D) MSCI EMERGING MARKETS",
    "EnglishLongName": "I.B.I. MEHAKA (4D) MSCI EMERGING MARKETS",
    "HebrewName": "איביאי מחקה MSCI EM",
    "HebrewLongName": "אי.בי.אי. מחקה (4D)י MSCI Emerging Markets",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.2,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 100.2,
    "MonthYield": 4.24,
    "YearYield": 4.24,
    "Last12MonthYield": 20.59,
    "ISIN": "IL0051193188"
  },
  {
    "Id": "TASE:5127733",
    "MayaId": "5127733",
    "Name": "IBI.NACANAB",
    "ShortName": "IBI.NACANAB",
    "Symbol": "TASE:5127733",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4D) Solactive North American Cannabis",
    "EnglishLongName": "I.B.I. MEHAKA (4D) Solactive North American Cannabis",
    "HebrewName": "איביאי מחקה SO NA CANABIS",
    "HebrewLongName": "אי.בי.אי. מחקה (4D)י Solactive North American Cannabis",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 9.38,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 6.0,
    "MonthYield": 2.55,
    "YearYield": 2.55,
    "Last12MonthYield": 0.83,
    "ISIN": "IL0051277338"
  },
  {
    "Id": "TASE:5128442",
    "MayaId": "5128442",
    "Name": "IBI.NQGSSAN",
    "ShortName": "IBI.NQGSSAN",
    "Symbol": "TASE:5128442",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4D) Nasdaq Global Smart Airlines",
    "EnglishLongName": "I.B.I. MEHAKA (4D) Nasdaq Global Smart Airlines",
    "HebrewName": "איביאי מחקה NasdaqAirline",
    "HebrewLongName": "אי.בי.אי. מחקה (4D)י Nasdaq Global Smart Airlines",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.2,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 40.0,
    "MonthYield": 4.65,
    "YearYield": 4.65,
    "Last12MonthYield": 30.44,
    "ISIN": "IL0051284425"
  },
  {
    "Id": "TASE:5124284",
    "MayaId": "5124284",
    "Name": "IBI.RU20N30U",
    "ShortName": "IBI.RU20N30U",
    "Symbol": "TASE:5124284",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4D) Russell 2000",
    "EnglishLongName": "I.B.I. MEHAKA (4D) Russell 2000",
    "HebrewName": "איביאי מחקה Russell 2000",
    "HebrewLongName": "אי.בי.אי. מחקה (4D)י Russell 2000",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.23,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 93.1,
    "MonthYield": 6.28,
    "YearYield": 6.28,
    "Last12MonthYield": 4.23,
    "ISIN": "IL0051242845"
  },
  {
    "Id": "TASE:5122692",
    "MayaId": "5122692",
    "Name": "IBI.SOBBNTR",
    "ShortName": "IBI.SOBBNTR",
    "Symbol": "TASE:5122692",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4D) Solactive US REIT",
    "EnglishLongName": "I.B.I. MEHAKA (4D) Solactive US REIT",
    "HebrewName": "איביאי מחקה SOL US REIT",
    "HebrewLongName": "אי.בי.אי. מחקה (4D)י Solactive US REIT",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.22,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 12.7,
    "MonthYield": 2.82,
    "YearYield": 2.82,
    "Last12MonthYield": -6.2,
    "ISIN": "IL0051226921"
  },
  {
    "Id": "TASE:5127865",
    "MayaId": "5127865",
    "Name": "IBI.SOLFINT",
    "ShortName": "IBI.SOLFINT",
    "Symbol": "TASE:5127865",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4D) Solactive FinTech",
    "EnglishLongName": "I.B.I. MEHAKA (4D) Solactive FinTech",
    "HebrewName": "איביאי מחקה SOL Fintech",
    "HebrewLongName": "אי.בי.אי. מחקה (4D)י Solactive FinTech",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.8,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 6.9,
    "MonthYield": -3.08,
    "YearYield": -3.08,
    "Last12MonthYield": -9.37,
    "ISIN": "IL0051278658"
  },
  {
    "Id": "TASE:5127147",
    "MayaId": "5127147",
    "Name": "IBI.SOLNET",
    "ShortName": "IBI.SOLNET",
    "Symbol": "TASE:5127147",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4D) SOLACTIVE US INTERNET",
    "EnglishLongName": "I.B.I. MEHAKA (4D) SOLACTIVE US INTERNET",
    "HebrewName": "איביאי מחקה SO USInternet",
    "HebrewLongName": "אי.בי.אי. מחקה (4D)י Solactive US Internet",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.13,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 55.5,
    "MonthYield": -3.65,
    "YearYield": -3.65,
    "Last12MonthYield": -9.63,
    "ISIN": "IL0051271471"
  },
  {
    "Id": "TASE:5141221",
    "MayaId": "5141221",
    "Name": "IBI.Value Equity",
    "ShortName": "IBI.Value Equity",
    "Symbol": "TASE:5141221",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. (4B) Value Equity IL",
    "EnglishLongName": "I.B.I. (4B) Value Equity IL",
    "HebrewName": "איביאי מניות ערך",
    "HebrewLongName": "אי.בי.אי. (4B) מניות ערך",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 1.1,
    "MonthYield": 5.91,
    "YearYield": 5.91,
    "Last12MonthYield": null,
    "ISIN": "IL0051412216"
  },
  {
    "Id": "TASE:5137187",
    "MayaId": "5137187",
    "Name": "IBIMEHAKA CO EQ US L CURH",
    "ShortName": "IBIMEHAKA CO EQ US L CURH",
    "Symbol": "TASE:5137187",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A) COMPOSITE US EQUITY LARGE CAP MONTHLY Currency Hedged",
    "EnglishLongName": "I.B.I. MEHAKA (4A) COMPOSITE US EQUITY LARGE CAP MONTHLY Currency Hedged",
    "HebrewName": "איביאי מחקה מש מנ אר L ממ",
    "HebrewLongName": "אי.בי.אי מחקה (4A) משולבת מניות ארה\"ב Large Cap מנוטרלת מט\"ח חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.72,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks Abroad, Composite",
    "AssetValue": 58.1,
    "MonthYield": 1.82,
    "YearYield": 1.82,
    "Last12MonthYield": 17.11,
    "ISIN": "IL0051371875"
  },
  {
    "Id": "TASE:5131289",
    "MayaId": "5131289",
    "Name": "IBIMEHAKA CoGov90Bank10",
    "ShortName": "IBIMEHAKA CoGov90Bank10",
    "Symbol": "TASE:5131289",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (2A) Composite Gov.Bond (90%) Index Israel Banks (10%) Monthly IL",
    "EnglishLongName": "I.B.I. MEHAKA (2A) Composite Gov.Bond (90%) Index Israel Banks (10%) Monthly IL",
    "HebrewName": "איביאי מחקה משמדינה90ב10",
    "HebrewLongName": "אי.בי.אי. מחקה (2A) משולבת אג\"ח מדינה (90%) אינדקס בנקים ישראל (10%) חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.015,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.31,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Composite Government Bond - up to 10% Equity",
    "AssetValue": 49.0,
    "MonthYield": 1.26,
    "YearYield": 1.26,
    "Last12MonthYield": 10.43,
    "ISIN": "IL0051312895"
  },
  {
    "Id": "TASE:5115761",
    "MayaId": "5115761",
    "Name": "IBIMEHAKA COMB CO EQ8020",
    "ShortName": "IBIMEHAKA COMB CO EQ8020",
    "Symbol": "TASE:5115761",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (2A) COMPOSITE CORPORATE (80%) EQUITY (20%) MONTHLY IL",
    "EnglishLongName": "I.B.I. MEHAKA (2A) COMPOSITE CORPORATE (80%) EQUITY (20%) MONTHLY IL",
    "HebrewName": "איביאי מחקה מש קונצמנ8020",
    "HebrewLongName": "אי.בי.אי. מחקה (2A) משולבת קונצרני (80%) מניות (20%) חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.5,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Composite Bonds",
    "SecondaryClassification": "up to 20% Equity",
    "AssetValue": 36.7,
    "MonthYield": 2.08,
    "YearYield": 2.08,
    "Last12MonthYield": 16.0,
    "ISIN": "IL0051157613"
  },
  {
    "Id": "TASE:5119185",
    "MayaId": "5119185",
    "Name": "IBIMEHAKA COMB EQ CURHED",
    "ShortName": "IBIMEHAKA COMB EQ CURHED",
    "Symbol": "TASE:5119185",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A) COMPOSITE US EQUITY MONTHLY Currency Hedged",
    "EnglishLongName": "I.B.I. MEHAKA (4A) COMPOSITE US EQUITY MONTHLY Currency Hedged",
    "HebrewName": "איביאי מחקה מש מנ ארהב ממ",
    "HebrewLongName": "אי.בי.אי. מחקה (4A) משולבת מניות ארה\"ב חודשי מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.95,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks Abroad, Composite",
    "AssetValue": 360.1,
    "MonthYield": 3.44,
    "YearYield": 3.44,
    "Last12MonthYield": 18.2,
    "ISIN": "IL0051191851"
  },
  {
    "Id": "TASE:5119706",
    "MayaId": "5119706",
    "Name": "IBIMEHAKA COMBBONDEQ9010",
    "ShortName": "IBIMEHAKA COMBBONDEQ9010",
    "Symbol": "TASE:5119706",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (2A) COMPOSITE BOND (90%) EQUITY (10%) MONTHLY IL",
    "EnglishLongName": "I.B.I. MEHAKA (2A) COMPOSITE BOND (90%) EQUITY (10%) MONTHLY IL",
    "HebrewName": "איביאי מחקה מש אגח מנ9010",
    "HebrewLongName": "אי.בי.אי. מחקה (2A) משולבת אג\"ח (90%) מניות (10%) חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.38,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Composite Bonds",
    "SecondaryClassification": "up to 10% Equity",
    "AssetValue": 62.6,
    "MonthYield": 0.91,
    "YearYield": 0.91,
    "Last12MonthYield": 9.35,
    "ISIN": "IL0051197064"
  },
  {
    "Id": "TASE:5118690",
    "MayaId": "5118690",
    "Name": "IBIMEHAKA COMBSXXRDAXCUH",
    "ShortName": "IBIMEHAKA COMBSXXRDAXCUH",
    "Symbol": "TASE:5118690",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A)COMPOSITE STOXXEurope600(70%) DAX(30%) MONTHLY Currency Hedged",
    "EnglishLongName": "I.B.I. MEHAKA (4A)COMPOSITE STOXXEurope600(70%) DAX(30%) MONTHLY Currency Hedged",
    "HebrewName": "איביאי מחקה משStoxx Daxממ",
    "HebrewLongName": "אי.בי.אי. מחקה (4A) משולבת DAX (70%) STOXX Europe 600י (30%) חודשי מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.15,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks Abroad, Composite",
    "AssetValue": 56.9,
    "MonthYield": 3.62,
    "YearYield": 3.62,
    "Last12MonthYield": 24.93,
    "ISIN": "IL0051186901"
  },
  {
    "Id": "TASE:5122890",
    "MayaId": "5122890",
    "Name": "IBIMEHAKACOMBIXRIXYNTRCH",
    "ShortName": "IBIMEHAKACOMBIXRIXYNTRCH",
    "Symbol": "TASE:5122890",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "I.B.I. MEHAKA (4A)COMPOSITE S&PDscretionry(50%)Staple(50%)MONTHLY CurrencyHedged",
    "EnglishLongName": "I.B.I. MEHAKA (4A)COMPOSITE S&PDscretionry(50%)Staple(50%)MONTHLY CurrencyHedged",
    "HebrewName": "איביאי מחקה מש SPConsumממ",
    "HebrewLongName": "אי.בי.אי. מחקה(4A)משולבת Staplesי(50%) S&P Discretionaryי(50%)חודשי מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.45,
    "Sector": "",
    "Industry": "",
    "ManagerName": "I.B.I MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks Abroad, Composite",
    "AssetValue": 12.0,
    "MonthYield": 4.36,
    "YearYield": 4.36,
    "Last12MonthYield": 6.49,
    "ISIN": "IL0051228901"
  },
  {
    "Id": "ICHO.TA",
    "MayaId": "1103852",
    "Name": "IC HOTELS",
    "ShortName": "ISRAEL CANADA HOTELS LTD",
    "Symbol": "ICHO.TA",
    "TaseSymbol": "ICHO",
    "YahooId": "ICHO.TA",
    "EnglishName": "IC HOTELS",
    "EnglishLongName": "ISRAEL CANADA HOTELS LTD",
    "HebrewName": "ישראל קנדה מלונ",
    "HebrewLongName": "ישראל קנדה מלונות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 104.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Investment & Holdings",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.2,
    "YearYield": 1.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011038523"
  },
  {
    "Id": "ICL.TA",
    "MayaId": "281014",
    "Name": "ICL",
    "ShortName": "ICL GROUP LTD",
    "Symbol": "ICL.TA",
    "TaseSymbol": "ICL",
    "YahooId": "ICL.TA",
    "EnglishName": "ICL",
    "EnglishLongName": "ICL GROUP LTD",
    "HebrewName": "איי.סי.אל",
    "HebrewLongName": "איי.סי.אל גרופ בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1658.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -9.5,
    "YearYield": -9.5,
    "Last12MonthYield": null,
    "ISIN": "IL0002810146"
  },
  {
    "Id": "ICON.TA",
    "MayaId": "1182484",
    "Name": "ICON GROUP",
    "ShortName": "ICON GROUP LTD",
    "Symbol": "ICON.TA",
    "TaseSymbol": "ICON",
    "YahooId": "ICON.TA",
    "EnglishName": "ICON GROUP",
    "EnglishLongName": "ICON GROUP LTD",
    "HebrewName": "אייקון גרופ",
    "HebrewLongName": "אייקון גרופ בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 545.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 6.4,
    "YearYield": 6.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011824849"
  },
  {
    "Id": "IDNT.TA",
    "MayaId": "1177450",
    "Name": "IDENTI",
    "ShortName": "IDENTI HEALTHCARE LTD",
    "Symbol": "IDNT.TA",
    "TaseSymbol": "IDNT",
    "YahooId": "IDNT.TA",
    "EnglishName": "IDENTI",
    "EnglishLongName": "IDENTI HEALTHCARE LTD",
    "HebrewName": "איידנטי",
    "HebrewLongName": "איידנטי הלת'קייר בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 170.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 7.3,
    "YearYield": 7.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011774507"
  },
  {
    "Id": "IDIN.TA",
    "MayaId": "1129501",
    "Name": "IDI INSUR",
    "ShortName": "I.D.I. INSURANCE COMPANY LTD",
    "Symbol": "IDIN.TA",
    "TaseSymbol": "IDIN",
    "YahooId": "IDIN.TA",
    "EnglishName": "IDI INSUR",
    "EnglishLongName": "I.D.I. INSURANCE COMPANY LTD",
    "HebrewName": "איידיאיי ביטוח",
    "HebrewLongName": "איי.די.איי. חברה לביטוח בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 23300.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Insurance",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -1.3,
    "YearYield": -1.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011295016"
  },
  {
    "Id": "IDMO.TA",
    "MayaId": "1176346",
    "Name": "IDOMOO",
    "ShortName": "IDOMOO LTD",
    "Symbol": "IDMO.TA",
    "TaseSymbol": "IDMO",
    "YahooId": "IDMO.TA",
    "EnglishName": "IDOMOO",
    "EnglishLongName": "IDOMOO LTD",
    "HebrewName": "אידומו",
    "HebrewLongName": "אידומו בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 397.5,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 8.2,
    "YearYield": 8.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011763468"
  },
  {
    "Id": "IES.TA",
    "MayaId": "431015",
    "Name": "IES",
    "ShortName": "IES HOLDINGS LTD.",
    "Symbol": "IES.TA",
    "TaseSymbol": "IES",
    "YahooId": "IES.TA",
    "EnglishName": "IES",
    "EnglishLongName": "IES HOLDINGS LTD.",
    "HebrewName": "אייאיאס",
    "HebrewLongName": "איי.אי.אס החזקות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 42270.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 4.1,
    "YearYield": 4.1,
    "Last12MonthYield": null,
    "ISIN": "IL0004310152"
  },
  {
    "Id": "ILDR.TA",
    "MayaId": "1121474",
    "Name": "ILD RENEWAL",
    "ShortName": "ISRAEL LAND DEVELOPMENT URBAN RENEWAL LTD",
    "Symbol": "ILDR.TA",
    "TaseSymbol": "ILDR",
    "YahooId": "ILDR.TA",
    "EnglishName": "ILD RENEWAL",
    "EnglishLongName": "ISRAEL LAND DEVELOPMENT URBAN RENEWAL LTD",
    "HebrewName": "הכשרה התחדשות",
    "HebrewLongName": "הכשרת הישוב התחדשות עירונית ישראל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1092.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.7,
    "YearYield": 0.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011214744"
  },
  {
    "Id": "ILX.TA",
    "MayaId": "1080753",
    "Name": "ILEX MEDICAL",
    "ShortName": "ILEX MEDICAL LTD.",
    "Symbol": "ILX.TA",
    "TaseSymbol": "ILX",
    "YahooId": "ILX.TA",
    "EnglishName": "ILEX MEDICAL",
    "EnglishLongName": "ILEX MEDICAL LTD.",
    "HebrewName": "אילקס מדיקל",
    "HebrewLongName": "אילקס מדיקל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 6475.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -1.7,
    "YearYield": -1.7,
    "Last12MonthYield": null,
    "ISIN": "IL0010807530"
  },
  {
    "Id": "ISI.TA",
    "MayaId": "1183813",
    "Name": "IMAGESAT I.S.I",
    "ShortName": "IMAGESAT INTERNATIONAL (I.S.I) LTD.",
    "Symbol": "ISI.TA",
    "TaseSymbol": "ISI",
    "YahooId": "ISI.TA",
    "EnglishName": "IMAGESAT  I.S.I",
    "EnglishLongName": "IMAGESAT INTERNATIONAL (I.S.I) LTD.",
    "HebrewName": "אימאג'סט",
    "HebrewLongName": "אימאג'סט אינטרנשיונל(אי.אס.איי)בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1817.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 27.9,
    "YearYield": 27.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011838138"
  },
  {
    "Id": "IMCO.TA",
    "MayaId": "282012",
    "Name": "IMCO",
    "ShortName": "IMCO INDUSTRIES LTD.",
    "Symbol": "IMCO.TA",
    "TaseSymbol": "IMCO",
    "YahooId": "IMCO.TA",
    "EnglishName": "IMCO",
    "EnglishLongName": "IMCO INDUSTRIES LTD.",
    "HebrewName": "אימקו",
    "HebrewLongName": "אימקו תעשיות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 10890.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 30.6,
    "YearYield": 30.6,
    "Last12MonthYield": null,
    "ISIN": "IL0002820129"
  },
  {
    "Id": "TASE:5117734",
    "MayaId": "5117734",
    "Name": "IMPACT (2B) 20/80 IL",
    "ShortName": "IMPACT (2B) 20/80 IL",
    "Symbol": "TASE:5117734",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "IMPACT (2B) 20/80 IL",
    "EnglishLongName": "IMPACT (2B) 20/80 IL",
    "HebrewName": "אימפקט (2B)י 20/80",
    "HebrewLongName": "אימפקט (2B)י 20/80",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.85,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.46,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 59.0,
    "MonthYield": 2.01,
    "YearYield": 2.01,
    "Last12MonthYield": 14.94,
    "ISIN": "IL0051177348"
  },
  {
    "Id": "TASE:5120225",
    "MayaId": "5120225",
    "Name": "IMPACT (4B) STOCKS IL",
    "ShortName": "IMPACT (4B) STOCKS IL",
    "Symbol": "TASE:5120225",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "IMPACT (4B) STOCKS IL",
    "EnglishLongName": "IMPACT (4B) STOCKS IL",
    "HebrewName": "אימפקט (4B) מניות",
    "HebrewLongName": "אימפקט (4B) מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.6,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 80.2,
    "MonthYield": 8.95,
    "YearYield": 8.95,
    "Last12MonthYield": 71.11,
    "ISIN": "IL0051202252"
  },
  {
    "Id": "TASE:5134143",
    "MayaId": "5134143",
    "Name": "IMPACT (4D) Global Shares",
    "ShortName": "IMPACT (4D) Global Shares",
    "Symbol": "TASE:5134143",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "IMPACT (4D) Global Shares",
    "EnglishLongName": "IMPACT (4D) Global Shares",
    "HebrewName": "אימפקט (4D)י Global Share",
    "HebrewLongName": "אימפקט (4D)י Global Shares",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.67,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.69,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 278.2,
    "MonthYield": 3.65,
    "YearYield": 3.65,
    "Last12MonthYield": 35.89,
    "ISIN": "IL0051341431"
  },
  {
    "Id": "TASE:5130729",
    "MayaId": "5130729",
    "Name": "IMPACT 10/90 IL",
    "ShortName": "IMPACT 10/90 IL",
    "Symbol": "TASE:5130729",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "IMPACT (1B) 10/90 IL",
    "EnglishLongName": "IMPACT (1B) 10/90 IL",
    "HebrewName": "אימפקט 10/90",
    "HebrewLongName": "אימפקט (1B)י 10/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.31,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 40.3,
    "MonthYield": 1.33,
    "YearYield": 1.33,
    "Last12MonthYield": 10.81,
    "ISIN": "IL0051307291"
  },
  {
    "Id": "TASE:73",
    "MayaId": "73",
    "Name": "Industry Shares and Convertibles",
    "ShortName": "Industry Shares and Convertibles",
    "Symbol": "TASE:73",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Industry Shares and Convertibles",
    "EnglishLongName": "Industry Shares and Convertibles",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "INRM.TA",
    "MayaId": "1132356",
    "Name": "INROM CONST",
    "ShortName": "INROM CONSTRUCTION INDUSTRIES LTD",
    "Symbol": "INRM.TA",
    "TaseSymbol": "INRM",
    "YahooId": "INRM.TA",
    "EnglishName": "INROM CONST",
    "EnglishLongName": "INROM CONSTRUCTION INDUSTRIES LTD",
    "HebrewName": "אינרום",
    "HebrewLongName": "אינרום תעשיות בנייה בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2099.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -1.8,
    "YearYield": -1.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011323560"
  },
  {
    "Id": "ININ.TA",
    "MayaId": "1080928",
    "Name": "INTER INDSTRIES",
    "ShortName": "INTER INDUSTRIES PLUS LTD",
    "Symbol": "ININ.TA",
    "TaseSymbol": "ININ",
    "YahooId": "ININ.TA",
    "EnglishName": "INTER INDSTRIES",
    "EnglishLongName": "INTER INDUSTRIES PLUS LTD",
    "HebrewName": "אינטר תעשיות",
    "HebrewLongName": "אינטר תעשיות פלוס בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 236.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -2.5,
    "YearYield": -2.5,
    "Last12MonthYield": null,
    "ISIN": "IL0010809288"
  },
  {
    "Id": "INCR.TA",
    "MayaId": "1106376",
    "Name": "INTERCURE",
    "ShortName": "INTERCURE LTD",
    "Symbol": "INCR.TA",
    "TaseSymbol": "INCR",
    "YahooId": "INCR.TA",
    "EnglishName": "INTERCURE",
    "EnglishLongName": "INTERCURE LTD",
    "HebrewName": "אינטרקיור",
    "HebrewLongName": "אינטרקיור בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 305.1,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -7.0,
    "YearYield": -7.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011063760"
  },
  {
    "Id": "INTR.TA",
    "MayaId": "174011",
    "Name": "INTERGAMA",
    "ShortName": "INTER-GAMMA INVESTMENT LTD.",
    "Symbol": "INTR.TA",
    "TaseSymbol": "INTR",
    "YahooId": "INTR.TA",
    "EnglishName": "INTERGAMA",
    "EnglishLongName": "INTER-GAMMA INVESTMENT LTD.",
    "HebrewName": "אינטרגאמא",
    "HebrewLongName": "אינטר גאמא חברה להשקעות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 8062.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.0,
    "YearYield": 0.0,
    "Last12MonthYield": null,
    "ISIN": "IL0001740112"
  },
  {
    "Id": "IN.FF5.TA",
    "MayaId": "1183482",
    "Name": "INV.FRF.NASDAQ",
    "ShortName": "INVESCO INVESTMENT MANAGEMENT LIMITED",
    "Symbol": "IN.FF5.TA",
    "TaseSymbol": "IN.FF5",
    "YahooId": "IN.FF5.TA",
    "EnglishName": "INV.FRF.NASDAQ",
    "EnglishLongName": "INVESCO KBW NASDAQ FINTECH UCITS ETF",
    "HebrewName": "אינבסקו.חוץNASDAQ.FINTECH",
    "HebrewLongName": "INVESCO KBW NASDAQ FINTECH UCITS ETF",
    "Type": "4",
    "SubType": "44",
    "SubTypeDesc": "Foreign ETF - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 18320.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "Foreign Fund Traded",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -2.1,
    "YearYield": -2.1,
    "Last12MonthYield": null,
    "ISIN": "IE00BYMS5W68"
  },
  {
    "Id": "IN.FF7.TA",
    "MayaId": "1185164",
    "Name": "INV.FRF.WORLD",
    "ShortName": "INVESCO INVESTMENT MANAGEMENT LIMITED",
    "Symbol": "IN.FF7.TA",
    "TaseSymbol": "IN.FF7",
    "YahooId": "IN.FF7.TA",
    "EnglishName": "INV.FRF.WORLD",
    "EnglishLongName": "INVESCO MSCI WORLD UCITS ETF ACC",
    "HebrewName": "אינבסקו חוץMSCI.WORLD",
    "HebrewLongName": "INVESCO MSCI WORLD UCITS ETF ACC",
    "Type": "4",
    "SubType": "44",
    "SubTypeDesc": "Foreign ETF - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 44580.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "Foreign Fund Traded",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -0.3,
    "YearYield": -0.3,
    "Last12MonthYield": null,
    "ISIN": "IE00B60SX394"
  },
  {
    "Id": "IN.FF11.TA",
    "MayaId": "1186055",
    "Name": "INV.FRFBLOCK",
    "ShortName": "INVESCO INVESTMENT MANAGEMENT LIMITED",
    "Symbol": "IN.FF11.TA",
    "TaseSymbol": "IN.FF11",
    "YahooId": "IN.FF11.TA",
    "EnglishName": "INV.FRFBLOCK",
    "EnglishLongName": "Invesco CoinShares Global Blockchain UCITS ETF Acc",
    "HebrewName": "אינבסקו.חוץBLOCKCHAIN",
    "HebrewLongName": "Invesco CoinShares Global Blockchain UCITS ETF Acc",
    "Type": "4",
    "SubType": "44",
    "SubTypeDesc": "Foreign ETF - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 54230.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "Foreign Fund Traded",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 10.5,
    "YearYield": 10.5,
    "Last12MonthYield": null,
    "ISIN": "IE00BGBN6P67"
  },
  {
    "Id": "IN.FF13.TA",
    "MayaId": "1186071",
    "Name": "INV.FRFCHINA",
    "ShortName": "INVESCO INVESTMENT MANAGEMENT LIMITED",
    "Symbol": "IN.FF13.TA",
    "TaseSymbol": "IN.FF13",
    "YahooId": "IN.FF13.TA",
    "EnglishName": "INV.FRFCHINA",
    "EnglishLongName": "INVESCO MSCI CHINA ALL SHARES STOCK CONNECT UCITS ETF ACC",
    "HebrewName": "אינבסקו.חוץMSCICHINA",
    "HebrewLongName": "INVESCO MSCI CHINA ALL SHARES STOCK CONNECT UCITS ETF ACC",
    "Type": "4",
    "SubType": "44",
    "SubTypeDesc": "Foreign ETF - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 10410.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "Foreign Fund Traded",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 3.4,
    "YearYield": 3.4,
    "Last12MonthYield": null,
    "ISIN": "IE00BK80XL30"
  },
  {
    "Id": "IN.FF3.TA",
    "MayaId": "1183466",
    "Name": "INV.FRFFINS&P",
    "ShortName": "INVESCO INVESTMENT MANAGEMENT LIMITED",
    "Symbol": "IN.FF3.TA",
    "TaseSymbol": "IN.FF3",
    "YahooId": "IN.FF3.TA",
    "EnglishName": "INV.FRFFINS&P",
    "EnglishLongName": "INVESCO FINANCIALS S&P US SELECT SECTOR UCITS ETF",
    "HebrewName": "אינבסקו.חוץPUCITSETF&FINS",
    "HebrewLongName": "INVESCO FINANCIALS S&P US SELECT SECTOR UCITS ETF",
    "Type": "4",
    "SubType": "44",
    "SubTypeDesc": "Foreign ETF - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 133340.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "Foreign Fund Traded",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -3.4,
    "YearYield": -3.4,
    "Last12MonthYield": null,
    "ISIN": "IE00B42Q4896"
  },
  {
    "Id": "IN.FF17.TA",
    "MayaId": "1209220",
    "Name": "INV.FRFFTSEAW",
    "ShortName": "INVESCO INVESTMENT MANAGEMENT LIMITED",
    "Symbol": "IN.FF17.TA",
    "TaseSymbol": "IN.FF17",
    "YahooId": "IN.FF17.TA",
    "EnglishName": "INV.FRFFTSEAW",
    "EnglishLongName": "Invesco FTSE ALL-WORLD UCITS ETF (מספר קרן: 1209220)",
    "HebrewName": "אינבסקו.חוץ.FTSEALLWORLD",
    "HebrewLongName": "Invesco FTSE ALL-WORLD UCITS ETF (מספר קרן: 1209220)",
    "Type": "4",
    "SubType": "44",
    "SubTypeDesc": "Foreign ETF - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2678.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "Foreign Fund Traded",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -0.1,
    "YearYield": -0.1,
    "Last12MonthYield": null,
    "ISIN": "IE000716YHJ7"
  },
  {
    "Id": "IN.FF10.TA",
    "MayaId": "1185206",
    "Name": "INV.FRFIBOXX",
    "ShortName": "INVESCO INVESTMENT MANAGEMENT LIMITED",
    "Symbol": "IN.FF10.TA",
    "TaseSymbol": "IN.FF10",
    "YahooId": "IN.FF10.TA",
    "EnglishName": "INV.FRFIBOXX",
    "EnglishLongName": "INVESCO AT1 CAPITAL BOND UCITS ETF ACC",
    "HebrewName": "אינבסקו.חוץIBOXX.AT1.USD",
    "HebrewLongName": "INVESCO AT1 CAPITAL BOND UCITS ETF ACC",
    "Type": "4",
    "SubType": "45",
    "SubTypeDesc": "Foreign ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 9468.9,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "Foreign Fund Bond Traded",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -0.2,
    "YearYield": -0.2,
    "Last12MonthYield": null,
    "ISIN": "IE00BFZPF322"
  },
  {
    "Id": "IN.FF6.TA",
    "MayaId": "1183490",
    "Name": "INV.FRFMSCIEM",
    "ShortName": "INVESCO INVESTMENT MANAGEMENT LIMITED",
    "Symbol": "IN.FF6.TA",
    "TaseSymbol": "IN.FF6",
    "YahooId": "IN.FF6.TA",
    "EnglishName": "INV.FRFMSCIEM",
    "EnglishLongName": "INVESCO MSCI EMERGING MARKETS UCITS ETF",
    "HebrewName": "אינבסקו.חוץMSCIEMUCITSETF",
    "HebrewLongName": "INVESCO MSCI EMERGING MARKETS UCITS ETF",
    "Type": "4",
    "SubType": "44",
    "SubTypeDesc": "Foreign ETF - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 22970.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "Foreign Fund Traded",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 4.5,
    "YearYield": 4.5,
    "Last12MonthYield": null,
    "ISIN": "IE00B3DWVS88"
  },
  {
    "Id": "IN.FF12.TA",
    "MayaId": "1186063",
    "Name": "INV.FRFNASDAQ",
    "ShortName": "INVESCO INVESTMENT MANAGEMENT LIMITED",
    "Symbol": "IN.FF12.TA",
    "TaseSymbol": "IN.FF12",
    "YahooId": "IN.FF12.TA",
    "EnglishName": "INV.FRFNASDAQ",
    "EnglishLongName": "INVESCO NASDAQ-100 SWAP UCITS ETF ACC",
    "HebrewName": "אינבסקו.חוץNASDAQ100SWAP",
    "HebrewLongName": "INVESCO NASDAQ-100 SWAP UCITS ETF ACC",
    "Type": "4",
    "SubType": "44",
    "SubTypeDesc": "Foreign ETF - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 24860.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "Foreign Fund Traded",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -1.9,
    "YearYield": -1.9,
    "Last12MonthYield": null,
    "ISIN": "IE00BNRQM384"
  },
  {
    "Id": "IN.FF15.TA",
    "MayaId": "1206895",
    "Name": "INV.FRFRUSS2000",
    "ShortName": "INVESCO INVESTMENT MANAGEMENT LIMITED",
    "Symbol": "IN.FF15.TA",
    "TaseSymbol": "IN.FF15",
    "YahooId": "IN.FF15.TA",
    "EnglishName": "INV.FRFRUSS2000",
    "EnglishLongName": "Invesco Russell 2000 UCITS ETF Acc (מספר קרן: 1206895)",
    "HebrewName": "אינבסקו.חוץ.RUSSELL.2000",
    "HebrewLongName": "Invesco Russell 2000 UCITS ETF Acc (מספר קרן: 1206895)",
    "Type": "4",
    "SubType": "44",
    "SubTypeDesc": "Foreign ETF - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 42520.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "Foreign Fund Traded",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 5.1,
    "YearYield": 5.1,
    "Last12MonthYield": null,
    "ISIN": "IE00B60SX402"
  },
  {
    "Id": "IN.FF1.TA",
    "MayaId": "1183441",
    "Name": "INV.FRFS&P 500",
    "ShortName": "INVESCO INVESTMENT MANAGEMENT LIMITED",
    "Symbol": "IN.FF1.TA",
    "TaseSymbol": "IN.FF1",
    "YahooId": "IN.FF1.TA",
    "EnglishName": "INV.FRFS&P 500",
    "EnglishLongName": "INVESCO S&P 500 UCITS ETF",
    "HebrewName": "אינבסקו.חוץ",
    "HebrewLongName": "INVESCO S&P 500 UCITS ETF",
    "Type": "4",
    "SubType": "44",
    "SubTypeDesc": "Foreign ETF - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4323.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "Foreign Fund Traded",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -1.1,
    "YearYield": -1.1,
    "Last12MonthYield": null,
    "ISIN": "IE00B3YCGJ38"
  },
  {
    "Id": "IN.FF16.TA",
    "MayaId": "1207208",
    "Name": "INV.FRFS&P 500EW",
    "ShortName": "INVESCO INVESTMENT MANAGEMENT LIMITED",
    "Symbol": "IN.FF16.TA",
    "TaseSymbol": "IN.FF16",
    "YahooId": "IN.FF16.TA",
    "EnglishName": "INV.FRFS&P500EW",
    "EnglishLongName": "INVESCO S&P 500 EQUAL WEIGHT UCITS ETF ACC",
    "HebrewName": "אינבסקו.חוץS&P500EW.UCITS",
    "HebrewLongName": "INVESCO S&P 500 EQUAL WEIGHT UCITS ETF ACC",
    "Type": "4",
    "SubType": "44",
    "SubTypeDesc": "Foreign ETF - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 21110.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "Foreign Fund Traded",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.8,
    "YearYield": 1.8,
    "Last12MonthYield": null,
    "ISIN": "IE00BNGJJT35"
  },
  {
    "Id": "IN.FF4.TA",
    "MayaId": "1183474",
    "Name": "INV.FRFS&P.CARE",
    "ShortName": "INVESCO INVESTMENT MANAGEMENT LIMITED",
    "Symbol": "IN.FF4.TA",
    "TaseSymbol": "IN.FF4",
    "YahooId": "IN.FF4.TA",
    "EnglishName": "INV.FRFS&P.CARE",
    "EnglishLongName": "INVESCO HEALTH CARE S&P US SELECT SECTOR UCITS ETF",
    "HebrewName": "אינבסקו.חוץP.HEALTCARE&S",
    "HebrewLongName": "INVESCO HEALTH CARE S&P US SELECT SECTOR UCITS ETF",
    "Type": "4",
    "SubType": "44",
    "SubTypeDesc": "Foreign ETF - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 242100.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "Foreign Fund Traded",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -1.8,
    "YearYield": -1.8,
    "Last12MonthYield": null,
    "ISIN": "IE00B3WMTH43"
  },
  {
    "Id": "IN.FF2.TA",
    "MayaId": "1183458",
    "Name": "INV.FRFS&PSCORE",
    "ShortName": "INVESCO INVESTMENT MANAGEMENT LIMITED",
    "Symbol": "IN.FF2.TA",
    "TaseSymbol": "IN.FF2",
    "YahooId": "IN.FF2.TA",
    "EnglishName": "INV.FRFS&PSCORE",
    "EnglishLongName": "INVESCO S&P 500 ESG UCITS ETF",
    "HebrewName": "אינבסקו.חוץ.P.SCORED&S",
    "HebrewLongName": "INVESCO S&P 500 ESG UCITS ETF",
    "Type": "4",
    "SubType": "44",
    "SubTypeDesc": "Foreign ETF - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 30130.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "Foreign Fund Traded",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -1.5,
    "YearYield": -1.5,
    "Last12MonthYield": null,
    "ISIN": "IE00BKS7L097"
  },
  {
    "Id": "IN.FF9.TA",
    "MayaId": "1185180",
    "Name": "INV.FRFS&PTEC",
    "ShortName": "INVESCO INVESTMENT MANAGEMENT LIMITED",
    "Symbol": "IN.FF9.TA",
    "TaseSymbol": "IN.FF9",
    "YahooId": "IN.FF9.TA",
    "EnglishName": "INV.FRFS&PTEC",
    "EnglishLongName": "INVESCO TECHNOLOGY S&P US SELECT SECTOR UCITS ETF ACC",
    "HebrewName": "אינבסקו.חוץP.TECHNOLOGY&S",
    "HebrewLongName": "INVESCO TECHNOLOGY S&P US SELECT SECTOR UCITS ETF ACC",
    "Type": "4",
    "SubType": "44",
    "SubTypeDesc": "Foreign ETF - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 267200.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "Foreign Fund Traded",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -3.1,
    "YearYield": -3.1,
    "Last12MonthYield": null,
    "ISIN": "IE00B3VSSL01"
  },
  {
    "Id": "IN.FF14.TA",
    "MayaId": "1207190",
    "Name": "INV.FRFSTOXX50",
    "ShortName": "INVESCO INVESTMENT MANAGEMENT LIMITED",
    "Symbol": "IN.FF14.TA",
    "TaseSymbol": "IN.FF14",
    "YahooId": "IN.FF14.TA",
    "EnglishName": "INV.FRFSTOXX50",
    "EnglishLongName": "INVESCO EURO STOXX 50 UCITS ETF ACC",
    "HebrewName": "אינבסקו.חוץEUSTOXX50UCITS",
    "HebrewLongName": "INVESCO EURO STOXX 50 UCITS ETF ACC",
    "Type": "4",
    "SubType": "44",
    "SubTypeDesc": "Foreign ETF - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 55880.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "Foreign Fund Traded",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.5,
    "YearYield": 1.5,
    "Last12MonthYield": null,
    "ISIN": "IE00B60SWX25"
  },
  {
    "Id": "IN.FF8.TA",
    "MayaId": "1185172",
    "Name": "INV.FRFSTOXX600",
    "ShortName": "INVESCO INVESTMENT MANAGEMENT LIMITED",
    "Symbol": "IN.FF8.TA",
    "TaseSymbol": "IN.FF8",
    "YahooId": "IN.FF8.TA",
    "EnglishName": "INV.FRFSTOXX600",
    "EnglishLongName": "INVESCO STOXX EUROPE 600 UCITS ETF ACC",
    "HebrewName": "אינבסקו.חוץSTOX.EUROPE600",
    "HebrewLongName": "INVESCO STOXX EUROPE 600 UCITS ETF ACC",
    "Type": "4",
    "SubType": "44",
    "SubTypeDesc": "Foreign ETF - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 55850.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "Foreign Fund Traded",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.1,
    "YearYield": 1.1,
    "Last12MonthYield": null,
    "ISIN": "IE00B60SWW18"
  },
  {
    "Id": "TASE:117",
    "MayaId": "117",
    "Name": "Investment & Holdings Shares and Convertibles",
    "ShortName": "Investment & Holdings Shares and Convertibles",
    "Symbol": "TASE:117",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Investment & Holdings Shares and Convertibles",
    "EnglishLongName": "Investment & Holdings Shares and Convertibles",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:5136262",
    "MayaId": "5136262",
    "Name": "Investor 360 Flexible",
    "ShortName": "Investor 360 Flexible",
    "Symbol": "TASE:5136262",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Investor 360 (4D) Flexible",
    "EnglishLongName": "Investor 360 (4D) Flexible",
    "HebrewName": "אינווסטור 360 גמישה",
    "HebrewLongName": "אינווסטור 360 (4D) גמישה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.9,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 275.5,
    "MonthYield": 7.53,
    "YearYield": 7.53,
    "Last12MonthYield": 76.59,
    "ISIN": "IL0051362627"
  },
  {
    "Id": "TASE:5135801",
    "MayaId": "5135801",
    "Name": "Investor360 Global Equity",
    "ShortName": "Investor360 Global Equity",
    "Symbol": "TASE:5135801",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Investor 360 (4D) Global Equity",
    "EnglishLongName": "Investor 360 (4D) Global Equity",
    "HebrewName": "אינווסטור360 מניות חו\"ל",
    "HebrewLongName": "אינווסטור 360 (4D) מניות חו\"ל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.045,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.54,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 21.9,
    "MonthYield": 3.46,
    "YearYield": 3.46,
    "Last12MonthYield": 7.86,
    "ISIN": "IL0051358013"
  },
  {
    "Id": "TASE:5135793",
    "MayaId": "5135793",
    "Name": "Investor360 Val Equity IL",
    "ShortName": "Investor360 Val Equity IL",
    "Symbol": "TASE:5135793",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Investor 360 (4B) Value Equity IL",
    "EnglishLongName": "Investor 360 (4B) Value Equity IL",
    "HebrewName": "אינווסטור360 מניות ערך יש",
    "HebrewLongName": "אינווסטור 360 (4B) מניות ערך ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.045,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.37,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 24.0,
    "MonthYield": 9.34,
    "YearYield": 9.34,
    "Last12MonthYield": 65.42,
    "ISIN": "IL0051357932"
  },
  {
    "Id": "IS.FF403.TA",
    "MayaId": "1159136",
    "Name": "ISH.FRF DGTL GL",
    "ShortName": "BLACKROCK ASSET MANAGEMENT IRELAND LIMITED",
    "Symbol": "IS.FF403.TA",
    "TaseSymbol": "IS.FF403",
    "YahooId": "IS.FF403.TA",
    "EnglishName": "ISH.FRF DGTL GL",
    "EnglishLongName": "ISHARES DIGITALISATION UCITS ETF UCITS ETF",
    "HebrewName": "איישרס.חוץ DIGITALISATION",
    "HebrewLongName": "ISHARES DIGITALISATION UCITS ETF UCITS ETF",
    "Type": "4",
    "SubType": "44",
    "SubTypeDesc": "Foreign ETF - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3409.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "Foreign Fund Traded",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -2.6,
    "YearYield": -2.6,
    "Last12MonthYield": null,
    "ISIN": "IE00BYZK4883"
  },
  {
    "Id": "IS.FF204.TA",
    "MayaId": "1159086",
    "Name": "ISH.FRF FLOT US",
    "ShortName": "BLACKROCK ASSET MANAGEMENT IRELAND LIMITED",
    "Symbol": "IS.FF204.TA",
    "TaseSymbol": "IS.FF204",
    "YahooId": "IS.FF204.TA",
    "EnglishName": "ISH.FRF FLOT US",
    "EnglishLongName": "ISHARES $ FLOATING RATE BOND UCITS ETF",
    "HebrewName": "איישרס.חוץ $ FLOATING RAT",
    "HebrewLongName": "ISHARES $ FLOATING RATE BOND UCITS ETF",
    "Type": "4",
    "SubType": "45",
    "SubTypeDesc": "Foreign ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2035.7,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "Foreign Fund Bond Traded",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -0.5,
    "YearYield": -0.5,
    "Last12MonthYield": null,
    "ISIN": "IE00BDFGJ627"
  },
  {
    "Id": "IS.FF302.TA",
    "MayaId": "1159102",
    "Name": "ISH.FRF GLB AGG",
    "ShortName": "BLACKROCK ASSET MANAGEMENT IRELAND LIMITED",
    "Symbol": "IS.FF302.TA",
    "TaseSymbol": "IS.FF302",
    "YahooId": "IS.FF302.TA",
    "EnglishName": "ISH.FRF GLB AGG",
    "EnglishLongName": "ISHARES CORE GLOBAL AGGREGATE BOND UCITS ETF",
    "HebrewName": "איישרס.חוץGLOBALAGGREGATE",
    "HebrewLongName": "ISHARES CORE GLOBAL AGGREGATE BOND UCITS ETF",
    "Type": "4",
    "SubType": "45",
    "SubTypeDesc": "Foreign ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1834.75,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "Foreign Fund Bond Traded",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -0.8,
    "YearYield": -0.8,
    "Last12MonthYield": null,
    "ISIN": "IE00BZ043R46"
  },
  {
    "Id": "IS.FF402.TA",
    "MayaId": "1159128",
    "Name": "ISH.FRF HEAL GL",
    "ShortName": "BLACKROCK ASSET MANAGEMENT IRELAND LIMITED",
    "Symbol": "IS.FF402.TA",
    "TaseSymbol": "IS.FF402",
    "YahooId": "IS.FF402.TA",
    "EnglishName": "ISH.FRF HEAL GL",
    "EnglishLongName": "ISHARES HEALTHCARE INNOVATION UCITS ETF",
    "HebrewName": "איישרס.חוץ HEALTHCARE INN",
    "HebrewLongName": "ISHARES HEALTHCARE INNOVATION UCITS ETF",
    "Type": "4",
    "SubType": "44",
    "SubTypeDesc": "Foreign ETF - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2919.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "Foreign Fund Traded",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.4,
    "YearYield": 1.4,
    "Last12MonthYield": null,
    "ISIN": "IE00BYZK4776"
  },
  {
    "Id": "IS.FF203.TA",
    "MayaId": "1159078",
    "Name": "ISH.FRF HIGH YL",
    "ShortName": "BLACKROCK ASSET MANAGEMENT IRELAND LIMITED",
    "Symbol": "IS.FF203.TA",
    "TaseSymbol": "IS.FF203",
    "YahooId": "IS.FF203.TA",
    "EnglishName": "ISH.FRF HIGH YL",
    "EnglishLongName": "ISHARES $ HIGH YIELD CORP BOND UCITS ETF",
    "HebrewName": "איישרס.חוץ HIGH YLD CRP $",
    "HebrewLongName": "ISHARES $ HIGH YIELD CORP BOND UCITS ETF",
    "Type": "4",
    "SubType": "45",
    "SubTypeDesc": "Foreign ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2344.7,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "Foreign Fund Bond Traded",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.0,
    "YearYield": 0.0,
    "Last12MonthYield": null,
    "ISIN": "IE00BYXYYL56"
  },
  {
    "Id": "IS.FF201.TA",
    "MayaId": "1158989",
    "Name": "ISH.FRF JPEMD $",
    "ShortName": "BLACKROCK ASSET MANAGEMENT IRELAND LIMITED",
    "Symbol": "IS.FF201.TA",
    "TaseSymbol": "IS.FF201",
    "YahooId": "IS.FF201.TA",
    "EnglishName": "ISH.FRF JPEMD $",
    "EnglishLongName": "ISHARES J.P. MORGAN $ EM BOND UCITS ETF",
    "HebrewName": "איישרס.חוץ JPMORGAN  EMD$",
    "HebrewLongName": "ISHARES J.P. MORGAN $ EM BOND UCITS ETF",
    "Type": "4",
    "SubType": "45",
    "SubTypeDesc": "Foreign ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2084.1,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "Foreign Fund Bond Traded",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.0,
    "YearYield": 0.0,
    "Last12MonthYield": null,
    "ISIN": "IE00BYXYYK40"
  },
  {
    "Id": "IS.FF103.TA",
    "MayaId": "1159185",
    "Name": "ISH.FRF LQDA US",
    "ShortName": "BLACKROCK ASSET MANAGEMENT IRELAND LIMITED",
    "Symbol": "IS.FF103.TA",
    "TaseSymbol": "IS.FF103",
    "YahooId": "IS.FF103.TA",
    "EnglishName": "ISH.FRF LQDA US",
    "EnglishLongName": "ISHARES $ CORP BOND UCITS ETF USD ETF",
    "HebrewName": "איישרס.חוץ CORP BONDS USD",
    "HebrewLongName": "ISHARES $ CORP BOND UCITS ETF USD ETF",
    "Type": "4",
    "SubType": "45",
    "SubTypeDesc": "Foreign ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1986.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "Foreign Fund Bond Traded",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -1.7,
    "YearYield": -1.7,
    "Last12MonthYield": null,
    "ISIN": "IE00BYXYYJ35"
  },
  {
    "Id": "IS.FF505.TA",
    "MayaId": "1159235",
    "Name": "ISH.FRF MS ACWI",
    "ShortName": "BLACKROCK ASSET MANAGEMENT IRELAND LIMITED",
    "Symbol": "IS.FF505.TA",
    "TaseSymbol": "IS.FF505",
    "YahooId": "IS.FF505.TA",
    "EnglishName": "ISH.FRF MS ACWI",
    "EnglishLongName": "ISHARES MSCI ACWI UCITS ETF",
    "HebrewName": "איישרס.חוץ MSCI AC WORLD",
    "HebrewLongName": "ISHARES MSCI ACWI UCITS ETF",
    "Type": "4",
    "SubType": "44",
    "SubTypeDesc": "Foreign ETF - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 34810.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "Foreign Fund Traded",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.1,
    "YearYield": 0.1,
    "Last12MonthYield": null,
    "ISIN": "IE00B6R52259"
  },
  {
    "Id": "IS.FF401.TA",
    "MayaId": "1159110",
    "Name": "ISH.FRF MS CNYA",
    "ShortName": "BLACKROCK ASSET MANAGEMENT IRELAND LIMITED",
    "Symbol": "IS.FF401.TA",
    "TaseSymbol": "IS.FF401",
    "YahooId": "IS.FF401.TA",
    "EnglishName": "ISH.FRF MS CNYA",
    "EnglishLongName": "ISHARES MSCI CHINA A UCITS ETF",
    "HebrewName": "איישרס.חוץ MSCI CHINA A",
    "HebrewLongName": "ISHARES MSCI CHINA A UCITS ETF",
    "Type": "4",
    "SubType": "44",
    "SubTypeDesc": "Foreign ETF - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1883.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "Foreign Fund Traded",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 2.8,
    "YearYield": 2.8,
    "Last12MonthYield": null,
    "ISIN": "IE00BQT3WG13"
  },
  {
    "Id": "IS.FF301.TA",
    "MayaId": "1159094",
    "Name": "ISH.FRF MS EURO",
    "ShortName": "BLACKROCK ASSET MANAGEMENT IRELAND LIMITED",
    "Symbol": "IS.FF301.TA",
    "TaseSymbol": "IS.FF301",
    "YahooId": "IS.FF301.TA",
    "EnglishName": "ISH.FRF MS EURO",
    "EnglishLongName": "(ISHARES CORE MSCI EUROPE UCITS ETF EUR (ACC",
    "HebrewName": "איישרס.חוץ MSCI EUROPE ID",
    "HebrewLongName": "(ISHARES CORE MSCI EUROPE UCITS ETF EUR (ACC",
    "Type": "4",
    "SubType": "44",
    "SubTypeDesc": "Foreign ETF - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 35390.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "Foreign Fund Traded",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.8,
    "YearYield": 0.8,
    "Last12MonthYield": null,
    "ISIN": "IE00B4K48X80"
  },
  {
    "Id": "IS.FF101.TA",
    "MayaId": "1159169",
    "Name": "ISH.FRF MSCI EM",
    "ShortName": "BLACKROCK ASSET MANAGEMENT IRELAND LIMITED",
    "Symbol": "IS.FF101.TA",
    "TaseSymbol": "IS.FF101",
    "YahooId": "IS.FF101.TA",
    "EnglishName": "ISH.FRF MSCI EM",
    "EnglishLongName": "ISHARES CORE MSCI EM IMI UCITS ETF",
    "HebrewName": "איישרס.חוץ MSCI EMERGINGM",
    "HebrewLongName": "ISHARES CORE MSCI EM IMI UCITS ETF",
    "Type": "4",
    "SubType": "44",
    "SubTypeDesc": "Foreign ETF - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 14920.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "Foreign Fund Traded",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 4.5,
    "YearYield": 4.5,
    "Last12MonthYield": null,
    "ISIN": "IE00BKM4GZ66"
  },
  {
    "Id": "IS.FF701.TA",
    "MayaId": "1159243",
    "Name": "ISH.FRF NDX 100",
    "ShortName": "BLACKROCK ASSET MANAGEMENT IRELAND LIMITED",
    "Symbol": "IS.FF701.TA",
    "TaseSymbol": "IS.FF701",
    "YahooId": "IS.FF701.TA",
    "EnglishName": "ISH.FRF NDX 100",
    "EnglishLongName": "ISHARES NASDAQ 100 UCITS ETF",
    "HebrewName": "איישרס.חוץ NASDAQ100INDEX",
    "HebrewLongName": "ISHARES NASDAQ 100 UCITS ETF",
    "Type": "4",
    "SubType": "44",
    "SubTypeDesc": "Foreign ETF - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 455600.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "Foreign Fund Traded",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -1.9,
    "YearYield": -1.9,
    "Last12MonthYield": null,
    "ISIN": "IE00B53SZB19"
  },
  {
    "Id": "IS.FF404.TA",
    "MayaId": "1159144",
    "Name": "ISH.FRF RBOT GL",
    "ShortName": "BLACKROCK ASSET MANAGEMENT IRELAND LIMITED",
    "Symbol": "IS.FF404.TA",
    "TaseSymbol": "IS.FF404",
    "YahooId": "IS.FF404.TA",
    "EnglishName": "ISH.FRF RBOT GL",
    "EnglishLongName": "ISHARES AUTOMATION & ROBOTICS UCITS ETF",
    "HebrewName": "איישרס.חוץAUTOMA&ROBOTICS",
    "HebrewLongName": "ISHARES AUTOMATION & ROBOTICS UCITS ETF",
    "Type": "4",
    "SubType": "44",
    "SubTypeDesc": "Foreign ETF - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5287.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "Foreign Fund Traded",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 2.9,
    "YearYield": 2.9,
    "Last12MonthYield": null,
    "ISIN": "IE00BYZK4552"
  },
  {
    "Id": "IS.FF405.TA",
    "MayaId": "1159151",
    "Name": "ISH.FRF SDIG GL",
    "ShortName": "BLACKROCK ASSET MANAGEMENT IRELAND LIMITED",
    "Symbol": "IS.FF405.TA",
    "TaseSymbol": "IS.FF405",
    "YahooId": "IS.FF405.TA",
    "EnglishName": "ISH.FRF SDIG GL",
    "EnglishLongName": "ISHARES $ SHORT DURATION CORP BOND UCITS ETF",
    "HebrewName": "איישרס.חוץ$ SHORT DURATIO",
    "HebrewLongName": "ISHARES $ SHORT DURATION CORP BOND UCITS ETF",
    "Type": "4",
    "SubType": "45",
    "SubTypeDesc": "Foreign ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2002.8,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "Foreign Fund Bond Traded",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -0.9,
    "YearYield": -0.9,
    "Last12MonthYield": null,
    "ISIN": "IE00BYXYYP94"
  },
  {
    "Id": "IS.FF502.TA",
    "MayaId": "1159201",
    "Name": "ISH.FRF SP CARE",
    "ShortName": "BLACKROCK ASSET MANAGEMENT IRELAND LIMITED",
    "Symbol": "IS.FF502.TA",
    "TaseSymbol": "IS.FF502",
    "YahooId": "IS.FF502.TA",
    "EnglishName": "ISH.FRF SP CARE",
    "EnglishLongName": "ISHARES S&P 500 HEALTH CARE SECTOR UCITS ETF",
    "HebrewName": "איישרס.חוץ P HEALTHCARE&S",
    "HebrewLongName": "ISHARES S&P 500 HEALTH CARE SECTOR UCITS ETF",
    "Type": "4",
    "SubType": "44",
    "SubTypeDesc": "Foreign ETF - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3919.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "Foreign Fund Traded",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -0.1,
    "YearYield": -0.1,
    "Last12MonthYield": null,
    "ISIN": "IE00B43HR379"
  },
  {
    "Id": "IS.FF504.TA",
    "MayaId": "1159227",
    "Name": "ISH.FRF SP CONS",
    "ShortName": "BLACKROCK ASSET MANAGEMENT IRELAND LIMITED",
    "Symbol": "IS.FF504.TA",
    "TaseSymbol": "IS.FF504",
    "YahooId": "IS.FF504.TA",
    "EnglishName": "ISH.FRF SP CONS",
    "EnglishLongName": "ISHARES S&P 500 CONSUMER DISCRETIONARY SECTOR UCITS ETF",
    "HebrewName": "איישרס.חוץ P CONS DISCR&S",
    "HebrewLongName": "ISHARES S&P 500 CONSUMER DISCRETIONARY SECTOR UCITS ETF",
    "Type": "4",
    "SubType": "44",
    "SubTypeDesc": "Foreign ETF - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5341.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "Foreign Fund Traded",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -0.8,
    "YearYield": -0.8,
    "Last12MonthYield": null,
    "ISIN": "IE00B4MCHD36"
  },
  {
    "Id": "IS.FF503.TA",
    "MayaId": "1159219",
    "Name": "ISH.FRF SP FINA",
    "ShortName": "BLACKROCK ASSET MANAGEMENT IRELAND LIMITED",
    "Symbol": "IS.FF503.TA",
    "TaseSymbol": "IS.FF503",
    "YahooId": "IS.FF503.TA",
    "EnglishName": "ISH.FRF SP FINA",
    "EnglishLongName": "ISHARES S&P 500 FINANCIALS SECTOR UCITS ETF",
    "HebrewName": "איישרס.חוץ P FINANCIALS&S",
    "HebrewLongName": "ISHARES S&P 500 FINANCIALS SECTOR UCITS ETF",
    "Type": "4",
    "SubType": "44",
    "SubTypeDesc": "Foreign ETF - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5010.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "Foreign Fund Traded",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -3.3,
    "YearYield": -3.3,
    "Last12MonthYield": null,
    "ISIN": "IE00B4JNQZ49"
  },
  {
    "Id": "IS.FF501.TA",
    "MayaId": "1159193",
    "Name": "ISH.FRF SP TECH",
    "ShortName": "BLACKROCK ASSET MANAGEMENT IRELAND LIMITED",
    "Symbol": "IS.FF501.TA",
    "TaseSymbol": "IS.FF501",
    "YahooId": "IS.FF501.TA",
    "EnglishName": "ISH.FRF SP TECH",
    "EnglishLongName": "ISHARES S&P 500 INFORMATION TECHNOLOGY SECTOR UCITS ETF",
    "HebrewName": "איישרס.חוץ P TECHNOLOGY&S",
    "HebrewLongName": "ISHARES S&P 500 INFORMATION TECHNOLOGY SECTOR UCITS ETF",
    "Type": "4",
    "SubType": "44",
    "SubTypeDesc": "Foreign ETF - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 12920.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "Foreign Fund Traded",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -3.8,
    "YearYield": -3.8,
    "Last12MonthYield": null,
    "ISIN": "IE00B3WJKG14"
  },
  {
    "Id": "IS.FF702.TA",
    "MayaId": "1159250",
    "Name": "ISH.FRF SPX 500",
    "ShortName": "BLACKROCK ASSET MANAGEMENT IRELAND LIMITED",
    "Symbol": "IS.FF702.TA",
    "TaseSymbol": "IS.FF702",
    "YahooId": "IS.FF702.TA",
    "EnglishName": "ISH.FRF SPX 500",
    "EnglishLongName": "ISHARES CORE S&P 500 UCITS ETF",
    "HebrewName": "איישרס.חוץ S&P500 INDEX",
    "HebrewLongName": "ISHARES CORE S&P 500 UCITS ETF",
    "Type": "4",
    "SubType": "44",
    "SubTypeDesc": "Foreign ETF - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 232220.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "Foreign Fund Traded",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -1.1,
    "YearYield": -1.1,
    "Last12MonthYield": null,
    "ISIN": "IE00B5BMR087"
  },
  {
    "Id": "IS.FF102.TA",
    "MayaId": "1159177",
    "Name": "ISH.FRF T BD 13",
    "ShortName": "BLACKROCK ASSET MANAGEMENT IRELAND LIMITED",
    "Symbol": "IS.FF102.TA",
    "TaseSymbol": "IS.FF102",
    "YahooId": "IS.FF102.TA",
    "EnglishName": "ISH.FRF T BD 13",
    "EnglishLongName": "ISHARES $ TREASURY BOND 1-3YR UCITS ETF",
    "HebrewName": "איישרס.חוץ T BOND 1-3YEAR",
    "HebrewLongName": "ISHARES $ TREASURY BOND 1-3YR UCITS ETF",
    "Type": "4",
    "SubType": "45",
    "SubTypeDesc": "Foreign ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1876.5,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "Foreign Fund Bond Traded",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -0.6,
    "YearYield": -0.6,
    "Last12MonthYield": null,
    "ISIN": "IE00BYXPSP02"
  },
  {
    "Id": "IS.FF704.TA",
    "MayaId": "1159276",
    "Name": "ISH.FRF T BD 37",
    "ShortName": "BLACKROCK ASSET MANAGEMENT IRELAND LIMITED",
    "Symbol": "IS.FF704.TA",
    "TaseSymbol": "IS.FF704",
    "YahooId": "IS.FF704.TA",
    "EnglishName": "ISH.FRF T BD 37",
    "EnglishLongName": "ISHARES $ TREASURY BOND 3-7YR UCITS ETF",
    "HebrewName": "איישרס.חוץ T BOND 3-7 YRS",
    "HebrewLongName": "ISHARES $ TREASURY BOND 3-7YR UCITS ETF",
    "Type": "4",
    "SubType": "45",
    "SubTypeDesc": "Foreign ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 45142.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "Foreign Fund Bond Traded",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -1.7,
    "YearYield": -1.7,
    "Last12MonthYield": null,
    "ISIN": "IE00B3VWN393"
  },
  {
    "Id": "IS.FF703.TA",
    "MayaId": "1159268",
    "Name": "ISH.FRF T BD710",
    "ShortName": "BLACKROCK ASSET MANAGEMENT IRELAND LIMITED",
    "Symbol": "IS.FF703.TA",
    "TaseSymbol": "IS.FF703",
    "YahooId": "IS.FF703.TA",
    "EnglishName": "ISH.FRF T BD710",
    "EnglishLongName": "ISHARES $ TREASURY BOND 7-10YR UCITS ETF USD",
    "HebrewName": "איישרס.חוץ T BOND 7-10YRS",
    "HebrewLongName": "ISHARES $ TREASURY BOND 7-10YR UCITS ETF USD",
    "Type": "4",
    "SubType": "45",
    "SubTypeDesc": "Foreign ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 48640.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "Foreign Fund Bond Traded",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -1.9,
    "YearYield": -1.9,
    "Last12MonthYield": null,
    "ISIN": "IE00B3VWN518"
  },
  {
    "Id": "IS.FF202.TA",
    "MayaId": "1159060",
    "Name": "ISH.FRF TIPS US",
    "ShortName": "BLACKROCK ASSET MANAGEMENT IRELAND LIMITED",
    "Symbol": "IS.FF202.TA",
    "TaseSymbol": "IS.FF202",
    "YahooId": "IS.FF202.TA",
    "EnglishName": "ISH.FRF TIPS US",
    "EnglishLongName": "ISHARES $ TIPS UCITS ETF",
    "HebrewName": "איישרס.חוץ US GOVCPI LINK",
    "HebrewLongName": "ISHARES $ TIPS UCITS ETF",
    "Type": "4",
    "SubType": "45",
    "SubTypeDesc": "Foreign ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 80591.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "Foreign Fund Bond Traded",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -0.9,
    "YearYield": -0.9,
    "Last12MonthYield": null,
    "ISIN": "IE00B1FZSC47"
  },
  {
    "Id": "TASE:5127980",
    "MayaId": "5127980",
    "Name": "ISP (1B) 10/90 IL",
    "ShortName": "ISP (1B) 10/90 IL",
    "Symbol": "TASE:5127980",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ISP Asset Management (1B) 10/90 IL",
    "EnglishLongName": "ISP Asset Management (1B) 10/90 IL",
    "HebrewName": "ISP (1B) 10/90",
    "HebrewLongName": "ISP Asset Managementי (1B)י 10/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.035,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.42,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 140.6,
    "MonthYield": 1.46,
    "YearYield": 1.46,
    "Last12MonthYield": 11.79,
    "ISIN": "IL0051279805"
  },
  {
    "Id": "TASE:5131867",
    "MayaId": "5131867",
    "Name": "ISP (2B) 80/20 IL",
    "ShortName": "ISP (2B) 80/20 IL",
    "Symbol": "TASE:5131867",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ISP Asset Management (2B) 80/20 IL",
    "EnglishLongName": "ISP Asset Management (2B) 80/20 IL",
    "HebrewName": "ISPי (2B)י 20/80",
    "HebrewLongName": "ISP Asset Managementי (2B)י 20/80",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.59,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 32.8,
    "MonthYield": 2.36,
    "YearYield": 2.36,
    "Last12MonthYield": 16.7,
    "ISIN": "IL0051318678"
  },
  {
    "Id": "TASE:5136015",
    "MayaId": "5136015",
    "Name": "ISP (4B) IL Equity",
    "ShortName": "ISP (4B) IL Equity",
    "Symbol": "TASE:5136015",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ISP Asset Management (4B) IL Equity",
    "EnglishLongName": "ISP Asset Management (4B) IL Equity",
    "HebrewName": "ISPי (4B) מניות ישראל",
    "HebrewLongName": "ISP Asset Managementי (4B) מניות ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.2,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.77,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 60.2,
    "MonthYield": 9.4,
    "YearYield": 9.4,
    "Last12MonthYield": 65.79,
    "ISIN": "IL0051360159"
  },
  {
    "Id": "TASE:5135256",
    "MayaId": "5135256",
    "Name": "ISP (4D) Global Equity",
    "ShortName": "ISP (4D) Global Equity",
    "Symbol": "TASE:5135256",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ISP Asset Management (4D) Global Equity",
    "EnglishLongName": "ISP Asset Management (4D) Global Equity",
    "HebrewName": "ISP י(4D) מניות חו\"ל",
    "HebrewLongName": "ISP Asset Management י(4D) מניות חו\"ל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.6,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.8,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 58.3,
    "MonthYield": 3.86,
    "YearYield": 3.86,
    "Last12MonthYield": 6.9,
    "ISIN": "IL0051352560"
  },
  {
    "Id": "TASE:5131875",
    "MayaId": "5131875",
    "Name": "ISP Bnds Without Stks IL",
    "ShortName": "ISP Bnds Without Stks IL",
    "Symbol": "TASE:5131875",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "ISP Asset Management (0B) Bonds Without Stocks IL",
    "EnglishLongName": "ISP Asset Management (0B) Bonds Without Stocks IL",
    "HebrewName": "ISPי אג\"ח ללא מניות",
    "HebrewLongName": "ISP Asset Managementי (0B) אג\"ח ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.4,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 42.5,
    "MonthYield": 0.63,
    "YearYield": 0.63,
    "Last12MonthYield": 8.16,
    "ISIN": "IL0051318751"
  },
  {
    "Id": "ISCD.TA",
    "MayaId": "1157403",
    "Name": "ISRACARD",
    "ShortName": "ISRACARD LTD",
    "Symbol": "ISCD.TA",
    "TaseSymbol": "ISCD",
    "YahooId": "ISCD.TA",
    "EnglishName": "ISRACARD",
    "EnglishLongName": "ISRACARD LTD",
    "HebrewName": "ישראכרט",
    "HebrewLongName": "ישראכרט בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1442.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Financial Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -5.1,
    "YearYield": -5.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011574030"
  },
  {
    "Id": "ISCN.TA",
    "MayaId": "434019",
    "Name": "ISRAEL CANADA",
    "ShortName": "ISRAEL CANADA (T.R) LTD",
    "Symbol": "ISCN.TA",
    "TaseSymbol": "ISCN",
    "YahooId": "ISCN.TA",
    "EnglishName": "ISRAEL CANADA",
    "EnglishLongName": "ISRAEL CANADA (T.R) LTD",
    "HebrewName": "ישראל קנדה",
    "HebrewLongName": "ישראל קנדה (ט.ר) בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1746.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 9.5,
    "YearYield": 9.5,
    "Last12MonthYield": null,
    "ISIN": "IL0004340191"
  },
  {
    "Id": "ILCO.TA",
    "MayaId": "576017",
    "Name": "ISRAEL CORP",
    "ShortName": "THE ISRAEL CORPORATION LTD.",
    "Symbol": "ILCO.TA",
    "TaseSymbol": "ILCO",
    "YahooId": "ILCO.TA",
    "EnglishName": "ISRAEL CORP",
    "EnglishLongName": "THE ISRAEL CORPORATION LTD.",
    "HebrewName": "חברה לישראל",
    "HebrewLongName": "החברה לישראל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 91500.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.4,
    "YearYield": 0.4,
    "Last12MonthYield": null,
    "ISIN": "IL0005760173"
  },
  {
    "Id": "ISHI.TA",
    "MayaId": "1168533",
    "Name": "ISRAEL SHIPYARD",
    "ShortName": "ISRAEL SHIPYARDS INDUSTRIES LTD",
    "Symbol": "ISHI.TA",
    "TaseSymbol": "ISHI",
    "YahooId": "ISHI.TA",
    "EnglishName": "ISRAEL SHIPYARD",
    "EnglishLongName": "ISRAEL SHIPYARDS INDUSTRIES LTD",
    "HebrewName": "מספנות ישראל",
    "HebrewLongName": "תעשיות מספנות ישראל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 18800.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Investment & Holdings",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 21.4,
    "YearYield": 21.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011685331"
  },
  {
    "Id": "ISRG.TA",
    "MayaId": "1187194",
    "Name": "ISRAIR GROUP",
    "ShortName": "ISRAIR GROUP LTD",
    "Symbol": "ISRG.TA",
    "TaseSymbol": "ISRG",
    "YahooId": "ISRG.TA",
    "EnglishName": "ISRAIR GROUP",
    "EnglishLongName": "ISRAIR GROUP LTD",
    "HebrewName": "ישראייר גרופ",
    "HebrewLongName": "ישראייר גרופ בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 168.7,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -2.1,
    "YearYield": -2.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011871949"
  },
  {
    "Id": "ISRS.TA",
    "MayaId": "613034",
    "Name": "ISRAS",
    "ShortName": "ISRAS INVESTMENT COMPANY LTD.",
    "Symbol": "ISRS.TA",
    "TaseSymbol": "ISRS",
    "YahooId": "ISRS.TA",
    "EnglishName": "ISRAS",
    "EnglishLongName": "ISRAS INVESTMENT COMPANY LTD.",
    "HebrewName": "ישרס",
    "HebrewLongName": "ישרס חברה להשקעות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 101950.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 5.4,
    "YearYield": 5.4,
    "Last12MonthYield": null,
    "ISIN": "IL0006130343"
  },
  {
    "Id": "ISHO.TA",
    "MayaId": "1202977",
    "Name": "ISRAS HOLDINGS",
    "ShortName": "ISRAS HOLDINGS LTD",
    "Symbol": "ISHO.TA",
    "TaseSymbol": "ISHO",
    "YahooId": "ISHO.TA",
    "EnglishName": "ISRAS HOLDINGS",
    "EnglishLongName": "ISRAS HOLDINGS LTD",
    "HebrewName": "ישרס אחזקות",
    "HebrewLongName": "ישרס אחזקות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 49020.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 10.2,
    "YearYield": 10.2,
    "Last12MonthYield": null,
    "ISIN": "IL0012029778"
  },
  {
    "Id": "ISRO.TA",
    "MayaId": "1080985",
    "Name": "ISROTEL",
    "ShortName": "ISROTEL LTD.",
    "Symbol": "ISRO.TA",
    "TaseSymbol": "ISRO",
    "YahooId": "ISRO.TA",
    "EnglishName": "ISROTEL",
    "EnglishLongName": "ISROTEL LTD.",
    "HebrewName": "ישרוטל",
    "HebrewLongName": "ישרוטל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 17690.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 13.4,
    "YearYield": 13.4,
    "Last12MonthYield": null,
    "ISIN": "IL0010809858"
  },
  {
    "Id": "ISTA.TA",
    "MayaId": "1081074",
    "Name": "ISSTA",
    "ShortName": "ISSTA LTD.",
    "Symbol": "ISTA.TA",
    "TaseSymbol": "ISTA",
    "YahooId": "ISTA.TA",
    "EnglishName": "ISSTA",
    "EnglishLongName": "ISSTA LTD.",
    "HebrewName": "איסתא",
    "HebrewLongName": "איסתא בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 10950.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.7,
    "YearYield": 0.7,
    "Last12MonthYield": null,
    "ISIN": "IL0010810740"
  },
  {
    "Id": "TASE:5141825",
    "MayaId": "5141825",
    "Name": "Itronot Finans Glob Equi",
    "ShortName": "Itronot Finans Glob Equi",
    "Symbol": "TASE:5141825",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Itronot Finansim (4D) Global Equity",
    "EnglishLongName": "Itronot Finansim (4D) Global Equity",
    "HebrewName": "יתרונות פיננסים מניותחול",
    "HebrewLongName": "יתרונות פיננסיים (4D) מניות חו\"ל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.8,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 13.5,
    "MonthYield": 1.06,
    "YearYield": 1.06,
    "Last12MonthYield": null,
    "ISIN": "IL0051418254"
  },
  {
    "Id": "JCFN.TA",
    "MayaId": "1185057",
    "Name": "JACOB FINANCE",
    "ShortName": "JACOB FINANCE AND INVESTMENTS LTD",
    "Symbol": "JCFN.TA",
    "TaseSymbol": "JCFN",
    "YahooId": "JCFN.TA",
    "EnglishName": "JACOB FINANCE",
    "EnglishLongName": "JACOB FINANCE AND INVESTMENTS LTD",
    "HebrewName": "יעקב פיננסים",
    "HebrewLongName": "יעקב פיננסים והשקעות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3357.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Financial Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.6,
    "YearYield": 1.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011850570"
  },
  {
    "Id": "JEEN.TA",
    "MayaId": "1099787",
    "Name": "JEEN AI TECH",
    "ShortName": "JEEN AI TECHNOLOGIES LTD",
    "Symbol": "JEEN.TA",
    "TaseSymbol": "JEEN",
    "YahooId": "JEEN.TA",
    "EnglishName": "JEEN AI TECH",
    "EnglishLongName": "JEEN AI TECHNOLOGIES LTD",
    "HebrewName": "ג'ין טכנולוגיות",
    "HebrewLongName": "ג'ין טכנולוגיות בינה מלאכותית בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 638.1,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 28.1,
    "YearYield": 28.1,
    "Last12MonthYield": null,
    "ISIN": "IL0010997877"
  },
  {
    "Id": "JBNK.TA",
    "MayaId": "726018",
    "Name": "JERUSALEM",
    "ShortName": "BANK OF JERUSALEM L.T.D.",
    "Symbol": "JBNK.TA",
    "TaseSymbol": "JBNK",
    "YahooId": "JBNK.TA",
    "EnglishName": "JERUSALEM",
    "EnglishLongName": "BANK OF JERUSALEM L.T.D.",
    "HebrewName": "ירושלים",
    "HebrewLongName": "בנק ירושלים בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2370.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Banks",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 3.8,
    "YearYield": 3.8,
    "Last12MonthYield": null,
    "ISIN": "IL0007260180"
  },
  {
    "Id": "JNGO.TA",
    "MayaId": "1178862",
    "Name": "JUNGO",
    "ShortName": "JUNGO CONNECTIVITY LTD",
    "Symbol": "JNGO.TA",
    "TaseSymbol": "JNGO",
    "YahooId": "JNGO.TA",
    "EnglishName": "JUNGO",
    "EnglishLongName": "JUNGO CONNECTIVITY LTD",
    "HebrewName": "ג'נגו",
    "HebrewLongName": "ג'נגו קונקטיביטי בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 302.7,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 3.9,
    "YearYield": 3.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011788622"
  },
  {
    "Id": "TASE:5132790",
    "MayaId": "5132790",
    "Name": "KABIN (1B) 90/10 IL",
    "ShortName": "KABIN (1B) 90/10 IL",
    "Symbol": "TASE:5132790",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KABIN (1B) 90/10 IL",
    "EnglishLongName": "KABIN (1B) 90/10 IL",
    "HebrewName": "קבין (1B)י 10/90",
    "HebrewLongName": "קבין (1B)י 10/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.36,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 1144.4,
    "MonthYield": 1.02,
    "YearYield": 1.02,
    "Last12MonthYield": 9.51,
    "ISIN": "IL0051327901"
  },
  {
    "Id": "TASE:5136239",
    "MayaId": "5136239",
    "Name": "Kabin (2B) 80/20 IL",
    "ShortName": "Kabin (2B) 80/20 IL",
    "Symbol": "TASE:5136239",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Kabin (2B) 80/20 IL",
    "EnglishLongName": "Kabin (2B) 80/20 IL",
    "HebrewName": "קבין (2B)י 20/80",
    "HebrewLongName": "קבין (2B)י 20/80",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.84,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.44,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 349.8,
    "MonthYield": 1.39,
    "YearYield": 1.39,
    "Last12MonthYield": 12.51,
    "ISIN": "IL0051362395"
  },
  {
    "Id": "TASE:5134218",
    "MayaId": "5134218",
    "Name": "Kabin (4D) Flexible",
    "ShortName": "Kabin (4D) Flexible",
    "Symbol": "TASE:5134218",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Kabin (4D) Flexible",
    "EnglishLongName": "Kabin (4D) Flexible",
    "HebrewName": "קבין (4D) גמישה",
    "HebrewLongName": "קבין (4D) גמישה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.8,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.8,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 22.6,
    "MonthYield": 8.01,
    "YearYield": 8.01,
    "Last12MonthYield": 36.3,
    "ISIN": "IL0051342181"
  },
  {
    "Id": "TASE:5132121",
    "MayaId": "5132121",
    "Name": "Kabin Bnd Without Stk IL",
    "ShortName": "Kabin Bnd Without Stk IL",
    "Symbol": "TASE:5132121",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Kabin (0B) Bonds Without Stocks IL",
    "EnglishLongName": "Kabin (0B) Bonds Without Stocks IL",
    "HebrewName": "קבין אג\"ח ללא מניות",
    "HebrewLongName": "קבין (0B) אג\"ח ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 1345.5,
    "MonthYield": 0.67,
    "YearYield": 0.67,
    "Last12MonthYield": 6.57,
    "ISIN": "IL0051321219"
  },
  {
    "Id": "KAFR.TA",
    "MayaId": "522011",
    "Name": "KAFRIT",
    "ShortName": "KAFRIT INDUSTRIES (1993) LTD.",
    "Symbol": "KAFR.TA",
    "TaseSymbol": "KAFR",
    "YahooId": "KAFR.TA",
    "EnglishName": "KAFRIT",
    "EnglishLongName": "KAFRIT INDUSTRIES (1993) LTD.",
    "HebrewName": "כפרית",
    "HebrewLongName": "כפרית תעשיות (1993) בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2850.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 2.5,
    "YearYield": 2.5,
    "Last12MonthYield": null,
    "ISIN": "IL0005220111"
  },
  {
    "Id": "KMDA.TA",
    "MayaId": "1094119",
    "Name": "KAMADA",
    "ShortName": "KAMADA LTD.",
    "Symbol": "KMDA.TA",
    "TaseSymbol": "KMDA",
    "YahooId": "KMDA.TA",
    "EnglishName": "KAMADA",
    "EnglishLongName": "KAMADA LTD.",
    "HebrewName": "קמהדע",
    "HebrewLongName": "קמהדע בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2464.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 11.2,
    "YearYield": 11.2,
    "Last12MonthYield": null,
    "ISIN": "IL0010941198"
  },
  {
    "Id": "KRNV-M.TA",
    "MayaId": "1087949",
    "Name": "KARDAN N.V M",
    "ShortName": "KARDAN N.V.",
    "Symbol": "KRNV-M.TA",
    "TaseSymbol": "KRNV-M",
    "YahooId": "KRNV-M.TA",
    "EnglishName": "KARDAN N.V-M",
    "EnglishLongName": "KARDAN N.V.",
    "HebrewName": "קרדן אן.וי-ש",
    "HebrewLongName": "קרדן אן.וי.",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3.4,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Investment & Holdings",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 17.2,
    "YearYield": 17.2,
    "Last12MonthYield": null,
    "ISIN": "NL0000113652"
  },
  {
    "Id": "KARE.TA",
    "MayaId": "1118447",
    "Name": "KARDAN REAL ES",
    "ShortName": "KARDAN REAL ESTATE ENTERPRISE AND DEVELOPMENT LTD",
    "Symbol": "KARE.TA",
    "TaseSymbol": "KARE",
    "YahooId": "KARE.TA",
    "EnglishName": "KARDAN REAL ES",
    "EnglishLongName": "KARDAN REAL ESTATE ENTERPRISE AND DEVELOPMENT LTD",
    "HebrewName": "קרדן נדלן",
    "HebrewLongName": "קרדן נדל\"ן יזום ופיתוח בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 620.5,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 5.3,
    "YearYield": 5.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011184475"
  },
  {
    "Id": "KRDI.TA",
    "MayaId": "1210152",
    "Name": "KARDEN ISRAEL",
    "ShortName": "KARDAN ISRAEL LTD.",
    "Symbol": "KRDI.TA",
    "TaseSymbol": "KRDI",
    "YahooId": "KRDI.TA",
    "EnglishName": "KARDEN ISRAEL",
    "EnglishLongName": "KARDAN ISRAEL LTD.",
    "HebrewName": "קרדן ישראל",
    "HebrewLongName": "קרדן ישראל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 542.9,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 18.1,
    "YearYield": 18.1,
    "Last12MonthYield": null,
    "ISIN": "IL0012101528"
  },
  {
    "Id": "TASE:5122411",
    "MayaId": "5122411",
    "Name": "KBN MNAYOT CHUL",
    "ShortName": "KBN MNAYOT CHUL",
    "Symbol": "TASE:5122411",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KABIN (4D) GLOBAL EQUITY",
    "EnglishLongName": "KABIN (4D) GLOBAL EQUITY",
    "HebrewName": "קבין 4D מניות חו\"ל",
    "HebrewLongName": "קבין (4D) מניות חו\"ל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.7,
    "TrusteeFee": 0.045,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.89,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 94.5,
    "MonthYield": 4.3,
    "YearYield": 4.3,
    "Last12MonthYield": 19.56,
    "ISIN": "IL0051224116"
  },
  {
    "Id": "KEN.TA",
    "MayaId": "1134139",
    "Name": "KENON",
    "ShortName": "KENON HOLDINGS LTD",
    "Symbol": "KEN.TA",
    "TaseSymbol": "KEN",
    "YahooId": "KEN.TA",
    "EnglishName": "KENON",
    "EnglishLongName": "KENON HOLDINGS LTD",
    "HebrewName": "קנון",
    "HebrewLongName": "קנון הולדינגס",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 20900.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Energy And Oil & Gas Exploration",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.2,
    "YearYield": 0.2,
    "Last12MonthYield": null,
    "ISIN": "SG9999012629"
  },
  {
    "Id": "KRUR.TA",
    "MayaId": "621011",
    "Name": "KERUR",
    "ShortName": "KERUR HOLDINGS LTD",
    "Symbol": "KRUR.TA",
    "TaseSymbol": "KRUR",
    "YahooId": "KRUR.TA",
    "EnglishName": "KERUR",
    "EnglishLongName": "KERUR HOLDINGS LTD",
    "HebrewName": "קרור",
    "HebrewLongName": "קרור אחזקות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 8870.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.2,
    "YearYield": 0.2,
    "Last12MonthYield": null,
    "ISIN": "IL0006210111"
  },
  {
    "Id": "KSTN.TA",
    "MayaId": "1175934",
    "Name": "KEYSTONE INFRA",
    "ShortName": "KEYSTONE INFRA LTD",
    "Symbol": "KSTN.TA",
    "TaseSymbol": "KSTN",
    "YahooId": "KSTN.TA",
    "EnglishName": "KEYSTONE INFRA",
    "EnglishLongName": "KEYSTONE INFRA LTD",
    "HebrewName": "קיסטון אינפרא",
    "HebrewLongName": "קיסטון אינפרא בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1207.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Investment & Holdings",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 26.6,
    "YearYield": 26.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011759342"
  },
  {
    "Id": "TASE:5109632",
    "MayaId": "5109632",
    "Name": "KIVUN (1B) 10/90 IL",
    "ShortName": "KIVUN (1B) 10/90 IL",
    "Symbol": "TASE:5109632",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KIVUN (1B) 10/90 IL",
    "EnglishLongName": "KIVUN (1B) 10/90 IL",
    "HebrewName": "כוון (1B)י 10/90",
    "HebrewLongName": "כוון (1B)י 10/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.74,
    "TrusteeFee": 0.045,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.37,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 7.1,
    "MonthYield": 1.25,
    "YearYield": 1.25,
    "Last12MonthYield": 12.02,
    "ISIN": "IL0051096324"
  },
  {
    "Id": "TASE:5103569",
    "MayaId": "5103569",
    "Name": "Kivun (2B) 70/30 IL",
    "ShortName": "Kivun (2B) 70/30 IL",
    "Symbol": "TASE:5103569",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Kivun (2B) 70/30 IL",
    "EnglishLongName": "Kivun (2B) 70/30 IL",
    "HebrewName": "כוון (2B)י 30/70",
    "HebrewLongName": "כוון (2B)י 30/70",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.045,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.7,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 16.7,
    "MonthYield": 2.39,
    "YearYield": 2.39,
    "Last12MonthYield": 21.1,
    "ISIN": "IL0051035694"
  },
  {
    "Id": "TASE:5105317",
    "MayaId": "5105317",
    "Name": "KIVUN (2B) 80/20 IL",
    "ShortName": "KIVUN (2B) 80/20 IL",
    "Symbol": "TASE:5105317",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KIVUN (2B) 20/80 IL",
    "EnglishLongName": "KIVUN (2B) 20/80 IL",
    "HebrewName": "כוון (2B)י 20/80",
    "HebrewLongName": "כוון (2B)י 20/80",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.045,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.58,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 19.9,
    "MonthYield": 1.9,
    "YearYield": 1.9,
    "Last12MonthYield": 16.83,
    "ISIN": "IL0051053176"
  },
  {
    "Id": "TASE:5107958",
    "MayaId": "5107958",
    "Name": "Kivun (2B) 85/15 IL",
    "ShortName": "Kivun (2B) 85/15 IL",
    "Symbol": "TASE:5107958",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Kivun (2B) 85/15 IL",
    "EnglishLongName": "Kivun (2B) 85/15 IL",
    "HebrewName": "כוון (2B)י 15/85",
    "HebrewLongName": "כוון (2B)י 15/85",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.045,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.4,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 15% Equity",
    "AssetValue": 21.5,
    "MonthYield": 1.88,
    "YearYield": 1.88,
    "Last12MonthYield": 15.16,
    "ISIN": "IL0051079585"
  },
  {
    "Id": "TASE:5109624",
    "MayaId": "5109624",
    "Name": "Kivun Bnd No Stocks IL",
    "ShortName": "Kivun Bnd No Stocks IL",
    "Symbol": "TASE:5109624",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Kivun (0B) Bond Without Stocks IL",
    "EnglishLongName": "Kivun (0B) Bond Without Stocks IL",
    "HebrewName": "כוון אג\"ח ללא מניות",
    "HebrewLongName": "כוון (0B) אג\"ח ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.045,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.26,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 13.4,
    "MonthYield": 0.55,
    "YearYield": 0.55,
    "Last12MonthYield": 6.79,
    "ISIN": "IL0051096241"
  },
  {
    "Id": "TASE:5115373",
    "MayaId": "5115373",
    "Name": "Kivun Global Equity U.S",
    "ShortName": "Kivun Global Equity U.S",
    "Symbol": "TASE:5115373",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Kivun (4D) Global Equity U.S",
    "EnglishLongName": "Kivun (4D) Global Equity U.S",
    "HebrewName": "כוון מניות גלובלית U.S",
    "HebrewLongName": "כוון (4D) מניות גלובלית U.S",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.87,
    "TrusteeFee": 0.045,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.26,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Geographical stocks",
    "AssetValue": 14.4,
    "MonthYield": 2.35,
    "YearYield": 2.35,
    "Last12MonthYield": 12.78,
    "ISIN": "IL0051153737"
  },
  {
    "Id": "TASE:5126560",
    "MayaId": "5126560",
    "Name": "KIVUN ISRAEL STOCKS IL",
    "ShortName": "KIVUN ISRAEL STOCKS IL",
    "Symbol": "TASE:5126560",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "(KIVUN ISRAEL STOCKS IL (4B",
    "EnglishLongName": "(KIVUN ISRAEL STOCKS IL (4B",
    "HebrewName": "כוון מניות ישראל",
    "HebrewLongName": "כוון מניות ישראל (4B)",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.45,
    "TrusteeFee": 0.045,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.27,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 41.2,
    "MonthYield": 8.44,
    "YearYield": 8.44,
    "Last12MonthYield": 76.17,
    "ISIN": "IL0051265606"
  },
  {
    "Id": "KLIL.TA",
    "MayaId": "797035",
    "Name": "KLIL",
    "ShortName": "KLIL INDUSTRIES LTD.",
    "Symbol": "KLIL.TA",
    "TaseSymbol": "KLIL",
    "YahooId": "KLIL.TA",
    "EnglishName": "KLIL",
    "EnglishLongName": "KLIL INDUSTRIES LTD.",
    "HebrewName": "קליל",
    "HebrewLongName": "קליל תעשיות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 19980.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 3.6,
    "YearYield": 3.6,
    "Last12MonthYield": null,
    "ISIN": "IL0007970358"
  },
  {
    "Id": "KNFM.TA",
    "MayaId": "543017",
    "Name": "KNAFAIM",
    "ShortName": "KNAFAIM HOLDINGS LTD.",
    "Symbol": "KNFM.TA",
    "TaseSymbol": "KNFM",
    "YahooId": "KNFM.TA",
    "EnglishName": "KNAFAIM",
    "EnglishLongName": "KNAFAIM HOLDINGS LTD.",
    "HebrewName": "כנפיים",
    "HebrewLongName": "כנפיים אחזקות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1733.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 6.1,
    "YearYield": 6.1,
    "Last12MonthYield": null,
    "ISIN": "IL0005430173"
  },
  {
    "Id": "TASE:5126776",
    "MayaId": "5126776",
    "Name": "KSM 80 20 IL",
    "ShortName": "KSM 80-20 IL",
    "Symbol": "TASE:5126776",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (2B) 80-20 IL",
    "EnglishLongName": "KSM ACTIVE (2B) 80-20 IL",
    "HebrewName": "קסם אקט 20-80",
    "HebrewLongName": "קסם אקטיב (2B)י 20-80",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.82,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.46,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 590.4,
    "MonthYield": 2.12,
    "YearYield": 2.12,
    "Last12MonthYield": 13.18,
    "ISIN": "IL0051267768"
  },
  {
    "Id": "TASE:5112719",
    "MayaId": "5112719",
    "Name": "KSM 90 10 IL",
    "ShortName": "KSM 90-10 IL",
    "Symbol": "TASE:5112719",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (1A) 90-10 IL",
    "EnglishLongName": "KSM ACTIVE (1A) 90-10 IL",
    "HebrewName": "קסם 10-90",
    "HebrewLongName": "קסם אקטיב (1A)י 10-90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.38,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 468.9,
    "MonthYield": 1.33,
    "YearYield": 1.33,
    "Last12MonthYield": 9.92,
    "ISIN": "IL0051127194"
  },
  {
    "Id": "TASE:5104773",
    "MayaId": "5104773",
    "Name": "KSM ACT ! 4 Y COR PORT IL",
    "ShortName": "KSM ACT ! 4 Y COR PORT IL",
    "Symbol": "TASE:5104773",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (0B)(!) UP TO 4 YEARS CORPORATE PORTFOLIO IL",
    "EnglishLongName": "KSM ACTIVE (0B)(!) UP TO 4 YEARS CORPORATE PORTFOLIO IL",
    "HebrewName": "קסם אקט ! תיק קונצרנ 4",
    "HebrewLongName": "קסם אקטיב (0B)(!) תיק קונצרני עד 4 שנים",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.77,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.27,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 413.1,
    "MonthYield": 0.7,
    "YearYield": 0.7,
    "Last12MonthYield": 5.37,
    "ISIN": "IL0051047731"
  },
  {
    "Id": "TASE:5105846",
    "MayaId": "5105846",
    "Name": "KSM ACT ! BON POr W EQ IL",
    "ShortName": "KSM ACT ! BON POr W EQ IL",
    "Symbol": "TASE:5105846",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (0A)(!) BONDS PORTFOLIO WITHOUT EQUITY IL",
    "EnglishLongName": "KSM ACTIVE (0A)(!) BONDS PORTFOLIO WITHOUT EQUITY IL",
    "HebrewName": "קסם אקט ! תיק אגח ללא מנ",
    "HebrewLongName": "קסם אקטיב (0A)(!) תיק אג\"ח ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.64,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 777.4,
    "MonthYield": 0.61,
    "YearYield": 0.61,
    "Last12MonthYield": 5.59,
    "ISIN": "IL0051058464"
  },
  {
    "Id": "TASE:5103387",
    "MayaId": "5103387",
    "Name": "KSM ACT ! GLOB COR NEUTRA",
    "ShortName": "KSM ACT ! GLOB COR NEUTRA",
    "Symbol": "TASE:5103387",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (0A)(!) GLOBAL CORPORATE NEUTRALIZED FOREIGN CURRENCY TAXABLE",
    "EnglishLongName": "KSM ACTIVE (0A)(!) GLOBAL CORPORATE NEUTRALIZED FOREIGN CURRENCY TAXABLE",
    "HebrewName": "קסם אקט ! קונ חול מנ חייב",
    "HebrewLongName": "קסם אקטיב (0A)(!) קונצרני חו\"ל מנוטרלת מט\"ח חייבת",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.2,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX-Protected Bonds",
    "AssetValue": 226.3,
    "MonthYield": 0.29,
    "YearYield": 0.29,
    "Last12MonthYield": 6.82,
    "ISIN": "IL0051033871"
  },
  {
    "Id": "TASE:5129184",
    "MayaId": "5129184",
    "Name": "KSM ACT (2A) Bonds +15%",
    "ShortName": "KSM ACT (2A) Bonds +15%",
    "Symbol": "TASE:5129184",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (2A) Bonds +15%",
    "EnglishLongName": "KSM ACTIVE (2A) Bonds +15%",
    "HebrewName": "קסם אקטיב תיק אג\"ח + 15",
    "HebrewLongName": "קסם אקטיב (2A) תיק אג\"ח + 15",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.4,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 15% Equity",
    "AssetValue": 207.3,
    "MonthYield": 1.49,
    "YearYield": 1.49,
    "Last12MonthYield": 10.9,
    "ISIN": "IL0051291842"
  },
  {
    "Id": "TASE:5134457",
    "MayaId": "5134457",
    "Name": "KSM ACT (2B) 75/25 IL",
    "ShortName": "KSM ACT (2B) 75/25 IL",
    "Symbol": "TASE:5134457",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM Active (2B) 75/25 IL",
    "EnglishLongName": "KSM Active (2B) 75/25 IL",
    "HebrewName": "קסם אקטיב (2B)י 25/75",
    "HebrewLongName": "קסם אקטיב (2B)י 25/75",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.55,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 25% Equity",
    "AssetValue": 37.4,
    "MonthYield": 2.16,
    "YearYield": 2.16,
    "Last12MonthYield": 14.18,
    "ISIN": "IL0051344575"
  },
  {
    "Id": "TASE:5122064",
    "MayaId": "5122064",
    "Name": "KSM ACT (4D) Sapir Flexib",
    "ShortName": "KSM ACT (4D) Sapir Flexib",
    "Symbol": "TASE:5122064",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE(4D) Sapir Flexible",
    "EnglishLongName": "KSM ACTIVE(4D) Sapir Flexible",
    "HebrewName": "קסם אקטיב ספ גמישה",
    "HebrewLongName": "קסם אקטיב (4D) ספיר גמישה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.6,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 107.3,
    "MonthYield": 3.01,
    "YearYield": 3.01,
    "Last12MonthYield": 22.07,
    "ISIN": "IL0051220643"
  },
  {
    "Id": "TASE:5103718",
    "MayaId": "5103718",
    "Name": "KSM ACT 2029 B DEN DOLLAR",
    "ShortName": "KSM ACT 2029 B DEN DOLLAR",
    "Symbol": "TASE:5103718",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (0D) 2029 BONDS DENOMINATED IN DOLLAR",
    "EnglishLongName": "KSM ACTIVE (0D) 2029 BONDS DENOMINATED IN DOLLAR",
    "HebrewName": "קסם אקט אגח חול 2029 נקוב",
    "HebrewLongName": "קסם אקטיב (0D) אג\"ח חו\"ל 2029 נקובה בדולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.46,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.21,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Bonds",
    "AssetValue": 112.6,
    "MonthYield": -0.92,
    "YearYield": -0.92,
    "Last12MonthYield": -9.42,
    "ISIN": "IL0051037187"
  },
  {
    "Id": "TASE:5109319",
    "MayaId": "5109319",
    "Name": "KSM ACT 70/30 IL",
    "ShortName": "KSM ACT 70/30 IL",
    "Symbol": "TASE:5109319",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (2C) 70/30 IL",
    "EnglishLongName": "KSM ACTIVE (2C) 70/30 IL",
    "HebrewName": "קסם אקט 30/70",
    "HebrewLongName": "קסם אקטיב (2C)י 30/70",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.76,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.56,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 172.4,
    "MonthYield": 2.5,
    "YearYield": 2.5,
    "Last12MonthYield": 15.81,
    "ISIN": "IL0051093198"
  },
  {
    "Id": "TASE:5127717",
    "MayaId": "5127717",
    "Name": "KSM ACT 85/15 IL",
    "ShortName": "KSM ACT 85/15 IL",
    "Symbol": "TASE:5127717",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (2B) 85/15 IL",
    "EnglishLongName": "KSM ACTIVE (2B) 85/15 IL",
    "HebrewName": "קסם אקט 15/85",
    "HebrewLongName": "קסם אקטיב (2B)י 15/85",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.68,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 15% Equity",
    "AssetValue": 281.9,
    "MonthYield": 1.64,
    "YearYield": 1.64,
    "Last12MonthYield": 11.11,
    "ISIN": "IL0051277171"
  },
  {
    "Id": "TASE:5100284",
    "MayaId": "5100284",
    "Name": "KSM ACT 90/10 SOLID P IL",
    "ShortName": "KSM ACT 90/10 SOLID P IL",
    "Symbol": "TASE:5100284",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (1A) 90/10 SOLID PORTFOLIO IL",
    "EnglishLongName": "KSM ACTIVE (1A) 90/10 SOLID PORTFOLIO IL",
    "HebrewName": "קסם אקט 10/90 תיק סולידי",
    "HebrewLongName": "קסם אקטיב (1A)י 10/90 תיק סולידי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 363.7,
    "MonthYield": 1.14,
    "YearYield": 1.14,
    "Last12MonthYield": 9.58,
    "ISIN": "IL0051002843"
  },
  {
    "Id": "TASE:5116512",
    "MayaId": "5116512",
    "Name": "KSM ACT AverageAABonds IL",
    "ShortName": "KSM ACT AverageAABonds IL",
    "Symbol": "TASE:5116512",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (00) Average AA Bonds IL",
    "EnglishLongName": "KSM ACTIVE (00) Average AA Bonds IL",
    "HebrewName": "קסם אקטיב אג\"ח ממוצע AA",
    "HebrewLongName": "קסם אקטיב (00) אג\"ח ממוצע AA",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.21,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 133.5,
    "MonthYield": 0.45,
    "YearYield": 0.45,
    "Last12MonthYield": 5.95,
    "ISIN": "IL0051165129"
  },
  {
    "Id": "TASE:5136783",
    "MayaId": "5136783",
    "Name": "KSM ACT Blkchin Stocks",
    "ShortName": "KSM ACT Blkchin Stocks",
    "Symbol": "TASE:5136783",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (4D) BlockChain Stocks",
    "EnglishLongName": "KSM ACTIVE (4D) BlockChain Stocks",
    "HebrewName": "קסם אקט מניות בלוקצ'יין",
    "HebrewLongName": "קסם אקטיב (4D) מניות בלוקצ'יין",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.75,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 7.91,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks by Sectors - Foreign",
    "AssetValue": 22.1,
    "MonthYield": 15.46,
    "YearYield": 15.46,
    "Last12MonthYield": 33.85,
    "ISIN": "IL0051367832"
  },
  {
    "Id": "TASE:5116942",
    "MayaId": "5116942",
    "Name": "KSM ACT BNDS NO STKS IL",
    "ShortName": "KSM ACT BNDS NO STKS IL",
    "Symbol": "TASE:5116942",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (0A) RANKED BOND WITHOUT STOCKS IL",
    "EnglishLongName": "KSM ACTIVE (0A) RANKED BOND WITHOUT STOCKS IL",
    "HebrewName": "קסם אקט מדורג ללא מניו",
    "HebrewLongName": "קסם אקטיב (0A) אג\"ח מדורג ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.71,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 184.0,
    "MonthYield": 0.57,
    "YearYield": 0.57,
    "Last12MonthYield": 6.48,
    "ISIN": "IL0051169428"
  },
  {
    "Id": "TASE:5128996",
    "MayaId": "5128996",
    "Name": "KSM ACT BON&EQU PORT IL",
    "ShortName": "KSM ACT BON&EQU PORT IL",
    "Symbol": "TASE:5128996",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (3D) BONDS & EQUITY PORTFOLIO IL",
    "EnglishLongName": "KSM ACTIVE (3D) BONDS & EQUITY PORTFOLIO IL",
    "HebrewName": "קסם אקט תיק אג\"ח ומניות",
    "HebrewLongName": "קסם אקטיב (3D) תיק אג\"ח ומניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.8,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - Max. Exposure over 30% Equity",
    "AssetValue": 102.1,
    "MonthYield": 3.91,
    "YearYield": 3.91,
    "Last12MonthYield": 23.68,
    "ISIN": "IL0051289960"
  },
  {
    "Id": "TASE:5101480",
    "MayaId": "5101480",
    "Name": "KSM ACT BOND + 25% IL",
    "ShortName": "KSM ACT BOND + 25% IL",
    "Symbol": "TASE:5101480",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (2B) BOND + 25% IL",
    "EnglishLongName": "KSM ACTIVE (2B) BOND + 25% IL",
    "HebrewName": "קסם אקט אגח + 25%",
    "HebrewLongName": "קסם אקטיב (2B)י אג\"ח + 25%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.68,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.51,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 25% Equity",
    "AssetValue": 80.2,
    "MonthYield": 2.04,
    "YearYield": 2.04,
    "Last12MonthYield": 14.65,
    "ISIN": "IL0051014806"
  },
  {
    "Id": "TASE:5123468",
    "MayaId": "5123468",
    "Name": "KSM ACT BOND +10% IL",
    "ShortName": "KSM ACT BOND +10% IL",
    "Symbol": "TASE:5123468",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (1B)(!) BOND + 10% IL",
    "EnglishLongName": "KSM ACTIVE (1B)(!) BOND + 10% IL",
    "HebrewName": "קסם אקט אג\"ח +10%",
    "HebrewLongName": "קסם אקטיב (1B)(!)י אג\"ח +10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.38,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 114.8,
    "MonthYield": 1.39,
    "YearYield": 1.39,
    "Last12MonthYield": 9.55,
    "ISIN": "IL0051234685"
  },
  {
    "Id": "TASE:5134473",
    "MayaId": "5134473",
    "Name": "KSM ACT Bonds + 10% IL",
    "ShortName": "KSM ACT Bonds + 10% IL",
    "Symbol": "TASE:5134473",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM Active (1A) Bonds + 10% IL",
    "EnglishLongName": "KSM Active (1A) Bonds + 10% IL",
    "HebrewName": "קסם אקטיב אג\"ח + 10%",
    "HebrewLongName": "קסם אקטיב (1A) אג\"ח + 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.74,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 143.2,
    "MonthYield": 1.42,
    "YearYield": 1.42,
    "Last12MonthYield": 9.48,
    "ISIN": "IL0051344732"
  },
  {
    "Id": "TASE:5103056",
    "MayaId": "5103056",
    "Name": "KSM ACT BONDS IL",
    "ShortName": "KSM ACT BONDS IL",
    "Symbol": "TASE:5103056",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (0B) BONDS IL",
    "EnglishLongName": "KSM ACTIVE (0B) BONDS IL",
    "HebrewName": "קסם אקטיב אג\"ח",
    "HebrewLongName": "קסם אקטיב (0B) אג\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.15,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 180.7,
    "MonthYield": 0.51,
    "YearYield": 0.51,
    "Last12MonthYield": 5.48,
    "ISIN": "IL0051030562"
  },
  {
    "Id": "TASE:5134481",
    "MayaId": "5134481",
    "Name": "KSM ACT Co Bonds + 10% IL",
    "ShortName": "KSM ACT Co Bonds + 10% IL",
    "Symbol": "TASE:5134481",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM Active (1B) Corporate Bonds + 10% IL",
    "EnglishLongName": "KSM Active (1B) Corporate Bonds + 10% IL",
    "HebrewName": "קסם אקטיב אג\"ח חברות +10%",
    "HebrewLongName": "קסם אקטיב (1B) אג\"ח חברות + 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.4,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles with Equity",
    "AssetValue": 494.3,
    "MonthYield": 1.2,
    "YearYield": 1.2,
    "Last12MonthYield": 8.95,
    "ISIN": "IL0051344815"
  },
  {
    "Id": "TASE:5118880",
    "MayaId": "5118880",
    "Name": "KSM ACT Corp $ Lin Pl IL",
    "ShortName": "KSM ACT Corp $-Lin Pl IL",
    "Symbol": "TASE:5118880",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (0D) Corporate Dollar-Linked Plus IL",
    "EnglishLongName": "KSM ACTIVE (0D) Corporate Dollar-Linked Plus IL",
    "HebrewName": "קסםאקט קונצצמוד דולרפלוס",
    "HebrewLongName": "קסם אקטיב (0D) קונצרני צמוד דולר פלוס",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.78,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.65,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 28.1,
    "MonthYield": -0.09,
    "YearYield": -0.09,
    "Last12MonthYield": -4.18,
    "ISIN": "IL0051188808"
  },
  {
    "Id": "TASE:5119664",
    "MayaId": "5119664",
    "Name": "KSM ACT CPI LIN MED GOV",
    "ShortName": "KSM ACT CPI-LIN MED GOV",
    "Symbol": "TASE:5119664",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (00) CPI-LINKED MEDIUM GOEVERNMENT",
    "EnglishLongName": "KSM ACTIVE (00) CPI-LINKED MEDIUM GOEVERNMENT",
    "HebrewName": "קסם אקט ממשלתי צמוד בינונ",
    "HebrewLongName": "קסם אקטיב (00) ממשלתי צמוד בינוני",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.64,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.17,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked Government Bonds - No Equity",
    "AssetValue": 808.7,
    "MonthYield": 0.07,
    "YearYield": 0.07,
    "Last12MonthYield": 4.37,
    "ISIN": "IL0051196645"
  },
  {
    "Id": "TASE:5105978",
    "MayaId": "5105978",
    "Name": "KSM ACT CPILIN GOV NO EQU",
    "ShortName": "KSM ACT CPILIN GOV NO EQU",
    "Symbol": "TASE:5105978",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (0A) CPI-LINKED GOVERNMENT WITHOUT EQUITY",
    "EnglishLongName": "KSM ACTIVE (0A) CPI-LINKED GOVERNMENT WITHOUT EQUITY",
    "HebrewName": "קסם אקט מדי צמוד לא מניות",
    "HebrewLongName": "קסם אקטיב (0A) מדינה צמוד ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.71,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.18,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked Government Bonds - No Equity",
    "AssetValue": 573.7,
    "MonthYield": 0.06,
    "YearYield": 0.06,
    "Last12MonthYield": 4.2,
    "ISIN": "IL0051059785"
  },
  {
    "Id": "TASE:5124292",
    "MayaId": "5124292",
    "Name": "KSM ACT ENERGY IL",
    "ShortName": "KSM ACT ENERGY IL",
    "Symbol": "TASE:5124292",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (4C) ENERGY IL",
    "EnglishLongName": "KSM ACTIVE (4C) ENERGY IL",
    "HebrewName": "קסם אקט אנרגיה",
    "HebrewLongName": "קסם אקטיב (4C) אנרגיה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.79,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.77,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sectors",
    "AssetValue": 16.6,
    "MonthYield": -0.35,
    "YearYield": -0.35,
    "Last12MonthYield": 37.63,
    "ISIN": "IL0051242928"
  },
  {
    "Id": "TASE:5111406",
    "MayaId": "5111406",
    "Name": "KSM ACT Equity Plus IL",
    "ShortName": "KSM ACT Equity Plus IL",
    "Symbol": "TASE:5111406",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (4B) Equity Plus IL",
    "EnglishLongName": "KSM ACTIVE (4B) Equity Plus IL",
    "HebrewName": "קסם אקטיב מניות",
    "HebrewLongName": "קסם אקטיב (4B) מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.1,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 14.6,
    "MonthYield": 5.42,
    "YearYield": 5.42,
    "Last12MonthYield": 46.6,
    "ISIN": "IL0051114069"
  },
  {
    "Id": "TASE:5104948",
    "MayaId": "5104948",
    "Name": "KSM ACT EUROPE",
    "ShortName": "KSM ACT EUROPE",
    "Symbol": "TASE:5104948",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (4D) EUROPE",
    "EnglishLongName": "KSM ACTIVE (4D) EUROPE",
    "HebrewName": "קסם אקט אירופה",
    "HebrewLongName": "קסם אקטיב (4D) אירופה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.95,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.46,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Geographical stocks",
    "AssetValue": 10.0,
    "MonthYield": 1.33,
    "YearYield": 1.33,
    "Last12MonthYield": 18.84,
    "ISIN": "IL0051049489"
  },
  {
    "Id": "TASE:5100318",
    "MayaId": "5100318",
    "Name": "KSM ACT G ST FREE KOSH IL",
    "ShortName": "KSM ACT G ST FREE KOSH IL",
    "Symbol": "TASE:5100318",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (0B) GOVERMMENT STOCKS FREE KOSHER IL",
    "EnglishLongName": "KSM ACTIVE (0B) GOVERMMENT STOCKS FREE KOSHER IL",
    "HebrewName": "קסם אקט מדינה ללא מנ כשר",
    "HebrewLongName": "קסם אקטיב (0B) מדינה ללא מניות כשרה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.67,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - No Equity",
    "AssetValue": 63.8,
    "MonthYield": 0.51,
    "YearYield": 0.51,
    "Last12MonthYield": 5.99,
    "ISIN": "IL0051003189"
  },
  {
    "Id": "TASE:5120993",
    "MayaId": "5120993",
    "Name": "KSM ACT GLOB BOND NEUTRAL",
    "ShortName": "KSM ACT GLOB BOND NEUTRAL",
    "Symbol": "TASE:5120993",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (1A) GLOBAL BOND NEUTRALIZED FOREIGN CURRENCY",
    "EnglishLongName": "KSM ACTIVE (1A) GLOBAL BOND NEUTRALIZED FOREIGN CURRENCY",
    "HebrewName": "קסם אקטיב אגח חול מנוטרל",
    "HebrewLongName": "קסם אקטיב (1A) אג\"ח חו\"ל מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.36,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX-Protected Bonds",
    "AssetValue": 154.1,
    "MonthYield": 0.42,
    "YearYield": 0.42,
    "Last12MonthYield": 7.4,
    "ISIN": "IL0051209935"
  },
  {
    "Id": "TASE:5112693",
    "MayaId": "5112693",
    "Name": "KSM ACT GLOBAL SHARES",
    "ShortName": "KSM ACT GLOBAL SHARES",
    "Symbol": "TASE:5112693",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (4D) GLOBAL SHARES",
    "EnglishLongName": "KSM ACTIVE (4D) GLOBAL SHARES",
    "HebrewName": "קסם אקטיב מניות חו\"ל",
    "HebrewLongName": "קסם אקטיב (4D) מניות חו\"ל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.87,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.07,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 29.1,
    "MonthYield": 0.76,
    "YearYield": 0.76,
    "Last12MonthYield": -1.07,
    "ISIN": "IL0051126931"
  },
  {
    "Id": "TASE:5123211",
    "MayaId": "5123211",
    "Name": "KSM ACT GOLD",
    "ShortName": "KSM ACT GOLD",
    "Symbol": "TASE:5123211",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM (4D) GOLD",
    "EnglishLongName": "KSM (4D) GOLD",
    "HebrewName": "קסם אקטיב זהב",
    "HebrewLongName": "קסם אקטיב (4D) זהב",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.9,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.23,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks by Sectors - Foreign",
    "AssetValue": 125.8,
    "MonthYield": 6.29,
    "YearYield": 6.29,
    "Last12MonthYield": 65.05,
    "ISIN": "IL0051232119"
  },
  {
    "Id": "TASE:5110309",
    "MayaId": "5110309",
    "Name": "KSM ACT GOV AA & up IL",
    "ShortName": "KSM ACT GOV- AA & up IL",
    "Symbol": "TASE:5110309",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (00) GOVERNMENT- AA & up IL",
    "EnglishLongName": "KSM ACTIVE (00) GOVERNMENT- AA & up IL",
    "HebrewName": "קסם אקטיב מדינה -AA ומעלה",
    "HebrewLongName": "קסם אקטיב (00) מדינה – AA ומעלה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.62,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - No Equity",
    "AssetValue": 147.9,
    "MonthYield": 0.46,
    "YearYield": 0.46,
    "Last12MonthYield": 6.03,
    "ISIN": "IL0051103096"
  },
  {
    "Id": "TASE:5123476",
    "MayaId": "5123476",
    "Name": "KSM ACT GOV BONDS",
    "ShortName": "KSM ACT GOV BONDS",
    "Symbol": "TASE:5123476",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (0A) GOVERNMENT BONDS WITHOUT EQUITY",
    "EnglishLongName": "KSM ACTIVE (0A) GOVERNMENT BONDS WITHOUT EQUITY",
    "HebrewName": "קסם אקט אג\"ח מדינה",
    "HebrewLongName": "קסם אקטיב (0A) אג\"ח מדינה ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.64,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.23,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - No Equity",
    "AssetValue": 154.5,
    "MonthYield": 0.47,
    "YearYield": 0.47,
    "Last12MonthYield": 5.56,
    "ISIN": "IL0051234768"
  },
  {
    "Id": "TASE:5116553",
    "MayaId": "5116553",
    "Name": "KSM ACT GOV BONDS +10%",
    "ShortName": "KSM ACT GOV BONDS +10%",
    "Symbol": "TASE:5116553",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM (1A) GOVERNMENT BONDS + 10%",
    "EnglishLongName": "KSM (1A) GOVERNMENT BONDS + 10%",
    "HebrewName": "קסם אקט אגח מדינה +10%",
    "HebrewLongName": "קסם אקטיב (1A) אג\"ח מדינה + 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.62,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - up to 10% Equity",
    "AssetValue": 153.7,
    "MonthYield": 1.18,
    "YearYield": 1.18,
    "Last12MonthYield": 9.31,
    "ISIN": "IL0051165533"
  },
  {
    "Id": "TASE:5112479",
    "MayaId": "5112479",
    "Name": "KSM ACT IN DOLLAR BOND",
    "ShortName": "KSM ACT IN DOLLAR BOND",
    "Symbol": "TASE:5112479",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (0D) INTERNATIONAL DOLLAR BOND",
    "EnglishLongName": "KSM ACTIVE (0D) INTERNATIONAL DOLLAR BOND",
    "HebrewName": "קסם אקטיב אג\"ח דולר בינל",
    "HebrewLongName": "קסם אקטיב (0D) אג\"ח דולר בינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.27,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.19,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "Dollar Bond",
    "AssetValue": 24.4,
    "MonthYield": -1.16,
    "YearYield": -1.16,
    "Last12MonthYield": -6.32,
    "ISIN": "IL0051124795"
  },
  {
    "Id": "TASE:5134465",
    "MayaId": "5134465",
    "Name": "KSM ACT Invest Po+30% IL",
    "ShortName": "KSM ACT Invest Po+30% IL",
    "Symbol": "TASE:5134465",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM Active (2C) Investment Portfolio + 30% IL",
    "EnglishLongName": "KSM Active (2C) Investment Portfolio + 30% IL",
    "HebrewName": "קסם אקטיב תיק השקעות+30%",
    "HebrewLongName": "קסם אקטיב (2C) תיק השקעות + 30%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.61,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 146.7,
    "MonthYield": 2.52,
    "YearYield": 2.52,
    "Last12MonthYield": 17.19,
    "ISIN": "IL0051344658"
  },
  {
    "Id": "TASE:5134002",
    "MayaId": "5134002",
    "Name": "KSM ACT Isr fuoffu15%eqIL",
    "ShortName": "KSM ACT Isr fuoffu15%eqIL",
    "Symbol": "TASE:5134002",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (2B) Israeli fund of funds 15% equity IL",
    "EnglishLongName": "KSM ACTIVE (2B) Israeli fund of funds 15% equity IL",
    "HebrewName": "קסם אקט אגד ישר עד 15%מני",
    "HebrewLongName": "קסם אקטיב (2B) אגד ישראלי עד 15% מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.015,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.45,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Fund of Funds",
    "SecondaryClassification": "Israeli Fund of Funds",
    "AssetValue": 157.5,
    "MonthYield": 1.4,
    "YearYield": 1.4,
    "Last12MonthYield": 10.86,
    "ISIN": "IL0051340029"
  },
  {
    "Id": "TASE:5134010",
    "MayaId": "5134010",
    "Name": "KSM ACT Isr fuoffu30%eqIL",
    "ShortName": "KSM ACT Isr fuoffu30%eqIL",
    "Symbol": "TASE:5134010",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (2C) Israeli fund of funds 30% equity IL",
    "EnglishLongName": "KSM ACTIVE (2C) Israeli fund of funds 30% equity IL",
    "HebrewName": "קסם אקט אגד ישר עד 30%מני",
    "HebrewLongName": "קסם אקטיב (2B) אגד ישראלי עד 30% מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.015,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.63,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Fund of Funds",
    "SecondaryClassification": "Israeli Fund of Funds",
    "AssetValue": 133.3,
    "MonthYield": 2.38,
    "YearYield": 2.38,
    "Last12MonthYield": 15.85,
    "ISIN": "IL0051340102"
  },
  {
    "Id": "TASE:5100953",
    "MayaId": "5100953",
    "Name": "KSM ACT MANAGED PORT IL",
    "ShortName": "KSM ACT MANAGED PORT IL",
    "Symbol": "TASE:5100953",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (3D) MANAGED PORTFOLIO IL",
    "EnglishLongName": "KSM ACTIVE (3D) MANAGED PORTFOLIO IL",
    "HebrewName": "קסם אקט תיק מנוהל",
    "HebrewLongName": "קסם אקטיב (3D) תיק מנוהל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.45,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.44,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - Max. Exposure over 30% Equity",
    "AssetValue": 156.0,
    "MonthYield": 1.63,
    "YearYield": 1.63,
    "Last12MonthYield": 12.98,
    "ISIN": "IL0051009533"
  },
  {
    "Id": "TASE:5103726",
    "MayaId": "5103726",
    "Name": "KSM ACT PORT+20% FOR FUND",
    "ShortName": "KSM ACT PORT+20% FOR FUND",
    "Symbol": "TASE:5103726",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (2D) PORTFOLIO + 20% - FOREIGN FUND OF FUNDS",
    "EnglishLongName": "KSM ACTIVE (2D) PORTFOLIO + 20% - FOREIGN FUND OF FUNDS",
    "HebrewName": "קסם אקטיב תיק+20% אגד חוץ",
    "HebrewLongName": "קסם אקטיב (2D) תיק + 20% - אגד חוץ",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.04,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Fund of Funds",
    "SecondaryClassification": "Foreign Fund of Funds",
    "AssetValue": 23.4,
    "MonthYield": -0.67,
    "YearYield": -0.67,
    "Last12MonthYield": -6.29,
    "ISIN": "IL0051037260"
  },
  {
    "Id": "TASE:5108238",
    "MayaId": "5108238",
    "Name": "KSM ACT SHEKEL COR+10 IL",
    "ShortName": "KSM ACT SHEKEL COR+10 IL",
    "Symbol": "TASE:5108238",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (1B) SHEKEL CORPORATE + 10 IL",
    "EnglishLongName": "KSM ACTIVE (1B) SHEKEL CORPORATE + 10 IL",
    "HebrewName": "קסם אקט קונצרני שקלי + 10",
    "HebrewLongName": "קסם אקטיב (1B) קונצרני שקלי + 10",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.08,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.42,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Shekel Corporate and Convertibles with Equity",
    "AssetValue": 5.9,
    "MonthYield": 1.63,
    "YearYield": 1.63,
    "Last12MonthYield": 9.15,
    "ISIN": "IL0051082381"
  },
  {
    "Id": "TASE:5137740",
    "MayaId": "5137740",
    "Name": "KSM ACT Shkl MoneyMrkt IL",
    "ShortName": "KSM ACT Shkl MoneyMrkt IL",
    "Symbol": "TASE:5137740",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM Active (00) Shekel Money Market IL",
    "EnglishLongName": "KSM Active (00) Shekel Money Market IL",
    "HebrewName": "קסם אקטיב כספית שקלית",
    "HebrewLongName": "קסם אקטיב (00) כספית שקלית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.19,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 10103.1,
    "MonthYield": 0.21,
    "YearYield": 0.21,
    "Last12MonthYield": 4.63,
    "ISIN": "IL0051377401"
  },
  {
    "Id": "TASE:5122338",
    "MayaId": "5122338",
    "Name": "KSM ACT TA L& M Cap IL",
    "ShortName": "KSM ACT TA L& M Cap IL",
    "Symbol": "TASE:5122338",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM Active (4B) TA Large & Mid Cap IL",
    "EnglishLongName": "KSM Active (4B) TA Large & Mid Cap IL",
    "HebrewName": "קסם אקט תא Lrg & Mid Cap",
    "HebrewLongName": "קסם אקטיב (4B) ת\"א Large & Mid Cap",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.24,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.99,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 203.6,
    "MonthYield": 8.96,
    "YearYield": 8.96,
    "Last12MonthYield": 63.46,
    "ISIN": "IL0051223381"
  },
  {
    "Id": "TASE:5102421",
    "MayaId": "5102421",
    "Name": "KSM ACT TRACK BL P 2 IL",
    "ShortName": "KSM ACT TRACK BL P 2 IL",
    "Symbol": "TASE:5102421",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (2B) TRACKING BENLEUMI`S PORTFOLIO NO. 2 IL",
    "EnglishLongName": "KSM ACTIVE (2B) TRACKING BENLEUMI`S PORTFOLIO NO. 2 IL",
    "HebrewName": "קסם אקט עוקב תיק 2 בינ\"ל",
    "HebrewLongName": "קסם אקטיב (2B) עוקבת תיק 2 הבנק הבינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.76,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 15% Equity",
    "AssetValue": 458.1,
    "MonthYield": 0.79,
    "YearYield": 0.79,
    "Last12MonthYield": 8.22,
    "ISIN": "IL0051024219"
  },
  {
    "Id": "TASE:5109558",
    "MayaId": "5109558",
    "Name": "KSM ACT TRACK BL P 3 IL",
    "ShortName": "KSM ACT TRACK BL P 3 IL",
    "Symbol": "TASE:5109558",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (2B) TRACKING BENLEUMI'S PORTFOLIO NO. 3 IL",
    "EnglishLongName": "KSM ACTIVE (2B) TRACKING BENLEUMI'S PORTFOLIO NO. 3 IL",
    "HebrewName": "קסם אקט עוקב תיק 3 בינ\"",
    "HebrewLongName": "קסם אקטיב (2B) עוקבת תיק 3 הבנק הבינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.61,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.36,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 235.2,
    "MonthYield": 1.69,
    "YearYield": 1.69,
    "Last12MonthYield": 11.23,
    "ISIN": "IL0051095581"
  },
  {
    "Id": "TASE:5108220",
    "MayaId": "5108220",
    "Name": "KSM ACT TRAK BL BD P2 IL",
    "ShortName": "KSM ACT TRAK BL BD P2 IL",
    "Symbol": "TASE:5108220",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (00) TRACKING BENLEUMI`S PORTFOLIO 2 – BOND COMPONENT IL",
    "EnglishLongName": "KSM ACTIVE (00) TRACKING BENLEUMI`S PORTFOLIO 2 – BOND COMPONENT IL",
    "HebrewName": "קסם אקט עוקב אג תיק 2 בינ",
    "HebrewLongName": "קסם אקטיב (00) עוקבת מרכיב אג\"ח – תיק 2 הבנק הבינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.62,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 97.3,
    "MonthYield": 0.46,
    "YearYield": 0.46,
    "Last12MonthYield": 6.61,
    "ISIN": "IL0051082209"
  },
  {
    "Id": "TASE:5109848",
    "MayaId": "5109848",
    "Name": "KSM ACT US $ DENOMINATED",
    "ShortName": "KSM ACT US $ DENOMINATED",
    "Symbol": "TASE:5109848",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (4D) US $ DENOMINATED",
    "EnglishLongName": "KSM ACTIVE (4D) US $ DENOMINATED",
    "HebrewName": "קסם אקטיב ארה\"ב נקוב $",
    "HebrewLongName": "קסם אקטיב (4D) ארה\"ב נקוב $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.4,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.77,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 30.2,
    "MonthYield": 3.34,
    "YearYield": 3.34,
    "Last12MonthYield": -5.57,
    "ISIN": "IL0051098486"
  },
  {
    "Id": "TASE:5122668",
    "MayaId": "5122668",
    "Name": "KSM ACT US CURRENCY HEDGE",
    "ShortName": "KSM ACT US CURRENCY HEDGE",
    "Symbol": "TASE:5122668",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE(4A) US FOREIGN CURRENCY NEUTRALIZED",
    "EnglishLongName": "KSM ACTIVE(4A) US FOREIGN CURRENCY NEUTRALIZED",
    "HebrewName": "קסם אקט ארה\"ב מנוטרלת",
    "HebrewLongName": "קסם אקטיב (4A) ארה\"ב מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.2,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.67,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Geographical stocks",
    "AssetValue": 62.4,
    "MonthYield": 0.67,
    "YearYield": 0.67,
    "Last12MonthYield": 17.55,
    "ISIN": "IL0051226681"
  },
  {
    "Id": "TASE:5119003",
    "MayaId": "5119003",
    "Name": "KSM ACT US EQUITIES",
    "ShortName": "KSM ACT US EQUITIES",
    "Symbol": "TASE:5119003",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (4D) US EQUITIES",
    "EnglishLongName": "KSM ACTIVE (4D) US EQUITIES",
    "HebrewName": "קסם אקט מניות ארה\"ב",
    "HebrewLongName": "קסם אקטיב (4D) מניות ארה\"ב",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.61,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.37,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Geographical stocks",
    "AssetValue": 180.9,
    "MonthYield": 0.85,
    "YearYield": 0.85,
    "Last12MonthYield": 2.63,
    "ISIN": "IL0051190036"
  },
  {
    "Id": "TASE:5140603",
    "MayaId": "5140603",
    "Name": "KSM ACT USA Stocks Sharia",
    "ShortName": "KSM ACT USA Stocks Sharia",
    "Symbol": "TASE:5140603",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (4D) USA Stocks Sharia",
    "EnglishLongName": "KSM ACTIVE (4D) USA Stocks Sharia",
    "HebrewName": "קסם אקט מניות ארה\"ב שריעה",
    "HebrewLongName": "קסם אקטיב (4D) מניות ארה\"ב שריעה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.27,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Geographical stocks",
    "AssetValue": 1.2,
    "MonthYield": 0.72,
    "YearYield": 0.72,
    "Last12MonthYield": null,
    "ISIN": "IL0051406036"
  },
  {
    "Id": "TASE:5101308",
    "MayaId": "5101308",
    "Name": "KSM ACT USA TAXABLE",
    "ShortName": "KSM ACT USA TAXABLE",
    "Symbol": "TASE:5101308",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (4D) USA TAXABLE",
    "EnglishLongName": "KSM ACTIVE (4D) USA TAXABLE",
    "HebrewName": "קסם אקט ארה\"ב חייבת",
    "HebrewLongName": "קסם אקטיב (4D) ארה\"ב חייבת",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.45,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.17,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Geographical stocks",
    "AssetValue": 46.3,
    "MonthYield": -0.3,
    "YearYield": -0.3,
    "Last12MonthYield": -2.96,
    "ISIN": "IL0051013089"
  },
  {
    "Id": "TASE:5109053",
    "MayaId": "5109053",
    "Name": "KSM ACTBond Dollar Plus",
    "ShortName": "KSM ACTBond Dollar Plus",
    "Symbol": "TASE:5109053",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (0D) Bond Dollar Plus",
    "EnglishLongName": "KSM ACTIVE (0D) Bond Dollar Plus",
    "HebrewName": "קסם אקט Bond Dollar Plus",
    "HebrewLongName": "קסם אקטיב (0D)י Bond Dollar Plus",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.01,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "Dollar Bond",
    "AssetValue": 70.1,
    "MonthYield": -1.07,
    "YearYield": -1.07,
    "Last12MonthYield": -6.67,
    "ISIN": "IL0051090533"
  },
  {
    "Id": "TASE:5110838",
    "MayaId": "5110838",
    "Name": "KSM ACTGlob Equities",
    "ShortName": "KSM ACTGlob Equities",
    "Symbol": "TASE:5110838",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (4D) Global Equities",
    "EnglishLongName": "KSM ACTIVE (4D) Global Equities",
    "HebrewName": "קסם אקטיב מניותחו\"לגלובלי",
    "HebrewLongName": "קסם אקטיב (4D) מניות חו\"ל גלובלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.22,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.52,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 108.6,
    "MonthYield": 0.94,
    "YearYield": 0.94,
    "Last12MonthYield": 5.52,
    "ISIN": "IL0051108384"
  },
  {
    "Id": "TASE:5127253",
    "MayaId": "5127253",
    "Name": "KSM ACTGlob Rob Equities",
    "ShortName": "KSM ACTGlob Rob Equities",
    "Symbol": "TASE:5127253",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (4D) Global Robotics Equities",
    "EnglishLongName": "KSM ACTIVE (4D) Global Robotics Equities",
    "HebrewName": "קסםאקט מניות רובוטיקה חול",
    "HebrewLongName": "קסם אקטיב (4D) מניות רובוטיקה חו\"ל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.94,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.42,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks by Sectors - Foreign",
    "AssetValue": 66.7,
    "MonthYield": 5.24,
    "YearYield": 5.24,
    "Last12MonthYield": 17.83,
    "ISIN": "IL0051272537"
  },
  {
    "Id": "TASE:5132832",
    "MayaId": "5132832",
    "Name": "KSM ACTIVE (0F) Dollar*3",
    "ShortName": "KSM ACTIVE (0F) Dollar*3",
    "Symbol": "TASE:5132832",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (0F) Dollar*3",
    "EnglishLongName": "KSM ACTIVE (0F) Dollar*3",
    "HebrewName": "קסם אקטיב דולר פי 3",
    "HebrewLongName": "קסם אקטיב (0F) דולר פי 3",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.0,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": true,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.63,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Leveraged and Strategic",
    "SecondaryClassification": "Leveraged, High-Risk",
    "AssetValue": 26.0,
    "MonthYield": -2.45,
    "YearYield": -2.45,
    "Last12MonthYield": -33.87,
    "ISIN": "IL0051328321"
  },
  {
    "Id": "TASE:5114558",
    "MayaId": "5114558",
    "Name": "KSM ACTIVE (1A) 95 5 IL",
    "ShortName": "KSM ACTIVE (1A) 95-5 IL",
    "Symbol": "TASE:5114558",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (1A) 95-5 IL",
    "EnglishLongName": "KSM ACTIVE (1A) 95-5 IL",
    "HebrewName": "קסם אקטיב (1A)י 5-95",
    "HebrewLongName": "קסם אקטיב (1A)י 5-95",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 5% Equity",
    "AssetValue": 43.4,
    "MonthYield": 0.84,
    "YearYield": 0.84,
    "Last12MonthYield": 7.38,
    "ISIN": "IL0051145584"
  },
  {
    "Id": "TASE:5121439",
    "MayaId": "5121439",
    "Name": "KSM ACTIVE (2B) 80/20 IL",
    "ShortName": "KSM ACTIVE (2B) 80/20 IL",
    "Symbol": "TASE:5121439",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (2B) 80/20 IL",
    "EnglishLongName": "KSM ACTIVE (2B) 80/20 IL",
    "HebrewName": "קסם אקטיב (2B)י 20/80",
    "HebrewLongName": "קסם אקטיב (2B)י 20/80",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.48,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 392.0,
    "MonthYield": 1.74,
    "YearYield": 1.74,
    "Last12MonthYield": 12.25,
    "ISIN": "IL0051214398"
  },
  {
    "Id": "TASE:5104781",
    "MayaId": "5104781",
    "Name": "KSM ACTIVE (4D) Europe",
    "ShortName": "KSM ACTIVE (4D) Europe",
    "Symbol": "TASE:5104781",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (4D) Europe",
    "EnglishLongName": "KSM ACTIVE (4D) Europe",
    "HebrewName": "קסם אקטיב מניות אירופה",
    "HebrewLongName": "קסם אקטיב (4D) מניות אירופה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.94,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.57,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Geographical stocks",
    "AssetValue": 26.5,
    "MonthYield": 1.78,
    "YearYield": 1.78,
    "Last12MonthYield": 18.53,
    "ISIN": "IL0051047814"
  },
  {
    "Id": "TASE:5110879",
    "MayaId": "5110879",
    "Name": "KSM ACTIVE (4D) Globe",
    "ShortName": "KSM ACTIVE (4D) Globe",
    "Symbol": "TASE:5110879",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (4D) Globe",
    "EnglishLongName": "KSM ACTIVE (4D) Globe",
    "HebrewName": "קסם אקטיב גלוב",
    "HebrewLongName": "קסם אקטיב (4D) גלוב",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.19,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.55,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "For Foreign Residents Only",
    "SecondaryClassification": "",
    "AssetValue": 9.1,
    "MonthYield": 0.08,
    "YearYield": 0.08,
    "Last12MonthYield": 7.26,
    "ISIN": "IL0051108798"
  },
  {
    "Id": "TASE:5104278",
    "MayaId": "5104278",
    "Name": "KSM ACTIVE (4D) Japan",
    "ShortName": "KSM ACTIVE (4D) Japan",
    "Symbol": "TASE:5104278",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (4D) Japan",
    "EnglishLongName": "KSM ACTIVE (4D) Japan",
    "HebrewName": "קסם אקטיב יפן",
    "HebrewLongName": "קסם אקטיב (4D) יפן",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.95,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.99,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Geographical stocks",
    "AssetValue": 19.2,
    "MonthYield": 1.91,
    "YearYield": 1.91,
    "Last12MonthYield": 15.01,
    "ISIN": "IL0051042781"
  },
  {
    "Id": "TASE:5125380",
    "MayaId": "5125380",
    "Name": "KSM ACTIVE (5D) Flex",
    "ShortName": "KSM ACTIVE (5D) Flex",
    "Symbol": "TASE:5125380",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (5D) Flex",
    "EnglishLongName": "KSM ACTIVE (5D) Flex",
    "HebrewName": "קסם אקטיב גמישה FLEX",
    "HebrewLongName": "קסם אקטיב (5D)י גמישה FLEX",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.46,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.55,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 95.6,
    "MonthYield": 7.81,
    "YearYield": 7.81,
    "Last12MonthYield": 48.38,
    "ISIN": "IL0051253800"
  },
  {
    "Id": "TASE:5105648",
    "MayaId": "5105648",
    "Name": "KSM ACTIVE COR A & UP IL",
    "ShortName": "KSM ACTIVE COR A & UP IL",
    "Symbol": "TASE:5105648",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (0A) CORPORATE A & UP IL",
    "EnglishLongName": "KSM ACTIVE (0A) CORPORATE A & UP IL",
    "HebrewName": "קסם אקט קונצרני A ומעלה",
    "HebrewLongName": "קסם אקטיב (0A) קונצרני A ומעלה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.72,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 429.5,
    "MonthYield": 0.54,
    "YearYield": 0.54,
    "Last12MonthYield": 6.43,
    "ISIN": "IL0051056484"
  },
  {
    "Id": "TASE:5109863",
    "MayaId": "5109863",
    "Name": "KSM ACTIVE GOV + 15%",
    "ShortName": "KSM ACTIVE GOV + 15%",
    "Symbol": "TASE:5109863",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (2A) GOVERNMENT + 15%",
    "EnglishLongName": "KSM ACTIVE (2A) GOVERNMENT + 15%",
    "HebrewName": "קסם אקט ממשלתי + 15%",
    "HebrewLongName": "קסם אקטיב (2A) ממשלתי+15%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.73,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bonds - General - Up to 20% Equity",
    "AssetValue": 76.2,
    "MonthYield": 1.36,
    "YearYield": 1.36,
    "Last12MonthYield": 10.27,
    "ISIN": "IL0051098635"
  },
  {
    "Id": "TASE:5103361",
    "MayaId": "5103361",
    "Name": "KSM ACTIVE GOV BONDS IL",
    "ShortName": "KSM ACTIVE GOV BONDS IL",
    "Symbol": "TASE:5103361",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (0B) GOVERNMENT BONDS IL",
    "EnglishLongName": "KSM ACTIVE (0B) GOVERNMENT BONDS IL",
    "HebrewName": "קסם אקטיב אג\"ח מדינה",
    "HebrewLongName": "קסם אקטיב (0B) אג\"ח מדינה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.07,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.03,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - No Equity",
    "AssetValue": 45.9,
    "MonthYield": 0.24,
    "YearYield": 0.24,
    "Last12MonthYield": 3.44,
    "ISIN": "IL0051033616"
  },
  {
    "Id": "TASE:5109160",
    "MayaId": "5109160",
    "Name": "KSM ACTIVE Shkl Corp IL",
    "ShortName": "KSM ACTIVE Shkl Corp IL",
    "Symbol": "TASE:5109160",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM Active (0A)(!) Shekel Corporate IL",
    "EnglishLongName": "KSM Active (0A)(!) Shekel Corporate IL",
    "HebrewName": "קסם אקטיב קונצרני שקלי",
    "HebrewLongName": "קסם אקטיב (0A)(!) קונצרני שקלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.98,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Shekel Corporate and Convertibles - No Equity",
    "AssetValue": 57.7,
    "MonthYield": 0.87,
    "YearYield": 0.87,
    "Last12MonthYield": 6.33,
    "ISIN": "IL0051091606"
  },
  {
    "Id": "TASE:5141080",
    "MayaId": "5141080",
    "Name": "KSM ACTIVE Sukuk $ sharia",
    "ShortName": "KSM ACTIVE Sukuk $-sharia",
    "Symbol": "TASE:5141080",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (0D) Sukuk $ Exposed - Sharia",
    "EnglishLongName": "KSM ACTIVE (0D) Sukuk $ Exposed - Sharia",
    "HebrewName": "קסם אקטיב סוקוק $ - שריעה",
    "HebrewLongName": "קסם אקטיב (0D) סוקוק חשופת דולר - שריעה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "Dollar Bond",
    "AssetValue": 4.7,
    "MonthYield": -1.32,
    "YearYield": -1.32,
    "Last12MonthYield": null,
    "ISIN": "IL0051410806"
  },
  {
    "Id": "TASE:5110713",
    "MayaId": "5110713",
    "Name": "KSM ACTIVE TA 90 IL",
    "ShortName": "KSM ACTIVE TA 90 IL",
    "Symbol": "TASE:5110713",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (4A) TA 90 IL",
    "EnglishLongName": "KSM ACTIVE (4A) TA 90 IL",
    "HebrewName": "קסם אקטיב ת\"א 90",
    "HebrewLongName": "קסם אקטיב (4A) ת\"א 90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.2,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.65,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 235.6,
    "MonthYield": 9.09,
    "YearYield": 9.09,
    "Last12MonthYield": 57.18,
    "ISIN": "IL0051107139"
  },
  {
    "Id": "TASE:5138490",
    "MayaId": "5138490",
    "Name": "KSM Active TFP B&E IL FoF",
    "ShortName": "KSM Active TFP B&E IL FoF",
    "Symbol": "TASE:5138490",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM Active (3C) Tacking Fund Portfolio Bonds and Equity - IL Fund of Funds",
    "EnglishLongName": "KSM Active (3C) Tacking Fund Portfolio Bonds and Equity - IL Fund of Funds",
    "HebrewName": "קסם אקטיב מח א מ אגד יש",
    "HebrewLongName": "קסם אקטיב (3C) תיק מחקות אג\"ח ומניות - אגד ישראלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Fund of Funds",
    "SecondaryClassification": "Israeli Fund of Funds",
    "AssetValue": 4.9,
    "MonthYield": 1.64,
    "YearYield": 1.64,
    "Last12MonthYield": 12.41,
    "ISIN": "IL0051384902"
  },
  {
    "Id": "TASE:5103486",
    "MayaId": "5103486",
    "Name": "KSM ACTIVE(4D)US EQUITIES",
    "ShortName": "KSM ACTIVE(4D)US EQUITIES",
    "Symbol": "TASE:5103486",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (4D) US EQUITIES",
    "EnglishLongName": "KSM ACTIVE (4D) US EQUITIES",
    "HebrewName": "קסם אקטיב (4D) מניות US",
    "HebrewLongName": "קסם אקטיב (4D) מניות US",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.7,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Geographical stocks",
    "AssetValue": 10.1,
    "MonthYield": -0.22,
    "YearYield": -0.22,
    "Last12MonthYield": -4.6,
    "ISIN": "IL0051034861"
  },
  {
    "Id": "TASE:5108105",
    "MayaId": "5108105",
    "Name": "KSM ACTPremium IL",
    "ShortName": "KSM ACTPremium IL",
    "Symbol": "TASE:5108105",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (3C) Premium IL",
    "EnglishLongName": "KSM ACTIVE (3C) Premium IL",
    "HebrewName": "קסם אקטיב פרימיום",
    "HebrewLongName": "קסם אקטיב (3C) פרימיום",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.85,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.88,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - Max. Exposure over 30% Equity",
    "AssetValue": 330.1,
    "MonthYield": 3.64,
    "YearYield": 3.64,
    "Last12MonthYield": 23.78,
    "ISIN": "IL0051081052"
  },
  {
    "Id": "TASE:5133384",
    "MayaId": "5133384",
    "Name": "KSM ACTReal Est IL",
    "ShortName": "KSM ACTReal Est IL",
    "Symbol": "TASE:5133384",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (4B) Real Estate IL",
    "EnglishLongName": "KSM ACTIVE (4B) Real Estate IL",
    "HebrewName": "קסם אקטיב מניות נדל\"ן",
    "HebrewLongName": "קסם אקטיב (4B) מניות נדל\"ן",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sectors",
    "AssetValue": 7.5,
    "MonthYield": 9.26,
    "YearYield": 9.26,
    "Last12MonthYield": 30.52,
    "ISIN": "IL0051333842"
  },
  {
    "Id": "TASE:5122056",
    "MayaId": "5122056",
    "Name": "KSM ACTSapir 70/30 IL",
    "ShortName": "KSM ACTSapir 70/30 IL",
    "Symbol": "TASE:5122056",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (2B) Sapir 70/30 IL",
    "EnglishLongName": "KSM ACTIVE (2B) Sapir 70/30 IL",
    "HebrewName": "קסם אקטיב ספיר 30/70",
    "HebrewLongName": "קסם אקטיב (2B) ספיר 30/70",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.58,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.5,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 157.4,
    "MonthYield": 2.24,
    "YearYield": 2.24,
    "Last12MonthYield": 16.2,
    "ISIN": "IL0051220569"
  },
  {
    "Id": "TASE:5121330",
    "MayaId": "5121330",
    "Name": "KSM ACTSapir GlobBond&Eq",
    "ShortName": "KSM ACTSapir GlobBond&Eq",
    "Symbol": "TASE:5121330",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (3D) Sapir Global Bonds & Equities",
    "EnglishLongName": "KSM ACTIVE (3D) Sapir Global Bonds & Equities",
    "HebrewName": "קסםאקט ספ תיק אגח ומניות",
    "HebrewLongName": "קסם אקטיב (3D) ספיר תיק אג\"ח ומניות חו\"ל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.9,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Bond",
    "AssetValue": 147.3,
    "MonthYield": -0.5,
    "YearYield": -0.5,
    "Last12MonthYield": -2.21,
    "ISIN": "IL0051213309"
  },
  {
    "Id": "TASE:5136635",
    "MayaId": "5136635",
    "Name": "KSM ACTUSAerospaceDefense",
    "ShortName": "KSM ACTUSAerospaceDefense",
    "Symbol": "TASE:5136635",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (4D) US Aerospace & Defense",
    "EnglishLongName": "KSM ACTIVE (4D) US Aerospace & Defense",
    "HebrewName": "קסם אקטיב חלל והגנה ארה\"ב",
    "HebrewLongName": "קסם אקטיב (4D) חלל והגנה ארה\"ב",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.94,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.84,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks by Sectors - Foreign",
    "AssetValue": 17.1,
    "MonthYield": 18.2,
    "YearYield": 18.2,
    "Last12MonthYield": 49.5,
    "ISIN": "IL0051366354"
  },
  {
    "Id": "TASE:5121132",
    "MayaId": "5121132",
    "Name": "KSM BSTAR IL TC",
    "ShortName": "KSM BSTAR IL TC",
    "Symbol": "TASE:5121132",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4D) Bluestar Israel Global Technology",
    "EnglishLongName": "KSM KTF (4D) Bluestar Israel Global Technology",
    "HebrewName": "קסם KTF ישראטק Bstar",
    "HebrewLongName": "קסם Bluestar Israel Global Technology (4D) KTF",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.86,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 19.9,
    "MonthYield": 4.49,
    "YearYield": 4.49,
    "Last12MonthYield": 2.07,
    "ISIN": "IL0051211329"
  },
  {
    "Id": "TASE:5127857",
    "MayaId": "5127857",
    "Name": "KSM DIS TECH CH",
    "ShortName": "KSM DIS TECH CH",
    "Symbol": "TASE:5127857",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) Indxx USD Disruptive Technologies Currency Hedged",
    "EnglishLongName": "KSM KTF (4A) Indxx USD Disruptive Technologies Currency Hedged",
    "HebrewName": "קסם Indx DisTech KTF ממ",
    "HebrewLongName": "קסם Indxx USD Disruptive Technologies (4A) KTF מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.15,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 18.6,
    "MonthYield": 2.07,
    "YearYield": 2.07,
    "Last12MonthYield": 4.52,
    "ISIN": "IL0051278575"
  },
  {
    "Id": "TASE:5125166",
    "MayaId": "5125166",
    "Name": "KSM DJ INDST AV",
    "ShortName": "KSM DJ INDST AV",
    "Symbol": "TASE:5125166",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) DJ Industrial Average Currency Hedged",
    "EnglishLongName": "KSM KTF (4A) DJ Industrial Average Currency Hedged",
    "HebrewName": "קסם DowJones IA KTF ממ",
    "HebrewLongName": "קסם DJ Industrial Average (4A) KTF מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.025,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.62,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 121.7,
    "MonthYield": 2.84,
    "YearYield": 2.84,
    "Last12MonthYield": 15.58,
    "ISIN": "IL0051251663"
  },
  {
    "Id": "TASE:5128913",
    "MayaId": "5128913",
    "Name": "KSM DJ INT COMP",
    "ShortName": "KSM DJ INT COMP",
    "Symbol": "TASE:5128913",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4D) DJ Internet Composite",
    "EnglishLongName": "KSM KTF (4D) DJ Internet Composite",
    "HebrewName": "קסם DJ Internet KTF",
    "HebrewLongName": "קסם DJ Internet Composite (4D) KTF",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.24,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 8.3,
    "MonthYield": -3.41,
    "YearYield": -3.41,
    "Last12MonthYield": -6.78,
    "ISIN": "IL0051289135"
  },
  {
    "Id": "KSM-F154.TA",
    "MayaId": "1147198",
    "Name": "KSM ETF (00) All Bond Floating Shekel IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F154.TA",
    "TaseSymbol": "KSM.F154",
    "YahooId": "KSM-F154.TA",
    "EnglishName": "KSM.TELB IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.ALLBOר.מש ש",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.23,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3987.13,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.1,
    "YearYield": 0.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011471989"
  },
  {
    "Id": "KSM-F213.TA",
    "MayaId": "1192384",
    "Name": "KSM ETF (00) Index Israeli Gov CPI Linked 5Y Duration IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F213.TA",
    "TaseSymbol": "KSM.F213",
    "YahooId": "KSM-F213.TA",
    "EnglishName": "KSM.IGCL5YD IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.אינ מצ מ5ק",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.02,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1195.15,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government linked index - medium term",
    "AssetValue": null,
    "MonthYield": 0.1,
    "YearYield": 0.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011923849"
  },
  {
    "Id": "KSM-F214.TA",
    "MayaId": "1192392",
    "Name": "KSM ETF (00) Index Israeli Gov Non Linked 5Y Duration IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F214.TA",
    "TaseSymbol": "KSM.F214",
    "YahooId": "KSM-F214.TA",
    "EnglishName": "KSM.IGNL 5YD IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם אינ מד מ5ק",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.02,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1307.29,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Fixed interest- medium term",
    "AssetValue": null,
    "MonthYield": 0.8,
    "YearYield": 0.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011923922"
  },
  {
    "Id": "KSM.FK1.TA",
    "MayaId": "1155126",
    "Name": "KSM ETF (00) KOSHER Tel Bond 60 CPI Linked IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM.FK1.TA",
    "TaseSymbol": "KSM.FK1",
    "YahooId": "KSM.FK1.TA",
    "EnglishName": "KSM.KOSTA-B60IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.כתלבונ 60 צ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 121.21,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.4,
    "YearYield": 0.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011551269"
  },
  {
    "Id": "KSM.FK2.TA",
    "MayaId": "1155159",
    "Name": "KSM ETF (00) Kosher Tel Bond Shekel IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM.FK2.TA",
    "TaseSymbol": "KSM.FK2",
    "YahooId": "KSM.FK2.TA",
    "EnglishName": "KSM.KOSTA-BSHIL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.כשתלבונד שק",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4316.2,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.9,
    "YearYield": 0.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011551590"
  },
  {
    "Id": "KSM-F26.TA",
    "MayaId": "1146042",
    "Name": "KSM ETF (00) Short Tel Bond 20 CPI Linked (574) IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F26.TA",
    "TaseSymbol": "KSM.F26",
    "YahooId": "KSM-F26.TA",
    "EnglishName": "KSM.SHTEL-B20IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.חסתלבו 20 צ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 258.69,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Leveraged",
    "SecondaryClassification": "Bonds in Israel",
    "AssetValue": null,
    "MonthYield": 0.1,
    "YearYield": 0.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011460420"
  },
  {
    "Id": "KSM-F50.TA",
    "MayaId": "1146455",
    "Name": "KSM ETF (00) Short Tel Bond 40 CPI Linked (534) IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F50.TA",
    "TaseSymbol": "KSM.F50",
    "YahooId": "KSM-F50.TA",
    "EnglishName": "KSM.SHTEL-B40IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.חסתלבו 40 צ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1363.47,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Leveraged",
    "SecondaryClassification": "Bonds in Israel",
    "AssetValue": null,
    "MonthYield": 0.0,
    "YearYield": 0.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011464554"
  },
  {
    "Id": "KSM-F18.TA",
    "MayaId": "1145960",
    "Name": "KSM ETF (00) Tel Bond 20 CPI Linked IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F18.TA",
    "TaseSymbol": "KSM.F18",
    "YahooId": "KSM-F18.TA",
    "EnglishName": "KSM.TEL-B20 IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תלבונד 20 צ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.015,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4036.17,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.2,
    "YearYield": 0.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011459604"
  },
  {
    "Id": "KSM-F40.TA",
    "MayaId": "1146216",
    "Name": "KSM ETF (00) Tel Bond 40 CPI Linked IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F40.TA",
    "TaseSymbol": "KSM.F40",
    "YahooId": "KSM-F40.TA",
    "EnglishName": "KSM.TEL-B40 IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תלבונד 40צ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.015,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3837.67,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.5,
    "YearYield": 0.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011462160"
  },
  {
    "Id": "KSM-F41.TA",
    "MayaId": "1146232",
    "Name": "KSM ETF (00) Tel Bond 60 CPI Linked IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F41.TA",
    "TaseSymbol": "KSM.F41",
    "YahooId": "KSM-F41.TA",
    "EnglishName": "KSM.TEL-B60 IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תלבונד 60 צ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.015,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3951.18,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.3,
    "YearYield": 0.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011462327"
  },
  {
    "Id": "KSM-F217.TA",
    "MayaId": "1193614",
    "Name": "KSM ETF (00) Tel Bond CPI Linked 1 3 IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F217.TA",
    "TaseSymbol": "KSM.F217",
    "YahooId": "KSM-F217.TA",
    "EnglishName": "KSM.TEL-CP1-3IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תלבונד צ1-3",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.015,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4034.72,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest - short term",
    "AssetValue": null,
    "MonthYield": 0.2,
    "YearYield": 0.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011936148"
  },
  {
    "Id": "KSM-F1.TA",
    "MayaId": "1150754",
    "Name": "KSM ETF (00) Tel Bond CPI Linked 3 5 IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F1.TA",
    "TaseSymbol": "KSM.F1",
    "YahooId": "KSM-F1.TA",
    "EnglishName": "KSM.TEL-CP35 IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תלבונד צ3-5",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4057.54,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest - medium term",
    "AssetValue": null,
    "MonthYield": 0.3,
    "YearYield": 0.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011507543"
  },
  {
    "Id": "KSM-F221.TA",
    "MayaId": "1193671",
    "Name": "KSM ETF (00) Tel Bond CPI Linked 5 15 IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F221.TA",
    "TaseSymbol": "KSM.F221",
    "YahooId": "KSM-F221.TA",
    "EnglishName": "KSM.TEL-CP51IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תלב צמ 5-15",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.015,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4383.79,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed  interest - long term",
    "AssetValue": null,
    "MonthYield": 0.9,
    "YearYield": 0.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011936718"
  },
  {
    "Id": "KSM-F205.TA",
    "MayaId": "1176320",
    "Name": "KSM ETF (00) Tel Bond CPI Linked A IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F205.TA",
    "TaseSymbol": "KSM.F205",
    "YahooId": "KSM-F205.TA",
    "EnglishName": "KSM.TEL-CPIA IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תלבונד צמ A",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4192.62,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.2,
    "YearYield": 0.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011763203"
  },
  {
    "Id": "KSM-F218.TA",
    "MayaId": "1193648",
    "Name": "KSM ETF (00) Tel Bond CPI Linked AA AAA IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F218.TA",
    "TaseSymbol": "KSM.F218",
    "YahooId": "KSM-F218.TA",
    "EnglishName": "KSM.TEL-CPAA LI",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.בונדצAA-AAA",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.015,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4149.04,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "UBANK",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.4,
    "YearYield": 0.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011936486"
  },
  {
    "Id": "KSM-F126.TA",
    "MayaId": "1146281",
    "Name": "KSM ETF (00) Tel Bond CPI Linked Bank Without COCO IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F126.TA",
    "TaseSymbol": "KSM.F126",
    "YahooId": "KSM-F126.TA",
    "EnglishName": "KSM.TEL-BCLB IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תבצ בל COCO",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.23,
    "TrusteeFee": 0.03,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3650.45,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.2,
    "YearYield": 0.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011462814"
  },
  {
    "Id": "KSM-F107.TA",
    "MayaId": "1146927",
    "Name": "KSM ETF (00) Tel Bond CPI Linked IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F107.TA",
    "TaseSymbol": "KSM.F107",
    "YahooId": "KSM-F107.TA",
    "EnglishName": "KSM.TEL-BCL IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תלבונד צמוד",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.015,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4100.19,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.2,
    "YearYield": 0.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011469272"
  },
  {
    "Id": "KSM-F108.TA",
    "MayaId": "1146935",
    "Name": "KSM ETF (00) Tel Bond CPI Linked SmallCap IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F108.TA",
    "TaseSymbol": "KSM.F108",
    "YahooId": "KSM-F108.TA",
    "EnglishName": "KSM.TEL-BCLS IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תלבונדצ יתר",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.22,
    "TrusteeFee": 0.02,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4227.34,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.3,
    "YearYield": 0.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011469355"
  },
  {
    "Id": "KSM-F223.TA",
    "MayaId": "1193689",
    "Name": "KSM ETF (00) Tel Bond Shekel 1 3 IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F223.TA",
    "TaseSymbol": "KSM.F223",
    "YahooId": "KSM-F223.TA",
    "EnglishName": "KSM.TEL-SH03IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תלבונדש 1-3",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.015,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4696.6,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest - short term",
    "AssetValue": null,
    "MonthYield": 0.8,
    "YearYield": 0.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011936890"
  },
  {
    "Id": "KSM-F174.TA",
    "MayaId": "1147396",
    "Name": "KSM ETF (00) Tel Bond Shekel 3 5 IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F174.TA",
    "TaseSymbol": "KSM.F174",
    "YahooId": "KSM-F174.TA",
    "EnglishName": "KSM.TEL-SH35 IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תלבונד ש3-5",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4360.94,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest - medium term",
    "AssetValue": null,
    "MonthYield": 1.1,
    "YearYield": 1.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011473969"
  },
  {
    "Id": "KSM-F207.TA",
    "MayaId": "1185123",
    "Name": "KSM ETF (00) Tel Bond Shekel 5 15 IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F207.TA",
    "TaseSymbol": "KSM.F207",
    "YahooId": "KSM-F207.TA",
    "EnglishName": "KSM.TEL-SH51IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תלבשקלי5-15",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4434.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed  interest - long term",
    "AssetValue": null,
    "MonthYield": 1.6,
    "YearYield": 1.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011851230"
  },
  {
    "Id": "KSM-F2.TA",
    "MayaId": "1150762",
    "Name": "KSM ETF (00) Tel Bond Shekel 50 IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F2.TA",
    "TaseSymbol": "KSM.F2",
    "YahooId": "KSM-F2.TA",
    "EnglishName": "KSM.TEL-B50 IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תלבונד ש 50",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.014,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4375.9,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.9,
    "YearYield": 0.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011507626"
  },
  {
    "Id": "KSM-F219.TA",
    "MayaId": "1193655",
    "Name": "KSM ETF (00) Tel Bond Shekel A IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F219.TA",
    "TaseSymbol": "KSM.F219",
    "YahooId": "KSM-F219.TA",
    "EnglishName": "KSM.TEL-SHA LI",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תלבונד ש A",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.015,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4486.6,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 1.0,
    "YearYield": 1.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011936551"
  },
  {
    "Id": "KSM-F220.TA",
    "MayaId": "1193663",
    "Name": "KSM ETF (00) Tel Bond Shekel AA AAA IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F220.TA",
    "TaseSymbol": "KSM.F220",
    "YahooId": "KSM-F220.TA",
    "EnglishName": "KSM.TEL-SHAA IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.בונדשAA-AAA",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.015,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4539.41,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 1.1,
    "YearYield": 1.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011936635"
  },
  {
    "Id": "KSM-F48.TA",
    "MayaId": "1146414",
    "Name": "KSM ETF (00) Tel Bond Shekel IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F48.TA",
    "TaseSymbol": "KSM.F48",
    "YahooId": "KSM-F48.TA",
    "EnglishName": "KSM.TEL-BSH IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תלבונד שקלי",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.015,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4309.1,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 1.0,
    "YearYield": 1.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011464141"
  },
  {
    "Id": "KSM-F42.TA",
    "MayaId": "1146257",
    "Name": "KSM ETF (00) Tel Gov CPI Linked",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F42.TA",
    "TaseSymbol": "KSM.F42",
    "YahooId": "KSM-F42.TA",
    "EnglishName": "KSM.TL G CPI-LI",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תל גוב-צמוד",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3750.66,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government linked index  - other",
    "AssetValue": null,
    "MonthYield": 0.1,
    "YearYield": 0.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011462574"
  },
  {
    "Id": "KSM-F35.TA",
    "MayaId": "1146133",
    "Name": "KSM ETF (00) Tel Gov CPI Linked 0 2",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F35.TA",
    "TaseSymbol": "KSM.F35",
    "YahooId": "KSM-F35.TA",
    "EnglishName": "KSM.TL GCPI0-2",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תל ג-צמ 0-2",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.015,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2669.07,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government linked index  - short term",
    "AssetValue": null,
    "MonthYield": 0.2,
    "YearYield": 0.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011461337"
  },
  {
    "Id": "KSM-F36.TA",
    "MayaId": "1146158",
    "Name": "KSM ETF (00) Tel Gov CPI Linked 2 5",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F36.TA",
    "TaseSymbol": "KSM.F36",
    "YahooId": "KSM-F36.TA",
    "EnglishName": "KSM.TL GCPI2-5",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תל ג-צמ 2-5",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.015,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2956.65,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government linked index - medium term",
    "AssetValue": null,
    "MonthYield": 0.1,
    "YearYield": 0.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011461584"
  },
  {
    "Id": "KSM-F62.TA",
    "MayaId": "1145739",
    "Name": "KSM ETF (00) Tel Gov CPI Linked 5 10",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F62.TA",
    "TaseSymbol": "KSM.F62",
    "YahooId": "KSM-F62.TA",
    "EnglishName": "KSM.TL GCP5-10",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תל ג-צמ5-10",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.03,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3796.4,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government linked index  - long term",
    "AssetValue": null,
    "MonthYield": 0.1,
    "YearYield": 0.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011457392"
  },
  {
    "Id": "KSM-F58.TA",
    "MayaId": "1146562",
    "Name": "KSM ETF (00) Tel Gov Shekel",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F58.TA",
    "TaseSymbol": "KSM.F58",
    "YahooId": "KSM-F58.TA",
    "EnglishName": "KSM.TLG SHEK",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תל גוב-שקלי",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.015,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5020.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.8,
    "YearYield": 0.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011465627"
  },
  {
    "Id": "KSM-F37.TA",
    "MayaId": "1146166",
    "Name": "KSM ETF (00) Tel Gov Shekel 0 2",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F37.TA",
    "TaseSymbol": "KSM.F37",
    "YahooId": "KSM-F37.TA",
    "EnglishName": "KSM.TLG SHEK0-2",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תל ג-שק 0-2",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3555.36,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Fixed interest - short term",
    "AssetValue": null,
    "MonthYield": 0.2,
    "YearYield": 0.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011461667"
  },
  {
    "Id": "KSM-F39.TA",
    "MayaId": "1146190",
    "Name": "KSM ETF (00) Tel Gov Shekel 2 5",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F39.TA",
    "TaseSymbol": "KSM.F39",
    "YahooId": "KSM-F39.TA",
    "EnglishName": "KSM.TLG SHEK2-5",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תל ג-שק 2-5",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.015,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4526.28,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Fixed interest- medium term",
    "AssetValue": null,
    "MonthYield": 0.6,
    "YearYield": 0.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011461907"
  },
  {
    "Id": "KSM-F38.TA",
    "MayaId": "1146174",
    "Name": "KSM ETF (00) Tel Gov Shekel 5+",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F38.TA",
    "TaseSymbol": "KSM.F38",
    "YahooId": "KSM-F38.TA",
    "EnglishName": "+KSM.TLG SHEK 5",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תל ג-שק 5+",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.015,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 6465.77,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Fixed  interest- long term",
    "AssetValue": null,
    "MonthYield": 1.2,
    "YearYield": 1.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011461741"
  },
  {
    "Id": "KSM-F153.TA",
    "MayaId": "1147180",
    "Name": "KSM ETF (00) Tel Gov Short Shekel 5+ (917.6)",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F153.TA",
    "TaseSymbol": "KSM.F153",
    "YahooId": "KSM-F153.TA",
    "EnglishName": "+KSM.TLGSH SK 5",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.ח תל ג-שק5+",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.3,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5714.88,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Leveraged",
    "SecondaryClassification": "Bonds in Israel",
    "AssetValue": null,
    "MonthYield": -1.8,
    "YearYield": -1.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011471807"
  },
  {
    "Id": "KSM-F43.TA",
    "MayaId": "1146273",
    "Name": "KSM ETF (00) Tel Gov T Bills (MAKAM)",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F43.TA",
    "TaseSymbol": "KSM.F43",
    "YahooId": "KSM-F43.TA",
    "EnglishName": "KSM.TLG T-BILL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תל גוב- מקמ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3136.81,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Makam (T-Bill)",
    "AssetValue": null,
    "MonthYield": 0.3,
    "YearYield": 0.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011462731"
  },
  {
    "Id": "KSM-F227.TA",
    "MayaId": "1199058",
    "Name": "KSM ETF (00)(!) KOSHER Tel Bond Yields CPI Linked IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F227.TA",
    "TaseSymbol": "KSM.F227",
    "YahooId": "KSM-F227.TA",
    "EnglishName": "KSM.KOSTE-YLDIL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.כשבונד תשו",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4427.17,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.3,
    "YearYield": 0.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011990582"
  },
  {
    "Id": "KSM-F190.TA",
    "MayaId": "1161876",
    "Name": "KSM ETF (00)(!) Short Tel Bond Global Shekel (718) IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F190.TA",
    "TaseSymbol": "KSM.F190",
    "YahooId": "KSM-F190.TA",
    "EnglishName": "KSM.SHTEL-BGIL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.חסתלבונדג ש",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3477.53,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Leveraged",
    "SecondaryClassification": "Bonds in Israel",
    "AssetValue": null,
    "MonthYield": 0.0,
    "YearYield": 0.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011618761"
  },
  {
    "Id": "KSM-F148.TA",
    "MayaId": "1147131",
    "Name": "KSM ETF (00)(!) Short Tel Bond Yields CPI Linked (682.1) IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F148.TA",
    "TaseSymbol": "KSM.F148",
    "YahooId": "KSM-F148.TA",
    "EnglishName": "KSM.SHTEL-YLDIL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסםחסתלבונד תשצ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2814.13,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Leveraged",
    "SecondaryClassification": "Bonds in Israel",
    "AssetValue": null,
    "MonthYield": 0.0,
    "YearYield": 0.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011471310"
  },
  {
    "Id": "KSM-F110.TA",
    "MayaId": "1146950",
    "Name": "KSM ETF (00)(!) Tel Bond Yields CPI Linked IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F110.TA",
    "TaseSymbol": "KSM.F110",
    "YahooId": "KSM-F110.TA",
    "EnglishName": "KSM.TEL-YLD IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תלבונד תשוצ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.015,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4422.28,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.2,
    "YearYield": 0.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011469504"
  },
  {
    "Id": "KSM-F198.TA",
    "MayaId": "1170836",
    "Name": "KSM ETF (00)(!) Tel Bond Yields Shekel IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F198.TA",
    "TaseSymbol": "KSM.F198",
    "YahooId": "KSM-F198.TA",
    "EnglishName": "KSM.TEL-NIS IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תלבונד תש ש",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4353.66,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "UBANK",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 1.1,
    "YearYield": 1.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011708364"
  },
  {
    "Id": "KSM-F3.TA",
    "MayaId": "1150770",
    "Name": "KSM ETF (00)(!)Tel Bond Global Shekel IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F3.TA",
    "TaseSymbol": "KSM.F3",
    "YahooId": "KSM-F3.TA",
    "EnglishName": "KSM.TEL-BGLO IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תלבונדגל שק",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4672.25,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 1.0,
    "YearYield": 1.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011507709"
  },
  {
    "Id": "KSM-F85.TA",
    "MayaId": "1146638",
    "Name": "KSM ETF (0A) Comp Tel Gov (65%) Cor Bond IL (35%) Monthly",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F85.TA",
    "TaseSymbol": "KSM.F85",
    "YahooId": "KSM-F85.TA",
    "EnglishName": "KSM.CMPTGVCOIL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תלג-כממוקונ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 15430.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli Composite Bonds",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.7,
    "YearYield": 0.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011466385"
  },
  {
    "Id": "KSM-F161.TA",
    "MayaId": "1147263",
    "Name": "KSM ETF (0A) iBoxx $ Corps Liquid 3 7 Years Currency Hedged",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F161.TA",
    "TaseSymbol": "KSM.F161",
    "YahooId": "KSM-F161.TA",
    "EnglishName": "KSM.IBOXPHA1CH",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.3-7$ IBOXממ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.3,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 17505.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.3,
    "YearYield": 0.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011472631"
  },
  {
    "Id": "KSM-F144.TA",
    "MayaId": "1147081",
    "Name": "KSM ETF (0A) Tel Bond Composite IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F144.TA",
    "TaseSymbol": "KSM.F144",
    "YahooId": "KSM-F144.TA",
    "EnglishName": "KSM.TEL-COMP IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תלבונד מאגר",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.015,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4202.84,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate Bond - Shekel, Linked",
    "AssetValue": null,
    "MonthYield": 0.6,
    "YearYield": 0.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011470817"
  },
  {
    "Id": "KSM-F86.TA",
    "MayaId": "1146646",
    "Name": "KSM ETF (0A) Tel Gov",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F86.TA",
    "TaseSymbol": "KSM.F86",
    "YahooId": "KSM-F86.TA",
    "EnglishName": "KSM.TEL GOV",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תל גוב-כללי",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.015,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3812.01,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.6,
    "YearYield": 0.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011466468"
  },
  {
    "Id": "KSM-F175.TA",
    "MayaId": "1157379",
    "Name": "KSM ETF (0D) All Bond Dollar and Top 5 Tel Bond 20 CPI Linked IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F175.TA",
    "TaseSymbol": "KSM.F175",
    "YahooId": "KSM-F175.TA",
    "EnglishName": "KSM.TEL-BDOL IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.ABדוט5בת20צ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.025,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4275.81,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "UBANK",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "other",
    "AssetValue": null,
    "MonthYield": 0.5,
    "YearYield": 0.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011573792"
  },
  {
    "Id": "KSM-F164.TA",
    "MayaId": "1147297",
    "Name": "KSM ETF (0D) iBoxx $ Corps Liquid 3 7 Years",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F164.TA",
    "TaseSymbol": "KSM.F164",
    "YahooId": "KSM-F164.TA",
    "EnglishName": "KSM.IBOXPHA1",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.3-7$ IBOX",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.3,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 6509.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -1.5,
    "YearYield": -1.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011472979"
  },
  {
    "Id": "KSM-F106.TA",
    "MayaId": "1146919",
    "Name": "KSM ETF (0D) iBoxx US Liquid Investment Grade Top 30",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F106.TA",
    "TaseSymbol": "KSM.F106",
    "YahooId": "KSM-F106.TA",
    "EnglishName": "KSM.IBOXIG30",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.IG30$ IBOX",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 9555.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -1.9,
    "YearYield": -1.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011469199"
  },
  {
    "Id": "KSM-F176.TA",
    "MayaId": "1157908",
    "Name": "KSM ETF (0D) S&P U.S. Treasury Bond 1 3 Year",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F176.TA",
    "TaseSymbol": "KSM.F176",
    "YahooId": "KSM-F176.TA",
    "EnglishName": "KSM.SPBDUS3T",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.SPBDUS3T",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 11871.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -0.8,
    "YearYield": -0.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011579088"
  },
  {
    "Id": "KSM-F177.TA",
    "MayaId": "1157916",
    "Name": "KSM ETF (0D) S&P U.S. Treasury Bond 3 5 Year",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F177.TA",
    "TaseSymbol": "KSM.F177",
    "YahooId": "KSM-F177.TA",
    "EnglishName": "KSM.SPBDUS5T",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.SPBDUS5T",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 16587.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -0.6,
    "YearYield": -0.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011579161"
  },
  {
    "Id": "KSM-F178.TA",
    "MayaId": "1157924",
    "Name": "KSM ETF (0D) S&P U.S. Treasury Bond 7 10 Year",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F178.TA",
    "TaseSymbol": "KSM.F178",
    "YahooId": "KSM-F178.TA",
    "EnglishName": "KSM.SPBDU10T",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.SPBDU10T",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2112.5,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -1.2,
    "YearYield": -1.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011579245"
  },
  {
    "Id": "KSM-F141.TA",
    "MayaId": "1147057",
    "Name": "KSM ETF (2A) Comp Tel Gov (55%) Cor Bond (30%) Equity (15%) Monthly CurrHedged",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F141.TA",
    "TaseSymbol": "KSM.F141",
    "YahooId": "KSM-F141.TA",
    "EnglishName": "KSM.CMPTGCECH",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תלג-כומניממ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 14111.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli Composite Bonds",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.1,
    "YearYield": 1.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011470577"
  },
  {
    "Id": "KSM-F91.TA",
    "MayaId": "1146695",
    "Name": "KSM ETF (2A) Composite Gen Bond IL (80%) Equity (20%) Monthly",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F91.TA",
    "TaseSymbol": "KSM.F91",
    "YahooId": "KSM-F91.TA",
    "EnglishName": "KSM.CPBNEQ IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.משאגחומנ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 16212.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli Composite Bonds",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.8,
    "YearYield": 1.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011466955"
  },
  {
    "Id": "KSM-F88.TA",
    "MayaId": "1146661",
    "Name": "KSM ETF (2A) Composite Gen Bond IL (90%) IL Equity (10%) Monthly",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F88.TA",
    "TaseSymbol": "KSM.F88",
    "YahooId": "KSM-F88.TA",
    "EnglishName": "KSM.CPBNDEQISIL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.משאגחומניש",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 16649.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli Composite Bonds",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.4,
    "YearYield": 1.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011466617"
  },
  {
    "Id": "KSM-F84.TA",
    "MayaId": "1146620",
    "Name": "KSM ETF (4A) Bloomberg Brent Crude Currency Hedged Future",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F84.TA",
    "TaseSymbol": "KSM.F84",
    "YahooId": "KSM-F84.TA",
    "EnglishName": "KSM.BCOMCOCH",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.BB OILממ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 1.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 719.2,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Commodities",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 3.5,
    "YearYield": 3.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011466203"
  },
  {
    "Id": "KSM-F125.TA",
    "MayaId": "1146265",
    "Name": "KSM ETF (4A) Composite Euro Equity Monthly Euro Hedged",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F125.TA",
    "TaseSymbol": "KSM.F125",
    "YahooId": "KSM-F125.TA",
    "EnglishName": "KSM.CPSTKEUEH",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.משמנאירומא",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 23410.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.1,
    "YearYield": 1.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011462657"
  },
  {
    "Id": "KSM-F140.TA",
    "MayaId": "1146828",
    "Name": "KSM ETF (4A) Composite MidCap Equity Monthly Currency Hedged",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F140.TA",
    "TaseSymbol": "KSM.F140",
    "YahooId": "KSM-F140.TA",
    "EnglishName": "KSM.CPSTKMIDCH",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.משמנMIDמפממ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 20170.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 3.2,
    "YearYield": 3.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011468282"
  },
  {
    "Id": "KSM-F119.TA",
    "MayaId": "1147040",
    "Name": "KSM ETF (4A) Composite US Equity Monthly Currency Hedged",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F119.TA",
    "TaseSymbol": "KSM.F119",
    "YahooId": "KSM-F119.TA",
    "EnglishName": "KSM.CPSTKUSCH",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.משמנארהבממ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 40440.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.7,
    "YearYield": 0.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011470403"
  },
  {
    "Id": "KSM-F92.TA",
    "MayaId": "1146703",
    "Name": "KSM ETF (4A) DAX Currency Hedged",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F92.TA",
    "TaseSymbol": "KSM.F92",
    "YahooId": "KSM-F92.TA",
    "EnglishName": "KSM.DAXNRCH",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.DAXממ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 1.0,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 20960.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Europe - developed markets",
    "AssetValue": null,
    "MonthYield": 2.5,
    "YearYield": 2.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011467037"
  },
  {
    "Id": "KSM-F139.TA",
    "MayaId": "1146810",
    "Name": "KSM ETF (4A) DJ Internet Composite Currency Hedged",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F139.TA",
    "TaseSymbol": "KSM.F139",
    "YahooId": "KSM-F139.TA",
    "EnglishName": "KSM.DJINETNCH",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסםDJINTERNETממ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 1.975,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5763.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Internet",
    "AssetValue": null,
    "MonthYield": -4.9,
    "YearYield": -4.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011468100"
  },
  {
    "Id": "KSM-F145.TA",
    "MayaId": "1147107",
    "Name": "KSM ETF (4A) DJ US Dividend Currency Hedged",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F145.TA",
    "TaseSymbol": "KSM.F145",
    "YahooId": "KSM-F145.TA",
    "EnglishName": "KSM.DJDVNCH",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.DJUSDIVממ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.93,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 10600.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": 1.2,
    "YearYield": 1.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011471070"
  },
  {
    "Id": "KSM-F17.TA",
    "MayaId": "1145952",
    "Name": "KSM ETF (4A) EURO STOXX 50 Currency Hedged",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F17.TA",
    "TaseSymbol": "KSM.F17",
    "YahooId": "KSM-F17.TA",
    "EnglishName": "KSM.SX5TCH",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.EUSTOX50ממ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.68,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 8340.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Europe - general",
    "AssetValue": null,
    "MonthYield": 2.7,
    "YearYield": 2.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011459521"
  },
  {
    "Id": "KSM-F138.TA",
    "MayaId": "1147545",
    "Name": "KSM ETF (4A) FTSE 100 Currency Hedged",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F138.TA",
    "TaseSymbol": "KSM.F138",
    "YahooId": "KSM-F138.TA",
    "EnglishName": "KSM.UKXNUKCH",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.FTSE100ממ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 12230.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Europe - developed markets",
    "AssetValue": null,
    "MonthYield": 2.8,
    "YearYield": 2.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011475451"
  },
  {
    "Id": "KSM-F136.TA",
    "MayaId": "1147099",
    "Name": "KSM ETF (4A) FTSE 250 Currency Hedged",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F136.TA",
    "TaseSymbol": "KSM.F136",
    "YahooId": "KSM-F136.TA",
    "EnglishName": "KSM.MCXNUKCH",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.FTSE250ממ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1802.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Europe - developed markets",
    "AssetValue": null,
    "MonthYield": 3.7,
    "YearYield": 3.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011470999"
  },
  {
    "Id": "KSM-F90.TA",
    "MayaId": "1146687",
    "Name": "KSM ETF (4A) Hang Seng China Currency Hedged",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F90.TA",
    "TaseSymbol": "KSM.F90",
    "YahooId": "KSM-F90.TA",
    "EnglishName": "KSM.HSI21NCH",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסHANGSENGCHNממ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 1.0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1066.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Asia and the Pacific - emerging markets",
    "AssetValue": null,
    "MonthYield": 3.9,
    "YearYield": 3.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011466872"
  },
  {
    "Id": "KSM-F77.TA",
    "MayaId": "1146430",
    "Name": "KSM ETF (4A) Index Israeli Banks IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F77.TA",
    "TaseSymbol": "KSM.F77",
    "YahooId": "KSM-F77.TA",
    "EnglishName": "KSM.IN IS BANKS",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.אי בנק ישר",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.015,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 75510.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Banking and non-banking credit",
    "AssetValue": null,
    "MonthYield": 9.5,
    "YearYield": 9.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011464307"
  },
  {
    "Id": "KSM-F239.TA",
    "MayaId": "1220151",
    "Name": "KSM ETF (4A) Israel 100 Profitability Equally Weighted iNDEX IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F239.TA",
    "TaseSymbol": "KSM.F239",
    "YahooId": "KSM-F239.TA",
    "EnglishName": "KSM.I100 PEW IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.אי 100 ר מש",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.015,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 7644.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Large & Mid Cap",
    "AssetValue": null,
    "MonthYield": 8.3,
    "YearYield": 8.3,
    "Last12MonthYield": null,
    "ISIN": "IL0012201518"
  },
  {
    "Id": "KSM.FK3.TA",
    "MayaId": "1155365",
    "Name": "KSM ETF (4A) Kosher TA 125 IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM.FK3.TA",
    "TaseSymbol": "KSM.FK3",
    "YahooId": "KSM.FK3.TA",
    "EnglishName": "KSM.KOS TA125IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.כשר תא 125",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 38300.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Large & Mid Cap",
    "AssetValue": null,
    "MonthYield": 8.3,
    "YearYield": 8.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011553653"
  },
  {
    "Id": "KSM-F49.TA",
    "MayaId": "1146422",
    "Name": "KSM ETF (4A) LBMA Gold Price PM USD Currency Hedged",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F49.TA",
    "TaseSymbol": "KSM.F49",
    "YahooId": "KSM-F49.TA",
    "EnglishName": "KSM.GOLDLNPMCH",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קס.LBMAGOLDPMממ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 1.48,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3349.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Commodities",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 8.0,
    "YearYield": 8.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011464224"
  },
  {
    "Id": "KSM-F129.TA",
    "MayaId": "1146588",
    "Name": "KSM ETF (4A) MDAX Currency Hedged",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F129.TA",
    "TaseSymbol": "KSM.F129",
    "YahooId": "KSM-F129.TA",
    "EnglishName": "KSM.MDAXNRCH",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.MDAXGERממ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.74,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2715.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Europe - developed markets",
    "AssetValue": null,
    "MonthYield": 3.7,
    "YearYield": 3.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011465882"
  },
  {
    "Id": "KSM-F171.TA",
    "MayaId": "1147362",
    "Name": "KSM ETF (4A) MSCI AC World Dollar Hedged",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F171.TA",
    "TaseSymbol": "KSM.F171",
    "YahooId": "KSM-F171.TA",
    "EnglishName": "KSM.M1WDDH",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסMSCIACWORLDמד",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.22,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4531.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.8,
    "YearYield": 0.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011473621"
  },
  {
    "Id": "KSM-F95.TA",
    "MayaId": "1146737",
    "Name": "KSM ETF (4A) MSCI Emerging Markets Dollar Hedged",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F95.TA",
    "TaseSymbol": "KSM.F95",
    "YahooId": "KSM-F95.TA",
    "EnglishName": "KSM.M1EFDH",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.MSCI EMמד",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 1.4,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1392.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Global - emerging markets",
    "AssetValue": null,
    "MonthYield": 5.5,
    "YearYield": 5.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011467375"
  },
  {
    "Id": "KSM-F143.TA",
    "MayaId": "1147073",
    "Name": "KSM ETF (4A) MSCI World Dollar Hedged",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F143.TA",
    "TaseSymbol": "KSM.F143",
    "YahooId": "KSM-F143.TA",
    "EnglishName": "KSM.M1WODH",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.MSCIWORLDמד",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 1.0,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 11170.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Global - developed markets",
    "AssetValue": null,
    "MonthYield": 0.4,
    "YearYield": 0.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011470734"
  },
  {
    "Id": "KSM-F83.TA",
    "MayaId": "1146612",
    "Name": "KSM ETF (4A) NASDAQ 100 Currency Hedged",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F83.TA",
    "TaseSymbol": "KSM.F83",
    "YahooId": "KSM-F83.TA",
    "EnglishName": "KSM.XNDXNNRCH",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.NDX100ממ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 20450.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": -0.8,
    "YearYield": -0.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011466120"
  },
  {
    "Id": "KSM-F120.TA",
    "MayaId": "1146141",
    "Name": "KSM ETF (4A) NASDAQ US BuyBack Achievers Currency Hedged",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F120.TA",
    "TaseSymbol": "KSM.F120",
    "YahooId": "KSM-F120.TA",
    "EnglishName": "KSM.DRBNCH",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסםNDXUSBBACKממ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 1.08,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 20360.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": 0.2,
    "YearYield": 0.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011461410"
  },
  {
    "Id": "KSM-F16.TA",
    "MayaId": "1145945",
    "Name": "KSM ETF (4A) NIKKEI 225 Currency Hedged",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F16.TA",
    "TaseSymbol": "KSM.F16",
    "YahooId": "KSM-F16.TA",
    "EnglishName": "KSM.NKYNTRCH",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.NIKKEI225ממ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 1.23,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 58730.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Asia and Pacific - developed markets",
    "AssetValue": null,
    "MonthYield": 6.1,
    "YearYield": 6.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011459455"
  },
  {
    "Id": "KSM-F94.TA",
    "MayaId": "1146729",
    "Name": "KSM ETF (4A) Russell 2000 Currency Hedged",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F94.TA",
    "TaseSymbol": "KSM.F94",
    "YahooId": "KSM-F94.TA",
    "EnglishName": "KSM.RU20N30UCH",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.RUSS2000ממ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.35,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2348.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": 5.8,
    "YearYield": 5.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011467292"
  },
  {
    "Id": "KSM-F82.TA",
    "MayaId": "1146604",
    "Name": "KSM ETF (4A) S&P 500 Currency Hedged",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F82.TA",
    "TaseSymbol": "KSM.F82",
    "YahooId": "KSM-F82.TA",
    "EnglishName": "KSM.SPTR500NCH",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.SP500ממ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.9,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 6447.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": -0.4,
    "YearYield": -0.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011466047"
  },
  {
    "Id": "KSM-F229.TA",
    "MayaId": "1193754",
    "Name": "KSM ETF (4A) S&P Consumer Discretionary Currency Hedged",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F229.TA",
    "TaseSymbol": "KSM.F229",
    "YahooId": "KSM-F229.TA",
    "EnglishName": "KSM.SP IXY H",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.SP IXY ממ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.02,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5470.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Consumer Discretionary",
    "AssetValue": null,
    "MonthYield": 3.0,
    "YearYield": 3.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011937542"
  },
  {
    "Id": "KSM-F232.TA",
    "MayaId": "1193788",
    "Name": "KSM ETF (4A) S&P Consumer Staples Currency Hedged",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F232.TA",
    "TaseSymbol": "KSM.F232",
    "YahooId": "KSM-F232.TA",
    "EnglishName": "KSM.SP IXR H",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.SP IXR ממ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2976.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Consumer Staples",
    "AssetValue": null,
    "MonthYield": 5.5,
    "YearYield": 5.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011937880"
  },
  {
    "Id": "KSM-F224.TA",
    "MayaId": "1193713",
    "Name": "KSM ETF (4A) S&P Financial Currency Hedged",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F224.TA",
    "TaseSymbol": "KSM.F224",
    "YahooId": "KSM-F224.TA",
    "EnglishName": "KSM.IXMNTR CH",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.IXMNTR ממ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.02,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5840.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Financial",
    "AssetValue": null,
    "MonthYield": -1.9,
    "YearYield": -1.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011937138"
  },
  {
    "Id": "KSM-F228.TA",
    "MayaId": "1193747",
    "Name": "KSM ETF (4A) S&P MidCap 400 Currency Hedged",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F228.TA",
    "TaseSymbol": "KSM.F228",
    "YahooId": "KSM-F228.TA",
    "EnglishName": "KSM.SP400NTR CH",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.SP400NTR ממ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.02,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2904.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": 3.4,
    "YearYield": 3.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011937476"
  },
  {
    "Id": "KSM-F230.TA",
    "MayaId": "1193762",
    "Name": "KSM ETF (4A) S&P Regional Banks Currency Hedged",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F230.TA",
    "TaseSymbol": "KSM.F230",
    "YahooId": "KSM-F230.TA",
    "EnglishName": "KSM.SPSIRBKN CH",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.SPSIRBKN ממ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1717.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Banking",
    "AssetValue": null,
    "MonthYield": 1.5,
    "YearYield": 1.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011937625"
  },
  {
    "Id": "KSM-F117.TA",
    "MayaId": "1147024",
    "Name": "KSM ETF (4A) S&P SmallCap 600 Currency Hedged",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F117.TA",
    "TaseSymbol": "KSM.F117",
    "YahooId": "KSM-F117.TA",
    "EnglishName": "KSM.SPTRSMCNCH",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.SPSCAP600ממ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 13080.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": 4.4,
    "YearYield": 4.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011470247"
  },
  {
    "Id": "KSM-F225.TA",
    "MayaId": "1193739",
    "Name": "KSM ETF (4A) S&P Technology Currency Hedged",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F225.TA",
    "TaseSymbol": "KSM.F225",
    "YahooId": "KSM-F225.TA",
    "EnglishName": "KSM.SPTECH H",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.SPTECH ממ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 9760.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Technology",
    "AssetValue": null,
    "MonthYield": -0.1,
    "YearYield": -0.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011937393"
  },
  {
    "Id": "KSM-F127.TA",
    "MayaId": "1146307",
    "Name": "KSM ETF (4A) STOXX Europe 600 Banks Euro Hedged",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F127.TA",
    "TaseSymbol": "KSM.F127",
    "YahooId": "KSM-F127.TA",
    "EnglishName": "KSM.SX7REH",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסSTOX600BANKמא",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 11320.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Banking",
    "AssetValue": null,
    "MonthYield": 1.9,
    "YearYield": 1.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011463077"
  },
  {
    "Id": "KSM-F121.TA",
    "MayaId": "1146182",
    "Name": "KSM ETF (4A) STOXX Europe 600 Euro Hedged",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F121.TA",
    "TaseSymbol": "KSM.F121",
    "YahooId": "KSM-F121.TA",
    "EnglishName": "KSM.SXXREH",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.STOX600מא",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.93,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 13500.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Europe - general",
    "AssetValue": null,
    "MonthYield": 3.1,
    "YearYield": 3.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011461824"
  },
  {
    "Id": "KSM-F124.TA",
    "MayaId": "1146240",
    "Name": "KSM ETF (4A) STOXX Europe MID 200 Euro Hedged",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F124.TA",
    "TaseSymbol": "KSM.F124",
    "YahooId": "KSM-F124.TA",
    "EnglishName": "KSM.MCXREH",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסםSTOXMID200מא",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.9,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 7393.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Europe - general",
    "AssetValue": null,
    "MonthYield": 2.5,
    "YearYield": 2.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011462400"
  },
  {
    "Id": "KSM-F74.TA",
    "MayaId": "1146356",
    "Name": "KSM ETF (4A) TA 125 IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F74.TA",
    "TaseSymbol": "KSM.F74",
    "YahooId": "KSM-F74.TA",
    "EnglishName": "KSM.TA-125 IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תא 125",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.015,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 38320.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Large & Mid Cap",
    "AssetValue": null,
    "MonthYield": 9.1,
    "YearYield": 9.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011463564"
  },
  {
    "Id": "KSM-F59.TA",
    "MayaId": "1146570",
    "Name": "KSM ETF (4A) TA 35 IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F59.TA",
    "TaseSymbol": "KSM.F59",
    "YahooId": "KSM-F59.TA",
    "EnglishName": "KSM.TA-35 IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תא 35",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.015,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 38300.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Large Cap",
    "AssetValue": null,
    "MonthYield": 9.2,
    "YearYield": 9.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011465700"
  },
  {
    "Id": "KSM-F72.TA",
    "MayaId": "1146331",
    "Name": "KSM ETF (4A) TA 90 IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F72.TA",
    "TaseSymbol": "KSM.F72",
    "YahooId": "KSM-F72.TA",
    "EnglishName": "KSM.TA-90 IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תא 90",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.014,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 35510.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Mid Cap",
    "AssetValue": null,
    "MonthYield": 6.7,
    "YearYield": 6.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011463317"
  },
  {
    "Id": "KSM-F206.TA",
    "MayaId": "1178359",
    "Name": "KSM ETF (4A) TA Construction IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F206.TA",
    "TaseSymbol": "KSM.F206",
    "YahooId": "KSM-F206.TA",
    "EnglishName": "KSM.TA-CONS IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תא בניה",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0.15,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 22540.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Real estate and construction",
    "AssetValue": null,
    "MonthYield": 13.3,
    "YearYield": 13.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011783599"
  },
  {
    "Id": "KSM-F57.TA",
    "MayaId": "1146554",
    "Name": "KSM ETF (4A) TA Finance IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F57.TA",
    "TaseSymbol": "KSM.F57",
    "YahooId": "KSM-F57.TA",
    "EnglishName": "KSM.TA-FIN IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תא פיננסים",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.03,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 85590.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Financial",
    "AssetValue": null,
    "MonthYield": 8.2,
    "YearYield": 8.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011465544"
  },
  {
    "Id": "KSM-F75.TA",
    "MayaId": "1146364",
    "Name": "KSM ETF (4A) TA Global BlueTech IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F75.TA",
    "TaseSymbol": "KSM.F75",
    "YahooId": "KSM-F75.TA",
    "EnglishName": "KSM.TA-BLUE IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תא גלובל-טק",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.03,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4729.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "technology",
    "AssetValue": null,
    "MonthYield": 10.5,
    "YearYield": 10.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011463648"
  },
  {
    "Id": "KSM-F21.TA",
    "MayaId": "1145994",
    "Name": "KSM ETF (4A) TA Growth IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F21.TA",
    "TaseSymbol": "KSM.F21",
    "YahooId": "KSM-F21.TA",
    "EnglishName": "KSM.TA-GROW IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תא צמיחה",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 1.0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 20440.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Small Cap",
    "AssetValue": null,
    "MonthYield": 7.2,
    "YearYield": 7.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011459943"
  },
  {
    "Id": "KSM-F34.TA",
    "MayaId": "1146125",
    "Name": "KSM ETF (4A) TA Insurance IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F34.TA",
    "TaseSymbol": "KSM.F34",
    "YahooId": "KSM-F34.TA",
    "EnglishName": "KSM.TAINSCO IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תא ביטוח",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.03,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 107730.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Insurance",
    "AssetValue": null,
    "MonthYield": 7.1,
    "YearYield": 7.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011461253"
  },
  {
    "Id": "KSM-F103.TA",
    "MayaId": "1146885",
    "Name": "KSM ETF (4A) TA Oil&Gas IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F103.TA",
    "TaseSymbol": "KSM.F103",
    "YahooId": "KSM-F103.TA",
    "EnglishName": "KSM.TA-OIL IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תא נפט וגז",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.03,
    "VariableFee": 0.2,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 30610.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Oil, gas and energy",
    "AssetValue": null,
    "MonthYield": -2.6,
    "YearYield": -2.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011468852"
  },
  {
    "Id": "KSM-F56.TA",
    "MayaId": "1146547",
    "Name": "KSM ETF (4A) TA RealEstate IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F56.TA",
    "TaseSymbol": "KSM.F56",
    "YahooId": "KSM-F56.TA",
    "EnglishName": "KSM.TA-REAL IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תא נדלן",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.53,
    "TrusteeFee": 0.03,
    "VariableFee": 0.2,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 14430.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Real estate and construction",
    "AssetValue": null,
    "MonthYield": 9.4,
    "YearYield": 9.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011465478"
  },
  {
    "Id": "KSM-F192.TA",
    "MayaId": "1167261",
    "Name": "KSM ETF (4A) TA Sector Balance IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F192.TA",
    "TaseSymbol": "KSM.F192",
    "YahooId": "KSM-F192.TA",
    "EnglishName": "KSM.TA-SECT IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תא סקט באלנ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.3,
    "TrusteeFee": 0.03,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 44820.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Large & Mid Cap",
    "AssetValue": null,
    "MonthYield": 7.7,
    "YearYield": 7.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011672610"
  },
  {
    "Id": "KSM-F55.TA",
    "MayaId": "1146539",
    "Name": "KSM ETF (4A) TA SME60 IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F55.TA",
    "TaseSymbol": "KSM.F55",
    "YahooId": "KSM-F55.TA",
    "EnglishName": "KSM.TA-SME60 IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תא SME60",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.98,
    "TrusteeFee": 0.03,
    "VariableFee": 0.2,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 10660.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Mid & Small Cap",
    "AssetValue": null,
    "MonthYield": 6.0,
    "YearYield": 6.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011465395"
  },
  {
    "Id": "KSM-F13.TA",
    "MayaId": "1145911",
    "Name": "KSM ETF (4A) Tel Div IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F13.TA",
    "TaseSymbol": "KSM.F13",
    "YahooId": "KSM-F13.TA",
    "EnglishName": "KSM.TEL-DIV IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.תל דיב",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.53,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 46810.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "All Cap",
    "AssetValue": null,
    "MonthYield": 6.2,
    "YearYield": 6.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011459117"
  },
  {
    "Id": "KSM-F14.TA",
    "MayaId": "1145929",
    "Name": "KSM ETF (4D) Bloomberg Brent Crude Future",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F14.TA",
    "TaseSymbol": "KSM.F14",
    "YahooId": "KSM-F14.TA",
    "EnglishName": "KSM.BCOMCO",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.BB OIL",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 1.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1820.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Commodities",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 2.5,
    "YearYield": 2.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011459299"
  },
  {
    "Id": "KSM-F162.TA",
    "MayaId": "1147271",
    "Name": "KSM ETF (4D) Bluestar Israel Global Technology",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F162.TA",
    "TaseSymbol": "KSM.F162",
    "YahooId": "KSM-F162.TA",
    "EnglishName": "KSM.BGTHNTR",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.ישראטקBSTAR",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 16160.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Technology",
    "AssetValue": null,
    "MonthYield": 3.6,
    "YearYield": 3.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011472714"
  },
  {
    "Id": "KSM-F150.TA",
    "MayaId": "1147156",
    "Name": "KSM ETF (4D) Composite US Equity Monthly",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F150.TA",
    "TaseSymbol": "KSM.F150",
    "YahooId": "KSM-F150.TA",
    "EnglishName": "KSM.CPSTKUS",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.משמנארהב",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 35090.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -0.3,
    "YearYield": -0.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011471567"
  },
  {
    "Id": "KSM-F156.TA",
    "MayaId": "1147214",
    "Name": "KSM ETF (4D) Composite US S&P Sector Equity Monthly",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F156.TA",
    "TaseSymbol": "KSM.F156",
    "YahooId": "KSM-F156.TA",
    "EnglishName": "KSM.CPSTKSUS",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.משמנסארהב",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 30880.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -2.0,
    "YearYield": -2.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011472144"
  },
  {
    "Id": "KSM-F191.TA",
    "MayaId": "1162783",
    "Name": "KSM ETF (4D) CSI300",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F191.TA",
    "TaseSymbol": "KSM.F191",
    "YahooId": "KSM-F191.TA",
    "EnglishName": "KSM.CSI300",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.CSI300",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 27460.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Asia and the Pacific - emerging markets",
    "AssetValue": null,
    "MonthYield": 2.2,
    "YearYield": 2.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011627838"
  },
  {
    "Id": "KSM-F53.TA",
    "MayaId": "1146513",
    "Name": "KSM ETF (4D) DAX",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F53.TA",
    "TaseSymbol": "KSM.F53",
    "YahooId": "KSM-F53.TA",
    "EnglishName": "KSM.DAXNR",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.DAX",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.53,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 7865.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Europe - developed markets",
    "AssetValue": null,
    "MonthYield": 0.4,
    "YearYield": 0.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011465130"
  },
  {
    "Id": "KSM-F9.TA",
    "MayaId": "1145879",
    "Name": "KSM ETF (4D) DJ Health Care Titans 30",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F9.TA",
    "TaseSymbol": "KSM.F9",
    "YahooId": "KSM-F9.TA",
    "EnglishName": "KSM.DJTHCAT",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.DJHCARE",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 1.0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3265.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Health Care",
    "AssetValue": null,
    "MonthYield": 0.7,
    "YearYield": 0.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011458796"
  },
  {
    "Id": "KSM-F78.TA",
    "MayaId": "1146448",
    "Name": "KSM ETF (4D) DJ Industrial Average",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F78.TA",
    "TaseSymbol": "KSM.F78",
    "YahooId": "KSM-F78.TA",
    "EnglishName": "KSM.DJINR",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.DJ30",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 16690.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": 0.5,
    "YearYield": 0.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011464489"
  },
  {
    "Id": "KSM-F28.TA",
    "MayaId": "1146067",
    "Name": "KSM ETF (4D) DJ US Dividend",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F28.TA",
    "TaseSymbol": "KSM.F28",
    "YahooId": "KSM-F28.TA",
    "EnglishName": "KSM.DJDVN",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.DJUSDIV",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 1.14,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3539.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": 2.4,
    "YearYield": 2.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011460677"
  },
  {
    "Id": "KSM-F76.TA",
    "MayaId": "1146406",
    "Name": "KSM ETF (4D) EURO STOXX 50",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F76.TA",
    "TaseSymbol": "KSM.F76",
    "YahooId": "KSM-F76.TA",
    "EnglishName": "KSM.SX5T",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.EUSTOX50",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 23740.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Europe - general",
    "AssetValue": null,
    "MonthYield": 0.6,
    "YearYield": 0.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011464067"
  },
  {
    "Id": "KSM-F51.TA",
    "MayaId": "1146497",
    "Name": "KSM ETF (4D) FTSE 100",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F51.TA",
    "TaseSymbol": "KSM.F51",
    "YahooId": "KSM-F51.TA",
    "EnglishName": "KSM.UKXNUK",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.FTSE100",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5026.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Europe - developed markets",
    "AssetValue": null,
    "MonthYield": 1.4,
    "YearYield": 1.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011464976"
  },
  {
    "Id": "KSM-F54.TA",
    "MayaId": "1146521",
    "Name": "KSM ETF (4D) FTSE China 50",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F54.TA",
    "TaseSymbol": "KSM.F54",
    "YahooId": "KSM-F54.TA",
    "EnglishName": "KSM.TXIN0NCH",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.FTSECHN50",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.95,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 7271.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Asia and the Pacific - emerging markets",
    "AssetValue": null,
    "MonthYield": 1.8,
    "YearYield": 1.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011465213"
  },
  {
    "Id": "KSM-F211.TA",
    "MayaId": "1189372",
    "Name": "KSM ETF (4D) Index World Growth",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F211.TA",
    "TaseSymbol": "KSM.F211",
    "YahooId": "KSM-F211.TA",
    "EnglishName": "KSM.IN WOR GROW",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.אינ צמ עולמ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.015,
    "VariableFee": 0.2,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 6963.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -0.1,
    "YearYield": -0.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011893729"
  },
  {
    "Id": "KSM-F210.TA",
    "MayaId": "1189018",
    "Name": "KSM ETF (4D) Index World Value",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F210.TA",
    "TaseSymbol": "KSM.F210",
    "YahooId": "KSM-F210.TA",
    "EnglishName": "KSM.IN WOR VALU",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.אינ ער עולמ",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.015,
    "VariableFee": 0.2,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5881.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 2.1,
    "YearYield": 2.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011890188"
  },
  {
    "Id": "KSM-F199.TA",
    "MayaId": "1170844",
    "Name": "KSM ETF (4D) Indxx China Internet",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F199.TA",
    "TaseSymbol": "KSM.F199",
    "YahooId": "KSM-F199.TA",
    "EnglishName": "KSM.ICNET",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.ICNET",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5336.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Internet",
    "AssetValue": null,
    "MonthYield": 4.3,
    "YearYield": 4.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011708448"
  },
  {
    "Id": "KSM-F194.TA",
    "MayaId": "1167329",
    "Name": "KSM ETF (4D) Indxx Climate Change Solutions",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F194.TA",
    "TaseSymbol": "KSM.F194",
    "YahooId": "KSM-F194.TA",
    "EnglishName": "KSM.ICCHNG",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.ICCHNG",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 21070.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Alternative / Renewable Energy",
    "AssetValue": null,
    "MonthYield": 2.2,
    "YearYield": 2.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011673295"
  },
  {
    "Id": "KSM-F10.TA",
    "MayaId": "1145887",
    "Name": "KSM ETF (4D) ISE Clean Edge Water",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F10.TA",
    "TaseSymbol": "KSM.F10",
    "YahooId": "KSM-F10.TA",
    "EnglishName": "KSM.HHOTR",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.ISEUSWATER",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 25200.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Cleantech",
    "AssetValue": null,
    "MonthYield": 3.6,
    "YearYield": 3.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011458879"
  },
  {
    "Id": "KSM-F195.TA",
    "MayaId": "1168715",
    "Name": "KSM ETF (4D) ISE Cyber Security",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F195.TA",
    "TaseSymbol": "KSM.F195",
    "YahooId": "KSM-F195.TA",
    "EnglishName": "KSM.HXRNTR",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.HXRNTR",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.45,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 24130.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Cyber Security",
    "AssetValue": null,
    "MonthYield": -1.4,
    "YearYield": -1.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011687154"
  },
  {
    "Id": "KSM-F6.TA",
    "MayaId": "1145820",
    "Name": "KSM ETF (4D) LBMA Gold Price PM USD",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F6.TA",
    "TaseSymbol": "KSM.F6",
    "YahooId": "KSM-F6.TA",
    "EnglishName": "KSM.GOLDLNPM",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.LBMAGOLDPM",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 1.48,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 11655.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Commodities",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 6.8,
    "YearYield": 6.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011458200"
  },
  {
    "Id": "KSM-F128.TA",
    "MayaId": "1146372",
    "Name": "KSM ETF (4D) MDAX",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F128.TA",
    "TaseSymbol": "KSM.F128",
    "YahooId": "KSM-F128.TA",
    "EnglishName": "KSM.MDAXNR",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.MDAXGER",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 10620.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Europe - developed markets",
    "AssetValue": null,
    "MonthYield": 3.3,
    "YearYield": 3.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011463721"
  },
  {
    "Id": "KSM-F118.TA",
    "MayaId": "1147032",
    "Name": "KSM ETF (4D) Morningstar Wide Moat Focus",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F118.TA",
    "TaseSymbol": "KSM.F118",
    "YahooId": "KSM-F118.TA",
    "EnglishName": "KSM.MWMFTR",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.WIDEMOATUS",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 51540.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - general",
    "AssetValue": null,
    "MonthYield": 0.7,
    "YearYield": 0.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011470320"
  },
  {
    "Id": "KSM-F69.TA",
    "MayaId": "1145838",
    "Name": "KSM ETF (4D) MSCI AC Far East EX Japan",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F69.TA",
    "TaseSymbol": "KSM.F69",
    "YahooId": "KSM-F69.TA",
    "EnglishName": "KSM.M1FEJ",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.MSCIFEEXJPN",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.95,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2738.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Asia and Pacific - General",
    "AssetValue": null,
    "MonthYield": 7.3,
    "YearYield": 7.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011458382"
  },
  {
    "Id": "KSM-F89.TA",
    "MayaId": "1146679",
    "Name": "KSM ETF (4D) MSCI AC World",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F89.TA",
    "TaseSymbol": "KSM.F89",
    "YahooId": "KSM-F89.TA",
    "EnglishName": "KSM.M1WD",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.MSCIACWORLD",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.95,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1553.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.1,
    "YearYield": 0.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011466799"
  },
  {
    "Id": "KSM-F212.TA",
    "MayaId": "1194067",
    "Name": "KSM ETF (4D) MSCI ACWI Sustainable Development",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F212.TA",
    "TaseSymbol": "KSM.F212",
    "YahooId": "KSM-F212.TA",
    "EnglishName": "KSM.M1CXBLRV",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.M1CXBLRV",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4060.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -0.7,
    "YearYield": -0.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011940678"
  },
  {
    "Id": "KSM-F240.TA",
    "MayaId": "1230473",
    "Name": "KSM ETF (4D) MSCI China",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F240.TA",
    "TaseSymbol": "KSM.F240",
    "YahooId": "KSM-F240.TA",
    "EnglishName": "KSM.NDEUCHF",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.NDEUCHF",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4140.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Asia and the Pacific - emerging markets",
    "AssetValue": null,
    "MonthYield": 3.9,
    "YearYield": 3.9,
    "Last12MonthYield": null,
    "ISIN": "IL0012304734"
  },
  {
    "Id": "KSM-F68.TA",
    "MayaId": "1145812",
    "Name": "KSM ETF (4D) MSCI Emerging Markets",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F68.TA",
    "TaseSymbol": "KSM.F68",
    "YahooId": "KSM-F68.TA",
    "EnglishName": "KSM.M1EF",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.MSCI EM",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 1.14,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4632.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Global - emerging markets",
    "AssetValue": null,
    "MonthYield": 5.2,
    "YearYield": 5.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011458127"
  },
  {
    "Id": "KSM-F67.TA",
    "MayaId": "1145804",
    "Name": "KSM ETF (4D) MSCI World",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F67.TA",
    "TaseSymbol": "KSM.F67",
    "YahooId": "KSM-F67.TA",
    "EnglishName": "KSM.M1WO",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.MSCIWORLD",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.83,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 13590.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Global - developed markets",
    "AssetValue": null,
    "MonthYield": -0.4,
    "YearYield": -0.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011458044"
  },
  {
    "Id": "KSM-F203.TA",
    "MayaId": "1174119",
    "Name": "KSM ETF (4D) MVIS US Listed Semiconductor 25",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F203.TA",
    "TaseSymbol": "KSM.F203",
    "YahooId": "KSM-F203.TA",
    "EnglishName": "KSM.MVSMHTR",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.MVSMHTR",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.45,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 49270.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Semiconductor",
    "AssetValue": null,
    "MonthYield": 7.3,
    "YearYield": 7.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011741191"
  },
  {
    "Id": "KSM-F52.TA",
    "MayaId": "1146505",
    "Name": "KSM ETF (4D) NASDAQ 100",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F52.TA",
    "TaseSymbol": "KSM.F52",
    "YahooId": "KSM-F52.TA",
    "EnglishName": "KSM.XNDXNNR",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.NDX100",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 76140.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": -1.8,
    "YearYield": -1.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011465056"
  },
  {
    "Id": "KSM-F123.TA",
    "MayaId": "1146224",
    "Name": "KSM ETF (4D) NASDAQ US BuyBack Achievers",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F123.TA",
    "TaseSymbol": "KSM.F123",
    "YahooId": "KSM-F123.TA",
    "EnglishName": "KSM.DRBN",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.NDXUSBBACK",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.78,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 82130.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": -0.3,
    "YearYield": -0.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011462244"
  },
  {
    "Id": "KSM-F60.TA",
    "MayaId": "1145713",
    "Name": "KSM ETF (4D) Russell 2000",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F60.TA",
    "TaseSymbol": "KSM.F60",
    "YahooId": "KSM-F60.TA",
    "EnglishName": "KSM.RU20N30U",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.RUSS2000",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.47,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 8317.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": 5.0,
    "YearYield": 5.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011457137"
  },
  {
    "Id": "KSM-F80.TA",
    "MayaId": "1146471",
    "Name": "KSM ETF (4D) S&P 500",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F80.TA",
    "TaseSymbol": "KSM.F80",
    "YahooId": "KSM-F80.TA",
    "EnglishName": "KSM.SPTR500N",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.SP500",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 23860.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": -1.3,
    "YearYield": -1.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011464711"
  },
  {
    "Id": "KSM-F237.TA",
    "MayaId": "1203835",
    "Name": "KSM ETF (4D) S&P 500 Equal Weight",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F237.TA",
    "TaseSymbol": "KSM.F237",
    "YahooId": "KSM-F237.TA",
    "EnglishName": "KSM.SPXEWNTR",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.SPXEWNTR",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4334.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": 2.0,
    "YearYield": 2.0,
    "Last12MonthYield": null,
    "ISIN": "IL0012038357"
  },
  {
    "Id": "KSM-F142.TA",
    "MayaId": "1147065",
    "Name": "KSM ETF (4D) S&P 500 Low Volatility High Dividend",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F142.TA",
    "TaseSymbol": "KSM.F142",
    "YahooId": "KSM-F142.TA",
    "EnglishName": "KSM.SP5LVHDN",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.SP500LVHD",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.98,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 31000.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": 1.2,
    "YearYield": 1.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011470650"
  },
  {
    "Id": "KSM-F233.TA",
    "MayaId": "1202183",
    "Name": "KSM ETF (4D) S&P 500 TOP 50",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F233.TA",
    "TaseSymbol": "KSM.F233",
    "YahooId": "KSM-F233.TA",
    "EnglishName": "KSM.SP5T5N",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.SP5T5N",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5312.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": -2.1,
    "YearYield": -2.1,
    "Last12MonthYield": null,
    "ISIN": "IL0012021833"
  },
  {
    "Id": "KSM-F134.TA",
    "MayaId": "1146794",
    "Name": "KSM ETF (4D) S&P Consumer Discretionary",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F134.TA",
    "TaseSymbol": "KSM.F134",
    "YahooId": "KSM-F134.TA",
    "EnglishName": "KSM.IXYNTR",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.SPצריכהמחז",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.76,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 75260.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Consumer Discretionary",
    "AssetValue": null,
    "MonthYield": 0.0,
    "YearYield": 0.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011467946"
  },
  {
    "Id": "KSM-F236.TA",
    "MayaId": "1193820",
    "Name": "KSM ETF (4D) S&P Consumer Staples",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F236.TA",
    "TaseSymbol": "KSM.F236",
    "YahooId": "KSM-F236.TA",
    "EnglishName": "KSM.SP IXR",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.SP IXR",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3060.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Consumer Staples",
    "AssetValue": null,
    "MonthYield": 3.9,
    "YearYield": 3.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011938201"
  },
  {
    "Id": "KSM-F12.TA",
    "MayaId": "1145903",
    "Name": "KSM ETF (4D) S&P Energy",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F12.TA",
    "TaseSymbol": "KSM.F12",
    "YahooId": "KSM-F12.TA",
    "EnglishName": "KSM.IXENTR",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.SPENERGY",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.28,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3508.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Energy",
    "AssetValue": null,
    "MonthYield": 5.7,
    "YearYield": 5.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011459034"
  },
  {
    "Id": "KSM-F132.TA",
    "MayaId": "1146786",
    "Name": "KSM ETF (4D) S&P Financial",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F132.TA",
    "TaseSymbol": "KSM.F132",
    "YahooId": "KSM-F132.TA",
    "EnglishName": "KSM.IXMNTR",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.SPFINANCE",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 21670.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Financial",
    "AssetValue": null,
    "MonthYield": -2.9,
    "YearYield": -2.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011467862"
  },
  {
    "Id": "KSM-F152.TA",
    "MayaId": "1147172",
    "Name": "KSM ETF (4D) S&P Health Care",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F152.TA",
    "TaseSymbol": "KSM.F152",
    "YahooId": "KSM-F152.TA",
    "EnglishName": "KSM.IXVNTR",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסםSPHEALTHCARE",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5282.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Health Care",
    "AssetValue": null,
    "MonthYield": -0.9,
    "YearYield": -0.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011471724"
  },
  {
    "Id": "KSM-F109.TA",
    "MayaId": "1146943",
    "Name": "KSM ETF (4D) S&P Homebuilders",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F109.TA",
    "TaseSymbol": "KSM.F109",
    "YahooId": "KSM-F109.TA",
    "EnglishName": "KSM.SPSIHON",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.SPHOMEBUILD",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 35000.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "REIT &  Real Estate",
    "AssetValue": null,
    "MonthYield": 8.4,
    "YearYield": 8.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011469439"
  },
  {
    "Id": "KSM-F133.TA",
    "MayaId": "1147529",
    "Name": "KSM ETF (4D) S&P Industrial",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F133.TA",
    "TaseSymbol": "KSM.F133",
    "YahooId": "KSM-F133.TA",
    "EnglishName": "KSM.IXINTR",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.SPINDUST",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 52400.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Industrials",
    "AssetValue": null,
    "MonthYield": 1.5,
    "YearYield": 1.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011475295"
  },
  {
    "Id": "KSM-F5.TA",
    "MayaId": "1150796",
    "Name": "KSM ETF (4D) S&P MidCap 400",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F5.TA",
    "TaseSymbol": "KSM.F5",
    "YahooId": "KSM-F5.TA",
    "EnglishName": "KSM.SP400NTR",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.SPMIDCAP400",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 17330.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": 1.8,
    "YearYield": 1.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011507964"
  },
  {
    "Id": "KSM-F158.TA",
    "MayaId": "1147230",
    "Name": "KSM ETF (4D) S&P Technology",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F158.TA",
    "TaseSymbol": "KSM.F158",
    "YahooId": "KSM-F158.TA",
    "EnglishName": "KSM.IXTNTR",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.SPTECH",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.64,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 9465.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Technology",
    "AssetValue": null,
    "MonthYield": -1.8,
    "YearYield": -1.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011472300"
  },
  {
    "Id": "KSM-F122.TA",
    "MayaId": "1146208",
    "Name": "KSM ETF (4D) STOXX Europe 600",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F122.TA",
    "TaseSymbol": "KSM.F122",
    "YahooId": "KSM-F122.TA",
    "EnglishName": "KSM.SXXR",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.STOX600",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.73,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 53110.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Europe - general",
    "AssetValue": null,
    "MonthYield": 1.1,
    "YearYield": 1.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011462087"
  },
  {
    "Id": "KSM-F130.TA",
    "MayaId": "1146596",
    "Name": "KSM ETF (4D) STOXX Europe 600 Health Care",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F130.TA",
    "TaseSymbol": "KSM.F130",
    "YahooId": "KSM-F130.TA",
    "EnglishName": "KSM.SXDR",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.STOX600HLTH",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 46910.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Health Care",
    "AssetValue": null,
    "MonthYield": 2.7,
    "YearYield": 2.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011465965"
  },
  {
    "Id": "KSM-F22.TA",
    "MayaId": "1146000",
    "Name": "KSM ETF (4D) STOXX Europe MID 200",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F22.TA",
    "TaseSymbol": "KSM.F22",
    "YahooId": "KSM-F22.TA",
    "EnglishName": "KSM.MCXR",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.STOXMID200",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.9,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2414.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Europe - general",
    "AssetValue": null,
    "MonthYield": 0.8,
    "YearYield": 0.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011460008"
  },
  {
    "Id": "KSM-F135.TA",
    "MayaId": "1146802",
    "Name": "KSM ETF (4D) Swiss Market",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F135.TA",
    "TaseSymbol": "KSM.F135",
    "YahooId": "KSM-F135.TA",
    "EnglishName": "KSM.SMIC",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.SWISS SMI",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 57540.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Europe - developed markets",
    "AssetValue": null,
    "MonthYield": 0.4,
    "YearYield": 0.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011468027"
  },
  {
    "Id": "KSM-F64.TA",
    "MayaId": "1145754",
    "Name": "KSM ETF (4D)(!) KOSPI 200",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F64.TA",
    "TaseSymbol": "KSM.F64",
    "YahooId": "KSM-F64.TA",
    "EnglishName": "KSM.KOSPI2T",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.KOSPI 200",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 14540.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Asia and Pacific - developed markets",
    "AssetValue": null,
    "MonthYield": 11.8,
    "YearYield": 11.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011457541"
  },
  {
    "Id": "KSM-F63.TA",
    "MayaId": "1145747",
    "Name": "KSM ETF (4D)(!) MSCI India",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F63.TA",
    "TaseSymbol": "KSM.F63",
    "YahooId": "KSM-F63.TA",
    "EnglishName": "KSM.NDELSIA",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.MSCI INDIA",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 1.0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 8311.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Asia and the Pacific - emerging markets",
    "AssetValue": null,
    "MonthYield": -4.1,
    "YearYield": -4.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011457475"
  },
  {
    "Id": "KSM-F181.TA",
    "MayaId": "1157957",
    "Name": "KSM ETF (4D)(!) NIFTY 50",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F181.TA",
    "TaseSymbol": "KSM.F181",
    "YahooId": "KSM-F181.TA",
    "EnglishName": "KSM.NIFTY50",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.NIFTY50",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 11640.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Asia and the Pacific - emerging markets",
    "AssetValue": null,
    "MonthYield": -4.0,
    "YearYield": -4.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011579575"
  },
  {
    "Id": "KSM-F188.TA",
    "MayaId": "1161884",
    "Name": "KSM ETF (60) Short TA 125 (4263.6) IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F188.TA",
    "TaseSymbol": "KSM.F188",
    "YahooId": "KSM-F188.TA",
    "EnglishName": "KSM.SHTA-125IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.חסתא125",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3775.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Leveraged",
    "SecondaryClassification": "Stocks in Israel",
    "AssetValue": null,
    "MonthYield": -18.6,
    "YearYield": -18.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011618845"
  },
  {
    "Id": "KSM-F186.TA",
    "MayaId": "1161058",
    "Name": "KSM ETF (60) Short TA 90 (6123.68) IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F186.TA",
    "TaseSymbol": "KSM.F186",
    "YahooId": "KSM-F186.TA",
    "EnglishName": "KSM.SHTA-90IL 2",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.חסתא 90 2",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2188.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Leveraged",
    "SecondaryClassification": "Stocks in Israel",
    "AssetValue": null,
    "MonthYield": -7.2,
    "YearYield": -7.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011610586"
  },
  {
    "Id": "KSM-F46.TA",
    "MayaId": "1146380",
    "Name": "KSM ETF (6A) Leveraged TA 35 x3 Monthly IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F46.TA",
    "TaseSymbol": "KSM.F46",
    "YahooId": "KSM-F46.TA",
    "EnglishName": "KSM.LVTA-35X3IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.ממתא 35פי3",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 2.75,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5098.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Leveraged",
    "SecondaryClassification": "Stocks in Israel",
    "AssetValue": null,
    "MonthYield": 28.7,
    "YearYield": 28.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011463804"
  },
  {
    "Id": "KSM-F27.TA",
    "MayaId": "1146059",
    "Name": "KSM ETF (6A) Short Leveraged TA 35 x2 Monthly IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F27.TA",
    "TaseSymbol": "KSM.F27",
    "YahooId": "KSM-F27.TA",
    "EnglishName": "KSM.LSTA-35X2IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.מחתא 35פי2",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 2.75,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 571.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Leveraged",
    "SecondaryClassification": "Stocks in Israel",
    "AssetValue": null,
    "MonthYield": -14.6,
    "YearYield": -14.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011460594"
  },
  {
    "Id": "KSM-F96.TA",
    "MayaId": "1146745",
    "Name": "KSM ETF (6A) Short TA 35 (5,337.49) IL",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F96.TA",
    "TaseSymbol": "KSM.F96",
    "YahooId": "KSM-F96.TA",
    "EnglishName": "KSM.SHTA-35 IL",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.חסתא 35",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1939.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Leveraged",
    "SecondaryClassification": "Stocks in Israel",
    "AssetValue": null,
    "MonthYield": -10.3,
    "YearYield": -10.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011467458"
  },
  {
    "Id": "KSM-F113.TA",
    "MayaId": "1146984",
    "Name": "KSM ETF (6D) Leveraged DAX x3 Monthly",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F113.TA",
    "TaseSymbol": "KSM.F113",
    "YahooId": "KSM-F113.TA",
    "EnglishName": "KSM.LVDAXNR3",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.ממDAXפי3",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 2.75,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 9540.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "UBANK",
    "MainClassification": "Leveraged",
    "SecondaryClassification": "Stocks Abroad",
    "AssetValue": null,
    "MonthYield": 4.0,
    "YearYield": 4.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011469843"
  },
  {
    "Id": "KSM-F112.TA",
    "MayaId": "1146976",
    "Name": "KSM ETF (6D) Leveraged NASDAQ 100 x3 Monthly",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F112.TA",
    "TaseSymbol": "KSM.F112",
    "YahooId": "KSM-F112.TA",
    "EnglishName": "KSM.LVXNDXNNR3",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.ממNDX100פי3",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 2.75,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 27080.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "UBANK",
    "MainClassification": "Leveraged",
    "SecondaryClassification": "Stocks Abroad",
    "AssetValue": null,
    "MonthYield": -3.5,
    "YearYield": -3.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011469769"
  },
  {
    "Id": "KSM-F111.TA",
    "MayaId": "1146968",
    "Name": "KSM ETF (6D) Leveraged S&P 500 x3 Monthly",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F111.TA",
    "TaseSymbol": "KSM.F111",
    "YahooId": "KSM-F111.TA",
    "EnglishName": "KSM.LVSPTR500N3",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.ממSP500פי3",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 2.75,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 65630.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "UBANK",
    "MainClassification": "Leveraged",
    "SecondaryClassification": "Stocks Abroad",
    "AssetValue": null,
    "MonthYield": -2.4,
    "YearYield": -2.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011469686"
  },
  {
    "Id": "KSM-F116.TA",
    "MayaId": "1147016",
    "Name": "KSM ETF (6D) Short Leveraged DAX x2 Monthly",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F116.TA",
    "TaseSymbol": "KSM.F116",
    "YahooId": "KSM-F116.TA",
    "EnglishName": "KSM.LSDAXNR2",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.מחDAXפי2",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 2.75,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5317.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "UBANK",
    "MainClassification": "Leveraged",
    "SecondaryClassification": "Stocks Abroad",
    "AssetValue": null,
    "MonthYield": -5.5,
    "YearYield": -5.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011470163"
  },
  {
    "Id": "KSM-F209.TA",
    "MayaId": "1189802",
    "Name": "KSM ETF (6D) Short Leveraged Future Bloomberg Brent Crude x2 Monthly",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F209.TA",
    "TaseSymbol": "KSM.F209",
    "YahooId": "KSM-F209.TA",
    "EnglishName": "KSM.LSBCOMCOT2",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.מחBBOILפי2",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 1.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3295.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "KSM",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Leveraged",
    "SecondaryClassification": "Commerce",
    "AssetValue": null,
    "MonthYield": -6.0,
    "YearYield": -6.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011898025"
  },
  {
    "Id": "KSM-F115.TA",
    "MayaId": "1147008",
    "Name": "KSM ETF (6D) Short Leveraged NASDAQ 100 x2 Monthly",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F115.TA",
    "TaseSymbol": "KSM.F115",
    "YahooId": "KSM-F115.TA",
    "EnglishName": "KSM.LSXNDXNNR2",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.מחNDX100פי2",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 2.75,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 371.8,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "UBANK",
    "MainClassification": "Leveraged",
    "SecondaryClassification": "Stocks Abroad",
    "AssetValue": null,
    "MonthYield": 1.6,
    "YearYield": 1.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011470080"
  },
  {
    "Id": "KSM-F114.TA",
    "MayaId": "1146992",
    "Name": "KSM ETF (6D) Short Leveraged S&P 500 x2 Monthly",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F114.TA",
    "TaseSymbol": "KSM.F114",
    "YahooId": "KSM-F114.TA",
    "EnglishName": "KSM.LSSPTR500N2",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.מחSP500פי2",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 2.75,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3406.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "UBANK",
    "MainClassification": "Leveraged",
    "SecondaryClassification": "Stocks Abroad",
    "AssetValue": null,
    "MonthYield": 0.7,
    "YearYield": 0.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011469926"
  },
  {
    "Id": "KSM-F31.TA",
    "MayaId": "1146091",
    "Name": "KSM ETF(!)(4D) IBOVESPA",
    "ShortName": "KSM MUTUAL FUNDS LTD",
    "Symbol": "KSM-F31.TA",
    "TaseSymbol": "KSM.F31",
    "YahooId": "KSM-F31.TA",
    "EnglishName": "KSM.IBOV",
    "EnglishLongName": "KSM MUTUAL FUNDS LTD",
    "HebrewName": "קסם.IBOVESPA",
    "HebrewLongName": "קסם קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 1.0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 8065.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "KSM",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - emerging markets",
    "AssetValue": null,
    "MonthYield": 3.7,
    "YearYield": 3.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011460917"
  },
  {
    "Id": "TASE:5118179",
    "MayaId": "5118179",
    "Name": "KSM IBOXIG30",
    "ShortName": "KSM IBOXIG30",
    "Symbol": "TASE:5118179",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (0D) iBoxx US Liquid Investment Grade Top 30",
    "EnglishLongName": "KSM KTF (0D) iBoxx US Liquid Investment Grade Top 30",
    "HebrewName": "קסם iBox $ IG30 KTF",
    "HebrewLongName": "קסם iBoxx US Liquid Investment Grade Top 30 (0D) KTF",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.17,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Hedged Corporate and Convertibles",
    "AssetValue": 121.1,
    "MonthYield": -1.28,
    "YearYield": -1.28,
    "Last12MonthYield": -6.41,
    "ISIN": "IL0051181795"
  },
  {
    "Id": "TASE:5130869",
    "MayaId": "5130869",
    "Name": "KSM IND CLM CNG",
    "ShortName": "KSM IND CLM CNG",
    "Symbol": "TASE:5130869",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4D) Indxx Climate Change Solutions",
    "EnglishLongName": "KSM KTF (4D) Indxx Climate Change Solutions",
    "HebrewName": "קסם ICCHNG KTF",
    "HebrewLongName": "קסם Indxx Climate Change Solutions (4D) KTF",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.69,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 15.1,
    "MonthYield": 1.6,
    "YearYield": 1.6,
    "Last12MonthYield": 17.31,
    "ISIN": "IL0051308695"
  },
  {
    "Id": "TASE:5133699",
    "MayaId": "5133699",
    "Name": "KSM KTF Agriculture BB",
    "ShortName": "KSM KTF Agriculture BB",
    "Symbol": "TASE:5133699",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4D) Bloomberg Agriculture",
    "EnglishLongName": "KSM KTF (4D) Bloomberg Agriculture",
    "HebrewName": "קסם BB Agriculture KTF",
    "HebrewLongName": "קסם KTFי (4D)י Bloomberg Agriculture",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.19,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Commodities",
    "SecondaryClassification": "Commodities Index",
    "AssetValue": 9.8,
    "MonthYield": -1.71,
    "YearYield": -1.71,
    "Last12MonthYield": -16.86,
    "ISIN": "IL0051336993"
  },
  {
    "Id": "TASE:5121025",
    "MayaId": "5121025",
    "Name": "KSM KTF ALLBO FS IL",
    "ShortName": "KSM KTF ALLBO FS IL",
    "Symbol": "TASE:5121025",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00) All-Bond Floating Shekel IL",
    "EnglishLongName": "KSM KTF (00) All-Bond Floating Shekel IL",
    "HebrewName": "קסם All Bond KTF ר.משת שק",
    "HebrewLongName": "קסם KTFי (00) All-Bond -ריבית משתנה שקלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.35,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.04,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "",
    "AssetValue": 20.6,
    "MonthYield": 0.16,
    "YearYield": 0.16,
    "Last12MonthYield": 4.93,
    "ISIN": "IL0051210255"
  },
  {
    "Id": "TASE:5139894",
    "MayaId": "5139894",
    "Name": "KSM KTF BDLRTNTR",
    "ShortName": "KSM KTF BDLRTNTR",
    "Symbol": "TASE:5139894",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4D) BlueStar Data Center and Logistics Real Estate",
    "EnglishLongName": "KSM KTF (4D) BlueStar Data Center and Logistics Real Estate",
    "HebrewName": "קסם BDLRTNTR KTF",
    "HebrewLongName": "קסם KTF י(4D)י BlueStar Data Center and Logistics Real Estate",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.2,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 5.8,
    "MonthYield": 5.42,
    "YearYield": 5.42,
    "Last12MonthYield": null,
    "ISIN": "IL0051398944"
  },
  {
    "Id": "TASE:5132261",
    "MayaId": "5132261",
    "Name": "KSM KTF BECOMNTR CH",
    "ShortName": "KSM KTF BECOMNTR CH",
    "Symbol": "TASE:5132261",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) BlueStar E-Commerce US Leaders Currency Hedged",
    "EnglishLongName": "KSM KTF (4A) BlueStar E-Commerce US Leaders Currency Hedged",
    "HebrewName": "קסם BECOMNTR KTF ממ",
    "HebrewLongName": "קסם KTF י(4A)י BlueStar E-Commerce US Leaders מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.91,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 4.4,
    "MonthYield": -1.82,
    "YearYield": -1.82,
    "Last12MonthYield": -6.61,
    "ISIN": "IL0051322613"
  },
  {
    "Id": "TASE:5139878",
    "MayaId": "5139878",
    "Name": "KSM KTF BRRNY",
    "ShortName": "KSM KTF BRRNY",
    "Symbol": "TASE:5139878",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4D) CME CF Bitcoin Reference Rate (BRRNY)",
    "EnglishLongName": "KSM KTF (4D) CME CF Bitcoin Reference Rate (BRRNY)",
    "HebrewName": "קסם BRRNY KTF",
    "HebrewLongName": "קסם KTF י(4D)י CME CF Bitcoin Reference Rate (BRRNY)",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 4.49,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Digital Assets",
    "SecondaryClassification": "Bitcoin",
    "AssetValue": 30.0,
    "MonthYield": 7.26,
    "YearYield": 7.26,
    "Last12MonthYield": -13.18,
    "ISIN": "IL0051398787"
  },
  {
    "Id": "TASE:5141403",
    "MayaId": "5141403",
    "Name": "KSM KTF BRRNY CH",
    "ShortName": "KSM KTF BRRNY CH",
    "Symbol": "TASE:5141403",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) CME CF Bitcoin Reference Rate BRRNY) Currency Hedged)",
    "EnglishLongName": "KSM KTF (4A) CME CF Bitcoin Reference Rate BRRNY) Currency Hedged)",
    "HebrewName": "קסם BRRNY KTF ממ",
    "HebrewLongName": "קסם KTF י(4A)י CME CF Bitcoin Reference Rate (BRRNY) מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Digital Assets",
    "SecondaryClassification": "Bitcoin",
    "AssetValue": 4.1,
    "MonthYield": 8.75,
    "YearYield": 8.75,
    "Last12MonthYield": null,
    "ISIN": "IL0051414030"
  },
  {
    "Id": "TASE:5136114",
    "MayaId": "5136114",
    "Name": "KSM KTF Bullet 26 IL",
    "ShortName": "KSM KTF Bullet 26 IL",
    "Symbol": "TASE:5136114",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00) Index Bullet Israel 2026 IL",
    "EnglishLongName": "KSM KTF (00) Index Bullet Israel 2026 IL",
    "HebrewName": "קסם Bullet KTF ישראל 2026",
    "HebrewLongName": "קסם KTF י(00) אינדקס Bullet ישראל 2026",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.14,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 244.1,
    "MonthYield": 0.25,
    "YearYield": 0.25,
    "Last12MonthYield": 4.86,
    "ISIN": "IL0051361140"
  },
  {
    "Id": "TASE:5136882",
    "MayaId": "5136882",
    "Name": "KSM KTF Bullet 27 IL",
    "ShortName": "KSM KTF Bullet 27 IL",
    "Symbol": "TASE:5136882",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00)(!) Index Bullet Israel 2027 IL",
    "EnglishLongName": "KSM KTF (00)(!) Index Bullet Israel 2027 IL",
    "HebrewName": "קסם Bullet KTF ישראל 2027",
    "HebrewLongName": "קסם KTFי(00)(!) אינדקס Bullet ישראל 2027",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.18,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 369.8,
    "MonthYield": 0.25,
    "YearYield": 0.25,
    "Last12MonthYield": 5.37,
    "ISIN": "IL0051368822"
  },
  {
    "Id": "TASE:5138102",
    "MayaId": "5138102",
    "Name": "KSM KTF Bullet 28 IL",
    "ShortName": "KSM KTF Bullet 28 IL",
    "Symbol": "TASE:5138102",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00)(!) Index Bullet Israel 2028 IL",
    "EnglishLongName": "KSM KTF (00)(!) Index Bullet Israel 2028 IL",
    "HebrewName": "קסם Bullet KTF ישראל 2028",
    "HebrewLongName": "קסם KTFי(00)(!) אינדקס Bullet ישראל 2028",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.18,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 123.7,
    "MonthYield": 0.33,
    "YearYield": 0.33,
    "Last12MonthYield": 5.74,
    "ISIN": "IL0051381023"
  },
  {
    "Id": "TASE:5138110",
    "MayaId": "5138110",
    "Name": "KSM KTF Bullet 29 IL",
    "ShortName": "KSM KTF Bullet 29 IL",
    "Symbol": "TASE:5138110",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00)(!) Index Bullet Israel 2029 IL",
    "EnglishLongName": "KSM KTF (00)(!) Index Bullet Israel 2029 IL",
    "HebrewName": "קסם Bullet KTF ישראל 2029",
    "HebrewLongName": "קסם KTFי(00)(!) אינדקס Bullet ישראל 2029",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.22,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 111.9,
    "MonthYield": 0.45,
    "YearYield": 0.45,
    "Last12MonthYield": 6.57,
    "ISIN": "IL0051381106"
  },
  {
    "Id": "TASE:5138128",
    "MayaId": "5138128",
    "Name": "KSM KTF Bullet 30 IL",
    "ShortName": "KSM KTF Bullet 30 IL",
    "Symbol": "TASE:5138128",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00)(!) Index Bullet Israel 2030 IL",
    "EnglishLongName": "KSM KTF (00)(!) Index Bullet Israel 2030 IL",
    "HebrewName": "קסם Bullet KTF ישראל 2030",
    "HebrewLongName": "קסם KTFי(00)(!) אינדקס Bullet ישראל 2030",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.23,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 97.4,
    "MonthYield": 0.55,
    "YearYield": 0.55,
    "Last12MonthYield": 6.56,
    "ISIN": "IL0051381288"
  },
  {
    "Id": "TASE:5138557",
    "MayaId": "5138557",
    "Name": "KSM KTF Bullet CPI2026 IL",
    "ShortName": "KSM KTF Bullet CPI2026 IL",
    "Symbol": "TASE:5138557",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00) Index Bullet CPI Linked 2026 IL",
    "EnglishLongName": "KSM KTF (00) Index Bullet CPI Linked 2026 IL",
    "HebrewName": "קסם Bullet KTF צמוד 2026",
    "HebrewLongName": "קסם KTFי (00) אינדקס Bullet צמוד 2026",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.15,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 36.6,
    "MonthYield": 0.16,
    "YearYield": 0.16,
    "Last12MonthYield": 4.53,
    "ISIN": "IL0051385578"
  },
  {
    "Id": "TASE:5138581",
    "MayaId": "5138581",
    "Name": "KSM KTF Bullet CPI2027 IL",
    "ShortName": "KSM KTF Bullet CPI2027 IL",
    "Symbol": "TASE:5138581",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00)(!) Index Bullet CPI Linked 2027 IL",
    "EnglishLongName": "KSM KTF (00)(!) Index Bullet CPI Linked 2027 IL",
    "HebrewName": "קסם Bullet KTF צמוד 2027",
    "HebrewLongName": "קסם KTFי (00)(!) אינדקס Bullet צמוד 2027",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.2,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 222.1,
    "MonthYield": 0.06,
    "YearYield": 0.06,
    "Last12MonthYield": 4.74,
    "ISIN": "IL0051385818"
  },
  {
    "Id": "TASE:5138599",
    "MayaId": "5138599",
    "Name": "KSM KTF Bullet CPI2029 IL",
    "ShortName": "KSM KTF Bullet CPI2029 IL",
    "Symbol": "TASE:5138599",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00)(!) Index Bullet CPI Linked 2029 IL",
    "EnglishLongName": "KSM KTF (00)(!) Index Bullet CPI Linked 2029 IL",
    "HebrewName": "קסם Bullet KTF צמוד 2029",
    "HebrewLongName": "קסם KTFי (00)(!) אינדקס Bullet צמוד 2029",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.23,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 108.2,
    "MonthYield": 0.16,
    "YearYield": 0.16,
    "Last12MonthYield": 5.62,
    "ISIN": "IL0051385990"
  },
  {
    "Id": "TASE:5135611",
    "MayaId": "5135611",
    "Name": "KSM KTF BURRTNTR CH",
    "ShortName": "KSM KTF BURRTNTR CH",
    "Symbol": "TASE:5135611",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) BlueStar Top-10 US Residential Real Estate Currency Hedged",
    "EnglishLongName": "KSM KTF (4A) BlueStar Top-10 US Residential Real Estate Currency Hedged",
    "HebrewName": "קסם BURRTNTR KTF ממ",
    "HebrewLongName": "קסם KTF י(4A)י BlueStar נדל\"ן למגורים ארה\"ב - Top 10 מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 3.3,
    "MonthYield": 5.53,
    "YearYield": 5.53,
    "Last12MonthYield": -4.71,
    "ISIN": "IL0051356116"
  },
  {
    "Id": "TASE:5135272",
    "MayaId": "5135272",
    "Name": "KSM KTF Comp Eq MidCap H",
    "ShortName": "KSM KTF Comp Eq MidCap H",
    "Symbol": "TASE:5135272",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) Comp. Foreign Developed Equity MidCap Monthly Currency-Hedged",
    "EnglishLongName": "KSM KTF (4A) Comp. Foreign Developed Equity MidCap Monthly Currency-Hedged",
    "HebrewName": "קסם KTFמש מניות MidCap ממ",
    "HebrewLongName": "קסם KTFי (4A) משולבת מניות חו\"ל מפותחות MidCap חודשי מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.29,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks Abroad, Composite",
    "AssetValue": 17.9,
    "MonthYield": 4.51,
    "YearYield": 4.51,
    "Last12MonthYield": 15.75,
    "ISIN": "IL0051352727"
  },
  {
    "Id": "TASE:5131826",
    "MayaId": "5131826",
    "Name": "KSM KTF Comp SP US Cons",
    "ShortName": "KSM KTF Comp SP US Cons",
    "Symbol": "TASE:5131826",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4D) Comp.S&P US Consumer Discretionary (50%) Staples (50%) Monthly",
    "EnglishLongName": "KSM KTF (4D) Comp.S&P US Consumer Discretionary (50%) Staples (50%) Monthly",
    "HebrewName": "קסם KTF מש SP ארהב צריכה",
    "HebrewLongName": "קסם KTFי (4D) משולבת S&P ארה\"ב צריכה מחזורית (50%) בסיסית (50%) חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.75,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks Abroad, Composite",
    "AssetValue": 12.1,
    "MonthYield": 2.99,
    "YearYield": 2.99,
    "Last12MonthYield": -6.97,
    "ISIN": "IL0051318264"
  },
  {
    "Id": "TASE:5131818",
    "MayaId": "5131818",
    "Name": "KSM KTF Comp SP US Cons H",
    "ShortName": "KSM KTF Comp SP US Cons H",
    "Symbol": "TASE:5131818",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) Comp.S&P US Discretionary (50%) Staples(50%) MonthlyCurrency-Hedged",
    "EnglishLongName": "KSM KTF (4A) Comp.S&P US Discretionary (50%) Staples(50%) MonthlyCurrency-Hedged",
    "HebrewName": "קסםKTFמש SP צריכה ארהב ממ",
    "HebrewLongName": "קסם KTFי (4A) משולבת S&P ארהב צריכה מחזורית (50%) בסיסית (50%) חודשי מנוטרלת מטח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.41,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks Abroad, Composite",
    "AssetValue": 14.7,
    "MonthYield": 4.32,
    "YearYield": 4.32,
    "Last12MonthYield": 6.04,
    "ISIN": "IL0051318181"
  },
  {
    "Id": "TASE:5131842",
    "MayaId": "5131842",
    "Name": "KSM KTF Comp SP US Fin H",
    "ShortName": "KSM KTF Comp SP US Fin H",
    "Symbol": "TASE:5131842",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) Comp.S&P US Finance (70%) Region Bank (30%) Monthly Currency-Hedged",
    "EnglishLongName": "KSM KTF (4A) Comp.S&P US Finance (70%) Region Bank (30%) Monthly Currency-Hedged",
    "HebrewName": "קסםKTFמש SP ארהב פיננס ממ",
    "HebrewLongName": "קסם 4A) KTF) משולבת S&P ארהב פיננסים (70%) בנקים אזוריים (30%) חודשי מנוטרלת מטח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.87,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks Abroad, Composite",
    "AssetValue": 27.7,
    "MonthYield": 0.99,
    "YearYield": 0.99,
    "Last12MonthYield": 11.24,
    "ISIN": "IL0051318421"
  },
  {
    "Id": "TASE:5132089",
    "MayaId": "5132089",
    "Name": "KSM KTF Comp SP US Sector",
    "ShortName": "KSM KTF Comp SP US Sector",
    "Symbol": "TASE:5132089",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4D) Composite S&P US Select Sector Monthly",
    "EnglishLongName": "KSM KTF (4D) Composite S&P US Select Sector Monthly",
    "HebrewName": "קסם KTFמש SP סקטורים ארהב",
    "HebrewLongName": "קסם KTFי (4D) משולבת S&P סקטורים ארה\"ב חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks Abroad, Composite",
    "AssetValue": 85.5,
    "MonthYield": -0.85,
    "YearYield": -0.85,
    "Last12MonthYield": 1.73,
    "ISIN": "IL0051320898"
  },
  {
    "Id": "TASE:5132394",
    "MayaId": "5132394",
    "Name": "KSM KTF CSI300",
    "ShortName": "KSM KTF CSI300",
    "Symbol": "TASE:5132394",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF(4D) CSI300",
    "EnglishLongName": "KSM KTF(4D) CSI300",
    "HebrewName": "קסם CSI300 KTF",
    "HebrewLongName": "קסם CSI300 (4D) KTF",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.64,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 8.7,
    "MonthYield": 0.93,
    "YearYield": 0.93,
    "Last12MonthYield": 16.01,
    "ISIN": "IL0051323942"
  },
  {
    "Id": "TASE:5127543",
    "MayaId": "5127543",
    "Name": "KSM KTF DAXNR",
    "ShortName": "KSM KTF DAXNR",
    "Symbol": "TASE:5127543",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4D) DAX",
    "EnglishLongName": "KSM KTF (4D) DAX",
    "HebrewName": "קסם DAX KTF",
    "HebrewLongName": "קסם DAX (4D) KTF",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.025,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.49,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 29.8,
    "MonthYield": 0.4,
    "YearYield": 0.4,
    "Last12MonthYield": 20.74,
    "ISIN": "IL0051275431"
  },
  {
    "Id": "TASE:5125158",
    "MayaId": "5125158",
    "Name": "KSM KTF DAXNR CH",
    "ShortName": "KSM KTF DAXNR CH",
    "Symbol": "TASE:5125158",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) DAX Currency Hedged",
    "EnglishLongName": "KSM KTF (4A) DAX Currency Hedged",
    "HebrewName": "קסם DAX KTF ממ",
    "HebrewLongName": "קסם DAX (4A) KTF מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.025,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 143.2,
    "MonthYield": 3.21,
    "YearYield": 3.21,
    "Last12MonthYield": 28.05,
    "ISIN": "IL0051251580"
  },
  {
    "Id": "TASE:5129028",
    "MayaId": "5129028",
    "Name": "KSM KTF EL CP35 IL",
    "ShortName": "KSM KTF EL-CP35 IL",
    "Symbol": "TASE:5129028",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00) Tel Bond-CPI Linked 3-5 IL",
    "EnglishLongName": "KSM KTF (00) Tel Bond-CPI Linked 3-5 IL",
    "HebrewName": "קסם KTF תלבונד צ 3-5",
    "HebrewLongName": "קסם KTFי (00) תל בונד-צמודות 3-5",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.35,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.24,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 65.6,
    "MonthYield": 0.16,
    "YearYield": 0.16,
    "Last12MonthYield": 5.77,
    "ISIN": "IL0051290281"
  },
  {
    "Id": "TASE:5141726",
    "MayaId": "5141726",
    "Name": "KSM KTF ETHUSDNY",
    "ShortName": "KSM KTF ETHUSDNY",
    "Symbol": "TASE:5141726",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4D) CME CF Ethereum Reference Rate (ETHUSDNY)",
    "EnglishLongName": "KSM KTF (4D) CME CF Ethereum Reference Rate (ETHUSDNY)",
    "HebrewName": "קסם ETHUSDNY KTF",
    "HebrewLongName": "קסם KTF י(4D)י CME CF Ethereum Reference Rate (ETHUSDNY)",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Digital Assets",
    "SecondaryClassification": "Ethereum",
    "AssetValue": 0.3,
    "MonthYield": 8.84,
    "YearYield": 8.84,
    "Last12MonthYield": null,
    "ISIN": "IL0051417264"
  },
  {
    "Id": "TASE:5140967",
    "MayaId": "5140967",
    "Name": "KSM KTF Eu Inf &Con iN EH",
    "ShortName": "KSM KTF Eu Inf &Con iN EH",
    "Symbol": "TASE:5140967",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4D) Europe Infrastructure & Construction iNDEX Euro Hedged",
    "EnglishLongName": "KSM KTF (4D) Europe Infrastructure & Construction iNDEX Euro Hedged",
    "HebrewName": "קסם KTF אינ תש ובי אי מא",
    "HebrewLongName": "קסם KTFי (4D) אינדקס תשתיות ובינוי אירופה מנוטרלת אירו",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 6.1,
    "MonthYield": 4.1,
    "YearYield": 4.1,
    "Last12MonthYield": null,
    "ISIN": "IL0051409675"
  },
  {
    "Id": "TASE:5138748",
    "MayaId": "5138748",
    "Name": "KSM KTF Global Def Ind iN",
    "ShortName": "KSM KTF Global Def Ind iN",
    "Symbol": "TASE:5138748",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4D) Global Defense Industries iNDEX",
    "EnglishLongName": "KSM KTF (4D) Global Defense Industries iNDEX",
    "HebrewName": "קסם KTF אינ תעש ביט גלובל",
    "HebrewLongName": "קסם KTF י(4D) אינדקס תעשיות ביטחוניות גלובלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.65,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 377.7,
    "MonthYield": 12.99,
    "YearYield": 12.99,
    "Last12MonthYield": 58.9,
    "ISIN": "IL0051387483"
  },
  {
    "Id": "TASE:5142096",
    "MayaId": "5142096",
    "Name": "KSM KTF GOLDLNPM CH",
    "ShortName": "KSM KTF GOLDLNPM CH",
    "Symbol": "TASE:5142096",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) LBMA GOLD PRICE PM USD Currency Hedged",
    "EnglishLongName": "KSM KTF (4A) LBMA GOLD PRICE PM USD Currency Hedged",
    "HebrewName": "קסם GOLDLNPM KTF ממ",
    "HebrewLongName": "קסם KTF י(4A)י LBMA GOLD PRICE PM USD מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.95,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Commodities",
    "SecondaryClassification": "Commodity",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:5131941",
    "MayaId": "5131941",
    "Name": "KSM KTF HXRNTR DH",
    "ShortName": "KSM KTF HXRNTR DH",
    "Symbol": "TASE:5131941",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4D) ISE Cyber Security Dollar Hedged",
    "EnglishLongName": "KSM KTF (4D) ISE Cyber Security Dollar Hedged",
    "HebrewName": "קסם HXRNTR KTF מד",
    "HebrewLongName": "קסם KTF י(4D)י ISE Cyber Security מנוטרלת דולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.84,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 39.9,
    "MonthYield": -1.2,
    "YearYield": -1.2,
    "Last12MonthYield": 2.98,
    "ISIN": "IL0051319411"
  },
  {
    "Id": "TASE:5138250",
    "MayaId": "5138250",
    "Name": "KSM KTF IBOXIG30 CH",
    "ShortName": "KSM KTF IBOXIG30 CH",
    "Symbol": "TASE:5138250",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (0A) iBoxx US Liquid Investment Grade Top 30 Currency Hedged",
    "EnglishLongName": "KSM KTF (0A) iBoxx US Liquid Investment Grade Top 30 Currency Hedged",
    "HebrewName": "קסם IBOXIG30 KTF ממ",
    "HebrewLongName": "קסם KTFי (0A)י iBoxx US Liquid Investment Grade Top 30 מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.31,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Hedged Corporate and Convertibles",
    "AssetValue": 160.6,
    "MonthYield": 0.13,
    "YearYield": 0.13,
    "Last12MonthYield": 7.7,
    "ISIN": "IL0051382500"
  },
  {
    "Id": "TASE:5140538",
    "MayaId": "5140538",
    "Name": "KSM KTF IBul 31 N link IL",
    "ShortName": "KSM KTF IBul 31 N-link IL",
    "Symbol": "TASE:5140538",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00)(!) Israeli Bullet 2031 Non-Linked iNDEX IL",
    "EnglishLongName": "KSM KTF (00)(!) Israeli Bullet 2031 Non-Linked iNDEX IL",
    "HebrewName": "קסם Bullet KTF שקלי 2031",
    "HebrewLongName": "קסם KTFי(00)(!) אינדקס Bullet שקלי 2031",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.22,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 29.3,
    "MonthYield": 0.9,
    "YearYield": 0.9,
    "Last12MonthYield": null,
    "ISIN": "IL0051405384"
  },
  {
    "Id": "TASE:5134929",
    "MayaId": "5134929",
    "Name": "KSM KTF IBXXLFC1",
    "ShortName": "KSM KTF IBXXLFC1",
    "Symbol": "TASE:5134929",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (0D) iBoxx USD Liquid FRN Investment Grade Corporates 100",
    "EnglishLongName": "KSM KTF (0D) iBoxx USD Liquid FRN Investment Grade Corporates 100",
    "HebrewName": "קסם iBox $ FRNIG KTF",
    "HebrewLongName": "קסם iBoxx USD Liquid FRN Investment Grade Corporates 100 (0D) KTF",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.07,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Hedged Corporate and Convertibles",
    "AssetValue": 19.4,
    "MonthYield": -1.23,
    "YearYield": -1.23,
    "Last12MonthYield": -10.63,
    "ISIN": "IL0051349293"
  },
  {
    "Id": "TASE:5131719",
    "MayaId": "5131719",
    "Name": "KSM KTF ICNET",
    "ShortName": "KSM KTF ICNET",
    "Symbol": "TASE:5131719",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4D) Indxx China Internet",
    "EnglishLongName": "KSM KTF (4D) Indxx China Internet",
    "HebrewName": "קסם ICNET KTF",
    "HebrewLongName": "קסם Indxx China Internet (4D) KTF",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.68,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 5.1,
    "MonthYield": 5.53,
    "YearYield": 5.53,
    "Last12MonthYield": 21.6,
    "ISIN": "IL0051317191"
  },
  {
    "Id": "TASE:5135785",
    "MayaId": "5135785",
    "Name": "KSM KTF II AA& UCL03IL",
    "ShortName": "KSM KTF II AA& UCL03IL",
    "Symbol": "TASE:5135785",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00) Index Israeli AA & Up CPI-Linked 0-3 IL",
    "EnglishLongName": "KSM KTF (00) Index Israeli AA & Up CPI-Linked 0-3 IL",
    "HebrewName": "קסם KTF אי AA ומע צמ 0-3",
    "HebrewLongName": "קסם KTF י(00) אינדקס AA ומעלה צמוד 0-3",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.14,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 216.6,
    "MonthYield": 0.16,
    "YearYield": 0.16,
    "Last12MonthYield": 5.08,
    "ISIN": "IL0051357858"
  },
  {
    "Id": "TASE:5135777",
    "MayaId": "5135777",
    "Name": "KSM KTF II AA& UNL03IL",
    "ShortName": "KSM KTF II AA& UNL03IL",
    "Symbol": "TASE:5135777",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00) Index Israeli AA & Up Non-Linked 0-3 IL",
    "EnglishLongName": "KSM KTF (00) Index Israeli AA & Up Non-Linked 0-3 IL",
    "HebrewName": "קסם KTF אי AA ומע שק 0-3",
    "HebrewLongName": "קסם KTF י(00) אינדקס AA ומעלה שקלי 0-3",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.18,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 80.7,
    "MonthYield": 0.57,
    "YearYield": 0.57,
    "Last12MonthYield": 6.22,
    "ISIN": "IL0051357775"
  },
  {
    "Id": "TASE:5138227",
    "MayaId": "5138227",
    "Name": "KSM KTF II AA& Up 3+IL",
    "ShortName": "KSM KTF II AA& Up 3+IL",
    "Symbol": "TASE:5138227",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00) Index Israeli AA & Up 3+IL",
    "EnglishLongName": "KSM KTF (00) Index Israeli AA & Up 3+IL",
    "HebrewName": "קסם KTF אינ AA ומעלה 3 +",
    "HebrewLongName": "קסם KTF י(00) אינדקס AA ומעלה 3+",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.45,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 38.7,
    "MonthYield": 0.67,
    "YearYield": 0.67,
    "Last12MonthYield": 8.56,
    "ISIN": "IL0051382278"
  },
  {
    "Id": "TASE:5132279",
    "MayaId": "5132279",
    "Name": "KSM KTF In Cloud Comp CH",
    "ShortName": "KSM KTF In Cloud Comp CH",
    "Symbol": "TASE:5132279",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) Index Cloud Computing Currency Hedged",
    "EnglishLongName": "KSM KTF (4A) Index Cloud Computing Currency Hedged",
    "HebrewName": "קסם KTF אינ Cloud Comp ממ",
    "HebrewLongName": "קסם KTF י (4A) אינדקס Cloud Computing מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.26,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 12.0,
    "MonthYield": -3.88,
    "YearYield": -3.88,
    "Last12MonthYield": -7.25,
    "ISIN": "IL0051322795"
  },
  {
    "Id": "TASE:5138268",
    "MayaId": "5138268",
    "Name": "KSM KTF In Con an In E IL",
    "ShortName": "KSM KTF In Con an In E IL",
    "Symbol": "TASE:5138268",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) Index Construction and Infrastructure Engineering IL",
    "EnglishLongName": "KSM KTF (4A) Index Construction and Infrastructure Engineering IL",
    "HebrewName": "קסם KTF אינ בינוי והנ תש",
    "HebrewLongName": "קסם KTFי (4A) אינדקס בינוי והנדסת תשתיות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.02,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 4.24,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 237.3,
    "MonthYield": 8.78,
    "YearYield": 8.78,
    "Last12MonthYield": 24.21,
    "ISIN": "IL0051382682"
  },
  {
    "Id": "TASE:5132006",
    "MayaId": "5132006",
    "Name": "KSM KTF In eGaming DH",
    "ShortName": "KSM KTF In eGaming DH",
    "Symbol": "TASE:5132006",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4D) Index eGaming Dollar Hedged",
    "EnglishLongName": "KSM KTF (4D) Index eGaming Dollar Hedged",
    "HebrewName": "קסם KTF אינ eGaming מד",
    "HebrewLongName": "קסם KTF י(4D)י אינדקס eGaming מנוטרלת דולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.94,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 11.4,
    "MonthYield": -1.6,
    "YearYield": -1.6,
    "Last12MonthYield": 31.83,
    "ISIN": "IL0051320062"
  },
  {
    "Id": "TASE:5131578",
    "MayaId": "5131578",
    "Name": "KSM KTF In Food Equ IL",
    "ShortName": "KSM KTF In Food Equ IL",
    "Symbol": "TASE:5131578",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) Index IL Food Equity",
    "EnglishLongName": "KSM KTF (4A) Index IL Food Equity",
    "HebrewName": "קסם KTF אינ מזון ישראלי",
    "HebrewLongName": "קסם KTFי (4A)י אינדקס מזון ישראלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.83,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 62.0,
    "MonthYield": 5.9,
    "YearYield": 5.9,
    "Last12MonthYield": 52.27,
    "ISIN": "IL0051315781"
  },
  {
    "Id": "TASE:5137575",
    "MayaId": "5137575",
    "Name": "KSM KTF IN GL$Bul Bond26",
    "ShortName": "KSM KTF IN GL$Bul-Bond26",
    "Symbol": "TASE:5137575",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (0D) iNDEX Global $ Bullet-Bond 2026",
    "EnglishLongName": "KSM KTF (0D) iNDEX Global $ Bullet-Bond 2026",
    "HebrewName": "קסם Bullet KTF דולר 26 גל",
    "HebrewLongName": "קסם KTF י(0D) אינדקס Bullet דולר 2026 - גלובלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.45,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.1,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Hedged Corporate and Convertibles",
    "AssetValue": 8.2,
    "MonthYield": -1.25,
    "YearYield": -1.25,
    "Last12MonthYield": -9.9,
    "ISIN": "IL0051375751"
  },
  {
    "Id": "TASE:5132451",
    "MayaId": "5132451",
    "Name": "KSM KTF In Glob Ex Op DH",
    "ShortName": "KSM KTF In Glob Ex Op DH",
    "Symbol": "TASE:5132451",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4D) Index Global Exchanges Operators Dollar Hedged",
    "EnglishLongName": "KSM KTF (4D) Index Global Exchanges Operators Dollar Hedged",
    "HebrewName": "קסם KTF אי מפ בור עול מד",
    "HebrewLongName": "קסם KTF י(4D)י אינדקס מפעילי בורסות עולמיות מנוטרלת דולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.41,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 5.1,
    "MonthYield": 2.33,
    "YearYield": 2.33,
    "Last12MonthYield": 11.57,
    "ISIN": "IL0051324510"
  },
  {
    "Id": "TASE:5132931",
    "MayaId": "5132931",
    "Name": "KSM KTF In IL Bo A Eq We",
    "ShortName": "KSM KTF In IL Bo A Eq We",
    "Symbol": "TASE:5132931",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00) Index IL Bond A Equal Weight",
    "EnglishLongName": "KSM KTF (00) Index IL Bond A Equal Weight",
    "HebrewName": "קסם KTF אינ אג A משק שו",
    "HebrewLongName": "קסם KTFי (00) אינדקס אג\"ח A משקל שווה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.26,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 64.8,
    "MonthYield": 0.69,
    "YearYield": 0.69,
    "Last12MonthYield": 7.13,
    "ISIN": "IL0051329311"
  },
  {
    "Id": "TASE:5132949",
    "MayaId": "5132949",
    "Name": "KSM KTF In IL Bo AA Eq We",
    "ShortName": "KSM KTF In IL Bo AA Eq We",
    "Symbol": "TASE:5132949",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00) Index IL Bond AA Equal Weight",
    "EnglishLongName": "KSM KTF (00) Index IL Bond AA Equal Weight",
    "HebrewName": "קסם KTF אינ אג AA משק שו",
    "HebrewLongName": "קסם KTFי (00) אינדקס אג\"ח AA משקל שווה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.35,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.26,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 46.8,
    "MonthYield": 0.56,
    "YearYield": 0.56,
    "Last12MonthYield": 7.14,
    "ISIN": "IL0051329493"
  },
  {
    "Id": "TASE:5133004",
    "MayaId": "5133004",
    "Name": "KSM KTF In IL Cons Bonds",
    "ShortName": "KSM KTF In IL Cons Bonds",
    "Symbol": "TASE:5133004",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00) index IL Construction Bonds",
    "EnglishLongName": "KSM KTF (00) index IL Construction Bonds",
    "HebrewName": "קסם KTF אינ אג חב בנ ביש",
    "HebrewLongName": "קסם KTFי (00) אינדקס אג\"ח חברות בנייה בישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.24,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 4.5,
    "MonthYield": 0.71,
    "YearYield": 0.71,
    "Last12MonthYield": 7.35,
    "ISIN": "IL0051330046"
  },
  {
    "Id": "TASE:5132956",
    "MayaId": "5132956",
    "Name": "KSM KTF In IL Sec Bal Bo",
    "ShortName": "KSM KTF In IL Sec Bal Bo",
    "Symbol": "TASE:5132956",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00) Index IL Sector Balance Bonds",
    "EnglishLongName": "KSM KTF (00) Index IL Sector Balance Bonds",
    "HebrewName": "קסם KTF אינ אג\"ח סקט באלא",
    "HebrewLongName": "קסם KTFי (00) אינדקס אג\"ח סקטור באלאנס",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.27,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 24.4,
    "MonthYield": 0.55,
    "YearYield": 0.55,
    "Last12MonthYield": 7.36,
    "ISIN": "IL0051329568"
  },
  {
    "Id": "TASE:5133772",
    "MayaId": "5133772",
    "Name": "KSM KTF IN T60CLCBxB IL",
    "ShortName": "KSM KTF IN T60CLCBxB IL",
    "Symbol": "TASE:5133772",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00) Index IL Top60 CPI-Linked Corporate Bonds ex Banks",
    "EnglishLongName": "KSM KTF (00) Index IL Top60 CPI-Linked Corporate Bonds ex Banks",
    "HebrewName": "קסם KTF אי צ מד T60 לל בנ",
    "HebrewLongName": "קסם KTFי (00) אינדקס צמוד מדורג Top60 ללא בנקים",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 245.8,
    "MonthYield": 0.29,
    "YearYield": 0.29,
    "Last12MonthYield": 6.98,
    "ISIN": "IL0051337728"
  },
  {
    "Id": "TASE:5132378",
    "MayaId": "5132378",
    "Name": "KSM KTF In Travel CH",
    "ShortName": "KSM KTF In Travel CH",
    "Symbol": "TASE:5132378",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) Index Travel Currency Hedged",
    "EnglishLongName": "KSM KTF (4A) Index Travel Currency Hedged",
    "HebrewName": "קסם KTF אינ Travel ממ",
    "HebrewLongName": "קסם KTF י(4A)י אינדקס Travel מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.4,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 14.3,
    "MonthYield": -0.46,
    "YearYield": -0.46,
    "Last12MonthYield": 11.79,
    "ISIN": "IL0051323785"
  },
  {
    "Id": "TASE:5135116",
    "MayaId": "5135116",
    "Name": "KSM KTF InI T60 CLBYW IL",
    "ShortName": "KSM KTF InI T60 CLBYW IL",
    "Symbol": "TASE:5135116",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00) INDEX Top 60 CPI-Linked Bond - YTM Weighted IL",
    "EnglishLongName": "KSM KTF (00) INDEX Top 60 CPI-Linked Bond - YTM Weighted IL",
    "HebrewName": "קסם KTF אי T60 צמ מש תל",
    "HebrewLongName": "קסם KTFי (00) אינדקס Top 60 צמוד - משקל תשואה לפדיון",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.29,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 24.0,
    "MonthYield": 0.26,
    "YearYield": 0.26,
    "Last12MonthYield": 7.3,
    "ISIN": "IL0051351166"
  },
  {
    "Id": "TASE:5140512",
    "MayaId": "5140512",
    "Name": "KSM KTF Is 100 YB iN IL",
    "ShortName": "KSM KTF Is 100 YB iN IL",
    "Symbol": "TASE:5140512",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00)(!) Israeli 100 Yields Bond iNDEX IL",
    "EnglishLongName": "KSM KTF (00)(!) Israeli 100 Yields Bond iNDEX IL",
    "HebrewName": "קסם KTF אינ אג\"ח תשו 100",
    "HebrewLongName": "קסם KTFי(00)(!) אינדקס אג\"ח תשואות 100",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.22,
    "TrusteeFee": 0.025,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Hi-risk Corporate & Convertibles",
    "AssetValue": 96.7,
    "MonthYield": 0.96,
    "YearYield": 0.96,
    "Last12MonthYield": null,
    "ISIN": "IL0051405129"
  },
  {
    "Id": "TASE:5141973",
    "MayaId": "5141973",
    "Name": "KSM KTF Is Bullet 2033 IL",
    "ShortName": "KSM KTF Is Bullet 2033 IL",
    "Symbol": "TASE:5141973",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00)(!) Israeli Bullet 2033 iNDEX IL",
    "EnglishLongName": "KSM KTF (00)(!) Israeli Bullet 2033 iNDEX IL",
    "HebrewName": "קסם Bullet KTF ישראל 2033",
    "HebrewLongName": "קסם KTFי(00)(!) אינדקס Bullet ישראל 2033",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.22,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": "IL0051419732"
  },
  {
    "Id": "TASE:5141965",
    "MayaId": "5141965",
    "Name": "KSM KTF Is Bullet 2034 IL",
    "ShortName": "KSM KTF Is Bullet 2034 IL",
    "Symbol": "TASE:5141965",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00)(!) Israeli Bullet 2034 iNDEX IL",
    "EnglishLongName": "KSM KTF (00)(!) Israeli Bullet 2034 iNDEX IL",
    "HebrewName": "קסם Bullet KTF ישראל 2034",
    "HebrewLongName": "קסם KTFי(00)(!) אינדקס Bullet ישראל 2034",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.22,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": "IL0051419658"
  },
  {
    "Id": "TASE:5141957",
    "MayaId": "5141957",
    "Name": "KSM KTF Is Bullet 2035 IL",
    "ShortName": "KSM KTF Is Bullet 2035 IL",
    "Symbol": "TASE:5141957",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00)(!) Israeli Bullet 2035 iNDEX IL",
    "EnglishLongName": "KSM KTF (00)(!) Israeli Bullet 2035 iNDEX IL",
    "HebrewName": "קסם Bullet KTF ישראל 2035",
    "HebrewLongName": "קסם KTFי(00)(!) אינדקס Bullet ישראל 2035",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.22,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": "IL0051419575"
  },
  {
    "Id": "TASE:5140520",
    "MayaId": "5140520",
    "Name": "KSM KTF Is Bullet 32 IL",
    "ShortName": "KSM KTF Is Bullet 32 IL",
    "Symbol": "TASE:5140520",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00)(!) Israeli Bullet 2032 iNDEX IL",
    "EnglishLongName": "KSM KTF (00)(!) Israeli Bullet 2032 iNDEX IL",
    "HebrewName": "קסם Bullet KTF ישראל 2032",
    "HebrewLongName": "קסם KTFי(00)(!) אינדקס Bullet ישראל 2032",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.22,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.39,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 112.0,
    "MonthYield": 0.7,
    "YearYield": 0.7,
    "Last12MonthYield": null,
    "ISIN": "IL0051405202"
  },
  {
    "Id": "TASE:5139050",
    "MayaId": "5139050",
    "Name": "KSM KTF Is GU Bull Bo 30i",
    "ShortName": "KSM KTF Is GU Bull-Bo 30i",
    "Symbol": "TASE:5139050",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (0D) Israeli Gov USD Bullet-Bond 2030 iNDEX",
    "EnglishLongName": "KSM KTF (0D) Israeli Gov USD Bullet-Bond 2030 iNDEX",
    "HebrewName": "קסם KTF אי Bul מי דו 2030",
    "HebrewLongName": "קסם KTF י(0D) אינדקס Bullet מדינת ישראל דולר 2030",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.91,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Government - Medium",
    "AssetValue": 61.0,
    "MonthYield": -1.1,
    "YearYield": -1.1,
    "Last12MonthYield": -5.63,
    "ISIN": "IL0051390503"
  },
  {
    "Id": "TASE:5141734",
    "MayaId": "5141734",
    "Name": "KSM KTF Is HY100 N L i IL",
    "ShortName": "KSM KTF Is HY100 N-L i IL",
    "Symbol": "TASE:5141734",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00) Israeli High Yields 100 Non-Linked iNDEX IL",
    "EnglishLongName": "KSM KTF (00) Israeli High Yields 100 Non-Linked iNDEX IL",
    "HebrewName": "קסם KTF אינ אג\"ח תש 100-ש",
    "HebrewLongName": "קסם KTFי (00) אינדקס אג''ח תשואות 100-שקלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.22,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 3.9,
    "MonthYield": 1.0,
    "YearYield": 1.0,
    "Last12MonthYield": null,
    "ISIN": "IL0051417348"
  },
  {
    "Id": "TASE:5141312",
    "MayaId": "5141312",
    "Name": "KSM KTF Israel Ban iN IL",
    "ShortName": "KSM KTF Israel Ban iN IL",
    "Symbol": "TASE:5141312",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) Israeli Banks iNDEX IL",
    "EnglishLongName": "KSM KTF (4A) Israeli Banks iNDEX IL",
    "HebrewName": "קסם KTF אינדקס בנקים ישרא",
    "HebrewLongName": "קסם KTFי (4A) אינדקס בנקים ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 19.0,
    "MonthYield": 9.44,
    "YearYield": 9.44,
    "Last12MonthYield": null,
    "ISIN": "IL0051413123"
  },
  {
    "Id": "TASE:5134986",
    "MayaId": "5134986",
    "Name": "KSM KTF ITOPTEN CH",
    "ShortName": "KSM KTF ITOPTEN CH",
    "Symbol": "TASE:5134986",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) Indxx US Tech Top 10 - MR Currency Hedged",
    "EnglishLongName": "KSM KTF (4A) Indxx US Tech Top 10 - MR Currency Hedged",
    "HebrewName": "קסם ITOPTEN KTF ממ",
    "HebrewLongName": "קסם KTFי (4A)י Indxx US Tech Top 10 - MR מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 265.7,
    "MonthYield": -1.03,
    "YearYield": -1.03,
    "Last12MonthYield": 19.74,
    "ISIN": "IL0051349863"
  },
  {
    "Id": "TASE:5137567",
    "MayaId": "5137567",
    "Name": "KSM KTF IUBT10N CH",
    "ShortName": "KSM KTF IUBT10N CH",
    "Symbol": "TASE:5137567",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) Indxx US Banks Top 10 Currency Hedged",
    "EnglishLongName": "KSM KTF (4A) Indxx US Banks Top 10 Currency Hedged",
    "HebrewName": "קסם IUBT10N KTF ממ",
    "HebrewLongName": "קסם KTFי(4A)י Indxx US Banks Top 10 מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.35,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.48,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 14.6,
    "MonthYield": 0.99,
    "YearYield": 0.99,
    "Last12MonthYield": 36.02,
    "ISIN": "IL0051375678"
  },
  {
    "Id": "TASE:5133434",
    "MayaId": "5133434",
    "Name": "KSM KTF IUSINFI CH",
    "ShortName": "KSM KTF IUSINFI CH",
    "Symbol": "TASE:5133434",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) Indxx US Infrastructure Currency Hedged",
    "EnglishLongName": "KSM KTF (4A) Indxx US Infrastructure Currency Hedged",
    "HebrewName": "קסם IUSINFI KTF ממ",
    "HebrewLongName": "קסם KTF י(4A)י Indxx US Infrastructure מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.77,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 33.1,
    "MonthYield": 8.91,
    "YearYield": 8.91,
    "Last12MonthYield": 32.63,
    "ISIN": "IL0051334345"
  },
  {
    "Id": "TASE:5125604",
    "MayaId": "5125604",
    "Name": "KSM KTF IXMNTR",
    "ShortName": "KSM KTF IXMNTR",
    "Symbol": "TASE:5125604",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4D) S&P Financial",
    "EnglishLongName": "KSM KTF (4D) S&P Financial",
    "HebrewName": "קסם SP Finance KTF",
    "HebrewLongName": "קסם S&P Financial (4D) KTF",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.53,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 85.9,
    "MonthYield": -2.1,
    "YearYield": -2.1,
    "Last12MonthYield": -2.23,
    "ISIN": "IL0051256043"
  },
  {
    "Id": "TASE:5136692",
    "MayaId": "5136692",
    "Name": "KSM KTF IXRNTR",
    "ShortName": "KSM KTF IXRNTR",
    "Symbol": "TASE:5136692",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4D) S&P Consumer Staples",
    "EnglishLongName": "KSM KTF (4D) S&P Consumer Staples",
    "HebrewName": "קסם SP KTF צריכה בסיס",
    "HebrewLongName": "קסם KTFי (4D)י S&P Consumer Staples",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.73,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 21.1,
    "MonthYield": 4.57,
    "YearYield": 4.57,
    "Last12MonthYield": -8.19,
    "ISIN": "IL0051366925"
  },
  {
    "Id": "TASE:5136056",
    "MayaId": "5136056",
    "Name": "KSM KTF IXVNTR CH",
    "ShortName": "KSM KTF IXVNTR CH",
    "Symbol": "TASE:5136056",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF(4A) S&P Health Care Currency Hedged",
    "EnglishLongName": "KSM KTF(4A) S&P Health Care Currency Hedged",
    "HebrewName": "קסם SP HealthCare KTF ממ",
    "HebrewLongName": "קסם KTFי (4A)י S&P Health Care מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.55,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.97,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 50.4,
    "MonthYield": 1.4,
    "YearYield": 1.4,
    "Last12MonthYield": 13.7,
    "ISIN": "IL0051360563"
  },
  {
    "Id": "TASE:5135330",
    "MayaId": "5135330",
    "Name": "KSM KTF M1WD",
    "ShortName": "KSM KTF M1WD",
    "Symbol": "TASE:5135330",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4D) MSCI AC World",
    "EnglishLongName": "KSM KTF (4D) MSCI AC World",
    "HebrewName": "קסם M1WD KTF",
    "HebrewLongName": "קסם KTF י(4D)י MSCI AC World",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.3,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.04,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Global Stocks",
    "AssetValue": 199.4,
    "MonthYield": 0.17,
    "YearYield": 0.17,
    "Last12MonthYield": 6.21,
    "ISIN": "IL0051353303"
  },
  {
    "Id": "TASE:5139696",
    "MayaId": "5139696",
    "Name": "KSM KTF M1WO DH",
    "ShortName": "KSM KTF M1WO DH",
    "Symbol": "TASE:5139696",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4D) MSCI World Dollar Hedged",
    "EnglishLongName": "KSM KTF (4D) MSCI World Dollar Hedged",
    "HebrewName": "קסם M1WO KTF מד",
    "HebrewLongName": "קסם KTF י(4D)י MSCI World מנוטרלת דולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.31,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 124.0,
    "MonthYield": 1.29,
    "YearYield": 1.29,
    "Last12MonthYield": 19.72,
    "ISIN": "IL0051396963"
  },
  {
    "Id": "TASE:5138896",
    "MayaId": "5138896",
    "Name": "KSM KTF M7IN",
    "ShortName": "KSM KTF M7IN",
    "Symbol": "TASE:5138896",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4D) MSCI India",
    "EnglishLongName": "KSM KTF (4D) MSCI India",
    "HebrewName": "קסם M7IN KTF",
    "HebrewLongName": "קסם KTF י(4D)י MSCI India",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.55,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.88,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 9.3,
    "MonthYield": -3.83,
    "YearYield": -3.83,
    "Last12MonthYield": -15.07,
    "ISIN": "IL0051388960"
  },
  {
    "Id": "TASE:5142088",
    "MayaId": "5142088",
    "Name": "KSM KTF MVIDITR IL",
    "ShortName": "KSM KTF MVIDITR IL",
    "Symbol": "TASE:5142088",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) MarketVector Israel Defense Industries Index IL",
    "EnglishLongName": "KSM KTF (4A) MarketVector Israel Defense Industries Index IL",
    "HebrewName": "קסם MVIDITR KTF",
    "HebrewLongName": "קסם KTF י(4A)י MarketVector תעשיות בטחוניות ישראליות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:5141494",
    "MayaId": "5141494",
    "Name": "KSM KTF MVNLRITR DH",
    "ShortName": "KSM KTF MVNLRITR DH",
    "Symbol": "TASE:5141494",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4D) MarketVector Global Nuclear Energy Industry Index Dollar Hedged",
    "EnglishLongName": "KSM KTF (4D) MarketVector Global Nuclear Energy Industry Index Dollar Hedged",
    "HebrewName": "קסם MVNLRITR KTF מד",
    "HebrewLongName": "קסם KTF י(4D)י MarketVector Global Nuclear Energy Industry Index מנוטרלת דולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 0.5,
    "MonthYield": 18.75,
    "YearYield": 18.75,
    "Last12MonthYield": null,
    "ISIN": "IL0051414949"
  },
  {
    "Id": "TASE:5132972",
    "MayaId": "5132972",
    "Name": "KSM KTF MVSMHTR CH",
    "ShortName": "KSM KTF MVSMHTR CH",
    "Symbol": "TASE:5132972",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) MVIS US Listed Semiconductor 25 Currency Hedged",
    "EnglishLongName": "KSM KTF (4A) MVIS US Listed Semiconductor 25 Currency Hedged",
    "HebrewName": "קסם MVSMHTR KTF ממ",
    "HebrewLongName": "קסם KTF י(4A)י MVIS US Listed Semiconductor 25 מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.69,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 339.5,
    "MonthYield": 10.13,
    "YearYield": 10.13,
    "Last12MonthYield": 59.73,
    "ISIN": "IL0051329725"
  },
  {
    "Id": "TASE:5136064",
    "MayaId": "5136064",
    "Name": "KSM KTF NKYNTR",
    "ShortName": "KSM KTF NKYNTR",
    "Symbol": "TASE:5136064",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF(4D) NIKKEI 225",
    "EnglishLongName": "KSM KTF(4D) NIKKEI 225",
    "HebrewName": "קסם Nikkei225 KTF",
    "HebrewLongName": "קסם KTFי (4D)י NIKKEI 225",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.55,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.75,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 88.9,
    "MonthYield": 3.83,
    "YearYield": 3.83,
    "Last12MonthYield": 15.86,
    "ISIN": "IL0051360647"
  },
  {
    "Id": "TASE:5138631",
    "MayaId": "5138631",
    "Name": "KSM KTF RU20N30U",
    "ShortName": "KSM KTF RU20N30U",
    "Symbol": "TASE:5138631",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4D) Russell 2000",
    "EnglishLongName": "KSM KTF (4D) Russell 2000",
    "HebrewName": "קסם RU20N30U KTF",
    "HebrewLongName": "קסם KTF י(4D)י Russell 2000",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.25,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 32.0,
    "MonthYield": 6.3,
    "YearYield": 6.3,
    "Last12MonthYield": 4.56,
    "ISIN": "IL0051386311"
  },
  {
    "Id": "TASE:5138441",
    "MayaId": "5138441",
    "Name": "KSM KTF SP5T5N",
    "ShortName": "KSM KTF SP5T5N",
    "Symbol": "TASE:5138441",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4D) S&P 500 TOP 50",
    "EnglishLongName": "KSM KTF (4D) S&P 500 TOP 50",
    "HebrewName": "קסם SP5T5N KTF",
    "HebrewLongName": "קסם KTF י(4D)י 50 S&P 500 TOP",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.51,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 11.9,
    "MonthYield": -1.96,
    "YearYield": -1.96,
    "Last12MonthYield": 2.02,
    "ISIN": "IL0051384415"
  },
  {
    "Id": "TASE:5138011",
    "MayaId": "5138011",
    "Name": "KSM KTF SP5T5N CH",
    "ShortName": "KSM KTF SP5T5N CH",
    "Symbol": "TASE:5138011",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) S&P 500 TOP 50 Currency Hedged",
    "EnglishLongName": "KSM KTF (4A) S&P 500 TOP 50 Currency Hedged",
    "HebrewName": "קסם SP5T5N KTF ממ",
    "HebrewLongName": "קסם KTF י(4A)י 50 S&P 500 TOP מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.75,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 161.3,
    "MonthYield": -0.59,
    "YearYield": -0.59,
    "Last12MonthYield": 16.13,
    "ISIN": "IL0051380116"
  },
  {
    "Id": "TASE:5137724",
    "MayaId": "5137724",
    "Name": "KSM KTF SPBDU10T CH",
    "ShortName": "KSM KTF SPBDU10T CH",
    "Symbol": "TASE:5137724",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (0A) S&P U.S. Treasury Bond 7-10 Year Currency Hedged",
    "EnglishLongName": "KSM KTF (0A) S&P U.S. Treasury Bond 7-10 Year Currency Hedged",
    "HebrewName": "קסם SPBDU10T KTF ממ",
    "HebrewLongName": "קסם KTF י(0A)י S&P U.S. Treasury Bond 7-10 Year מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.56,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Hedged Government - Long",
    "AssetValue": 368.8,
    "MonthYield": 0.1,
    "YearYield": 0.1,
    "Last12MonthYield": 7.37,
    "ISIN": "IL0051377245"
  },
  {
    "Id": "TASE:5139977",
    "MayaId": "5139977",
    "Name": "KSM KTF SPRFI02",
    "ShortName": "KSM KTF SPRFI02",
    "Symbol": "TASE:5139977",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4D) Cboe S&P 500 15% Buffer FEB IC - Yearly Defined Outcome",
    "EnglishLongName": "KSM KTF (4D) Cboe S&P 500 15% Buffer FEB IC - Yearly Defined Outcome",
    "HebrewName": "קסם SPRFI02 KTF",
    "HebrewLongName": "קסם KTFי(4D)י Cboe S&P 500 15% Buffer FEB IC - מובנה שנתי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.03,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 8.6,
    "MonthYield": -0.61,
    "YearYield": -0.61,
    "Last12MonthYield": null,
    "ISIN": "IL0051399777"
  },
  {
    "Id": "TASE:5137955",
    "MayaId": "5137955",
    "Name": "KSM KTF SPRFI03",
    "ShortName": "KSM KTF SPRFI03",
    "Symbol": "TASE:5137955",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4D) Cboe S&P 500 15% Buffer MAR IC - Yearly Defined Outcome",
    "EnglishLongName": "KSM KTF (4D) Cboe S&P 500 15% Buffer MAR IC - Yearly Defined Outcome",
    "HebrewName": "קסם SPRFI03 KTF",
    "HebrewLongName": "קסם KTFי(4D)י Cboe S&P 500 15% Buffer MAR IC - מובנה שנתי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.9,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.02,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 12.6,
    "MonthYield": -1.06,
    "YearYield": -1.06,
    "Last12MonthYield": -3.15,
    "ISIN": "IL0051379555"
  },
  {
    "Id": "TASE:5138664",
    "MayaId": "5138664",
    "Name": "KSM KTF SPRFI06",
    "ShortName": "KSM KTF SPRFI06",
    "Symbol": "TASE:5138664",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4D) Cboe S&P 500 15% Buffer JUN IC - Yearly Defined Outcome",
    "EnglishLongName": "KSM KTF (4D) Cboe S&P 500 15% Buffer JUN IC - Yearly Defined Outcome",
    "HebrewName": "קסם SPRFI06 KTF",
    "HebrewLongName": "קסם KTFי(4D)י Cboe S&P 500 15% Buffer JUN IC - מובנה שנתי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.85,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.85,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 21.7,
    "MonthYield": -0.81,
    "YearYield": -0.81,
    "Last12MonthYield": -2.8,
    "ISIN": "IL0051386642"
  },
  {
    "Id": "TASE:5140793",
    "MayaId": "5140793",
    "Name": "KSM KTF SPRFI07",
    "ShortName": "KSM KTF SPRFI07",
    "Symbol": "TASE:5140793",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4D) Cboe S&P 500 15% Buffer JUL IC - Yearly Defined Outcome",
    "EnglishLongName": "KSM KTF (4D) Cboe S&P 500 15% Buffer JUL IC - Yearly Defined Outcome",
    "HebrewName": "קסם SPRFI07 KTF",
    "HebrewLongName": "קסם KTFי(4D)י Cboe S&P 500 15% Buffer JUL IC - מובנה שנתי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 2.9,
    "MonthYield": -0.78,
    "YearYield": -0.78,
    "Last12MonthYield": null,
    "ISIN": "IL0051407935"
  },
  {
    "Id": "TASE:5138979",
    "MayaId": "5138979",
    "Name": "KSM KTF SPRFI08",
    "ShortName": "KSM KTF SPRFI08",
    "Symbol": "TASE:5138979",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4D) Cboe S&P 500 15% Buffer AUG IC - Yearly Defined Outcome",
    "EnglishLongName": "KSM KTF (4D) Cboe S&P 500 15% Buffer AUG IC - Yearly Defined Outcome",
    "HebrewName": "קסם SPRFI08 KTF",
    "HebrewLongName": "קסם KTFי(4D)י Cboe S&P 500 15% Buffer AUG IC - מובנה שנתי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.85,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.93,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 3.0,
    "MonthYield": -0.73,
    "YearYield": -0.73,
    "Last12MonthYield": -2.62,
    "ISIN": "IL0051389794"
  },
  {
    "Id": "TASE:5139506",
    "MayaId": "5139506",
    "Name": "KSM KTF SPRFI11",
    "ShortName": "KSM KTF SPRFI11",
    "Symbol": "TASE:5139506",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4D) Cboe S&P 500 15% Buffer NOV IC - Yearly Defined Outcome",
    "EnglishLongName": "KSM KTF (4D) Cboe S&P 500 15% Buffer NOV IC - Yearly Defined Outcome",
    "HebrewName": "קסם SPRFI11 KTF",
    "HebrewLongName": "קסם KTFי(4D)י Cboe S&P 500 15% Buffer NOV IC - מובנה שנתי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.94,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 4.1,
    "MonthYield": -0.5,
    "YearYield": -0.5,
    "Last12MonthYield": -4.37,
    "ISIN": "IL0051395064"
  },
  {
    "Id": "TASE:5139613",
    "MayaId": "5139613",
    "Name": "KSM KTF SPRFI12",
    "ShortName": "KSM KTF SPRFI12",
    "Symbol": "TASE:5139613",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4D) Cboe S&P 500 15% Buffer DEC IC - Yearly Defined Outcome",
    "EnglishLongName": "KSM KTF (4D) Cboe S&P 500 15% Buffer DEC IC - Yearly Defined Outcome",
    "HebrewName": "קסם SPRFI12 KTF",
    "HebrewLongName": "קסם KTFי(4D)י Cboe S&P 500 15% Buffer DEC IC - מובנה שנתי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.16,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 20.7,
    "MonthYield": -0.37,
    "YearYield": -0.37,
    "Last12MonthYield": -1.46,
    "ISIN": "IL0051396138"
  },
  {
    "Id": "TASE:5139902",
    "MayaId": "5139902",
    "Name": "KSM KTF SPTSX60N",
    "ShortName": "KSM KTF SPTSX60N",
    "Symbol": "TASE:5139902",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4D) S&P/TSX 60",
    "EnglishLongName": "KSM KTF (4D) S&P/TSX 60",
    "HebrewName": "קסם SP/TSX 60 KTF",
    "HebrewLongName": "קסם S&P/TSX 60 (4D) KTF",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.27,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 12.5,
    "MonthYield": 0.7,
    "YearYield": 0.7,
    "Last12MonthYield": null,
    "ISIN": "IL0051399025"
  },
  {
    "Id": "TASE:5122940",
    "MayaId": "5122940",
    "Name": "KSM KTF SXXR EH",
    "ShortName": "KSM KTF SXXR EH",
    "Symbol": "TASE:5122940",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) STOXX Europe 600 Euro Hedged",
    "EnglishLongName": "KSM KTF (4A) STOXX Europe 600 Euro Hedged",
    "HebrewName": "קסם Stox600 KTF מא",
    "HebrewLongName": "קסם STOXX Europe 600 (4A) KTF מנוטרלת אירו",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.17,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 97.9,
    "MonthYield": 3.75,
    "YearYield": 3.75,
    "Last12MonthYield": 25.98,
    "ISIN": "IL0051229404"
  },
  {
    "Id": "TASE:5113345",
    "MayaId": "5113345",
    "Name": "KSM KTF TA 125 IL",
    "ShortName": "KSM KTF TA-125 IL",
    "Symbol": "TASE:5113345",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) TA-125 IL",
    "EnglishLongName": "KSM KTF (4A) TA-125 IL",
    "HebrewName": "קסם KTF תא 125",
    "HebrewLongName": "קסם 4A) KTF) ת\"א 125",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.025,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.12,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 1329.2,
    "MonthYield": 8.85,
    "YearYield": 8.85,
    "Last12MonthYield": 64.11,
    "ISIN": "IL0051133457"
  },
  {
    "Id": "TASE:5124490",
    "MayaId": "5124490",
    "Name": "KSM KTF TA 35 IL",
    "ShortName": "KSM KTF TA-35 IL",
    "Symbol": "TASE:5124490",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) TA-35 IL",
    "EnglishLongName": "KSM KTF (4A) TA-35 IL",
    "HebrewName": "קסם KTF תא 35",
    "HebrewLongName": "קסם 4A) KTF) ת\"א 35",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.025,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.96,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 537.4,
    "MonthYield": 9.28,
    "YearYield": 9.28,
    "Last12MonthYield": 65.5,
    "ISIN": "IL0051244908"
  },
  {
    "Id": "TASE:5124508",
    "MayaId": "5124508",
    "Name": "KSM KTF TA 90 IL",
    "ShortName": "KSM KTF TA-90 IL",
    "Symbol": "TASE:5124508",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) TA-90 IL",
    "EnglishLongName": "KSM KTF (4A) TA-90 IL",
    "HebrewName": "קסם KTF תא 90",
    "HebrewLongName": "קסם 4A) KTF) ת\"א 90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.025,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.98,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 452.7,
    "MonthYield": 7.32,
    "YearYield": 7.32,
    "Last12MonthYield": 56.86,
    "ISIN": "IL0051245087"
  },
  {
    "Id": "TASE:5132782",
    "MayaId": "5132782",
    "Name": "KSM KTF TA CONS IL",
    "ShortName": "KSM KTF TA-CONS IL",
    "Symbol": "TASE:5132782",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) TA-Construction IL",
    "EnglishLongName": "KSM KTF (4A) TA-Construction IL",
    "HebrewName": "קסם KTF תא-בנייה",
    "HebrewLongName": "קסם 4A) KTF) ת\"א-בנייה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 4.55,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 42.2,
    "MonthYield": 12.07,
    "YearYield": 12.07,
    "Last12MonthYield": 23.44,
    "ISIN": "IL0051327828"
  },
  {
    "Id": "TASE:5135132",
    "MayaId": "5135132",
    "Name": "KSM KTF TA FAM",
    "ShortName": "KSM KTF TA-FAM",
    "Symbol": "TASE:5135132",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) TA- Family IL",
    "EnglishLongName": "KSM KTF (4A) TA- Family IL",
    "HebrewName": "קסם KTF תא פמילי",
    "HebrewLongName": "קסם KTFי (4A) ת\"א -פמילי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.98,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 13.2,
    "MonthYield": 8.86,
    "YearYield": 8.86,
    "Last12MonthYield": 55.66,
    "ISIN": "IL0051351323"
  },
  {
    "Id": "TASE:5131487",
    "MayaId": "5131487",
    "Name": "KSM KTF TA IPIS IL",
    "ShortName": "KSM KTF TA-IPIS IL",
    "Symbol": "TASE:5131487",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (40) TA-Investment Properties in IL",
    "EnglishLongName": "KSM KTF (40) TA-Investment Properties in IL",
    "HebrewName": "קסם KTF תא מניב ישראל",
    "HebrewLongName": "קסם KTFי (40) ת\"א -מניב ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 82.5,
    "MonthYield": 7.69,
    "YearYield": 7.69,
    "Last12MonthYield": 44.86,
    "ISIN": "IL0051314875"
  },
  {
    "Id": "TASE:5136130",
    "MayaId": "5136130",
    "Name": "KSM KTF TA MAALA IL",
    "ShortName": "KSM KTF TA-MAALA IL",
    "Symbol": "TASE:5136130",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) TA-Maala IL",
    "EnglishLongName": "KSM KTF (4A) TA-Maala IL",
    "HebrewName": "קסם KTF ת\"א מעלה",
    "HebrewLongName": "קסם KTFי (4A) ת\"א מעלה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.015,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 66.1,
    "MonthYield": 7.05,
    "YearYield": 7.05,
    "Last12MonthYield": 79.82,
    "ISIN": "IL0051361306"
  },
  {
    "Id": "TASE:5141478",
    "MayaId": "5141478",
    "Name": "KSM KTF TA REAL IL",
    "ShortName": "KSM KTF TA-REAL IL",
    "Symbol": "TASE:5141478",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) TA-RealEstate IL",
    "EnglishLongName": "KSM KTF (4A) TA-RealEstate IL",
    "HebrewName": "קסם KTF תא נדלן",
    "HebrewLongName": "קסם KTFי (4A) ת\"א נדל\"ן",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 0.5,
    "MonthYield": 9.82,
    "YearYield": 9.82,
    "Last12MonthYield": null,
    "ISIN": "IL0051414782"
  },
  {
    "Id": "TASE:5127535",
    "MayaId": "5127535",
    "Name": "KSM KTF TA SECT IL",
    "ShortName": "KSM KTF TA-SECT IL",
    "Symbol": "TASE:5127535",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) TA Sector-Balance IL",
    "EnglishLongName": "KSM KTF (4A) TA Sector-Balance IL",
    "HebrewName": "קסם KTF תא סקטור-באלאנס",
    "HebrewLongName": "קסם 4A) KTF) ת\"א סקטור-באלאנס",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.025,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 219.4,
    "MonthYield": 7.83,
    "YearYield": 7.83,
    "Last12MonthYield": 69.38,
    "ISIN": "IL0051275357"
  },
  {
    "Id": "TASE:5130927",
    "MayaId": "5130927",
    "Name": "KSM KTF TA Technology IL",
    "ShortName": "KSM KTF TA-Technology IL",
    "Symbol": "TASE:5130927",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) TA-Technology IL",
    "EnglishLongName": "KSM KTF (4A) TA-Technology IL",
    "HebrewName": "קסם KTF תא טכנולוגיה",
    "HebrewLongName": "קסם 4A) KTF) ת\"א -טכנולוגיה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0.15,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.27,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 75.3,
    "MonthYield": 14.93,
    "YearYield": 14.93,
    "Last12MonthYield": 80.4,
    "ISIN": "IL0051309271"
  },
  {
    "Id": "TASE:5139233",
    "MayaId": "5139233",
    "Name": "KSM KTF TA125 Value IL",
    "ShortName": "KSM KTF TA125-Value IL",
    "Symbol": "TASE:5139233",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) TA125-Value IL",
    "EnglishLongName": "KSM KTF (4A) TA125-Value IL",
    "HebrewName": "קסם KTF ת\"א-125 ערך",
    "HebrewLongName": "קסם KTFי (4A) ת\"א-125 ערך",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.94,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 143.8,
    "MonthYield": 5.4,
    "YearYield": 5.4,
    "Last12MonthYield": 66.04,
    "ISIN": "IL0051392335"
  },
  {
    "Id": "TASE:5139738",
    "MayaId": "5139738",
    "Name": "KSM KTF TA90 andBanks IL",
    "ShortName": "KSM KTF TA90 andBanks IL",
    "Symbol": "TASE:5139738",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) TA 90 and Banks IL",
    "EnglishLongName": "KSM KTF (4A) TA 90 and Banks IL",
    "HebrewName": "קסם KTF ת\"א 90 ובנקים",
    "HebrewLongName": "קסם KTFי (4A) ת\"א 90 ובנקים",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.67,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 104.7,
    "MonthYield": 8.08,
    "YearYield": 8.08,
    "Last12MonthYield": 62.44,
    "ISIN": "IL0051397383"
  },
  {
    "Id": "TASE:5115589",
    "MayaId": "5115589",
    "Name": "KSM KTF TEL B20 IL",
    "ShortName": "KSM KTF TEL-B20 IL",
    "Symbol": "TASE:5115589",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00) Tel Bond-20 CPI Linked IL",
    "EnglishLongName": "KSM KTF (00) Tel Bond-20 CPI Linked IL",
    "HebrewName": "קסם KTF תלבונד 20 צמודות",
    "HebrewLongName": "קסם KTFי (00) תל בונד 20 צמודות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.43,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 327.4,
    "MonthYield": 0.22,
    "YearYield": 0.22,
    "Last12MonthYield": 7.02,
    "ISIN": "IL0051155898"
  },
  {
    "Id": "TASE:5113303",
    "MayaId": "5113303",
    "Name": "KSM KTF TEL B40 IL",
    "ShortName": "KSM KTF TEL-B40 IL",
    "Symbol": "TASE:5113303",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00) Tel Bond-40 CPI Linked IL",
    "EnglishLongName": "KSM KTF (00) Tel Bond-40 CPI Linked IL",
    "HebrewName": "קסם KTF תלבונד 40 צמודות",
    "HebrewLongName": "קסם KTFי (00) תל בונד 40 צמודות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.35,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.26,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 29.0,
    "MonthYield": 0.24,
    "YearYield": 0.24,
    "Last12MonthYield": 6.07,
    "ISIN": "IL0051133036"
  },
  {
    "Id": "TASE:5129432",
    "MayaId": "5129432",
    "Name": "KSM KTF TEL B50 IL",
    "ShortName": "KSM KTF TEL-B50 IL",
    "Symbol": "TASE:5129432",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00) Tel Bond Shekel-50 IL",
    "EnglishLongName": "KSM KTF (00) Tel Bond Shekel-50 IL",
    "HebrewName": "קסם KTF תלבונד שקלי-50",
    "HebrewLongName": "קסם KTFי (00) תל בונד שקלי-50",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 138.2,
    "MonthYield": 0.91,
    "YearYield": 0.91,
    "Last12MonthYield": 8.16,
    "ISIN": "IL0051294325"
  },
  {
    "Id": "TASE:5118021",
    "MayaId": "5118021",
    "Name": "KSM KTF TEL B60 IL",
    "ShortName": "KSM KTF TEL-B60 IL",
    "Symbol": "TASE:5118021",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00) Tel Bond-60 CPI Linked IL",
    "EnglishLongName": "KSM KTF (00) Tel Bond-60 CPI Linked IL",
    "HebrewName": "קסם KTF תלבונד 60 צמודות",
    "HebrewLongName": "קסם KTFי (00) תל בונד 60 צמודות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 717.6,
    "MonthYield": 0.23,
    "YearYield": 0.23,
    "Last12MonthYield": 6.58,
    "ISIN": "IL0051180219"
  },
  {
    "Id": "TASE:5129010",
    "MayaId": "5129010",
    "Name": "KSM KTF TEL BCL AA IL",
    "ShortName": "KSM KTF TEL-BCL AA IL",
    "Symbol": "TASE:5129010",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00) Tel Bond-CPI-Linked AA-AAA IL",
    "EnglishLongName": "KSM KTF (00) Tel Bond-CPI-Linked AA-AAA IL",
    "HebrewName": "קסם KTF בונד צמודAA",
    "HebrewLongName": "קסם KTFי (00) תל בונד-צמודות AA-AAA",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 355.2,
    "MonthYield": 0.26,
    "YearYield": 0.26,
    "Last12MonthYield": 6.78,
    "ISIN": "IL0051290109"
  },
  {
    "Id": "TASE:5117437",
    "MayaId": "5117437",
    "Name": "KSM KTF TEL BCL IL",
    "ShortName": "KSM KTF TEL-BCL IL",
    "Symbol": "TASE:5117437",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00) Tel Bond-CPI Linked IL",
    "EnglishLongName": "KSM KTF (00) Tel Bond-CPI Linked IL",
    "HebrewName": "קסם KTF תלבונד צמוד",
    "HebrewLongName": "קסם KTFי (00) תל בונד צמודות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.26,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.31,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 341.5,
    "MonthYield": 0.25,
    "YearYield": 0.25,
    "Last12MonthYield": 6.56,
    "ISIN": "IL0051174378"
  },
  {
    "Id": "TASE:5132402",
    "MayaId": "5132402",
    "Name": "KSM KTF TEL BCLB IL",
    "ShortName": "KSM KTF TEL-BCLB IL",
    "Symbol": "TASE:5132402",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00) Tel Bond-CPI Linked Bank Without COCO IL",
    "EnglishLongName": "KSM KTF (00) Tel Bond-CPI Linked Bank Without COCO IL",
    "HebrewName": "קסם KTF תבונצ בנק לל COCO",
    "HebrewLongName": "קסם KTFי (00) תל בונד צמודות- בנקים ללא COCO",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.19,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 90.9,
    "MonthYield": 0.08,
    "YearYield": 0.08,
    "Last12MonthYield": 5.19,
    "ISIN": "IL0051324023"
  },
  {
    "Id": "TASE:5115605",
    "MayaId": "5115605",
    "Name": "KSM KTF TEL BCLS IL",
    "ShortName": "KSM KTF TEL-BCLS IL",
    "Symbol": "TASE:5115605",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00) Tel Bond-CPI Linked SmallCap IL",
    "EnglishLongName": "KSM KTF (00) Tel Bond-CPI Linked SmallCap IL",
    "HebrewName": "קסם KTF תלבונד צ יתר",
    "HebrewLongName": "קסם KTFי (00) תל בונד צמודות יתר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.35,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.25,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 34.9,
    "MonthYield": 0.27,
    "YearYield": 0.27,
    "Last12MonthYield": 6.37,
    "ISIN": "IL0051156052"
  },
  {
    "Id": "TASE:5129036",
    "MayaId": "5129036",
    "Name": "KSM KTF TEL BDOL IL",
    "ShortName": "KSM KTF TEL-BDOL IL",
    "Symbol": "TASE:5129036",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (0D) All-Bond Dollar and Top 5 Tel Bond-20 CPI-Linked IL",
    "EnglishLongName": "KSM KTF (0D) All-Bond Dollar and Top 5 Tel Bond-20 CPI-Linked IL",
    "HebrewName": "קסם AlB KTF דו וט5 בת20 צ",
    "HebrewLongName": "קסם KTFי (0D)י All-Bond-דולר וטופ 5 בתל בונד-20 צמודות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.35,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.95,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 35.8,
    "MonthYield": 0.08,
    "YearYield": 0.08,
    "Last12MonthYield": -6.69,
    "ISIN": "IL0051290364"
  },
  {
    "Id": "TASE:5139415",
    "MayaId": "5139415",
    "Name": "KSM KTF Tel Bo 125 VaC IL",
    "ShortName": "KSM KTF Tel Bo 125 VaC IL",
    "Symbol": "TASE:5139415",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00) Tel Bond 125 Value CPI IL",
    "EnglishLongName": "KSM KTF (00) Tel Bond 125 Value CPI IL",
    "HebrewName": "קסם KTF תלבונד 125 ערך צמ",
    "HebrewLongName": "קסם KTFי (00) תל בונד 125 ערך צמודות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.22,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 2.8,
    "MonthYield": 0.22,
    "YearYield": 0.22,
    "Last12MonthYield": null,
    "ISIN": "IL0051394158"
  },
  {
    "Id": "TASE:5139407",
    "MayaId": "5139407",
    "Name": "KSM KTF Tel Bo 125 VaS IL",
    "ShortName": "KSM KTF Tel Bo 125 VaS IL",
    "Symbol": "TASE:5139407",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00) Tel Bond 125 Value Shekel IL",
    "EnglishLongName": "KSM KTF (00) Tel Bond 125 Value Shekel IL",
    "HebrewName": "קסם KTF תלבונד 125 ערך שק",
    "HebrewLongName": "קסם KTFי (00) תל בונד 125 ערך שקלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.38,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 1.3,
    "MonthYield": 0.89,
    "YearYield": 0.89,
    "Last12MonthYield": null,
    "ISIN": "IL0051394075"
  },
  {
    "Id": "TASE:5129002",
    "MayaId": "5129002",
    "Name": "KSM KTF TEL BSH AA IL",
    "ShortName": "KSM KTF TEL-BSH AA IL",
    "Symbol": "TASE:5129002",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00) Tel Bond-Shekel AA-AAA IL",
    "EnglishLongName": "KSM KTF (00) Tel Bond-Shekel AA-AAA IL",
    "HebrewName": "קסם KTF בונד שקלי AA",
    "HebrewLongName": "קסם KTFי (00) תל בונד-שקלי AA-AAA",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.38,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 195.6,
    "MonthYield": 0.83,
    "YearYield": 0.83,
    "Last12MonthYield": 8.01,
    "ISIN": "IL0051290026"
  },
  {
    "Id": "TASE:5114566",
    "MayaId": "5114566",
    "Name": "KSM KTF TEL BSH IL",
    "ShortName": "KSM KTF TEL-BSH IL",
    "Symbol": "TASE:5114566",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00) Tel Bond-Shekel IL",
    "EnglishLongName": "KSM KTF (00) Tel Bond-Shekel IL",
    "HebrewName": "קסם KTF תלבונד שקלי",
    "HebrewLongName": "קסם KTFי (00) תל בונד שקלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 239.3,
    "MonthYield": 0.9,
    "YearYield": 0.9,
    "Last12MonthYield": 7.21,
    "ISIN": "IL0051145667"
  },
  {
    "Id": "TASE:5115597",
    "MayaId": "5115597",
    "Name": "KSM KTF TEL COMP IL",
    "ShortName": "KSM KTF TEL-COMP IL",
    "Symbol": "TASE:5115597",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (0A) Tel Bond-Composite IL",
    "EnglishLongName": "KSM KTF (0A) Tel Bond-Composite IL",
    "HebrewName": "קסם KTF תלבונד מאגר",
    "HebrewLongName": "קסם 0A) KTF) תל בונד מאגר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.35,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 141.8,
    "MonthYield": 0.5,
    "YearYield": 0.5,
    "Last12MonthYield": 6.48,
    "ISIN": "IL0051155971"
  },
  {
    "Id": "TASE:5140058",
    "MayaId": "5140058",
    "Name": "KSM KTF TEL CP03 IL",
    "ShortName": "KSM KTF TEL-CP03 IL",
    "Symbol": "TASE:5140058",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00) Tel Bond-CPI Linked 1-3 IL",
    "EnglishLongName": "KSM KTF (00) Tel Bond-CPI Linked 1-3 IL",
    "HebrewName": "קסם KTF תלבונד צ 1-3",
    "HebrewLongName": "קסם KTF י(00)י תל בונד צמודות 1-3",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.17,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 72.6,
    "MonthYield": 0.17,
    "YearYield": 0.17,
    "Last12MonthYield": null,
    "ISIN": "IL0051400583"
  },
  {
    "Id": "TASE:5133392",
    "MayaId": "5133392",
    "Name": "KSM KTF TEL CPIA IL",
    "ShortName": "KSM KTF TEL-CPIA IL",
    "Symbol": "TASE:5133392",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00) Tel Bond-CPI Linked A IL",
    "EnglishLongName": "KSM KTF (00) Tel Bond-CPI Linked A IL",
    "HebrewName": "קסם KTF תלבונד צמודות A",
    "HebrewLongName": "קסם KTFי (00) תל בונד-צמודות A",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.025,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 790.7,
    "MonthYield": 0.2,
    "YearYield": 0.2,
    "Last12MonthYield": 5.9,
    "ISIN": "IL0051333925"
  },
  {
    "Id": "TASE:5113428",
    "MayaId": "5113428",
    "Name": "KSM KTF TEL GOV",
    "ShortName": "KSM KTF TEL GOV",
    "Symbol": "TASE:5113428",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (0A) Tel Gov",
    "EnglishLongName": "KSM KTF (0A) Tel Gov",
    "HebrewName": "קסם KTF תל גוב- כללי",
    "HebrewLongName": "קסם 0A) KTF) תל גוב- כללי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.31,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bonds",
    "AssetValue": 129.8,
    "MonthYield": 0.47,
    "YearYield": 0.47,
    "Last12MonthYield": 6.3,
    "ISIN": "IL0051134281"
  },
  {
    "Id": "TASE:5113386",
    "MayaId": "5113386",
    "Name": "KSM KTF TEL GOV CPI LIN",
    "ShortName": "KSM KTF TEL GOV CPI-LIN",
    "Symbol": "TASE:5113386",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00) Tel Gov-CPI Linked",
    "EnglishLongName": "KSM KTF (00) Tel Gov-CPI Linked",
    "HebrewName": "קסם KTF תל גוב-צמודות",
    "HebrewLongName": "קסם KTFי (00) תל גוב- צמודות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.47,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked",
    "AssetValue": 34.8,
    "MonthYield": 0.03,
    "YearYield": 0.03,
    "Last12MonthYield": 4.47,
    "ISIN": "IL0051133861"
  },
  {
    "Id": "TASE:5113444",
    "MayaId": "5113444",
    "Name": "KSM KTF TEL GOV SHEK 2 5",
    "ShortName": "KSM KTF TEL GOV SHEK 2-5",
    "Symbol": "TASE:5113444",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00) Tel Gov-Shekel 2-5",
    "EnglishLongName": "KSM KTF (00) Tel Gov-Shekel 2-5",
    "HebrewName": "קסם KTF תל גוב-שקלי 2-5",
    "HebrewLongName": "קסם KTFי (00) תל גוב- שקלי 2-5",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.23,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Non-Linked Government Bonds",
    "AssetValue": 118.8,
    "MonthYield": 0.59,
    "YearYield": 0.59,
    "Last12MonthYield": 6.26,
    "ISIN": "IL0051134448"
  },
  {
    "Id": "TASE:5129192",
    "MayaId": "5129192",
    "Name": "KSM KTF TEL GOV SHEK 5 10",
    "ShortName": "KSM KTF TEL GOV SHEK 5-10",
    "Symbol": "TASE:5129192",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00) Tel Gov-Shekel 5-10",
    "EnglishLongName": "KSM KTF (00) Tel Gov-Shekel 5-10",
    "HebrewName": "קסם KTF תל גוב-שקלי 5-10",
    "HebrewLongName": "קסם KTFי (00) תל גוב- שקלי 5-10",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.57,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Non-Linked Government Bonds",
    "AssetValue": 532.7,
    "MonthYield": 0.77,
    "YearYield": 0.77,
    "Last12MonthYield": 8.99,
    "ISIN": "IL0051291925"
  },
  {
    "Id": "TASE:5118039",
    "MayaId": "5118039",
    "Name": "KSM KTF TEL GOV SHEK 5+",
    "ShortName": "KSM KTF TEL GOV SHEK 5+",
    "Symbol": "TASE:5118039",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00) Tel Gov-Shekel 5+",
    "EnglishLongName": "KSM KTF (00) Tel Gov-Shekel 5+",
    "HebrewName": "קסם KTF תל גוב-שקלי 5+",
    "HebrewLongName": "קסם KTFי (00) תל גוב שקלי 5+",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.81,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Non-Linked Government Bonds",
    "AssetValue": 37.1,
    "MonthYield": 1.26,
    "YearYield": 1.26,
    "Last12MonthYield": 10.93,
    "ISIN": "IL0051180391"
  },
  {
    "Id": "TASE:5121223",
    "MayaId": "5121223",
    "Name": "KSM KTF TEL NIS IL",
    "ShortName": "KSM KTF TEL-NIS IL",
    "Symbol": "TASE:5121223",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00)(!) Tel Bond-Yields Shekel IL",
    "EnglishLongName": "KSM KTF (00)(!) Tel Bond-Yields Shekel IL",
    "HebrewName": "קסם KTF תלבונד תשו ש",
    "HebrewLongName": "קסם KTFי (00)(!) תל בונד תשואות שקל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.29,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 29.3,
    "MonthYield": 1.06,
    "YearYield": 1.06,
    "Last12MonthYield": 5.85,
    "ISIN": "IL0051212236"
  },
  {
    "Id": "TASE:5118120",
    "MayaId": "5118120",
    "Name": "KSM KTF TEL YLD IL",
    "ShortName": "KSM KTF TEL-YLD IL",
    "Symbol": "TASE:5118120",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00)(!) Tel Bond-Yields CPI Linked IL",
    "EnglishLongName": "KSM KTF (00)(!) Tel Bond-Yields CPI Linked IL",
    "HebrewName": "קסם KTF תלבונד תשו צמודות",
    "HebrewLongName": "קסם KTFי (00)(!) תל בונד-תשואות צמודות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 180.2,
    "MonthYield": 0.16,
    "YearYield": 0.16,
    "Last12MonthYield": 5.78,
    "ISIN": "IL0051181209"
  },
  {
    "Id": "TASE:5138904",
    "MayaId": "5138904",
    "Name": "KSM KTF TipR US Mom An iN",
    "ShortName": "KSM KTF TipR US Mom An iN",
    "Symbol": "TASE:5138904",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4D) TipRanks US Momentum Analysts iNDEX",
    "EnglishLongName": "KSM KTF (4D) TipRanks US Momentum Analysts iNDEX",
    "HebrewName": "קסם TipR US Mom An iN KTF",
    "HebrewLongName": "קסם KTF י(4D)י TipRanks US Momentum Analysts iNDEX",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.93,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 39.4,
    "MonthYield": 1.63,
    "YearYield": 1.63,
    "Last12MonthYield": 3.02,
    "ISIN": "IL0051389042"
  },
  {
    "Id": "TASE:5140363",
    "MayaId": "5140363",
    "Name": "KSM KTF TiR US Mo A iN CH",
    "ShortName": "KSM KTF TiR US Mo A iN CH",
    "Symbol": "TASE:5140363",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) TipRanks US Momentum Analysts iNDEX Currency Hedged",
    "EnglishLongName": "KSM KTF (4A) TipRanks US Momentum Analysts iNDEX Currency Hedged",
    "HebrewName": "קסם TiR US Mo A iN KTF ממ",
    "HebrewLongName": "קסם KTF י(4A)י TipRanks US Momentum Analysts iNDEX מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 23.5,
    "MonthYield": 3.03,
    "YearYield": 3.03,
    "Last12MonthYield": null,
    "ISIN": "IL0051403637"
  },
  {
    "Id": "TASE:5141320",
    "MayaId": "5141320",
    "Name": "KSM KTF TR Gl Mo An iN DH",
    "ShortName": "KSM KTF TR Gl Mo An iN DH",
    "Symbol": "TASE:5141320",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4D) TipRanks Global Momentum Analysts iNDEX Dollar Hedged",
    "EnglishLongName": "KSM KTF (4D) TipRanks Global Momentum Analysts iNDEX Dollar Hedged",
    "HebrewName": "קסם TR Gl Mo An iN KTF מד",
    "HebrewLongName": "קסם KTF י(4D)י TipRanks Global Momentum Analysts iNDEX מנוטרלת דולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 17.8,
    "MonthYield": 3.64,
    "YearYield": 3.64,
    "Last12MonthYield": null,
    "ISIN": "IL0051413206"
  },
  {
    "Id": "TASE:5118781",
    "MayaId": "5118781",
    "Name": "KSM MWMFTR CH",
    "ShortName": "KSM MWMFTR CH",
    "Symbol": "TASE:5118781",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) Morningstar Wide Moat Focus Currency Hedged",
    "EnglishLongName": "KSM KTF (4A) Morningstar Wide Moat Focus Currency Hedged",
    "HebrewName": "קסם WideMoat US KTF ממ",
    "HebrewLongName": "קסם Morningstar Wide Moat Focus (4A) KTF מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.9,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 312.5,
    "MonthYield": 3.94,
    "YearYield": 3.94,
    "Last12MonthYield": 15.15,
    "ISIN": "IL0051187818"
  },
  {
    "Id": "TASE:5128905",
    "MayaId": "5128905",
    "Name": "KSM NASDAQ 100",
    "ShortName": "KSM NASDAQ 100",
    "Symbol": "TASE:5128905",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4D) NASDAQ 100",
    "EnglishLongName": "KSM KTF (4D) NASDAQ 100",
    "HebrewName": "קסם XNDXNNR KTF",
    "HebrewLongName": "קסם NASDAQ 100 (4D) KTF",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.025,
    "VariableFee": 0.2,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.86,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 1867.1,
    "MonthYield": -0.2,
    "YearYield": -0.2,
    "Last12MonthYield": 5.64,
    "ISIN": "IL0051289051"
  },
  {
    "Id": "TASE:5117122",
    "MayaId": "5117122",
    "Name": "KSM NON CPI LIN KOSH GOV",
    "ShortName": "KSM NON CPI-LIN KOSH GOV",
    "Symbol": "TASE:5117122",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (00) NON CPI-LINKED KOSHER GOVERNMENT",
    "EnglishLongName": "KSM ACTIVE (00) NON CPI-LINKED KOSHER GOVERNMENT",
    "HebrewName": "קסם אקט שקלית ממשלתית כשר",
    "HebrewLongName": "קסם אקטיב (00) שקלית ממשלתית כשרה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.54,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.37,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Shekel Bonds - No Equity",
    "AssetValue": 62.8,
    "MonthYield": 0.75,
    "YearYield": 0.75,
    "Last12MonthYield": 6.83,
    "ISIN": "IL0051171226"
  },
  {
    "Id": "TASE:5128079",
    "MayaId": "5128079",
    "Name": "KSM RSL 2000 CH",
    "ShortName": "KSM RSL 2000 CH",
    "Symbol": "TASE:5128079",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) Russell 2000 Currency Hedged",
    "EnglishLongName": "KSM KTF (4A) Russell 2000 Currency Hedged",
    "HebrewName": "קסם Russell 2000 KTF ממ",
    "HebrewLongName": "קסם Russell 2000 (4A) KTF מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.025,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.44,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 178.0,
    "MonthYield": 7.73,
    "YearYield": 7.73,
    "Last12MonthYield": 19.34,
    "ISIN": "IL0051280795"
  },
  {
    "Id": "TASE:5124482",
    "MayaId": "5124482",
    "Name": "KSM S&P 500",
    "ShortName": "KSM S&P 500",
    "Symbol": "TASE:5124482",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4D) S&P 500",
    "EnglishLongName": "KSM KTF (4D) S&P 500",
    "HebrewName": "קסם SP500 KTF",
    "HebrewLongName": "קסם S&P 500 (4D) KTF",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.025,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.39,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 4405.9,
    "MonthYield": 0.09,
    "YearYield": 0.09,
    "Last12MonthYield": 3.07,
    "ISIN": "IL0051244825"
  },
  {
    "Id": "TASE:5130851",
    "MayaId": "5130851",
    "Name": "KSM S&P 500 DNM$",
    "ShortName": "KSM S&P500 DNM$",
    "Symbol": "TASE:5130851",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "$ KSM KTF (4D) S&P 500 Denominated",
    "EnglishLongName": "$ KSM KTF (4D) S&P 500 Denominated",
    "HebrewName": "קסם SP500 KTF נקובה $",
    "HebrewLongName": "קסם S&P 500 (4D) KTF נקובה $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.41,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 80.6,
    "MonthYield": 0.41,
    "YearYield": 0.41,
    "Last12MonthYield": 3.39,
    "ISIN": "IL0051308513"
  },
  {
    "Id": "TASE:5125174",
    "MayaId": "5125174",
    "Name": "KSM S&P FINN CH",
    "ShortName": "KSM S&P FINN CH",
    "Symbol": "TASE:5125174",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) S&P Financial Currency Hedged",
    "EnglishLongName": "KSM KTF (4A) S&P Financial Currency Hedged",
    "HebrewName": "קסם SP Finance KTF ממ",
    "HebrewLongName": "קסם S&P Financial (4A) KTF מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.86,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 70.6,
    "MonthYield": -0.78,
    "YearYield": -0.78,
    "Last12MonthYield": 11.37,
    "ISIN": "IL0051251747"
  },
  {
    "Id": "TASE:5125620",
    "MayaId": "5125620",
    "Name": "KSM S&P TECH CH",
    "ShortName": "KSM S&P TECH CH",
    "Symbol": "TASE:5125620",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) S&P Technology Currency Hedged",
    "EnglishLongName": "KSM KTF (4A) S&P Technology Currency Hedged",
    "HebrewName": "קסם SP Tech KTF ממ",
    "HebrewLongName": "קסם S&P Technology (4A) KTF מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.025,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.66,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 246.8,
    "MonthYield": 0.99,
    "YearYield": 0.99,
    "Last12MonthYield": 22.34,
    "ISIN": "IL0051256209"
  },
  {
    "Id": "TASE:5129127",
    "MayaId": "5129127",
    "Name": "KSM S&P5 MI3 5T",
    "ShortName": "KSM S&P5 MI3-5T",
    "Symbol": "TASE:5129127",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (0D) S&P 500 Bond Mega 30 Investment Grade 3-5 Year",
    "EnglishLongName": "KSM KTF (0D) S&P 500 Bond Mega 30 Investment Grade 3-5 Year",
    "HebrewName": "קסם SP5MI35T KTF",
    "HebrewLongName": "קסם S&P 500 Bond Mega 30 Investment Grade 3-5 Year (0D) KTF",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.19,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Corporate and Convertibles - Medium",
    "AssetValue": 299.4,
    "MonthYield": -1.34,
    "YearYield": -1.34,
    "Last12MonthYield": -7.7,
    "ISIN": "IL0051291271"
  },
  {
    "Id": "TASE:5127550",
    "MayaId": "5127550",
    "Name": "KSM SP AR&DF CH",
    "ShortName": "KSM SP AR&DF CH",
    "Symbol": "TASE:5127550",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) S&P Aerospace & Defense Currency Hedged",
    "EnglishLongName": "KSM KTF (4A) S&P Aerospace & Defense Currency Hedged",
    "HebrewName": "קסם SP US AD KTF ממ",
    "HebrewLongName": "קסם S&P Aerospace & Defense (4A) KTF מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.22,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 69.7,
    "MonthYield": 20.11,
    "YearYield": 20.11,
    "Last12MonthYield": 70.56,
    "ISIN": "IL0051275506"
  },
  {
    "Id": "TASE:5125638",
    "MayaId": "5125638",
    "Name": "KSM SP CONS DSC",
    "ShortName": "KSM SP CONS DSC",
    "Symbol": "TASE:5125638",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) S&P Consumer Discretionary Currency Hedged",
    "EnglishLongName": "KSM KTF (4A) S&P Consumer Discretionary Currency Hedged",
    "HebrewName": "קסם SP KTF צריכה מחזור ממ",
    "HebrewLongName": "קסם S&P Consumer Discretionary (4A) KTF מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.3,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.41,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 55.5,
    "MonthYield": 2.82,
    "YearYield": 2.82,
    "Last12MonthYield": 7.29,
    "ISIN": "IL0051256381"
  },
  {
    "Id": "TASE:5125182",
    "MayaId": "5125182",
    "Name": "KSM SP INDUS CH",
    "ShortName": "KSM SP INDUS CH",
    "Symbol": "TASE:5125182",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) S&P Industrial Currency Hedged",
    "EnglishLongName": "KSM KTF (4A) S&P Industrial Currency Hedged",
    "HebrewName": "קסם SP Industrial KTF ממ",
    "HebrewLongName": "קסם S&P Industrial (4A) KTF מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.025,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.54,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 96.9,
    "MonthYield": 6.64,
    "YearYield": 6.64,
    "Last12MonthYield": 24.47,
    "ISIN": "IL0051251820"
  },
  {
    "Id": "TASE:5122957",
    "MayaId": "5122957",
    "Name": "KSM SPTR500N CH",
    "ShortName": "KSM SPTR500N CH",
    "Symbol": "TASE:5122957",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) S&P 500 Currency Hedged",
    "EnglishLongName": "KSM KTF (4A) S&P 500 Currency Hedged",
    "HebrewName": "קסם SP500 KTF ממ",
    "HebrewLongName": "קסם S&P 500 (4A) KTF מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.025,
    "VariableFee": 0.2,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.6,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 2638.2,
    "MonthYield": 1.45,
    "YearYield": 1.45,
    "Last12MonthYield": 17.66,
    "ISIN": "IL0051229578"
  },
  {
    "Id": "TASE:5122965",
    "MayaId": "5122965",
    "Name": "KSM STK US CH",
    "ShortName": "KSM STK US CH",
    "Symbol": "TASE:5122965",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) Composite S&P 500 (70%) Nasdaq (30%) Monthly Currency Hedged",
    "EnglishLongName": "KSM KTF (4A) Composite S&P 500 (70%) Nasdaq (30%) Monthly Currency Hedged",
    "HebrewName": "קסם KTF מש מנ ארהב ממ",
    "HebrewLongName": "קסם 4A) KTF) משולבת (S&P 500 (70%) Nasdaq (30% חודשי מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.74,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks Abroad, Composite",
    "AssetValue": 124.7,
    "MonthYield": 1.39,
    "YearYield": 1.39,
    "Last12MonthYield": 17.2,
    "ISIN": "IL0051229651"
  },
  {
    "Id": "TASE:5125612",
    "MayaId": "5125612",
    "Name": "KSM STX EURO600",
    "ShortName": "KSM STX EURO600",
    "Symbol": "TASE:5125612",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4D) STOXX Europe 600",
    "EnglishLongName": "KSM KTF (4D) STOXX Europe 600",
    "HebrewName": "קסם Stox600 KTF",
    "HebrewLongName": "קסם STOXX Europe 600 (4D) KTF",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.025,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.48,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 109.7,
    "MonthYield": 0.87,
    "YearYield": 0.87,
    "Last12MonthYield": 19.06,
    "ISIN": "IL0051256126"
  },
  {
    "Id": "TASE:5124516",
    "MayaId": "5124516",
    "Name": "KSM XNDXNNR CH",
    "ShortName": "KSM XNDXNNR CH",
    "Symbol": "TASE:5124516",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) NASDAQ 100 Currency Hedged",
    "EnglishLongName": "KSM KTF (4A) NASDAQ 100 Currency Hedged",
    "HebrewName": "קסם NDX100 KTF ממ",
    "HebrewLongName": "קסם NASDAQ 100 (4A) KTF מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.025,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.07,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 702.0,
    "MonthYield": 1.16,
    "YearYield": 1.16,
    "Last12MonthYield": 19.7,
    "ISIN": "IL0051245160"
  },
  {
    "Id": "TASE:5133012",
    "MayaId": "5133012",
    "Name": "KSM.SPSIRBKN",
    "ShortName": "KSM.SPSIRBKN",
    "Symbol": "TASE:5133012",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4D) S&P Regional Banks",
    "EnglishLongName": "KSM KTF (4D) S&P Regional Banks",
    "HebrewName": "קסם SP RBanks KTF",
    "HebrewLongName": "קסם S&P Regional Banks (4D) KTF",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.72,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 3.7,
    "MonthYield": 3.94,
    "YearYield": 3.94,
    "Last12MonthYield": -1.26,
    "ISIN": "IL0051330129"
  },
  {
    "Id": "TASE:5131206",
    "MayaId": "5131206",
    "Name": "KSM.XNBINNRCH",
    "ShortName": "KSM.XNBINNRCH",
    "Symbol": "TASE:5131206",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (4A) NASDAQ Biotechnology Currency Hedged",
    "EnglishLongName": "KSM KTF (4A) NASDAQ Biotechnology Currency Hedged",
    "HebrewName": "קסם NDX Bio KTF ממ",
    "HebrewLongName": "קסם NASDAQ Biotechnology (4A) KTF מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.82,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 13.0,
    "MonthYield": 1.02,
    "YearYield": 1.02,
    "Last12MonthYield": 31.25,
    "ISIN": "IL0051312069"
  },
  {
    "Id": "TASE:5110226",
    "MayaId": "5110226",
    "Name": "KSMAC!FPtwoutSto IsrFfFIL",
    "ShortName": "KSMAC!FPtwoutSto-IsrFfFIL",
    "Symbol": "TASE:5110226",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (0C)(!) Funds Portfolio without Stocks - Israeli Fund of Funds IL",
    "EnglishLongName": "KSM ACTIVE (0C)(!) Funds Portfolio without Stocks - Israeli Fund of Funds IL",
    "HebrewName": "קסםאקט!תיקקרנללאמנ-אגדישר",
    "HebrewLongName": "קסם אקטיב (0C)(!) תיק קרנות ללא מניות-אגד ישראלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.26,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Fund of Funds",
    "SecondaryClassification": "Israeli Fund of Funds",
    "AssetValue": 19.4,
    "MonthYield": 0.6,
    "YearYield": 0.6,
    "Last12MonthYield": 5.81,
    "ISIN": "IL0051102262"
  },
  {
    "Id": "TASE:5136874",
    "MayaId": "5136874",
    "Name": "KSMACMonMark IL",
    "ShortName": "KSMACMonMark IL",
    "Symbol": "TASE:5136874",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (00) Money Market IL",
    "EnglishLongName": "KSM ACTIVE (00) Money Market IL",
    "HebrewName": "קסם אקטיב כספית",
    "HebrewLongName": "קסם אקטיב (00) כספית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.24,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 1961.7,
    "MonthYield": 0.2,
    "YearYield": 0.2,
    "Last12MonthYield": 4.67,
    "ISIN": "IL0051368749"
  },
  {
    "Id": "TASE:5118815",
    "MayaId": "5118815",
    "Name": "KSMACT ! COR SEL +10% IL",
    "ShortName": "KSMACT ! COR SEL +10% IL",
    "Symbol": "TASE:5118815",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (1A)(!) CORPORATE SELECTED + 10% IL",
    "EnglishLongName": "KSM ACTIVE (1A)(!) CORPORATE SELECTED + 10% IL",
    "HebrewName": "קסם אקט ! מב קונצרנ +10%",
    "HebrewLongName": "קסם אקטיב (1A)(!) מבחר קונצרני +10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.83,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.37,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles with Equity",
    "AssetValue": 91.4,
    "MonthYield": 1.29,
    "YearYield": 1.29,
    "Last12MonthYield": 9.5,
    "ISIN": "IL0051188154"
  },
  {
    "Id": "TASE:5116470",
    "MayaId": "5116470",
    "Name": "KSMACT B PORT W OUT EQ IL",
    "ShortName": "KSMACT B PORT W OUT EQ IL",
    "Symbol": "TASE:5116470",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (0B) BONDS PORTFOLIO WITHOUT EQUITIES IL",
    "EnglishLongName": "KSM ACTIVE (0B) BONDS PORTFOLIO WITHOUT EQUITIES IL",
    "HebrewName": "קסם אקט תיק אגח ללא מניות",
    "HebrewLongName": "קסם אקטיב (0B) תיק אג\"ח ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.73,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 633.4,
    "MonthYield": 0.63,
    "YearYield": 0.63,
    "Last12MonthYield": 5.82,
    "ISIN": "IL0051164700"
  },
  {
    "Id": "TASE:5118146",
    "MayaId": "5118146",
    "Name": "KSMACT Flexible Portfolio",
    "ShortName": "KSMACT Flexible Portfolio",
    "Symbol": "TASE:5118146",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (4D) Flexible Portfolio",
    "EnglishLongName": "KSM ACTIVE (4D) Flexible Portfolio",
    "HebrewName": "קסם אקטיב תיק השקעות גמיש",
    "HebrewLongName": "קסם אקטיב (4D) תיק השקעות גמיש",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.84,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.06,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 372.8,
    "MonthYield": 8.38,
    "YearYield": 8.38,
    "Last12MonthYield": 58.56,
    "ISIN": "IL0051181464"
  },
  {
    "Id": "TASE:5100581",
    "MayaId": "5100581",
    "Name": "KSMACT NO CPI LIN A&UP IL",
    "ShortName": "KSMACT NO CPI LIN A&UP IL",
    "Symbol": "TASE:5100581",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (00) NON-CPI LINKED - A & up IL",
    "EnglishLongName": "KSM ACTIVE (00) NON-CPI LINKED - A & up IL",
    "HebrewName": "קסם אקט שקל A ומעלה",
    "HebrewLongName": "קסם אקטיב (00) שקלי - A ומעלה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.71,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Shekel Corporate and Convertibles - No Equity",
    "AssetValue": 70.5,
    "MonthYield": 0.77,
    "YearYield": 0.77,
    "Last12MonthYield": 6.51,
    "ISIN": "IL0051005812"
  },
  {
    "Id": "TASE:5130588",
    "MayaId": "5130588",
    "Name": "KSMACT TRACK BL BD P3 IL",
    "ShortName": "KSMACT TRACK BL BD P3 IL",
    "Symbol": "TASE:5130588",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (00) TRACKING BENLEUMI`S PORTFOLIO 3 – BOND COMPONENT IL",
    "EnglishLongName": "KSM ACTIVE (00) TRACKING BENLEUMI`S PORTFOLIO 3 – BOND COMPONENT IL",
    "HebrewName": "קסם אקט עוקב אג תיק 3 בינ",
    "HebrewLongName": "קסם אקטיב (00) עוקבת מרכיב אג\"ח – תיק 3 הבנק הבינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.62,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 28.5,
    "MonthYield": 0.59,
    "YearYield": 0.59,
    "Last12MonthYield": 6.82,
    "ISIN": "IL0051305881"
  },
  {
    "Id": "TASE:5104252",
    "MayaId": "5104252",
    "Name": "KSMACT TRACK LIQ COMP IL",
    "ShortName": "KSMACT TRACK LIQ COMP IL",
    "Symbol": "TASE:5104252",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (0A) TRACKING BENLEUMI LIQUIDITY COMPONENT IL",
    "EnglishLongName": "KSM ACTIVE (0A) TRACKING BENLEUMI LIQUIDITY COMPONENT IL",
    "HebrewName": "קסם אקט עוקב מרכ נזיל בינ",
    "HebrewLongName": "קסם אקטיב (0A) עוקבת מרכיב נזילות הבנק הבינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.52,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.11,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 74.5,
    "MonthYield": 0.32,
    "YearYield": 0.32,
    "Last12MonthYield": 5.1,
    "ISIN": "IL0051042526"
  },
  {
    "Id": "TASE:5110820",
    "MayaId": "5110820",
    "Name": "KSMACT Yet R of Share IL",
    "ShortName": "KSMACT Yet- R of Share IL",
    "Symbol": "TASE:5110820",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (4A) Yeter - Rest of Shares IL",
    "EnglishLongName": "KSM ACTIVE (4A) Yeter - Rest of Shares IL",
    "HebrewName": "קסם אקטיב מניות יתר",
    "HebrewLongName": "קסם אקטיב (4A) מניות יתר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.84,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.13,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 111.0,
    "MonthYield": 5.08,
    "YearYield": 5.08,
    "Last12MonthYield": 42.6,
    "ISIN": "IL0051108202"
  },
  {
    "Id": "TASE:5114210",
    "MayaId": "5114210",
    "Name": "KSMACT!Bon&DepFFunFundsD$",
    "ShortName": "KSMACT!Bon&DepFFunFundsD$",
    "Symbol": "TASE:5114210",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (1D)(!) Bonds & Deposits Foreign Fund of Funds Denominated in Dollar",
    "EnglishLongName": "KSM ACTIVE (1D)(!) Bonds & Deposits Foreign Fund of Funds Denominated in Dollar",
    "HebrewName": "קסםאקט!אגד חוץאגח ופקדנק$",
    "HebrewLongName": "קסם אקטיב (1D) (!) אגד חוץ אג\"ח ופקדונות נקוב $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.47,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.16,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Fund of Funds",
    "SecondaryClassification": "Foreign Fund of Funds",
    "AssetValue": 8.4,
    "MonthYield": -0.63,
    "YearYield": -0.63,
    "Last12MonthYield": -6.9,
    "ISIN": "IL0051142102"
  },
  {
    "Id": "TASE:5111364",
    "MayaId": "5111364",
    "Name": "KSMACT!CorLoSh IL LeveFud",
    "ShortName": "KSMACT!CorLoSh IL-LeveFud",
    "Symbol": "TASE:5111364",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (0A)(!) Corporate Long Short IL – Leveraged Fund",
    "EnglishLongName": "KSM ACTIVE (0A)(!) Corporate Long Short IL – Leveraged Fund",
    "HebrewName": "קסם אקט!קונצרני לונג שורט",
    "HebrewLongName": "קסם אקטיב (0A)(!) קונצרני לונג שורט",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.13,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": true,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.29,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Leveraged and Strategic",
    "SecondaryClassification": "Leveraged, Other",
    "AssetValue": 19.0,
    "MonthYield": 0.55,
    "YearYield": 0.55,
    "Last12MonthYield": 5.95,
    "ISIN": "IL0051113640"
  },
  {
    "Id": "TASE:5118534",
    "MayaId": "5118534",
    "Name": "KSMACT!GlobBonDollarHY",
    "ShortName": "KSMACT!GlobBonDollarHY",
    "Symbol": "TASE:5118534",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (0D)(!) Global Bonds Dollar HY",
    "EnglishLongName": "KSM ACTIVE (0D)(!) Global Bonds Dollar HY",
    "HebrewName": "קסם אקט! אגח חו\"ל דולר HY",
    "HebrewLongName": "קסם אקטיב (0D)(!) אג\"ח חו\"ל דולר HY",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.04,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "Dollar Bond",
    "AssetValue": 33.5,
    "MonthYield": -0.45,
    "YearYield": -0.45,
    "Last12MonthYield": -8.06,
    "ISIN": "IL0051185341"
  },
  {
    "Id": "TASE:5130091",
    "MayaId": "5130091",
    "Name": "KSMACT$ MonMark Denomin$",
    "ShortName": "KSMACT$ MonMark- Denomin$",
    "Symbol": "TASE:5130091",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (0D) Dollar Money Market – Denominated in $",
    "EnglishLongName": "KSM ACTIVE (0D) Dollar Money Market – Denominated in $",
    "HebrewName": "קסם אקט כספית דולרית-נקו$",
    "HebrewLongName": "קסם אקטיב (0D) כספית דולרית - נקובה $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.19,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "FX Money Market with Corporate",
    "AssetValue": 699.3,
    "MonthYield": -0.93,
    "YearYield": -0.93,
    "Last12MonthYield": -9.51,
    "ISIN": "IL0051300916"
  },
  {
    "Id": "TASE:5124466",
    "MayaId": "5124466",
    "Name": "KSMACT(!) Israel 90/10 IL",
    "ShortName": "KSMACT(!) Israel 90/10 IL",
    "Symbol": "TASE:5124466",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (1A)(!) Israel 90/10 IL",
    "EnglishLongName": "KSM ACTIVE (1A)(!) Israel 90/10 IL",
    "HebrewName": "קסם אקטיב (!) 10/90",
    "HebrewLongName": "קסם אקטיב (1A)(!)י 10/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.74,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.37,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 106.0,
    "MonthYield": 1.37,
    "YearYield": 1.37,
    "Last12MonthYield": 9.71,
    "ISIN": "IL0051244668"
  },
  {
    "Id": "TASE:5135702",
    "MayaId": "5135702",
    "Name": "KSMACT80/20IL Den in $",
    "ShortName": "KSMACT80/20IL-Den in $",
    "Symbol": "TASE:5135702",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (2D) 80/20 IL – Denominated in $",
    "EnglishLongName": "KSM ACTIVE (2D) 80/20 IL – Denominated in $",
    "HebrewName": "קסם אקט 20/80 נקובה$",
    "HebrewLongName": "קסם אקטיב (2D)י 20/80 נקובה $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.58,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.76,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 15.3,
    "MonthYield": -0.14,
    "YearYield": -0.14,
    "Last12MonthYield": -4.42,
    "ISIN": "IL0051357023"
  },
  {
    "Id": "TASE:5109988",
    "MayaId": "5109988",
    "Name": "KSMACTAA andup and/orGvIL",
    "ShortName": "KSMACTAA andup and/orGvIL",
    "Symbol": "TASE:5109988",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (0B) AA and up and/or Government IL",
    "EnglishLongName": "KSM ACTIVE (0B) AA and up and/or Government IL",
    "HebrewName": "קסםאקטAA ומעלה ו/או מדינה",
    "HebrewLongName": "קסם אקטיב (0B)י AA ומעלה ו/או מדינה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.23,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 112.3,
    "MonthYield": 0.44,
    "YearYield": 0.44,
    "Last12MonthYield": 6.27,
    "ISIN": "IL0051099880"
  },
  {
    "Id": "TASE:5135223",
    "MayaId": "5135223",
    "Name": "KSMACTBareket 70/30 IL",
    "ShortName": "KSMACTBareket 70/30 IL",
    "Symbol": "TASE:5135223",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (2B) Bareket 70/30 IL",
    "EnglishLongName": "KSM ACTIVE (2B) Bareket 70/30 IL",
    "HebrewName": "קסם אקטיב ברקת 30/70",
    "HebrewLongName": "קסם אקטיב (2B) ברקת 30/70",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.58,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.5,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 58.6,
    "MonthYield": 2.41,
    "YearYield": 2.41,
    "Last12MonthYield": 17.89,
    "ISIN": "IL0051352230"
  },
  {
    "Id": "TASE:5114228",
    "MayaId": "5114228",
    "Name": "KSMACTBndRatdSecurCompoIL",
    "ShortName": "KSMACTBndRatdSecurCompoIL",
    "Symbol": "TASE:5114228",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (0A)(!) Bond Rated - Security Component IL",
    "EnglishLongName": "KSM ACTIVE (0A)(!) Bond Rated - Security Component IL",
    "HebrewName": "קסםאקטיבאגחמדורגרכיבבטוחה",
    "HebrewLongName": "קסם אקטיב (0A)(!) אג\"ח מדורג - רכיב בטוחה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.87,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.25,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 164.8,
    "MonthYield": 0.62,
    "YearYield": 0.62,
    "Last12MonthYield": 5.28,
    "ISIN": "IL0051142284"
  },
  {
    "Id": "TASE:5125802",
    "MayaId": "5125802",
    "Name": "KSMACTBondupto3Y IL",
    "ShortName": "KSMACTBondupto3Y IL",
    "Symbol": "TASE:5125802",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (0B) Bonds up to 3 Years IL",
    "EnglishLongName": "KSM ACTIVE (0B) Bonds up to 3 Years IL",
    "HebrewName": "קסם אקטיב אג\"ח עד 3 שנים",
    "HebrewLongName": "קסם אקטיב (0B) אג\"ח עד 3 שנים",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.54,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.2,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 244.9,
    "MonthYield": 0.52,
    "YearYield": 0.52,
    "Last12MonthYield": 5.5,
    "ISIN": "IL0051258023"
  },
  {
    "Id": "TASE:5123724",
    "MayaId": "5123724",
    "Name": "KSMACTCorp Bonds Plus IL",
    "ShortName": "KSMACTCorp Bonds Plus IL",
    "Symbol": "TASE:5123724",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (2A) Corporate Bonds Plus IL",
    "EnglishLongName": "KSM ACTIVE (2A) Corporate Bonds Plus IL",
    "HebrewName": "קסם אקטיב אג\"ח חברות פלוס",
    "HebrewLongName": "קסם אקטיב (2A) אג\"ח חברות פלוס",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.3,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.54,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles with Equity",
    "AssetValue": 130.5,
    "MonthYield": 2.13,
    "YearYield": 2.13,
    "Last12MonthYield": 14.64,
    "ISIN": "IL0051237241"
  },
  {
    "Id": "TASE:5112487",
    "MayaId": "5112487",
    "Name": "KSMACTCORPOBONDSBUYSIDEIL",
    "ShortName": "KSMACTCORPOBONDSBUYSIDEIL",
    "Symbol": "TASE:5112487",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (0A)(!) CORPORATE BONDS BUY SIDE IL",
    "EnglishLongName": "KSM ACTIVE (0A)(!) CORPORATE BONDS BUY SIDE IL",
    "HebrewName": "קסם אקטאג\"חקונצרניBuySide",
    "HebrewLongName": "קסם אקטיב (0A)(!) אג\"ח קונצרני Buy Side",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 206.4,
    "MonthYield": 0.76,
    "YearYield": 0.76,
    "Last12MonthYield": 5.73,
    "ISIN": "IL0051124878"
  },
  {
    "Id": "TASE:5121058",
    "MayaId": "5121058",
    "Name": "KSMACTDolLinMoMarkInterTr",
    "ShortName": "KSMACTDolLinMoMarkInterTr",
    "Symbol": "TASE:5121058",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (0D) Dollar Linked Money Market Interest Trend",
    "EnglishLongName": "KSM ACTIVE (0D) Dollar Linked Money Market Interest Trend",
    "HebrewName": "קסם אקטכספדולמגמתריבית",
    "HebrewLongName": "קסם אקטיב (0D) כספית דולר מגמת ריבית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.19,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.17,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "FX Money Market with Corporate",
    "AssetValue": 164.2,
    "MonthYield": -1.23,
    "YearYield": -1.23,
    "Last12MonthYield": -9.88,
    "ISIN": "IL0051210586"
  },
  {
    "Id": "TASE:5101431",
    "MayaId": "5101431",
    "Name": "KSMACTEmergMark",
    "ShortName": "KSMACTEmergMark",
    "Symbol": "TASE:5101431",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (4D) Emerging Markets",
    "EnglishLongName": "KSM ACTIVE (4D) Emerging Markets",
    "HebrewName": "קסם אקטיב שווקים מתעוררים",
    "HebrewLongName": "קסם אקטיב (4D) שווקים מתעוררים",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.95,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.48,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Geographical stocks",
    "AssetValue": 4.1,
    "MonthYield": 2.76,
    "YearYield": 2.76,
    "Last12MonthYield": 9.71,
    "ISIN": "IL0051014319"
  },
  {
    "Id": "TASE:5117973",
    "MayaId": "5117973",
    "Name": "KSMACTEurIndPlus NetFoCur",
    "ShortName": "KSMACTEurIndPlus-NetFoCur",
    "Symbol": "TASE:5117973",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (4A) Europe Index Plus - Neutralized Foreign Currency",
    "EnglishLongName": "KSM ACTIVE (4A) Europe Index Plus - Neutralized Foreign Currency",
    "HebrewName": "קסםאקט אירופIndPl-מנומטח",
    "HebrewLongName": "קסם אקטיב (4A) אירופה Index Plus - מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.25,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.12,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Geographical stocks",
    "AssetValue": 28.2,
    "MonthYield": 3.98,
    "YearYield": 3.98,
    "Last12MonthYield": 24.64,
    "ISIN": "IL0051179732"
  },
  {
    "Id": "TASE:5137278",
    "MayaId": "5137278",
    "Name": "KSMACTEuro MoMark",
    "ShortName": "KSMACTEuro MoMark",
    "Symbol": "TASE:5137278",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (0D) Euro Money Market",
    "EnglishLongName": "KSM ACTIVE (0D) Euro Money Market",
    "HebrewName": "קסם אקטיב כספית אירו",
    "HebrewLongName": "קסם אקטיב (0D) כספית אירו",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.14,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.22,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "FX Money Market with Corporate",
    "AssetValue": 24.8,
    "MonthYield": -2.63,
    "YearYield": -2.63,
    "Last12MonthYield": -1.39,
    "ISIN": "IL0051372782"
  },
  {
    "Id": "TASE:5111661",
    "MayaId": "5111661",
    "Name": "KSMACTGl HYBPort Den in$",
    "ShortName": "KSMACTGl HYBPort-Den in$",
    "Symbol": "TASE:5111661",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (0D)(!) Global HY Bond Portfolio - Denominated in $",
    "EnglishLongName": "KSM ACTIVE (0D)(!) Global HY Bond Portfolio - Denominated in $",
    "HebrewName": "קסם אקט תיק אגח חול HY-נ$",
    "HebrewLongName": "קסם אקטיב (0D)(!) תיק אג\"ח חו\"ל HY – נקובה $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.12,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Bonds",
    "AssetValue": 67.0,
    "MonthYield": -0.4,
    "YearYield": -0.4,
    "Last12MonthYield": -7.62,
    "ISIN": "IL0051116619"
  },
  {
    "Id": "TASE:5100243",
    "MayaId": "5100243",
    "Name": "KSMACTGlobal DivEquities",
    "ShortName": "KSMACTGlobal DivEquities",
    "Symbol": "TASE:5100243",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (4D) Global Dividend Equities",
    "EnglishLongName": "KSM ACTIVE (4D) Global Dividend Equities",
    "HebrewName": "קסםאקט מניותדיבידנדגלובלי",
    "HebrewLongName": "קסם אקטיב (4D) מניות דיבידנד גלובלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.89,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.21,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 57.8,
    "MonthYield": 0.15,
    "YearYield": 0.15,
    "Last12MonthYield": -1.72,
    "ISIN": "IL0051002439"
  },
  {
    "Id": "TASE:5103106",
    "MayaId": "5103106",
    "Name": "KSMACTGlobBdNeutrFreinCur",
    "ShortName": "KSMACTGlobBdNeutrFreinCur",
    "Symbol": "TASE:5103106",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (0A) Global Bonds - Neutralized Foreign Currency",
    "EnglishLongName": "KSM ACTIVE (0A) Global Bonds - Neutralized Foreign Currency",
    "HebrewName": "קסם אקטאג\"ח גלובמנוטרלמטח",
    "HebrewLongName": "קסם אקטיב (0A) אג\"ח גלובלי - מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.5,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX-Protected Bonds",
    "AssetValue": 129.6,
    "MonthYield": 0.38,
    "YearYield": 0.38,
    "Last12MonthYield": 6.16,
    "ISIN": "IL0051031065"
  },
  {
    "Id": "TASE:5118872",
    "MayaId": "5118872",
    "Name": "KSMACTGlobSec NetFoCur",
    "ShortName": "KSMACTGlobSec-NetFoCur",
    "Symbol": "TASE:5118872",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (4A) Global Sectors - Neutralized Foreign Currency",
    "EnglishLongName": "KSM ACTIVE (4A) Global Sectors - Neutralized Foreign Currency",
    "HebrewName": "קסםאקטסקטור חול-מנוטרלמטח",
    "HebrewLongName": "קסם אקטיב (4A) סקטורים חו\"ל - מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.55,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.18,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks by Sectors - Foreign",
    "AssetValue": 70.5,
    "MonthYield": 1.81,
    "YearYield": 1.81,
    "Last12MonthYield": 16.9,
    "ISIN": "IL0051188725"
  },
  {
    "Id": "TASE:5100151",
    "MayaId": "5100151",
    "Name": "KSMACTGlobTecH Giants",
    "ShortName": "KSMACTGlobTecH Giants",
    "Symbol": "TASE:5100151",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (4D) Global Technology Giants",
    "EnglishLongName": "KSM ACTIVE (4D) Global Technology Giants",
    "HebrewName": "קסם אקט ענקיות טכנ חול",
    "HebrewLongName": "קסם אקטיב (4D) ענקיות טכנולוגיה חו\"ל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.94,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.06,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks by Sectors - Foreign",
    "AssetValue": 366.3,
    "MonthYield": -1.05,
    "YearYield": -1.05,
    "Last12MonthYield": 5.66,
    "ISIN": "IL0051001514"
  },
  {
    "Id": "TASE:5114749",
    "MayaId": "5114749",
    "Name": "KSMACTGov Shekel Plus IL",
    "ShortName": "KSMACTGov Shekel Plus IL",
    "Symbol": "TASE:5114749",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (1A) Government Shekel Plus IL",
    "EnglishLongName": "KSM ACTIVE (1A) Government Shekel Plus IL",
    "HebrewName": "קסם אקטיב מדינה שקלי פלוס",
    "HebrewLongName": "קסם אקטיב (1A) מדינה שקלי פלוס",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.62,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.49,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Shekel Bonds - Up to 10% Equity",
    "AssetValue": 107.5,
    "MonthYield": 1.57,
    "YearYield": 1.57,
    "Last12MonthYield": 11.05,
    "ISIN": "IL0051147499"
  },
  {
    "Id": "TASE:5103114",
    "MayaId": "5103114",
    "Name": "KSMACTGovCpi link+10%IL",
    "ShortName": "KSMACTGovCpi-link+10%IL",
    "Symbol": "TASE:5103114",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (1B) Government Cpi-linked + 10% IL",
    "EnglishLongName": "KSM ACTIVE (1B) Government Cpi-linked + 10% IL",
    "HebrewName": "קסם אקט מדינה צמוד + 10%",
    "HebrewLongName": "קסם אקטיב (1B) מדינה צמוד + 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.68,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.23,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked Government Bonds - Up to 10% Equity",
    "AssetValue": 411.1,
    "MonthYield": 0.68,
    "YearYield": 0.68,
    "Last12MonthYield": 7.61,
    "ISIN": "IL0051031149"
  },
  {
    "Id": "TASE:5122031",
    "MayaId": "5122031",
    "Name": "KSMACTGovSheku to 2 y IL",
    "ShortName": "KSMACTGovSheku to 2 y IL",
    "Symbol": "TASE:5122031",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (00) Government Shekel up to 2 years IL",
    "EnglishLongName": "KSM ACTIVE (00) Government Shekel up to 2 years IL",
    "HebrewName": "קסם אקט ממשלי שקליעדשנת",
    "HebrewLongName": "קסם אקטיב (00) ממשלתי שקלי עד שנתיים",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.44,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.1,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Shekel Bonds - No Equity",
    "AssetValue": 100.1,
    "MonthYield": 0.43,
    "YearYield": 0.43,
    "Last12MonthYield": 5.18,
    "ISIN": "IL0051220312"
  },
  {
    "Id": "TASE:5128087",
    "MayaId": "5128087",
    "Name": "KSMACTIMoney Market USD",
    "ShortName": "KSMACTIMoney Market USD",
    "Symbol": "TASE:5128087",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (0D) Money Market USD",
    "EnglishLongName": "KSM ACTIVE (0D) Money Market USD",
    "HebrewName": "קסם אקטיב כספית דולרית",
    "HebrewLongName": "קסם אקטיב (0D) כספית דולרית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.015,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.17,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "FX Money Market with Corporate",
    "AssetValue": 353.9,
    "MonthYield": -1.24,
    "YearYield": -1.24,
    "Last12MonthYield": -9.82,
    "ISIN": "IL0051280878"
  },
  {
    "Id": "TASE:5118898",
    "MayaId": "5118898",
    "Name": "KSMACTIsraelBuySideEquiIL",
    "ShortName": "KSMACTIsraelBuySideEquiIL",
    "Symbol": "TASE:5118898",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (4B) Israel Buy Side Equities IL",
    "EnglishLongName": "KSM ACTIVE (4B) Israel Buy Side Equities IL",
    "HebrewName": "קסםאקטמניותישראל Buy Side",
    "HebrewLongName": "קסם אקטיב (4B) מניות ישראל Buy Side",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.61,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.9,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 115.8,
    "MonthYield": 8.74,
    "YearYield": 8.74,
    "Last12MonthYield": 57.09,
    "ISIN": "IL0051188980"
  },
  {
    "Id": "TASE:5108733",
    "MayaId": "5108733",
    "Name": "KSMACTIVEOPPORBONDSPLUSIL",
    "ShortName": "KSMACTIVEOPPORBONDSPLUSIL",
    "Symbol": "TASE:5108733",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (2B)(!) OPPORTUNITY BONDS PLUS IL",
    "EnglishLongName": "KSM ACTIVE (2B)(!) OPPORTUNITY BONDS PLUS IL",
    "HebrewName": "קסם אקטיבאגחהזדמנויותפלוס",
    "HebrewLongName": "קסם אקטיב (2B)(!) אג\"ח הזדמנויות פלוס",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.34,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.44,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Hi-risk Corporate & Convertibles",
    "AssetValue": 34.0,
    "MonthYield": 2.41,
    "YearYield": 2.41,
    "Last12MonthYield": 14.09,
    "ISIN": "IL0051087331"
  },
  {
    "Id": "TASE:5110382",
    "MayaId": "5110382",
    "Name": "KSMACTMonMarDenomin $",
    "ShortName": "KSMACTMonMarDenomin $",
    "Symbol": "TASE:5110382",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (0D) Money Market Denominated in $",
    "EnglishLongName": "KSM ACTIVE (0D) Money Market Denominated in $",
    "HebrewName": "קסם אקט כספית נקובה דולר",
    "HebrewLongName": "קסם אקטיב (0D) כספית נקובה דולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.16,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "FX Money Market with Corporate",
    "AssetValue": 598.5,
    "MonthYield": -0.93,
    "YearYield": -0.93,
    "Last12MonthYield": -9.51,
    "ISIN": "IL0051103823"
  },
  {
    "Id": "TASE:5127881",
    "MayaId": "5127881",
    "Name": "KSMACTMonMarkExeIL",
    "ShortName": "KSMACTMonMarkExeIL",
    "Symbol": "TASE:5127881",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (00) Money Market Exempt IL",
    "EnglishLongName": "KSM ACTIVE (00) Money Market Exempt IL",
    "HebrewName": "קסם אקטיב כספית פטורה",
    "HebrewLongName": "קסם אקטיב (00) כספית פטורה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.24,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 7236.2,
    "MonthYield": 0.21,
    "YearYield": 0.21,
    "Last12MonthYield": 4.65,
    "ISIN": "IL0051278815"
  },
  {
    "Id": "TASE:5101621",
    "MayaId": "5101621",
    "Name": "KSMACTRa GlobBonds",
    "ShortName": "KSMACTRa GlobBonds",
    "Symbol": "TASE:5101621",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (0D) Rated Global Bonds",
    "EnglishLongName": "KSM ACTIVE (0D) Rated Global Bonds",
    "HebrewName": "קסם אקט אג\"ח גלובלי מדורג",
    "HebrewLongName": "קסם אקטיב (0D) אג\"ח גלובלי מדורג",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.1,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Bond",
    "AssetValue": 84.0,
    "MonthYield": -1.11,
    "YearYield": -1.11,
    "Last12MonthYield": -6.38,
    "ISIN": "IL0051016215"
  },
  {
    "Id": "TASE:5118138",
    "MayaId": "5118138",
    "Name": "KSMACTRated BonIL",
    "ShortName": "KSMACTRated BonIL",
    "Symbol": "TASE:5118138",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (0C) Rated Bonds IL",
    "EnglishLongName": "KSM ACTIVE (0C) Rated Bonds IL",
    "HebrewName": "קסם אקטיב אג\"ח מדורג",
    "HebrewLongName": "קסם אקטיב (0C) אג\"ח מדורג",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.77,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.27,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 295.0,
    "MonthYield": 0.62,
    "YearYield": 0.62,
    "Last12MonthYield": 6.22,
    "ISIN": "IL0051181381"
  },
  {
    "Id": "TASE:5119730",
    "MayaId": "5119730",
    "Name": "KSMACTSapirGlob70/30 Den$",
    "ShortName": "KSMACTSapirGlob70/30-Den$",
    "Symbol": "TASE:5119730",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (2D) Sapir Global 70/30 – Denominated in $",
    "EnglishLongName": "KSM ACTIVE (2D) Sapir Global 70/30 – Denominated in $",
    "HebrewName": "קסם אקט ספ חול 30/70נקו$",
    "HebrewLongName": "קסם אקטיב (2D) ספיר חו\"ל 30/70 - נקובה $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.06,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Bonds",
    "AssetValue": 262.8,
    "MonthYield": -0.05,
    "YearYield": -0.05,
    "Last12MonthYield": -2.92,
    "ISIN": "IL0051197304"
  },
  {
    "Id": "TASE:5137161",
    "MayaId": "5137161",
    "Name": "KSMACTShort Dollar*2",
    "ShortName": "KSMACTShort Dollar*2",
    "Symbol": "TASE:5137161",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (0F) Short Dollar*2",
    "EnglishLongName": "KSM ACTIVE (0F) Short Dollar*2",
    "HebrewName": "קסם אקטיב שורט דולר פי 2",
    "HebrewLongName": "קסם אקטיב (0F) שורט דולר פי 2",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.0,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": true,
      "SHORT": true
    },
    "Price": null,
    "StandardDeviation": 2.43,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Leveraged and Strategic",
    "SecondaryClassification": "Leveraged, High-Risk",
    "AssetValue": 3.5,
    "MonthYield": 2.03,
    "YearYield": 2.03,
    "Last12MonthYield": 30.09,
    "ISIN": "IL0051371610"
  },
  {
    "Id": "TASE:5118062",
    "MayaId": "5118062",
    "Name": "KSMACTTracPor1FIBIB IL",
    "ShortName": "KSMACTTracPor1FIBIB IL",
    "Symbol": "TASE:5118062",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (1B) Tracking Portfolio 1 FIBI Bank IL",
    "EnglishLongName": "KSM ACTIVE (1B) Tracking Portfolio 1 FIBI Bank IL",
    "HebrewName": "קסם אקט עוקבתיק בנק הבינל",
    "HebrewLongName": "קסם אקטיב (1B) עוקבת תיק 1 הבנק הבינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.58,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.21,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 5% Equity",
    "AssetValue": 46.1,
    "MonthYield": 0.64,
    "YearYield": 0.64,
    "Last12MonthYield": 7.25,
    "ISIN": "IL0051180623"
  },
  {
    "Id": "TASE:5118112",
    "MayaId": "5118112",
    "Name": "KSMACTUSA IndPlus Kosher",
    "ShortName": "KSMACTUSA IndPlus Kosher",
    "Symbol": "TASE:5118112",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM ACTIVE (4D) USA Index Plus Kosher",
    "EnglishLongName": "KSM ACTIVE (4D) USA Index Plus Kosher",
    "HebrewName": "קסם אקטארהב IndexPlusכשרה",
    "HebrewLongName": "קסם אקטיב (4D) ארה\"ב Index Plus כשרה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.82,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.63,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Geographical stocks",
    "AssetValue": 267.3,
    "MonthYield": -0.1,
    "YearYield": -0.1,
    "Last12MonthYield": 3.4,
    "ISIN": "IL0051181126"
  },
  {
    "Id": "TASE:5113329",
    "MayaId": "5113329",
    "Name": "KSMKT TEL GOV CPI LIN2 5",
    "ShortName": "KSMKT TEL GOV CPI-LIN2-5",
    "Symbol": "TASE:5113329",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00) Tel Gov-CPI-Linked 2-5",
    "EnglishLongName": "KSM KTF (00) Tel Gov-CPI-Linked 2-5",
    "HebrewName": "קסם KTF תל גוב- צמודות2-5",
    "HebrewLongName": "קסם KTFי (00) תל גוב- צמודות 2-5",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.14,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked",
    "AssetValue": 105.1,
    "MonthYield": 0.13,
    "YearYield": 0.13,
    "Last12MonthYield": 4.28,
    "ISIN": "IL0051133291"
  },
  {
    "Id": "TASE:5118054",
    "MayaId": "5118054",
    "Name": "KSMKT TEL GOV CPI LIN5 10",
    "ShortName": "KSMKT TEL GOV CPI-LIN5-10",
    "Symbol": "TASE:5118054",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00) Tel Gov-CPI-Linked 5-10",
    "EnglishLongName": "KSM KTF (00) Tel Gov-CPI-Linked 5-10",
    "HebrewName": "קסםKTF תל גוב-צמודות 5-10",
    "HebrewLongName": "קסם KTFי (00) תל גוב- צמודות 5-10",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.39,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked",
    "AssetValue": 135.4,
    "MonthYield": -0.13,
    "YearYield": -0.13,
    "Last12MonthYield": 4.96,
    "ISIN": "IL0051180540"
  },
  {
    "Id": "TASE:5138565",
    "MayaId": "5138565",
    "Name": "KSMKTF Bullet N linke26IL",
    "ShortName": "KSMKTF Bullet N-linke26IL",
    "Symbol": "TASE:5138565",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00) Index Bullet Non Linked 2026 IL",
    "EnglishLongName": "KSM KTF (00) Index Bullet Non Linked 2026 IL",
    "HebrewName": "קסם Bullet KTF שקלי 2026",
    "HebrewLongName": "קסם KTF י(00) אינדקס Bullet שקלי 2026",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.14,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 90.6,
    "MonthYield": 0.32,
    "YearYield": 0.32,
    "Last12MonthYield": 5.26,
    "ISIN": "IL0051385651"
  },
  {
    "Id": "TASE:5138573",
    "MayaId": "5138573",
    "Name": "KSMKTF Bullet N linke27IL",
    "ShortName": "KSMKTF Bullet N-linke27IL",
    "Symbol": "TASE:5138573",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00)(!) Index Bullet Non Linked 2027 IL",
    "EnglishLongName": "KSM KTF (00)(!) Index Bullet Non Linked 2027 IL",
    "HebrewName": "קסם Bullet KTF שקלי 27",
    "HebrewLongName": "קסם KTFי (00)(!) אינדקס Bullet שקלי 2027",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.17,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 85.3,
    "MonthYield": 0.44,
    "YearYield": 0.44,
    "Last12MonthYield": 5.87,
    "ISIN": "IL0051385735"
  },
  {
    "Id": "TASE:5138607",
    "MayaId": "5138607",
    "Name": "KSMKTF Bullet N linke29IL",
    "ShortName": "KSMKTF Bullet N-linke29IL",
    "Symbol": "TASE:5138607",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00)(!) Index Bullet Non Linked 2029 IL",
    "EnglishLongName": "KSM KTF (00)(!) Index Bullet Non Linked 2029 IL",
    "HebrewName": "קסם Bullet KTF שקלי 29",
    "HebrewLongName": "קסם KTFי (00)(!) אינדקס Bullet שקלי 2029",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.29,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 80.0,
    "MonthYield": 0.74,
    "YearYield": 0.74,
    "Last12MonthYield": 7.42,
    "ISIN": "IL0051386071"
  },
  {
    "Id": "TASE:5139241",
    "MayaId": "5139241",
    "Name": "KSMKTF IB Bo28 AAA AAi iL",
    "ShortName": "KSMKTF IB-Bo28 AAA-AAi iL",
    "Symbol": "TASE:5139241",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00) Israeli Bullet-Bond 2028 AAA-AA iNDEX IL",
    "EnglishLongName": "KSM KTF (00) Israeli Bullet-Bond 2028 AAA-AA iNDEX IL",
    "HebrewName": "קסם Bul KTF יש AA ומע 28",
    "HebrewLongName": "קסם KTF י(00) אינדקס Bullet ישראל AA ומעלה 2028",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.15,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 32.3,
    "MonthYield": 0.28,
    "YearYield": 0.28,
    "Last12MonthYield": 5.3,
    "ISIN": "IL0051392418"
  },
  {
    "Id": "TASE:5130943",
    "MayaId": "5130943",
    "Name": "KSMKTF IN N.LinIN&FS B IL",
    "ShortName": "KSMKTF IN N.LinIN&FS B-IL",
    "Symbol": "TASE:5130943",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00) Index Non-Linked Insurance & Financial Services Bonds IL",
    "EnglishLongName": "KSM KTF (00) Index Non-Linked Insurance & Financial Services Bonds IL",
    "HebrewName": "קסם KTF אג שק ביט שיר פינ",
    "HebrewLongName": "קסם KTFי (00) אינדקס אג\"ח שקלי ביטוח ושירותים פיננסיים",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.42,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 16.5,
    "MonthYield": 0.95,
    "YearYield": 0.95,
    "Last12MonthYield": 8.88,
    "ISIN": "IL0051309438"
  },
  {
    "Id": "TASE:5113402",
    "MayaId": "5113402",
    "Name": "KSMKTF TEL GOV T BIL",
    "ShortName": "KSMKTF TEL GOV T-BIL",
    "Symbol": "TASE:5113402",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00) Tel Gov T-Bills (MAKAM)",
    "EnglishLongName": "KSM KTF (00) Tel Gov T-Bills (MAKAM)",
    "HebrewName": "קסם KTF תל גוב- מק\"מ",
    "HebrewLongName": "קסם KTFי (00) תל גוב- מק\"מ",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.08,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Non-Linked Government Bonds",
    "AssetValue": 200.4,
    "MonthYield": 0.27,
    "YearYield": 0.27,
    "Last12MonthYield": 4.46,
    "ISIN": "IL0051134026"
  },
  {
    "Id": "TASE:5131347",
    "MayaId": "5131347",
    "Name": "KSMKTFComp Corp50+Gov50IL",
    "ShortName": "KSMKTFComp Corp50+Gov50IL",
    "Symbol": "TASE:5131347",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00) Composite Corp.Bond (50%) Gov.Bond (50%) Monthly IL",
    "EnglishLongName": "KSM KTF (00) Composite Corp.Bond (50%) Gov.Bond (50%) Monthly IL",
    "HebrewName": "קסם KTF מש חברות ומדינה",
    "HebrewLongName": "קסם KTFי (00) משולבת אג\"ח חברות (50%) אג\"ח מדינה (50%) חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.015,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.46,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Composite Bonds",
    "SecondaryClassification": "No Equity",
    "AssetValue": 17.3,
    "MonthYield": 0.46,
    "YearYield": 0.46,
    "Last12MonthYield": 7.78,
    "ISIN": "IL0051313471"
  },
  {
    "Id": "TASE:5118047",
    "MayaId": "5118047",
    "Name": "KSMKTFTEL GOV SHEKEL",
    "ShortName": "KSMKTFTEL GOV SHEKEL",
    "Symbol": "TASE:5118047",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KSM KTF (00) Tel Gov-Shekel",
    "EnglishLongName": "KSM KTF (00) Tel Gov-Shekel",
    "HebrewName": "קסם KTF תל גוב-שקלי",
    "HebrewLongName": "קסם KTFי (00) תל גוב- שקלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.43,
    "Sector": "",
    "Industry": "",
    "ManagerName": "KSM MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Non-Linked Government Bonds",
    "AssetValue": 111.1,
    "MonthYield": 0.85,
    "YearYield": 0.85,
    "Last12MonthYield": 7.89,
    "ISIN": "IL0051180474"
  },
  {
    "Id": "TASE:5126420",
    "MayaId": "5126420",
    "Name": "KVN GMISHA",
    "ShortName": "KVN GMISHA",
    "Symbol": "TASE:5126420",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "KIVUN GEMISHA (DIVERSIFIED FUND) (4D)",
    "EnglishLongName": "KIVUN GEMISHA (DIVERSIFIED FUND) (4D)",
    "HebrewName": "כוון גמישה 4D קרן נאמנות",
    "HebrewLongName": "כוון גמישה (4D) קרן נאמנות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.87,
    "TrusteeFee": 0.045,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.66,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 63.4,
    "MonthYield": 7.05,
    "YearYield": 7.05,
    "Last12MonthYield": 47.67,
    "ISIN": "IL0051264203"
  },
  {
    "Id": "LHIS.TA",
    "MayaId": "826016",
    "Name": "LACHISH",
    "ShortName": "LACHISH INDUSTRIES LTD.",
    "Symbol": "LHIS.TA",
    "TaseSymbol": "LHIS",
    "YahooId": "LHIS.TA",
    "EnglishName": "LACHISH",
    "EnglishLongName": "LACHISH INDUSTRIES LTD.",
    "HebrewName": "לכיש",
    "HebrewLongName": "תעשיות לכיש בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1357.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 14.1,
    "YearYield": 14.1,
    "Last12MonthYield": null,
    "ISIN": "IL0008260163"
  },
  {
    "Id": "LAHAV.TA",
    "MayaId": "136010",
    "Name": "LAHAV",
    "ShortName": "LAHAV L.R. REAL ESTATE LTD",
    "Symbol": "LAHAV.TA",
    "TaseSymbol": "LAHAV",
    "YahooId": "LAHAV.TA",
    "EnglishName": "LAHAV",
    "EnglishLongName": "LAHAV L.R. REAL ESTATE LTD",
    "HebrewName": "להב",
    "HebrewLongName": "להב אל.אר רילאסטייט בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 933.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Investment & Holdings",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 10.5,
    "YearYield": 10.5,
    "Last12MonthYield": null,
    "ISIN": "IL0001360101"
  },
  {
    "Id": "ILDC.TA",
    "MayaId": "612010",
    "Name": "LAND DEV",
    "ShortName": "LAND DEVELOPMENT OF NIMRODI GROUP LTD",
    "Symbol": "ILDC.TA",
    "TaseSymbol": "ILDC",
    "YahooId": "ILDC.TA",
    "EnglishName": "LAND DEV",
    "EnglishLongName": "LAND DEVELOPMENT OF NIMRODI GROUP LTD",
    "HebrewName": "הכשרת הישוב",
    "HebrewLongName": "הכשרת הישוב מקבוצת נמרודי בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3945.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -2.7,
    "YearYield": -2.7,
    "Last12MonthYield": null,
    "ISIN": "IL0006120104"
  },
  {
    "Id": "LAPD.TA",
    "MayaId": "642017",
    "Name": "LAPIDOTH CAP.",
    "ShortName": "LAPIDOTH CAPITAL LTD",
    "Symbol": "LAPD.TA",
    "TaseSymbol": "LAPD",
    "YahooId": "LAPD.TA",
    "EnglishName": "LAPIDOTH   CAP.",
    "EnglishLongName": "LAPIDOTH CAPITAL LTD",
    "HebrewName": "לפידות קפיטל",
    "HebrewLongName": "לפידות קפיטל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 9702.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Investment & Holdings",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 2.5,
    "YearYield": 2.5,
    "Last12MonthYield": null,
    "ISIN": "IL0006420173"
  },
  {
    "Id": "LSCO.TA",
    "MayaId": "1140946",
    "Name": "LESICO",
    "ShortName": "LESICO LTD",
    "Symbol": "LSCO.TA",
    "TaseSymbol": "LSCO",
    "YahooId": "LSCO.TA",
    "EnglishName": "LESICO",
    "EnglishLongName": "LESICO LTD",
    "HebrewName": "לסיכו",
    "HebrewLongName": "לסיכו בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 386.2,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 4.0,
    "YearYield": 4.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011409468"
  },
  {
    "Id": "LUMI.TA",
    "MayaId": "604611",
    "Name": "LEUMI",
    "ShortName": "BANK LEUMI LE- ISRAEL B.M.",
    "Symbol": "LUMI.TA",
    "TaseSymbol": "LUMI",
    "YahooId": "LUMI.TA",
    "EnglishName": "LEUMI",
    "EnglishLongName": "BANK LEUMI LE- ISRAEL B.M.",
    "HebrewName": "לאומי",
    "HebrewLongName": "בנק לאומי לישראל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 7640.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Banks",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 10.3,
    "YearYield": 10.3,
    "Last12MonthYield": null,
    "ISIN": "IL0006046119"
  },
  {
    "Id": "LEOF.TA",
    "MayaId": "200014",
    "Name": "LEVINSKI OFER",
    "ShortName": "LEVINSKI OFER LTD",
    "Symbol": "LEOF.TA",
    "TaseSymbol": "LEOF",
    "YahooId": "LEOF.TA",
    "EnglishName": "LEVINSKI OFER",
    "EnglishLongName": "LEVINSKI OFER LTD",
    "HebrewName": "לוינסקי עופר",
    "HebrewLongName": "לוינסקי עופר בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 472.2,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -3.3,
    "YearYield": -3.3,
    "Last12MonthYield": null,
    "ISIN": "IL0002000144"
  },
  {
    "Id": "LEVI.TA",
    "MayaId": "573014",
    "Name": "LEVINSTEIN ENG",
    "ShortName": "MESHULAM LEVINSTEIN CONSTRUCTING & ENGINEERING LTD",
    "Symbol": "LEVI.TA",
    "TaseSymbol": "LEVI",
    "YahooId": "LEVI.TA",
    "EnglishName": "LEVINSTEIN ENG",
    "EnglishLongName": "MESHULAM LEVINSTEIN CONSTRUCTING & ENGINEERING LTD",
    "HebrewName": "לוינשטין הנדסה",
    "HebrewLongName": "משולם לוינשטין הנדסה וקבלנות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 60210.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 14.6,
    "YearYield": 14.6,
    "Last12MonthYield": null,
    "ISIN": "IL0005730143"
  },
  {
    "Id": "LBTL.TA",
    "MayaId": "584011",
    "Name": "LIBENTAL",
    "ShortName": "A.LIBENTAL HOLDINGS LTD.",
    "Symbol": "LBTL.TA",
    "TaseSymbol": "LBTL",
    "YahooId": "LBTL.TA",
    "EnglishName": "LIBENTAL",
    "EnglishLongName": "A.LIBENTAL HOLDINGS LTD.",
    "HebrewName": "ליבנטל",
    "HebrewLongName": "א.ליבנטל אחזקות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1820.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 3.5,
    "YearYield": 3.5,
    "Last12MonthYield": null,
    "ISIN": "IL0005840116"
  },
  {
    "Id": "LBRA.TA",
    "MayaId": "1176981",
    "Name": "LIBRA",
    "ShortName": "LIBRA INSURANCE COMPANY LTD",
    "Symbol": "LBRA.TA",
    "TaseSymbol": "LBRA",
    "YahooId": "LBRA.TA",
    "EnglishName": "LIBRA",
    "EnglishLongName": "LIBRA INSURANCE COMPANY LTD",
    "HebrewName": "ליברה",
    "HebrewLongName": "ליברה חברה לביטוח בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1751.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Insurance",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -6.2,
    "YearYield": -6.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011769812"
  },
  {
    "Id": "LCTX.TA",
    "MayaId": "1136365",
    "Name": "LINEAGE THERAP",
    "ShortName": "LINEAGE CELL THERAPEUTICS INC.",
    "Symbol": "LCTX.TA",
    "TaseSymbol": "LCTX",
    "YahooId": "LCTX.TA",
    "EnglishName": "LINEAGE THERAP",
    "EnglishLongName": "LINEAGE CELL THERAPEUTICS INC.",
    "HebrewName": "ליניאג תרפיוטיק",
    "HebrewLongName": "ליניאג' סל תרפיוטיקס אינק.",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 540.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.1,
    "YearYield": 1.1,
    "Last12MonthYield": null,
    "ISIN": "US53566P1093"
  },
  {
    "Id": "LPSN.TA",
    "MayaId": "1123017",
    "Name": "LIVEPERSON",
    "ShortName": "LIVEPERSON INC.",
    "Symbol": "LPSN.TA",
    "TaseSymbol": "LPSN",
    "YahooId": "LPSN.TA",
    "EnglishName": "LIVEPERSON",
    "EnglishLongName": "LIVEPERSON INC.",
    "HebrewName": "לייבפרסון",
    "HebrewLongName": "לייבפרסון, אינק.",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 967.3,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -23.2,
    "YearYield": -23.2,
    "Last12MonthYield": null,
    "ISIN": "US5381463091"
  },
  {
    "Id": "LODZ.TA",
    "MayaId": "753012",
    "Name": "LODZIA",
    "ShortName": "LODZIA REAL ESTATE LTD.",
    "Symbol": "LODZ.TA",
    "TaseSymbol": "LODZ",
    "YahooId": "LODZ.TA",
    "EnglishName": "LODZIA",
    "EnglishLongName": "LODZIA REAL ESTATE LTD.",
    "HebrewName": "לודזיה",
    "HebrewLongName": "לודזיה נדל\"ן בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2229.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 3.9,
    "YearYield": 3.9,
    "Last12MonthYield": null,
    "ISIN": "IL0007530129"
  },
  {
    "Id": "LUDN.TA",
    "MayaId": "1081439",
    "Name": "LUDAN",
    "ShortName": "LUDAN ENGINEERING CO. LTD.",
    "Symbol": "LUDN.TA",
    "TaseSymbol": "LUDN",
    "YahooId": "LUDN.TA",
    "EnglishName": "LUDAN",
    "EnglishLongName": "LUDAN ENGINEERING CO. LTD.",
    "HebrewName": "לודן",
    "HebrewLongName": "לודן חברה להנדסה בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1207.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -4.9,
    "YearYield": -4.9,
    "Last12MonthYield": null,
    "ISIN": "IL0010814395"
  },
  {
    "Id": "LUDT.TA",
    "MayaId": "1226992",
    "Name": "LUDAN TECH",
    "ShortName": "LUDAN-TECH (L.K.) LTD",
    "Symbol": "LUDT.TA",
    "TaseSymbol": "LUDT",
    "YahooId": "LUDT.TA",
    "EnglishName": "LUDAN-TECH",
    "EnglishLongName": "LUDAN-TECH (L.K.) LTD",
    "HebrewName": "לודן-טק",
    "HebrewLongName": "לודן-טק (ל.ק.) בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 530.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 5.5,
    "YearYield": 5.5,
    "Last12MonthYield": null,
    "ISIN": "IL0012269929"
  },
  {
    "Id": "LUZN.TA",
    "MayaId": "473017",
    "Name": "LUZON GROUP",
    "ShortName": "AMOS LUZON DEVELOPMENT AND ENERGY GROUP LTD",
    "Symbol": "LUZN.TA",
    "TaseSymbol": "LUZN",
    "YahooId": "LUZN.TA",
    "EnglishName": "LUZON GROUP",
    "EnglishLongName": "AMOS LUZON DEVELOPMENT AND ENERGY GROUP LTD",
    "HebrewName": "לוזון קבוצה",
    "HebrewLongName": "קבוצת עמוס לוזון יזמות ואנרגיה בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 486.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 10.6,
    "YearYield": 10.6,
    "Last12MonthYield": null,
    "ISIN": "IL0004730177"
  },
  {
    "Id": "LURO.TA",
    "MayaId": "1202597",
    "Name": "LUZON RON",
    "ShortName": "LUZON RONSON N.V.",
    "Symbol": "LURO.TA",
    "TaseSymbol": "LURO",
    "YahooId": "LURO.TA",
    "EnglishName": "LUZON RON",
    "EnglishLongName": "LUZON RONSON N.V.",
    "HebrewName": "לוזון רונסון",
    "HebrewLongName": "לוזון רונסון אן.וי.",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2940.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 20.6,
    "YearYield": 20.6,
    "Last12MonthYield": null,
    "ISIN": "IL0012025974"
  },
  {
    "Id": "MGIC.TA",
    "MayaId": "1082312",
    "Name": "MAGIC",
    "ShortName": "MAGIC SOFTWARE ENTERPRISES LTD.",
    "Symbol": "MGIC.TA",
    "TaseSymbol": "MGIC",
    "YahooId": "MGIC.TA",
    "EnglishName": "MAGIC",
    "EnglishLongName": "MAGIC SOFTWARE ENTERPRISES LTD.",
    "HebrewName": "מג'יק",
    "HebrewLongName": "מג'יק תעשיות תכנה בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 8434.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 3.9,
    "YearYield": 3.9,
    "Last12MonthYield": null,
    "ISIN": "IL0010823123"
  },
  {
    "Id": "MLTM.TA",
    "MayaId": "156018",
    "Name": "MALAM TEAM",
    "ShortName": "MALAM-TEAM LTD.",
    "Symbol": "MLTM.TA",
    "TaseSymbol": "MLTM",
    "YahooId": "MLTM.TA",
    "EnglishName": "MALAM TEAM",
    "EnglishLongName": "MALAM-TEAM LTD.",
    "HebrewName": "מלם תים",
    "HebrewLongName": "מלם-תים בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 13620.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 3.4,
    "YearYield": 3.4,
    "Last12MonthYield": null,
    "ISIN": "IL0001560189"
  },
  {
    "Id": "MLTH.TA",
    "MayaId": "731018",
    "Name": "MALAM TEAM HOLD",
    "ShortName": "MALAM-TAEM HOLDINGS LTD.",
    "Symbol": "MLTH.TA",
    "TaseSymbol": "MLTH",
    "YahooId": "MLTH.TA",
    "EnglishName": "MALAM-TEAM HOLD",
    "EnglishLongName": "MALAM-TAEM HOLDINGS LTD.",
    "HebrewName": "מלם-תים אחזקות",
    "HebrewLongName": "מלם-תים אחזקות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 25780.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 2.3,
    "YearYield": 2.3,
    "Last12MonthYield": null,
    "ISIN": "IL0007310183"
  },
  {
    "Id": "MSLA.TA",
    "MayaId": "1106749",
    "Name": "MASLAVI",
    "ShortName": "MASLAVI CONSTRUCTION COMPANY LTD.",
    "Symbol": "MSLA.TA",
    "TaseSymbol": "MSLA",
    "YahooId": "MSLA.TA",
    "EnglishName": "MASLAVI",
    "EnglishLongName": "MASLAVI CONSTRUCTION COMPANY LTD.",
    "HebrewName": "מצלאוי",
    "HebrewLongName": "מצלאוי חברה לבנין בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1691.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 12.6,
    "YearYield": 12.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011067498"
  },
  {
    "Id": "MSVT.TA",
    "MayaId": "1172972",
    "Name": "MASSIVIT",
    "ShortName": "MASSIVIT 3D PRINTING TECHNOLOGIES LTD.",
    "Symbol": "MSVT.TA",
    "TaseSymbol": "MSVT",
    "YahooId": "MSVT.TA",
    "EnglishName": "MASSIVIT",
    "EnglishLongName": "MASSIVIT 3D PRINTING TECHNOLOGIES LTD.",
    "HebrewName": "מאסיבית",
    "HebrewLongName": "מאסיבית טכנולוגיות הדפסה תלת מימד בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 69.3,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.7,
    "YearYield": 1.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011729725"
  },
  {
    "Id": "MTLF.TA",
    "MayaId": "1176791",
    "Name": "MATRICELF",
    "ShortName": "MATRICELF LTD",
    "Symbol": "MTLF.TA",
    "TaseSymbol": "MTLF",
    "YahooId": "MTLF.TA",
    "EnglishName": "MATRICELF",
    "EnglishLongName": "MATRICELF LTD",
    "HebrewName": "מטריסלף",
    "HebrewLongName": "מטריסלף בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 607.9,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 11.0,
    "YearYield": 11.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011767915"
  },
  {
    "Id": "MTRX.TA",
    "MayaId": "445015",
    "Name": "MATRIX",
    "ShortName": "MATRIX IT LTD.",
    "Symbol": "MTRX.TA",
    "TaseSymbol": "MTRX",
    "YahooId": "MTRX.TA",
    "EnglishName": "MATRIX",
    "EnglishLongName": "MATRIX IT LTD.",
    "HebrewName": "מטריקס",
    "HebrewLongName": "מטריקס אי.טי בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 14420.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 6.3,
    "YearYield": 6.3,
    "Last12MonthYield": null,
    "ISIN": "IL0004450156"
  },
  {
    "Id": "MAXO.TA",
    "MayaId": "1168558",
    "Name": "MAX STOCK",
    "ShortName": "MAX STOCK LTD.",
    "Symbol": "MAXO.TA",
    "TaseSymbol": "MAXO",
    "YahooId": "MAXO.TA",
    "EnglishName": "MAX STOCK",
    "EnglishLongName": "MAX STOCK LTD.",
    "HebrewName": "מקס סטוק",
    "HebrewLongName": "מקס סטוק בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2849.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 13.4,
    "YearYield": 13.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011685588"
  },
  {
    "Id": "MTRN.TA",
    "MayaId": "1091065",
    "Name": "MAYTRONICS",
    "ShortName": "MAYTRONICS LTD.",
    "Symbol": "MTRN.TA",
    "TaseSymbol": "MTRN",
    "YahooId": "MTRN.TA",
    "EnglishName": "MAYTRONICS",
    "EnglishLongName": "MAYTRONICS LTD.",
    "HebrewName": "מיטרוניקס",
    "HebrewLongName": "מיטרוניקס בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 369.9,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -7.8,
    "YearYield": -7.8,
    "Last12MonthYield": null,
    "ISIN": "IL0010910656"
  },
  {
    "Id": "MDPR.TA",
    "MayaId": "1139955",
    "Name": "MEDIPOWER 0.1$",
    "ShortName": "MEDI POWER (OVERSEAS) PUBLIC CO LIMITED.",
    "Symbol": "MDPR.TA",
    "TaseSymbol": "MDPR",
    "YahooId": "MDPR.TA",
    "EnglishName": "MEDIPOWER 0.1$",
    "EnglishLongName": "MEDI POWER (OVERSEAS) PUBLIC CO LIMITED.",
    "HebrewName": "מדיפאואר",
    "HebrewLongName": "מדיפאואר (אוברסיס) פאבליק קו. לימיטד",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 675.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -0.4,
    "YearYield": -0.4,
    "Last12MonthYield": null,
    "ISIN": "CY0100361019"
  },
  {
    "Id": "MDTR.TA",
    "MayaId": "1131523",
    "Name": "MEDITR TOWER",
    "ShortName": "MEDITERRANEAN TOWERS LTD",
    "Symbol": "MDTR.TA",
    "TaseSymbol": "MDTR",
    "YahooId": "MDTR.TA",
    "EnglishName": "MEDITR TOWER",
    "EnglishLongName": "MEDITERRANEAN TOWERS LTD",
    "HebrewName": "מגדלי תיכון",
    "HebrewLongName": "מגדלי הים התיכון בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1568.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 12.4,
    "YearYield": 12.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011315236"
  },
  {
    "Id": "MGOR.TA",
    "MayaId": "1104488",
    "Name": "MEGA OR",
    "ShortName": "MEGA OR HOLDINGS LTD",
    "Symbol": "MGOR.TA",
    "TaseSymbol": "MGOR",
    "YahooId": "MGOR.TA",
    "EnglishName": "MEGA OR",
    "EnglishLongName": "MEGA OR HOLDINGS LTD",
    "HebrewName": "מגה אור",
    "HebrewLongName": "מגה אור החזקות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 35350.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 31.0,
    "YearYield": 31.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011044885"
  },
  {
    "Id": "MGDO.TA",
    "MayaId": "1216605",
    "Name": "MEGIDO",
    "ShortName": "MEGIDO Y.K. LTD",
    "Symbol": "MGDO.TA",
    "TaseSymbol": "MGDO",
    "YahooId": "MGDO.TA",
    "EnglishName": "MEGIDO",
    "EnglishLongName": "MEGIDO Y.K. LTD",
    "HebrewName": "מגידו",
    "HebrewLongName": "מגידו י.ק. בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 936.5,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 8.0,
    "YearYield": 8.0,
    "Last12MonthYield": null,
    "ISIN": "IL0012166059"
  },
  {
    "Id": "MEDN.TA",
    "MayaId": "686014",
    "Name": "MEHADRIN",
    "ShortName": "MEHADRIN LTD.",
    "Symbol": "MEDN.TA",
    "TaseSymbol": "MEDN",
    "YahooId": "MEDN.TA",
    "EnglishName": "MEHADRIN",
    "EnglishLongName": "MEHADRIN LTD.",
    "HebrewName": "מהדרין",
    "HebrewLongName": "מהדרין בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 32650.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 7.1,
    "YearYield": 7.1,
    "Last12MonthYield": null,
    "ISIN": "IL0006860147"
  },
  {
    "Id": "TASE:5128632",
    "MayaId": "5128632",
    "Name": "MEITAV ! BNDS TOT RTRN",
    "ShortName": "MEITAV ! BNDS TOT RTRN",
    "Symbol": "TASE:5128632",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Meitav (0B)(!) Bonds Total Return IL",
    "EnglishLongName": "Meitav (0B)(!) Bonds Total Return IL",
    "HebrewName": "מיטב (!) אג\"ח תשואה כוללת",
    "HebrewLongName": "מיטב (0B)(!) אג\"ח תשואה כוללת",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.74,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.2,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 138.5,
    "MonthYield": 0.61,
    "YearYield": 0.61,
    "Last12MonthYield": 6.12,
    "ISIN": "IL0051286321"
  },
  {
    "Id": "TASE:5107131",
    "MayaId": "5107131",
    "Name": "MEITAV ! CORP BNDS",
    "ShortName": "MEITAV ! CORP BNDS",
    "Symbol": "TASE:5107131",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (0B)(!) CORPORATE BONDS IL",
    "EnglishLongName": "MEITAV (0B)(!) CORPORATE BONDS IL",
    "HebrewName": "מיטב (!) אג\"ח חברות",
    "HebrewLongName": "מיטב (0B)(!) אג\"ח חברות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.02,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.21,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 430.7,
    "MonthYield": 0.44,
    "YearYield": 0.44,
    "Last12MonthYield": 5.35,
    "ISIN": "IL0051071319"
  },
  {
    "Id": "TASE:5123948",
    "MayaId": "5123948",
    "Name": "MEITAV ! CORP BOND",
    "ShortName": "MEITAV ! CORP BOND",
    "Symbol": "TASE:5123948",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Meitav (0A)(!) Corporate Bonds IL",
    "EnglishLongName": "Meitav (0A)(!) Corporate Bonds IL",
    "HebrewName": "מיטב (!) אג\"ח קונצרני",
    "HebrewLongName": "מיטב (0A) (!) אג\"ח קונצרני",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.2,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 169.2,
    "MonthYield": 0.33,
    "YearYield": 0.33,
    "Last12MonthYield": 5.22,
    "ISIN": "IL0051239486"
  },
  {
    "Id": "TASE:5114780",
    "MayaId": "5114780",
    "Name": "MEITAV ! GOVT BONDS",
    "ShortName": "MEITAV ! GOVT BONDS",
    "Symbol": "TASE:5114780",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (0B)(!) GOVERNMENT BONDS IL",
    "EnglishLongName": "MEITAV (0B)(!) GOVERNMENT BONDS IL",
    "HebrewName": "מיטב (!) אג\"ח ממשלתי",
    "HebrewLongName": "מיטב (0B)(!) אג\"ח ממשלתי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.84,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - No Equity",
    "AssetValue": 567.9,
    "MonthYield": 0.27,
    "YearYield": 0.27,
    "Last12MonthYield": 6.13,
    "ISIN": "IL0051147804"
  },
  {
    "Id": "TASE:5120738",
    "MayaId": "5120738",
    "Name": "MEITAV ! NIS UPTO 4YRS",
    "ShortName": "MEITAV ! NIS UPTO 4YRS",
    "Symbol": "TASE:5120738",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (0A)(!) NIS CORPORATE TO 4 YEARS IL",
    "EnglishLongName": "MEITAV (0A)(!) NIS CORPORATE TO 4 YEARS IL",
    "HebrewName": "מיטב ! שקלי קונצ עד 4 שנ",
    "HebrewLongName": "מיטב (0A)(!) שקלי קונצרני עד 4 שנים",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.62,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.26,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Shekel Corporate and Convertibles - No Equity",
    "AssetValue": 52.4,
    "MonthYield": 0.82,
    "YearYield": 0.82,
    "Last12MonthYield": 7.57,
    "ISIN": "IL0051207384"
  },
  {
    "Id": "TASE:5105713",
    "MayaId": "5105713",
    "Name": "MEITAV $ BND FRGN FF",
    "ShortName": "MEITAV $ BND FRGN FF",
    "Symbol": "TASE:5105713",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (1D)(!) $ DENOMINATED BOND FOREIGN FUND OF FUNDS",
    "EnglishLongName": "MEITAV (1D)(!) $ DENOMINATED BOND FOREIGN FUND OF FUNDS",
    "HebrewName": "מיטב אגד חוץ BOND נקוב $",
    "HebrewLongName": "מיטב (1D)(!) אגד חוץ BOND נקוב $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.23,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.93,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Fund of Funds",
    "SecondaryClassification": "Foreign Fund of Funds",
    "AssetValue": 24.9,
    "MonthYield": -0.65,
    "YearYield": -0.65,
    "Last12MonthYield": -6.4,
    "ISIN": "IL0051057136"
  },
  {
    "Id": "TASE:5114798",
    "MayaId": "5114798",
    "Name": "MEITAV (!) 90/10",
    "ShortName": "MEITAV (!) 90/10",
    "Symbol": "TASE:5114798",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (1B)(!) 90/10 IL",
    "EnglishLongName": "MEITAV (1B)(!) 90/10 IL",
    "HebrewName": "מיטב ! 10/90",
    "HebrewLongName": "מיטב (1B)(!) י10/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.81,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 461.9,
    "MonthYield": 1.24,
    "YearYield": 1.24,
    "Last12MonthYield": 10.13,
    "ISIN": "IL0051147986"
  },
  {
    "Id": "TASE:5128640",
    "MayaId": "5128640",
    "Name": "MEITAV (!) SELECT CORP BN",
    "ShortName": "MEITAV (!) SELECT CORP BN",
    "Symbol": "TASE:5128640",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Meitav (0B)(!) SELECTED CORPORATE BONDS IL",
    "EnglishLongName": "Meitav (0B)(!) SELECTED CORPORATE BONDS IL",
    "HebrewName": "מיטב (!) נבחרת קונצרני",
    "HebrewLongName": "מיטב (0B)(!) נבחרת קונצרני",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.26,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 654.2,
    "MonthYield": 0.7,
    "YearYield": 0.7,
    "Last12MonthYield": 6.96,
    "ISIN": "IL0051286404"
  },
  {
    "Id": "TASE:5137872",
    "MayaId": "5137872",
    "Name": "MEITAV 10/90 ESG",
    "ShortName": "MEITAV 10/90 ESG",
    "Symbol": "TASE:5137872",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (1B) 10/90 ESG Model IL",
    "EnglishLongName": "MEITAV (1B) 10/90 ESG Model IL",
    "HebrewName": "מיטב 10/90 ESG",
    "HebrewLongName": "מיטב (1B)י 10/90 מודל ESG",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.41,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 151.0,
    "MonthYield": 1.42,
    "YearYield": 1.42,
    "Last12MonthYield": 11.89,
    "ISIN": "IL0051378722"
  },
  {
    "Id": "TASE:5140348",
    "MayaId": "5140348",
    "Name": "MEITAV 15/85 ESG",
    "ShortName": "MEITAV 15/85 ESG",
    "Symbol": "TASE:5140348",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (2B) 15/85 ESG Model IL",
    "EnglishLongName": "MEITAV (2B) 15/85 ESG Model IL",
    "HebrewName": "מיטב 15/85 ESG",
    "HebrewLongName": "מיטב (2B)י 15/85 מודל ESG",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.39,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 15% Equity",
    "AssetValue": 5.0,
    "MonthYield": 1.59,
    "YearYield": 1.59,
    "Last12MonthYield": null,
    "ISIN": "IL0051403488"
  },
  {
    "Id": "TASE:5137880",
    "MayaId": "5137880",
    "Name": "MEITAV 20/80 ESG",
    "ShortName": "MEITAV 20/80 ESG",
    "Symbol": "TASE:5137880",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (2B) 20/80 ESG Model IL",
    "EnglishLongName": "MEITAV (2B) 20/80 ESG Model IL",
    "HebrewName": "מיטב 20/80 ESG",
    "HebrewLongName": "מיטב (2B)י 20/80 מודל ESG",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.54,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 143.5,
    "MonthYield": 2.22,
    "YearYield": 2.22,
    "Last12MonthYield": 15.62,
    "ISIN": "IL0051378805"
  },
  {
    "Id": "TASE:5114079",
    "MayaId": "5114079",
    "Name": "MEITAV 30/70",
    "ShortName": "MEITAV 30/70",
    "Symbol": "TASE:5114079",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (2B) 30/70 IL",
    "EnglishLongName": "MEITAV (2B) 30/70 IL",
    "HebrewName": "מיטב 30/70",
    "HebrewLongName": "מיטב (2B) י30/70",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.67,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 616.6,
    "MonthYield": 2.17,
    "YearYield": 2.17,
    "Last12MonthYield": 17.45,
    "ISIN": "IL0051140791"
  },
  {
    "Id": "TASE:5137898",
    "MayaId": "5137898",
    "Name": "MEITAV 30/70 ESG",
    "ShortName": "MEITAV 30/70 ESG",
    "Symbol": "TASE:5137898",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (2B) 30/70 ESG Model IL",
    "EnglishLongName": "MEITAV (2B) 30/70 ESG Model IL",
    "HebrewName": "מיטב 30/70 ESG",
    "HebrewLongName": "מיטב (2B)י 30/70 מודל ESG",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.56,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 32.0,
    "MonthYield": 2.59,
    "YearYield": 2.59,
    "Last12MonthYield": 18.69,
    "ISIN": "IL0051378987"
  },
  {
    "Id": "TASE:5126065",
    "MayaId": "5126065",
    "Name": "MEITAV 60/40",
    "ShortName": "MEITAV 60/40",
    "Symbol": "TASE:5126065",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (3B) 60/40 IL",
    "EnglishLongName": "MEITAV (3B) 60/40 IL",
    "HebrewName": "מיטב 40/60",
    "HebrewLongName": "מיטב (3B)י 40/60",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.79,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - Max. Exposure over 30% Equity",
    "AssetValue": 281.6,
    "MonthYield": 2.63,
    "YearYield": 2.63,
    "Last12MonthYield": 20.85,
    "ISIN": "IL0051260656"
  },
  {
    "Id": "TASE:5134028",
    "MayaId": "5134028",
    "Name": "MEITAV 75/25 IL",
    "ShortName": "MEITAV 75/25 IL",
    "Symbol": "TASE:5134028",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (2B) 75/25 IL",
    "EnglishLongName": "MEITAV (2B) 75/25 IL",
    "HebrewName": "מיטב 25/75",
    "HebrewLongName": "מיטב (2B)י 25/75",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.56,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 25% Equity",
    "AssetValue": 446.5,
    "MonthYield": 2.22,
    "YearYield": 2.22,
    "Last12MonthYield": 19.39,
    "ISIN": "IL0051340284"
  },
  {
    "Id": "TASE:5102330",
    "MayaId": "5102330",
    "Name": "MEITAV 75/25 INV PORT",
    "ShortName": "MEITAV 75/25 INV PORT",
    "Symbol": "TASE:5102330",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (2B) 75/25 INVESTMENT PORTFOLIO IL",
    "EnglishLongName": "MEITAV (2B) 75/25 INVESTMENT PORTFOLIO IL",
    "HebrewName": "מיטב תיק השקעות 25/75",
    "HebrewLongName": "מיטב (2B) תיק השקעות 25/75",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.56,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 25% Equity",
    "AssetValue": 308.1,
    "MonthYield": 2.06,
    "YearYield": 2.06,
    "Last12MonthYield": 17.06,
    "ISIN": "IL0051023302"
  },
  {
    "Id": "TASE:5122601",
    "MayaId": "5122601",
    "Name": "MEITAV 80/20",
    "ShortName": "MEITAV 80/20",
    "Symbol": "TASE:5122601",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (2B) 80/20 IL",
    "EnglishLongName": "MEITAV (2B) 80/20 IL",
    "HebrewName": "מיטב 20/80",
    "HebrewLongName": "מיטב (2B)י 20/80",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.84,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.53,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 1027.5,
    "MonthYield": 1.57,
    "YearYield": 1.57,
    "Last12MonthYield": 13.83,
    "ISIN": "IL0051226012"
  },
  {
    "Id": "TASE:5107727",
    "MayaId": "5107727",
    "Name": "MEITAV 85/15",
    "ShortName": "MEITAV 85/15",
    "Symbol": "TASE:5107727",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (2B) 85/15 IL",
    "EnglishLongName": "MEITAV (2B) 85/15 IL",
    "HebrewName": "מיטב 15/85",
    "HebrewLongName": "מיטב (2B)י 15/85",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.39,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 15% Equity",
    "AssetValue": 412.9,
    "MonthYield": 1.22,
    "YearYield": 1.22,
    "Last12MonthYield": 10.51,
    "ISIN": "IL0051077274"
  },
  {
    "Id": "TASE:5126347",
    "MayaId": "5126347",
    "Name": "MEITAV 85/15 INV PORT",
    "ShortName": "MEITAV 85/15 INV PORT",
    "Symbol": "TASE:5126347",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (2C) 85/15 INVESTMENT PORTFOLIO IL",
    "EnglishLongName": "MEITAV (2C) 85/15 INVESTMENT PORTFOLIO IL",
    "HebrewName": "מיטב תיק השקעות 15/85",
    "HebrewLongName": "מיטב (2C) תיק השקעות 15/85",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.42,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 15% Equity",
    "AssetValue": 310.1,
    "MonthYield": 1.28,
    "YearYield": 1.28,
    "Last12MonthYield": 11.53,
    "ISIN": "IL0051263478"
  },
  {
    "Id": "TASE:5127923",
    "MayaId": "5127923",
    "Name": "MEITAV 9010 GLOBAL BOND P",
    "ShortName": "MEITAV 9010 GLOBAL BOND P",
    "Symbol": "TASE:5127923",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (1D) 90/10 GLOBAL BOND PORTFOLIO",
    "EnglishLongName": "MEITAV (1D) 90/10 GLOBAL BOND PORTFOLIO",
    "HebrewName": "מיטב 10/90 תיק אגח חול",
    "HebrewLongName": "מיטב (1D)י 10/90 תיק אג\"ח חו\"ל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.97,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Bond",
    "AssetValue": 19.5,
    "MonthYield": -0.73,
    "YearYield": -0.73,
    "Last12MonthYield": -2.39,
    "ISIN": "IL0051279235"
  },
  {
    "Id": "TASE:5119359",
    "MayaId": "5119359",
    "Name": "MEITAV 95/5",
    "ShortName": "MEITAV 95/5",
    "Symbol": "TASE:5119359",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (1A) 95/5 IL",
    "EnglishLongName": "MEITAV (1A) 95/5 IL",
    "HebrewName": "מיטב 5/95",
    "HebrewLongName": "מיטב (1A)י 5/95",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.56,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.23,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 5% Equity",
    "AssetValue": 29.4,
    "MonthYield": 0.52,
    "YearYield": 0.52,
    "Last12MonthYield": 7.74,
    "ISIN": "IL0051193592"
  },
  {
    "Id": "TASE:5141486",
    "MayaId": "5141486",
    "Name": "Meitav Banks InsurCapmark",
    "ShortName": "Meitav Banks InsurCapmark",
    "Symbol": "TASE:5141486",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Meitav (4B) Banks-Insurance And Capital markets IL",
    "EnglishLongName": "Meitav (4B) Banks-Insurance And Capital markets IL",
    "HebrewName": "מיטב בנקים ביטוח שוק ההון",
    "HebrewLongName": "מיטב (4B) בנקים – ביטוח ושוק ההון",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.95,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sectors",
    "AssetValue": 4.3,
    "MonthYield": 8.49,
    "YearYield": 8.49,
    "Last12MonthYield": null,
    "ISIN": "IL0051414865"
  },
  {
    "Id": "TASE:5105143",
    "MayaId": "5105143",
    "Name": "MEITAV BND A AND ABOVE",
    "ShortName": "MEITAV BND A AND ABOVE",
    "Symbol": "TASE:5105143",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (1B) BOND A AND ABOVE IL",
    "EnglishLongName": "MEITAV (1B) BOND A AND ABOVE IL",
    "HebrewName": "מיטב בונד A ומעלה",
    "HebrewLongName": "מיטב (1B) בונד A ומעלה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.02,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.36,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles with Equity",
    "AssetValue": 249.6,
    "MonthYield": 0.95,
    "YearYield": 0.95,
    "Last12MonthYield": 10.87,
    "ISIN": "IL0051051436"
  },
  {
    "Id": "TASE:5126008",
    "MayaId": "5126008",
    "Name": "MEITAV BND TO 5% STCKS",
    "ShortName": "MEITAV BND TO 5% STCKS",
    "Symbol": "TASE:5126008",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (1B) BOND UP TO 5% STOCKS IL",
    "EnglishLongName": "MEITAV (1B) BOND UP TO 5% STOCKS IL",
    "HebrewName": "מיטב אג\"ח עד 5% מניות",
    "HebrewLongName": "מיטב (1B) אג\"ח עד 5% מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.55,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 5% Equity",
    "AssetValue": 111.2,
    "MonthYield": 0.96,
    "YearYield": 0.96,
    "Last12MonthYield": 7.74,
    "ISIN": "IL0051260086"
  },
  {
    "Id": "TASE:5130463",
    "MayaId": "5130463",
    "Name": "MEITAV BND UP TO 4YRS",
    "ShortName": "MEITAV BND UP TO 4YRS",
    "Symbol": "TASE:5130463",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (0A) BOND UP TO 4 YEARS IL",
    "EnglishLongName": "MEITAV (0A) BOND UP TO 4 YEARS IL",
    "HebrewName": "מיטב אג\"ח עד 4 שנים",
    "HebrewLongName": "מיטב (0A) אג\"ח עד 4 שנים",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.27,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 194.8,
    "MonthYield": 0.57,
    "YearYield": 0.57,
    "Last12MonthYield": 6.82,
    "ISIN": "IL0051304637"
  },
  {
    "Id": "TASE:5123138",
    "MayaId": "5123138",
    "Name": "MEITAV BOND",
    "ShortName": "MEITAV BOND",
    "Symbol": "TASE:5123138",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (0B) BOND IL",
    "EnglishLongName": "MEITAV (0B) BOND IL",
    "HebrewName": "מיטב אג\"ח",
    "HebrewLongName": "מיטב (0B) אג\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 542.6,
    "MonthYield": 0.67,
    "YearYield": 0.67,
    "Last12MonthYield": 7.14,
    "ISIN": "IL0051231384"
  },
  {
    "Id": "TASE:5118237",
    "MayaId": "5118237",
    "Name": "MEITAV BOND + 20%",
    "ShortName": "MEITAV BOND + 20%",
    "Symbol": "TASE:5118237",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (2B) Bonds + 20% IL",
    "EnglishLongName": "MEITAV (2B) Bonds + 20% IL",
    "HebrewName": "מיטב אג\"ח + 20%",
    "HebrewLongName": "מיטב (2B) אג\"ח + 20%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.5,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 89.2,
    "MonthYield": 2.03,
    "YearYield": 2.03,
    "Last12MonthYield": 17.53,
    "ISIN": "IL0051182371"
  },
  {
    "Id": "TASE:5140355",
    "MayaId": "5140355",
    "Name": "MEITAV BOND ESG",
    "ShortName": "MEITAV BOND ESG",
    "Symbol": "TASE:5140355",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (0B) Bond ESG Model IL",
    "EnglishLongName": "MEITAV (0B) Bond ESG Model IL",
    "HebrewName": "מיטב אג\"ח ESG",
    "HebrewLongName": "מיטב (0B) אג\"ח מודל ESG",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.31,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 4.6,
    "MonthYield": 0.86,
    "YearYield": 0.86,
    "Last12MonthYield": null,
    "ISIN": "IL0051403553"
  },
  {
    "Id": "TASE:5134036",
    "MayaId": "5134036",
    "Name": "MEITAV BOND NO STOCK",
    "ShortName": "MEITAV BOND NO STOCK",
    "Symbol": "TASE:5134036",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Meitav (0B) Bond Without stocks IL",
    "EnglishLongName": "Meitav (0B) Bond Without stocks IL",
    "HebrewName": "מיטב אגח ללא מניות",
    "HebrewLongName": "מיטב (0B) אג\"ח ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.31,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 300.7,
    "MonthYield": 0.8,
    "YearYield": 0.8,
    "Last12MonthYield": 7.76,
    "ISIN": "IL0051340367"
  },
  {
    "Id": "TASE:5134614",
    "MayaId": "5134614",
    "Name": "MEITAV BondPortf+10% IL",
    "ShortName": "MEITAV BondPortf+10% IL",
    "Symbol": "TASE:5134614",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (1A)(!) Bond Portfolio + 10% IL",
    "EnglishLongName": "MEITAV (1A)(!) Bond Portfolio + 10% IL",
    "HebrewName": "מיטב תיק אגח + 10%",
    "HebrewLongName": "מיטב (1A)(!) תיק אג\"ח + 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.26,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 12.8,
    "MonthYield": 0.93,
    "YearYield": 0.93,
    "Last12MonthYield": 9.78,
    "ISIN": "IL0051346141"
  },
  {
    "Id": "TASE:5134606",
    "MayaId": "5134606",
    "Name": "MEITAV BondPortNoStock IL",
    "ShortName": "MEITAV BondPortNoStock IL",
    "Symbol": "TASE:5134606",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (0A)(!) Bond Portfolio Without Stocks IL",
    "EnglishLongName": "MEITAV (0A)(!) Bond Portfolio Without Stocks IL",
    "HebrewName": "מיטב תיק אגח ללא מניות",
    "HebrewLongName": "מיטב (0A)(!) תיק אג\"ח ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.15,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 19.1,
    "MonthYield": 0.4,
    "YearYield": 0.4,
    "Last12MonthYield": 6.37,
    "ISIN": "IL0051346067"
  },
  {
    "Id": "TASE:5123872",
    "MayaId": "5123872",
    "Name": "MEITAV BONDS + 10%",
    "ShortName": "MEITAV BONDS + 10%",
    "Symbol": "TASE:5123872",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (1A) BONDS + 10% IL",
    "EnglishLongName": "MEITAV (1A) BONDS + 10% IL",
    "HebrewName": "מיטב אג\"ח + 10%",
    "HebrewLongName": "מיטב (1A) אג\"ח + 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 1032.2,
    "MonthYield": 1.17,
    "YearYield": 1.17,
    "Last12MonthYield": 10.68,
    "ISIN": "IL0051238728"
  },
  {
    "Id": "TASE:5113956",
    "MayaId": "5113956",
    "Name": "MEITAV CORP BNDS + 10",
    "ShortName": "MEITAV CORP BNDS + 10",
    "Symbol": "TASE:5113956",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (1B) CORPORATE BONDS + 10% IL",
    "EnglishLongName": "MEITAV (1B) CORPORATE BONDS + 10% IL",
    "HebrewName": "מיטב אגח קונצרני + 10%",
    "HebrewLongName": "מיטב (1B) אג\"ח קונצרני + 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.29,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.36,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles with Equity",
    "AssetValue": 16.7,
    "MonthYield": 1.1,
    "YearYield": 1.1,
    "Last12MonthYield": 8.36,
    "ISIN": "IL0051139561"
  },
  {
    "Id": "TASE:5137799",
    "MayaId": "5137799",
    "Name": "Meitav Corporate A And Up",
    "ShortName": "Meitav Corporate A And Up",
    "Symbol": "TASE:5137799",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Meitav (0B) Corporate Bonds A And Up IL",
    "EnglishLongName": "Meitav (0B) Corporate Bonds A And Up IL",
    "HebrewName": "מיטב אג\"ח קונצרני A ומעלה",
    "HebrewLongName": "מיטב (0B) אג\"ח קונצרני A ומעלה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 221.7,
    "MonthYield": 0.63,
    "YearYield": 0.63,
    "Last12MonthYield": 6.78,
    "ISIN": "IL0051377997"
  },
  {
    "Id": "TASE:5122619",
    "MayaId": "5122619",
    "Name": "MEITAV CPI GOVERNMENT",
    "ShortName": "MEITAV CPI GOVERNMENT",
    "Symbol": "TASE:5122619",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (0B) CPI GOVERNMENT BONDS IL",
    "EnglishLongName": "MEITAV (0B) CPI GOVERNMENT BONDS IL",
    "HebrewName": "מיטב מדינה צמודה",
    "HebrewLongName": "מיטב (0B) מדינה צמודה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.64,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.15,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked Government Bonds - No Equity",
    "AssetValue": 211.5,
    "MonthYield": 0.09,
    "YearYield": 0.09,
    "Last12MonthYield": 4.35,
    "ISIN": "IL0051226194"
  },
  {
    "Id": "TASE:5114830",
    "MayaId": "5114830",
    "Name": "MEITAV CPI GOVT + 10%",
    "ShortName": "MEITAV CPI GOVT + 10%",
    "Symbol": "TASE:5114830",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (1A) CPI LINKED GOVERNMENT + 10% IL",
    "EnglishLongName": "MEITAV (1A) CPI LINKED GOVERNMENT + 10% IL",
    "HebrewName": "מיטב מדינה צמודה+10%",
    "HebrewLongName": "מיטב (1A) מדינה צמודה + 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.19,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked Government Bonds - Up to 10% Equity",
    "AssetValue": 17.9,
    "MonthYield": 0.49,
    "YearYield": 0.49,
    "Last12MonthYield": 6.7,
    "ISIN": "IL0051148307"
  },
  {
    "Id": "TASE:5105580",
    "MayaId": "5105580",
    "Name": "MEITAV FOLOW TIK2 BOND",
    "ShortName": "MEITAV FOLOW TIK2 BOND",
    "Symbol": "TASE:5105580",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Meitav (2B) Following Tik 2 Bank Ben Leumi IL",
    "EnglishLongName": "Meitav (2B) Following Tik 2 Bank Ben Leumi IL",
    "HebrewName": "מיטב עוקבת תיק 2 בינל",
    "HebrewLongName": "מיטב (2B) עוקבת תיק 2 הבנק הבינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.74,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 15% Equity",
    "AssetValue": 450.1,
    "MonthYield": 0.7,
    "YearYield": 0.7,
    "Last12MonthYield": 8.69,
    "ISIN": "IL0051055809"
  },
  {
    "Id": "TASE:5112917",
    "MayaId": "5112917",
    "Name": "MEITAV FOLOW TIK3 BOND",
    "ShortName": "MEITAV FOLOW TIK3 BOND",
    "Symbol": "TASE:5112917",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Meitav (2C) Following Tik 3 Bank Ben Leumi IL",
    "EnglishLongName": "Meitav (2C) Following Tik 3 Bank Ben Leumi IL",
    "HebrewName": "מיטב עוקבת תיק 3 בינל",
    "HebrewLongName": "מיטב (2C) עוקבת תיק 3 הבנק הבינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.37,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 616.1,
    "MonthYield": 1.05,
    "YearYield": 1.05,
    "Last12MonthYield": 10.59,
    "ISIN": "IL0051129174"
  },
  {
    "Id": "TASE:5101951",
    "MayaId": "5101951",
    "Name": "MEITAV GAS AND OIL",
    "ShortName": "MEITAV GAS AND OIL",
    "Symbol": "TASE:5101951",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (4A) GAS AND OIL IL",
    "EnglishLongName": "MEITAV (4A) GAS AND OIL IL",
    "HebrewName": "מיטב גז ונפט",
    "HebrewLongName": "מיטב (4A) גז ונפט",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.05,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.91,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sectors",
    "AssetValue": 77.4,
    "MonthYield": -1.72,
    "YearYield": -1.72,
    "Last12MonthYield": 37.87,
    "ISIN": "IL0051019516"
  },
  {
    "Id": "TASE:5141619",
    "MayaId": "5141619",
    "Name": "Meitav Global Eq Kosher",
    "ShortName": "Meitav Global Eq Kosher",
    "Symbol": "TASE:5141619",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Meitav (4D) Global Equity Kosher",
    "EnglishLongName": "Meitav (4D) Global Equity Kosher",
    "HebrewName": "מיטב מניות גלובלי כשרה",
    "HebrewLongName": "מיטב (4D) מניות גלובלי כשרה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.95,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 3.2,
    "MonthYield": 1.61,
    "YearYield": 1.61,
    "Last12MonthYield": null,
    "ISIN": "IL0051416191"
  },
  {
    "Id": "TASE:5138375",
    "MayaId": "5138375",
    "Name": "Meitav Global Equity",
    "ShortName": "Meitav Global Equity",
    "Symbol": "TASE:5138375",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Meitav (4D) Global Equity",
    "EnglishLongName": "Meitav (4D) Global Equity",
    "HebrewName": "מיטב מניות חול",
    "HebrewLongName": "מיטב (4D) מניות חו\"ל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.5,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.07,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 3.2,
    "MonthYield": 2.01,
    "YearYield": 2.01,
    "Last12MonthYield": 0.42,
    "ISIN": "IL0051383755"
  },
  {
    "Id": "TASE:5101019",
    "MayaId": "5101019",
    "Name": "MEITAV GLOBAL TECH STCKS",
    "ShortName": "MEITAV GLOBAL TECH STCKS",
    "Symbol": "TASE:5101019",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (4D) GLOBAL TECHNOLOGY STOCKS",
    "EnglishLongName": "MEITAV (4D) GLOBAL TECHNOLOGY STOCKS",
    "HebrewName": "מיטב מניות טכנולוגיה חו\"ל",
    "HebrewLongName": "מיטב (4D) מניות טכנולוגיה חו\"ל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.69,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks by Sectors - Foreign",
    "AssetValue": 455.9,
    "MonthYield": -0.68,
    "YearYield": -0.68,
    "Last12MonthYield": 10.78,
    "ISIN": "IL0051010192"
  },
  {
    "Id": "TASE:5134663",
    "MayaId": "5134663",
    "Name": "MEITAV GovBondNoStocksIL",
    "ShortName": "MEITAV GovBondNoStocksIL",
    "Symbol": "TASE:5134663",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (0A) GOVERNMENT BONDS WITHOUT STOCKS IL",
    "EnglishLongName": "MEITAV (0A) GOVERNMENT BONDS WITHOUT STOCKS IL",
    "HebrewName": "מיטב אג\"ח מדינה ללא מניות",
    "HebrewLongName": "מיטב (0A) אג\"ח מדינה ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - No Equity",
    "AssetValue": 292.2,
    "MonthYield": 0.59,
    "YearYield": 0.59,
    "Last12MonthYield": 6.79,
    "ISIN": "IL0051346638"
  },
  {
    "Id": "TASE:5121272",
    "MayaId": "5121272",
    "Name": "MEITAV GOVERNMENT",
    "ShortName": "MEITAV GOVERNMENT",
    "Symbol": "TASE:5121272",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (0B) Government IL",
    "EnglishLongName": "MEITAV (0B) Government IL",
    "HebrewName": "מיטב מדינה",
    "HebrewLongName": "מיטב (0B) מדינה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.26,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - No Equity",
    "AssetValue": 519.9,
    "MonthYield": 0.49,
    "YearYield": 0.49,
    "Last12MonthYield": 5.85,
    "ISIN": "IL0051212723"
  },
  {
    "Id": "TASE:5127931",
    "MayaId": "5127931",
    "Name": "MEITAV GOVERNMENT+ 10%",
    "ShortName": "MEITAV GOVERNMENT+ 10%",
    "Symbol": "TASE:5127931",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (1B) GOVERNMENT + 10% IL",
    "EnglishLongName": "MEITAV (1B) GOVERNMENT + 10% IL",
    "HebrewName": "מיטב מדינה + 10%",
    "HebrewLongName": "מיטב (1B) מדינה + 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - up to 10% Equity",
    "AssetValue": 212.5,
    "MonthYield": 1.27,
    "YearYield": 1.27,
    "Last12MonthYield": 8.94,
    "ISIN": "IL0051279318"
  },
  {
    "Id": "TASE:5111307",
    "MayaId": "5111307",
    "Name": "MEITAV GOVT + 20%",
    "ShortName": "MEITAV GOVT + 20%",
    "Symbol": "TASE:5111307",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (2A) MEDINA+20% IL",
    "EnglishLongName": "MEITAV (2A) MEDINA+20% IL",
    "HebrewName": "מיטב מדינה +20%",
    "HebrewLongName": "מיטב (2A) מדינה + 20%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.38,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bonds - General - Up to 20% Equity",
    "AssetValue": 500.8,
    "MonthYield": 1.43,
    "YearYield": 1.43,
    "Last12MonthYield": 11.93,
    "ISIN": "IL0051113079"
  },
  {
    "Id": "TASE:5107651",
    "MayaId": "5107651",
    "Name": "MEITAV GOVT BND + 10%",
    "ShortName": "MEITAV GOVT BND + 10%",
    "Symbol": "TASE:5107651",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (1A) GOVERNMENT BOND + 10% IL",
    "EnglishLongName": "MEITAV (1A) GOVERNMENT BOND + 10% IL",
    "HebrewName": "מיטב ממשלתי + 10%",
    "HebrewLongName": "מיטב (1A) ממשלתי+ 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - up to 10% Equity",
    "AssetValue": 606.6,
    "MonthYield": 1.26,
    "YearYield": 1.26,
    "Last12MonthYield": 10.37,
    "ISIN": "IL0051076516"
  },
  {
    "Id": "TASE:5113618",
    "MayaId": "5113618",
    "Name": "MEITAV GROWTH SHARES IL",
    "ShortName": "MEITAV GROWTH SHARES IL",
    "Symbol": "TASE:5113618",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (4A) GROWTH SHARES IL",
    "EnglishLongName": "MEITAV (4A) GROWTH SHARES IL",
    "HebrewName": "מיטב מניות צמיחה",
    "HebrewLongName": "מיטב (4A) מניות צמיחה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.69,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.95,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 120.0,
    "MonthYield": 9.31,
    "YearYield": 9.31,
    "Last12MonthYield": 65.03,
    "ISIN": "IL0051136187"
  },
  {
    "Id": "TASE:5106992",
    "MayaId": "5106992",
    "Name": "MEITAV HIGH RISK BND OPS",
    "ShortName": "MEITAV HIGH RISK BND OPS",
    "Symbol": "TASE:5106992",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (0B)(!) MEITAV HIGH RISK BOND OPPORTUNITIES IL",
    "EnglishLongName": "MEITAV (0B)(!) MEITAV HIGH RISK BOND OPPORTUNITIES IL",
    "HebrewName": "מיטב הזד אגח בסיכון גבוה",
    "HebrewLongName": "מיטב (0B)(!) הזדמנויות אג\"ח בסיכון גבוה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.52,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.22,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Hi-risk Corporate & Convertibles",
    "AssetValue": 224.0,
    "MonthYield": 0.23,
    "YearYield": 0.23,
    "Last12MonthYield": 6.04,
    "ISIN": "IL0051069925"
  },
  {
    "Id": "TASE:5118716",
    "MayaId": "5118716",
    "Name": "MEITAV INV PORT +30%",
    "ShortName": "MEITAV INV PORT +30%",
    "Symbol": "TASE:5118716",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (2B) INVESTMENT PORTFOLIO + 30% IL",
    "EnglishLongName": "MEITAV (2B) INVESTMENT PORTFOLIO + 30% IL",
    "HebrewName": "מיטב תיק השקעות + 30%",
    "HebrewLongName": "מיטב (2B) תיק השקעות + 30%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.62,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 457.9,
    "MonthYield": 2.37,
    "YearYield": 2.37,
    "Last12MonthYield": 19.08,
    "ISIN": "IL0051187164"
  },
  {
    "Id": "TASE:5126024",
    "MayaId": "5126024",
    "Name": "MEITAV INV PORT TO 50%",
    "ShortName": "MEITAV INV PORT TO 50%",
    "Symbol": "TASE:5126024",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (3C) INVESTMENT PORTFOLIO UP TO 50% IL",
    "EnglishLongName": "MEITAV (3C) INVESTMENT PORTFOLIO UP TO 50% IL",
    "HebrewName": "מיטב תיק השקעות עד 50%",
    "HebrewLongName": "מיטב (3C) תיק השקעות עד 50%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.78,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.68,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - Max. Exposure over 30% Equity",
    "AssetValue": 267.2,
    "MonthYield": 3.96,
    "YearYield": 3.96,
    "Last12MonthYield": 26.65,
    "ISIN": "IL0051260243"
  },
  {
    "Id": "MTAV.TA",
    "MayaId": "1081843",
    "Name": "MEITAV INVEST",
    "ShortName": "MEITAV INVESTMENT HOUSE LTD",
    "Symbol": "MTAV.TA",
    "TaseSymbol": "MTAV",
    "YahooId": "MTAV.TA",
    "EnglishName": "MEITAV INVEST",
    "EnglishLongName": "MEITAV INVESTMENT HOUSE LTD",
    "HebrewName": "מיטב השקעות",
    "HebrewLongName": "מיטב בית השקעות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 12330.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Financial Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 9.9,
    "YearYield": 9.9,
    "Last12MonthYield": null,
    "ISIN": "IL0010818438"
  },
  {
    "Id": "TASE:5137690",
    "MayaId": "5137690",
    "Name": "Meitav Kaspit WithoutCorp",
    "ShortName": "Meitav Kaspit WithoutCorp",
    "Symbol": "TASE:5137690",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Meitav (00) Kaspit Without Corporate IL",
    "EnglishLongName": "Meitav (00) Kaspit Without Corporate IL",
    "HebrewName": "מיטב כספית שקלית ללא קונ",
    "HebrewLongName": "מיטב (00) כספית שקלית ללא קונצרני",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.14,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 2615.8,
    "MonthYield": 0.21,
    "YearYield": 0.21,
    "Last12MonthYield": 4.46,
    "ISIN": "IL0051376908"
  },
  {
    "Id": "TASE:5108626",
    "MayaId": "5108626",
    "Name": "MEITAV KSHR CPI GVT BN",
    "ShortName": "MEITAV KSHR CPI GVT BN",
    "Symbol": "TASE:5108626",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (1A) CPI KOSHER GOVERNMENT BONDS IL",
    "EnglishLongName": "MEITAV (1A) CPI KOSHER GOVERNMENT BONDS IL",
    "HebrewName": "מיטב מדדית ממשלתית כשרה",
    "HebrewLongName": "מיטב (1A) מדדית ממשלתית כשרה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.95,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.23,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked Government Bonds - Up to 10% Equity",
    "AssetValue": 55.4,
    "MonthYield": 0.76,
    "YearYield": 0.76,
    "Last12MonthYield": 7.21,
    "ISIN": "IL0051086267"
  },
  {
    "Id": "TASE:5135926",
    "MayaId": "5135926",
    "Name": "Meitav Liquid Manag Money",
    "ShortName": "Meitav Liquid Manag Money",
    "Symbol": "TASE:5135926",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Meitav (00) Liquidity Management Money Market IL",
    "EnglishLongName": "Meitav (00) Liquidity Management Money Market IL",
    "HebrewName": "מיטב כספית ניהול נזילות",
    "HebrewLongName": "מיטב (00) כספית ניהול נזילות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.22,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 4768.0,
    "MonthYield": 0.22,
    "YearYield": 0.22,
    "Last12MonthYield": 4.75,
    "ISIN": "IL0051359268"
  },
  {
    "Id": "TASE:5124938",
    "MayaId": "5124938",
    "Name": "MEITAV LONG RUN STCKS IL",
    "ShortName": "MEITAV LONG RUN STCKS IL",
    "Symbol": "TASE:5124938",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (4A) LONG RUN STOCKS IL",
    "EnglishLongName": "MEITAV (4A) LONG RUN STOCKS IL",
    "HebrewName": "מיטב מניות LONG RUN",
    "HebrewLongName": "מיטב (4A) מניות LONG RUN",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.65,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 224.8,
    "MonthYield": 8.98,
    "YearYield": 8.98,
    "Last12MonthYield": 67.99,
    "ISIN": "IL0051249386"
  },
  {
    "Id": "TASE:5114434",
    "MayaId": "5114434",
    "Name": "MEITAV LQID COMP TRACK",
    "ShortName": "MEITAV LQID COMP TRACK",
    "Symbol": "TASE:5114434",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Meitav (0A) Following Liquidity Component Portfolio Bank Ben Leumi IL",
    "EnglishLongName": "Meitav (0A) Following Liquidity Component Portfolio Bank Ben Leumi IL",
    "HebrewName": "מיטב עוקב מרכ נזילות בינל",
    "HebrewLongName": "מיטב (0A) עוקבת תיק מרכיב הנזילות הבנק הבינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.52,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.1,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 256.0,
    "MonthYield": 0.23,
    "YearYield": 0.23,
    "Last12MonthYield": 5.03,
    "ISIN": "IL0051144348"
  },
  {
    "Id": "TASE:5139332",
    "MayaId": "5139332",
    "Name": "Meitav Momentum Shares",
    "ShortName": "Meitav Momentum Shares",
    "Symbol": "TASE:5139332",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Meitav (4B) Momentum Shares IL",
    "EnglishLongName": "Meitav (4B) Momentum Shares IL",
    "HebrewName": "מיטב מניות מומנטום",
    "HebrewLongName": "מיטב (4B) מניות מומנטום",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.05,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.77,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 50.0,
    "MonthYield": 9.48,
    "YearYield": 9.48,
    "Last12MonthYield": 70.1,
    "ISIN": "IL0051393325"
  },
  {
    "Id": "TASE:5123898",
    "MayaId": "5123898",
    "Name": "MEITAV MONEY MARKET F",
    "ShortName": "MEITAV MONEY MARKET F",
    "Symbol": "TASE:5123898",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (00) KASPIT IL",
    "EnglishLongName": "MEITAV (00) KASPIT IL",
    "HebrewName": "מיטב כספית",
    "HebrewLongName": "מיטב (00) כספית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 4631.3,
    "MonthYield": 0.23,
    "YearYield": 0.23,
    "Last12MonthYield": 4.74,
    "ISIN": "IL0051238983"
  },
  {
    "Id": "TASE:5141296",
    "MayaId": "5141296",
    "Name": "Meitav Money Market Jumbo",
    "ShortName": "Meitav Money Market Jumbo",
    "Symbol": "TASE:5141296",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Meitav (00) Money Market Fund Jumbo IL",
    "EnglishLongName": "Meitav (00) Money Market Fund Jumbo IL",
    "HebrewName": "מיטב כספית ג'מבו",
    "HebrewLongName": "מיטב (00) כספית ג'מבו",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.12,
    "TrusteeFee": 0.005,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 26.1,
    "MonthYield": 0.25,
    "YearYield": 0.25,
    "Last12MonthYield": null,
    "ISIN": "IL0051412968"
  },
  {
    "Id": "TASE:5136544",
    "MayaId": "5136544",
    "Name": "Meitav Money Market Kosh",
    "ShortName": "Meitav Money Market Kosh",
    "Symbol": "TASE:5136544",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Meitav (00) Shekel Money Market Kosher IL",
    "EnglishLongName": "Meitav (00) Shekel Money Market Kosher IL",
    "HebrewName": "מיטב כספית שקלית כשרה",
    "HebrewLongName": "מיטב (00) כספית שקלית כשרה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.16,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 7580.4,
    "MonthYield": 0.21,
    "YearYield": 0.21,
    "Last12MonthYield": 4.75,
    "ISIN": "IL0051365448"
  },
  {
    "Id": "TASE:1220227",
    "MayaId": "1220227",
    "Name": "MEITAV MoneyMark 13022026",
    "ShortName": "MEITAV MoneyMark 13022026",
    "Symbol": "TASE:1220227",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (00) Money Market Renews Monthly On 13/02/2026 IL",
    "EnglishLongName": "MEITAV (00) Money Market Renews Monthly On 13/02/2026 IL",
    "HebrewName": "מיטב כספית 13022026 מתחדש",
    "HebrewLongName": "מיטב (00) כספית מתחדשת חודשי ב- 13/02/2026",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.007,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 24.7,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": "IL0012202276"
  },
  {
    "Id": "TASE:5115498",
    "MayaId": "5115498",
    "Name": "MEITAV NIS CORP BOND",
    "ShortName": "MEITAV NIS CORP BOND",
    "Symbol": "TASE:5115498",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (00) NIS CORPORATE IL",
    "EnglishLongName": "MEITAV (00) NIS CORPORATE IL",
    "HebrewName": "מיטב קונצרני שקלי",
    "HebrewLongName": "מיטב (00) קונצרני שקלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.64,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Shekel Corporate and Convertibles - No Equity",
    "AssetValue": 26.3,
    "MonthYield": 0.72,
    "YearYield": 0.72,
    "Last12MonthYield": 7.58,
    "ISIN": "IL0051154982"
  },
  {
    "Id": "TASE:5101563",
    "MayaId": "5101563",
    "Name": "MEITAV NIS GOV KSR BND",
    "ShortName": "MEITAV NIS GOV KSR BND",
    "Symbol": "TASE:5101563",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV(00) NIS GOVT KOSHER BONDS IL",
    "EnglishLongName": "MEITAV(00) NIS GOVT KOSHER BONDS IL",
    "HebrewName": "מיטב מדינה שקלית כשרה",
    "HebrewLongName": "מיטב (00) מדינה שקלית כשרה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.4,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Shekel Bonds - No Equity",
    "AssetValue": 75.3,
    "MonthYield": 0.85,
    "YearYield": 0.85,
    "Last12MonthYield": 7.59,
    "ISIN": "IL0051015639"
  },
  {
    "Id": "TASE:5123120",
    "MayaId": "5123120",
    "Name": "MEITAV NIS UP TO 4YRS",
    "ShortName": "MEITAV NIS UP TO 4YRS",
    "Symbol": "TASE:5123120",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (00) NIS UP TO 4 YEARS IL",
    "EnglishLongName": "MEITAV (00) NIS UP TO 4 YEARS IL",
    "HebrewName": "מיטב מדינה שקלי עד 4 שנים",
    "HebrewLongName": "מיטב (00) מדינה שקלי עד 4 שנים",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.49,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Shekel Bonds - No Equity",
    "AssetValue": 144.6,
    "MonthYield": 0.69,
    "YearYield": 0.69,
    "Last12MonthYield": 6.83,
    "ISIN": "IL0051231202"
  },
  {
    "Id": "TASE:5133822",
    "MayaId": "5133822",
    "Name": "Meitav Port15 ILFF",
    "ShortName": "Meitav Port15 ILFF",
    "Symbol": "TASE:5133822",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Meitav (2B) Portfolio UP TO 15% Stocks Israeli Fund of Funds IL",
    "EnglishLongName": "Meitav (2B) Portfolio UP TO 15% Stocks Israeli Fund of Funds IL",
    "HebrewName": "מיטב תיק15 אגד ישראלי",
    "HebrewLongName": "מיטב (2B) תיק עד 15% מניות- אגד ישראלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.37,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Fund of Funds",
    "SecondaryClassification": "Israeli Fund of Funds",
    "AssetValue": 90.8,
    "MonthYield": 1.39,
    "YearYield": 1.39,
    "Last12MonthYield": 11.18,
    "ISIN": "IL0051338221"
  },
  {
    "Id": "TASE:5133939",
    "MayaId": "5133939",
    "Name": "Meitav PortBond+15",
    "ShortName": "Meitav PortBond+15",
    "Symbol": "TASE:5133939",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Meitav (2A) Portfolio Bond + 15% IL",
    "EnglishLongName": "Meitav (2A) Portfolio Bond + 15% IL",
    "HebrewName": "מיטב תיק אגח + 15",
    "HebrewLongName": "מיטב (2A) תיק אג\"ח + 15%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.35,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 15% Equity",
    "AssetValue": 71.0,
    "MonthYield": 1.53,
    "YearYield": 1.53,
    "Last12MonthYield": 12.39,
    "ISIN": "IL0051339393"
  },
  {
    "Id": "TASE:5133830",
    "MayaId": "5133830",
    "Name": "Meitav PortBond30 ILFF",
    "ShortName": "Meitav PortBond30 ILFF",
    "Symbol": "TASE:5133830",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Meitav (3C) Portfolio Bond UP TO 30% Stocks Israeli Fund of Funds IL",
    "EnglishLongName": "Meitav (3C) Portfolio Bond UP TO 30% Stocks Israeli Fund of Funds IL",
    "HebrewName": "מיטב תיקאגח30 אגד ישראלי",
    "HebrewLongName": "מיטב (3C) תיק עד 30% מניות-אגד ישראלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.55,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Fund of Funds",
    "SecondaryClassification": "Israeli Fund of Funds",
    "AssetValue": 72.4,
    "MonthYield": 2.27,
    "YearYield": 2.27,
    "Last12MonthYield": 17.18,
    "ISIN": "IL0051338304"
  },
  {
    "Id": "TASE:5136163",
    "MayaId": "5136163",
    "Name": "MEITAV RealEst Infrastruc",
    "ShortName": "MEITAV RealEst-Infrastruc",
    "Symbol": "TASE:5136163",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (4B) Real Estate - Infrastructure IL",
    "EnglishLongName": "MEITAV (4B) Real Estate - Infrastructure IL",
    "HebrewName": "מיטב נדל\"ן - תשתיות",
    "HebrewLongName": "מיטב (4B) נדל\"ן - תשתיות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.95,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.81,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sectors",
    "AssetValue": 45.7,
    "MonthYield": 6.42,
    "YearYield": 6.42,
    "Last12MonthYield": 52.66,
    "ISIN": "IL0051361637"
  },
  {
    "Id": "TASE:5100383",
    "MayaId": "5100383",
    "Name": "MEITAV RNK A AND ABOVE",
    "ShortName": "MEITAV RNK A AND ABOVE",
    "Symbol": "TASE:5100383",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (0B) Rated A and Above IL",
    "EnglishLongName": "MEITAV (0B) Rated A and Above IL",
    "HebrewName": "מיטב מדורגות A ומעלה",
    "HebrewLongName": "מיטב (0B) מדורגות A ומעלה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 217.9,
    "MonthYield": 0.54,
    "YearYield": 0.54,
    "Last12MonthYield": 6.44,
    "ISIN": "IL0051003833"
  },
  {
    "Id": "TASE:5123880",
    "MayaId": "5123880",
    "Name": "MEITAV RNK BND NO STKS",
    "ShortName": "MEITAV RNK BND NO STKS",
    "Symbol": "TASE:5123880",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (0A) Agach Medoragot Lelo Menayot IL",
    "EnglishLongName": "MEITAV (0A) Agach Medoragot Lelo Menayot IL",
    "HebrewName": "מיטב אגח מדורג ללא מניות",
    "HebrewLongName": "מיטב (0A) אג\"ח מדורגות ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.17,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 413.0,
    "MonthYield": 0.4,
    "YearYield": 0.4,
    "Last12MonthYield": 5.45,
    "ISIN": "IL0051238801"
  },
  {
    "Id": "TASE:5130455",
    "MayaId": "5130455",
    "Name": "MEITAV RNK CRP BNDTO5Y",
    "ShortName": "MEITAV RNK CRP BNDTO5Y",
    "Symbol": "TASE:5130455",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (0B) RANKED CORPORATE BONDS UP TO 5 YEARS IL",
    "EnglishLongName": "MEITAV (0B) RANKED CORPORATE BONDS UP TO 5 YEARS IL",
    "HebrewName": "מיטב אגח קונצרני מדורג 5ש",
    "HebrewLongName": "מיטב (0B) אג\"ח קונצרני מדורג עד 5 שנים",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.68,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.2,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 104.8,
    "MonthYield": 0.35,
    "YearYield": 0.35,
    "Last12MonthYield": 5.89,
    "ISIN": "IL0051304553"
  },
  {
    "Id": "TASE:5118930",
    "MayaId": "5118930",
    "Name": "Meitav shares ESG IL",
    "ShortName": "Meitav shares ESG IL",
    "Symbol": "TASE:5118930",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Meitav (4B) shares ESG IL",
    "EnglishLongName": "Meitav (4B) shares ESG IL",
    "HebrewName": "מיטב מניות ESG ישראל",
    "HebrewLongName": "מיטב (4B) מניות ESG ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.81,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 221.9,
    "MonthYield": 8.48,
    "YearYield": 8.48,
    "Last12MonthYield": 71.72,
    "ISIN": "IL0051189301"
  },
  {
    "Id": "TASE:5103692",
    "MayaId": "5103692",
    "Name": "MEITAV SKY STOCKS",
    "ShortName": "MEITAV SKY STOCKS",
    "Symbol": "TASE:5103692",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV SKY (4A) stocks IL",
    "EnglishLongName": "MEITAV SKY (4A) stocks IL",
    "HebrewName": "מיטב סקי מניות",
    "HebrewLongName": "מיטב סקיי (4A) מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.59,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.95,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 581.7,
    "MonthYield": 7.59,
    "YearYield": 7.59,
    "Last12MonthYield": 65.32,
    "ISIN": "IL0051036924"
  },
  {
    "Id": "TASE:5120886",
    "MayaId": "5120886",
    "Name": "MEITAV SOLID",
    "ShortName": "MEITAV SOLID",
    "Symbol": "TASE:5120886",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Meitav (0B) Solidit IL",
    "EnglishLongName": "Meitav (0B) Solidit IL",
    "HebrewName": "מיטב סולידית",
    "HebrewLongName": "מיטב (0B) סולידית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.2,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 447.5,
    "MonthYield": 0.33,
    "YearYield": 0.33,
    "Last12MonthYield": 5.46,
    "ISIN": "IL0051208861"
  },
  {
    "Id": "TASE:5123955",
    "MayaId": "5123955",
    "Name": "MEITAV SOLID ISRAEL BONDS",
    "ShortName": "MEITAV SOLID ISRAEL BONDS",
    "Symbol": "TASE:5123955",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (0B) SOLID ISRAEL BONDS IL",
    "EnglishLongName": "MEITAV (0B) SOLID ISRAEL BONDS IL",
    "HebrewName": "מיטב אג\"ח ישראל סולידית",
    "HebrewLongName": "מיטב (0B) אג\"ח ישראל סולידית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.2,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 564.9,
    "MonthYield": 0.31,
    "YearYield": 0.31,
    "Last12MonthYield": 5.61,
    "ISIN": "IL0051239551"
  },
  {
    "Id": "TASE:5127030",
    "MayaId": "5127030",
    "Name": "MEITAV SOLID PLUS",
    "ShortName": "MEITAV SOLID PLUS",
    "Symbol": "TASE:5127030",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (1A) SOLID PLUS IL",
    "EnglishLongName": "MEITAV (1A) SOLID PLUS IL",
    "HebrewName": "מיטב סולידית פלוס",
    "HebrewLongName": "מיטב (1A) סולידית פלוס",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 159.9,
    "MonthYield": 1.12,
    "YearYield": 1.12,
    "Last12MonthYield": 9.0,
    "ISIN": "IL0051270309"
  },
  {
    "Id": "TASE:5104153",
    "MayaId": "5104153",
    "Name": "MEITAV STCKS IL",
    "ShortName": "MEITAV STCKS IL",
    "Symbol": "TASE:5104153",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (4B) STOCKS IL",
    "EnglishLongName": "MEITAV (4B) STOCKS IL",
    "HebrewName": "מיטב מניות ישראל",
    "HebrewLongName": "מיטב (4B) מניות ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.68,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.53,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 214.2,
    "MonthYield": 9.56,
    "YearYield": 9.56,
    "Last12MonthYield": 71.31,
    "ISIN": "IL0051041536"
  },
  {
    "Id": "TASE:5100474",
    "MayaId": "5100474",
    "Name": "MEITAV T.A 125",
    "ShortName": "MEITAV T.A 125",
    "Symbol": "TASE:5100474",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (4A) T.A 125 IL",
    "EnglishLongName": "MEITAV (4A) T.A 125 IL",
    "HebrewName": "מיטב ת״א 125",
    "HebrewLongName": "מיטב (4A) ת״א 125",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.85,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.16,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 1511.8,
    "MonthYield": 9.54,
    "YearYield": 9.54,
    "Last12MonthYield": 77.57,
    "ISIN": "IL0051004740"
  },
  {
    "Id": "TASE:5140504",
    "MayaId": "5140504",
    "Name": "Meitav TA 125 Momentum",
    "ShortName": "Meitav TA 125 Momentum",
    "Symbol": "TASE:5140504",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Meitav (4A) TA 125 Momentum",
    "EnglishLongName": "Meitav (4A) TA 125 Momentum",
    "HebrewName": "מיטב ת\"א 125 מומנטום",
    "HebrewLongName": "מיטב (4A) ת\"א 125 מומנטום",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.05,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.47,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 17.3,
    "MonthYield": 12.43,
    "YearYield": 12.43,
    "Last12MonthYield": null,
    "ISIN": "IL0051405046"
  },
  {
    "Id": "TASE:5103296",
    "MayaId": "5103296",
    "Name": "MEITAV TA MID CAP STOCKS",
    "ShortName": "MEITAV TA MID CAP STOCKS",
    "Symbol": "TASE:5103296",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (4A) TA MID CAP STOCKS IL",
    "EnglishLongName": "MEITAV (4A) TA MID CAP STOCKS IL",
    "HebrewName": "מיטב מניות ת\"א MID CAP",
    "HebrewLongName": "מיטב (4A) מניות ת\"א MID CAP",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 383.4,
    "MonthYield": 7.23,
    "YearYield": 7.23,
    "Last12MonthYield": 57.07,
    "ISIN": "IL0051032964"
  },
  {
    "Id": "TASE:5103767",
    "MayaId": "5103767",
    "Name": "MEITAV TIK1 BOND TRACK",
    "ShortName": "MEITAV TIK1 BOND TRACK",
    "Symbol": "TASE:5103767",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (1B) Following Tik 1 Bank Ben Leumi IL",
    "EnglishLongName": "MEITAV (1B) Following Tik 1 Bank Ben Leumi IL",
    "HebrewName": "מיטב עוקבת תיק 1 בינלאומי",
    "HebrewLongName": "מיטב (1B) עוקבת תיק 1 הבנק הבינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.17,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 5% Equity",
    "AssetValue": 64.5,
    "MonthYield": 0.73,
    "YearYield": 0.73,
    "Last12MonthYield": 6.93,
    "ISIN": "IL0051037674"
  },
  {
    "Id": "MTRD.TA",
    "MayaId": "1203181",
    "Name": "MEITAV TRA",
    "ShortName": "MEITAV TRADE INVESTMENTS LTD",
    "Symbol": "MTRD.TA",
    "TaseSymbol": "MTRD",
    "YahooId": "MTRD.TA",
    "EnglishName": "MEITAV TRA",
    "EnglishLongName": "MEITAV TRADE INVESTMENTS LTD",
    "HebrewName": "מיטב טרייד",
    "HebrewLongName": "מיטב טרייד השקעות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1945.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Financial Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -7.0,
    "YearYield": -7.0,
    "Last12MonthYield": null,
    "ISIN": "IL0012031816"
  },
  {
    "Id": "TASE:5141437",
    "MayaId": "5141437",
    "Name": "Meitav Triple Times TA90",
    "ShortName": "Meitav Triple Times TA90",
    "Symbol": "TASE:5141437",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Meitav (6A) Triple Times TA 90 IL",
    "EnglishLongName": "Meitav (6A) Triple Times TA 90 IL",
    "HebrewName": "מיטב תא 90 פי 3",
    "HebrewLongName": "מיטב (6A) ת\"א 90 פי 3",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.5,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": true,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Leveraged and Strategic",
    "SecondaryClassification": "Leveraged, High-Risk",
    "AssetValue": 0.3,
    "MonthYield": 21.4,
    "YearYield": 21.4,
    "Last12MonthYield": null,
    "ISIN": "IL0051414378"
  },
  {
    "Id": "TASE:5139860",
    "MayaId": "5139860",
    "Name": "Meitav TripleTimes Banks",
    "ShortName": "Meitav TripleTimes Banks",
    "Symbol": "TASE:5139860",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Meitav (6A) Triple Times Banks IL",
    "EnglishLongName": "Meitav (6A) Triple Times Banks IL",
    "HebrewName": "מיטב בנקים פי 3",
    "HebrewLongName": "מיטב (6A) בנקים פי 3",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.5,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": true,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 8.83,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Leveraged and Strategic",
    "SecondaryClassification": "Leveraged, High-Risk",
    "AssetValue": 64.8,
    "MonthYield": 29.91,
    "YearYield": 29.91,
    "Last12MonthYield": null,
    "ISIN": "IL0051398605"
  },
  {
    "Id": "TASE:5102256",
    "MayaId": "5102256",
    "Name": "MEITAV USA STOCKS",
    "ShortName": "MEITAV USA STOCKS",
    "Symbol": "TASE:5102256",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (4D) USA STOCKS",
    "EnglishLongName": "MEITAV (4D) USA STOCKS",
    "HebrewName": "מיטב מניות ארה\"ב",
    "HebrewLongName": "מיטב (4D) מניות ארה\"ב",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.76,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Geographical stocks",
    "AssetValue": 659.4,
    "MonthYield": -0.05,
    "YearYield": -0.05,
    "Last12MonthYield": 1.17,
    "ISIN": "IL0051022569"
  },
  {
    "Id": "MLSR.TA",
    "MayaId": "323014",
    "Name": "MELISRON",
    "ShortName": "MELISRON LTD.",
    "Symbol": "MLSR.TA",
    "TaseSymbol": "MLSR",
    "YahooId": "MLSR.TA",
    "EnglishName": "MELISRON",
    "EnglishLongName": "MELISRON LTD.",
    "HebrewName": "מליסרון",
    "HebrewLongName": "מליסרון בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 43310.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 7.3,
    "YearYield": 7.3,
    "Last12MonthYield": null,
    "ISIN": "IL0003230146"
  },
  {
    "Id": "MNIN.TA",
    "MayaId": "1129444",
    "Name": "MENDELSON IF",
    "ShortName": "MENDELSON INFRASTRUCTURES & INDUSTRIES LTD",
    "Symbol": "MNIN.TA",
    "TaseSymbol": "MNIN",
    "YahooId": "MNIN.TA",
    "EnglishName": "MENDELSON    IF",
    "EnglishLongName": "MENDELSON INFRASTRUCTURES & INDUSTRIES LTD",
    "HebrewName": "מנדלסוןתשת",
    "HebrewLongName": "מנדלסון תשתיות ותעשיות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1630.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 9.3,
    "YearYield": 9.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011294449"
  },
  {
    "Id": "MNIF.TA",
    "MayaId": "1170893",
    "Name": "MENIF",
    "ShortName": "MENIF-FINANCIAL SERVICES LTD",
    "Symbol": "MNIF.TA",
    "TaseSymbol": "MNIF",
    "YahooId": "MNIF.TA",
    "EnglishName": "MENIF",
    "EnglishLongName": "MENIF-FINANCIAL SERVICES LTD",
    "HebrewName": "מניף",
    "HebrewLongName": "מניף-שירותים פיננסיים בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2539.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Financial Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 7.9,
    "YearYield": 7.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011708935"
  },
  {
    "Id": "MNRT.TA",
    "MayaId": "1140573",
    "Name": "MENIVIM REIT",
    "ShortName": "MENIVIM-THE NEW REIT LTD",
    "Symbol": "MNRT.TA",
    "TaseSymbol": "MNRT",
    "YahooId": "MNRT.TA",
    "EnglishName": "MENIVIM REIT",
    "EnglishLongName": "MENIVIM-THE NEW REIT LTD",
    "HebrewName": "מניבים ריט",
    "HebrewLongName": "מניבים קרן הריט החדשה בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 232.9,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.8,
    "YearYield": 1.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011405730"
  },
  {
    "Id": "MMHD.TA",
    "MayaId": "566018",
    "Name": "MENORA MIV HLD",
    "ShortName": "MENORA MIVTACHIM HOLDINGS LTD",
    "Symbol": "MMHD.TA",
    "TaseSymbol": "MMHD",
    "YahooId": "MMHD.TA",
    "EnglishName": "MENORA MIV HLD",
    "EnglishLongName": "MENORA MIVTACHIM HOLDINGS LTD",
    "HebrewName": "מנורה מב החז",
    "HebrewLongName": "מנורה מבטחים החזקות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 39080.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Insurance",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.1,
    "YearYield": 1.1,
    "Last12MonthYield": null,
    "ISIN": "IL0005660183"
  },
  {
    "Id": "CMER.TA",
    "MayaId": "338012",
    "Name": "MER",
    "ShortName": "C. MER INDUSTRIES LTD.",
    "Symbol": "CMER.TA",
    "TaseSymbol": "CMER",
    "YahooId": "CMER.TA",
    "EnglishName": "MER",
    "EnglishLongName": "C. MER INDUSTRIES LTD.",
    "HebrewName": "מר",
    "HebrewLongName": "ח.מר תעשיות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3926.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 13.1,
    "YearYield": 13.1,
    "Last12MonthYield": null,
    "ISIN": "IL0003380123"
  },
  {
    "Id": "MRHL.TA",
    "MayaId": "257014",
    "Name": "MERCHAVIA HOLD",
    "ShortName": "MERCHAVIA HOLDINGS AND INVESTMENTS LTD",
    "Symbol": "MRHL.TA",
    "TaseSymbol": "MRHL",
    "YahooId": "MRHL.TA",
    "EnglishName": "MERCHAVIA HOLD",
    "EnglishLongName": "MERCHAVIA HOLDINGS AND INVESTMENTS LTD",
    "HebrewName": "מרחביה אחזקות",
    "HebrewLongName": "מרחביה אחזקות והשקעות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 171.5,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -10.2,
    "YearYield": -10.2,
    "Last12MonthYield": null,
    "ISIN": "IL0002570146"
  },
  {
    "Id": "MSKE.TA",
    "MayaId": "1166974",
    "Name": "MESHEK ENERGY",
    "ShortName": "MESHEK ENERGY-RENEWABLE ENERGIES LTD",
    "Symbol": "MSKE.TA",
    "TaseSymbol": "MSKE",
    "YahooId": "MSKE.TA",
    "EnglishName": "MESHEK ENERGY",
    "EnglishLongName": "MESHEK ENERGY-RENEWABLE ENERGIES LTD",
    "HebrewName": "משק אנרגיה",
    "HebrewLongName": "משק אנרגיה-אנרגיות מתחדשות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 968.9,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Energy And Oil & Gas Exploration",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 15.7,
    "YearYield": 15.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011669749"
  },
  {
    "Id": "TASE:5126438",
    "MayaId": "5126438",
    "Name": "MGD DUBL NASDAQ",
    "ShortName": "MGD DUBL NASDAQ",
    "Symbol": "TASE:5126438",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (6F) Double NASDAQ - Leveraged Fund",
    "EnglishLongName": "Migdal (6F) Double NASDAQ - Leveraged Fund",
    "HebrewName": "מגדל F6 נאסד\"ק כפליים",
    "HebrewLongName": "מגדל (6F) נאסד\"ק כפליים - קרן ממונפת",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 3.6,
    "TrusteeFee": 0.06,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": true,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.89,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Leveraged and Strategic",
    "SecondaryClassification": "Leveraged, High-Risk",
    "AssetValue": 292.3,
    "MonthYield": 0.86,
    "YearYield": 0.86,
    "Last12MonthYield": 13.58,
    "ISIN": "IL0051264385"
  },
  {
    "Id": "TASE:5131339",
    "MayaId": "5131339",
    "Name": "MGD EMERG MARKT",
    "ShortName": "MGD EMERG MARKT",
    "Symbol": "TASE:5131339",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (4D) Emerging Markets",
    "EnglishLongName": "Migdal (4D) Emerging Markets",
    "HebrewName": "מגדל 4D שווקים מתעוררים",
    "HebrewLongName": "מגדל (4D) שווקים מתעוררים",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.95,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.7,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Geographical stocks",
    "AssetValue": 8.5,
    "MonthYield": 4.63,
    "YearYield": 4.63,
    "Last12MonthYield": 21.85,
    "ISIN": "IL0051313398"
  },
  {
    "Id": "TASE:5123799",
    "MayaId": "5123799",
    "Name": "MGD FLEXIBLE",
    "ShortName": "MGD FLEXIBLE",
    "Symbol": "TASE:5123799",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (4D) Flexible",
    "EnglishLongName": "Migdal (4D) Flexible",
    "HebrewName": "מגדל 4D גמישה",
    "HebrewLongName": "מגדל (4D) גמישה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.75,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.05,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 21.2,
    "MonthYield": 9.89,
    "YearYield": 9.89,
    "Last12MonthYield": 40.46,
    "ISIN": "IL0051237993"
  },
  {
    "Id": "TASE:5103585",
    "MayaId": "5103585",
    "Name": "MGD GLOB BOND $",
    "ShortName": "MGD GLOB BOND $",
    "Symbol": "TASE:5103585",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (0D) $ Global Bonds Denominated in Dollar",
    "EnglishLongName": "Migdal (0D) $ Global Bonds Denominated in Dollar",
    "HebrewName": "מגדל 0D אג\"ח $ בינל נקוב$",
    "HebrewLongName": "מגדל (0D) אג\"ח $ בינלאומי – נקובה דולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.95,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.27,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Bonds",
    "AssetValue": 35.5,
    "MonthYield": -0.88,
    "YearYield": -0.88,
    "Last12MonthYield": -7.21,
    "ISIN": "IL0051035850"
  },
  {
    "Id": "TASE:5104666",
    "MayaId": "5104666",
    "Name": "MGD MIDCAP GRMN",
    "ShortName": "MGD MIDCAP GRMN",
    "Symbol": "TASE:5104666",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (4A) Mid Cap Germany Currency - Hedged",
    "EnglishLongName": "Migdal (4A) Mid Cap Germany Currency - Hedged",
    "HebrewName": "מגדל MID CAP גרמניה ממ",
    "HebrewLongName": "מגדל (4A) יMID CAP גרמניה מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.85,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.85,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Geographical stocks",
    "AssetValue": 7.0,
    "MonthYield": 3.1,
    "YearYield": 3.1,
    "Last12MonthYield": 19.45,
    "ISIN": "IL0051046667"
  },
  {
    "Id": "MGRT.TA",
    "MayaId": "1139195",
    "Name": "MGURIT",
    "ShortName": "MEGUREIT ISRAEL LTD",
    "Symbol": "MGRT.TA",
    "TaseSymbol": "MGRT",
    "YahooId": "MGRT.TA",
    "EnglishName": "MGURIT",
    "EnglishLongName": "MEGUREIT ISRAEL LTD",
    "HebrewName": "מגוריט",
    "HebrewLongName": "מגוריט ישראל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 889.9,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -0.2,
    "YearYield": -0.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011391955"
  },
  {
    "Id": "MIA.TA",
    "MayaId": "494013",
    "Name": "MIA DYNAMICS",
    "ShortName": "MIA DYNAMICS MOTORS LTD",
    "Symbol": "MIA.TA",
    "TaseSymbol": "MIA",
    "YahooId": "MIA.TA",
    "EnglishName": "MIA DYNAMICS",
    "EnglishLongName": "MIA DYNAMICS MOTORS LTD",
    "HebrewName": "מיה דיינמיקס",
    "HebrewLongName": "מיה דיינמיקס מוטורס בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 92.8,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 15.9,
    "YearYield": 15.9,
    "Last12MonthYield": null,
    "ISIN": "IL0004940131"
  },
  {
    "Id": "MCLL.TA",
    "MayaId": "1179753",
    "Name": "MICHLOL FIN",
    "ShortName": "MICHLOL FINANCE",
    "Symbol": "MCLL.TA",
    "TaseSymbol": "MCLL",
    "YahooId": "MCLL.TA",
    "EnglishName": "MICHLOL FIN",
    "EnglishLongName": "MICHLOL FINANCE",
    "HebrewName": "מכלול מימון",
    "HebrewLongName": "מכלול מימון בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1396.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Financial Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -5.3,
    "YearYield": -5.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011797532"
  },
  {
    "Id": "MCPL.TA",
    "MayaId": "1229335",
    "Name": "MICHPAL TECH",
    "ShortName": "MICHPAL TECHNOLOGIES LTD",
    "Symbol": "MCPL.TA",
    "TaseSymbol": "MCPL",
    "YahooId": "MCPL.TA",
    "EnglishName": "MICHPAL TECH",
    "EnglishLongName": "MICHPAL TECHNOLOGIES LTD",
    "HebrewName": "מכפל טכנולוגיות",
    "HebrewLongName": "מיכפל טכנולוגיות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 6746.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 2.3,
    "YearYield": 2.3,
    "Last12MonthYield": null,
    "ISIN": "IL0012293358"
  },
  {
    "Id": "TASE:5140785",
    "MayaId": "5140785",
    "Name": "Migda Mn MrFn No Corp IL",
    "ShortName": "Migda Mn MrFn No Corp IL",
    "Symbol": "TASE:5140785",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (00) Money Market Fund Without Corporate IL",
    "EnglishLongName": "Migdal (00) Money Market Fund Without Corporate IL",
    "HebrewName": "מגדל כספית שקלי ללא קונצ",
    "HebrewLongName": "מגדל (00) כספית שקלית ללא קונצרני",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.06,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 520.3,
    "MonthYield": 0.24,
    "YearYield": 0.24,
    "Last12MonthYield": null,
    "ISIN": "IL0051407851"
  },
  {
    "Id": "TASE:5126990",
    "MayaId": "5126990",
    "Name": "Migdal $ LnkMny Mrk Fund",
    "ShortName": "Migdal $ LnkMny Mrk Fund",
    "Symbol": "TASE:5126990",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (0D) Dollar Linked Money Market Fund",
    "EnglishLongName": "Migdal (0D) Dollar Linked Money Market Fund",
    "HebrewName": "מגדל כספית דולר",
    "HebrewLongName": "מגדל (0D) כספית דולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.16,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "FX Money Market with Corporate",
    "AssetValue": 155.3,
    "MonthYield": -1.23,
    "YearYield": -1.23,
    "Last12MonthYield": -9.9,
    "ISIN": "IL0051269905"
  },
  {
    "Id": "TASE:5106208",
    "MayaId": "5106208",
    "Name": "Migdal (!) 90/10IL",
    "ShortName": "Migdal (!) 90/10IL",
    "Symbol": "TASE:5106208",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (1B)(!) 90/10 IL",
    "EnglishLongName": "Migdal (1B)(!) 90/10 IL",
    "HebrewName": "מגדל (!) 10/90",
    "HebrewLongName": "מגדל (1B)(!)י 10/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 367.6,
    "MonthYield": 1.09,
    "YearYield": 1.09,
    "Last12MonthYield": 11.06,
    "ISIN": "IL0051062086"
  },
  {
    "Id": "TASE:5136668",
    "MayaId": "5136668",
    "Name": "Migdal 15% EQ Fn of Fn IL",
    "ShortName": "Migdal 15% EQ Fn of Fn IL",
    "Symbol": "TASE:5136668",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (2B) Up To 15% Equities Portfolio - Israeli Fund of Funds IL",
    "EnglishLongName": "Migdal (2B) Up To 15% Equities Portfolio - Israeli Fund of Funds IL",
    "HebrewName": "מגדל עד15% מנ אגד ישר",
    "HebrewLongName": "מגדל (2B) תיק עד 15% מניות - אגד ישראלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.42,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Fund of Funds",
    "SecondaryClassification": "Israeli Fund of Funds",
    "AssetValue": 44.0,
    "MonthYield": 1.56,
    "YearYield": 1.56,
    "Last12MonthYield": 10.81,
    "ISIN": "IL0051366685"
  },
  {
    "Id": "TASE:5136650",
    "MayaId": "5136650",
    "Name": "Migdal 30% EQ Fn of Fn IL",
    "ShortName": "Migdal 30% EQ Fn of Fn IL",
    "Symbol": "TASE:5136650",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (2B) Up To 30% Equities Portfolio - Israeli Fund of Funds IL",
    "EnglishLongName": "Migdal (2B) Up To 30% Equities Portfolio - Israeli Fund of Funds IL",
    "HebrewName": "מגדל עד30% מנ אגד ישר",
    "HebrewLongName": "מגדל (2B) תיק עד 30% מניות - אגד ישראלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.67,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Fund of Funds",
    "SecondaryClassification": "Israeli Fund of Funds",
    "AssetValue": 14.1,
    "MonthYield": 2.29,
    "YearYield": 2.29,
    "Last12MonthYield": 15.03,
    "ISIN": "IL0051366503"
  },
  {
    "Id": "TASE:5125422",
    "MayaId": "5125422",
    "Name": "Migdal 70/30 Buy Side IL",
    "ShortName": "Migdal 70/30 Buy Side IL",
    "Symbol": "TASE:5125422",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (2B) 70/30 Buy Side IL",
    "EnglishLongName": "Migdal (2B) 70/30 Buy Side IL",
    "HebrewName": "מגדל 30/70 Buy Side",
    "HebrewLongName": "מגדל (2B)י 30/70 Buy Side",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.79,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 51.6,
    "MonthYield": 2.76,
    "YearYield": 2.76,
    "Last12MonthYield": 18.96,
    "ISIN": "IL0051254220"
  },
  {
    "Id": "TASE:5101191",
    "MayaId": "5101191",
    "Name": "Migdal 75/25 Plus IL",
    "ShortName": "Migdal 75/25 Plus IL",
    "Symbol": "TASE:5101191",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (2B) 75/25 Plus IL",
    "EnglishLongName": "Migdal (2B) 75/25 Plus IL",
    "HebrewName": "מגדל 25/75 פלוס",
    "HebrewLongName": "מגדל (2B)י 25/75 פלוס",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.68,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 25% Equity",
    "AssetValue": 48.8,
    "MonthYield": 2.68,
    "YearYield": 2.68,
    "Last12MonthYield": 16.3,
    "ISIN": "IL0051011919"
  },
  {
    "Id": "TASE:5125414",
    "MayaId": "5125414",
    "Name": "Migdal 80/20 Buy Side IL",
    "ShortName": "Migdal 80/20 Buy Side IL",
    "Symbol": "TASE:5125414",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (2B) 80/20 Buy Side IL",
    "EnglishLongName": "Migdal (2B) 80/20 Buy Side IL",
    "HebrewName": "מגדל 20/80 Buy Side",
    "HebrewLongName": "מגדל (2B)י 20/80 Buy Side",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.73,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.57,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 97.7,
    "MonthYield": 2.28,
    "YearYield": 2.28,
    "Last12MonthYield": 15.33,
    "ISIN": "IL0051254147"
  },
  {
    "Id": "TASE:5118195",
    "MayaId": "5118195",
    "Name": "Migdal 90/10 Plus IL",
    "ShortName": "Migdal 90/10 Plus IL",
    "Symbol": "TASE:5118195",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MIGDAL (1B)(!) 10/90 PLUS IL",
    "EnglishLongName": "MIGDAL (1B)(!) 10/90 PLUS IL",
    "HebrewName": "מגדל 10/90 פלוס",
    "HebrewLongName": "מגדל (1B)(!)י 10/90 פלוס",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 55.3,
    "MonthYield": 0.98,
    "YearYield": 0.98,
    "Last12MonthYield": 9.74,
    "ISIN": "IL0051181951"
  },
  {
    "Id": "TASE:5138532",
    "MayaId": "5138532",
    "Name": "Migdal 90/10 RatedBndIL",
    "ShortName": "Migdal 90/10- RatedBndIL",
    "Symbol": "TASE:5138532",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (1A) 90/10 - Rated Bonds IL",
    "EnglishLongName": "Migdal (1A) 90/10 - Rated Bonds IL",
    "HebrewName": "מגדל 10/90 - אגח מדורג",
    "HebrewLongName": "מגדל (1A)י 10/90 - אג\"ח מדורג",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.49,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.29,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles with Equity",
    "AssetValue": 4.3,
    "MonthYield": 1.11,
    "YearYield": 1.11,
    "Last12MonthYield": 10.31,
    "ISIN": "IL0051385321"
  },
  {
    "Id": "TASE:5125406",
    "MayaId": "5125406",
    "Name": "Migdal 90/10 S Bnd Por IL",
    "ShortName": "Migdal 90/10 S Bnd Por IL",
    "Symbol": "TASE:5125406",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (1B) 90/10 Solid Bonds Portfolio IL",
    "EnglishLongName": "Migdal (1B) 90/10 Solid Bonds Portfolio IL",
    "HebrewName": "מגדל 10/90 תיק אגח סולידי",
    "HebrewLongName": "מגדל (1B)י 10/90 תיק אג\"ח סולידי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.31,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 45.0,
    "MonthYield": 1.04,
    "YearYield": 1.04,
    "Last12MonthYield": 7.93,
    "ISIN": "IL0051254063"
  },
  {
    "Id": "TASE:5105259",
    "MayaId": "5105259",
    "Name": "Migdal Af 85/15 IL",
    "ShortName": "Migdal Af 85/15 IL",
    "Symbol": "TASE:5105259",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal Afikim (2B) 85/15 IL",
    "EnglishLongName": "Migdal Afikim (2B) 85/15 IL",
    "HebrewName": "מגדל אפ 15/85",
    "HebrewLongName": "מגדל אפיקים (2B)י 15/85",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.045,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.39,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 15% Equity",
    "AssetValue": 427.4,
    "MonthYield": 1.45,
    "YearYield": 1.45,
    "Last12MonthYield": 10.58,
    "ISIN": "IL0051052590"
  },
  {
    "Id": "TASE:5108030",
    "MayaId": "5108030",
    "Name": "Migdal Afikim Bonds IL",
    "ShortName": "Migdal Afikim Bonds IL",
    "Symbol": "TASE:5108030",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal Afikim (1B)(!) Bonds IL",
    "EnglishLongName": "Migdal Afikim (1B)(!) Bonds IL",
    "HebrewName": "מגדל אפיקים אג\"ח",
    "HebrewLongName": "מגדל אפיקים (1B)(!) אג\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.78,
    "TrusteeFee": 0.045,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 5% Equity",
    "AssetValue": 130.0,
    "MonthYield": 0.82,
    "YearYield": 0.82,
    "Last12MonthYield": 6.49,
    "ISIN": "IL0051080302"
  },
  {
    "Id": "TASE:5108055",
    "MayaId": "5108055",
    "Name": "Migdal Afikim(!) 90/10 IL",
    "ShortName": "Migdal Afikim(!) 90/10 IL",
    "Symbol": "TASE:5108055",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal Afikim (1C)(!) 90/10 IL",
    "EnglishLongName": "Migdal Afikim (1C)(!) 90/10 IL",
    "HebrewName": "מגדל אפיקים (!) 10/90",
    "HebrewLongName": "מגדל אפיקים (1C)(!) 10/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.045,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.24,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 51.9,
    "MonthYield": 1.18,
    "YearYield": 1.18,
    "Last12MonthYield": 8.5,
    "ISIN": "IL0051080559"
  },
  {
    "Id": "TASE:5131230",
    "MayaId": "5131230",
    "Name": "Migdal Ag $ Global Bond",
    "ShortName": "Migdal Ag $ Global Bond",
    "Symbol": "TASE:5131230",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (0E) Aggressive Dollar Global Bonds",
    "EnglishLongName": "Migdal (0E) Aggressive Dollar Global Bonds",
    "HebrewName": "מגדל דולר אגרסיבי אגח חול",
    "HebrewLongName": "מגדל (0E) דולר אגרסיבית אג\"ח חו\"ל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.37,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.87,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "Dollar Bond",
    "AssetValue": 8.0,
    "MonthYield": -2.19,
    "YearYield": -2.19,
    "Last12MonthYield": -17.29,
    "ISIN": "IL0051312309"
  },
  {
    "Id": "TASE:5131115",
    "MayaId": "5131115",
    "Name": "Migdal B Port Mnth In IL",
    "ShortName": "Migdal B Port Mnth In IL",
    "Symbol": "TASE:5131115",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (2A) Bonds Portfolio – Monthly Income IL",
    "EnglishLongName": "Migdal (2A) Bonds Portfolio – Monthly Income IL",
    "HebrewName": "מגדל תיק אגח הכנסה חודשית",
    "HebrewLongName": "מגדל (2A) תיק אג\"ח - הכנסה חודשית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.18,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.39,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 15% Equity",
    "AssetValue": 33.0,
    "MonthYield": 1.05,
    "YearYield": 1.05,
    "Last12MonthYield": 8.52,
    "ISIN": "IL0051311152"
  },
  {
    "Id": "TASE:5112909",
    "MayaId": "5112909",
    "Name": "Migdal B Rated SecComp IL",
    "ShortName": "Migdal B Rated SecComp IL",
    "Symbol": "TASE:5112909",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (0A)(!) Bond Rated - Security Component IL",
    "EnglishLongName": "Migdal (0A)(!) Bond Rated - Security Component IL",
    "HebrewName": "מגדל אגח מדורג רכיב בטוחה",
    "HebrewLongName": "מגדל (0A)(!) אג\"ח מדורג - רכיב בטוחה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.045,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.21,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 268.2,
    "MonthYield": 0.45,
    "YearYield": 0.45,
    "Last12MonthYield": 5.35,
    "ISIN": "IL0051129091"
  },
  {
    "Id": "TASE:5139183",
    "MayaId": "5139183",
    "Name": "Migdal Banks Equity IL",
    "ShortName": "Migdal Banks Equity IL",
    "Symbol": "TASE:5139183",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (4A) Banks Equity IL",
    "EnglishLongName": "Migdal (4A) Banks Equity IL",
    "HebrewName": "מגדל מניות בנקים",
    "HebrewLongName": "מגדל (4A) מניות בנקים",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.49,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.95,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sectors",
    "AssetValue": 117.3,
    "MonthYield": 9.27,
    "YearYield": 9.27,
    "Last12MonthYield": 71.38,
    "ISIN": "IL0051391832"
  },
  {
    "Id": "TASE:5106547",
    "MayaId": "5106547",
    "Name": "Migdal Bnd Mtrt up2027 IL",
    "ShortName": "Migdal Bnd Mtrt up2027 IL",
    "Symbol": "TASE:5106547",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (0A) Bonds to Maturity up to 2027 IL",
    "EnglishLongName": "Migdal (0A) Bonds to Maturity up to 2027 IL",
    "HebrewName": "מגדל אגח לפדיון עד 2027",
    "HebrewLongName": "מגדל (0A) אג\"ח לפדיון עד 2027",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.55,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.11,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 232.0,
    "MonthYield": 0.28,
    "YearYield": 0.28,
    "Last12MonthYield": 4.79,
    "ISIN": "IL0051065477"
  },
  {
    "Id": "TASE:5112677",
    "MayaId": "5112677",
    "Name": "Migdal Bnd Shk A&High IL",
    "ShortName": "Migdal Bnd Shk A&High IL",
    "Symbol": "TASE:5112677",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (00) Shekel Bond A & Higher IL",
    "EnglishLongName": "Migdal (00) Shekel Bond A & Higher IL",
    "HebrewName": "מגדל בונד שקלי A ומעלה",
    "HebrewLongName": "מגדל (00) בונד שקלי A ומעלה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.74,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.29,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Shekel Corporate and Convertibles - No Equity",
    "AssetValue": 113.0,
    "MonthYield": 0.76,
    "YearYield": 0.76,
    "Last12MonthYield": 6.31,
    "ISIN": "IL0051126774"
  },
  {
    "Id": "TASE:5131099",
    "MayaId": "5131099",
    "Name": "Migdal Bond up20% Eq IL",
    "ShortName": "Migdal Bond up20% Eq IL",
    "Symbol": "TASE:5131099",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (2B) Bonds & up to 20% Equity IL",
    "EnglishLongName": "Migdal (2B) Bonds & up to 20% Equity IL",
    "HebrewName": "מגדל אג\"ח ומניות עד 20%",
    "HebrewLongName": "מגדל (‏‎2B‎‏) אג\"ח ומניות עד 20%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.44,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 96.1,
    "MonthYield": 1.46,
    "YearYield": 1.46,
    "Last12MonthYield": 11.33,
    "ISIN": "IL0051310998"
  },
  {
    "Id": "TASE:5103676",
    "MayaId": "5103676",
    "Name": "Migdal Bond Wout Stock IL",
    "ShortName": "Migdal Bond Wout Stock IL",
    "Symbol": "TASE:5103676",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (00) Bonds Without Stocks IL",
    "EnglishLongName": "Migdal (00) Bonds Without Stocks IL",
    "HebrewName": "מגדל אג\"ח ללא מניות",
    "HebrewLongName": "מגדל (00) אג\"ח ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 224.6,
    "MonthYield": 0.7,
    "YearYield": 0.7,
    "Last12MonthYield": 7.26,
    "ISIN": "IL0051036767"
  },
  {
    "Id": "TASE:5138391",
    "MayaId": "5138391",
    "Name": "Migdal Bonds up to 2030IL",
    "ShortName": "Migdal Bonds up to 2030IL",
    "Symbol": "TASE:5138391",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (0A) Bonds to Maturity up to 2030 IL",
    "EnglishLongName": "Migdal (0A) Bonds to Maturity up to 2030 IL",
    "HebrewName": "מגדל אגח לפדיון עד 2030",
    "HebrewLongName": "מגדל (0A) אג\"ח לפדיון עד 2030",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.49,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.24,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 59.0,
    "MonthYield": 0.47,
    "YearYield": 0.47,
    "Last12MonthYield": 6.44,
    "ISIN": "IL0051383912"
  },
  {
    "Id": "TASE:5125687",
    "MayaId": "5125687",
    "Name": "Migdal Buy Side Bonds",
    "ShortName": "Migdal Buy Side Bonds",
    "Symbol": "TASE:5125687",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (0B)(!) Buy Side Bonds",
    "EnglishLongName": "Migdal (0B)(!) Buy Side Bonds",
    "HebrewName": "מגדל אג\"ח Buy Side",
    "HebrewLongName": "מגדל (0B)(!) אג\"ח Buy Side",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 52.7,
    "MonthYield": 0.7,
    "YearYield": 0.7,
    "Last12MonthYield": 6.27,
    "ISIN": "IL0051256878"
  },
  {
    "Id": "TASE:5131438",
    "MayaId": "5131438",
    "Name": "Migdal China",
    "ShortName": "Migdal China",
    "Symbol": "TASE:5131438",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (4D) China",
    "EnglishLongName": "Migdal (4D) China",
    "HebrewName": "מגדל סין",
    "HebrewLongName": "מגדל (4D) סין",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.25,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.07,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Geographical stocks",
    "AssetValue": 10.8,
    "MonthYield": 3.68,
    "YearYield": 3.68,
    "Last12MonthYield": 18.29,
    "ISIN": "IL0051314388"
  },
  {
    "Id": "TASE:5104849",
    "MayaId": "5104849",
    "Name": "Migdal Co Bonds IL",
    "ShortName": "Migdal Co Bonds IL",
    "Symbol": "TASE:5104849",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (0A)(!) Coporate Bonds IL",
    "EnglishLongName": "Migdal (0A)(!) Coporate Bonds IL",
    "HebrewName": "מגדל אג\"ח חברות",
    "HebrewLongName": "מגדל (0A)(!) אג\"ח חברות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.88,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 384.4,
    "MonthYield": 0.7,
    "YearYield": 0.7,
    "Last12MonthYield": 6.41,
    "ISIN": "IL0051048499"
  },
  {
    "Id": "TASE:5130224",
    "MayaId": "5130224",
    "Name": "Migdal Corp Bonds + 25%IL",
    "ShortName": "Migdal Corp Bonds + 25%IL",
    "Symbol": "TASE:5130224",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (2A) Corporate Bonds + 25% IL",
    "EnglishLongName": "Migdal (2A) Corporate Bonds + 25% IL",
    "HebrewName": "מגדל אגח חברות + 25%",
    "HebrewLongName": "מגדל (2A) אג\"ח חברות + 25%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.36,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles with Equity",
    "AssetValue": 19.6,
    "MonthYield": 1.38,
    "YearYield": 1.38,
    "Last12MonthYield": 9.86,
    "ISIN": "IL0051302243"
  },
  {
    "Id": "TASE:5125695",
    "MayaId": "5125695",
    "Name": "Migdal CorpBonds BS+10%IL",
    "ShortName": "Migdal CorpBonds BS+10%IL",
    "Symbol": "TASE:5125695",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (1A)(!) Corporate Bonds Buy Side +10% IL",
    "EnglishLongName": "Migdal (1A)(!) Corporate Bonds Buy Side +10% IL",
    "HebrewName": "מגדל אגחחברות 10%+BuySide",
    "HebrewLongName": "מגדל (1A)(!) אג\"ח חברות Buy Sideי + 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.38,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles with Equity",
    "AssetValue": 542.7,
    "MonthYield": 0.89,
    "YearYield": 0.89,
    "Last12MonthYield": 9.85,
    "ISIN": "IL0051256951"
  },
  {
    "Id": "TASE:5106190",
    "MayaId": "5106190",
    "Name": "Migdal Corporate Portf IL",
    "ShortName": "Migdal Corporate Portf IL",
    "Symbol": "TASE:5106190",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (1A)(!) Corporate Portfolio IL",
    "EnglishLongName": "Migdal (1A)(!) Corporate Portfolio IL",
    "HebrewName": "מגדל ת. השקעות קונצ ישראל",
    "HebrewLongName": "מגדל (1A)(!) תיק השקעות קונצרני ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.52,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.31,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles with Equity",
    "AssetValue": 83.5,
    "MonthYield": 0.59,
    "YearYield": 0.59,
    "Last12MonthYield": 5.98,
    "ISIN": "IL0051061906"
  },
  {
    "Id": "TASE:5116926",
    "MayaId": "5116926",
    "Name": "Migdal CPI link R Bond IL",
    "ShortName": "Migdal CPI-link R Bond IL",
    "Symbol": "TASE:5116926",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (0A) CPI-linked Rated Bonds IL",
    "EnglishLongName": "Migdal (0A) CPI-linked Rated Bonds IL",
    "HebrewName": "מגדל צמודה בונד מדורג",
    "HebrewLongName": "מגדל0A) ‎) צמודה בונד מדורג",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.23,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 989.9,
    "MonthYield": 0.38,
    "YearYield": 0.38,
    "Last12MonthYield": 5.72,
    "ISIN": "IL0051169261"
  },
  {
    "Id": "TASE:5117932",
    "MayaId": "5117932",
    "Name": "Migdal CPI Lnk Bnd A&H IL",
    "ShortName": "Migdal CPI-Lnk Bnd A&H IL",
    "Symbol": "TASE:5117932",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (00) CPI-Linked Bond A & Higher IL",
    "EnglishLongName": "Migdal (00) CPI-Linked Bond A & Higher IL",
    "HebrewName": "מגדל בונד צמוד A ומעלה",
    "HebrewLongName": "מגדל (00) בונד צמוד A ומעלה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 426.1,
    "MonthYield": 0.45,
    "YearYield": 0.45,
    "Last12MonthYield": 6.5,
    "ISIN": "IL0051179328"
  },
  {
    "Id": "TASE:5115001",
    "MayaId": "5115001",
    "Name": "Migdal Deno in Dollar",
    "ShortName": "Migdal Deno in Dollar",
    "Symbol": "TASE:5115001",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "$ Migdal (0D) Money Market Fund Denominated in Dollar",
    "EnglishLongName": "$ Migdal (0D) Money Market Fund Denominated in Dollar",
    "HebrewName": "מגדל כספית נקובה בדולר",
    "HebrewLongName": "מגדל (0D) כספית נקובה בדולר $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.249,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.18,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "FX Money Market with Corporate",
    "AssetValue": 334.8,
    "MonthYield": -0.93,
    "YearYield": -0.93,
    "Last12MonthYield": -9.52,
    "ISIN": "IL0051150014"
  },
  {
    "Id": "TASE:5116165",
    "MayaId": "5116165",
    "Name": "Migdal Gl Inv Tech St HD",
    "ShortName": "Migdal Gl Inv Tech St HD",
    "Symbol": "TASE:5116165",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (4A) Global Innovative Technologies Stocks Currency – Hedged",
    "EnglishLongName": "Migdal (4A) Global Innovative Technologies Stocks Currency – Hedged",
    "HebrewName": "מגדל מניות חול טכנ חדש ממ",
    "HebrewLongName": "מגדל (4A) מניות חו\"ל טכנולוגיות חדשניות - מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.95,
    "TrusteeFee": 0.06,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.49,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 53.3,
    "MonthYield": 1.44,
    "YearYield": 1.44,
    "Last12MonthYield": 23.63,
    "ISIN": "IL0051161656"
  },
  {
    "Id": "TASE:5138284",
    "MayaId": "5138284",
    "Name": "Migdal GLBonds up to 2030",
    "ShortName": "Migdal GLBonds up to 2030",
    "Symbol": "TASE:5138284",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (0D) Global Bonds to Maturity up to 2030",
    "EnglishLongName": "Migdal (0D) Global Bonds to Maturity up to 2030",
    "HebrewName": "מגדל אגח בינלאומי עד 2030",
    "HebrewLongName": "מגדל (0D) אגח בינלאומי לפדיון עד 2030",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.56,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.1,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "Dollar Bond",
    "AssetValue": 34.6,
    "MonthYield": -1.27,
    "YearYield": -1.27,
    "Last12MonthYield": -6.94,
    "ISIN": "IL0051382849"
  },
  {
    "Id": "TASE:5131313",
    "MayaId": "5131313",
    "Name": "Migdal Glob Cyber Equity",
    "ShortName": "Migdal Glob Cyber Equity",
    "Symbol": "TASE:5131313",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (4D) Global Cyber Equity",
    "EnglishLongName": "Migdal (4D) Global Cyber Equity",
    "HebrewName": "מגדל מניות סייבר חול",
    "HebrewLongName": "מגדל (4D) מניות סייבר חו\"ל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.94,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.01,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks by Sectors - Foreign",
    "AssetValue": 126.7,
    "MonthYield": -0.7,
    "YearYield": -0.7,
    "Last12MonthYield": -6.19,
    "ISIN": "IL0051313133"
  },
  {
    "Id": "TASE:5140041",
    "MayaId": "5140041",
    "Name": "Migdal Global Semicond Eq",
    "ShortName": "Migdal Global Semicond Eq",
    "Symbol": "TASE:5140041",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (4D) Global Semiconductors Equity",
    "EnglishLongName": "Migdal (4D) Global Semiconductors Equity",
    "HebrewName": "מגדל מניות שבבים גלובלי",
    "HebrewLongName": "מגדל (4D) מניות שבבים גלובלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.54,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks by Sectors - Foreign",
    "AssetValue": 6.5,
    "MonthYield": 9.97,
    "YearYield": 9.97,
    "Last12MonthYield": null,
    "ISIN": "IL0051400419"
  },
  {
    "Id": "TASE:5131388",
    "MayaId": "5131388",
    "Name": "Migdal Globl Stock $ Deno",
    "ShortName": "Migdal Globl Stock $ Deno",
    "Symbol": "TASE:5131388",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (4D) Global Stocks $ Denominated",
    "EnglishLongName": "Migdal (4D) Global Stocks $ Denominated",
    "HebrewName": "מגדל מניות חול נקובה $",
    "HebrewLongName": "מגדל (4D) מניות חו\"ל נקובה $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.95,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.11,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 19.3,
    "MonthYield": 0.05,
    "YearYield": 0.05,
    "Last12MonthYield": 1.69,
    "ISIN": "IL0051313885"
  },
  {
    "Id": "TASE:5113683",
    "MayaId": "5113683",
    "Name": "Migdal Gov + 15% IL",
    "ShortName": "Migdal Gov + 15% IL",
    "Symbol": "TASE:5113683",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (2B) Government Bonds + 15% IL",
    "EnglishLongName": "Migdal (2B) Government Bonds + 15% IL",
    "HebrewName": "מגדל מדינה + 15%",
    "HebrewLongName": "מגדל (2B) אג\"ח מדינה + 15%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.57,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.51,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bonds - General - Up to 20% Equity",
    "AssetValue": 12.6,
    "MonthYield": 1.45,
    "YearYield": 1.45,
    "Last12MonthYield": 10.39,
    "ISIN": "IL0051136831"
  },
  {
    "Id": "TASE:5131057",
    "MayaId": "5131057",
    "Name": "Migdal Gov Bon&up10 eq IL",
    "ShortName": "Migdal Gov Bon&up10 eq IL",
    "Symbol": "TASE:5131057",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (1A) Government Bonds & up to 10% Equity IL",
    "EnglishLongName": "Migdal (1A) Government Bonds & up to 10% Equity IL",
    "HebrewName": "מגדל אג מדינה ומניות עד10",
    "HebrewLongName": "מגדל (1A) אג\"ח מדינה ומניות עד 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.43,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.36,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - up to 10% Equity",
    "AssetValue": 227.5,
    "MonthYield": 0.86,
    "YearYield": 0.86,
    "Last12MonthYield": 9.98,
    "ISIN": "IL0051310576"
  },
  {
    "Id": "TASE:5115332",
    "MayaId": "5115332",
    "Name": "Migdal Gov Bond+10% IL",
    "ShortName": "Migdal Gov Bond+10% IL",
    "Symbol": "TASE:5115332",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (1A) Government Bond +10% IL",
    "EnglishLongName": "Migdal (1A) Government Bond +10% IL",
    "HebrewName": "מגדל אג\"ח מדינה+10%",
    "HebrewLongName": "מגדל (1A) אג\"ח מדינה+10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.49,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.44,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - up to 10% Equity",
    "AssetValue": 31.5,
    "MonthYield": 1.15,
    "YearYield": 1.15,
    "Last12MonthYield": 9.82,
    "ISIN": "IL0051153323"
  },
  {
    "Id": "TASE:5116140",
    "MayaId": "5116140",
    "Name": "Migdal Gov Bonds IL",
    "ShortName": "Migdal Gov Bonds IL",
    "Symbol": "TASE:5116140",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (0A) Govermment Bonds IL",
    "EnglishLongName": "Migdal (0A) Govermment Bonds IL",
    "HebrewName": "מגדל אגח מדינה",
    "HebrewLongName": "מגדל (0A) אג\"ח מדינה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.64,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.29,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - No Equity",
    "AssetValue": 248.0,
    "MonthYield": 0.6,
    "YearYield": 0.6,
    "Last12MonthYield": 6.28,
    "ISIN": "IL0051161409"
  },
  {
    "Id": "TASE:5104419",
    "MayaId": "5104419",
    "Name": "Migdal Gov Bonds Strg IL",
    "ShortName": "Migdal Gov Bonds Strg IL",
    "Symbol": "TASE:5104419",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (0A) Government Bonds Strategies IL",
    "EnglishLongName": "Migdal (0A) Government Bonds Strategies IL",
    "HebrewName": "מגדל אסטרטגיות אג\"ח מדינה",
    "HebrewLongName": "מגדל (‏‎0A‎‏) אסטרטגיות אג\"ח מדינה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.09,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.39,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Leveraged and Strategic",
    "SecondaryClassification": "Strategic (not leveraged)",
    "AssetValue": 47.6,
    "MonthYield": 0.68,
    "YearYield": 0.68,
    "Last12MonthYield": 6.43,
    "ISIN": "IL0051044191"
  },
  {
    "Id": "TASE:5131172",
    "MayaId": "5131172",
    "Name": "Migdal Gov CPI Link IL",
    "ShortName": "Migdal Gov CPI-Link IL",
    "Symbol": "TASE:5131172",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (1A) Government CPI-Linked IL",
    "EnglishLongName": "Migdal (1A) Government CPI-Linked IL",
    "HebrewName": "מגדל מדד מדינה",
    "HebrewLongName": "מגדל (1A) מדד מדינה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.25,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked Government Bonds - Up to 10% Equity",
    "AssetValue": 210.9,
    "MonthYield": 0.83,
    "YearYield": 0.83,
    "Last12MonthYield": 6.98,
    "ISIN": "IL0051311723"
  },
  {
    "Id": "TASE:5112842",
    "MayaId": "5112842",
    "Name": "Migdal Gov Inflation IL",
    "ShortName": "Migdal Gov Inflation IL",
    "Symbol": "TASE:5112842",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (1B) Government Inflation IL",
    "EnglishLongName": "Migdal (1B) Government Inflation IL",
    "HebrewName": "מגדל אינפלציה מדינה",
    "HebrewLongName": "מגדל (1B) אינפלציה מדינה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.68,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked Government Bonds - Up to 10% Equity",
    "AssetValue": 163.0,
    "MonthYield": 0.45,
    "YearYield": 0.45,
    "Last12MonthYield": 8.22,
    "ISIN": "IL0051128424"
  },
  {
    "Id": "TASE:5131131",
    "MayaId": "5131131",
    "Name": "Migdal Gov+ A and up IL",
    "ShortName": "Migdal Gov+ A and up IL",
    "Symbol": "TASE:5131131",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (0B) Government Plus A and up IL",
    "EnglishLongName": "Migdal (0B) Government Plus A and up IL",
    "HebrewName": "מגדל מדינה פלוס A ומעלה",
    "HebrewLongName": "מגדל (0B) מדינה פלוס A ומעלה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.27,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - No Equity",
    "AssetValue": 328.5,
    "MonthYield": 0.44,
    "YearYield": 0.44,
    "Last12MonthYield": 5.95,
    "ISIN": "IL0051311319"
  },
  {
    "Id": "TASE:5136338",
    "MayaId": "5136338",
    "Name": "Migdal Growth Eqty IL",
    "ShortName": "Migdal Growth Eqty IL",
    "Symbol": "TASE:5136338",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (4B) Growth Equity IL",
    "EnglishLongName": "Migdal (4B) Growth Equity IL",
    "HebrewName": "מגדל מניות צמיחה",
    "HebrewLongName": "מגדל (4B) מניות צמיחה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.46,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 2.9,
    "MonthYield": 9.77,
    "YearYield": 9.77,
    "Last12MonthYield": 53.15,
    "ISIN": "IL0051363385"
  },
  {
    "Id": "TASE:5118187",
    "MayaId": "5118187",
    "Name": "Migdal HY Oppor Bonds IL",
    "ShortName": "Migdal HY Oppor Bonds IL",
    "Symbol": "TASE:5118187",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (1B)(!) High Yield Opportunities Bonds IL",
    "EnglishLongName": "Migdal (1B)(!) High Yield Opportunities Bonds IL",
    "HebrewName": "מגדל הזדמ אגח תשואה גבוהה",
    "HebrewLongName": "מגדל (1B)(!) הזדמנויות אג\"ח תשואה גבוהה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.25,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.29,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Hi-risk Corporate & Convertibles",
    "AssetValue": 447.0,
    "MonthYield": 1.18,
    "YearYield": 1.18,
    "Last12MonthYield": 9.04,
    "ISIN": "IL0051181878"
  },
  {
    "Id": "TASE:5102991",
    "MayaId": "5102991",
    "Name": "Migdal ILS Money Markt IL",
    "ShortName": "Migdal ILS Money Markt IL",
    "Symbol": "TASE:5102991",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (00) Shekel Money Market Fund IL",
    "EnglishLongName": "Migdal (00) Shekel Money Market Fund IL",
    "HebrewName": "מגדל כספית שקלית",
    "HebrewLongName": "מגדל (00) כספית שקלית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.239,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 5913.0,
    "MonthYield": 0.21,
    "YearYield": 0.21,
    "Last12MonthYield": 4.68,
    "ISIN": "IL0051029911"
  },
  {
    "Id": "TASE:5126511",
    "MayaId": "5126511",
    "Name": "Migdal In Rs Co B Opr IL",
    "ShortName": "Migdal In Rs Co B Opr IL",
    "Symbol": "TASE:5126511",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (1A)(!) Increased Risk Corporate Bond Opportunities IL",
    "EnglishLongName": "Migdal (1A)(!) Increased Risk Corporate Bond Opportunities IL",
    "HebrewName": "מגדל הזדמ אגח חבר סיכ מוג",
    "HebrewLongName": "מגדל (1A)(!) הזדמנויות באג\"ח חברות סיכון מוגבר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.91,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Hi-risk Corporate & Convertibles",
    "AssetValue": 138.3,
    "MonthYield": 0.78,
    "YearYield": 0.78,
    "Last12MonthYield": 8.39,
    "ISIN": "IL0051265119"
  },
  {
    "Id": "TASE:5103759",
    "MayaId": "5103759",
    "Name": "Migdal India",
    "ShortName": "Migdal India",
    "Symbol": "TASE:5103759",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (4D) India",
    "EnglishLongName": "Migdal (4D) India",
    "HebrewName": "מגדל הודו",
    "HebrewLongName": "מגדל (4D) הודו",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.95,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.73,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Geographical stocks",
    "AssetValue": 58.1,
    "MonthYield": -2.27,
    "YearYield": -2.27,
    "Last12MonthYield": -13.5,
    "ISIN": "IL0051037591"
  },
  {
    "Id": "MGDL.TA",
    "MayaId": "1081165",
    "Name": "MIGDAL INSUR.",
    "ShortName": "MIGDAL INSURANCE & FINANCIAL HOLDINGS LTD.",
    "Symbol": "MGDL.TA",
    "TaseSymbol": "MGDL",
    "YahooId": "MGDL.TA",
    "EnglishName": "MIGDAL INSUR.",
    "EnglishLongName": "MIGDAL INSURANCE & FINANCIAL HOLDINGS LTD.",
    "HebrewName": "מגדל ביטוח",
    "HebrewLongName": "מגדל אחזקות ביטוח ופיננסים בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1620.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Insurance",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 8.2,
    "YearYield": 8.2,
    "Last12MonthYield": null,
    "ISIN": "IL0010811656"
  },
  {
    "Id": "TASE:5131271",
    "MayaId": "5131271",
    "Name": "Migdal Is BuySide Eq IL",
    "ShortName": "Migdal Is BuySide Eq IL",
    "Symbol": "TASE:5131271",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (4B) Israel Buy Side Equity IL",
    "EnglishLongName": "Migdal (4B) Israel Buy Side Equity IL",
    "HebrewName": "מגדל מניות ישראל Buy Side",
    "HebrewLongName": "מגדל (4B) מניות ישראל Buy Side",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.75,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.46,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 126.8,
    "MonthYield": 9.93,
    "YearYield": 9.93,
    "Last12MonthYield": 64.99,
    "ISIN": "IL0051312713"
  },
  {
    "Id": "TASE:5101571",
    "MayaId": "5101571",
    "Name": "Migdal Long Shk Gov IL",
    "ShortName": "Migdal Long Shk Gov IL",
    "Symbol": "TASE:5101571",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (00) Long Term Shekel Government IL",
    "EnglishLongName": "Migdal (00) Long Term Shekel Government IL",
    "HebrewName": "מגדל מדינה שקלים ארוכים",
    "HebrewLongName": "מגדל (00) מדינה שקלים ארוכים",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.62,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Shekel Bonds - No Equity",
    "AssetValue": 228.5,
    "MonthYield": 1.14,
    "YearYield": 1.14,
    "Last12MonthYield": 8.87,
    "ISIN": "IL0051015712"
  },
  {
    "Id": "TASE:5103304",
    "MayaId": "5103304",
    "Name": "Migdal MaofX2 Memunef IL",
    "ShortName": "Migdal MaofX2 Memunef IL",
    "Symbol": "TASE:5103304",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (6A) Maof Kiflayim Keren Memunefet IL",
    "EnglishLongName": "Migdal (6A) Maof Kiflayim Keren Memunefet IL",
    "HebrewName": "מגדל מעוף כפליים ממונפת",
    "HebrewLongName": "מגדל (6A) מעו\"ף כפליים קרן ממונפת",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.81,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": true,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.96,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Leveraged and Strategic",
    "SecondaryClassification": "Leveraged, High-Risk",
    "AssetValue": 58.6,
    "MonthYield": 19.13,
    "YearYield": 19.13,
    "Last12MonthYield": 142.09,
    "ISIN": "IL0051033046"
  },
  {
    "Id": "TASE:5137559",
    "MayaId": "5137559",
    "Name": "Migdal Mn MrFn Pout Mn IL",
    "ShortName": "Migdal Mn MrFn Pout Mn IL",
    "Symbol": "TASE:5137559",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (00) Money Market Fund Payout Monthly IL",
    "EnglishLongName": "Migdal (00) Money Market Fund Payout Monthly IL",
    "HebrewName": "מגדל כספית מחלקת חודשי",
    "HebrewLongName": "מגדל (00) כספית מחלקת חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.16,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.07,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 261.6,
    "MonthYield": 0.19,
    "YearYield": 0.19,
    "Last12MonthYield": 4.12,
    "ISIN": "IL0051375595"
  },
  {
    "Id": "TASE:5141304",
    "MayaId": "5141304",
    "Name": "Migdal Mn MrFn Savings IL",
    "ShortName": "Migdal Mn MrFn Savings IL",
    "Symbol": "TASE:5141304",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (00) Money Market Fund Savings IL",
    "EnglishLongName": "Migdal (00) Money Market Fund Savings IL",
    "HebrewName": "מגדל כספית חיסכון",
    "HebrewLongName": "מגדל (00) כספית חיסכון",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.005,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 29.7,
    "MonthYield": 0.23,
    "YearYield": 0.23,
    "Last12MonthYield": null,
    "ISIN": "IL0051413040"
  },
  {
    "Id": "TASE:5134309",
    "MayaId": "5134309",
    "Name": "Migdal Money Mark Fund IL",
    "ShortName": "Migdal Money Mark Fund IL",
    "Symbol": "TASE:5134309",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (00) Money Market Fund IL",
    "EnglishLongName": "Migdal (00) Money Market Fund IL",
    "HebrewName": "מגדל כספית",
    "HebrewLongName": "מגדל (00) כספית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.239,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 5443.9,
    "MonthYield": 0.21,
    "YearYield": 0.21,
    "Last12MonthYield": 4.69,
    "ISIN": "IL0051343098"
  },
  {
    "Id": "TASE:5138524",
    "MayaId": "5138524",
    "Name": "Migdal Nasdaq100KosherHD",
    "ShortName": "Migdal Nasdaq100KosherHD",
    "Symbol": "TASE:5138524",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (4A) Nasdaq 100 Kosher Currency Hedged",
    "EnglishLongName": "Migdal (4A) Nasdaq 100 Kosher Currency Hedged",
    "HebrewName": "מגדל נאסד\"ק 100 כשרה ממ",
    "HebrewLongName": "מגדל (4A) נאסד\"ק 100 כשרה מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.04,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Geographical stocks",
    "AssetValue": 18.1,
    "MonthYield": 1.21,
    "YearYield": 1.21,
    "Last12MonthYield": 19.49,
    "ISIN": "IL0051385248"
  },
  {
    "Id": "TASE:5138656",
    "MayaId": "5138656",
    "Name": "Migdal Oprt Bnd NoStcksIL",
    "ShortName": "Migdal Oprt Bnd NoStcksIL",
    "Symbol": "TASE:5138656",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (0A)(!) Opportunity Bonds Without Stocks IL",
    "EnglishLongName": "Migdal (0A)(!) Opportunity Bonds Without Stocks IL",
    "HebrewName": "מגדל הזדמנויות אגח ללא מנ",
    "HebrewLongName": "מגדל (0A)(!) הזדמנויות אג\"ח ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.63,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 6.0,
    "MonthYield": 0.86,
    "YearYield": 0.86,
    "Last12MonthYield": -1.31,
    "ISIN": "IL0051386568"
  },
  {
    "Id": "TASE:5104831",
    "MayaId": "5104831",
    "Name": "Migdal Portf 1 In Bank IL",
    "ShortName": "Migdal Portf 1 In Bank IL",
    "Symbol": "TASE:5104831",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (1B) Tracking Portfolio 1 International Bank IL",
    "EnglishLongName": "Migdal (1B) Tracking Portfolio 1 International Bank IL",
    "HebrewName": "מגדל עוקב תיק 1 הבינלאומי",
    "HebrewLongName": "מגדל (1B) עוקבת תיק 1 הבנק הבינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.18,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 5% Equity",
    "AssetValue": 52.5,
    "MonthYield": 0.55,
    "YearYield": 0.55,
    "Last12MonthYield": 6.44,
    "ISIN": "IL0051048317"
  },
  {
    "Id": "TASE:5124862",
    "MayaId": "5124862",
    "Name": "Migdal Portfolio 50/50 IL",
    "ShortName": "Migdal Portfolio 50/50 IL",
    "Symbol": "TASE:5124862",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (3C) Portfolio 50/50 IL",
    "EnglishLongName": "Migdal (3C) Portfolio 50/50 IL",
    "HebrewName": "מגדל תיק 50/50",
    "HebrewLongName": "מגדל (3C) תיק 50/50",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.05,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - Max. Exposure over 30% Equity",
    "AssetValue": 95.9,
    "MonthYield": 4.62,
    "YearYield": 4.62,
    "Last12MonthYield": 25.02,
    "ISIN": "IL0051248628"
  },
  {
    "Id": "TASE:5102678",
    "MayaId": "5102678",
    "Name": "Migdal Portfolio 70/30 IL",
    "ShortName": "Migdal Portfolio 70/30 IL",
    "Symbol": "TASE:5102678",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (2B) Portfolio 70/30 IL",
    "EnglishLongName": "Migdal (2B) Portfolio 70/30 IL",
    "HebrewName": "מגדל תיק השקעות 30/70",
    "HebrewLongName": "מגדל (‏B‏2) תיק השקעות 30/70",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.68,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 373.1,
    "MonthYield": 2.71,
    "YearYield": 2.71,
    "Last12MonthYield": 19.21,
    "ISIN": "IL0051026784"
  },
  {
    "Id": "TASE:5118385",
    "MayaId": "5118385",
    "Name": "Migdal Portfolio 75/25 IL",
    "ShortName": "Migdal Portfolio 75/25 IL",
    "Symbol": "TASE:5118385",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (2B) Portfolio 75/25 IL",
    "EnglishLongName": "Migdal (2B) Portfolio 75/25 IL",
    "HebrewName": "מגדל תיק 25/75",
    "HebrewLongName": "מגדל (2B) תיק 25/75",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.045,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.55,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 25% Equity",
    "AssetValue": 303.5,
    "MonthYield": 2.05,
    "YearYield": 2.05,
    "Last12MonthYield": 15.01,
    "ISIN": "IL0051183858"
  },
  {
    "Id": "TASE:5122304",
    "MayaId": "5122304",
    "Name": "Migdal Portfolio 80/20 IL",
    "ShortName": "Migdal Portfolio 80/20 IL",
    "Symbol": "TASE:5122304",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (2B) Portfolio 80/20 IL",
    "EnglishLongName": "Migdal (2B) Portfolio 80/20 IL",
    "HebrewName": "מגדל תיק 20/80",
    "HebrewLongName": "מגדל (2B) תיק 20/80",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.85,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.5,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 777.5,
    "MonthYield": 1.5,
    "YearYield": 1.5,
    "Last12MonthYield": 13.47,
    "ISIN": "IL0051223043"
  },
  {
    "Id": "TASE:5112826",
    "MayaId": "5112826",
    "Name": "Migdal Portfolio 85/15",
    "ShortName": "Migdal Portfolio 85/15",
    "Symbol": "TASE:5112826",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (2B) Portfolio 85/15",
    "EnglishLongName": "Migdal (2B) Portfolio 85/15",
    "HebrewName": "מגדל תיק השקעות 15/85",
    "HebrewLongName": "מגדל (‏‎2B‎‏) תיק השקעות 15/85",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.4,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 15% Equity",
    "AssetValue": 454.4,
    "MonthYield": 1.12,
    "YearYield": 1.12,
    "Last12MonthYield": 10.66,
    "ISIN": "IL0051128267"
  },
  {
    "Id": "TASE:5120423",
    "MayaId": "5120423",
    "Name": "Migdal Portfolio 90/10 IL",
    "ShortName": "Migdal Portfolio 90/10 IL",
    "Symbol": "TASE:5120423",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (1B) Portfolio 90/10 IL",
    "EnglishLongName": "Migdal (1B) Portfolio 90/10 IL",
    "HebrewName": "מגדל תיק 10/90",
    "HebrewLongName": "מגדל (1B) תיק 10/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.37,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 612.2,
    "MonthYield": 1.03,
    "YearYield": 1.03,
    "Last12MonthYield": 10.28,
    "ISIN": "IL0051204233"
  },
  {
    "Id": "TASE:5122379",
    "MayaId": "5122379",
    "Name": "Migdal Portfolio 90/10 IL",
    "ShortName": "Migdal Portfolio 90/10 IL",
    "Symbol": "TASE:5122379",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (1A) Portfolio 90/10 IL",
    "EnglishLongName": "Migdal (1A) Portfolio 90/10 IL",
    "HebrewName": "מגדל תיק השקעות 10/90",
    "HebrewLongName": "מגדל (1A) תיק השקעות 10/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.77,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.38,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 487.8,
    "MonthYield": 1.27,
    "YearYield": 1.27,
    "Last12MonthYield": 9.92,
    "ISIN": "IL0051223795"
  },
  {
    "Id": "TASE:5111711",
    "MayaId": "5111711",
    "Name": "Migdal prem portf up50 IL",
    "ShortName": "Migdal prem portf up50 IL",
    "Symbol": "TASE:5111711",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (3D) Premium Portfolio up to 50% IL",
    "EnglishLongName": "Migdal (3D) Premium Portfolio up to 50% IL",
    "HebrewName": "מגדל פרימיו תיק השקע עד50",
    "HebrewLongName": "מגדל (3D) פרימיום תיק השקעות עד 50%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.78,
    "TrusteeFee": 0.045,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.13,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - Max. Exposure over 30% Equity",
    "AssetValue": 130.7,
    "MonthYield": 4.9,
    "YearYield": 4.9,
    "Last12MonthYield": 31.65,
    "ISIN": "IL0051117112"
  },
  {
    "Id": "TASE:5112669",
    "MayaId": "5112669",
    "Name": "Migdal Rate Bond A&HighIL",
    "ShortName": "Migdal Rate Bond A&HighIL",
    "Symbol": "TASE:5112669",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (00) Rated Bond A and Higher IL",
    "EnglishLongName": "Migdal (00) Rated Bond A and Higher IL",
    "HebrewName": "מגדל בונד מדורג A ומעלה",
    "HebrewLongName": "מגדל (00) בונד מדורג A ומעלה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 219.9,
    "MonthYield": 0.61,
    "YearYield": 0.61,
    "Last12MonthYield": 7.14,
    "ISIN": "IL0051126691"
  },
  {
    "Id": "TASE:5131297",
    "MayaId": "5131297",
    "Name": "Migdal Real Estate IL",
    "ShortName": "Migdal Real Estate IL",
    "Symbol": "TASE:5131297",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (4A) Real Estate IL",
    "EnglishLongName": "Migdal (4A) Real Estate IL",
    "HebrewName": "מגדל נדל\"ן",
    "HebrewLongName": "מגדל (4A) נדל\"ן",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.25,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.2,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sectors",
    "AssetValue": 26.7,
    "MonthYield": 10.47,
    "YearYield": 10.47,
    "Last12MonthYield": 34.94,
    "ISIN": "IL0051312978"
  },
  {
    "Id": "TASE:5117536",
    "MayaId": "5117536",
    "Name": "Migdal S&P 500",
    "ShortName": "Migdal S&P 500",
    "Symbol": "TASE:5117536",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (4D) S&P 500",
    "EnglishLongName": "Migdal (4D) S&P 500",
    "HebrewName": "מגדל S&P 500",
    "HebrewLongName": "מגדל (4D)י S&P 500",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.42,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Geographical stocks",
    "AssetValue": 19.5,
    "MonthYield": 0.03,
    "YearYield": 0.03,
    "Last12MonthYield": 1.36,
    "ISIN": "IL0051175367"
  },
  {
    "Id": "TASE:5103163",
    "MayaId": "5103163",
    "Name": "Migdal Sh BndA&Hgh +10 IL",
    "ShortName": "Migdal Sh BndA&Hgh +10 IL",
    "Symbol": "TASE:5103163",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (1A) Shekel Bond A & Higher +10% IL",
    "EnglishLongName": "Migdal (1A) Shekel Bond A & Higher +10% IL",
    "HebrewName": "מגדל בונד שק A ומעלה +10%",
    "HebrewLongName": "מגדל (1A) בונד שקלי A ומעלה +10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.4,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Shekel Corporate and Convertibles with Equity",
    "AssetValue": 16.4,
    "MonthYield": 1.52,
    "YearYield": 1.52,
    "Last12MonthYield": 10.49,
    "ISIN": "IL0051031636"
  },
  {
    "Id": "TASE:5138094",
    "MayaId": "5138094",
    "Name": "Migdal Shekels Mr kosh IL",
    "ShortName": "Migdal Shekels Mr kosh IL",
    "Symbol": "TASE:5138094",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (00) Shekels Money Market Kosher IL",
    "EnglishLongName": "Migdal (00) Shekels Money Market Kosher IL",
    "HebrewName": "מגדל כספית שקלית כשרה",
    "HebrewLongName": "מגדל (00) כספית שקלית כשרה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.149,
    "TrusteeFee": 0.005,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 5311.8,
    "MonthYield": 0.22,
    "YearYield": 0.22,
    "Last12MonthYield": 4.67,
    "ISIN": "IL0051380942"
  },
  {
    "Id": "TASE:5115324",
    "MayaId": "5115324",
    "Name": "Migdal Solid IL",
    "ShortName": "Migdal Solid IL",
    "Symbol": "TASE:5115324",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (0A) Solid IL",
    "EnglishLongName": "Migdal (0A) Solid IL",
    "HebrewName": "מגדל סולידית",
    "HebrewLongName": "מגדל (0A) סולידית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.2,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 45.2,
    "MonthYield": 0.41,
    "YearYield": 0.41,
    "Last12MonthYield": 5.86,
    "ISIN": "IL0051153240"
  },
  {
    "Id": "TASE:5131479",
    "MayaId": "5131479",
    "Name": "Migdal Solid Isr Bnds IL",
    "ShortName": "Migdal Solid Isr Bnds IL",
    "Symbol": "TASE:5131479",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (0A) Solid Israel Bonds IL",
    "EnglishLongName": "Migdal (0A) Solid Israel Bonds IL",
    "HebrewName": "מגדל אג\"ח ישראל סולידית",
    "HebrewLongName": "מגדל (0A) אג\"ח ישראל סולידית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.17,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 7.1,
    "MonthYield": 0.67,
    "YearYield": 0.67,
    "Last12MonthYield": 5.75,
    "ISIN": "IL0051314792"
  },
  {
    "Id": "TASE:5131453",
    "MayaId": "5131453",
    "Name": "Migdal T.A 125 Equity IL",
    "ShortName": "Migdal T.A 125 Equity IL",
    "Symbol": "TASE:5131453",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (4A) T.A 125 Equity IL",
    "EnglishLongName": "Migdal (4A) T.A 125 Equity IL",
    "HebrewName": "מגדל מניות ישראל ת\"א 125",
    "HebrewLongName": "מגדל (4A) מניות ישראל ת\"א 125",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.49,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.6,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 120.9,
    "MonthYield": 6.15,
    "YearYield": 6.15,
    "Last12MonthYield": 56.76,
    "ISIN": "IL0051314537"
  },
  {
    "Id": "TASE:5131354",
    "MayaId": "5131354",
    "Name": "Migdal T.A Mid Cap IL",
    "ShortName": "Migdal T.A Mid Cap IL",
    "Symbol": "TASE:5131354",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (4A) T.A Mid Cap IL",
    "EnglishLongName": "Migdal (4A) T.A Mid Cap IL",
    "HebrewName": "מגדל ת\"א Mid Cap",
    "HebrewLongName": "מגדל (4A) ת\"א Mid Cap",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.89,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 18.1,
    "MonthYield": 10.21,
    "YearYield": 10.21,
    "Last12MonthYield": 64.57,
    "ISIN": "IL0051313547"
  },
  {
    "Id": "TASE:5102926",
    "MayaId": "5102926",
    "Name": "Migdal Tr Port2 IntBn IL",
    "ShortName": "Migdal Tr Port2 IntBn IL",
    "Symbol": "TASE:5102926",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (2B) Tracking Portfolio 2 International Bank IL",
    "EnglishLongName": "Migdal (2B) Tracking Portfolio 2 International Bank IL",
    "HebrewName": "מגדל עוק תיק 2 בנק בינל",
    "HebrewLongName": "מגדל (2B) עוקבת תיק 2 הבנק הבינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 15% Equity",
    "AssetValue": 184.7,
    "MonthYield": 0.57,
    "YearYield": 0.57,
    "Last12MonthYield": 8.22,
    "ISIN": "IL0051029267"
  },
  {
    "Id": "TASE:5118799",
    "MayaId": "5118799",
    "Name": "Migdal Tr Port3 IntBn IL",
    "ShortName": "Migdal Tr Port3 IntBn IL",
    "Symbol": "TASE:5118799",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (2B) Tracking Portfolio 3 International Bank IL",
    "EnglishLongName": "Migdal (2B) Tracking Portfolio 3 International Bank IL",
    "HebrewName": "מגדל עוק תיק 3 בנק בינל",
    "HebrewLongName": "מגדל (2B) עוקבת תיק 3 הבנק הבינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.43,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 216.3,
    "MonthYield": 1.77,
    "YearYield": 1.77,
    "Last12MonthYield": 11.24,
    "ISIN": "IL0051187990"
  },
  {
    "Id": "TASE:5129499",
    "MayaId": "5129499",
    "Name": "Migdal TrBn CmPr2 IntB IL",
    "ShortName": "Migdal TrBn CmPr2 IntB IL",
    "Symbol": "TASE:5129499",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (00) Tracking Bond Component - Portfolio 2 International Bank IL",
    "EnglishLongName": "Migdal (00) Tracking Bond Component - Portfolio 2 International Bank IL",
    "HebrewName": "מגדל עוק אגח תיק 2 בינל",
    "HebrewLongName": "מגדל (00) עוקבת מרכיב אג\"ח – תיק 2 הבנק הבינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.61,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.26,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 12.8,
    "MonthYield": 0.57,
    "YearYield": 0.57,
    "Last12MonthYield": 6.73,
    "ISIN": "IL0051294994"
  },
  {
    "Id": "TASE:5100680",
    "MayaId": "5100680",
    "Name": "Migdal TrLq CPrt IntBn IL",
    "ShortName": "Migdal TrLq CPrt IntBn IL",
    "Symbol": "TASE:5100680",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (0A) Tracking Liquidity Component Portfolio International Bank IL",
    "EnglishLongName": "Migdal (0A) Tracking Liquidity Component Portfolio International Bank IL",
    "HebrewName": "מגדל תיק מר נזיל בנק בינל",
    "HebrewLongName": "מגדל (‏A‏0)‏‎ ‎עוקבת תיק מרכיב הנזילות הבנק הבינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.49,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.11,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 27.5,
    "MonthYield": 0.34,
    "YearYield": 0.34,
    "Last12MonthYield": 4.97,
    "ISIN": "IL0051006802"
  },
  {
    "Id": "TASE:5103148",
    "MayaId": "5103148",
    "Name": "Migdal US Sector Currency",
    "ShortName": "Migdal US Sector Currency",
    "Symbol": "TASE:5103148",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (4A) US Sectors Currency – Hedged",
    "EnglishLongName": "Migdal (4A) US Sectors Currency – Hedged",
    "HebrewName": "מגדל סקטור ארהב-מנוטר מטח",
    "HebrewLongName": "מגדל (4A) סקטורים ארה\"ב - מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.5,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.93,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Geographical stocks",
    "AssetValue": 73.9,
    "MonthYield": 1.02,
    "YearYield": 1.02,
    "Last12MonthYield": 14.78,
    "ISIN": "IL0051031487"
  },
  {
    "Id": "TASE:5126487",
    "MayaId": "5126487",
    "Name": "Migdal Yeter Rest Shar IL",
    "ShortName": "Migdal Yeter-Rest Shar IL",
    "Symbol": "TASE:5126487",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (4B) Yeter - Rest of Shares IL",
    "EnglishLongName": "Migdal (4B) Yeter - Rest of Shares IL",
    "HebrewName": "מגדל (B4) מניות יתר",
    "HebrewLongName": "מגדל (4B) מניות יתר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.25,
    "TrusteeFee": 0.06,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.09,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 14.6,
    "MonthYield": 8.92,
    "YearYield": 8.92,
    "Last12MonthYield": 50.92,
    "ISIN": "IL0051264872"
  },
  {
    "Id": "TASE:5137120",
    "MayaId": "5137120",
    "Name": "Migdal ₪ A AAAup2028IL",
    "ShortName": "Migdal ₪ A-AAAup2028IL",
    "Symbol": "TASE:5137120",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Migdal (0A) Shekel A-AAA to Maturity up to 2028 IL",
    "EnglishLongName": "Migdal (0A) Shekel A-AAA to Maturity up to 2028 IL",
    "HebrewName": "מגדל A-AAA שקלפדיון 2028",
    "HebrewLongName": "מגדל (A-AAA (0A שקלי לפדיון עד 2028",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.55,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.11,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Shekel Corporate and Convertibles - No Equity",
    "AssetValue": 48.5,
    "MonthYield": 0.44,
    "YearYield": 0.44,
    "Last12MonthYield": 5.64,
    "ISIN": "IL0051371206"
  },
  {
    "Id": "MLD-M.TA",
    "MayaId": "1108638",
    "Name": "MIRLAND M",
    "ShortName": "MIRLAND DEVELOPMENT CORPORATION PLC",
    "Symbol": "MLD-M.TA",
    "TaseSymbol": "MLD-M",
    "YahooId": "MLD-M.TA",
    "EnglishName": "MIRLAND-M",
    "EnglishLongName": "MIRLAND DEVELOPMENT CORPORATION PLC",
    "HebrewName": "מירלנד-ש",
    "HebrewLongName": "מירלנד דיוולופמנט קורפריישן פי אל סי",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2.5,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.0,
    "YearYield": 0.0,
    "Last12MonthYield": null,
    "ISIN": "CY0106902113"
  },
  {
    "Id": "MSHR.TA",
    "MayaId": "1105196",
    "Name": "MISHORIM",
    "ShortName": "MISHORIM REAL ESTATE INVESTMENTS LTD",
    "Symbol": "MSHR.TA",
    "TaseSymbol": "MSHR",
    "YahooId": "MSHR.TA",
    "EnglishName": "MISHORIM",
    "EnglishLongName": "MISHORIM REAL ESTATE INVESTMENTS LTD",
    "HebrewName": "מישורים",
    "HebrewLongName": "מישורים השקעות נדל\"ן בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 519.2,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 2.4,
    "YearYield": 2.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011051963"
  },
  {
    "Id": "MVNE.TA",
    "MayaId": "226019",
    "Name": "MIVNE",
    "ShortName": "MIVNE REAL ESTATE (K.D) LTD",
    "Symbol": "MVNE.TA",
    "TaseSymbol": "MVNE",
    "YahooId": "MVNE.TA",
    "EnglishName": "MIVNE",
    "EnglishLongName": "MIVNE REAL ESTATE (K.D) LTD",
    "HebrewName": "מבנה",
    "HebrewLongName": "מבנה נדל\"ן (כ.ד) בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1578.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 3.5,
    "YearYield": 3.5,
    "Last12MonthYield": null,
    "ISIN": "IL0002260193"
  },
  {
    "Id": "MISH.TA",
    "MayaId": "127019",
    "Name": "MIVTACH SHAMIR",
    "ShortName": "MIVTACH SHAMIR HOLDINGS LTD.",
    "Symbol": "MISH.TA",
    "TaseSymbol": "MISH",
    "YahooId": "MISH.TA",
    "EnglishName": "MIVTACH SHAMIR",
    "EnglishLongName": "MIVTACH SHAMIR HOLDINGS LTD.",
    "HebrewName": "מבטח שמיר",
    "HebrewLongName": "מבטח שמיר אחזקות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 42900.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Investment & Holdings",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 7.6,
    "YearYield": 7.6,
    "Last12MonthYield": null,
    "ISIN": "IL0001270193"
  },
  {
    "Id": "MZTF.TA",
    "MayaId": "695437",
    "Name": "MIZRAHI TEFAHOT",
    "ShortName": "MIZRAHI TEFAHOT BANK LTD.",
    "Symbol": "MZTF.TA",
    "TaseSymbol": "MZTF",
    "YahooId": "MZTF.TA",
    "EnglishName": "MIZRAHI TEFAHOT",
    "EnglishLongName": "MIZRAHI TEFAHOT BANK LTD.",
    "HebrewName": "מזרחי טפחות",
    "HebrewLongName": "בנק מזרחי טפחות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 23960.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Banks",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 9.7,
    "YearYield": 9.7,
    "Last12MonthYield": null,
    "ISIN": "IL0006954379"
  },
  {
    "Id": "MLRN.TA",
    "MayaId": "1170950",
    "Name": "MLRN",
    "ShortName": "M.L.R.N PROJECTS AND TRADING LTD",
    "Symbol": "MLRN.TA",
    "TaseSymbol": "MLRN",
    "YahooId": "MLRN.TA",
    "EnglishName": "MLRN",
    "EnglishLongName": "M.L.R.N PROJECTS AND TRADING LTD",
    "HebrewName": "מלרן",
    "HebrewLongName": "מ.ל.ר.ן פרוייקטים ומסחר בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1515.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Financial Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.0,
    "YearYield": 1.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011709503"
  },
  {
    "Id": "TASE:5127220",
    "MayaId": "5127220",
    "Name": "MNT 30/70 $",
    "ShortName": "MNT 30/70 $",
    "Symbol": "TASE:5127220",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MONITAR (2D) 70/30- US DOLLAR DENOMINATED",
    "EnglishLongName": "MONITAR (2D) 70/30- US DOLLAR DENOMINATED",
    "HebrewName": "מוניטר 2D 30/70 - נקובה $",
    "HebrewLongName": "מוניטר (2D)י 30/70- נקובה $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.95,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.97,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Bonds",
    "AssetValue": 12.5,
    "MonthYield": -0.19,
    "YearYield": -0.19,
    "Last12MonthYield": -5.32,
    "ISIN": "IL0051272206"
  },
  {
    "Id": "TASE:5127212",
    "MayaId": "5127212",
    "Name": "MNT GMISHA",
    "ShortName": "MNT GMISHA",
    "Symbol": "TASE:5127212",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MONITAR (4D) FLEXIBLE",
    "EnglishLongName": "MONITAR (4D) FLEXIBLE",
    "HebrewName": "מוניטר 4D גמישה",
    "HebrewLongName": "מוניטר (4D) גמישה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.2,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.31,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 7.4,
    "MonthYield": 1.1,
    "YearYield": 1.1,
    "Last12MonthYield": 0.65,
    "ISIN": "IL0051272123"
  },
  {
    "Id": "TASE:5109731",
    "MayaId": "5109731",
    "Name": "MOR FLEXIBLE",
    "ShortName": "MOR FLEXIBLE",
    "Symbol": "TASE:5109731",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE FLEXIBLE - MUTUAL FUND",
    "EnglishLongName": "MORE FLEXIBLE - MUTUAL FUND",
    "HebrewName": "מור גמישה 4D",
    "HebrewLongName": "מור גמישה (4D) - קרן נאמנות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.88,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.46,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 1114.8,
    "MonthYield": 7.37,
    "YearYield": 7.37,
    "Last12MonthYield": 48.59,
    "ISIN": "IL0051097314"
  },
  {
    "Id": "TASE:5123740",
    "MayaId": "5123740",
    "Name": "MOR GLOB EQUITY",
    "ShortName": "MOR GLOB EQUITY",
    "Symbol": "TASE:5123740",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE (4D) GLOBAL EQUITY",
    "EnglishLongName": "MORE (4D) GLOBAL EQUITY",
    "HebrewName": "מור 4D מניות גלובלי",
    "HebrewLongName": "מור (4D) מניות גלובלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.85,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.18,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 435.8,
    "MonthYield": 3.73,
    "YearYield": 3.73,
    "Last12MonthYield": 14.22,
    "ISIN": "IL0051237407"
  },
  {
    "Id": "TASE:5139399",
    "MayaId": "5139399",
    "Name": "Mor Inv Grade Bonds No Eq",
    "ShortName": "Mor Inv Grade Bonds No Eq",
    "Symbol": "TASE:5139399",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "More (0A) Investment Grade Bonds Without Equities IL",
    "EnglishLongName": "More (0A) Investment Grade Bonds Without Equities IL",
    "HebrewName": "מור אג\"ח מדורג ללא מניות",
    "HebrewLongName": "מור (0A) אג\"ח מדורג ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.22,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 59.6,
    "MonthYield": 0.46,
    "YearYield": 0.46,
    "Last12MonthYield": 7.07,
    "ISIN": "IL0051393994"
  },
  {
    "Id": "TASE:5127725",
    "MayaId": "5127725",
    "Name": "MOR INVESTMENT",
    "ShortName": "MOR INVESTMENT",
    "Symbol": "TASE:5127725",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE (4D) INVESTMENTS",
    "EnglishLongName": "MORE (4D) INVESTMENTS",
    "HebrewName": "מור 4D השקעות",
    "HebrewLongName": "מור (4D) השקעות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.55,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.57,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 690.1,
    "MonthYield": 9.05,
    "YearYield": 9.05,
    "Last12MonthYield": 61.41,
    "ISIN": "IL0051277254"
  },
  {
    "Id": "TASE:5109756",
    "MayaId": "5109756",
    "Name": "MOR NONCPI GOV B NO EQ K",
    "ShortName": "MOR NONCPI GOV B NO EQ K",
    "Symbol": "TASE:5109756",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE NON-CPI LINKED (00) GOVERNMENT BOND WITHOUT EQUITY IL – KOSHER",
    "EnglishLongName": "MORE NON-CPI LINKED (00) GOVERNMENT BOND WITHOUT EQUITY IL – KOSHER",
    "HebrewName": "מור שקלי מדינה ללא מני כש",
    "HebrewLongName": "מור שקלית מדינה (00) ללא מניות - כשרה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.39,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Shekel Bonds - No Equity",
    "AssetValue": 216.9,
    "MonthYield": 0.73,
    "YearYield": 0.73,
    "Last12MonthYield": 6.94,
    "ISIN": "IL0051097561"
  },
  {
    "Id": "TASE:5135009",
    "MayaId": "5135009",
    "Name": "MORE (!) BOND + 10% IL",
    "ShortName": "MORE (!) BOND + 10% IL",
    "Symbol": "TASE:5135009",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE (1A)(!) BOND + 10% IL",
    "EnglishLongName": "MORE (1A)(!) BOND + 10% IL",
    "HebrewName": "מור (!) אג\"ח + 10%",
    "HebrewLongName": "מור (1A)(!) אג\"ח + 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 1029.1,
    "MonthYield": 1.47,
    "YearYield": 1.47,
    "Last12MonthYield": 11.42,
    "ISIN": "IL0051350093"
  },
  {
    "Id": "TASE:5118633",
    "MayaId": "5118633",
    "Name": "MORE (!) Corp bond port",
    "ShortName": "MORE (!) Corp bond port",
    "Symbol": "TASE:5118633",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE (0A)(!) Corporate bond portfolio IL",
    "EnglishLongName": "MORE (0A)(!) Corporate bond portfolio IL",
    "HebrewName": "מור (!) תיק אג\"ח קונצרני",
    "HebrewLongName": "מור (0A)(!) תיק אג\"ח קונצרני",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.88,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.22,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 721.9,
    "MonthYield": 0.55,
    "YearYield": 0.55,
    "Last12MonthYield": 5.91,
    "ISIN": "IL0051186331"
  },
  {
    "Id": "TASE:5128376",
    "MayaId": "5128376",
    "Name": "MORE 70/30",
    "ShortName": "MORE 70/30",
    "Symbol": "TASE:5128376",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE (2B) 70/30 IL",
    "EnglishLongName": "MORE (2B) 70/30 IL",
    "HebrewName": "מור 30/70",
    "HebrewLongName": "מור (2B)י 30/70",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.62,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 973.1,
    "MonthYield": 2.24,
    "YearYield": 2.24,
    "Last12MonthYield": 17.97,
    "ISIN": "IL0051283765"
  },
  {
    "Id": "TASE:5138789",
    "MayaId": "5138789",
    "Name": "MORE 70/30 Glb Equity Ksh",
    "ShortName": "MORE 70/30 Glb Equity Ksh",
    "Symbol": "TASE:5138789",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE (2B) 70/30 Global Equity IL - Kosher",
    "EnglishLongName": "MORE (2B) 70/30 Global Equity IL - Kosher",
    "HebrewName": "מור 30/70 מניות חו\"ל כשרה",
    "HebrewLongName": "מור (2B)י 30/70 מניות חו\"ל - כשרה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.43,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 64.8,
    "MonthYield": 1.94,
    "YearYield": 1.94,
    "Last12MonthYield": 14.42,
    "ISIN": "IL0051387897"
  },
  {
    "Id": "TASE:5125919",
    "MayaId": "5125919",
    "Name": "MORE 75/25 IL",
    "ShortName": "MORE 75/25 IL",
    "Symbol": "TASE:5125919",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE 75/25 (2B) IL",
    "EnglishLongName": "MORE 75/25 (2B) IL",
    "HebrewName": "מור 25/75",
    "HebrewLongName": "מור 25/75 (2B)",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.85,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.47,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 25% Equity",
    "AssetValue": 908.6,
    "MonthYield": 2.53,
    "YearYield": 2.53,
    "Last12MonthYield": 16.99,
    "ISIN": "IL0051259195"
  },
  {
    "Id": "TASE:5133947",
    "MayaId": "5133947",
    "Name": "MORE 80/20 GLOBAL EQ IL",
    "ShortName": "MORE 80/20 GLOBAL EQ IL",
    "Symbol": "TASE:5133947",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE (2B) 80/20 Global Equity IL",
    "EnglishLongName": "MORE (2B) 80/20 Global Equity IL",
    "HebrewName": "מור 20/80 מניות חו\"ל",
    "HebrewLongName": "מור (2B)י 20/80 מניות חו\"ל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.82,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 1326.4,
    "MonthYield": 1.57,
    "YearYield": 1.57,
    "Last12MonthYield": 11.28,
    "ISIN": "IL0051339476"
  },
  {
    "Id": "TASE:5122726",
    "MayaId": "5122726",
    "Name": "MORE 80/20 IL",
    "ShortName": "MORE 80/20 IL",
    "Symbol": "TASE:5122726",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE 80/20 (2B) IL",
    "EnglishLongName": "MORE 80/20 (2B) IL",
    "HebrewName": "מור 20/80",
    "HebrewLongName": "מור 20/80 (2B)",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.83,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.43,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 927.7,
    "MonthYield": 1.95,
    "YearYield": 1.95,
    "Last12MonthYield": 14.47,
    "ISIN": "IL0051227267"
  },
  {
    "Id": "TASE:5119821",
    "MayaId": "5119821",
    "Name": "MORE 85/15 IL",
    "ShortName": "MORE 85/15 IL",
    "Symbol": "TASE:5119821",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE 85/15 (2A) IL",
    "EnglishLongName": "MORE 85/15 (2A) IL",
    "HebrewName": "מור 15/85",
    "HebrewLongName": "מור 15/85 (2A)",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.73,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 15% Equity",
    "AssetValue": 869.5,
    "MonthYield": 1.79,
    "YearYield": 1.79,
    "Last12MonthYield": 12.81,
    "ISIN": "IL0051198211"
  },
  {
    "Id": "TASE:5121249",
    "MayaId": "5121249",
    "Name": "MORE 90/10 GLOBAL BOND",
    "ShortName": "MORE 90/10 GLOBAL BOND",
    "Symbol": "TASE:5121249",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE (1D) 90/10 GLOBAL BOND PORTFOLIO",
    "EnglishLongName": "MORE (1D) 90/10 GLOBAL BOND PORTFOLIO",
    "HebrewName": "מור 10/90 תיק אג\"ח חו\"ל",
    "HebrewLongName": "מור (1D)י 10/90 תיק אג\"ח חו\"ל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.84,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.86,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Bond",
    "AssetValue": 242.7,
    "MonthYield": -0.79,
    "YearYield": -0.79,
    "Last12MonthYield": -4.94,
    "ISIN": "IL0051212491"
  },
  {
    "Id": "TASE:5121587",
    "MayaId": "5121587",
    "Name": "MORE 90/10 IL",
    "ShortName": "MORE 90/10 IL",
    "Symbol": "TASE:5121587",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE 90/10 (1A) IL",
    "EnglishLongName": "MORE 90/10 (1A) IL",
    "HebrewName": "מור 10/90",
    "HebrewLongName": "מור 1A) 10/90)",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.78,
    "TrusteeFee": 0.015,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 2286.2,
    "MonthYield": 1.2,
    "YearYield": 1.2,
    "Last12MonthYield": 9.72,
    "ISIN": "IL0051215874"
  },
  {
    "Id": "TASE:5125885",
    "MayaId": "5125885",
    "Name": "MORE 95/5 IL",
    "ShortName": "MORE 95/5 IL",
    "Symbol": "TASE:5125885",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE (1B) 95/5 IL",
    "EnglishLongName": "MORE (1B) 95/5 IL",
    "HebrewName": "מור 5/95",
    "HebrewLongName": "מור (1B)י 5/95",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.61,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 5% Equity",
    "AssetValue": 128.1,
    "MonthYield": 0.96,
    "YearYield": 0.96,
    "Last12MonthYield": 8.34,
    "ISIN": "IL0051258858"
  },
  {
    "Id": "TASE:5129937",
    "MayaId": "5129937",
    "Name": "MORE A&UP– UP TO 4 YRS IL",
    "ShortName": "MORE A&UP– UP TO 4 YRS IL",
    "Symbol": "TASE:5129937",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "More (0A) A and up – up to 4 years IL",
    "EnglishLongName": "More (0A) A and up – up to 4 years IL",
    "HebrewName": "מור A ומעלה עד 4 שנים",
    "HebrewLongName": "מור (0A)י A ומעלה עד 4 שנים",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.76,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.25,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 527.1,
    "MonthYield": 0.47,
    "YearYield": 0.47,
    "Last12MonthYield": 5.89,
    "ISIN": "IL0051299373"
  },
  {
    "Id": "TASE:5130364",
    "MayaId": "5130364",
    "Name": "more bareket IL 70/30",
    "ShortName": "more bareket IL 70/30",
    "Symbol": "TASE:5130364",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "more (2B) bareket IL 70/30",
    "EnglishLongName": "more (2B) bareket IL 70/30",
    "HebrewName": "מור ברקת 30/70",
    "HebrewLongName": "מור (2B) ברקת 30/70",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.58,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.51,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 132.5,
    "MonthYield": 2.8,
    "YearYield": 2.8,
    "Last12MonthYield": 22.26,
    "ISIN": "IL0051303647"
  },
  {
    "Id": "TASE:5137153",
    "MayaId": "5137153",
    "Name": "MORE Bond mty 12/2027",
    "ShortName": "MORE Bond mty 12/2027",
    "Symbol": "TASE:5137153",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE (00) Bond Maturity until 12/2027 IL",
    "EnglishLongName": "MORE (00) Bond Maturity until 12/2027 IL",
    "HebrewName": "מור אג\"ח לפדיון עד 12/27",
    "HebrewLongName": "מור (00) אג\"ח לפדיון עד 12/27",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.17,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 21.7,
    "MonthYield": 0.3,
    "YearYield": 0.3,
    "Last12MonthYield": 5.42,
    "ISIN": "IL0051371537"
  },
  {
    "Id": "TASE:5122817",
    "MayaId": "5122817",
    "Name": "MORE BOND PORTFOLIO+15 IL",
    "ShortName": "MORE BOND PORTFOLIO+15 IL",
    "Symbol": "TASE:5122817",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE (2B) bond portfolio + 15% IL",
    "EnglishLongName": "MORE (2B) bond portfolio + 15% IL",
    "HebrewName": "מור תיק אג\"ח + 15%",
    "HebrewLongName": "מור (2B) תיק אג\"ח + 15%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.77,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.39,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 15% Equity",
    "AssetValue": 373.0,
    "MonthYield": 1.98,
    "YearYield": 1.98,
    "Last12MonthYield": 13.49,
    "ISIN": "IL0051228174"
  },
  {
    "Id": "TASE:5119086",
    "MayaId": "5119086",
    "Name": "MORE BOND PORTFOLIO+30%",
    "ShortName": "MORE BOND PORTFOLIO+30%",
    "Symbol": "TASE:5119086",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE (2A) BOND PORTFOLIO IL + 30%",
    "EnglishLongName": "MORE (2A) BOND PORTFOLIO IL + 30%",
    "HebrewName": "מור תיק אג\"ח + 30%",
    "HebrewLongName": "מור (2A) תיק אג\"ח + 30%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.76,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.57,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 905.9,
    "MonthYield": 2.94,
    "YearYield": 2.94,
    "Last12MonthYield": 18.72,
    "ISIN": "IL0051190861"
  },
  {
    "Id": "TASE:5141874",
    "MayaId": "5141874",
    "Name": "More Bonds Only IL",
    "ShortName": "More Bonds Only IL",
    "Symbol": "TASE:5141874",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "More (0A)(!) Bonds Only IL",
    "EnglishLongName": "More (0A)(!) Bonds Only IL",
    "HebrewName": "מור אג\"ח ללא מניות",
    "HebrewLongName": "מור (0A)(!) אג\"ח ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 13.4,
    "MonthYield": 0.6,
    "YearYield": 0.6,
    "Last12MonthYield": null,
    "ISIN": "IL0051418742"
  },
  {
    "Id": "TASE:5107693",
    "MayaId": "5107693",
    "Name": "MORE BONDS PLUS IL",
    "ShortName": "MORE BONDS PLUS IL",
    "Symbol": "TASE:5107693",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE BONDS PLUS – MUTUAL FUND IL",
    "EnglishLongName": "MORE BONDS PLUS – MUTUAL FUND IL",
    "HebrewName": "מור אג\"ח פלוס",
    "HebrewLongName": "מור אג\"ח פלוס (1A)",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.37,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 1060.1,
    "MonthYield": 1.09,
    "YearYield": 1.09,
    "Last12MonthYield": 12.09,
    "ISIN": "IL0051076938"
  },
  {
    "Id": "TASE:5140702",
    "MayaId": "5140702",
    "Name": "MORE CORP BONDS +20% IL",
    "ShortName": "MORE CORP BONDS +20% IL",
    "Symbol": "TASE:5140702",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE (2B) CORPORATE BONDS +20% IL",
    "EnglishLongName": "MORE (2B) CORPORATE BONDS +20% IL",
    "HebrewName": "מור אג\"ח חברות +20%",
    "HebrewLongName": "מור (2B) אג\"ח חברות + 20%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.47,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles with Equity",
    "AssetValue": 51.7,
    "MonthYield": 2.18,
    "YearYield": 2.18,
    "Last12MonthYield": null,
    "ISIN": "IL0051407026"
  },
  {
    "Id": "TASE:5125901",
    "MayaId": "5125901",
    "Name": "MORE CORPORATE BONDS IL",
    "ShortName": "MORE CORPORATE BONDS IL",
    "Symbol": "TASE:5125901",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE CORPORATE BONDS (1A) IL",
    "EnglishLongName": "MORE CORPORATE BONDS (1A) IL",
    "HebrewName": "מור אג\"ח חברות",
    "HebrewLongName": "מור אג\"ח חברות (1A)",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles with Equity",
    "AssetValue": 126.7,
    "MonthYield": 1.58,
    "YearYield": 1.58,
    "Last12MonthYield": 12.39,
    "ISIN": "IL0051259013"
  },
  {
    "Id": "TASE:5138003",
    "MayaId": "5138003",
    "Name": "More Dollar Money Market",
    "ShortName": "More Dollar Money Market",
    "Symbol": "TASE:5138003",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "More (0D) Dollar Money Market",
    "EnglishLongName": "More (0D) Dollar Money Market",
    "HebrewName": "מור כספית דולרית",
    "HebrewLongName": "מור (0D) כספית דולרית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.005,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.16,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "FX Money Market with Corporate",
    "AssetValue": 68.5,
    "MonthYield": -1.26,
    "YearYield": -1.26,
    "Last12MonthYield": -9.95,
    "ISIN": "IL0051380033"
  },
  {
    "Id": "TASE:5129457",
    "MayaId": "5129457",
    "Name": "MORE FOLLOW BENLEUMI 2 IL",
    "ShortName": "MORE FOLLOW BENLEUMI 2 IL",
    "Symbol": "TASE:5129457",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE (2B) Following tik 2 Bank ben leumi IL",
    "EnglishLongName": "MORE (2B) Following tik 2 Bank ben leumi IL",
    "HebrewName": "מור עוקבת תיק 2 הבינלאומי",
    "HebrewLongName": "מור (2B) עוקבת תיק 2 הבנק הבינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.74,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.31,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 15% Equity",
    "AssetValue": 512.8,
    "MonthYield": 1.32,
    "YearYield": 1.32,
    "Last12MonthYield": 10.1,
    "ISIN": "IL0051294572"
  },
  {
    "Id": "TASE:5137682",
    "MayaId": "5137682",
    "Name": "More Following FIBI 3",
    "ShortName": "More Following FIBI 3",
    "Symbol": "TASE:5137682",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "More(2B) Following Portfolio 3 FIBI Bank IL",
    "EnglishLongName": "More(2B) Following Portfolio 3 FIBI Bank IL",
    "HebrewName": "מור עוקבת בינלאומי תיק 3",
    "HebrewLongName": "מור (2B) עוקבת תיק 3 הבנק הבינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.66,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.44,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 145.4,
    "MonthYield": 2.44,
    "YearYield": 2.44,
    "Last12MonthYield": 14.77,
    "ISIN": "IL0051376825"
  },
  {
    "Id": "TASE:5133798",
    "MayaId": "5133798",
    "Name": "MORE fund of funds 15 IL",
    "ShortName": "MORE fund of funds 15 IL",
    "Symbol": "TASE:5133798",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE (2B) Israeli fund of funds 15% equity IL",
    "EnglishLongName": "MORE (2B) Israeli fund of funds 15% equity IL",
    "HebrewName": "מור אגד ישראלי 15% מניות",
    "HebrewLongName": "מור (2B) אגד ישראלי עד 15% מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.37,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Fund of Funds",
    "SecondaryClassification": "Israeli Fund of Funds",
    "AssetValue": 203.9,
    "MonthYield": 1.54,
    "YearYield": 1.54,
    "Last12MonthYield": 10.6,
    "ISIN": "IL0051337983"
  },
  {
    "Id": "TASE:5133780",
    "MayaId": "5133780",
    "Name": "MORE fund of funds 30 IL",
    "ShortName": "MORE fund of funds 30 IL",
    "Symbol": "TASE:5133780",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE (2C) Israeli fund of funds 30% equity IL",
    "EnglishLongName": "MORE (2C) Israeli fund of funds 30% equity IL",
    "HebrewName": "מור אגד ישראלי 30% מניות",
    "HebrewLongName": "מור (2C) אגד ישראלי עד 30% מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.57,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Fund of Funds",
    "SecondaryClassification": "Israeli Fund of Funds",
    "AssetValue": 172.4,
    "MonthYield": 2.25,
    "YearYield": 2.25,
    "Last12MonthYield": 15.45,
    "ISIN": "IL0051337801"
  },
  {
    "Id": "TASE:5131040",
    "MayaId": "5131040",
    "Name": "More Global Clean Energy",
    "ShortName": "More Global Clean Energy",
    "Symbol": "TASE:5131040",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "More (4D) Global Clean Energy",
    "EnglishLongName": "More (4D) Global Clean Energy",
    "HebrewName": "מור אנרגיה נקיה גלובלי",
    "HebrewLongName": "מור (4D) אנרגיה נקיה גלובלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.85,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.62,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks by Sectors - Foreign",
    "AssetValue": 19.3,
    "MonthYield": 3.13,
    "YearYield": 3.13,
    "Last12MonthYield": 29.65,
    "ISIN": "IL0051310402"
  },
  {
    "Id": "TASE:5133129",
    "MayaId": "5133129",
    "Name": "MORE GLOBAL GROWTH EQ",
    "ShortName": "MORE GLOBAL GROWTH EQ",
    "Symbol": "TASE:5133129",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE (4D) GLOBAL GROWTH EQUITY",
    "EnglishLongName": "MORE (4D) GLOBAL GROWTH EQUITY",
    "HebrewName": "מור מניות צמיחה גלובלי",
    "HebrewLongName": "מור (4D) מניות צמיחה גלובלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.76,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 224.6,
    "MonthYield": 3.47,
    "YearYield": 3.47,
    "Last12MonthYield": 13.46,
    "ISIN": "IL0051331291"
  },
  {
    "Id": "TASE:5128962",
    "MayaId": "5128962",
    "Name": "More Global Technology Eq",
    "ShortName": "More Global Technology Eq",
    "Symbol": "TASE:5128962",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "More (4D) Global Technology Equity",
    "EnglishLongName": "More (4D) Global Technology Equity",
    "HebrewName": "מור מניות טכנולוגיה גלובל",
    "HebrewLongName": "מור (4D) מניות טכנולוגיה גלובלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.1,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.98,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks by Sectors - Foreign",
    "AssetValue": 295.1,
    "MonthYield": 1.58,
    "YearYield": 1.58,
    "Last12MonthYield": -0.62,
    "ISIN": "IL0051289622"
  },
  {
    "Id": "TASE:5118641",
    "MayaId": "5118641",
    "Name": "MORE GOV BOND IL –KOSHER",
    "ShortName": "MORE GOV BOND IL –KOSHER",
    "Symbol": "TASE:5118641",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE(00) GOVERNMENT BOND IL –KOSHER",
    "EnglishLongName": "MORE(00) GOVERNMENT BOND IL –KOSHER",
    "HebrewName": "מור אג\"ח מדינה - כשרה",
    "HebrewLongName": "מור (00) אג\"ח מדינה - כשרה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.64,
    "TrusteeFee": 0.012,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.27,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - No Equity",
    "AssetValue": 134.8,
    "MonthYield": 0.46,
    "YearYield": 0.46,
    "Last12MonthYield": 6.09,
    "ISIN": "IL0051186414"
  },
  {
    "Id": "TASE:5121090",
    "MayaId": "5121090",
    "Name": "MORE GOV CPI LINKED +20%",
    "ShortName": "MORE GOV CPI-LINKED +20%",
    "Symbol": "TASE:5121090",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE (2A) GOVERNMENT CPI-LINKED IL+20%",
    "EnglishLongName": "MORE (2A) GOVERNMENT CPI-LINKED IL+20%",
    "HebrewName": "מור מדדית מדינה + 20%",
    "HebrewLongName": "מור (2A) מדדית מדינה +20%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bonds - General - Up to 20% Equity",
    "AssetValue": 397.9,
    "MonthYield": 1.62,
    "YearYield": 1.62,
    "Last12MonthYield": 11.67,
    "ISIN": "IL0051210909"
  },
  {
    "Id": "TASE:5117510",
    "MayaId": "5117510",
    "Name": "MORE GOV CPI LNK NO EQ IL",
    "ShortName": "MORE GOV CPI-LNK NO EQ IL",
    "Symbol": "TASE:5117510",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE (00) GOVERNMENT CPI-LINKED WITHOUT EQUITIES IL",
    "EnglishLongName": "MORE (00) GOVERNMENT CPI-LINKED WITHOUT EQUITIES IL",
    "HebrewName": "מור מדדית מדינה ללא מניות",
    "HebrewLongName": "מור (00) מדדית מדינה ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.18,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked Government Bonds - No Equity",
    "AssetValue": 81.3,
    "MonthYield": 0.08,
    "YearYield": 0.08,
    "Last12MonthYield": 4.36,
    "ISIN": "IL0051175102"
  },
  {
    "Id": "TASE:5119078",
    "MayaId": "5119078",
    "Name": "MORE GOVERNMENT +10%",
    "ShortName": "MORE GOVERNMENT +10%",
    "Symbol": "TASE:5119078",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "10%+ MORE (1A) GOVERNMENT IL",
    "EnglishLongName": "10%+ MORE (1A) GOVERNMENT IL",
    "HebrewName": "מור מדינה + 10%",
    "HebrewLongName": "מור (1A) מדינה + 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.012,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.36,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - up to 10% Equity",
    "AssetValue": 329.3,
    "MonthYield": 1.26,
    "YearYield": 1.26,
    "Last12MonthYield": 9.92,
    "ISIN": "IL0051190788"
  },
  {
    "Id": "TASE:5127477",
    "MayaId": "5127477",
    "Name": "MORE GOVERNMENT BONDS +15",
    "ShortName": "MORE GOVERNMENT BONDS +15",
    "Symbol": "TASE:5127477",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE (2A) GOVERNMENT BONDS +15% IL",
    "EnglishLongName": "MORE (2A) GOVERNMENT BONDS +15% IL",
    "HebrewName": "מור אג\"ח מדינה + 15%",
    "HebrewLongName": "מור (2A) אג\"ח מדינה + 15%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.63,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.37,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bonds - General - Up to 20% Equity",
    "AssetValue": 211.8,
    "MonthYield": 1.68,
    "YearYield": 1.68,
    "Last12MonthYield": 11.6,
    "ISIN": "IL0051274772"
  },
  {
    "Id": "TASE:5137849",
    "MayaId": "5137849",
    "Name": "More High Yield Internal",
    "ShortName": "More High Yield Internal",
    "Symbol": "TASE:5137849",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "More (1B)(!) High Yield Internal Rating Bonds IL",
    "EnglishLongName": "More (1B)(!) High Yield Internal Rating Bonds IL",
    "HebrewName": "מור אגח דירוג פנימי תשואה",
    "HebrewLongName": "מור (1B)(!) אג\"ח דירוג פנימי תשואה גבוהה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.4,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.24,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Hi-risk Corporate & Convertibles",
    "AssetValue": 260.7,
    "MonthYield": 1.06,
    "YearYield": 1.06,
    "Last12MonthYield": 8.26,
    "ISIN": "IL0051378490"
  },
  {
    "Id": "MRIN.TA",
    "MayaId": "1141464",
    "Name": "MORE INVEST",
    "ShortName": "Y.D. MORE INVESTMENTS LTD",
    "Symbol": "MRIN.TA",
    "TaseSymbol": "MRIN",
    "YahooId": "MRIN.TA",
    "EnglishName": "MORE INVEST",
    "EnglishLongName": "Y.D. MORE INVESTMENTS LTD",
    "HebrewName": "מור השקעות",
    "HebrewLongName": "י.ד. מור השקעות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5140.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Financial Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -6.5,
    "YearYield": -6.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011414641"
  },
  {
    "Id": "TASE:5123294",
    "MayaId": "5123294",
    "Name": "MORE ISRAEL BONDS KOSHE",
    "ShortName": "MORE ISRAEL BONDS-KOSHE",
    "Symbol": "TASE:5123294",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE (0A) ISRAEL BONDS IL - KOSHER",
    "EnglishLongName": "MORE (0A) ISRAEL BONDS IL - KOSHER",
    "HebrewName": "מור אג\"ח ישראל - כשרה",
    "HebrewLongName": "מור (0A) אג\"ח ישראל - כשרה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 228.2,
    "MonthYield": 0.51,
    "YearYield": 0.51,
    "Last12MonthYield": 6.31,
    "ISIN": "IL0051232945"
  },
  {
    "Id": "TASE:5119466",
    "MayaId": "5119466",
    "Name": "MORE ISRAEL EQUITIES IL",
    "ShortName": "MORE ISRAEL EQUITIES IL",
    "Symbol": "TASE:5119466",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE (4B) ISRAEL EQUITIES IL",
    "EnglishLongName": "MORE (4B) ISRAEL EQUITIES IL",
    "HebrewName": "מור מניות ישראל",
    "HebrewLongName": "מור (4B) מניות ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.69,
    "TrusteeFee": 0.035,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.83,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 2274.7,
    "MonthYield": 8.63,
    "YearYield": 8.63,
    "Last12MonthYield": 62.83,
    "ISIN": "IL0051194665"
  },
  {
    "Id": "TASE:5139324",
    "MayaId": "5139324",
    "Name": "More Lqdty Mgmt Money Mkt",
    "ShortName": "More Lqdty Mgmt Money Mkt",
    "Symbol": "TASE:5139324",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "More (00) Liquidity Management Money Market IL",
    "EnglishLongName": "More (00) Liquidity Management Money Market IL",
    "HebrewName": "מור כספית ניהול נזילות",
    "HebrewLongName": "מור (00) כספית ניהול נזילות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.005,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 1885.7,
    "MonthYield": 0.26,
    "YearYield": 0.26,
    "Last12MonthYield": 4.68,
    "ISIN": "IL0051393242"
  },
  {
    "Id": "TASE:5109749",
    "MayaId": "5109749",
    "Name": "MORE MAASER BOND KOSHER",
    "ShortName": "MORE MAASER BOND KOSHER",
    "Symbol": "TASE:5109749",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE (1A) MAASER BOND IL–KOSHER",
    "EnglishLongName": "MORE (1A) MAASER BOND IL–KOSHER",
    "HebrewName": "מור מעשר אג\"ח - כשרה",
    "HebrewLongName": "מור (1A) מעשר אג\"ח - כשרה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.88,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.27,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 5% Equity",
    "AssetValue": 103.3,
    "MonthYield": 0.79,
    "YearYield": 0.79,
    "Last12MonthYield": 7.27,
    "ISIN": "IL0051097496"
  },
  {
    "Id": "TASE:5115621",
    "MayaId": "5115621",
    "Name": "MORE MAKAM PLUS IL",
    "ShortName": "MORE MAKAM PLUS IL",
    "Symbol": "TASE:5115621",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE MAKAM PLUS - MUTUAL FUND IL",
    "EnglishLongName": "MORE MAKAM PLUS - MUTUAL FUND IL",
    "HebrewName": "מור מק\"מ פלוס",
    "HebrewLongName": "מור מק\"מ פלוס (1A)",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.55,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.14,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Shekel Bonds - Up to 10% Equity",
    "AssetValue": 205.0,
    "MonthYield": 0.85,
    "YearYield": 0.85,
    "Last12MonthYield": 7.54,
    "ISIN": "IL0051156219"
  },
  {
    "Id": "TASE:5141411",
    "MayaId": "5141411",
    "Name": "More Mid Cap Isr Eq",
    "ShortName": "More Mid Cap Isr Eq",
    "Symbol": "TASE:5141411",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "More (4A) Israel Mid Cap Equities IL",
    "EnglishLongName": "More (4A) Israel Mid Cap Equities IL",
    "HebrewName": "מור מניות מיד קפ ישראל",
    "HebrewLongName": "מור (4A) מניות MID CAP ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.95,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 23.7,
    "MonthYield": 6.25,
    "YearYield": 6.25,
    "Last12MonthYield": null,
    "ISIN": "IL0051414113"
  },
  {
    "Id": "TASE:5119813",
    "MayaId": "5119813",
    "Name": "MORE MONEY MARKET IL",
    "ShortName": "MORE MONEY MARKET IL",
    "Symbol": "TASE:5119813",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE MONEY MARKET (00) IL",
    "EnglishLongName": "MORE MONEY MARKET (00) IL",
    "HebrewName": "מור כספית",
    "HebrewLongName": "מור כספית (00)",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.24,
    "TrusteeFee": 0.005,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 4762.7,
    "MonthYield": 0.23,
    "YearYield": 0.23,
    "Last12MonthYield": 4.66,
    "ISIN": "IL0051198138"
  },
  {
    "Id": "TASE:5114020",
    "MayaId": "5114020",
    "Name": "MORE NON CPI BOND above A",
    "ShortName": "MORE NON CPI BOND above A",
    "Symbol": "TASE:5114020",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE (00) NON CPI-LINKED BOND IL above A",
    "EnglishLongName": "MORE (00) NON CPI-LINKED BOND IL above A",
    "HebrewName": "מור בונד שקלי A ומעלה",
    "HebrewLongName": "מור (00) בונד שקלי A ומעלה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.74,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.29,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Shekel Corporate and Convertibles - No Equity",
    "AssetValue": 70.2,
    "MonthYield": 0.71,
    "YearYield": 0.71,
    "Last12MonthYield": 6.95,
    "ISIN": "IL0051140205"
  },
  {
    "Id": "TASE:5124342",
    "MayaId": "5124342",
    "Name": "MORE OPPORTUNITY Corp B",
    "ShortName": "MORE OPPORTUNITY Corp B",
    "Symbol": "TASE:5124342",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE (1A)(!) OPPORTUNITY Corporate BONDS IL",
    "EnglishLongName": "MORE (1A)(!) OPPORTUNITY Corporate BONDS IL",
    "HebrewName": "מור הזדמנויות אגח קונצר",
    "HebrewLongName": "מור (1A)(!) הזדמנויות אג\"ח קונצרני",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.18,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.2,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles with Equity",
    "AssetValue": 1531.0,
    "MonthYield": 1.08,
    "YearYield": 1.08,
    "Last12MonthYield": 7.1,
    "ISIN": "IL0051243421"
  },
  {
    "Id": "MPP.TA",
    "MayaId": "1184381",
    "Name": "MORE PENSION",
    "ShortName": "MORE PROVIDENT FUNDS AND PENSION LTD",
    "Symbol": "MPP.TA",
    "TaseSymbol": "MPP",
    "YahooId": "MPP.TA",
    "EnglishName": "MORE PENSION",
    "EnglishLongName": "MORE PROVIDENT FUNDS AND PENSION LTD",
    "HebrewName": "מור גמל פנסיה",
    "HebrewLongName": "מור גמל ופנסיה בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1397.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Financial Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -3.1,
    "YearYield": -3.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011843815"
  },
  {
    "Id": "TASE:5124805",
    "MayaId": "5124805",
    "Name": "MORE Portfolio 50%",
    "ShortName": "MORE Portfolio 50%",
    "Symbol": "TASE:5124805",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE (3B) Portfolio IL 50%",
    "EnglishLongName": "MORE (3B) Portfolio IL 50%",
    "HebrewName": "מור תיק השקעות 50%",
    "HebrewLongName": "מור (3B) תיק השקעות 50%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.8,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - Max. Exposure over 30% Equity",
    "AssetValue": 606.9,
    "MonthYield": 4.34,
    "YearYield": 4.34,
    "Last12MonthYield": 28.08,
    "ISIN": "IL0051248057"
  },
  {
    "Id": "TASE:5124300",
    "MayaId": "5124300",
    "Name": "MORE REAL ESTATE IL",
    "ShortName": "MORE REAL ESTATE IL",
    "Symbol": "TASE:5124300",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE (4B) REAL ESTATE IL",
    "EnglishLongName": "MORE (4B) REAL ESTATE IL",
    "HebrewName": "מור נדל\"ן",
    "HebrewLongName": "מור (4B) נדל\"ן",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.32,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.98,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sectors",
    "AssetValue": 289.0,
    "MonthYield": 9.76,
    "YearYield": 9.76,
    "Last12MonthYield": 42.39,
    "ISIN": "IL0051243009"
  },
  {
    "Id": "MORE.S10.TA",
    "MayaId": "1195304",
    "Name": "MORE SAL (00) Tel Bond 60 CPI Linked IL",
    "ShortName": "MORE MUTUAL FUNDS MANAGMENT (2013) LTD",
    "Symbol": "MORE.S10.TA",
    "TaseSymbol": "MORE.S10",
    "YahooId": "MORE.S10.TA",
    "EnglishName": "MO.T.B 60LINKED",
    "EnglishLongName": "MORE MUTUAL FUNDS MANAGMENT (2013) LTD",
    "HebrewName": "מו.ס תל.ב 60.צ",
    "HebrewLongName": "מור ניהול קרנות נאמנות (2013) בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.02,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5792.07,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MORE",
    "TrusteeName": "UBANK",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.3,
    "YearYield": 0.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011953044"
  },
  {
    "Id": "MORE.S11.TA",
    "MayaId": "1195312",
    "Name": "MORE SAL (0A)Tel Bond Composite IL",
    "ShortName": "MORE MUTUAL FUNDS MANAGMENT (2013) LTD",
    "Symbol": "MORE.S11.TA",
    "TaseSymbol": "MORE.S11",
    "YahooId": "MORE.S11.TA",
    "EnglishName": "MO.TEL COMP",
    "EnglishLongName": "MORE MUTUAL FUNDS MANAGMENT (2013) LTD",
    "HebrewName": "מו.סל תלב.מאגר",
    "HebrewLongName": "מור ניהול קרנות נאמנות (2013) בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.02,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5902.58,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MORE",
    "TrusteeName": "UBANK",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "other",
    "AssetValue": null,
    "MonthYield": 0.5,
    "YearYield": 0.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011953127"
  },
  {
    "Id": "MORE.S6.TA",
    "MayaId": "1187764",
    "Name": "MORE SAL (4A) Index Banks EW IL",
    "ShortName": "MORE MUTUAL FUNDS MANAGMENT (2013) LTD",
    "Symbol": "MORE.S6.TA",
    "TaseSymbol": "MORE.S6",
    "YahooId": "MORE.S6.TA",
    "EnglishName": "MO.BANKSEWIL",
    "EnglishLongName": "MORE MUTUAL FUNDS MANAGMENT (2013) LTD",
    "HebrewName": "מו.סל בנקים EW",
    "HebrewLongName": "מור ניהול קרנות נאמנות (2013) בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 12230.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MORE",
    "TrusteeName": "UBANK",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Banking and non-banking credit",
    "AssetValue": null,
    "MonthYield": 8.6,
    "YearYield": 8.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011877649"
  },
  {
    "Id": "MORE.S4.TA",
    "MayaId": "1165844",
    "Name": "MORE SAL (4A) NASDAQ 100 Currency Hedged",
    "ShortName": "MORE MUTUAL FUNDS MANAGMENT (2013) LTD",
    "Symbol": "MORE.S4.TA",
    "TaseSymbol": "MORE.S4",
    "YahooId": "MORE.S4.TA",
    "EnglishName": "MO.NDX100CH",
    "EnglishLongName": "MORE MUTUAL FUNDS MANAGMENT (2013) LTD",
    "HebrewName": "מו.NDX100ממ",
    "HebrewLongName": "מור ניהול קרנות נאמנות (2013) בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.02,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 11590.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MORE",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": -1.4,
    "YearYield": -1.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011658445"
  },
  {
    "Id": "MORE.S2.TA",
    "MayaId": "1165828",
    "Name": "MORE SAL (4A) S&P 500 Currency Hedged",
    "ShortName": "MORE MUTUAL FUNDS MANAGMENT (2013) LTD",
    "Symbol": "MORE.S2.TA",
    "TaseSymbol": "MORE.S2",
    "YahooId": "MORE.S2.TA",
    "EnglishName": "MO.SP500CH",
    "EnglishLongName": "MORE MUTUAL FUNDS MANAGMENT (2013) LTD",
    "HebrewName": "מו.SP500ממ",
    "HebrewLongName": "מור ניהול קרנות נאמנות (2013) בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.02,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 10590.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MORE",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": -0.3,
    "YearYield": -0.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011658288"
  },
  {
    "Id": "MORE.S9.TA",
    "MayaId": "1196153",
    "Name": "MORE SAL (4A) TA 125 IL",
    "ShortName": "MORE MUTUAL FUNDS MANAGMENT (2013) LTD",
    "Symbol": "MORE.S9.TA",
    "TaseSymbol": "MORE.S9",
    "YahooId": "MORE.S9.TA",
    "EnglishName": "MO.TA125IL",
    "EnglishLongName": "MORE MUTUAL FUNDS MANAGMENT (2013) LTD",
    "HebrewName": "מו.סל תא 125",
    "HebrewLongName": "מור ניהול קרנות נאמנות (2013) בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.02,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 10640.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MORE",
    "TrusteeName": "UBANK",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Large & Mid Cap",
    "AssetValue": null,
    "MonthYield": 8.6,
    "YearYield": 8.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011961534"
  },
  {
    "Id": "MORE.S7.TA",
    "MayaId": "1194380",
    "Name": "MORE SAL (4A) TA 35 IL",
    "ShortName": "MORE MUTUAL FUNDS MANAGMENT (2013) LTD",
    "Symbol": "MORE.S7.TA",
    "TaseSymbol": "MORE.S7",
    "YahooId": "MORE.S7.TA",
    "EnglishName": "MO.TA35IL",
    "EnglishLongName": "MORE MUTUAL FUNDS MANAGMENT (2013) LTD",
    "HebrewName": "מו.סל תא 35",
    "HebrewLongName": "מור ניהול קרנות נאמנות (2013) בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.02,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 11050.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MORE",
    "TrusteeName": "UBANK",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Large Cap",
    "AssetValue": null,
    "MonthYield": 9.1,
    "YearYield": 9.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011943805"
  },
  {
    "Id": "MORE.S8.TA",
    "MayaId": "1196146",
    "Name": "MORE SAL (4A) TA 90 IL",
    "ShortName": "MORE MUTUAL FUNDS MANAGMENT (2013) LTD",
    "Symbol": "MORE.S8.TA",
    "TaseSymbol": "MORE.S8",
    "YahooId": "MORE.S8.TA",
    "EnglishName": "MO.TA90IL",
    "EnglishLongName": "MORE MUTUAL FUNDS MANAGMENT (2013) LTD",
    "HebrewName": "מו.סל תא 90",
    "HebrewLongName": "מור ניהול קרנות נאמנות (2013) בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.45,
    "TrusteeFee": 0.02,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 10290.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MORE",
    "TrusteeName": "UBANK",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Mid Cap",
    "AssetValue": null,
    "MonthYield": 7.1,
    "YearYield": 7.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011961468"
  },
  {
    "Id": "MORE.S3.TA",
    "MayaId": "1165836",
    "Name": "MORE SAL (4D) NASDAQ 100",
    "ShortName": "MORE MUTUAL FUNDS MANAGMENT (2013) LTD",
    "Symbol": "MORE.S3.TA",
    "TaseSymbol": "MORE.S3",
    "YahooId": "MORE.S3.TA",
    "EnglishName": "MO.NDX100",
    "EnglishLongName": "MORE MUTUAL FUNDS MANAGMENT (2013) LTD",
    "HebrewName": "מו.NDX100",
    "HebrewLongName": "מור ניהול קרנות נאמנות (2013) בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.02,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 12040.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MORE",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": -1.6,
    "YearYield": -1.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011658361"
  },
  {
    "Id": "MORE.S1.TA",
    "MayaId": "1165810",
    "Name": "MORE SAL (4D) S&P 500",
    "ShortName": "MORE MUTUAL FUNDS MANAGMENT (2013) LTD",
    "Symbol": "MORE.S1.TA",
    "TaseSymbol": "MORE.S1",
    "YahooId": "MORE.S1.TA",
    "EnglishName": "MO.SP500",
    "EnglishLongName": "MORE MUTUAL FUNDS MANAGMENT (2013) LTD",
    "HebrewName": "מו.SP500",
    "HebrewLongName": "מור ניהול קרנות נאמנות (2013) בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.02,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 10820.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MORE",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": -1.2,
    "YearYield": -1.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011658106"
  },
  {
    "Id": "TASE:5122718",
    "MayaId": "5122718",
    "Name": "MORE SOLID IL",
    "ShortName": "MORE SOLID IL",
    "Symbol": "TASE:5122718",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE SOLID (0A) IL",
    "EnglishLongName": "MORE SOLID (0A) IL",
    "HebrewName": "מור סולידית",
    "HebrewLongName": "מור סולידית (0A)",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.63,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.21,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 177.6,
    "MonthYield": 0.36,
    "YearYield": 0.36,
    "Last12MonthYield": 5.66,
    "ISIN": "IL0051227184"
  },
  {
    "Id": "TASE:5135421",
    "MayaId": "5135421",
    "Name": "MORE T A AA Duration3 IL",
    "ShortName": "MORE T A-AA Duration3 IL",
    "Symbol": "TASE:5135421",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE Tracking (00) Index A-AA Duration 3 Synthetic IL",
    "EnglishLongName": "MORE Tracking (00) Index A-AA Duration 3 Synthetic IL",
    "HebrewName": "מור מחקה A-AA מח\"מ 3",
    "HebrewLongName": "מור מחקה (00) אינדקס A-AA מח\"מ 3 סינטטי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.23,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 36.5,
    "MonthYield": 0.52,
    "YearYield": 0.52,
    "Last12MonthYield": 6.79,
    "ISIN": "IL0051354210"
  },
  {
    "Id": "TASE:5135439",
    "MayaId": "5135439",
    "Name": "MORE T A Duration 4 IL",
    "ShortName": "MORE T A Duration 4 IL",
    "Symbol": "TASE:5135439",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE Tracking (00) Index A Duration 4 Synthetic IL",
    "EnglishLongName": "MORE Tracking (00) Index A Duration 4 Synthetic IL",
    "HebrewName": "מור מחקה A מח\"מ 4",
    "HebrewLongName": "מור מחקה (00) אינדקס A מח\"מ 4 סינטטי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.36,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 181.4,
    "MonthYield": 0.81,
    "YearYield": 0.81,
    "Last12MonthYield": 7.75,
    "ISIN": "IL0051354392"
  },
  {
    "Id": "TASE:5131966",
    "MayaId": "5131966",
    "Name": "MORE T Banks IL EW",
    "ShortName": "MORE T Banks IL EW",
    "Symbol": "TASE:5131966",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE Tracking (4A) Index Banks IL EW",
    "EnglishLongName": "MORE Tracking (4A) Index Banks IL EW",
    "HebrewName": "מור מחקה אי.בנקים מש",
    "HebrewLongName": "מור מחקה (4A) אינדקס בנקים משקל שווה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.02,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 1083.0,
    "MonthYield": 9.06,
    "YearYield": 9.06,
    "Last12MonthYield": 68.07,
    "ISIN": "IL0051319668"
  },
  {
    "Id": "TASE:5134119",
    "MayaId": "5134119",
    "Name": "MORE T Chip.Equi.Manuf",
    "ShortName": "MORE T Chip.Equi.Manuf",
    "Symbol": "TASE:5134119",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE Tracking (4D) Index Chip Equipment Manufacturers global",
    "EnglishLongName": "MORE Tracking (4D) Index Chip Equipment Manufacturers global",
    "HebrewName": "מור מחקה ציוד שבבים",
    "HebrewLongName": "מור מחקה (4D) אינדקס יצרני ציוד לשבבים גלובלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.24,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 102.4,
    "MonthYield": 20.93,
    "YearYield": 20.93,
    "Last12MonthYield": 66.23,
    "ISIN": "IL0051341191"
  },
  {
    "Id": "TASE:5131743",
    "MayaId": "5131743",
    "Name": "MORE T Consumer IL",
    "ShortName": "MORE T Consumer IL",
    "Symbol": "TASE:5131743",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE Tracking (4A) Index Consumer IL",
    "EnglishLongName": "MORE Tracking (4A) Index Consumer IL",
    "HebrewName": "מור מחקה אי.צריכה ישראלית",
    "HebrewLongName": "מור מחקה (4A) אינדקס צריכה ישראלית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.55,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.24,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 20.7,
    "MonthYield": 5.04,
    "YearYield": 5.04,
    "Last12MonthYield": 33.43,
    "ISIN": "IL0051317431"
  },
  {
    "Id": "TASE:5132220",
    "MayaId": "5132220",
    "Name": "MORE T Cyber Cloud Comp",
    "ShortName": "MORE T Cyber Cloud Comp",
    "Symbol": "TASE:5132220",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE Tracking (4D) Index Cyber Cloud Computing global",
    "EnglishLongName": "MORE Tracking (4D) Index Cyber Cloud Computing global",
    "HebrewName": "מור מחקה אי.סייבר מח.ענן",
    "HebrewLongName": "מור מחקה (4D) אינדקס סייבר למחשוב ענן גלובלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.91,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 107.8,
    "MonthYield": -4.1,
    "YearYield": -4.1,
    "Last12MonthYield": -11.68,
    "ISIN": "IL0051322209"
  },
  {
    "Id": "TASE:5132212",
    "MayaId": "5132212",
    "Name": "MORE T Digital Payments",
    "ShortName": "MORE T Digital Payments",
    "Symbol": "TASE:5132212",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE Tracking (4D) Index Digital Payments global",
    "EnglishLongName": "MORE Tracking (4D) Index Digital Payments global",
    "HebrewName": "מור מחקה אי.תש.דיגיטליים",
    "HebrewLongName": "מור מחקה (4D) אינדקס תשלומים דיגיטליים גלובלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.85,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 2.8,
    "MonthYield": -3.42,
    "YearYield": -3.42,
    "Last12MonthYield": -25.32,
    "ISIN": "IL0051322126"
  },
  {
    "Id": "TASE:5131883",
    "MayaId": "5131883",
    "Name": "MORE T Infra&Const USA",
    "ShortName": "MORE T Infra&Const USA",
    "Symbol": "TASE:5131883",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE Tracking (4D) Index Infrastructure & Construction USA",
    "EnglishLongName": "MORE Tracking (4D) Index Infrastructure & Construction USA",
    "HebrewName": "מור מחקה אי.תש.ובינוי US",
    "HebrewLongName": "מור מחקה (4D) אינדקס תשתיות ובינוי ארה\"ב",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.68,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 294.7,
    "MonthYield": 4.86,
    "YearYield": 4.86,
    "Last12MonthYield": 5.04,
    "ISIN": "IL0051318835"
  },
  {
    "Id": "TASE:5134424",
    "MayaId": "5134424",
    "Name": "MORE T Insurance EW",
    "ShortName": "MORE T Insurance EW",
    "Symbol": "TASE:5134424",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE Tracking (4A) Index Insurance IL EW",
    "EnglishLongName": "MORE Tracking (4A) Index Insurance IL EW",
    "HebrewName": "מור מחקה אי.ביטוח מש",
    "HebrewLongName": "מור מחקה (4A) אינדקס ביטוח משקל שווה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 5.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 327.4,
    "MonthYield": 5.96,
    "YearYield": 5.96,
    "Last12MonthYield": 160.28,
    "ISIN": "IL0051344245"
  },
  {
    "Id": "TASE:5117585",
    "MayaId": "5117585",
    "Name": "MORE T Nasdaq100",
    "ShortName": "MORE T Nasdaq100",
    "Symbol": "TASE:5117585",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE Tracking (4D) Nasdaq 100",
    "EnglishLongName": "MORE Tracking (4D) Nasdaq 100",
    "HebrewName": "מור מחקה NASDAQ100",
    "HebrewLongName": "מור מחקה (4D)י NASDAQ 100",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.86,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 723.2,
    "MonthYield": -0.22,
    "YearYield": -0.22,
    "Last12MonthYield": 4.91,
    "ISIN": "IL0051175854"
  },
  {
    "Id": "TASE:5122098",
    "MayaId": "5122098",
    "Name": "MORE T Nasdaq100CH",
    "ShortName": "MORE T Nasdaq100CH",
    "Symbol": "TASE:5122098",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE Tracking (4A) NASDAQ 100 Currency Hedged",
    "EnglishLongName": "MORE Tracking (4A) NASDAQ 100 Currency Hedged",
    "HebrewName": "מור מחקה NASDAQ100 ממ",
    "HebrewLongName": "מור מחקה (4A)י NASDAQ 100 מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.06,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 208.3,
    "MonthYield": 1.16,
    "YearYield": 1.16,
    "Last12MonthYield": 19.28,
    "ISIN": "IL0051220981"
  },
  {
    "Id": "TASE:5141361",
    "MayaId": "5141361",
    "Name": "MORE T Nuclear Energy",
    "ShortName": "MORE T Nuclear Energy",
    "Symbol": "TASE:5141361",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE Tracking (4D) Nuclear Energy Industry iNDEX",
    "EnglishLongName": "MORE Tracking (4D) Nuclear Energy Industry iNDEX",
    "HebrewName": "מור מחקה Nuclear Energy",
    "HebrewLongName": "מור מחקה י(4D)י Nuclear Energy Industry iNDEX",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 14.8,
    "MonthYield": 16.53,
    "YearYield": 16.53,
    "Last12MonthYield": null,
    "ISIN": "IL0051413610"
  },
  {
    "Id": "TASE:5117601",
    "MayaId": "5117601",
    "Name": "MORE T S&P 500",
    "ShortName": "MORE T S&P500",
    "Symbol": "TASE:5117601",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE Tracking (4D) S&P 500",
    "EnglishLongName": "MORE Tracking (4D) S&P 500",
    "HebrewName": "מור מחקה S&P500",
    "HebrewLongName": "מור מחקה (4D)י S&P 500",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.4,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 266.4,
    "MonthYield": 0.09,
    "YearYield": 0.09,
    "Last12MonthYield": 2.63,
    "ISIN": "IL0051176019"
  },
  {
    "Id": "TASE:5123021",
    "MayaId": "5123021",
    "Name": "MORE T S&P 500CH",
    "ShortName": "MORE T S&P500CH",
    "Symbol": "TASE:5123021",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE Tracking (4A) S&P 500 Currency Hedged",
    "EnglishLongName": "MORE Tracking (4A) S&P 500 Currency Hedged",
    "HebrewName": "מור מחקה S&P 500 ממ",
    "HebrewLongName": "מור מחקה (4A)י S&P 500 מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.6,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 233.8,
    "MonthYield": 1.46,
    "YearYield": 1.46,
    "Last12MonthYield": 17.04,
    "ISIN": "IL0051230212"
  },
  {
    "Id": "TASE:5139928",
    "MayaId": "5139928",
    "Name": "MORE T S&P Bitcoin",
    "ShortName": "MORE T S&P Bitcoin",
    "Symbol": "TASE:5139928",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE Tracking (4D) S&P Bitcoin Futures Daily Roll Index",
    "EnglishLongName": "MORE Tracking (4D) S&P Bitcoin Futures Daily Roll Index",
    "HebrewName": "מור מחקה S&P Bitcoin",
    "HebrewLongName": "מור מחקה (4D)י S&P Bitcoin Futures Daily Roll Index",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 4.5,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Digital Assets",
    "SecondaryClassification": "Bitcoin",
    "AssetValue": 9.1,
    "MonthYield": 7.25,
    "YearYield": 7.25,
    "Last12MonthYield": -15.38,
    "ISIN": "IL0051399280"
  },
  {
    "Id": "TASE:5123997",
    "MayaId": "5123997",
    "Name": "MORE T S&P Financial",
    "ShortName": "MORE T S&P Financial",
    "Symbol": "TASE:5123997",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE Tracking (4D) S&P Financial",
    "EnglishLongName": "MORE Tracking (4D) S&P Financial",
    "HebrewName": "מור מחקה S&P Financial",
    "HebrewLongName": "מור מחקה (4D)י S&P Financial",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.56,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 17.9,
    "MonthYield": -2.16,
    "YearYield": -2.16,
    "Last12MonthYield": -2.39,
    "ISIN": "IL0051239973"
  },
  {
    "Id": "TASE:5122908",
    "MayaId": "5122908",
    "Name": "MORE T S&P Health Care",
    "ShortName": "MORE T S&P Health Care",
    "Symbol": "TASE:5122908",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE Tracking (4D) S&P Health Care",
    "EnglishLongName": "MORE Tracking (4D) S&P Health Care",
    "HebrewName": "מור מחקה S&P Health Care",
    "HebrewLongName": "מור מחקה (4D)י S&P Health Care",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.82,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 35.5,
    "MonthYield": -0.04,
    "YearYield": -0.04,
    "Last12MonthYield": -0.81,
    "ISIN": "IL0051229081"
  },
  {
    "Id": "TASE:5123419",
    "MayaId": "5123419",
    "Name": "MORE T SP 500 LVHD",
    "ShortName": "MORE T SP 500 LVHD",
    "Symbol": "TASE:5123419",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE Tracking (4D) S&P 500 Low Volatility High Dividend",
    "EnglishLongName": "MORE Tracking (4D) S&P 500 Low Volatility High Dividend",
    "HebrewName": "מור מחקה S&P 500 LVHD",
    "HebrewLongName": "מור מחקה (S&P 500 Low Volatility High Dividend (4D",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.22,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 16.4,
    "MonthYield": 1.82,
    "YearYield": 1.82,
    "Last12MonthYield": -9.03,
    "ISIN": "IL0051234198"
  },
  {
    "Id": "TASE:5113063",
    "MayaId": "5113063",
    "Name": "MORE T TA 125 IL",
    "ShortName": "MORE T TA-125 IL",
    "Symbol": "TASE:5113063",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE Tracking (4A) TA-125 IL",
    "EnglishLongName": "MORE Tracking (4A) TA-125 IL",
    "HebrewName": "מור מחקה תא 125",
    "HebrewLongName": "מור מחקה (4A) ת\"א 125",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.45,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.12,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 162.0,
    "MonthYield": 8.83,
    "YearYield": 8.83,
    "Last12MonthYield": 63.77,
    "ISIN": "IL0051130636"
  },
  {
    "Id": "TASE:5101506",
    "MayaId": "5101506",
    "Name": "MORE T TA 35 IL",
    "ShortName": "MORE T TA-35 IL",
    "Symbol": "TASE:5101506",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE Tracking (4A) TA-35 IL",
    "EnglishLongName": "MORE Tracking (4A) TA-35 IL",
    "HebrewName": "מור מחקה תא 35",
    "HebrewLongName": "מור מחקה (4A) ת\"א 35",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.45,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.96,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 127.0,
    "MonthYield": 9.27,
    "YearYield": 9.27,
    "Last12MonthYield": 65.19,
    "ISIN": "IL0051015068"
  },
  {
    "Id": "TASE:5115126",
    "MayaId": "5115126",
    "Name": "MORE T TA 90 IL",
    "ShortName": "MORE T TA-90 IL",
    "Symbol": "TASE:5115126",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE Tracking (4A) TA-90 IL",
    "EnglishLongName": "MORE Tracking (4A) TA-90 IL",
    "HebrewName": "מור מחקה תא 90",
    "HebrewLongName": "מור מחקה (4A) ת\"א 90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.45,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.98,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 164.7,
    "MonthYield": 7.32,
    "YearYield": 7.32,
    "Last12MonthYield": 56.72,
    "ISIN": "IL0051151269"
  },
  {
    "Id": "TASE:5131891",
    "MayaId": "5131891",
    "Name": "MORE T Tech pro EW IL",
    "ShortName": "MORE T Tech pro EW IL",
    "Symbol": "TASE:5131891",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE Tracking (4A) Index Tech Equal Weighted Profitability IL",
    "EnglishLongName": "MORE Tracking (4A) Index Tech Equal Weighted Profitability IL",
    "HebrewName": "מור מחקה אי.טכנ מ.שווה",
    "HebrewLongName": "מור מחקה (4A) אינדקס טכנולוגיה ישראל רווחיות משקל שווה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.55,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.14,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 39.5,
    "MonthYield": 10.72,
    "YearYield": 10.72,
    "Last12MonthYield": 67.03,
    "ISIN": "IL0051318918"
  },
  {
    "Id": "TASE:5117049",
    "MayaId": "5117049",
    "Name": "MORE T Tel BCLS",
    "ShortName": "MORE T Tel-BCLS",
    "Symbol": "TASE:5117049",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE Tracking (00) Tel Bond-CPI Linked SmallCap IL",
    "EnglishLongName": "MORE Tracking (00) Tel Bond-CPI Linked SmallCap IL",
    "HebrewName": "מור מחקה תל בונד צ יתר",
    "HebrewLongName": "מור מחקה (00) תל בונד צמודות- יתר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.24,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 15.3,
    "MonthYield": 0.28,
    "YearYield": 0.28,
    "Last12MonthYield": 6.53,
    "ISIN": "IL0051170491"
  },
  {
    "Id": "TASE:5118559",
    "MayaId": "5118559",
    "Name": "MORE T Tel Bond Banks",
    "ShortName": "MORE T Tel Bond Banks",
    "Symbol": "TASE:5118559",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE Tracking (00) Tel Bond-CPI Linked Bank without COCO IL",
    "EnglishLongName": "MORE Tracking (00) Tel Bond-CPI Linked Bank without COCO IL",
    "HebrewName": "מור מחקה תלבונד צ בנק",
    "HebrewLongName": "מור מחקה (00) תל בונד צמודות- בנקים ללא COCO",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.16,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 21.9,
    "MonthYield": 0.08,
    "YearYield": 0.08,
    "Last12MonthYield": 5.13,
    "ISIN": "IL0051185598"
  },
  {
    "Id": "TASE:5114319",
    "MayaId": "5114319",
    "Name": "MORE T Tel Bond Shekel",
    "ShortName": "MORE T Tel Bond Shekel",
    "Symbol": "TASE:5114319",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE Tracking (00) Tel Bond Shekel IL",
    "EnglishLongName": "MORE Tracking (00) Tel Bond Shekel IL",
    "HebrewName": "מור מחקה תל בונד שקלי",
    "HebrewLongName": "מור מחקה (00) תל בונד שקלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 69.5,
    "MonthYield": 0.9,
    "YearYield": 0.9,
    "Last12MonthYield": 7.16,
    "ISIN": "IL0051143191"
  },
  {
    "Id": "TASE:5126818",
    "MayaId": "5126818",
    "Name": "MORE T Tel Bond YLD",
    "ShortName": "MORE T Tel Bond YLD",
    "Symbol": "TASE:5126818",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE Tracking (00)(!) Tel Bond Yields CPI Linked IL",
    "EnglishLongName": "MORE Tracking (00)(!) Tel Bond Yields CPI Linked IL",
    "HebrewName": "מור מחקה תלבונד תשו.צמ",
    "HebrewLongName": "מור מחקה (00)(!) תל בונד- תשואות צמודות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 14.9,
    "MonthYield": 0.16,
    "YearYield": 0.16,
    "Last12MonthYield": 5.79,
    "ISIN": "IL0051268188"
  },
  {
    "Id": "TASE:5122395",
    "MayaId": "5122395",
    "Name": "MORE T Tel Bond YLD NIS",
    "ShortName": "MORE T Tel Bond YLD NIS",
    "Symbol": "TASE:5122395",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE Tracking (00)(!) TelBond-Yield NIS IL",
    "EnglishLongName": "MORE Tracking (00)(!) TelBond-Yield NIS IL",
    "HebrewName": "מור מחקה תלבונד תשו.שקל",
    "HebrewLongName": "מור מחקה (00)(!) תל בונד תשואות שקל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 36.3,
    "MonthYield": 1.05,
    "YearYield": 1.05,
    "Last12MonthYield": 5.85,
    "ISIN": "IL0051223951"
  },
  {
    "Id": "TASE:5119177",
    "MayaId": "5119177",
    "Name": "MORE T Tel COMP",
    "ShortName": "MORE T Tel-COMP",
    "Symbol": "TASE:5119177",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE Tracking (0A) TEL BOND COMPOSITE IL",
    "EnglishLongName": "MORE Tracking (0A) TEL BOND COMPOSITE IL",
    "HebrewName": "מור מחקה תלבונד מאגר",
    "HebrewLongName": "מור מחקה (0A) תל בונד מאגר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.26,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 45.9,
    "MonthYield": 0.51,
    "YearYield": 0.51,
    "Last12MonthYield": 6.59,
    "ISIN": "IL0051191778"
  },
  {
    "Id": "TASE:5113006",
    "MayaId": "5113006",
    "Name": "MORE T Tel Gov 2 5",
    "ShortName": "MORE T Tel Gov 2-5",
    "Symbol": "TASE:5113006",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE Tracking (00) Tel Gov- CPI Linked 2-5 IL",
    "EnglishLongName": "MORE Tracking (00) Tel Gov- CPI Linked 2-5 IL",
    "HebrewName": "מור מחקה גליל 2-5",
    "HebrewLongName": "מור מחקה (00) תל גוב- צמודות 2-5",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.15,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked",
    "AssetValue": 12.0,
    "MonthYield": 0.14,
    "YearYield": 0.14,
    "Last12MonthYield": 4.39,
    "ISIN": "IL0051130065"
  },
  {
    "Id": "TASE:5115118",
    "MayaId": "5115118",
    "Name": "MORE T Tel Gov 5 10",
    "ShortName": "MORE T Tel Gov 5-10",
    "Symbol": "TASE:5115118",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE Tracking (00) Tel Gov- CPI Linked 5-10 IL",
    "EnglishLongName": "MORE Tracking (00) Tel Gov- CPI Linked 5-10 IL",
    "HebrewName": "מור מחקה גליל 5-10",
    "HebrewLongName": "מור מחקה (00) תל גוב- צמודות 5-10",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked",
    "AssetValue": 36.0,
    "MonthYield": -0.12,
    "YearYield": -0.12,
    "Last12MonthYield": 5.05,
    "ISIN": "IL0051151186"
  },
  {
    "Id": "TASE:5113022",
    "MayaId": "5113022",
    "Name": "MORE T Tel Shekel 2 5",
    "ShortName": "MORE T Tel Shekel 2-5",
    "Symbol": "TASE:5113022",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE Tracking (00) Tel Gov- Shekel 2-5 IL",
    "EnglishLongName": "MORE Tracking (00) Tel Gov- Shekel 2-5 IL",
    "HebrewName": "מור מחקה שחר 2-5",
    "HebrewLongName": "מור מחקה (00) תל גוב- שקלי 2-5",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.2,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Non-Linked Government Bonds",
    "AssetValue": 29.4,
    "MonthYield": 0.59,
    "YearYield": 0.59,
    "Last12MonthYield": 6.24,
    "ISIN": "IL0051130222"
  },
  {
    "Id": "TASE:5138235",
    "MayaId": "5138235",
    "Name": "MORE T US model pricing",
    "ShortName": "MORE T US model pricing",
    "Symbol": "TASE:5138235",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE Tracking (4D) Index US momentum pricing model",
    "EnglishLongName": "MORE Tracking (4D) Index US momentum pricing model",
    "HebrewName": "מור מחקה אי.אר.מודל תמחור",
    "HebrewLongName": "מור מחקה (4D) אינדקס ארה\"ב מודל תמחור מומנטום",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.44,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 4.5,
    "MonthYield": -1.24,
    "YearYield": -1.24,
    "Last12MonthYield": 1.71,
    "ISIN": "IL0051382351"
  },
  {
    "Id": "TASE:5107701",
    "MayaId": "5107701",
    "Name": "MORE TA 125 EQUITY IL",
    "ShortName": "MORE TA 125 EQUITY IL",
    "Symbol": "TASE:5107701",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE(4A) TA 125 EQUITY IL",
    "EnglishLongName": "MORE(4A) TA 125 EQUITY IL",
    "HebrewName": "מור מניות ת\"א 125",
    "HebrewLongName": "מור (4A) מניות ת\"א 125",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.75,
    "TrusteeFee": 0.035,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 365.3,
    "MonthYield": 9.93,
    "YearYield": 9.93,
    "Last12MonthYield": 66.98,
    "ISIN": "IL0051077019"
  },
  {
    "Id": "TASE:5125257",
    "MayaId": "5125257",
    "Name": "MORE VALUE EQUITIES IL",
    "ShortName": "MORE VALUE EQUITIES IL",
    "Symbol": "TASE:5125257",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE VALUE EQUITIES (4D) IL",
    "EnglishLongName": "MORE VALUE EQUITIES (4D) IL",
    "HebrewName": "מור מניות ערך",
    "HebrewLongName": "מור מניות ערך (4D)",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.59,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.82,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 903.5,
    "MonthYield": 7.67,
    "YearYield": 7.67,
    "Last12MonthYield": 60.67,
    "ISIN": "IL0051252570"
  },
  {
    "Id": "TASE:5124326",
    "MayaId": "5124326",
    "Name": "MORE YETER IL",
    "ShortName": "MORE YETER IL",
    "Symbol": "TASE:5124326",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MORE (4B) YETER IL",
    "EnglishLongName": "MORE (4B) YETER IL",
    "HebrewName": "מור יתר",
    "HebrewLongName": "מור (4B) יתר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.2,
    "TrusteeFee": 0.035,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.95,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 321.9,
    "MonthYield": 6.29,
    "YearYield": 6.29,
    "Last12MonthYield": 54.81,
    "ISIN": "IL0051243264"
  },
  {
    "Id": "TASE:5131586",
    "MayaId": "5131586",
    "Name": "More(!)corp collater bond",
    "ShortName": "More(!)corp collater bond",
    "Symbol": "TASE:5131586",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "More (0A)(!) Corporate collateralized bonds IL",
    "EnglishLongName": "More (0A)(!) Corporate collateralized bonds IL",
    "HebrewName": "מור(!) אג\"ח חב רכיב בטוחה",
    "HebrewLongName": "מור (0A)(!) אג\"ח חברות עם רכיב בטוחה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.82,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.19,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MORE MUTUAL FUNDS MANAGEMENT(2013)LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 444.1,
    "MonthYield": 0.65,
    "YearYield": 0.65,
    "Last12MonthYield": 6.06,
    "ISIN": "IL0051315864"
  },
  {
    "Id": "TASE:5128467",
    "MayaId": "5128467",
    "Name": "MTF ASIA TECHNL",
    "ShortName": "MTF ASIA TECHNL",
    "Symbol": "TASE:5128467",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4D) Bluestar Asia Technology",
    "EnglishLongName": "MTF TR (4D) Bluestar Asia Technology",
    "HebrewName": "MTF‏ מח BSEAQNTR",
    "HebrewLongName": "MTF מחקה (Bluestar Asia Technology (4D",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.88,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 55.4,
    "MonthYield": 5.99,
    "YearYield": 5.99,
    "Last12MonthYield": 29.54,
    "ISIN": "IL0051284672"
  },
  {
    "Id": "TASE:5121207",
    "MayaId": "5121207",
    "Name": "MTF IBOXIG30 HD",
    "ShortName": "MTF IBOXIG30 HD",
    "Symbol": "TASE:5121207",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (0A) iBoxx US Liquid Investment Grade Top 30 Currency-Hedged",
    "EnglishLongName": "MTF TR (0A) iBoxx US Liquid Investment Grade Top 30 Currency-Hedged",
    "HebrewName": "MTF מח‏ iBox $ IG30 ממ",
    "HebrewLongName": "MTF מחקה (iBoxx US Liquid Investment Grade Top 30 (0A מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Hedged Corporate and Convertibles",
    "AssetValue": 443.9,
    "MonthYield": 0.11,
    "YearYield": 0.11,
    "Last12MonthYield": 8.01,
    "ISIN": "IL0051212079"
  },
  {
    "Id": "TASE:5129267",
    "MayaId": "5129267",
    "Name": "MTF IND GLB CMR",
    "ShortName": "MTF IND GLB CMR",
    "Symbol": "TASE:5129267",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4D) Indxx Global E-Commerce",
    "EnglishLongName": "MTF TR (4D) Indxx Global E-Commerce",
    "HebrewName": "MTF מח Indx Glob E-Com",
    "HebrewLongName": "MTF מחקה (Indxx Global E-Commerce (4D",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.75,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 16.9,
    "MonthYield": -0.91,
    "YearYield": -0.91,
    "Last12MonthYield": 3.84,
    "ISIN": "IL0051292675"
  },
  {
    "Id": "TASE:5125752",
    "MayaId": "5125752",
    "Name": "MTF INDX GLBA&D",
    "ShortName": "MTF INDX GLBA&D",
    "Symbol": "TASE:5125752",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4D) Indxx Global Aerospace & Defense",
    "EnglishLongName": "MTF TR (4D) Indxx Global Aerospace & Defense",
    "HebrewName": "MTF מח Indx GlobA&D",
    "HebrewLongName": "MTF מחקה (Indxx Global Aerospace & Defense (4D",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.12,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 2239.8,
    "MonthYield": 12.89,
    "YearYield": 12.89,
    "Last12MonthYield": 57.07,
    "ISIN": "IL0051257520"
  },
  {
    "Id": "TASE:5125430",
    "MayaId": "5125430",
    "Name": "MTF INDXX E COM",
    "ShortName": "MTF INDXX E-COM",
    "Symbol": "TASE:5125430",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) Indxx US E-Commerce Currency-Hedged",
    "EnglishLongName": "MTF TR (4A) Indxx US E-Commerce Currency-Hedged",
    "HebrewName": "MTF מח Indx US E-Com ממ",
    "HebrewLongName": "MTF מחקה (Indxx US E-Commerce (4A מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.19,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 294.3,
    "MonthYield": -0.4,
    "YearYield": -0.4,
    "Last12MonthYield": 9.51,
    "ISIN": "IL0051254303"
  },
  {
    "Id": "TASE:5128020",
    "MayaId": "5128020",
    "Name": "MTF MTFGMDNT US",
    "ShortName": "MTF MTFGMDNT US",
    "Symbol": "TASE:5128020",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4D) Indxx Global Medical Devices USD-Hedged",
    "EnglishLongName": "MTF TR (4D) Indxx Global Medical Devices USD-Hedged",
    "HebrewName": "MTF מח‏ Indx GlobMedDev מ",
    "HebrewLongName": "MTF מחקה (Indxx Global Medical Devices (4D מנוטרלת דולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.94,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 26.7,
    "MonthYield": 1.66,
    "YearYield": 1.66,
    "Last12MonthYield": -0.48,
    "ISIN": "IL0051280209"
  },
  {
    "Id": "TASE:5130398",
    "MayaId": "5130398",
    "Name": "MTF PURE CYBER",
    "ShortName": "MTF PURE CYBER",
    "Symbol": "TASE:5130398",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4D) Indxx Pure Cyber USD-Hedged",
    "EnglishLongName": "MTF TR (4D) Indxx Pure Cyber USD-Hedged",
    "HebrewName": "MTF מח Indx Pure Cyber מד",
    "HebrewLongName": "MTF מחקה (Indxx Pure Cyber (4D מנוטרלת דולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.83,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 12.7,
    "MonthYield": -1.4,
    "YearYield": -1.4,
    "Last12MonthYield": -9.32,
    "ISIN": "IL0051303985"
  },
  {
    "Id": "TASE:5130745",
    "MayaId": "5130745",
    "Name": "MTF RE ENRGY HD",
    "ShortName": "MTF RE ENRGY HD",
    "Symbol": "TASE:5130745",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4D) Indxx Renewable Energy USD-Hedged",
    "EnglishLongName": "MTF TR (4D) Indxx Renewable Energy USD-Hedged",
    "HebrewName": "MTF מח Indxx ReEnergy מד",
    "HebrewLongName": "MTF מחקה (Indxx Renewable Energy (4D מנוטרלת דולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.94,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 31.8,
    "MonthYield": 3.49,
    "YearYield": 3.49,
    "Last12MonthYield": 31.51,
    "ISIN": "IL0051307457"
  },
  {
    "Id": "TASE:5124730",
    "MayaId": "5124730",
    "Name": "MTF RU1GN30U",
    "ShortName": "MTF RU1GN30U",
    "Symbol": "TASE:5124730",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4D) Russell 1000 Growth",
    "EnglishLongName": "MTF TR (4D) Russell 1000 Growth",
    "HebrewName": "MTF מח‏ Russell 1000G",
    "HebrewLongName": "MTF מחקה (Russell 1000 Growth (4D",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.77,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 94.3,
    "MonthYield": -1.92,
    "YearYield": -1.92,
    "Last12MonthYield": 0.76,
    "ISIN": "IL0051247307"
  },
  {
    "Id": "TASE:5123575",
    "MayaId": "5123575",
    "Name": "MTF S&P 500 LVHD",
    "ShortName": "MTF S&P500 LVHD",
    "Symbol": "TASE:5123575",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) S&P 500 Low Volatility High Dividend Currency-Hedged",
    "EnglishLongName": "MTF TR (4A) S&P 500 Low Volatility High Dividend Currency-Hedged",
    "HebrewName": "MTF מח‏ SP500 LVHD ממ",
    "HebrewLongName": "MTF מחקה (S&P 500 Low Volatility High Dividend (4A מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.1,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 15.7,
    "MonthYield": 3.18,
    "YearYield": 3.18,
    "Last12MonthYield": 3.61,
    "ISIN": "IL0051235757"
  },
  {
    "Id": "TASE:5125760",
    "MayaId": "5125760",
    "Name": "MTF S&P TECH HD",
    "ShortName": "MTF S&P TECH HD",
    "Symbol": "TASE:5125760",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) S&P Technology Currency-Hedged",
    "EnglishLongName": "MTF TR (4A) S&P Technology Currency-Hedged",
    "HebrewName": "MTF מח‏ SP Tech ממ",
    "HebrewLongName": "MTF מחקה (S&P Technology (4A מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.66,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 132.9,
    "MonthYield": 0.97,
    "YearYield": 0.97,
    "Last12MonthYield": 22.04,
    "ISIN": "IL0051257603"
  },
  {
    "Id": "MTF-F58.TA",
    "MayaId": "1162361",
    "Name": "MTF Sal (00) Index Banks and Insurance Bonds Tier 2 IL",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F58.TA",
    "TaseSymbol": "MTF.F58",
    "YahooId": "MTF-F58.TA",
    "EnglishName": "MTF.BNBITBO2 IL",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.אגחבנקביט2",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.005,
    "VariableFee": 0.03,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 516.96,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MIGDAL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate Bond - Shekel, Linked",
    "AssetValue": null,
    "MonthYield": 0.9,
    "YearYield": 0.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011623613"
  },
  {
    "Id": "MTF.FK55.TA",
    "MayaId": "1159698",
    "Name": "MTF SAL (00) Kosher Tel Bond 60 CPI Linked IL",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF.FK55.TA",
    "TaseSymbol": "MTF.FK55",
    "YahooId": "MTF.FK55.TA",
    "EnglishName": "MTF.KOTEL-B60IL",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.כשתלבונד60",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 507.17,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.4,
    "YearYield": 0.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011596983"
  },
  {
    "Id": "MTF.FK57.TA",
    "MayaId": "1159706",
    "Name": "MTF SAL (00) Kosher Tel Bond shekel IL",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF.FK57.TA",
    "TaseSymbol": "MTF.FK57",
    "YahooId": "MTF.FK57.TA",
    "EnglishName": "MTF.KOTELBSH IL",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.כשתלבונדשקל",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 501.72,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.9,
    "YearYield": 0.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011597064"
  },
  {
    "Id": "MTF-F3.TA",
    "MayaId": "1149988",
    "Name": "MTF SAL (00) Tel Bond 20 CPI Linked IL",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F3.TA",
    "TaseSymbol": "MTF.F3",
    "YahooId": "MTF-F3.TA",
    "EnglishName": "MTF.TEL-B20 IL",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.תלבונד20",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.005,
    "VariableFee": 0.01,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 504.04,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.4,
    "YearYield": 0.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011499881"
  },
  {
    "Id": "MTF-F4.TA",
    "MayaId": "1149996",
    "Name": "MTF SAL (00) Tel Bond 60 CPI Linked IL",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F4.TA",
    "TaseSymbol": "MTF.F4",
    "YahooId": "MTF-F4.TA",
    "EnglishName": "MTF.TEL-B60 IL",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.תלבונד60",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.005,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 505.48,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.2,
    "YearYield": 0.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011499964"
  },
  {
    "Id": "MTF-F112.TA",
    "MayaId": "1193127",
    "Name": "MTF SAL (00) Tel Bond CPI Linked 1 3 IL",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F112.TA",
    "TaseSymbol": "MTF.F112",
    "YahooId": "MTF-F112.TA",
    "EnglishName": "MTF.TEL-CP03IL",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.תלבנצ1-3",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.005,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 406.16,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MIGDAL",
    "TrusteeName": "UBANK",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest - short term",
    "AssetValue": null,
    "MonthYield": 0.2,
    "YearYield": 0.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011931271"
  },
  {
    "Id": "MTF-F117.TA",
    "MayaId": "1193135",
    "Name": "MTF Sal (00) Tel Bond CPI Linked 5 15 IL",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F117.TA",
    "TaseSymbol": "MTF.F117",
    "YahooId": "MTF-F117.TA",
    "EnglishName": "MTF.TEL-CP51IL",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.תלבנדצ5-15",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.005,
    "VariableFee": 0.02,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 440.91,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MIGDAL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed  interest - long term",
    "AssetValue": null,
    "MonthYield": 0.9,
    "YearYield": 0.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011931354"
  },
  {
    "Id": "MTF-F79.TA",
    "MayaId": "1171594",
    "Name": "MTF SAL (00) Tel Bond CPI Linked A IL",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F79.TA",
    "TaseSymbol": "MTF.F79",
    "YahooId": "MTF-F79.TA",
    "EnglishName": "MTF.TEL-CPIA IL",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.תלבוצמודA",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.005,
    "VariableFee": 0.02,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 419.85,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.2,
    "YearYield": 0.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011715948"
  },
  {
    "Id": "MTF-F11.TA",
    "MayaId": "1150101",
    "Name": "MTF SAL (00) Tel Bond CPI Linked IL",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F11.TA",
    "TaseSymbol": "MTF.F11",
    "YahooId": "MTF-F11.TA",
    "EnglishName": "MTF.TEL-BCL IL",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.תלבונדצמוד",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.005,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 447.95,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.2,
    "YearYield": 0.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011501017"
  },
  {
    "Id": "MTF-F113.TA",
    "MayaId": "1193051",
    "Name": "MTF SAL (00) Tel Bond Shekel 1 3 IL",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F113.TA",
    "TaseSymbol": "MTF.F113",
    "YahooId": "MTF-F113.TA",
    "EnglishName": "MTF.TEL-SH03IL",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.תלבנדש1-3",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.005,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 472.11,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MIGDAL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest - short term",
    "AssetValue": null,
    "MonthYield": 0.8,
    "YearYield": 0.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011930513"
  },
  {
    "Id": "MTF-F114.TA",
    "MayaId": "1193044",
    "Name": "MTF Sal (00) Tel Bond Shekel 5 15 IL",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F114.TA",
    "TaseSymbol": "MTF.F114",
    "YahooId": "MTF-F114.TA",
    "EnglishName": "MTF.TEL-SH51IL",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.תלבנדש5-15",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.005,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 443.77,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MIGDAL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed  interest - long term",
    "AssetValue": null,
    "MonthYield": 1.6,
    "YearYield": 1.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011930448"
  },
  {
    "Id": "MTF-F15.TA",
    "MayaId": "1150168",
    "Name": "MTF SAL (00) Tel Bond Shekel 50 IL",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F15.TA",
    "TaseSymbol": "MTF.F15",
    "YahooId": "MTF-F15.TA",
    "EnglishName": "MTF.TEL-B50 IL",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.תלבונדשקל50",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.005,
    "VariableFee": 0.02,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 350.14,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.9,
    "YearYield": 0.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011501686"
  },
  {
    "Id": "MTF-F80.TA",
    "MayaId": "1172824",
    "Name": "MTF SAL (00) Tel Bond Shekel A IL",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F80.TA",
    "TaseSymbol": "MTF.F80",
    "YahooId": "MTF-F80.TA",
    "EnglishName": "MTF.TEL-SHA IL",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.תלבושקלA",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.005,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 449.65,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 1.0,
    "YearYield": 1.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011728248"
  },
  {
    "Id": "MTF-F5.TA",
    "MayaId": "1150002",
    "Name": "MTF SAL (00) Tel Bond Shekel IL",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F5.TA",
    "TaseSymbol": "MTF.F5",
    "YahooId": "MTF-F5.TA",
    "EnglishName": "MTF.TEL-BSH IL",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.תלבונדשקלי",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.005,
    "VariableFee": 0.02,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 501.51,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.9,
    "YearYield": 0.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011500027"
  },
  {
    "Id": "MTF-F6.TA",
    "MayaId": "1150010",
    "Name": "MTF SAL (00) Tel Gov CPI Linked 2 5 IL",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F6.TA",
    "TaseSymbol": "MTF.F6",
    "YahooId": "MTF-F6.TA",
    "EnglishName": "MTF.TAR25GV IL",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.תג צמוד 2-5",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.03,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 381.92,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government linked index - medium term",
    "AssetValue": null,
    "MonthYield": 0.2,
    "YearYield": 0.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011500100"
  },
  {
    "Id": "MTF-F9.TA",
    "MayaId": "1150069",
    "Name": "MTF SAL (00) Tel Gov CPI Linked 5 10 IL",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F9.TA",
    "TaseSymbol": "MTF.F9",
    "YahooId": "MTF-F9.TA",
    "EnglishName": "MTF.TAR510GV IL",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.תג צמוד5-10",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.03,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 410.26,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government linked index  - long term",
    "AssetValue": null,
    "MonthYield": -0.1,
    "YearYield": -0.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011500696"
  },
  {
    "Id": "MTF-F8.TA",
    "MayaId": "1150051",
    "Name": "MTF SAL (00) Tel Gov Shekel 5+ IL",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F8.TA",
    "TaseSymbol": "MTF.F8",
    "YahooId": "MTF-F8.TA",
    "EnglishName": "MTF.TAR5FIG IL",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.תג שקלי 5+",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.03,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 487.33,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Fixed  interest- long term",
    "AssetValue": null,
    "MonthYield": 1.5,
    "YearYield": 1.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011500514"
  },
  {
    "Id": "MTF-F1.TA",
    "MayaId": "1149954",
    "Name": "MTF SAL (00) Tel Gov Shekel IL",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F1.TA",
    "TaseSymbol": "MTF.F1",
    "YahooId": "MTF-F1.TA",
    "EnglishName": "MTF.TANLCFXG IL",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.תג-שקלי",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 402.05,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 1.2,
    "YearYield": 1.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011499543"
  },
  {
    "Id": "MTF-F13.TA",
    "MayaId": "1150135",
    "Name": "MTF SAL (00)(!) Tel Bond Gobal Shekel IL",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F13.TA",
    "TaseSymbol": "MTF.F13",
    "YahooId": "MTF-F13.TA",
    "EnglishName": "MTF.TEL-BGLO IL",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.תלבונדגלובל",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 398.53,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.9,
    "YearYield": 0.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011501355"
  },
  {
    "Id": "MTF-F12.TA",
    "MayaId": "1150119",
    "Name": "MTF SAL (00)(!) Tel Bond Yields CPI Linked IL",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F12.TA",
    "TaseSymbol": "MTF.F12",
    "YahooId": "MTF-F12.TA",
    "EnglishName": "MTF.TEL-YLD IL",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.תלבונדתשוצמ",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.005,
    "VariableFee": 0.03,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 455.33,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": -0.1,
    "YearYield": -0.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011501199"
  },
  {
    "Id": "MTF-F2.TA",
    "MayaId": "1149962",
    "Name": "MTF SAL (00)Tel Gov Shekel 2 5 IL",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F2.TA",
    "TaseSymbol": "MTF.F2",
    "YahooId": "MTF-F2.TA",
    "EnglishName": "MTF.TAR25FIG IL",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.תג שקלי 2-5",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.03,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 431.93,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Fixed interest- medium term",
    "AssetValue": null,
    "MonthYield": 0.7,
    "YearYield": 0.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011499626"
  },
  {
    "Id": "MTF-F116.TA",
    "MayaId": "1193317",
    "Name": "MTF Sal (0A) Tel Bond Composite IL",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F116.TA",
    "TaseSymbol": "MTF.F116",
    "YahooId": "MTF-F116.TA",
    "EnglishName": "MTF.TELBNDCOMIL",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.תלבונד-מאגר",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.005,
    "VariableFee": 0.02,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 431.42,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MIGDAL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate Bond - Shekel, Linked",
    "AssetValue": null,
    "MonthYield": 0.5,
    "YearYield": 0.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011933178"
  },
  {
    "Id": "MTF-F115.TA",
    "MayaId": "1193069",
    "Name": "MTF Sal (0A) Tel Gov IL",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F115.TA",
    "TaseSymbol": "MTF.F115",
    "YahooId": "MTF-F115.TA",
    "EnglishName": "MTF.TAGBDGVIL",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.תל גוב כללי",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.005,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 396.34,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MIGDAL",
    "TrusteeName": "UBANK",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.5,
    "YearYield": 0.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011930695"
  },
  {
    "Id": "MTF-F109.TA",
    "MayaId": "1191881",
    "Name": "MTF Sal (0D) iBoxx US Liquid Investment Grade Top 30",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F109.TA",
    "TaseSymbol": "MTF.F109",
    "YahooId": "MTF-F109.TA",
    "EnglishName": "MTF.IBOXX IG30",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "IBOXX IG30.MTF",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 102.6,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -1.3,
    "YearYield": -1.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011918815"
  },
  {
    "Id": "MTF-F125.TA",
    "MayaId": "1219294",
    "Name": "MTF Sal (0D) Index US Gov 10Y Fixed Duration",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F125.TA",
    "TaseSymbol": "MTF.F125",
    "YahooId": "MTF-F125.TA",
    "EnglishName": "MTF.TBILL DUR10",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "US GOV 10Y.MTF",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 257.95,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MIGDAL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -0.5,
    "YearYield": -0.5,
    "Last12MonthYield": null,
    "ISIN": "IL0012192949"
  },
  {
    "Id": "MTF-F36.TA",
    "MayaId": "1150416",
    "Name": "MTF SAL (4A) DAX Currency Hedged",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F36.TA",
    "TaseSymbol": "MTF.F36",
    "YahooId": "MTF-F36.TA",
    "EnglishName": "MTF.DAXHD",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.סלDAXממ",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.45,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5837.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Europe - developed markets",
    "AssetValue": null,
    "MonthYield": 2.1,
    "YearYield": 2.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011504169"
  },
  {
    "Id": "MTF-F120.TA",
    "MayaId": "1201623",
    "Name": "MTF SAL (4A) Index Israel 120 IL",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F120.TA",
    "TaseSymbol": "MTF.F120",
    "YahooId": "MTF-F120.TA",
    "EnglishName": "MTF.ISR120IL",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.אינד120ישר",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.005,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 6033.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Large & Mid Cap",
    "AssetValue": null,
    "MonthYield": 8.4,
    "YearYield": 8.4,
    "Last12MonthYield": null,
    "ISIN": "IL0012016239"
  },
  {
    "Id": "MTF-F71.TA",
    "MayaId": "1168723",
    "Name": "MTF Sal (4A) Index Israeli Renewable Energy Equityl IL",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F71.TA",
    "TaseSymbol": "MTF.F71",
    "YahooId": "MTF-F71.TA",
    "EnglishName": "MTF.INX ENRG IL",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.אנר מתחד יש",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.02,
    "VariableFee": 0.15,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1659.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Oil, gas and energy",
    "AssetValue": null,
    "MonthYield": 11.4,
    "YearYield": 11.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011687238"
  },
  {
    "Id": "MTF.FK56.TA",
    "MayaId": "1159714",
    "Name": "MTF Sal (4A) Kosher TA 125 IL",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF.FK56.TA",
    "TaseSymbol": "MTF.FK56",
    "YahooId": "MTF.FK56.TA",
    "EnglishName": "MTF.K TA-125 IL",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.כשתא125",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.005,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 6044.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Large & Mid Cap",
    "AssetValue": null,
    "MonthYield": 9.1,
    "YearYield": 9.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011597148"
  },
  {
    "Id": "MTF-F85.TA",
    "MayaId": "1176031",
    "Name": "MTF SAL (4A) MSCI AC World USD Hedged",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F85.TA",
    "TaseSymbol": "MTF.F85",
    "YahooId": "MTF-F85.TA",
    "EnglishName": "MTF.M1WDHD",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MSCIACWI.MTF מד",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3059.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.0,
    "YearYield": 1.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011760316"
  },
  {
    "Id": "MTF-F96.TA",
    "MayaId": "1181445",
    "Name": "MTF Sal (4A) Nasdaq 100 Currency Hedged",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F96.TA",
    "TaseSymbol": "MTF.F96",
    "YahooId": "MTF-F96.TA",
    "EnglishName": "MTF.NASDAQ100HD",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "NASDAQ100.MTFממ",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 9745.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": -0.9,
    "YearYield": -0.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011814451"
  },
  {
    "Id": "MTF-F50.TA",
    "MayaId": "1150531",
    "Name": "MTF SAL (4A) NIKKEI 225 Currency Hedged",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F50.TA",
    "TaseSymbol": "MTF.F50",
    "YahooId": "MTF-F50.TA",
    "EnglishName": "MTF.NKYNTRHD",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "NIKKEI225.MTFממ",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.77,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5658.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Asia and Pacific - developed markets",
    "AssetValue": null,
    "MonthYield": 6.2,
    "YearYield": 6.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011505315"
  },
  {
    "Id": "MTF-F51.TA",
    "MayaId": "1150549",
    "Name": "MTF SAL (4A) RUSSELL 2000 Currency Hedged",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F51.TA",
    "TaseSymbol": "MTF.F51",
    "YahooId": "MTF-F51.TA",
    "EnglishName": "MTF.RU20N30UHD",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "RUSS2000.MTFממ",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4529.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": 5.7,
    "YearYield": 5.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011505497"
  },
  {
    "Id": "MTF-F52.TA",
    "MayaId": "1150572",
    "Name": "MTF SAL (4A) S&P 500 Currency Hedged",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F52.TA",
    "TaseSymbol": "MTF.F52",
    "YahooId": "MTF-F52.TA",
    "EnglishName": "MTF.SPTR500NHD",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "SP500.MTFממ",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 8627.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Europe - developed markets",
    "AssetValue": null,
    "MonthYield": -0.3,
    "YearYield": -0.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011505729"
  },
  {
    "Id": "MTF-F39.TA",
    "MayaId": "1150564",
    "Name": "MTF SAL (4A) S&P Aerospace & Defense Currency Hedged",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F39.TA",
    "TaseSymbol": "MTF.F39",
    "YahooId": "MTF-F39.TA",
    "EnglishName": "MTF.SPSIADNHD",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "D.MTF&SPUSAממ",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5927.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Aerospace & Defense",
    "AssetValue": null,
    "MonthYield": 20.3,
    "YearYield": 20.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011505646"
  },
  {
    "Id": "MTF-F42.TA",
    "MayaId": "1150663",
    "Name": "MTF SAL (4A) S&P Consumer Discretionary Currency Hedged",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F42.TA",
    "TaseSymbol": "MTF.F42",
    "YahooId": "MTF-F42.TA",
    "EnglishName": "MTF.IXYNTRHD",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.צריכהמחSPממ",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 7386.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Consumer Discretionary",
    "AssetValue": null,
    "MonthYield": 1.7,
    "YearYield": 1.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011506636"
  },
  {
    "Id": "MTF-F43.TA",
    "MayaId": "1150689",
    "Name": "MTF SAL (4A) S&P Consumer Staples Currency Hedged",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F43.TA",
    "TaseSymbol": "MTF.F43",
    "YahooId": "MTF-F43.TA",
    "EnglishName": "MTF.IXRNTRHD",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.צריכהבסSPממ",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.03,
    "VariableFee": 0.15,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3426.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Consumer Staples",
    "AssetValue": null,
    "MonthYield": 4.7,
    "YearYield": 4.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011506891"
  },
  {
    "Id": "MTF-F44.TA",
    "MayaId": "1150721",
    "Name": "MTF SAL (4A) S&P Energy Currency Hedged",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F44.TA",
    "TaseSymbol": "MTF.F44",
    "YahooId": "MTF-F44.TA",
    "EnglishName": "MTF.IXENTRHD",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "SPENERGY.MTFממ",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.03,
    "VariableFee": 0.15,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3674.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Energy",
    "AssetValue": null,
    "MonthYield": 6.1,
    "YearYield": 6.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011507212"
  },
  {
    "Id": "MTF-F45.TA",
    "MayaId": "1150598",
    "Name": "MTF SAL (4A) S&P Financial Currency Hedged",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F45.TA",
    "TaseSymbol": "MTF.F45",
    "YahooId": "MTF-F45.TA",
    "EnglishName": "MTF.IXMNTRHD",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "SPFINANCE.MTFממ",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5214.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Financial",
    "AssetValue": null,
    "MonthYield": -1.1,
    "YearYield": -1.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011505984"
  },
  {
    "Id": "MTF-F46.TA",
    "MayaId": "1150432",
    "Name": "MTF SAL (4A) S&P Health Care Currency Hedged",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F46.TA",
    "TaseSymbol": "MTF.F46",
    "YahooId": "MTF-F46.TA",
    "EnglishName": "MTF.IXVNTRHD",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "SPHEALTH.MTFממ",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 6160.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Health Care",
    "AssetValue": null,
    "MonthYield": -0.5,
    "YearYield": -0.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011504326"
  },
  {
    "Id": "MTF-F47.TA",
    "MayaId": "1150457",
    "Name": "MTF SAL (4A) S&P Industrial Currency Hedged",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F47.TA",
    "TaseSymbol": "MTF.F47",
    "YahooId": "MTF-F47.TA",
    "EnglishName": "MTF.IXINTRHD",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "SPINDUSTR.MTFממ",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5245.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Industrials",
    "AssetValue": null,
    "MonthYield": 6.1,
    "YearYield": 6.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011504573"
  },
  {
    "Id": "MTF-F131.TA",
    "MayaId": "1212794",
    "Name": "MTF Sal (4A) S&P Israel 100 (ILS) IL",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F131.TA",
    "TaseSymbol": "MTF.F131",
    "YahooId": "MTF-F131.TA",
    "EnglishName": "MTF.SPISOHINIL",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "SP100ISRAEL.MTF",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.005,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3699.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Large & Mid Cap",
    "AssetValue": null,
    "MonthYield": 9.6,
    "YearYield": 9.6,
    "Last12MonthYield": null,
    "ISIN": "IL0012127945"
  },
  {
    "Id": "MTF-F48.TA",
    "MayaId": "1150481",
    "Name": "MTF SAL (4A) S&P Technology Currency Hedged",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F48.TA",
    "TaseSymbol": "MTF.F48",
    "YahooId": "MTF-F48.TA",
    "EnglishName": "MTF.IXTNTRHD",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "SPTECH.MTFממ",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 11700.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Technology",
    "AssetValue": null,
    "MonthYield": -1.8,
    "YearYield": -1.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011504813"
  },
  {
    "Id": "MTF-F49.TA",
    "MayaId": "1150507",
    "Name": "MTF SAL (4A) S&P Utilities Currency Hedged",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F49.TA",
    "TaseSymbol": "MTF.F49",
    "YahooId": "MTF-F49.TA",
    "EnglishName": "MTF.IXUNTRHD",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "SPUTILIT.MTFממ",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3441.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Utilities",
    "AssetValue": null,
    "MonthYield": 0.4,
    "YearYield": 0.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011505075"
  },
  {
    "Id": "MTF-F40.TA",
    "MayaId": "1150614",
    "Name": "MTF SAL (4A) STOXX Europe 600 Currency Hedged",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F40.TA",
    "TaseSymbol": "MTF.F40",
    "YahooId": "MTF-F40.TA",
    "EnglishName": "MTF.SXXRHD",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "STX600.MTFממ",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.55,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 9056.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Europe - general",
    "AssetValue": null,
    "MonthYield": 2.7,
    "YearYield": 2.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011506149"
  },
  {
    "Id": "MTF-F84.TA",
    "MayaId": "1174796",
    "Name": "MTF SAL (4A) TA 125 Fossil Free IL",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F84.TA",
    "TaseSymbol": "MTF.F84",
    "YahooId": "MTF-F84.TA",
    "EnglishName": "MTF.TA125FOS IL",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "TA125FOSSIL.MTF",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3999.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Large & Mid Cap",
    "AssetValue": null,
    "MonthYield": 9.6,
    "YearYield": 9.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011747966"
  },
  {
    "Id": "MTF-F19.TA",
    "MayaId": "1150283",
    "Name": "MTF SAL (4A) TA 125 IL",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F19.TA",
    "TaseSymbol": "MTF.F19",
    "YahooId": "MTF-F19.TA",
    "EnglishName": "MTF.TA-125 IL",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.תא125",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.24,
    "TrusteeFee": 0.005,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 6036.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Large & Mid Cap",
    "AssetValue": null,
    "MonthYield": 8.5,
    "YearYield": 8.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011502833"
  },
  {
    "Id": "MTF-F16.TA",
    "MayaId": "1150184",
    "Name": "MTF SAL (4A) TA 35 IL",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F16.TA",
    "TaseSymbol": "MTF.F16",
    "YahooId": "MTF-F16.TA",
    "EnglishName": "MTF.TA-35 IL",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.תא35",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.24,
    "TrusteeFee": 0.005,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5247.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Large Cap",
    "AssetValue": null,
    "MonthYield": 9.4,
    "YearYield": 9.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011501843"
  },
  {
    "Id": "MTF-F17.TA",
    "MayaId": "1150259",
    "Name": "MTF SAL (4A) TA 90 IL",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F17.TA",
    "TaseSymbol": "MTF.F17",
    "YahooId": "MTF-F17.TA",
    "EnglishName": "MTF.TA-90 IL",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.תא90",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.005,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5559.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Mid Cap",
    "AssetValue": null,
    "MonthYield": 6.7,
    "YearYield": 6.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011502593"
  },
  {
    "Id": "MTF-F65.TA",
    "MayaId": "1165653",
    "Name": "MTF SAL (4A) TA Construction IL",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F65.TA",
    "TaseSymbol": "MTF.F65",
    "YahooId": "MTF-F65.TA",
    "EnglishName": "MTF.TA-CONS IL",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.תא-בנייה",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.03,
    "VariableFee": 0.2,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2230.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Real estate and construction",
    "AssetValue": null,
    "MonthYield": 11.8,
    "YearYield": 11.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011656530"
  },
  {
    "Id": "MTF-F66.TA",
    "MayaId": "1165661",
    "Name": "MTF SAL (4A) TA Israel Commercial Real Estate IL",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F66.TA",
    "TaseSymbol": "MTF.F66",
    "YahooId": "MTF-F66.TA",
    "EnglishName": "MTF.TA-IPIS IL",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.תא-מניב ישר",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.03,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1493.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Real estate and construction",
    "AssetValue": null,
    "MonthYield": 7.9,
    "YearYield": 7.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011656613"
  },
  {
    "Id": "MTF-F100.TA",
    "MayaId": "1183953",
    "Name": "MTF Sal (4A) TA Real Estate IL",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F100.TA",
    "TaseSymbol": "MTF.F100",
    "YahooId": "MTF-F100.TA",
    "EnglishName": "MTF.TA-REALE IL",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.תא-נדלן",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.015,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1599.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Real estate and construction",
    "AssetValue": null,
    "MonthYield": 9.8,
    "YearYield": 9.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011839532"
  },
  {
    "Id": "MTF-F18.TA",
    "MayaId": "1150267",
    "Name": "MTF SAL (4A) TA Tech Elite IL",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F18.TA",
    "TaseSymbol": "MTF.F18",
    "YahooId": "MTF-F18.TA",
    "EnglishName": "MTF.TATECELT IL",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.טק-עילית",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 730.2,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "technology",
    "AssetValue": null,
    "MonthYield": 12.6,
    "YearYield": 12.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011502676"
  },
  {
    "Id": "MTF-F74.TA",
    "MayaId": "1169408",
    "Name": "MTF SAL (4A) TA Technology IL",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F74.TA",
    "TaseSymbol": "MTF.F74",
    "YahooId": "MTF-F74.TA",
    "EnglishName": "MTF.TA-TECH IL",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.תא-טכנ",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.01,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2219.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "technology",
    "AssetValue": null,
    "MonthYield": 14.6,
    "YearYield": 14.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011694085"
  },
  {
    "Id": "MTF-F126.TA",
    "MayaId": "1205657",
    "Name": "MTF SAL (4D) Bloomberg US Analyst Recommendations",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F126.TA",
    "TaseSymbol": "MTF.F126",
    "YahooId": "MTF-F126.TA",
    "EnglishName": "MTF.USANLYS REC",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "USANLYS REC.MTF",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2575.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": -0.7,
    "YearYield": -0.7,
    "Last12MonthYield": null,
    "ISIN": "IL0012056573"
  },
  {
    "Id": "MTF-F78.TA",
    "MayaId": "1171586",
    "Name": "MTF Sal (4D) Bluestar China Internet Software",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F78.TA",
    "TaseSymbol": "MTF.F78",
    "YahooId": "MTF-F78.TA",
    "EnglishName": "MTF.BCHNQNTR",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "BSCHINA NET.MTF",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1149.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Internet",
    "AssetValue": null,
    "MonthYield": 8.0,
    "YearYield": 8.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011715864"
  },
  {
    "Id": "MTF-F68.TA",
    "MayaId": "1169796",
    "Name": "MTF Sal (4D) Bluestar Top 10 US Banks",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F68.TA",
    "TaseSymbol": "MTF.F68",
    "YahooId": "MTF-F68.TA",
    "EnglishName": "MTF.BUBNKNTR",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "TOP10USBNK.MTF",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3880.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Banking",
    "AssetValue": null,
    "MonthYield": -2.0,
    "YearYield": -2.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011697963"
  },
  {
    "Id": "MTF-F69.TA",
    "MayaId": "1167584",
    "Name": "MTF Sal (4D) Bluestar Travel & Vacation",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F69.TA",
    "TaseSymbol": "MTF.F69",
    "YahooId": "MTF-F69.TA",
    "EnglishName": "MTF.BTOURNTR",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "VAC.MTF&TRAVEL",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3308.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Travel",
    "AssetValue": null,
    "MonthYield": -0.3,
    "YearYield": -0.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011675845"
  },
  {
    "Id": "MTF-F7.TA",
    "MayaId": "1150861",
    "Name": "MTF SAL (4D) DAX",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F7.TA",
    "TaseSymbol": "MTF.F7",
    "YahooId": "MTF-F7.TA",
    "EnglishName": "MTF.DAX",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "DAX.MTF",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.45,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 8599.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Europe - developed markets",
    "AssetValue": null,
    "MonthYield": -0.1,
    "YearYield": -0.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011508616"
  },
  {
    "Id": "MTF-F93.TA",
    "MayaId": "1181023",
    "Name": "MTF Sal (4D) FTSE China A50",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F93.TA",
    "TaseSymbol": "MTF.F93",
    "YahooId": "MTF-F93.TA",
    "EnglishName": "MTF.CHIHIN A50",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "CHINAA50.MTF",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2457.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Asia and the Pacific - emerging markets",
    "AssetValue": null,
    "MonthYield": -1.6,
    "YearYield": -1.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011810236"
  },
  {
    "Id": "MTF-F76.TA",
    "MayaId": "1171321",
    "Name": "MTF Sal (4D) Index Shopping Centers REIT",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F76.TA",
    "TaseSymbol": "MTF.F76",
    "YahooId": "MTF-F76.TA",
    "EnglishName": "MTF.SHOPCENRIET",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "SHOPCENREIT.MTF",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4203.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "REIT &  Real Estate",
    "AssetValue": null,
    "MonthYield": 1.5,
    "YearYield": 1.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011713216"
  },
  {
    "Id": "MTF-F122.TA",
    "MayaId": "1200195",
    "Name": "MTF Sal (4D) Index Top10 Tech",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F122.TA",
    "TaseSymbol": "MTF.F122",
    "YahooId": "MTF-F122.TA",
    "EnglishName": "MTF.TOP10 TECH",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "TOP10 TECH.MTF",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3397.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Technology",
    "AssetValue": null,
    "MonthYield": -2.8,
    "YearYield": -2.8,
    "Last12MonthYield": null,
    "ISIN": "IL0012001959"
  },
  {
    "Id": "MTF-F127.TA",
    "MayaId": "1207901",
    "Name": "MTF Sal (4D) Index US Semiconductors Top10",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F127.TA",
    "TaseSymbol": "MTF.F127",
    "YahooId": "MTF-F127.TA",
    "EnglishName": "MTF.TOP10SEMIC",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "TOP10SEMIC.MTF",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3212.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Semiconductor",
    "AssetValue": null,
    "MonthYield": 9.1,
    "YearYield": 9.1,
    "Last12MonthYield": null,
    "ISIN": "IL0012079013"
  },
  {
    "Id": "MTF-F128.TA",
    "MayaId": "1217561",
    "Name": "MTF Sal (4D) iNDEX US Top10 Pure Cyber Security",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F128.TA",
    "TaseSymbol": "MTF.F128",
    "YahooId": "MTF-F128.TA",
    "EnglishName": "MTF.TOP10 CYBER",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "TOP10 CYBER.MTF",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1851.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Cyber Security",
    "AssetValue": null,
    "MonthYield": -1.3,
    "YearYield": -1.3,
    "Last12MonthYield": null,
    "ISIN": "IL0012175613"
  },
  {
    "Id": "MTF-F107.TA",
    "MayaId": "1189810",
    "Name": "MTF Sal (4D) Index World Growth",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F107.TA",
    "TaseSymbol": "MTF.F107",
    "YahooId": "MTF-F107.TA",
    "EnglishName": "MTF.WORLDGROWTH",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.צמיחהעולמי",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.12,
    "TrusteeFee": 0.005,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3716.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -0.2,
    "YearYield": -0.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011898108"
  },
  {
    "Id": "MTF-F106.TA",
    "MayaId": "1189828",
    "Name": "MTF Sal (4D) Index World Value",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F106.TA",
    "TaseSymbol": "MTF.F106",
    "YahooId": "MTF-F106.TA",
    "EnglishName": "MTF.WORLDVALUE",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.ערךעולמי",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.12,
    "TrusteeFee": 0.005,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3989.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.1,
    "YearYield": 1.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011898280"
  },
  {
    "Id": "MTF-F134.TA",
    "MayaId": "1222439",
    "Name": "MTF SAL (4D) Indxx Top 10 Europe Defense Euro Hedged",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F134.TA",
    "TaseSymbol": "MTF.F134",
    "YahooId": "MTF-F134.TA",
    "EnglishName": "MTF.IT10EUDNEH",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "IT10EUDE.MTFמא",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3050.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Aerospace & Defense",
    "AssetValue": null,
    "MonthYield": 21.3,
    "YearYield": 21.3,
    "Last12MonthYield": null,
    "ISIN": "IL0012224395"
  },
  {
    "Id": "MTF-F133.TA",
    "MayaId": "1221670",
    "Name": "MTF SAL (4D) Indxx Top 10 US Oil Industry",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F133.TA",
    "TaseSymbol": "MTF.F133",
    "YahooId": "MTF-F133.TA",
    "EnglishName": "MTF.INDIT10UOIN",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "INDXXOILT10.MTF",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2311.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Energy",
    "AssetValue": null,
    "MonthYield": 6.2,
    "YearYield": 6.2,
    "Last12MonthYield": null,
    "ISIN": "IL0012216706"
  },
  {
    "Id": "MTF-F123.TA",
    "MayaId": "1200351",
    "Name": "MTF Sal (4D) Indxx US Healthcare Top 10",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F123.TA",
    "TaseSymbol": "MTF.F123",
    "YahooId": "MTF-F123.TA",
    "EnglishName": "MTF.MTFUSHN10",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "HEALT10.MTF",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2417.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Health Care",
    "AssetValue": null,
    "MonthYield": -2.7,
    "YearYield": -2.7,
    "Last12MonthYield": null,
    "ISIN": "IL0012003518"
  },
  {
    "Id": "MTF-F54.TA",
    "MayaId": "1158328",
    "Name": "MTF SAL (4D) Indxx USA Cloud Computing",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F54.TA",
    "TaseSymbol": "MTF.F54",
    "YahooId": "MTF-F54.TA",
    "EnglishName": "MTF.MTFCCUNT",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "CLOUD COMP.MTF",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3802.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Cloud Computing",
    "AssetValue": null,
    "MonthYield": -9.2,
    "YearYield": -9.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011583288"
  },
  {
    "Id": "MTF-F124.TA",
    "MayaId": "1201003",
    "Name": "MTF Sal (4D) MSCI AC World",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F124.TA",
    "TaseSymbol": "MTF.F124",
    "YahooId": "MTF-F124.TA",
    "EnglishName": "MTF.MSCI ACWI",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MSCI ACWI.MTF",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.17,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3560.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.1,
    "YearYield": 0.1,
    "Last12MonthYield": null,
    "ISIN": "IL0012010034"
  },
  {
    "Id": "MTF-F34.TA",
    "MayaId": "1150275",
    "Name": "MTF SAL (4D) MSCI Emerging Markets",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F34.TA",
    "TaseSymbol": "MTF.F34",
    "YahooId": "MTF-F34.TA",
    "EnglishName": "MTF.NDUEEGF",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MSCIEM.MTF",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.35,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4496.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Global - emerging markets",
    "AssetValue": null,
    "MonthYield": 5.4,
    "YearYield": 5.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011502759"
  },
  {
    "Id": "MTF-F95.TA",
    "MayaId": "1181387",
    "Name": "MTF Sal (4D) Nasdaq 100",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F95.TA",
    "TaseSymbol": "MTF.F95",
    "YahooId": "MTF-F95.TA",
    "EnglishName": "MTF.NASDAQ100",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "NASDAQ100.MTF",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5578.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": -1.9,
    "YearYield": -1.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011813875"
  },
  {
    "Id": "MTF-F33.TA",
    "MayaId": "1150242",
    "Name": "MTF SAL (4D) RUSSELL 2000",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F33.TA",
    "TaseSymbol": "MTF.F33",
    "YahooId": "MTF-F33.TA",
    "EnglishName": "MTF.RU20N30U",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "RUSS2000.MTF",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.24,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 7467.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": 5.2,
    "YearYield": 5.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011502429"
  },
  {
    "Id": "MTF-F23.TA",
    "MayaId": "1150333",
    "Name": "MTF SAL (4D) S&P 500",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F23.TA",
    "TaseSymbol": "MTF.F23",
    "YahooId": "MTF-F23.TA",
    "EnglishName": "MTF.SPTR500N",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "SP500.MTF",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 9328.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": -1.1,
    "YearYield": -1.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011503336"
  },
  {
    "Id": "MTF-F60.TA",
    "MayaId": "1162189",
    "Name": "MTF Sal (4D) S&P 500 Scored & Screened",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F60.TA",
    "TaseSymbol": "MTF.F60",
    "YahooId": "MTF-F60.TA",
    "EnglishName": "MTF.MSPXESUN",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "SC.MTF&S&P500SC",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.01,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 14200.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": -1.6,
    "YearYield": -1.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011621898"
  },
  {
    "Id": "MTF-F24.TA",
    "MayaId": "1150341",
    "Name": "MTF SAL (4D) S&P Aerospace & Defense",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F24.TA",
    "TaseSymbol": "MTF.F24",
    "YahooId": "MTF-F24.TA",
    "EnglishName": "MTF.SPSIADN",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "D.MTF&SPUSA",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 15300.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Aerospace & Defense",
    "AssetValue": null,
    "MonthYield": 18.8,
    "YearYield": 18.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011503419"
  },
  {
    "Id": "MTF-F25.TA",
    "MayaId": "1150358",
    "Name": "MTF SAL (4D) S&P Consumer Discretionary",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F25.TA",
    "TaseSymbol": "MTF.F25",
    "YahooId": "MTF-F25.TA",
    "EnglishName": "MTF.IXYNTR",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.צריכהמחSP",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 7546.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Consumer Discretionary",
    "AssetValue": null,
    "MonthYield": 1.3,
    "YearYield": 1.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011503583"
  },
  {
    "Id": "MTF-F26.TA",
    "MayaId": "1150366",
    "Name": "MTF SAL (4D) S&P Consumer Staples",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F26.TA",
    "TaseSymbol": "MTF.F26",
    "YahooId": "MTF-F26.TA",
    "EnglishName": "MTF.IXRNTR",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.צריכהבסSP",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.03,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2955.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Consumer Staples",
    "AssetValue": null,
    "MonthYield": 2.3,
    "YearYield": 2.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011503666"
  },
  {
    "Id": "MTF-F27.TA",
    "MayaId": "1150382",
    "Name": "MTF SAL (4D) S&P Financial",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F27.TA",
    "TaseSymbol": "MTF.F27",
    "YahooId": "MTF-F27.TA",
    "EnglishName": "MTF.IXMNTR",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "SPFINANCE.MTF",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5228.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Financial",
    "AssetValue": null,
    "MonthYield": -2.7,
    "YearYield": -2.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011503823"
  },
  {
    "Id": "MTF-F28.TA",
    "MayaId": "1150390",
    "Name": "MTF SAL (4D) S&P Health Care",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F28.TA",
    "TaseSymbol": "MTF.F28",
    "YahooId": "MTF-F28.TA",
    "EnglishName": "MTF.IXVNTR",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "SPHEALTH.MTF",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4901.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Health Care",
    "AssetValue": null,
    "MonthYield": -0.9,
    "YearYield": -0.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011503906"
  },
  {
    "Id": "MTF-F29.TA",
    "MayaId": "1150408",
    "Name": "MTF SAL (4D) S&P Industrial",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F29.TA",
    "TaseSymbol": "MTF.F29",
    "YahooId": "MTF-F29.TA",
    "EnglishName": "MTF.IXINTR",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "SPINDUSTR.MTF",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 7342.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Industrials",
    "AssetValue": null,
    "MonthYield": 4.8,
    "YearYield": 4.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011504086"
  },
  {
    "Id": "MTF-F30.TA",
    "MayaId": "1150424",
    "Name": "MTF SAL (4D) S&P Technology",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F30.TA",
    "TaseSymbol": "MTF.F30",
    "YahooId": "MTF-F30.TA",
    "EnglishName": "MTF.IXTNTR",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "SPTECH.MTF",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 14370.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Technology",
    "AssetValue": null,
    "MonthYield": -2.4,
    "YearYield": -2.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011504243"
  },
  {
    "Id": "MTF-F31.TA",
    "MayaId": "1150226",
    "Name": "MTF SAL (4D) STOXX Europe 600",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F31.TA",
    "TaseSymbol": "MTF.F31",
    "YahooId": "MTF-F31.TA",
    "EnglishName": "MTF.SXXR",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "STX600.MTF",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5512.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Europe - general",
    "AssetValue": null,
    "MonthYield": 0.5,
    "YearYield": 0.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011502262"
  },
  {
    "Id": "MTF-F90.TA",
    "MayaId": "1171099",
    "Name": "MTF SAL (6A) Short TA 90 (4,574.35) IL",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F90.TA",
    "TaseSymbol": "MTF.F90",
    "YahooId": "MTF-F90.TA",
    "EnglishName": "MTFSALSHORTTA90",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF סל חסר תא90",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 516.7,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Leveraged",
    "SecondaryClassification": "Stocks in Israel",
    "AssetValue": null,
    "MonthYield": -15.8,
    "YearYield": -15.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011710998"
  },
  {
    "Id": "MTF-F104.TA",
    "MayaId": "1187079",
    "Name": "MTF Sal (6D) Leveraged Nasdaq 100x3 Monthly",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F104.TA",
    "TaseSymbol": "MTF.F104",
    "YahooId": "MTF-F104.TA",
    "EnglishName": "MTF.NDX100X3L",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.מNDX100X3",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 1.35,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 18350.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Leveraged",
    "SecondaryClassification": "Stocks Abroad",
    "AssetValue": null,
    "MonthYield": -4.3,
    "YearYield": -4.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011870792"
  },
  {
    "Id": "MTF-F103.TA",
    "MayaId": "1188069",
    "Name": "MTF Sal (6D) Short Leveraged Nasdaq 100x2 Monthly",
    "ShortName": "MIGDAL MUTUAL FUNDS LTD",
    "Symbol": "MTF-F103.TA",
    "TaseSymbol": "MTF.F103",
    "YahooId": "MTF-F103.TA",
    "EnglishName": "MTF.NDX100X2SL",
    "EnglishLongName": "MIGDAL MUTUAL FUNDS LTD",
    "HebrewName": "MTF.מחסNDX100X2",
    "HebrewLongName": "מגדל קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2007.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MIGDAL",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Leveraged",
    "SecondaryClassification": "Stocks Abroad",
    "AssetValue": null,
    "MonthYield": 1.7,
    "YearYield": 1.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011880692"
  },
  {
    "Id": "TASE:5123567",
    "MayaId": "5123567",
    "Name": "MTF SP US A&D",
    "ShortName": "MTF SP US A&D",
    "Symbol": "TASE:5123567",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) S&P Aerospace & Defense Currency-Hedged",
    "EnglishLongName": "MTF TR (4A) S&P Aerospace & Defense Currency-Hedged",
    "HebrewName": "MTF מח‏ SP US A&D ממ",
    "HebrewLongName": "MTF מחקה (S&P Aerospace & Defense (4A מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.24,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 308.2,
    "MonthYield": 19.98,
    "YearYield": 19.98,
    "Last12MonthYield": 70.38,
    "ISIN": "IL0051235674"
  },
  {
    "Id": "TASE:5123443",
    "MayaId": "5123443",
    "Name": "MTF SP500 ARIST",
    "ShortName": "MTF SP500 ARIST",
    "Symbol": "TASE:5123443",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) S&P 500 Dividend Aristocrats Currency-Hedged",
    "EnglishLongName": "MTF TR (4A) S&P 500 Dividend Aristocrats Currency-Hedged",
    "HebrewName": "MTF מח‏ SP500 Aristo ממ",
    "HebrewLongName": "MTF מחקה (S&P 500 Dividend Aristocrats (4A מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.16,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 27.6,
    "MonthYield": 5.45,
    "YearYield": 5.45,
    "Last12MonthYield": 10.07,
    "ISIN": "IL0051234438"
  },
  {
    "Id": "TASE:5128038",
    "MayaId": "5128038",
    "Name": "MTF SP500MEGA30",
    "ShortName": "MTF SP500MEGA30",
    "Symbol": "TASE:5128038",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (0D) S&P 500 Bond Mega 30 Investment Grade 1-3 Year",
    "EnglishLongName": "MTF TR (0D) S&P 500 Bond Mega 30 Investment Grade 1-3 Year",
    "HebrewName": "MTF‏ מח SP5MI13T",
    "HebrewLongName": "MTF מחקה (0D)י S&P 500 Bond Mega 30 Investment Grade 1-3 Year",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.18,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Corporate and Convertibles - Short",
    "AssetValue": 302.5,
    "MonthYield": -1.32,
    "YearYield": -1.32,
    "Last12MonthYield": -9.46,
    "ISIN": "IL0051280381"
  },
  {
    "Id": "TASE:5127667",
    "MayaId": "5127667",
    "Name": "MTF SP5MI35T",
    "ShortName": "MTF SP5MI35T",
    "Symbol": "TASE:5127667",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (0D) S&P 500 Bond Mega 30 Investment Grade 3-5 Year",
    "EnglishLongName": "MTF TR (0D) S&P 500 Bond Mega 30 Investment Grade 3-5 Year",
    "HebrewName": "SP 30Bond 3-5 Year מח MTF",
    "HebrewLongName": "MTF מחקה (S&P 500 Bond Mega 30 Investment Grade 3-5 Year (0D",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.2,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Corporate and Convertibles - Medium",
    "AssetValue": 126.8,
    "MonthYield": -1.35,
    "YearYield": -1.35,
    "Last12MonthYield": -7.93,
    "ISIN": "IL0051276678"
  },
  {
    "Id": "TASE:5125869",
    "MayaId": "5125869",
    "Name": "MTF SPTR500N HD",
    "ShortName": "MTF SPTR500N HD",
    "Symbol": "TASE:5125869",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) S&P 500 Currency-Hedged",
    "EnglishLongName": "MTF TR (4A) S&P 500 Currency-Hedged",
    "HebrewName": "MTF מח SP500 ממ",
    "HebrewLongName": "MTF מחקה (S&P 500 (4A מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.6,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 1546.0,
    "MonthYield": 1.46,
    "YearYield": 1.46,
    "Last12MonthYield": 16.99,
    "ISIN": "IL0051258692"
  },
  {
    "Id": "TASE:5138276",
    "MayaId": "5138276",
    "Name": "MTF TR ABLC50BL IL",
    "ShortName": "MTF TR ABLC50BL IL",
    "Symbol": "TASE:5138276",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (0A) A.B. 2028 Balanced Bullet Bonds AAA-A IL",
    "EnglishLongName": "MTF TR (0A) A.B. 2028 Balanced Bullet Bonds AAA-A IL",
    "HebrewName": "MTF מח AB אגח מא Bullet28",
    "HebrewLongName": "MTF מחקה (A.B. (0A אג\"ח מאוזן AAA-A 2028 Bullet",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.14,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 54.2,
    "MonthYield": 0.31,
    "YearYield": 0.31,
    "Last12MonthYield": 5.55,
    "ISIN": "IL0051382765"
  },
  {
    "Id": "TASE:5127378",
    "MayaId": "5127378",
    "Name": "MTF TR BAINTR HD",
    "ShortName": "MTF TR BAINTR HD",
    "Symbol": "TASE:5127378",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4D) Bluestar Artificial Intelligence USD-Hedged",
    "EnglishLongName": "MTF TR (4D) Bluestar Artificial Intelligence USD-Hedged",
    "HebrewName": "MTF מח Bstar AI מד",
    "HebrewLongName": "MTF מחקה (Bluestar Artificial Intelligence (4D מנוטרלת דולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.48,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 169.0,
    "MonthYield": 4.87,
    "YearYield": 4.87,
    "Last12MonthYield": 11.23,
    "ISIN": "IL0051273782"
  },
  {
    "Id": "TASE:5128459",
    "MayaId": "5128459",
    "Name": "MTF TR BCHNQNTR",
    "ShortName": "MTF TR BCHNQNTR",
    "Symbol": "TASE:5128459",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4D) Bluestar China Internet Software",
    "EnglishLongName": "MTF TR (4D) Bluestar China Internet Software",
    "HebrewName": "MTF‏ מח BCHNQNTR",
    "HebrewLongName": "MTF מחקה (Bluestar China Internet Software (4D",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.17,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 16.5,
    "MonthYield": 7.04,
    "YearYield": 7.04,
    "Last12MonthYield": 21.0,
    "ISIN": "IL0051284599"
  },
  {
    "Id": "TASE:5128624",
    "MayaId": "5128624",
    "Name": "MTF TR BEGAMNTR",
    "ShortName": "MTF TR BEGAMNTR",
    "Symbol": "TASE:5128624",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4D) Bluestar E-Games",
    "EnglishLongName": "MTF TR (4D) Bluestar E-Games",
    "HebrewName": "MTF‏ מח BEGAMNTR",
    "HebrewLongName": "MTF מחקה (Bluestar E-Games (4D",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.64,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 17.1,
    "MonthYield": 0.08,
    "YearYield": 0.08,
    "Last12MonthYield": 2.71,
    "ISIN": "IL0051286248"
  },
  {
    "Id": "TASE:5125703",
    "MayaId": "5125703",
    "Name": "MTF TR BFNQNTR HD",
    "ShortName": "MTF TR BFNQNTR HD",
    "Symbol": "TASE:5125703",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4D) Bluestar Fintech USD-Hedged",
    "EnglishLongName": "MTF TR (4D) Bluestar Fintech USD-Hedged",
    "HebrewName": "MTF מח Bstar FinTech מד",
    "HebrewLongName": "MTF מחקה (Bluestar Fintech (4D מנוטרלת דולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.85,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 26.9,
    "MonthYield": -3.55,
    "YearYield": -3.55,
    "Last12MonthYield": -10.8,
    "ISIN": "IL0051257033"
  },
  {
    "Id": "TASE:5140215",
    "MayaId": "5140215",
    "Name": "MTF TR BLNConCorEarLeadHD",
    "ShortName": "MTF TR BLNConCorEarLeadHD",
    "Symbol": "TASE:5140215",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) Bloomberg New Constructs Core Earnings Leaders Currency Hedged",
    "EnglishLongName": "MTF TR (4A) Bloomberg New Constructs Core Earnings Leaders Currency Hedged",
    "HebrewName": "MTF מח BLNConCorEarLeadממ",
    "HebrewLongName": "MTF מחקה (Bloomberg New Constructs Core Earnings Leaders (4A מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.71,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 36.9,
    "MonthYield": 2.54,
    "YearYield": 2.54,
    "Last12MonthYield": null,
    "ISIN": "IL0051402159"
  },
  {
    "Id": "TASE:5127162",
    "MayaId": "5127162",
    "Name": "MTF TR BRBTNTR HD",
    "ShortName": "MTF TR BRBTNTR HD",
    "Symbol": "TASE:5127162",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4D) Bluestar Robotics USD-Hedged",
    "EnglishLongName": "MTF TR (4D) Bluestar Robotics USD-Hedged",
    "HebrewName": "MTF מח Bstar Robotic מד",
    "HebrewLongName": "MTF מחקה (Bluestar Robotics (4D מנוטרלת דולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.03,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 87.2,
    "MonthYield": 7.59,
    "YearYield": 7.59,
    "Last12MonthYield": 32.66,
    "ISIN": "IL0051271620"
  },
  {
    "Id": "TASE:5129648",
    "MayaId": "5129648",
    "Name": "MTF TR BSTAR CONNECT Tech",
    "ShortName": "MTF TR BSTAR CONNECT Tech",
    "Symbol": "TASE:5129648",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4D) Bluestar Global Connective Technologies",
    "EnglishLongName": "MTF TR (4D) Bluestar Global Connective Technologies",
    "HebrewName": "MTF מח BSTAR Connec Tech",
    "HebrewLongName": "MTF מחקה (4D)י Bluestar Global Connective Technologies",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.9,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 36.6,
    "MonthYield": 2.44,
    "YearYield": 2.44,
    "Last12MonthYield": 15.28,
    "ISIN": "IL0051296486"
  },
  {
    "Id": "TASE:5130976",
    "MayaId": "5130976",
    "Name": "MTF TR BSTAR SOL HD",
    "ShortName": "MTF TR BSTAR SOL HD",
    "Symbol": "TASE:5130976",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4D) Bluestar Solar Energy Industry USD-Hedged",
    "EnglishLongName": "MTF TR (4D) Bluestar Solar Energy Industry USD-Hedged",
    "HebrewName": "MTF מח BSTAR Solar En מד",
    "HebrewLongName": "MTF מחקה (Bluestar Solar Energy Industry (4D מנוטרלת דולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.23,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 7.8,
    "MonthYield": 5.86,
    "YearYield": 5.86,
    "Last12MonthYield": 61.07,
    "ISIN": "IL0051309768"
  },
  {
    "Id": "TASE:5131503",
    "MayaId": "5131503",
    "Name": "MTF TR BTOURNTR HD",
    "ShortName": "MTF TR BTOURNTR HD",
    "Symbol": "TASE:5131503",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) Bluestar Travel & Vacation Currency-Hedged",
    "EnglishLongName": "MTF TR (4A) Bluestar Travel & Vacation Currency-Hedged",
    "HebrewName": "MTF מח BSTAR TRAV VAC ממ",
    "HebrewLongName": "MTF מחקה (Bluestar Travel & Vacation (4A מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.72,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 71.0,
    "MonthYield": 0.29,
    "YearYield": 0.29,
    "Last12MonthYield": 5.69,
    "ISIN": "IL0051315039"
  },
  {
    "Id": "TASE:5140884",
    "MayaId": "5140884",
    "Name": "MTF TR BUALTNTR HD",
    "ShortName": "MTF TR BUALTNTR HD",
    "Symbol": "TASE:5140884",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) Bluestar TOP 10 US Listed Alternative Asset Managers Currency Hedged",
    "EnglishLongName": "MTF TR (4A) Bluestar TOP 10 US Listed Alternative Asset Managers Currency Hedged",
    "HebrewName": "MTF מח BstarT10US AsMn ממ",
    "HebrewLongName": "MTF מחקה (4A)י Bluestar TOP 10 US Listed Alternative Asset Managers מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 5.0,
    "MonthYield": 3.42,
    "YearYield": 3.42,
    "Last12MonthYield": null,
    "ISIN": "IL0051408842"
  },
  {
    "Id": "TASE:5131446",
    "MayaId": "5131446",
    "Name": "MTF TR BUBNKNTR HD",
    "ShortName": "MTF TR BUBNKNTR HD",
    "Symbol": "TASE:5131446",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) Bluestar Top 10 US Banks Currency-Hedged",
    "EnglishLongName": "MTF TR (4A) Bluestar Top 10 US Banks Currency-Hedged",
    "HebrewName": "MTF מח BST TOP US BNK ממ",
    "HebrewLongName": "MTF מחקה (Bluestar Top 10 US Banks (4A מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.66,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 307.5,
    "MonthYield": 0.89,
    "YearYield": 0.89,
    "Last12MonthYield": 33.32,
    "ISIN": "IL0051314461"
  },
  {
    "Id": "TASE:5136932",
    "MayaId": "5136932",
    "Name": "MTF TR Cm SP500 NDX100 HD",
    "ShortName": "MTF TR Cm SP500 NDX100 HD",
    "Symbol": "TASE:5136932",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) Composite S&P 500 (70%) Nasdaq 100 (30%) Monthly Currency-Hedged",
    "EnglishLongName": "MTF TR (4A) Composite S&P 500 (70%) Nasdaq 100 (30%) Monthly Currency-Hedged",
    "HebrewName": "MTF מח מש NDX100 SP500 ממ",
    "HebrewLongName": "MTF מחקה (4A) משולבת S&P 500י (70%) Nasdaq 100י (30%) חודשי מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.72,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks Abroad, Composite",
    "AssetValue": 321.7,
    "MonthYield": 1.41,
    "YearYield": 1.41,
    "Last12MonthYield": 18.34,
    "ISIN": "IL0051369325"
  },
  {
    "Id": "TASE:5139068",
    "MayaId": "5139068",
    "Name": "MTF TR Cm SP500 RU2000 HD",
    "ShortName": "MTF TR Cm SP500 RU2000 HD",
    "Symbol": "TASE:5139068",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) Composite S&P 500 (70%) Russell 2000 (30%) Monthly Currency-Hedged",
    "EnglishLongName": "MTF TR (4A) Composite S&P 500 (70%) Russell 2000 (30%) Monthly Currency-Hedged",
    "HebrewName": "MTF מח מש RU2000 SP500 ממ",
    "HebrewLongName": "MTF מחקה (4A) משולבת S&P 500י (70%) Russell 2000י (30%) חודשי מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.44,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks Abroad, Composite",
    "AssetValue": 14.3,
    "MonthYield": 3.32,
    "YearYield": 3.32,
    "Last12MonthYield": 18.07,
    "ISIN": "IL0051390685"
  },
  {
    "Id": "TASE:5137047",
    "MayaId": "5137047",
    "Name": "MTF TR CmTA125&TA90IL",
    "ShortName": "MTF TR CmTA125&TA90IL",
    "Symbol": "TASE:5137047",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) Composite TA 125 (70%) TA 90 (30%) Monthly IL",
    "EnglishLongName": "MTF TR (4A) Composite TA 125 (70%) TA 90 (30%) Monthly IL",
    "HebrewName": "MTF מח מש תא125&תא90",
    "HebrewLongName": "MTF מחקה (4A) משולבת ת\"א 125 (70%) ת\"א 90 (30%) חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks in Israel, Composite",
    "AssetValue": 98.8,
    "MonthYield": 8.4,
    "YearYield": 8.4,
    "Last12MonthYield": 62.21,
    "ISIN": "IL0051370471"
  },
  {
    "Id": "TASE:5137054",
    "MayaId": "5137054",
    "Name": "MTF TR CmTELB50&TELBSHIL",
    "ShortName": "MTF TR CmTELB50&TELBSHIL",
    "Symbol": "TASE:5137054",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Composite Tel Bond Shekel 50 (70%) Tel Bond Shekel (30%) Monthly IL",
    "EnglishLongName": "MTF TR (00) Composite Tel Bond Shekel 50 (70%) Tel Bond Shekel (30%) Monthly IL",
    "HebrewName": "MTF מח מש בנדשק50&בנדשקלי",
    "HebrewLongName": "MTF מחקה (00) משולבת תל בונד שקלי 50 (70%) תל בונד שקלי (30%) חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 15.2,
    "MonthYield": 0.92,
    "YearYield": 0.92,
    "Last12MonthYield": 8.1,
    "ISIN": "IL0051370547"
  },
  {
    "Id": "TASE:5119623",
    "MayaId": "5119623",
    "Name": "MTF TR Co Gov Bn 90 HD IL",
    "ShortName": "MTF TR Co Gov Bn 90 HD IL",
    "Symbol": "TASE:5119623",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (2A) Composite Gov. Bonds (90%) Equity (10%) monthly Currency-Hedged IL",
    "EnglishLongName": "MTF TR (2A) Composite Gov. Bonds (90%) Equity (10%) monthly Currency-Hedged IL",
    "HebrewName": "MTF‏ מח מש אגח ממשלת90%ממ",
    "HebrewLongName": "MTF מחקה (2A) משולבת ממשלתי (90%) מניות (10%) חודשי מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.49,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Composite Government Bond - up to 10% Equity",
    "AssetValue": 15.1,
    "MonthYield": 1.04,
    "YearYield": 1.04,
    "Last12MonthYield": 8.77,
    "ISIN": "IL0051196231"
  },
  {
    "Id": "TASE:5121983",
    "MayaId": "5121983",
    "Name": "MTF TR Com Europe HD",
    "ShortName": "MTF TR Com Europe HD",
    "Symbol": "TASE:5121983",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) Composite DAX (50%) STOXX Europe 600 (50%) monthly Currency-Hedged",
    "EnglishLongName": "MTF TR (4A) Composite DAX (50%) STOXX Europe 600 (50%) monthly Currency-Hedged",
    "HebrewName": "MTF מח מש אירופה ממ",
    "HebrewLongName": "MTF מחקה (4A) משולבת DAXי (50%) STOXX Europe 600י (50%) חודשי מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.22,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks Abroad, Composite",
    "AssetValue": 21.6,
    "MonthYield": 3.46,
    "YearYield": 3.46,
    "Last12MonthYield": 26.31,
    "ISIN": "IL0051219835"
  },
  {
    "Id": "TASE:5122841",
    "MayaId": "5122841",
    "Name": "MTF TR Com GovBnd Blnc IL",
    "ShortName": "MTF TR Com GovBnd Blnc IL",
    "Symbol": "TASE:5122841",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Composite Shekel Gov (50%) CPI Linked Gov (50%) monthly IL",
    "EnglishLongName": "MTF TR (00) Composite Shekel Gov (50%) CPI Linked Gov (50%) monthly IL",
    "HebrewName": "MTF מח‏ מש ממשלתי מאוזן",
    "HebrewLongName": "MTF מחקה‏ (00) משולבת שקליות ממשלתיות (50%) מדדיות ממשלתיות (50%) חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Composite Government Bond - No Equity",
    "AssetValue": 62.6,
    "MonthYield": 0.46,
    "YearYield": 0.46,
    "Last12MonthYield": 6.6,
    "ISIN": "IL0051228414"
  },
  {
    "Id": "TASE:5119615",
    "MayaId": "5119615",
    "Name": "MTF TR Com Is Bnd 85HD IL",
    "ShortName": "MTF TR Com Is Bnd 85HD IL",
    "Symbol": "TASE:5119615",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (2A) Composite Israel Bonds (85%) Equity (15%) monthly Currency-Hedged IL",
    "EnglishLongName": "MTF TR (2A) Composite Israel Bonds (85%) Equity (15%) monthly Currency-Hedged IL",
    "HebrewName": "MTF מח מש אגח ישראל 85%ממ",
    "HebrewLongName": "MTF מחקה‏ (2A) משולבת אג\"ח ישראל (85%) מניות (15%) חודשי מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.49,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.37,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Composite Bonds",
    "SecondaryClassification": "up to 20% Equity",
    "AssetValue": 17.1,
    "MonthYield": 1.28,
    "YearYield": 1.28,
    "Last12MonthYield": 10.25,
    "ISIN": "IL0051196157"
  },
  {
    "Id": "TASE:5121413",
    "MayaId": "5121413",
    "Name": "MTF TR Com Is Bond 100 IL",
    "ShortName": "MTF TR Com Is Bond 100 IL",
    "Symbol": "TASE:5121413",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Composite Gov. Bonds (60%) Israel Corp. Bonds (40%) monthly IL",
    "EnglishLongName": "MTF TR (00) Composite Gov. Bonds (60%) Israel Corp. Bonds (40%) monthly IL",
    "HebrewName": "MTF‏ מח מש אגח ישראל 100%",
    "HebrewLongName": "MTF מחקה (00) משולבת ממשלתיות (60%) קונצרני ישראלי (40%) חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.39,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Composite Bonds",
    "SecondaryClassification": "No Equity",
    "AssetValue": 30.3,
    "MonthYield": 0.52,
    "YearYield": 0.52,
    "Last12MonthYield": 6.15,
    "ISIN": "IL0051214133"
  },
  {
    "Id": "TASE:5121504",
    "MayaId": "5121504",
    "Name": "MTF TR Com Is Bond75HD IL",
    "ShortName": "MTF TR Com Is Bond75HD IL",
    "Symbol": "TASE:5121504",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (2A) Composite Israel Bonds (75%) Equity (25%) monthly Currency-Hedged IL",
    "EnglishLongName": "MTF TR (2A) Composite Israel Bonds (75%) Equity (25%) monthly Currency-Hedged IL",
    "HebrewName": "MTF‏ מח מש אגח ישראל75%ממ",
    "HebrewLongName": "MTF מחקה‏ (2A) משולבת אג\"ח ישראל (75%) מניות (25%) חודשי מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.49,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.49,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Composite Bonds",
    "SecondaryClassification": "up to 30% Equity",
    "AssetValue": 16.3,
    "MonthYield": 1.69,
    "YearYield": 1.69,
    "Last12MonthYield": 13.05,
    "ISIN": "IL0051215049"
  },
  {
    "Id": "TASE:5115274",
    "MayaId": "5115274",
    "Name": "MTF TR Com Isr Bond 80 IL",
    "ShortName": "MTF TR Com Isr Bond 80 IL",
    "Symbol": "TASE:5115274",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (2A) Composite Israel Bonds (80%) Israel Equity (20%) monthly IL",
    "EnglishLongName": "MTF TR (2A) Composite Israel Bonds (80%) Israel Equity (20%) monthly IL",
    "HebrewName": "MTF‏ מח מש אגח ישראל 80%",
    "HebrewLongName": "MTF מחקה (2A) משולבת אג\"ח ישראל (80%) מניות ישראל (20%) חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.49,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.57,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Composite Bonds",
    "SecondaryClassification": "up to 20% Equity",
    "AssetValue": 18.7,
    "MonthYield": 2.08,
    "YearYield": 2.08,
    "Last12MonthYield": 15.89,
    "ISIN": "IL0051152747"
  },
  {
    "Id": "TASE:5118450",
    "MayaId": "5118450",
    "Name": "MTF TR Com Isr Bond HD IL",
    "ShortName": "MTF TR Com Isr Bond HD IL",
    "Symbol": "TASE:5118450",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (2A) Composite Israel Bonds (90%) Foreign Equity (10%) monthly HD IL",
    "EnglishLongName": "MTF TR (2A) Composite Israel Bonds (90%) Foreign Equity (10%) monthly HD IL",
    "HebrewName": "MTF מח מש אגח ישראל ממ",
    "HebrewLongName": "MTF מחקה‏ (2A) משולבת אג\"ח ישראל (90%) מניות חו\"ל (10%) חודשי מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.49,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Composite Bonds",
    "SecondaryClassification": "up to 10% Equity",
    "AssetValue": 54.9,
    "MonthYield": 0.63,
    "YearYield": 0.63,
    "Last12MonthYield": 7.23,
    "ISIN": "IL0051184500"
  },
  {
    "Id": "TASE:5122288",
    "MayaId": "5122288",
    "Name": "MTF TR Com Isr Equity IL",
    "ShortName": "MTF TR Com Isr Equity IL",
    "Symbol": "TASE:5122288",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) Composite TA-125 (70%) TA-Banks 5 (30%) monthly IL",
    "EnglishLongName": "MTF TR (4A) Composite TA-125 (70%) TA-Banks 5 (30%) monthly IL",
    "HebrewName": "MTF מח‏ מש מניות ישראל",
    "HebrewLongName": "MTF מחקה‏ (4A) משולבת ת\"א 125 (70%) ת\"א בנקים 5 (30%) חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.015,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.2,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks in Israel, Composite",
    "AssetValue": 405.9,
    "MonthYield": 9.13,
    "YearYield": 9.13,
    "Last12MonthYield": 67.27,
    "ISIN": "IL0051222888"
  },
  {
    "Id": "TASE:5121405",
    "MayaId": "5121405",
    "Name": "MTF TR Com Med Cpi Bnd IL",
    "ShortName": "MTF TR Com Med Cpi Bnd IL",
    "Symbol": "TASE:5121405",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Composite Tel Gov-CPI Linked 2-5(60%) CPI Linked Corp(40%)monthly IL",
    "EnglishLongName": "MTF TR (00) Composite Tel Gov-CPI Linked 2-5(60%) CPI Linked Corp(40%)monthly IL",
    "HebrewName": "MTF מח מש אגח צמוד בינוני",
    "HebrewLongName": "MTF מחקה (00) משולבת תל גוב-צמודות 2-5 (60%) קונצרני צמוד (40%) חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.39,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.16,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Composite Bonds",
    "SecondaryClassification": "No Equity",
    "AssetValue": 45.4,
    "MonthYield": 0.16,
    "YearYield": 0.16,
    "Last12MonthYield": 4.92,
    "ISIN": "IL0051214059"
  },
  {
    "Id": "TASE:5117080",
    "MayaId": "5117080",
    "Name": "MTF TR Com Shekel IL",
    "ShortName": "MTF TR Com Shekel IL",
    "Symbol": "TASE:5117080",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Composite Tel Gov - Shekel 2-5 (75%) Tel Bnd-Shkl (25%) monthly IL",
    "EnglishLongName": "MTF TR (00) Composite Tel Gov - Shekel 2-5 (75%) Tel Bnd-Shkl (25%) monthly IL",
    "HebrewName": "MTF מח‏ מש שקלי",
    "HebrewLongName": "MTF מחקה‏ (00) משולבת תל גוב-שקלי 2-5 (75%) תל בונד שקלי (25%) חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.39,
    "TrusteeFee": 0.015,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.22,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Composite Bonds",
    "SecondaryClassification": "No Equity",
    "AssetValue": 12.6,
    "MonthYield": 0.66,
    "YearYield": 0.66,
    "Last12MonthYield": 6.28,
    "ISIN": "IL0051170806"
  },
  {
    "Id": "TASE:5141759",
    "MayaId": "5141759",
    "Name": "MTF TR Com TA125 SP500 HD",
    "ShortName": "MTF TR Com TA125 SP500 HD",
    "Symbol": "TASE:5141759",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR Composite (4A) TA 125 (50%) S&P 500 (50%)Monthly Currency-Hedged",
    "EnglishLongName": "MTF TR Composite (4A) TA 125 (50%) S&P 500 (50%)Monthly Currency-Hedged",
    "HebrewName": "MTF מח‏ מש תא125 SP500 ממ",
    "HebrewLongName": "MTF מחקה (4A) משולבת ת\"א-125 (50%) S&P 500 י(50%) חודשי מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Other",
    "SecondaryClassification": "",
    "AssetValue": 8.0,
    "MonthYield": 5.13,
    "YearYield": 5.13,
    "Last12MonthYield": null,
    "ISIN": "IL0051417595"
  },
  {
    "Id": "TASE:5142054",
    "MayaId": "5142054",
    "Name": "MTF TR CryptoEcosystemiND",
    "ShortName": "MTF TR CryptoEcosystemiND",
    "Symbol": "TASE:5142054",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4D) Crypto Ecosystem iNDEX",
    "EnglishLongName": "MTF TR (4D) Crypto Ecosystem iNDEX",
    "HebrewName": "MTF מח Crypto EcosystiND",
    "HebrewLongName": "MTF מחקה (4D)י Crypto Ecosystem iNDEX",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:5127642",
    "MayaId": "5127642",
    "Name": "MTF TR DAX",
    "ShortName": "MTF TR DAX",
    "Symbol": "TASE:5127642",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4D) DAX",
    "EnglishLongName": "MTF TR (4D) DAX",
    "HebrewName": "MTF מח DAX",
    "HebrewLongName": "MTF מחקה (DAX (4D",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.48,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 65.8,
    "MonthYield": 0.7,
    "YearYield": 0.7,
    "Last12MonthYield": 21.02,
    "ISIN": "IL0051276421"
  },
  {
    "Id": "TASE:5127659",
    "MayaId": "5127659",
    "Name": "MTF TR DAX HD",
    "ShortName": "MTF TR DAX HD",
    "Symbol": "TASE:5127659",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) DAX Currency-Hedged",
    "EnglishLongName": "MTF TR (4A) DAX Currency-Hedged",
    "HebrewName": "MTF מח DAX ממ",
    "HebrewLongName": "MTF מחקה (DAX (4A מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.38,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 48.3,
    "MonthYield": 3.51,
    "YearYield": 3.51,
    "Last12MonthYield": 27.08,
    "ISIN": "IL0051276595"
  },
  {
    "Id": "TASE:5138466",
    "MayaId": "5138466",
    "Name": "MTF TR IBOXIG30",
    "ShortName": "MTF TR IBOXIG30",
    "Symbol": "TASE:5138466",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (0D) iBoxx US Liquid Investment Grade Top 30",
    "EnglishLongName": "MTF TR (0D) iBoxx US Liquid Investment Grade Top 30",
    "HebrewName": "MTF מח‏ iBoxx $ Lq IG30",
    "HebrewLongName": "MTF מחקה (iBoxx US Liquid Investment Grade Top 30 (0D",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.17,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Hedged Corporate and Convertibles",
    "AssetValue": 91.5,
    "MonthYield": -1.27,
    "YearYield": -1.27,
    "Last12MonthYield": -6.5,
    "ISIN": "IL0051384662"
  },
  {
    "Id": "TASE:5127428",
    "MayaId": "5127428",
    "Name": "MTF TR IL0051274285 IL",
    "ShortName": "MTF TR IL0051274285 IL",
    "Symbol": "TASE:5127428",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) TA Sector-Balance IL",
    "EnglishLongName": "MTF TR (4A) TA Sector-Balance IL",
    "HebrewName": "MTF מח תא סקטור-באלאנס",
    "HebrewLongName": "MTF מחקה (4A) ת\"א סקטור-באלאנס",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.02,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.96,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 122.3,
    "MonthYield": 7.83,
    "YearYield": 7.83,
    "Last12MonthYield": 69.39,
    "ISIN": "IL0051274285"
  },
  {
    "Id": "TASE:5135413",
    "MayaId": "5135413",
    "Name": "MTF TR IL00BIDX7292 IL",
    "ShortName": "MTF TR IL00BIDX7292 IL",
    "Symbol": "TASE:5135413",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Tel Gov - Shekel 5-10 IL",
    "EnglishLongName": "MTF TR (00) Tel Gov - Shekel 5-10 IL",
    "HebrewName": "MTF מח תל גוב-שקלי 5-10",
    "HebrewLongName": "MTF מחקה (00) תל גוב-שקלי 5-10",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.57,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Non-Linked Government Bonds",
    "AssetValue": 323.9,
    "MonthYield": 0.77,
    "YearYield": 0.77,
    "Last12MonthYield": 9.02,
    "ISIN": "IL0051354137"
  },
  {
    "Id": "TASE:5138342",
    "MayaId": "5138342",
    "Name": "MTF TR ILINDX111413 IL",
    "ShortName": "MTF TR ILINDX111413 IL",
    "Symbol": "TASE:5138342",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (0A) Index Israeli AAA-AA 5-7 Bond IL",
    "EnglishLongName": "MTF TR (0A) Index Israeli AAA-AA 5-7 Bond IL",
    "HebrewName": "MTF מח אנ AA-AAA יש 5-7",
    "HebrewLongName": "MTF מחקה (0A) אינדקס AA-AAA ישראל 5-7",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.51,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 220.4,
    "MonthYield": 0.85,
    "YearYield": 0.85,
    "Last12MonthYield": 9.67,
    "ISIN": "IL0051383425"
  },
  {
    "Id": "TASE:5140900",
    "MayaId": "5140900",
    "Name": "MTF TR ILINDX112015",
    "ShortName": "MTF TR ILINDX112015",
    "Symbol": "TASE:5140900",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) iNDEX Israeli Government Non-Linked 10Y Fixed Duration Bond IL",
    "EnglishLongName": "MTF TR (00) iNDEX Israeli Government Non-Linked 10Y Fixed Duration Bond IL",
    "HebrewName": "MTF מח אנד מדישר מחמ10שקל",
    "HebrewLongName": "MTF מחקה (00) אינדקס מדינת ישראל - מח\"מ 10 קבוע שקלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Non-Linked Government Bonds",
    "AssetValue": 48.5,
    "MonthYield": 1.28,
    "YearYield": 1.28,
    "Last12MonthYield": null,
    "ISIN": "IL0051409006"
  },
  {
    "Id": "TASE:5129069",
    "MayaId": "5129069",
    "Name": "MTF TR ILINDX112080 IL",
    "ShortName": "MTF TR ILINDX112080 IL",
    "Symbol": "TASE:5129069",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Index A-AA Israel 1-3 IL",
    "EnglishLongName": "MTF TR (00) Index A-AA Israel 1-3 IL",
    "HebrewName": "MTF מח אינד A-AA 1-3",
    "HebrewLongName": "MTF מחקה (00) אינדקס A-AA ישראל 1-3",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.18,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 148.6,
    "MonthYield": 0.45,
    "YearYield": 0.45,
    "Last12MonthYield": 6.03,
    "ISIN": "IL0051290695"
  },
  {
    "Id": "TASE:5131727",
    "MayaId": "5131727",
    "Name": "MTF TR ILINDX112460 IL",
    "ShortName": "MTF TR ILINDX112460 IL",
    "Symbol": "TASE:5131727",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Index Non-Linked A-AA IL",
    "EnglishLongName": "MTF TR (00) Index Non-Linked A-AA IL",
    "HebrewName": "MTF מח אנד A-AA שקלי",
    "HebrewLongName": "MTF מחקה (00) אינדקס A-AA שקלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 58.1,
    "MonthYield": 0.92,
    "YearYield": 0.92,
    "Last12MonthYield": 8.27,
    "ISIN": "IL0051317274"
  },
  {
    "Id": "TASE:5131735",
    "MayaId": "5131735",
    "Name": "MTF TR ILINDX112478 IL",
    "ShortName": "MTF TR ILINDX112478 IL",
    "Symbol": "TASE:5131735",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Index CPI-Linked A-AA IL",
    "EnglishLongName": "MTF TR (00) Index CPI-Linked A-AA IL",
    "HebrewName": "MTF מח אנד A-AA צמוד",
    "HebrewLongName": "MTF מחקה (00) אינדקס A-AA צמוד",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0.02,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.23,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 271.8,
    "MonthYield": 0.25,
    "YearYield": 0.25,
    "Last12MonthYield": 6.33,
    "ISIN": "IL0051317357"
  },
  {
    "Id": "TASE:5135942",
    "MayaId": "5135942",
    "Name": "MTF TR ILINDX112619 IL",
    "ShortName": "MTF TR ILINDX112619 IL",
    "Symbol": "TASE:5135942",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (0A) Index Israeli AAA-A Bonds to Maturity 2029 (Rolling Every 4 Years)IL",
    "EnglishLongName": "MTF TR (0A) Index Israeli AAA-A Bonds to Maturity 2029 (Rolling Every 4 Years)IL",
    "HebrewName": "MTF מח אנ A-AAAל2029(כל4)",
    "HebrewLongName": "MTF מחקה (0A) אינדקס A-AAA לפדיון 2029 (מתגלגל כל 4 שנים)",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.03,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 81.6,
    "MonthYield": 0.41,
    "YearYield": 0.41,
    "Last12MonthYield": 5.15,
    "ISIN": "IL0051359425"
  },
  {
    "Id": "TASE:5136312",
    "MayaId": "5136312",
    "Name": "MTF TR ILINDX112866 IL",
    "ShortName": "MTF TR ILINDX112866 IL",
    "Symbol": "TASE:5136312",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Index Israeli Government Non-Linked Maturity Bonds - Quarter 4 IL",
    "EnglishLongName": "MTF TR (00) Index Israeli Government Non-Linked Maturity Bonds - Quarter 4 IL",
    "HebrewName": "MTF מח אנד ממשל ₪ לפד רב4",
    "HebrewLongName": "MTF מחקה (00) אינדקס ממשלתי שקלי לפדיון - רבעון 4",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.01,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Non-Linked Government Bonds",
    "AssetValue": 37.8,
    "MonthYield": 0.33,
    "YearYield": 0.33,
    "Last12MonthYield": 4.43,
    "ISIN": "IL0051363120"
  },
  {
    "Id": "TASE:5136825",
    "MayaId": "5136825",
    "Name": "MTF TR ILINDX112882 IL",
    "ShortName": "MTF TR ILINDX112882 IL",
    "Symbol": "TASE:5136825",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Index Israeli A-AAA Duration Adjusted Layers IL",
    "EnglishLongName": "MTF TR (00) Index Israeli A-AAA Duration Adjusted Layers IL",
    "HebrewName": "MTF מח אנ A-AAA שכ מד מחמ",
    "HebrewLongName": "MTF מחקה (00) אינדקס A-AAA שכבות מדורגות מח\"מ",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.23,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 28.0,
    "MonthYield": 0.41,
    "YearYield": 0.41,
    "Last12MonthYield": 6.64,
    "ISIN": "IL0051368251"
  },
  {
    "Id": "TASE:5138318",
    "MayaId": "5138318",
    "Name": "MTF TR ILINDX112908 IL",
    "ShortName": "MTF TR ILINDX112908 IL",
    "Symbol": "TASE:5138318",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Index Israeli CoCo-10 Bond IL",
    "EnglishLongName": "MTF TR (00) Index Israeli CoCo-10 Bond IL",
    "HebrewName": "MTF מח אנד CoCo ישראל 10",
    "HebrewLongName": "MTF מחקה (00) אינדקס CoCo ישראל-10",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.39,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 51.5,
    "MonthYield": 0.45,
    "YearYield": 0.45,
    "Last12MonthYield": 8.33,
    "ISIN": "IL0051383185"
  },
  {
    "Id": "TASE:5135470",
    "MayaId": "5135470",
    "Name": "MTF TR ILINDX121164 IL",
    "ShortName": "MTF TR ILINDX121164 IL",
    "Symbol": "TASE:5135470",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) Index Israeli Industrials IL",
    "EnglishLongName": "MTF TR (4A) Index Israeli Industrials IL",
    "HebrewName": "MTF מח אינדקס תעשיה ישר",
    "HebrewLongName": "MTF מחקה (4A) אינדקס תעשיה ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.52,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 107.6,
    "MonthYield": 12.52,
    "YearYield": 12.52,
    "Last12MonthYield": 75.47,
    "ISIN": "IL0051354707"
  },
  {
    "Id": "TASE:5139027",
    "MayaId": "5139027",
    "Name": "MTF TR ILINDX121271 IL",
    "ShortName": "MTF TR ILINDX121271 IL",
    "Symbol": "TASE:5139027",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) Index Israeli Construction - Low Leverage Factor IL",
    "EnglishLongName": "MTF TR (4A) Index Israeli Construction - Low Leverage Factor IL",
    "HebrewName": "MTF מח אנ בנישרמנףפינמוך",
    "HebrewLongName": "MTF מחקה (4A) אינדקס בנייה ישראל - פקטור מינוף פיננסי נמוך",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 4.39,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 44.3,
    "MonthYield": 12.32,
    "YearYield": 12.32,
    "Last12MonthYield": 24.57,
    "ISIN": "IL0051390271"
  },
  {
    "Id": "TASE:5134713",
    "MayaId": "5134713",
    "Name": "MTF TR ILINDX121347 IL",
    "ShortName": "MTF TR ILINDX121347 IL",
    "Symbol": "TASE:5134713",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) Index TA-125 Smart Momentum IL",
    "EnglishLongName": "MTF TR (4A) Index TA-125 Smart Momentum IL",
    "HebrewName": "MTF מח אנד תא 125 SMRT MO",
    "HebrewLongName": "MTF מחקה (4A) אינדקס ת\"א-125 Smart Momentum",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.56,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 24.1,
    "MonthYield": 10.05,
    "YearYield": 10.05,
    "Last12MonthYield": 67.78,
    "ISIN": "IL0051347131"
  },
  {
    "Id": "TASE:5131529",
    "MayaId": "5131529",
    "Name": "MTF TR ILINDX121370 IL",
    "ShortName": "MTF TR ILINDX121370 IL",
    "Symbol": "TASE:5131529",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) Index Israeli Consumer Staples Equity IL",
    "EnglishLongName": "MTF TR (4A) Index Israeli Consumer Staples Equity IL",
    "HebrewName": "MTF מח אנד צריכה בסיסית",
    "HebrewLongName": "MTF מחקה (4A) אינדקס צריכה בסיסית ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.82,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 102.3,
    "MonthYield": 4.62,
    "YearYield": 4.62,
    "Last12MonthYield": 48.33,
    "ISIN": "IL0051315294"
  },
  {
    "Id": "TASE:5137773",
    "MayaId": "5137773",
    "Name": "MTF TR ILINDX141014 HD",
    "ShortName": "MTF TR ILINDX141014 HD",
    "Symbol": "TASE:5137773",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (0A) Index US Gov 10Y Fixed Duration Currency-Hedged",
    "EnglishLongName": "MTF TR (0A) Index US Gov 10Y Fixed Duration Currency-Hedged",
    "HebrewName": "MTF מח אנד מUSמחמ10קב ממ",
    "HebrewLongName": "MTF מחקה (0A) אינדקס אג\"ח ממשלת ארה\"ב - מח\"מ 10 קבוע מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.71,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Hedged Government - Long",
    "AssetValue": 251.2,
    "MonthYield": 0.47,
    "YearYield": 0.47,
    "Last12MonthYield": 7.63,
    "ISIN": "IL0051377732"
  },
  {
    "Id": "TASE:5135983",
    "MayaId": "5135983",
    "Name": "MTF TR ILINDX162176 HD",
    "ShortName": "MTF TR ILINDX162176 HD",
    "Symbol": "TASE:5135983",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) Index US Semiconductors Top10 Currency Hedged",
    "EnglishLongName": "MTF TR (4A) Index US Semiconductors Top10 Currency Hedged",
    "HebrewName": "MTF מח אנד US SEMI10 ממ",
    "HebrewLongName": "MTF מחקה (4A) אינדקס שבבים ארה\"ב Top10 מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 4.26,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 324.7,
    "MonthYield": 10.85,
    "YearYield": 10.85,
    "Last12MonthYield": 60.72,
    "ISIN": "IL0051359839"
  },
  {
    "Id": "TASE:5139274",
    "MayaId": "5139274",
    "Name": "MTF TR ILINDX6302EH",
    "ShortName": "MTF TR ILINDX6302EH",
    "Symbol": "TASE:5139274",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4D) Europe Top20 iNDEX Euro Hedged",
    "EnglishLongName": "MTF TR (4D) Europe Top20 iNDEX Euro Hedged",
    "HebrewName": "MTF מח EurTop20iNDEX מא",
    "HebrewLongName": "MTF מחקה (Europe Top20 iNDEX (4D מנוטרלת אירו",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 28.0,
    "MonthYield": 4.72,
    "YearYield": 4.72,
    "Last12MonthYield": 13.66,
    "ISIN": "IL0051392749"
  },
  {
    "Id": "TASE:5129531",
    "MayaId": "5129531",
    "Name": "MTF TR Ind A Isr 2 4 IL",
    "ShortName": "MTF TR Ind A Isr 2-4 IL",
    "Symbol": "TASE:5129531",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Index Israeli A Domestic 2-4 Bond IL",
    "EnglishLongName": "MTF TR (00) Index Israeli A Domestic 2-4 Bond IL",
    "HebrewName": "MTF מח אינדקס A ישראל 2-4",
    "HebrewLongName": "MTF מחקה (00) אינדקס A ישראל 2-4",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0.02,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.26,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 179.7,
    "MonthYield": 0.61,
    "YearYield": 0.61,
    "Last12MonthYield": 7.06,
    "ISIN": "IL0051295314"
  },
  {
    "Id": "TASE:5130000",
    "MayaId": "5130000",
    "Name": "MTF TR Ind Bnk Ins Bnd IL",
    "ShortName": "MTF TR Ind Bnk Ins Bnd IL",
    "Symbol": "TASE:5130000",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Index Banks and Insurance Bonds IL",
    "EnglishLongName": "MTF TR (00) Index Banks and Insurance Bonds IL",
    "HebrewName": "MTF מח אנד אגח בנק וביטוח",
    "HebrewLongName": "MTF מחקה (00) אינדקס אג\"ח בנקים וביטוח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 115.3,
    "MonthYield": 0.65,
    "YearYield": 0.65,
    "Last12MonthYield": 7.65,
    "ISIN": "IL0051300007"
  },
  {
    "Id": "TASE:5130372",
    "MayaId": "5130372",
    "Name": "MTF TR Ind Cm Bnk 2080 IL",
    "ShortName": "MTF TR Ind Cm Bnk 2080 IL",
    "Symbol": "TASE:5130372",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (20) Composite Index Israel Banks 80/20 monthly IL",
    "EnglishLongName": "MTF TR (20) Composite Index Israel Banks 80/20 monthly IL",
    "HebrewName": "MTF מח אנ מש בנק 2080",
    "HebrewLongName": "MTF מחקה (20) מדד משולב אינדקס בנקים ישראל 20/80 חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.63,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Composite Bonds",
    "SecondaryClassification": "up to 20% Equity",
    "AssetValue": 178.8,
    "MonthYield": 1.97,
    "YearYield": 1.97,
    "Last12MonthYield": 16.66,
    "ISIN": "IL0051303720"
  },
  {
    "Id": "TASE:5130596",
    "MayaId": "5130596",
    "Name": "MTF TR Ind Cm CRE 8020 IL",
    "ShortName": "MTF TR Ind Cm CRE 8020 IL",
    "Symbol": "TASE:5130596",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (2A) Composite Index Commercial Real Estate 80/20 monthly IL",
    "EnglishLongName": "MTF TR (2A) Composite Index Commercial Real Estate 80/20 monthly IL",
    "HebrewName": "MTF מח מש אנד 2080 נד מני",
    "HebrewLongName": "MTF מחקה (2A) מדד משולב אינדקס נדל\"ן מניב 20/80 חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.78,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Composite Bonds",
    "SecondaryClassification": "up to 20% Equity",
    "AssetValue": 15.8,
    "MonthYield": 2.15,
    "YearYield": 2.15,
    "Last12MonthYield": 14.74,
    "ISIN": "IL0051305964"
  },
  {
    "Id": "TASE:5123344",
    "MayaId": "5123344",
    "Name": "MTF TR IND CPI A IL",
    "ShortName": "MTF TR IND CPI A IL",
    "Symbol": "TASE:5123344",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) INDEX CPI-Linked A IL",
    "EnglishLongName": "MTF TR (00) INDEX CPI-Linked A IL",
    "HebrewName": "MTF מח‏ אינד A צמוד",
    "HebrewLongName": "MTF מחקה (00) אינדקס A צמוד",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0.02,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.26,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 373.1,
    "MonthYield": 0.16,
    "YearYield": 0.16,
    "Last12MonthYield": 6.37,
    "ISIN": "IL0051233448"
  },
  {
    "Id": "TASE:5123278",
    "MayaId": "5123278",
    "Name": "MTF TR IND CPI AA&Up IL",
    "ShortName": "MTF TR IND CPI AA&Up IL",
    "Symbol": "TASE:5123278",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) INDEX CPI-Linked AA And Up IL",
    "EnglishLongName": "MTF TR (00) INDEX CPI-Linked AA And Up IL",
    "HebrewName": "MTF מח‏ אינד AAומעלה צמוד",
    "HebrewLongName": "MTF מחקה (00) אינדקס AA ומעלה צמוד",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 411.8,
    "MonthYield": 0.23,
    "YearYield": 0.23,
    "Last12MonthYield": 6.41,
    "ISIN": "IL0051232788"
  },
  {
    "Id": "TASE:5133715",
    "MayaId": "5133715",
    "Name": "MTF TR Ind Gl Manufact HD",
    "ShortName": "MTF TR Ind Gl Manufact HD",
    "Symbol": "TASE:5133715",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4D) INDEX Global Manufacturers USD-Hedged",
    "EnglishLongName": "MTF TR (4D) INDEX Global Manufacturers USD-Hedged",
    "HebrewName": "MTF מח אנד Gl Manufact מד",
    "HebrewLongName": "MTF מחקה (4D) אינדקס Global Manufacturers מנוטרלת דולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.22,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 8.4,
    "MonthYield": 3.07,
    "YearYield": 3.07,
    "Last12MonthYield": 32.41,
    "ISIN": "IL0051337157"
  },
  {
    "Id": "TASE:5134135",
    "MayaId": "5134135",
    "Name": "MTF TR Ind GlMe&Minpr HD",
    "ShortName": "MTF TR Ind GlMe&Minpr HD",
    "Symbol": "TASE:5134135",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4D) INDEX Global Metals & Minerals producers USD-Hedged",
    "EnglishLongName": "MTF TR (4D) INDEX Global Metals & Minerals producers USD-Hedged",
    "HebrewName": "MTF מח אנד GlMe&Minpr מד",
    "HebrewLongName": "MTF מחקה (4D) אינדקס Global Metals & Minerals producers מנוטרלת דולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.86,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 45.9,
    "MonthYield": 13.31,
    "YearYield": 13.31,
    "Last12MonthYield": 109.85,
    "ISIN": "IL0051341357"
  },
  {
    "Id": "TASE:5134242",
    "MayaId": "5134242",
    "Name": "MTF TR Ind GlSemicondu HD",
    "ShortName": "MTF TR Ind GlSemicondu HD",
    "Symbol": "TASE:5134242",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4D) INDEX Global Semiconductors USD-Hedged",
    "EnglishLongName": "MTF TR (4D) INDEX Global Semiconductors USD-Hedged",
    "HebrewName": "MTF מח אנד GlSemicondu מד",
    "HebrewLongName": "MTF מחקה (4D) אינדקס Global Semiconductors מנוטרלת דולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.36,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 57.4,
    "MonthYield": 13.47,
    "YearYield": 13.47,
    "Last12MonthYield": 61.54,
    "ISIN": "IL0051342421"
  },
  {
    "Id": "TASE:5131222",
    "MayaId": "5131222",
    "Name": "MTF TR Ind GOV CO Bnd IL",
    "ShortName": "MTF TR Ind GOV CO Bnd IL",
    "Symbol": "TASE:5131222",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Index Government Companies Bonds IL",
    "EnglishLongName": "MTF TR (00) Index Government Companies Bonds IL",
    "HebrewName": "MTF מח אנד אגח חבר ממשל",
    "HebrewLongName": "MTF מחקה (00) אינדקס אג\"ח חברות ממשלתיות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0.02,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.48,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 207.3,
    "MonthYield": 0.24,
    "YearYield": 0.24,
    "Last12MonthYield": 6.92,
    "ISIN": "IL0051312226"
  },
  {
    "Id": "TASE:5123351",
    "MayaId": "5123351",
    "Name": "MTF TR Ind HY BBB Gen IL",
    "ShortName": "MTF TR Ind HY-BBB Gen IL",
    "Symbol": "TASE:5123351",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) (!) INDEX HY-BBB General IL",
    "EnglishLongName": "MTF TR (00) (!) INDEX HY-BBB General IL",
    "HebrewName": "MTF מח אינד HY-BBB כללי",
    "HebrewLongName": "MTF מחקה (00)(!) אינדקס HY-BBB כללי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Hi-risk Corporate & Convertibles",
    "AssetValue": 99.9,
    "MonthYield": 1.01,
    "YearYield": 1.01,
    "Last12MonthYield": 7.38,
    "ISIN": "IL0051233513"
  },
  {
    "Id": "TASE:5130604",
    "MayaId": "5130604",
    "Name": "MTF TR Ind Infrastru IL",
    "ShortName": "MTF TR Ind Infrastru IL",
    "Symbol": "TASE:5130604",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) Index National Infrastructure Israel IL",
    "EnglishLongName": "MTF TR (4A) Index National Infrastructure Israel IL",
    "HebrewName": "MTF מח אנד תשתיות ישראל",
    "HebrewLongName": "MTF מחקה (4A) אינדקס תשתיות לאומיות ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.88,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 633.4,
    "MonthYield": 6.76,
    "YearYield": 6.76,
    "Last12MonthYield": 68.26,
    "ISIN": "IL0051306046"
  },
  {
    "Id": "TASE:5139514",
    "MayaId": "5139514",
    "Name": "MTF TR Ind IsG$2030l6yr",
    "ShortName": "MTF TR Ind IsG$2030l6yr",
    "Symbol": "TASE:5139514",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (0D) iNDEX Israeli Gov $ Maturity 2030 (rolling every 6 years) in $",
    "EnglishLongName": "MTF TR (0D) iNDEX Israeli Gov $ Maturity 2030 (rolling every 6 years) in $",
    "HebrewName": "MTF מח אנ ישראל2030 6ש$",
    "HebrewLongName": "MTF מחקה (0D) אינדקס מדינת ישראל דולר לפדיון 2030 (מתגלגל כל 6 שנים) נקובה $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.12,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Government - Medium",
    "AssetValue": 245.3,
    "MonthYield": -0.8,
    "YearYield": -0.8,
    "Last12MonthYield": -5.33,
    "ISIN": "IL0051395148"
  },
  {
    "Id": "TASE:5130083",
    "MayaId": "5130083",
    "Name": "MTF TR Ind Lnk Bnk Ins IL",
    "ShortName": "MTF TR Ind Lnk Bnk Ins IL",
    "Symbol": "TASE:5130083",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Index CPI-Linked Banks and Insurance IL",
    "EnglishLongName": "MTF TR (00) Index CPI-Linked Banks and Insurance IL",
    "HebrewName": "MTF מח אנד צמוד בנק ביטוח",
    "HebrewLongName": "MTF מחקה (00) אינדקס צמודות בנקים וביטוח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.16,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 74.5,
    "MonthYield": 0.13,
    "YearYield": 0.13,
    "Last12MonthYield": 5.44,
    "ISIN": "IL0051300833"
  },
  {
    "Id": "TASE:5129549",
    "MayaId": "5129549",
    "Name": "MTF TR Ind Low Lev Bnd IL",
    "ShortName": "MTF TR Ind Low-Lev Bnd IL",
    "Symbol": "TASE:5129549",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Index Low Financial Leveraged Bonds IL",
    "EnglishLongName": "MTF TR (00) Index Low Financial Leveraged Bonds IL",
    "HebrewName": "MTF מח אנד אגח מינוף נמוך",
    "HebrewLongName": "MTF מחקה (00) אינדקס אג\"ח במינוף פיננסי נמוך",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0.02,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 148.2,
    "MonthYield": 0.66,
    "YearYield": 0.66,
    "Last12MonthYield": 6.79,
    "ISIN": "IL0051295496"
  },
  {
    "Id": "TASE:5123369",
    "MayaId": "5123369",
    "Name": "MTF TR IND NoLnk A IL",
    "ShortName": "MTF TR IND NoLnk A IL",
    "Symbol": "TASE:5123369",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) INDEX Non-Linked A IL",
    "EnglishLongName": "MTF TR (00) INDEX Non-Linked A IL",
    "HebrewName": "MTF מח‏ אינד Aש",
    "HebrewLongName": "MTF מחקה (00) אינדקס A שקלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0.02,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 185.2,
    "MonthYield": 0.96,
    "YearYield": 0.96,
    "Last12MonthYield": 7.23,
    "ISIN": "IL0051233695"
  },
  {
    "Id": "TASE:5123260",
    "MayaId": "5123260",
    "Name": "MTF TR IND NoLnkAA&Up IL",
    "ShortName": "MTF TR IND NoLnkAA&Up IL",
    "Symbol": "TASE:5123260",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) INDEX Non-Linked AA And Up IL",
    "EnglishLongName": "MTF TR (00) INDEX Non-Linked AA And Up IL",
    "HebrewName": "MTF מח‏ אינד AA ומעלהש",
    "HebrewLongName": "MTF מחקה (00) אינדקס AA ומעלה שקלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0.02,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 262.5,
    "MonthYield": 0.8,
    "YearYield": 0.8,
    "Last12MonthYield": 7.84,
    "ISIN": "IL0051232606"
  },
  {
    "Id": "TASE:5138458",
    "MayaId": "5138458",
    "Name": "MTF TR Ind T10USBankBond",
    "ShortName": "MTF TR Ind T10USBankBond",
    "Symbol": "TASE:5138458",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (0D) Index Top 10 US Banks Bonds",
    "EnglishLongName": "MTF TR (0D) Index Top 10 US Banks Bonds",
    "HebrewName": "MTF מח אנ Top10USBankBnd",
    "HebrewLongName": "MTF מחקה (0D) אינדקס Top 10 US Banks Bonds",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.12,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Hedged Corporate and Convertibles",
    "AssetValue": 43.3,
    "MonthYield": -1.38,
    "YearYield": -1.38,
    "Last12MonthYield": -6.6,
    "ISIN": "IL0051384589"
  },
  {
    "Id": "TASE:5141262",
    "MayaId": "5141262",
    "Name": "MTF TR Ind T10USIsrBa HD",
    "ShortName": "MTF TR Ind T10USIsrBa HD",
    "Symbol": "TASE:5141262",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) Indxx Top 10 US-Israel Banks Currency-Hedged",
    "EnglishLongName": "MTF TR (4A) Indxx Top 10 US-Israel Banks Currency-Hedged",
    "HebrewName": "MTF מחIndx T10USIsraBanממ",
    "HebrewLongName": "MTF מחקה (Indxx Top 10 US-Israel Banks (4A מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Hedged Global Stocks",
    "AssetValue": 4.9,
    "MonthYield": 4.24,
    "YearYield": 4.24,
    "Last12MonthYield": null,
    "ISIN": "IL0051412620"
  },
  {
    "Id": "TASE:5129887",
    "MayaId": "5129887",
    "Name": "MTF TR Ind TA 125 QU IL",
    "ShortName": "MTF TR Ind TA 125 QU IL",
    "Symbol": "TASE:5129887",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) Index TA 125 Quality IL",
    "EnglishLongName": "MTF TR (4A) Index TA 125 Quality IL",
    "HebrewName": "MTF מח אנד תא 125 Quality",
    "HebrewLongName": "MTF מחקה (4A) אינדקס ת\"א 125 Quality",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.41,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 79.0,
    "MonthYield": 9.67,
    "YearYield": 9.67,
    "Last12MonthYield": 70.72,
    "ISIN": "IL0051298870"
  },
  {
    "Id": "TASE:5140397",
    "MayaId": "5140397",
    "Name": "MTF TR iNDIsraelEco90 IL",
    "ShortName": "MTF TR iNDIsraelEco90 IL",
    "Symbol": "TASE:5140397",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) iNDEX Israeli Economy 90 IL",
    "EnglishLongName": "MTF TR (4A) iNDEX Israeli Economy 90 IL",
    "HebrewName": "MTF מח אנד כלכ ישראל 90",
    "HebrewLongName": "MTF מחקה (4A) אינדקס כלכלת ישראל 90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.19,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 5.3,
    "MonthYield": 7.81,
    "YearYield": 7.81,
    "Last12MonthYield": null,
    "ISIN": "IL0051403975"
  },
  {
    "Id": "TASE:5134853",
    "MayaId": "5134853",
    "Name": "MTF TR INDX112700 IL",
    "ShortName": "MTF TR INDX112700 IL",
    "Symbol": "TASE:5134853",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Index Israeli A Non-Linked Stable or Positive Outlook IL",
    "EnglishLongName": "MTF TR (00) Index Israeli A Non-Linked Stable or Positive Outlook IL",
    "HebrewName": "MTF מח אנד A ש אופק יצ חי",
    "HebrewLongName": "MTF מחקה (00) אינדקס A שקלי אופק דירוג יציב או חיובי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.26,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 60.8,
    "MonthYield": 0.98,
    "YearYield": 0.98,
    "Last12MonthYield": 8.26,
    "ISIN": "IL0051348535"
  },
  {
    "Id": "TASE:5140868",
    "MayaId": "5140868",
    "Name": "MTF TR INDX1164 IL",
    "ShortName": "MTF TR INDX1164 IL",
    "Symbol": "TASE:5140868",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) (!) iNDEX Israeli 0-3 Non-Linked up to A Bond IL",
    "EnglishLongName": "MTF TR (00) (!) iNDEX Israeli 0-3 Non-Linked up to A Bond IL",
    "HebrewName": "MTF מח אינד 0-3 שקלי עד A",
    "HebrewLongName": "MTF מחקה (00)(!) אינדקס 0-3 שקלי עד A",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 4.0,
    "MonthYield": 0.95,
    "YearYield": 0.95,
    "Last12MonthYield": null,
    "ISIN": "IL0051408685"
  },
  {
    "Id": "TASE:5141072",
    "MayaId": "5141072",
    "Name": "MTF TR INDX121586 IL",
    "ShortName": "MTF TR INDX121586 IL",
    "Symbol": "TASE:5141072",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) Index Israeli Financials Top15 IL",
    "EnglishLongName": "MTF TR (4A) Index Israeli Financials Top15 IL",
    "HebrewName": "MTF מח אנד פיננ יש TOP15",
    "HebrewLongName": "MTF מחקה (4A) אינדקס פיננסים ישראל Top15",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 19.5,
    "MonthYield": 8.99,
    "YearYield": 8.99,
    "Last12MonthYield": null,
    "ISIN": "IL0051410723"
  },
  {
    "Id": "TASE:5134796",
    "MayaId": "5134796",
    "Name": "MTF TR INDX1277 IL",
    "ShortName": "MTF TR INDX1277 IL",
    "Symbol": "TASE:5134796",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Index AA ILS-CPI Linkage Mechanism IL",
    "EnglishLongName": "MTF TR (00) Index AA ILS-CPI Linkage Mechanism IL",
    "HebrewName": "MTF מח אנ AA מנגנון שק צמ",
    "HebrewLongName": "MTF מחקה (00) אינדקס AA מנגנון שקלי-צמוד",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 34.5,
    "MonthYield": 0.59,
    "YearYield": 0.59,
    "Last12MonthYield": 7.83,
    "ISIN": "IL0051347966"
  },
  {
    "Id": "TASE:5134788",
    "MayaId": "5134788",
    "Name": "MTF TR INDX1278 IL",
    "ShortName": "MTF TR INDX1278 IL",
    "Symbol": "TASE:5134788",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Index A ILS-CPI Linkage Mechanism IL",
    "EnglishLongName": "MTF TR (00) Index A ILS-CPI Linkage Mechanism IL",
    "HebrewName": "MTF מח אנד A מנגנון שק צמ",
    "HebrewLongName": "MTF מחקה (00) אינדקס A מנגנון שקלי-צמוד",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 44.0,
    "MonthYield": 0.62,
    "YearYield": 0.62,
    "Last12MonthYield": 7.45,
    "ISIN": "IL0051347883"
  },
  {
    "Id": "TASE:5133038",
    "MayaId": "5133038",
    "Name": "MTF TR INDX6102 HD",
    "ShortName": "MTF TR INDX6102 HD",
    "Symbol": "TASE:5133038",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4D) Index Israeli High-Tech Overseas USD-Hedged",
    "EnglishLongName": "MTF TR (4D) Index Israeli High-Tech Overseas USD-Hedged",
    "HebrewName": "MTF מח אנד היטק יש חול מד",
    "HebrewLongName": "MTF מחקה (4D) אינדקס הייטק ישראלי בחו\"ל מנוטרלת דולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.8,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 5.2,
    "MonthYield": -0.96,
    "YearYield": -0.96,
    "Last12MonthYield": -17.99,
    "ISIN": "IL0051330384"
  },
  {
    "Id": "TASE:5133897",
    "MayaId": "5133897",
    "Name": "MTF TR INDX6212 HD",
    "ShortName": "MTF TR INDX6212 HD",
    "Symbol": "TASE:5133897",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) Index US Residential REIT TOP10 Currency Hedged",
    "EnglishLongName": "MTF TR (4A) Index US Residential REIT TOP10 Currency Hedged",
    "HebrewName": "MTF מח אנד US REIT10 ממ",
    "HebrewLongName": "MTF מחקה (4A) אינדקס נדל\"ן למגורים ארה\"ב Top10 מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.21,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 5.2,
    "MonthYield": -0.8,
    "YearYield": -0.8,
    "Last12MonthYield": -10.9,
    "ISIN": "IL0051338973"
  },
  {
    "Id": "TASE:5141213",
    "MayaId": "5141213",
    "Name": "MTF TR IndxBuildAmeric HD",
    "ShortName": "MTF TR IndxBuildAmeric HD",
    "Symbol": "TASE:5141213",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) Indxx Building America Infrastructure Currency-Hedged",
    "EnglishLongName": "MTF TR (4A) Indxx Building America Infrastructure Currency-Hedged",
    "HebrewName": "MTF מח Indx BuildAmeInfממ",
    "HebrewLongName": "MTF מחקה (Indxx Building America Infrastructure (4A מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 8.5,
    "MonthYield": 11.04,
    "YearYield": 11.04,
    "Last12MonthYield": null,
    "ISIN": "IL0051412133"
  },
  {
    "Id": "TASE:5139886",
    "MayaId": "5139886",
    "Name": "MTF TR Indxx Bitcoin Rfr",
    "ShortName": "MTF TR Indxx Bitcoin Rfr",
    "Symbol": "TASE:5139886",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4D) Indxx Bitcoin Reference",
    "EnglishLongName": "MTF TR (4D) Indxx Bitcoin Reference",
    "HebrewName": "MTF מח Indxx Bitcoin Rfr",
    "HebrewLongName": "MTF מחקה (Indxx Bitcoin Reference (4D",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 4.49,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Digital Assets",
    "SecondaryClassification": "Bitcoin",
    "AssetValue": 19.0,
    "MonthYield": 7.32,
    "YearYield": 7.32,
    "Last12MonthYield": -12.88,
    "ISIN": "IL0051398860"
  },
  {
    "Id": "TASE:5140199",
    "MayaId": "5140199",
    "Name": "MTF TR IsraelEco125iND IL",
    "ShortName": "MTF TR IsraelEco125iND IL",
    "Symbol": "TASE:5140199",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) iNDEX Israeli Economy 125 IL",
    "EnglishLongName": "MTF TR (4A) iNDEX Israeli Economy 125 IL",
    "HebrewName": "MTF מח אנד כלכ ישראל 125",
    "HebrewLongName": "MTF מחקה (4A) אינדקס כלכלת ישראל 125",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.9,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 116.6,
    "MonthYield": 7.77,
    "YearYield": 7.77,
    "Last12MonthYield": null,
    "ISIN": "IL0051401995"
  },
  {
    "Id": "TASE:5140439",
    "MayaId": "5140439",
    "Name": "MTF TR IT10EUDN EH",
    "ShortName": "MTF TR IT10EUDN EH",
    "Symbol": "TASE:5140439",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4D) Indxx Top 10 Europe Defense Euro-Hedged",
    "EnglishLongName": "MTF TR (4D) Indxx Top 10 Europe Defense Euro-Hedged",
    "HebrewName": "MTF מח Indx Top10EurDefמא",
    "HebrewLongName": "MTF מחקה (Indxx Top 10 Europe Defense (4D מנוטרלת אירו",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.75,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 28.6,
    "MonthYield": 15.97,
    "YearYield": 15.97,
    "Last12MonthYield": null,
    "ISIN": "IL0051404395"
  },
  {
    "Id": "TASE:5122569",
    "MayaId": "5122569",
    "Name": "MTF TR M1WO",
    "ShortName": "MTF TR M1WO",
    "Symbol": "TASE:5122569",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4D) MSCI World",
    "EnglishLongName": "MTF TR (4D) MSCI World",
    "HebrewName": "MTF מח MSCI World",
    "HebrewLongName": "MTF מחקה (MSCI World (4D",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.02,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.08,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 605.3,
    "MonthYield": -0.26,
    "YearYield": -0.26,
    "Last12MonthYield": 4.41,
    "ISIN": "IL0051225691"
  },
  {
    "Id": "TASE:5140165",
    "MayaId": "5140165",
    "Name": "MTF TR MSCI World HD",
    "ShortName": "MTF TR MSCI World HD",
    "Symbol": "TASE:5140165",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4D) MSCI World USD-Hedged",
    "EnglishLongName": "MTF TR (4D) MSCI World USD-Hedged",
    "HebrewName": "MTF מח MSCI World מד",
    "HebrewLongName": "MTF מחקה (MSCI World (4D מנוטרלת דולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 67.8,
    "MonthYield": 1.3,
    "YearYield": 1.3,
    "Last12MonthYield": null,
    "ISIN": "IL0051401656"
  },
  {
    "Id": "TASE:5127592",
    "MayaId": "5127592",
    "Name": "MTF TR MTFCCUNT",
    "ShortName": "MTF TR MTFCCUNT",
    "Symbol": "TASE:5127592",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) Indxx US Cloud Computing Currency-Hedged",
    "EnglishLongName": "MTF TR (4A) Indxx US Cloud Computing Currency-Hedged",
    "HebrewName": "MTF מח Indx US Cloud ממ",
    "HebrewLongName": "MTF מחקה (Indxx US Cloud Computing (4A מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.44,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 63.2,
    "MonthYield": -6.78,
    "YearYield": -6.78,
    "Last12MonthYield": -15.58,
    "ISIN": "IL0051275928"
  },
  {
    "Id": "TASE:5137112",
    "MayaId": "5137112",
    "Name": "MTF TR MTFUSHN HEALTH HD",
    "ShortName": "MTF TR MTFUSHN HEALTH HD",
    "Symbol": "TASE:5137112",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) Indxx US Healthcare Top 10 Currency-Hedged",
    "EnglishLongName": "MTF TR (4A) Indxx US Healthcare Top 10 Currency-Hedged",
    "HebrewName": "MTF מח Indx US HEALT10 ממ",
    "HebrewLongName": "MTF מחקה (Indxx US Healthcare Top 10 (4A מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.85,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 58.1,
    "MonthYield": 0.88,
    "YearYield": 0.88,
    "Last12MonthYield": 15.38,
    "ISIN": "IL0051371123"
  },
  {
    "Id": "TASE:5134531",
    "MayaId": "5134531",
    "Name": "MTF TR Nasdaq 100",
    "ShortName": "MTF TR Nasdaq 100",
    "Symbol": "TASE:5134531",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4D) Nasdaq 100",
    "EnglishLongName": "MTF TR (4D) Nasdaq 100",
    "HebrewName": "MTF מח Nasdaq 100",
    "HebrewLongName": "MTF מחקה (Nasdaq 100 (4D",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.025,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.86,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 724.2,
    "MonthYield": -0.2,
    "YearYield": -0.2,
    "Last12MonthYield": 5.29,
    "ISIN": "IL0051345317"
  },
  {
    "Id": "TASE:5134549",
    "MayaId": "5134549",
    "Name": "MTF TR Nasdaq 100 HD",
    "ShortName": "MTF TR Nasdaq 100 HD",
    "Symbol": "TASE:5134549",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) Nasdaq 100 Currency-Hedged",
    "EnglishLongName": "MTF TR (4A) Nasdaq 100 Currency-Hedged",
    "HebrewName": "MTF מח Nasdaq 100 ממ",
    "HebrewLongName": "MTF מחקה (Nasdaq 100 (4A מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.07,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 878.1,
    "MonthYield": 1.21,
    "YearYield": 1.21,
    "Last12MonthYield": 19.91,
    "ISIN": "IL0051345499"
  },
  {
    "Id": "TASE:5138201",
    "MayaId": "5138201",
    "Name": "MTF TR RU20N30U HD",
    "ShortName": "MTF TR RU20N30U HD",
    "Symbol": "TASE:5138201",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) Russell 2000 Currency-Hedged",
    "EnglishLongName": "MTF TR (4A) Russell 2000 Currency-Hedged",
    "HebrewName": "MTF מח Russell 2000 ממ",
    "HebrewLongName": "MTF מחקה (Russell 2000 (4A מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.42,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 187.4,
    "MonthYield": 7.73,
    "YearYield": 7.73,
    "Last12MonthYield": 18.68,
    "ISIN": "IL0051382013"
  },
  {
    "Id": "TASE:5138151",
    "MayaId": "5138151",
    "Name": "MTF TR S&P 500 Top 50",
    "ShortName": "MTF TR S&P 500 Top 50",
    "Symbol": "TASE:5138151",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4D) S&P 500 Top 50",
    "EnglishLongName": "MTF TR (4D) S&P 500 Top 50",
    "HebrewName": "MTF‏ מח S&P 500 Top 50",
    "HebrewLongName": "MTF מחקה (S&P 500 Top 50 (4D",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.55,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 63.1,
    "MonthYield": -1.96,
    "YearYield": -1.96,
    "Last12MonthYield": 2.1,
    "ISIN": "IL0051381510"
  },
  {
    "Id": "TASE:5139365",
    "MayaId": "5139365",
    "Name": "MTF TR S&P Israel 100 IL",
    "ShortName": "MTF TR S&P Israel 100 IL",
    "Symbol": "TASE:5139365",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) S&P Israel 100 (ILS) IL",
    "EnglishLongName": "MTF TR (4A) S&P Israel 100 (ILS) IL",
    "HebrewName": "MTF מח S&PIsrael100ILS",
    "HebrewLongName": "MTF מחקה S&P Israel 100 (ILS) (4A)",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.12,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 277.1,
    "MonthYield": 8.98,
    "YearYield": 8.98,
    "Last12MonthYield": 62.27,
    "ISIN": "IL0051393655"
  },
  {
    "Id": "TASE:5141924",
    "MayaId": "5141924",
    "Name": "MTF TR SP Isra70LarCapIL",
    "ShortName": "MTF TR SP Isra70LarCapIL",
    "Symbol": "TASE:5141924",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) S&P Israel 30 LargeCap (ILS) IL",
    "EnglishLongName": "MTF TR (4A) S&P Israel 30 LargeCap (ILS) IL",
    "HebrewName": "MTF מח SP Israel30LarCap",
    "HebrewLongName": "MTF מחקה (4A)י (ILS)י S&P Israel 30 LargeCap",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.015,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 0.3,
    "MonthYield": 10.08,
    "YearYield": 10.08,
    "Last12MonthYield": null,
    "ISIN": "IL0051419245"
  },
  {
    "Id": "TASE:5141916",
    "MayaId": "5141916",
    "Name": "MTF TR SP Isra70MidCapIL",
    "ShortName": "MTF TR SP Isra70MidCapIL",
    "Symbol": "TASE:5141916",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) S&P Israel 70 MidCap (ILS) IL",
    "EnglishLongName": "MTF TR (4A) S&P Israel 70 MidCap (ILS) IL",
    "HebrewName": "MTF מח SP Israel70MidCap",
    "HebrewLongName": "MTF מחקה (4A)י (ILS)י S&P Israel 70 MidCap",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 0.5,
    "MonthYield": 6.73,
    "YearYield": 6.73,
    "Last12MonthYield": null,
    "ISIN": "IL0051419161"
  },
  {
    "Id": "TASE:5140850",
    "MayaId": "5140850",
    "Name": "MTF TR SP500MUN",
    "ShortName": "MTF TR SP500MUN",
    "Symbol": "TASE:5140850",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4D) S&P 500 Momentum",
    "EnglishLongName": "MTF TR (4D) S&P 500 Momentum",
    "HebrewName": "MTF מח S&P 500 Momentum",
    "HebrewLongName": "MTF מחקה (4D)י S&P 500 Momentum",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 13.6,
    "MonthYield": -1.11,
    "YearYield": -1.11,
    "Last12MonthYield": null,
    "ISIN": "IL0051408503"
  },
  {
    "Id": "TASE:5141114",
    "MayaId": "5141114",
    "Name": "MTF TR SP500MUN HD",
    "ShortName": "MTF TR SP500MUN HD",
    "Symbol": "TASE:5141114",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) S&P 500 Momentum Currency-Hedged",
    "EnglishLongName": "MTF TR (4A) S&P 500 Momentum Currency-Hedged",
    "HebrewName": "MTF מח S&P 500Momentumממ",
    "HebrewLongName": "MTF מחקה (4A)י S&P 500 Momentum מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 9.5,
    "MonthYield": 0.26,
    "YearYield": 0.26,
    "Last12MonthYield": null,
    "ISIN": "IL0051411143"
  },
  {
    "Id": "TASE:5138482",
    "MayaId": "5138482",
    "Name": "MTF TR SP5MI35T HD",
    "ShortName": "MTF TR SP5MI35T HD",
    "Symbol": "TASE:5138482",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (0A) S&P 500 Bond Mega 30 Investment Grade 3-5 Year Currency-Hedged",
    "EnglishLongName": "MTF TR (0A) S&P 500 Bond Mega 30 Investment Grade 3-5 Year Currency-Hedged",
    "HebrewName": "MTF מח SPMega30 3-5 ממ",
    "HebrewLongName": "MTF מחקה (S&P 500 Bond Mega 30 Investment Grade 3-5 Year (0A מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Hedged Corporate and Convertibles - Medium",
    "AssetValue": 171.4,
    "MonthYield": 0.03,
    "YearYield": 0.03,
    "Last12MonthYield": 6.67,
    "ISIN": "IL0051384829"
  },
  {
    "Id": "TASE:5137716",
    "MayaId": "5137716",
    "Name": "MTF TR SP5MI57T DENOM D",
    "ShortName": "MTF TR SP5MI57T DENOM D",
    "Symbol": "TASE:5137716",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (0D) S&P 500 Bond Mega 30 Investment Grade 5-7 Year Denominated in Dollar",
    "EnglishLongName": "MTF TR (0D) S&P 500 Bond Mega 30 Investment Grade 5-7 Year Denominated in Dollar",
    "HebrewName": "MTF מח SPMega30 5-7 נקוב$",
    "HebrewLongName": "MTF מחקה (0D)י S&P 500 Bond Mega 30 Investment Grade 5-7 Year נקובה דולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.21,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Corporate and Convertibles - Long",
    "AssetValue": 89.0,
    "MonthYield": -1.06,
    "YearYield": -1.06,
    "Last12MonthYield": -6.7,
    "ISIN": "IL0051377161"
  },
  {
    "Id": "TASE:5133061",
    "MayaId": "5133061",
    "Name": "MTF TR SPC500UN HD",
    "ShortName": "MTF TR SPC500UN HD",
    "Symbol": "TASE:5133061",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) S&P CHINA 500 USD-Hedged",
    "EnglishLongName": "MTF TR (4A) S&P CHINA 500 USD-Hedged",
    "HebrewName": "MTF מח S&P CHINA 500 מד",
    "HebrewLongName": "MTF מחקה S&P CHINA 500 (4A) מנוטרלת דולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.96,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 11.7,
    "MonthYield": 4.44,
    "YearYield": 4.44,
    "Last12MonthYield": 34.24,
    "ISIN": "IL0051330616"
  },
  {
    "Id": "TASE:5122924",
    "MayaId": "5122924",
    "Name": "MTF TR SPDAUDN",
    "ShortName": "MTF TR SPDAUDN",
    "Symbol": "TASE:5122924",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4D) S&P 500 Dividend Aristocrats",
    "EnglishLongName": "MTF TR (4D) S&P 500 Dividend Aristocrats",
    "HebrewName": "MTF מח‏ SP500 Aristo",
    "HebrewLongName": "MTF מחקה‏ (S&P 500 Dividend Aristocrats (4D",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.43,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 38.2,
    "MonthYield": 4.06,
    "YearYield": 4.06,
    "Last12MonthYield": -3.85,
    "ISIN": "IL0051229248"
  },
  {
    "Id": "TASE:5135603",
    "MayaId": "5135603",
    "Name": "MTF TR SPNRSVX HD",
    "ShortName": "MTF TR SPNRSVX HD",
    "Symbol": "TASE:5135603",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) S&P 500 VALUE Currency-Hedged",
    "EnglishLongName": "MTF TR (4A) S&P 500 VALUE Currency-Hedged",
    "HebrewName": "MTF מח S&P 500 Value ממ",
    "HebrewLongName": "MTF מחקה (S&P 500 VALUE (4A מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.12,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 21.0,
    "MonthYield": 2.64,
    "YearYield": 2.64,
    "Last12MonthYield": 13.11,
    "ISIN": "IL0051356033"
  },
  {
    "Id": "TASE:5130521",
    "MayaId": "5130521",
    "Name": "MTF TR SPS&S HD",
    "ShortName": "MTF TR SPS&S HD",
    "Symbol": "TASE:5130521",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) S&P 500 Scored & Screened Currency-Hedged",
    "EnglishLongName": "MTF TR (4A) S&P 500 Scored & Screened Currency-Hedged",
    "HebrewName": "MTF מח S&P 500 S&S ממ",
    "HebrewLongName": "MTF מחקה (4A)י S&P 500 Scored & Screened מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.6,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 149.5,
    "MonthYield": 1.26,
    "YearYield": 1.26,
    "Last12MonthYield": 17.51,
    "ISIN": "IL0051305212"
  },
  {
    "Id": "TASE:5122627",
    "MayaId": "5122627",
    "Name": "MTF TR SPTR500N",
    "ShortName": "MTF TR SPTR500N",
    "Symbol": "TASE:5122627",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4D) S&P 500",
    "EnglishLongName": "MTF TR (4D) S&P 500",
    "HebrewName": "MTF מח SP500",
    "HebrewLongName": "MTF מחקה (S&P 500 (4D",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.39,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 2094.2,
    "MonthYield": 0.09,
    "YearYield": 0.09,
    "Last12MonthYield": 2.82,
    "ISIN": "IL0051226277"
  },
  {
    "Id": "TASE:5138474",
    "MayaId": "5138474",
    "Name": "MTF TR SPXEWNTR HD",
    "ShortName": "MTF TR SPXEWNTR HD",
    "Symbol": "TASE:5138474",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) S&P 500 Equal Weight Currency-Hedged",
    "EnglishLongName": "MTF TR (4A) S&P 500 Equal Weight Currency-Hedged",
    "HebrewName": "MTF מח SP500 EW ממ",
    "HebrewLongName": "MTF מחקה (S&P 500 Equal Weight (4A מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.51,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 107.7,
    "MonthYield": 4.17,
    "YearYield": 4.17,
    "Last12MonthYield": 13.88,
    "ISIN": "IL0051384746"
  },
  {
    "Id": "TASE:5122163",
    "MayaId": "5122163",
    "Name": "MTF TR STOXX600",
    "ShortName": "MTF TR STOXX600",
    "Symbol": "TASE:5122163",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) STOXX Europe 600 Currency-Hedged",
    "EnglishLongName": "MTF TR (4A) STOXX Europe 600 Currency-Hedged",
    "HebrewName": "MTF מח‏ STOXX600 ממ",
    "HebrewLongName": "MTF מחקה (STOXX Europe 600 (4A מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.17,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 94.0,
    "MonthYield": 3.75,
    "YearYield": 3.75,
    "Last12MonthYield": 26.06,
    "ISIN": "IL0051221633"
  },
  {
    "Id": "TASE:5121843",
    "MayaId": "5121843",
    "Name": "MTF TR SXXR",
    "ShortName": "MTF TR SXXR",
    "Symbol": "TASE:5121843",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4D) STOXX Europe 600",
    "EnglishLongName": "MTF TR (4D) STOXX Europe 600",
    "HebrewName": "MTF מח‏ STOXX600",
    "HebrewLongName": "MTF מחקה (STOXX Europe 600 (4D",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.45,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 51.3,
    "MonthYield": 0.91,
    "YearYield": 0.91,
    "Last12MonthYield": 19.04,
    "ISIN": "IL0051218431"
  },
  {
    "Id": "TASE:5109889",
    "MayaId": "5109889",
    "Name": "MTF TR TA 125 IL",
    "ShortName": "MTF TR TA-125 IL",
    "Symbol": "TASE:5109889",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) TA-125 IL",
    "EnglishLongName": "MTF TR (4A) TA-125 IL",
    "HebrewName": "MTF מחקה ת\"א 125",
    "HebrewLongName": "MTF מחקה (4A) ת\"א 125",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.005,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.12,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 1941.9,
    "MonthYield": 8.85,
    "YearYield": 8.85,
    "Last12MonthYield": 64.14,
    "ISIN": "IL0051098890"
  },
  {
    "Id": "TASE:5109897",
    "MayaId": "5109897",
    "Name": "MTF TR TA 35 IL",
    "ShortName": "MTF TR TA-35 IL",
    "Symbol": "TASE:5109897",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) TA-35 IL",
    "EnglishLongName": "MTF TR (4A) TA-35 IL",
    "HebrewName": "MTF מחקה ת\"א 35",
    "HebrewLongName": "MTF מחקה (4A) ת\"א 35",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.015,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.96,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 589.3,
    "MonthYield": 9.28,
    "YearYield": 9.28,
    "Last12MonthYield": 65.52,
    "ISIN": "IL0051098973"
  },
  {
    "Id": "TASE:5140157",
    "MayaId": "5140157",
    "Name": "MTF TR TA 90 and Banks IL",
    "ShortName": "MTF TR TA 90 and Banks IL",
    "Symbol": "TASE:5140157",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) TA 90 and Banks IL",
    "EnglishLongName": "MTF TR (4A) TA 90 and Banks IL",
    "HebrewName": "MTF מח ת\"א 90 ובנקים",
    "HebrewLongName": "MTF מחקה (4A) ת\"א 90 ובנקים",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.66,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 12.5,
    "MonthYield": 8.08,
    "YearYield": 8.08,
    "Last12MonthYield": null,
    "ISIN": "IL0051401573"
  },
  {
    "Id": "TASE:5135090",
    "MayaId": "5135090",
    "Name": "MTF TR TA 90 Denom $ IL",
    "ShortName": "MTF TR TA-90 Denom $ IL",
    "Symbol": "TASE:5135090",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4D) TA-90 Denominated in $ IL",
    "EnglishLongName": "MTF TR (4D) TA-90 Denominated in $ IL",
    "HebrewName": "MTF מח ת\"א-90 נקובה $",
    "HebrewLongName": "MTF מחקה (4D) ת\"א-90 נקובה $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.41,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 71.0,
    "MonthYield": 6.95,
    "YearYield": 6.95,
    "Last12MonthYield": 39.33,
    "ISIN": "IL0051350903"
  },
  {
    "Id": "TASE:5130620",
    "MayaId": "5130620",
    "Name": "MTF TR TA 90 IL",
    "ShortName": "MTF TR TA-90 IL",
    "Symbol": "TASE:5130620",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) TA-90 IL",
    "EnglishLongName": "MTF TR (4A) TA-90 IL",
    "HebrewName": "MTF מח תא 90",
    "HebrewLongName": "MTF מחקה (4A) ת\"א 90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.03,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.98,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 946.0,
    "MonthYield": 7.34,
    "YearYield": 7.34,
    "Last12MonthYield": 57.27,
    "ISIN": "IL0051306202"
  },
  {
    "Id": "TASE:5123641",
    "MayaId": "5123641",
    "Name": "MTF TR TA GROW IL",
    "ShortName": "MTF TR TA-GROW IL",
    "Symbol": "TASE:5123641",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) TA-Growth IL",
    "EnglishLongName": "MTF TR (4A) TA-Growth IL",
    "HebrewName": "MTF מח תא צמיחה",
    "HebrewLongName": "MTF מחקה (4A) ת\"א צמיחה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 25.1,
    "MonthYield": 7.38,
    "YearYield": 7.38,
    "Last12MonthYield": 32.51,
    "ISIN": "IL0051236417"
  },
  {
    "Id": "TASE:5140447",
    "MayaId": "5140447",
    "Name": "MTF TR TA insurance IL",
    "ShortName": "MTF TR TA-insurance IL",
    "Symbol": "TASE:5140447",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) TA-insurance IL",
    "EnglishLongName": "MTF TR (4A) TA-insurance IL",
    "HebrewName": "MTF מח ת\"א - ביטוח",
    "HebrewLongName": "MTF מחקה (4A) ת\"א - ביטוח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 5.43,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 104.0,
    "MonthYield": 7.09,
    "YearYield": 7.09,
    "Last12MonthYield": null,
    "ISIN": "IL0051404478"
  },
  {
    "Id": "TASE:5140595",
    "MayaId": "5140595",
    "Name": "MTF TR TA Oil & Gas IL",
    "ShortName": "MTF TR TA - Oil & Gas IL",
    "Symbol": "TASE:5140595",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) TA - Oil & Gas IL",
    "EnglishLongName": "MTF TR (4A) TA - Oil & Gas IL",
    "HebrewName": "MTF מח ת\"א - נפט וגז",
    "HebrewLongName": "MTF מחקה (4A) ת\"א -נפט וגז",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 34.9,
    "MonthYield": -2.29,
    "YearYield": -2.29,
    "Last12MonthYield": null,
    "ISIN": "IL0051405954"
  },
  {
    "Id": "TASE:5140892",
    "MayaId": "5140892",
    "Name": "MTF TR TA Real Estate IL",
    "ShortName": "MTF TR TA -Real Estate IL",
    "Symbol": "TASE:5140892",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) TA-Real Estate IL",
    "EnglishLongName": "MTF TR (4A) TA-Real Estate IL",
    "HebrewName": "MTF מח ת\"א - נדל\"ן",
    "HebrewLongName": "MTF מחקה (4A) ת\"א – נדל\"ן",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.015,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 34.1,
    "MonthYield": 9.77,
    "YearYield": 9.77,
    "Last12MonthYield": null,
    "ISIN": "IL0051408925"
  },
  {
    "Id": "TASE:5118997",
    "MayaId": "5118997",
    "Name": "MTF TR TA SME60 IL",
    "ShortName": "MTF TR TA-SME60 IL",
    "Symbol": "TASE:5118997",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) TA-SME60 IL",
    "EnglishLongName": "MTF TR (4A) TA-SME60 IL",
    "HebrewName": "MTF מח תא SME60",
    "HebrewLongName": "MTF מחקה (4A) ת\"א SME60",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0.15,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.39,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 204.5,
    "MonthYield": 5.85,
    "YearYield": 5.85,
    "Last12MonthYield": 45.42,
    "ISIN": "IL0051189970"
  },
  {
    "Id": "TASE:5130893",
    "MayaId": "5130893",
    "Name": "MTF TR TA TECH IL",
    "ShortName": "MTF TR TA-TECH IL",
    "Symbol": "TASE:5130893",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) TA-Technology IL",
    "EnglishLongName": "MTF TR (4A) TA-Technology IL",
    "HebrewName": "MTF מח תא טכנולוגיה",
    "HebrewLongName": "MTF מחקה (4A) ת\"א-טכנולוגיה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.45,
    "TrusteeFee": 0.02,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.27,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 149.7,
    "MonthYield": 14.92,
    "YearYield": 14.92,
    "Last12MonthYield": 79.97,
    "ISIN": "IL0051308935"
  },
  {
    "Id": "TASE:5116181",
    "MayaId": "5116181",
    "Name": "MTF TR TAGBDGV IL",
    "ShortName": "MTF TR TAGBDGV IL",
    "Symbol": "TASE:5116181",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (0A) Tel-Gov IL",
    "EnglishLongName": "MTF TR (0A) Tel-Gov IL",
    "HebrewName": "MTF מח תל גוב-כללי",
    "HebrewLongName": "MTF מחקה (0A) תל גוב-כללי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.03,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.39,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bonds",
    "AssetValue": 255.2,
    "MonthYield": 0.48,
    "YearYield": 0.48,
    "Last12MonthYield": 6.34,
    "ISIN": "IL0051161813"
  },
  {
    "Id": "TASE:5117866",
    "MayaId": "5117866",
    "Name": "MTF TR TALNCGV IL",
    "ShortName": "MTF TR TALNCGV IL",
    "Symbol": "TASE:5117866",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Tel Gov - CPI Linked IL",
    "EnglishLongName": "MTF TR (00) Tel Gov - CPI Linked IL",
    "HebrewName": "MTF מח‏ תל גוב-צמודות",
    "HebrewLongName": "MTF מחקה‏ (00) תל גוב-צמודות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.03,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.47,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked",
    "AssetValue": 36.7,
    "MonthYield": 0.04,
    "YearYield": 0.04,
    "Last12MonthYield": 4.55,
    "ISIN": "IL0051178668"
  },
  {
    "Id": "TASE:5123393",
    "MayaId": "5123393",
    "Name": "MTF TR TANLCFXG IL",
    "ShortName": "MTF TR TANLCFXG IL",
    "Symbol": "TASE:5123393",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Tel Gov - Shekel IL",
    "EnglishLongName": "MTF TR (00) Tel Gov - Shekel IL",
    "HebrewName": "MTF מח תל גוב-שקלי",
    "HebrewLongName": "‏MTF מחקה (00) תל גוב-שקלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.13,
    "TrusteeFee": 0.03,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.42,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Non-Linked Government Bonds",
    "AssetValue": 67.1,
    "MonthYield": 0.86,
    "YearYield": 0.86,
    "Last12MonthYield": 7.93,
    "ISIN": "IL0051233935"
  },
  {
    "Id": "TASE:5122973",
    "MayaId": "5122973",
    "Name": "MTF TR TAR25FIG IL",
    "ShortName": "MTF TR TAR25FIG IL",
    "Symbol": "TASE:5122973",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Tel Gov - Shekel 2-5 IL",
    "EnglishLongName": "MTF TR (00) Tel Gov - Shekel 2-5 IL",
    "HebrewName": "MTF מח תל גוב-שקלי 2-5",
    "HebrewLongName": "MTF מחקה (00) תל גוב-שקלי 2-5",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.02,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.24,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Non-Linked Government Bonds",
    "AssetValue": 225.4,
    "MonthYield": 0.59,
    "YearYield": 0.59,
    "Last12MonthYield": 6.28,
    "ISIN": "IL0051229735"
  },
  {
    "Id": "TASE:5121686",
    "MayaId": "5121686",
    "Name": "MTF TR TAR25GV IL",
    "ShortName": "MTF TR TAR25GV IL",
    "Symbol": "TASE:5121686",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Tel Gov - CPI Linked 2-5 IL",
    "EnglishLongName": "MTF TR (00) Tel Gov - CPI Linked 2-5 IL",
    "HebrewName": "MTF מח תל גוב-צמודות 2-5",
    "HebrewLongName": "MTF מחקה‏ (00) תל גוב-צמודות 2-5",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.03,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.14,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked",
    "AssetValue": 182.7,
    "MonthYield": 0.14,
    "YearYield": 0.14,
    "Last12MonthYield": 4.42,
    "ISIN": "IL0051216864"
  },
  {
    "Id": "TASE:5135405",
    "MayaId": "5135405",
    "Name": "MTF TR TAR510GV IL",
    "ShortName": "MTF TR TAR510GV IL",
    "Symbol": "TASE:5135405",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Tel Gov - CPI Linked 5-10 IL",
    "EnglishLongName": "MTF TR (00) Tel Gov - CPI Linked 5-10 IL",
    "HebrewName": "MTF מח תל גוב-צמודות 5-10",
    "HebrewLongName": "MTF מחקה (00) תל גוב-צמודות 5-10",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.39,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked",
    "AssetValue": 191.8,
    "MonthYield": -0.11,
    "YearYield": -0.11,
    "Last12MonthYield": 5.21,
    "ISIN": "IL0051354053"
  },
  {
    "Id": "TASE:5130513",
    "MayaId": "5130513",
    "Name": "MTF TR TAR5FIG IL",
    "ShortName": "MTF TR TAR5FIG IL",
    "Symbol": "TASE:5130513",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Tel Gov-Shekel 5+ IL",
    "EnglishLongName": "MTF TR (00) Tel Gov-Shekel 5+ IL",
    "HebrewName": "MTF מח תל גוב-שקלי 5+",
    "HebrewLongName": "MTF מחקה (00) תל גוב-שקלי 5+",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.79,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Non-Linked Government Bonds",
    "AssetValue": 204.2,
    "MonthYield": 1.25,
    "YearYield": 1.25,
    "Last12MonthYield": 11.23,
    "ISIN": "IL0051305139"
  },
  {
    "Id": "TASE:5125356",
    "MayaId": "5125356",
    "Name": "MTF TR TEL B LNK 3 5 IL",
    "ShortName": "MTF TR TEL-B LNK 3-5 IL",
    "Symbol": "TASE:5125356",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Tel Bond-CPI Linked 3-5 IL",
    "EnglishLongName": "MTF TR (00) Tel Bond-CPI Linked 3-5 IL",
    "HebrewName": "MTF מח‏ תלבונד צ 3-5",
    "HebrewLongName": "MTF מחקה‏ (00) תל בונד צמודות 3-5",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.25,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 239.9,
    "MonthYield": 0.17,
    "YearYield": 0.17,
    "Last12MonthYield": 5.88,
    "ISIN": "IL0051253560"
  },
  {
    "Id": "TASE:5125349",
    "MayaId": "5125349",
    "Name": "MTF TR TEL B LNK 5 15 IL",
    "ShortName": "MTF TR TEL-B LNK 5-15 IL",
    "Symbol": "TASE:5125349",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Tel Bond-CPI Linked 5-15 IL",
    "EnglishLongName": "MTF TR (00) Tel Bond-CPI Linked 5-15 IL",
    "HebrewName": "MTF מח‏ תלבונד צ 5-15",
    "HebrewLongName": "MTF מחקה‏ (00) תל בונד צמודות 5-15",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.5,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 153.2,
    "MonthYield": 0.39,
    "YearYield": 0.39,
    "Last12MonthYield": 8.66,
    "ISIN": "IL0051253495"
  },
  {
    "Id": "TASE:5125331",
    "MayaId": "5125331",
    "Name": "MTF TR TEL B SH 3 5 IL",
    "ShortName": "MTF TR TEL-B SH 3-5 IL",
    "Symbol": "TASE:5125331",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Tel Bond-Shekel 3-5 IL",
    "EnglishLongName": "MTF TR (00) Tel Bond-Shekel 3-5 IL",
    "HebrewName": "MTF מח תלבונד ש 3-5",
    "HebrewLongName": "MTF מחקה‏ (00) תל בונד שקלי 3-5",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0.02,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.36,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 106.2,
    "MonthYield": 0.87,
    "YearYield": 0.87,
    "Last12MonthYield": 7.51,
    "ISIN": "IL0051253313"
  },
  {
    "Id": "TASE:5125364",
    "MayaId": "5125364",
    "Name": "MTF TR TEL B SH 5 15 IL",
    "ShortName": "MTF TR TEL-B SH 5-15 IL",
    "Symbol": "TASE:5125364",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Tel Bond-Shekel 5-15 IL",
    "EnglishLongName": "MTF TR (00) Tel Bond-Shekel 5-15 IL",
    "HebrewName": "MTF מח‏ תלבונד ש 5-15",
    "HebrewLongName": "MTF מחקה‏ (00) תל בונד שקלי 5-15",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.57,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 170.6,
    "MonthYield": 1.23,
    "YearYield": 1.23,
    "Last12MonthYield": 10.83,
    "ISIN": "IL0051253644"
  },
  {
    "Id": "TASE:5123039",
    "MayaId": "5123039",
    "Name": "MTF TR TEL B20 CPI LINKIL",
    "ShortName": "MTF TR TEL-B20 CPI-LINKIL",
    "Symbol": "TASE:5123039",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Tel - Bond 20 CPI-Linked IL",
    "EnglishLongName": "MTF TR (00) Tel - Bond 20 CPI-Linked IL",
    "HebrewName": "MTF מח תלבונד 20 צמודות",
    "HebrewLongName": "MTF מחקה (00) תל בונד 20 צמודות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0.01,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.43,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 414.2,
    "MonthYield": 0.21,
    "YearYield": 0.21,
    "Last12MonthYield": 7.02,
    "ISIN": "IL0051230394"
  },
  {
    "Id": "TASE:5112404",
    "MayaId": "5112404",
    "Name": "MTF TR TEL B40 CPI LINKIL",
    "ShortName": "MTF TR TEL-B40 CPI-LINKIL",
    "Symbol": "TASE:5112404",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Tel - Bond 40 CPI-Linked IL",
    "EnglishLongName": "MTF TR (00) Tel - Bond 40 CPI-Linked IL",
    "HebrewName": "MTF מח‏ תלבונד 40 צמודות",
    "HebrewLongName": "MTF מחקה‏ (00) תל בונד 40 צמודות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.27,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 34.3,
    "MonthYield": 0.25,
    "YearYield": 0.25,
    "Last12MonthYield": 6.17,
    "ISIN": "IL0051124043"
  },
  {
    "Id": "TASE:5122262",
    "MayaId": "5122262",
    "Name": "MTF TR TEL B60 CPI LINKIL",
    "ShortName": "MTF TR TEL-B60 CPI-LINKIL",
    "Symbol": "TASE:5122262",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Tel - Bond 60 CPI-Linked IL",
    "EnglishLongName": "MTF TR (00) Tel - Bond 60 CPI-Linked IL",
    "HebrewName": "MTF מח תלבונד 60 צמודות",
    "HebrewLongName": "MTF מחקה (00) תל בונד 60 צמודות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 295.1,
    "MonthYield": 0.23,
    "YearYield": 0.23,
    "Last12MonthYield": 6.58,
    "ISIN": "IL0051222623"
  },
  {
    "Id": "TASE:5123518",
    "MayaId": "5123518",
    "Name": "MTF TR TEL BCL IL",
    "ShortName": "MTF TR TEL-BCL IL",
    "Symbol": "TASE:5123518",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Tel Bond-CPI Linked IL",
    "EnglishLongName": "MTF TR (00) Tel Bond-CPI Linked IL",
    "HebrewName": "MTF מח‏ תלבונד צמוד",
    "HebrewLongName": "MTF מחקה‏ (00) תל בונד צמודות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 117.0,
    "MonthYield": 0.25,
    "YearYield": 0.25,
    "Last12MonthYield": 6.56,
    "ISIN": "IL0051235187"
  },
  {
    "Id": "TASE:5117817",
    "MayaId": "5117817",
    "Name": "MTF TR TEL BCLB NOCOCO IL",
    "ShortName": "MTF TR TEL-BCLB NOCOCO IL",
    "Symbol": "TASE:5117817",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Tel Bond CPI Linked - Bank Without COCO IL",
    "EnglishLongName": "MTF TR (00) Tel Bond CPI Linked - Bank Without COCO IL",
    "HebrewName": "MTF מח‏ תלבונד צבנללאCOCO",
    "HebrewLongName": "MTF מחקה (00) תל בונד צמודות – בנקים ללא COCO",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.03,
    "VariableFee": 0.02,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.19,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 112.1,
    "MonthYield": 0.08,
    "YearYield": 0.08,
    "Last12MonthYield": 5.17,
    "ISIN": "IL0051178171"
  },
  {
    "Id": "TASE:5116918",
    "MayaId": "5116918",
    "Name": "MTF TR TEL BCLS IL",
    "ShortName": "MTF TR TEL-BCLS IL",
    "Symbol": "TASE:5116918",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Tel Bond-CPI Linked SmallCap IL",
    "EnglishLongName": "MTF TR (00) Tel Bond-CPI Linked SmallCap IL",
    "HebrewName": "MTF מח‏ תלבונד צ יתר",
    "HebrewLongName": "MTF מחקה‏ (00) תל בונד צמודות יתר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.24,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 60.0,
    "MonthYield": 0.28,
    "YearYield": 0.28,
    "Last12MonthYield": 6.48,
    "ISIN": "IL0051169188"
  },
  {
    "Id": "TASE:5125372",
    "MayaId": "5125372",
    "Name": "MTF TR Tel Bond Sh 1 3 IL",
    "ShortName": "MTF TR Tel Bond-Sh 1-3 IL",
    "Symbol": "TASE:5125372",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Tel Bond-Shekel 1- 3 IL",
    "EnglishLongName": "MTF TR (00) Tel Bond-Shekel 1- 3 IL",
    "HebrewName": "MTF מח‏ תלבונד שקלי 1-3",
    "HebrewLongName": "MTF מחקה‏ (00) תל בונד-שקלי 1-3",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.21,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 201.5,
    "MonthYield": 0.67,
    "YearYield": 0.67,
    "Last12MonthYield": 4.9,
    "ISIN": "IL0051253727"
  },
  {
    "Id": "TASE:5127709",
    "MayaId": "5127709",
    "Name": "MTF TR Tel Bond Shekel IL",
    "ShortName": "MTF TR Tel Bond-Shekel IL",
    "Symbol": "TASE:5127709",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Tel Bond-Shekel IL",
    "EnglishLongName": "MTF TR (00) Tel Bond-Shekel IL",
    "HebrewName": "MTF מח תלבונד שקלי",
    "HebrewLongName": "MTF מחקה (00) תל בונד שקלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0.02,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 686.9,
    "MonthYield": 0.9,
    "YearYield": 0.9,
    "Last12MonthYield": 7.22,
    "ISIN": "IL0051277098"
  },
  {
    "Id": "TASE:5119151",
    "MayaId": "5119151",
    "Name": "MTF TR TEL COMP IL",
    "ShortName": "MTF TR TEL-COMP IL",
    "Symbol": "TASE:5119151",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (0A) Tel Bond-Composite IL",
    "EnglishLongName": "MTF TR (0A) Tel Bond-Composite IL",
    "HebrewName": "MTF מח‏ תלבונד מאגר",
    "HebrewLongName": "MTF מחקה‏ (0A) תל בונד מאגר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.17,
    "TrusteeFee": 0.015,
    "VariableFee": 0.02,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.23,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 172.7,
    "MonthYield": 0.51,
    "YearYield": 0.51,
    "Last12MonthYield": 6.7,
    "ISIN": "IL0051191513"
  },
  {
    "Id": "TASE:5133210",
    "MayaId": "5133210",
    "Name": "MTF TR TEL CPAA IL",
    "ShortName": "MTF TR TEL-CPAA IL",
    "Symbol": "TASE:5133210",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Tel Bond CPI Linked AA-AAA IL",
    "EnglishLongName": "MTF TR (00) Tel Bond CPI Linked AA-AAA IL",
    "HebrewName": "MTF מח תלבונד צמד AA-AAA",
    "HebrewLongName": "MTF מחקה (00) תל בונד-צמודות AA-AAA",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 361.8,
    "MonthYield": 0.27,
    "YearYield": 0.27,
    "Last12MonthYield": 6.99,
    "ISIN": "IL0051332109"
  },
  {
    "Id": "TASE:5137013",
    "MayaId": "5137013",
    "Name": "MTF TR TEL DIV IL",
    "ShortName": "MTF TR TEL-DIV IL",
    "Symbol": "TASE:5137013",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) Tel-Div IL",
    "EnglishLongName": "MTF TR (4A) Tel-Div IL",
    "HebrewName": "MTF מחקה תל-דיב",
    "HebrewLongName": "MTF מחקה (4A) תל-דיב",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.03,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.68,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 31.4,
    "MonthYield": 5.91,
    "YearYield": 5.91,
    "Last12MonthYield": 48.07,
    "ISIN": "IL0051370133"
  },
  {
    "Id": "TASE:5122320",
    "MayaId": "5122320",
    "Name": "MTF TR TEL NIS IL",
    "ShortName": "MTF TR TEL-NIS IL",
    "Symbol": "TASE:5122320",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00)(!) Tel Bond-Yield NIS IL",
    "EnglishLongName": "MTF TR (00)(!) Tel Bond-Yield NIS IL",
    "HebrewName": "MTF מח תלבונד תשו ש",
    "HebrewLongName": "MTF מחקה (00)(!) תל בונד תשואות שקל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 42.9,
    "MonthYield": 1.06,
    "YearYield": 1.06,
    "Last12MonthYield": 5.87,
    "ISIN": "IL0051223209"
  },
  {
    "Id": "TASE:5133202",
    "MayaId": "5133202",
    "Name": "MTF TR TEL SHAA IL",
    "ShortName": "MTF TR TEL-SHAA IL",
    "Symbol": "TASE:5133202",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Tel Bond Shekel AA-AAA IL",
    "EnglishLongName": "MTF TR (00) Tel Bond Shekel AA-AAA IL",
    "HebrewName": "MTF מח תלבונד שקל AA-AAA",
    "HebrewLongName": "MTF מחקה (00) תל בונד-שקלי AA-AAA",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.37,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 58.7,
    "MonthYield": 0.84,
    "YearYield": 0.84,
    "Last12MonthYield": 8.24,
    "ISIN": "IL0051332026"
  },
  {
    "Id": "TASE:5122635",
    "MayaId": "5122635",
    "Name": "MTF TR TEL YLD IL",
    "ShortName": "MTF TR TEL-YLD IL",
    "Symbol": "TASE:5122635",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00)(!) Tel - Bond Yields CPI Linked IL",
    "EnglishLongName": "MTF TR (00)(!) Tel - Bond Yields CPI Linked IL",
    "HebrewName": "MTF מח‏ תלבונד תשו צמודות",
    "HebrewLongName": "MTF מחקה (00)(!) תל - בונד תשואות צמודות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0.02,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 202.7,
    "MonthYield": 0.16,
    "YearYield": 0.16,
    "Last12MonthYield": 5.79,
    "ISIN": "IL0051226350"
  },
  {
    "Id": "TASE:5125984",
    "MayaId": "5125984",
    "Name": "MTF TR TelBond CPI 1 3 IL",
    "ShortName": "MTF TR TelBond-CPI 1-3 IL",
    "Symbol": "TASE:5125984",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Tel Bond-CPI Linked 1-3 IL",
    "EnglishLongName": "MTF TR (00) Tel Bond-CPI Linked 1-3 IL",
    "HebrewName": "MTF מח תל בונד-צמודות 1-3",
    "HebrewLongName": "MTF מחקה‏ (00) תל בונד-צמודות 1-3",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.18,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 428.4,
    "MonthYield": 0.17,
    "YearYield": 0.17,
    "Last12MonthYield": 4.86,
    "ISIN": "IL0051259849"
  },
  {
    "Id": "TASE:5127907",
    "MayaId": "5127907",
    "Name": "MTF TR TelBond Shek 50 IL",
    "ShortName": "MTF TR TelBond Shek 50 IL",
    "Symbol": "TASE:5127907",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Tel Bond Shekel 50 IL",
    "EnglishLongName": "MTF TR (00) Tel Bond Shekel 50 IL",
    "HebrewName": "MTF מח‏ תלבונד שקל 50",
    "HebrewLongName": "MTF מחקה (00) תל בונד שקלי 50",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0.02,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.37,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 387.9,
    "MonthYield": 0.91,
    "YearYield": 0.91,
    "Last12MonthYield": 8.12,
    "ISIN": "IL0051279078"
  },
  {
    "Id": "TASE:5139167",
    "MayaId": "5139167",
    "Name": "MTF TR TelBondSh A IL",
    "ShortName": "MTF TR TelBondSh A IL",
    "Symbol": "TASE:5139167",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (00) Tel Bond-Shekel A IL",
    "EnglishLongName": "MTF TR (00) Tel Bond-Shekel A IL",
    "HebrewName": "MTF מח תלבונד שקלי A",
    "HebrewLongName": "MTF מחקה (00) תל בונד - שקלי A",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 33.1,
    "MonthYield": 0.98,
    "YearYield": 0.98,
    "Last12MonthYield": null,
    "ISIN": "IL0051391675"
  },
  {
    "Id": "TASE:5140207",
    "MayaId": "5140207",
    "Name": "MTF TR US 2000 Profit HD",
    "ShortName": "MTF TR US 2000 Profit HD",
    "Symbol": "TASE:5140207",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) Indxx US 2000 Profitability Currency-Hedged",
    "EnglishLongName": "MTF TR (4A) Indxx US 2000 Profitability Currency-Hedged",
    "HebrewName": "MTF מח Indx US 2000Profממ",
    "HebrewLongName": "MTF מחקה (Indxx US 2000 Profitability (4A מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 15.7,
    "MonthYield": 6.01,
    "YearYield": 6.01,
    "Last12MonthYield": null,
    "ISIN": "IL0051402076"
  },
  {
    "Id": "TASE:5138433",
    "MayaId": "5138433",
    "Name": "MTF TR USANRN",
    "ShortName": "MTF TR USANRN",
    "Symbol": "TASE:5138433",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4D) Bloomberg US Analyst Recommendations",
    "EnglishLongName": "MTF TR (4D) Bloomberg US Analyst Recommendations",
    "HebrewName": "MTF מח BLBRG US AN RC",
    "HebrewLongName": "MTF מחקה (Bloomberg US Analyst Recommendations (4D",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.6,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 38.3,
    "MonthYield": 0.4,
    "YearYield": 0.4,
    "Last12MonthYield": -2.78,
    "ISIN": "IL0051384332"
  },
  {
    "Id": "TASE:5135108",
    "MayaId": "5135108",
    "Name": "MTF TR USANRN HD",
    "ShortName": "MTF TR USANRN HD",
    "Symbol": "TASE:5135108",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4A) Bloomberg US Analyst Recommendations Currency-Hedge",
    "EnglishLongName": "MTF TR (4A) Bloomberg US Analyst Recommendations Currency-Hedge",
    "HebrewName": "MTF מח BLBRG US AN RC ממ",
    "HebrewLongName": "MTF מחקה (Bloomberg US Analyst Recommendations (4A מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.77,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 618.7,
    "MonthYield": 1.8,
    "YearYield": 1.8,
    "Last12MonthYield": 11.1,
    "ISIN": "IL0051351083"
  },
  {
    "Id": "TASE:5140140",
    "MayaId": "5140140",
    "Name": "MTF TR WorldTop100iND HD",
    "ShortName": "MTF TR WorldTop100iND HD",
    "Symbol": "TASE:5140140",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF TR (4D) World Top 100 iNDEX USD-Hedged",
    "EnglishLongName": "MTF TR (4D) World Top 100 iNDEX USD-Hedged",
    "HebrewName": "MTF מח WorldTop100iND מד",
    "HebrewLongName": "MTF מחקה (World Top 100 iNDEX (4D מנוטרלת דולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.31,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Hedged Global Stocks",
    "AssetValue": 11.1,
    "MonthYield": 1.65,
    "YearYield": 1.65,
    "Last12MonthYield": null,
    "ISIN": "IL0051401409"
  },
  {
    "Id": "TASE:5127402",
    "MayaId": "5127402",
    "Name": "MTF.MTFECONT",
    "ShortName": "MTF.MTFECONT",
    "Symbol": "TASE:5127402",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MTF SAL (4D) Indxx US E-Commerce",
    "EnglishLongName": "MTF SAL (4D) Indxx US E-Commerce",
    "HebrewName": "MTF מחקה Indx US E-Com",
    "HebrewLongName": "MTF מחקה (Indxx US E-Commerce (4D",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.38,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MIGDAL MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 53.4,
    "MonthYield": -1.86,
    "YearYield": -1.86,
    "Last12MonthYield": -3.78,
    "ISIN": "IL0051274020"
  },
  {
    "Id": "TASE:5115795",
    "MayaId": "5115795",
    "Name": "MTV $ AD3 AKUV$",
    "ShortName": "MTV $ AD3 AKUV$",
    "Symbol": "TASE:5115795",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (0D) Money Market Fund Denominated in Dollar",
    "EnglishLongName": "MEITAV (0D) Money Market Fund Denominated in Dollar",
    "HebrewName": "מיטב כספית נקובה ב -$",
    "HebrewLongName": "מיטב (0D) כספית נקובה ב - $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.28,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.16,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "FX Money Market with Corporate",
    "AssetValue": 470.6,
    "MonthYield": -0.92,
    "YearYield": -0.92,
    "Last12MonthYield": -9.42,
    "ISIN": "IL0051157951"
  },
  {
    "Id": "TASE:5121694",
    "MayaId": "5121694",
    "Name": "MTV 90/10 FRN BD 30% FRCR",
    "ShortName": "MTV 90/10 FRN BD 30% FRCR",
    "Symbol": "TASE:5121694",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (1B)(!) 90/10 FOREIGN BOND PORTFOLIO UP TO 30% FOREIGN CURRENCY",
    "EnglishLongName": "MEITAV (1B)(!) 90/10 FOREIGN BOND PORTFOLIO UP TO 30% FOREIGN CURRENCY",
    "HebrewName": "מיטב 10/90 אגח חול 30 מטח",
    "HebrewLongName": "מיטב (1B)(!)י 10/90 תיק אג\"ח חו\"ל עד 30% מט\"ח.",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.29,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX-Protected Bonds",
    "AssetValue": 1003.4,
    "MonthYield": 0.51,
    "YearYield": 0.51,
    "Last12MonthYield": 9.53,
    "ISIN": "IL0051216948"
  },
  {
    "Id": "TASE:5108683",
    "MayaId": "5108683",
    "Name": "MTV AGC DOLLAR",
    "ShortName": "MTV AGC DOLLAR",
    "Symbol": "TASE:5108683",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Meitav(0D)(!)DOLLAR BONDS",
    "EnglishLongName": "Meitav(0D)(!)DOLLAR BONDS",
    "HebrewName": "מיטב 0D ! אג\"ח דולר",
    "HebrewLongName": "מיטב (0D) (!) אג\"ח דולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.09,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "Dollar Bond",
    "AssetValue": 452.7,
    "MonthYield": -1.13,
    "YearYield": -1.13,
    "Last12MonthYield": -5.94,
    "ISIN": "IL0051086838"
  },
  {
    "Id": "TASE:5121736",
    "MayaId": "5121736",
    "Name": "MTV FRGN STCK TO 30% FRCR",
    "ShortName": "MTV FRGN STCK TO 30% FRCR",
    "Symbol": "TASE:5121736",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (4B) FOREIGN STOCKS UP TO 30% FOREIGN CURRENCY",
    "EnglishLongName": "MEITAV (4B) FOREIGN STOCKS UP TO 30% FOREIGN CURRENCY",
    "HebrewName": "מיטב מניות חו\"ל עד 30% מט",
    "HebrewLongName": "מיטב (4B) מניות חו\"ל עד 30% מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.49,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.24,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 136.9,
    "MonthYield": 6.13,
    "YearYield": 6.13,
    "Last12MonthYield": 28.24,
    "ISIN": "IL0051217367"
  },
  {
    "Id": "TASE:5100672",
    "MayaId": "5100672",
    "Name": "MTV KASP$ RIBIT",
    "ShortName": "MTV KASP$ RIBIT",
    "Symbol": "TASE:5100672",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (0D) Dollar Money Market",
    "EnglishLongName": "MEITAV (0D) Dollar Money Market",
    "HebrewName": "מיטב כספית דולרית",
    "HebrewLongName": "מיטב (0D) כספית דולרית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.28,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.16,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "FX Money Market with Corporate",
    "AssetValue": 292.2,
    "MonthYield": -1.23,
    "YearYield": -1.23,
    "Last12MonthYield": -9.86,
    "ISIN": "IL0051006729"
  },
  {
    "Id": "TASE:5102207",
    "MayaId": "5102207",
    "Name": "MTV LONG RUN",
    "ShortName": "MTV LONG RUN",
    "Symbol": "TASE:5102207",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV (4D) LONG RUN",
    "EnglishLongName": "MEITAV (4D) LONG RUN",
    "HebrewName": "מיטב LONG RUN 4D",
    "HebrewLongName": "מיטב (LONG RUN (4D",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.48,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.56,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 333.9,
    "MonthYield": 5.93,
    "YearYield": 5.93,
    "Last12MonthYield": 42.58,
    "ISIN": "IL0051022072"
  },
  {
    "Id": "TASE:5120902",
    "MayaId": "5120902",
    "Name": "MTV OKV2HUL BNL",
    "ShortName": "MTV OKV2HUL BNL",
    "Symbol": "TASE:5120902",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Meitav (2D) Following Global Portfolio no 2 bank ben leumi",
    "EnglishLongName": "Meitav (2D) Following Global Portfolio no 2 bank ben leumi",
    "HebrewName": "מיטב 2D עוקבת 2 חול הבינל",
    "HebrewLongName": "מיטב (2D) עוקבת תיק 2 חו\"ל הבנק הבינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.97,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Bond",
    "AssetValue": 107.2,
    "MonthYield": -0.44,
    "YearYield": -0.44,
    "Last12MonthYield": -1.4,
    "ISIN": "IL0051209026"
  },
  {
    "Id": "TASE:5520044",
    "MayaId": "5520044",
    "Name": "MTV SKY HASHKAO",
    "ShortName": "MTV SKY HASHKAO",
    "Symbol": "TASE:5520044",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV SKY (4D) INVESTMENTS",
    "EnglishLongName": "MEITAV SKY (4D) INVESTMENTS",
    "HebrewName": "מיטב סקיי 4D השקעות",
    "HebrewLongName": "מיטב סקיי (4D) השקעות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.45,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 237.4,
    "MonthYield": 4.47,
    "YearYield": 4.47,
    "Last12MonthYield": 42.0,
    "ISIN": "IL0055200443"
  },
  {
    "Id": "TASE:5100961",
    "MayaId": "5100961",
    "Name": "MTV ZAHAV",
    "ShortName": "MTV ZAHAV",
    "Symbol": "TASE:5100961",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "MEITAV GOLD (5D)",
    "EnglishLongName": "MEITAV GOLD (5D)",
    "HebrewName": "מיטב 5D זהב",
    "HebrewLongName": "מיטב (5D) זהב",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.52,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks by Sectors - Foreign",
    "AssetValue": 59.8,
    "MonthYield": 5.55,
    "YearYield": 5.55,
    "Last12MonthYield": 52.42,
    "ISIN": "IL0051009616"
  },
  {
    "Id": "MRG.TA",
    "MayaId": "1171669",
    "Name": "MULTI RETAIL",
    "ShortName": "MULTI RETAIL GROUP LTD",
    "Symbol": "MRG.TA",
    "TaseSymbol": "MRG",
    "YahooId": "MRG.TA",
    "EnglishName": "MULTI RETAIL",
    "EnglishLongName": "MULTI RETAIL GROUP LTD",
    "HebrewName": "מולטי ריטייל",
    "HebrewLongName": "מולטי ריטייל גרופ בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 829.7,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 2.6,
    "YearYield": 2.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011716698"
  },
  {
    "Id": "MYDS.TA",
    "MayaId": "544015",
    "Name": "MYDAS",
    "ShortName": "MYDAS REAL ESTATE INVESTMENTS LTD",
    "Symbol": "MYDS.TA",
    "TaseSymbol": "MYDS",
    "YahooId": "MYDS.TA",
    "EnglishName": "MYDAS",
    "EnglishLongName": "MYDAS REAL ESTATE INVESTMENTS LTD",
    "HebrewName": "מידאס",
    "HebrewLongName": "מידאס השקעות בנדל\"ן בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 42.9,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 7.0,
    "YearYield": 7.0,
    "Last12MonthYield": null,
    "ISIN": "IL0005440156"
  },
  {
    "Id": "NFTA.TA",
    "MayaId": "643015",
    "Name": "NAPHTHA",
    "ShortName": "NAPHTHA ISRAEL PETROLEUM CORP. LTD.",
    "Symbol": "NFTA.TA",
    "TaseSymbol": "NFTA",
    "YahooId": "NFTA.TA",
    "EnglishName": "NAPHTHA",
    "EnglishLongName": "NAPHTHA ISRAEL PETROLEUM CORP. LTD.",
    "HebrewName": "נפטא",
    "HebrewLongName": "נפטא חברה ישראלית לנפט בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2611.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Energy And Oil & Gas Exploration",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.0,
    "YearYield": 0.0,
    "Last12MonthYield": null,
    "ISIN": "IL0006430156"
  },
  {
    "Id": "^IXIC",
    "MayaId": null,
    "Name": "Nasdaq",
    "ShortName": "Nasdaq",
    "Symbol": "^IXIC",
    "TaseSymbol": "",
    "YahooId": "^IXIC",
    "EnglishName": "Nasdaq",
    "EnglishLongName": "Nasdaq",
    "HebrewName": "נאסד\"ק",
    "HebrewLongName": "נאסד\"ק",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": null,
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": ""
  },
  {
    "Id": "^NDX",
    "MayaId": null,
    "Name": "Nasdaq 100",
    "ShortName": "Nasdaq 100",
    "Symbol": "^NDX",
    "TaseSymbol": "",
    "YahooId": "^NDX",
    "EnglishName": "Nasdaq 100",
    "EnglishLongName": "Nasdaq 100",
    "HebrewName": "נאסד\"ק 100",
    "HebrewLongName": "נאסד\"ק 100",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": null,
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": ""
  },
  {
    "Id": "NAWI.TA",
    "MayaId": "208017",
    "Name": "NAWI",
    "ShortName": "NAWI GROUP LTD",
    "Symbol": "NAWI.TA",
    "TaseSymbol": "NAWI",
    "YahooId": "NAWI.TA",
    "EnglishName": "NAWI",
    "EnglishLongName": "NAWI GROUP LTD",
    "HebrewName": "נאוי",
    "HebrewLongName": "נאוי גרופ בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5098.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Financial Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -3.3,
    "YearYield": -3.3,
    "Last12MonthYield": null,
    "ISIN": "IL0002080179"
  },
  {
    "Id": "NYAX.TA",
    "MayaId": "1175116",
    "Name": "NAYAX",
    "ShortName": "NAYAX LTD.",
    "Symbol": "NYAX.TA",
    "TaseSymbol": "NYAX",
    "YahooId": "NYAX.TA",
    "EnglishName": "NAYAX",
    "EnglishLongName": "NAYAX LTD.",
    "HebrewName": "נאייקס",
    "HebrewLongName": "נאייקס בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 18480.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 15.0,
    "YearYield": 15.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011751166"
  },
  {
    "Id": "NTGR.TA",
    "MayaId": "421016",
    "Name": "NETANEL GROUP",
    "ShortName": "NETANEL GROUP LTD.",
    "Symbol": "NTGR.TA",
    "TaseSymbol": "NTGR",
    "YahooId": "NTGR.TA",
    "EnglishName": "NETANEL GROUP",
    "EnglishLongName": "NETANEL GROUP LTD.",
    "HebrewName": "נתנאל גרופ",
    "HebrewLongName": "נתנאל גרופ בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1231.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 9.9,
    "YearYield": 9.9,
    "Last12MonthYield": null,
    "ISIN": "IL0004210162"
  },
  {
    "Id": "NTNB.TA",
    "MayaId": "1194513",
    "Name": "NETANEL MENIV",
    "ShortName": "NETANEL MENIVIM LTD",
    "Symbol": "NTNB.TA",
    "TaseSymbol": "NTNB",
    "YahooId": "NTNB.TA",
    "EnglishName": "NETANEL MENIV",
    "EnglishLongName": "NETANEL MENIVIM LTD",
    "HebrewName": "נתנאל מניבים",
    "HebrewLongName": "נתנאל מניבים בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 251.4,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 2.9,
    "YearYield": 2.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011945131"
  },
  {
    "Id": "NTO.TA",
    "MayaId": "168013",
    "Name": "NETO",
    "ShortName": "NETO M.E HOLDINGS LTD.",
    "Symbol": "NTO.TA",
    "TaseSymbol": "NTO",
    "YahooId": "NTO.TA",
    "EnglishName": "NETO",
    "EnglishLongName": "NETO M.E HOLDINGS LTD.",
    "HebrewName": "נטו אחזקות",
    "HebrewLongName": "נטו מ.ע. אחזקות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 25920.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 12.5,
    "YearYield": 12.5,
    "Last12MonthYield": null,
    "ISIN": "IL0001680136"
  },
  {
    "Id": "NTML.TA",
    "MayaId": "1105097",
    "Name": "NETO MALINDA",
    "ShortName": "NETO MALINDA TRADING LTD",
    "Symbol": "NTML.TA",
    "TaseSymbol": "NTML",
    "YahooId": "NTML.TA",
    "EnglishName": "NETO MALINDA",
    "EnglishLongName": "NETO MALINDA TRADING LTD",
    "HebrewName": "נטו מלינדה",
    "HebrewLongName": "נטו מלינדה סחר בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 17650.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 18.2,
    "YearYield": 18.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011050973"
  },
  {
    "Id": "NXSN.TA",
    "MayaId": "1176593",
    "Name": "NEXT VISION",
    "ShortName": "NEXT VISION STABILIZED SYSTEMS",
    "Symbol": "NXSN.TA",
    "TaseSymbol": "NXSN",
    "YahooId": "NXSN.TA",
    "EnglishName": "NEXT VISION",
    "EnglishLongName": "NEXT VISION STABILIZED SYSTEMS",
    "HebrewName": "נקסט ויז'ן",
    "HebrewLongName": "נקסט ויז'ן מערכות מיוצבות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 26020.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 26.7,
    "YearYield": 26.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011765935"
  },
  {
    "Id": "NXTG.TA",
    "MayaId": "433011",
    "Name": "NEXTAGE",
    "ShortName": "NEXTAGE THERAPEUTICS LTD",
    "Symbol": "NXTG.TA",
    "TaseSymbol": "NXTG",
    "YahooId": "NXTG.TA",
    "EnglishName": "NEXTAGE",
    "EnglishLongName": "NEXTAGE THERAPEUTICS LTD",
    "HebrewName": "נקסטייג'",
    "HebrewLongName": "נקסטייג' תראפיוטיקס בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 77.9,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.0,
    "YearYield": 0.0,
    "Last12MonthYield": null,
    "ISIN": "IL0004330119"
  },
  {
    "Id": "NXTM.TA",
    "MayaId": "1095785",
    "Name": "NEXTCOM",
    "ShortName": "NEXTCOM LTD",
    "Symbol": "NXTM.TA",
    "TaseSymbol": "NXTM",
    "YahooId": "NXTM.TA",
    "EnglishName": "NEXTCOM",
    "EnglishLongName": "NEXTCOM LTD",
    "HebrewName": "נקסטקום",
    "HebrewLongName": "נקסטקום בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 774.6,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 10.0,
    "YearYield": 10.0,
    "Last12MonthYield": null,
    "ISIN": "IL0010957855"
  },
  {
    "Id": "NXFR.M.TA",
    "MayaId": "1171933",
    "Name": "NEXTFERM M",
    "ShortName": "NEXTFERM TECHNOLOGIES LTD",
    "Symbol": "NXFR.M.TA",
    "TaseSymbol": "NXFR.M",
    "YahooId": "NXFR.M.TA",
    "EnglishName": "NEXTFERM-M",
    "EnglishLongName": "NEXTFERM TECHNOLOGIES LTD",
    "HebrewName": "נקסטפרם-ש",
    "HebrewLongName": "נקסטפרם טכנולוגיות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1800.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Investment & Holdings",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -21.1,
    "YearYield": -21.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011719338"
  },
  {
    "Id": "NXGN-M.TA",
    "MayaId": "1083930",
    "Name": "NEXTGEN M",
    "ShortName": "NEXTGEN BIOMED LTD",
    "Symbol": "NXGN-M.TA",
    "TaseSymbol": "NXGN-M",
    "YahooId": "NXGN-M.TA",
    "EnglishName": "NEXTGEN-M",
    "EnglishLongName": "NEXTGEN BIOMED LTD",
    "HebrewName": "נקסט ג'ן-ש",
    "HebrewLongName": "נקסט ג'ן ביומד בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 54.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Investment & Holdings",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.6,
    "YearYield": 0.6,
    "Last12MonthYield": null,
    "ISIN": "IL0010839301"
  },
  {
    "Id": "NICE.TA",
    "MayaId": "273011",
    "Name": "NICE",
    "ShortName": "NICE LTD",
    "Symbol": "NICE.TA",
    "TaseSymbol": "NICE",
    "YahooId": "NICE.TA",
    "EnglishName": "NICE",
    "EnglishLongName": "NICE LTD",
    "HebrewName": "נייס",
    "HebrewLongName": "נייס בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 34560.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -3.3,
    "YearYield": -3.3,
    "Last12MonthYield": null,
    "ISIN": "IL0002730112"
  },
  {
    "Id": "NISA.TA",
    "MayaId": "660019",
    "Name": "NISSAN",
    "ShortName": "NISSAN MEDICAL INDUSTRIES LTD.",
    "Symbol": "NISA.TA",
    "TaseSymbol": "NISA",
    "YahooId": "NISA.TA",
    "EnglishName": "NISSAN",
    "EnglishLongName": "NISSAN MEDICAL INDUSTRIES LTD.",
    "HebrewName": "ניסן",
    "HebrewLongName": "ניסן תעשיות רפואיות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 931.5,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.6,
    "YearYield": 1.6,
    "Last12MonthYield": null,
    "ISIN": "IL0006600196"
  },
  {
    "Id": "NOFR.TA",
    "MayaId": "1170877",
    "Name": "NOFAR ENERGY",
    "ShortName": "O.Y. NOFAR ENERGY LTD",
    "Symbol": "NOFR.TA",
    "TaseSymbol": "NOFR",
    "YahooId": "NOFR.TA",
    "EnglishName": "NOFAR ENERGY",
    "EnglishLongName": "O.Y. NOFAR ENERGY LTD",
    "HebrewName": "נופר אנרג'י",
    "HebrewLongName": "ע.י. נופר אנרג'י בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 14230.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 29.4,
    "YearYield": 29.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011708778"
  },
  {
    "Id": "TASE:705",
    "MayaId": "705",
    "Name": "Non Linked, Floating Int. Gov. Bonds, 0 5 Years",
    "ShortName": "Non-Linked, Floating Int. Gov. Bonds, 0-5 Years",
    "Symbol": "TASE:705",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Non Linked, Floating Int. Gov. Bonds, 0 5 Years",
    "EnglishLongName": "Non-Linked, Floating Int. Gov. Bonds, 0-5 Years",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "NSTR.TA",
    "MayaId": "723007",
    "Name": "NORSTAR",
    "ShortName": "NORSTAR HOLDINGS INC",
    "Symbol": "NSTR.TA",
    "TaseSymbol": "NSTR",
    "YahooId": "NSTR.TA",
    "EnglishName": "NORSTAR",
    "EnglishLongName": "NORSTAR HOLDINGS INC",
    "HebrewName": "נורסטאר",
    "HebrewLongName": "נורסטאר החזקות אינק",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 730.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 13.8,
    "YearYield": 13.8,
    "Last12MonthYield": null,
    "ISIN": "PAL0605071A3"
  },
  {
    "Id": "NVMI.TA",
    "MayaId": "1084557",
    "Name": "NOVA",
    "ShortName": "NOVA LTD",
    "Symbol": "NVMI.TA",
    "TaseSymbol": "NVMI",
    "YahooId": "NVMI.TA",
    "EnglishName": "NOVA",
    "EnglishLongName": "NOVA LTD",
    "HebrewName": "נובה",
    "HebrewLongName": "נובה בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 136540.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 30.6,
    "YearYield": 30.6,
    "Last12MonthYield": null,
    "ISIN": "IL0010845571"
  },
  {
    "Id": "NVLG.TA",
    "MayaId": "1140151",
    "Name": "NOVOLOG",
    "ShortName": "NOVOLOG (PHARM-UP 1966) LTD",
    "Symbol": "NVLG.TA",
    "TaseSymbol": "NVLG",
    "YahooId": "NVLG.TA",
    "EnglishName": "NOVOLOG",
    "EnglishLongName": "NOVOLOG (PHARM-UP 1966) LTD",
    "HebrewName": "נובולוג",
    "HebrewLongName": "נובולוג (פארם אפ 1966) בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 127.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 2.3,
    "YearYield": 2.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011401515"
  },
  {
    "Id": "NRGN.TA",
    "MayaId": "1172071",
    "Name": "NRGENE",
    "ShortName": "NRGENE TECHNOLOGIES LTD",
    "Symbol": "NRGN.TA",
    "TaseSymbol": "NRGN",
    "YahooId": "NRGN.TA",
    "EnglishName": "NRGENE",
    "EnglishLongName": "NRGENE TECHNOLOGIES LTD",
    "HebrewName": "אנרג'ין",
    "HebrewLongName": "אנרג'ין טכנולוגיות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 223.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 9.6,
    "YearYield": 9.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011720716"
  },
  {
    "Id": "NURI.TA",
    "MayaId": "1175728",
    "Name": "NUR",
    "ShortName": "NUR INK INNOVATIONS LTD",
    "Symbol": "NURI.TA",
    "TaseSymbol": "NURI",
    "YahooId": "NURI.TA",
    "EnglishName": "NUR",
    "EnglishLongName": "NUR INK INNOVATIONS LTD",
    "HebrewName": "נור",
    "HebrewLongName": "נור אינק אינוביישנס בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1489.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 12.8,
    "YearYield": 12.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011757288"
  },
  {
    "Id": "ORTC.TA",
    "MayaId": "1086230",
    "Name": "O.R.T.",
    "ShortName": "O.R.T TECHNOLOGIES LTD.",
    "Symbol": "ORTC.TA",
    "TaseSymbol": "ORTC",
    "YahooId": "ORTC.TA",
    "EnglishName": "O.R.T.",
    "EnglishLongName": "O.R.T TECHNOLOGIES LTD.",
    "HebrewName": "או.אר.טי",
    "HebrewLongName": "או.אר.טי.טכנולוגיות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 996.5,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 25.7,
    "YearYield": 25.7,
    "Last12MonthYield": null,
    "ISIN": "IL0010862303"
  },
  {
    "Id": "TASE:5120001",
    "MayaId": "5120001",
    "Name": "Ocean Bond Without Stocks",
    "ShortName": "Ocean Bond Without Stocks",
    "Symbol": "TASE:5120001",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ocean Yetsira (0B)(!) Bond Portfolio Without Stocks IL",
    "EnglishLongName": "Ocean Yetsira (0B)(!) Bond Portfolio Without Stocks IL",
    "HebrewName": "אושן תיק אג\"ח ללא מניות",
    "HebrewLongName": "אושן יצירה (0B)(!) תיק אג\"ח ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 275.0,
    "MonthYield": 0.51,
    "YearYield": 0.51,
    "Last12MonthYield": 5.18,
    "ISIN": "IL0051200017"
  },
  {
    "Id": "TASE:5119987",
    "MayaId": "5119987",
    "Name": "Ocean Equity Portfolio",
    "ShortName": "Ocean Equity Portfolio",
    "Symbol": "TASE:5119987",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ocean Yetsira (4B) Equity Portfolio IL",
    "EnglishLongName": "Ocean Yetsira (4B) Equity Portfolio IL",
    "HebrewName": "אושן תיק מניות",
    "HebrewLongName": "אושן יצירה (4B) תיק מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.85,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.7,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 71.9,
    "MonthYield": 4.98,
    "YearYield": 4.98,
    "Last12MonthYield": 44.51,
    "ISIN": "IL0051199870"
  },
  {
    "Id": "TASE:5119995",
    "MayaId": "5119995",
    "Name": "Ocean Flexible",
    "ShortName": "Ocean Flexible",
    "Symbol": "TASE:5119995",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ocean Yetsira (4D) Flexible",
    "EnglishLongName": "Ocean Yetsira (4D) Flexible",
    "HebrewName": "אושן גמישה",
    "HebrewLongName": "אושן יצירה (4D)י גמישה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.85,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.2,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 35.7,
    "MonthYield": 4.64,
    "YearYield": 4.64,
    "Last12MonthYield": 13.24,
    "ISIN": "IL0051199953"
  },
  {
    "Id": "TASE:5124268",
    "MayaId": "5124268",
    "Name": "Ocean Global Equity",
    "ShortName": "Ocean Global Equity",
    "Symbol": "TASE:5124268",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ocean Yetsira (4D) Global Equity",
    "EnglishLongName": "Ocean Yetsira (4D) Global Equity",
    "HebrewName": "אושן גלובל אקוויטי",
    "HebrewLongName": "אושן יצירה (4D) גלובל אקוויטי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.85,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.75,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 32.0,
    "MonthYield": 2.89,
    "YearYield": 2.89,
    "Last12MonthYield": 3.05,
    "ISIN": "IL0051242688"
  },
  {
    "Id": "TASE:5119979",
    "MayaId": "5119979",
    "Name": "Ocean Yetsira (1A) 90/10",
    "ShortName": "Ocean Yetsira (1A) 90/10",
    "Symbol": "TASE:5119979",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ocean Yetsira (1A) 90/10 IL",
    "EnglishLongName": "Ocean Yetsira (1A) 90/10 IL",
    "HebrewName": "אושן 10/90",
    "HebrewLongName": "אושן יצירה (1A)י 10/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.74,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.4,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 99.1,
    "MonthYield": 1.13,
    "YearYield": 1.13,
    "Last12MonthYield": 8.8,
    "ISIN": "IL0051199797"
  },
  {
    "Id": "TASE:5123666",
    "MayaId": "5123666",
    "Name": "Ocean Yetsira (2B) 20/80",
    "ShortName": "Ocean Yetsira (2B) 20/80",
    "Symbol": "TASE:5123666",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ocean Yetsira (2B) 20/80 IL",
    "EnglishLongName": "Ocean Yetsira (2B) 20/80 IL",
    "HebrewName": "אושן 20/80",
    "HebrewLongName": "אושן יצירה (2B)י 20/80",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.82,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.43,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 808.6,
    "MonthYield": 1.25,
    "YearYield": 1.25,
    "Last12MonthYield": 9.33,
    "ISIN": "IL0051236664"
  },
  {
    "Id": "TASE:5124227",
    "MayaId": "5124227",
    "Name": "Ocean Yetsira (2B) 70/30",
    "ShortName": "Ocean Yetsira (2B) 70/30",
    "Symbol": "TASE:5124227",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ocean Yetsira (2B) 70/30 IL",
    "EnglishLongName": "Ocean Yetsira (2B) 70/30 IL",
    "HebrewName": "אושן 30/70",
    "HebrewLongName": "אושן יצירה (2B)י 30/70",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.85,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.43,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 373.4,
    "MonthYield": 1.5,
    "YearYield": 1.5,
    "Last12MonthYield": 10.87,
    "ISIN": "IL0051242274"
  },
  {
    "Id": "TASE:127",
    "MayaId": "127",
    "Name": "Oil & Gas Exploration Shares and Convertibles",
    "ShortName": "Oil & Gas Exploration Shares and Convertibles",
    "Symbol": "TASE:127",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Oil & Gas Exploration Shares and Convertibles",
    "EnglishLongName": "Oil & Gas Exploration Shares and Convertibles",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "OMCN.TA",
    "MayaId": "1233493",
    "Name": "OMER CONS",
    "ShortName": "OMER CONSTRUCTION AND ENGINEERING LTD",
    "Symbol": "OMCN.TA",
    "TaseSymbol": "OMCN",
    "YahooId": "OMCN.TA",
    "EnglishName": "OMER CONS",
    "EnglishLongName": "OMER CONSTRUCTION AND ENGINEERING LTD",
    "HebrewName": "עומר הנדסה",
    "HebrewLongName": "עומר הנדסה ובניה (1986) בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1293.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 6.7,
    "YearYield": 6.7,
    "Last12MonthYield": null,
    "ISIN": "IL0012334939"
  },
  {
    "Id": "ONE.TA",
    "MayaId": "161018",
    "Name": "ONE TECHNOLOGI",
    "ShortName": "ONE SOFTWARE TECHNOLOGIES LTD",
    "Symbol": "ONE.TA",
    "TaseSymbol": "ONE",
    "YahooId": "ONE.TA",
    "EnglishName": "ONE TECHNOLOGI",
    "EnglishLongName": "ONE SOFTWARE TECHNOLOGIES LTD",
    "HebrewName": "וואן טכנולוגיות",
    "HebrewLongName": "וואן טכנולוגיות תוכנה בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 9344.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 8.9,
    "YearYield": 8.9,
    "Last12MonthYield": null,
    "ISIN": "IL0001610182"
  },
  {
    "Id": "OPAL.TA",
    "MayaId": "1094986",
    "Name": "OPAL BALANCE",
    "ShortName": "OPAL BALANCE INVESTMENTS LTD",
    "Symbol": "OPAL.TA",
    "TaseSymbol": "OPAL",
    "YahooId": "OPAL.TA",
    "EnglishName": "OPAL BALANCE",
    "EnglishLongName": "OPAL BALANCE INVESTMENTS LTD",
    "HebrewName": "אופל בלאנס",
    "HebrewLongName": "אופל בלאנס השקעות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 403.4,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Financial Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 10.3,
    "YearYield": 10.3,
    "Last12MonthYield": null,
    "ISIN": "IL0010949860"
  },
  {
    "Id": "OPCE.TA",
    "MayaId": "1141571",
    "Name": "OPC ENERGY",
    "ShortName": "OPC ENERGY LTD",
    "Symbol": "OPCE.TA",
    "TaseSymbol": "OPCE",
    "YahooId": "OPCE.TA",
    "EnglishName": "OPC ENERGY",
    "EnglishLongName": "OPC ENERGY LTD",
    "HebrewName": "או פי סי אנרגיה",
    "HebrewLongName": "או.פי.סי אנרגיה בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 7460.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Energy And Oil & Gas Exploration",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -0.8,
    "YearYield": -0.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011415713"
  },
  {
    "Id": "OPK.TA",
    "MayaId": "1129543",
    "Name": "OPKO HEALTH",
    "ShortName": "OPKO HEALTH,INC.",
    "Symbol": "OPK.TA",
    "TaseSymbol": "OPK",
    "YahooId": "OPK.TA",
    "EnglishName": "OPKO HEALTH",
    "EnglishLongName": "OPKO HEALTH,INC.",
    "HebrewName": "אופקו הלת'",
    "HebrewLongName": "אופקו הלת', אינק",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 405.4,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -0.5,
    "YearYield": -0.5,
    "Last12MonthYield": null,
    "ISIN": "US68375N1037"
  },
  {
    "Id": "ORAD.TA",
    "MayaId": "1104496",
    "Name": "ORAD",
    "ShortName": "ORAD LTD",
    "Symbol": "ORAD.TA",
    "TaseSymbol": "ORAD",
    "YahooId": "ORAD.TA",
    "EnglishName": "ORAD",
    "EnglishLongName": "ORAD LTD",
    "HebrewName": "אורד",
    "HebrewLongName": "אורד בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 149.9,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Investment & Holdings",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 4.3,
    "YearYield": 4.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011044968"
  },
  {
    "Id": "ORMP.TA",
    "MayaId": "1141324",
    "Name": "ORAMED PHARM",
    "ShortName": "ORAMED PHARMACEUTICALS INC.",
    "Symbol": "ORMP.TA",
    "TaseSymbol": "ORMP",
    "YahooId": "ORMP.TA",
    "EnglishName": "ORAMED PHARM",
    "EnglishLongName": "ORAMED PHARMACEUTICALS INC.",
    "HebrewName": "אורמד פארמ",
    "HebrewLongName": "אורמד פארמסוטיקלס אינק.",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1118.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 33.4,
    "YearYield": 33.4,
    "Last12MonthYield": null,
    "ISIN": "US68403P2039"
  },
  {
    "Id": "ORBI.TA",
    "MayaId": "265017",
    "Name": "ORBIT",
    "ShortName": "ORBIT TECHNOLOGIES LTD.",
    "Symbol": "ORBI.TA",
    "TaseSymbol": "ORBI",
    "YahooId": "ORBI.TA",
    "EnglishName": "ORBIT",
    "EnglishLongName": "ORBIT TECHNOLOGIES LTD.",
    "HebrewName": "אורביט",
    "HebrewLongName": "אורביט טכנולוג'יס בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4152.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.5,
    "YearYield": 1.5,
    "Last12MonthYield": null,
    "ISIN": "IL0002650179"
  },
  {
    "Id": "ORIN.TA",
    "MayaId": "1103506",
    "Name": "ORIAN",
    "ShortName": "ORIAN SH.M. LTD.",
    "Symbol": "ORIN.TA",
    "TaseSymbol": "ORIN",
    "YahooId": "ORIN.TA",
    "EnglishName": "ORIAN",
    "EnglishLongName": "ORIAN SH.M. LTD.",
    "HebrewName": "אוריין",
    "HebrewLongName": "אוריין ש.מ. בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2881.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 10.3,
    "YearYield": 10.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011035065"
  },
  {
    "Id": "ORNP.TA",
    "MayaId": "1232750",
    "Name": "ORION",
    "ShortName": "ORION RETAIL PROPERTIES LTD",
    "Symbol": "ORNP.TA",
    "TaseSymbol": "ORNP",
    "YahooId": "ORNP.TA",
    "EnglishName": "ORION",
    "EnglishLongName": "ORION RETAIL PROPERTIES LTD",
    "HebrewName": "אוריון",
    "HebrewLongName": "אוריון נכסים מסחריים בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 256.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -6.0,
    "YearYield": -6.0,
    "Last12MonthYield": null,
    "ISIN": "IL0012327503"
  },
  {
    "Id": "ORA.TA",
    "MayaId": "1134402",
    "Name": "ORMAT TECHNO",
    "ShortName": "ORMAT TECHNOLOGIES,INC",
    "Symbol": "ORA.TA",
    "TaseSymbol": "ORA",
    "YahooId": "ORA.TA",
    "EnglishName": "ORMAT TECHNO",
    "EnglishLongName": "ORMAT TECHNOLOGIES,INC",
    "HebrewName": "אורמת טכנו",
    "HebrewLongName": "אורמת טכנולוגיות, אינק",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 37300.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 7.2,
    "YearYield": 7.2,
    "Last12MonthYield": null,
    "ISIN": "US6866881021"
  },
  {
    "Id": "ORON.TA",
    "MayaId": "1135706",
    "Name": "ORON GROUP",
    "ShortName": "ORON GROUP INVESTMENTS & HOLDINGS LTD",
    "Symbol": "ORON.TA",
    "TaseSymbol": "ORON",
    "YahooId": "ORON.TA",
    "EnglishName": "ORON GROUP",
    "EnglishLongName": "ORON GROUP INVESTMENTS & HOLDINGS LTD",
    "HebrewName": "אורון קבוצה",
    "HebrewLongName": "קבוצת אורון אחזקות והשקעות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1849.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 36.6,
    "YearYield": 36.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011357063"
  },
  {
    "Id": "OVRS.TA",
    "MayaId": "1139617",
    "Name": "OVERSEAS",
    "ShortName": "OVERSEAS COMMERCE LTD.",
    "Symbol": "OVRS.TA",
    "TaseSymbol": "OVRS",
    "YahooId": "OVRS.TA",
    "EnglishName": "OVERSEAS",
    "EnglishLongName": "OVERSEAS COMMERCE LTD.",
    "HebrewName": "אוברסיז",
    "HebrewLongName": "אוברסיז קומרס בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 573.8,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -3.6,
    "YearYield": -3.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011396178"
  },
  {
    "Id": "PCBT.TA",
    "MayaId": "1091685",
    "Name": "P.C.B TEC",
    "ShortName": "P.C.B. TECHNOLOGIES LTD.",
    "Symbol": "PCBT.TA",
    "TaseSymbol": "PCBT",
    "YahooId": "PCBT.TA",
    "EnglishName": "P.C.B TEC",
    "EnglishLongName": "P.C.B. TECHNOLOGIES LTD.",
    "HebrewName": "פיסיבי טכנ",
    "HebrewLongName": "פי.סי.בי. טכנולוגיות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1525.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 17.8,
    "YearYield": 17.8,
    "Last12MonthYield": null,
    "ISIN": "IL0010916851"
  },
  {
    "Id": "PLRM.TA",
    "MayaId": "644013",
    "Name": "PALRAM",
    "ShortName": "PALRAM INDUSTRIES (1990) LTD.",
    "Symbol": "PLRM.TA",
    "TaseSymbol": "PLRM",
    "YahooId": "PLRM.TA",
    "EnglishName": "PALRAM",
    "EnglishLongName": "PALRAM INDUSTRIES (1990) LTD.",
    "HebrewName": "פלרם",
    "HebrewLongName": "פלרם (1990) תעשיות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5448.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 4.9,
    "YearYield": 4.9,
    "Last12MonthYield": null,
    "ISIN": "IL0006440130"
  },
  {
    "Id": "PRKM.TA",
    "MayaId": "1187640",
    "Name": "PARKOMAT",
    "ShortName": "PARKOMAT INTERNATIONAL LTD",
    "Symbol": "PRKM.TA",
    "TaseSymbol": "PRKM",
    "YahooId": "PRKM.TA",
    "EnglishName": "PARKOMAT",
    "EnglishLongName": "PARKOMAT INTERNATIONAL LTD",
    "HebrewName": "פרקומט",
    "HebrewLongName": "פרקומט אינטרנשיונל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 485.8,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 11.1,
    "YearYield": 11.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011876401"
  },
  {
    "Id": "PTNR.TA",
    "MayaId": "1083484",
    "Name": "PARTNER",
    "ShortName": "PARTNER COMMUNICATIONS COMPANY LTD.",
    "Symbol": "PTNR.TA",
    "TaseSymbol": "PTNR",
    "YahooId": "PTNR.TA",
    "EnglishName": "PARTNER",
    "EnglishLongName": "PARTNER COMMUNICATIONS COMPANY LTD.",
    "HebrewName": "פרטנר",
    "HebrewLongName": "חברת פרטנר תקשורת בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3545.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -2.8,
    "YearYield": -2.8,
    "Last12MonthYield": null,
    "ISIN": "IL0010834849"
  },
  {
    "Id": "TASE:5134226",
    "MayaId": "5134226",
    "Name": "Pasternak Bnds No Stk IL",
    "ShortName": "Pasternak Bnds No Stk IL",
    "Symbol": "TASE:5134226",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Pasternak Shoham (0B) General Bond No Stocks IL",
    "EnglishLongName": "Pasternak Shoham (0B) General Bond No Stocks IL",
    "HebrewName": "פסטרנק אגח ללא מניות",
    "HebrewLongName": "פסטרנק שהם (0B) אג\"ח כללי ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 241.7,
    "MonthYield": 0.61,
    "YearYield": 0.61,
    "Last12MonthYield": 5.7,
    "ISIN": "IL0051342264"
  },
  {
    "Id": "TASE:5125463",
    "MayaId": "5125463",
    "Name": "PASTERNAK CORP NO STKS IL",
    "ShortName": "PASTERNAK CORP NO STKS IL",
    "Symbol": "TASE:5125463",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "PASTERNAK SHOAM (0A)(!) CORPORATE BONDS EQUITY FREE IL",
    "EnglishLongName": "PASTERNAK SHOAM (0A)(!) CORPORATE BONDS EQUITY FREE IL",
    "HebrewName": "פסטרנק אגח חברות ללא מנ",
    "HebrewLongName": "פסטרנק שהם (A0)(!) אג\"ח חברות ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.85,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 822.0,
    "MonthYield": 0.55,
    "YearYield": 0.55,
    "Last12MonthYield": 5.35,
    "ISIN": "IL0051254634"
  },
  {
    "Id": "TASE:5137476",
    "MayaId": "5137476",
    "Name": "Pasternak Shoahm BndNoEqu",
    "ShortName": "Pasternak Shoahm BndNoEqu",
    "Symbol": "TASE:5137476",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Pasternak Shoahm (0B)(!) Bonds Without Equity IL",
    "EnglishLongName": "Pasternak Shoahm (0B)(!) Bonds Without Equity IL",
    "HebrewName": "פסטרנק שהם אג\"ח ללא מניות",
    "HebrewLongName": "פסטרנק שהם (0B)(!) אג\"ח ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.0,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.37,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 375.0,
    "MonthYield": 0.7,
    "YearYield": 0.7,
    "Last12MonthYield": 5.47,
    "ISIN": "IL0051374762"
  },
  {
    "Id": "TASE:5130810",
    "MayaId": "5130810",
    "Name": "PASTERNAK SHOHAM 30/70 IL",
    "ShortName": "PASTERNAK SHOHAM 30/70 IL",
    "Symbol": "TASE:5130810",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "PASTERNAK SHOHAM (2B) 30/70 IL",
    "EnglishLongName": "PASTERNAK SHOHAM (2B) 30/70 IL",
    "HebrewName": "פסטרנק שהם 30/70",
    "HebrewLongName": "פסטרנק שהם (2B)י 30/70",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.78,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.48,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 803.7,
    "MonthYield": 1.3,
    "YearYield": 1.3,
    "Last12MonthYield": 16.2,
    "ISIN": "IL0051308109"
  },
  {
    "Id": "TASE:5140553",
    "MayaId": "5140553",
    "Name": "Pasternak Shoham 75/25 IL",
    "ShortName": "Pasternak Shoham 75/25 IL",
    "Symbol": "TASE:5140553",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Pasternak Shoham (2B) 75/25 IL",
    "EnglishLongName": "Pasternak Shoham (2B) 75/25 IL",
    "HebrewName": "פסטרנק שהם 25/75",
    "HebrewLongName": "פסטרנק שהם (2B)י 25/75",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 25% Equity",
    "AssetValue": 11.0,
    "MonthYield": 1.54,
    "YearYield": 1.54,
    "Last12MonthYield": null,
    "ISIN": "IL0051405533"
  },
  {
    "Id": "TASE:5134234",
    "MayaId": "5134234",
    "Name": "Pasternak Shoham 80/20 IL",
    "ShortName": "Pasternak Shoham 80/20 IL",
    "Symbol": "TASE:5134234",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Pasternak Shoham (2B) 80/20 IL",
    "EnglishLongName": "Pasternak Shoham (2B) 80/20 IL",
    "HebrewName": "פסטרנק שהם 20/80",
    "HebrewLongName": "פסטרנק שהם (2B)י 20/80",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.78,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.4,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 448.1,
    "MonthYield": 1.18,
    "YearYield": 1.18,
    "Last12MonthYield": 13.84,
    "ISIN": "IL0051342348"
  },
  {
    "Id": "TASE:5136080",
    "MayaId": "5136080",
    "Name": "Pasternak Shoham 85/15 IL",
    "ShortName": "Pasternak Shoham 85/15 IL",
    "Symbol": "TASE:5136080",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Pasternak Shoham (2B) 85/15 IL",
    "EnglishLongName": "Pasternak Shoham (2B) 85/15 IL",
    "HebrewName": "פסטרנק שהם 15/85",
    "HebrewLongName": "פסטרנק שהם (2B)י 15/85",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 15% Equity",
    "AssetValue": 75.2,
    "MonthYield": 1.08,
    "YearYield": 1.08,
    "Last12MonthYield": 12.06,
    "ISIN": "IL0051360803"
  },
  {
    "Id": "TASE:5132204",
    "MayaId": "5132204",
    "Name": "PASTERNAK SHOHAM 90/10 IL",
    "ShortName": "PASTERNAK SHOHAM 90/10 IL",
    "Symbol": "TASE:5132204",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "PASTERNAK SHOHAM (1B)(!) 90/10 IL",
    "EnglishLongName": "PASTERNAK SHOHAM (1B)(!) 90/10 IL",
    "HebrewName": "פסטרנק שהם 10/90",
    "HebrewLongName": "פסטרנק שהם (1B)(!)י 10/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.73,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.31,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 271.7,
    "MonthYield": 0.88,
    "YearYield": 0.88,
    "Last12MonthYield": 9.96,
    "ISIN": "IL0051322043"
  },
  {
    "Id": "TASE:5137765",
    "MayaId": "5137765",
    "Name": "Pasternak Shoham 90/10 IL",
    "ShortName": "Pasternak Shoham 90/10 IL",
    "Symbol": "TASE:5137765",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Pasternak Shoham (1B) 90/10 IL",
    "EnglishLongName": "Pasternak Shoham (1B) 90/10 IL",
    "HebrewName": "פסטרנק שהם 10/90",
    "HebrewLongName": "פסטרנק שהם (1B)י 10/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 86.5,
    "MonthYield": 0.99,
    "YearYield": 0.99,
    "Last12MonthYield": 10.35,
    "ISIN": "IL0051377658"
  },
  {
    "Id": "TASE:5127576",
    "MayaId": "5127576",
    "Name": "Pasternak Shoham Eqt IL",
    "ShortName": "Pasternak Shoham Eqt IL",
    "Symbol": "TASE:5127576",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Pasternak Shoham (4B) Equity IL",
    "EnglishLongName": "Pasternak Shoham (4B) Equity IL",
    "HebrewName": "פסטרנק שהם (4B) מניות",
    "HebrewLongName": "פסטרנק שהם (4B) מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.75,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.81,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 2179.8,
    "MonthYield": 5.45,
    "YearYield": 5.45,
    "Last12MonthYield": 55.23,
    "ISIN": "IL0051275761"
  },
  {
    "Id": "TASE:5136098",
    "MayaId": "5136098",
    "Name": "Pasternak Shoham MC St IL",
    "ShortName": "Pasternak Shoham MC St IL",
    "Symbol": "TASE:5136098",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Pasternak Shoham (4B) Israel Mid Cap Stocks IL",
    "EnglishLongName": "Pasternak Shoham (4B) Israel Mid Cap Stocks IL",
    "HebrewName": "פסטרנק שהם מ MidCap ישראל",
    "HebrewLongName": "פסטרנק שהם (4B) מניות Mid Cap ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.55,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.19,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 265.1,
    "MonthYield": 3.37,
    "YearYield": 3.37,
    "Last12MonthYield": 51.97,
    "ISIN": "IL0051360985"
  },
  {
    "Id": "PMNT.TA",
    "MayaId": "1180876",
    "Name": "PAYMENT FINA",
    "ShortName": "PAYMENT FINANCIAL TECHNOLOGIES LTD",
    "Symbol": "PMNT.TA",
    "TaseSymbol": "PMNT",
    "YahooId": "PMNT.TA",
    "EnglishName": "PAYMENT FINA",
    "EnglishLongName": "PAYMENT FINANCIAL TECHNOLOGIES LTD",
    "HebrewName": "פיימנט",
    "HebrewLongName": "פיימנט טכנולוגיות פיננסיות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 655.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 13.0,
    "YearYield": 13.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011808768"
  },
  {
    "Id": "PAYT.TA",
    "MayaId": "412015",
    "Name": "PAYTON",
    "ShortName": "PAYTON INDUSTRIES LTD.",
    "Symbol": "PAYT.TA",
    "TaseSymbol": "PAYT",
    "YahooId": "PAYT.TA",
    "EnglishName": "PAYTON",
    "EnglishLongName": "PAYTON INDUSTRIES LTD.",
    "HebrewName": "פייטון",
    "HebrewLongName": "פייטון תעשיות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 7667.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 20.8,
    "YearYield": 20.8,
    "Last12MonthYield": null,
    "ISIN": "IL0004120155"
  },
  {
    "Id": "PAZ.TA",
    "MayaId": "1100007",
    "Name": "PAZ ENERGY",
    "ShortName": "PAZ RETAIL AND ENERGY LTD.",
    "Symbol": "PAZ.TA",
    "TaseSymbol": "PAZ",
    "YahooId": "PAZ.TA",
    "EnglishName": "PAZ ENERGY",
    "EnglishLongName": "PAZ RETAIL AND ENERGY LTD.",
    "HebrewName": "פז אנרגיה",
    "HebrewLongName": "פז קמעונאות ואנרגיה בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 74570.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Energy And Oil & Gas Exploration",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 7.7,
    "YearYield": 7.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011000077"
  },
  {
    "Id": "PEN.TA",
    "MayaId": "333013",
    "Name": "PENINSULA GROUP",
    "ShortName": "PENINSULA GROUP LTD",
    "Symbol": "PEN.TA",
    "TaseSymbol": "PEN",
    "YahooId": "PEN.TA",
    "EnglishName": "PENINSULA GROUP",
    "EnglishLongName": "PENINSULA GROUP LTD",
    "HebrewName": "פנינסולה",
    "HebrewLongName": "קבוצת פנינסולה בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 365.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Financial Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 7.7,
    "YearYield": 7.7,
    "Last12MonthYield": null,
    "ISIN": "IL0003330136"
  },
  {
    "Id": "PERI.TA",
    "MayaId": "1095819",
    "Name": "PERION NETWORK",
    "ShortName": "PERION NETWORK LTD.",
    "Symbol": "PERI.TA",
    "TaseSymbol": "PERI",
    "YahooId": "PERI.TA",
    "EnglishName": "PERION NETWORK",
    "EnglishLongName": "PERION NETWORK LTD.",
    "HebrewName": "פריון נטוורק",
    "HebrewLongName": "פריון נטוורק בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2890.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -1.8,
    "YearYield": -1.8,
    "Last12MonthYield": null,
    "ISIN": "IL0010958192"
  },
  {
    "Id": "PTCH.TA",
    "MayaId": "756015",
    "Name": "PETROCHEMICAL",
    "ShortName": "ISRAEL PETROCHEMICAL ENTERPRISES LTD.",
    "Symbol": "PTCH.TA",
    "TaseSymbol": "PTCH",
    "YahooId": "PTCH.TA",
    "EnglishName": "PETROCHEMICAL",
    "EnglishLongName": "ISRAEL PETROCHEMICAL ENTERPRISES LTD.",
    "HebrewName": "פטרוכימיים",
    "HebrewLongName": "מפעלים פטרוכימיים בישראל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 177.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Energy And Oil & Gas Exploration",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.4,
    "YearYield": 1.4,
    "Last12MonthYield": null,
    "ISIN": "IL0007560159"
  },
  {
    "Id": "PNRG.TA",
    "MayaId": "1172360",
    "Name": "PHINERGY",
    "ShortName": "PHINERGY LTD",
    "Symbol": "PNRG.TA",
    "TaseSymbol": "PNRG",
    "YahooId": "PNRG.TA",
    "EnglishName": "PHINERGY",
    "EnglishLongName": "PHINERGY LTD",
    "HebrewName": "פינרג'י",
    "HebrewLongName": "פינרג'י בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 141.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -20.2,
    "YearYield": -20.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011723603"
  },
  {
    "Id": "PHOE.TA",
    "MayaId": "767012",
    "Name": "PHOENIX",
    "ShortName": "PHOENIX FINANCIAL LTD",
    "Symbol": "PHOE.TA",
    "TaseSymbol": "PHOE",
    "YahooId": "PHOE.TA",
    "EnglishName": "PHOENIX",
    "EnglishLongName": "PHOENIX FINANCIAL LTD",
    "HebrewName": "הפניקס",
    "HebrewLongName": "הפניקס פיננסים בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 14440.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Insurance",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 11.5,
    "YearYield": 11.5,
    "Last12MonthYield": null,
    "ISIN": "IL0007670123"
  },
  {
    "Id": "PHTM.TA",
    "MayaId": "1173855",
    "Name": "PHOTOMYNE",
    "ShortName": "PHOTOMYNE LTD",
    "Symbol": "PHTM.TA",
    "TaseSymbol": "PHTM",
    "YahooId": "PHTM.TA",
    "EnglishName": "PHOTOMYNE",
    "EnglishLongName": "PHOTOMYNE LTD",
    "HebrewName": "פוטומיין",
    "HebrewLongName": "פוטומיין בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2062.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 5.2,
    "YearYield": 5.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011738551"
  },
  {
    "Id": "PIES.TA",
    "MayaId": "1186527",
    "Name": "PIE SIAM",
    "ShortName": "PIE SIAM LTD",
    "Symbol": "PIES.TA",
    "TaseSymbol": "PIES",
    "YahooId": "PIES.TA",
    "EnglishName": "PIE SIAM",
    "EnglishLongName": "PIE SIAM LTD",
    "HebrewName": "פאי סיאם",
    "HebrewLongName": "פאי סיאם בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4340.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -8.4,
    "YearYield": -8.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011865271"
  },
  {
    "Id": "TASE:5109137",
    "MayaId": "5109137",
    "Name": "Pitango (2B) 75/25 IL",
    "ShortName": "Pitango (2B) 75/25 IL",
    "Symbol": "TASE:5109137",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Pitango (2B) 75/25 IL",
    "EnglishLongName": "Pitango (2B) 75/25 IL",
    "HebrewName": "פיטנגו (2B)י 25/75",
    "HebrewLongName": "פיטנגו (2B)י 25/75",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.85,
    "TrusteeFee": 0.045,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.54,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 25% Equity",
    "AssetValue": 97.0,
    "MonthYield": 1.4,
    "YearYield": 1.4,
    "Last12MonthYield": 13.29,
    "ISIN": "IL0051091374"
  },
  {
    "Id": "TASE:5109129",
    "MayaId": "5109129",
    "Name": "Pitango (4B) Equity IL",
    "ShortName": "Pitango (4B) Equity IL",
    "Symbol": "TASE:5109129",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Pitango (4B) Equity IL",
    "EnglishLongName": "Pitango (4B) Equity IL",
    "HebrewName": "פיטנגו (4B) מניות",
    "HebrewLongName": "פיטנגו (4B) מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.83,
    "TrusteeFee": 0.045,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.47,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 28.1,
    "MonthYield": 5.57,
    "YearYield": 5.57,
    "Last12MonthYield": 37.99,
    "ISIN": "IL0051091291"
  },
  {
    "Id": "TASE:5136270",
    "MayaId": "5136270",
    "Name": "Pitango 90/10",
    "ShortName": "Pitango 90/10",
    "Symbol": "TASE:5136270",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Pitango (1B) 90/10",
    "EnglishLongName": "Pitango (1B) 90/10",
    "HebrewName": "פיטנגו 10/90",
    "HebrewLongName": "פיטנגו (1B)י 10/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.83,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.29,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 9.8,
    "MonthYield": 0.86,
    "YearYield": 0.86,
    "Last12MonthYield": 8.86,
    "ISIN": "IL0051362700"
  },
  {
    "Id": "PLSN.TA",
    "MayaId": "1081603",
    "Name": "PLASSON INDUS",
    "ShortName": "PLASSON INDUSTRIES LTD.",
    "Symbol": "PLSN.TA",
    "TaseSymbol": "PLSN",
    "YahooId": "PLSN.TA",
    "EnglishName": "PLASSON INDUS",
    "EnglishLongName": "PLASSON INDUSTRIES LTD.",
    "HebrewName": "פלסאון תעשיות",
    "HebrewLongName": "פלסאון תעשיות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 18120.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.9,
    "YearYield": 1.9,
    "Last12MonthYield": null,
    "ISIN": "IL0010816036"
  },
  {
    "Id": "PLCR.TA",
    "MayaId": "727016",
    "Name": "PLASTO CARGAL",
    "ShortName": "PLASTO-CARGAL GROUP LTD",
    "Symbol": "PLCR.TA",
    "TaseSymbol": "PLCR",
    "YahooId": "PLCR.TA",
    "EnglishName": "PLASTO CARGAL",
    "EnglishLongName": "PLASTO-CARGAL GROUP LTD",
    "HebrewName": "פלסטו קרגל",
    "HebrewLongName": "קבוצת פלסטו-קרגל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 643.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 7.0,
    "YearYield": 7.0,
    "Last12MonthYield": null,
    "ISIN": "IL0007270163"
  },
  {
    "Id": "PPIL.TA",
    "MayaId": "1092840",
    "Name": "PLASTOFIL",
    "ShortName": "PLASTOPIL HAZOREA COMPANY LTD.",
    "Symbol": "PPIL.TA",
    "TaseSymbol": "PPIL",
    "YahooId": "PPIL.TA",
    "EnglishName": "PLASTOFIL",
    "EnglishLongName": "PLASTOPIL HAZOREA COMPANY LTD.",
    "HebrewName": "פלסטופיל",
    "HebrewLongName": "חברת פלסטופיל הזורע בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 654.6,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 2.7,
    "YearYield": 2.7,
    "Last12MonthYield": null,
    "ISIN": "IL0010928401"
  },
  {
    "Id": "PLAZ-L.TA",
    "MayaId": "1109917",
    "Name": "PLAZA CENTERS L",
    "ShortName": "PLAZA CENTERS N.V",
    "Symbol": "PLAZ-L.TA",
    "TaseSymbol": "PLAZ-L",
    "YahooId": "PLAZ-L.TA",
    "EnglishName": "PLAZA CENTERS-L",
    "EnglishLongName": "PLAZA CENTERS N.V",
    "HebrewName": "פלאזה סנטר -ס",
    "HebrewLongName": "פלאזה סנטרס אן.וי",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 164.8,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.0,
    "YearYield": 0.0,
    "Last12MonthYield": null,
    "ISIN": "NL0011882741"
  },
  {
    "Id": "PLUR.TA",
    "MayaId": "1121730",
    "Name": "PLURI",
    "ShortName": "PLURI INC.",
    "Symbol": "PLUR.TA",
    "TaseSymbol": "PLUR",
    "YahooId": "PLUR.TA",
    "EnglishName": "PLURI",
    "EnglishLongName": "PLURI INC.",
    "HebrewName": "פלורי",
    "HebrewLongName": "פלורי אינק.",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 986.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 3.2,
    "YearYield": 3.2,
    "Last12MonthYield": null,
    "ISIN": "US72942G2030"
  },
  {
    "Id": "POLI.TA",
    "MayaId": "662577",
    "Name": "POALIM",
    "ShortName": "BANK HAPOALIM B.M.",
    "Symbol": "POLI.TA",
    "TaseSymbol": "POLI",
    "YahooId": "POLI.TA",
    "EnglishName": "POALIM",
    "EnglishLongName": "BANK HAPOALIM B.M.",
    "HebrewName": "פועלים",
    "HebrewLongName": "בנק הפועלים בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 7815.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Banks",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 10.4,
    "YearYield": 10.4,
    "Last12MonthYield": null,
    "ISIN": "IL0006625771"
  },
  {
    "Id": "POLY.TA",
    "MayaId": "745018",
    "Name": "POLYGON",
    "ShortName": "POLYGON REALESTATE LTD.",
    "Symbol": "POLY.TA",
    "TaseSymbol": "POLY",
    "YahooId": "POLY.TA",
    "EnglishName": "POLYGON",
    "EnglishLongName": "POLYGON REALESTATE LTD.",
    "HebrewName": "פוליגון",
    "HebrewLongName": "פוליגון נדל\"ן בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5774.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 7.7,
    "YearYield": 7.7,
    "Last12MonthYield": null,
    "ISIN": "IL0007450187"
  },
  {
    "Id": "POLP.TA",
    "MayaId": "1170216",
    "Name": "POLYRAM PLS",
    "ShortName": "POLYRAM PLASTIC INDUSTRIES LTD",
    "Symbol": "POLP.TA",
    "TaseSymbol": "POLP",
    "YahooId": "POLP.TA",
    "EnglishName": "POLYRAM PLS",
    "EnglishLongName": "POLYRAM PLASTIC INDUSTRIES LTD",
    "HebrewName": "פולירם",
    "HebrewLongName": "פולירם תעשיות פלסטיק בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 998.2,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 3.8,
    "YearYield": 3.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011702169"
  },
  {
    "Id": "PMVM.TA",
    "MayaId": "1173434",
    "Name": "POMVOM",
    "ShortName": "POMVOM LTD",
    "Symbol": "PMVM.TA",
    "TaseSymbol": "PMVM",
    "YahooId": "PMVM.TA",
    "EnglishName": "POMVOM",
    "EnglishLongName": "POMVOM LTD",
    "HebrewName": "פוםוום",
    "HebrewLongName": "פוםוום בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 214.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -5.8,
    "YearYield": -5.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011734345"
  },
  {
    "Id": "PRSK.TA",
    "MayaId": "1102128",
    "Name": "PRASHKOVSKY",
    "ShortName": "PRASHKOVSKY INVESTMENTS AND CONSTRUCTION LTD",
    "Symbol": "PRSK.TA",
    "TaseSymbol": "PRSK",
    "YahooId": "PRSK.TA",
    "EnglishName": "PRASHKOVSKY",
    "EnglishLongName": "PRASHKOVSKY INVESTMENTS AND CONSTRUCTION LTD",
    "HebrewName": "פרשקובסקי",
    "HebrewLongName": "פרשקובסקי השקעות ובניין בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 16320.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 7.8,
    "YearYield": 7.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011021289"
  },
  {
    "Id": "PRIM.TA",
    "MayaId": "1174457",
    "Name": "PRIME ENERGY",
    "ShortName": "PRIME ENERGY P.E. LTD",
    "Symbol": "PRIM.TA",
    "TaseSymbol": "PRIM",
    "YahooId": "PRIM.TA",
    "EnglishName": "PRIME ENERGY",
    "EnglishLongName": "PRIME ENERGY P.E. LTD",
    "HebrewName": "פריים אנרג'י",
    "HebrewLongName": "פריים אנרג'י פי.אי בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2670.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 47.0,
    "YearYield": 47.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011744575"
  },
  {
    "Id": "PRMG.TA",
    "MayaId": "1175496",
    "Name": "PRIMOTEC",
    "ShortName": "PRIMOTEC GROUP LTD",
    "Symbol": "PRMG.TA",
    "TaseSymbol": "PRMG",
    "YahooId": "PRMG.TA",
    "EnglishName": "PRIMOTEC",
    "EnglishLongName": "PRIMOTEC GROUP LTD",
    "HebrewName": "פרימוטק",
    "HebrewLongName": "פרימוטק גרופ בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1474.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 6.5,
    "YearYield": 6.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011754962"
  },
  {
    "Id": "PRTC.TA",
    "MayaId": "328013",
    "Name": "PRIORTECH",
    "ShortName": "PRIORTECH LTD",
    "Symbol": "PRTC.TA",
    "TaseSymbol": "PRTC",
    "YahooId": "PRTC.TA",
    "EnglishName": "PRIORTECH",
    "EnglishLongName": "PRIORTECH LTD",
    "HebrewName": "פריורטק",
    "HebrewLongName": "פריורטק בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 24170.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 14.4,
    "YearYield": 14.4,
    "Last12MonthYield": null,
    "ISIN": "IL0003280133"
  },
  {
    "Id": "TASE:5130422",
    "MayaId": "5130422",
    "Name": "PRO FLEXIBLE",
    "ShortName": "PRO FLEXIBLE",
    "Symbol": "TASE:5130422",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "PROFOUND Flexible (4D)",
    "EnglishLongName": "PROFOUND Flexible (4D)",
    "HebrewName": "פרופאונד גמישה",
    "HebrewLongName": "פרופאונד גמישה (4D)",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.75,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.89,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 90.1,
    "MonthYield": 5.67,
    "YearYield": 5.67,
    "Last12MonthYield": 50.04,
    "ISIN": "IL0051304223"
  },
  {
    "Id": "TASE:5138219",
    "MayaId": "5138219",
    "Name": "Profound ! Bd P NoStk IL",
    "ShortName": "Profound ! Bd P NoStk IL",
    "Symbol": "TASE:5138219",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Profound (0B)(!) Bonds Portfolio Without Stocks IL",
    "EnglishLongName": "Profound (0B)(!) Bonds Portfolio Without Stocks IL",
    "HebrewName": "פרופאונד ! תיק אגח ללא מנ",
    "HebrewLongName": "פרופאונד (0B)(!) תיק אג\"ח ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.29,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 48.0,
    "MonthYield": 0.8,
    "YearYield": 0.8,
    "Last12MonthYield": 6.25,
    "ISIN": "IL0051382195"
  },
  {
    "Id": "TASE:5141049",
    "MayaId": "5141049",
    "Name": "Profound ! Bnd Prt+10% IL",
    "ShortName": "Profound ! Bnd Prt+10% IL",
    "Symbol": "TASE:5141049",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Profound (1B)(!) Bonds Portfolio + 10% IL",
    "EnglishLongName": "Profound (1B)(!) Bonds Portfolio + 10% IL",
    "HebrewName": "פרופאונד ! תיק אגח + 10%",
    "HebrewLongName": "פרופאונד (1B)(!) תיק אג\"ח + 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 17.1,
    "MonthYield": 1.2,
    "YearYield": 1.2,
    "Last12MonthYield": null,
    "ISIN": "IL0051410491"
  },
  {
    "Id": "TASE:5124888",
    "MayaId": "5124888",
    "Name": "Profound (1A) 90/10 IL",
    "ShortName": "Profound (1A) 90/10 IL",
    "Symbol": "TASE:5124888",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Profound (1A) 90/10 IL",
    "EnglishLongName": "Profound (1A) 90/10 IL",
    "HebrewName": "פרופאונד (1A)י 10/90",
    "HebrewLongName": "פרופאונד (1A)י 10/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.42,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 76.6,
    "MonthYield": 1.23,
    "YearYield": 1.23,
    "Last12MonthYield": 10.26,
    "ISIN": "IL0051248883"
  },
  {
    "Id": "TASE:5134846",
    "MayaId": "5134846",
    "Name": "Profound (2B) 70/30 IL",
    "ShortName": "Profound (2B) 70/30 IL",
    "Symbol": "TASE:5134846",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Profound (2B) 70/30 IL",
    "EnglishLongName": "Profound (2B) 70/30 IL",
    "HebrewName": "פרופאונד (2B)י 30/70",
    "HebrewLongName": "פרופאונד (2B)י 30/70",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.59,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 32.2,
    "MonthYield": 2.17,
    "YearYield": 2.17,
    "Last12MonthYield": 19.43,
    "ISIN": "IL0051348469"
  },
  {
    "Id": "TASE:5119854",
    "MayaId": "5119854",
    "Name": "PROFOUND (4B) EQUITY IL",
    "ShortName": "PROFOUND (4B) EQUITY IL",
    "Symbol": "TASE:5119854",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "PROFOUND (4B) EQUITY IL",
    "EnglishLongName": "PROFOUND (4B) EQUITY IL",
    "HebrewName": "פרופאונד (4B) מנייתית",
    "HebrewLongName": "פרופאונד (4B) מנייתית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.85,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.12,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 692.3,
    "MonthYield": 6.96,
    "YearYield": 6.96,
    "Last12MonthYield": 66.49,
    "ISIN": "IL0051198542"
  },
  {
    "Id": "TASE:5130430",
    "MayaId": "5130430",
    "Name": "PROFOUND 20/80 IL",
    "ShortName": "PROFOUND 20/80 IL",
    "Symbol": "TASE:5130430",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "PROFOUND 80/20 (2B) IL",
    "EnglishLongName": "PROFOUND 80/20 (2B) IL",
    "HebrewName": "פרופאונד 20/80",
    "HebrewLongName": "פרופאונד 20/80 (2B)",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.77,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.5,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 27.3,
    "MonthYield": 1.82,
    "YearYield": 1.82,
    "Last12MonthYield": 14.84,
    "ISIN": "IL0051304306"
  },
  {
    "Id": "TASE:5135264",
    "MayaId": "5135264",
    "Name": "Profound Bnd No Stock IL",
    "ShortName": "Profound Bnd No Stock IL",
    "Symbol": "TASE:5135264",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Profound (0B) Bonds Without Stocks IL",
    "EnglishLongName": "Profound (0B) Bonds Without Stocks IL",
    "HebrewName": "פרופאונד אג\"ח ללא מניות",
    "HebrewLongName": "פרופאונד (0B) אג\"ח ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.99,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.31,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 161.0,
    "MonthYield": 0.59,
    "YearYield": 0.59,
    "Last12MonthYield": 5.52,
    "ISIN": "IL0051352644"
  },
  {
    "Id": "TASE:5130414",
    "MayaId": "5130414",
    "Name": "PROFOUND Inv grd bnds IL",
    "ShortName": "PROFOUND Inv grd bnds IL",
    "Symbol": "TASE:5130414",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "(!)(PROFOUND Investment grade bonds IL (0A",
    "EnglishLongName": "(!)(PROFOUND Investment grade bonds IL (0A",
    "HebrewName": "פרופאונד אג מדורגות",
    "HebrewLongName": "פרופאונד אג\"ח מדורגות (0A)(!)",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.25,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 97.2,
    "MonthYield": 0.74,
    "YearYield": 0.74,
    "Last12MonthYield": 5.48,
    "ISIN": "IL0051304140"
  },
  {
    "Id": "TASE:5140694",
    "MayaId": "5140694",
    "Name": "Profound L&M Cap Eq IL",
    "ShortName": "Profound L&M Cap Eq IL",
    "Symbol": "TASE:5140694",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Profound (4B) Large & Mid Cap Equity IL",
    "EnglishLongName": "Profound (4B) Large & Mid Cap Equity IL",
    "HebrewName": "פרופאונד מנ L&M Cap ישראל",
    "HebrewLongName": "פרופאונד (4B) מניות Large & Mid Cap ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.0,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 29.0,
    "MonthYield": 6.97,
    "YearYield": 6.97,
    "Last12MonthYield": null,
    "ISIN": "IL0051406945"
  },
  {
    "Id": "PRPD.TA",
    "MayaId": "1188622",
    "Name": "PROPDO",
    "ShortName": "PROPDO LTD",
    "Symbol": "PRPD.TA",
    "TaseSymbol": "PRPD",
    "YahooId": "PRPD.TA",
    "EnglishName": "PROPDO",
    "EnglishLongName": "PROPDO LTD",
    "HebrewName": "פרופדו",
    "HebrewLongName": "פרופדו בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2321.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -3.3,
    "YearYield": -3.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011886228"
  },
  {
    "Id": "PTBL.TA",
    "MayaId": "699017",
    "Name": "PROPERT & BUIL",
    "ShortName": "PROPERTY AND BUILDING CORP. LTD.",
    "Symbol": "PTBL.TA",
    "TaseSymbol": "PTBL",
    "YahooId": "PTBL.TA",
    "EnglishName": "PROPERT & BUIL",
    "EnglishLongName": "PROPERTY AND BUILDING CORP. LTD.",
    "HebrewName": "נכסים ובנין",
    "HebrewLongName": "חברה לנכסים ולבנין בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 41010.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 7.9,
    "YearYield": 7.9,
    "Last12MonthYield": null,
    "ISIN": "IL0006990175"
  },
  {
    "Id": "PSEC.TA",
    "MayaId": "1230655",
    "Name": "PROSPECT",
    "ShortName": "PROSPECT CAPITAL CORPORATION",
    "Symbol": "PSEC.TA",
    "TaseSymbol": "PSEC",
    "YahooId": "PSEC.TA",
    "EnglishName": "PROSPECT",
    "EnglishLongName": "PROSPECT CAPITAL CORPORATION",
    "HebrewName": "פרוספקט",
    "HebrewLongName": "פרוספקט קפיטל קורפוריישן",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 844.5,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Financial Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.0,
    "YearYield": 0.0,
    "Last12MonthYield": null,
    "ISIN": "US74348T1025"
  },
  {
    "Id": "TASE:5129606",
    "MayaId": "5129606",
    "Name": "PST FLEXIBLE",
    "ShortName": "PST FLEXIBLE",
    "Symbol": "TASE:5129606",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "PASTERNAK SHOHAM (4D) FLEXIBLE",
    "EnglishLongName": "PASTERNAK SHOHAM (4D) FLEXIBLE",
    "HebrewName": "פסטרנק שהם גמישה",
    "HebrewLongName": "פסטרנק שהם (4D) גמישה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.7,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.36,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 35.2,
    "MonthYield": 2.41,
    "YearYield": 2.41,
    "Last12MonthYield": 40.96,
    "ISIN": "IL0051296064"
  },
  {
    "Id": "TASE:5133111",
    "MayaId": "5133111",
    "Name": "Pstrnk Shoham Foreign EQU",
    "ShortName": "Pstrnk Shoham Foreign EQU",
    "Symbol": "TASE:5133111",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Pasternak Shoham (4D) Foreign Equities",
    "EnglishLongName": "Pasternak Shoham (4D) Foreign Equities",
    "HebrewName": "פסטרנק שהם מנ חו\"ל",
    "HebrewLongName": "פסטרנק שהם (4D) מניות חו\"ל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.75,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.59,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 299.9,
    "MonthYield": 0.53,
    "YearYield": 0.53,
    "Last12MonthYield": 3.44,
    "ISIN": "IL0051331119"
  },
  {
    "Id": "PSRX.TA",
    "MayaId": "1176908",
    "Name": "PSYRX BIO TECH",
    "ShortName": "PSYRX CNS BIO-TECH LTD",
    "Symbol": "PSRX.TA",
    "TaseSymbol": "PSRX",
    "YahooId": "PSRX.TA",
    "EnglishName": "PSYRX BIO-TECH",
    "EnglishLongName": "PSYRX CNS BIO-TECH LTD",
    "HebrewName": "פסיירקס ביו-טק",
    "HebrewLongName": "פסיירקס סי אן אס ביו-טק בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 90.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -2.9,
    "YearYield": -2.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011769085"
  },
  {
    "Id": "PULS.TA",
    "MayaId": "1176700",
    "Name": "PULSENMORE",
    "ShortName": "PULSENMORE LTD",
    "Symbol": "PULS.TA",
    "TaseSymbol": "PULS",
    "YahooId": "PULS.TA",
    "EnglishName": "PULSENMORE",
    "EnglishLongName": "PULSENMORE LTD",
    "HebrewName": "פלסאנמור",
    "HebrewLongName": "פלסאנמור בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1822.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -10.9,
    "YearYield": -10.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011767006"
  },
  {
    "Id": "PPBT.TA",
    "MayaId": "765016",
    "Name": "PURPLE BIOTECH",
    "ShortName": "PURPLE BIOTECH LTD",
    "Symbol": "PPBT.TA",
    "TaseSymbol": "PPBT",
    "YahooId": "PPBT.TA",
    "EnglishName": "PURPLE BIOTECH",
    "EnglishLongName": "PURPLE BIOTECH LTD",
    "HebrewName": "פרפל ביוטק",
    "HebrewLongName": "פרפל ביוטק בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1.2,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.0,
    "YearYield": 0.0,
    "Last12MonthYield": null,
    "ISIN": "IL0007650166"
  },
  {
    "Id": "QLTU.TA",
    "MayaId": "1083955",
    "Name": "QUALITAU",
    "ShortName": "QUALITAU LTD.",
    "Symbol": "QLTU.TA",
    "TaseSymbol": "QLTU",
    "YahooId": "QLTU.TA",
    "EnglishName": "QUALITAU",
    "EnglishLongName": "QUALITAU LTD.",
    "HebrewName": "קווליטאו",
    "HebrewLongName": "קווליטאו בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 63070.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 6.0,
    "YearYield": 6.0,
    "Last12MonthYield": null,
    "ISIN": "IL0010839558"
  },
  {
    "Id": "QNCO.TA",
    "MayaId": "386011",
    "Name": "QUEENCO",
    "ShortName": "(Y.Z)QUEENCO LTD",
    "Symbol": "QNCO.TA",
    "TaseSymbol": "QNCO",
    "YahooId": "QNCO.TA",
    "EnglishName": "QUEENCO",
    "EnglishLongName": "(Y.Z)QUEENCO LTD",
    "HebrewName": "קווינקו",
    "HebrewLongName": "(י.ז) קווינקו בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 706.6,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -1.7,
    "YearYield": -1.7,
    "Last12MonthYield": null,
    "ISIN": "IL0003860116"
  },
  {
    "Id": "RLCO.TA",
    "MayaId": "393017",
    "Name": "RALCO",
    "ShortName": "RALCO AGENCIES LTD.",
    "Symbol": "RLCO.TA",
    "TaseSymbol": "RLCO",
    "YahooId": "RLCO.TA",
    "EnglishName": "RALCO",
    "EnglishLongName": "RALCO AGENCIES LTD.",
    "HebrewName": "ראלקו",
    "HebrewLongName": "ראלקו סוכנויות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4625.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 7.2,
    "YearYield": 7.2,
    "Last12MonthYield": null,
    "ISIN": "IL0003930174"
  },
  {
    "Id": "RMN.TA",
    "MayaId": "1090943",
    "Name": "RAM ON",
    "ShortName": "RAM-ON INVESTMENTS AND HOLDINGS(1999) LTD",
    "Symbol": "RMN.TA",
    "TaseSymbol": "RMN",
    "YahooId": "RMN.TA",
    "EnglishName": "RAM ON",
    "EnglishLongName": "RAM-ON INVESTMENTS AND HOLDINGS(1999) LTD",
    "HebrewName": "רם און",
    "HebrewLongName": "רם-און השקעות והחזקות (1999) בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1299.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.5,
    "YearYield": 1.5,
    "Last12MonthYield": null,
    "ISIN": "IL0010909435"
  },
  {
    "Id": "RMLI.TA",
    "MayaId": "1104249",
    "Name": "RAMI LEVI",
    "ShortName": "RAMI LEVI CHAIN STORES HASHIKMA MARKETING 2006 LTD",
    "Symbol": "RMLI.TA",
    "TaseSymbol": "RMLI",
    "YahooId": "RMLI.TA",
    "EnglishName": "RAMI LEVI",
    "EnglishLongName": "RAMI LEVI CHAIN STORES HASHIKMA MARKETING 2006 LTD",
    "HebrewName": "רמי לוי",
    "HebrewLongName": "רשת חנויות רמי לוי שיווק השיקמה 2006 בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 35280.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 2.5,
    "YearYield": 2.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011042491"
  },
  {
    "Id": "RANI.TA",
    "MayaId": "1143619",
    "Name": "RANI ZIM",
    "ShortName": "RANI ZIM SHOPPING CENTERS LTD",
    "Symbol": "RANI.TA",
    "TaseSymbol": "RANI",
    "YahooId": "RANI.TA",
    "EnglishName": "RANI ZIM",
    "EnglishLongName": "RANI ZIM SHOPPING CENTERS LTD",
    "HebrewName": "רני צים",
    "HebrewLongName": "רני צים מרכזי קניות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 511.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -3.0,
    "YearYield": -3.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011436198"
  },
  {
    "Id": "RPAC.TA",
    "MayaId": "769026",
    "Name": "RAPAC",
    "ShortName": "RAPAC COMMUNICATION & INFRASTRUCTURE LTD",
    "Symbol": "RPAC.TA",
    "TaseSymbol": "RPAC",
    "YahooId": "RPAC.TA",
    "EnglishName": "RAPAC",
    "EnglishLongName": "RAPAC COMMUNICATION & INFRASTRUCTURE LTD",
    "HebrewName": "רפק",
    "HebrewLongName": "רפק תקשורת ותשתיות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 8042.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Investment & Holdings",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 7.8,
    "YearYield": 7.8,
    "Last12MonthYield": null,
    "ISIN": "IL0007690261"
  },
  {
    "Id": "BRIH.TA",
    "MayaId": "1179993",
    "Name": "RAV BARIACH",
    "ShortName": "RAV BARIACH(08)INDUSTRIES LTD.",
    "Symbol": "BRIH.TA",
    "TaseSymbol": "BRIH",
    "YahooId": "BRIH.TA",
    "EnglishName": "RAV BARIACH",
    "EnglishLongName": "RAV BARIACH(08)INDUSTRIES LTD.",
    "HebrewName": "רב בריח",
    "HebrewLongName": "רב-בריח(08) תעשיות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 120.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -8.9,
    "YearYield": -8.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011799934"
  },
  {
    "Id": "RAVD.TA",
    "MayaId": "526012",
    "Name": "RAVAD",
    "ShortName": "RAVAD LTD.",
    "Symbol": "RAVD.TA",
    "TaseSymbol": "RAVD",
    "YahooId": "RAVD.TA",
    "EnglishName": "RAVAD",
    "EnglishLongName": "RAVAD LTD.",
    "HebrewName": "רבד",
    "HebrewLongName": "רבד בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 679.2,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 25.0,
    "YearYield": 25.0,
    "Last12MonthYield": null,
    "ISIN": "IL0005260125"
  },
  {
    "Id": "RVL.TA",
    "MayaId": "1103878",
    "Name": "RAVAL",
    "ShortName": "RAVAL ICS LTD",
    "Symbol": "RVL.TA",
    "TaseSymbol": "RVL",
    "YahooId": "RVL.TA",
    "EnglishName": "RAVAL",
    "EnglishLongName": "RAVAL ICS LTD",
    "HebrewName": "רבל",
    "HebrewLongName": "רבל אי.סי.אס. בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 206.8,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 3.8,
    "YearYield": 3.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011038788"
  },
  {
    "Id": "RAYG-M.TA",
    "MayaId": "673012",
    "Name": "RAY TLV GROUP M",
    "ShortName": "RAY TLV GROUP LTD",
    "Symbol": "RAYG-M.TA",
    "TaseSymbol": "RAYG-M",
    "YahooId": "RAYG-M.TA",
    "EnglishName": "RAY TLV GROUP-M",
    "EnglishLongName": "RAY TLV GROUP LTD",
    "HebrewName": "ריי טי אל וי-ש",
    "HebrewLongName": "קבוצת ריי טי.אל.וי בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 82.1,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -8.9,
    "YearYield": -8.9,
    "Last12MonthYield": null,
    "ISIN": "IL0006730126"
  },
  {
    "Id": "RZR.TA",
    "MayaId": "1172527",
    "Name": "RAZOR LABS",
    "ShortName": "RAZOR LABS LTD",
    "Symbol": "RZR.TA",
    "TaseSymbol": "RZR",
    "YahooId": "RZR.TA",
    "EnglishName": "RAZOR LABS",
    "EnglishLongName": "RAZOR LABS LTD",
    "HebrewName": "רייזור",
    "HebrewLongName": "רייזור לאבס בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 511.4,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -12.3,
    "YearYield": -12.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011725277"
  },
  {
    "Id": "TASE:61",
    "MayaId": "61",
    "Name": "RealEstate & Construction Shares and Convertibles",
    "ShortName": "RealEstate & Construction Shares and Convertibles",
    "Symbol": "TASE:61",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "RealEstate & Construction Shares and Convertibles",
    "EnglishLongName": "RealEstate & Construction Shares and Convertibles",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "RIT1.TA",
    "MayaId": "1098920",
    "Name": "REIT 1",
    "ShortName": "REIT 1 LTD",
    "Symbol": "RIT1.TA",
    "TaseSymbol": "RIT1",
    "YahooId": "RIT1.TA",
    "EnglishName": "REIT 1",
    "EnglishLongName": "REIT 1 LTD",
    "HebrewName": "ריט 1",
    "HebrewLongName": "ריט 1 בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2783.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 5.3,
    "YearYield": 5.3,
    "Last12MonthYield": null,
    "ISIN": "IL0010989205"
  },
  {
    "Id": "AZRT.TA",
    "MayaId": "1162775",
    "Name": "REIT AZORIM LIV",
    "ShortName": "REIT AZORIM - H.F LIVING LTD",
    "Symbol": "AZRT.TA",
    "TaseSymbol": "AZRT",
    "YahooId": "AZRT.TA",
    "EnglishName": "REIT AZORIM LIV",
    "EnglishLongName": "REIT AZORIM - H.F LIVING LTD",
    "HebrewName": "ריט אזורים ליוי",
    "HebrewLongName": "ריט אזורים - ה.פ ליווינג בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 635.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 8.9,
    "YearYield": 8.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011627754"
  },
  {
    "Id": "REKA.TA",
    "MayaId": "1081009",
    "Name": "REKAH",
    "ShortName": "REKAH PHARMACEUTICAL INDUSTRY LTD.",
    "Symbol": "REKA.TA",
    "TaseSymbol": "REKA",
    "YahooId": "REKA.TA",
    "EnglishName": "REKAH",
    "EnglishLongName": "REKAH PHARMACEUTICAL INDUSTRY LTD.",
    "HebrewName": "רקח",
    "HebrewLongName": "רקח תעשיה פרמצבטית בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1081.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -1.2,
    "YearYield": -1.2,
    "Last12MonthYield": null,
    "ISIN": "IL0010810096"
  },
  {
    "Id": "RENT.TA",
    "MayaId": "1199645",
    "Name": "RENT IT",
    "ShortName": "RENT IT-RESIDENTIAL REIT LTD",
    "Symbol": "RENT.TA",
    "TaseSymbol": "RENT",
    "YahooId": "RENT.TA",
    "EnglishName": "RENT IT",
    "EnglishLongName": "RENT IT-RESIDENTIAL REIT LTD",
    "HebrewName": "רנט איט",
    "HebrewLongName": "רנט איט-ריט מגורים בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 970.3,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -6.9,
    "YearYield": -6.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011996456"
  },
  {
    "Id": "RESF.TA",
    "MayaId": "1233584",
    "Name": "RESHEF",
    "ShortName": "RESHEF TECHNOLOGIES LTD",
    "Symbol": "RESF.TA",
    "TaseSymbol": "RESF",
    "YahooId": "RESF.TA",
    "EnglishName": "RESHEF",
    "EnglishLongName": "RESHEF TECHNOLOGIES LTD",
    "HebrewName": "רשף",
    "HebrewLongName": "רשף טכנולוגיות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares TASE UP",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1045.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 33.0,
    "YearYield": 33.0,
    "Last12MonthYield": null,
    "ISIN": "IL0012335845"
  },
  {
    "Id": "RTMD-M.TA",
    "MayaId": "1173723",
    "Name": "RETAILMINDS M",
    "ShortName": "RETAILMINDS TECHNOLOGIES LTD",
    "Symbol": "RTMD-M.TA",
    "TaseSymbol": "RTMD-M",
    "YahooId": "RTMD-M.TA",
    "EnglishName": "RETAILMINDS -M",
    "EnglishLongName": "RETAILMINDS TECHNOLOGIES LTD",
    "HebrewName": "ריטייל מיינדס-ש",
    "HebrewLongName": "ריטייל-מיינדס טכנולוגיות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 24.5,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Investment & Holdings",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 16.7,
    "YearYield": 16.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011737231"
  },
  {
    "Id": "RTLS.TA",
    "MayaId": "1175488",
    "Name": "RETAILORS",
    "ShortName": "RETAILORS LTD",
    "Symbol": "RTLS.TA",
    "TaseSymbol": "RTLS",
    "YahooId": "RTLS.TA",
    "EnglishName": "RETAILORS",
    "EnglishLongName": "RETAILORS LTD",
    "HebrewName": "ריטיילורס",
    "HebrewLongName": "ריטיילורס בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4646.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 10.6,
    "YearYield": 10.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011754889"
  },
  {
    "Id": "RGAS.TA",
    "MayaId": "1226885",
    "Name": "RGA SERVICES",
    "ShortName": "R.G.A. SERVICES ISRAEL 1987 LTD",
    "Symbol": "RGAS.TA",
    "TaseSymbol": "RGAS",
    "YahooId": "RGAS.TA",
    "EnglishName": "RGA SERVICES",
    "EnglishLongName": "R.G.A. SERVICES ISRAEL 1987 LTD",
    "HebrewName": "רגא שרותים",
    "HebrewLongName": "ר.ג.א. שרותים ונקיון (ישראל) 1987 בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 93.6,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 14.4,
    "YearYield": 14.4,
    "Last12MonthYield": null,
    "ISIN": "IL0012268855"
  },
  {
    "Id": "RMON.TA",
    "MayaId": "1178722",
    "Name": "RIMON",
    "ShortName": "RIMON CONSULTING & MANAGEMENT SERVICES LTD.",
    "Symbol": "RMON.TA",
    "TaseSymbol": "RMON",
    "YahooId": "RMON.TA",
    "EnglishName": "RIMON",
    "EnglishLongName": "RIMON CONSULTING & MANAGEMENT SERVICES LTD.",
    "HebrewName": "רימון",
    "HebrewLongName": "רימון שירותי ייעוץ וניהול בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 10610.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 18.7,
    "YearYield": 18.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011787228"
  },
  {
    "Id": "RIMO.TA",
    "MayaId": "1080456",
    "Name": "RIMONI",
    "ShortName": "RIMONI INDUSTRIES LTD.",
    "Symbol": "RIMO.TA",
    "TaseSymbol": "RIMO",
    "YahooId": "RIMO.TA",
    "EnglishName": "RIMONI",
    "EnglishLongName": "RIMONI INDUSTRIES LTD.",
    "HebrewName": "רימוני",
    "HebrewLongName": "רימוני תעשיות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5006.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -2.8,
    "YearYield": -2.8,
    "Last12MonthYield": null,
    "ISIN": "IL0010804560"
  },
  {
    "Id": "ROBO.TA",
    "MayaId": "266015",
    "Name": "ROBOGROUP",
    "ShortName": "ROBOGROUP T.E.K LTD.",
    "Symbol": "ROBO.TA",
    "TaseSymbol": "ROBO",
    "YahooId": "ROBO.TA",
    "EnglishName": "ROBOGROUP",
    "EnglishLongName": "ROBOGROUP T.E.K LTD.",
    "HebrewName": "רובוגרופ",
    "HebrewLongName": "רובוגרופ ט.א.ק בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 69.5,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 6.4,
    "YearYield": 6.4,
    "Last12MonthYield": null,
    "ISIN": "IL0002660152"
  },
  {
    "Id": "RTSN.TA",
    "MayaId": "1171529",
    "Name": "ROTEM SHANI",
    "ShortName": "ROTEM SHANI ENTREPRENEURSHIP AND INVESTMENT LTD.",
    "Symbol": "RTSN.TA",
    "TaseSymbol": "RTSN",
    "YahooId": "RTSN.TA",
    "EnglishName": "ROTEM SHANI",
    "EnglishLongName": "ROTEM SHANI ENTREPRENEURSHIP AND INVESTMENT LTD.",
    "HebrewName": "רותם שני",
    "HebrewLongName": "רותם שני יזמות והשקעות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3506.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 12.1,
    "YearYield": 12.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011715294"
  },
  {
    "Id": "ROTS.TA",
    "MayaId": "539015",
    "Name": "ROTSHTEIN",
    "ShortName": "ROTSHTEIN REALESTATE LTD",
    "Symbol": "ROTS.TA",
    "TaseSymbol": "ROTS",
    "YahooId": "ROTS.TA",
    "EnglishName": "ROTSHTEIN",
    "EnglishLongName": "ROTSHTEIN REALESTATE LTD",
    "HebrewName": "רוטשטיין",
    "HebrewLongName": "רוטשטיין נדל\"ן בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 8706.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.7,
    "YearYield": 0.7,
    "Last12MonthYield": null,
    "ISIN": "IL0005390153"
  },
  {
    "Id": "RPOL.TA",
    "MayaId": "1222462",
    "Name": "RP OPTICAL",
    "ShortName": "RP OPTICAL LAB LTD",
    "Symbol": "RPOL.TA",
    "TaseSymbol": "RPOL",
    "YahooId": "RPOL.TA",
    "EnglishName": "RP OPTICAL",
    "EnglishLongName": "RP OPTICAL LAB LTD",
    "HebrewName": "אר פי אופטיקל",
    "HebrewLongName": "אר פי אופטיקל לאב בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3653.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 26.0,
    "YearYield": 26.0,
    "Last12MonthYield": null,
    "ISIN": "IL0012224627"
  },
  {
    "Id": "RSEL.TA",
    "MayaId": "299016",
    "Name": "RSL",
    "ShortName": "R.S.L. ELECTRONICS LTD.",
    "Symbol": "RSEL.TA",
    "TaseSymbol": "RSEL",
    "YahooId": "RSEL.TA",
    "EnglishName": "RSL",
    "EnglishLongName": "R.S.L. ELECTRONICS LTD.",
    "HebrewName": "אראסאל",
    "HebrewLongName": "אר.אס.אל.אלקטרוניקה בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1735.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 13.2,
    "YearYield": 13.2,
    "Last12MonthYield": null,
    "ISIN": "IL0002990161"
  },
  {
    "Id": "^GSPC",
    "MayaId": null,
    "Name": "S&P 500",
    "ShortName": "S&P 500",
    "Symbol": "^GSPC",
    "TaseSymbol": "",
    "YahooId": "^GSPC",
    "EnglishName": "S&P 500",
    "EnglishLongName": "S&P 500",
    "HebrewName": "S&P 500",
    "HebrewLongName": "S&P 500",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": null,
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": ""
  },
  {
    "Id": "SRAC.TA",
    "MayaId": "422014",
    "Name": "S.R ACCORD",
    "ShortName": "S.R ACCORD LTD",
    "Symbol": "SRAC.TA",
    "TaseSymbol": "SRAC",
    "YahooId": "SRAC.TA",
    "EnglishName": "S.R ACCORD",
    "EnglishLongName": "S.R ACCORD LTD",
    "HebrewName": "אסאר אקורד",
    "HebrewLongName": "אס.אר. אקורד בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5550.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Financial Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -3.6,
    "YearYield": -3.6,
    "Last12MonthYield": null,
    "ISIN": "IL0004220146"
  },
  {
    "Id": "SADE.TA",
    "MayaId": "341016",
    "Name": "SADE REAL ESTAT",
    "ShortName": "SADE REAL ESTATE-Y.S. LTD",
    "Symbol": "SADE.TA",
    "TaseSymbol": "SADE",
    "YahooId": "SADE.TA",
    "EnglishName": "SADE REAL ESTAT",
    "EnglishLongName": "SADE REAL ESTATE-Y.S. LTD",
    "HebrewName": "שדה נדל\"ן",
    "HebrewLongName": "שדה נדל\"ן-י.ש. בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 447.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -9.9,
    "YearYield": -9.9,
    "Last12MonthYield": null,
    "ISIN": "IL0003410169"
  },
  {
    "Id": "SANO1.TA",
    "MayaId": "813014",
    "Name": "SANO",
    "ShortName": "SANO BRUNO'S ENTERPRISES LTD.",
    "Symbol": "SANO1.TA",
    "TaseSymbol": "SANO1",
    "YahooId": "SANO1.TA",
    "EnglishName": "SANO",
    "EnglishLongName": "SANO BRUNO'S ENTERPRISES LTD.",
    "HebrewName": "סנו",
    "HebrewLongName": "סנו-מפעלי ברונוס בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 41130.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -5.4,
    "YearYield": -5.4,
    "Last12MonthYield": null,
    "ISIN": "IL0008130143"
  },
  {
    "Id": "SRFT.TA",
    "MayaId": "425017",
    "Name": "SARFATI",
    "ShortName": "ZVI SARFATI & SONS INVESTMENTS & CONSTRUCTIONS LTD.",
    "Symbol": "SRFT.TA",
    "TaseSymbol": "SRFT",
    "YahooId": "SRFT.TA",
    "EnglishName": "SARFATI",
    "EnglishLongName": "ZVI SARFATI & SONS INVESTMENTS & CONSTRUCTIONS LTD.",
    "HebrewName": "צרפתי",
    "HebrewLongName": "צבי צרפתי ובניו השקעות ובנין (1992) בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4540.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 5.2,
    "YearYield": 5.2,
    "Last12MonthYield": null,
    "ISIN": "IL0004250176"
  },
  {
    "Id": "SARN.TA",
    "MayaId": "1092725",
    "Name": "SARINE TECH",
    "ShortName": "SARINE TECHNOLOGIES LTD",
    "Symbol": "SARN.TA",
    "TaseSymbol": "SARN",
    "YahooId": "SARN.TA",
    "EnglishName": "SARINE TECH",
    "EnglishLongName": "SARINE TECHNOLOGIES LTD",
    "HebrewName": "שרין טכנו",
    "HebrewLongName": "שרין טכנולוגיות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 55.9,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -2.1,
    "YearYield": -2.1,
    "Last12MonthYield": null,
    "ISIN": "IL0010927254"
  },
  {
    "Id": "SVRE-L.TA",
    "MayaId": "1166693",
    "Name": "SAVER O L",
    "ShortName": "SAVERONE 2014 LTD",
    "Symbol": "SVRE-L.TA",
    "TaseSymbol": "SVRE-L",
    "YahooId": "SVRE-L.TA",
    "EnglishName": "SAVER O-L",
    "EnglishLongName": "SAVERONE 2014 LTD",
    "HebrewName": "סייברוואן-ס",
    "HebrewLongName": "סייברוואן 2014 בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.0,
    "YearYield": 0.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011666935"
  },
  {
    "Id": "SVRT-M.TA",
    "MayaId": "1169978",
    "Name": "SAVOREAT M",
    "ShortName": "SAVOREAT LTD.",
    "Symbol": "SVRT-M.TA",
    "TaseSymbol": "SVRT-M",
    "YahooId": "SVRT-M.TA",
    "EnglishName": "SAVOREAT-M",
    "EnglishLongName": "SAVOREAT LTD.",
    "HebrewName": "סבוריט-ש",
    "HebrewLongName": "סבוריט בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 204.1,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 3.8,
    "YearYield": 3.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011699787"
  },
  {
    "Id": "SHNP.TA",
    "MayaId": "1103571",
    "Name": "SCHNAPP",
    "ShortName": "E.SCHNAPP CO. WORKS LTD.",
    "Symbol": "SHNP.TA",
    "TaseSymbol": "SHNP",
    "YahooId": "SHNP.TA",
    "EnglishName": "SCHNAPP",
    "EnglishLongName": "E.SCHNAPP CO. WORKS LTD.",
    "HebrewName": "שנפ",
    "HebrewLongName": "מפעלי ע. שנפ ושות' בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1641.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.7,
    "YearYield": 0.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011035719"
  },
  {
    "Id": "SCDX.TA",
    "MayaId": "1178490",
    "Name": "SCODIX",
    "ShortName": "SCODIX LTD",
    "Symbol": "SCDX.TA",
    "TaseSymbol": "SCDX",
    "YahooId": "SCDX.TA",
    "EnglishName": "SCODIX",
    "EnglishLongName": "SCODIX LTD",
    "HebrewName": "סקודיקס",
    "HebrewLongName": "סקודיקס בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 200.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -6.0,
    "YearYield": -6.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011784902"
  },
  {
    "Id": "SCOP.TA",
    "MayaId": "288019",
    "Name": "SCOPE",
    "ShortName": "SCOPE METALS GROUP LTD",
    "Symbol": "SCOP.TA",
    "TaseSymbol": "SCOP",
    "YahooId": "SCOP.TA",
    "EnglishName": "SCOPE",
    "EnglishLongName": "SCOPE METALS GROUP LTD",
    "HebrewName": "סקופ",
    "HebrewLongName": "קבוצת סקופ מתכות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 17920.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 6.4,
    "YearYield": 6.4,
    "Last12MonthYield": null,
    "ISIN": "IL0002880198"
  },
  {
    "Id": "SEMG.TA",
    "MayaId": "249011",
    "Name": "SEACH MEDICAL",
    "ShortName": "SEACH MEDICAL GROUP LTD",
    "Symbol": "SEMG.TA",
    "TaseSymbol": "SEMG",
    "YahooId": "SEMG.TA",
    "EnglishName": "SEACH MEDICAL",
    "EnglishLongName": "SEACH MEDICAL GROUP LTD",
    "HebrewName": "שיח מדיקל",
    "HebrewLongName": "שיח מדיקל גרופ בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 287.5,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 7.0,
    "YearYield": 7.0,
    "Last12MonthYield": null,
    "ISIN": "IL0002490113"
  },
  {
    "Id": "TASE:5133343",
    "MayaId": "5133343",
    "Name": "Sela 80/20 IL",
    "ShortName": "Sela 80/20 IL",
    "Symbol": "TASE:5133343",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Sela (2B) 80/20 IL",
    "EnglishLongName": "Sela (2B) 80/20 IL",
    "HebrewName": "סלע 20/80",
    "HebrewLongName": "סלע (2B)י 20/80",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.47,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 3.3,
    "MonthYield": 2.54,
    "YearYield": 2.54,
    "Last12MonthYield": 12.06,
    "ISIN": "IL0051333438"
  },
  {
    "Id": "TASE:5123823",
    "MayaId": "5123823",
    "Name": "Sela 90/10 IL",
    "ShortName": "Sela 90/10 IL",
    "Symbol": "TASE:5123823",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Sela (1B) 90/10 IL",
    "EnglishLongName": "Sela (1B) 90/10 IL",
    "HebrewName": "סלע 10/90",
    "HebrewLongName": "סלע (1B)י 10/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.4,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 47.9,
    "MonthYield": 1.47,
    "YearYield": 1.47,
    "Last12MonthYield": 10.7,
    "ISIN": "IL0051238231"
  },
  {
    "Id": "TASE:5114855",
    "MayaId": "5114855",
    "Name": "SELA FOREIGN EQUITY",
    "ShortName": "SELA FOREIGN EQUITY",
    "Symbol": "TASE:5114855",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "SELA (4D) FOREIGN EQUITY",
    "EnglishLongName": "SELA (4D) FOREIGN EQUITY",
    "HebrewName": "סלע מניות חול",
    "HebrewLongName": "סלע (4D) מניות חו\"ל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.64,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.05,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 1.9,
    "MonthYield": 2.23,
    "YearYield": 2.23,
    "Last12MonthYield": 4.73,
    "ISIN": "IL0051148554"
  },
  {
    "Id": "TASE:5123831",
    "MayaId": "5123831",
    "Name": "Sela Genral Bond no Eq IL",
    "ShortName": "Sela Genral Bond no Eq IL",
    "Symbol": "TASE:5123831",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Sela (0B)(!) General Bond without Equity IL",
    "EnglishLongName": "Sela (0B)(!) General Bond without Equity IL",
    "HebrewName": "סלע אג\"ח כללי ללא מניות",
    "HebrewLongName": "סלע (0B)(!) אג\"ח כללי ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 39.5,
    "MonthYield": 0.91,
    "YearYield": 0.91,
    "Last12MonthYield": 7.47,
    "ISIN": "IL0051238314"
  },
  {
    "Id": "TASE:5136551",
    "MayaId": "5136551",
    "Name": "Sela GovShklBank 2.5yr IL",
    "ShortName": "Sela GovShklBank 2.5yr IL",
    "Symbol": "TASE:5136551",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Sela (00) Shekel Government & Banks Bonds - Up to 2.5 Years IL",
    "EnglishLongName": "Sela (00) Shekel Government & Banks Bonds - Up to 2.5 Years IL",
    "HebrewName": "סלע מדינה שקל בנקים עד2.5",
    "HebrewLongName": "סלע (00) מדינה שקלי ואג\"ח בנקים - עד 2.5 שנים",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.42,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.06,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Shekel Bonds - No Equity",
    "AssetValue": 17.5,
    "MonthYield": 0.3,
    "YearYield": 0.3,
    "Last12MonthYield": 4.64,
    "ISIN": "IL0051365513"
  },
  {
    "Id": "TASE:5141791",
    "MayaId": "5141791",
    "Name": "Sela Israel Value Equity",
    "ShortName": "Sela Israel Value Equity",
    "Symbol": "TASE:5141791",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Sela (4B) Israel Value Equity",
    "EnglishLongName": "Sela (4B) Israel Value Equity",
    "HebrewName": "סלע מניות ערך ישראל",
    "HebrewLongName": "סלע (4B) מניות ערך ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.59,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 2.3,
    "MonthYield": 7.39,
    "YearYield": 7.39,
    "Last12MonthYield": null,
    "ISIN": "IL0051417918"
  },
  {
    "Id": "TASE:5123815",
    "MayaId": "5123815",
    "Name": "Sela Stocks IL",
    "ShortName": "Sela Stocks IL",
    "Symbol": "TASE:5123815",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Sela (4B) Stocks IL",
    "EnglishLongName": "Sela (4B) Stocks IL",
    "HebrewName": "סלע מניות",
    "HebrewLongName": "סלע (4B) מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.49,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.99,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 82.1,
    "MonthYield": 8.77,
    "YearYield": 8.77,
    "Last12MonthYield": 53.33,
    "ISIN": "IL0051238157"
  },
  {
    "Id": "SLARL.TA",
    "MayaId": "1109644",
    "Name": "SELLA REAL EST",
    "ShortName": "SELLA CAPITAL REAL ESTATE LTD",
    "Symbol": "SLARL.TA",
    "TaseSymbol": "SLARL",
    "YahooId": "SLARL.TA",
    "EnglishName": "SELLA REAL EST",
    "EnglishLongName": "SELLA CAPITAL REAL ESTATE LTD",
    "HebrewName": "סלע נדלן",
    "HebrewLongName": "סלע קפיטל נדל\"ן בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1160.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.6,
    "YearYield": 0.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011096448"
  },
  {
    "Id": "TASE:5121868",
    "MayaId": "5121868",
    "Name": "SGM EUROPE EQUT",
    "ShortName": "SGM EUROPE EQUT",
    "Symbol": "TASE:5121868",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "SIGMA (4D) EUROPE STOCK DIVIDEND",
    "EnglishLongName": "SIGMA (4D) EUROPE STOCK DIVIDEND",
    "HebrewName": "סיגמא (4D) מניות דיבידנד",
    "HebrewLongName": "סיגמא (4D) מניות דיבידנד אירופה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.69,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.41,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Geographical stocks",
    "AssetValue": 53.1,
    "MonthYield": 4.01,
    "YearYield": 4.01,
    "Last12MonthYield": 21.05,
    "ISIN": "IL0051218688"
  },
  {
    "Id": "TASE:5113543",
    "MayaId": "5113543",
    "Name": "SGM GLOB EQUITY",
    "ShortName": "SGM GLOB EQUITY",
    "Symbol": "TASE:5113543",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "SIGMA (4D) GLOBAL EQUITY",
    "EnglishLongName": "SIGMA (4D) GLOBAL EQUITY",
    "HebrewName": "סיגמא 4D מניות חו\"ל",
    "HebrewLongName": "סיגמא (4D) מניות חו\"ל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.25,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.48,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 41.2,
    "MonthYield": 5.01,
    "YearYield": 5.01,
    "Last12MonthYield": 14.28,
    "ISIN": "IL0051135437"
  },
  {
    "Id": "TASE:5124045",
    "MayaId": "5124045",
    "Name": "SGM INTER $BOND",
    "ShortName": "SGM INTER $BOND",
    "Symbol": "TASE:5124045",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "SIGMA (0D)(!) INTERNATIONAL DOLLAR BONDS",
    "EnglishLongName": "SIGMA (0D)(!) INTERNATIONAL DOLLAR BONDS",
    "HebrewName": "סיגמא 0D ! אג\"ח דולר בינל",
    "HebrewLongName": "סיגמא (0D)(!) אג\"ח דולר בינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.08,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "Dollar Bond",
    "AssetValue": 96.6,
    "MonthYield": -1.0,
    "YearYield": -1.0,
    "Last12MonthYield": -8.14,
    "ISIN": "IL0051240450"
  },
  {
    "Id": "SHGR.TA",
    "MayaId": "1138379",
    "Name": "SHAGRIR",
    "ShortName": "SHAGRIR GROUP VEHICLE SERVICES LTD.",
    "Symbol": "SHGR.TA",
    "TaseSymbol": "SHGR",
    "YahooId": "SHGR.TA",
    "EnglishName": "SHAGRIR",
    "EnglishLongName": "SHAGRIR GROUP VEHICLE SERVICES LTD.",
    "HebrewName": "שגריר",
    "HebrewLongName": "קבוצת שגריר שירותי רכב בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1970.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 5.6,
    "YearYield": 5.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011383796"
  },
  {
    "Id": "SHMM.TA",
    "MayaId": "1176239",
    "Name": "SHAMAYM",
    "ShortName": "SHAMAYM IMPROVE LTD",
    "Symbol": "SHMM.TA",
    "TaseSymbol": "SHMM",
    "YahooId": "SHMM.TA",
    "EnglishName": "SHAMAYM",
    "EnglishLongName": "SHAMAYM IMPROVE LTD",
    "HebrewName": "שמיים",
    "HebrewLongName": "שמיים אימפרוב בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 153.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -7.7,
    "YearYield": -7.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011762395"
  },
  {
    "Id": "SHAN.TA",
    "MayaId": "1080837",
    "Name": "SHANIV",
    "ShortName": "SHANIV PAPER INDUSTRY LTD.",
    "Symbol": "SHAN.TA",
    "TaseSymbol": "SHAN",
    "YahooId": "SHAN.TA",
    "EnglishName": "SHANIV",
    "EnglishLongName": "SHANIV PAPER INDUSTRY LTD.",
    "HebrewName": "שניב",
    "HebrewLongName": "שניב תעשיות נייר בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 699.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 14.7,
    "YearYield": 14.7,
    "Last12MonthYield": null,
    "ISIN": "IL0010808371"
  },
  {
    "Id": "SPEN.TA",
    "MayaId": "1133875",
    "Name": "SHAPIR ENG",
    "ShortName": "SHAPIR ENGINEERING AND INDUSTRY LTD",
    "Symbol": "SPEN.TA",
    "TaseSymbol": "SPEN",
    "YahooId": "SPEN.TA",
    "EnglishName": "SHAPIR      ENG",
    "EnglishLongName": "SHAPIR ENGINEERING AND INDUSTRY LTD",
    "HebrewName": "שפיר הנדסה",
    "HebrewLongName": "שפיר הנדסה ותעשיה בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3108.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 2.2,
    "YearYield": 2.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011338758"
  },
  {
    "Id": "TASE:2",
    "MayaId": "2",
    "Name": "Shares",
    "ShortName": "Shares",
    "Symbol": "TASE:2",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Shares",
    "EnglishLongName": "Shares",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "SMNR.TA",
    "MayaId": "634030",
    "Name": "SHEMEN ESTATE",
    "ShortName": "SHEMEN YIELDING REAL ESTATE LTD.",
    "Symbol": "SMNR.TA",
    "TaseSymbol": "SMNR",
    "YahooId": "SMNR.TA",
    "EnglishName": "SHEMEN ESTATE",
    "EnglishLongName": "SHEMEN YIELDING REAL ESTATE LTD.",
    "HebrewName": "שמן נדלן",
    "HebrewLongName": "שמן נדל\"ן מניב בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1614.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 9.4,
    "YearYield": 9.4,
    "Last12MonthYield": null,
    "ISIN": "IL0006340306"
  },
  {
    "Id": "SBEN.TA",
    "MayaId": "1188242",
    "Name": "SHIKN&BINUI ENE",
    "ShortName": "SHIKUN & BINUI ENERGY LTD",
    "Symbol": "SBEN.TA",
    "TaseSymbol": "SBEN",
    "YahooId": "SBEN.TA",
    "EnglishName": "SHIKN&BINUI ENE",
    "EnglishLongName": "SHIKUN & BINUI ENERGY LTD",
    "HebrewName": "שוב אנרגיה",
    "HebrewLongName": "שיכון ובינוי אנרגיה בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 391.5,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Energy And Oil & Gas Exploration",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 11.4,
    "YearYield": 11.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011882425"
  },
  {
    "Id": "SKBN.TA",
    "MayaId": "1081942",
    "Name": "SHIKUN & BINUI",
    "ShortName": "SHIKUN & BINUI LTD.",
    "Symbol": "SKBN.TA",
    "TaseSymbol": "SKBN",
    "YahooId": "SKBN.TA",
    "EnglishName": "SHIKUN & BINUI",
    "EnglishLongName": "SHIKUN & BINUI LTD.",
    "HebrewName": "שיכון ובינוי",
    "HebrewLongName": "שיכון ובינוי בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1954.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 8.9,
    "YearYield": 8.9,
    "Last12MonthYield": null,
    "ISIN": "IL0010819428"
  },
  {
    "Id": "TASE:5127139",
    "MayaId": "5127139",
    "Name": "SHOFAN (2B) 20/80",
    "ShortName": "SHOFAN (2B) 20/80",
    "Symbol": "TASE:5127139",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "SHOFAN (2B) 20/80 IL",
    "EnglishLongName": "SHOFAN (2B) 20/80 IL",
    "HebrewName": "שופן 2B 20/80",
    "HebrewLongName": "שופן (2B)י 20/80",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.82,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.45,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 20.4,
    "MonthYield": 2.09,
    "YearYield": 2.09,
    "Last12MonthYield": 13.44,
    "ISIN": "IL0051271398"
  },
  {
    "Id": "TASE:5129382",
    "MayaId": "5129382",
    "Name": "Shofan Glat Bond",
    "ShortName": "Shofan Glat Bond",
    "Symbol": "TASE:5129382",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Shofan(OB) Glat Bond in supervision of Rav Vozner & Rav Karelitz Vaad Halacha IL",
    "EnglishLongName": "Shofan(OB) Glat Bond in supervision of Rav Vozner & Rav Karelitz Vaad Halacha IL",
    "HebrewName": "שופן אג\"ח גלאט",
    "HebrewLongName": "שופן (0B) אג\"ח גלאט בפקוח ועד ההלכה של הגר\"ש ואזנר והגר\"נ קרליץ",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 16.0,
    "MonthYield": 0.54,
    "YearYield": 0.54,
    "Last12MonthYield": 6.54,
    "ISIN": "IL0051293822"
  },
  {
    "Id": "SHOM.TA",
    "MayaId": "1082007",
    "Name": "SHOHAM BUSINESS",
    "ShortName": "E.N. SHOHAM BUSINESS LTD",
    "Symbol": "SHOM.TA",
    "TaseSymbol": "SHOM",
    "YahooId": "SHOM.TA",
    "EnglishName": "SHOHAM BUSINESS",
    "EnglishLongName": "E.N. SHOHAM BUSINESS LTD",
    "HebrewName": "שוהם ביזנס",
    "HebrewLongName": "א.נ שוהם ביזנס בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 854.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Financial Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -0.1,
    "YearYield": -0.1,
    "Last12MonthYield": null,
    "ISIN": "IL0010820079"
  },
  {
    "Id": "SHVL.TA",
    "MayaId": "1207968",
    "Name": "SHOVAL",
    "ShortName": "SHOVAL ENGINEERING AND CONSTRUCTION LTD",
    "Symbol": "SHVL.TA",
    "TaseSymbol": "SHVL",
    "YahooId": "SHVL.TA",
    "EnglishName": "SHOVAL",
    "EnglishLongName": "SHOVAL ENGINEERING AND CONSTRUCTION LTD",
    "HebrewName": "שובל",
    "HebrewLongName": "שובל הנדסה ובניין בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1131.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 23.4,
    "YearYield": 23.4,
    "Last12MonthYield": null,
    "ISIN": "IL0012079682"
  },
  {
    "Id": "SAE.TA",
    "MayaId": "777037",
    "Name": "SHUFERSAL",
    "ShortName": "SHUFERSAL LTD.",
    "Symbol": "SAE.TA",
    "TaseSymbol": "SAE",
    "YahooId": "SAE.TA",
    "EnglishName": "SHUFERSAL",
    "EnglishLongName": "SHUFERSAL LTD.",
    "HebrewName": "שופרסל",
    "HebrewLongName": "שופרסל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3977.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 2.5,
    "YearYield": 2.5,
    "Last12MonthYield": null,
    "ISIN": "IL0007770378"
  },
  {
    "Id": "TASE:5120704",
    "MayaId": "5120704",
    "Name": "SIGMA (0A)(!) MAN BOND",
    "ShortName": "SIGMA (0A)(!) MAN BOND",
    "Symbol": "TASE:5120704",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "SIGMA (0A)(!) MANAGED BOND PORTFOLIO IL",
    "EnglishLongName": "SIGMA (0A)(!) MANAGED BOND PORTFOLIO IL",
    "HebrewName": "סיגמא (0A)(!) תיק אג\"ח",
    "HebrewLongName": "סיגמא (0A)(!) תיק אג\"ח ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.76,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.23,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 70.8,
    "MonthYield": 0.76,
    "YearYield": 0.76,
    "Last12MonthYield": 6.41,
    "ISIN": "IL0051207046"
  },
  {
    "Id": "TASE:5120720",
    "MayaId": "5120720",
    "Name": "SIGMA (1B)(!) inv + 10%",
    "ShortName": "SIGMA (1B)(!) inv + 10%",
    "Symbol": "TASE:5120720",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "SIGMA (1B)(!) BONDS PORTFOLIO + 10% IL",
    "EnglishLongName": "SIGMA (1B)(!) BONDS PORTFOLIO + 10% IL",
    "HebrewName": "סיגמא תיק אגח + 10",
    "HebrewLongName": "סיגמא (1B)(!) תיק אג\"ח + 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 63.0,
    "MonthYield": 1.59,
    "YearYield": 1.59,
    "Last12MonthYield": 10.69,
    "ISIN": "IL0051207202"
  },
  {
    "Id": "TASE:5123096",
    "MayaId": "5123096",
    "Name": "SIGMA (2B) 70/30",
    "ShortName": "SIGMA (2B) 70/30",
    "Symbol": "TASE:5123096",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "SIGMA (2B) 70/30 IL",
    "EnglishLongName": "SIGMA (2B) 70/30 IL",
    "HebrewName": "סיגמא (2B)י 30/70",
    "HebrewLongName": "סיגמא (2B)י 30/70",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.61,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 1052.9,
    "MonthYield": 2.55,
    "YearYield": 2.55,
    "Last12MonthYield": 18.71,
    "ISIN": "IL0051230964"
  },
  {
    "Id": "TASE:5136627",
    "MayaId": "5136627",
    "Name": "SIGMA (2B) 80/20",
    "ShortName": "SIGMA (2B) 80/20",
    "Symbol": "TASE:5136627",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "SIGMA (2B) 80/20 IL",
    "EnglishLongName": "SIGMA (2B) 80/20 IL",
    "HebrewName": "סיגמא (2B)י 20/80",
    "HebrewLongName": "סיגמא (2B)י 20/80",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.51,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 870.0,
    "MonthYield": 2.1,
    "YearYield": 2.1,
    "Last12MonthYield": 15.39,
    "ISIN": "IL0051366271"
  },
  {
    "Id": "TASE:5125661",
    "MayaId": "5125661",
    "Name": "SIGMA (2B) 85/15 IL",
    "ShortName": "SIGMA (2B) 85/15 IL",
    "Symbol": "TASE:5125661",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "SIGMA (2B) 85/15 IL",
    "EnglishLongName": "SIGMA (2B) 85/15 IL",
    "HebrewName": "סיגמא (2B)י 15/85",
    "HebrewLongName": "סיגמא (2B)י 15/85",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.76,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.41,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 15% Equity",
    "AssetValue": 213.9,
    "MonthYield": 1.69,
    "YearYield": 1.69,
    "Last12MonthYield": 12.93,
    "ISIN": "IL0051256613"
  },
  {
    "Id": "TASE:5124060",
    "MayaId": "5124060",
    "Name": "SIGMA (2C) 25/75",
    "ShortName": "SIGMA (2C) 25/75",
    "Symbol": "TASE:5124060",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "SIGMA (2C) 25/75 IL",
    "EnglishLongName": "SIGMA (2C) 25/75 IL",
    "HebrewName": "סיגמא (2C)י 25/75",
    "HebrewLongName": "סיגמא (2C)י 25/75",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.49,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 25% Equity",
    "AssetValue": 41.1,
    "MonthYield": 2.67,
    "YearYield": 2.67,
    "Last12MonthYield": 16.23,
    "ISIN": "IL0051240609"
  },
  {
    "Id": "TASE:5125679",
    "MayaId": "5125679",
    "Name": "SIGMA (4D) Flexible",
    "ShortName": "SIGMA (4D) Flexible",
    "Symbol": "TASE:5125679",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "SIGMA (4D) Flexible",
    "EnglishLongName": "SIGMA (4D) Flexible",
    "HebrewName": "סיגמא (4D) גמישה",
    "HebrewLongName": "סיגמא (4D) גמישה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.25,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 334.4,
    "MonthYield": 8.19,
    "YearYield": 8.19,
    "Last12MonthYield": 62.37,
    "ISIN": "IL0051256795"
  },
  {
    "Id": "TASE:5133301",
    "MayaId": "5133301",
    "Name": "Sigma 50/50",
    "ShortName": "Sigma 50/50",
    "Symbol": "TASE:5133301",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Sigma (3D)' 50/50",
    "EnglishLongName": "Sigma (3D)' 50/50",
    "HebrewName": "סיגמא 50/50",
    "HebrewLongName": "סיגמא (3D)י 50/50",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.8,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - Max. Exposure over 30% Equity",
    "AssetValue": 34.7,
    "MonthYield": 3.9,
    "YearYield": 3.9,
    "Last12MonthYield": 26.27,
    "ISIN": "IL0051333016"
  },
  {
    "Id": "TASE:5109004",
    "MayaId": "5109004",
    "Name": "SIGMA 90/10",
    "ShortName": "SIGMA 90/10",
    "Symbol": "TASE:5109004",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "SIGMA (1B) 90/10 IL",
    "EnglishLongName": "SIGMA (1B) 90/10 IL",
    "HebrewName": "סיגמא 10/90",
    "HebrewLongName": "סיגמא (1B)י 10/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.4,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 571.1,
    "MonthYield": 1.5,
    "YearYield": 1.5,
    "Last12MonthYield": 11.27,
    "ISIN": "IL0051090046"
  },
  {
    "Id": "TASE:5141668",
    "MayaId": "5141668",
    "Name": "SIGMA BOND GRADED",
    "ShortName": "SIGMA BOND GRADED",
    "Symbol": "TASE:5141668",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "SIGMA (0B) BOND GRADED WITHOUT EQUITY IL",
    "EnglishLongName": "SIGMA (0B) BOND GRADED WITHOUT EQUITY IL",
    "HebrewName": "סיגמא אגח מדורג ללא מניות",
    "HebrewLongName": "סיגמא (0B) אג\"ח מדורג ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 0.5,
    "MonthYield": 0.54,
    "YearYield": 0.54,
    "Last12MonthYield": null,
    "ISIN": "IL0051416688"
  },
  {
    "Id": "TASE:5125653",
    "MayaId": "5125653",
    "Name": "SIGMA bond up to 12/2027",
    "ShortName": "SIGMA bond up to 12/2027",
    "Symbol": "TASE:5125653",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "SIGMA (0A) Bonds to Maturity up to 12/2027 IL",
    "EnglishLongName": "SIGMA (0A) Bonds to Maturity up to 12/2027 IL",
    "HebrewName": "סיגמא אג\"ח לפדיון 12/2027",
    "HebrewLongName": "סיגמא (0A) אג\"ח לפדיון עד 12/2027",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.13,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 113.9,
    "MonthYield": 0.28,
    "YearYield": 0.28,
    "Last12MonthYield": 4.61,
    "ISIN": "IL0051256530"
  },
  {
    "Id": "TASE:5138243",
    "MayaId": "5138243",
    "Name": "SIGMA BOND WITHOUT STOCK",
    "ShortName": "SIGMA BOND WITHOUT STOCK",
    "Symbol": "TASE:5138243",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "SIGMA (0B) BONDS WITHOUT STOCKS IL",
    "EnglishLongName": "SIGMA (0B) BONDS WITHOUT STOCKS IL",
    "HebrewName": "סיגמא אגח ללא מניות",
    "HebrewLongName": "סיגמא (0B) אג\"ח ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.25,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 34.0,
    "MonthYield": 0.59,
    "YearYield": 0.59,
    "Last12MonthYield": 6.9,
    "ISIN": "IL0051382435"
  },
  {
    "Id": "TASE:5141544",
    "MayaId": "5141544",
    "Name": "SIGMA BOND+30%",
    "ShortName": "SIGMA BOND+30%",
    "Symbol": "TASE:5141544",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "SIGMA (2B) BOND PROTOFLIO +30%",
    "EnglishLongName": "SIGMA (2B) BOND PROTOFLIO +30%",
    "HebrewName": "סיגמא תיק אג\"ח+30%",
    "HebrewLongName": "סיגמא (2B) תיק אג\"ח + 30%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 2.3,
    "MonthYield": 3.75,
    "YearYield": 3.75,
    "Last12MonthYield": null,
    "ISIN": "IL0051415441"
  },
  {
    "Id": "TASE:5113527",
    "MayaId": "5113527",
    "Name": "Sigma comb bonds + 20%",
    "ShortName": "Sigma comb bonds + 20%",
    "Symbol": "TASE:5113527",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "SIGMA (2A) COMBINED BONDS + 20% IL",
    "EnglishLongName": "SIGMA (2A) COMBINED BONDS + 20% IL",
    "HebrewName": "סיגמא אג\"ח משולבת + 20%",
    "HebrewLongName": "סיגמא (2A) אג\"ח משולבת + 20%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.85,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 126.7,
    "MonthYield": 2.0,
    "YearYield": 2.0,
    "Last12MonthYield": 12.7,
    "ISIN": "IL0051135270"
  },
  {
    "Id": "TASE:5108428",
    "MayaId": "5108428",
    "Name": "Sigma corporate bonds",
    "ShortName": "Sigma corporate bonds",
    "Symbol": "TASE:5108428",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "SIGMA (00)(!) CORPORATE BONDS IL",
    "EnglishLongName": "SIGMA (00)(!) CORPORATE BONDS IL",
    "HebrewName": "סיגמא 00 ! אג\"ח חברות",
    "HebrewLongName": "סיגמא (00)(!) אג\"ח חברות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 73.2,
    "MonthYield": 1.08,
    "YearYield": 1.08,
    "Last12MonthYield": 6.89,
    "ISIN": "IL0051084288"
  },
  {
    "Id": "TASE:5109871",
    "MayaId": "5109871",
    "Name": "Sigma general bonds",
    "ShortName": "Sigma general bonds",
    "Symbol": "TASE:5109871",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "SIGMA (00) GENERAL BONDS WITHOUT STOCKS IL",
    "EnglishLongName": "SIGMA (00) GENERAL BONDS WITHOUT STOCKS IL",
    "HebrewName": "סיגמא 00 אג כללי ללא מניו",
    "HebrewLongName": "סיגמא (00) אג\"ח כללי ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.49,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.29,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 35.2,
    "MonthYield": 0.52,
    "YearYield": 0.52,
    "Last12MonthYield": 6.37,
    "ISIN": "IL0051098718"
  },
  {
    "Id": "TASE:5101233",
    "MayaId": "5101233",
    "Name": "SIGMA GLOBAL VALUE STOCKS",
    "ShortName": "SIGMA GLOBAL VALUE STOCKS",
    "Symbol": "TASE:5101233",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "SIGMA (4D) GLOBAL VALUE STOCKS",
    "EnglishLongName": "SIGMA (4D) GLOBAL VALUE STOCKS",
    "HebrewName": "סיגמא מניות ערך גלובלי",
    "HebrewLongName": "סיגמא (4D) מניות ערך גלובלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.42,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 43.7,
    "MonthYield": 3.12,
    "YearYield": 3.12,
    "Last12MonthYield": -2.82,
    "ISIN": "IL0051012339"
  },
  {
    "Id": "TASE:5101399",
    "MayaId": "5101399",
    "Name": "SIGMA GOV BOND",
    "ShortName": "SIGMA GOV BOND",
    "Symbol": "TASE:5101399",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "SIGMA (0A) GOVERNMENT BONDS IL",
    "EnglishLongName": "SIGMA (0A) GOVERNMENT BONDS IL",
    "HebrewName": "סיגמא אג\"ח מדינה",
    "HebrewLongName": "סיגמא (0A) אג\"ח מדינה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.64,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.15,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - No Equity",
    "AssetValue": 160.5,
    "MonthYield": 0.45,
    "YearYield": 0.45,
    "Last12MonthYield": 5.19,
    "ISIN": "IL0051013998"
  },
  {
    "Id": "TASE:5123237",
    "MayaId": "5123237",
    "Name": "Sigma gov bond +10%",
    "ShortName": "Sigma gov bond +10%",
    "Symbol": "TASE:5123237",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "SIGMA (1A) GOVERNMENT BONDS + 10% IL",
    "EnglishLongName": "SIGMA (1A) GOVERNMENT BONDS + 10% IL",
    "HebrewName": "סיגמא 1A אג\"ח מדינה +%10",
    "HebrewLongName": "סיגמא (1A) אג\"ח מדינה + 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.67,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - up to 10% Equity",
    "AssetValue": 289.8,
    "MonthYield": 1.26,
    "YearYield": 1.26,
    "Last12MonthYield": 9.67,
    "ISIN": "IL0051232374"
  },
  {
    "Id": "TASE:5128673",
    "MayaId": "5128673",
    "Name": "SIGMA GOV CPI LINKED PLUS",
    "ShortName": "SIGMA GOV CPI-LINKED PLUS",
    "Symbol": "TASE:5128673",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "SIGMA (1A) GOVERNMENT CPI-LINKED PLUS IL",
    "EnglishLongName": "SIGMA (1A) GOVERNMENT CPI-LINKED PLUS IL",
    "HebrewName": "סיגמא מדינה צמודה פלוס",
    "HebrewLongName": "סיגמא (1A) מדינה צמודה פלוס",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.64,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.23,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked Government Bonds - Up to 10% Equity",
    "AssetValue": 1283.4,
    "MonthYield": 0.86,
    "YearYield": 0.86,
    "Last12MonthYield": 8.82,
    "ISIN": "IL0051286735"
  },
  {
    "Id": "TASE:5116041",
    "MayaId": "5116041",
    "Name": "SIGMA GOV SHEKEL",
    "ShortName": "SIGMA GOV SHEKEL",
    "Symbol": "TASE:5116041",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "SIGMA (00) NON-CPI LINKED GOVERNMENT IL BOND",
    "EnglishLongName": "SIGMA (00) NON-CPI LINKED GOVERNMENT IL BOND",
    "HebrewName": "סיגמא ממשלתי שקלי",
    "HebrewLongName": "סיגמא (00) ממשלתי שקלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.9,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.17,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Shekel Bonds - No Equity",
    "AssetValue": 30.1,
    "MonthYield": 0.6,
    "YearYield": 0.6,
    "Last12MonthYield": 5.03,
    "ISIN": "IL0051160419"
  },
  {
    "Id": "TASE:5130612",
    "MayaId": "5130612",
    "Name": "Sigma gov upto5 no sto",
    "ShortName": "Sigma gov upto5 no sto",
    "Symbol": "TASE:5130612",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Sigma (0A) government IL up to 5 years without stocks",
    "EnglishLongName": "Sigma (0A) government IL up to 5 years without stocks",
    "HebrewName": "סיגמא מדינה עד 5 ללא מניו",
    "HebrewLongName": "סיגמא (0A) מדינה עד 5 שנים ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.55,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.22,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - No Equity",
    "AssetValue": 486.7,
    "MonthYield": 0.55,
    "YearYield": 0.55,
    "Last12MonthYield": 5.88,
    "ISIN": "IL0051306129"
  },
  {
    "Id": "TASE:5115514",
    "MayaId": "5115514",
    "Name": "SIGMA GOVERNMENT +20%",
    "ShortName": "SIGMA GOVERNMENT +20%",
    "Symbol": "TASE:5115514",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "SIGMA (2B) GOVERNMENT IL + 20%",
    "EnglishLongName": "SIGMA (2B) GOVERNMENT IL + 20%",
    "HebrewName": "סיגמא מדינה +20%",
    "HebrewLongName": "סיגמא (2B) מדינה + 20%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.43,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bonds - General - Up to 20% Equity",
    "AssetValue": 738.8,
    "MonthYield": 1.84,
    "YearYield": 1.84,
    "Last12MonthYield": 14.03,
    "ISIN": "IL0051155146"
  },
  {
    "Id": "TASE:5120613",
    "MayaId": "5120613",
    "Name": "SIGMA Israel Equity",
    "ShortName": "SIGMA Israel Equity",
    "Symbol": "TASE:5120613",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "SIGMA (4C) Israel Equity IL",
    "EnglishLongName": "SIGMA (4C) Israel Equity IL",
    "HebrewName": "סיגמא מניות ישראל",
    "HebrewLongName": "סיגמא (4C) מניות ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.59,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.8,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 1277.0,
    "MonthYield": 8.5,
    "YearYield": 8.5,
    "Last12MonthYield": 77.11,
    "ISIN": "IL0051206139"
  },
  {
    "Id": "TASE:5115506",
    "MayaId": "5115506",
    "Name": "Sigma rating model",
    "ShortName": "Sigma rating model",
    "Symbol": "TASE:5115506",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "SIGMA (00)(!) INTERNAL RATING MODEL IL",
    "EnglishLongName": "SIGMA (00)(!) INTERNAL RATING MODEL IL",
    "HebrewName": "סיגמא 00 ! דירוג פנימי",
    "HebrewLongName": "סיגמא (00)(!) מודל דירוג פנימי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.27,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.26,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 55.7,
    "MonthYield": 0.56,
    "YearYield": 0.56,
    "Last12MonthYield": 6.45,
    "ISIN": "IL0051155062"
  },
  {
    "Id": "TASE:5107321",
    "MayaId": "5107321",
    "Name": "SIGMA SHKL BND A @HIGHER",
    "ShortName": "SIGMA SHKL BND A @HIGHER",
    "Symbol": "TASE:5107321",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "SIGMA (00) SHEKEL BOND A @ HIGHER IL",
    "EnglishLongName": "SIGMA (00) SHEKEL BOND A @ HIGHER IL",
    "HebrewName": "סיגמא בונד שקלי A ומעלה",
    "HebrewLongName": "סיגמא (00) בונד שקלי A ומעלה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.31,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Shekel Corporate and Convertibles - No Equity",
    "AssetValue": 50.6,
    "MonthYield": 0.88,
    "YearYield": 0.88,
    "Last12MonthYield": 7.5,
    "ISIN": "IL0051073216"
  },
  {
    "Id": "TASE:5108048",
    "MayaId": "5108048",
    "Name": "SIGMA SOLID SHEKEL +10%",
    "ShortName": "SIGMA SOLID SHEKEL +10%",
    "Symbol": "TASE:5108048",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "SIGMA (1A) SOLID SHEKEL IL +10%",
    "EnglishLongName": "SIGMA (1A) SOLID SHEKEL IL +10%",
    "HebrewName": "סיגמא שקלית סולידית + 10%",
    "HebrewLongName": "סיגמא (1A) שקלית סולידית + 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 66.6,
    "MonthYield": 1.51,
    "YearYield": 1.51,
    "Last12MonthYield": 10.35,
    "ISIN": "IL0051080484"
  },
  {
    "Id": "TASE:5141643",
    "MayaId": "5141643",
    "Name": "SIGMA TLV 125 EQUITY",
    "ShortName": "SIGMA TLV 125 EQUITY",
    "Symbol": "TASE:5141643",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "SIGMA (4B) TLV 125 EQUITY IL",
    "EnglishLongName": "SIGMA (4B) TLV 125 EQUITY IL",
    "HebrewName": "סיגמא מניות ת\"א 125",
    "HebrewLongName": "סיגמא (4B) מניות ת\"א 125",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.25,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 0.5,
    "MonthYield": 11.01,
    "YearYield": 11.01,
    "Last12MonthYield": null,
    "ISIN": "IL0051416431"
  },
  {
    "Id": "TASE:5106968",
    "MayaId": "5106968",
    "Name": "SIGMA TLV 125 ESG",
    "ShortName": "SIGMA TLV 125 ESG",
    "Symbol": "TASE:5106968",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "SIGMA (4B) TLV 125 ESG MODEL IL",
    "EnglishLongName": "SIGMA (4B) TLV 125 ESG MODEL IL",
    "HebrewName": "סיגמא תא ESG 125",
    "HebrewLongName": "סיגמא (4B) ת\"א 125 מודל ESG",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.45,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.18,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 26.9,
    "MonthYield": 8.14,
    "YearYield": 8.14,
    "Last12MonthYield": 67.61,
    "ISIN": "IL0051069685"
  },
  {
    "Id": "TASE:5141650",
    "MayaId": "5141650",
    "Name": "SIGMA VALUE EQUITY",
    "ShortName": "SIGMA VALUE EQUITY",
    "Symbol": "TASE:5141650",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "SIGMA (4B) VALUE EQUITY IL",
    "EnglishLongName": "SIGMA (4B) VALUE EQUITY IL",
    "HebrewName": "סיגמא מניות ערך",
    "HebrewLongName": "סיגמא (4B) מניות ערך",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.25,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 2.3,
    "MonthYield": 9.78,
    "YearYield": 9.78,
    "Last12MonthYield": null,
    "ISIN": "IL0051416506"
  },
  {
    "Id": "SLCL.TA",
    "MayaId": "1097054",
    "Name": "SILVER CASTLE",
    "ShortName": "SILVER CASTLE HOLDINGS LTD",
    "Symbol": "SLCL.TA",
    "TaseSymbol": "SLCL",
    "YahooId": "SLCL.TA",
    "EnglishName": "SILVER CASTLE",
    "EnglishLongName": "SILVER CASTLE HOLDINGS LTD",
    "HebrewName": "סילבר קסטל",
    "HebrewLongName": "סילבר קסטל אחזקות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 747.8,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Financial Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -13.5,
    "YearYield": -13.5,
    "Last12MonthYield": null,
    "ISIN": "IL0010970544"
  },
  {
    "Id": "SKLN.TA",
    "MayaId": "1131556",
    "Name": "SKYLINE",
    "ShortName": "SKYLINE INVESTMENTS INC.",
    "Symbol": "SKLN.TA",
    "TaseSymbol": "SKLN",
    "YahooId": "SKLN.TA",
    "EnglishName": "SKYLINE",
    "EnglishLongName": "SKYLINE INVESTMENTS INC.",
    "HebrewName": "סקייליין",
    "HebrewLongName": "סקייליין אינווסטמנטס אינק",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 520.1,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -2.9,
    "YearYield": -2.9,
    "Last12MonthYield": null,
    "ISIN": "CA83084Y1007"
  },
  {
    "Id": "SLRM.TA",
    "MayaId": "1177518",
    "Name": "SLRM",
    "ShortName": "SOLROM HOLDINGS LTD",
    "Symbol": "SLRM.TA",
    "TaseSymbol": "SLRM",
    "YahooId": "SLRM.TA",
    "EnglishName": "SLRM",
    "EnglishLongName": "SOLROM HOLDINGS LTD",
    "HebrewName": "סולרום החז",
    "HebrewLongName": "סולרום החזקות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1842.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 41.3,
    "YearYield": 41.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011775181"
  },
  {
    "Id": "SOFW.TA",
    "MayaId": "1175439",
    "Name": "SOFWAVE",
    "ShortName": "SOFWAVE MEDICAL LTD",
    "Symbol": "SOFW.TA",
    "TaseSymbol": "SOFW",
    "YahooId": "SOFW.TA",
    "EnglishName": "SOFWAVE",
    "EnglishLongName": "SOFWAVE MEDICAL LTD",
    "HebrewName": "סופווייב",
    "HebrewLongName": "סופווייב מדיקל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3326.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 26.8,
    "YearYield": 26.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011754392"
  },
  {
    "Id": "SOLR.TA",
    "MayaId": "1172287",
    "Name": "SOLAER",
    "ShortName": "SOLAER RENEWABLE ENERGIES LTD",
    "Symbol": "SOLR.TA",
    "TaseSymbol": "SOLR",
    "YahooId": "SOLR.TA",
    "EnglishName": "SOLAER",
    "EnglishLongName": "SOLAER RENEWABLE ENERGIES LTD",
    "HebrewName": "סולאיר",
    "HebrewLongName": "סולאיר אנרגיות מתחדשות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 6220.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 8.1,
    "YearYield": 8.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011722878"
  },
  {
    "Id": "SOLT.TA",
    "MayaId": "169011",
    "Name": "SOLTERRA",
    "ShortName": "SOLTERRA ENERGY LTD",
    "Symbol": "SOLT.TA",
    "TaseSymbol": "SOLT",
    "YahooId": "SOLT.TA",
    "EnglishName": "SOLTERRA",
    "EnglishLongName": "SOLTERRA ENERGY LTD",
    "HebrewName": "סולטרה אנרגיה",
    "HebrewLongName": "סולטרה אנרגיה בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 304.9,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 2.7,
    "YearYield": 2.7,
    "Last12MonthYield": null,
    "ISIN": "IL0001690119"
  },
  {
    "Id": "SONR.TA",
    "MayaId": "1226877",
    "Name": "SONOL",
    "ShortName": "SONOL REAL ESTATE AND INVESTMENTS LTD",
    "Symbol": "SONR.TA",
    "TaseSymbol": "SONR",
    "YahooId": "SONR.TA",
    "EnglishName": "SONOL",
    "EnglishLongName": "SONOL REAL ESTATE AND INVESTMENTS LTD",
    "HebrewName": "סונול נדלן",
    "HebrewLongName": "סונול נדל\"ן והשקעות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4157.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -3.5,
    "YearYield": -3.5,
    "Last12MonthYield": null,
    "ISIN": "IL0012268772"
  },
  {
    "Id": "SONO.TA",
    "MayaId": "1170539",
    "Name": "SONOVIA",
    "ShortName": "SONOVIA LTD",
    "Symbol": "SONO.TA",
    "TaseSymbol": "SONO",
    "YahooId": "SONO.TA",
    "EnglishName": "SONOVIA",
    "EnglishLongName": "SONOVIA LTD",
    "HebrewName": "סונוביה",
    "HebrewLongName": "סונוביה בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 51.5,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.6,
    "YearYield": 1.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011705394"
  },
  {
    "Id": "SCC.TA",
    "MayaId": "1092345",
    "Name": "SPACE COM",
    "ShortName": "SPACE-COMMUNICATION LTD.",
    "Symbol": "SCC.TA",
    "TaseSymbol": "SCC",
    "YahooId": "SCC.TA",
    "EnglishName": "SPACE COM",
    "EnglishLongName": "SPACE-COMMUNICATION LTD.",
    "HebrewName": "חלל תקשורת",
    "HebrewLongName": "חלל-תקשורת בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 321.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 21.3,
    "YearYield": 21.3,
    "Last12MonthYield": null,
    "ISIN": "IL0010923451"
  },
  {
    "Id": "SPDV.TA",
    "MayaId": "1178284",
    "Name": "SPEEDVALUE",
    "ShortName": "SPEEDVALUE LTD",
    "Symbol": "SPDV.TA",
    "TaseSymbol": "SPDV",
    "YahooId": "SPDV.TA",
    "EnglishName": "SPEEDVALUE",
    "EnglishLongName": "SPEEDVALUE LTD",
    "HebrewName": "ספידווליו",
    "HebrewLongName": "ספידווליו בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 341.1,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 16.0,
    "YearYield": 16.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011782849"
  },
  {
    "Id": "SPRG.TA",
    "MayaId": "1097344",
    "Name": "SPRING",
    "ShortName": "SPRING VENTURES LTD",
    "Symbol": "SPRG.TA",
    "TaseSymbol": "SPRG",
    "YahooId": "SPRG.TA",
    "EnglishName": "SPRING",
    "EnglishLongName": "SPRING VENTURES LTD",
    "HebrewName": "ספרינג",
    "HebrewLongName": "ספרינג ונצ'רס בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 559.2,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -1.9,
    "YearYield": -1.9,
    "Last12MonthYield": null,
    "ISIN": "IL0010973449"
  },
  {
    "Id": "SPNTC.TA",
    "MayaId": "1090117",
    "Name": "SPUNTECH",
    "ShortName": "N.R. SPUNTECH INDUSTRIES LTD.",
    "Symbol": "SPNTC.TA",
    "TaseSymbol": "SPNTC",
    "YahooId": "SPNTC.TA",
    "EnglishName": "SPUNTECH",
    "EnglishLongName": "N.R. SPUNTECH INDUSTRIES LTD.",
    "HebrewName": "ספאנטק",
    "HebrewLongName": "נ.ר. ספאנטק תעשיות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 353.8,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -0.9,
    "YearYield": -0.9,
    "Last12MonthYield": null,
    "ISIN": "IL0010901176"
  },
  {
    "Id": "STG.TA",
    "MayaId": "550012",
    "Name": "STG",
    "ShortName": "STG INTERNATIONAL LTD.",
    "Symbol": "STG.TA",
    "TaseSymbol": "STG",
    "YahooId": "STG.TA",
    "EnglishName": "STG",
    "EnglishLongName": "STG INTERNATIONAL LTD.",
    "HebrewName": "אסטיגי",
    "HebrewLongName": "אס.טי.ג'י. אינטרנשיונל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 7000.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 20.2,
    "YearYield": 20.2,
    "Last12MonthYield": null,
    "ISIN": "IL0005500124"
  },
  {
    "Id": "STRG.TA",
    "MayaId": "1122654",
    "Name": "STORAGE DROP",
    "ShortName": "STORAGE DROP STORAGE TECHNOLOGIES LTD",
    "Symbol": "STRG.TA",
    "TaseSymbol": "STRG",
    "YahooId": "STRG.TA",
    "EnglishName": "STORAGE DROP",
    "EnglishLongName": "STORAGE DROP STORAGE TECHNOLOGIES LTD",
    "HebrewName": "סטורג' דרופ",
    "HebrewLongName": "סטורג' דרופ טכנולוגיות אחסון בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 60.2,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 14.5,
    "YearYield": 14.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011226540"
  },
  {
    "Id": "STRS.TA",
    "MayaId": "746016",
    "Name": "STRAUSS GROUP",
    "ShortName": "STRAUSS GROUP LTD.",
    "Symbol": "STRS.TA",
    "TaseSymbol": "STRS",
    "YahooId": "STRS.TA",
    "EnglishName": "STRAUSS GROUP",
    "EnglishLongName": "STRAUSS GROUP LTD.",
    "HebrewName": "שטראוס",
    "HebrewLongName": "שטראוס גרופ בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 11710.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 6.3,
    "YearYield": 6.3,
    "Last12MonthYield": null,
    "ISIN": "IL0007460160"
  },
  {
    "Id": "STRW.TA",
    "MayaId": "1205913",
    "Name": "STRAWBERRY INC",
    "ShortName": "STRAWBERRY FIELDS REIT,INC",
    "Symbol": "STRW.TA",
    "TaseSymbol": "STRW",
    "YahooId": "STRW.TA",
    "EnglishName": "STRAWBERRY INC",
    "EnglishLongName": "STRAWBERRY FIELDS REIT,INC",
    "HebrewName": "סטרוברי אינק",
    "HebrewLongName": "סטרוברי פילדס ריט, אינק",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4284.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 3.0,
    "YearYield": 3.0,
    "Last12MonthYield": null,
    "ISIN": "US8631821019"
  },
  {
    "Id": "SFRN.TA",
    "MayaId": "1181569",
    "Name": "SUFRIN",
    "ShortName": "SUFRIN HOLDINGS LTD",
    "Symbol": "SFRN.TA",
    "TaseSymbol": "SFRN",
    "YahooId": "SFRN.TA",
    "EnglishName": "SUFRIN",
    "EnglishLongName": "SUFRIN HOLDINGS LTD",
    "HebrewName": "סופרין",
    "HebrewLongName": "סופרין אחזקות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 783.6,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 7.4,
    "YearYield": 7.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011815698"
  },
  {
    "Id": "SUGT.TA",
    "MayaId": "1233014",
    "Name": "SUGAT",
    "ShortName": "SUGAT GROUP LTD",
    "Symbol": "SUGT.TA",
    "TaseSymbol": "SUGT",
    "YahooId": "SUGT.TA",
    "EnglishName": "SUGAT",
    "EnglishLongName": "SUGAT GROUP LTD",
    "HebrewName": "סוגת",
    "HebrewLongName": "קבוצת סוגת בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2098.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 3.7,
    "YearYield": 3.7,
    "Last12MonthYield": null,
    "ISIN": "IL0012330143"
  },
  {
    "Id": "SMT.TA",
    "MayaId": "1081686",
    "Name": "SUMMIT",
    "ShortName": "SUMMIT REAL ESTATE HOLDINGS LTD",
    "Symbol": "SMT.TA",
    "TaseSymbol": "SMT",
    "YahooId": "SMT.TA",
    "EnglishName": "SUMMIT",
    "EnglishLongName": "SUMMIT REAL ESTATE HOLDINGS LTD",
    "HebrewName": "סאמיט",
    "HebrewLongName": "סאמיט אחזקות נדל\"ן בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 6432.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 5.8,
    "YearYield": 5.8,
    "Last12MonthYield": null,
    "ISIN": "IL0010816861"
  },
  {
    "Id": "SNFL.TA",
    "MayaId": "1098755",
    "Name": "SUNFLOWER",
    "ShortName": "SUNFLOWER SUSTAINABLE INVESTMENTS LTD.",
    "Symbol": "SNFL.TA",
    "TaseSymbol": "SNFL",
    "YahooId": "SNFL.TA",
    "EnglishName": "SUNFLOWER",
    "EnglishLongName": "SUNFLOWER SUSTAINABLE INVESTMENTS LTD.",
    "HebrewName": "סאנפלאואר",
    "HebrewLongName": "סאנפלאואר השקעות מתחדשות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 960.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 8.3,
    "YearYield": 8.3,
    "Last12MonthYield": null,
    "ISIN": "IL0010987555"
  },
  {
    "Id": "SNCM.TA",
    "MayaId": "1082353",
    "Name": "SUNY COMMUN",
    "ShortName": "SUNY CELLULAR COMMUNICATION LTD",
    "Symbol": "SNCM.TA",
    "TaseSymbol": "SNCM",
    "YahooId": "SNCM.TA",
    "EnglishName": "SUNY COMMUN",
    "EnglishLongName": "SUNY CELLULAR COMMUNICATION LTD",
    "HebrewName": "סאני תקשורת",
    "HebrewLongName": "סאני תקשורת סלולרית בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 156.1,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -2.7,
    "YearYield": -2.7,
    "Last12MonthYield": null,
    "ISIN": "IL0010823537"
  },
  {
    "Id": "SPGS.TA",
    "MayaId": "1166917",
    "Name": "SUPERGAS POWER",
    "ShortName": "SUPERGAS POWER (2019) LTD",
    "Symbol": "SPGS.TA",
    "TaseSymbol": "SPGS",
    "YahooId": "SPGS.TA",
    "EnglishName": "SUPERGAS POWER",
    "EnglishLongName": "SUPERGAS POWER (2019) LTD",
    "HebrewName": "סופרגז פאוור",
    "HebrewLongName": "סופרגז פאוור (2019) בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2398.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Energy And Oil & Gas Exploration",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -0.8,
    "YearYield": -0.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011669178"
  },
  {
    "Id": "SNEL.TA",
    "MayaId": "1084953",
    "Name": "SYNEL",
    "ShortName": "SYNEL PAYWAY M.L.L LTD",
    "Symbol": "SNEL.TA",
    "TaseSymbol": "SNEL",
    "YahooId": "SNEL.TA",
    "EnglishName": "SYNEL",
    "EnglishLongName": "SYNEL PAYWAY M.L.L LTD",
    "HebrewName": "סינאל",
    "HebrewLongName": "סינאל מלל פייוויי בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1752.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -0.8,
    "YearYield": -0.8,
    "Last12MonthYield": null,
    "ISIN": "IL0010849532"
  },
  {
    "Id": "TASE:5127105",
    "MayaId": "5127105",
    "Name": "T.F (1A) GOVERNMENT 2Y+5%",
    "ShortName": "T.F (1A) GOVERNMENT 2Y+5%",
    "Symbol": "TASE:5127105",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tamir Fishman (1A) Government Up To 2 YEARS+5% IL",
    "EnglishLongName": "Tamir Fishman (1A) Government Up To 2 YEARS+5% IL",
    "HebrewName": "ת.פ. (1A) ממשלתי+5%",
    "HebrewLongName": "תמיר פישמן (1A) ממשלתי עד שנתיים +5%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.55,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.13,
    "Sector": "",
    "Industry": "",
    "ManagerName": "TAMIR FISHMAN MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - up to 10% Equity",
    "AssetValue": 96.1,
    "MonthYield": 0.58,
    "YearYield": 0.58,
    "Last12MonthYield": 6.77,
    "ISIN": "IL0051271059"
  },
  {
    "Id": "TASE:5115811",
    "MayaId": "5115811",
    "Name": "T.F (1B) 10/90 IL",
    "ShortName": "T.F (1B) 10/90 IL",
    "Symbol": "TASE:5115811",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tamir Fishman (1B) 10/90 IL",
    "EnglishLongName": "Tamir Fishman (1B) 10/90 IL",
    "HebrewName": "ת.פ (1B)י 10/90",
    "HebrewLongName": "תמיר פישמן (1B)י 10/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.4,
    "Sector": "",
    "Industry": "",
    "ManagerName": "TAMIR FISHMAN MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 107.6,
    "MonthYield": 1.26,
    "YearYield": 1.26,
    "Last12MonthYield": 10.31,
    "ISIN": "IL0051158116"
  },
  {
    "Id": "TASE:5120464",
    "MayaId": "5120464",
    "Name": "T.F (1D) Floating Bond",
    "ShortName": "T.F (1D) Floating Bond",
    "Symbol": "TASE:5120464",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tamir Fishman (1D) Floating Rate Global Bond",
    "EnglishLongName": "Tamir Fishman (1D) Floating Rate Global Bond",
    "HebrewName": "ת.פ (1D) אג\"ח חו\"ל משתנה",
    "HebrewLongName": "תמיר פישמן (1D) אג\"ח חו\"ל בריבית משתנה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.85,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.84,
    "Sector": "",
    "Industry": "",
    "ManagerName": "TAMIR FISHMAN MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Bond",
    "AssetValue": 59.1,
    "MonthYield": 0.23,
    "YearYield": 0.23,
    "Last12MonthYield": -3.36,
    "ISIN": "IL0051204647"
  },
  {
    "Id": "TASE:5104518",
    "MayaId": "5104518",
    "Name": "T.F (2B) 15/85 IL",
    "ShortName": "T.F (2B) 15/85 IL",
    "Symbol": "TASE:5104518",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tamir Fishman (2B) 15/85 IL",
    "EnglishLongName": "Tamir Fishman (2B) 15/85 IL",
    "HebrewName": "ת.פ (2B)י 15/85",
    "HebrewLongName": "תמיר פישמן (2B)י 15/85",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.41,
    "Sector": "",
    "Industry": "",
    "ManagerName": "TAMIR FISHMAN MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 15% Equity",
    "AssetValue": 599.8,
    "MonthYield": 1.12,
    "YearYield": 1.12,
    "Last12MonthYield": 12.33,
    "ISIN": "IL0051045180"
  },
  {
    "Id": "TASE:5120522",
    "MayaId": "5120522",
    "Name": "T.F (4C) Equity IL",
    "ShortName": "T.F (4C) Equity IL",
    "Symbol": "TASE:5120522",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tamir Fishman (4C) Equity IL",
    "EnglishLongName": "Tamir Fishman (4C) Equity IL",
    "HebrewName": "ת.פ (4C) מניות",
    "HebrewLongName": "תמיר פישמן (4C) מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.79,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.14,
    "Sector": "",
    "Industry": "",
    "ManagerName": "TAMIR FISHMAN MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 2116.9,
    "MonthYield": 8.2,
    "YearYield": 8.2,
    "Last12MonthYield": 73.75,
    "ISIN": "IL0051205222"
  },
  {
    "Id": "TASE:5118666",
    "MayaId": "5118666",
    "Name": "T.F Government Plus",
    "ShortName": "T.F Government Plus",
    "Symbol": "TASE:5118666",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tamir Fishman (0A) Government Plus IL",
    "EnglishLongName": "Tamir Fishman (0A) Government Plus IL",
    "HebrewName": "ת.פ אג\"ח מדינה פלוס",
    "HebrewLongName": "תמיר פישמן (0A) אג\"ח מדינה פלוס",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.55,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "TAMIR FISHMAN MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - No Equity",
    "AssetValue": 20.8,
    "MonthYield": 0.52,
    "YearYield": 0.52,
    "Last12MonthYield": 5.77,
    "ISIN": "IL0051186661"
  },
  {
    "Id": "TASE:5132568",
    "MayaId": "5132568",
    "Name": "T.F(0B)(!) Corp Bond IL",
    "ShortName": "T.F(0B)(!) Corp Bond IL",
    "Symbol": "TASE:5132568",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tamir Fishman (0B)(!) Corporate Bond IL",
    "EnglishLongName": "Tamir Fishman (0B)(!) Corporate Bond IL",
    "HebrewName": "ת.פ (0B)(!) אג\"ח חברות",
    "HebrewLongName": "תמיר פישמן (0B)(!) אג\"ח חברות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.55,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "TAMIR FISHMAN MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 46.0,
    "MonthYield": 0.92,
    "YearYield": 0.92,
    "Last12MonthYield": 6.45,
    "ISIN": "IL0051325681"
  },
  {
    "Id": "TASE:5127121",
    "MayaId": "5127121",
    "Name": "T.F(2C) Tik 3 BenLeumi IL",
    "ShortName": "T.F(2C) Tik 3 BenLeumi IL",
    "Symbol": "TASE:5127121",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tamir Fishman (2C) Following Tik 3 Bank Ben Leumi IL",
    "EnglishLongName": "Tamir Fishman (2C) Following Tik 3 Bank Ben Leumi IL",
    "HebrewName": "ת.פ (2C) תיק 3 הבינלאומי",
    "HebrewLongName": "תמיר פישמן (2C) עוקבת תיק 3 הבנק הבינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.45,
    "Sector": "",
    "Industry": "",
    "ManagerName": "TAMIR FISHMAN MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 681.2,
    "MonthYield": 0.88,
    "YearYield": 0.88,
    "Last12MonthYield": 11.96,
    "ISIN": "IL0051271216"
  },
  {
    "Id": "TASE:137",
    "MayaId": "137",
    "Name": "TA 125",
    "ShortName": "TA-125",
    "Symbol": "TASE:137",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA 125",
    "EnglishLongName": "TA-125",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:189",
    "MayaId": "189",
    "Name": "TA 125 Equal Weight",
    "ShortName": "TA 125 Equal Weight",
    "Symbol": "TASE:189",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA 125 Equal Weight",
    "EnglishLongName": "TA 125 Equal Weight",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:185",
    "MayaId": "185",
    "Name": "TA 125 Fossil Free",
    "ShortName": "TA-125 Fossil Free",
    "Symbol": "TASE:185",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA 125 Fossil Free",
    "EnglishLongName": "TA-125 Fossil Free",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:142",
    "MayaId": "142",
    "Name": "TA 35",
    "ShortName": "TA-35",
    "Symbol": "TASE:142",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA 35",
    "EnglishLongName": "TA-35",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:174",
    "MayaId": "174",
    "Name": "TA 35 Dollar",
    "ShortName": "TA-35 Dollar",
    "Symbol": "TASE:174",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA 35 Dollar",
    "EnglishLongName": "TA-35 Dollar",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:143",
    "MayaId": "143",
    "Name": "TA 90",
    "ShortName": "TA-90",
    "Symbol": "TASE:143",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA 90",
    "EnglishLongName": "TA-90",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:196",
    "MayaId": "196",
    "Name": "TA 90 and Banks",
    "ShortName": "TA 90 and Banks",
    "Symbol": "TASE:196",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA 90 and Banks",
    "EnglishLongName": "TA 90 and Banks",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:176",
    "MayaId": "176",
    "Name": "TA 90 and SME60 CAP 0.8%",
    "ShortName": "TA-90 and SME60 CAP 0.8%",
    "Symbol": "TASE:176",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA 90 and SME60 CAP 0.8%",
    "EnglishLongName": "TA-90 and SME60 CAP 0.8%",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:202",
    "MayaId": "202",
    "Name": "TA 90 EW PM",
    "ShortName": "TA-90 EW PM",
    "Symbol": "TASE:202",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA 90 EW PM",
    "EnglishLongName": "TA-90 EW PM",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:168",
    "MayaId": "168",
    "Name": "TA AllShare",
    "ShortName": "TA-AllShare",
    "Symbol": "TASE:168",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA AllShare",
    "EnglishLongName": "TA-AllShare",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:194",
    "MayaId": "194",
    "Name": "TA Bank",
    "ShortName": "TA-Bank",
    "Symbol": "TASE:194",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA Bank",
    "EnglishLongName": "TA-Bank",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:205",
    "MayaId": "205",
    "Name": "TA Banks & Insurance EW",
    "ShortName": "TA Banks & Insurance EW",
    "Symbol": "TASE:205",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA Banks & Insurance EW",
    "EnglishLongName": "TA Banks & Insurance EW",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:204",
    "MayaId": "204",
    "Name": "TA Banks 5 Equal Weight",
    "ShortName": "TA Banks 5-Equal Weight",
    "Symbol": "TASE:204",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA Banks 5 Equal Weight",
    "EnglishLongName": "TA Banks 5-Equal Weight",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:164",
    "MayaId": "164",
    "Name": "TA Banks5",
    "ShortName": "TA-Banks5",
    "Symbol": "TASE:164",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA Banks5",
    "EnglishLongName": "TA-Banks5",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:167",
    "MayaId": "167",
    "Name": "TA Biomed",
    "ShortName": "TA-Biomed",
    "Symbol": "TASE:167",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA Biomed",
    "EnglishLongName": "TA-Biomed",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:184",
    "MayaId": "184",
    "Name": "TA Cleantech",
    "ShortName": "TA-Cleantech",
    "Symbol": "TASE:184",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA Cleantech",
    "EnglishLongName": "TA-Cleantech",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:172",
    "MayaId": "172",
    "Name": "TA Communication & InformationTechnology",
    "ShortName": "TA-Communication & InformationTechnology",
    "Symbol": "TASE:172",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA Communication & InformationTechnology",
    "EnglishLongName": "TA-Communication & InformationTechnology",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:181",
    "MayaId": "181",
    "Name": "TA Construction",
    "ShortName": "TA-Construction",
    "Symbol": "TASE:181",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA Construction",
    "EnglishLongName": "TA-Construction",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:207",
    "MayaId": "207",
    "Name": "TA Defense",
    "ShortName": "TA Defense",
    "Symbol": "TASE:207",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA Defense",
    "EnglishLongName": "TA Defense",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:187",
    "MayaId": "187",
    "Name": "TA Dual Listing",
    "ShortName": "TA-Dual Listing",
    "Symbol": "TASE:187",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA Dual Listing",
    "EnglishLongName": "TA-Dual Listing",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:180",
    "MayaId": "180",
    "Name": "TA Energy Utilities",
    "ShortName": "TA-Energy Utilities",
    "Symbol": "TASE:180",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA Energy Utilities",
    "EnglishLongName": "TA-Energy Utilities",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:179",
    "MayaId": "179",
    "Name": "TA Family",
    "ShortName": "TA-Family",
    "Symbol": "TASE:179",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA Family",
    "EnglishLongName": "TA-Family",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:148",
    "MayaId": "148",
    "Name": "TA Finance",
    "ShortName": "TA-Finance",
    "Symbol": "TASE:148",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA Finance",
    "EnglishLongName": "TA-Finance",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:145",
    "MayaId": "145",
    "Name": "TA Global BlueTech",
    "ShortName": "TA Global-BlueTech",
    "Symbol": "TASE:145",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA Global BlueTech",
    "EnglishLongName": "TA Global-BlueTech",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:163",
    "MayaId": "163",
    "Name": "TA Growth",
    "ShortName": "TA-Growth",
    "Symbol": "TASE:163",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA Growth",
    "EnglishLongName": "TA-Growth",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:178",
    "MayaId": "178",
    "Name": "TA Industrials",
    "ShortName": "TA-Industrials",
    "Symbol": "TASE:178",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA Industrials",
    "EnglishLongName": "TA-Industrials",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:206",
    "MayaId": "206",
    "Name": "TA Infrastructures",
    "ShortName": "TA Infrastructures",
    "Symbol": "TASE:206",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA Infrastructures",
    "EnglishLongName": "TA Infrastructures",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:33",
    "MayaId": "33",
    "Name": "TA Insurance",
    "ShortName": "TA-Insurance",
    "Symbol": "TASE:33",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA Insurance",
    "EnglishLongName": "TA-Insurance",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:171",
    "MayaId": "171",
    "Name": "TA Insurance & Financial Services",
    "ShortName": "TA-Insurance & Financial Services",
    "Symbol": "TASE:171",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA Insurance & Financial Services",
    "EnglishLongName": "TA-Insurance & Financial Services",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:183",
    "MayaId": "183",
    "Name": "TA Investment Properties Abroad",
    "ShortName": "TA-Investment Properties Abroad",
    "Symbol": "TASE:183",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA Investment Properties Abroad",
    "EnglishLongName": "TA-Investment Properties Abroad",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:182",
    "MayaId": "182",
    "Name": "TA Investment Properties in Israel",
    "ShortName": "TA-Investment Properties in Israel",
    "Symbol": "TASE:182",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA Investment Properties in Israel",
    "EnglishLongName": "TA-Investment Properties in Israel",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:150",
    "MayaId": "150",
    "Name": "TA Maala",
    "ShortName": "TA-Maala",
    "Symbol": "TASE:150",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA Maala",
    "EnglishLongName": "TA-Maala",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:170",
    "MayaId": "170",
    "Name": "TA Oil & Gas",
    "ShortName": "TA-Oil & Gas",
    "Symbol": "TASE:170",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA Oil & Gas",
    "EnglishLongName": "TA-Oil & Gas",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:208",
    "MayaId": "208",
    "Name": "TA Real Estate 35",
    "ShortName": "TA Real Estate-35",
    "Symbol": "TASE:208",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA Real Estate 35",
    "EnglishLongName": "TA Real Estate-35",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:149",
    "MayaId": "149",
    "Name": "TA RealEstate",
    "ShortName": "TA-RealEstate",
    "Symbol": "TASE:149",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA RealEstate",
    "EnglishLongName": "TA-RealEstate",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:188",
    "MayaId": "188",
    "Name": "TA Retail",
    "ShortName": "TA-Retail",
    "Symbol": "TASE:188",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA Retail",
    "EnglishLongName": "TA-Retail",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:175",
    "MayaId": "175",
    "Name": "TA Rimon",
    "ShortName": "TA-Rimon",
    "Symbol": "TASE:175",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA Rimon",
    "EnglishLongName": "TA-Rimon",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:177",
    "MayaId": "177",
    "Name": "TA Sector Balance",
    "ShortName": "TA Sector-Balance",
    "Symbol": "TASE:177",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA Sector Balance",
    "EnglishLongName": "TA Sector-Balance",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:147",
    "MayaId": "147",
    "Name": "TA SME60",
    "ShortName": "TA-SME60",
    "Symbol": "TASE:147",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA SME60",
    "EnglishLongName": "TA-SME60",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:203",
    "MayaId": "203",
    "Name": "TA SME60 EW PM",
    "ShortName": "TA-SME60 EW PM",
    "Symbol": "TASE:203",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA SME60 EW PM",
    "EnglishLongName": "TA-SME60 EW PM",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:173",
    "MayaId": "173",
    "Name": "TA Tech Elite",
    "ShortName": "TA Tech - Elite",
    "Symbol": "TASE:173",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA Tech Elite",
    "EnglishLongName": "TA Tech - Elite",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:169",
    "MayaId": "169",
    "Name": "TA Technology",
    "ShortName": "TA-Technology",
    "Symbol": "TASE:169",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA Technology",
    "EnglishLongName": "TA-Technology",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "^TA125",
    "MayaId": null,
    "Name": "TA-125 Index",
    "ShortName": "TA-125 Index",
    "Symbol": "^TA125",
    "TaseSymbol": "",
    "YahooId": "^TA125",
    "EnglishName": "TA-125 Index",
    "EnglishLongName": "TA-125 Index",
    "HebrewName": "ת\"א 125",
    "HebrewLongName": "ת\"א 125",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": null,
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": ""
  },
  {
    "Id": "^TA35",
    "MayaId": null,
    "Name": "TA-35 Index",
    "ShortName": "TA-35 Index",
    "Symbol": "^TA35",
    "TaseSymbol": "",
    "YahooId": "^TA35",
    "EnglishName": "TA-35 Index",
    "EnglishLongName": "TA-35 Index",
    "HebrewName": "ת\"א 35",
    "HebrewLongName": "ת\"א 35",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": null,
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": ""
  },
  {
    "Id": "^TA90",
    "MayaId": null,
    "Name": "TA-90 Index",
    "ShortName": "TA-90 Index",
    "Symbol": "^TA90",
    "TaseSymbol": "",
    "YahooId": "^TA90",
    "EnglishName": "TA-90 Index",
    "EnglishLongName": "TA-90 Index",
    "HebrewName": "ת\"א 90",
    "HebrewLongName": "ת\"א 90",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": null,
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": ""
  },
  {
    "Id": "^TA-BANKS5",
    "MayaId": null,
    "Name": "TA-Banks5 Index",
    "ShortName": "TA-Banks5 Index",
    "Symbol": "^TA-BANKS5",
    "TaseSymbol": "",
    "YahooId": "^TA-BANKS5",
    "EnglishName": "TA-Banks5 Index",
    "EnglishLongName": "TA-Banks5 Index",
    "HebrewName": "ת\"א בנקים",
    "HebrewLongName": "ת\"א בנקים",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": null,
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": ""
  },
  {
    "Id": "^TA-GROWTH",
    "MayaId": null,
    "Name": "TA-Growth Index",
    "ShortName": "TA-Growth Index",
    "Symbol": "^TA-GROWTH",
    "TaseSymbol": "",
    "YahooId": "^TA-GROWTH",
    "EnglishName": "TA-Growth Index",
    "EnglishLongName": "TA-Growth Index",
    "HebrewName": "ת\"א צמיחה",
    "HebrewLongName": "ת\"א צמיחה",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": null,
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": ""
  },
  {
    "Id": "^TA-REALESTATE",
    "MayaId": null,
    "Name": "TA-Real Estate Index",
    "ShortName": "TA-Real Estate Index",
    "Symbol": "^TA-REALESTATE",
    "TaseSymbol": "",
    "YahooId": "^TA-REALESTATE",
    "EnglishName": "TA-Real Estate Index",
    "EnglishLongName": "TA-Real Estate Index",
    "HebrewName": "ת\"א נדל\"ן",
    "HebrewLongName": "ת\"א נדל\"ן",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": null,
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": ""
  },
  {
    "Id": "TASE:195",
    "MayaId": "195",
    "Name": "TA125 Value",
    "ShortName": "TA125-Value",
    "Symbol": "TASE:195",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA125 Value",
    "EnglishLongName": "TA125-Value",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:197",
    "MayaId": "197",
    "Name": "TA20",
    "ShortName": "TA20",
    "Symbol": "TASE:197",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA20",
    "EnglishLongName": "TA20",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:199",
    "MayaId": "199",
    "Name": "TA200",
    "ShortName": "TA200",
    "Symbol": "TASE:199",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA200",
    "EnglishLongName": "TA200",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:198",
    "MayaId": "198",
    "Name": "TA50 Real",
    "ShortName": "TA50 Real",
    "Symbol": "TASE:198",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TA50 Real",
    "EnglishLongName": "TA50 Real",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TCH-F110.TA",
    "MayaId": "1144070",
    "Name": "Tachlit SAL (00) All Bond Floating Shekel IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F110.TA",
    "TaseSymbol": "TCH.F110",
    "YahooId": "TCH-F110.TA",
    "EnglishName": "TC.ALLBONDFLO",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.אולבונדר.מש",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3989.16,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.2,
    "YearYield": 0.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011440703"
  },
  {
    "Id": "TCH-F181.TA",
    "MayaId": "1216480",
    "Name": "Tachlit SAL (00) Kosher Tel Bond 60 CPI Linked IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F181.TA",
    "TaseSymbol": "TCH.F181",
    "YahooId": "TCH-F181.TA",
    "EnglishName": "TC.KOTELBONDN60",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.כשתלבונד60",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.0001,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 414.52,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.3,
    "YearYield": 0.3,
    "Last12MonthYield": null,
    "ISIN": "IL0012164807"
  },
  {
    "Id": "TCH.FK2.TA",
    "MayaId": "1155118",
    "Name": "Tachlit SAL (00) Kosher Tel Bond CPI Linked SmallCap IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH.FK2.TA",
    "TaseSymbol": "TCH.FK2",
    "YahooId": "TCH.FK2.TA",
    "EnglishName": "TC.KOBONDLYETER",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.כשתלבנדציתר",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4248.37,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.4,
    "YearYield": 0.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011551186"
  },
  {
    "Id": "TCH-F10.TA",
    "MayaId": "1143791",
    "Name": "Tachlit SAL (00) Tel Bond 20 CPI Linked IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F10.TA",
    "TaseSymbol": "TCH.F10",
    "YahooId": "TCH-F10.TA",
    "EnglishName": "TC.TELBOND20",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.תלבונד20",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.02,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 404.5,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.3,
    "YearYield": 0.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011437915"
  },
  {
    "Id": "TCH-F26.TA",
    "MayaId": "1145093",
    "Name": "Tachlit SAL (00) Tel Bond 40 CPI Linked IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F26.TA",
    "TaseSymbol": "TCH.F26",
    "YahooId": "TCH-F26.TA",
    "EnglishName": "TC.TELBOND40",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.תלבונד40",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 384.91,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.5,
    "YearYield": 0.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011450934"
  },
  {
    "Id": "TCH-F27.TA",
    "MayaId": "1145101",
    "Name": "Tachlit SAL (00) Tel Bond 60 CPI Linked IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F27.TA",
    "TaseSymbol": "TCH.F27",
    "YahooId": "TCH-F27.TA",
    "EnglishName": "TC.TELBOND60",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.תלבונד60",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.02,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 396.99,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.3,
    "YearYield": 0.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011451015"
  },
  {
    "Id": "TCH-F138.TA",
    "MayaId": "1144823",
    "Name": "Tachlit SAL (00) Tel Bond CPI Linked Bank Without COCO IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F138.TA",
    "TaseSymbol": "TCH.F138",
    "YahooId": "TCH-F138.TA",
    "EnglishName": "TC.TELBONDLBANK",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.תלבונדצבנק",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.015,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3671.61,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.2,
    "YearYield": 0.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011448235"
  },
  {
    "Id": "TCH-F97.TA",
    "MayaId": "1144690",
    "Name": "Tachlit SAL (00) Tel Bond CPI Linked SmallCap IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F97.TA",
    "TaseSymbol": "TCH.F97",
    "YahooId": "TCH-F97.TA",
    "EnglishName": "TC.BONDLYETER",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.תלבנדציתר",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4242.69,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.3,
    "YearYield": 0.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011446908"
  },
  {
    "Id": "TCH-F158.TA",
    "MayaId": "1169333",
    "Name": "Tachlit SAL (00) Tel Bond Shekel 50 IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F158.TA",
    "TaseSymbol": "TCH.F158",
    "YahooId": "TCH-F158.TA",
    "EnglishName": "TC.TELBONDSH50",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.תלבונדשקלי50",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4314.69,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MEITAV ",
    "TrusteeName": "UBANK",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.9,
    "YearYield": 0.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011693335"
  },
  {
    "Id": "TCH-F34.TA",
    "MayaId": "1145184",
    "Name": "Tachlit SAL (00) Tel Bond Shekel IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F34.TA",
    "TaseSymbol": "TCH.F34",
    "YahooId": "TCH-F34.TA",
    "EnglishName": "TC.TELBONDNIS",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.תלבונדשקלי",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.02,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 433.3,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.9,
    "YearYield": 0.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011451841"
  },
  {
    "Id": "TCH-F87.TA",
    "MayaId": "1144591",
    "Name": "Tachlit SAL (00) Tel Gov CPI Linked 0 2 Years IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F87.TA",
    "TaseSymbol": "TCH.F87",
    "YahooId": "TCH-F87.TA",
    "EnglishName": "TC.GALIL02",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.גליל0-2",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.02,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2622.98,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government linked index  - short term",
    "AssetValue": null,
    "MonthYield": 0.1,
    "YearYield": 0.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011445918"
  },
  {
    "Id": "TCH-F25.TA",
    "MayaId": "1145085",
    "Name": "Tachlit SAL (00) Tel Gov CPI Linked 2 5 Years IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F25.TA",
    "TaseSymbol": "TCH.F25",
    "YahooId": "TCH-F25.TA",
    "EnglishName": "TC.GALIL2-5",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.גליל2-5",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.02,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 294.73,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government linked index - medium term",
    "AssetValue": null,
    "MonthYield": 0.1,
    "YearYield": 0.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011450850"
  },
  {
    "Id": "TCH-F33.TA",
    "MayaId": "1145176",
    "Name": "Tachlit SAL (00) Tel Gov CPI Linked 5 10 Years IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F33.TA",
    "TaseSymbol": "TCH.F33",
    "YahooId": "TCH-F33.TA",
    "EnglishName": "TC.GALIL5-10",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.גליל5-10",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.02,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 377.27,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government linked index  - long term",
    "AssetValue": null,
    "MonthYield": 0.1,
    "YearYield": 0.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011451767"
  },
  {
    "Id": "TCH-F88.TA",
    "MayaId": "1144609",
    "Name": "Tachlit SAL (00) Tel Gov Non Linked Fixed Int 0 2 Years IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F88.TA",
    "TaseSymbol": "TCH.F88",
    "YahooId": "TCH-F88.TA",
    "EnglishName": "TC.SHAHAR02",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.שחר0-2",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.02,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3484.03,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Fixed interest - short term",
    "AssetValue": null,
    "MonthYield": 0.4,
    "YearYield": 0.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011446098"
  },
  {
    "Id": "TCH-F31.TA",
    "MayaId": "1145150",
    "Name": "Tachlit SAL (00) Tel Gov Non Linked Fixed Int 2 5 Years IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F31.TA",
    "TaseSymbol": "TCH.F31",
    "YahooId": "TCH-F31.TA",
    "EnglishName": "TC.SHAHAR2-5",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.שחר2-5",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.02,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 453.28,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Fixed interest- medium term",
    "AssetValue": null,
    "MonthYield": 0.7,
    "YearYield": 0.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011451502"
  },
  {
    "Id": "TCH-F32.TA",
    "MayaId": "1145168",
    "Name": "Tachlit SAL (00) Tel Gov Non Linked Fixed Int 5+ Years IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F32.TA",
    "TaseSymbol": "TCH.F32",
    "YahooId": "TCH-F32.TA",
    "EnglishName": "TC.SHAHAR5+",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.שחר5+",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.02,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 646.74,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Fixed  interest- long term",
    "AssetValue": null,
    "MonthYield": 1.2,
    "YearYield": 1.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011451684"
  },
  {
    "Id": "TCH-F24.TA",
    "MayaId": "1145077",
    "Name": "Tachlit SAL (00) Tel Gov Non Linked Floating Interest Shekel IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F24.TA",
    "TaseSymbol": "TCH.F24",
    "YahooId": "TCH-F24.TA",
    "EnglishName": "TC.GILON",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.גילון",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 313.93,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government variable interest ",
    "AssetValue": null,
    "MonthYield": 0.3,
    "YearYield": 0.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011450777"
  },
  {
    "Id": "TCH-F14.TA",
    "MayaId": "1144971",
    "Name": "Tachlit SAL (00) Tel Gov Non Linked IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F14.TA",
    "TaseSymbol": "TCH.F14",
    "YahooId": "TCH-F14.TA",
    "EnglishName": "TC.GOVSHEKEL",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.ממשלתישקלי",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 432.16,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government shekels - other",
    "AssetValue": null,
    "MonthYield": 0.8,
    "YearYield": 0.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011449712"
  },
  {
    "Id": "TCH-F91.TA",
    "MayaId": "1144633",
    "Name": "Tachlit SAL (00) Tel Gov Short Term Treasury Bill IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F91.TA",
    "TaseSymbol": "TCH.F91",
    "YahooId": "TCH-F91.TA",
    "EnglishName": "TC.MKM",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.מקמ",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3151.73,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Makam (T-Bill)",
    "AssetValue": null,
    "MonthYield": 0.3,
    "YearYield": 0.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011446338"
  },
  {
    "Id": "TCH.FK1.TA",
    "MayaId": "1155100",
    "Name": "Tachlit SAL (00)(!) Kosher Tel Bond Yields Linked IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH.FK1.TA",
    "TaseSymbol": "TCH.FK1",
    "YahooId": "TCH.FK1.TA",
    "EnglishName": "TC.KOTELBONYLLI",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.כשתלבונתשוצמ",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.0001,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4438.7,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.1,
    "YearYield": 0.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011551004"
  },
  {
    "Id": "TCH-F75.TA",
    "MayaId": "1144377",
    "Name": "Tachlit SAL (00)(!) Tel Bond Global Shekel IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F75.TA",
    "TaseSymbol": "TCH.F75",
    "YahooId": "TCH-F75.TA",
    "EnglishName": "TC.TELBNDGLOBAL",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.תלבונדגלובל",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4682.47,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 1.0,
    "YearYield": 1.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011443772"
  },
  {
    "Id": "TCH-F64.TA",
    "MayaId": "1144260",
    "Name": "Tachlit SAL (00)(!) Tel Bond Yield NIS IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F64.TA",
    "TaseSymbol": "TCH.F64",
    "YahooId": "TCH-F64.TA",
    "EnglishName": "TC.TELBONDYIELD",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.תלבונדתשוש",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.02,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4312.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 1.0,
    "YearYield": 1.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011442600"
  },
  {
    "Id": "TCH-F41.TA",
    "MayaId": "1145259",
    "Name": "Tachlit SAL (00)(!) Tel Bond Yields Linked IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F41.TA",
    "TaseSymbol": "TCH.F41",
    "YahooId": "TCH-F41.TA",
    "EnglishName": "TC.TELBONYIELLN",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.תלבונדתשוצמו",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.02,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4436.39,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.0,
    "YearYield": 0.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011452591"
  },
  {
    "Id": "TCH-F177.TA",
    "MayaId": "1213461",
    "Name": "Tachlit Sal (0A) Rated Wide Spread IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F177.TA",
    "TaseSymbol": "TCH.F177",
    "YahooId": "TCH-F177.TA",
    "EnglishName": "TC.WIDESPREAD",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.מדורגפיזורחב",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1142.84,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate Bond - Shekel, Linked",
    "AssetValue": null,
    "MonthYield": 0.0,
    "YearYield": 0.0,
    "Last12MonthYield": null,
    "ISIN": "IL0012134610"
  },
  {
    "Id": "TCH-F104.TA",
    "MayaId": "1144013",
    "Name": "Tachlit SAL (0B) Tel Bond Composite IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F104.TA",
    "TaseSymbol": "TCH.F104",
    "YahooId": "TCH-F104.TA",
    "EnglishName": "TC.TELBONDMAGAR",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.תלבונדמאגר",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.015,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4218.99,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate Bond - Shekel, Linked",
    "AssetValue": null,
    "MonthYield": 0.5,
    "YearYield": 0.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011440133"
  },
  {
    "Id": "TCH-F7.TA",
    "MayaId": "1143767",
    "Name": "Tachlit SAL (40) EURO STOXX 50 Currency Hedged",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F7.TA",
    "TaseSymbol": "TCH.F7",
    "YahooId": "TCH-F7.TA",
    "EnglishName": "TC.STOXX50ILS",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.EUSTOXX50ממ",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 6634.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Europe - general",
    "AssetValue": null,
    "MonthYield": 2.3,
    "YearYield": 2.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011437675"
  },
  {
    "Id": "TCH-F3.TA",
    "MayaId": "1143726",
    "Name": "Tachlit SAL (40) INDEX ISRAEL BANKS IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F3.TA",
    "TaseSymbol": "TCH.F3",
    "YahooId": "TCH-F3.TA",
    "EnglishName": "TC.ISRBANKS",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.בנקיםישרא",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.02,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 7691.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Banking and non-banking credit",
    "AssetValue": null,
    "MonthYield": 9.7,
    "YearYield": 9.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011437261"
  },
  {
    "Id": "TCH.FK4.TA",
    "MayaId": "1155373",
    "Name": "Tachlit SAL (40) Kosher TA 125 IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH.FK4.TA",
    "TaseSymbol": "TCH.FK4",
    "YahooId": "TCH.FK4.TA",
    "EnglishName": "TC.KOTA125",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.כשתא125",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.0001,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3858.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Large & Mid Cap",
    "AssetValue": null,
    "MonthYield": 8.4,
    "YearYield": 8.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011553737"
  },
  {
    "Id": "TCH-F21.TA",
    "MayaId": "1145044",
    "Name": "Tachlit SAL (40) SME60 IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F21.TA",
    "TaseSymbol": "TCH.F21",
    "YahooId": "TCH-F21.TA",
    "EnglishName": "TC.TASME60",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.תאSME60",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 1.0,
    "TrusteeFee": 0.02,
    "VariableFee": 0.15,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1082.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Mid & Small Cap",
    "AssetValue": null,
    "MonthYield": 5.1,
    "YearYield": 5.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011450447"
  },
  {
    "Id": "TCH-F2.TA",
    "MayaId": "1143718",
    "Name": "Tachlit SAL (40) TA 125 IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F2.TA",
    "TaseSymbol": "TCH.F2",
    "YahooId": "TCH-F2.TA",
    "EnglishName": "TC.TA125",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.תא125",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.02,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3855.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Large & Mid Cap",
    "AssetValue": null,
    "MonthYield": 9.1,
    "YearYield": 9.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011437188"
  },
  {
    "Id": "TCH-F1.TA",
    "MayaId": "1143700",
    "Name": "Tachlit SAL (40) TA 35 IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F1.TA",
    "TaseSymbol": "TCH.F1",
    "YahooId": "TCH-F1.TA",
    "EnglishName": "TC.TA35",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.תא35",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.02,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3843.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "MIZRAHI TEFAHOT",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Large Cap",
    "AssetValue": null,
    "MonthYield": 9.1,
    "YearYield": 9.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011437006"
  },
  {
    "Id": "TCH-F9.TA",
    "MayaId": "1143783",
    "Name": "Tachlit SAL (40) TA 90 IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F9.TA",
    "TaseSymbol": "TCH.F9",
    "YahooId": "TCH-F9.TA",
    "EnglishName": "TC.TA90",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.תא90",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.02,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3666.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Mid Cap",
    "AssetValue": null,
    "MonthYield": 7.0,
    "YearYield": 7.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011437832"
  },
  {
    "Id": "TCH-F171.TA",
    "MayaId": "1176536",
    "Name": "Tachlit SAL (40) TA Construction IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F171.TA",
    "TaseSymbol": "TCH.F171",
    "YahooId": "TCH-F171.TA",
    "EnglishName": "TC.TACONS",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.תאבנייה",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2269.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Real estate and construction",
    "AssetValue": null,
    "MonthYield": 12.8,
    "YearYield": 12.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011765364"
  },
  {
    "Id": "TCH-F118.TA",
    "MayaId": "1144161",
    "Name": "Tachlit SAL (40) TA Finance IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F118.TA",
    "TaseSymbol": "TCH.F118",
    "YahooId": "TCH-F118.TA",
    "EnglishName": "TC.TAFINANCE",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.תאפיננסים",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.015,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 8809.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Financial",
    "AssetValue": null,
    "MonthYield": 8.1,
    "YearYield": 8.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011441610"
  },
  {
    "Id": "TCH-F85.TA",
    "MayaId": "1144575",
    "Name": "Tachlit SAL (40) TA Growth IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F85.TA",
    "TaseSymbol": "TCH.F85",
    "YahooId": "TCH-F85.TA",
    "EnglishName": "TC.TAGROWTH",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.תאצמיחה",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 1.0,
    "TrusteeFee": 0.03,
    "VariableFee": 0.2,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2075.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Small Cap",
    "AssetValue": null,
    "MonthYield": 7.5,
    "YearYield": 7.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011445751"
  },
  {
    "Id": "TCH-F172.TA",
    "MayaId": "1197698",
    "Name": "Tachlit SAL (40) TA Insurance",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F172.TA",
    "TaseSymbol": "TCH.F172",
    "YahooId": "TCH-F172.TA",
    "EnglishName": "TC.TAINSURANCE",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.תאביטוח",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.03,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 11920.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Insurance",
    "AssetValue": null,
    "MonthYield": 7.2,
    "YearYield": 7.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011976987"
  },
  {
    "Id": "TCH-F136.TA",
    "MayaId": "1144807",
    "Name": "Tachlit SAL (40) TA Oil & GAS IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F136.TA",
    "TaseSymbol": "TCH.F136",
    "YahooId": "TCH-F136.TA",
    "EnglishName": "TC.TAOILGAS",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.תאנפטוגז",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3011.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Oil, gas and energy",
    "AssetValue": null,
    "MonthYield": -1.6,
    "YearYield": -1.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011448078"
  },
  {
    "Id": "TCH-F83.TA",
    "MayaId": "1144559",
    "Name": "Tachlit SAL (40) TA REAL ESTATE IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F83.TA",
    "TaseSymbol": "TCH.F83",
    "YahooId": "TCH-F83.TA",
    "EnglishName": "TC.TAREALEST",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.תאנדלן",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.45,
    "TrusteeFee": 0.015,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1467.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Real estate and construction",
    "AssetValue": null,
    "MonthYield": 10.0,
    "YearYield": 10.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011445595"
  },
  {
    "Id": "TCH-F20.TA",
    "MayaId": "1145036",
    "Name": "Tachlit SAL (40) TEL DIV IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F20.TA",
    "TaseSymbol": "TCH.F20",
    "YahooId": "TCH-F20.TA",
    "EnglishName": "TC.TELDIV",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.תלדיב",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.02,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4587.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "All Cap",
    "AssetValue": null,
    "MonthYield": 5.7,
    "YearYield": 5.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011450363"
  },
  {
    "Id": "TCH-F108.TA",
    "MayaId": "1144054",
    "Name": "Tachlit SAL (4A) CAC 40 Currency Hedged",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F108.TA",
    "TaseSymbol": "TCH.F108",
    "YahooId": "TCH-F108.TA",
    "EnglishName": "TC.CAC40ILS",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.CAC40ממ",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 18430.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Europe - developed markets",
    "AssetValue": null,
    "MonthYield": 2.6,
    "YearYield": 2.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011440547"
  },
  {
    "Id": "TCH-F52.TA",
    "MayaId": "1143882",
    "Name": "Tachlit SAL (4A) comp S&PConsumer (50%) S&PStaples (50%) Currency Hedged Monthly",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F52.TA",
    "TaseSymbol": "TCH.F52",
    "YahooId": "TCH-F52.TA",
    "EnglishName": "TC.CMPDISCONILS",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.משמחז/בסיסממ",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 21000.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -1.7,
    "YearYield": -1.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011438822"
  },
  {
    "Id": "TCH-F40.TA",
    "MayaId": "1145242",
    "Name": "Tachlit SAL (4A) composite INT. Equity Currency Hedged Monthly",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F40.TA",
    "TaseSymbol": "TCH.F40",
    "YahooId": "TCH-F40.TA",
    "EnglishName": "TC.CMPFOREQILS",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.משמניותחולממ",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 47870.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.5,
    "YearYield": 1.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011452427"
  },
  {
    "Id": "TCH-F12.TA",
    "MayaId": "1143825",
    "Name": "Tachlit SAL (4A) DAX Currency Hedged",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F12.TA",
    "TaseSymbol": "TCH.F12",
    "YahooId": "TCH-F12.TA",
    "EnglishName": "TC.DAXILS",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.DAXממ",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 21110.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Europe - developed markets",
    "AssetValue": null,
    "MonthYield": 2.2,
    "YearYield": 2.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011438251"
  },
  {
    "Id": "TCH-F139.TA",
    "MayaId": "1144831",
    "Name": "Tachlit SAL (4A) DJ Internet Composite Currency Hedged",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F139.TA",
    "TaseSymbol": "TCH.F139",
    "YahooId": "TCH-F139.TA",
    "EnglishName": "TC.DJINTERNEILS",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.DJINTERNETממ",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 597.6,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Internet",
    "AssetValue": null,
    "MonthYield": -4.8,
    "YearYield": -4.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011448318"
  },
  {
    "Id": "TCH-F29.TA",
    "MayaId": "1145127",
    "Name": "Tachlit SAL (4A) FTSE 100 Currency Hedged",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F29.TA",
    "TaseSymbol": "TCH.F29",
    "YahooId": "TCH-F29.TA",
    "EnglishName": "TC.FTSE100ILS",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.FTSE100ממ",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 1.3,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 10990.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Europe - developed markets",
    "AssetValue": null,
    "MonthYield": 2.6,
    "YearYield": 2.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011451270"
  },
  {
    "Id": "TCH-F141.TA",
    "MayaId": "1144856",
    "Name": "Tachlit SAL (4A) FTSE 250 Currency Hedged",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F141.TA",
    "TaseSymbol": "TCH.F141",
    "YahooId": "TCH-F141.TA",
    "EnglishName": "TC.FTSE25MIDILS",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.FTSE250ממ",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 1.0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1650.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Europe - developed markets",
    "AssetValue": null,
    "MonthYield": 0.0,
    "YearYield": 0.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011448565"
  },
  {
    "Id": "TCH-F5.TA",
    "MayaId": "1143742",
    "Name": "Tachlit SAL (4A) Hang Seng China 100 Currency Hedged",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F5.TA",
    "TaseSymbol": "TCH.F5",
    "YahooId": "TCH-F5.TA",
    "EnglishName": "TC.HSCEIILS",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.HANGSENGCHממ",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 1.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 9144.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Asia and the Pacific - emerging markets",
    "AssetValue": null,
    "MonthYield": 3.3,
    "YearYield": 3.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011437428"
  },
  {
    "Id": "TCH-F176.TA",
    "MayaId": "1213578",
    "Name": "Tachlit SAL (4A) Index Israel MidCap Without Reits IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F176.TA",
    "TaseSymbol": "TCH.F176",
    "YahooId": "TCH-F176.TA",
    "EnglishName": "TC.MIDNOREIT",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.מידללאנדלן",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3240.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Mid Cap",
    "AssetValue": null,
    "MonthYield": 7.1,
    "YearYield": 7.1,
    "Last12MonthYield": null,
    "ISIN": "IL0012135781"
  },
  {
    "Id": "TCH-F178.TA",
    "MayaId": "1213420",
    "Name": "Tachlit SAL (4A) Index World Quality U.S.D Hedged",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F178.TA",
    "TaseSymbol": "TCH.F178",
    "YahooId": "TCH-F178.TA",
    "EnglishName": "TC.WORLDQUAL",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.WORLDQUAL",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3439.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.5,
    "YearYield": 1.5,
    "Last12MonthYield": null,
    "ISIN": "IL0012134206"
  },
  {
    "Id": "TCH-F150.TA",
    "MayaId": "1144948",
    "Name": "Tachlit SAL (4A) IPOX 100 US Currency Hedged",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F150.TA",
    "TaseSymbol": "TCH.F150",
    "YahooId": "TCH-F150.TA",
    "EnglishName": "TC.IPOX100USILS",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.IPOX100USממ",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 1.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5431.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": 1.9,
    "YearYield": 1.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011449480"
  },
  {
    "Id": "TCH-F71.TA",
    "MayaId": "1144336",
    "Name": "Tachlit SAL (4A) MSCI AC World U.S.D Hedged",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F71.TA",
    "TaseSymbol": "TCH.F71",
    "YahooId": "TCH-F71.TA",
    "EnglishName": "TC.MSCIAC",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.MSCIACWORLמד",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 456.4,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.9,
    "YearYield": 0.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011443368"
  },
  {
    "Id": "TCH-F102.TA",
    "MayaId": "1143866",
    "Name": "Tachlit SAL (4A) MSCI World U.S.D Hedged",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F102.TA",
    "TaseSymbol": "TCH.F102",
    "YahooId": "TCH-F102.TA",
    "EnglishName": "TC.MSCIWORLDILS",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.MSCIWORLDמד",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 10970.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Global - developed markets",
    "AssetValue": null,
    "MonthYield": 0.2,
    "YearYield": 0.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011438665"
  },
  {
    "Id": "TCH-F4.TA",
    "MayaId": "1143734",
    "Name": "Tachlit SAL (4A) NASDAQ 100 Currency Hedged",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F4.TA",
    "TaseSymbol": "TCH.F4",
    "YahooId": "TCH-F4.TA",
    "EnglishName": "TC.NASDAQ100",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.NDX100ממ",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 19850.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": -1.0,
    "YearYield": -1.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011437345"
  },
  {
    "Id": "TCH-F129.TA",
    "MayaId": "1144468",
    "Name": "Tachlit SAL (4A) NIKKEI 225 Currency Hedged",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F129.TA",
    "TaseSymbol": "TCH.F129",
    "YahooId": "TCH-F129.TA",
    "EnglishName": "TC.NIKKEI225ILS",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.NIKKEI225ממ",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.95,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 53900.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Asia and Pacific - developed markets",
    "AssetValue": null,
    "MonthYield": 6.3,
    "YearYield": 6.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011444689"
  },
  {
    "Id": "TCH-F39.TA",
    "MayaId": "1145234",
    "Name": "Tachlit SAL (4A) Russell 2000 Currency Hedged",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F39.TA",
    "TaseSymbol": "TCH.F39",
    "YahooId": "TCH-F39.TA",
    "EnglishName": "TC.RUSEL2000ILS",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.RUSS2000ממ",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2202.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": 5.8,
    "YearYield": 5.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011452344"
  },
  {
    "Id": "TCH-F11.TA",
    "MayaId": "1143817",
    "Name": "Tachlit SAL (4A) S&P 500 Currency Hedged",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F11.TA",
    "TaseSymbol": "TCH.F11",
    "YahooId": "TCH-F11.TA",
    "EnglishName": "TC.SP500ILS",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.SP500ממ",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5921.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": -0.3,
    "YearYield": -0.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011438178"
  },
  {
    "Id": "TCH-F147.TA",
    "MayaId": "1144914",
    "Name": "Tachlit SAL (4A) S&P 500 Dividend Aristocrats Currency Hedged",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F147.TA",
    "TaseSymbol": "TCH.F147",
    "YahooId": "TCH-F147.TA",
    "EnglishName": "TC.SP500ARISILS",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.SP500ARISTממ",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.9,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 702.5,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": 4.6,
    "YearYield": 4.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011449142"
  },
  {
    "Id": "TCH-F140.TA",
    "MayaId": "1144849",
    "Name": "Tachlit SAL (4A) S&P Financial Currency Hedged",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F140.TA",
    "TaseSymbol": "TCH.F140",
    "YahooId": "TCH-F140.TA",
    "EnglishName": "TC.SPUSFINANILS",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.SPFINANCEממ",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3864.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Financial",
    "AssetValue": null,
    "MonthYield": -2.9,
    "YearYield": -2.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011448490"
  },
  {
    "Id": "TCH-F49.TA",
    "MayaId": "1145333",
    "Name": "Tachlit SAL (4A) S&P Health Care Currency Hedged",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F49.TA",
    "TaseSymbol": "TCH.F49",
    "YahooId": "TCH-F49.TA",
    "EnglishName": "TC.SPHEALTHILS",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.SPHEALTHCAממ",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4561.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Health Care",
    "AssetValue": null,
    "MonthYield": 0.4,
    "YearYield": 0.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011453334"
  },
  {
    "Id": "TCH-F51.TA",
    "MayaId": "1143858",
    "Name": "Tachlit SAL (4A) S&P Industrial Currency Hedged",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F51.TA",
    "TaseSymbol": "TCH.F51",
    "YahooId": "TCH-F51.TA",
    "EnglishName": "TC.SPINDUSTRILS",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.SPINDUSTממ",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4229.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Industrials",
    "AssetValue": null,
    "MonthYield": 4.7,
    "YearYield": 4.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011438582"
  },
  {
    "Id": "TCH-F151.TA",
    "MayaId": "1144955",
    "Name": "Tachlit SAL (4A) S&P MidCap 400 Currency Hedged",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F151.TA",
    "TaseSymbol": "TCH.F151",
    "YahooId": "TCH-F151.TA",
    "EnglishName": "TC.SP400MIDILS",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.SPMIDCA400ממ",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.9,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3940.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": 4.8,
    "YearYield": 4.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011449555"
  },
  {
    "Id": "TCH-F56.TA",
    "MayaId": "1143965",
    "Name": "Tachlit SAL (4A) S&P Technology Currency Hedged",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F56.TA",
    "TaseSymbol": "TCH.F56",
    "YahooId": "TCH-F56.TA",
    "EnglishName": "TC.SPTECHNOILS",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.SPTECHממ",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 9716.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Technology",
    "AssetValue": null,
    "MonthYield": -1.1,
    "YearYield": -1.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011439655"
  },
  {
    "Id": "TCH-F101.TA",
    "MayaId": "1143833",
    "Name": "Tachlit SAL (4A) STOXX Europe 600 EURO Hedged",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F101.TA",
    "TaseSymbol": "TCH.F101",
    "YahooId": "TCH-F101.TA",
    "EnglishName": "TC.STOXEU600ILS",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.STOXX600מא",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 756.4,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Europe - general",
    "AssetValue": null,
    "MonthYield": 2.6,
    "YearYield": 2.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011438335"
  },
  {
    "Id": "TCH-F179.TA",
    "MayaId": "1217835",
    "Name": "Tachlit SAL (4D) CME CF Bitcoin Reference Rate (BRRNY)",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F179.TA",
    "TaseSymbol": "TCH.F179",
    "YahooId": "TCH-F179.TA",
    "EnglishName": "TC.SALBITCOIN",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.SALBITCOIN",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3841.63,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Digital Assets",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 4.6,
    "YearYield": 4.6,
    "Last12MonthYield": null,
    "ISIN": "IL0012178351"
  },
  {
    "Id": "TCH-F182.TA",
    "MayaId": "1220409",
    "Name": "Tachlit SAL (4D) CME CF Ethereum Reference Rate (ETHUSDNY)",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F182.TA",
    "TaseSymbol": "TCH.F182",
    "YahooId": "TCH-F182.TA",
    "EnglishName": "TC.ETHER-DOLLAR",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ ETHER-DOLLAR",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3425.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Digital Assets",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 6.2,
    "YearYield": 6.2,
    "Last12MonthYield": null,
    "ISIN": "IL0012204090"
  },
  {
    "Id": "TCH-F16.TA",
    "MayaId": "1144997",
    "Name": "Tachlit SAL (4D) composite Gov. Bond (80%) Foreign Equity (20%) Monthly IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F16.TA",
    "TaseSymbol": "TCH.F16",
    "YahooId": "TCH-F16.TA",
    "EnglishName": "TC.CMPGOVFEQ",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.משממשלתמניות",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 17120.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.5,
    "YearYield": 0.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011449977"
  },
  {
    "Id": "TCH-F134.TA",
    "MayaId": "1144518",
    "Name": "Tachlit SAL (4D) composite US Equity Monthly",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F134.TA",
    "TaseSymbol": "TCH.F134",
    "YahooId": "TCH-F134.TA",
    "EnglishName": "TC.CMPUSAEQ",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.משמניותארהב",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 40380.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.1,
    "YearYield": 1.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011445181"
  },
  {
    "Id": "TCH-F113.TA",
    "MayaId": "1144104",
    "Name": "Tachlit SAL (4D) DAX",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F113.TA",
    "TaseSymbol": "TCH.F113",
    "YahooId": "TCH-F113.TA",
    "EnglishName": "TC.DAX",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.DAX",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 8151.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Europe - developed markets",
    "AssetValue": null,
    "MonthYield": 0.0,
    "YearYield": 0.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011441040"
  },
  {
    "Id": "TCH-F79.TA",
    "MayaId": "1144427",
    "Name": "Tachlit SAL (4D) EURO STOXX 50",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F79.TA",
    "TaseSymbol": "TCH.F79",
    "YahooId": "TCH-F79.TA",
    "EnglishName": "TC.EUROSTOXX50",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.EUSTOXX50",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 28240.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Europe - general",
    "AssetValue": null,
    "MonthYield": 1.2,
    "YearYield": 1.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011444275"
  },
  {
    "Id": "TCH-F81.TA",
    "MayaId": "1144534",
    "Name": "Tachlit SAL (4D) Future Bloomberg Brent Crude",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F81.TA",
    "TaseSymbol": "TCH.F81",
    "YahooId": "TCH-F81.TA",
    "EnglishName": "TC.FUBRENTOIL",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.FUBBOIL",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 1.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1832.66,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Commodities",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 2.1,
    "YearYield": 2.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011445348"
  },
  {
    "Id": "TCH-F82.TA",
    "MayaId": "1144542",
    "Name": "Tachlit SAL (4D) Future Bloomberg Silver",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F82.TA",
    "TaseSymbol": "TCH.F82",
    "YahooId": "TCH-F82.TA",
    "EnglishName": "TC.FUSILVER",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.FUBBSIVER",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 1.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 15051.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Commodities",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 27.9,
    "YearYield": 27.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011445421"
  },
  {
    "Id": "TCH-F159.TA",
    "MayaId": "1169341",
    "Name": "Tachlit SAL (4D) Index Big Tech 30 USA",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F159.TA",
    "TaseSymbol": "TCH.F159",
    "YahooId": "TCH-F159.TA",
    "EnglishName": "TC.BIGTECHUSA",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.ביגטקארהב",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 7150.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Technology",
    "AssetValue": null,
    "MonthYield": -3.9,
    "YearYield": -3.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011693418"
  },
  {
    "Id": "TCH-F174.TA",
    "MayaId": "1189604",
    "Name": "Tachlit SAL (4D) Index World Growth",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F174.TA",
    "TaseSymbol": "TCH.F174",
    "YahooId": "TCH-F174.TA",
    "EnglishName": "TC.WORLDGROWTH",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.צמיחהעולמי",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5155.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.8,
    "YearYield": 0.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011896045"
  },
  {
    "Id": "TCH-F173.TA",
    "MayaId": "1189596",
    "Name": "Tachlit SAL (4D) Index World Value U.S.D Hedged",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F173.TA",
    "TaseSymbol": "TCH.F173",
    "YahooId": "TCH-F173.TA",
    "EnglishName": "TC.WORLDVALUE",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.ערךעולמי",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4579.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.8,
    "YearYield": 1.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011895963"
  },
  {
    "Id": "TCH-F155.TA",
    "MayaId": "1160159",
    "Name": "Tachlit SAL (4D) Indxx US Industrial Real Estate & Logistics",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F155.TA",
    "TaseSymbol": "TCH.F155",
    "YahooId": "TCH-F155.TA",
    "EnglishName": "TC.INDXREALLOG",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.INDXREALLOG",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4159.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "REIT &  Real Estate",
    "AssetValue": null,
    "MonthYield": 4.4,
    "YearYield": 4.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011601593"
  },
  {
    "Id": "TCH-F63.TA",
    "MayaId": "1144252",
    "Name": "Tachlit SAL (4D) ISE Cyber Security",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F63.TA",
    "TaseSymbol": "TCH.F63",
    "YahooId": "TCH-F63.TA",
    "EnglishName": "TC.ISECEYBER",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.ISECYBER",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2319.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Cyber Security",
    "AssetValue": null,
    "MonthYield": -3.0,
    "YearYield": -3.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011442527"
  },
  {
    "Id": "TCH-F94.TA",
    "MayaId": "1144666",
    "Name": "Tachlit SAL (4D) LBMA Gold Price AM",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F94.TA",
    "TaseSymbol": "TCH.F94",
    "YahooId": "TCH-F94.TA",
    "EnglishName": "TC.GOLDAMUSD",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.LBMAGOLDAM",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 1.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 12085.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Commodities",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 7.0,
    "YearYield": 7.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011446668"
  },
  {
    "Id": "TCH-F44.TA",
    "MayaId": "1145283",
    "Name": "Tachlit SAL (4D) MDAX",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F44.TA",
    "TaseSymbol": "TCH.F44",
    "YahooId": "TCH-F44.TA",
    "EnglishName": "TC.MDAX",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.MDAX",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 6461.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Europe - developed markets",
    "AssetValue": null,
    "MonthYield": 3.1,
    "YearYield": 3.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011452831"
  },
  {
    "Id": "TCH-F46.TA",
    "MayaId": "1145309",
    "Name": "Tachlit SAL (4D) MDAX Currency Hedged",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F46.TA",
    "TaseSymbol": "TCH.F46",
    "YahooId": "TCH-F46.TA",
    "EnglishName": "TC.MDAXILS",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.MDAXממ",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.85,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1719.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Europe - developed markets",
    "AssetValue": null,
    "MonthYield": 4.4,
    "YearYield": 4.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011453094"
  },
  {
    "Id": "TCH-F124.TA",
    "MayaId": "1144237",
    "Name": "Tachlit SAL (4D) MSCI AC World",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F124.TA",
    "TaseSymbol": "TCH.F124",
    "YahooId": "TCH-F124.TA",
    "EnglishName": "TC.MACIACM1WD",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.MSCIACWORLD",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 1.0,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3799.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -0.3,
    "YearYield": -0.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011442378"
  },
  {
    "Id": "TCH-F128.TA",
    "MayaId": "1144450",
    "Name": "Tachlit SAL (4D) MSCI Emerging Markets",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F128.TA",
    "TaseSymbol": "TCH.F128",
    "YahooId": "TCH-F128.TA",
    "EnglishName": "TC.MSCIEMERGING",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.MSCIEM",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.55,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2302.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Global - emerging markets",
    "AssetValue": null,
    "MonthYield": 4.6,
    "YearYield": 4.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011444507"
  },
  {
    "Id": "TCH-F114.TA",
    "MayaId": "1144112",
    "Name": "Tachlit SAL (4D) MSCI India",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F114.TA",
    "TaseSymbol": "TCH.F114",
    "YahooId": "TCH-F114.TA",
    "EnglishName": "TC.MSCIINDIA",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.MSCIINDIA",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 1.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 873.9,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Asia and the Pacific - emerging markets",
    "AssetValue": null,
    "MonthYield": -3.6,
    "YearYield": -3.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011441123"
  },
  {
    "Id": "TCH-F77.TA",
    "MayaId": "1144401",
    "Name": "Tachlit SAL (4D) NASDAQ 100",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F77.TA",
    "TaseSymbol": "TCH.F77",
    "YahooId": "TCH-F77.TA",
    "EnglishName": "TC.NASDAQ100",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.NDX100",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 41420.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": -1.9,
    "YearYield": -1.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011444010"
  },
  {
    "Id": "TCH-F80.TA",
    "MayaId": "1144526",
    "Name": "Tachlit SAL (4D) NASDAQ Biotechnology",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F80.TA",
    "TaseSymbol": "TCH.F80",
    "YahooId": "TCH-F80.TA",
    "EnglishName": "TC.NASDAQBIO",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.NDXBIO",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 1.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 15480.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Biotechnology",
    "AssetValue": null,
    "MonthYield": -0.3,
    "YearYield": -0.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011445264"
  },
  {
    "Id": "TCH-F78.TA",
    "MayaId": "1144419",
    "Name": "Tachlit SAL (4D) NIKKEI 225",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F78.TA",
    "TaseSymbol": "TCH.F78",
    "YahooId": "TCH-F78.TA",
    "EnglishName": "TC.NIKKEI225",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.NIKKEI225",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.03,
    "VariableFee": 0.15,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 27520.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Asia and Pacific - developed markets",
    "AssetValue": null,
    "MonthYield": 4.4,
    "YearYield": 4.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011444192"
  },
  {
    "Id": "TCH-F164.TA",
    "MayaId": "1170703",
    "Name": "Tachlit SAL (4D) PHLX Semiconductor Sector",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F164.TA",
    "TaseSymbol": "TCH.F164",
    "YahooId": "TCH-F164.TA",
    "EnglishName": "TC.XSOX",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.XSOX",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 8593.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Semiconductor",
    "AssetValue": null,
    "MonthYield": 7.3,
    "YearYield": 7.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011707036"
  },
  {
    "Id": "TCH-F131.TA",
    "MayaId": "1144484",
    "Name": "Tachlit SAL (4D) Russell 2000",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F131.TA",
    "TaseSymbol": "TCH.F131",
    "YahooId": "TCH-F131.TA",
    "EnglishName": "TC.RUSSELL2000",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.RUSS2000",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 9202.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": 5.2,
    "YearYield": 5.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011444846"
  },
  {
    "Id": "TCH-F76.TA",
    "MayaId": "1144385",
    "Name": "Tachlit SAL (4D) S&P 500",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F76.TA",
    "TaseSymbol": "TCH.F76",
    "YahooId": "TCH-F76.TA",
    "EnglishName": "TC.SP500",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.SP500",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 25500.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": -1.2,
    "YearYield": -1.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011443855"
  },
  {
    "Id": "TCH-F146.TA",
    "MayaId": "1144906",
    "Name": "Tachlit SAL (4D) S&P 500 Dividend Aristocrats",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F146.TA",
    "TaseSymbol": "TCH.F146",
    "YahooId": "TCH-F146.TA",
    "EnglishName": "TC.SP500ARISTO",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.SP500ARISTOO",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2824.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": 2.4,
    "YearYield": 2.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011449068"
  },
  {
    "Id": "TCH-F69.TA",
    "MayaId": "1144310",
    "Name": "Tachlit SAL (4D) S&P Aerospace & Defense",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F69.TA",
    "TaseSymbol": "TCH.F69",
    "YahooId": "TCH-F69.TA",
    "EnglishName": "TC.SPAERODEFILS",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.SPUSAD",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 16310.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Aerospace & Defense",
    "AssetValue": null,
    "MonthYield": 19.2,
    "YearYield": 19.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011443103"
  },
  {
    "Id": "TCH-F55.TA",
    "MayaId": "1143957",
    "Name": "Tachlit SAL (4D) S&P Consumer Discretionary",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F55.TA",
    "TaseSymbol": "TCH.F55",
    "YahooId": "TCH-F55.TA",
    "EnglishName": "TC.SPCONSUDIS",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.צריכהמחזSP",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 22500.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Consumer Discretionary",
    "AssetValue": null,
    "MonthYield": 1.4,
    "YearYield": 1.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011439572"
  },
  {
    "Id": "TCH-F57.TA",
    "MayaId": "1143981",
    "Name": "Tachlit SAL (4D) S&P Consumer Staples",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F57.TA",
    "TaseSymbol": "TCH.F57",
    "YahooId": "TCH-F57.TA",
    "EnglishName": "TC.SPCONSUMER",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.צריכהבסיסSP",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 11590.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Consumer Staples",
    "AssetValue": null,
    "MonthYield": 3.9,
    "YearYield": 3.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011439812"
  },
  {
    "Id": "TCH-F65.TA",
    "MayaId": "1144278",
    "Name": "Tachlit SAL (4D) S&P Energy",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F65.TA",
    "TaseSymbol": "TCH.F65",
    "YahooId": "TCH-F65.TA",
    "EnglishName": "TC.SPENERGY",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.SPENERGY",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.35,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 6272.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Energy",
    "AssetValue": null,
    "MonthYield": 5.7,
    "YearYield": 5.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011442782"
  },
  {
    "Id": "TCH-F50.TA",
    "MayaId": "1143841",
    "Name": "Tachlit SAL (4D) S&P Financial",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F50.TA",
    "TaseSymbol": "TCH.F50",
    "YahooId": "TCH-F50.TA",
    "EnglishName": "TC.SPFINANCE",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.SPFINANCE",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.45,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 15220.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Financial",
    "AssetValue": null,
    "MonthYield": -3.3,
    "YearYield": -3.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011438418"
  },
  {
    "Id": "TCH-F58.TA",
    "MayaId": "1143999",
    "Name": "Tachlit SAL (4D) S&P Health Care",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F58.TA",
    "TaseSymbol": "TCH.F58",
    "YahooId": "TCH-F58.TA",
    "EnglishName": "TC.SPHEALTH",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.SPHEALTHCA",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 18420.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Health Care",
    "AssetValue": null,
    "MonthYield": -0.2,
    "YearYield": -0.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011439994"
  },
  {
    "Id": "TCH-F100.TA",
    "MayaId": "1144724",
    "Name": "Tachlit SAL (4D) STOXX Europe 600",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F100.TA",
    "TaseSymbol": "TCH.F100",
    "YahooId": "TCH-F100.TA",
    "EnglishName": "TC.STOXX600EUR",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.STOXX600",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2945.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Europe - general",
    "AssetValue": null,
    "MonthYield": 0.9,
    "YearYield": 0.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011447245"
  },
  {
    "Id": "TCH-F93.TA",
    "MayaId": "1144658",
    "Name": "Tachlit SAL (60) Leveraged*2 TA 35 Monthly IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F93.TA",
    "TaseSymbol": "TCH.F93",
    "YahooId": "TCH-F93.TA",
    "EnglishName": "TC.LVRG*2TA35",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.תא35פי2",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 1.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 7097.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Leveraged",
    "SecondaryClassification": "Stocks in Israel",
    "AssetValue": null,
    "MonthYield": 18.8,
    "YearYield": 18.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011446585"
  },
  {
    "Id": "TCH-F98.TA",
    "MayaId": "1144708",
    "Name": "Tachlit SAL (60) Long Leveraged*3 TA 35 Monthly IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F98.TA",
    "TaseSymbol": "TCH.F98",
    "YahooId": "TCH-F98.TA",
    "EnglishName": "TC.LVRG*3TA35",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.תא35פי3",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 1.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 6320.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Leveraged",
    "SecondaryClassification": "Stocks in Israel",
    "AssetValue": null,
    "MonthYield": 29.0,
    "YearYield": 29.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011447088"
  },
  {
    "Id": "TCH-F99.TA",
    "MayaId": "1144716",
    "Name": "Tachlit SAL (60) Short Leveraged*2 TA 35 Monthly IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F99.TA",
    "TaseSymbol": "TCH.F99",
    "YahooId": "TCH-F99.TA",
    "EnglishName": "TC.SHORT*2TA35",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.חסתא35פי2",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 1.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 46.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Leveraged",
    "SecondaryClassification": "Stocks in Israel",
    "AssetValue": null,
    "MonthYield": -16.9,
    "YearYield": -16.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011447161"
  },
  {
    "Id": "TCH-F120.TA",
    "MayaId": "1144187",
    "Name": "Tachlit SAL (60) Short TA 35 (5677.6) IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F120.TA",
    "TaseSymbol": "TCH.F120",
    "YahooId": "TCH-F120.TA",
    "EnglishName": "TC.SHTA35",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.חסתא35",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 249.1,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Leveraged",
    "SecondaryClassification": "Stocks in Israel",
    "AssetValue": null,
    "MonthYield": 0.0,
    "YearYield": 0.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011441875"
  },
  {
    "Id": "TCH-F157.TA",
    "MayaId": "1161033",
    "Name": "Tachlit SAL (60) Short TA 90 (5767.86) IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F157.TA",
    "TaseSymbol": "TCH.F157",
    "YahooId": "TCH-F157.TA",
    "EnglishName": "TC.SH2TA90",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.חס2תא90",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 228.1,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Leveraged",
    "SecondaryClassification": "Stocks in Israel",
    "AssetValue": null,
    "MonthYield": -7.4,
    "YearYield": -7.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011610339"
  },
  {
    "Id": "TCH-F184.TA",
    "MayaId": "1221662",
    "Name": "Tachlit SAL Leveraged (6D) NASDAQ 100 x3 Monthly",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F184.TA",
    "TaseSymbol": "TCH.F184",
    "YahooId": "TCH-F184.TA",
    "EnglishName": "TC.NASDAQ100X3",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.NASDAQ100X3",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 1.45,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3311.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Leveraged",
    "SecondaryClassification": "Stocks Abroad",
    "AssetValue": null,
    "MonthYield": -5.0,
    "YearYield": -5.0,
    "Last12MonthYield": null,
    "ISIN": "IL0012216623"
  },
  {
    "Id": "TCH-F183.TA",
    "MayaId": "1221654",
    "Name": "Tachlit SAL Leveraged (6D) S&P 500 x3 Monthly",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH-F183.TA",
    "TaseSymbol": "TCH.F183",
    "YahooId": "TCH-F183.TA",
    "EnglishName": "TC.SP500X3",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.SP500X3",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 1.95,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3361.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "MEITAV ",
    "TrusteeName": "HERMETIC",
    "MainClassification": "Leveraged",
    "SecondaryClassification": "Stocks Abroad",
    "AssetValue": null,
    "MonthYield": 1.7,
    "YearYield": 1.7,
    "Last12MonthYield": null,
    "ISIN": "IL0012216540"
  },
  {
    "Id": "TCH.FK3.TA",
    "MayaId": "1155183",
    "Name": "Tachlit SAL(00) Kosher Tel Bond Shekel IL",
    "ShortName": "MEITAV MUTUAL FUNDS LTD",
    "Symbol": "TCH.FK3.TA",
    "TaseSymbol": "TCH.FK3",
    "YahooId": "TCH.FK3.TA",
    "EnglishName": "TC.KOTELBONDNIS",
    "EnglishLongName": "MEITAV MUTUAL FUNDS LTD",
    "HebrewName": "תכ.כשתלבונדשקלי",
    "HebrewLongName": "מיטב קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.0001,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 433.41,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "MEITAV ",
    "TrusteeName": "ALMGOR - BRIGHTMAN",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 1.0,
    "YearYield": 1.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011551830"
  },
  {
    "Id": "TASE:5140736",
    "MayaId": "5140736",
    "Name": "Tachlit TTF 150Small Mid",
    "ShortName": "Tachlit TTF 150Small-Mid",
    "Symbol": "TASE:5140736",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4A) Index 150 Small-Mid Cap Israel IL",
    "EnglishLongName": "Tachlit TTF (4A) Index 150 Small-Mid Cap Israel IL",
    "HebrewName": "תכלית TTF‏‏ 150 Small-Mid",
    "HebrewLongName": "תכלית TTFי (4A)י ‏אינדקס 150 Small-Mid Cap ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 7.4,
    "MonthYield": 7.44,
    "YearYield": 7.44,
    "Last12MonthYield": null,
    "ISIN": "IL0051407364"
  },
  {
    "Id": "TASE:5124425",
    "MayaId": "5124425",
    "Name": "Tachlit TTF 2 5 Balanced",
    "ShortName": "Tachlit TTF 2-5 Balanced",
    "Symbol": "TASE:5124425",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (00) Index Rated 2-5 Balanced IL",
    "EnglishLongName": "Tachlit TTF (00) Index Rated 2-5 Balanced IL",
    "HebrewName": "תכלית TTF אינד 2-5 מאוזן",
    "HebrewLongName": "תכלית TTF י(00) אינדקס מדורג 2-5 מאוזן",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.29,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 79.4,
    "MonthYield": 0.56,
    "YearYield": 0.56,
    "Last12MonthYield": 6.91,
    "ISIN": "IL0051244254"
  },
  {
    "Id": "TASE:5124417",
    "MayaId": "5124417",
    "Name": "Tachlit TTF 5+ Balanced",
    "ShortName": "Tachlit TTF 5+ Balanced",
    "Symbol": "TASE:5124417",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (00) Index Rated 5+ Balanced IL",
    "EnglishLongName": "Tachlit TTF (00) Index Rated 5+ Balanced IL",
    "HebrewName": "תכלית TTF אינד 5+ מאוזן",
    "HebrewLongName": "תכלית TTF י(00) אינדקס מדורג 5+ מאוזן",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.66,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 71.5,
    "MonthYield": 0.98,
    "YearYield": 0.98,
    "Last12MonthYield": 10.79,
    "ISIN": "IL0051244171"
  },
  {
    "Id": "TASE:5136023",
    "MayaId": "5136023",
    "Name": "TACHLIT TTF A AA Matu2028",
    "ShortName": "TACHLIT TTF A-AA Matu2028",
    "Symbol": "TASE:5136023",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (00) Index A-AA to Maturity 2028 (Rolling Every 3 Years) IL",
    "EnglishLongName": "Tachlit TTF (00) Index A-AA to Maturity 2028 (Rolling Every 3 Years) IL",
    "HebrewName": "תכלית TTF י A-AA לפד 2028",
    "HebrewLongName": "תכלית TTF י(00) אינדקס A-AA לפדיון 2028 (מתגלגל כל 3 שנים)",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 15.7,
    "MonthYield": 0.3,
    "YearYield": 0.3,
    "Last12MonthYield": 5.02,
    "ISIN": "IL0051360233"
  },
  {
    "Id": "TASE:5137328",
    "MayaId": "5137328",
    "Name": "Tachlit TTF AA AAA 0 3",
    "ShortName": "Tachlit TTF AA-AAA 0-3",
    "Symbol": "TASE:5137328",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (00) Index AA-AAA 0-3 – Low Financial leveraged Factor IL",
    "EnglishLongName": "Tachlit TTF (00) Index AA-AAA 0-3 – Low Financial leveraged Factor IL",
    "HebrewName": "תכלית AA-AAA TTF י0-3",
    "HebrewLongName": "תכלית TTF י(00) אינדקס AA-AAA י0-3 - פקטור מינוף פיננסי נמוך",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.12,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 48.1,
    "MonthYield": 0.27,
    "YearYield": 0.27,
    "Last12MonthYield": 5.38,
    "ISIN": "IL0051373285"
  },
  {
    "Id": "TASE:5128772",
    "MayaId": "5128772",
    "Name": "Tachlit TTF AllBond DOL",
    "ShortName": "Tachlit TTF AllBond-DOL",
    "Symbol": "TASE:5128772",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (0D) All-Bond U.S.D And TOP 5 Tel Bond 20 CPI-Linked IL",
    "EnglishLongName": "Tachlit TTF (0D) All-Bond U.S.D And TOP 5 Tel Bond 20 CPI-Linked IL",
    "HebrewName": "תכלית TTF י All Bond-דולר",
    "HebrewLongName": "תכלית TTFי (0D)י All-Bond דולר וטופ 5 בתל בונד-20 צמודות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.96,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 43.2,
    "MonthYield": -0.41,
    "YearYield": -0.41,
    "Last12MonthYield": -7.74,
    "ISIN": "IL0051287725"
  },
  {
    "Id": "TASE:5132162",
    "MayaId": "5132162",
    "Name": "TACHLIT TTF BigTec30USILS",
    "ShortName": "TACHLIT TTF BigTec30USILS",
    "Symbol": "TASE:5132162",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4A) Index Big Tech 30 USA Currency-Hedged",
    "EnglishLongName": "Tachlit TTF (4A) Index Big Tech 30 USA Currency-Hedged",
    "HebrewName": "תכלית TTF ביגטק30ארהב ממ",
    "HebrewLongName": "תכלית TTF (י4A) אינדקס ביג טק 30 ארה\"ב מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.23,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 242.5,
    "MonthYield": -0.57,
    "YearYield": -0.57,
    "Last12MonthYield": 18.04,
    "ISIN": "IL0051321623"
  },
  {
    "Id": "TASE:5139787",
    "MayaId": "5139787",
    "Name": "Tachlit TTF Bitcoin BRRNY",
    "ShortName": "Tachlit TTF Bitcoin BRRNY",
    "Symbol": "TASE:5139787",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4D) CME CF Bitcoin Reference Rate (BRRNY)",
    "EnglishLongName": "Tachlit TTF (4D) CME CF Bitcoin Reference Rate (BRRNY)",
    "HebrewName": "תכלית Bitcoin BRRNY TTF",
    "HebrewLongName": "תכלית TTF י(4D)י CME CF Bitcoin Reference Rate (BRRNY)",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 4.51,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Digital Assets",
    "SecondaryClassification": "Bitcoin",
    "AssetValue": 79.3,
    "MonthYield": 7.34,
    "YearYield": 7.34,
    "Last12MonthYield": -12.68,
    "ISIN": "IL0051397870"
  },
  {
    "Id": "TASE:5138623",
    "MayaId": "5138623",
    "Name": "TACHLIT TTF BlockchEco",
    "ShortName": "TACHLIT TTF BlockchEco",
    "Symbol": "TASE:5138623",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4D) Indxx Blockchain Ecosystem",
    "EnglishLongName": "Tachlit TTF (4D) Indxx Blockchain Ecosystem",
    "HebrewName": "תכליתBlockchain Ecosy TTF",
    "HebrewLongName": "תכלית TTF י(4D)י Indxx Blockchain Ecosystem",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.95,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 10.37,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 2.7,
    "MonthYield": 21.5,
    "YearYield": 21.5,
    "Last12MonthYield": 20.5,
    "ISIN": "IL0051386238"
  },
  {
    "Id": "TASE:5130158",
    "MayaId": "5130158",
    "Name": "TACHLIT TTF BND AA AAA",
    "ShortName": "TACHLIT TTF BND AA-AAA",
    "Symbol": "TASE:5130158",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (00) Index Tel Bond-CPI Linked AA-AAA IL",
    "EnglishLongName": "Tachlit TTF (00) Index Tel Bond-CPI Linked AA-AAA IL",
    "HebrewName": "תכלית TTF תלבונד צ AA-AAA",
    "HebrewLongName": "תכלית TTF י(00) תל בונד צמודות AA-AAA",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 192.5,
    "MonthYield": 0.26,
    "YearYield": 0.26,
    "Last12MonthYield": 6.79,
    "ISIN": "IL0051301583"
  },
  {
    "Id": "TASE:5130836",
    "MayaId": "5130836",
    "Name": "Tachlit TTF BND SH AA AAA",
    "ShortName": "Tachlit TTF BND SH AA-AAA",
    "Symbol": "TASE:5130836",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (00) Tel Bond-Shekel AA-AAA IL",
    "EnglishLongName": "Tachlit TTF (00) Tel Bond-Shekel AA-AAA IL",
    "HebrewName": "תכלית TTF תל בונד שAA-AAA",
    "HebrewLongName": "תכלית TTF י(00) תל בונד שקלי AA-AAA",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 157.3,
    "MonthYield": 0.84,
    "YearYield": 0.84,
    "Last12MonthYield": 8.25,
    "ISIN": "IL0051308364"
  },
  {
    "Id": "TASE:5135140",
    "MayaId": "5135140",
    "Name": "Tachlit TTF BND ShekeA IL",
    "ShortName": "Tachlit TTF BND ShekeA IL",
    "Symbol": "TASE:5135140",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (00) Tel-Bond Shekel A IL",
    "EnglishLongName": "Tachlit TTF (00) Tel-Bond Shekel A IL",
    "HebrewName": "תכלית TTF תל-בונד שקלי A",
    "HebrewLongName": "תכלית TTF י(00) תל בונד-שקלי A",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 198.8,
    "MonthYield": 0.98,
    "YearYield": 0.98,
    "Last12MonthYield": 6.67,
    "ISIN": "IL0051351406"
  },
  {
    "Id": "TASE:5133376",
    "MayaId": "5133376",
    "Name": "TACHLIT TTF BoCPIL A&UPIL",
    "ShortName": "TACHLIT TTF BoCPIL A&UPIL",
    "Symbol": "TASE:5133376",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (00) INDEX Israel CPI-Linked A&UP Spread factor From Gov Bonds IL",
    "EnglishLongName": "Tachlit TTF (00) INDEX Israel CPI-Linked A&UP Spread factor From Gov Bonds IL",
    "HebrewName": "תכלית TTF אגחצמוד A&UP",
    "HebrewLongName": "תכלית TTF י(00) אינדקס ישראל צמוד A ומעלה פקטור מרווח מאג\"ח ממשלתי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 120.2,
    "MonthYield": 0.25,
    "YearYield": 0.25,
    "Last12MonthYield": 6.77,
    "ISIN": "IL0051333768"
  },
  {
    "Id": "TASE:5132535",
    "MayaId": "5132535",
    "Name": "TACHLIT TTF BoIL A&UP IL",
    "ShortName": "TACHLIT TTF BoIL A&UP IL",
    "Symbol": "TASE:5132535",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (00) INDEX ISRAEL A&UP Spread factor From Gov Bonds IL",
    "EnglishLongName": "Tachlit TTF (00) INDEX ISRAEL A&UP Spread factor From Gov Bonds IL",
    "HebrewName": "תכלית TTF אגחישראל A&UP",
    "HebrewLongName": "תכלית TTF י(00) אינדקס ישראל A ומעלה פקטור מרווח מאג\"ח ממשלתי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 211.4,
    "MonthYield": 0.48,
    "YearYield": 0.48,
    "Last12MonthYield": 7.15,
    "ISIN": "IL0051325350"
  },
  {
    "Id": "TASE:5134390",
    "MayaId": "5134390",
    "Name": "TACHLIT TTF BoSH A&UP IL",
    "ShortName": "TACHLIT TTF BoSH A&UP IL",
    "Symbol": "TASE:5134390",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (00) INDEX Israel Non-Linked A&UP Spread factor From Govt Bonds IL",
    "EnglishLongName": "Tachlit TTF (00) INDEX Israel Non-Linked A&UP Spread factor From Govt Bonds IL",
    "HebrewName": "תכלית TTF אגחשקלי A&UP",
    "HebrewLongName": "תכלית TTF י(00) אינדקס ישראל שקלי A ומעלה פקטור מרווח מאג\"ח ממשלתי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 33.1,
    "MonthYield": 0.93,
    "YearYield": 0.93,
    "Last12MonthYield": 8.46,
    "ISIN": "IL0051343908"
  },
  {
    "Id": "TASE:5132923",
    "MayaId": "5132923",
    "Name": "TACHLIT TTF BTech CHN ILS",
    "ShortName": "TACHLIT TTF BTech CHN ILS",
    "Symbol": "TASE:5132923",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4D) Index Big Tech 30 CHINA U.S.D Hedged",
    "EnglishLongName": "Tachlit TTF (4D) Index Big Tech 30 CHINA U.S.D Hedged",
    "HebrewName": "תכלית TTF ביג טק30 סין מד",
    "HebrewLongName": "תכלית TTF י(4D) אינדקס ביג טק 30 סין מנוטרלת דולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.13,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 12.6,
    "MonthYield": 3.17,
    "YearYield": 3.17,
    "Last12MonthYield": 26.79,
    "ISIN": "IL0051329238"
  },
  {
    "Id": "TASE:5140249",
    "MayaId": "5140249",
    "Name": "Tachlit TTF Bull CPIL1028",
    "ShortName": "Tachlit TTF Bull CPIL1028",
    "Symbol": "TASE:5140249",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (00) Tel-Bond Bullet CPI Linked 10/2028 IL",
    "EnglishLongName": "Tachlit TTF (00) Tel-Bond Bullet CPI Linked 10/2028 IL",
    "HebrewName": "תכלית TTF בולט 10/28 צמוד",
    "HebrewLongName": "תכלית TTF י(00) תל-בונד בולט 10/2028 צמוד",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.17,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 7.9,
    "MonthYield": 0.12,
    "YearYield": 0.12,
    "Last12MonthYield": null,
    "ISIN": "IL0051402498"
  },
  {
    "Id": "TASE:5140256",
    "MayaId": "5140256",
    "Name": "Tachlit TTF Bull Israel29",
    "ShortName": "Tachlit TTF Bull Israel29",
    "Symbol": "TASE:5140256",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (00)(!) Tel-Bond Bullet Israel 2029 IL",
    "EnglishLongName": "Tachlit TTF (00)(!) Tel-Bond Bullet Israel 2029 IL",
    "HebrewName": "תכלית TTF בולט 2029 ישראל",
    "HebrewLongName": "תכלית TTF י(00)(!) תל-בונד בולט 2029 ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.23,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 9.2,
    "MonthYield": 0.41,
    "YearYield": 0.41,
    "Last12MonthYield": null,
    "ISIN": "IL0051402563"
  },
  {
    "Id": "TASE:5140231",
    "MayaId": "5140231",
    "Name": "Tachlit TTF Bull NoLink29",
    "ShortName": "Tachlit TTF Bull NoLink29",
    "Symbol": "TASE:5140231",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (00)(!) Tel-Bond Bullet Non Linked 2029 IL",
    "EnglishLongName": "Tachlit TTF (00)(!) Tel-Bond Bullet Non Linked 2029 IL",
    "HebrewName": "תכלית TTF בולט 2029 שקלי",
    "HebrewLongName": "תכלית TTF י(00)(!) תל-בונד בולט 2029 שקלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.23,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 11.5,
    "MonthYield": 0.73,
    "YearYield": 0.73,
    "Last12MonthYield": null,
    "ISIN": "IL0051402316"
  },
  {
    "Id": "TASE:5117346",
    "MayaId": "5117346",
    "Name": "Tachlit TTF CMP BONDEQ15",
    "ShortName": "Tachlit TTF CMP BONDEQ15",
    "Symbol": "TASE:5117346",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (2A) Composite Gov./Corp. Bonds (85%) Equity (15%) Monthly IL",
    "EnglishLongName": "Tachlit TTF (2A) Composite Gov./Corp. Bonds (85%) Equity (15%) Monthly IL",
    "HebrewName": "תכלית TTFמש אגח מניות 15%",
    "HebrewLongName": "תכלית TTF י(2A) משולבת אגח ממשלתי קונצרני (85%) מניות (15%) מנוטרלת מט\"ח חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.36,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Composite Bonds",
    "SecondaryClassification": "up to 20% Equity",
    "AssetValue": 31.1,
    "MonthYield": 0.97,
    "YearYield": 0.97,
    "Last12MonthYield": 9.66,
    "ISIN": "IL0051173461"
  },
  {
    "Id": "TASE:5115837",
    "MayaId": "5115837",
    "Name": "Tachlit TTF CMP BONDTA125",
    "ShortName": "Tachlit TTF CMP BONDTA125",
    "Symbol": "TASE:5115837",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (2A) Composite Gov./Corp. Bonds (90%) TA 125 (10%) Monthly IL",
    "EnglishLongName": "Tachlit TTF (2A) Composite Gov./Corp. Bonds (90%) TA 125 (10%) Monthly IL",
    "HebrewName": "תכלית TTFמש אגח מניות 10%",
    "HebrewLongName": "תכלית TTF י(2A) משולבת אגח ממשלתי קונצרני (90%) מניות (10%) חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Composite Bonds",
    "SecondaryClassification": "up to 10% Equity",
    "AssetValue": 22.4,
    "MonthYield": 1.23,
    "YearYield": 1.23,
    "Last12MonthYield": 10.36,
    "ISIN": "IL0051158371"
  },
  {
    "Id": "TASE:5139191",
    "MayaId": "5139191",
    "Name": "TACHLIT TTF CMP ISRAELEQY",
    "ShortName": "TACHLIT TTF CMP ISRAELEQY",
    "Symbol": "TASE:5139191",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (40) composite Israel Equity Monthly IL",
    "EnglishLongName": "Tachlit TTF (40) composite Israel Equity Monthly IL",
    "HebrewName": "תכלית TTF מש מניות ישראל",
    "HebrewLongName": "תכלית TTF י(40) משולבת מניות ישראל חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.5,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks in Israel, Composite",
    "AssetValue": 72.7,
    "MonthYield": 7.82,
    "YearYield": 7.82,
    "Last12MonthYield": 60.4,
    "ISIN": "IL0051391915"
  },
  {
    "Id": "TASE:5140025",
    "MayaId": "5140025",
    "Name": "TACHLIT TTF CMP LOCALEQ",
    "ShortName": "TACHLIT TTF CMP LOCALEQ",
    "Symbol": "TASE:5140025",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (40) composite Local Equity Monthly IL",
    "EnglishLongName": "Tachlit TTF (40) composite Local Equity Monthly IL",
    "HebrewName": "תכלית TTF מש מניות מקומיו",
    "HebrewLongName": "תכלית TTFי (40) משולבת מניות מקומיות חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.04,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks in Israel, Composite",
    "AssetValue": 24.8,
    "MonthYield": 8.03,
    "YearYield": 8.03,
    "Last12MonthYield": null,
    "ISIN": "IL0051400252"
  },
  {
    "Id": "TASE:5118724",
    "MayaId": "5118724",
    "Name": "Tachlit TTF CMPBNDEQ20ILS",
    "ShortName": "Tachlit TTF CMPBNDEQ20ILS",
    "Symbol": "TASE:5118724",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (2B) Comp Gov/Corp Bonds(90%) Equity(20%) Currency-Hedged Monthly IL",
    "EnglishLongName": "Tachlit TTF (2B) Comp Gov/Corp Bonds(90%) Equity(20%) Currency-Hedged Monthly IL",
    "HebrewName": "תכלית TTFמש אגחמניות20%ממ",
    "HebrewLongName": "תכלית TTF י(2B) משולבת אגח ממשלתי קונצרני (90%) מניות (20%) מנוטרלת מט\"ח חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.5,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Composite Bonds",
    "SecondaryClassification": "up to 20% Equity",
    "AssetValue": 52.3,
    "MonthYield": 0.93,
    "YearYield": 0.93,
    "Last12MonthYield": 8.74,
    "ISIN": "IL0051187248"
  },
  {
    "Id": "TASE:5137666",
    "MayaId": "5137666",
    "Name": "Tachlit TTF CmSP&NDX",
    "ShortName": "Tachlit TTF CmSP&NDX",
    "Symbol": "TASE:5137666",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4D) Composite S&P 500 (70%) Nasdaq 100 (30%) Monthly",
    "EnglishLongName": "Tachlit TTF (4D) Composite S&P 500 (70%) Nasdaq 100 (30%) Monthly",
    "HebrewName": "תכלית TTF מש SP500/NDX100",
    "HebrewLongName": "תכלית TTF י(4D)י משולבת S&P 500י (70%) Nasdaq 100י (30%) חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.51,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks Abroad, Composite",
    "AssetValue": 47.7,
    "MonthYield": 0.05,
    "YearYield": 0.05,
    "Last12MonthYield": 3.69,
    "ISIN": "IL0051376668"
  },
  {
    "Id": "TASE:5138086",
    "MayaId": "5138086",
    "Name": "Tachlit TTF CoCo Israel10",
    "ShortName": "Tachlit TTF CoCo Israel10",
    "Symbol": "TASE:5138086",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (00) Index CoCo Israel-10 IL",
    "EnglishLongName": "Tachlit TTF (00) Index CoCo Israel-10 IL",
    "HebrewName": "תכלית TTFי CoCo ישראל-10",
    "HebrewLongName": "תכלית TTF י(00) אינדקס CoCo ישראל-10",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 33.9,
    "MonthYield": 0.44,
    "YearYield": 0.44,
    "Last12MonthYield": 8.21,
    "ISIN": "IL0051380868"
  },
  {
    "Id": "TASE:5137229",
    "MayaId": "5137229",
    "Name": "Tachlit TTF CountryBalan4",
    "ShortName": "Tachlit TTF CountryBalan4",
    "Symbol": "TASE:5137229",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (00) Index Country Balanced Duration 4 IL",
    "EnglishLongName": "Tachlit TTF (00) Index Country Balanced Duration 4 IL",
    "HebrewName": "תכלית TTF מדינה מאוזןמחמ4",
    "HebrewLongName": "תכלית TTF י(00) אינדקס מדינה מאוזן - מח\"מ 4 קבוע",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.2,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bonds",
    "AssetValue": 23.9,
    "MonthYield": 0.34,
    "YearYield": 0.34,
    "Last12MonthYield": 5.64,
    "ISIN": "IL0051372295"
  },
  {
    "Id": "TASE:5139779",
    "MayaId": "5139779",
    "Name": "Tachlit TTF CPI 1 3Factor",
    "ShortName": "Tachlit TTF CPI 1-3Factor",
    "Symbol": "TASE:5139779",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (00) Index CPI Linked 1-3 Spread Factor From Gov Bonds IL",
    "EnglishLongName": "Tachlit TTF (00) Index CPI Linked 1-3 Spread Factor From Gov Bonds IL",
    "HebrewName": "תכלית TTF צמוד 1-3 פקטור",
    "HebrewLongName": "תכלית TTF י(00) אינדקס צמוד 1-3 פקטור מרווח מאג\"ח ממשלתי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.18,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 7.4,
    "MonthYield": 0.12,
    "YearYield": 0.12,
    "Last12MonthYield": 5.32,
    "ISIN": "IL0051397797"
  },
  {
    "Id": "TASE:5124557",
    "MayaId": "5124557",
    "Name": "TACHLIT TTF DAXNR",
    "ShortName": "TACHLIT TTF DAXNR",
    "Symbol": "TASE:5124557",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4D) DAX",
    "EnglishLongName": "Tachlit TTF (4D) DAX",
    "HebrewName": "תכלית DAX TTF",
    "HebrewLongName": "תכלית DAX (4D) TTF",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0.2,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.5,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 92.3,
    "MonthYield": 0.7,
    "YearYield": 0.7,
    "Last12MonthYield": 21.05,
    "ISIN": "IL0051245574"
  },
  {
    "Id": "TASE:5139084",
    "MayaId": "5139084",
    "Name": "Tachlit TTF Defense Top30",
    "ShortName": "Tachlit TTF Defense Top30",
    "Symbol": "TASE:5139084",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4D) Index Defense Industries Global Top30 EW",
    "EnglishLongName": "Tachlit TTF (4D) Index Defense Industries Global Top30 EW",
    "HebrewName": "תכלית TTF ביטחוניות Top30",
    "HebrewLongName": "תכלית TTF י(4D) אינדקס תעשיות ביטחוניות גלובלי Top30 EW",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.45,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.63,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 199.3,
    "MonthYield": 13.95,
    "YearYield": 13.95,
    "Last12MonthYield": 61.47,
    "ISIN": "IL0051390842"
  },
  {
    "Id": "TASE:5140454",
    "MayaId": "5140454",
    "Name": "Tachlit TTF Ether Dollar",
    "ShortName": "Tachlit TTF Ether-Dollar",
    "Symbol": "TASE:5140454",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4D) CME CF Ethereum Reference Rate (ETHUSDNY)",
    "EnglishLongName": "Tachlit TTF (4D) CME CF Ethereum Reference Rate (ETHUSDNY)",
    "HebrewName": "תכלית Ether-Dollar TTF",
    "HebrewLongName": "תכלית TTF י(4D)י CME CF Ethereum Reference Rate (ETHUSDNY)",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 8.58,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Digital Assets",
    "SecondaryClassification": "Ethereum",
    "AssetValue": 31.2,
    "MonthYield": 9.14,
    "YearYield": 9.14,
    "Last12MonthYield": null,
    "ISIN": "IL0051404544"
  },
  {
    "Id": "TASE:5139092",
    "MayaId": "5139092",
    "Name": "TACHLIT TTF EU STOXX50",
    "ShortName": "TACHLIT TTF EU STOXX50",
    "Symbol": "TASE:5139092",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4D) EURO STOXX 50",
    "EnglishLongName": "Tachlit TTF (4D) EURO STOXX 50",
    "HebrewName": "תכלית TTF ‏‏‏EU STOXX50",
    "HebrewLongName": "תכלית TTF י(4D)י EURO STOXX 50",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.5,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 20.1,
    "MonthYield": 1.46,
    "YearYield": 1.46,
    "Last12MonthYield": 21.35,
    "ISIN": "IL0051390925"
  },
  {
    "Id": "TASE:5138797",
    "MayaId": "5138797",
    "Name": "Tachlit TTF ExchanAndData",
    "ShortName": "Tachlit TTF ExchanAndData",
    "Symbol": "TASE:5138797",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4D) Indxx Global Financial Exchanges And Data",
    "EnglishLongName": "Tachlit TTF (4D) Indxx Global Financial Exchanges And Data",
    "HebrewName": "תכלית TTFי ExchanAndData",
    "HebrewLongName": "תכלית TTF י(4D)י Indxx Global Financial Exchanges And Data",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.22,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 56.7,
    "MonthYield": 2.14,
    "YearYield": 2.14,
    "Last12MonthYield": -7.61,
    "ISIN": "IL0051387970"
  },
  {
    "Id": "TASE:5118393",
    "MayaId": "5118393",
    "Name": "Tachlit TTF Gov Bonds",
    "ShortName": "Tachlit TTF Gov Bonds",
    "Symbol": "TASE:5118393",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (0A) Tel Gov-General IL",
    "EnglishLongName": "Tachlit TTF (0A) Tel Gov-General IL",
    "HebrewName": "תכלית TTF תלגוב כללי",
    "HebrewLongName": "תכלית 0A) TTF) תל גוב-כללי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bonds",
    "AssetValue": 86.9,
    "MonthYield": 0.48,
    "YearYield": 0.48,
    "Last12MonthYield": 6.37,
    "ISIN": "IL0051183932"
  },
  {
    "Id": "TASE:5141429",
    "MayaId": "5141429",
    "Name": "Tachlit TTF IL Cap Market",
    "ShortName": "Tachlit TTF IL Cap Market",
    "Symbol": "TASE:5141429",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4B) Index Israel Capital Markets IL",
    "EnglishLongName": "Tachlit TTF (4B) Index Israel Capital Markets IL",
    "HebrewName": "תכלית TTF שוק ההון ישראל",
    "HebrewLongName": "תכלית TTFי (4B)‏ אינדקס שוק ההון ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 14.7,
    "MonthYield": 5.24,
    "YearYield": 5.24,
    "Last12MonthYield": null,
    "ISIN": "IL0051414295"
  },
  {
    "Id": "TASE:5141882",
    "MayaId": "5141882",
    "Name": "Tachlit TTF IL DefenseInd",
    "ShortName": "Tachlit TTF IL DefenseInd",
    "Symbol": "TASE:5141882",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4A) Index Israeli Defense Industries IL",
    "EnglishLongName": "Tachlit TTF (4A) Index Israeli Defense Industries IL",
    "HebrewName": "תכלית TTF ישרא ביטחוניות",
    "HebrewLongName": "תכלית TTF י(4A) אינדקס תעשיות ביטחוניות ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.35,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 21.6,
    "MonthYield": 23.26,
    "YearYield": 23.26,
    "Last12MonthYield": null,
    "ISIN": "IL0051418825"
  },
  {
    "Id": "TASE:5138813",
    "MayaId": "5138813",
    "Name": "Tachlit TTF IL GrowthMome",
    "ShortName": "Tachlit TTF IL GrowthMome",
    "Symbol": "TASE:5138813",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4C) Index Israeli Growth-Momentum IL",
    "EnglishLongName": "Tachlit TTF (4C) Index Israeli Growth-Momentum IL",
    "HebrewName": "תכלית TTF ישראל צמיחהמומנ",
    "HebrewLongName": "תכלית TTF י(4C) אינדקס ישראליות צמיחה-מומנטום",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.25,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 37.6,
    "MonthYield": 9.32,
    "YearYield": 9.32,
    "Last12MonthYield": 67.4,
    "ISIN": "IL0051388135"
  },
  {
    "Id": "TASE:5125067",
    "MayaId": "5125067",
    "Name": "TACHLIT TTF ILS CAP500M",
    "ShortName": "TACHLIT TTF ILS CAP500M",
    "Symbol": "TASE:5125067",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (00) Index Israeli Non-Linked CAP 500 M IL",
    "EnglishLongName": "Tachlit TTF (00) Index Israeli Non-Linked CAP 500 M IL",
    "HebrewName": "תכלית TTF שקלי תקרה 500מ",
    "HebrewLongName": "תכלית TTF י(00) אינדקס שקלי מדורג תקרת סדרה 500 מ'",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.27,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 21.0,
    "MonthYield": 0.92,
    "YearYield": 0.92,
    "Last12MonthYield": 7.26,
    "ISIN": "IL0051250673"
  },
  {
    "Id": "TASE:5131933",
    "MayaId": "5131933",
    "Name": "Tachlit TTF INDXTech REIT",
    "ShortName": "Tachlit TTF INDXTech-REIT",
    "Symbol": "TASE:5131933",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4D) INDXX TECHNOLOGY REITs",
    "EnglishLongName": "Tachlit TTF (4D) INDXX TECHNOLOGY REITs",
    "HebrewName": "תכלית INDXX Tech-REIT TTF",
    "HebrewLongName": "תכלית TTF י(4D) ‏ INDXX TECHNOLOGY REITs",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.73,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 3.8,
    "MonthYield": 1.34,
    "YearYield": 1.34,
    "Last12MonthYield": -9.51,
    "ISIN": "IL0051319338"
  },
  {
    "Id": "TASE:5129374",
    "MayaId": "5129374",
    "Name": "Tachlit TTF INDXX REALUSD",
    "ShortName": "Tachlit TTF INDXX REALUSD",
    "Symbol": "TASE:5129374",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4D) INDXX US INDUSTRIAL REAL ESTATE &LOGISTICS U.S.D",
    "EnglishLongName": "Tachlit TTF (4D) INDXX US INDUSTRIAL REAL ESTATE &LOGISTICS U.S.D",
    "HebrewName": "תכלית INDXX REAL EST TTF",
    "HebrewLongName": "תכלית TTF י(4D)י INDXX US Industrial Real Estate&Logistics",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.61,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 32.9,
    "MonthYield": 6.73,
    "YearYield": 6.73,
    "Last12MonthYield": -1.75,
    "ISIN": "IL0051293749"
  },
  {
    "Id": "TASE:5140975",
    "MayaId": "5140975",
    "Name": "Tachlit TTF Infrast Const",
    "ShortName": "Tachlit TTF Infrast-Const",
    "Symbol": "TASE:5140975",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4A) Index Essential Infrastructures And Construction IL",
    "EnglishLongName": "Tachlit TTF (4A) Index Essential Infrastructures And Construction IL",
    "HebrewName": "תכלית TTF‏‏ תשתיות ובנייה",
    "HebrewLongName": "תכלית 4A) TTF) ‏אינדקס תשתיות חיוניות ובנייה בישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 17.4,
    "MonthYield": 6.72,
    "YearYield": 6.72,
    "Last12MonthYield": null,
    "ISIN": "IL0051409758"
  },
  {
    "Id": "TASE:5136031",
    "MayaId": "5136031",
    "Name": "TACHLIT TTF ISR AA 2 4",
    "ShortName": "TACHLIT TTF ISR AA 2-4",
    "Symbol": "TASE:5136031",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (00) Index Israel AA Balanced 2-4 IL",
    "EnglishLongName": "Tachlit TTF (00) Index Israel AA Balanced 2-4 IL",
    "HebrewName": "תכלית TTF יש AA מאוזן 2-4",
    "HebrewLongName": "תכלית TTF י(00) אינדקס ישראל AA מאוזן 2-4",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.2,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 82.4,
    "MonthYield": 0.51,
    "YearYield": 0.51,
    "Last12MonthYield": 6.67,
    "ISIN": "IL0051360316"
  },
  {
    "Id": "TASE:5131925",
    "MayaId": "5131925",
    "Name": "Tachlit TTF ISRAEL BANKS",
    "ShortName": "Tachlit TTF ISRAEL BANKS",
    "Symbol": "TASE:5131925",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (40) INDEX ISRAEL BANKS IL",
    "EnglishLongName": "Tachlit TTF (40) INDEX ISRAEL BANKS IL",
    "HebrewName": "תכלית TTF בנקים ישראל",
    "HebrewLongName": "תכלית TTFי (40) אינדקס בנקים ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.98,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 456.1,
    "MonthYield": 9.43,
    "YearYield": 9.43,
    "Last12MonthYield": 71.09,
    "ISIN": "IL0051319254"
  },
  {
    "Id": "TASE:5141627",
    "MayaId": "5141627",
    "Name": "Tachlit TTF LBMA Gold ILS",
    "ShortName": "Tachlit TTF LBMA Gold ILS",
    "Symbol": "TASE:5141627",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4A) LBMA Gold AM Currency Hedged",
    "EnglishLongName": "Tachlit TTF (4A) LBMA Gold AM Currency Hedged",
    "HebrewName": "תכלית TTF ‏‏‏LBMA Gold ממ",
    "HebrewLongName": "תכלית TTFי (4A)י ‏‏‏LBMA Gold Price AM מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.95,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Commodities",
    "SecondaryClassification": "Commodity",
    "AssetValue": 8.0,
    "MonthYield": 7.0,
    "YearYield": 7.0,
    "Last12MonthYield": null,
    "ISIN": "IL0051416274"
  },
  {
    "Id": "TASE:5136171",
    "MayaId": "5136171",
    "Name": "TACHLIT TTF MegaBanks ILS",
    "ShortName": "TACHLIT TTF MegaBanks ILS",
    "Symbol": "TASE:5136171",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4A) Index Mega 20 US Banks Currency-Hedged",
    "EnglishLongName": "Tachlit TTF (4A) Index Mega 20 US Banks Currency-Hedged",
    "HebrewName": "תכלית MegaUSBanks TTF ממ",
    "HebrewLongName": "תכלית TTF י(4A)י אינדקס Mega 20 US Banks מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.4,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.76,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 85.9,
    "MonthYield": -0.5,
    "YearYield": -0.5,
    "Last12MonthYield": 22.54,
    "ISIN": "IL0051361710"
  },
  {
    "Id": "TASE:5138755",
    "MayaId": "5138755",
    "Name": "TACHLIT TTF MSCI IndiaUSD",
    "ShortName": "TACHLIT TTF MSCI IndiaUSD",
    "Symbol": "TASE:5138755",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "(Tachlit TTF (4D) MSCI India (USD",
    "EnglishLongName": "(Tachlit TTF (4D) MSCI India (USD",
    "HebrewName": "תכלית MSCI India USD TTF",
    "HebrewLongName": "תכלית TTF י(4D)י (MSCI India (USD",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.55,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.87,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 13.5,
    "MonthYield": -3.7,
    "YearYield": -3.7,
    "Last12MonthYield": -15.07,
    "ISIN": "IL0051387558"
  },
  {
    "Id": "TASE:5131537",
    "MayaId": "5131537",
    "Name": "Tachlit TTF NASDAQ GreILS",
    "ShortName": "Tachlit TTF NASDAQ GreILS",
    "Symbol": "TASE:5131537",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4A) NASDAQ Clean Edge Green Energy EW Currency-Hedged",
    "EnglishLongName": "Tachlit TTF (4A) NASDAQ Clean Edge Green Energy EW Currency-Hedged",
    "HebrewName": "תכלית NASDAQ Green TTF ממ",
    "HebrewLongName": "תכלית NASDAQ Clean Edge Green Energy EW (4A) TTF מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 4.79,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 30.5,
    "MonthYield": 11.5,
    "YearYield": 11.5,
    "Last12MonthYield": 42.12,
    "ISIN": "IL0051315377"
  },
  {
    "Id": "TASE:5141718",
    "MayaId": "5141718",
    "Name": "Tachlit TTF Quantum Compu",
    "ShortName": "Tachlit TTF Quantum Compu",
    "Symbol": "TASE:5141718",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4D) iNDEX Quantum Computing Ecosystem",
    "EnglishLongName": "Tachlit TTF (4D) iNDEX Quantum Computing Ecosystem",
    "HebrewName": "תכלית TTF ‏Quantum Comput",
    "HebrewLongName": "תכלית TTFי (4D) ‏Quantum Computing Ecosystem iNDEX",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 7.6,
    "MonthYield": 4.77,
    "YearYield": 4.77,
    "Last12MonthYield": null,
    "ISIN": "IL0051417181"
  },
  {
    "Id": "TASE:5139720",
    "MayaId": "5139720",
    "Name": "Tachlit TTF Russel2000ILS",
    "ShortName": "Tachlit TTF Russel2000ILS",
    "Symbol": "TASE:5139720",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4A) Russell 2000 Currency-Hedged",
    "EnglishLongName": "Tachlit TTF (4A) Russell 2000 Currency-Hedged",
    "HebrewName": "תכלית TTF ‏‏‏Russel2000ממ",
    "HebrewLongName": "תכלית TTF‏‏ (4A) ‏Russell 2000 מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.49,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 17.2,
    "MonthYield": 7.84,
    "YearYield": 7.84,
    "Last12MonthYield": 19.29,
    "ISIN": "IL0051397201"
  },
  {
    "Id": "TASE:5135074",
    "MayaId": "5135074",
    "Name": "TACHLIT TTF Semicond ILS",
    "ShortName": "TACHLIT TTF Semicond ILS",
    "Symbol": "TASE:5135074",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4A) PHLX Semiconductor Sector Currency-Hedged",
    "EnglishLongName": "Tachlit TTF (4A) PHLX Semiconductor Sector Currency-Hedged",
    "HebrewName": "תכלית PHLX Semicon TTF ממ",
    "HebrewLongName": "תכלית PHLX Semiconductor Sector (4A) TTF מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0.2,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 4.15,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 296.9,
    "MonthYield": 10.51,
    "YearYield": 10.51,
    "Last12MonthYield": 53.12,
    "ISIN": "IL0051350747"
  },
  {
    "Id": "TASE:5134556",
    "MayaId": "5134556",
    "Name": "TACHLIT TTF SemiconEq ILS",
    "ShortName": "TACHLIT TTF SemiconEq ILS",
    "Symbol": "TASE:5134556",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4D) Indxx Semiconductor Equipment Providers U.S.D Hedged",
    "EnglishLongName": "Tachlit TTF (4D) Indxx Semiconductor Equipment Providers U.S.D Hedged",
    "HebrewName": "תכלית TTF SemiconEquip מד",
    "HebrewLongName": "תכלית TTF י(4D)י Indxx Semiconductor Equipment Providers מנוטרלת דולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.54,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 10.7,
    "MonthYield": 16.35,
    "YearYield": 16.35,
    "Last12MonthYield": 64.32,
    "ISIN": "IL0051345564"
  },
  {
    "Id": "TASE:5138334",
    "MayaId": "5138334",
    "Name": "TACHLIT TTF SP30B3 5Y ILS",
    "ShortName": "TACHLIT TTF SP30B3-5Y ILS",
    "Symbol": "TASE:5138334",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (0A) S&P 500 Bond Mega 30 Investment Grade 3-5 Year Currency-Hedged",
    "EnglishLongName": "Tachlit TTF (0A) S&P 500 Bond Mega 30 Investment Grade 3-5 Year Currency-Hedged",
    "HebrewName": "תכלית SP 30B 3-5Y TTF ממ",
    "HebrewLongName": "תכלית TTF י(0A)י S&P 500 Bond Mega 30 Investment Grade 3-5 Year מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Hedged Corporate and Convertibles - Medium",
    "AssetValue": 78.7,
    "MonthYield": 0.06,
    "YearYield": 0.06,
    "Last12MonthYield": 7.16,
    "ISIN": "IL0051383342"
  },
  {
    "Id": "TASE:5136999",
    "MayaId": "5136999",
    "Name": "TACHLIT TTF SP30BOND 3 5Y",
    "ShortName": "TACHLIT TTF SP30BOND 3-5Y",
    "Symbol": "TASE:5136999",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (0D) S&P 500 Bond Mega 30 Investment Grade 3-5 Year",
    "EnglishLongName": "Tachlit TTF (0D) S&P 500 Bond Mega 30 Investment Grade 3-5 Year",
    "HebrewName": "תכלית SP 30Bond 3-5Y TTF",
    "HebrewLongName": "תכלית TTF י(0D)י S&P 500 Bond Mega 30 Investment Grade 3-5 Year",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.15,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.19,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Corporate and Convertibles - Medium",
    "AssetValue": 325.7,
    "MonthYield": -1.35,
    "YearYield": -1.35,
    "Last12MonthYield": -7.62,
    "ISIN": "IL0051369994"
  },
  {
    "Id": "TASE:5137781",
    "MayaId": "5137781",
    "Name": "TACHLIT TTF SP30BOND 5 7Y",
    "ShortName": "TACHLIT TTF SP30BOND 5-7Y",
    "Symbol": "TASE:5137781",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (0D) S&P 500 Bond Mega 30 Investment Grade 5-7 Year",
    "EnglishLongName": "Tachlit TTF (0D) S&P 500 Bond Mega 30 Investment Grade 5-7 Year",
    "HebrewName": "תכלית SP 30Bond 5-7Y TTF",
    "HebrewLongName": "תכלית TTF י(0D)י S&P 500 Bond Mega 30 Investment Grade 5-7 Year",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.22,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Corporate and Convertibles - Long",
    "AssetValue": 43.4,
    "MonthYield": -1.36,
    "YearYield": -1.36,
    "Last12MonthYield": -6.86,
    "ISIN": "IL0051377815"
  },
  {
    "Id": "TASE:5138383",
    "MayaId": "5138383",
    "Name": "Tachlit TTF SP500 EW ILS",
    "ShortName": "Tachlit TTF SP500 EW ILS",
    "Symbol": "TASE:5138383",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4A) S&P 500 Equal Weight Currency-Hedged",
    "EnglishLongName": "Tachlit TTF (4A) S&P 500 Equal Weight Currency-Hedged",
    "HebrewName": "תכלית SP 500 EW TTF ממ",
    "HebrewLongName": "תכלית TTF י(4A)י S&P 500 Equal Weight מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.52,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 26.6,
    "MonthYield": 4.24,
    "YearYield": 4.24,
    "Last12MonthYield": 13.83,
    "ISIN": "IL0051383839"
  },
  {
    "Id": "TASE:5138805",
    "MayaId": "5138805",
    "Name": "Tachlit TTF SP500 Growth",
    "ShortName": "Tachlit TTF SP500 Growth",
    "Symbol": "TASE:5138805",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4D) S&P 500 Growth",
    "EnglishLongName": "Tachlit TTF (4D) S&P 500 Growth",
    "HebrewName": "תכלית TTFי SP500 Growth",
    "HebrewLongName": "תכלית TTF י(4D)י S&P 500 Growth",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.3,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.89,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 6.4,
    "MonthYield": -0.89,
    "YearYield": -0.89,
    "Last12MonthYield": 5.28,
    "ISIN": "IL0051388051"
  },
  {
    "Id": "TASE:5131198",
    "MayaId": "5131198",
    "Name": "TACHLIT TTF SP500 Scored",
    "ShortName": "TACHLIT TTF SP500 Scored",
    "Symbol": "TASE:5131198",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4D) S&P 500 Scored & Screened",
    "EnglishLongName": "Tachlit TTF (4D) S&P 500 Scored & Screened",
    "HebrewName": "תכלית SP500 Scored TTF",
    "HebrewLongName": "תכלית TTF י(4D)י S&P 500 Scored & Screened",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0.2,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.36,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 62.6,
    "MonthYield": -0.13,
    "YearYield": -0.13,
    "Last12MonthYield": 3.41,
    "ISIN": "IL0051311988"
  },
  {
    "Id": "TASE:5141684",
    "MayaId": "5141684",
    "Name": "Tachlit TTF SP500Mome ILS",
    "ShortName": "Tachlit TTF SP500Mome ILS",
    "Symbol": "TASE:5141684",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4A) S&P 500 Momentum Currency-Hedged",
    "EnglishLongName": "Tachlit TTF (4A) S&P 500 Momentum Currency-Hedged",
    "HebrewName": "תכלית SP500Moment TTF ממ",
    "HebrewLongName": "תכלית TTF י(4A)י S&P 500 Momentum מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 3.1,
    "MonthYield": 0.26,
    "YearYield": 0.26,
    "Last12MonthYield": null,
    "ISIN": "IL0051416845"
  },
  {
    "Id": "TASE:5141676",
    "MayaId": "5141676",
    "Name": "Tachlit TTF SP500Momentum",
    "ShortName": "Tachlit TTF SP500Momentum",
    "Symbol": "TASE:5141676",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4D) S&P 500 Momentum",
    "EnglishLongName": "Tachlit TTF (4D) S&P 500 Momentum",
    "HebrewName": "תכלית SP500Momentum TTF",
    "HebrewLongName": "תכלית TTF י(4D)י S&P 500 Momentum",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 2.7,
    "MonthYield": -1.11,
    "YearYield": -1.11,
    "Last12MonthYield": null,
    "ISIN": "IL0051416761"
  },
  {
    "Id": "TASE:5133681",
    "MayaId": "5133681",
    "Name": "Tachlit TTF SP900 PValILS",
    "ShortName": "Tachlit TTF SP900 PValILS",
    "Symbol": "TASE:5133681",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4A) S&P 900 Pure Value Currency-Hedged",
    "EnglishLongName": "Tachlit TTF (4A) S&P 900 Pure Value Currency-Hedged",
    "HebrewName": "תכלית SP900 PValue TTF ממ",
    "HebrewLongName": "תכלית TTF י(4A)י S&P 900 Pure Value מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.21,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 41.6,
    "MonthYield": 5.29,
    "YearYield": 5.29,
    "Last12MonthYield": 15.93,
    "ISIN": "IL0051336811"
  },
  {
    "Id": "TASE:5141833",
    "MayaId": "5141833",
    "Name": "Tachlit TTF SuperInvHed",
    "ShortName": "Tachlit TTF SuperInvHed",
    "Symbol": "TASE:5141833",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4B) Indxx Super Institutional Investors Holdings 13F U.S.D Hedged",
    "EnglishLongName": "Tachlit TTF (4B) Indxx Super Institutional Investors Holdings 13F U.S.D Hedged",
    "HebrewName": "תכלית SuperInvestor TTFמד",
    "HebrewLongName": "תכלית TTF י(4B)י Indxx Super Institutional Investors Holdings 13F מנוטרלת דולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.65,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:5114657",
    "MayaId": "5114657",
    "Name": "Tachlit TTF TA 125",
    "ShortName": "Tachlit TTF TA 125",
    "Symbol": "TASE:5114657",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (40) TA 125 IL",
    "EnglishLongName": "Tachlit TTF (40) TA 125 IL",
    "HebrewName": "תכלית TTF תא 125",
    "HebrewLongName": "תכלית TTF י(40) ת\"א 125",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.03,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.12,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 1939.3,
    "MonthYield": 8.85,
    "YearYield": 8.85,
    "Last12MonthYield": 64.09,
    "ISIN": "IL0051146574"
  },
  {
    "Id": "TASE:5109418",
    "MayaId": "5109418",
    "Name": "Tachlit TTF TA 35",
    "ShortName": "Tachlit TTF TA 35",
    "Symbol": "TASE:5109418",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (40) TA 35 IL",
    "EnglishLongName": "Tachlit TTF (40) TA 35 IL",
    "HebrewName": "תכלית TTF תא 35",
    "HebrewLongName": "תכלית TTF י(40) ת\"א 35",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.3,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.96,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 157.4,
    "MonthYield": 9.27,
    "YearYield": 9.27,
    "Last12MonthYield": 65.35,
    "ISIN": "IL0051094188"
  },
  {
    "Id": "TASE:5118740",
    "MayaId": "5118740",
    "Name": "Tachlit TTF TA 90",
    "ShortName": "Tachlit TTF TA 90",
    "Symbol": "TASE:5118740",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (40) TA 90 IL",
    "EnglishLongName": "Tachlit TTF (40) TA 90 IL",
    "HebrewName": "תכלית TTF תא 90",
    "HebrewLongName": "תכלית TTF י(40) ת\"א 90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.98,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 453.2,
    "MonthYield": 7.34,
    "YearYield": 7.34,
    "Last12MonthYield": 57.35,
    "ISIN": "IL0051187404"
  },
  {
    "Id": "TASE:5127584",
    "MayaId": "5127584",
    "Name": "Tachlit TTF TA Balance",
    "ShortName": "Tachlit TTF TA Balance",
    "Symbol": "TASE:5127584",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4A) TA Sector-Balance IL",
    "EnglishLongName": "Tachlit TTF (4A) TA Sector-Balance IL",
    "HebrewName": "תכלית TTF ת\"א סקטור-בלאנס",
    "HebrewLongName": "תכלית TTF י(4A) ת\"א סקטור-באלאנס",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.1,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 88.2,
    "MonthYield": 7.82,
    "YearYield": 7.82,
    "Last12MonthYield": 69.35,
    "ISIN": "IL0051275845"
  },
  {
    "Id": "TASE:5133541",
    "MayaId": "5133541",
    "Name": "Tachlit TTF TA Cons",
    "ShortName": "Tachlit TTF TA-Cons",
    "Symbol": "TASE:5133541",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (40) TA-Construction IL",
    "EnglishLongName": "Tachlit TTF (40) TA-Construction IL",
    "HebrewName": "תכלית TTF תא-בנייה",
    "HebrewLongName": "תכלית TTF י(40) ת\"א-בנייה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 4.55,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 246.5,
    "MonthYield": 12.05,
    "YearYield": 12.05,
    "Last12MonthYield": 23.58,
    "ISIN": "IL0051335417"
  },
  {
    "Id": "TASE:5128970",
    "MayaId": "5128970",
    "Name": "Tachlit TTF TA Family",
    "ShortName": "Tachlit TTF TA-Family",
    "Symbol": "TASE:5128970",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4A) TA-Family IL",
    "EnglishLongName": "Tachlit TTF (4A) TA-Family IL",
    "HebrewName": "תכלית TTF תא-פמילי",
    "HebrewLongName": "תכלית TTF י(4A) ת\"א-פמילי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.1,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 84.2,
    "MonthYield": 8.83,
    "YearYield": 8.83,
    "Last12MonthYield": 54.94,
    "ISIN": "IL0051289705"
  },
  {
    "Id": "TASE:5133582",
    "MayaId": "5133582",
    "Name": "TACHLIT TTF TA INSAndFIN",
    "ShortName": "TACHLIT TTF TA INSAndFIN",
    "Symbol": "TASE:5133582",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TACHLIT TTF (40) TA-Insurance And Financial services IL",
    "EnglishLongName": "TACHLIT TTF (40) TA-Insurance And Financial services IL",
    "HebrewName": "תכלית TTF תא ביטוח ופיננס",
    "HebrewLongName": "תכלית TTF י(40) ת\"א-ביטוח ושירותים פיננסים",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.3,
    "TrusteeFee": 0.02,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 4.46,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 492.9,
    "MonthYield": 7.64,
    "YearYield": 7.64,
    "Last12MonthYield": 152.12,
    "ISIN": "IL0051335821"
  },
  {
    "Id": "TASE:5142039",
    "MayaId": "5142039",
    "Name": "Tachlit TTF TA REAL ES 35",
    "ShortName": "Tachlit TTF TA REAL-ES 35",
    "Symbol": "TASE:5142039",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4A) TA REAL-ESTATE 35 IL",
    "EnglishLongName": "Tachlit TTF (4A) TA REAL-ESTATE 35 IL",
    "HebrewName": "תכלית TTF תא נדלן-35",
    "HebrewLongName": "תכלית TTF י(4A) ‏ת\"א נדל\"ן-35",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "MIZRAHI TEFAHOT TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": null,
    "MonthYield": 0.0,
    "YearYield": null,
    "Last12MonthYield": 0.0,
    "ISIN": "IL0051420391"
  },
  {
    "Id": "TASE:5139852",
    "MayaId": "5139852",
    "Name": "Tachlit TTF TA90AndBanks",
    "ShortName": "Tachlit TTF TA90AndBanks",
    "Symbol": "TASE:5139852",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (40) TA 90 And Banks IL",
    "EnglishLongName": "Tachlit TTF (40) TA 90 And Banks IL",
    "HebrewName": "תכלית TTF תא 90 ובנקים",
    "HebrewLongName": "תכלית TTFי (40) ת\"א 90 ובנקים",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.025,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.63,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 56.1,
    "MonthYield": 8.08,
    "YearYield": 8.08,
    "Last12MonthYield": null,
    "ISIN": "IL0051398522"
  },
  {
    "Id": "TASE:5108857",
    "MayaId": "5108857",
    "Name": "TACHLIT TTF TAR25FIG",
    "ShortName": "TACHLIT TTF TAR25FIG",
    "Symbol": "TASE:5108857",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (00) Tel Gov-Non-Linked Fixed Int 2-5 Years IL",
    "EnglishLongName": "Tachlit TTF (00) Tel Gov-Non-Linked Fixed Int 2-5 Years IL",
    "HebrewName": "תכלית TTF תלגוב שקלי 2-5",
    "HebrewLongName": "תכלית TTF י(00) תל גוב-שקלי 2-5",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.03,
    "VariableFee": 0.05,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.24,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Non-Linked Government Bonds",
    "AssetValue": 301.5,
    "MonthYield": 0.59,
    "YearYield": 0.59,
    "Last12MonthYield": 6.38,
    "ISIN": "IL0051088578"
  },
  {
    "Id": "TASE:5117379",
    "MayaId": "5117379",
    "Name": "TACHLIT TTF TAR25GV",
    "ShortName": "TACHLIT TTF TAR25GV",
    "Symbol": "TASE:5117379",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (00) Tel Gov-CPI-Linked 2-5 Years IL",
    "EnglishLongName": "Tachlit TTF (00) Tel Gov-CPI-Linked 2-5 Years IL",
    "HebrewName": "תכלית TTF תלגוב צמוד 2-5",
    "HebrewLongName": "תכלית TTF י(00) תל גוב-צמודות 2-5",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.14,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked",
    "AssetValue": 540.6,
    "MonthYield": 0.14,
    "YearYield": 0.14,
    "Last12MonthYield": 4.43,
    "ISIN": "IL0051173792"
  },
  {
    "Id": "TASE:5119375",
    "MayaId": "5119375",
    "Name": "TACHLIT TTF TAR5+FIG",
    "ShortName": "TACHLIT TTF TAR5+FIG",
    "Symbol": "TASE:5119375",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (00) Tel Gov-Non-Linked Fixed Int 5+ Years IL",
    "EnglishLongName": "Tachlit TTF (00) Tel Gov-Non-Linked Fixed Int 5+ Years IL",
    "HebrewName": "תכלית TTF תלגוב שקלי 5+",
    "HebrewLongName": "תכלית TTF י(00) תל גוב-שקלי 5+",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.79,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Non-Linked Government Bonds",
    "AssetValue": 141.8,
    "MonthYield": 1.25,
    "YearYield": 1.25,
    "Last12MonthYield": 11.19,
    "ISIN": "IL0051193758"
  },
  {
    "Id": "TASE:5119383",
    "MayaId": "5119383",
    "Name": "TACHLIT TTF TAR510GV",
    "ShortName": "TACHLIT TTF TAR510GV",
    "Symbol": "TASE:5119383",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (00) Tel Gov-CPI-Linked 5-10 Years IL",
    "EnglishLongName": "Tachlit TTF (00) Tel Gov-CPI-Linked 5-10 Years IL",
    "HebrewName": "תכלית TTF תלגוב צמוד 5-10",
    "HebrewLongName": "תכלית TTF י(00) תל גוב-צמודות 5-10",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.39,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked",
    "AssetValue": 70.6,
    "MonthYield": -0.12,
    "YearYield": -0.12,
    "Last12MonthYield": 5.2,
    "ISIN": "IL0051193832"
  },
  {
    "Id": "TASE:5118757",
    "MayaId": "5118757",
    "Name": "TACHLIT TTF TEL BCLB",
    "ShortName": "TACHLIT TTF TEL BCLB",
    "Symbol": "TASE:5118757",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (00) Tel Bond-CPI Linked Bank Without COCO IL",
    "EnglishLongName": "Tachlit TTF (00) Tel Bond-CPI Linked Bank Without COCO IL",
    "HebrewName": "תכלית TTF תלבונד צ בנק",
    "HebrewLongName": "תכלית TTF י(00) תל בונד צמודות-בנקים ללא COCO",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.17,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 56.8,
    "MonthYield": 0.08,
    "YearYield": 0.08,
    "Last12MonthYield": 5.12,
    "ISIN": "IL0051187578"
  },
  {
    "Id": "TASE:5115472",
    "MayaId": "5115472",
    "Name": "Tachlit TTF Tel Bond20",
    "ShortName": "Tachlit TTF Tel Bond20",
    "Symbol": "TASE:5115472",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (00) Tel Bond 20 CPI-Linked IL",
    "EnglishLongName": "Tachlit TTF (00) Tel Bond 20 CPI-Linked IL",
    "HebrewName": "תכלית TTF תלבונד 20",
    "HebrewLongName": "תכלית TTF י(00) תל בונד 20 צמודות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.43,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 181.4,
    "MonthYield": 0.22,
    "YearYield": 0.22,
    "Last12MonthYield": 7.07,
    "ISIN": "IL0051154727"
  },
  {
    "Id": "TASE:5136965",
    "MayaId": "5136965",
    "Name": "Tachlit TTF Tel Bond60",
    "ShortName": "Tachlit TTF Tel Bond60",
    "Symbol": "TASE:5136965",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (00) Tel Bond 60 CPI-Linked IL",
    "EnglishLongName": "Tachlit TTF (00) Tel Bond 60 CPI-Linked IL",
    "HebrewName": "תכלית TTF תלבונד 60",
    "HebrewLongName": "תכלית TTF י(00) תל בונד 60 צמודות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 524.2,
    "MonthYield": 0.24,
    "YearYield": 0.24,
    "Last12MonthYield": 6.86,
    "ISIN": "IL0051369655"
  },
  {
    "Id": "TASE:5136916",
    "MayaId": "5136916",
    "Name": "TACHLIT TTF TEL COMP",
    "ShortName": "TACHLIT TTF TEL-COMP",
    "Symbol": "TASE:5136916",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (0A) Tel Bond-Composite IL",
    "EnglishLongName": "Tachlit TTF (0A) Tel Bond-Composite IL",
    "HebrewName": "תכלית TTF תלבונד מאגר",
    "HebrewLongName": "תכלית TTF י(0A) תל בונד מאגר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 369.2,
    "MonthYield": 0.51,
    "YearYield": 0.51,
    "Last12MonthYield": 6.86,
    "ISIN": "IL0051369168"
  },
  {
    "Id": "TASE:5130828",
    "MayaId": "5130828",
    "Name": "Tachlit TTF TEL CPBI",
    "ShortName": "Tachlit TTF TEL-CPBI",
    "Symbol": "TASE:5130828",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (00) Tel Bond-Shekel Bank&Insurance IL",
    "EnglishLongName": "Tachlit TTF (00) Tel Bond-Shekel Bank&Insurance IL",
    "HebrewName": "תכלית TTF תל בונד בנקבטח",
    "HebrewLongName": "תכלית TTF י(00) תל בונד שקלי בנקים וביטוח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.41,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 138.4,
    "MonthYield": 0.89,
    "YearYield": 0.89,
    "Last12MonthYield": 8.73,
    "ISIN": "IL0051308281"
  },
  {
    "Id": "TASE:5130166",
    "MayaId": "5130166",
    "Name": "TACHLIT TTF TEL SH13",
    "ShortName": "TACHLIT TTF TEL-SH13",
    "Symbol": "TASE:5130166",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (00) Tel Bond-Shekel 1-3 IL",
    "EnglishLongName": "Tachlit TTF (00) Tel Bond-Shekel 1-3 IL",
    "HebrewName": "תכלית TTF תלבונד ש 1-3",
    "HebrewLongName": "תכלית TTF י(00) תל בונד-שקלי 1-3",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.16,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 163.4,
    "MonthYield": 0.68,
    "YearYield": 0.68,
    "Last12MonthYield": 5.12,
    "ISIN": "IL0051301666"
  },
  {
    "Id": "TASE:5130133",
    "MayaId": "5130133",
    "Name": "TACHLIT TTF TEL SH35",
    "ShortName": "TACHLIT TTF TEL-SH35",
    "Symbol": "TASE:5130133",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (00) Tel Bond-Shekel 3-5 IL",
    "EnglishLongName": "Tachlit TTF (00) Tel Bond-Shekel 3-5 IL",
    "HebrewName": "תכלית TTF תלבונד ש 3-5",
    "HebrewLongName": "תכלית TTF י(00) תל בונד שקלי 3-5",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 59.9,
    "MonthYield": 0.87,
    "YearYield": 0.87,
    "Last12MonthYield": 7.53,
    "ISIN": "IL0051301336"
  },
  {
    "Id": "TASE:5130174",
    "MayaId": "5130174",
    "Name": "TACHLIT TTF TEL SH51",
    "ShortName": "TACHLIT TTF TEL-SH51",
    "Symbol": "TASE:5130174",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (00) Tel Bond-Shekel 5-15 IL",
    "EnglishLongName": "Tachlit TTF (00) Tel Bond-Shekel 5-15 IL",
    "HebrewName": "תכלית TTF תלבונד ש 5-15",
    "HebrewLongName": "תכלית TTF י(00) תל בונד שקלי 5-15",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.05,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.57,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 402.1,
    "MonthYield": 1.23,
    "YearYield": 1.23,
    "Last12MonthYield": 10.84,
    "ISIN": "IL0051301740"
  },
  {
    "Id": "TASE:5135819",
    "MayaId": "5135819",
    "Name": "Tachlit TTF TelB CPIL 1 3",
    "ShortName": "Tachlit TTF TelB CPIL 1-3",
    "Symbol": "TASE:5135819",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (00) Tel Bond CPI-Linked 1-3 Years IL",
    "EnglishLongName": "Tachlit TTF (00) Tel Bond CPI-Linked 1-3 Years IL",
    "HebrewName": "תכלית TTF תלבונד צמוד 1-3",
    "HebrewLongName": "תכלית TTF י(00) תל בונד-צמודות 1-3",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.17,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 768.5,
    "MonthYield": 0.16,
    "YearYield": 0.16,
    "Last12MonthYield": 4.91,
    "ISIN": "IL0051358195"
  },
  {
    "Id": "TASE:5125323",
    "MayaId": "5125323",
    "Name": "Tachlit TTF TelB Shek50",
    "ShortName": "Tachlit TTF TelB Shek50",
    "Symbol": "TASE:5125323",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (00) Tel Bond Shekel-50 IL",
    "EnglishLongName": "Tachlit TTF (00) Tel Bond Shekel-50 IL",
    "HebrewName": "תכלית TTF תלבונד ש 50",
    "HebrewLongName": "תכלית TTF י(00) תל בונד שקלי 50",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.37,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 234.1,
    "MonthYield": 0.91,
    "YearYield": 0.91,
    "Last12MonthYield": 8.11,
    "ISIN": "IL0051253230"
  },
  {
    "Id": "TASE:5114491",
    "MayaId": "5114491",
    "Name": "Tachlit TTF TelBShekel",
    "ShortName": "Tachlit TTF TelBShekel",
    "Symbol": "TASE:5114491",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (00) Tel Bond-Shekel IL",
    "EnglishLongName": "Tachlit TTF (00) Tel Bond-Shekel IL",
    "HebrewName": "תכלית TTF תלבונד שקלי",
    "HebrewLongName": "תכלית TTF י(00) תל בונד שקלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.2,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.31,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 176.4,
    "MonthYield": 0.9,
    "YearYield": 0.9,
    "Last12MonthYield": 7.21,
    "ISIN": "IL0051144918"
  },
  {
    "Id": "TASE:5133335",
    "MayaId": "5133335",
    "Name": "Tachlit TTF US Robo ILS",
    "ShortName": "Tachlit TTF US Robo ILS",
    "Symbol": "TASE:5133335",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4A) Nasdaq CTA US Artificial Intelligence and Robotics Currency-Hed",
    "EnglishLongName": "Tachlit TTF (4A) Nasdaq CTA US Artificial Intelligence and Robotics Currency-Hed",
    "HebrewName": "תכלית TTF US Robotics ממ",
    "HebrewLongName": "תכלית TTF י(4A)י Nasdaq CTA US Artificial Intelligence and Robotics מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.72,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 10.2,
    "MonthYield": 5.29,
    "YearYield": 5.29,
    "Last12MonthYield": 16.45,
    "ISIN": "IL0051333354"
  },
  {
    "Id": "TASE:5140637",
    "MayaId": "5140637",
    "Name": "Tachlit TTF USCapMarkets",
    "ShortName": "Tachlit TTF USCapMarkets",
    "Symbol": "TASE:5140637",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4A) US Capital Markets iNDEX Currency-Hedged",
    "EnglishLongName": "Tachlit TTF (4A) US Capital Markets iNDEX Currency-Hedged",
    "HebrewName": "תכלית USCapMarkets TTFממ",
    "HebrewLongName": "תכלית TTF י(4A)י US Capital Markets iNDEX מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.39,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 19.3,
    "MonthYield": 5.03,
    "YearYield": 5.03,
    "Last12MonthYield": null,
    "ISIN": "IL0051406374"
  },
  {
    "Id": "TASE:5139761",
    "MayaId": "5139761",
    "Name": "Tachlit TTF USREITsILS",
    "ShortName": "Tachlit TTF USREITsILS",
    "Symbol": "TASE:5139761",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4A) US REITs iNDEX Currency-Hedged",
    "EnglishLongName": "Tachlit TTF (4A) US REITs iNDEX Currency-Hedged",
    "HebrewName": "תכלית US REITs TTFממ",
    "HebrewLongName": "תכלית TTF י(4A)י US REITs iNDEX מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.35,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.1,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 9.0,
    "MonthYield": 3.89,
    "YearYield": 3.89,
    "Last12MonthYield": null,
    "ISIN": "IL0051397615"
  },
  {
    "Id": "TASE:5131768",
    "MayaId": "5131768",
    "Name": "TachlitTTF IND tour@Le EW",
    "ShortName": "TachlitTTF IND tour@Le EW",
    "Symbol": "TASE:5131768",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4D) INDXX TOURISM & LEISURE EW",
    "EnglishLongName": "Tachlit TTF (4D) INDXX TOURISM & LEISURE EW",
    "HebrewName": "תכליתIND Tour&Leis EW TTF",
    "HebrewLongName": "תכלית TTF י(4D) ‏ INDXX TOURISM & LEISURE EW",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.24,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 17.8,
    "MonthYield": -0.25,
    "YearYield": -0.25,
    "Last12MonthYield": -5.39,
    "ISIN": "IL0051317688"
  },
  {
    "Id": "TASE:5124409",
    "MayaId": "5124409",
    "Name": "TachlitTTFIndx HY BBBUnIL",
    "ShortName": "TachlitTTFIndx HY-BBBUnIL",
    "Symbol": "TASE:5124409",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (00)(!) Index HY-BBB Universe IL",
    "EnglishLongName": "Tachlit TTF (00)(!) Index HY-BBB Universe IL",
    "HebrewName": "תכלית TTF אינדHY-BBB כלל",
    "HebrewLongName": "תכלית TTF י(00)(!) אינדקס HY-BBB כללי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.26,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Hi-risk Corporate & Convertibles",
    "AssetValue": 21.3,
    "MonthYield": 1.02,
    "YearYield": 1.02,
    "Last12MonthYield": 7.3,
    "ISIN": "IL0051244098"
  },
  {
    "Id": "TDRN.TA",
    "MayaId": "258012",
    "Name": "TADIRAN GROUP",
    "ShortName": "TADIRAN GROUP LTD",
    "Symbol": "TDRN.TA",
    "TaseSymbol": "TDRN",
    "YahooId": "TDRN.TA",
    "EnglishName": "TADIRAN GROUP",
    "EnglishLongName": "TADIRAN GROUP LTD",
    "HebrewName": "תדיראן גרופ",
    "HebrewLongName": "תדיראן גרופ בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 15640.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 22.6,
    "YearYield": 22.6,
    "Last12MonthYield": null,
    "ISIN": "IL0002580129"
  },
  {
    "Id": "TMRP.TA",
    "MayaId": "1141357",
    "Name": "TAMAR PET",
    "ShortName": "TAMAR PETROLEUM LTD",
    "Symbol": "TMRP.TA",
    "TaseSymbol": "TMRP",
    "YahooId": "TMRP.TA",
    "EnglishName": "TAMAR PET",
    "EnglishLongName": "TAMAR PETROLEUM LTD",
    "HebrewName": "תמר פטרוליום",
    "HebrewLongName": "תמר פטרוליום בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3322.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Energy And Oil & Gas Exploration",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -10.2,
    "YearYield": -10.2,
    "Last12MonthYield": null,
    "ISIN": "IL0011413577"
  },
  {
    "Id": "TASE:5141593",
    "MayaId": "5141593",
    "Name": "Tamir Fishman 70/30",
    "ShortName": "Tamir Fishman 70/30",
    "Symbol": "TASE:5141593",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tamir Fishman (2B) 70/30 IL",
    "EnglishLongName": "Tamir Fishman (2B) 70/30 IL",
    "HebrewName": "תמיר פישמן 30/70",
    "HebrewLongName": "תמיר פישמן (2B)י 30/70",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "TAMIR FISHMAN MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 0.6,
    "MonthYield": 2.04,
    "YearYield": 2.04,
    "Last12MonthYield": null,
    "ISIN": "IL0051415938"
  },
  {
    "Id": "TASE:5141585",
    "MayaId": "5141585",
    "Name": "Tamir Fishman 80/20",
    "ShortName": "Tamir Fishman 80/20",
    "Symbol": "TASE:5141585",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tamir Fishman (2B) 80/20 IL",
    "EnglishLongName": "Tamir Fishman (2B) 80/20 IL",
    "HebrewName": "תמיר פישמן 20/80",
    "HebrewLongName": "תמיר פישמן (2B)י 20/80",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "TAMIR FISHMAN MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 0.1,
    "MonthYield": 0.5,
    "YearYield": 0.5,
    "Last12MonthYield": null,
    "ISIN": "IL0051415854"
  },
  {
    "Id": "TASE:5141601",
    "MayaId": "5141601",
    "Name": "Tamir Fishman Flexible",
    "ShortName": "Tamir Fishman Flexible",
    "Symbol": "TASE:5141601",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tamir Fishman (4D) Flexible",
    "EnglishLongName": "Tamir Fishman (4D) Flexible",
    "HebrewName": "תמיר פישמן גמישה",
    "HebrewLongName": "תמיר פישמן (4D)י גמישה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.49,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "TAMIR FISHMAN MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 1.6,
    "MonthYield": 3.62,
    "YearYield": 3.62,
    "Last12MonthYield": null,
    "ISIN": "IL0051416019"
  },
  {
    "Id": "TASE:5122809",
    "MayaId": "5122809",
    "Name": "Target (4D) Europe Shares",
    "ShortName": "Target (4D) Europe Shares",
    "Symbol": "TASE:5122809",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Target (4D) EUROPE SHARES",
    "EnglishLongName": "Target (4D) EUROPE SHARES",
    "HebrewName": "טרגט (4D) מניות אירופה",
    "HebrewLongName": "טרגט (4D) מניות אירופה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.59,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.47,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Geographical stocks",
    "AssetValue": 9.0,
    "MonthYield": 0.27,
    "YearYield": 0.27,
    "Last12MonthYield": 10.33,
    "ISIN": "IL0051228091"
  },
  {
    "Id": "TASE:5118260",
    "MayaId": "5118260",
    "Name": "Target 80/20 IL",
    "ShortName": "Target 80/20 IL",
    "Symbol": "TASE:5118260",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Target (2B) 80/20 IL",
    "EnglishLongName": "Target (2B) 80/20 IL",
    "HebrewName": "טרגט 20/80",
    "HebrewLongName": "טרגט (2B)י 20/80",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.55,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.42,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 23.5,
    "MonthYield": 2.0,
    "YearYield": 2.0,
    "Last12MonthYield": 10.97,
    "ISIN": "IL0051182603"
  },
  {
    "Id": "TASE:5118765",
    "MayaId": "5118765",
    "Name": "Target 90/10 IL",
    "ShortName": "Target 90/10 IL",
    "Symbol": "TASE:5118765",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Target (1B) 90/10 IL",
    "EnglishLongName": "Target (1B) 90/10 IL",
    "HebrewName": "טרגט 10/90",
    "HebrewLongName": "טרגט (1B)י 10/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.55,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.36,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 83.9,
    "MonthYield": 1.24,
    "YearYield": 1.24,
    "Last12MonthYield": 8.63,
    "ISIN": "IL0051187651"
  },
  {
    "Id": "TASE:5116637",
    "MayaId": "5116637",
    "Name": "Target Agh Lelo Menyot IL",
    "ShortName": "Target Agh Lelo Menyot IL",
    "Symbol": "TASE:5116637",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Target (0A) Agach Lelo Menayot IL",
    "EnglishLongName": "Target (0A) Agach Lelo Menayot IL",
    "HebrewName": "טרגט אג\"ח ללא מניות",
    "HebrewLongName": "טרגט (0A) אג\"ח ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.55,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.29,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 232.4,
    "MonthYield": 0.65,
    "YearYield": 0.65,
    "Last12MonthYield": 6.82,
    "ISIN": "IL0051166374"
  },
  {
    "Id": "TASE:5118773",
    "MayaId": "5118773",
    "Name": "Target Crp Bnd NoStock IL",
    "ShortName": "Target Crp Bnd NoStock IL",
    "Symbol": "TASE:5118773",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TARGET CORPORATE BONDS (0A)(!) STOCKS FREE IL",
    "EnglishLongName": "TARGET CORPORATE BONDS (0A)(!) STOCKS FREE IL",
    "HebrewName": "טרגט אג\"ח חברות ללא מניות",
    "HebrewLongName": "טרגט אג\"ח חברות (0A)(!) ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.55,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.25,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 37.8,
    "MonthYield": 0.87,
    "YearYield": 0.87,
    "Last12MonthYield": 6.2,
    "ISIN": "IL0051187735"
  },
  {
    "Id": "TRA.TA",
    "MayaId": "666016",
    "Name": "TARYA",
    "ShortName": "TARYA ISRAEL LTD",
    "Symbol": "TRA.TA",
    "TaseSymbol": "TRA",
    "YahooId": "TRA.TA",
    "EnglishName": "TARYA",
    "EnglishLongName": "TARYA ISRAEL LTD",
    "HebrewName": "טריא",
    "HebrewLongName": "טריא ישראל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 56.3,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 6.2,
    "YearYield": 6.2,
    "Last12MonthYield": null,
    "ISIN": "IL0006660166"
  },
  {
    "Id": "TASE.TA",
    "MayaId": "1159029",
    "Name": "TASE",
    "ShortName": "TEL AVIV STOCK EXCHANGE LTD",
    "Symbol": "TASE.TA",
    "TaseSymbol": "TASE",
    "YahooId": "TASE.TA",
    "EnglishName": "TASE",
    "EnglishLongName": "TEL AVIV STOCK EXCHANGE LTD",
    "HebrewName": "הבורסה לניע בתא",
    "HebrewLongName": "הבורסה לניירות ערך בתל-אביב בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 11340.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Financial Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 21.1,
    "YearYield": 21.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011590291"
  },
  {
    "Id": "TATT.TA",
    "MayaId": "1082726",
    "Name": "TAT TECHNO",
    "ShortName": "TAT TECHNOLOGIES LTD",
    "Symbol": "TATT.TA",
    "TaseSymbol": "TATT",
    "YahooId": "TATT.TA",
    "EnglishName": "TAT TECHNO",
    "EnglishLongName": "TAT TECHNOLOGIES LTD",
    "HebrewName": "תאת טכנו",
    "HebrewLongName": "תאת טכנולוגיות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 16400.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 18.2,
    "YearYield": 18.2,
    "Last12MonthYield": null,
    "ISIN": "IL0010827264"
  },
  {
    "Id": "TAYA.TA",
    "MayaId": "796011",
    "Name": "TAYA INV",
    "ShortName": "TAYA INVESTMENT CO. LTD.",
    "Symbol": "TAYA.TA",
    "TaseSymbol": "TAYA",
    "YahooId": "TAYA.TA",
    "EnglishName": "TAYA INV",
    "EnglishLongName": "TAYA INVESTMENT CO. LTD.",
    "HebrewName": "תיא השקעות",
    "HebrewLongName": "תיא חברה להשקעות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5140.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 2.1,
    "YearYield": 2.1,
    "Last12MonthYield": null,
    "ISIN": "IL0007960110"
  },
  {
    "Id": "TASE:766",
    "MayaId": "766",
    "Name": "TB A Diversified Issuers",
    "ShortName": "TB A Diversified Issuers",
    "Symbol": "TASE:766",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TB A Diversified Issuers",
    "EnglishLongName": "TB A Diversified Issuers",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:767",
    "MayaId": "767",
    "Name": "TB AA Diversified Issuers",
    "ShortName": "TB AA Diversified Issuers",
    "Symbol": "TASE:767",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TB AA Diversified Issuers",
    "EnglishLongName": "TB AA Diversified Issuers",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:5130141",
    "MayaId": "5130141",
    "Name": "TC.NDXDRAGONILS",
    "ShortName": "TC.NDXDRAGONILS",
    "Symbol": "TASE:5130141",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4A) Nasdaq Golden Dragon China Currency-Hedged",
    "EnglishLongName": "Tachlit TTF (4A) Nasdaq Golden Dragon China Currency-Hedged",
    "HebrewName": "תכליתChina HXCNTR TTF ממ",
    "HebrewLongName": "תכלית TTF י(4A)י Nasdaq Golden Dragon China מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.76,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 8.3,
    "MonthYield": 3.63,
    "YearYield": 3.63,
    "Last12MonthYield": 13.89,
    "ISIN": "IL0051301419"
  },
  {
    "Id": "TASE:5121322",
    "MayaId": "5121322",
    "Name": "TCL CMP INT EQT",
    "ShortName": "TCL CMP INT EQT",
    "Symbol": "TASE:5121322",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4D) Composite Int. Equity Monthly",
    "EnglishLongName": "Tachlit TTF (4D) Composite Int. Equity Monthly",
    "HebrewName": "תכלית TTF מש מניות חול",
    "HebrewLongName": "תכלית 4D) TTF) משולבת סל מניות חו\"ל חודשי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.21,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Stocks Abroad, Composite",
    "AssetValue": 77.6,
    "MonthYield": 0.16,
    "YearYield": 0.16,
    "Last12MonthYield": 7.17,
    "ISIN": "IL0051213226"
  },
  {
    "Id": "TASE:5128756",
    "MayaId": "5128756",
    "Name": "TCL DJONES INTR",
    "ShortName": "TCL DJONES INTR",
    "Symbol": "TASE:5128756",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4D) Dow Jones Internet Composite",
    "EnglishLongName": "Tachlit TTF (4D) Dow Jones Internet Composite",
    "HebrewName": "תכלית TTF DJ Internet",
    "HebrewLongName": "תכלית Dow Jones Internet Composite (4D) TTF",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.65,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 13.3,
    "MonthYield": -3.3,
    "YearYield": -3.3,
    "Last12MonthYield": -6.83,
    "ISIN": "IL0051287568"
  },
  {
    "Id": "TASE:5124581",
    "MayaId": "5124581",
    "Name": "TCL DOWJONES IA",
    "ShortName": "TCL DOWJONES IA",
    "Symbol": "TASE:5124581",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4D) DJ Industrial Average",
    "EnglishLongName": "Tachlit TTF (4D) DJ Industrial Average",
    "HebrewName": "תכלית DowJones IA TTF",
    "HebrewLongName": "תכלית DJ Industrial Average (4D) TTF",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 107.9,
    "MonthYield": 1.47,
    "YearYield": 1.47,
    "Last12MonthYield": 1.42,
    "ISIN": "IL0051245814"
  },
  {
    "Id": "TASE:5128939",
    "MayaId": "5128939",
    "Name": "TCL IND EGAMING",
    "ShortName": "TCL IND EGAMING",
    "Symbol": "TASE:5128939",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4D) Indxx US eGaming & Virtual Reality",
    "EnglishLongName": "Tachlit TTF (4D) Indxx US eGaming & Virtual Reality",
    "HebrewName": "תכלית Indx eGaming TTF",
    "HebrewLongName": "תכלית TTF י(4D)י Indxx US eGaming & Virtual Reality",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.98,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 25.5,
    "MonthYield": -0.91,
    "YearYield": -0.91,
    "Last12MonthYield": 15.63,
    "ISIN": "IL0051289390"
  },
  {
    "Id": "TASE:5129945",
    "MayaId": "5129945",
    "Name": "TCL IND FOOD TC",
    "ShortName": "TCL IND FOOD TC",
    "Symbol": "TASE:5129945",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4D) Indxx US Food-Tech",
    "EnglishLongName": "Tachlit TTF (4D) Indxx US Food-Tech",
    "HebrewName": "תכלית INDXX Food Tech TTF",
    "HebrewLongName": "תכלית Indxx US Food-Tech (4D) TTF",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.75,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 7.6,
    "MonthYield": 4.6,
    "YearYield": 4.6,
    "Last12MonthYield": -18.02,
    "ISIN": "IL0051299456"
  },
  {
    "Id": "TASE:5127600",
    "MayaId": "5127600",
    "Name": "TCL ISE CLUD IL",
    "ShortName": "TCL ISE CLUD IL",
    "Symbol": "TASE:5127600",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4A) ISE CTA Cloud Computing Currency-Hedged",
    "EnglishLongName": "Tachlit TTF (4A) ISE CTA Cloud Computing Currency-Hedged",
    "HebrewName": "תכלית ISE CLOUD TTF ממ",
    "HebrewLongName": "תכלית ISE CTA Cloud Computing (4A) TTF מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0.2,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.04,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 96.7,
    "MonthYield": -3.69,
    "YearYield": -3.69,
    "Last12MonthYield": 2.67,
    "ISIN": "IL0051276009"
  },
  {
    "Id": "TASE:5127063",
    "MayaId": "5127063",
    "Name": "TCL ISE CYBR IL",
    "ShortName": "TCL ISE CYBR IL",
    "Symbol": "TASE:5127063",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4B) ISE CYBER SECURITY U.S.D Hedged",
    "EnglishLongName": "Tachlit TTF (4B) ISE CYBER SECURITY U.S.D Hedged",
    "HebrewName": "תכלית ISE Cyber TTF מד",
    "HebrewLongName": "תכלית ISE Cyber Security (4B) TTF מנוטרלת דולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.83,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 125.7,
    "MonthYield": -1.19,
    "YearYield": -1.19,
    "Last12MonthYield": 1.7,
    "ISIN": "IL0051270630"
  },
  {
    "Id": "TASE:5124573",
    "MayaId": "5124573",
    "Name": "TCL MSCI WORLD",
    "ShortName": "TCL MSCI WORLD",
    "Symbol": "TASE:5124573",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4D) MSCI WORLD",
    "EnglishLongName": "Tachlit TTF (4D) MSCI WORLD",
    "HebrewName": "תכלית MSCI WORLD TTF",
    "HebrewLongName": "תכלית MSCI WORLD (4D) TTF",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.31,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.07,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 401.9,
    "MonthYield": -0.27,
    "YearYield": -0.27,
    "Last12MonthYield": 5.15,
    "ISIN": "IL0051245731"
  },
  {
    "Id": "TASE:5123179",
    "MayaId": "5123179",
    "Name": "TCL NDX 100 ILS",
    "ShortName": "TCL NDX 100 ILS",
    "Symbol": "TASE:5123179",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4A) NASDAQ 100 Currency-Hedged",
    "EnglishLongName": "Tachlit TTF (4A) NASDAQ 100 Currency-Hedged",
    "HebrewName": "תכלית NDX 100 TTF ממ",
    "HebrewLongName": "תכלית NASDAQ 100 (4A) TTF מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.05,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 888.8,
    "MonthYield": 1.16,
    "YearYield": 1.16,
    "Last12MonthYield": 19.64,
    "ISIN": "IL0051231798"
  },
  {
    "Id": "TASE:5127329",
    "MayaId": "5127329",
    "Name": "TCL PHLX SMCOND",
    "ShortName": "TCL PHLX SMCOND",
    "Symbol": "TASE:5127329",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4D) PHLX Semiconductor Sector",
    "EnglishLongName": "Tachlit TTF (4D) PHLX Semiconductor Sector",
    "HebrewName": "תכליתPHLX Semicond TTF",
    "HebrewLongName": "תכלית PHLX Semiconductor Sector (4D) TTF",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.77,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 956.0,
    "MonthYield": 9.13,
    "YearYield": 9.13,
    "Last12MonthYield": 35.62,
    "ISIN": "IL0051273295"
  },
  {
    "Id": "TASE:5127055",
    "MayaId": "5127055",
    "Name": "TCL SP US AD IL",
    "ShortName": "TCL SP US AD IL",
    "Symbol": "TASE:5127055",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4A) S&P Aerospace & Defense Currency-Hedged",
    "EnglishLongName": "Tachlit TTF (4A) S&P Aerospace & Defense Currency-Hedged",
    "HebrewName": "תכלית SP US AD TTF ממ",
    "HebrewLongName": "תכלית S&P Aerospace & Defense (4A) TTF מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.55,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.24,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 323.8,
    "MonthYield": 20.02,
    "YearYield": 20.02,
    "Last12MonthYield": 71.83,
    "ISIN": "IL0051270556"
  },
  {
    "Id": "TASE:5127287",
    "MayaId": "5127287",
    "Name": "TCL SP UTILT IL",
    "ShortName": "TCL SP UTILT IL",
    "Symbol": "TASE:5127287",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4A) S&P Utilities Currency-Hedged",
    "EnglishLongName": "Tachlit TTF (4A) S&P Utilities Currency-Hedged",
    "HebrewName": "תכלית SP Utilities TTF ממ",
    "HebrewLongName": "תכלית S&P Utilities (4A) TTF מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 58.9,
    "MonthYield": 2.21,
    "YearYield": 2.21,
    "Last12MonthYield": 15.58,
    "ISIN": "IL0051272875"
  },
  {
    "Id": "TASE:5123161",
    "MayaId": "5123161",
    "Name": "TCL SP500 ILS",
    "ShortName": "TCL SP500 ILS",
    "Symbol": "TASE:5123161",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4A) S&P 500 Currency-Hedged",
    "EnglishLongName": "Tachlit TTF (4A) S&P 500 Currency-Hedged",
    "HebrewName": "תכלית SP500 TTF ממ",
    "HebrewLongName": "תכלית S&P 500 (4A) TTF מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.57,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 1820.9,
    "MonthYield": 1.46,
    "YearYield": 1.46,
    "Last12MonthYield": 17.06,
    "ISIN": "IL0051231616"
  },
  {
    "Id": "TASE:5123153",
    "MayaId": "5123153",
    "Name": "TCL STOX600 ILS",
    "ShortName": "TCL STOX600 ILS",
    "Symbol": "TASE:5123153",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4A) STOXX600 EURO Hedged",
    "EnglishLongName": "Tachlit TTF (4A) STOXX600 EURO Hedged",
    "HebrewName": "תכלית STOX600 TTF מא",
    "HebrewLongName": "תכלית STOXX Europe 600 (4A) TTF מנוטרלת אירו",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.17,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 194.7,
    "MonthYield": 3.66,
    "YearYield": 3.66,
    "Last12MonthYield": 25.94,
    "ISIN": "IL0051231533"
  },
  {
    "Id": "TASE:5127915",
    "MayaId": "5127915",
    "Name": "TCL TTF ISE CLD",
    "ShortName": "TCL TTF ISE CLD",
    "Symbol": "TASE:5127915",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4D) ISE CTA Cloud Computing",
    "EnglishLongName": "Tachlit TTF (4D) ISE CTA Cloud Computing",
    "HebrewName": "תכלית ISE CLOUD TTF",
    "HebrewLongName": "תכלית ISE CTA Cloud Computing (4D) TTF",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.6,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.73,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "HERMETIC TRUST LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 48.6,
    "MonthYield": -4.97,
    "YearYield": -4.97,
    "Last12MonthYield": -9.36,
    "ISIN": "IL0051279151"
  },
  {
    "Id": "TASE:5124532",
    "MayaId": "5124532",
    "Name": "TCL TTF NDX 100",
    "ShortName": "TCL TTF NDX 100",
    "Symbol": "TASE:5124532",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4D) NASDAQ 100",
    "EnglishLongName": "Tachlit TTF (4D) NASDAQ 100",
    "HebrewName": "תכלית NDX 100 TTF",
    "HebrewLongName": "תכלית NASDAQ 100 (4D) TTF",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.3,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.81,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 285.1,
    "MonthYield": -0.21,
    "YearYield": -0.21,
    "Last12MonthYield": 5.14,
    "ISIN": "IL0051245327"
  },
  {
    "Id": "TASE:5113998",
    "MayaId": "5113998",
    "Name": "TCL TTF SP500",
    "ShortName": "TCL TTF SP500",
    "Symbol": "TASE:5113998",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4D) S&P 500",
    "EnglishLongName": "Tachlit TTF (4D) S&P 500",
    "HebrewName": "תכלית SP500 TTF",
    "HebrewLongName": "תכלית S&P 500 (4D) TTF",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.3,
    "TrusteeFee": 0.03,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 1285.8,
    "MonthYield": 0.08,
    "YearYield": 0.08,
    "Last12MonthYield": 2.6,
    "ISIN": "IL0051139983"
  },
  {
    "Id": "TASE:5128988",
    "MayaId": "5128988",
    "Name": "TCL US CYBERSC",
    "ShortName": "TCL US CYBERSC",
    "Symbol": "TASE:5128988",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tachlit TTF (4D) Indxx US Junior Cybersecurity",
    "EnglishLongName": "Tachlit TTF (4D) Indxx US Junior Cybersecurity",
    "HebrewName": "תכלית Indx Cybersec TTF",
    "HebrewLongName": "תכלית TTF י(4D)י Indxx US Junior Cybersecurity",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.51,
    "Sector": "",
    "Industry": "",
    "ManagerName": "MEITAV MUTUAL FUNDS LTD",
    "TrusteeName": "ALMGOR - BRIGHTMAN TRUSTS LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 22.0,
    "MonthYield": 7.2,
    "YearYield": 7.2,
    "Last12MonthYield": 19.56,
    "ISIN": "IL0051289887"
  },
  {
    "Id": "TECT.TA",
    "MayaId": "216010",
    "Name": "TECTONA",
    "ShortName": "TECTONA LTD",
    "Symbol": "TECT.TA",
    "TaseSymbol": "TECT",
    "YahooId": "TECT.TA",
    "EnglishName": "TECTONA",
    "EnglishLongName": "TECTONA LTD",
    "HebrewName": "טקטונה",
    "HebrewLongName": "טקטונה בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 299.1,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 15.7,
    "YearYield": 15.7,
    "Last12MonthYield": null,
    "ISIN": "IL0002160104"
  },
  {
    "Id": "TEDE.TA",
    "MayaId": "142018",
    "Name": "TEDEA",
    "ShortName": "TEDEA TECHNOLOGICAL DEVELOPMENT & AUTOMOTION LTD.",
    "Symbol": "TEDE.TA",
    "TaseSymbol": "TEDE",
    "YahooId": "TEDE.TA",
    "EnglishName": "TEDEA",
    "EnglishLongName": "TEDEA TECHNOLOGICAL DEVELOPMENT & AUTOMOTION LTD.",
    "HebrewName": "תדאה",
    "HebrewLongName": "תדאה פיתוח טכנולוגי ואוטומציה בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 321.1,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Investment & Holdings",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 2.2,
    "YearYield": 2.2,
    "Last12MonthYield": null,
    "ISIN": "IL0001420186"
  },
  {
    "Id": "TFRLF.TA",
    "MayaId": "1082585",
    "Name": "TEFRON",
    "ShortName": "TEFRON LTD.",
    "Symbol": "TFRLF.TA",
    "TaseSymbol": "TFRLF",
    "YahooId": "TFRLF.TA",
    "EnglishName": "TEFRON",
    "EnglishLongName": "TEFRON LTD.",
    "HebrewName": "תפרון",
    "HebrewLongName": "תפרון בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1397.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -2.8,
    "YearYield": -2.8,
    "Last12MonthYield": null,
    "ISIN": "IL0010825854"
  },
  {
    "Id": "^TASE",
    "MayaId": null,
    "Name": "Tel Aviv Stock Exchange",
    "ShortName": "Tel Aviv Stock Exchange",
    "Symbol": "^TASE",
    "TaseSymbol": "",
    "YahooId": "^TASE",
    "EnglishName": "Tel Aviv Stock Exchange",
    "EnglishLongName": "Tel Aviv Stock Exchange",
    "HebrewName": "הבורסה לני\"ע",
    "HebrewLongName": "הבורסה לני\"ע",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": null,
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": ""
  },
  {
    "Id": "TASE:743",
    "MayaId": "743",
    "Name": "Tel Bond 100 CPI Linked",
    "ShortName": "Tel Bond 100 CPI Linked",
    "Symbol": "TASE:743",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond 100 CPI Linked",
    "EnglishLongName": "Tel Bond 100 CPI Linked",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:753",
    "MayaId": "753",
    "Name": "Tel Bond 125 Value CPI",
    "ShortName": "Tel Bond 125 Value CPI",
    "Symbol": "TASE:753",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond 125 Value CPI",
    "EnglishLongName": "Tel Bond 125 Value CPI",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:752",
    "MayaId": "752",
    "Name": "Tel Bond 125 Value Shekel",
    "ShortName": "Tel Bond 125 Value Shekel",
    "Symbol": "TASE:752",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond 125 Value Shekel",
    "EnglishLongName": "Tel Bond 125 Value Shekel",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:707",
    "MayaId": "707",
    "Name": "Tel Bond 20 CPI Linked",
    "ShortName": "Tel Bond-20 CPI Linked",
    "Symbol": "TASE:707",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond 20 CPI Linked",
    "EnglishLongName": "Tel Bond-20 CPI Linked",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:708",
    "MayaId": "708",
    "Name": "Tel Bond 40 CPI Linked",
    "ShortName": "Tel Bond-40 CPI Linked",
    "Symbol": "TASE:708",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond 40 CPI Linked",
    "EnglishLongName": "Tel Bond-40 CPI Linked",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:709",
    "MayaId": "709",
    "Name": "Tel Bond 60 CPI Linked",
    "ShortName": "Tel Bond-60 CPI Linked",
    "Symbol": "TASE:709",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond 60 CPI Linked",
    "EnglishLongName": "Tel Bond-60 CPI Linked",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:765",
    "MayaId": "765",
    "Name": "Tel Bond 60 ILS",
    "ShortName": "Tel-Bond 60 ILS",
    "Symbol": "TASE:765",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond 60 ILS",
    "EnglishLongName": "Tel-Bond 60 ILS",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:750",
    "MayaId": "750",
    "Name": "Tel Bond Banks&GovComp",
    "ShortName": "Tel Bond Banks&GovComp",
    "Symbol": "TASE:750",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond Banks&GovComp",
    "EnglishLongName": "Tel Bond Banks&GovComp",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:761",
    "MayaId": "761",
    "Name": "Tel Bond Bullet 10/28 CPI",
    "ShortName": "Tel-Bond Bullet 10/28 CPI",
    "Symbol": "TASE:761",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond Bullet 10/28 CPI",
    "EnglishLongName": "Tel-Bond Bullet 10/28 CPI",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:760",
    "MayaId": "760",
    "Name": "Tel Bond Bullet 2029 ILS",
    "ShortName": "Tel-Bond Bullet 2029 ILS",
    "Symbol": "TASE:760",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond Bullet 2029 ILS",
    "EnglishLongName": "Tel-Bond Bullet 2029 ILS",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:762",
    "MayaId": "762",
    "Name": "Tel Bond Bullet 29 Israel",
    "ShortName": "Tel-Bond Bullet 29 Israel",
    "Symbol": "TASE:762",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond Bullet 29 Israel",
    "EnglishLongName": "Tel-Bond Bullet 29 Israel",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:744",
    "MayaId": "744",
    "Name": "Tel Bond CoCo A+",
    "ShortName": "Tel Bond-CoCo A+",
    "Symbol": "TASE:744",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond CoCo A+",
    "EnglishLongName": "Tel Bond-CoCo A+",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:715",
    "MayaId": "715",
    "Name": "Tel Bond Composite",
    "ShortName": "Tel Bond-Composite",
    "Symbol": "TASE:715",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond Composite",
    "EnglishLongName": "Tel Bond-Composite",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:763",
    "MayaId": "763",
    "Name": "Tel Bond CP",
    "ShortName": "Tel Bond CP",
    "Symbol": "TASE:763",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond CP",
    "EnglishLongName": "Tel Bond CP",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:749",
    "MayaId": "749",
    "Name": "Tel Bond CPI 5 10",
    "ShortName": "Tel Bond CPI 5-10",
    "Symbol": "TASE:749",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond CPI 5 10",
    "EnglishLongName": "Tel Bond CPI 5-10",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:747",
    "MayaId": "747",
    "Name": "Tel Bond CPI Banks & COCO",
    "ShortName": "Tel Bond CPI Banks & COCO",
    "Symbol": "TASE:747",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond CPI Banks & COCO",
    "EnglishLongName": "Tel Bond CPI Banks & COCO",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:711",
    "MayaId": "711",
    "Name": "Tel Bond CPI Linked",
    "ShortName": "Tel Bond-CPI Linked",
    "Symbol": "TASE:711",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond CPI Linked",
    "EnglishLongName": "Tel Bond-CPI Linked",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:721",
    "MayaId": "721",
    "Name": "Tel Bond CPI Linked 1 3",
    "ShortName": "Tel Bond-CPI Linked 1-3",
    "Symbol": "TASE:721",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond CPI Linked 1 3",
    "EnglishLongName": "Tel Bond-CPI Linked 1-3",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:722",
    "MayaId": "722",
    "Name": "Tel Bond CPI Linked 3 5",
    "ShortName": "Tel Bond-CPI Linked 3-5",
    "Symbol": "TASE:722",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond CPI Linked 3 5",
    "EnglishLongName": "Tel Bond-CPI Linked 3-5",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:723",
    "MayaId": "723",
    "Name": "Tel Bond CPI Linked 5 15",
    "ShortName": "Tel Bond-CPI Linked 5-15",
    "Symbol": "TASE:723",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond CPI Linked 5 15",
    "EnglishLongName": "Tel Bond-CPI Linked 5-15",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:735",
    "MayaId": "735",
    "Name": "Tel Bond CPI Linked A",
    "ShortName": "Tel Bond-CPI Linked A",
    "Symbol": "TASE:735",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond CPI Linked A",
    "EnglishLongName": "Tel Bond-CPI Linked A",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:736",
    "MayaId": "736",
    "Name": "Tel Bond CPI Linked AA AAA",
    "ShortName": "Tel Bond-CPI Linked AA-AAA",
    "Symbol": "TASE:736",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond CPI Linked AA AAA",
    "EnglishLongName": "Tel Bond-CPI Linked AA-AAA",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:756",
    "MayaId": "756",
    "Name": "Tel Bond CPI Linked AAA",
    "ShortName": "Tel Bond CPI Linked AAA",
    "Symbol": "TASE:756",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond CPI Linked AAA",
    "EnglishLongName": "Tel Bond CPI Linked AAA",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:713",
    "MayaId": "713",
    "Name": "Tel Bond CPI Linked Banks Exclude COCO",
    "ShortName": "Tel Bond-CPI Linked Banks Exclude COCO",
    "Symbol": "TASE:713",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond CPI Linked Banks Exclude COCO",
    "EnglishLongName": "Tel Bond-CPI Linked Banks Exclude COCO",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:758",
    "MayaId": "758",
    "Name": "Tel Bond CPI Linked Double Rating",
    "ShortName": "Tel Bond CPI Linked Double Rating",
    "Symbol": "TASE:758",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond CPI Linked Double Rating",
    "EnglishLongName": "Tel Bond CPI Linked Double Rating",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:731",
    "MayaId": "731",
    "Name": "Tel Bond CPI Linked MaalaSRI",
    "ShortName": "Tel Bond-CPI Linked MaalaSRI",
    "Symbol": "TASE:731",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond CPI Linked MaalaSRI",
    "EnglishLongName": "Tel Bond-CPI Linked MaalaSRI",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:734",
    "MayaId": "734",
    "Name": "Tel Bond CPI Linked RealEstate",
    "ShortName": "Tel Bond-CPI Linked RealEstate",
    "Symbol": "TASE:734",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond CPI Linked RealEstate",
    "EnglishLongName": "Tel Bond-CPI Linked RealEstate",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:712",
    "MayaId": "712",
    "Name": "Tel Bond CPI Linked SmallCap",
    "ShortName": "Tel Bond-CPI Linked SmallCap",
    "Symbol": "TASE:712",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond CPI Linked SmallCap",
    "EnglishLongName": "Tel Bond-CPI Linked SmallCap",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:719",
    "MayaId": "719",
    "Name": "Tel Bond Global Shekel",
    "ShortName": "Tel Bond-Global Shekel",
    "Symbol": "TASE:719",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond Global Shekel",
    "EnglishLongName": "Tel Bond-Global Shekel",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:717",
    "MayaId": "717",
    "Name": "Tel Bond Non Linked",
    "ShortName": "Tel Bond-Non Linked",
    "Symbol": "TASE:717",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond Non Linked",
    "EnglishLongName": "Tel Bond-Non Linked",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:757",
    "MayaId": "757",
    "Name": "Tel Bond Non Linked AAA",
    "ShortName": "Tel Bond Non Linked AAA",
    "Symbol": "TASE:757",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond Non Linked AAA",
    "EnglishLongName": "Tel Bond Non Linked AAA",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:759",
    "MayaId": "759",
    "Name": "Tel Bond Non Linked Double Rating",
    "ShortName": "Tel Bond Non Linked Double Rating",
    "Symbol": "TASE:759",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond Non Linked Double Rating",
    "EnglishLongName": "Tel Bond Non Linked Double Rating",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:710",
    "MayaId": "710",
    "Name": "Tel Bond Shekel",
    "ShortName": "Tel Bond-Shekel",
    "Symbol": "TASE:710",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond Shekel",
    "EnglishLongName": "Tel Bond-Shekel",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:724",
    "MayaId": "724",
    "Name": "Tel Bond Shekel 1 3",
    "ShortName": "Tel Bond-Shekel 1-3",
    "Symbol": "TASE:724",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond Shekel 1 3",
    "EnglishLongName": "Tel Bond-Shekel 1-3",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:742",
    "MayaId": "742",
    "Name": "Tel Bond Shekel 100",
    "ShortName": "Tel Bond Shekel 100",
    "Symbol": "TASE:742",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond Shekel 100",
    "EnglishLongName": "Tel Bond Shekel 100",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:725",
    "MayaId": "725",
    "Name": "Tel Bond Shekel 3 5",
    "ShortName": "Tel Bond-Shekel 3-5",
    "Symbol": "TASE:725",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond Shekel 3 5",
    "EnglishLongName": "Tel Bond-Shekel 3-5",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:748",
    "MayaId": "748",
    "Name": "Tel Bond Shekel 5 10",
    "ShortName": "Tel Bond Shekel 5-10",
    "Symbol": "TASE:748",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond Shekel 5 10",
    "EnglishLongName": "Tel Bond Shekel 5-10",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:726",
    "MayaId": "726",
    "Name": "Tel Bond Shekel 5 15",
    "ShortName": "Tel Bond-Shekel 5-15",
    "Symbol": "TASE:726",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond Shekel 5 15",
    "EnglishLongName": "Tel Bond-Shekel 5-15",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:720",
    "MayaId": "720",
    "Name": "Tel Bond Shekel 50",
    "ShortName": "Tel Bond Shekel-50",
    "Symbol": "TASE:720",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond Shekel 50",
    "EnglishLongName": "Tel Bond Shekel-50",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:737",
    "MayaId": "737",
    "Name": "Tel Bond Shekel A",
    "ShortName": "Tel Bond-Shekel A",
    "Symbol": "TASE:737",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond Shekel A",
    "EnglishLongName": "Tel Bond-Shekel A",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:738",
    "MayaId": "738",
    "Name": "Tel Bond Shekel AA AAA",
    "ShortName": "Tel Bond-Shekel AA-AAA",
    "Symbol": "TASE:738",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond Shekel AA AAA",
    "EnglishLongName": "Tel Bond-Shekel AA-AAA",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:733",
    "MayaId": "733",
    "Name": "Tel Bond Shekel Bank&Insurance",
    "ShortName": "Tel Bond-Shekel Bank&Insurance",
    "Symbol": "TASE:733",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond Shekel Bank&Insurance",
    "EnglishLongName": "Tel Bond-Shekel Bank&Insurance",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:732",
    "MayaId": "732",
    "Name": "Tel Bond Shekel MaalaSRI",
    "ShortName": "Tel Bond-Shekel MaalaSRI",
    "Symbol": "TASE:732",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond Shekel MaalaSRI",
    "EnglishLongName": "Tel Bond-Shekel MaalaSRI",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:746",
    "MayaId": "746",
    "Name": "Tel Bond Shekel Yield Diversified",
    "ShortName": "Tel Bond Shekel-Yield Diversified",
    "Symbol": "TASE:746",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond Shekel Yield Diversified",
    "EnglishLongName": "Tel Bond Shekel-Yield Diversified",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:714",
    "MayaId": "714",
    "Name": "Tel Bond Yields CPI Linked",
    "ShortName": "Tel Bond Yields CPI Linked",
    "Symbol": "TASE:714",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond Yields CPI Linked",
    "EnglishLongName": "Tel Bond Yields CPI Linked",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:745",
    "MayaId": "745",
    "Name": "Tel Bond Yields CPI Linked Diversified",
    "ShortName": "Tel Bond Yields CPI Linked Diversified",
    "Symbol": "TASE:745",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Bond Yields CPI Linked Diversified",
    "EnglishLongName": "Tel Bond Yields CPI Linked Diversified",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:166",
    "MayaId": "166",
    "Name": "Tel Div",
    "ShortName": "Tel-Div",
    "Symbol": "TASE:166",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Div",
    "EnglishLongName": "Tel-Div",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:200",
    "MayaId": "200",
    "Name": "Tel Div Aristocrats",
    "ShortName": "Tel Div Aristocrats",
    "Symbol": "TASE:200",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Div Aristocrats",
    "EnglishLongName": "Tel Div Aristocrats",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:602",
    "MayaId": "602",
    "Name": "Tel Gov",
    "ShortName": "Tel-Gov",
    "Symbol": "TASE:602",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Gov",
    "EnglishLongName": "Tel-Gov",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:605",
    "MayaId": "605",
    "Name": "Tel Gov CPI Linked",
    "ShortName": "Tel Gov - CPI Linked",
    "Symbol": "TASE:605",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Gov CPI Linked",
    "EnglishLongName": "Tel Gov - CPI Linked",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:637",
    "MayaId": "637",
    "Name": "Tel Gov CPI Linked 0 2",
    "ShortName": "Tel Gov - CPI Linked 0-2",
    "Symbol": "TASE:637",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Gov CPI Linked 0 2",
    "EnglishLongName": "Tel Gov - CPI Linked 0-2",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:728",
    "MayaId": "728",
    "Name": "Tel Gov CPI Linked 10+",
    "ShortName": "Tel Gov - CPI Linked 10+",
    "Symbol": "TASE:728",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Gov CPI Linked 10+",
    "EnglishLongName": "Tel Gov - CPI Linked 10+",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:646",
    "MayaId": "646",
    "Name": "Tel Gov CPI Linked 2 5",
    "ShortName": "Tel Gov - CPI Linked 2-5",
    "Symbol": "TASE:646",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Gov CPI Linked 2 5",
    "EnglishLongName": "Tel Gov - CPI Linked 2-5",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:658",
    "MayaId": "658",
    "Name": "Tel Gov CPI Linked 5 10",
    "ShortName": "Tel Gov - CPI Linked 5-10",
    "Symbol": "TASE:658",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Gov CPI Linked 5 10",
    "EnglishLongName": "Tel Gov - CPI Linked 5-10",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:727",
    "MayaId": "727",
    "Name": "Tel Gov CPI Linked 5+",
    "ShortName": "Tel Gov - CPI Linked 5+",
    "Symbol": "TASE:727",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Gov CPI Linked 5+",
    "EnglishLongName": "Tel Gov - CPI Linked 5+",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:694",
    "MayaId": "694",
    "Name": "Tel Gov CPI Linked, 15+ Years",
    "ShortName": "Tel Gov-CPI-Linked, 15+ Years",
    "Symbol": "TASE:694",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Gov CPI Linked, 15+ Years",
    "EnglishLongName": "Tel Gov-CPI-Linked, 15+ Years",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:701",
    "MayaId": "701",
    "Name": "Tel Gov Floating Shekel",
    "ShortName": "Tel Gov-Floating Shekel",
    "Symbol": "TASE:701",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Gov Floating Shekel",
    "EnglishLongName": "Tel Gov-Floating Shekel",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:690",
    "MayaId": "690",
    "Name": "Tel Gov Non Linked",
    "ShortName": "Tel Gov-Non Linked",
    "Symbol": "TASE:690",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Gov Non Linked",
    "EnglishLongName": "Tel Gov-Non Linked",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:700",
    "MayaId": "700",
    "Name": "Tel Gov Shekel",
    "ShortName": "Tel Gov - Shekel",
    "Symbol": "TASE:700",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Gov Shekel",
    "EnglishLongName": "Tel Gov - Shekel",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:702",
    "MayaId": "702",
    "Name": "Tel Gov Shekel 0 2",
    "ShortName": "Tel Gov - Shekel 0-2",
    "Symbol": "TASE:702",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Gov Shekel 0 2",
    "EnglishLongName": "Tel Gov - Shekel 0-2",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:730",
    "MayaId": "730",
    "Name": "Tel Gov Shekel 10+",
    "ShortName": "Tel Gov - Shekel 10+",
    "Symbol": "TASE:730",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Gov Shekel 10+",
    "EnglishLongName": "Tel Gov - Shekel 10+",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:703",
    "MayaId": "703",
    "Name": "Tel Gov Shekel 2 5",
    "ShortName": "Tel Gov - Shekel 2-5",
    "Symbol": "TASE:703",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Gov Shekel 2 5",
    "EnglishLongName": "Tel Gov - Shekel 2-5",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:729",
    "MayaId": "729",
    "Name": "Tel Gov Shekel 5 10",
    "ShortName": "Tel Gov - Shekel 5-10",
    "Symbol": "TASE:729",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Gov Shekel 5 10",
    "EnglishLongName": "Tel Gov - Shekel 5-10",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:704",
    "MayaId": "704",
    "Name": "Tel Gov Shekel 5+",
    "ShortName": "Tel Gov - Shekel 5+",
    "Symbol": "TASE:704",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Gov Shekel 5+",
    "EnglishLongName": "Tel Gov - Shekel 5+",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:800",
    "MayaId": "800",
    "Name": "Tel Gov T Bills (MAKAM)",
    "ShortName": "Tel Gov T-Bills (MAKAM)",
    "Symbol": "TASE:800",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tel Gov T Bills (MAKAM)",
    "EnglishLongName": "Tel Gov T-Bills (MAKAM)",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:718",
    "MayaId": "718",
    "Name": "TelBond Yield NIS",
    "ShortName": "TelBond-Yield NIS",
    "Symbol": "TASE:718",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TelBond Yield NIS",
    "EnglishLongName": "TelBond-Yield NIS",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TLSY.TA",
    "MayaId": "354019",
    "Name": "TELSYS",
    "ShortName": "TELSYS LTD.",
    "Symbol": "TLSY.TA",
    "TaseSymbol": "TLSY",
    "YahooId": "TLSY.TA",
    "EnglishName": "TELSYS",
    "EnglishLongName": "TELSYS LTD.",
    "HebrewName": "טלסיס",
    "HebrewLongName": "טלסיס בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 23480.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 3.0,
    "YearYield": 3.0,
    "Last12MonthYield": null,
    "ISIN": "IL0003540197"
  },
  {
    "Id": "TRLT.TA",
    "MayaId": "1180173",
    "Name": "TERA LIGHT",
    "ShortName": "TERA LIGHT LTD",
    "Symbol": "TRLT.TA",
    "TaseSymbol": "TRLT",
    "YahooId": "TRLT.TA",
    "EnglishName": "TERA LIGHT",
    "EnglishLongName": "TERA LIGHT LTD",
    "HebrewName": "טראלייט",
    "HebrewLongName": "טראלייט בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1535.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 12.4,
    "YearYield": 12.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011801730"
  },
  {
    "Id": "TRX.TA",
    "MayaId": "1178714",
    "Name": "TERMINAL X",
    "ShortName": "TERMINAL X ONLINE LTD",
    "Symbol": "TRX.TA",
    "TaseSymbol": "TRX",
    "YahooId": "TRX.TA",
    "EnglishName": "TERMINAL X",
    "EnglishLongName": "TERMINAL X ONLINE LTD",
    "HebrewName": "טרמינל איקס",
    "HebrewLongName": "טרמינל איקס אונליין בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 850.9,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 29.6,
    "YearYield": 29.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011787145"
  },
  {
    "Id": "TUZA.TA",
    "MayaId": "290023",
    "Name": "TEUZA",
    "ShortName": "TEUZA - A FAIRCHILD  TECHNOLOGY VENTURE LTD.",
    "Symbol": "TUZA.TA",
    "TaseSymbol": "TUZA",
    "YahooId": "TUZA.TA",
    "EnglishName": "TEUZA",
    "EnglishLongName": "TEUZA - A FAIRCHILD  TECHNOLOGY VENTURE LTD.",
    "HebrewName": "תעוזה",
    "HebrewLongName": "תעוזה",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 38.3,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.1,
    "YearYield": 1.1,
    "Last12MonthYield": null,
    "ISIN": "IL0002900236"
  },
  {
    "Id": "TEVA.TA",
    "MayaId": "629014",
    "Name": "TEVA",
    "ShortName": "TEVA- PHARMACEUTICAL INDUSTRIES LTD.",
    "Symbol": "TEVA.TA",
    "TaseSymbol": "TEVA",
    "YahooId": "TEVA.TA",
    "EnglishName": "TEVA",
    "EnglishLongName": "TEVA- PHARMACEUTICAL INDUSTRIES LTD.",
    "HebrewName": "טבע",
    "HebrewLongName": "טבע תעשיות פרמצבטיות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 9700.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -1.1,
    "YearYield": -1.1,
    "Last12MonthYield": null,
    "ISIN": "IL0006290147"
  },
  {
    "Id": "TASE:5128814",
    "MayaId": "5128814",
    "Name": "TF (4D) DIGITAL ECONOMY",
    "ShortName": "TF (4D) DIGITAL ECONOMY",
    "Symbol": "TASE:5128814",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Tamir Fishman (4D) DIGITAL ECONOMY",
    "EnglishLongName": "Tamir Fishman (4D) DIGITAL ECONOMY",
    "HebrewName": "ת.פ (4D) יDIGITAL ECONOMY",
    "HebrewLongName": "תמיר פישמן (4D)י DIGITAL ECONOMY",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.49,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.45,
    "Sector": "",
    "Industry": "",
    "ManagerName": "TAMIR FISHMAN MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 33.2,
    "MonthYield": 0.8,
    "YearYield": 0.8,
    "Last12MonthYield": 0.74,
    "ISIN": "IL0051288145"
  },
  {
    "Id": "TIGBUR.TA",
    "MayaId": "1105022",
    "Name": "TGBR",
    "ShortName": "TIGBUR - TEMPORARY PROFESSIONAL PERSONNEL LTD",
    "Symbol": "TIGBUR.TA",
    "TaseSymbol": "TIGBUR",
    "YahooId": "TIGBUR.TA",
    "EnglishName": "TGBR",
    "EnglishLongName": "TIGBUR - TEMPORARY PROFESSIONAL PERSONNEL LTD",
    "HebrewName": "תיגבור",
    "HebrewLongName": "תיגבור-מאגר כח אדם מקצועי זמני בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 6201.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 4.3,
    "YearYield": 4.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011050221"
  },
  {
    "Id": "TGI.TA",
    "MayaId": "1090141",
    "Name": "TGI",
    "ShortName": "TGI INFRASTRUCTURES LTD",
    "Symbol": "TGI.TA",
    "TaseSymbol": "TGI",
    "YahooId": "TGI.TA",
    "EnglishName": "TGI",
    "EnglishLongName": "TGI INFRASTRUCTURES LTD",
    "HebrewName": "טי.ג'י.איי",
    "HebrewLongName": "טי.ג'י.איי תשתיות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 262.1,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 3.5,
    "YearYield": 3.5,
    "Last12MonthYield": null,
    "ISIN": "IL0010901416"
  },
  {
    "Id": "TMIS.TA",
    "MayaId": "1097229",
    "Name": "THEMIS",
    "ShortName": "THEMIS G.R.E.N. LTD",
    "Symbol": "TMIS.TA",
    "TaseSymbol": "TMIS",
    "YahooId": "TMIS.TA",
    "EnglishName": "THEMIS",
    "EnglishLongName": "THEMIS G.R.E.N. LTD",
    "HebrewName": "תמיס",
    "HebrewLongName": "תמיס ג'י.אר.אי.אנ.בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1219.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.9,
    "YearYield": 0.9,
    "Last12MonthYield": null,
    "ISIN": "IL0010972292"
  },
  {
    "Id": "THES.TA",
    "MayaId": "397018",
    "Name": "THIRDEYE",
    "ShortName": "THIRDEYE SYSTEMS LTD",
    "Symbol": "THES.TA",
    "TaseSymbol": "THES",
    "YahooId": "THES.TA",
    "EnglishName": "THIRDEYE",
    "EnglishLongName": "THIRDEYE SYSTEMS LTD",
    "HebrewName": "עין שלישית",
    "HebrewLongName": "עין שלישית מערכות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 718.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 43.5,
    "YearYield": 43.5,
    "Last12MonthYield": null,
    "ISIN": "IL0003970188"
  },
  {
    "Id": "TIGI.TA",
    "MayaId": "1173871",
    "Name": "TIGI",
    "ShortName": "TIGI LTD",
    "Symbol": "TIGI.TA",
    "TaseSymbol": "TIGI",
    "YahooId": "TIGI.TA",
    "EnglishName": "TIGI",
    "EnglishLongName": "TIGI LTD",
    "HebrewName": "תיגי",
    "HebrewLongName": "תיגי בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 260.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 5.7,
    "YearYield": 5.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011738718"
  },
  {
    "Id": "TKUN.TA",
    "MayaId": "1084367",
    "Name": "TIKUN OLAM CANB",
    "ShortName": "TIKUN OLAM-CANNBIT PHARMACEUTICALS LTD",
    "Symbol": "TKUN.TA",
    "TaseSymbol": "TKUN",
    "YahooId": "TKUN.TA",
    "EnglishName": "TIKUN OLAM CANB",
    "EnglishLongName": "TIKUN OLAM-CANNBIT PHARMACEUTICALS LTD",
    "HebrewName": "תיקון עולם קנבט",
    "HebrewLongName": "תיקון עולם קנביט פארמסוטיקלס בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 26.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -0.8,
    "YearYield": -0.8,
    "Last12MonthYield": null,
    "ISIN": "IL0010843675"
  },
  {
    "Id": "TTAM.TA",
    "MayaId": "103010",
    "Name": "TIV TAAM",
    "ShortName": "TIV TAAM HOLDINGS 1 LTD",
    "Symbol": "TTAM.TA",
    "TaseSymbol": "TTAM",
    "YahooId": "TTAM.TA",
    "EnglishName": "TIV TAAM",
    "EnglishLongName": "TIV TAAM HOLDINGS 1 LTD",
    "HebrewName": "טיב טעם",
    "HebrewLongName": "טיב טעם הולדינגס 1 בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1147.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 7.2,
    "YearYield": 7.2,
    "Last12MonthYield": null,
    "ISIN": "IL0001030100"
  },
  {
    "Id": "TASE:5100300",
    "MayaId": "5100300",
    "Name": "TMR AG BENLEUMI",
    "ShortName": "TMR AG BENLEUMI",
    "Symbol": "TASE:5100300",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TAMIR FISHMAN (0D) (!) AGACH BEINLEUMI",
    "EnglishLongName": "TAMIR FISHMAN (0D) (!) AGACH BEINLEUMI",
    "HebrewName": "תמיר פישמן 0D ! אג בינלאו",
    "HebrewLongName": "תמיר פישמן (0D) (!) אג\"ח בינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.06,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.92,
    "Sector": "",
    "Industry": "",
    "ManagerName": "TAMIR FISHMAN MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "Dollar Bond",
    "AssetValue": 40.8,
    "MonthYield": -0.63,
    "YearYield": -0.63,
    "Last12MonthYield": -6.58,
    "ISIN": "IL0051003007"
  },
  {
    "Id": "TGTR.TA",
    "MayaId": "462010",
    "Name": "TOGETHER",
    "ShortName": "TOGETHER PHARMA LTD",
    "Symbol": "TGTR.TA",
    "TaseSymbol": "TGTR",
    "YahooId": "TGTR.TA",
    "EnglishName": "TOGETHER",
    "EnglishLongName": "TOGETHER PHARMA LTD",
    "HebrewName": "טוגדר",
    "HebrewLongName": "טוגדר פארמה בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 350.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 4.5,
    "YearYield": 4.5,
    "Last12MonthYield": null,
    "ISIN": "IL0004620105"
  },
  {
    "Id": "TOEN.TA",
    "MayaId": "1129493",
    "Name": "TOMER ENERGY",
    "ShortName": "TOMER ENERGY ROYALTIES (2012) LTD",
    "Symbol": "TOEN.TA",
    "TaseSymbol": "TOEN",
    "YahooId": "TOEN.TA",
    "EnglishName": "TOMER ENERGY",
    "EnglishLongName": "TOMER ENERGY ROYALTIES (2012) LTD",
    "HebrewName": "תומר אנרגיה",
    "HebrewLongName": "תומר תמלוגי אנרגיה (2012) בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2213.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Energy And Oil & Gas Exploration",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -6.1,
    "YearYield": -6.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011294936"
  },
  {
    "Id": "TNDO.TA",
    "MayaId": "1180686",
    "Name": "TONDO SMART",
    "ShortName": "TONDO SMART LTD",
    "Symbol": "TNDO.TA",
    "TaseSymbol": "TNDO",
    "YahooId": "TNDO.TA",
    "EnglishName": "TONDO SMART",
    "EnglishLongName": "TONDO SMART LTD",
    "HebrewName": "טונדו סמארט",
    "HebrewLongName": "טונדו סמארט בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 448.6,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 17.1,
    "YearYield": 17.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011806861"
  },
  {
    "Id": "TASE:5115449",
    "MayaId": "5115449",
    "Name": "Top Alpha Bnds No Eqt IL",
    "ShortName": "Top Alpha Bnds No Eqt IL",
    "Symbol": "TASE:5115449",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TOP ALPHA (0A)(!) BONDS WITHOUT EQUITY IL",
    "EnglishLongName": "TOP ALPHA (0A)(!) BONDS WITHOUT EQUITY IL",
    "HebrewName": "טופ אלפא אג\"ח ללא מניות",
    "HebrewLongName": "טופ אלפא (0A)(!) אג\"ח ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.76,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.25,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 34.9,
    "MonthYield": 0.37,
    "YearYield": 0.37,
    "Last12MonthYield": 6.16,
    "ISIN": "IL0051154495"
  },
  {
    "Id": "TOPG.TA",
    "MayaId": "1083377",
    "Name": "TOP GROUP",
    "ShortName": "TOP GROUP SOFTWARE LTD.",
    "Symbol": "TOPG.TA",
    "TaseSymbol": "TOPG",
    "YahooId": "TOPG.TA",
    "EnglishName": "TOP GROUP",
    "EnglishLongName": "TOP GROUP SOFTWARE LTD.",
    "HebrewName": "טופ גרופ",
    "HebrewLongName": "טופ גרופ תוכנה בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1345.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 5.5,
    "YearYield": 5.5,
    "Last12MonthYield": null,
    "ISIN": "IL0010833775"
  },
  {
    "Id": "TPGM.TA",
    "MayaId": "1179142",
    "Name": "TOP GUM",
    "ShortName": "TOP GUM INDUSTRIES LTD.",
    "Symbol": "TPGM.TA",
    "TaseSymbol": "TPGM",
    "YahooId": "TPGM.TA",
    "EnglishName": "TOP GUM",
    "EnglishLongName": "TOP GUM INDUSTRIES LTD.",
    "HebrewName": "טופ גאם",
    "HebrewLongName": "טופ גאם תעשיות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1368.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -3.5,
    "YearYield": -3.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011791428"
  },
  {
    "Id": "TASE:5115456",
    "MayaId": "5115456",
    "Name": "TOP MNAYOT CHUL",
    "ShortName": "TOP MNAYOT CHUL",
    "Symbol": "TASE:5115456",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "TOP ALPHA (4D) OVERSEAS SHARES",
    "EnglishLongName": "TOP ALPHA (4D) OVERSEAS SHARES",
    "HebrewName": "טופ אלפא 4D מניות חו\"ל",
    "HebrewLongName": "טופ אלפא (4D) מניות חו\"ל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.44,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.42,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 166.7,
    "MonthYield": 0.94,
    "YearYield": 0.94,
    "Last12MonthYield": 7.23,
    "ISIN": "IL0051154560"
  },
  {
    "Id": "TSEM.TA",
    "MayaId": "1082379",
    "Name": "TOWER",
    "ShortName": "TOWER SEMICONDUCTOR LTD.",
    "Symbol": "TSEM.TA",
    "TaseSymbol": "TSEM",
    "YahooId": "TSEM.TA",
    "EnglishName": "TOWER",
    "EnglishLongName": "TOWER SEMICONDUCTOR LTD.",
    "HebrewName": "טאואר",
    "HebrewLongName": "טאואר סמיקונדקטור בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 39350.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 7.2,
    "YearYield": 7.2,
    "Last12MonthYield": null,
    "ISIN": "IL0010823792"
  },
  {
    "Id": "TRAN.TA",
    "MayaId": "1174093",
    "Name": "TRUCKNET",
    "ShortName": "TRUCKNET ENTERPRISE LTD",
    "Symbol": "TRAN.TA",
    "TaseSymbol": "TRAN",
    "YahooId": "TRAN.TA",
    "EnglishName": "TRUCKNET",
    "EnglishLongName": "TRUCKNET ENTERPRISE LTD",
    "HebrewName": "טראקנט",
    "HebrewLongName": "טראקנט אנטרפרייז בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 53.9,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -2.3,
    "YearYield": -2.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011740938"
  },
  {
    "Id": "TSG.TA",
    "MayaId": "1209477",
    "Name": "TSG",
    "ShortName": "TSG IT ADVANCED SYSTEMS LTD",
    "Symbol": "TSG.TA",
    "TaseSymbol": "TSG",
    "YahooId": "TSG.TA",
    "EnglishName": "TSG",
    "EnglishLongName": "TSG IT ADVANCED SYSTEMS LTD",
    "HebrewName": "טיאסג'י",
    "HebrewLongName": "טיאסג'י איטי מערכות מתקדמות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 67000.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 20.5,
    "YearYield": 20.5,
    "Last12MonthYield": null,
    "ISIN": "IL0012094772"
  },
  {
    "Id": "TURB.TA",
    "MayaId": "1181742",
    "Name": "TURBOGEN",
    "ShortName": "TURBOGEN LTD",
    "Symbol": "TURB.TA",
    "TaseSymbol": "TURB",
    "YahooId": "TURB.TA",
    "EnglishName": "TURBOGEN",
    "EnglishLongName": "TURBOGEN LTD",
    "HebrewName": "טורבוג'ן",
    "HebrewLongName": "טורבוג'ן בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1791.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -10.5,
    "YearYield": -10.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011817421"
  },
  {
    "Id": "TRPZ.TA",
    "MayaId": "1175611",
    "Name": "TURPAZ",
    "ShortName": "TURPAZ INDUSTRIES LTD",
    "Symbol": "TRPZ.TA",
    "TaseSymbol": "TRPZ",
    "YahooId": "TRPZ.TA",
    "EnglishName": "TURPAZ",
    "EnglishLongName": "TURPAZ INDUSTRIES LTD",
    "HebrewName": "תורפז",
    "HebrewLongName": "תורפז תעשיות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 7549.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 16.4,
    "YearYield": 16.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011756116"
  },
  {
    "Id": "UMH.TA",
    "MayaId": "1184282",
    "Name": "UMH",
    "ShortName": "UMH PROPERTIES, INC.",
    "Symbol": "UMH.TA",
    "TaseSymbol": "UMH",
    "YahooId": "UMH.TA",
    "EnglishName": "UMH",
    "EnglishLongName": "UMH PROPERTIES, INC.",
    "HebrewName": "יו.אמ.איץ'",
    "HebrewLongName": "יו.אמ.איץ' פרופרטיס אינק",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4929.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -2.8,
    "YearYield": -2.8,
    "Last12MonthYield": null,
    "ISIN": "US9030021037"
  },
  {
    "Id": "UNIT.TA",
    "MayaId": "1083831",
    "Name": "UNITRONICS",
    "ShortName": "UNITRONICS (1989)(R\"G) LTD.",
    "Symbol": "UNIT.TA",
    "TaseSymbol": "UNIT",
    "YahooId": "UNIT.TA",
    "EnglishName": "UNITRONICS",
    "EnglishLongName": "UNITRONICS (1989)(R\"G) LTD.",
    "HebrewName": "יוניטרוניקס",
    "HebrewLongName": "יוניטרוניקס (1989) (ר\"ג) בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2708.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 17.6,
    "YearYield": 17.6,
    "Last12MonthYield": null,
    "ISIN": "IL0010838311"
  },
  {
    "Id": "UNMI.TA",
    "MayaId": "1144773",
    "Name": "UNIVERSAL",
    "ShortName": "UNIVERSAL MOTORS ISRAEL LTD",
    "Symbol": "UNMI.TA",
    "TaseSymbol": "UNMI",
    "YahooId": "UNMI.TA",
    "EnglishName": "UNIVERSAL",
    "EnglishLongName": "UNIVERSAL MOTORS ISRAEL LTD",
    "HebrewName": "יוניברסל מוטורס",
    "HebrewLongName": "יוניברסל מוטורס ישראל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2955.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.0,
    "YearYield": 0.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011447732"
  },
  {
    "Id": "UNVO-M.TA",
    "MayaId": "1093558",
    "Name": "UNIVO M",
    "ShortName": "UNIVO PHARMACEUTICALS LTD",
    "Symbol": "UNVO-M.TA",
    "TaseSymbol": "UNVO-M",
    "YahooId": "UNVO-M.TA",
    "EnglishName": "UNIVO-M",
    "EnglishLongName": "UNIVO PHARMACEUTICALS LTD",
    "HebrewName": "יוניבו-ש",
    "HebrewLongName": "יוניבו תעשיות פרמצבטיות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 930000.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Investment & Holdings",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.0,
    "YearYield": 0.0,
    "Last12MonthYield": null,
    "ISIN": "IL0010935588"
  },
  {
    "Id": "UPSL.TA",
    "MayaId": "456012",
    "Name": "UPSELLON BRANDS",
    "ShortName": "UPSELLON BRANDS HOLDINGS LTD",
    "Symbol": "UPSL.TA",
    "TaseSymbol": "UPSL",
    "YahooId": "UPSL.TA",
    "EnglishName": "UPSELLON BRANDS",
    "EnglishLongName": "UPSELLON BRANDS HOLDINGS LTD",
    "HebrewName": "אפסלון ברנדס",
    "HebrewLongName": "אפסלון ברנדס הולדינג בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 55.8,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -5.4,
    "YearYield": -5.4,
    "Last12MonthYield": null,
    "ISIN": "IL0004560129"
  },
  {
    "Id": "URBC.TA",
    "MayaId": "1220755",
    "Name": "URBANICA",
    "ShortName": "URBANICA (PALO) RETAIL LTD",
    "Symbol": "URBC.TA",
    "TaseSymbol": "URBC",
    "YahooId": "URBC.TA",
    "EnglishName": "URBANICA",
    "EnglishLongName": "URBANICA (PALO) RETAIL LTD",
    "HebrewName": "אורבניקה",
    "HebrewLongName": "אורבניקה (פאלו) ריטייל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 838.1,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -0.5,
    "YearYield": -0.5,
    "Last12MonthYield": null,
    "ISIN": "IL0012207556"
  },
  {
    "Id": "UTRN.TA",
    "MayaId": "1157114",
    "Name": "UTRON",
    "ShortName": "UTRON LTD",
    "Symbol": "UTRN.TA",
    "TaseSymbol": "UTRN",
    "YahooId": "UTRN.TA",
    "EnglishName": "UTRON",
    "EnglishLongName": "UTRON LTD",
    "HebrewName": "יוטרון",
    "HebrewLongName": "יוטרון בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 516.2,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 12.8,
    "YearYield": 12.8,
    "Last12MonthYield": null,
    "ISIN": "IL0011571143"
  },
  {
    "Id": "VRDS.TA",
    "MayaId": "1176387",
    "Name": "VERIDIS",
    "ShortName": "VERIDIS ENVIRONMENT LTD",
    "Symbol": "VRDS.TA",
    "TaseSymbol": "VRDS",
    "YahooId": "VRDS.TA",
    "EnglishName": "VERIDIS",
    "EnglishLongName": "VERIDIS ENVIRONMENT LTD",
    "HebrewName": "ורידיס",
    "HebrewLongName": "ורידיס אינווירונמנט בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 3390.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -2.5,
    "YearYield": -2.5,
    "Last12MonthYield": null,
    "ISIN": "IL0011763872"
  },
  {
    "Id": "VCTR.TA",
    "MayaId": "1123777",
    "Name": "VICTORY",
    "ShortName": "VICTORY SUPERMARKET CHAIN LTD",
    "Symbol": "VCTR.TA",
    "TaseSymbol": "VCTR",
    "YahooId": "VCTR.TA",
    "EnglishName": "VICTORY",
    "EnglishLongName": "VICTORY SUPERMARKET CHAIN LTD",
    "HebrewName": "ויקטורי",
    "HebrewLongName": "ויקטורי רשת סופרמרקטים בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5301.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -2.6,
    "YearYield": -2.6,
    "Last12MonthYield": null,
    "ISIN": "IL0011237778"
  },
  {
    "Id": "VILR.TA",
    "MayaId": "416016",
    "Name": "VILLAR",
    "ShortName": "VILLAR INTERNATIONAL LTD.",
    "Symbol": "VILR.TA",
    "TaseSymbol": "VILR",
    "YahooId": "VILR.TA",
    "EnglishName": "VILLAR",
    "EnglishLongName": "VILLAR INTERNATIONAL LTD.",
    "HebrewName": "וילאר",
    "HebrewLongName": "וילאר אינטרנשיונל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 18260.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 12.2,
    "YearYield": 12.2,
    "Last12MonthYield": null,
    "ISIN": "IL0004160169"
  },
  {
    "Id": "VISN.TA",
    "MayaId": "350017",
    "Name": "VISION SIGMA",
    "ShortName": "VISION SIGMA LTD",
    "Symbol": "VISN.TA",
    "TaseSymbol": "VISN",
    "YahooId": "VISN.TA",
    "EnglishName": "VISION SIGMA",
    "EnglishLongName": "VISION SIGMA LTD",
    "HebrewName": "ויז'ן סיגמא",
    "HebrewLongName": "ויז'ן סיגמא בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5927.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 2.8,
    "YearYield": 2.8,
    "Last12MonthYield": null,
    "ISIN": "IL0003500175"
  },
  {
    "Id": "VTNA.TA",
    "MayaId": "1109966",
    "Name": "VITANIA",
    "ShortName": "VITANIA LTD",
    "Symbol": "VTNA.TA",
    "TaseSymbol": "VTNA",
    "YahooId": "VTNA.TA",
    "EnglishName": "VITANIA",
    "EnglishLongName": "VITANIA LTD",
    "HebrewName": "ויתניה",
    "HebrewLongName": "ויתניה בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2306.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -0.9,
    "YearYield": -0.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011099665"
  },
  {
    "Id": "TASE:5130059",
    "MayaId": "5130059",
    "Name": "VRD FLEXIBLE",
    "ShortName": "VRD FLEXIBLE",
    "Symbol": "TASE:5130059",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "VARDAN (4D) Flexible",
    "EnglishLongName": "VARDAN (4D) Flexible",
    "HebrewName": "ורדן Flexible",
    "HebrewLongName": "ורדן (4D)י Flexible",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.88,
    "TrusteeFee": 0.045,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.75,
    "Sector": "",
    "Industry": "",
    "ManagerName": "AYALON  MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 3.5,
    "MonthYield": 7.35,
    "YearYield": 7.35,
    "Last12MonthYield": -1.35,
    "ISIN": "IL0051300593"
  },
  {
    "Id": "TASE:598",
    "MayaId": "598",
    "Name": "VTA35",
    "ShortName": "VTA35",
    "Symbol": "TASE:598",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "VTA35",
    "EnglishLongName": "VTA35",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:3",
    "MayaId": "3",
    "Name": "Warrants",
    "ShortName": "Warrants",
    "Symbol": "TASE:3",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Warrants",
    "EnglishLongName": "Warrants",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "WATR.TA",
    "MayaId": "1180306",
    "Name": "WATER IO",
    "ShortName": "WATER.IO LTD",
    "Symbol": "WATR.TA",
    "TaseSymbol": "WATR",
    "YahooId": "WATR.TA",
    "EnglishName": "WATER IO",
    "EnglishLongName": "WATER.IO LTD",
    "HebrewName": "ווטר אי או",
    "HebrewLongName": "ווטר אי או בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 355.1,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 34.9,
    "YearYield": 34.9,
    "Last12MonthYield": null,
    "ISIN": "IL0011803066"
  },
  {
    "Id": "WESR.TA",
    "MayaId": "1173228",
    "Name": "WESURE GLOBALT",
    "ShortName": "WESURE GLOBAL TECH LTD.",
    "Symbol": "WESR.TA",
    "TaseSymbol": "WESR",
    "YahooId": "WESR.TA",
    "EnglishName": "WESURE GLOBALT",
    "EnglishLongName": "WESURE GLOBAL TECH LTD.",
    "HebrewName": "ווישור גלובלטק",
    "HebrewLongName": "ווישור גלובלטק בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1326.0,
    "StandardDeviation": null,
    "Sector": "Finance",
    "Industry": "Insurance",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.1,
    "YearYield": 1.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011732281"
  },
  {
    "Id": "WILK.TA",
    "MayaId": "278010",
    "Name": "WILK",
    "ShortName": "WILK TECHNOLOGIES LTD",
    "Symbol": "WILK.TA",
    "TaseSymbol": "WILK",
    "YahooId": "WILK.TA",
    "EnglishName": "WILK",
    "EnglishLongName": "WILK TECHNOLOGIES LTD",
    "HebrewName": "וילק",
    "HebrewLongName": "וילק טכנולוגיות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 318.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 31.3,
    "YearYield": 31.3,
    "Last12MonthYield": null,
    "ISIN": "IL0002780109"
  },
  {
    "Id": "WILC.TA",
    "MayaId": "1082858",
    "Name": "WILLI FOOD INTE",
    "ShortName": "G.WILLI-FOOD INTERNATIONAL",
    "Symbol": "WILC.TA",
    "TaseSymbol": "WILC",
    "YahooId": "WILC.TA",
    "EnglishName": "WILLI FOOD INTE",
    "EnglishLongName": "G.WILLI-FOOD INTERNATIONAL",
    "HebrewName": "ויליפוד אינטרנש",
    "HebrewLongName": "ג.ויליפוד אינטרנשיונל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 9402.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 1.7,
    "YearYield": 1.7,
    "Last12MonthYield": null,
    "ISIN": "IL0010828585"
  },
  {
    "Id": "WLFD.TA",
    "MayaId": "371013",
    "Name": "WILLY FOOD",
    "ShortName": "WILLY FOOD INVESTMENTS LTD",
    "Symbol": "WLFD.TA",
    "TaseSymbol": "WLFD",
    "YahooId": "WLFD.TA",
    "EnglishName": "WILLY FOOD",
    "EnglishLongName": "WILLY FOOD INVESTMENTS LTD",
    "HebrewName": "וילי פוד",
    "HebrewLongName": "וילי פוד השקעות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 5774.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 9.4,
    "YearYield": 9.4,
    "Last12MonthYield": null,
    "ISIN": "IL0003710139"
  },
  {
    "Id": "WNBZ-L.TA",
    "MayaId": "1105162",
    "Name": "WIND BU L",
    "ShortName": "WIND BUZZ TECHNOLOGIES LTD",
    "Symbol": "WNBZ-L.TA",
    "TaseSymbol": "WNBZ-L",
    "YahooId": "WNBZ-L.TA",
    "EnglishName": "WIND BU-L",
    "EnglishLongName": "WIND BUZZ TECHNOLOGIES LTD",
    "HebrewName": "ווינד באז-ס",
    "HebrewLongName": "ווינד באז טכנולוגיות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 18.4,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 0.0,
    "YearYield": 0.0,
    "Last12MonthYield": null,
    "ISIN": "IL0011051625"
  },
  {
    "Id": "XTLB.TA",
    "MayaId": "1085497",
    "Name": "XTL BIO",
    "ShortName": "XTL BIOPHARMACEUTICALS LTD.",
    "Symbol": "XTLB.TA",
    "TaseSymbol": "XTLB",
    "YahooId": "XTLB.TA",
    "EnglishName": "XTL BIO",
    "EnglishLongName": "XTL BIOPHARMACEUTICALS LTD.",
    "HebrewName": "אקס טי אל",
    "HebrewLongName": "אקס טי אל  ביופרמסוטיקלס בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2.7,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 16.7,
    "YearYield": 16.7,
    "Last12MonthYield": null,
    "ISIN": "IL0010854979"
  },
  {
    "Id": "YBRD.TA",
    "MayaId": "111013",
    "Name": "Y.B RENEWAL",
    "ShortName": "Y.B URBAN RENEWAL - RESIDENTIAL DEVELOPMENT LTD",
    "Symbol": "YBRD.TA",
    "TaseSymbol": "YBRD",
    "YahooId": "YBRD.TA",
    "EnglishName": "Y.B RENEWAL",
    "EnglishLongName": "Y.B URBAN RENEWAL - RESIDENTIAL DEVELOPMENT LTD",
    "HebrewName": "י.ב התחדשות",
    "HebrewLongName": "י.ב התחדשות הארץ- מתחמי מגורים בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 766.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 5.1,
    "YearYield": 5.1,
    "Last12MonthYield": null,
    "ISIN": "IL0001110134"
  },
  {
    "Id": "TASE:5117304",
    "MayaId": "5117304",
    "Name": "Y.L BOND PORT WITHOUT EQU",
    "ShortName": "Y.L BOND PORT WITHOUT EQU",
    "Symbol": "TASE:5117304",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YELIN LAPIDOT (0B) BONDS PORTFOLIO IL WITHOUT EQUITY",
    "EnglishLongName": "YELIN LAPIDOT (0B) BONDS PORTFOLIO IL WITHOUT EQUITY",
    "HebrewName": "י.ל. תיק אג\"ח ללא מניות",
    "HebrewLongName": "ילין לפידות (0B) תיק אג\"ח ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.74,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.31,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 277.8,
    "MonthYield": 0.56,
    "YearYield": 0.56,
    "Last12MonthYield": 6.99,
    "ISIN": "IL0051173040"
  },
  {
    "Id": "TASE:5115092",
    "MayaId": "5115092",
    "Name": "y.l bond Portfol up to 15",
    "ShortName": "y.l bond Portfol up to 15",
    "Symbol": "TASE:5115092",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Yelin Lapidot (2C) bonds Portfolio IL up to 15% shares",
    "EnglishLongName": "Yelin Lapidot (2C) bonds Portfolio IL up to 15% shares",
    "HebrewName": "י.ל. תיק אג\"ח+15%",
    "HebrewLongName": "ילין לפידות (2C) תיק אג\"ח + 15%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.76,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.39,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 15% Equity",
    "AssetValue": 355.2,
    "MonthYield": 0.82,
    "YearYield": 0.82,
    "Last12MonthYield": 10.14,
    "ISIN": "IL0051150923"
  },
  {
    "Id": "TASE:5123005",
    "MayaId": "5123005",
    "Name": "Y.L Bonds Portfolio LV",
    "ShortName": "Y.L Bonds Portfolio LV",
    "Symbol": "TASE:5123005",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Yelin Lapidot (0B) Bonds Portfolio LV IL",
    "EnglishLongName": "Yelin Lapidot (0B) Bonds Portfolio LV IL",
    "HebrewName": "י.ל תיק אג\"ח LV",
    "HebrewLongName": "ילין לפידות (0B) תיק אג\"ח LV",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.5,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.11,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 112.8,
    "MonthYield": 0.32,
    "YearYield": 0.32,
    "Last12MonthYield": 5.42,
    "ISIN": "IL0051230055"
  },
  {
    "Id": "TASE:5114897",
    "MayaId": "5114897",
    "Name": "Y.L DIVIDEND STOCKS",
    "ShortName": "Y.L DIVIDEND STOCKS",
    "Symbol": "TASE:5114897",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YELIN LAPIDOT (4A) DIVIDEND STOCKS IL",
    "EnglishLongName": "YELIN LAPIDOT (4A) DIVIDEND STOCKS IL",
    "HebrewName": "י.ל מניות דיבידנד",
    "HebrewLongName": "ילין לפידות (4A) מניות דיבידנד",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.95,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.21,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 675.8,
    "MonthYield": 5.73,
    "YearYield": 5.73,
    "Last12MonthYield": 53.25,
    "ISIN": "IL0051148976"
  },
  {
    "Id": "TASE:5123963",
    "MayaId": "5123963",
    "Name": "Y.L INVESTMENT PORTF 50",
    "ShortName": "Y.L INVESTMENT PORTF 50",
    "Symbol": "TASE:5123963",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YELIN LAPIDOT (3c) INVESTMENT PORTFOLIO IL UP TO 50% SHARES",
    "EnglishLongName": "YELIN LAPIDOT (3c) INVESTMENT PORTFOLIO IL UP TO 50% SHARES",
    "HebrewName": "י.ל תיק השקעות עד 50%",
    "HebrewLongName": "ילין לפידות (3C) תיק השקעות עד 50%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.93,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.95,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - Max. Exposure over 30% Equity",
    "AssetValue": 359.3,
    "MonthYield": 3.39,
    "YearYield": 3.39,
    "Last12MonthYield": 26.61,
    "ISIN": "IL0051239635"
  },
  {
    "Id": "TASE:5133640",
    "MayaId": "5133640",
    "Name": "y.l israeli fundoffunds15",
    "ShortName": "y.l israeli fundoffunds15",
    "Symbol": "TASE:5133640",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Yalin lapidot (2B) israeli fund of funds up to 15% shares IL",
    "EnglishLongName": "Yalin lapidot (2B) israeli fund of funds up to 15% shares IL",
    "HebrewName": "י.ל אגד ישראלי עד 15%",
    "HebrewLongName": "ילין לפידות (2B) אגד ישראלי עד 15% מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Fund of Funds",
    "SecondaryClassification": "Israeli Fund of Funds",
    "AssetValue": 63.4,
    "MonthYield": 1.27,
    "YearYield": 1.27,
    "Last12MonthYield": 9.32,
    "ISIN": "IL0051336407"
  },
  {
    "Id": "TASE:5133632",
    "MayaId": "5133632",
    "Name": "y.l israeli fundoffunds30",
    "ShortName": "y.l israeli fundoffunds30",
    "Symbol": "TASE:5133632",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Yalin Lapidot (2B) israeli fund of funds up to 30% shares IL",
    "EnglishLongName": "Yalin Lapidot (2B) israeli fund of funds up to 30% shares IL",
    "HebrewName": "י.ל אגד ישראלי עד 30%",
    "HebrewLongName": "ילין לפידות (2B) אגד ישראלי עד 30% מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.47,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Fund of Funds",
    "SecondaryClassification": "Israeli Fund of Funds",
    "AssetValue": 54.2,
    "MonthYield": 1.97,
    "YearYield": 1.97,
    "Last12MonthYield": 13.46,
    "ISIN": "IL0051336324"
  },
  {
    "Id": "TASE:5134317",
    "MayaId": "5134317",
    "Name": "Y.L Large & mid cap Israe",
    "ShortName": "Y.L Large & mid cap Israe",
    "Symbol": "TASE:5134317",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Yelin Lapidot (4B) Large & mid cap Israel",
    "EnglishLongName": "Yelin Lapidot (4B) Large & mid cap Israel",
    "HebrewName": "י.ל Large & mid cap ישראל",
    "HebrewLongName": "ילין לפידות (4B)י Large & mid cap ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.2,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.12,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 172.8,
    "MonthYield": 9.05,
    "YearYield": 9.05,
    "Last12MonthYield": 67.03,
    "ISIN": "IL0051343171"
  },
  {
    "Id": "TASE:5114913",
    "MayaId": "5114913",
    "Name": "Y.L SHEKEL CORPORATE +20",
    "ShortName": "Y.L SHEKEL CORPORATE +20",
    "Symbol": "TASE:5114913",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YELIN LAPIDOT (2A) SHEKEL CORPORATE IL + 20%",
    "EnglishLongName": "YELIN LAPIDOT (2A) SHEKEL CORPORATE IL + 20%",
    "HebrewName": "י.ל קונצרני שקלי + 20%",
    "HebrewLongName": "ילין לפידות (2A) קונצרני שקלי + 20%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.77,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.37,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Shekel Corporate and Convertibles with Equity",
    "AssetValue": 57.3,
    "MonthYield": 1.22,
    "YearYield": 1.22,
    "Last12MonthYield": 10.66,
    "ISIN": "IL0051149131"
  },
  {
    "Id": "TASE:5128368",
    "MayaId": "5128368",
    "Name": "y.l value stocks TA 125",
    "ShortName": "y.l value stocks TA 125",
    "Symbol": "TASE:5128368",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Yalin Lapidot (4B) value stocks TA 125 IL",
    "EnglishLongName": "Yalin Lapidot (4B) value stocks TA 125 IL",
    "HebrewName": "י.ל מניות ערך ת\"א 125",
    "HebrewLongName": "ילין לפידות (4B) מניות ערך ת\"א 125",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.5,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.3,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 617.6,
    "MonthYield": 5.87,
    "YearYield": 5.87,
    "Last12MonthYield": 55.67,
    "ISIN": "IL0051283682"
  },
  {
    "Id": "TASE:5117502",
    "MayaId": "5117502",
    "Name": "Y.L! COROP BONDS+10",
    "ShortName": "Y.L! COROP BONDS+10",
    "Symbol": "TASE:5117502",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YELIN LAPIDOT (1A)(!) CORPORATE BONDS IL+ 10%",
    "EnglishLongName": "YELIN LAPIDOT (1A)(!) CORPORATE BONDS IL+ 10%",
    "HebrewName": "י.ל. ! אגח חברות +10",
    "HebrewLongName": "ילין לפידות (1A)(!) אג\"ח חברות + 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.91,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles with Equity",
    "AssetValue": 979.7,
    "MonthYield": 0.94,
    "YearYield": 0.94,
    "Last12MonthYield": 9.33,
    "ISIN": "IL0051175029"
  },
  {
    "Id": "TASE:5116777",
    "MayaId": "5116777",
    "Name": "Y.L! SHEKEL COROPORATE",
    "ShortName": "Y.L! SHEKEL COROPORATE",
    "Symbol": "TASE:5116777",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YELIN LAPIDOT (00)(!) SHEKEL CORPORATE IL",
    "EnglishLongName": "YELIN LAPIDOT (00)(!) SHEKEL CORPORATE IL",
    "HebrewName": "י.ל. ! קונצרני שקלי",
    "HebrewLongName": "ילין לפידות (00)(!) קונצרני שקלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.26,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Shekel Corporate and Convertibles - No Equity",
    "AssetValue": 121.0,
    "MonthYield": 1.0,
    "YearYield": 1.0,
    "Last12MonthYield": 7.71,
    "ISIN": "IL0051167778"
  },
  {
    "Id": "TASE:5136189",
    "MayaId": "5136189",
    "Name": "Y.L. ! 90\\10",
    "ShortName": "Y.L. ! 90\\10",
    "Symbol": "TASE:5136189",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YELIN LAPIDOT (1B)(!) 90\\10 IL",
    "EnglishLongName": "YELIN LAPIDOT (1B)(!) 90\\10 IL",
    "HebrewName": "י.ל. ! 10/90",
    "HebrewLongName": "ילין לפידות (1B)(!)י 10/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.54,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 53.8,
    "MonthYield": 1.6,
    "YearYield": 1.6,
    "Last12MonthYield": 12.25,
    "ISIN": "IL0051361892"
  },
  {
    "Id": "TASE:5130182",
    "MayaId": "5130182",
    "Name": "Y.L. 60/40",
    "ShortName": "Y.L. 60/40",
    "Symbol": "TASE:5130182",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Yalin Lapidot (3C) 60/40 IL",
    "EnglishLongName": "Yalin Lapidot (3C) 60/40 IL",
    "HebrewName": "י.ל. 40/60",
    "HebrewLongName": "ילין לפידות (3C)י 40/60",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.84,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.76,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - Max. Exposure over 30% Equity",
    "AssetValue": 269.1,
    "MonthYield": 2.74,
    "YearYield": 2.74,
    "Last12MonthYield": 22.56,
    "ISIN": "IL0051301823"
  },
  {
    "Id": "TASE:5121728",
    "MayaId": "5121728",
    "Name": "Y.L. 70/30",
    "ShortName": "Y.L. 70/30",
    "Symbol": "TASE:5121728",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Yelin Lapidot (2D) 70/30 IL",
    "EnglishLongName": "Yelin Lapidot (2D) 70/30 IL",
    "HebrewName": "י.ל. 30/70",
    "HebrewLongName": "ילין לפידות (2D)י 30/70",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.6,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 1381.3,
    "MonthYield": 1.84,
    "YearYield": 1.84,
    "Last12MonthYield": 16.74,
    "ISIN": "IL0051217284"
  },
  {
    "Id": "TASE:5135991",
    "MayaId": "5135991",
    "Name": "Y.L. 70\\30 VALUE",
    "ShortName": "Y.L. 70\\30 VALUE",
    "Symbol": "TASE:5135991",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YELIN LAPIDOT (2B) 70\\30 VALUE IL",
    "EnglishLongName": "YELIN LAPIDOT (2B) 70\\30 VALUE IL",
    "HebrewName": "י.ל. 30/70 ערך",
    "HebrewLongName": "ילין לפידות (2B)י 30/70 ערך",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.71,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 484.7,
    "MonthYield": 2.92,
    "YearYield": 2.92,
    "Last12MonthYield": 21.77,
    "ISIN": "IL0051359912"
  },
  {
    "Id": "TASE:5118617",
    "MayaId": "5118617",
    "Name": "Y.L. 75/25",
    "ShortName": "Y.L. 75/25",
    "Symbol": "TASE:5118617",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YELIN LAPIDOT (2C) 75/25 IL",
    "EnglishLongName": "YELIN LAPIDOT (2C) 75/25 IL",
    "HebrewName": "י.ל. 25/75",
    "HebrewLongName": "ילין לפידות (2C)י 25/75",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.52,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 25% Equity",
    "AssetValue": 879.9,
    "MonthYield": 1.47,
    "YearYield": 1.47,
    "Last12MonthYield": 13.84,
    "ISIN": "IL0051186174"
  },
  {
    "Id": "TASE:5128491",
    "MayaId": "5128491",
    "Name": "Y.L. 75/25 Growth",
    "ShortName": "Y.L. 75/25 Growth",
    "Symbol": "TASE:5128491",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Yelin Lapidot (2B) 75\\25 Growth IL",
    "EnglishLongName": "Yelin Lapidot (2B) 75\\25 Growth IL",
    "HebrewName": "י.ל. 25/75 צמיחה",
    "HebrewLongName": "ילין לפידות (2B)י 25/75 צמיחה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.52,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 25% Equity",
    "AssetValue": 331.0,
    "MonthYield": 1.75,
    "YearYield": 1.75,
    "Last12MonthYield": 15.59,
    "ISIN": "IL0051284912"
  },
  {
    "Id": "TASE:5116488",
    "MayaId": "5116488",
    "Name": "Y.L. 80/20",
    "ShortName": "Y.L. 80/20",
    "Symbol": "TASE:5116488",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YELIN LAPIDOT (2B) 80/20 IL",
    "EnglishLongName": "YELIN LAPIDOT (2B) 80/20 IL",
    "HebrewName": "י.ל. 20/80",
    "HebrewLongName": "ילין לפידות (2B)י 20/80",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.95,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.48,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 1053.9,
    "MonthYield": 1.44,
    "YearYield": 1.44,
    "Last12MonthYield": 12.77,
    "ISIN": "IL0051164882"
  },
  {
    "Id": "TASE:5122239",
    "MayaId": "5122239",
    "Name": "Y.L. 80/20 TZMIHA",
    "ShortName": "Y.L. 80/20 TZMIHA",
    "Symbol": "TASE:5122239",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YELIN LAPIDOT (2B) 80\\20 TZMIHA IL",
    "EnglishLongName": "YELIN LAPIDOT (2B) 80\\20 TZMIHA IL",
    "HebrewName": "י.ל. 20/80 צמיחה",
    "HebrewLongName": "ילין לפידות (2B)י 20/80 צמיחה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.84,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.44,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 20% Equity",
    "AssetValue": 581.9,
    "MonthYield": 1.9,
    "YearYield": 1.9,
    "Last12MonthYield": 13.65,
    "ISIN": "IL0051222391"
  },
  {
    "Id": "TASE:5125968",
    "MayaId": "5125968",
    "Name": "Y.L. 85/15",
    "ShortName": "Y.L. 85/15",
    "Symbol": "TASE:5125968",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Yelin Lapidot (2B) 85/15 IL",
    "EnglishLongName": "Yelin Lapidot (2B) 85/15 IL",
    "HebrewName": "י.ל. 15/85",
    "HebrewLongName": "ילין לפידות (2B)י 15/85",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.38,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 15% Equity",
    "AssetValue": 383.9,
    "MonthYield": 1.22,
    "YearYield": 1.22,
    "Last12MonthYield": 11.55,
    "ISIN": "IL0051259682"
  },
  {
    "Id": "TASE:5115704",
    "MayaId": "5115704",
    "Name": "Y.L. 90/10",
    "ShortName": "Y.L. 90/10",
    "Symbol": "TASE:5115704",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YELIN LAPIDOT (1A) 90/10 IL",
    "EnglishLongName": "YELIN LAPIDOT (1A) 90/10 IL",
    "HebrewName": "י.ל. 10/90",
    "HebrewLongName": "ילין לפידות (1A)י 10/90",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.8,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 926.9,
    "MonthYield": 1.11,
    "YearYield": 1.11,
    "Last12MonthYield": 9.97,
    "ISIN": "IL0051157043"
  },
  {
    "Id": "TASE:5119243",
    "MayaId": "5119243",
    "Name": "Y.L. 90/10 TZMIHA",
    "ShortName": "Y.L. 90/10 TZMIHA",
    "Symbol": "TASE:5119243",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YELIN LAPIDOT (1B)(!) 90/10 TZMIHA IL",
    "EnglishLongName": "YELIN LAPIDOT (1B)(!) 90/10 TZMIHA IL",
    "HebrewName": "י.ל. 10/90 צמיחה",
    "HebrewLongName": "ילין לפידות (1B)(!)י 10/90 צמיחה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 1006.4,
    "MonthYield": 1.09,
    "YearYield": 1.09,
    "Last12MonthYield": 9.46,
    "ISIN": "IL0051192438"
  },
  {
    "Id": "TASE:5125026",
    "MayaId": "5125026",
    "Name": "Y.L. 90/10 Value",
    "ShortName": "Y.L. 90/10 Value",
    "Symbol": "TASE:5125026",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YELIN LAPIDOT (1B) 90/10 Value IL",
    "EnglishLongName": "YELIN LAPIDOT (1B) 90/10 Value IL",
    "HebrewName": "י.ל. 10/90 ערך",
    "HebrewLongName": "ילין לפידות (1B)י 10/90 ערך",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 267.9,
    "MonthYield": 1.28,
    "YearYield": 1.28,
    "Last12MonthYield": 11.36,
    "ISIN": "IL0051250269"
  },
  {
    "Id": "TASE:5119060",
    "MayaId": "5119060",
    "Name": "Y.L. 95/5",
    "ShortName": "Y.L. 95/5",
    "Symbol": "TASE:5119060",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Yelin Lapidot (1B) 95/5 IL",
    "EnglishLongName": "Yelin Lapidot (1B) 95/5 IL",
    "HebrewName": "י.ל. 5/95",
    "HebrewLongName": "ילין לפידות (1B)י 5/95",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.54,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.27,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 5% Equity",
    "AssetValue": 70.8,
    "MonthYield": 0.62,
    "YearYield": 0.62,
    "Last12MonthYield": 7.58,
    "ISIN": "IL0051190606"
  },
  {
    "Id": "TASE:5119953",
    "MayaId": "5119953",
    "Name": "Y.L. A VAMAL AD4SHANIM",
    "ShortName": "Y.L. A VAMAL AD4SHANIM",
    "Symbol": "TASE:5119953",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YELIN LAPIDOT (0A) A VAMALA AD 4 SHANIM IL",
    "EnglishLongName": "YELIN LAPIDOT (0A) A VAMALA AD 4 SHANIM IL",
    "HebrewName": "י.ל. איי ומעלה עד4שנים",
    "HebrewLongName": "ילין לפידות (0A)י A ומעלה עד 4 שנים",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.76,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 747.9,
    "MonthYield": 0.5,
    "YearYield": 0.5,
    "Last12MonthYield": 6.6,
    "ISIN": "IL0051199532"
  },
  {
    "Id": "TASE:5130190",
    "MayaId": "5130190",
    "Name": "y.l. above A+10%",
    "ShortName": "y.l. above A+10%",
    "Symbol": "TASE:5130190",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Yalin Lapidot (1A) above A IL+10%",
    "EnglishLongName": "Yalin Lapidot (1A) above A IL+10%",
    "HebrewName": "י.ל. A ומעלה+10%",
    "HebrewLongName": "ילין לפידות (1A)י A ומעלה + 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.35,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles with Equity",
    "AssetValue": 267.5,
    "MonthYield": 1.03,
    "YearYield": 1.03,
    "Last12MonthYield": 10.37,
    "ISIN": "IL0051301906"
  },
  {
    "Id": "TASE:5111935",
    "MayaId": "5111935",
    "Name": "Y.L. AG MED LELO MENA",
    "ShortName": "Y.L. AG MED LELO MENA",
    "Symbol": "TASE:5111935",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YALIN LAPIDOT (00) AGACH MEDORAG IL LELO MENAYOT",
    "EnglishLongName": "YALIN LAPIDOT (00) AGACH MEDORAG IL LELO MENAYOT",
    "HebrewName": "י.ל. א.מדורג ללא מניות",
    "HebrewLongName": "ילין לפידות (00) אג\"ח מדורג ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 288.8,
    "MonthYield": 0.54,
    "YearYield": 0.54,
    "Last12MonthYield": 6.91,
    "ISIN": "IL0051119357"
  },
  {
    "Id": "TASE:5122221",
    "MayaId": "5122221",
    "Name": "Y.L. CORP +10%",
    "ShortName": "Y.L. CORP +10%",
    "Symbol": "TASE:5122221",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YELIN LAPIDOT (1B) CORPORATE IL +10%",
    "EnglishLongName": "YELIN LAPIDOT (1B) CORPORATE IL +10%",
    "HebrewName": "י.ל. קונצרני+10%",
    "HebrewLongName": "ילין לפידות (1B) קונצרני + 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles with Equity",
    "AssetValue": 471.2,
    "MonthYield": 1.02,
    "YearYield": 1.02,
    "Last12MonthYield": 10.34,
    "ISIN": "IL0051222219"
  },
  {
    "Id": "TASE:5120068",
    "MayaId": "5120068",
    "Name": "Y.L. CORP BOND",
    "ShortName": "Y.L. CORP BOND",
    "Symbol": "TASE:5120068",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YELIN LAPIDOT (0B)(!) CORPORATE BONDS IL",
    "EnglishLongName": "YELIN LAPIDOT (0B)(!) CORPORATE BONDS IL",
    "HebrewName": "י.ל. אגח קונצרני",
    "HebrewLongName": "ילין לפידות (0B)(!) אג\"ח קונצרני",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.89,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.24,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 1117.9,
    "MonthYield": 0.64,
    "YearYield": 0.64,
    "Last12MonthYield": 6.33,
    "ISIN": "IL0051200686"
  },
  {
    "Id": "TASE:5114392",
    "MayaId": "5114392",
    "Name": "y.l. follow tik1 benleumi",
    "ShortName": "y.l. follow tik1 benleumi",
    "Symbol": "TASE:5114392",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Yelin Lapidot (1B) Following tik 1 bank ben leumi IL",
    "EnglishLongName": "Yelin Lapidot (1B) Following tik 1 bank ben leumi IL",
    "HebrewName": "י.ל. עוקבת תיק 1 בינל",
    "HebrewLongName": "ילין לפידות (1B) עוקבת תיק 1 הבנק הבינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.54,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.14,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 5% Equity",
    "AssetValue": 46.7,
    "MonthYield": 0.54,
    "YearYield": 0.54,
    "Last12MonthYield": 6.52,
    "ISIN": "IL0051143928"
  },
  {
    "Id": "TASE:5117312",
    "MayaId": "5117312",
    "Name": "y.l. follow tik2 benleumi",
    "ShortName": "y.l. follow tik2 benleumi",
    "Symbol": "TASE:5117312",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Yelin Lapidot (2B) Following tik 2 bank ben leumi IL",
    "EnglishLongName": "Yelin Lapidot (2B) Following tik 2 bank ben leumi IL",
    "HebrewName": "י.ל. עוקבת תיק 2 בינל",
    "HebrewLongName": "ילין לפידות (2B) עוקבת תיק 2 הבנק הבינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.005,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.26,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - Up to 15% Equity",
    "AssetValue": 472.8,
    "MonthYield": 0.57,
    "YearYield": 0.57,
    "Last12MonthYield": 8.15,
    "ISIN": "IL0051173123"
  },
  {
    "Id": "TASE:5125042",
    "MayaId": "5125042",
    "Name": "y.l. follow tik3 benleumi",
    "ShortName": "y.l. follow tik3 benleumi",
    "Symbol": "TASE:5125042",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Yelin Lapidot (2B) Following tik 3 bank ben leumi IL",
    "EnglishLongName": "Yelin Lapidot (2B) Following tik 3 bank ben leumi IL",
    "HebrewName": "י.ל. עוקבת תיק 3 בינל",
    "HebrewLongName": "ילין לפידות (2B) עוקבת תיק 3 הבנק הבינלאומי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.74,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.36,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 344.1,
    "MonthYield": 0.94,
    "YearYield": 0.94,
    "Last12MonthYield": 11.46,
    "ISIN": "IL0051250426"
  },
  {
    "Id": "TASE:5125448",
    "MayaId": "5125448",
    "Name": "Y.L. GOV PORTFOLIO+10",
    "ShortName": "Y.L. GOV PORTFOLIO+10",
    "Symbol": "TASE:5125448",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YALIN LAPIDOT (1B) GOVERNMENT PORTFOLIO IL + 10%",
    "EnglishLongName": "YALIN LAPIDOT (1B) GOVERNMENT PORTFOLIO IL + 10%",
    "HebrewName": "י.ל. תיק ממשלתי+10",
    "HebrewLongName": "ילין לפידות (1B) תיק ממשלתי + 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.54,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.36,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - up to 10% Equity",
    "AssetValue": 74.0,
    "MonthYield": 0.97,
    "YearYield": 0.97,
    "Last12MonthYield": 9.65,
    "ISIN": "IL0051254485"
  },
  {
    "Id": "TASE:5123757",
    "MayaId": "5123757",
    "Name": "y.l. high risk com bo p",
    "ShortName": "y.l. high risk com bo p",
    "Symbol": "TASE:5123757",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Yalin Lapidot (0B)(!) high risk companies bond potential IL",
    "EnglishLongName": "Yalin Lapidot (0B)(!) high risk companies bond potential IL",
    "HebrewName": "י.ל. אגח פוט חבר סכןגבו",
    "HebrewLongName": "ילין לפידות (0B)(!) אג\"ח פוטנציאל חברות בסיכון גבוה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.55,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.15,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Hi-risk Corporate & Convertibles",
    "AssetValue": 395.4,
    "MonthYield": 0.66,
    "YearYield": 0.66,
    "Last12MonthYield": 4.49,
    "ISIN": "IL0051237571"
  },
  {
    "Id": "TASE:5108899",
    "MayaId": "5108899",
    "Name": "y.l. high risk com bo p+1",
    "ShortName": "y.l. high risk com bo p+1",
    "Symbol": "TASE:5108899",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Yalin Lapidot (1B)(!) high risk companies bond potential IL + 10%",
    "EnglishLongName": "Yalin Lapidot (1B)(!) high risk companies bond potential IL + 10%",
    "HebrewName": "י.ל אגח פוט חבר סכןגבו+10",
    "HebrewLongName": "ילין לפידות (1B)(!) אג\"ח פוטנציאל חברות בסיכון גבוה +10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.7,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.2,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Hi-risk Corporate & Convertibles",
    "AssetValue": 859.1,
    "MonthYield": 1.19,
    "YearYield": 1.19,
    "Last12MonthYield": 8.36,
    "ISIN": "IL0051088990"
  },
  {
    "Id": "TASE:5115712",
    "MayaId": "5115712",
    "Name": "Y.L. MEDIN SHIK LELO ME",
    "ShortName": "Y.L. MEDIN SHIK LELO ME",
    "Symbol": "TASE:5115712",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YELIN LAPIDOT (00) MEDINA SHIKLI IL LELO MENAYOT",
    "EnglishLongName": "YELIN LAPIDOT (00) MEDINA SHIKLI IL LELO MENAYOT",
    "HebrewName": "י.ל. מדינה שקלי ללא מניות",
    "HebrewLongName": "ילין לפידות (00) מדינה שקלי ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.76,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.42,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Shekel Bonds - No Equity",
    "AssetValue": 9.4,
    "MonthYield": 0.88,
    "YearYield": 0.88,
    "Last12MonthYield": 7.51,
    "ISIN": "IL0051157126"
  },
  {
    "Id": "TASE:5118369",
    "MayaId": "5118369",
    "Name": "Y.L. MEDINA LELO MENAYOT",
    "ShortName": "Y.L. MEDINA LELO MENAYOT",
    "Symbol": "TASE:5118369",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YELIN LAPIDOT (00) MEDINA IL LELO MENAYOT",
    "EnglishLongName": "YELIN LAPIDOT (00) MEDINA IL LELO MENAYOT",
    "HebrewName": "י.ל. מדינה ללא מניות",
    "HebrewLongName": "ילין לפידות (00) מדינה ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.55,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.26,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - No Equity",
    "AssetValue": 78.7,
    "MonthYield": 0.46,
    "YearYield": 0.46,
    "Last12MonthYield": 5.94,
    "ISIN": "IL0051183692"
  },
  {
    "Id": "TASE:5117296",
    "MayaId": "5117296",
    "Name": "Y.L. MEDINA SHIKLI 1 4 S",
    "ShortName": "Y.L. MEDINA SHIKLI 1-4 S",
    "Symbol": "TASE:5117296",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YELIN LAPIDOT (00) MEDINA SHIKLI IL 1-4 SHANIM",
    "EnglishLongName": "YELIN LAPIDOT (00) MEDINA SHIKLI IL 1-4 SHANIM",
    "HebrewName": "י.ל. מדינה שקלי 1-4 שנים",
    "HebrewLongName": "ילין לפידות (00) מדינה שקלי 1-4 שנים",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.42,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.27,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Shekel Bonds - No Equity",
    "AssetValue": 62.3,
    "MonthYield": 0.57,
    "YearYield": 0.57,
    "Last12MonthYield": 6.42,
    "ISIN": "IL0051172968"
  },
  {
    "Id": "TASE:5118377",
    "MayaId": "5118377",
    "Name": "Y.L. MEDINA TZAMUD KATZAR",
    "ShortName": "Y.L. MEDINA TZAMUD KATZAR",
    "Symbol": "TASE:5118377",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YELIN LAPIDOT (1A) MEDINA TZAMUD KATZAR IL",
    "EnglishLongName": "YELIN LAPIDOT (1A) MEDINA TZAMUD KATZAR IL",
    "HebrewName": "י.ל. מדינה צמוד קצר",
    "HebrewLongName": "ילין לפידות (1A) מדינה צמוד קצר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.68,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.13,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked Government Bonds - Up to 10% Equity",
    "AssetValue": 638.9,
    "MonthYield": 0.64,
    "YearYield": 0.64,
    "Last12MonthYield": 6.39,
    "ISIN": "IL0051183775"
  },
  {
    "Id": "TASE:5115787",
    "MayaId": "5115787",
    "Name": "Y.L. MEDINA+10%",
    "ShortName": "Y.L. MEDINA+10%",
    "Symbol": "TASE:5115787",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YELIN LAPIDOT (1B) MEDINA IL+ 10%",
    "EnglishLongName": "YELIN LAPIDOT (1B) MEDINA IL+ 10%",
    "HebrewName": "י.ל. מדינה+10%",
    "HebrewLongName": "ילין לפידות (1B) מדינה + 10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.64,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.36,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bond, General - up to 10% Equity",
    "AssetValue": 73.8,
    "MonthYield": 0.81,
    "YearYield": 0.81,
    "Last12MonthYield": 8.87,
    "ISIN": "IL0051157878"
  },
  {
    "Id": "TASE:5106273",
    "MayaId": "5106273",
    "Name": "Y.L. MENAYATIT IL",
    "ShortName": "Y.L. MENAYATIT IL",
    "Symbol": "TASE:5106273",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YALIN LAPIDOT (4B) MENAYATIT IL",
    "EnglishLongName": "YALIN LAPIDOT (4B) MENAYATIT IL",
    "HebrewName": "י.ל. מנייתית",
    "HebrewLongName": "ילין לפידות (4B) מנייתית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.32,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.85,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 1380.3,
    "MonthYield": 6.44,
    "YearYield": 6.44,
    "Last12MonthYield": 50.71,
    "ISIN": "IL0051062730"
  },
  {
    "Id": "TASE:5119508",
    "MayaId": "5119508",
    "Name": "Y.L. Menayot Tzmiha",
    "ShortName": "Y.L. Menayot Tzmiha",
    "Symbol": "TASE:5119508",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Yelin Lapidot (4D) Menayot Tzmiha IL",
    "EnglishLongName": "Yelin Lapidot (4D) Menayot Tzmiha IL",
    "HebrewName": "י.ל. מניות צמיחה",
    "HebrewLongName": "ילין לפידות (4D) מניות צמיחה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.8,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.73,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 437.5,
    "MonthYield": 8.85,
    "YearYield": 8.85,
    "Last12MonthYield": 52.65,
    "ISIN": "IL0051195084"
  },
  {
    "Id": "TASE:5141742",
    "MayaId": "5141742",
    "Name": "Y.L. mid cap Israel",
    "ShortName": "Y.L. mid cap Israel",
    "Symbol": "TASE:5141742",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Yelin Lapidot (4A) Israel Mid Cap Equities",
    "EnglishLongName": "Yelin Lapidot (4A) Israel Mid Cap Equities",
    "HebrewName": "י.ל mid cap ישראל",
    "HebrewLongName": "ילין לפידות (4A) מניות Mid Cap ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.95,
    "TrusteeFee": 0.03,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 1.2,
    "MonthYield": 5.64,
    "YearYield": 5.64,
    "Last12MonthYield": null,
    "ISIN": "IL0051417421"
  },
  {
    "Id": "TASE:5141452",
    "MayaId": "5141452",
    "Name": "Y.L. Money Kosher",
    "ShortName": "Y.L. Money - Kosher",
    "Symbol": "TASE:5141452",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YELIN LAPIDOT (00) money market fund - Kosher IL",
    "EnglishLongName": "YELIN LAPIDOT (00) money market fund - Kosher IL",
    "HebrewName": "י.ל. כספית כשרה",
    "HebrewLongName": "ילין לפידות (00) כספית כשרה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.12,
    "TrusteeFee": 0.005,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 7.7,
    "MonthYield": 0.26,
    "YearYield": 0.26,
    "Last12MonthYield": null,
    "ISIN": "IL0051414527"
  },
  {
    "Id": "TASE:5137641",
    "MayaId": "5137641",
    "Name": "y.l. money market fund",
    "ShortName": "y.l. money market fund",
    "Symbol": "TASE:5137641",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Yelin Lapidot (00) money market fund IL",
    "EnglishLongName": "Yelin Lapidot (00) money market fund IL",
    "HebrewName": "י.ל כספית",
    "HebrewLongName": "ילין לפידות (00) כספית",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.22,
    "TrusteeFee": 0.01,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 5151.5,
    "MonthYield": 0.21,
    "YearYield": 0.21,
    "Last12MonthYield": 4.79,
    "ISIN": "IL0051376411"
  },
  {
    "Id": "TASE:5130984",
    "MayaId": "5130984",
    "Name": "Y.L. REAL ESTATE EQUITY",
    "ShortName": "Y.L. REAL ESTATE EQUITY",
    "Symbol": "TASE:5130984",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Yelin Lapidot (4B) Real Estate Equity IL",
    "EnglishLongName": "Yelin Lapidot (4B) Real Estate Equity IL",
    "HebrewName": "י.ל. מניות נדל\"ן",
    "HebrewLongName": "ילין לפידות (4B) מניות נדל\"ן",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.2,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.22,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sectors",
    "AssetValue": 44.7,
    "MonthYield": 6.87,
    "YearYield": 6.87,
    "Last12MonthYield": 30.02,
    "ISIN": "IL0051309842"
  },
  {
    "Id": "TASE:5115886",
    "MayaId": "5115886",
    "Name": "y.l. solid bonds protfo10",
    "ShortName": "y.l. solid bonds protfo10",
    "Symbol": "TASE:5115886",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Yelin Lapidot (1A) Solid Bonds Portfolio IL + 10%",
    "EnglishLongName": "Yelin Lapidot (1A) Solid Bonds Portfolio IL + 10%",
    "HebrewName": "י.ל. תיק אגח סולידי+10%",
    "HebrewLongName": "ילין לפידות (1A) תיק אג\"ח סולידי +10%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli bonds - General - Up to 10% Equity",
    "AssetValue": 265.2,
    "MonthYield": 0.79,
    "YearYield": 0.79,
    "Last12MonthYield": 8.79,
    "ISIN": "IL0051158868"
  },
  {
    "Id": "TASE:5125455",
    "MayaId": "5125455",
    "Name": "y.l. solid bonds protfoli",
    "ShortName": "y.l. solid bonds protfoli",
    "Symbol": "TASE:5125455",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Yelin Lapidot (0B) solid Bonds Portfolio IL",
    "EnglishLongName": "Yelin Lapidot (0B) solid Bonds Portfolio IL",
    "HebrewName": "י.ל. תיק אגח סולידי",
    "HebrewLongName": "ילין לפידות (0B) תיק אג\"ח סולידי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.64,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.22,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 70.4,
    "MonthYield": 0.38,
    "YearYield": 0.38,
    "Last12MonthYield": 5.87,
    "ISIN": "IL0051254550"
  },
  {
    "Id": "TASE:5130208",
    "MayaId": "5130208",
    "Name": "Y.L. State + 20%",
    "ShortName": "Y.L. State + 20%",
    "Symbol": "TASE:5130208",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Yalin Lapidot (2B) State IL + 20%",
    "EnglishLongName": "Yalin Lapidot (2B) State IL + 20%",
    "HebrewName": "י.ל. מדינה + 20%",
    "HebrewLongName": "ילין לפידות (2B) מדינה + 20%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.54,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.53,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "Government Bonds - General - Up to 20% Equity",
    "AssetValue": 24.0,
    "MonthYield": 1.16,
    "YearYield": 1.16,
    "Last12MonthYield": 12.33,
    "ISIN": "IL0051302086"
  },
  {
    "Id": "TASE:5107495",
    "MayaId": "5107495",
    "Name": "Y.L. TIK+30%",
    "ShortName": "Y.L. TIK+30%",
    "Symbol": "TASE:5107495",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YELIN LAPIDOT (2B) TIK IL + 30%",
    "EnglishLongName": "YELIN LAPIDOT (2B) TIK IL + 30%",
    "HebrewName": "י.ל. תיק+30%",
    "HebrewLongName": "ילין לפידות (2B) תיק + 30%",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.45,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.52,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bond, General - up to 30% Equity",
    "AssetValue": 175.0,
    "MonthYield": 1.56,
    "YearYield": 1.56,
    "Last12MonthYield": 15.51,
    "ISIN": "IL0051074958"
  },
  {
    "Id": "TASE:5128343",
    "MayaId": "5128343",
    "Name": "Y.L. TZAMUD MEDINA",
    "ShortName": "Y.L. TZAMUD MEDINA",
    "Symbol": "TASE:5128343",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YELIN LAPIDOT (0A) TZAMUD MEDINA IL",
    "EnglishLongName": "YELIN LAPIDOT (0A) TZAMUD MEDINA IL",
    "HebrewName": "י.ל. צמוד מדינה",
    "HebrewLongName": "ילין לפידות (0A) צמוד מדינה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.17,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - Government Bonds",
    "SecondaryClassification": "CPI-Linked Government Bonds - No Equity",
    "AssetValue": 38.8,
    "MonthYield": 0.05,
    "YearYield": 0.05,
    "Last12MonthYield": 4.12,
    "ISIN": "IL0051283435"
  },
  {
    "Id": "TASE:5108873",
    "MayaId": "5108873",
    "Name": "Y.L. YETER",
    "ShortName": "Y.L. YETER",
    "Symbol": "TASE:5108873",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YELIN LAPIDOT (4B) YETER IL",
    "EnglishLongName": "YELIN LAPIDOT (4B) YETER IL",
    "HebrewName": "י.ל. יתר",
    "HebrewLongName": "ילין לפידות (4B) יתר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 2.46,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.89,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Market Cap",
    "AssetValue": 322.0,
    "MonthYield": 6.54,
    "YearYield": 6.54,
    "Last12MonthYield": 47.27,
    "ISIN": "IL0051088735"
  },
  {
    "Id": "TASE:5118088",
    "MayaId": "5118088",
    "Name": "Y.L.! BONDS TOTAL RETURN",
    "ShortName": "Y.L.! BONDS TOTAL RETURN",
    "Symbol": "TASE:5118088",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YELIN LAPIDOT (0B)(!) BONDS IL TOTAL RETURN",
    "EnglishLongName": "YELIN LAPIDOT (0B)(!) BONDS IL TOTAL RETURN",
    "HebrewName": "י.ל! אג\"ח TOTAL RETURN",
    "HebrewLongName": "ילין לפידות (0B)(!) אג\"ח TOTAL RETURN IL",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.27,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 804.1,
    "MonthYield": 0.53,
    "YearYield": 0.53,
    "Last12MonthYield": 6.42,
    "ISIN": "IL0051180888"
  },
  {
    "Id": "TASE:5138961",
    "MayaId": "5138961",
    "Name": "Y.L.Corp cpi link A&Highr",
    "ShortName": "Y.L.Corp cpi-link A&Highr",
    "Symbol": "TASE:5138961",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YELIN LAPIDOT (0A) Corporate CPI-Linked A & Higher IL",
    "EnglishLongName": "YELIN LAPIDOT (0A) Corporate CPI-Linked A & Higher IL",
    "HebrewName": "י.ל. קונצרני צמוד A ומעלה",
    "HebrewLongName": "ילין לפידות (0A) קונצרני צמוד A ומעלה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.59,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.29,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 269.9,
    "MonthYield": 0.3,
    "YearYield": 0.3,
    "Last12MonthYield": 7.67,
    "ISIN": "IL0051389612"
  },
  {
    "Id": "TASE:5139258",
    "MayaId": "5139258",
    "Name": "Y.L.Mon Mark liqu mang",
    "ShortName": "Y.L.Mon Mark liqu mang",
    "Symbol": "TASE:5139258",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YELIN LAPIDOT (00) Money Market Liquidity Management IL",
    "EnglishLongName": "YELIN LAPIDOT (00) Money Market Liquidity Management IL",
    "HebrewName": "י.ל.כספית ניהול נזילות",
    "HebrewLongName": "ילין לפידות (00) כספית ניהול נזילות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.19,
    "TrusteeFee": 0.005,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.0,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Money Market Fund",
    "SecondaryClassification": "Non-Linked Money Market",
    "AssetValue": 12407.4,
    "MonthYield": 0.21,
    "YearYield": 0.21,
    "Last12MonthYield": 4.81,
    "ISIN": "IL0051392582"
  },
  {
    "Id": "TASE:5137492",
    "MayaId": "5137492",
    "Name": "Y.L.TF Bullet 2026 CPI",
    "ShortName": "Y.L.TF Bullet 2026 CPI",
    "Symbol": "TASE:5137492",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (00) quabify Bullet 2026 CPI Linked IL",
    "EnglishLongName": "YLTF (00) quabify Bullet 2026 CPI Linked IL",
    "HebrewName": "י.ל מחקה לפדיון 2026 צמוד",
    "HebrewLongName": "ילין לפידות מחקה (00) quabify אג״ח לפדיון 2026 צמוד",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.24,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.13,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 126.1,
    "MonthYield": 0.16,
    "YearYield": 0.16,
    "Last12MonthYield": 4.57,
    "ISIN": "IL0051374929"
  },
  {
    "Id": "TASE:5137518",
    "MayaId": "5137518",
    "Name": "Y.L.TF Bullet 2026 ILS",
    "ShortName": "Y.L.TF Bullet 2026 ILS",
    "Symbol": "TASE:5137518",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (00) quabify Bullet 2026 ILS IL",
    "EnglishLongName": "YLTF (00) quabify Bullet 2026 ILS IL",
    "HebrewName": "י.ל מחקה לפדיון 2026 שקלי",
    "HebrewLongName": "ילין לפידות מחקה (00) quabify אג״ח לפדיון 2026 שקלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.24,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.11,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 39.0,
    "MonthYield": 0.33,
    "YearYield": 0.33,
    "Last12MonthYield": 5.34,
    "ISIN": "IL0051375181"
  },
  {
    "Id": "TASE:5138987",
    "MayaId": "5138987",
    "Name": "Y.L.TF Bullet 2026Balance",
    "ShortName": "Y.L.TF Bullet 2026Balance",
    "Symbol": "TASE:5138987",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (00) quabify Bullet 2026 Balanced IL",
    "EnglishLongName": "YLTF (00) quabify Bullet 2026 Balanced IL",
    "HebrewName": "י.ל מחקה פדיון 2026 מאוזן",
    "HebrewLongName": "ילין לפידות מחקה (00) quabify אג״ח לפדיון 2026 מאוזן",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.24,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.13,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 5.2,
    "MonthYield": 0.24,
    "YearYield": 0.24,
    "Last12MonthYield": 5.0,
    "ISIN": "IL0051389877"
  },
  {
    "Id": "TASE:5137484",
    "MayaId": "5137484",
    "Name": "Y.L.TF Bullet 2027 CPI",
    "ShortName": "Y.L.TF Bullet 2027 CPI",
    "Symbol": "TASE:5137484",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (00) quabify Bullet 2027 CPI Linked IL",
    "EnglishLongName": "YLTF (00) quabify Bullet 2027 CPI Linked IL",
    "HebrewName": "י.ל מחקה לפדיון 2027 צמוד",
    "HebrewLongName": "ילין לפידות מחקה (00) quabify אג״ח לפדיון 2027 צמוד",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.24,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.2,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 272.9,
    "MonthYield": 0.07,
    "YearYield": 0.07,
    "Last12MonthYield": 4.71,
    "ISIN": "IL0051374846"
  },
  {
    "Id": "TASE:5137500",
    "MayaId": "5137500",
    "Name": "Y.L.TF Bullet 2027 ILS",
    "ShortName": "Y.L.TF Bullet 2027 ILS",
    "Symbol": "TASE:5137500",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (00) quabify Bullet 2027 ILS IL",
    "EnglishLongName": "YLTF (00) quabify Bullet 2027 ILS IL",
    "HebrewName": "י.ל מחקה לפדיון 2027 שקלי",
    "HebrewLongName": "ילין לפידות מחקה (00) quabify אג״ח לפדיון 2027 שקלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.24,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.16,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 93.0,
    "MonthYield": 0.44,
    "YearYield": 0.44,
    "Last12MonthYield": 5.89,
    "ISIN": "IL0051375009"
  },
  {
    "Id": "TASE:5138995",
    "MayaId": "5138995",
    "Name": "Y.L.TF Bullet 2027Balance",
    "ShortName": "Y.L.TF Bullet 2027Balance",
    "Symbol": "TASE:5138995",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (00) quabify Bullet 2027 Balanced IL",
    "EnglishLongName": "YLTF (00) quabify Bullet 2027 Balanced IL",
    "HebrewName": "י.ל מחקה פדיון 2027 מאוזן",
    "HebrewLongName": "ילין לפידות מחקה (00) quabify אג״ח לפדיון 2027 מאוזן",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.24,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.16,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 4.3,
    "MonthYield": 0.26,
    "YearYield": 0.26,
    "Last12MonthYield": 5.33,
    "ISIN": "IL0051389950"
  },
  {
    "Id": "TASE:5138045",
    "MayaId": "5138045",
    "Name": "Y.L.TF Bullet 2028 CPI",
    "ShortName": "Y.L.TF Bullet 2028 CPI",
    "Symbol": "TASE:5138045",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (00) quabify Bullet 2028 CPI Linked IL",
    "EnglishLongName": "YLTF (00) quabify Bullet 2028 CPI Linked IL",
    "HebrewName": "י.ל מחקה לפדיון 2028 צמוד",
    "HebrewLongName": "ילין לפידות מחקה (00) quabify אג״ח לפדיון 2028 צמוד",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.24,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.18,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 174.4,
    "MonthYield": 0.1,
    "YearYield": 0.1,
    "Last12MonthYield": 4.93,
    "ISIN": "IL0051380454"
  },
  {
    "Id": "TASE:5138060",
    "MayaId": "5138060",
    "Name": "Y.L.TF Bullet 2028 ILS",
    "ShortName": "Y.L.TF Bullet 2028 ILS",
    "Symbol": "TASE:5138060",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (00) quabify Bullet 2028 ILS IL",
    "EnglishLongName": "YLTF (00) quabify Bullet 2028 ILS IL",
    "HebrewName": "י.ל מחקה לפדיון 2028 שקלי",
    "HebrewLongName": "ילין לפידות מחקה (00) quabify אג״ח לפדיון 2028 שקלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.24,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.2,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 82.0,
    "MonthYield": 0.58,
    "YearYield": 0.58,
    "Last12MonthYield": 6.48,
    "ISIN": "IL0051380603"
  },
  {
    "Id": "TASE:5139001",
    "MayaId": "5139001",
    "Name": "Y.L.TF Bullet 2028Balance",
    "ShortName": "Y.L.TF Bullet 2028Balance",
    "Symbol": "TASE:5139001",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (00) quabify Bullet 2028 Balanced IL",
    "EnglishLongName": "YLTF (00) quabify Bullet 2028 Balanced IL",
    "HebrewName": "י.ל מחקה פדיון 2028 מאוזן",
    "HebrewLongName": "ילין לפידות מחקה (00) quabify אג״ח לפדיון 2028 מאוזן",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.24,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.18,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 16.8,
    "MonthYield": 0.33,
    "YearYield": 0.33,
    "Last12MonthYield": 5.65,
    "ISIN": "IL0051390016"
  },
  {
    "Id": "TASE:5138052",
    "MayaId": "5138052",
    "Name": "Y.L.TF Bullet 2029 CPI",
    "ShortName": "Y.L.TF Bullet 2029 CPI",
    "Symbol": "TASE:5138052",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (00) quabify Bullet 2029 CPI Linked IL",
    "EnglishLongName": "YLTF (00) quabify Bullet 2029 CPI Linked IL",
    "HebrewName": "י.ל מחקה לפדיון 2029 צמוד",
    "HebrewLongName": "ילין לפידות מחקה (00) quabify אג״ח לפדיון 2029 צמוד",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.24,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.2,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 157.6,
    "MonthYield": 0.19,
    "YearYield": 0.19,
    "Last12MonthYield": 5.49,
    "ISIN": "IL0051380520"
  },
  {
    "Id": "TASE:5138078",
    "MayaId": "5138078",
    "Name": "Y.L.TF Bullet 2029 ILS",
    "ShortName": "Y.L.TF Bullet 2029 ILS",
    "Symbol": "TASE:5138078",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (00) quabify Bullet 2029 ILS IL",
    "EnglishLongName": "YLTF (00) quabify Bullet 2029 ILS IL",
    "HebrewName": "י.ל מחקה לפדיון 2029 שקלי",
    "HebrewLongName": "ילין לפידות מחקה (00) quabify אג״ח לפדיון 2029 שקלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.24,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 137.5,
    "MonthYield": 0.73,
    "YearYield": 0.73,
    "Last12MonthYield": 7.27,
    "ISIN": "IL0051380785"
  },
  {
    "Id": "TASE:5139019",
    "MayaId": "5139019",
    "Name": "Y.L.TF Bullet 2029Balance",
    "ShortName": "Y.L.TF Bullet 2029Balance",
    "Symbol": "TASE:5139019",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (00) quabify Bullet 2029 Balanced IL",
    "EnglishLongName": "YLTF (00) quabify Bullet 2029 Balanced IL",
    "HebrewName": "י.ל מחקה פדיון 2029 מאוזן",
    "HebrewLongName": "ילין לפידות מחקה (00) quabify אג״ח לפדיון 2029 מאוזן",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.24,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.2,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 11.9,
    "MonthYield": 0.46,
    "YearYield": 0.46,
    "Last12MonthYield": 6.36,
    "ISIN": "IL0051390198"
  },
  {
    "Id": "TASE:5139555",
    "MayaId": "5139555",
    "Name": "Y.L.TF Bullet 2030 CPI",
    "ShortName": "Y.L.TF Bullet 2030 CPI",
    "Symbol": "TASE:5139555",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (00) quabify Bullet 2030 CPI Linked IL",
    "EnglishLongName": "YLTF (00) quabify Bullet 2030 CPI Linked IL",
    "HebrewName": "י.ל מחקה לפדיון 2030 צמוד",
    "HebrewLongName": "ילין לפידות מחקה (00) quabify אג\"ח לפדיון 2030 צמוד",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.24,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.23,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 28.5,
    "MonthYield": 0.25,
    "YearYield": 0.25,
    "Last12MonthYield": 5.94,
    "ISIN": "IL0051395551"
  },
  {
    "Id": "TASE:5139548",
    "MayaId": "5139548",
    "Name": "Y.L.TF Bullet 2030 ILS",
    "ShortName": "Y.L.TF Bullet 2030 ILS",
    "Symbol": "TASE:5139548",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (00) quabify Bullet 2030 ILS IL",
    "EnglishLongName": "YLTF (00) quabify Bullet 2030 ILS IL",
    "HebrewName": "י.ל מחקה לפדיון 2030 שקלי",
    "HebrewLongName": "ילין לפידות מחקה (00) quabify אג\"ח לפדיון 2030 שקלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.24,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 59.8,
    "MonthYield": 0.86,
    "YearYield": 0.86,
    "Last12MonthYield": 7.43,
    "ISIN": "IL0051395486"
  },
  {
    "Id": "TASE:5139530",
    "MayaId": "5139530",
    "Name": "Y.L.TF Bullet 2030Balance",
    "ShortName": "Y.L.TF Bullet 2030Balance",
    "Symbol": "TASE:5139530",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (00) quabify Bullet 2030 Balanced IL",
    "EnglishLongName": "YLTF (00) quabify Bullet 2030 Balanced IL",
    "HebrewName": "י.ל מחקה פדיון 2030 מאוזן",
    "HebrewLongName": "ילין לפידות מחקה (00) quabify אג\"ח לפדיון 2030 מאוזן",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.24,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.25,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 27.4,
    "MonthYield": 0.54,
    "YearYield": 0.54,
    "Last12MonthYield": 6.65,
    "ISIN": "IL0051395304"
  },
  {
    "Id": "TASE:5141122",
    "MayaId": "5141122",
    "Name": "Y.L.TF Bullet 2031 CPI",
    "ShortName": "Y.L.TF Bullet 2031 CPI",
    "Symbol": "TASE:5141122",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (00) quabify Bullet 2031 CPI Linked IL",
    "EnglishLongName": "YLTF (00) quabify Bullet 2031 CPI Linked IL",
    "HebrewName": "י.ל מחקה לפדיון 2031 צמוד",
    "HebrewLongName": "ילין לפידות מחקה (00) quabify אג\"ח לפדיון 2031 צמוד",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.24,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 17.6,
    "MonthYield": 0.24,
    "YearYield": 0.24,
    "Last12MonthYield": null,
    "ISIN": "IL0051411226"
  },
  {
    "Id": "TASE:5141130",
    "MayaId": "5141130",
    "Name": "Y.L.TF Bullet 2031 ILS",
    "ShortName": "Y.L.TF Bullet 2031 ILS",
    "Symbol": "TASE:5141130",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (00) quabify Bullet 2031 ILS IL",
    "EnglishLongName": "YLTF (00) quabify Bullet 2031 ILS IL",
    "HebrewName": "י.ל מחקה לפדיון 2031 שקלי",
    "HebrewLongName": "ילין לפידות מחקה (00) quabify אג\"ח לפדיון 2031 שקלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.24,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 4.8,
    "MonthYield": 0.86,
    "YearYield": 0.86,
    "Last12MonthYield": null,
    "ISIN": "IL0051411309"
  },
  {
    "Id": "TASE:5141148",
    "MayaId": "5141148",
    "Name": "Y.L.TF Bullet 2031Balance",
    "ShortName": "Y.L.TF Bullet 2031Balance",
    "Symbol": "TASE:5141148",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (00) quabify Bullet 2031 Balanced IL",
    "EnglishLongName": "YLTF (00) quabify Bullet 2031 Balanced IL",
    "HebrewName": "י.ל מחקה פדיון 2031 מאוזן",
    "HebrewLongName": "ילין לפידות מחקה (00) quabify אג״ח לפדיון 2031 מאוזן",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.24,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 2.9,
    "MonthYield": 0.55,
    "YearYield": 0.55,
    "Last12MonthYield": null,
    "ISIN": "IL0051411481"
  },
  {
    "Id": "TASE:5141171",
    "MayaId": "5141171",
    "Name": "Y.L.TF Bullet 2032 CPI",
    "ShortName": "Y.L.TF Bullet 2032 CPI",
    "Symbol": "TASE:5141171",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (00) quabify Bullet 2032 CPI Linked IL",
    "EnglishLongName": "YLTF (00) quabify Bullet 2032 CPI Linked IL",
    "HebrewName": "י.ל מחקה לפדיון 2032 צמוד",
    "HebrewLongName": "ילין לפידות מחקה (00) quabify אג\"ח לפדיון 2032 צמוד",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.24,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 3.1,
    "MonthYield": 0.22,
    "YearYield": 0.22,
    "Last12MonthYield": null,
    "ISIN": "IL0051411713"
  },
  {
    "Id": "TASE:5141163",
    "MayaId": "5141163",
    "Name": "Y.L.TF Bullet 2032 ILS",
    "ShortName": "Y.L.TF Bullet 2032 ILS",
    "Symbol": "TASE:5141163",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (00) quabify Bullet 2032 ILS IL",
    "EnglishLongName": "YLTF (00) quabify Bullet 2032 ILS IL",
    "HebrewName": "י.ל מחקה לפדיון 2032 שקלי",
    "HebrewLongName": "ילין לפידות מחקה (00) quabify אג\"ח לפדיון 2032 שקלי",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.24,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 18.7,
    "MonthYield": 1.06,
    "YearYield": 1.06,
    "Last12MonthYield": null,
    "ISIN": "IL0051411630"
  },
  {
    "Id": "TASE:5141155",
    "MayaId": "5141155",
    "Name": "Y.L.TF Bullet 2032Balance",
    "ShortName": "Y.L.TF Bullet 2032Balance",
    "Symbol": "TASE:5141155",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (00) quabify Bullet 2032 Balanced IL",
    "EnglishLongName": "YLTF (00) quabify Bullet 2032 Balanced IL",
    "HebrewName": "י.ל מחקה פדיון 2032 מאוזן",
    "HebrewLongName": "ילין לפידות מחקה (00) quabify אג״ח לפדיון 2032 מאוזן",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.24,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "corporate bond",
    "AssetValue": 5.0,
    "MonthYield": 0.62,
    "YearYield": 0.62,
    "Last12MonthYield": null,
    "ISIN": "IL0051411556"
  },
  {
    "Id": "TASE:5139647",
    "MayaId": "5139647",
    "Name": "Y.L.TF Corp CPI Duration2",
    "ShortName": "Y.L.TF Corp CPI Duration2",
    "Symbol": "TASE:5139647",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (00) quabify Corporate Bonds CPI Fixed Duration 2 IL",
    "EnglishLongName": "YLTF (00) quabify Corporate Bonds CPI Fixed Duration 2 IL",
    "HebrewName": "י.ל מחקה קונצרני צמד מחמ2",
    "HebrewLongName": "ילין לפידות מחקה (00) quabify קונצרני צמוד מח\"מ 2 קבוע",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.19,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.15,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 2.1,
    "MonthYield": 0.14,
    "YearYield": 0.14,
    "Last12MonthYield": null,
    "ISIN": "IL0051396476"
  },
  {
    "Id": "TASE:5140074",
    "MayaId": "5140074",
    "Name": "Y.L.TF Corp CPI Duration3",
    "ShortName": "Y.L.TF Corp CPI Duration3",
    "Symbol": "TASE:5140074",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (00) quabify Corporate Bonds CPI Fixed Duration 3 IL",
    "EnglishLongName": "YLTF (00) quabify Corporate Bonds CPI Fixed Duration 3 IL",
    "HebrewName": "י.ל מחקה קונצרני צמד מחמ3",
    "HebrewLongName": "ילין לפידות מחקה (00) quabify קונצרני צמוד מח\"מ 3 קבוע",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.19,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.2,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 0.5,
    "MonthYield": 0.19,
    "YearYield": 0.19,
    "Last12MonthYield": null,
    "ISIN": "IL0051400740"
  },
  {
    "Id": "TASE:5140082",
    "MayaId": "5140082",
    "Name": "Y.L.TF Corp CPI Duration4",
    "ShortName": "Y.L.TF Corp CPI Duration4",
    "Symbol": "TASE:5140082",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (00) quabify Corporate Bonds CPI Fixed Duration 4 IL",
    "EnglishLongName": "YLTF (00) quabify Corporate Bonds CPI Fixed Duration 4 IL",
    "HebrewName": "י.ל מחקה קונצרני צמד מחמ4",
    "HebrewLongName": "ילין לפידות מחקה (00) quabify קונצרני צמוד מח\"מ 4 קבוע",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.19,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.26,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 0.4,
    "MonthYield": 0.18,
    "YearYield": 0.18,
    "Last12MonthYield": null,
    "ISIN": "IL0051400823"
  },
  {
    "Id": "TASE:5139654",
    "MayaId": "5139654",
    "Name": "Y.L.TF Corp ILS Duration2",
    "ShortName": "Y.L.TF Corp ILS Duration2",
    "Symbol": "TASE:5139654",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (00) quabify Corporate Bonds ILS Fixed Duration 2 IL",
    "EnglishLongName": "YLTF (00) quabify Corporate Bonds ILS Fixed Duration 2 IL",
    "HebrewName": "י.ל מחקה קונצרני שקל מחמ2",
    "HebrewLongName": "ילין לפידות מחקה (00) quabify קונצרני שקלי מח\"מ 2 קבוע",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.19,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.17,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 0.7,
    "MonthYield": 0.69,
    "YearYield": 0.69,
    "Last12MonthYield": null,
    "ISIN": "IL0051396542"
  },
  {
    "Id": "TASE:5140090",
    "MayaId": "5140090",
    "Name": "Y.L.TF Corp ILS Duration3",
    "ShortName": "Y.L.TF Corp ILS Duration3",
    "Symbol": "TASE:5140090",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (00) quabify Corporate Bonds ILS Fixed Duration 3 IL",
    "EnglishLongName": "YLTF (00) quabify Corporate Bonds ILS Fixed Duration 3 IL",
    "HebrewName": "י.ל מחקה קונצרני שקל מחמ3",
    "HebrewLongName": "ילין לפידות מחקה (00) quabify קונצרני שקלי מח\"מ 3 קבוע",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.19,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.29,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 0.5,
    "MonthYield": 0.86,
    "YearYield": 0.86,
    "Last12MonthYield": null,
    "ISIN": "IL0051400906"
  },
  {
    "Id": "TASE:5140108",
    "MayaId": "5140108",
    "Name": "Y.L.TF Corp ILS Duration4",
    "ShortName": "Y.L.TF Corp ILS Duration4",
    "Symbol": "TASE:5140108",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (00) quabify Corporate Bonds ILS Fixed Duration 4 IL",
    "EnglishLongName": "YLTF (00) quabify Corporate Bonds ILS Fixed Duration 4 IL",
    "HebrewName": "י.ל מחקה קונצרני שקל מחמ4",
    "HebrewLongName": "ילין לפידות מחקה (00) quabify קונצרני שקלי מח\"מ 4 קבוע",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.19,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 1.9,
    "MonthYield": 0.96,
    "YearYield": 0.96,
    "Last12MonthYield": null,
    "ISIN": "IL0051401086"
  },
  {
    "Id": "TASE:5138649",
    "MayaId": "5138649",
    "Name": "Y.L.TF CPI Banks IL",
    "ShortName": "Y.L.TF CPI Banks IL",
    "Symbol": "TASE:5138649",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (00) Tel Bond Banks CPI IL",
    "EnglishLongName": "YLTF (00) Tel Bond Banks CPI IL",
    "HebrewName": "י.ל מחקה צמודות בנקים",
    "HebrewLongName": "ילין לפידות מחקה (00) תל בונד צמודות בנקים",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.18,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 15.5,
    "MonthYield": 0.19,
    "YearYield": 0.19,
    "Last12MonthYield": 5.76,
    "ISIN": "IL0051386493"
  },
  {
    "Id": "TASE:5136395",
    "MayaId": "5136395",
    "Name": "Y.L.TF Global Chips AI",
    "ShortName": "Y.L.TF Global Chips AI",
    "Symbol": "TASE:5136395",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (4D) Index Global Chips - AI Based",
    "EnglishLongName": "YLTF (4D) Index Global Chips - AI Based",
    "HebrewName": "י.ל. מחקה שבבים גלובלי AI",
    "HebrewLongName": "ילין לפידות מחקה (4D) אינדקס שבבים גלובלי - מבוסס AI",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.77,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 3.54,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 47.6,
    "MonthYield": 11.56,
    "YearYield": 11.56,
    "Last12MonthYield": 29.1,
    "ISIN": "IL0051363955"
  },
  {
    "Id": "TASE:5136981",
    "MayaId": "5136981",
    "Name": "Y.L.TF Global EssInfra AI",
    "ShortName": "Y.L.TF Global EssInfra AI",
    "Symbol": "TASE:5136981",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (4D) Index Global Essential Infrastructures - AI Based",
    "EnglishLongName": "YLTF (4D) Index Global Essential Infrastructures - AI Based",
    "HebrewName": "י.ל. מחקה תשתיו גלובלי AI",
    "HebrewLongName": "ילין לפידות מחקה (4D) אינדקס תשתיות חיוניות גלובלי - מבוסס AI",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.77,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.45,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 16.3,
    "MonthYield": -1.43,
    "YearYield": -1.43,
    "Last12MonthYield": -3.27,
    "ISIN": "IL0051369812"
  },
  {
    "Id": "TASE:5136148",
    "MayaId": "5136148",
    "Name": "Y.L.TF Global GrnEnrgy AI",
    "ShortName": "Y.L.TF Global GrnEnrgy AI",
    "Symbol": "TASE:5136148",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (4D) Index Global Green Energy - AI Based",
    "EnglishLongName": "YLTF (4D) Index Global Green Energy - AI Based",
    "HebrewName": "י.ל. מחקה אנ ירק גלובל AI",
    "HebrewLongName": "ילין לפידות מחקה (4D) אינדקס אנרגיה ירוקה גלובלי - מבוסס AI",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.77,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.1,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Stocks by Sector Abroad",
    "AssetValue": 19.4,
    "MonthYield": 4.9,
    "YearYield": 4.9,
    "Last12MonthYield": 40.01,
    "ISIN": "IL0051361488"
  },
  {
    "Id": "TASE:5139282",
    "MayaId": "5139282",
    "Name": "Y.L.TF S&P 500",
    "ShortName": "Y.L.TF S&P 500",
    "Symbol": "TASE:5139282",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (4D) S&P 500",
    "EnglishLongName": "YLTF (4D) S&P 500",
    "HebrewName": "י.ל מחקה S&P 500",
    "HebrewLongName": "ילין לפידות מחקה (4D)י S&P 500",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.39,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 97.4,
    "MonthYield": 0.13,
    "YearYield": 0.13,
    "Last12MonthYield": 3.12,
    "ISIN": "IL0051392822"
  },
  {
    "Id": "TASE:5139290",
    "MayaId": "5139290",
    "Name": "Y.L.TF S&P 500 CH",
    "ShortName": "Y.L.TF S&P 500 CH",
    "Symbol": "TASE:5139290",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (4A) S&P 500 Currency Hedged",
    "EnglishLongName": "YLTF (4A) S&P 500 Currency Hedged",
    "HebrewName": "י.ל מחקה S&P500 ממ",
    "HebrewLongName": "ילין לפידות מחקה (4A)י S&P 500 מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.6,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 158.5,
    "MonthYield": 1.49,
    "YearYield": 1.49,
    "Last12MonthYield": 17.26,
    "ISIN": "IL0051392905"
  },
  {
    "Id": "TASE:5140280",
    "MayaId": "5140280",
    "Name": "Y.L.TF S&P 500 MrkLead",
    "ShortName": "Y.L.TF S&P500 MrkLead",
    "Symbol": "TASE:5140280",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (4D) S&P 500 Market Leaders",
    "EnglishLongName": "YLTF (4D) S&P 500 Market Leaders",
    "HebrewName": "י.ל מחקה S&P500 MrkLead",
    "HebrewLongName": "ילין לפידות מחקה (4D)י S&P 500 Market Leaders",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.49,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.53,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 7.1,
    "MonthYield": 0.5,
    "YearYield": 0.5,
    "Last12MonthYield": null,
    "ISIN": "IL0051402803"
  },
  {
    "Id": "TASE:5140272",
    "MayaId": "5140272",
    "Name": "Y.L.TF S&P 500 MrkLead CH",
    "ShortName": "Y.L.TF S&P500 MrkLead CH",
    "Symbol": "TASE:5140272",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (4A) S&P 500 Market Leaders Currency Hedged",
    "EnglishLongName": "YLTF (4A) S&P 500 Market Leaders Currency Hedged",
    "HebrewName": "י.ל מחקה S&P500 MrkLeadממ",
    "HebrewLongName": "ילין לפידות מחקה (4A)י S&P 500 Market Leaders מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.49,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.53,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 14.1,
    "MonthYield": 1.87,
    "YearYield": 1.87,
    "Last12MonthYield": null,
    "ISIN": "IL0051402720"
  },
  {
    "Id": "TASE:5139308",
    "MayaId": "5139308",
    "Name": "Y.L.TF S&P World",
    "ShortName": "Y.L.TF S&P World",
    "Symbol": "TASE:5139308",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (4D) S&P World",
    "EnglishLongName": "YLTF (4D) S&P World",
    "HebrewName": "י.ל מחקה S&P World",
    "HebrewLongName": "ילין לפידות מחקה (4D)י S&P World",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.04,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX Geographical Stocks",
    "AssetValue": 7.6,
    "MonthYield": -0.36,
    "YearYield": -0.36,
    "Last12MonthYield": null,
    "ISIN": "IL0051393085"
  },
  {
    "Id": "TASE:5139316",
    "MayaId": "5139316",
    "Name": "Y.L.TF S&P World DH",
    "ShortName": "Y.L.TF S&P World DH",
    "Symbol": "TASE:5139316",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (4A) S&P World USD Hedged",
    "EnglishLongName": "YLTF (4A) S&P World USD Hedged",
    "HebrewName": "י.ל מחקה S&P World מד",
    "HebrewLongName": "ילין לפידות מחקה (4A)י S&P World מנוטרלת דולר",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Geographical Stocks",
    "AssetValue": 7.9,
    "MonthYield": 1.17,
    "YearYield": 1.17,
    "Last12MonthYield": null,
    "ISIN": "IL0051393168"
  },
  {
    "Id": "TASE:5137294",
    "MayaId": "5137294",
    "Name": "Y.L.TF TA125 Equal Weight",
    "ShortName": "Y.L.TF TA125 Equal Weight",
    "Symbol": "TASE:5137294",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (4A) TA 125 Equal Weight IL",
    "EnglishLongName": "YLTF (4A) TA 125 Equal Weight IL",
    "HebrewName": "י.ל מחקה תא 125 משקל שווה",
    "HebrewLongName": "ילין לפידות מחקה (4A) ת\"א 125 משקל שווה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.1,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.75,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks, General",
    "AssetValue": 91.7,
    "MonthYield": 7.83,
    "YearYield": 7.83,
    "Last12MonthYield": 59.05,
    "ISIN": "IL0051372949"
  },
  {
    "Id": "TASE:5137302",
    "MayaId": "5137302",
    "Name": "Y.L.TF TASE Banks",
    "ShortName": "Y.L.TF TASE Banks",
    "Symbol": "TASE:5137302",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (4A) Tel Aviv Stock Exchange Banks IL",
    "EnglishLongName": "YLTF (4A) Tel Aviv Stock Exchange Banks IL",
    "HebrewName": "י.ל מחקה ת\"א בנקים",
    "HebrewLongName": "ילין לפידות מחקה (4A) ת\"א בנקים",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.49,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.99,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Stocks by Sector",
    "AssetValue": 724.3,
    "MonthYield": 9.24,
    "YearYield": 9.24,
    "Last12MonthYield": 69.78,
    "ISIN": "IL0051373020"
  },
  {
    "Id": "TASE:5136940",
    "MayaId": "5136940",
    "Name": "Y.L.TF Tel Bond 100 CPI",
    "ShortName": "Y.L.TF Tel Bond 100 CPI",
    "Symbol": "TASE:5136940",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (00) Tel Bond 100 CPI IL",
    "EnglishLongName": "YLTF (00) Tel Bond 100 CPI IL",
    "HebrewName": "י.ל מחקה תל בונד 100 צמוד",
    "HebrewLongName": "ילין לפידות מחקה (00) תל בונד 100 צמודות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.32,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 165.1,
    "MonthYield": 0.25,
    "YearYield": 0.25,
    "Last12MonthYield": 6.64,
    "ISIN": "IL0051369408"
  },
  {
    "Id": "TASE:5136957",
    "MayaId": "5136957",
    "Name": "Y.L.TF Tel Bond Shekel100",
    "ShortName": "Y.L.TF Tel Bond Shekel100",
    "Symbol": "TASE:5136957",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (00) Tel Bond Shekel 100 IL",
    "EnglishLongName": "YLTF (00) Tel Bond Shekel 100 IL",
    "HebrewName": "י.ל מחקה תל בונד שקלי 100",
    "HebrewLongName": "ילין לפידות מחקה (00) תל בונד שקלי 100",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.36,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 89.4,
    "MonthYield": 0.9,
    "YearYield": 0.9,
    "Last12MonthYield": 8.22,
    "ISIN": "IL0051369572"
  },
  {
    "Id": "TASE:5137419",
    "MayaId": "5137419",
    "Name": "Y.L.TF Tel Bond Yields SD",
    "ShortName": "Y.L.TF Tel Bond Yields SD",
    "Symbol": "TASE:5137419",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (00) Tel Bond Yields Shekel Diverse Allocation IL",
    "EnglishLongName": "YLTF (00) Tel Bond Yields Shekel Diverse Allocation IL",
    "HebrewName": "י.ל מחקה תל בונד תשוא שקל",
    "HebrewLongName": "ילין לפידות מחקה (00) תל בונד תשואות שקלי פיזור רחב",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.28,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "shekel corporate bond",
    "AssetValue": 3.2,
    "MonthYield": 0.96,
    "YearYield": 0.96,
    "Last12MonthYield": 6.2,
    "ISIN": "IL0051374192"
  },
  {
    "Id": "TASE:5137401",
    "MayaId": "5137401",
    "Name": "Y.L.TF Tel Bond YieldsCPI",
    "ShortName": "Y.L.TF Tel Bond YieldsCPI",
    "Symbol": "TASE:5137401",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YLTF (00) Tel Bond Yields CPI Diverse Allocation IL",
    "EnglishLongName": "YLTF (00) Tel Bond Yields CPI Diverse Allocation IL",
    "HebrewName": "י.ל מחקה תל בונד תשוא צמד",
    "HebrewLongName": "ילין לפידות מחקה (00) תל בונד תשואות צמודות פיזור רחב",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.25,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.27,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "index-linked corporate bond",
    "AssetValue": 161.6,
    "MonthYield": 0.13,
    "YearYield": 0.13,
    "Last12MonthYield": 6.32,
    "ISIN": "IL0051374010"
  },
  {
    "Id": "YAAZ.TA",
    "MayaId": "1227321",
    "Name": "YAAZ",
    "ShortName": "YAAZ ENTREPRENEURSHIP AND URBAN RENEWAL LTD",
    "Symbol": "YAAZ.TA",
    "TaseSymbol": "YAAZ",
    "YahooId": "YAAZ.TA",
    "EnglishName": "YAAZ",
    "EnglishLongName": "YAAZ ENTREPRENEURSHIP AND URBAN RENEWAL LTD",
    "HebrewName": "יעז יזמות",
    "HebrewLongName": "י.ע.ז יזמות ובניה והתחדשות עירונית בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 924.1,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 4.6,
    "YearYield": 4.6,
    "Last12MonthYield": null,
    "ISIN": "IL0012273210"
  },
  {
    "Id": "YACO.TA",
    "MayaId": "1142421",
    "Name": "YACOBI GROUP",
    "ShortName": "YACOBI BROTHERS GROUP (YSB) LTD",
    "Symbol": "YACO.TA",
    "TaseSymbol": "YACO",
    "YahooId": "YACO.TA",
    "EnglishName": "YACOBI GROUP",
    "EnglishLongName": "YACOBI BROTHERS GROUP (YSB) LTD",
    "HebrewName": "יעקובי קבוצה",
    "HebrewLongName": "קבוצת אחים יעקובי (ואי.אס.בי)בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 77.5,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 11.3,
    "YearYield": 11.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011424210"
  },
  {
    "Id": "YBOX.TA",
    "MayaId": "486027",
    "Name": "YBOX",
    "ShortName": "YBOX REAL ESTATE LTD",
    "Symbol": "YBOX.TA",
    "TaseSymbol": "YBOX",
    "YahooId": "YBOX.TA",
    "EnglishName": "YBOX",
    "EnglishLongName": "YBOX REAL ESTATE LTD",
    "HebrewName": "וויי בוקס",
    "HebrewLongName": "וויי-בוקס נדל\"ן בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 121.3,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 12.1,
    "YearYield": 12.1,
    "Last12MonthYield": null,
    "ISIN": "IL0004860271"
  },
  {
    "Id": "YESD.TA",
    "MayaId": "1188416",
    "Name": "YESODOT",
    "ShortName": "YESODOT EITANIM CONSTRUCTION LTD",
    "Symbol": "YESD.TA",
    "TaseSymbol": "YESD",
    "YahooId": "YESD.TA",
    "EnglishName": "YESODOT",
    "EnglishLongName": "YESODOT EITANIM CONSTRUCTION LTD",
    "HebrewName": "יסודות",
    "HebrewLongName": "ע.ע. יסודות איתנים ייזום ובניה בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 278.4,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Real",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -2.1,
    "YearYield": -2.1,
    "Last12MonthYield": null,
    "ISIN": "IL0011884165"
  },
  {
    "Id": "TASE:162",
    "MayaId": "162",
    "Name": "Yeter Rest of Shares",
    "ShortName": "Yeter-Rest of Shares",
    "Symbol": "TASE:162",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Yeter Rest of Shares",
    "EnglishLongName": "Yeter-Rest of Shares",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:161",
    "MayaId": "161",
    "Name": "Yeter Rest of Shares & Convertibles",
    "ShortName": "Yeter-Rest of Shares & Convertibles",
    "Symbol": "TASE:161",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Yeter Rest of Shares & Convertibles",
    "EnglishLongName": "Yeter-Rest of Shares & Convertibles",
    "HebrewName": "",
    "HebrewLongName": "",
    "Type": "2",
    "SubType": "0",
    "SubTypeDesc": "Index",
    "Exchange": "TLV",
    "QuoteType": "INDEX",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": null,
    "Sector": "",
    "Industry": "",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": null,
    "YearYield": null,
    "Last12MonthYield": null,
    "ISIN": null
  },
  {
    "Id": "TASE:5130232",
    "MayaId": "5130232",
    "Name": "Yetsira BND WithoutStocks",
    "ShortName": "Yetsira BND WithoutStocks",
    "Symbol": "TASE:5130232",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Ocean Yetsira (0B) Bonds Without Stocks IL",
    "EnglishLongName": "Ocean Yetsira (0B) Bonds Without Stocks IL",
    "HebrewName": "אושן אג\"ח ללא מניות",
    "HebrewLongName": "אושן יצירה (0B)י אג\"ח ללא מניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.34,
    "Sector": "",
    "Industry": "",
    "ManagerName": "SIGMA MUTUAL FUNDS LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 538.6,
    "MonthYield": 0.63,
    "YearYield": 0.63,
    "Last12MonthYield": 6.29,
    "ISIN": "IL0051302326"
  },
  {
    "Id": "YELN-F4.TA",
    "MayaId": "1201698",
    "Name": "YLETF (4A) Nasdaq 100 Currency Hedged",
    "ShortName": "YELIN LAPIDOT - MUTUAL FUNDS MANAGEMENT LTD",
    "Symbol": "YELN-F4.TA",
    "TaseSymbol": "YELN.F4",
    "YahooId": "YELN-F4.TA",
    "EnglishName": "YLETFNASD100CH",
    "EnglishLongName": "YELIN LAPIDOT - MUTUAL FUNDS MANAGEMENT LTD",
    "HebrewName": "י.ל סלNASD100ממ",
    "HebrewLongName": "ילין לפידות-ניהול קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 7021.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "YALIN LAPIDOT",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": -1.0,
    "YearYield": -1.0,
    "Last12MonthYield": null,
    "ISIN": "IL0012016981"
  },
  {
    "Id": "YELN-F2.TA",
    "MayaId": "1201664",
    "Name": "YLETF (4A) S&P 500 Currency Hedged",
    "ShortName": "YELIN LAPIDOT - MUTUAL FUNDS MANAGEMENT LTD",
    "Symbol": "YELN-F2.TA",
    "TaseSymbol": "YELN.F2",
    "YahooId": "YELN-F2.TA",
    "EnglishName": "YLETF S&P500 CH",
    "EnglishLongName": "YELIN LAPIDOT - MUTUAL FUNDS MANAGEMENT LTD",
    "HebrewName": "י.ל סל S&P500ממ",
    "HebrewLongName": "ילין לפידות-ניהול קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 6794.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "YALIN LAPIDOT",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": -0.4,
    "YearYield": -0.4,
    "Last12MonthYield": null,
    "ISIN": "IL0012016643"
  },
  {
    "Id": "YELN-F5.TA",
    "MayaId": "1206549",
    "Name": "YLETF (4A) Tel Aviv Stock Exchange Banks IL",
    "ShortName": "YELIN LAPIDOT - MUTUAL FUNDS MANAGEMENT LTD",
    "Symbol": "YELN-F5.TA",
    "TaseSymbol": "YELN.F5",
    "YahooId": "YELN-F5.TA",
    "EnglishName": "YLETF BANKS IL",
    "EnglishLongName": "YELIN LAPIDOT - MUTUAL FUNDS MANAGEMENT LTD",
    "HebrewName": "י.ל סל תא בנקים",
    "HebrewLongName": "ילין לפידות-ניהול קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0.49,
    "TrusteeFee": 0.005,
    "VariableFee": 0.1,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 11040.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "YALIN LAPIDOT",
    "TrusteeName": "UBANK",
    "MainClassification": "Israeli Shares",
    "SecondaryClassification": "Banking and non-banking credit",
    "AssetValue": null,
    "MonthYield": 9.2,
    "YearYield": 9.2,
    "Last12MonthYield": null,
    "ISIN": "IL0012065491"
  },
  {
    "Id": "YELN-F3.TA",
    "MayaId": "1201672",
    "Name": "YLETF (4D) Nasdaq 100",
    "ShortName": "YELIN LAPIDOT - MUTUAL FUNDS MANAGEMENT LTD",
    "Symbol": "YELN-F3.TA",
    "TaseSymbol": "YELN.F3",
    "YahooId": "YELN-F3.TA",
    "EnglishName": "YLETF NASDAQ100",
    "EnglishLongName": "YELIN LAPIDOT - MUTUAL FUNDS MANAGEMENT LTD",
    "HebrewName": "י.ל סלNASDAQ100",
    "HebrewLongName": "ילין לפידות-ניהול קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 6162.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "YALIN LAPIDOT",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": -1.7,
    "YearYield": -1.7,
    "Last12MonthYield": null,
    "ISIN": "IL0012016726"
  },
  {
    "Id": "YELN-F1.TA",
    "MayaId": "1201656",
    "Name": "YLETF (4D) S&P 500",
    "ShortName": "YELIN LAPIDOT - MUTUAL FUNDS MANAGEMENT LTD",
    "Symbol": "YELN-F1.TA",
    "TaseSymbol": "YELN.F1",
    "YahooId": "YELN-F1.TA",
    "EnglishName": "YLETP S&P 500",
    "EnglishLongName": "YELIN LAPIDOT - MUTUAL FUNDS MANAGEMENT LTD",
    "HebrewName": "י.ל סל P 500&S",
    "HebrewLongName": "ילין לפידות-ניהול קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "42",
    "SubTypeDesc": "ETF Fund - Equity",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0.02,
    "VariableFee": 0.3,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 6115.0,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs",
    "ManagerName": "YALIN LAPIDOT",
    "TrusteeName": "UBANK",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "America - developed markets",
    "AssetValue": null,
    "MonthYield": -1.3,
    "YearYield": -1.3,
    "Last12MonthYield": null,
    "ISIN": "IL0012016569"
  },
  {
    "Id": "TASE:5121181",
    "MayaId": "5121181",
    "Name": "YLN 1090AG HUL",
    "ShortName": "YLN 1090AG HUL",
    "Symbol": "TASE:5121181",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Yelin Lapidot (1B) 90/10 tik agach hul up to 30% foreign currency",
    "EnglishLongName": "Yelin Lapidot (1B) 90/10 tik agach hul up to 30% foreign currency",
    "HebrewName": "י.ל 1090תיקאגחולומנעד30מט",
    "HebrewLongName": "ילין לפידות (1B)י 10/90 תיק אג\"ח חו\"ל ומניות עד 30% מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.7,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.38,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX-Protected Bonds",
    "AssetValue": 26.7,
    "MonthYield": 0.44,
    "YearYield": 0.44,
    "Last12MonthYield": 7.82,
    "ISIN": "IL0051211816"
  },
  {
    "Id": "TASE:5120126",
    "MayaId": "5120126",
    "Name": "YLN 90/10 CHUL",
    "ShortName": "YLN 90/10 CHUL",
    "Symbol": "TASE:5120126",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YELIN LAPIDOT (1D)` 90/10 TIK AGAH CHUL VE MENAYOT",
    "EnglishLongName": "YELIN LAPIDOT (1D)` 90/10 TIK AGAH CHUL VE MENAYOT",
    "HebrewName": "ילין 1D 10/90 אג חולומני",
    "HebrewLongName": "ילין לפידות (1D)י 10/90 תיק אג\"ח חו\"ל ומניות",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.13,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Bond",
    "AssetValue": 429.5,
    "MonthYield": -1.1,
    "YearYield": -1.1,
    "Last12MonthYield": -6.61,
    "ISIN": "IL0051201262"
  },
  {
    "Id": "TASE:5119961",
    "MayaId": "5119961",
    "Name": "YLN AGACH CHUL",
    "ShortName": "YLN AGACH CHUL",
    "Symbol": "TASE:5119961",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YELIN LAPIDOT (0D)(!) AGACH HUL",
    "EnglishLongName": "YELIN LAPIDOT (0D)(!) AGACH HUL",
    "HebrewName": "ילין 0D ! אג\"ח חו\"ל",
    "HebrewLongName": "ילין לפידות (0D)(!) אג\"ח חו\"ל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.9,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Bond",
    "AssetValue": 89.5,
    "MonthYield": -1.29,
    "YearYield": -1.29,
    "Last12MonthYield": -7.9,
    "ISIN": "IL0051199615"
  },
  {
    "Id": "TASE:5127089",
    "MayaId": "5127089",
    "Name": "YLN FRGIN EQT $",
    "ShortName": "YLN FRGIN EQT $",
    "Symbol": "TASE:5127089",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Yelin Lapidot (4D) Foreign Equity $ Nominated",
    "EnglishLongName": "Yelin Lapidot (4D) Foreign Equity $ Nominated",
    "HebrewName": "ילין 4D מניות חו\"ל נקוב $",
    "HebrewLongName": "ילין לפידות (4D) מניות חו\"ל נקובה $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.7,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.22,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 174.5,
    "MonthYield": 4.17,
    "YearYield": 4.17,
    "Last12MonthYield": 9.35,
    "ISIN": "IL0051270895"
  },
  {
    "Id": "TASE:5123971",
    "MayaId": "5123971",
    "Name": "YLN GLB CRP 30%",
    "ShortName": "YLN GLB CRP 30%",
    "Symbol": "TASE:5123971",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Yelin Lapidot (1B)(!) Global Corporate Bonds up to 30% foreign currency",
    "EnglishLongName": "Yelin Lapidot (1B)(!) Global Corporate Bonds up to 30% foreign currency",
    "HebrewName": "י.ל אגח חב חול עד 30 מט",
    "HebrewLongName": "ילין לפידות (1B)(!) אג\"ח חברות חו\"ל עד 30% מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.69,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.33,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX-Protected Bonds",
    "AssetValue": 65.0,
    "MonthYield": 0.25,
    "YearYield": 0.25,
    "Last12MonthYield": 6.82,
    "ISIN": "IL0051239718"
  },
  {
    "Id": "TASE:5121710",
    "MayaId": "5121710",
    "Name": "YLN GLOBL BND $",
    "ShortName": "YLN GLOBL BND $",
    "Symbol": "TASE:5121710",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Yelin Lapidot (1D)(!) Global Bonds $ Nominated",
    "EnglishLongName": "Yelin Lapidot (1D)(!) Global Bonds $ Nominated",
    "HebrewName": "ילין 1D ! אגח חול נקוב $",
    "HebrewLongName": "ילין לפידות (1D)(!) אג\"ח חו\"ל נקוב $",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.79,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.12,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Bonds",
    "SecondaryClassification": "FX Bonds",
    "AssetValue": 173.2,
    "MonthYield": -1.02,
    "YearYield": -1.02,
    "Last12MonthYield": -7.6,
    "ISIN": "IL0051217102"
  },
  {
    "Id": "TASE:5114087",
    "MayaId": "5114087",
    "Name": "YLN GMISHA",
    "ShortName": "YLN GMISHA",
    "Symbol": "TASE:5114087",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Yelin Lapidot (4D) Gmisha",
    "EnglishLongName": "Yelin Lapidot (4D) Gmisha",
    "HebrewName": "ילין 4D גמישה",
    "HebrewLongName": "ילין לפידות (4D) גמישה",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.91,
    "TrusteeFee": 0.05,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.69,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Flexible",
    "SecondaryClassification": "",
    "AssetValue": 382.2,
    "MonthYield": 6.58,
    "YearYield": 6.58,
    "Last12MonthYield": 47.88,
    "ISIN": "IL0051140874"
  },
  {
    "Id": "TASE:5130356",
    "MayaId": "5130356",
    "Name": "YLN IL CORPORAT",
    "ShortName": "YLN IL CORPORAT",
    "Symbol": "TASE:5130356",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YELIN LAPIDOT(0A)(!) ISRAEL CORPORATE",
    "EnglishLongName": "YELIN LAPIDOT(0A)(!) ISRAEL CORPORATE",
    "HebrewName": "י.ל. קונצרני ישראל",
    "HebrewLongName": "ילין לפידות (0A)(!) קונצרני ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.24,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Corporate and Convertibles - No Equity",
    "AssetValue": 514.5,
    "MonthYield": 0.68,
    "YearYield": 0.68,
    "Last12MonthYield": 6.88,
    "ISIN": "IL0051303563"
  },
  {
    "Id": "TASE:5128350",
    "MayaId": "5128350",
    "Name": "YLN ISRAEL BOND",
    "ShortName": "YLN ISRAEL BOND",
    "Symbol": "TASE:5128350",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "YELIN LAPIDOT (0A)(!) ISRAEL BOND",
    "EnglishLongName": "YELIN LAPIDOT (0A)(!) ISRAEL BOND",
    "HebrewName": "י.ל אג\"ח ישראל",
    "HebrewLongName": "ילין לפידות (0A)(!) אג\"ח ישראל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.75,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 0.26,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Israeli Bonds - General",
    "SecondaryClassification": "Israeli Bonds - General - No Equity",
    "AssetValue": 231.0,
    "MonthYield": 0.63,
    "YearYield": 0.63,
    "Last12MonthYield": 6.88,
    "ISIN": "IL0051283500"
  },
  {
    "Id": "TASE:5120977",
    "MayaId": "5120977",
    "Name": "YLN MENAYOT HUL",
    "ShortName": "YLN MENAYOT HUL",
    "Symbol": "TASE:5120977",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Yelin Lapidod (4D) Menayot Hul",
    "EnglishLongName": "Yelin Lapidod (4D) Menayot Hul",
    "HebrewName": "ילין 4D מניות חו\"ל",
    "HebrewLongName": "ילין לפידות (4D) מניות חו\"ל",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 1.7,
    "TrusteeFee": 0.04,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 1.51,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "Foreign Stocks - General",
    "AssetValue": 497.1,
    "MonthYield": 3.43,
    "YearYield": 3.43,
    "Last12MonthYield": 9.83,
    "ISIN": "IL0051209778"
  },
  {
    "Id": "TASE:5135157",
    "MayaId": "5135157",
    "Name": "YLTrack Cyber AI Based CH",
    "ShortName": "YLTrack Cyber AI Based CH",
    "Symbol": "TASE:5135157",
    "TaseSymbol": null,
    "YahooId": null,
    "EnglishName": "Yelin Lapidot Tracking (4A) Index Cyber US - AI Based Currency Hedged",
    "EnglishLongName": "Yelin Lapidot Tracking (4A) Index Cyber US - AI Based Currency Hedged",
    "HebrewName": "יל מחקה סייבר מבוסס AI ממ",
    "HebrewLongName": "ילין לפידות מחקה (4A) אינדקס סייבר ארה\"ב - מבוסס AI מנוטרלת מט\"ח",
    "Type": "4",
    "SubType": "0",
    "SubTypeDesc": "Mutual Fund",
    "Exchange": "TLV",
    "QuoteType": "MUTUALFUND",
    "ManagementFee": 0.77,
    "TrusteeFee": 0.02,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": true,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": null,
    "StandardDeviation": 2.73,
    "Sector": "",
    "Industry": "",
    "ManagerName": "YALIN LAPIDOT-MUTUAL FUNDS MANAGEMENT LTD",
    "TrusteeName": "UBANK TRUST COMPANY LTD",
    "MainClassification": "Foreign Shares",
    "SecondaryClassification": "FX-Hedged Stocks by Sector Abroad ",
    "AssetValue": 19.4,
    "MonthYield": -1.95,
    "YearYield": -1.95,
    "Last12MonthYield": -4.42,
    "ISIN": "IL0051351570"
  },
  {
    "Id": "YHNF.TA",
    "MayaId": "1161264",
    "Name": "YOCHANANOF",
    "ShortName": "M.YOCHANANOF AND SONS (1988) LTD",
    "Symbol": "YHNF.TA",
    "TaseSymbol": "YHNF",
    "YahooId": "YHNF.TA",
    "EnglishName": "YOCHANANOF",
    "EnglishLongName": "M.YOCHANANOF AND SONS (1988) LTD",
    "HebrewName": "יוחננוף",
    "HebrewLongName": "מ.יוחננוף ובניו (1988) בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 36700.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Commerce & Services",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 9.7,
    "YearYield": 9.7,
    "Last12MonthYield": null,
    "ISIN": "IL0011612640"
  },
  {
    "Id": "ZNKL.TA",
    "MayaId": "130013",
    "Name": "ZANLAKOL",
    "ShortName": "ZANLAKOL LTD.",
    "Symbol": "ZNKL.TA",
    "TaseSymbol": "ZNKL",
    "YahooId": "ZNKL.TA",
    "EnglishName": "ZANLAKOL",
    "EnglishLongName": "ZANLAKOL LTD.",
    "HebrewName": "זנלכל",
    "HebrewLongName": "זנלכל בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 4386.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Industry",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -1.0,
    "YearYield": -1.0,
    "Last12MonthYield": null,
    "ISIN": "IL0001300131"
  },
  {
    "Id": "ZPRS.TA",
    "MayaId": "1194695",
    "Name": "ZEPHYRUS",
    "ShortName": "ZEPHYRUS WING ENERGIES LTD",
    "Symbol": "ZPRS.TA",
    "TaseSymbol": "ZPRS",
    "YahooId": "ZPRS.TA",
    "EnglishName": "ZEPHYRUS",
    "EnglishLongName": "ZEPHYRUS WING ENERGIES LTD",
    "HebrewName": "זפירוס",
    "HebrewLongName": "זפירוס ווינג אנרג'יס בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 2499.0,
    "StandardDeviation": null,
    "Sector": "High",
    "Industry": "Tech",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 17.3,
    "YearYield": 17.3,
    "Last12MonthYield": null,
    "ISIN": "IL0011946956"
  },
  {
    "Id": "ZOOZ.TA",
    "MayaId": "1174184",
    "Name": "ZOOZ STRATEGY",
    "ShortName": "ZOOZ STRATEGY LTD",
    "Symbol": "ZOOZ.TA",
    "TaseSymbol": "ZOOZ",
    "YahooId": "ZOOZ.TA",
    "EnglishName": "ZOOZ STRATEGY",
    "EnglishLongName": "ZOOZ STRATEGY LTD",
    "HebrewName": "זוז אסטרטגיה",
    "HebrewLongName": "זוז אסטרטגיה בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 150.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Investment & Holdings",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": 19.4,
    "YearYield": 19.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011741845"
  },
  {
    "Id": "ZUR.TA",
    "MayaId": "730010",
    "Name": "ZUR",
    "ShortName": "ZUR SHAMIR HOLDINGS LTD.",
    "Symbol": "ZUR.TA",
    "TaseSymbol": "ZUR",
    "YahooId": "ZUR.TA",
    "EnglishName": "ZUR",
    "EnglishLongName": "ZUR SHAMIR HOLDINGS LTD.",
    "HebrewName": "צור",
    "HebrewLongName": "צור שמיר אחזקות בע\"מ",
    "Type": "1",
    "SubType": "1",
    "SubTypeDesc": "Shares",
    "Exchange": "TLV",
    "QuoteType": "EQUITY",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 1167.0,
    "StandardDeviation": null,
    "Sector": "Real",
    "Industry": "Investment & Holdings",
    "ManagerName": "",
    "TrusteeName": "",
    "MainClassification": "",
    "SecondaryClassification": "",
    "AssetValue": null,
    "MonthYield": -3.6,
    "YearYield": -3.6,
    "Last12MonthYield": null,
    "ISIN": "IL0007300101"
  },
  {
    "Id": "IBI.FK1.TA",
    "MayaId": "1155076",
    "Name": "‏I.B.I. SAL (00) Kosher Tel Bond 60 CPI LINKED IL",
    "ShortName": "I.B.I MUTUAL FUNDS LTD",
    "Symbol": "IBI.FK1.TA",
    "TaseSymbol": "IBI.FK1",
    "YahooId": "IBI.FK1.TA",
    "EnglishName": "IBI.KOTELB60CPI",
    "EnglishLongName": "I.B.I MUTUAL FUNDS LTD",
    "HebrewName": "IBI.כשתלבונד60צ",
    "HebrewLongName": "אי.בי.אי קרנות נאמנות בע\"מ",
    "Type": "4",
    "SubType": "43",
    "SubTypeDesc": "ETF - Bonds",
    "Exchange": "TLV",
    "QuoteType": "ETF",
    "ManagementFee": 0,
    "TrusteeFee": 0,
    "VariableFee": 0,
    "FundIndicators": {
      "IMITATING": false,
      "LEVERAGED": false,
      "SHORT": false
    },
    "Price": 396.63,
    "StandardDeviation": null,
    "Sector": "Financial Instruments",
    "Industry": "ETFs On Bonds",
    "ManagerName": "I.B.I",
    "TrusteeName": "UBANK",
    "MainClassification": "Israeli bonds - Corporate and Convertibles",
    "SecondaryClassification": "Fixed interest",
    "AssetValue": null,
    "MonthYield": 0.4,
    "YearYield": 0.4,
    "Last12MonthYield": null,
    "ISIN": "IL0011550766"
  }
];

export const Indices = [
  "All Bond",
  "All Bond CPI Linked",
  "All Bond Dollar & Top 5 Tel Bond 20 CPI",
  "All Bond Floating Shekel",
  "All Bond Shekel",
  "All Corporate Bonds",
  "Banks Shares and Convertibles",
  "Bond Max one year maturity",
  "Chemical, Rubber & Plastic Shares and Convertibles",
  "Commerce & Services Shares and Convertibles",
  "Convertible Bonds",
  "CPI Linked Corporate Bonds",
  "Deposit Backed Bonds",
  "General Shares and Convertibles",
  "Industry Shares and Convertibles",
  "Investment & Holdings Shares and Convertibles",
  "Nasdaq",
  "Nasdaq 100",
  "Non Linked, Floating Int. Gov. Bonds, 0 5 Years",
  "Oil & Gas Exploration Shares and Convertibles",
  "RealEstate & Construction Shares and Convertibles",
  "S&P 500",
  "Shares",
  "TA 125",
  "TA 125 Equal Weight",
  "TA 125 Fossil Free",
  "TA 35",
  "TA 35 Dollar",
  "TA 90",
  "TA 90 and Banks",
  "TA 90 and SME60 CAP 0.8%",
  "TA 90 EW PM",
  "TA AllShare",
  "TA Bank",
  "TA Banks & Insurance EW",
  "TA Banks 5 Equal Weight",
  "TA Banks5",
  "TA Biomed",
  "TA Cleantech",
  "TA Communication & InformationTechnology",
  "TA Construction",
  "TA Defense",
  "TA Dual Listing",
  "TA Energy Utilities",
  "TA Family",
  "TA Finance",
  "TA Global BlueTech",
  "TA Growth",
  "TA Industrials",
  "TA Infrastructures",
  "TA Insurance",
  "TA Insurance & Financial Services",
  "TA Investment Properties Abroad",
  "TA Investment Properties in Israel",
  "TA Maala",
  "TA Oil & Gas",
  "TA Real Estate 35",
  "TA RealEstate",
  "TA Retail",
  "TA Rimon",
  "TA Sector Balance",
  "TA SME60",
  "TA SME60 EW PM",
  "TA Tech Elite",
  "TA Technology",
  "TA-125 Index",
  "TA-35 Index",
  "TA-90 Index",
  "TA-Banks5 Index",
  "TA-Growth Index",
  "TA-Real Estate Index",
  "TA125 Value",
  "TA20",
  "TA200",
  "TA50 Real",
  "TB A Diversified Issuers",
  "TB AA Diversified Issuers",
  "Tel Aviv Stock Exchange",
  "Tel Bond 100 CPI Linked",
  "Tel Bond 125 Value CPI",
  "Tel Bond 125 Value Shekel",
  "Tel Bond 20 CPI Linked",
  "Tel Bond 40 CPI Linked",
  "Tel Bond 60 CPI Linked",
  "Tel Bond 60 ILS",
  "Tel Bond Banks&GovComp",
  "Tel Bond Bullet 10/28 CPI",
  "Tel Bond Bullet 2029 ILS",
  "Tel Bond Bullet 29 Israel",
  "Tel Bond CoCo A+",
  "Tel Bond Composite",
  "Tel Bond CP",
  "Tel Bond CPI 5 10",
  "Tel Bond CPI Banks & COCO",
  "Tel Bond CPI Linked",
  "Tel Bond CPI Linked 1 3",
  "Tel Bond CPI Linked 3 5",
  "Tel Bond CPI Linked 5 15",
  "Tel Bond CPI Linked A",
  "Tel Bond CPI Linked AA AAA",
  "Tel Bond CPI Linked AAA",
  "Tel Bond CPI Linked Banks Exclude COCO",
  "Tel Bond CPI Linked Double Rating",
  "Tel Bond CPI Linked MaalaSRI",
  "Tel Bond CPI Linked RealEstate",
  "Tel Bond CPI Linked SmallCap",
  "Tel Bond Global Shekel",
  "Tel Bond Non Linked",
  "Tel Bond Non Linked AAA",
  "Tel Bond Non Linked Double Rating",
  "Tel Bond Shekel",
  "Tel Bond Shekel 1 3",
  "Tel Bond Shekel 100",
  "Tel Bond Shekel 3 5",
  "Tel Bond Shekel 5 10",
  "Tel Bond Shekel 5 15",
  "Tel Bond Shekel 50",
  "Tel Bond Shekel A",
  "Tel Bond Shekel AA AAA",
  "Tel Bond Shekel Bank&Insurance",
  "Tel Bond Shekel MaalaSRI",
  "Tel Bond Shekel Yield Diversified",
  "Tel Bond Yields CPI Linked",
  "Tel Bond Yields CPI Linked Diversified",
  "Tel Div",
  "Tel Div Aristocrats",
  "Tel Gov",
  "Tel Gov CPI Linked",
  "Tel Gov CPI Linked 0 2",
  "Tel Gov CPI Linked 10+",
  "Tel Gov CPI Linked 2 5",
  "Tel Gov CPI Linked 5 10",
  "Tel Gov CPI Linked 5+",
  "Tel Gov CPI Linked, 15+ Years",
  "Tel Gov Floating Shekel",
  "Tel Gov Non Linked",
  "Tel Gov Shekel",
  "Tel Gov Shekel 0 2",
  "Tel Gov Shekel 10+",
  "Tel Gov Shekel 2 5",
  "Tel Gov Shekel 5 10",
  "Tel Gov Shekel 5+",
  "Tel Gov T Bills (MAKAM)",
  "TelBond Yield NIS",
  "VTA35",
  "Warrants",
  "Yeter Rest of Shares",
  "Yeter Rest of Shares & Convertibles"
];
